import { FeatureCollection } from 'geojson';

// GeoJSON das Mesorregiões do Rio Grande do Sul
// Fonte: IBGE - Instituto Brasileiro de Geografia e Estatística
// API: https://servicodados.ibge.gov.br/api/v3/malhas/mesorregioes
export const RS_MESORREGIAO_GEOJSON: FeatureCollection = {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {
        "mesorregiao_nome": "Noroeste Rio-grandense",
        "mesorregiao_id": 4301,
        "num_municipios": 216
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -54.90289598907663,
              -27.698884408489178
            ],
            [
              -54.904423348694316,
              -27.69009664005043
            ],
            [
              -54.9038233145588,
              -27.68222126287035
            ],
            [
              -54.904423348694316,
              -27.67170475309939
            ],
            [
              -54.90502338282983,
              -27.656194101702038
            ],
            [
              -54.90709622802526,
              -27.647886539188907
            ],
            [
              -54.90660529100529,
              -27.641883965118723
            ],
            [
              -54.903223280423276,
              -27.636409617566716
            ],
            [
              -54.89520464243045,
              -27.629206528682495
            ],
            [
              -54.8884951698242,
              -27.626613416684176
            ],
            [
              -54.87889462365591,
              -27.625989148980878
            ],
            [
              -54.869184980372076,
              -27.627189663794915
            ],
            [
              -54.86078450247482,
              -27.629398611052743
            ],
            [
              -54.85462051544632,
              -27.62738174616516
            ],
            [
              -54.84769284860898,
              -27.621283130909855
            ],
            [
              -54.84267438129373,
              -27.61249536247111
            ],
            [
              -54.839674210616145,
              -27.605196232401767
            ],
            [
              -54.83869233657621,
              -27.596312422777896
            ],
            [
              -54.836783137054105,
              -27.590694013448203
            ],
            [
              -54.83361932070319,
              -27.577680432864046
            ],
            [
              -54.831110087045566,
              -27.56788423198151
            ],
            [
              -54.826582556750296,
              -27.554006280731247
            ],
            [
              -54.821291346646184,
              -27.544017997478463
            ],
            [
              -54.81709110769756,
              -27.535614393780207
            ],
            [
              -54.809781600955795,
              -27.529995984450515
            ],
            [
              -54.80258119132958,
              -27.530716293338937
            ],
            [
              -54.79521713603004,
              -27.534990126076906
            ],
            [
              -54.792598805256866,
              -27.544402162218955
            ],
            [
              -54.79079870285032,
              -27.55770386635848
            ],
            [
              -54.787689435057175,
              -27.57018922042446
            ],
            [
              -54.78458016726404,
              -27.57868886530784
            ],
            [
              -54.77808888888889,
              -27.58368300693423
            ],
            [
              -54.77312497013142,
              -27.58531570708132
            ],
            [
              -54.766306400409626,
              -27.584883521748267
            ],
            [
              -54.75872415087899,
              -27.581522080268964
            ],
            [
              -54.75310564942823,
              -27.575087320865727
            ],
            [
              -54.74950544461512,
              -27.567788190796385
            ],
            [
              -54.74492336576208,
              -27.562601966799747
            ],
            [
              -54.738486635944696,
              -27.560921246060097
            ],
            [
              -54.73052254650964,
              -27.561785616726205
            ],
            [
              -54.723322136883425,
              -27.563514358058416
            ],
            [
              -54.717212698412695,
              -27.564906955242698
            ],
            [
              -54.7067939238778,
              -27.56860454086993
            ],
            [
              -54.694193207031915,
              -27.57278233242278
            ],
            [
              -54.68088335893497,
              -27.57451107375499
            ],
            [
              -54.67477392046424,
              -27.571485776423618
            ],
            [
              -54.671719201228875,
              -27.566395593612103
            ],
            [
              -54.67161010411333,
              -27.56039301954192
            ],
            [
              -54.67270107526882,
              -27.553814198361
            ],
            [
              -54.67390114353985,
              -27.548195789031308
            ],
            [
              -54.68011967912613,
              -27.52658652237865
            ],
            [
              -54.67990148489503,
              -27.518182918680395
            ],
            [
              -54.679410547875065,
              -27.512900653498633
            ],
            [
              -54.67788318825738,
              -27.509010985501156
            ],
            [
              -54.67548305171531,
              -27.50579360579954
            ],
            [
              -54.67090097286226,
              -27.504785173355746
            ],
            [
              -54.66560976275815,
              -27.50579360579954
            ],
            [
              -54.66010035842294,
              -27.508578800168102
            ],
            [
              -54.65671834784093,
              -27.513188777054005
            ],
            [
              -54.654809148318826,
              -27.52067998949359
            ],
            [
              -54.652027171872334,
              -27.531676705190165
            ],
            [
              -54.64799057859703,
              -27.540176350073544
            ],
            [
              -54.64242662570405,
              -27.544786326959446
            ],
            [
              -54.63408069636456,
              -27.546419027106534
            ],
            [
              -54.63200785116914,
              -27.545698718218112
            ],
            [
              -54.62688028673835,
              -27.544017997478463
            ],
            [
              -54.62071629970985,
              -27.538783752889263
            ],
            [
              -54.61580692951016,
              -27.532204931708343
            ],
            [
              -54.613079501621435,
              -27.523177060306786
            ],
            [
              -54.61160669056153,
              -27.51669428031099
            ],
            [
              -54.60947929680833,
              -27.510403582685438
            ],
            [
              -54.60620638334186,
              -27.503776740911956
            ],
            [
              -54.60227888718211,
              -27.497678125656652
            ],
            [
              -54.597478614097966,
              -27.49172357217903
            ],
            [
              -54.595023928998124,
              -27.4874017188485
            ],
            [
              -54.59191466120498,
              -27.475108447152763
            ],
            [
              -54.592187403993854,
              -27.468577646564405
            ],
            [
              -54.59109643283837,
              -27.46291121664215
            ],
            [
              -54.58940542754736,
              -27.45820519857113
            ],
            [
              -54.58618706263867,
              -27.455083860054632
            ],
            [
              -54.58100494965011,
              -27.45330709812986
            ],
            [
              -54.57342270011947,
              -27.453595221685227
            ],
            [
              -54.566822324628774,
              -27.45758093086783
            ],
            [
              -54.561422017409114,
              -27.462479031309098
            ],
            [
              -54.55220331114525,
              -27.473619808783358
            ],
            [
              -54.54647571257894,
              -27.481014980037823
            ],
            [
              -54.54238457074586,
              -27.486681409960077
            ],
            [
              -54.53949349718382,
              -27.492876066400505
            ],
            [
              -54.53818433179723,
              -27.4999831140996
            ],
            [
              -54.53709336064175,
              -27.502816329060728
            ],
            [
              -54.5344204813108,
              -27.505697564614415
            ],
            [
              -54.52989295101553,
              -27.50617777054003
            ],
            [
              -54.52487448370029,
              -27.50617777054003
            ],
            [
              -54.52089243898276,
              -27.50329653498634
            ],
            [
              -54.51778317118962,
              -27.49902270224837
            ],
            [
              -54.51478300051203,
              -27.493500334103803
            ],
            [
              -54.51249196108551,
              -27.488890357217905
            ],
            [
              -54.51031001877453,
              -27.48548089514604
            ],
            [
              -54.50621887694145,
              -27.48231153603698
            ],
            [
              -54.5006003754907,
              -27.480390712334525
            ],
            [
              -54.491818057689024,
              -27.479814465223786
            ],
            [
              -54.48172657450077,
              -27.481014980037823
            ],
            [
              -54.474580713432324,
              -27.481207062408068
            ],
            [
              -54.47398067929681,
              -27.48130310359319
            ],
            [
              -54.46312551629971,
              -27.479718424038666
            ],
            [
              -54.45619784946236,
              -27.478085723891574
            ],
            [
              -54.44948837685612,
              -27.47539657070813
            ],
            [
              -54.44577907492746,
              -27.47208314982139
            ],
            [
              -54.443324389827616,
              -27.468289523009034
            ],
            [
              -54.442615258576545,
              -27.464880060937173
            ],
            [
              -54.44397897252091,
              -27.459981960495902
            ],
            [
              -54.44801556579621,
              -27.4559962513133
            ],
            [
              -54.46039808841099,
              -27.448601080058836
            ],
            [
              -54.465525652841784,
              -27.443078711914268
            ],
            [
              -54.46988953746373,
              -27.437988529102753
            ],
            [
              -54.47212602833248,
              -27.434483025845765
            ],
            [
              -54.47201693121693,
              -27.430497316663164
            ],
            [
              -54.46988953746373,
              -27.42579129859214
            ],
            [
              -54.46579839563065,
              -27.423582351334314
            ],
            [
              -54.456579689366784,
              -27.422189754150033
            ],
            [
              -54.45270674176481,
              -27.423006104223578
            ],
            [
              -54.44479720088752,
              -27.42511901029628
            ],
            [
              -54.43912415087899,
              -27.424686824963228
            ],
            [
              -54.4356875917392,
              -27.423294227778946
            ],
            [
              -54.43039638163509,
              -27.419596642151713
            ],
            [
              -54.425814302782044,
              -27.415418850598865
            ],
            [
              -54.41937757296467,
              -27.40932023534356
            ],
            [
              -54.41577736815156,
              -27.40701524690061
            ],
            [
              -54.411413483529614,
              -27.405286505568398
            ],
            [
              -54.40557678784776,
              -27.407495452826225
            ],
            [
              -54.39881276668373,
              -27.41157720319395
            ],
            [
              -54.39232148830858,
              -27.418108003782308
            ],
            [
              -54.38839399214883,
              -27.422717980668207
            ],
            [
              -54.38452104454685,
              -27.428096287035093
            ],
            [
              -54.37721153780509,
              -27.44187819710023
            ],
            [
              -54.36979293394777,
              -27.452586789241437
            ],
            [
              -54.36297436422598,
              -27.459789878125658
            ],
            [
              -54.3571922171019,
              -27.464880060937173
            ],
            [
              -54.351573715651135,
              -27.466992967009876
            ],
            [
              -54.3461188598737,
              -27.466992967009876
            ],
            [
              -54.342573203618365,
              -27.465408287455347
            ],
            [
              -54.34039126130739,
              -27.463391422567767
            ],
            [
              -54.33690015360983,
              -27.4566205190166
            ],
            [
              -54.33510005120328,
              -27.45129023324228
            ],
            [
              -54.33510005120328,
              -27.446488173986133
            ],
            [
              -54.338100221880865,
              -27.440005393990333
            ],
            [
              -54.34039126130739,
              -27.43097752258878
            ],
            [
              -54.341373135347325,
              -27.425695257407018
            ],
            [
              -54.34191862092507,
              -27.421181321706243
            ],
            [
              -54.341700426693976,
              -27.41748373607901
            ],
            [
              -54.34279139784946,
              -27.412777718007984
            ],
            [
              -54.34251865506059,
              -27.4073994116411
            ],
            [
              -54.34148223246288,
              -27.40442213490229
            ],
            [
              -54.33891845024748,
              -27.403221620088253
            ],
            [
              -54.33537279399215,
              -27.402885475940323
            ],
            [
              -54.33351814302782,
              -27.403509743643625
            ],
            [
              -54.32882696705922,
              -27.40667910275268
            ],
            [
              -54.32069923195085,
              -27.413017820970794
            ],
            [
              -54.310607748762585,
              -27.421997671779785
            ],
            [
              -54.30149813961427,
              -27.433522613994537
            ],
            [
              -54.297516094896736,
              -27.441686114729986
            ],
            [
              -54.294188632872505,
              -27.445911926875393
            ],
            [
              -54.28900651988394,
              -27.447976812355538
            ],
            [
              -54.28387895545315,
              -27.44778472998529
            ],
            [
              -54.28300617852876,
              -27.44778472998529
            ],
            [
              -54.27727857996245,
              -27.44480745324648
            ],
            [
              -54.27198736985834,
              -27.441013826434126
            ],
            [
              -54.26827806792968,
              -27.4363078083631
            ],
            [
              -54.26778713090971,
              -27.431409707921834
            ],
            [
              -54.27018726745178,
              -27.424206619037612
            ],
            [
              -54.27067820447175,
              -27.418684250893044
            ],
            [
              -54.26849626216078,
              -27.415418850598865
            ],
            [
              -54.268714456391876,
              -27.412777718007984
            ],
            [
              -54.26751438812084,
              -27.404278073124605
            ],
            [
              -54.26402328042328,
              -27.399283931498214
            ],
            [
              -54.259823041474654,
              -27.39621061357428
            ],
            [
              -54.253604505888376,
              -27.394481872242068
            ],
            [
              -54.24558586789554,
              -27.39318531624291
            ],
            [
              -54.242585697217955,
              -27.392993233872662
            ],
            [
              -54.23538528759174,
              -27.393713542761084
            ],
            [
              -54.2280212322922,
              -27.392080842613996
            ],
            [
              -54.22229363372589,
              -27.389487730615677
            ],
            [
              -54.2173842635262,
              -27.38502181550746
            ],
            [
              -54.21438409284861,
              -27.381612353435596
            ],
            [
              -54.21302037890425,
              -27.375081552847238
            ],
            [
              -54.21329312169312,
              -27.369703246480352
            ],
            [
              -54.21411135005974,
              -27.365285351964697
            ],
            [
              -54.213893155828636,
              -27.358178304265603
            ],
            [
              -54.21329312169312,
              -27.35121531834419
            ],
            [
              -54.21198395630653,
              -27.3455969090145
            ],
            [
              -54.21040204813108,
              -27.339978499684808
            ],
            [
              -54.208601945724524,
              -27.335992790502207
            ],
            [
              -54.20478354668032,
              -27.327781269174196
            ],
            [
              -54.2022743130227,
              -27.323411395251103
            ],
            [
              -54.195673937532,
              -27.312702803109897
            ],
            [
              -54.19327380098993,
              -27.30847699096449
            ],
            [
              -54.192182829834444,
              -27.30458732296701
            ],
            [
              -54.19229192694999,
              -27.300793696154656
            ],
            [
              -54.19278286396996,
              -27.297480275267915
            ],
            [
              -54.193819286567674,
              -27.294791122084472
            ],
            [
              -54.194201126472095,
              -27.292294051271277
            ],
            [
              -54.19267376685441,
              -27.287876156755623
            ],
            [
              -54.19158279569892,
              -27.283122118092038
            ],
            [
              -54.19081911589008,
              -27.278079955873082
            ],
            [
              -54.18901901348353,
              -27.271597175877286
            ],
            [
              -54.18749165386585,
              -27.267995631435177
            ],
            [
              -54.18661887694146,
              -27.264922313511242
            ],
            [
              -54.17767291346646,
              -27.25791130699727
            ],
            [
              -54.1741818057689,
              -27.254886009665896
            ],
            [
              -54.16949062980031,
              -27.253589453666738
            ],
            [
              -54.165508585082776,
              -27.254117680184912
            ],
            [
              -54.16212657450077,
              -27.256086524479933
            ],
            [
              -54.1595082437276,
              -27.259399945366674
            ],
            [
              -54.157326301416624,
              -27.26319357217903
            ],
            [
              -54.15579894179894,
              -27.269004063878967
            ],
            [
              -54.15541710189452,
              -27.27241352595083
            ],
            [
              -54.15541710189452,
              -27.276495276318556
            ],
            [
              -54.15618078170336,
              -27.28000077957554
            ],
            [
              -54.15890820959208,
              -27.284082529943266
            ],
            [
              -54.160217374978664,
              -27.28758803320025
            ],
            [
              -54.15989008363202,
              -27.29147770119773
            ],
            [
              -54.15879911247653,
              -27.294310916158857
            ],
            [
              -54.15492616487455,
              -27.296904028157176
            ],
            [
              -54.14848943505718,
              -27.29858474889683
            ],
            [
              -54.13277945041816,
              -27.301514005043078
            ],
            [
              -54.12628817204301,
              -27.301514005043078
            ],
            [
              -54.11390564942823,
              -27.302186293338938
            ],
            [
              -54.111505512886154,
              -27.302522437486868
            ],
            [
              -54.10752346816863,
              -27.303002643412484
            ],
            [
              -54.1009776412357,
              -27.30329076696785
            ],
            [
              -54.09650465949821,
              -27.302810561042236
            ],
            [
              -54.08908605564089,
              -27.30132192267283
            ],
            [
              -54.082376583034645,
              -27.29892089304476
            ],
            [
              -54.08030373783922,
              -27.29772037823072
            ],
            [
              -54.075721658986176,
              -27.294502998529104
            ],
            [
              -54.07228509984639,
              -27.290997495272116
            ],
            [
              -54.070812288786485,
              -27.28691574490439
            ],
            [
              -54.06819395801331,
              -27.282401809203613
            ],
            [
              -54.0648119474313,
              -27.275919029207817
            ],
            [
              -54.06039351425158,
              -27.269484269804583
            ],
            [
              -54.05641146953405,
              -27.26511439588149
            ],
            [
              -54.05499320703191,
              -27.264009922252576
            ],
            [
              -54.05188393923878,
              -27.261512851439377
            ],
            [
              -54.04719276327018,
              -27.259495986551798
            ],
            [
              -54.04151971326165,
              -27.258103389367513
            ],
            [
              -54.03530117767537,
              -27.257190998108847
            ],
            [
              -54.02777347670251,
              -27.254886009665896
            ],
            [
              -54.0243914661205,
              -27.25171665055684
            ],
            [
              -54.02079126130739,
              -27.245906158856904
            ],
            [
              -54.01768199351425,
              -27.238607028787563
            ],
            [
              -54.015881891107696,
              -27.23298861945787
            ],
            [
              -54.01560914831882,
              -27.22909895146039
            ],
            [
              -54.015500051203276,
              -27.224681056944736
            ],
            [
              -54.01620918245435,
              -27.22252013027947
            ],
            [
              -54.01648192524321,
              -27.21627745324648
            ],
            [
              -54.01500911418331,
              -27.20811395251103
            ],
            [
              -54.012281686294585,
              -27.202591584366463
            ],
            [
              -54.00802689878819,
              -27.198413792813618
            ],
            [
              -54.001099231950846,
              -27.19630088674091
            ],
            [
              -53.992098719918076,
              -27.19591672200042
            ],
            [
              -53.98418917904079,
              -27.19620484555579
            ],
            [
              -53.97709786653012,
              -27.197981607480564
            ],
            [
              -53.97229759344598,
              -27.19889399873923
            ],
            [
              -53.96771551459293,
              -27.19889399873923
            ],
            [
              -53.96329708141321,
              -27.197693483925196
            ],
            [
              -53.960187813620074,
              -27.19529245429712
            ],
            [
              -53.955605734767026,
              -27.18371949148981
            ],
            [
              -53.955223894862606,
              -27.17848524690061
            ],
            [
              -53.95582392899812,
              -27.175604011346923
            ],
            [
              -53.95838771121352,
              -27.17060986972053
            ],
            [
              -53.96067875064004,
              -27.16508750157596
            ],
            [
              -53.95980597371565,
              -27.16009335994957
            ],
            [
              -53.95729674005803,
              -27.157020042025636
            ],
            [
              -53.95309650110941,
              -27.15289027106535
            ],
            [
              -53.946605222734256,
              -27.151305591510823
            ],
            [
              -53.94022304147465,
              -27.152986312250473
            ],
            [
              -53.933622665983954,
              -27.155915568396722
            ],
            [
              -53.928986038573136,
              -27.158988886320657
            ],
            [
              -53.925385833760025,
              -27.163214698466064
            ],
            [
              -53.92151288615805,
              -27.16897716957344
            ],
            [
              -53.91687625874722,
              -27.174787661273378
            ],
            [
              -53.910221334698754,
              -27.176276299642783
            ],
            [
              -53.90498467315241,
              -27.175411928976676
            ],
            [
              -53.90171175968595,
              -27.17392329060727
            ],
            [
              -53.89767516641065,
              -27.17032174616516
            ],
            [
              -53.895384126984126,
              -27.166720201723052
            ],
            [
              -53.89380221880867,
              -27.163214698466064
            ],
            [
              -53.89227485919099,
              -27.160621586467744
            ],
            [
              -53.89020201399556,
              -27.157692330321495
            ],
            [
              -53.88829281447346,
              -27.15452297121244
            ],
            [
              -53.88731094043352,
              -27.151977879806683
            ],
            [
              -53.88731094043352,
              -27.147800088253835
            ],
            [
              -53.88660180918245,
              -27.143190111367936
            ],
            [
              -53.885019901007,
              -27.13541077537298
            ],
            [
              -53.883492541389316,
              -27.13190527211599
            ],
            [
              -53.88180153609831,
              -27.129696324858163
            ],
            [
              -53.87891046253627,
              -27.127487377600335
            ],
            [
              -53.87520116060761,
              -27.12590269804581
            ],
            [
              -53.8699099505035,
              -27.125182389157388
            ],
            [
              -53.864291449052736,
              -27.126190821601178
            ],
            [
              -53.86129127837515,
              -27.12849581004413
            ],
            [
              -53.858618399044204,
              -27.132577560411853
            ],
            [
              -53.85540003413552,
              -27.14078908173986
            ],
            [
              -53.85098160095579,
              -27.15020111788191
            ],
            [
              -53.84781778460488,
              -27.156491815507458
            ],
            [
              -53.84618132787165,
              -27.158604721580165
            ],
            [
              -53.8415992490186,
              -27.16561572809414
            ],
            [
              -53.83712626728111,
              -27.168400922462702
            ],
            [
              -53.835107970643456,
              -27.169793519646984
            ],
            [
              -53.82959856630824,
              -27.17257871401555
            ],
            [
              -53.82512558457074,
              -27.174307455347762
            ],
            [
              -53.81972527735108,
              -27.175700052532044
            ],
            [
              -53.81481590715139,
              -27.17589213490229
            ],
            [
              -53.808979211469534,
              -27.172818816978356
            ],
            [
              -53.79452384365933,
              -27.161678039504096
            ],
            [
              -53.789723570575184,
              -27.15778837150662
            ],
            [
              -53.78492329749104,
              -27.15380266232402
            ],
            [
              -53.78170493258235,
              -27.15068132380752
            ],
            [
              -53.77892295613586,
              -27.148712479512504
            ],
            [
              -53.77597733401604,
              -27.147511964698467
            ],
            [
              -53.772922614780676,
              -27.14770404706871
            ],
            [
              -53.77030428400751,
              -27.148712479512504
            ],
            [
              -53.76708591909882,
              -27.150777364992646
            ],
            [
              -53.765122171018945,
              -27.152506106324857
            ],
            [
              -53.7628856801502,
              -27.155387341878544
            ],
            [
              -53.76201290322581,
              -27.15711608321076
            ],
            [
              -53.75999460658815,
              -27.162302307207398
            ],
            [
              -53.7584126984127,
              -27.16801675772221
            ],
            [
              -53.75748537293053,
              -27.173106940533724
            ],
            [
              -53.7562853046595,
              -27.17618025845766
            ],
            [
              -53.751594128690904,
              -27.188089365412903
            ],
            [
              -53.750394060419865,
              -27.18991414793024
            ],
            [
              -53.7477757296467,
              -27.191786951040136
            ],
            [
              -53.74510285031575,
              -27.192507259928558
            ],
            [
              -53.74019348011606,
              -27.192123095188066
            ],
            [
              -53.735284109916364,
              -27.190778518596343
            ],
            [
              -53.73092022529442,
              -27.189289880226937
            ],
            [
              -53.722901587301585,
              -27.185496253414584
            ],
            [
              -53.71771947431302,
              -27.182518976675773
            ],
            [
              -53.71379197815327,
              -27.179781802899768
            ],
            [
              -53.705609694487116,
              -27.172818816978356
            ],
            [
              -53.70091851851852,
              -27.16998560201723
            ],
            [
              -53.68619040791944,
              -27.163598863206555
            ],
            [
              -53.679917323775385,
              -27.161581998318976
            ],
            [
              -53.67511705069124,
              -27.16071762765287
            ],
            [
              -53.66938945212493,
              -27.161581998318976
            ],
            [
              -53.666389281447344,
              -27.16268647194789
            ],
            [
              -53.660988974227685,
              -27.166480098760243
            ],
            [
              -53.657388769414574,
              -27.16998560201723
            ],
            [
              -53.651279330943844,
              -27.176612443790713
            ],
            [
              -53.65007926267281,
              -27.17882139104854
            ],
            [
              -53.648715548728454,
              -27.183911573860055
            ],
            [
              -53.647897320361835,
              -27.19130674511452
            ],
            [
              -53.648224611708486,
              -27.19462016600126
            ],
            [
              -53.64920648574842,
              -27.198317751628494
            ],
            [
              -53.64958832565284,
              -27.20340793444001
            ],
            [
              -53.65100658815498,
              -27.210082796806052
            ],
            [
              -53.65122478238607,
              -27.212723929396933
            ],
            [
              -53.650788393923875,
              -27.215509123765496
            ],
            [
              -53.648715548728454,
              -27.21800619457869
            ],
            [
              -53.645497183819764,
              -27.21959087413322
            ],
            [
              -53.642115173237755,
              -27.21978295650347
            ],
            [
              -53.63807857996245,
              -27.21891858583736
            ],
            [
              -53.635187506400406,
              -27.217381926875394
            ],
            [
              -53.63071452466291,
              -27.213396217692793
            ],
            [
              -53.62678702850316,
              -27.207009478882117
            ],
            [
              -53.62482328042328,
              -27.202495543181342
            ],
            [
              -53.62171401263014,
              -27.192699342298802
            ],
            [
              -53.61980481310804,
              -27.18900175667157
            ],
            [
              -53.61822290493258,
              -27.18732103593192
            ],
            [
              -53.61582276839051,
              -27.186216562303006
            ],
            [
              -53.61331353473289,
              -27.185880418155076
            ],
            [
              -53.60971332991978,
              -27.186312603488126
            ],
            [
              -53.60682225635774,
              -27.18698489178399
            ],
            [
              -53.60098556067588,
              -27.189289880226937
            ],
            [
              -53.5996763952893,
              -27.18938592141206
            ],
            [
              -53.591385014507594,
              -27.187513118302164
            ],
            [
              -53.58909397508107,
              -27.18640864467325
            ],
            [
              -53.58162082266598,
              -27.181990750157595
            ],
            [
              -53.57458405871309,
              -27.177620876234503
            ],
            [
              -53.57109295101553,
              -27.175700052532044
            ],
            [
              -53.56291066734938,
              -27.17257871401555
            ],
            [
              -53.559419559651815,
              -27.172290590460182
            ],
            [
              -53.55620119474313,
              -27.17257871401555
            ],
            [
              -53.55189185867896,
              -27.174019331792394
            ],
            [
              -53.54780071684588,
              -27.176420361420465
            ],
            [
              -53.54550967741935,
              -27.178005040974995
            ],
            [
              -53.54240040962622,
              -27.180790235343558
            ],
            [
              -53.538418364908686,
              -27.186120521117882
            ],
            [
              -53.537218296637654,
              -27.187176974154234
            ],
            [
              -53.5307270182625,
              -27.194476104223575
            ],
            [
              -53.52598129373613,
              -27.19822171044337
            ],
            [
              -53.523799351425154,
              -27.19951826644253
            ],
            [
              -53.5181808499744,
              -27.20220741962597
            ],
            [
              -53.51539887352791,
              -27.203023769699517
            ],
            [
              -53.50748933265062,
              -27.204176263920992
            ],
            [
              -53.50061621437105,
              -27.204320325698678
            ],
            [
              -53.49641597542243,
              -27.204176263920992
            ],
            [
              -53.49308851339819,
              -27.203503975625132
            ],
            [
              -53.490524731182795,
              -27.201006904811937
            ],
            [
              -53.48959740570063,
              -27.19951826644253
            ],
            [
              -53.48828824031405,
              -27.195388495482245
            ],
            [
              -53.4881791431985,
              -27.193803815927716
            ],
            [
              -53.488397337429596,
              -27.187609159487288
            ],
            [
              -53.488888274449565,
              -27.183479388527
            ],
            [
              -53.48970650281618,
              -27.18040607060307
            ],
            [
              -53.491724799453834,
              -27.176708484975837
            ],
            [
              -53.494288581669224,
              -27.17358714645934
            ],
            [
              -53.49597958696023,
              -27.17200246690481
            ],
            [
              -53.49957979177334,
              -27.169217272536248
            ],
            [
              -53.502907253797574,
              -27.16561572809414
            ],
            [
              -53.50508919610855,
              -27.161485957133852
            ],
            [
              -53.50759842976617,
              -27.15380266232402
            ],
            [
              -53.50808936678614,
              -27.151497673881067
            ],
            [
              -53.50830756101724,
              -27.145783223366255
            ],
            [
              -53.50798026967059,
              -27.14362229670099
            ],
            [
              -53.5071074927462,
              -27.13939648455558
            ],
            [
              -53.50558013312852,
              -27.136899413742384
            ],
            [
              -53.503125448028676,
              -27.13478650766968
            ],
            [
              -53.49908885475337,
              -27.133393910485395
            ],
            [
              -53.49472497013142,
              -27.132577560411853
            ],
            [
              -53.49117931387609,
              -27.13228943685648
            ],
            [
              -53.48452438982761,
              -27.133922137003573
            ],
            [
              -53.48201515616999,
              -27.134978590039925
            ],
            [
              -53.47912408260795,
              -27.136707331372136
            ],
            [
              -53.47628755760368,
              -27.138916278629964
            ],
            [
              -53.47219641577061,
              -27.143910420256358
            ],
            [
              -53.46957808499744,
              -27.14770404706871
            ],
            [
              -53.46821437105308,
              -27.150489241437278
            ],
            [
              -53.46652336576207,
              -27.15289027106535
            ],
            [
              -53.46417777777778,
              -27.155003177138056
            ],
            [
              -53.459813893155825,
              -27.15677993906283
            ],
            [
              -53.45757740228708,
              -27.157212124395883
            ],
            [
              -53.4553954599761,
              -27.15692400084051
            ],
            [
              -53.449122375832054,
              -27.154907135952932
            ],
            [
              -53.44410390851681,
              -27.152410065139737
            ],
            [
              -53.4407218979348,
              -27.15020111788191
            ],
            [
              -53.434012425328554,
              -27.14688769699517
            ],
            [
              -53.43177593445981,
              -27.146215408699305
            ],
            [
              -53.42501191329578,
              -27.14511093507039
            ],
            [
              -53.417920600785116,
              -27.14439062618197
            ],
            [
              -53.4154113671275,
              -27.14338219373818
            ],
            [
              -53.41170206519884,
              -27.141413349443162
            ],
            [
              -53.40619266086363,
              -27.136515249001892
            ],
            [
              -53.40357433009046,
              -27.133105786930027
            ],
            [
              -53.401174193548385,
              -27.12950424248792
            ],
            [
              -53.39921044546851,
              -27.125422492120194
            ],
            [
              -53.3981740228708,
              -27.121580844715275
            ],
            [
              -53.3956102406554,
              -27.113417343979826
            ],
            [
              -53.39441017238437,
              -27.1105841290187
            ],
            [
              -53.39321010411333,
              -27.108807367093927
            ],
            [
              -53.3871006656426,
              -27.100595845765916
            ],
            [
              -53.383991397849464,
              -27.096994301323807
            ],
            [
              -53.380991227171876,
              -27.09411306577012
            ],
            [
              -53.37640914831883,
              -27.0915199537718
            ],
            [
              -53.37062700119474,
              -27.091087768438747
            ],
            [
              -53.36768137907493,
              -27.09219224206766
            ],
            [
              -53.365008499743986,
              -27.094305148140364
            ],
            [
              -53.362608363201915,
              -27.097810651397353
            ],
            [
              -53.36031732377539,
              -27.101508237024586
            ],
            [
              -53.356880764635605,
              -27.107894975835258
            ],
            [
              -53.35540795357569,
              -27.111304437907123
            ],
            [
              -53.353280559822494,
              -27.115386188274847
            ],
            [
              -53.350389486260454,
              -27.118219403235976
            ],
            [
              -53.34809844683393,
              -27.11999616516075
            ],
            [
              -53.345807407407406,
              -27.12100459760454
            ],
            [
              -53.339697968936676,
              -27.12138876234503
            ],
            [
              -53.33718873527906,
              -27.121484803530155
            ],
            [
              -53.33309759344598,
              -27.12100459760454
            ],
            [
              -53.328188223246286,
              -27.11999616516075
            ],
            [
              -53.324915309779826,
              -27.118795650346712
            ],
            [
              -53.32142420208227,
              -27.11841148560622
            ],
            [
              -53.31727851169141,
              -27.118603567976464
            ],
            [
              -53.3122054958184,
              -27.119708041605378
            ],
            [
              -53.30871438812084,
              -27.121292721159907
            ],
            [
              -53.30287769243898,
              -27.125614574490438
            ],
            [
              -53.2992229390681,
              -27.128687892414373
            ],
            [
              -53.29622276839051,
              -27.132385478041606
            ],
            [
              -53.29431356886841,
              -27.135602857743223
            ],
            [
              -53.29349534050179,
              -27.137283578482876
            ],
            [
              -53.292895306366276,
              -27.14078908173986
            ],
            [
              -53.2932771462707,
              -27.143814379071234
            ],
            [
              -53.29431356886841,
              -27.14731988232822
            ],
            [
              -53.29600457415941,
              -27.151497673881067
            ],
            [
              -53.298622904932586,
              -27.15677993906283
            ],
            [
              -53.30069575012801,
              -27.160621586467744
            ],
            [
              -53.30298678955453,
              -27.165519686909015
            ],
            [
              -53.30898713090971,
              -27.181606585417104
            ],
            [
              -53.310623587642944,
              -27.18439177978567
            ],
            [
              -53.31460563236047,
              -27.18938592141206
            ],
            [
              -53.31662392899812,
              -27.191498827484764
            ],
            [
              -53.319296808329064,
              -27.195196413111997
            ],
            [
              -53.3207150708312,
              -27.19822171044337
            ],
            [
              -53.32158784775559,
              -27.20278366673671
            ],
            [
              -53.322515173237754,
              -27.209890714435808
            ],
            [
              -53.3226242703533,
              -27.211523414582896
            ],
            [
              -53.32142420208227,
              -27.2148848560622
            ],
            [
              -53.31940590544461,
              -27.21728588569027
            ],
            [
              -53.31580570063151,
              -27.218822544652237
            ],
            [
              -53.31318736985834,
              -27.219110668207605
            ],
            [
              -53.311005427547364,
              -27.218678482874555
            ],
            [
              -53.307787062638674,
              -27.21651755620929
            ],
            [
              -53.304895989076634,
              -27.212916011767177
            ],
            [
              -53.303695920805595,
              -27.210803105694474
            ],
            [
              -53.301186687147975,
              -27.205280737549906
            ],
            [
              -53.29611367127496,
              -27.199422225257408
            ],
            [
              -53.29311350059737,
              -27.19687713385165
            ],
            [
              -53.29120430107527,
              -27.19591672200042
            ],
            [
              -53.28580399385561,
              -27.193515692372348
            ],
            [
              -53.27789445297832,
              -27.191210703929396
            ],
            [
              -53.27271233998976,
              -27.18938592141206
            ],
            [
              -53.267912066905616,
              -27.18741707711704
            ],
            [
              -53.25962068612391,
              -27.183287306156757
            ],
            [
              -53.25182024236218,
              -27.17810108216012
            ],
            [
              -53.244674381293734,
              -27.172818816978356
            ],
            [
              -53.24167421061615,
              -27.17161830216432
            ],
            [
              -53.235510223587646,
              -27.17060986972053
            ],
            [
              -53.23207366444786,
              -27.171090075646145
            ],
            [
              -53.22470960914832,
              -27.175123805421308
            ],
            [
              -53.217291005291,
              -27.179685761714644
            ],
            [
              -53.21030878989589,
              -27.184487820970794
            ],
            [
              -53.204908482676224,
              -27.187897283042656
            ],
            [
              -53.2009264379587,
              -27.1905864362261
            ],
            [
              -53.19721713603004,
              -27.192699342298802
            ],
            [
              -53.19192592592593,
              -27.193083507039294
            ],
            [
              -53.1877256869773,
              -27.19231517755831
            ],
            [
              -53.185980133128524,
              -27.19159486866989
            ],
            [
              -53.18210718552654,
              -27.189289880226937
            ],
            [
              -53.17948885475337,
              -27.185592294599708
            ],
            [
              -53.17801604369346,
              -27.182518976675773
            ],
            [
              -53.17659778119133,
              -27.17790899978987
            ],
            [
              -53.17501587301587,
              -27.17161830216432
            ],
            [
              -53.17430674176481,
              -27.166576139945366
            ],
            [
              -53.17392490186039,
              -27.159901277579323
            ],
            [
              -53.17392490186039,
              -27.155819527211598
            ],
            [
              -53.17321577060932,
              -27.15020111788191
            ],
            [
              -53.172397542242706,
              -27.147992170624082
            ],
            [
              -53.169506468680666,
              -27.144198543811726
            ],
            [
              -53.16699723502304,
              -27.142613864257196
            ],
            [
              -53.16421525857655,
              -27.14131730825804
            ],
            [
              -53.159414985492404,
              -27.140020752258877
            ],
            [
              -53.15668755760369,
              -27.140116793444
            ],
            [
              -53.15461471240826,
              -27.140596999369617
            ],
            [
              -53.151996381635094,
              -27.142085637739022
            ],
            [
              -53.150305376344086,
              -27.143814379071234
            ],
            [
              -53.14888711384195,
              -27.145879264551375
            ],
            [
              -53.1473052056665,
              -27.149384767808364
            ],
            [
              -53.1451778119133,
              -27.155579424248792
            ],
            [
              -53.14370500085339,
              -27.160621586467744
            ],
            [
              -53.141686704215736,
              -27.1715222609792
            ],
            [
              -53.13961385902031,
              -27.175700052532044
            ],
            [
              -53.13819559651818,
              -27.177380773271697
            ],
            [
              -53.13612275132275,
              -27.178677329270855
            ],
            [
              -53.132195255163,
              -27.180213988232822
            ],
            [
              -53.13099518689196,
              -27.180310029417946
            ],
            [
              -53.127013142174434,
              -27.179397638159276
            ],
            [
              -53.12161283495477,
              -27.176708484975837
            ],
            [
              -53.11779443591057,
              -27.174307455347762
            ],
            [
              -53.11332145417307,
              -27.17219454927506
            ],
            [
              -53.10470278204472,
              -27.16940935490649
            ],
            [
              -53.096302304147464,
              -27.16729644883379
            ],
            [
              -53.0911201911589,
              -27.166191975204875
            ],
            [
              -53.082719713261646,
              -27.164991460390837
            ],
            [
              -53.08021047960403,
              -27.164319172094977
            ],
            [
              -53.075301109404336,
              -27.162014183652026
            ],
            [
              -53.072519132957844,
              -27.158988886320657
            ],
            [
              -53.07120996757126,
              -27.157020042025636
            ],
            [
              -53.069682607953574,
              -27.15159371506619
            ],
            [
              -53.06979170506912,
              -27.146119367514185
            ],
            [
              -53.07071903055129,
              -27.14179751418365
            ],
            [
              -53.07088267622461,
              -27.139204402185335
            ],
            [
              -53.07181000170678,
              -27.13449838411431
            ],
            [
              -53.07279187574672,
              -27.132097354486238
            ],
            [
              -53.07557385219321,
              -27.128111645303637
            ],
            [
              -53.07841037719747,
              -27.121100638789663
            ],
            [
              -53.079010411332995,
              -27.118507526791344
            ],
            [
              -53.07917405700631,
              -27.115914414793025
            ],
            [
              -53.078301280081924,
              -27.111304437907123
            ],
            [
              -53.07671937190647,
              -27.107798934650138
            ],
            [
              -53.07301006997781,
              -27.1019884429502
            ],
            [
              -53.07011899641577,
              -27.098482939693213
            ],
            [
              -53.06411865506059,
              -27.092096200882537
            ],
            [
              -53.061009387267454,
              -27.089407047699098
            ],
            [
              -53.054790851681176,
              -27.085997585627233
            ],
            [
              -53.05059061273255,
              -27.08422082370246
            ],
            [
              -53.04819047619048,
              -27.08369259718428
            ],
            [
              -53.034280593958016,
              -27.0823
            ],
            [
              -53.029807612220516,
              -27.082588123555368
            ],
            [
              -53.0272983785629,
              -27.08321239125867
            ],
            [
              -53.024080013654206,
              -27.08460498844295
            ],
            [
              -53.02140713432326,
              -27.08647779155285
            ],
            [
              -53.01949793480116,
              -27.089118924143726
            ],
            [
              -53.01780692951016,
              -27.09310463332633
            ],
            [
              -53.017206895374635,
              -27.095217539399034
            ],
            [
              -53.01747963816351,
              -27.09901116621139
            ],
            [
              -53.01900699778119,
              -27.10227656650557
            ],
            [
              -53.02031616316778,
              -27.104581554948517
            ],
            [
              -53.02478914490528,
              -27.109287573019543
            ],
            [
              -53.02888028673835,
              -27.112793076276528
            ],
            [
              -53.03340781703363,
              -27.11610649716327
            ],
            [
              -53.03831718723332,
              -27.120908556419415
            ],
            [
              -53.04142645502645,
              -27.124894265602016
            ],
            [
              -53.042899266086366,
              -27.128207686488757
            ],
            [
              -53.04480846560847,
              -27.133922137003573
            ],
            [
              -53.045026659839564,
              -27.137283578482876
            ],
            [
              -53.044208431472946,
              -27.144102502626602
            ],
            [
              -53.04262652329749,
              -27.149912994326538
            ],
            [
              -53.04120826079536,
              -27.15289027106535
            ],
            [
              -53.038917221368834,
              -27.156491815507458
            ],
            [
              -53.03760805598225,
              -27.157692330321495
            ],
            [
              -53.03198955453149,
              -27.15951711283883
            ],
            [
              -53.029916709336064,
              -27.15951711283883
            ],
            [
              -53.026207407407405,
              -27.158604721580165
            ],
            [
              -53.0226072025943,
              -27.156683897877706
            ],
            [
              -53.018297866530126,
              -27.15289027106535
            ],
            [
              -53.013006656426015,
              -27.146599573439797
            ],
            [
              -53.01011558286397,
              -27.142085637739022
            ],
            [
              -53.006024441030895,
              -27.137523681445682
            ],
            [
              -53.0030242703533,
              -27.135602857743223
            ],
            [
              -52.99969680832907,
              -27.13521869300273
            ],
            [
              -52.99658754053593,
              -27.13608306366884
            ],
            [
              -52.995005632360474,
              -27.136995454927508
            ],
            [
              -52.99249639870285,
              -27.140020752258877
            ],
            [
              -52.991678170336236,
              -27.14098116411011
            ],
            [
              -52.988896193889744,
              -27.145495099810883
            ],
            [
              -52.98491414917221,
              -27.153418497583527
            ],
            [
              -52.98300494965011,
              -27.15908492750578
            ],
            [
              -52.982677658303466,
              -27.163502822021435
            ],
            [
              -52.98289585253456,
              -27.164991460390837
            ],
            [
              -52.9840959208056,
              -27.168785087203194
            ],
            [
              -52.98507779484554,
              -27.170513828535405
            ],
            [
              -52.98911438812084,
              -27.17449953771801
            ],
            [
              -52.9942965011094,
              -27.178293164530363
            ],
            [
              -52.998278545826935,
              -27.182278873712967
            ],
            [
              -53.00051503669568,
              -27.185208129859213
            ],
            [
              -53.00127871650452,
              -27.186792809413742
            ],
            [
              -53.00247878477556,
              -27.192699342298802
            ],
            [
              -53.00258788189111,
              -27.197597442740072
            ],
            [
              -53.00002409967571,
              -27.20672135532675
            ],
            [
              -52.9994240655402,
              -27.20801791132591
            ],
            [
              -52.99571476361154,
              -27.21320413532255
            ],
            [
              -52.991678170336236,
              -27.217718071023324
            ],
            [
              -52.98660515446322,
              -27.220695347762135
            ],
            [
              -52.984423212152244,
              -27.22151169783568
            ],
            [
              -52.97880471070148,
              -27.221319615465433
            ],
            [
              -52.9755863457928,
              -27.220311183021643
            ],
            [
              -52.971222461170846,
              -27.217814112208448
            ],
            [
              -52.96980419866871,
              -27.216181412061356
            ],
            [
              -52.96849503328213,
              -27.2130120529523
            ],
            [
              -52.96800409626216,
              -27.20897832317714
            ],
            [
              -52.967894999146615,
              -27.198077648665688
            ],
            [
              -52.96800409626216,
              -27.1958206808153
            ],
            [
              -52.96767680491551,
              -27.19039435385585
            ],
            [
              -52.96609489674006,
              -27.180694194158438
            ],
            [
              -52.964294794333505,
              -27.17521984660643
            ],
            [
              -52.96151281788701,
              -27.16859300483295
            ],
            [
              -52.95960361836491,
              -27.165711769279262
            ],
            [
              -52.95671254480287,
              -27.163310739651187
            ],
            [
              -52.95349417989418,
              -27.162878554318134
            ],
            [
              -52.949893975081075,
              -27.16302261609582
            ],
            [
              -52.945093701996925,
              -27.164799378020593
            ],
            [
              -52.942202628434885,
              -27.166384057575122
            ],
            [
              -52.93827513227513,
              -27.170801952090777
            ],
            [
              -52.936802321215225,
              -27.174019331792394
            ],
            [
              -52.93609318996416,
              -27.178005040974995
            ],
            [
              -52.93702051544632,
              -27.19092258037403
            ],
            [
              -52.937675098139614,
              -27.19721327799958
            ],
            [
              -52.936802321215225,
              -27.20047867829376
            ],
            [
              -52.93587499573306,
              -27.201583151922673
            ],
            [
              -52.93287482505547,
              -27.203215852069764
            ],
            [
              -52.92927462024236,
              -27.20408022273587
            ],
            [
              -52.923274278887185,
              -27.2037920991805
            ],
            [
              -52.91820126301417,
              -27.203215852069764
            ],
            [
              -52.906909711554874,
              -27.200622740071445
            ],
            [
              -52.90341860385731,
              -27.199086081109478
            ],
            [
              -52.89921836490869,
              -27.19687713385165
            ],
            [
              -52.89529086874894,
              -27.19389985711284
            ],
            [
              -52.89141792114695,
              -27.190010189115362
            ],
            [
              -52.88858139614268,
              -27.186120521117882
            ],
            [
              -52.88509028844513,
              -27.182711059046017
            ],
            [
              -52.87701710189452,
              -27.177380773271697
            ],
            [
              -52.87461696535245,
              -27.176084217272535
            ],
            [
              -52.866707424475166,
              -27.172818816978356
            ],
            [
              -52.85999795186892,
              -27.170417787350285
            ],
            [
              -52.85612500426694,
              -27.169697478461863
            ],
            [
              -52.85252479945383,
              -27.169889560832107
            ],
            [
              -52.8513247311828,
              -27.17032174616516
            ],
            [
              -52.84848820617853,
              -27.17118611683127
            ],
            [
              -52.84712449223417,
              -27.172098508089935
            ],
            [
              -52.84439706434545,
              -27.17521984660643
            ],
            [
              -52.84308789895887,
              -27.17848524690061
            ],
            [
              -52.842924253285545,
              -27.18050211178819
            ],
            [
              -52.84368793309439,
              -27.184295738600547
            ],
            [
              -52.84608806963646,
              -27.190682477411222
            ],
            [
              -52.84657900665643,
              -27.197597442740072
            ],
            [
              -52.846688103771974,
              -27.202303460811095
            ],
            [
              -52.84608806963646,
              -27.20619312880857
            ],
            [
              -52.84570622973204,
              -27.20739364362261
            ],
            [
              -52.842596961938895,
              -27.210178837991176
            ],
            [
              -52.839705888376855,
              -27.21128331162009
            ],
            [
              -52.8379057859703,
              -27.211523414582896
            ],
            [
              -52.833978289810545,
              -27.21128331162009
            ],
            [
              -52.83081447345963,
              -27.210322899768858
            ],
            [
              -52.82672333162656,
              -27.207921870140787
            ],
            [
              -52.823723160948965,
              -27.205616881697836
            ],
            [
              -52.821323024406894,
              -27.204176263920992
            ],
            [
              -52.81728643113159,
              -27.202495543181342
            ],
            [
              -52.81417716333846,
              -27.202303460811095
            ],
            [
              -52.80752223928998,
              -27.20239950199622
            ],
            [
              -52.80097641235706,
              -27.20340793444001
            ],
            [
              -52.799121761392726,
              -27.203600016810256
            ],
            [
              -52.78548462194914,
              -27.206001046438328
            ],
            [
              -52.77479310462536,
              -27.207489684807733
            ],
            [
              -52.767592694999145,
              -27.209602590880436
            ],
            [
              -52.76361065028162,
              -27.211187270434966
            ],
            [
              -52.76050138248848,
              -27.21320413532255
            ],
            [
              -52.758592182966375,
              -27.21522100021013
            ],
            [
              -52.757719406041986,
              -27.21718984450515
            ],
            [
              -52.75761030892644,
              -27.22218398613154
            ],
            [
              -52.7583194401775,
              -27.225593448203405
            ],
            [
              -52.76050138248848,
              -27.230923733977725
            ],
            [
              -52.76311971326165,
              -27.238414946417315
            ],
            [
              -52.76388339307049,
              -27.242976902710655
            ],
            [
              -52.76361065028162,
              -27.247010632485818
            ],
            [
              -52.7630106161461,
              -27.249219579743645
            ],
            [
              -52.76077412527735,
              -27.253685494851858
            ],
            [
              -52.75761030892644,
              -27.257479121664215
            ],
            [
              -52.75630114353985,
              -27.258391512922884
            ],
            [
              -52.752319098822326,
              -27.259784110107166
            ],
            [
              -52.74877344256699,
              -27.25997619247741
            ],
            [
              -52.74610056323605,
              -27.259207862996426
            ],
            [
              -52.74239126130739,
              -27.257719224627024
            ],
            [
              -52.74031841611197,
              -27.25599048329481
            ],
            [
              -52.739172896398706,
              -27.254405803740283
            ],
            [
              -52.7374818911077,
              -27.250179991594873
            ],
            [
              -52.733990783410135,
              -27.242688779155284
            ],
            [
              -52.730281481481484,
              -27.238078802269385
            ],
            [
              -52.72700856801502,
              -27.23601391678924
            ],
            [
              -52.723681105990785,
              -27.235101525530574
            ],
            [
              -52.72062638675542,
              -27.23500548434545
            ],
            [
              -52.7162079535757,
              -27.23601391678924
            ],
            [
              -52.713807817033626,
              -27.237694637528893
            ],
            [
              -52.71228045741594,
              -27.239999625971844
            ],
            [
              -52.710589452124935,
              -27.243601170413953
            ],
            [
              -52.70829841269841,
              -27.24979582685438
            ],
            [
              -52.70628011606076,
              -27.256086524479933
            ],
            [
              -52.70578917904079,
              -27.260120254255096
            ],
            [
              -52.70600737327189,
              -27.26319357217903
            ],
            [
              -52.70720744154293,
              -27.27078082580374
            ],
            [
              -52.70660740740741,
              -27.27471851439378
            ],
            [
              -52.70540733913637,
              -27.276783399873924
            ],
            [
              -52.70349813961427,
              -27.27928047068712
            ],
            [
              -52.70011612903226,
              -27.282113685648245
            ],
            [
              -52.69738870114354,
              -27.283506282832526
            ],
            [
              -52.694988564601466,
              -27.284322632906072
            ],
            [
              -52.69149745690391,
              -27.284418674091196
            ],
            [
              -52.68942461170848,
              -27.28389044757302
            ],
            [
              -52.686097149684244,
              -27.2812973355747
            ],
            [
              -52.681896910735624,
              -27.275582885059887
            ],
            [
              -52.67987861409797,
              -27.271597175877286
            ],
            [
              -52.677423928998124,
              -27.26280940743854
            ],
            [
              -52.677314831882576,
              -27.260504418995588
            ],
            [
              -52.67758757467145,
              -27.25171665055684
            ],
            [
              -52.677423928998124,
              -27.24912353855852
            ],
            [
              -52.67638750640041,
              -27.245714076486657
            ],
            [
              -52.67387827274279,
              -27.24249669678504
            ],
            [
              -52.672023621778465,
              -27.240479831897456
            ],
            [
              -52.667605188598735,
              -27.237790678714017
            ],
            [
              -52.663786789554536,
              -27.237118390418154
            ],
            [
              -52.660186584741425,
              -27.237790678714017
            ],
            [
              -52.65751370541048,
              -27.23951942004623
            ],
            [
              -52.655277214541734,
              -27.24148826434125
            ],
            [
              -52.65287707799966,
              -27.244993767598235
            ],
            [
              -52.64987690732207,
              -27.25042009455768
            ],
            [
              -52.64807680491552,
              -27.257190998108847
            ],
            [
              -52.64720402799112,
              -27.259495986551798
            ],
            [
              -52.6449129885646,
              -27.261704933809625
            ],
            [
              -52.64240375490698,
              -27.262905448623663
            ],
            [
              -52.639676327018265,
              -27.26381783988233
            ],
            [
              -52.633185048643114,
              -27.265498560621978
            ],
            [
              -52.626584673152415,
              -27.26612282832528
            ],
            [
              -52.617911452466295,
              -27.265690642992226
            ],
            [
              -52.614693087557605,
              -27.26511439588149
            ],
            [
              -52.611311076975596,
              -27.264105963437697
            ],
            [
              -52.60541983273596,
              -27.261080666106324
            ],
            [
              -52.603183341867215,
              -27.25930390418155
            ],
            [
              -52.59358279569893,
              -27.250276032779997
            ],
            [
              -52.58878252261478,
              -27.247298756041186
            ],
            [
              -52.5874733572282,
              -27.246914591300694
            ],
            [
              -52.582673084144055,
              -27.246722508930446
            ],
            [
              -52.57798190817546,
              -27.247298756041186
            ],
            [
              -52.5697996245093,
              -27.248979476780836
            ],
            [
              -52.56652671104284,
              -27.249315620928765
            ],
            [
              -52.56358108892302,
              -27.248883435595715
            ],
            [
              -52.56112640382318,
              -27.2477789619668
            ],
            [
              -52.55790803891449,
              -27.245185849968482
            ],
            [
              -52.55501696535245,
              -27.241392223156126
            ],
            [
              -52.55288957159925,
              -27.239279317083422
            ],
            [
              -52.550707629288276,
              -27.238414946417315
            ],
            [
              -52.54738016726404,
              -27.238799111157807
            ],
            [
              -52.544598190817545,
              -27.240623893675142
            ],
            [
              -52.54388905956648,
              -27.241104099600758
            ],
            [
              -52.542198054275474,
              -27.243793252784197
            ],
            [
              -52.54061614610002,
              -27.248691353225468
            ],
            [
              -52.5400161119645,
              -27.251620609371717
            ],
            [
              -52.53870694657792,
              -27.25599048329481
            ],
            [
              -52.536306810035846,
              -27.260120254255096
            ],
            [
              -52.53461580474484,
              -27.260984624921203
            ],
            [
              -52.531506536951696,
              -27.262185139735237
            ],
            [
              -52.52719720088752,
              -27.262905448623663
            ],
            [
              -52.519178562894695,
              -27.26280940743854
            ],
            [
              -52.508105205666496,
              -27.264105963437697
            ],
            [
              -52.492995255162995,
              -27.26717928136163
            ],
            [
              -52.48879501621437,
              -27.267323343139317
            ],
            [
              -52.48317651476361,
              -27.26717928136163
            ],
            [
              -52.47930356716163,
              -27.26588272536247
            ],
            [
              -52.47772165898618,
              -27.264105963437697
            ],
            [
              -52.476576139272915,
              -27.261704933809625
            ],
            [
              -52.47641249359959,
              -27.259207862996426
            ],
            [
              -52.478594435910566,
              -27.2523889388527
            ],
            [
              -52.4800126984127,
              -27.250179991594873
            ],
            [
              -52.48159460658815,
              -27.246578447152764
            ],
            [
              -52.481812800819256,
              -27.245185849968482
            ],
            [
              -52.48159460658815,
              -27.24081597604539
            ],
            [
              -52.48077637822154,
              -27.23759859634377
            ],
            [
              -52.479794504181605,
              -27.235485690271066
            ],
            [
              -52.47728527052398,
              -27.23361288716117
            ],
            [
              -52.475376071001875,
              -27.2327004959025
            ],
            [
              -52.466702850315755,
              -27.23101977516285
            ],
            [
              -52.46250261136713,
              -27.229194992645514
            ],
            [
              -52.460211571940604,
              -27.227514271905864
            ],
            [
              -52.4547021676054,
              -27.222904295019962
            ],
            [
              -52.450720122887866,
              -27.21987899768859
            ],
            [
              -52.44777450076805,
              -27.21819827694894
            ],
            [
              -52.44488342720601,
              -27.216901720949778
            ],
            [
              -52.440519542584056,
              -27.216181412061356
            ],
            [
              -52.437573920464246,
              -27.216181412061356
            ],
            [
              -52.43528288103772,
              -27.216709638579534
            ],
            [
              -52.43250090459123,
              -27.217814112208448
            ],
            [
              -52.43031896228025,
              -27.221223574280312
            ],
            [
              -52.430209865164706,
              -27.223720645093508
            ],
            [
              -52.43097354497355,
              -27.22650583946207
            ],
            [
              -52.43337368151562,
              -27.230923733977725
            ],
            [
              -52.43730117767537,
              -27.23659016389998
            ],
            [
              -52.438883085850826,
              -27.240287749527212
            ],
            [
              -52.4395922171019,
              -27.243120964488337
            ],
            [
              -52.441501416624,
              -27.248019064929608
            ],
            [
              -52.442101450759516,
              -27.250516135742803
            ],
            [
              -52.442210547875064,
              -27.253781536036982
            ],
            [
              -52.44199235364397,
              -27.258199430552636
            ],
            [
              -52.440519542584056,
              -27.262185139735237
            ],
            [
              -52.43910128008193,
              -27.264394086993065
            ],
            [
              -52.435173783922174,
              -27.26818771380542
            ],
            [
              -52.43200996757126,
              -27.27078082580374
            ],
            [
              -52.426991500256015,
              -27.275486843874763
            ],
            [
              -52.422082130056324,
              -27.279712656020173
            ],
            [
              -52.419191056494284,
              -27.282401809203613
            ],
            [
              -52.41559085168117,
              -27.285283044757303
            ],
            [
              -52.41231793821471,
              -27.28691574490439
            ],
            [
              -52.40691763099505,
              -27.29008510401345
            ],
            [
              -52.403590168970815,
              -27.29147770119773
            ],
            [
              -52.40009906127325,
              -27.29248613364152
            ],
            [
              -52.397808021846735,
              -27.29248613364152
            ],
            [
              -52.39589882232463,
              -27.291381660012608
            ],
            [
              -52.39409871991808,
              -27.2877801155705
            ],
            [
              -52.393716880013656,
              -27.285090962387056
            ],
            [
              -52.39388052568698,
              -27.283506282832526
            ],
            [
              -52.395789725209085,
              -27.2773116263921
            ],
            [
              -52.396717050691244,
              -27.273181855431815
            ],
            [
              -52.397808021846735,
              -27.269916455137633
            ],
            [
              -52.39971722136883,
              -27.26328961336415
            ],
            [
              -52.399989964157704,
              -27.260984624921203
            ],
            [
              -52.39971722136883,
              -27.25661475099811
            ],
            [
              -52.397098890595664,
              -27.253493412481614
            ],
            [
              -52.39469875405359,
              -27.251812691741964
            ],
            [
              -52.39158948626046,
              -27.25138050640891
            ],
            [
              -52.390007578085,
              -27.25171665055684
            ],
            [
              -52.38580733913637,
              -27.253493412481614
            ],
            [
              -52.384389076634235,
              -27.25469392729565
            ],
            [
              -52.38209803720772,
              -27.2576231834419
            ],
            [
              -52.381116163167775,
              -27.260792542550956
            ],
            [
              -52.3812798088411,
              -27.264394086993065
            ],
            [
              -52.382698071343235,
              -27.2720773818029
            ],
            [
              -52.38329810547875,
              -27.2812973355747
            ],
            [
              -52.38258897422769,
              -27.28758803320025
            ],
            [
              -52.381498003072196,
              -27.29469508089935
            ],
            [
              -52.38051612903226,
              -27.298296625341457
            ],
            [
              -52.37849783239461,
              -27.302714519857112
            ],
            [
              -52.37762505547022,
              -27.30391503467115
            ],
            [
              -52.375006724697045,
              -27.305115549485187
            ],
            [
              -52.371188325652845,
              -27.30530763185543
            ],
            [
              -52.36747902372419,
              -27.304491281781885
            ],
            [
              -52.36562437275986,
              -27.30329076696785
            ],
            [
              -52.36109684246458,
              -27.299497140155495
            ],
            [
              -52.359787677078,
              -27.297816419415845
            ],
            [
              -52.356896603515956,
              -27.292918318974575
            ],
            [
              -52.35542379245605,
              -27.291189577642363
            ],
            [
              -52.35209633043181,
              -27.288884589199412
            ],
            [
              -52.35018713090971,
              -27.288212300903552
            ],
            [
              -52.34718696023212,
              -27.288020218533305
            ],
            [
              -52.34527776071002,
              -27.288308342088676
            ],
            [
              -52.34200484724356,
              -27.289604898087834
            ],
            [
              -52.34031384195255,
              -27.29109353645724
            ],
            [
              -52.33791370541048,
              -27.29402279260349
            ],
            [
              -52.332295203959724,
              -27.299881304895987
            ],
            [
              -52.329076839051034,
              -27.302186293338938
            ],
            [
              -52.32389472606247,
              -27.304107117041397
            ],
            [
              -52.31658521932071,
              -27.307276476150452
            ],
            [
              -52.313094111623144,
              -27.309293341038035
            ],
            [
              -52.311021266427716,
              -27.311310205925615
            ],
            [
              -52.310093940945556,
              -27.312894885480144
            ],
            [
              -52.3063846390169,
              -27.316880594662745
            ],
            [
              -52.30338446833931,
              -27.31870537718008
            ],
            [
              -52.2997842635262,
              -27.319089541920572
            ],
            [
              -52.29487489332651,
              -27.31740882118092
            ],
            [
              -52.29329298515105,
              -27.316016223996638
            ],
            [
              -52.292092916880016,
              -27.314287482664426
            ],
            [
              -52.29160197986005,
              -27.312510720739652
            ],
            [
              -52.291001945724524,
              -27.308717093927296
            ],
            [
              -52.2912746885134,
              -27.30521159067031
            ],
            [
              -52.29351117938215,
              -27.29959318134062
            ],
            [
              -52.29651135005974,
              -27.293590607270435
            ],
            [
              -52.299075132275135,
              -27.29008510401345
            ],
            [
              -52.302020754394945,
              -27.284706797646564
            ],
            [
              -52.30529366786141,
              -27.27471851439378
            ],
            [
              -52.30622099334357,
              -27.27010853750788
            ],
            [
              -52.306111896228025,
              -27.265690642992226
            ],
            [
              -52.30469363372589,
              -27.26261732506829
            ],
            [
              -52.30049339477727,
              -27.258487554108008
            ],
            [
              -52.29880238948626,
              -27.257479121664215
            ],
            [
              -52.29400211640212,
              -27.25671079218323
            ],
            [
              -52.29029281447346,
              -27.2569989157386
            ],
            [
              -52.28838361495136,
              -27.257479121664215
            ],
            [
              -52.28478341013825,
              -27.25959202773692
            ],
            [
              -52.28101955965182,
              -27.260792542550956
            ],
            [
              -52.2782921317631,
              -27.261176707291447
            ],
            [
              -52.272509984639015,
              -27.26060046018071
            ],
            [
              -52.27010984809694,
              -27.25988015129229
            ],
            [
              -52.2612729817375,
              -27.25690287455348
            ],
            [
              -52.25707274278887,
              -27.256182565665057
            ],
            [
              -52.254508960573474,
              -27.256422668627863
            ],
            [
              -52.245508448540704,
              -27.259207862996426
            ],
            [
              -52.241308209592084,
              -27.260696501365835
            ],
            [
              -52.23852623314559,
              -27.262089098550117
            ],
            [
              -52.23541696535245,
              -27.26420200462282
            ],
            [
              -52.23421689708142,
              -27.26588272536247
            ],
            [
              -52.233998702850315,
              -27.26919614624921
            ],
            [
              -52.235580611025775,
              -27.272317484765708
            ],
            [
              -52.236889776412355,
              -27.273806123135113
            ],
            [
              -52.24179914661205,
              -27.276111111578064
            ],
            [
              -52.245890288445125,
              -27.277215585206978
            ],
            [
              -52.24959959037378,
              -27.27769579113259
            ],
            [
              -52.25641816009558,
              -27.278079955873082
            ],
            [
              -52.25980017067759,
              -27.278896305946628
            ],
            [
              -52.26449134664619,
              -27.2812973355747
            ],
            [
              -52.267982454343745,
              -27.28321815927716
            ],
            [
              -52.26950981396143,
              -27.28461075646144
            ],
            [
              -52.27441918416112,
              -27.29042124816138
            ],
            [
              -52.27551015531661,
              -27.29147770119773
            ],
            [
              -52.27791029185868,
              -27.294887163269596
            ],
            [
              -52.27840122887865,
              -27.296807986972052
            ],
            [
              -52.27769209762758,
              -27.300217449043917
            ],
            [
              -52.27458282983444,
              -27.303482849338096
            ],
            [
              -52.27300092165899,
              -27.304395240596765
            ],
            [
              -52.27021894521249,
              -27.304491281781885
            ],
            [
              -52.26367311827957,
              -27.304011075856273
            ],
            [
              -52.253581635091315,
              -27.302378375709182
            ],
            [
              -52.25052691585595,
              -27.302090252153814
            ],
            [
              -52.24812677931388,
              -27.302378375709182
            ],
            [
              -52.24289011776754,
              -27.303482849338096
            ],
            [
              -52.24109001536098,
              -27.30429919941164
            ],
            [
              -52.23738071343233,
              -27.307276476150452
            ],
            [
              -52.23481693121693,
              -27.310685938222317
            ],
            [
              -52.23252589179041,
              -27.314815709182604
            ],
            [
              -52.23121672640382,
              -27.318081109476783
            ],
            [
              -52.22919842976617,
              -27.325284198361
            ],
            [
              -52.22838020139956,
              -27.327397104433704
            ],
            [
              -52.22718013312852,
              -27.328981783988233
            ],
            [
              -52.22477999658645,
              -27.330614484135324
            ],
            [
              -52.22112524321557,
              -27.332007081319606
            ],
            [
              -52.215888581669226,
              -27.332487287245222
            ],
            [
              -52.21337934801161,
              -27.331911040134482
            ],
            [
              -52.209397303294075,
              -27.3305184429502
            ],
            [
              -52.207324458098654,
              -27.329317928136163
            ],
            [
              -52.205578904249876,
              -27.327397104433704
            ],
            [
              -52.20312421915003,
              -27.32297920991805
            ],
            [
              -52.201215019627924,
              -27.318417253624713
            ],
            [
              -52.19968766001024,
              -27.31380727673881
            ],
            [
              -52.19668748933265,
              -27.305979920151294
            ],
            [
              -52.195378323946066,
              -27.303098684597604
            ],
            [
              -52.19101443932412,
              -27.291717804160537
            ],
            [
              -52.18779607441543,
              -27.28619543601597
            ],
            [
              -52.18288670421574,
              -27.279904738390417
            ],
            [
              -52.18010472776925,
              -27.276591317503676
            ],
            [
              -52.17590448882062,
              -27.273277896616936
            ],
            [
              -52.17230428400751,
              -27.271501134692162
            ],
            [
              -52.168322239289985,
              -27.270876866988864
            ],
            [
              -52.16477658303465,
              -27.272221443580584
            ],
            [
              -52.163521966205835,
              -27.273181855431815
            ],
            [
              -52.16090363543267,
              -27.276111111578064
            ],
            [
              -52.15959447004609,
              -27.27832005883589
            ],
            [
              -52.159321727257215,
              -27.28158545913007
            ],
            [
              -52.16079453831712,
              -27.287684074385375
            ],
            [
              -52.16270373783922,
              -27.292198010086153
            ],
            [
              -52.164722034476874,
              -27.296279760453878
            ],
            [
              -52.16777675371224,
              -27.303818993486026
            ],
            [
              -52.16881317630995,
              -27.307420537928138
            ],
            [
              -52.169085919098826,
              -27.309293341038035
            ],
            [
              -52.167994947943335,
              -27.312318638369405
            ],
            [
              -52.16608574842123,
              -27.313615194368566
            ],
            [
              -52.16412200034136,
              -27.314191441479302
            ],
            [
              -52.16128547533709,
              -27.314287482664426
            ],
            [
              -52.15632155657962,
              -27.312606761924776
            ],
            [
              -52.14830291858679,
              -27.309005217482664
            ],
            [
              -52.14612097627582,
              -27.307708661483506
            ],
            [
              -52.14192073732719,
              -27.305979920151294
            ],
            [
              -52.134011196449904,
              -27.30357889052322
            ],
            [
              -52.12631984980372,
              -27.302522437486868
            ],
            [
              -52.1216832223929,
              -27.30261847867199
            ],
            [
              -52.119173988735284,
              -27.303194725782728
            ],
            [
              -52.11431916709336,
              -27.305019508300063
            ],
            [
              -52.11197357910906,
              -27.306316064299224
            ],
            [
              -52.107718791602665,
              -27.309677505778524
            ],
            [
              -52.10570049496501,
              -27.31342311199832
            ],
            [
              -52.10531865506059,
              -27.31740882118092
            ],
            [
              -52.10570049496501,
              -27.322787127547805
            ],
            [
              -52.10711875746715,
              -27.326100548434546
            ],
            [
              -52.11077351083803,
              -27.33320759613364
            ],
            [
              -52.11110080218467,
              -27.335416543391467
            ],
            [
              -52.11071896228025,
              -27.337193305316244
            ],
            [
              -52.10880976275815,
              -27.341179014498845
            ],
            [
              -52.10711875746715,
              -27.343387961756672
            ],
            [
              -52.10330035842294,
              -27.346701382643413
            ],
            [
              -52.09920921658986,
              -27.34819002101282
            ],
            [
              -52.096590885816696,
              -27.348382103383063
            ],
            [
              -52.0938089093702,
              -27.348093979827695
            ],
            [
              -52.09179061273255,
              -27.34727762975415
            ],
            [
              -52.08589936849292,
              -27.342811714645933
            ],
            [
              -52.08219006656426,
              -27.340218602647617
            ],
            [
              -52.0786989588667,
              -27.33877798487077
            ],
            [
              -52.076080628093536,
              -27.33839382013028
            ],
            [
              -52.071989486260456,
              -27.33839382013028
            ],
            [
              -52.06609824202082,
              -27.339498293759192
            ],
            [
              -52.06227984297662,
              -27.340890890943477
            ],
            [
              -52.05818870114354,
              -27.343099838201304
            ],
            [
              -52.054424850657114,
              -27.344780558940954
            ],
            [
              -52.04902454343745,
              -27.34631721790292
            ],
            [
              -52.04482430448882,
              -27.34660534145829
            ],
            [
              -52.042587813620074,
              -27.34598107375499
            ],
            [
              -52.03838757467145,
              -27.344204311830218
            ],
            [
              -52.035605598224954,
              -27.342523591090565
            ],
            [
              -52.031078067929684,
              -27.339498293759192
            ],
            [
              -52.026986926096605,
              -27.337001222945997
            ],
            [
              -52.023223075610176,
              -27.334216028577433
            ],
            [
              -52.01989561358594,
              -27.331911040134482
            ],
            [
              -52.01727728281277,
              -27.331094690060937
            ],
            [
              -52.01498624338625,
              -27.330902607690692
            ],
            [
              -52.01122239289981,
              -27.33181499894936
            ],
            [
              -52.00931319337771,
              -27.332583328430342
            ],
            [
              -52.008113125106675,
              -27.333687802059256
            ],
            [
              -52.00740399385561,
              -27.335800708131963
            ],
            [
              -52.00718579962451,
              -27.339306211388948
            ],
            [
              -52.00838586789555,
              -27.343195879386425
            ],
            [
              -52.01078600443762,
              -27.34660534145829
            ],
            [
              -52.01367707799966,
              -27.349006371086364
            ],
            [
              -52.0170045400239,
              -27.351023235973944
            ],
            [
              -52.020713841952556,
              -27.35251187434335
            ],
            [
              -52.02267759003243,
              -27.3548168627863
            ],
            [
              -52.023223075610176,
              -27.355921336415214
            ],
            [
              -52.023604915514596,
              -27.358994654339146
            ],
            [
              -52.022895784263525,
              -27.362212034040766
            ],
            [
              -52.02027745349036,
              -27.365093269594453
            ],
            [
              -52.017113637139445,
              -27.367782422777896
            ],
            [
              -52.01242246117085,
              -27.371191884849758
            ],
            [
              -52.00642211981567,
              -27.374601346921622
            ],
            [
              -52.0018945895204,
              -27.376714252994326
            ],
            [
              -51.99671247653183,
              -27.37820289136373
            ],
            [
              -51.992512237583206,
              -27.37839497373398
            ],
            [
              -51.988475644307904,
              -27.377290500105065
            ],
            [
              -51.98340262843489,
              -27.375081552847238
            ],
            [
              -51.98078429766172,
              -27.3738810380332
            ],
            [
              -51.975220344768736,
              -27.372392399663795
            ],
            [
              -51.972111076975594,
              -27.372392399663795
            ],
            [
              -51.968019935142514,
              -27.372920626181973
            ],
            [
              -51.96240143369176,
              -27.3745053057365
            ],
            [
              -51.95640109233658,
              -27.37772268543812
            ],
            [
              -51.9520917562724,
              -27.380219756251314
            ],
            [
              -51.95100078511692,
              -27.381516312250472
            ],
            [
              -51.94887339136371,
              -27.385790144988444
            ],
            [
              -51.948600648574846,
              -27.389583771800798
            ],
            [
              -51.949091585594815,
              -27.392513027947047
            ],
            [
              -51.9506189452125,
              -27.394481872242068
            ],
            [
              -51.95389185867896,
              -27.395394263500737
            ],
            [
              -51.95711022358764,
              -27.395106139945366
            ],
            [
              -51.96371059907834,
              -27.39361750157596
            ],
            [
              -51.969983683222395,
              -27.39188876024375
            ],
            [
              -51.97560218467315,
              -27.38967981298592
            ],
            [
              -51.97871145246629,
              -27.388911483504938
            ],
            [
              -51.98220256016385,
              -27.38862335994957
            ],
            [
              -51.990875780849976,
              -27.389103565875185
            ],
            [
              -51.99807619047619,
              -27.39068824542971
            ],
            [
              -52.00058542413381,
              -27.391504595503257
            ],
            [
              -52.00478566308244,
              -27.39352146039084
            ],
            [
              -52.00658576548899,
              -27.395010098760245
            ],
            [
              -52.00860406212664,
              -27.3988037255726
            ],
            [
              -52.008494965011096,
              -27.40211714645934
            ],
            [
              -52.00778583376003,
              -27.403893908384113
            ],
            [
              -52.00642211981567,
              -27.405718690901452
            ],
            [
              -52.00331285202253,
              -27.408215761714647
            ],
            [
              -51.99960355009387,
              -27.409704400084053
            ],
            [
              -51.99638518518519,
              -27.410184606009665
            ],
            [
              -51.98449359959037,
              -27.410520750157595
            ],
            [
              -51.97429301928657,
              -27.41028064719479
            ],
            [
              -51.968783614951356,
              -27.410712832527842
            ],
            [
              -51.96251053080731,
              -27.412009388527
            ],
            [
              -51.95787390339648,
              -27.413690109266653
            ],
            [
              -51.953619115890085,
              -27.41589905652448
            ],
            [
              -51.951273527905784,
              -27.417291653708762
            ],
            [
              -51.939272845195426,
              -27.425887339777265
            ],
            [
              -51.93578173749787,
              -27.42872055473839
            ],
            [
              -51.933981635091314,
              -27.431505749106954
            ],
            [
              -51.93332705239802,
              -27.435203334734187
            ],
            [
              -51.933490698071346,
              -27.438084570287877
            ],
            [
              -51.93409073220686,
              -27.439381126287035
            ],
            [
              -51.939218296637655,
              -27.446007968060517
            ],
            [
              -51.9416729817375,
              -27.448889203614204
            ],
            [
              -51.948382454343744,
              -27.454123448203404
            ],
            [
              -51.95340092165899,
              -27.457388848497583
            ],
            [
              -51.95820119474313,
              -27.459405713385166
            ],
            [
              -51.96207414234511,
              -27.46151861945787
            ],
            [
              -51.963819696193895,
              -27.4631032990124
            ],
            [
              -51.964201536098315,
              -27.464207772641313
            ],
            [
              -51.963874244751665,
              -27.468289523009034
            ],
            [
              -51.96229233657621,
              -27.471122737970163
            ],
            [
              -51.95989220003413,
              -27.473379705820552
            ],
            [
              -51.956510189452125,
              -27.475108447152763
            ],
            [
              -51.950782590885815,
              -27.47530052952301
            ],
            [
              -51.945000443761735,
              -27.473091582265184
            ],
            [
              -51.93981833077317,
              -27.470594511451985
            ],
            [
              -51.93649086874893,
              -27.46881774952721
            ],
            [
              -51.9333816009558,
              -27.466704843454508
            ],
            [
              -51.93049052739376,
              -27.464303813826433
            ],
            [
              -51.92721761392729,
              -27.462382990123977
            ],
            [
              -51.920017204301075,
              -27.459021548644674
            ],
            [
              -51.918380747567845,
              -27.458397280941373
            ],
            [
              -51.91439870285032,
              -27.457821033830637
            ],
            [
              -51.91199856630824,
              -27.45767697205295
            ],
            [
              -51.90752558457075,
              -27.45820519857113
            ],
            [
              -51.90392537975764,
              -27.459789878125658
            ],
            [
              -51.90130704898447,
              -27.462623093086783
            ],
            [
              -51.90048882061785,
              -27.46411173145619
            ],
            [
              -51.899997883597884,
              -27.46809744063879
            ],
            [
              -51.899997883597884,
              -27.474100014708974
            ],
            [
              -51.900379723502304,
              -27.47827780626182
            ],
            [
              -51.90141614610002,
              -27.48250361840723
            ],
            [
              -51.9025071172555,
              -27.4913874280311
            ],
            [
              -51.90228892302441,
              -27.495517198991386
            ],
            [
              -51.90130704898447,
              -27.49931082580374
            ],
            [
              -51.89961604369346,
              -27.503680699726832
            ],
            [
              -51.89797958696023,
              -27.50718620298382
            ],
            [
              -51.8967795186892,
              -27.510691706240806
            ],
            [
              -51.89650677590033,
              -27.51242044757302
            ],
            [
              -51.89481577060932,
              -27.516982403866358
            ],
            [
              -51.89328841099164,
              -27.51899926875394
            ],
            [
              -51.89077917733402,
              -27.5202958247531
            ],
            [
              -51.88772445809865,
              -27.520776030678714
            ],
            [
              -51.88057859703021,
              -27.52101613364152
            ],
            [
              -51.87921488308585,
              -27.52058394830847
            ],
            [
              -51.876105615292715,
              -27.518807186383693
            ],
            [
              -51.875396484041644,
              -27.517990836310148
            ],
            [
              -51.87381457586619,
              -27.513284818239125
            ],
            [
              -51.87392367298174,
              -27.51150805631435
            ],
            [
              -51.87479644990613,
              -27.508098594242487
            ],
            [
              -51.87877849462366,
              -27.49902270224837
            ],
            [
              -51.87997856289469,
              -27.49570928136163
            ],
            [
              -51.88041495135689,
              -27.49239586047489
            ],
            [
              -51.87970582010582,
              -27.4874017188485
            ],
            [
              -51.878287557603684,
              -27.48452048329481
            ],
            [
              -51.876105615292715,
              -27.48159122714856
            ],
            [
              -51.87261450759515,
              -27.478806032779996
            ],
            [
              -51.86830517153098,
              -27.47659708552217
            ],
            [
              -51.86312305854241,
              -27.475204488337887
            ],
            [
              -51.85821368834272,
              -27.475108447152763
            ],
            [
              -51.85292247823861,
              -27.476212920781677
            ],
            [
              -51.85052234169654,
              -27.47698125026266
            ],
            [
              -51.84757671957672,
              -27.478517909224628
            ],
            [
              -51.84512203447687,
              -27.480486753519646
            ],
            [
              -51.84359467485919,
              -27.483079865517965
            ],
            [
              -51.84321283495477,
              -27.4874017188485
            ],
            [
              -51.843376480628095,
              -27.488698274847657
            ],
            [
              -51.845885714285714,
              -27.497822187434334
            ],
            [
              -51.85057689025431,
              -27.507378285354065
            ],
            [
              -51.85412254650964,
              -27.51270857112839
            ],
            [
              -51.85510442054958,
              -27.515493765496952
            ],
            [
              -51.85537716333845,
              -27.51827895986552
            ],
            [
              -51.85499532343403,
              -27.51962353645724
            ],
            [
              -51.85330431814303,
              -27.52260081319605
            ],
            [
              -51.85030414746544,
              -27.525482048749737
            ],
            [
              -51.846976685441206,
              -27.52610631645304
            ],
            [
              -51.84348557774364,
              -27.525386007564613
            ],
            [
              -51.8405945041816,
              -27.52418549275058
            ],
            [
              -51.837103396484046,
              -27.522216648455558
            ],
            [
              -51.833503191670935,
              -27.51808687749527
            ],
            [
              -51.831484895033284,
              -27.515397724311832
            ],
            [
              -51.82837562724014,
              -27.513284818239125
            ],
            [
              -51.827011913295784,
              -27.512804612313513
            ],
            [
              -51.82177525174944,
              -27.512804612313513
            ],
            [
              -51.81828414405189,
              -27.514005127127547
            ],
            [
              -51.815120327700974,
              -27.51669428031099
            ],
            [
              -51.80961092336577,
              -27.523081019121665
            ],
            [
              -51.808083563748085,
              -27.52452163689851
            ],
            [
              -51.8042106161461,
              -27.527306831267072
            ],
            [
              -51.798701211810894,
              -27.529995984450515
            ],
            [
              -51.79477371565114,
              -27.53110045807943
            ],
            [
              -51.79057347670251,
              -27.531004416894305
            ],
            [
              -51.7874096603516,
              -27.529707860895147
            ],
            [
              -51.78571865506059,
              -27.528219222525742
            ],
            [
              -51.785173169482846,
              -27.525722151712543
            ],
            [
              -51.785173169482846,
              -27.52101613364152
            ],
            [
              -51.78577320361837,
              -27.51861510401345
            ],
            [
              -51.788009694487116,
              -27.514821477201092
            ],
            [
              -51.78920976275815,
              -27.51371700357218
            ],
            [
              -51.79510100699778,
              -27.51049962387056
            ],
            [
              -51.79837392046424,
              -27.509395150241648
            ],
            [
              -51.80011947431302,
              -27.507378285354065
            ],
            [
              -51.80170138248848,
              -27.503776740911956
            ],
            [
              -51.80257415941287,
              -27.499406866988863
            ],
            [
              -51.80251961085509,
              -27.497486043286404
            ],
            [
              -51.80181047960403,
              -27.49398054002942
            ],
            [
              -51.800610411333,
              -27.491915654549274
            ],
            [
              -51.799519440177505,
              -27.490907222105484
            ],
            [
              -51.79690110940434,
              -27.48999483084682
            ],
            [
              -51.7940100358423,
              -27.489898789661694
            ],
            [
              -51.790518928144735,
              -27.49071513973524
            ],
            [
              -51.785500460829496,
              -27.49148346921622
            ],
            [
              -51.782609387267456,
              -27.4913874280311
            ],
            [
              -51.77600901177676,
              -27.490186913217062
            ],
            [
              -51.77028141321045,
              -27.488602233662533
            ],
            [
              -51.75969899300222,
              -27.486777451145198
            ],
            [
              -51.755280559822495,
              -27.486777451145198
            ],
            [
              -51.751625806451614,
              -27.48812202773692
            ],
            [
              -51.74682553336747,
              -27.491915654549274
            ],
            [
              -51.7442072025943,
              -27.49498897247321
            ],
            [
              -51.74022515787677,
              -27.500703422988025
            ],
            [
              -51.737988667008025,
              -27.50420892624501
            ],
            [
              -51.73269745690391,
              -27.509587232611892
            ],
            [
              -51.73040641747738,
              -27.51150805631435
            ],
            [
              -51.728115378050866,
              -27.512804612313513
            ],
            [
              -51.724515173237755,
              -27.513620962387055
            ],
            [
              -51.720424031404676,
              -27.513476900609373
            ],
            [
              -51.71731476361154,
              -27.511412015129228
            ],
            [
              -51.716714729476024,
              -27.510307541500314
            ],
            [
              -51.71562375832053,
              -27.506705997058205
            ],
            [
              -51.7142054958184,
              -27.499214784618616
            ],
            [
              -51.70967796552313,
              -27.48778588358899
            ],
            [
              -51.70629595494112,
              -27.483704133221266
            ],
            [
              -51.70329578426353,
              -27.481111021222947
            ],
            [
              -51.7012229390681,
              -27.479814465223786
            ],
            [
              -51.69958648233487,
              -27.479094156335364
            ],
            [
              -51.694186175115206,
              -27.478181765076698
            ],
            [
              -51.69222242703533,
              -27.478181765076698
            ],
            [
              -51.68660392558457,
              -27.47899811515024
            ],
            [
              -51.6842037890425,
              -27.479478321075856
            ],
            [
              -51.6776034135518,
              -27.48322392729565
            ],
            [
              -51.67422140296979,
              -27.48648932758983
            ],
            [
              -51.67318498037208,
              -27.487977965959235
            ],
            [
              -51.67280314046766,
              -27.491579510401344
            ],
            [
              -51.673621368834276,
              -27.496093446102122
            ],
            [
              -51.67438504864312,
              -27.49801426980458
            ],
            [
              -51.677003379416284,
              -27.501183628913637
            ],
            [
              -51.6776034135518,
              -27.503008411430972
            ],
            [
              -51.67749431643625,
              -27.50488121454087
            ],
            [
              -51.67558511691415,
              -27.508290676612734
            ],
            [
              -51.67340317460317,
              -27.510019417944946
            ],
            [
              -51.66827561017239,
              -27.514821477201092
            ],
            [
              -51.664675405359276,
              -27.517318548014288
            ],
            [
              -51.65971148660181,
              -27.51928739230931
            ],
            [
              -51.655620344768735,
              -27.519815618827487
            ],
            [
              -51.65120191158901,
              -27.519479474679557
            ],
            [
              -51.647383512544806,
              -27.516310115570498
            ],
            [
              -51.646674381293735,
              -27.514485333053162
            ],
            [
              -51.646292541389315,
              -27.51011545913007
            ],
            [
              -51.64711076975593,
              -27.50320049380122
            ],
            [
              -51.64618344427377,
              -27.49729396091616
            ],
            [
              -51.64471063321386,
              -27.493884498844295
            ],
            [
              -51.64258323946066,
              -27.49148346921622
            ],
            [
              -51.63920122887865,
              -27.489514624921203
            ],
            [
              -51.637182932241,
              -27.48879431603278
            ],
            [
              -51.63260085338795,
              -27.488602233662533
            ],
            [
              -51.63041891107698,
              -27.48908243958815
            ],
            [
              -51.62730964328384,
              -27.49071513973524
            ],
            [
              -51.62310940433521,
              -27.49330825173356
            ],
            [
              -51.62027287933095,
              -27.496477610842614
            ],
            [
              -51.619672845195424,
              -27.498206352174826
            ],
            [
              -51.61978194231098,
              -27.502096020172306
            ],
            [
              -51.62158204471753,
              -27.507378285354065
            ],
            [
              -51.625291346646186,
              -27.516982403866358
            ],
            [
              -51.62769148318826,
              -27.52101613364152
            ],
            [
              -51.63069165386585,
              -27.52749891363732
            ],
            [
              -51.631891722136885,
              -27.53268513763396
            ],
            [
              -51.63210991636798,
              -27.53801542340828
            ],
            [
              -51.63107349377027,
              -27.541520926665267
            ],
            [
              -51.62790967741935,
              -27.544498203404075
            ],
            [
              -51.62567318655061,
              -27.545506635847868
            ],
            [
              -51.62349124423963,
              -27.546082882958604
            ],
            [
              -51.619181908175456,
              -27.546178924143728
            ],
            [
              -51.614981669226836,
              -27.545410594662744
            ],
            [
              -51.61170875576037,
              -27.543681853330533
            ],
            [
              -51.60832674517836,
              -27.54137686488758
            ],
            [
              -51.60592660863629,
              -27.538495629333894
            ],
            [
              -51.60309008363202,
              -27.533213364152132
            ],
            [
              -51.59938078170337,
              -27.528603387266234
            ],
            [
              -51.59392592592593,
              -27.524377575120823
            ],
            [
              -51.59081665813279,
              -27.52298497793654
            ],
            [
              -51.58830742447517,
              -27.522408730825802
            ],
            [
              -51.58492541389316,
              -27.522216648455558
            ],
            [
              -51.581379757637826,
              -27.522888936751418
            ],
            [
              -51.58001604369346,
              -27.52360924563984
            ],
            [
              -51.57832503840246,
              -27.52610631645304
            ],
            [
              -51.57772500426694,
              -27.53009202563564
            ],
            [
              -51.577779552824715,
              -27.531916808152975
            ],
            [
              -51.578979621095755,
              -27.536910949779365
            ],
            [
              -51.57968875234682,
              -27.541616967850388
            ],
            [
              -51.58050698071344,
              -27.544882368144567
            ],
            [
              -51.58301621437106,
              -27.552277539399032
            ],
            [
              -51.585525448028676,
              -27.557223660432864
            ],
            [
              -51.58672551629971,
              -27.5602969783568
            ],
            [
              -51.587380098993,
              -27.563178213910486
            ],
            [
              -51.587380098993,
              -27.565579243538558
            ],
            [
              -51.585579996586446,
              -27.56961297331372
            ],
            [
              -51.57837958696023,
              -27.577008144568186
            ],
            [
              -51.57172466291176,
              -27.582578533305316
            ],
            [
              -51.57030640040963,
              -27.583394883378862
            ],
            [
              -51.56708803550094,
              -27.584307274637528
            ],
            [
              -51.56332418501451,
              -27.584115192267284
            ],
            [
              -51.56092404847244,
              -27.583106759823494
            ],
            [
              -51.55797842635262,
              -27.579793338936753
            ],
            [
              -51.556396518177166,
              -27.57518336205085
            ],
            [
              -51.55557828981055,
              -27.570381302794704
            ],
            [
              -51.55541464413723,
              -27.565579243538558
            ],
            [
              -51.554923707117254,
              -27.563994563984032
            ],
            [
              -51.553178153268476,
              -27.56168957554108
            ],
            [
              -51.55181443932412,
              -27.560489060727043
            ],
            [
              -51.54761420037549,
              -27.55909646354276
            ],
            [
              -51.544123092677935,
              -27.559480628283254
            ],
            [
              -51.53992285372931,
              -27.561593534355957
            ],
            [
              -51.53659539170507,
              -27.562601966799747
            ],
            [
              -51.53299518689197,
              -27.562601966799747
            ],
            [
              -51.528685850827785,
              -27.561785616726205
            ],
            [
              -51.52497654889913,
              -27.56077718428241
            ],
            [
              -51.51701245946408,
              -27.55770386635848
            ],
            [
              -51.51308496330432,
              -27.556599392729566
            ],
            [
              -51.508502884451275,
              -27.55611918680395
            ],
            [
              -51.501902508960576,
              -27.55611918680395
            ],
            [
              -51.49672039597201,
              -27.557223660432864
            ],
            [
              -51.4909927974057,
              -27.559000422357638
            ],
            [
              -51.48701075268817,
              -27.56077718428241
            ],
            [
              -51.48330145075952,
              -27.563178213910486
            ],
            [
              -51.48199228537293,
              -27.564714872872454
            ],
            [
              -51.47839208055982,
              -27.569709014498844
            ],
            [
              -51.477410206519885,
              -27.57259025005253
            ],
            [
              -51.476919269499916,
              -27.57580762975415
            ],
            [
              -51.47659197815327,
              -27.57940917419626
            ],
            [
              -51.47719201228879,
              -27.586804345450727
            ],
            [
              -51.477792046424305,
              -27.590117766337467
            ],
            [
              -51.47757385219321,
              -27.59588023744484
            ],
            [
              -51.47681017238437,
              -27.59880949359109
            ],
            [
              -51.475282812766686,
              -27.600682296700988
            ],
            [
              -51.47190080218468,
              -27.602891243958815
            ],
            [
              -51.47020979689367,
              -27.603515511662113
            ],
            [
              -51.462300256016384,
              -27.604619985291027
            ],
            [
              -51.4590818911077,
              -27.606108623660432
            ],
            [
              -51.457281788701145,
              -27.607501220844714
            ],
            [
              -51.45122689878819,
              -27.613503794914898
            ],
            [
              -51.44522655743301,
              -27.61878606009666
            ],
            [
              -51.44200819252433,
              -27.622291563353645
            ],
            [
              -51.43660788530466,
              -27.629782775793235
            ],
            [
              -51.436007851169144,
              -27.631079331792392
            ],
            [
              -51.4356805598225,
              -27.634296711494013
            ],
            [
              -51.43611694828469,
              -27.637081905862576
            ],
            [
              -51.438026147806795,
              -27.643996871191426
            ],
            [
              -51.43791705069125,
              -27.648798930447573
            ],
            [
              -51.43698972520908,
              -27.652112351334313
            ],
            [
              -51.435189622802525,
              -27.654417339777265
            ],
            [
              -51.43240764635603,
              -27.655617854591302
            ],
            [
              -51.42728008192525,
              -27.656194101702038
            ],
            [
              -51.42389807134323,
              -27.65590597814667
            ],
            [
              -51.41920689537464,
              -27.65460942214751
            ],
            [
              -51.415388496330436,
              -27.652112351334313
            ],
            [
              -51.412606519883944,
              -27.64899101281782
            ],
            [
              -51.41189738863287,
              -27.647502374448415
            ],
            [
              -51.410915514592936,
              -27.64409291237655
            ],
            [
              -51.40987909199522,
              -27.639723038453457
            ],
            [
              -51.40911541218638,
              -27.637706173565874
            ],
            [
              -51.407315309779825,
              -27.63458483504938
            ],
            [
              -51.405297013142174,
              -27.631895681865938
            ],
            [
              -51.402024099675714,
              -27.62968673460811
            ],
            [
              -51.3946054958184,
              -27.62570102542551
            ],
            [
              -51.38920518859874,
              -27.62378020172305
            ],
            [
              -51.3860959208056,
              -27.623492078167683
            ],
            [
              -51.384404915514594,
              -27.62378020172305
            ],
            [
              -51.38129564772146,
              -27.625508943055262
            ],
            [
              -51.377804540023895,
              -27.62867830216432
            ],
            [
              -51.37551350059737,
              -27.631223393570078
            ],
            [
              -51.37218603857313,
              -27.633480361420467
            ],
            [
              -51.37011319337771,
              -27.636697741122084
            ],
            [
              -51.36978590203107,
              -27.64049136793444
            ],
            [
              -51.37109506741765,
              -27.644717180079848
            ],
            [
              -51.37180419866872,
              -27.64582165370876
            ],
            [
              -51.37480436934631,
              -27.65201631014919
            ],
            [
              -51.375295306366276,
              -27.653504948518595
            ],
            [
              -51.37709540877283,
              -27.657106492960708
            ],
            [
              -51.37791363713944,
              -27.659987728514395
            ],
            [
              -51.37682266598396,
              -27.66411749947468
            ],
            [
              -51.37480436934631,
              -27.66738289976886
            ],
            [
              -51.37027683905104,
              -27.672088917839883
            ],
            [
              -51.36422194913808,
              -27.676506812355537
            ],
            [
              -51.36007625874723,
              -27.67881180079849
            ],
            [
              -51.354785048643116,
              -27.680012315612522
            ],
            [
              -51.3497120327701,
              -27.679916274427402
            ],
            [
              -51.34649366786141,
              -27.67828357428031
            ],
            [
              -51.34278436593276,
              -27.67569046228199
            ],
            [
              -51.34011148660181,
              -27.674201823912586
            ],
            [
              -51.332311042840075,
              -27.671176526581213
            ],
            [
              -51.32707438129374,
              -27.67098444421097
            ],
            [
              -51.319273937532,
              -27.672809226728305
            ],
            [
              -51.31769202935655,
              -27.67338547383904
            ],
            [
              -51.315073698583376,
              -27.675114215171256
            ],
            [
              -51.31441911589009,
              -27.67597858583736
            ],
            [
              -51.313382693292375,
              -27.67881180079849
            ],
            [
              -51.313000853387955,
              -27.68471833368355
            ],
            [
              -51.31321904761905,
              -27.687503528052112
            ],
            [
              -51.313000853387955,
              -27.69177736079008
            ],
            [
              -51.312619013483534,
              -27.693314019752048
            ],
            [
              -51.31130984809695,
              -27.695811090565243
            ],
            [
              -51.30830967741936,
              -27.698692326118934
            ],
            [
              -51.30700051203277,
              -27.699508676192476
            ],
            [
              -51.303182112988566,
              -27.700709191006514
            ],
            [
              -51.30198204471753,
              -27.70258199411641
            ],
            [
              -51.30340030721966,
              -27.705607291447784
            ],
            [
              -51.30847332309268,
              -27.71040935070393
            ],
            [
              -51.31021887694146,
              -27.713098503887373
            ],
            [
              -51.31060071684588,
              -27.715499533515445
            ],
            [
              -51.31000068271036,
              -27.718092645513764
            ],
            [
              -51.30880061443933,
              -27.719485242698045
            ],
            [
              -51.30901880867042,
              -27.720493675141835
            ],
            [
              -51.308200580303804,
              -27.72251054002942
            ],
            [
              -51.30487311827957,
              -27.726016043286403
            ],
            [
              -51.30421853558628,
              -27.728897278840094
            ],
            [
              -51.30678231780168,
              -27.73110622609792
            ],
            [
              -51.31027342549923,
              -27.73278694683757
            ],
            [
              -51.31190988223246,
              -27.73432360579954
            ],
            [
              -51.3131099505035,
              -27.736484532464804
            ],
            [
              -51.31169168800137,
              -27.736916717797858
            ],
            [
              -51.30700051203277,
              -27.735187976465646
            ],
            [
              -51.30470947260625,
              -27.735476100021014
            ],
            [
              -51.302418433179724,
              -27.73778108846396
            ],
            [
              -51.30160020481311,
              -27.740422221054843
            ],
            [
              -51.30181839904421,
              -27.7442158478672
            ],
            [
              -51.300781976446494,
              -27.747289165791134
            ],
            [
              -51.298,
              -27.749882277789453
            ],
            [
              -51.298,
              -27.75117883378861
            ],
            [
              -51.30001829663765,
              -27.75410808993486
            ],
            [
              -51.3024729817375,
              -27.754876419415844
            ],
            [
              -51.30661867212835,
              -27.75478037823072
            ],
            [
              -51.30841877453491,
              -27.753387781046438
            ],
            [
              -51.30950974569039,
              -27.75079466904812
            ],
            [
              -51.31278265915685,
              -27.745992609791973
            ],
            [
              -51.313000853387955,
              -27.74368762134902
            ],
            [
              -51.312619013483534,
              -27.74162273586888
            ],
            [
              -51.31147349377027,
              -27.739797953351545
            ],
            [
              -51.312182625021336,
              -27.73869347972263
            ],
            [
              -51.31660105820106,
              -27.73869347972263
            ],
            [
              -51.31807386926097,
              -27.739509829796177
            ],
            [
              -51.31861935483871,
              -27.740806385795334
            ],
            [
              -51.318292063492066,
              -27.742823250682918
            ],
            [
              -51.31731018945213,
              -27.744792094977935
            ],
            [
              -51.31687380098993,
              -27.74719312460601
            ],
            [
              -51.3178011264721,
              -27.749882277789453
            ],
            [
              -51.31567373271889,
              -27.75079466904812
            ],
            [
              -51.312291722136884,
              -27.75151497793654
            ],
            [
              -51.31207352790579,
              -27.753483822231562
            ],
            [
              -51.31398272742789,
              -27.753916007564616
            ],
            [
              -51.31741928656768,
              -27.75271549275058
            ],
            [
              -51.319273937532,
              -27.75237934860265
            ],
            [
              -51.322001365420725,
              -27.75252341038033
            ],
            [
              -51.32521973032941,
              -27.7521872662324
            ],
            [
              -51.330292746202424,
              -27.751082792603487
            ],
            [
              -51.33471117938215,
              -27.75209122504728
            ],
            [
              -51.335583956306536,
              -27.752619451565455
            ],
            [
              -51.33531121351767,
              -27.754204131119984
            ],
            [
              -51.33242013995562,
              -27.75770963437697
            ],
            [
              -51.33018364908688,
              -27.759486396301746
            ],
            [
              -51.32887448370029,
              -27.761791384744694
            ],
            [
              -51.32958361495136,
              -27.762703776003363
            ],
            [
              -51.33711131592422,
              -27.76558501155705
            ],
            [
              -51.337602252944194,
              -27.766785526371088
            ],
            [
              -51.33662037890425,
              -27.768418226518175
            ],
            [
              -51.33509301928657,
              -27.769282597184283
            ],
            [
              -51.333892951015535,
              -27.77081925614625
            ],
            [
              -51.33362020822666,
              -27.774516841773483
            ],
            [
              -51.3324746885134,
              -27.77638964488338
            ],
            [
              -51.331001877453495,
              -27.777590159697414
            ],
            [
              -51.330292746202424,
              -27.778982756881696
            ],
            [
              -51.33127462024236,
              -27.78071149821391
            ],
            [
              -51.334820276497695,
              -27.78239221895356
            ],
            [
              -51.33487482505547,
              -27.783112527841983
            ],
            [
              -51.33182010582011,
              -27.78532147509981
            ],
            [
              -51.33111097456904,
              -27.78637792813616
            ],
            [
              -51.33171100870456,
              -27.78829875183862
            ],
            [
              -51.333183819764464,
              -27.789691349022903
            ],
            [
              -51.33509301928657,
              -27.790699781466696
            ],
            [
              -51.339675098139615,
              -27.79247654339147
            ],
            [
              -51.34240252602834,
              -27.793292893465015
            ],
            [
              -51.344584468339306,
              -27.79319685227989
            ],
            [
              -51.347802833248,
              -27.791179987392308
            ],
            [
              -51.347802833248,
              -27.787818545913005
            ],
            [
              -51.34960293565455,
              -27.786810113469215
            ],
            [
              -51.35511233998976,
              -27.791179987392308
            ],
            [
              -51.35549417989418,
              -27.792908728724523
            ],
            [
              -51.35647605393412,
              -27.79439736709393
            ],
            [
              -51.3558760197986,
              -27.796414231981508
            ],
            [
              -51.35222126642772,
              -27.799007343979827
            ],
            [
              -51.35107574671446,
              -27.801600455978146
            ],
            [
              -51.349493838539004,
              -27.802512847236816
            ],
            [
              -51.349111998634584,
              -27.804577732716957
            ],
            [
              -51.34922109575013,
              -27.806786679974785
            ],
            [
              -51.35009387267452,
              -27.8078911536037
            ],
            [
              -51.35167578084997,
              -27.807987194788822
            ],
            [
              -51.35331223758321,
              -27.807410947678083
            ],
            [
              -51.35369407748763,
              -27.805778247530995
            ],
            [
              -51.3558760197986,
              -27.80529804160538
            ],
            [
              -51.35511233998976,
              -27.80198462071864
            ],
            [
              -51.3563124082608,
              -27.80030389997899
            ],
            [
              -51.35827615634067,
              -27.799199426350075
            ],
            [
              -51.358876190476195,
              -27.79819099390628
            ],
            [
              -51.362203652500426,
              -27.79771078798067
            ],
            [
              -51.363403720771466,
              -27.798479117461653
            ],
            [
              -51.36280368663595,
              -27.80198462071864
            ],
            [
              -51.3643855948114,
              -27.80409752679134
            ],
            [
              -51.3643855948114,
              -27.80669063878966
            ],
            [
              -51.36411285202253,
              -27.811780821601175
            ],
            [
              -51.3648219832736,
              -27.814277892414374
            ],
            [
              -51.36602205154463,
              -27.816006633746586
            ],
            [
              -51.366785731353474,
              -27.818023498634165
            ],
            [
              -51.36869493087558,
              -27.81970421937382
            ],
            [
              -51.37027683905104,
              -27.820616610632484
            ],
            [
              -51.37458617511521,
              -27.819800260558942
            ],
            [
              -51.37627718040621,
              -27.820712651817608
            ],
            [
              -51.378022734255,
              -27.823209722630803
            ],
            [
              -51.378186379928316,
              -27.826379081739862
            ],
            [
              -51.377422700119475,
              -27.827291472998528
            ],
            [
              -51.3756771462707,
              -27.827579596553896
            ],
            [
              -51.37518620925073,
              -27.830076667367095
            ],
            [
              -51.375786243386244,
              -27.830893017440637
            ],
            [
              -51.3714223587643,
              -27.834398520697626
            ],
            [
              -51.3709859703021,
              -27.836607467955453
            ],
            [
              -51.3712041645332,
              -27.839008497583524
            ],
            [
              -51.370822324628776,
              -27.840977341878546
            ],
            [
              -51.37109506741765,
              -27.843186289136373
            ],
            [
              -51.37360430107527,
              -27.84400263920992
            ],
            [
              -51.376877214541736,
              -27.84381055683967
            ],
            [
              -51.3816229390681,
              -27.844578886320654
            ],
            [
              -51.38309575012801,
              -27.846115545282622
            ],
            [
              -51.38211387608807,
              -27.84770022483715
            ],
            [
              -51.38009557945042,
              -27.84899678083631
            ],
            [
              -51.37840457415942,
              -27.848804698466065
            ],
            [
              -51.37747724867725,
              -27.8493809455768
            ],
            [
              -51.377422700119475,
              -27.851685934019752
            ],
            [
              -51.37807728281277,
              -27.85547956083211
            ],
            [
              -51.379713739546,
              -27.855719663794915
            ],
            [
              -51.38129564772146,
              -27.8564879932759
            ],
            [
              -51.381513841952554,
              -27.85812069342299
            ],
            [
              -51.38260481310804,
              -27.860617764236185
            ],
            [
              -51.38058651647039,
              -27.86378712334524
            ],
            [
              -51.381186550605904,
              -27.865803988232823
            ],
            [
              -51.38402307561017,
              -27.865611905862576
            ],
            [
              -51.38522314388121,
              -27.86479555578903
            ],
            [
              -51.38582317801673,
              -27.866620338306365
            ],
            [
              -51.385495886670085,
              -27.86830105904602
            ],
            [
              -51.384295818399046,
              -27.86902136793444
            ],
            [
              -51.38402307561017,
              -27.872911035931917
            ],
            [
              -51.382713910223586,
              -27.87391946837571
            ],
            [
              -51.38522314388121,
              -27.876992786299642
            ],
            [
              -51.38500494965011,
              -27.877809136373187
            ],
            [
              -51.38691414917221,
              -27.879681939483085
            ],
            [
              -51.38871425157877,
              -27.87958589829796
            ],
            [
              -51.388877897252094,
              -27.881986927926036
            ],
            [
              -51.38789602321216,
              -27.88318744274007
            ],
            [
              -51.389314285714285,
              -27.884003792813616
            ],
            [
              -51.388877897252094,
              -27.88578055473839
            ],
            [
              -51.3907870967742,
              -27.88707711073755
            ],
            [
              -51.39182351937191,
              -27.889286057995378
            ],
            [
              -51.394987335722824,
              -27.88842168732927
            ],
            [
              -51.39689653524492,
              -27.887317213700356
            ],
            [
              -51.399187574671444,
              -27.886981069552427
            ],
            [
              -51.402405939580134,
              -27.885396389997897
            ],
            [
              -51.40382420208227,
              -27.885396389997897
            ],
            [
              -51.404424236217785,
              -27.888181584366464
            ],
            [
              -51.40589704727769,
              -27.888277625551588
            ],
            [
              -51.40791534391535,
              -27.886788987182182
            ],
            [
              -51.40998818911077,
              -27.886596904811935
            ],
            [
              -51.411788291517325,
              -27.887605337255724
            ],
            [
              -51.41047912613074,
              -27.88909397562513
            ],
            [
              -51.40720621266428,
              -27.89039053162429
            ],
            [
              -51.40709711554873,
              -27.891110840512713
            ],
            [
              -51.408897217955285,
              -27.893079684807734
            ],
            [
              -51.409279057859706,
              -27.894184158436648
            ],
            [
              -51.40862447516641,
              -27.897209455768017
            ],
            [
              -51.407697149684246,
              -27.898698094137423
            ],
            [
              -51.408024441030896,
              -27.902107556209288
            ],
            [
              -51.411406451612905,
              -27.90249172094978
            ],
            [
              -51.412115582863976,
              -27.904316503467115
            ],
            [
              -51.41347929680833,
              -27.90580514183652
            ],
            [
              -51.41522485065711,
              -27.905180874133222
            ],
            [
              -51.41582488479263,
              -27.905997224206764
            ],
            [
              -51.4141884280594,
              -27.907197739020802
            ],
            [
              -51.41282471411504,
              -27.907101697835678
            ],
            [
              -51.412279228537294,
              -27.909310645093505
            ],
            [
              -51.41407933094385,
              -27.91199979827695
            ],
            [
              -51.41571578767708,
              -27.912480004202564
            ],
            [
              -51.415497593445984,
              -27.91411270434965
            ],
            [
              -51.417188598736985,
              -27.915217177978565
            ],
            [
              -51.41740679296809,
              -27.91632165160748
            ],
            [
              -51.41980692951016,
              -27.915601342719057
            ],
            [
              -51.42209796893668,
              -27.91411270434965
            ],
            [
              -51.42318894009217,
              -27.91497707501576
            ],
            [
              -51.42558907663424,
              -27.915217177978565
            ],
            [
              -51.42711643625192,
              -27.914592910275267
            ],
            [
              -51.42782556750299,
              -27.91339239546123
            ],
            [
              -51.42951657279399,
              -27.913920621979408
            ],
            [
              -51.43202580645161,
              -27.912287921832316
            ],
            [
              -51.433116777607104,
              -27.916177589829797
            ],
            [
              -51.43628059395802,
              -27.91632165160748
            ],
            [
              -51.43742611367128,
              -27.917186022273587
            ],
            [
              -51.43988079877112,
              -27.9182904959025
            ],
            [
              -51.43998989588667,
              -27.920115278419836
            ],
            [
              -51.442117289639874,
              -27.92088360790082
            ],
            [
              -51.44282642089094,
              -27.922420266862787
            ],
            [
              -51.444190134835296,
              -27.923380678714015
            ],
            [
              -51.445390203106335,
              -27.925685667156966
            ],
            [
              -51.44811763099505,
              -27.92510942004623
            ],
            [
              -51.45171783580816,
              -27.924821296490858
            ],
            [
              -51.45302700119475,
              -27.92650201723051
            ],
            [
              -51.455699880525685,
              -27.92679014078588
            ],
            [
              -51.45837275985663,
              -27.928999088043707
            ],
            [
              -51.460172862263185,
              -27.949215757512082
            ],
            [
              -51.46830059737157,
              -27.952289075436017
            ],
            [
              -51.473700904591226,
              -27.952913343139315
            ],
            [
              -51.48870175797918,
              -27.953585631435175
            ],
            [
              -51.50337532002048,
              -27.952385116621137
            ],
            [
              -51.50921201570234,
              -27.95541041395251
            ],
            [
              -51.51041208397338,
              -27.959780287875603
            ],
            [
              -51.51597603686636,
              -27.966311088463964
            ],
            [
              -51.515921488308585,
              -27.97048888001681
            ],
            [
              -51.52317644649258,
              -27.979276648455556
            ],
            [
              -51.5256856801502,
              -27.983982666526583
            ],
            [
              -51.53048595323434,
              -27.98590349022904
            ],
            [
              -51.532613346987546,
              -27.98792035511662
            ],
            [
              -51.540904727769245,
              -27.990417425929817
            ],
            [
              -51.54368670421574,
              -27.99080159067031
            ],
            [
              -51.545923195084484,
              -27.987776293338936
            ],
            [
              -51.54870517153098,
              -27.988112437486866
            ],
            [
              -51.556505615292714,
              -27.98561536667367
            ],
            [
              -51.56130588837686,
              -27.98691192267283
            ],
            [
              -51.57052459464072,
              -27.986383696154654
            ],
            [
              -51.57428844512716,
              -27.987776293338936
            ],
            [
              -51.58257982590886,
              -27.982205904601805
            ],
            [
              -51.58339805427548,
              -27.97778801008615
            ],
            [
              -51.585689093702,
              -27.974186465644042
            ],
            [
              -51.59081665813279,
              -27.9761072893465
            ],
            [
              -51.597417033623486,
              -27.976587495272117
            ],
            [
              -51.59921713603004,
              -27.974906774532464
            ],
            [
              -51.60549022017409,
              -27.972601786089516
            ],
            [
              -51.608490390851685,
              -27.972985950830008
            ],
            [
              -51.61579989759345,
              -27.969288365202775
            ],
            [
              -51.61890916538658,
              -27.968423994536668
            ],
            [
              -51.62790967741935,
              -27.967079417944948
            ],
            [
              -51.631509882232464,
              -27.96779972683337
            ],
            [
              -51.63620105820106,
              -27.966311088463964
            ],
            [
              -51.64040129714969,
              -27.966599212019332
            ],
            [
              -51.64481973032941,
              -27.96852003572179
            ],
            [
              -51.646674381293735,
              -27.974522609791972
            ],
            [
              -51.649892746202426,
              -27.97308199201513
            ],
            [
              -51.654420276497696,
              -27.972313662534145
            ],
            [
              -51.657802287079704,
              -27.97437854801429
            ],
            [
              -51.66069336064175,
              -27.974522609791972
            ],
            [
              -51.66320259429937,
              -27.977884051271275
            ],
            [
              -51.66560273084144,
              -27.97701968060517
            ],
            [
              -51.66729373613245,
              -27.977595927715907
            ],
            [
              -51.66969387267452,
              -27.976203330531625
            ],
            [
              -51.67018480969449,
              -27.97730780416054
            ],
            [
              -51.67269404335211,
              -27.977884051271275
            ],
            [
              -51.674494145758665,
              -27.980717266232404
            ],
            [
              -51.67427595152756,
              -27.982590069342297
            ],
            [
              -51.676512442396316,
              -27.983118295860475
            ],
            [
              -51.673675917392046,
              -27.98359850178609
            ],
            [
              -51.67149397508108,
              -27.983118295860475
            ],
            [
              -51.66920293565455,
              -27.984318810674512
            ],
            [
              -51.66811196449906,
              -27.991089714225676
            ],
            [
              -51.66238436593275,
              -27.989889199411643
            ],
            [
              -51.656493121693124,
              -27.990321384744693
            ],
            [
              -51.65507485919099,
              -27.988688684597605
            ],
            [
              -51.652020139955624,
              -27.989312952300903
            ],
            [
              -51.65060187745349,
              -27.991089714225676
            ],
            [
              -51.64689257552484,
              -27.99209814666947
            ],
            [
              -51.645910701484894,
              -27.993202620298383
            ],
            [
              -51.644110599078346,
              -28.00069383273797
            ],
            [
              -51.644110599078346,
              -28.00199038873713
            ],
            [
              -51.645910701484894,
              -28.003719130069342
            ],
            [
              -51.65540215053764,
              -28.00467954192057
            ],
            [
              -51.65829322409968,
              -28.003190903551165
            ],
            [
              -51.66031152073733,
              -27.99810072073965
            ],
            [
              -51.66331169141492,
              -27.99800467955453
            ],
            [
              -51.66440266257041,
              -28.0004057091826
            ],
            [
              -51.66200252602833,
              -28.004487459550326
            ],
            [
              -51.66167523468169,
              -28.007800880437067
            ],
            [
              -51.6608024577573,
              -28.009097436436225
            ],
            [
              -51.65480211640212,
              -28.010105868880018
            ],
            [
              -51.65098371735791,
              -28.012987104433705
            ],
            [
              -51.65169284860898,
              -28.01389949569237
            ],
            [
              -51.65447482505547,
              -28.014619804580793
            ],
            [
              -51.667402833248,
              -28.014523763395673
            ],
            [
              -51.66898474142345,
              -28.015292092876656
            ],
            [
              -51.67062119815668,
              -28.01970998739231
            ],
            [
              -51.67471233998976,
              -28.022111017020382
            ],
            [
              -51.67629424816522,
              -28.02489621138895
            ],
            [
              -51.6754760197986,
              -28.026096726202983
            ],
            [
              -51.67067574671446,
              -28.02628880857323
            ],
            [
              -51.66822106161461,
              -28.024416005463333
            ],
            [
              -51.66009332650623,
              -28.027105158646776
            ],
            [
              -51.65807502986858,
              -28.02691307627653
            ],
            [
              -51.65660221880867,
              -28.024608087833577
            ],
            [
              -51.65589308755761,
              -28.02100654339147
            ],
            [
              -51.65387479091996,
              -28.01942186383694
            ],
            [
              -51.65071097456904,
              -28.017693122504728
            ],
            [
              -51.645910701484894,
              -28.017885204874975
            ],
            [
              -51.64531066734938,
              -28.019181760874133
            ],
            [
              -51.6456925072538,
              -28.02100654339147
            ],
            [
              -51.64858358081584,
              -28.02302340827905
            ],
            [
              -51.650383683222394,
              -28.025808602647615
            ],
            [
              -51.653602048131084,
              -28.031715135532675
            ],
            [
              -51.65431117938215,
              -28.034980535826854
            ],
            [
              -51.652783819764466,
              -28.035892927085523
            ],
            [
              -51.648692677931386,
              -28.03248346501366
            ],
            [
              -51.64689257552484,
              -28.03229138264341
            ],
            [
              -51.64018310291859,
              -28.037621668417735
            ],
            [
              -51.6393103259942,
              -28.039494471527632
            ],
            [
              -51.6393103259942,
              -28.044920798487077
            ],
            [
              -51.63669199522103,
              -28.04669756041185
            ],
            [
              -51.633910018774536,
              -28.04760995167052
            ],
            [
              -51.63118259088582,
              -28.047417869300272
            ],
            [
              -51.62769148318826,
              -28.05001098129859
            ],
            [
              -51.62518224953064,
              -28.05020306366884
            ],
            [
              -51.622018433179726,
              -28.052796175667158
            ],
            [
              -51.62010923365762,
              -28.055293246480353
            ],
            [
              -51.61770909711555,
              -28.05908687329271
            ],
            [
              -51.616290834613416,
              -28.060287388106744
            ],
            [
              -51.615908994708995,
              -28.06167998529103
            ],
            [
              -51.61361795528247,
              -28.063312685438117
            ],
            [
              -51.61492712066906,
              -28.065281529733138
            ],
            [
              -51.61732725721113,
              -28.065905797436436
            ],
            [
              -51.61907281105991,
              -28.066914229880226
            ],
            [
              -51.620818364908686,
              -28.06859495061988
            ],
            [
              -51.62098201058201,
              -28.069795465433913
            ],
            [
              -51.62310940433521,
              -28.070515774322338
            ],
            [
              -51.624909506741766,
              -28.072820762765286
            ],
            [
              -51.62518224953064,
              -28.07531783357848
            ],
            [
              -51.62709144905274,
              -28.076710430762766
            ],
            [
              -51.627800580303806,
              -28.07781490439168
            ],
            [
              -51.62921884280594,
              -28.078679275057784
            ],
            [
              -51.631509882232464,
              -28.077718863206556
            ],
            [
              -51.632273562041306,
              -28.079015419205717
            ],
            [
              -51.62981887694146,
              -28.07987978987182
            ],
            [
              -51.62720054616829,
              -28.079687707501577
            ],
            [
              -51.62300030721966,
              -28.078679275057784
            ],
            [
              -51.62169114183308,
              -28.080023851649507
            ],
            [
              -51.62381853558628,
              -28.084681849127968
            ],
            [
              -51.62501860385731,
              -28.08540215801639
            ],
            [
              -51.62878245434375,
              -28.089579949569238
            ],
            [
              -51.628291517323774,
              -28.09130869090145
            ],
            [
              -51.626982351937194,
              -28.091884938012186
            ],
            [
              -51.62349124423963,
              -28.091788896827065
            ],
            [
              -51.62141839904421,
              -28.092077020382433
            ],
            [
              -51.61989103942653,
              -28.091596814456818
            ],
            [
              -51.614599829322415,
              -28.090876505568396
            ],
            [
              -51.61252698412699,
              -28.09030025845766
            ],
            [
              -51.60898132787165,
              -28.091212649716326
            ],
            [
              -51.60581751152074,
              -28.093517638159277
            ],
            [
              -51.60298098651647,
              -28.096686997268336
            ],
            [
              -51.604017409114185,
              -28.09860782097079
            ],
            [
              -51.60538112305854,
              -28.098991985711283
            ],
            [
              -51.60870858508278,
              -28.097599388527
            ],
            [
              -51.613017921146955,
              -28.09721522378651
            ],
            [
              -51.61432708653354,
              -28.097407306156754
            ],
            [
              -51.61618173749787,
              -28.098895944526163
            ],
            [
              -51.6178181942311,
              -28.10249748896827
            ],
            [
              -51.6173818057689,
              -28.10417820970792
            ],
            [
              -51.61470892643796,
              -28.109892660222737
            ],
            [
              -51.615090766342384,
              -28.11229368985081
            ],
            [
              -51.61699996586448,
              -28.11368628703509
            ],
            [
              -51.617490902884455,
              -28.111909525110317
            ],
            [
              -51.61901826250214,
              -28.109988701407858
            ],
            [
              -51.62027287933095,
              -28.109892660222737
            ],
            [
              -51.62130930192866,
              -28.112821916368986
            ],
            [
              -51.622509370199694,
              -28.114694719478884
            ],
            [
              -51.626109575012805,
              -28.11599127547804
            ],
            [
              -51.628182420208226,
              -28.11560711073755
            ],
            [
              -51.63178262502134,
              -28.112821916368986
            ],
            [
              -51.63320088752347,
              -28.113494204664846
            ],
            [
              -51.63489189281447,
              -28.113398163479722
            ],
            [
              -51.6327099505035,
              -28.11690366673671
            ],
            [
              -51.63178262502134,
              -28.119784902290398
            ],
            [
              -51.629382488479266,
              -28.12290624080689
            ],
            [
              -51.62670960914832,
              -28.12449092036142
            ],
            [
              -51.623600341355186,
              -28.1290048560622
            ],
            [
              -51.6220729817375,
              -28.130589535616725
            ],
            [
              -51.622891210104115,
              -28.132222235763816
            ],
            [
              -51.625291346646186,
              -28.131597968060518
            ],
            [
              -51.62660051203277,
              -28.13039745324648
            ],
            [
              -51.628291517323774,
              -28.127708300063038
            ],
            [
              -51.62949158559481,
              -28.127708300063038
            ],
            [
              -51.63107349377027,
              -28.125979558730826
            ],
            [
              -51.63200081925243,
              -28.12612362050851
            ],
            [
              -51.63238265915685,
              -28.12780434124816
            ],
            [
              -51.63369182454344,
              -28.128620691321707
            ],
            [
              -51.634019115890084,
              -28.13068557680185
            ],
            [
              -51.63309179040792,
              -28.131597968060518
            ],
            [
              -51.63347363031234,
              -28.13371087413322
            ],
            [
              -51.63429185867896,
              -28.134815347762135
            ],
            [
              -51.63620105820106,
              -28.13529555368775
            ],
            [
              -51.637292029356544,
              -28.13471930657701
            ],
            [
              -51.637292029356544,
              -28.133422750577854
            ],
            [
              -51.63821935483871,
              -28.132798482874552
            ],
            [
              -51.641383171189624,
              -28.133614832948098
            ],
            [
              -51.64389240484724,
              -28.132894524059676
            ],
            [
              -51.64721986687148,
              -28.133086606429924
            ],
            [
              -51.64831083802697,
              -28.132510359319184
            ],
            [
              -51.65071097456904,
              -28.1329905652448
            ],
            [
              -51.653983888035505,
              -28.132606400504308
            ],
            [
              -51.65671131592422,
              -28.133614832948098
            ],
            [
              -51.65627492746203,
              -28.135103471317503
            ],
            [
              -51.65922054958184,
              -28.136784192057156
            ],
            [
              -51.66129339477727,
              -28.13558367724312
            ],
            [
              -51.66402082266599,
              -28.136784192057156
            ],
            [
              -51.666802799112475,
              -28.13558367724312
            ],
            [
              -51.668002867383514,
              -28.136688150872033
            ],
            [
              -51.67067574671446,
              -28.1376005421307
            ],
            [
              -51.671984912101045,
              -28.137216377390207
            ],
            [
              -51.671984912101045,
              -28.13591982139105
            ],
            [
              -51.674112305854244,
              -28.13471930657701
            ],
            [
              -51.6795126130739,
              -28.135103471317503
            ],
            [
              -51.682294589520396,
              -28.136784192057156
            ],
            [
              -51.685185663082436,
              -28.137792624500946
            ],
            [
              -51.68998593616658,
              -28.13889709812986
            ],
            [
              -51.693804335210785,
              -28.141778333683547
            ],
            [
              -51.694622563577404,
              -28.144083322126498
            ],
            [
              -51.69407707799966,
              -28.145283836940532
            ],
            [
              -51.69631356886841,
              -28.14739674301324
            ],
            [
              -51.69369523809524,
              -28.149989855011558
            ],
            [
              -51.68589479433351,
              -28.157192943895776
            ],
            [
              -51.67209400921659,
              -28.166316856482453
            ],
            [
              -51.66729373613245,
              -28.169294133221264
            ],
            [
              -51.66031152073733,
              -28.171599121664215
            ],
            [
              -51.65769318996416,
              -28.17342390418155
            ],
            [
              -51.65147465437788,
              -28.18091511662114
            ],
            [
              -51.6520746885134,
              -28.182499796175666
            ],
            [
              -51.65011094043352,
              -28.186677587728514
            ],
            [
              -51.653220208226664,
              -28.187109773061568
            ],
            [
              -51.65720225294419,
              -28.18922267913427
            ],
            [
              -51.65922054958184,
              -28.188022164320234
            ],
            [
              -51.66009332650623,
              -28.185717175877286
            ],
            [
              -51.66091155487285,
              -28.185477072914477
            ],
            [
              -51.662275268817204,
              -28.18648550535827
            ],
            [
              -51.66418446833931,
              -28.190903399873925
            ],
            [
              -51.66287530295273,
              -28.189991008615255
            ],
            [
              -51.66282075439495,
              -28.19580150031519
            ],
            [
              -51.668384707287935,
              -28.19858669468376
            ],
            [
              -51.66849380440348,
              -28.200891683126706
            ],
            [
              -51.666802799112475,
              -28.20199615675562
            ],
            [
              -51.6693120327701,
              -28.20449322756882
            ],
            [
              -51.66947567844342,
              -28.206077907123344
            ],
            [
              -51.66822106161461,
              -28.206318010086154
            ],
            [
              -51.66691189622803,
              -28.205405618827484
            ],
            [
              -51.662220720259434,
              -28.205789783567976
            ],
            [
              -51.652401979860045,
              -28.212416625341458
            ],
            [
              -51.64929271206691,
              -28.218803364152134
            ],
            [
              -51.64907451783581,
              -28.221204393780205
            ],
            [
              -51.646674381293735,
              -28.223509382223156
            ],
            [
              -51.64607434715822,
              -28.227303009035513
            ],
            [
              -51.64678347840929,
              -28.231288718218114
            ],
            [
              -51.64067403993856,
              -28.233305583105693
            ],
            [
              -51.6374011264721,
              -28.236186818659384
            ],
            [
              -51.637182932241,
              -28.239212115990753
            ],
            [
              -51.640019457245266,
              -28.245502813616305
            ],
            [
              -51.6390921317631,
              -28.24751967850389
            ],
            [
              -51.637182932241,
              -28.248191966799748
            ],
            [
              -51.636801092336576,
              -28.250785078798067
            ],
            [
              -51.63571012118109,
              -28.25251382013028
            ],
            [
              -51.62960068271036,
              -28.25649952931288
            ],
            [
              -51.62769148318826,
              -28.261589712124398
            ],
            [
              -51.62130930192866,
              -28.267784368564826
            ],
            [
              -51.6222911759686,
              -28.269801233452405
            ],
            [
              -51.62180023894863,
              -28.271193830636687
            ],
            [
              -51.61830913125107,
              -28.273114654339146
            ],
            [
              -51.616290834613416,
              -28.277004322336627
            ],
            [
              -51.61132691585595,
              -28.279309310779574
            ],
            [
              -51.60499928315412,
              -28.2926110149191
            ],
            [
              -51.603199180747566,
              -28.292418932548856
            ],
            [
              -51.602817340843146,
              -28.294291735658753
            ],
            [
              -51.5939804744837,
              -28.301398783357847
            ],
            [
              -51.58618003072197,
              -28.303799812985922
            ],
            [
              -51.58432537975764,
              -28.303223565875182
            ],
            [
              -51.565506127325484,
              -28.306296883799117
            ],
            [
              -51.56370602491893,
              -28.301878989283463
            ],
            [
              -51.55770568356375,
              -28.309514263500734
            ],
            [
              -51.553614541730674,
              -28.309898428241226
            ],
            [
              -51.54472312681345,
              -28.31359601386846
            ],
            [
              -51.541722956135864,
              -28.321519411641102
            ],
            [
              -51.541613859020316,
              -28.32608136793444
            ],
            [
              -51.538777334016046,
              -28.327521985711282
            ],
            [
              -51.534304352278546,
              -28.32641751208237
            ],
            [
              -51.53272244410309,
              -28.330499262450093
            ],
            [
              -51.529776821983276,
              -28.334004765707082
            ],
            [
              -51.532613346987546,
              -28.33919098970372
            ],
            [
              -51.53299518689197,
              -28.34260045177558
            ],
            [
              -51.534795289298515,
              -28.34418513133011
            ],
            [
              -51.53861368834272,
              -28.354701641101073
            ],
            [
              -51.53828639699608,
              -28.358399226728302
            ],
            [
              -51.53970465949821,
              -28.359791823912587
            ],
            [
              -51.53692268305171,
              -28.365218150872032
            ],
            [
              -51.53861368834272,
              -28.366322624500945
            ],
            [
              -51.538886431131594,
              -28.367523139314983
            ],
            [
              -51.53468619218297,
              -28.37179697205295
            ],
            [
              -51.535177129202935,
              -28.374198001681027
            ],
            [
              -51.53332247823861,
              -28.375686640050432
            ],
            [
              -51.53201331285202,
              -28.375686640050432
            ],
            [
              -51.53119508448541,
              -28.37827975204875
            ],
            [
              -51.5295040791944,
              -28.37731934019752
            ],
            [
              -51.52879494794334,
              -28.381209008195
            ],
            [
              -51.526994845536784,
              -28.379720369825595
            ],
            [
              -51.524103771974744,
              -28.38130504938012
            ],
            [
              -51.52519474313023,
              -28.38288972893465
            ],
            [
              -51.522903703703705,
              -28.383513996637948
            ],
            [
              -51.522412766683736,
              -28.385578882118093
            ],
            [
              -51.52421286909029,
              -28.392013641521327
            ],
            [
              -51.52170363543267,
              -28.390621044337045
            ],
            [
              -51.52061266427718,
              -28.391581456188273
            ],
            [
              -51.5173942993685,
              -28.391581456188273
            ],
            [
              -51.515921488308585,
              -28.388700220634586
            ],
            [
              -51.51472142003755,
              -28.389900735448624
            ],
            [
              -51.51281222051545,
              -28.39018885900399
            ],
            [
              -51.51368499743984,
              -28.388316055894094
            ],
            [
              -51.50828469022018,
              -28.386299191006515
            ],
            [
              -51.503975354156,
              -28.388892303004834
            ],
            [
              -51.501902508960576,
              -28.388988344189954
            ],
            [
              -51.501520669056156,
              -28.393214156335365
            ],
            [
              -51.49808410991637,
              -28.39470279470477
            ],
            [
              -51.4978113671275,
              -28.396191433074176
            ],
            [
              -51.498684144051886,
              -28.398208297961755
            ],
            [
              -51.50081153780509,
              -28.397920174406387
            ],
            [
              -51.50288438300051,
              -28.39931277159067
            ],
            [
              -51.50108428059396,
              -28.400513286404706
            ],
            [
              -51.501902508960576,
              -28.401521718848496
            ],
            [
              -51.503975354156,
              -28.40161776003362
            ],
            [
              -51.50288438300051,
              -28.40358660432864
            ],
            [
              -51.50861198156682,
              -28.40459503677243
            ],
            [
              -51.50992114695341,
              -28.407380231140994
            ],
            [
              -51.510684826762244,
              -28.407716375288928
            ],
            [
              -51.51330315753542,
              -28.40589159277159
            ],
            [
              -51.51570329407749,
              -28.405987633956713
            ],
            [
              -51.5190853046595,
              -28.40891689010296
            ],
            [
              -51.5190853046595,
              -28.412614475730194
            ],
            [
              -51.522412766683736,
              -28.413622908173984
            ],
            [
              -51.524103771974744,
              -28.41242239335995
            ],
            [
              -51.528194913807816,
              -28.41309468165581
            ],
            [
              -51.53048595323434,
              -28.41448727884009
            ],
            [
              -51.53381341525858,
              -28.41467936121034
            ],
            [
              -51.536377197473975,
              -28.416119978987183
            ],
            [
              -51.54030469363373,
              -28.41669622609792
            ],
            [
              -51.54777784604882,
              -28.421786408909433
            ],
            [
              -51.5578147806793,
              -28.420777976465644
            ],
            [
              -51.56032401433692,
              -28.419817564614416
            ],
            [
              -51.56768806963646,
              -28.42092203824333
            ],
            [
              -51.572488342720604,
              -28.419721523429292
            ],
            [
              -51.57712497013142,
              -28.42197849127968
            ],
            [
              -51.58459812254651,
              -28.424283479722632
            ],
            [
              -51.58361624850657,
              -28.42942168312671
            ],
            [
              -51.58432537975764,
              -28.43182271275478
            ],
            [
              -51.58748919610855,
              -28.435280195419207
            ],
            [
              -51.589616589861755,
              -28.435280195419207
            ],
            [
              -51.59201672640383,
              -28.433695515864677
            ],
            [
              -51.592998600443764,
              -28.43388759823492
            ],
            [
              -51.60161727257211,
              -28.44257932548855
            ],
            [
              -51.60412650622973,
              -28.443395675562094
            ],
            [
              -51.604781088923026,
              -28.446709096448835
            ],
            [
              -51.60429015190306,
              -28.449110126076906
            ],
            [
              -51.60510838026967,
              -28.450502723261188
            ],
            [
              -51.610126847584915,
              -28.449302208447154
            ],
            [
              -51.61269062980031,
              -28.447381384744695
            ],
            [
              -51.614217989417995,
              -28.447093261189327
            ],
            [
              -51.61519986345793,
              -28.449014084891783
            ],
            [
              -51.614981669226836,
              -28.45251958814877
            ],
            [
              -51.617109062980035,
              -28.453095835259507
            ],
            [
              -51.61579989759345,
              -28.45420030888842
            ],
            [
              -51.616781771633384,
              -28.456409256146248
            ],
            [
              -51.616399931728964,
              -28.46010684177348
            ],
            [
              -51.61699996586448,
              -28.461979644883378
            ],
            [
              -51.619181908175456,
              -28.463180159697416
            ],
            [
              -51.61830913125107,
              -28.46529306577012
            ],
            [
              -51.62130930192866,
              -28.46428463332633
            ],
            [
              -51.622400273084146,
              -28.465917333473417
            ],
            [
              -51.620381976446495,
              -28.470095125026265
            ],
            [
              -51.617490902884455,
              -28.472976360579953
            ],
            [
              -51.61869097115549,
              -28.47451301954192
            ],
            [
              -51.618418228366615,
              -28.477394255095607
            ],
            [
              -51.61978194231098,
              -28.479603202353434
            ],
            [
              -51.62027287933095,
              -28.478210605169153
            ],
            [
              -51.622018433179726,
              -28.47609769909645
            ],
            [
              -51.625400443761734,
              -28.47552145198571
            ],
            [
              -51.628182420208226,
              -28.472976360579953
            ],
            [
              -51.62970977982591,
              -28.47278427820971
            ],
            [
              -51.63069165386585,
              -28.4719199075436
            ],
            [
              -51.63260085338795,
              -28.47158376339567
            ],
            [
              -51.63358272742789,
              -28.470719392729563
            ],
            [
              -51.63287359617682,
              -28.46860648665686
            ],
            [
              -51.633910018774536,
              -28.46702180710233
            ],
            [
              -51.63527373271889,
              -28.46601337465854
            ],
            [
              -51.638492097627584,
              -28.465581189325487
            ],
            [
              -51.64171046253627,
              -28.465581189325487
            ],
            [
              -51.64438334186721,
              -28.46721388947258
            ],
            [
              -51.64678347840929,
              -28.467982218953562
            ],
            [
              -51.64841993514252,
              -28.469807001470897
            ],
            [
              -51.65147465437788,
              -28.470479289766757
            ],
            [
              -51.6542020822666,
              -28.469086692582476
            ],
            [
              -51.65447482505547,
              -28.465917333473417
            ],
            [
              -51.65720225294419,
              -28.464908901029627
            ],
            [
              -51.66129339477727,
              -28.465917333473417
            ],
            [
              -51.67220310633214,
              -28.46567723051061
            ],
            [
              -51.67727612220516,
              -28.46399650977096
            ],
            [
              -51.679403515958356,
              -28.46428463332633
            ],
            [
              -51.68082177846049,
              -28.465389106955243
            ],
            [
              -51.683876497695856,
              -28.465917333473417
            ],
            [
              -51.68540385731354,
              -28.4666856629544
            ],
            [
              -51.68709486260454,
              -28.4666856629544
            ],
            [
              -51.690095033282134,
              -28.463516303845346
            ],
            [
              -51.69582263184844,
              -28.46361234503047
            ],
            [
              -51.69767728281277,
              -28.46342026266022
            ],
            [
              -51.69969557945042,
              -28.462411830216432
            ],
            [
              -51.70171387608807,
              -28.45972267703299
            ],
            [
              -51.70711418330773,
              -28.45837810044127
            ],
            [
              -51.70842334869432,
              -28.458618203404075
            ],
            [
              -51.71000525686978,
              -28.45612113259088
            ],
            [
              -51.71147806792968,
              -28.45511270014709
            ],
            [
              -51.71649653524492,
              -28.454296350073545
            ],
            [
              -51.71987854582694,
              -28.45439239125867
            ],
            [
              -51.72342420208227,
              -28.45280771170414
            ],
            [
              -51.724515173237755,
              -28.452999794074387
            ],
            [
              -51.728988154975255,
              -28.451319073334734
            ],
            [
              -51.73220651988394,
              -28.45151115570498
            ],
            [
              -51.7356976275815,
              -28.45079084681656
            ],
            [
              -51.73820686123912,
              -28.449686373187646
            ],
            [
              -51.742898037207716,
              -28.450694805631436
            ],
            [
              -51.745025430960915,
              -28.449782414372766
            ],
            [
              -51.74720737327189,
              -28.4516071968901
            ],
            [
              -51.747916504522955,
              -28.450406682076068
            ],
            [
              -51.75020754394948,
              -28.449014084891783
            ],
            [
              -51.75168035500939,
              -28.448677940743853
            ],
            [
              -51.754025942993685,
              -28.450310640890944
            ],
            [
              -51.75571694828469,
              -28.449302208447154
            ],
            [
              -51.758117084826765,
              -28.450022517335576
            ],
            [
              -51.76029902713774,
              -28.449302208447154
            ],
            [
              -51.76248096944871,
              -28.44920616726203
            ],
            [
              -51.76368103771975,
              -28.449782414372766
            ],
            [
              -51.764226523297495,
              -28.450982929186804
            ],
            [
              -51.76411742618194,
              -28.45280771170414
            ],
            [
              -51.76248096944871,
              -28.45439239125867
            ],
            [
              -51.76182638675542,
              -28.4580899768859
            ],
            [
              -51.763026455026456,
              -28.45780185333053
            ],
            [
              -51.76411742618194,
              -28.458618203404075
            ],
            [
              -51.76728124253286,
              -28.45770581214541
            ],
            [
              -51.76940863628606,
              -28.45780185333053
            ],
            [
              -51.77268154975252,
              -28.46077913006934
            ],
            [
              -51.77388161802355,
              -28.461211315402394
            ],
            [
              -51.77622720600785,
              -28.46111527421727
            ],
            [
              -51.77508168629459,
              -28.46327620088254
            ],
            [
              -51.77219061273255,
              -28.464476715696573
            ],
            [
              -51.77071780167264,
              -28.467309930657702
            ],
            [
              -51.76809947089947,
              -28.468318363101492
            ],
            [
              -51.76329919781533,
              -28.468894610212228
            ],
            [
              -51.762099129544296,
              -28.470095125026265
            ],
            [
              -51.76089906127326,
              -28.47259219583946
            ],
            [
              -51.76231732377539,
              -28.473984793023746
            ],
            [
              -51.765481140126305,
              -28.474080834208866
            ],
            [
              -51.77109964157706,
              -28.47508926665266
            ],
            [
              -51.77169967571258,
              -28.473888751838622
            ],
            [
              -51.77180877282813,
              -28.470815433914687
            ],
            [
              -51.77142693292371,
              -28.46927877495272
            ],
            [
              -51.77399071513911,
              -28.46759805421307
            ],
            [
              -51.775408977641234,
              -28.467502013027946
            ],
            [
              -51.77808185697218,
              -28.468318363101492
            ],
            [
              -51.78070018774535,
              -28.46999908384114
            ],
            [
              -51.782609387267456,
              -28.471679804580795
            ],
            [
              -51.78468223246288,
              -28.47451301954192
            ],
            [
              -51.783100324287425,
              -28.47609769909645
            ],
            [
              -51.781518416111965,
              -28.478306646354277
            ],
            [
              -51.776609045912274,
              -28.47518530783778
            ],
            [
              -51.775790817545655,
              -28.476721966799747
            ],
            [
              -51.77600901177676,
              -28.478882893465013
            ],
            [
              -51.77759091995221,
              -28.481476005463332
            ],
            [
              -51.78031834784093,
              -28.48402109686909
            ],
            [
              -51.78010015360983,
              -28.485797858793863
            ],
            [
              -51.77639085168118,
              -28.48459734397983
            ],
            [
              -51.775408977641234,
              -28.48459734397983
            ],
            [
              -51.77382706946578,
              -28.486085982349234
            ],
            [
              -51.773608875234686,
              -28.491704391678923
            ],
            [
              -51.77388161802355,
              -28.493385112418576
            ],
            [
              -51.77529988052569,
              -28.49420146249212
            ],
            [
              -51.777372725721115,
              -28.493721256566506
            ],
            [
              -51.78020925072538,
              -28.490695959235133
            ],
            [
              -51.7803728963987,
              -28.489687526791343
            ],
            [
              -51.7825002901519,
              -28.48771868249632
            ],
            [
              -51.78408219832736,
              -28.487190455978148
            ],
            [
              -51.78980979689367,
              -28.487382538348392
            ],
            [
              -51.79019163679809,
              -28.489495444421095
            ],
            [
              -51.78920976275815,
              -28.492616782937592
            ],
            [
              -51.78828243727599,
              -28.497322801008615
            ],
            [
              -51.788500631507084,
              -28.5002040365623
            ],
            [
              -51.78610049496501,
              -28.501212469006095
            ],
            [
              -51.78320942140297,
              -28.503901622189534
            ],
            [
              -51.779881959378734,
              -28.503517457449043
            ],
            [
              -51.77840914831883,
              -28.504477869300274
            ],
            [
              -51.78020925072538,
              -28.506494734187854
            ],
            [
              -51.78097293053422,
              -28.511104711073756
            ],
            [
              -51.782391193036354,
              -28.51321761714646
            ],
            [
              -51.7869732718894,
              -28.515090420256357
            ],
            [
              -51.78757330602492,
              -28.51648301744064
            ],
            [
              -51.786809626216076,
              -28.518691964698466
            ],
            [
              -51.785609557945044,
              -28.520276644252995
            ],
            [
              -51.786373237753885,
              -28.522293509140574
            ],
            [
              -51.788500631507084,
              -28.522293509140574
            ],
            [
              -51.79068257381806,
              -28.519892479512503
            ],
            [
              -51.791718996415774,
              -28.519700397142255
            ],
            [
              -51.7935736473801,
              -28.520276644252995
            ],
            [
              -51.79559194401775,
              -28.523301941584368
            ],
            [
              -51.794991909882235,
              -28.52411829165791
            ],
            [
              -51.79057347670251,
              -28.525799012397563
            ],
            [
              -51.78751875746715,
              -28.528488165581003
            ],
            [
              -51.78631868919611,
              -28.5309852363942
            ],
            [
              -51.78899156852705,
              -28.53199366883799
            ],
            [
              -51.792482676224616,
              -28.5316095040975
            ],
            [
              -51.79739204642431,
              -28.532089710023115
            ],
            [
              -51.79957398873528,
              -28.532089710023115
            ],
            [
              -51.801483188257386,
              -28.534778863206554
            ],
            [
              -51.802792353643966,
              -28.537708119352803
            ],
            [
              -51.80541068441714,
              -28.5395809224627
            ],
            [
              -51.806010718552656,
              -28.54049331372137
            ],
            [
              -51.802792353643966,
              -28.542606219794074
            ],
            [
              -51.80377422768391,
              -28.544190899348603
            ],
            [
              -51.807701723843664,
              -28.54447902290397
            ],
            [
              -51.80928363201912,
              -28.54539141416264
            ],
            [
              -51.810974637310125,
              -28.54841671149401
            ],
            [
              -51.81381116231439,
              -28.55100982349233
            ],
            [
              -51.81408390510326,
              -28.552114297121243
            ],
            [
              -51.81239289981226,
              -28.554515326749318
            ],
            [
              -51.81070189452125,
              -28.5559079239336
            ],
            [
              -51.80857450076805,
              -28.557012397562513
            ],
            [
              -51.80857450076805,
              -28.55830895356167
            ],
            [
              -51.810974637310125,
              -28.560613942004622
            ],
            [
              -51.81681133299198,
              -28.564023404076487
            ],
            [
              -51.8193205666496,
              -28.567576927926034
            ],
            [
              -51.82057518347841,
              -28.56810515444421
            ],
            [
              -51.82172070319167,
              -28.567576927926034
            ],
            [
              -51.82297532002048,
              -28.563303095188065
            ],
            [
              -51.82439358252262,
              -28.563014971632697
            ],
            [
              -51.82832107868237,
              -28.564983815927715
            ],
            [
              -51.828593821471244,
              -28.566616516074806
            ],
            [
              -51.82832107868237,
              -28.568681401554947
            ],
            [
              -51.827393753200205,
              -28.571418575330952
            ],
            [
              -51.826520976275816,
              -28.572907213700358
            ],
            [
              -51.82679371906469,
              -28.574780016810255
            ],
            [
              -51.82679371906469,
              -28.578717705400294
            ],
            [
              -51.82788469022017,
              -28.579389993696154
            ],
            [
              -51.830993958013316,
              -28.57468397562513
            ],
            [
              -51.83290315753542,
              -28.573579501996218
            ],
            [
              -51.83481235705752,
              -28.57429981088464
            ],
            [
              -51.836721556579626,
              -28.576988964068082
            ],
            [
              -51.84037630995051,
              -28.57761323177138
            ],
            [
              -51.840485407066055,
              -28.579005828955662
            ],
            [
              -51.837976173408435,
              -28.580014261399455
            ],
            [
              -51.837103396484046,
              -28.581022693843245
            ],
            [
              -51.836776105137396,
              -28.58260737339777
            ],
            [
              -51.837594333504015,
              -28.585680691321706
            ],
            [
              -51.838521658986174,
              -28.586208917839883
            ],
            [
              -51.84277644649258,
              -28.584912361840722
            ],
            [
              -51.84348557774364,
              -28.586016835469636
            ],
            [
              -51.84359467485919,
              -28.58808172094978
            ],
            [
              -51.84468564601468,
              -28.589282235763815
            ],
            [
              -51.84812220515447,
              -28.589618379911744
            ],
            [
              -51.851122375832055,
              -28.590386709392728
            ],
            [
              -51.85368615804745,
              -28.590386709392728
            ],
            [
              -51.85499532343403,
              -28.59168326539189
            ],
            [
              -51.85657723160949,
              -28.596197201092668
            ],
            [
              -51.857613654207206,
              -28.59730167472158
            ],
            [
              -51.85908646526711,
              -28.597397715906702
            ],
            [
              -51.86481406383342,
              -28.593219924353857
            ],
            [
              -51.86901430278205,
              -28.592787739020803
            ],
            [
              -51.87130534220857,
              -28.59370013027947
            ],
            [
              -51.87141443932412,
              -28.595092727463754
            ],
            [
              -51.869614336917564,
              -28.598214065980248
            ],
            [
              -51.867977880184334,
              -28.599078436646355
            ],
            [
              -51.86612322922001,
              -28.598886354276107
            ],
            [
              -51.86530500085339,
              -28.599702704349653
            ],
            [
              -51.86688690902885,
              -28.608922658121454
            ],
            [
              -51.86737784604882,
              -28.610891502416475
            ],
            [
              -51.86721420037549,
              -28.613100449674302
            ],
            [
              -51.866723263355524,
              -28.613820758562724
            ],
            [
              -51.86219573306025,
              -28.611707852490017
            ],
            [
              -51.86121385902031,
              -28.610315255305736
            ],
            [
              -51.857722751322754,
              -28.606617669678503
            ],
            [
              -51.85630448882062,
              -28.60589736079008
            ],
            [
              -51.85390435227855,
              -28.60589736079008
            ],
            [
              -51.85057689025431,
              -28.606617669678503
            ],
            [
              -51.849104079194404,
              -28.607385999159487
            ],
            [
              -51.848285850827786,
              -28.609210781676822
            ],
            [
              -51.848285850827786,
              -28.610507337675983
            ],
            [
              -51.85177695852535,
              -28.61338857322967
            ],
            [
              -51.8535770609319,
              -28.61401284093297
            ],
            [
              -51.85499532343403,
              -28.61530939693213
            ],
            [
              -51.855213517665135,
              -28.617278241227147
            ],
            [
              -51.856522683051715,
              -28.62131197100231
            ],
            [
              -51.85799549411163,
              -28.624385288926245
            ],
            [
              -51.857286362860556,
              -28.627314545072494
            ],
            [
              -51.85641358593617,
              -28.628322977516284
            ],
            [
              -51.85701362007168,
              -28.630003698255937
            ],
            [
              -51.85952285372931,
              -28.632692851439376
            ],
            [
              -51.86192299027138,
              -28.63370128388317
            ],
            [
              -51.86290486431132,
              -28.635814189955873
            ],
            [
              -51.85308612391193,
              -28.637590951880647
            ],
            [
              -51.851995152756444,
              -28.638887507879808
            ],
            [
              -51.85297702679638,
              -28.641384578693003
            ],
            [
              -51.85281338112306,
              -28.64359352595083
            ],
            [
              -51.84959501621437,
              -28.644505917209496
            ],
            [
              -51.842994640723674,
              -28.646714864467324
            ],
            [
              -51.840921795528246,
              -28.64757923513343
            ],
            [
              -51.83857620754395,
              -28.65079661483505
            ],
            [
              -51.839612630141666,
              -28.651997129649086
            ],
            [
              -51.84228550947261,
              -28.652717438537508
            ],
            [
              -51.845776617170166,
              -28.64959610002101
            ],
            [
              -51.8493222734255,
              -28.64892381172515
            ],
            [
              -51.85368615804745,
              -28.65449420046228
            ],
            [
              -51.860122887864826,
              -28.6570873124606
            ],
            [
              -51.860504727769246,
              -28.65809574490439
            ],
            [
              -51.85679542584059,
              -28.66198541290187
            ],
            [
              -51.85052234169654,
              -28.661793330531623
            ],
            [
              -51.84817675371224,
              -28.663522071863838
            ],
            [
              -51.938018228366616,
              -28.668996419415844
            ],
            [
              -51.99442143710531,
              -28.67250192267283
            ],
            [
              -51.99480327700973,
              -28.661697289346503
            ],
            [
              -51.99267588325653,
              -28.661505206976255
            ],
            [
              -51.992512237583206,
              -28.657711580163898
            ],
            [
              -51.993003174603174,
              -28.656318982979617
            ],
            [
              -51.9972034135518,
              -28.653005562092876
            ],
            [
              -51.994094145758666,
              -28.648683708762345
            ],
            [
              -51.99518511691415,
              -28.648395585206977
            ],
            [
              -51.99649428230074,
              -28.610507337675983
            ],
            [
              -52.06648008192524,
              -28.61439700567346
            ],
            [
              -52.092990681003585,
              -28.615885644042866
            ],
            [
              -52.09162696705923,
              -28.6288031834419
            ],
            [
              -52.09069964157706,
              -28.62851505988653
            ],
            [
              -52.08819040791944,
              -28.630291821811305
            ],
            [
              -52.089608670421576,
              -28.63211660432864
            ],
            [
              -52.09179061273255,
              -28.63240472788401
            ],
            [
              -52.09239064686807,
              -28.633221077957554
            ],
            [
              -52.095499914661204,
              -28.63211660432864
            ],
            [
              -52.09817279399215,
              -28.630003698255937
            ],
            [
              -52.1001910906298,
              -28.629907657070813
            ],
            [
              -52.10057293053422,
              -28.63110817188485
            ],
            [
              -52.09980925072538,
              -28.633893366253414
            ],
            [
              -52.099972896398704,
              -28.635814189955873
            ],
            [
              -52.10248213005632,
              -28.637590951880647
            ],
            [
              -52.10171845024748,
              -28.63960781676823
            ],
            [
              -52.102373032940775,
              -28.641720722840933
            ],
            [
              -52.10390039255846,
              -28.644121752469005
            ],
            [
              -52.104882266598395,
              -28.64757923513343
            ],
            [
              -52.10591868919611,
              -28.649692141206135
            ],
            [
              -52.106900563236046,
              -28.65079661483505
            ],
            [
              -52.110609865164705,
              -28.65209317083421
            ],
            [
              -52.11110080218467,
              -28.653293685648244
            ],
            [
              -52.11077351083803,
              -28.65540659172095
            ],
            [
              -52.10968253968254,
              -28.655790756461442
            ],
            [
              -52.1051004608295,
              -28.65550263290607
            ],
            [
              -52.102809421402974,
              -28.655598674091195
            ],
            [
              -52.10117296466974,
              -28.657183353645724
            ],
            [
              -52.10090022188087,
              -28.65900813616306
            ],
            [
              -52.10128206178529,
              -28.661697289346503
            ],
            [
              -52.10090022188087,
              -28.663378010086152
            ],
            [
              -52.10057293053422,
              -28.667603822231563
            ],
            [
              -52.10008199351425,
              -28.668996419415844
            ],
            [
              -52.10117296466974,
              -28.667603822231563
            ],
            [
              -52.102318484383005,
              -28.66491466904812
            ],
            [
              -52.107391500256014,
              -28.66750778104644
            ],
            [
              -52.111809933435744,
              -28.671781613784407
            ],
            [
              -52.120810445468514,
              -28.671301407858792
            ],
            [
              -52.12108318825738,
              -28.667987986972054
            ],
            [
              -52.124901587301586,
              -28.671685572599284
            ],
            [
              -52.133520259429936,
              -28.672982128598445
            ],
            [
              -52.13979334357399,
              -28.671301407858792
            ],
            [
              -52.14759378733572,
              -28.66688351334314
            ],
            [
              -52.15599426523298,
              -28.651709006093718
            ],
            [
              -52.15632155657962,
              -28.652621397352384
            ],
            [
              -52.15997630995051,
              -28.654878365202773
            ],
            [
              -52.162594640723675,
              -28.65939230090355
            ],
            [
              -52.167994947943335,
              -28.65838386845976
            ],
            [
              -52.17061327871651,
              -28.659776465644043
            ],
            [
              -52.17617723160949,
              -28.66068885690271
            ],
            [
              -52.17917740228708,
              -28.659488342088675
            ],
            [
              -52.18321399556238,
              -28.65939230090355
            ],
            [
              -52.183486738351256,
              -28.65809574490439
            ],
            [
              -52.18572322922,
              -28.656607106534985
            ],
            [
              -52.18932343403311,
              -28.656895230090356
            ],
            [
              -52.19319638163509,
              -28.65607888001681
            ],
            [
              -52.19521467827274,
              -28.654878365202773
            ],
            [
              -52.19319638163509,
              -28.660496774532465
            ],
            [
              -52.19450554702168,
              -28.66059281571759
            ],
            [
              -52.19401461000171,
              -28.66328196890103
            ],
            [
              -52.1923236047107,
              -28.664194360159698
            ],
            [
              -52.19199631336406,
              -28.66981276948939
            ],
            [
              -52.19357822153951,
              -28.671013284303424
            ],
            [
              -52.199087625874725,
              -28.671589531414163
            ],
            [
              -52.20170595664789,
              -28.6734143139315
            ],
            [
              -52.203178767707804,
              -28.673606396301743
            ],
            [
              -52.21048827444957,
              -28.66990881067451
            ],
            [
              -52.217579586960234,
              -28.671397449043916
            ],
            [
              -52.217088649940266,
              -28.669620687119142
            ],
            [
              -52.21779778119133,
              -28.669092460600965
            ],
            [
              -52.22439815668203,
              -28.668708295860476
            ],
            [
              -52.22521638504865,
              -28.669092460600965
            ],
            [
              -52.225707322068615,
              -28.671781613784407
            ],
            [
              -52.22718013312852,
              -28.672790046228197
            ],
            [
              -52.227725618706266,
              -28.671301407858792
            ],
            [
              -52.22881658986175,
              -28.671013284303424
            ],
            [
              -52.22881658986175,
              -28.668084028157175
            ],
            [
              -52.23388960573477,
              -28.671013284303424
            ],
            [
              -52.23568970814132,
              -28.671109325488548
            ],
            [
              -52.24141730670763,
              -28.665394874973735
            ],
            [
              -52.2419082437276,
              -28.663714154234082
            ],
            [
              -52.240926369687664,
              -28.662513639420045
            ],
            [
              -52.243326506229735,
              -28.66097698045808
            ],
            [
              -52.24349015190305,
              -28.65968042445892
            ],
            [
              -52.2463812254651,
              -28.6623215570498
            ],
            [
              -52.24938139614269,
              -28.662417598234924
            ],
            [
              -52.24932684758491,
              -28.66429040134482
            ],
            [
              -52.25052691585595,
              -28.667411739861315
            ],
            [
              -52.249490493258236,
              -28.66981276948939
            ],
            [
              -52.25221792114696,
              -28.672405881487705
            ],
            [
              -52.252381566820276,
              -28.675623261189326
            ],
            [
              -52.25341798941799,
              -28.677592105484344
            ],
            [
              -52.25292705239802,
              -28.679512929186803
            ],
            [
              -52.253581635091315,
              -28.68037729985291
            ],
            [
              -52.2570181942311,
              -28.680521361630593
            ],
            [
              -52.25980017067759,
              -28.68229812355537
            ],
            [
              -52.259309233657625,
              -28.684411029628073
            ],
            [
              -52.26001836490869,
              -28.686379873923094
            ],
            [
              -52.26209121010412,
              -28.68791653288506
            ],
            [
              -52.263509472606245,
              -28.689981418365203
            ],
            [
              -52.26640054616829,
              -28.691181933179237
            ],
            [
              -52.26770971155487,
              -28.693390880437065
            ],
            [
              -52.270873527905785,
              -28.693919106955242
            ],
            [
              -52.27218269329237,
              -28.69511962176928
            ],
            [
              -52.2785103259942,
              -28.696080033620508
            ],
            [
              -52.27687386926097,
              -28.728493933599495
            ],
            [
              -52.277801194743134,
              -28.7352168165581
            ],
            [
              -52.27971039426524,
              -28.736705454927506
            ],
            [
              -52.28200143369176,
              -28.73718566085312
            ],
            [
              -52.28260146782728,
              -28.73848221685228
            ],
            [
              -52.286474415429254,
              -28.739682731666317
            ],
            [
              -52.290511008704556,
              -28.74438874973734
            ],
            [
              -52.291711076975595,
              -28.744676873292708
            ],
            [
              -52.29471124765318,
              -28.743620420256356
            ],
            [
              -52.296184058713095,
              -28.74539718218113
            ],
            [
              -52.2980932582352,
              -28.74578134692162
            ],
            [
              -52.30082068612391,
              -28.74799029417945
            ],
            [
              -52.29700228707971,
              -28.750583406177768
            ],
            [
              -52.298202355350746,
              -28.75168787980668
            ],
            [
              -52.29678409284861,
              -28.754377032990124
            ],
            [
              -52.29302024236218,
              -28.7549052595083
            ],
            [
              -52.295474927462024,
              -28.756393897877704
            ],
            [
              -52.29591131592422,
              -28.758698886320655
            ],
            [
              -52.29520218467315,
              -28.760715751208238
            ],
            [
              -52.29591131592422,
              -28.761580121874342
            ],
            [
              -52.2953112817887,
              -28.762588554318135
            ],
            [
              -52.30142072025943,
              -28.767198531204034
            ],
            [
              -52.30131162314388,
              -28.769215396091617
            ],
            [
              -52.303220822665985,
              -28.77031986972053
            ],
            [
              -52.304475439494794,
              -28.772096631645304
            ],
            [
              -52.30338446833931,
              -28.772816940533726
            ],
            [
              -52.30458453661034,
              -28.77430557890313
            ],
            [
              -52.30338446833931,
              -28.77531401134692
            ],
            [
              -52.305620959208056,
              -28.77661056734608
            ],
            [
              -52.3063846390169,
              -28.778483370455977
            ],
            [
              -52.306111896228025,
              -28.78021211178819
            ],
            [
              -52.307202867383516,
              -28.781316585417105
            ],
            [
              -52.305184570745865,
              -28.783621573860053
            ],
            [
              -52.30491182795699,
              -28.785686459340198
            ],
            [
              -52.30627554190135,
              -28.786502809413744
            ],
            [
              -52.308621129885644,
              -28.785590418155074
            ],
            [
              -52.309875746714454,
              -28.786214685858372
            ],
            [
              -52.31249407748763,
              -28.78948008615255
            ],
            [
              -52.31238498037208,
              -28.793417774742593
            ],
            [
              -52.31451237412528,
              -28.79591484555579
            ],
            [
              -52.31980358422939,
              -28.795722763185545
            ],
            [
              -52.321221846731525,
              -28.796779216221896
            ],
            [
              -52.32138549240485,
              -28.798507957554108
            ],
            [
              -52.31980358422939,
              -28.801581275478043
            ],
            [
              -52.32062181259601,
              -28.80518281992015
            ],
            [
              -52.32547663423792,
              -28.80638333473419
            ],
            [
              -52.32378562894692,
              -28.808496240806893
            ],
            [
              -52.329022290493256,
              -28.812577991174617
            ],
            [
              -52.32727673664448,
              -28.813586423618407
            ],
            [
              -52.32542208568015,
              -28.814786938432444
            ],
            [
              -52.32580392558457,
              -28.816323597394412
            ],
            [
              -52.324112920293565,
              -28.81800431813406
            ],
            [
              -52.32940413039768,
              -28.82088555368775
            ],
            [
              -52.32951322751323,
              -28.82160586257617
            ],
            [
              -52.32602211981567,
              -28.823094500945576
            ],
            [
              -52.3234037890425,
              -28.821797944946418
            ],
            [
              -52.32198552654037,
              -28.82251825383484
            ],
            [
              -52.322803754906985,
              -28.82391085101912
            ],
            [
              -52.322094623655914,
              -28.82559157175877
            ],
            [
              -52.317076156340676,
              -28.829001033830636
            ],
            [
              -52.31238498037208,
              -28.828376766127338
            ],
            [
              -52.30960300392559,
              -28.829193116200884
            ],
            [
              -52.31211223758321,
              -28.838701193528053
            ],
            [
              -52.31118491210104,
              -28.84129430552637
            ],
            [
              -52.306111896228025,
              -28.841198264341248
            ],
            [
              -52.30502092507254,
              -28.842686902710653
            ],
            [
              -52.30671193036355,
              -28.84489584996848
            ],
            [
              -52.31107581498549,
              -28.84518397352385
            ],
            [
              -52.31287591739205,
              -28.848017188484974
            ],
            [
              -52.31271227171872,
              -28.84888155915108
            ],
            [
              -52.30747561017238,
              -28.84921770329901
            ],
            [
              -52.304475439494794,
              -28.851378629964277
            ],
            [
              -52.29842054958184,
              -28.84657657070813
            ],
            [
              -52.29640225294419,
              -28.847104797226308
            ],
            [
              -52.29602041303977,
              -28.851522691741962
            ],
            [
              -52.298311452466294,
              -28.851618732927086
            ],
            [
              -52.301093428912786,
              -28.854019762555158
            ],
            [
              -52.30600279911248,
              -28.85377965959235
            ],
            [
              -52.3063846390169,
              -28.854692050851018
            ],
            [
              -52.30327537122376,
              -28.857477245219584
            ],
            [
              -52.30431179382147,
              -28.859494110107164
            ],
            [
              -52.30927571257894,
              -28.863383778104645
            ],
            [
              -52.308075644307905,
              -28.8638159634377
            ],
            [
              -52.30251169141492,
              -28.86227930447573
            ],
            [
              -52.29487489332651,
              -28.866985322546753
            ],
            [
              -52.29607496159754,
              -28.868618022693845
            ],
            [
              -52.298311452466294,
              -28.86760959025005
            ],
            [
              -52.299620617852874,
              -28.868906146249213
            ],
            [
              -52.30131162314388,
              -28.873420081949988
            ],
            [
              -52.29940242362178,
              -28.875581008615256
            ],
            [
              -52.29111104284008,
              -28.877597873502836
            ],
            [
              -52.289692780337944,
              -28.878894429501997
            ],
            [
              -52.291001945724524,
              -28.88460888001681
            ],
            [
              -52.29291114524663,
              -28.886289600756463
            ],
            [
              -52.2931838880355,
              -28.888306465644042
            ],
            [
              -52.29160197986005,
              -28.888402506829166
            ],
            [
              -52.289583683222396,
              -28.88657772431183
            ],
            [
              -52.28620167264038,
              -28.888690630384534
            ],
            [
              -52.28140139955624,
              -28.886385641941583
            ],
            [
              -52.27867397166752,
              -28.88691386845976
            ],
            [
              -52.278183034647554,
              -28.887682197940745
            ],
            [
              -52.279819491380785,
              -28.892676339567135
            ],
            [
              -52.28101955965182,
              -28.894020916158855
            ],
            [
              -52.289201843317976,
              -28.895797678083632
            ],
            [
              -52.28789267793139,
              -28.89709423408279
            ],
            [
              -52.27971039426524,
              -28.898919016600125
            ],
            [
              -52.278183034647554,
              -28.90002349022904
            ],
            [
              -52.277801194743134,
              -28.901704210968692
            ],
            [
              -52.281074108209594,
              -28.905209714225677
            ],
            [
              -52.28031042840075,
              -28.91250884429502
            ],
            [
              -52.278073937532,
              -28.914621750367726
            ],
            [
              -52.270818979348014,
              -28.91779110947678
            ],
            [
              -52.26558231780167,
              -28.92230504517756
            ],
            [
              -52.26601870626387,
              -28.92571450724942
            ],
            [
              -52.2719099505035,
              -28.92821157806262
            ],
            [
              -52.273219115890086,
              -28.93118885480143
            ],
            [
              -52.270491688001364,
              -28.932677493170832
            ],
            [
              -52.26078204471753,
              -28.932581451985712
            ],
            [
              -52.26067294760198,
              -28.93450227568817
            ],
            [
              -52.26209121010412,
              -28.935894872872453
            ],
            [
              -52.26241850145076,
              -28.938487984870772
            ],
            [
              -52.265473220686125,
              -28.9381998613154
            ],
            [
              -52.2672187745349,
              -28.939592458499686
            ],
            [
              -52.26667328895716,
              -28.941993488127757
            ],
            [
              -52.26770971155487,
              -28.94540295019962
            ],
            [
              -52.26661874039939,
              -28.9474198150872
            ],
            [
              -52.26280034135518,
              -28.94761189745745
            ],
            [
              -52.25740003413552,
              -28.95198177138054
            ],
            [
              -52.259309233657625,
              -28.956687789451564
            ],
            [
              -52.2612729817375,
              -28.958608613154023
            ],
            [
              -52.26121843317972,
              -28.960193292708553
            ],
            [
              -52.25980017067759,
              -28.96110568396722
            ],
            [
              -52.25838190817546,
              -28.959905169153185
            ],
            [
              -52.255218091824545,
              -28.959905169153185
            ],
            [
              -52.250308721624855,
              -28.964515146039084
            ],
            [
              -52.24878136200717,
              -28.964899310779575
            ],
            [
              -52.246217579791775,
              -28.962690363521748
            ],
            [
              -52.24392654036525,
              -28.962786404706872
            ],
            [
              -52.24239918074757,
              -28.96638794914898
            ],
            [
              -52.24479931728964,
              -28.968885019962176
            ],
            [
              -52.24452657450077,
              -28.969797411220846
            ],
            [
              -52.240980918245434,
              -28.971814276108425
            ],
            [
              -52.23988994708995,
              -28.9717182349233
            ],
            [
              -52.236889776412355,
              -28.968500855221684
            ],
            [
              -52.234380542754735,
              -28.968692937591932
            ],
            [
              -52.23481693121693,
              -28.972102399663793
            ],
            [
              -52.23988994708995,
              -28.973783120403446
            ],
            [
              -52.24038088410992,
              -28.974695511662112
            ],
            [
              -52.23912626728111,
              -28.975511861735658
            ],
            [
              -52.23159856630824,
              -28.974023223366252
            ],
            [
              -52.22958026967059,
              -28.97070980247951
            ],
            [
              -52.22832565284178,
              -28.970085534776214
            ],
            [
              -52.227016487455195,
              -28.971478131960495
            ],
            [
              -52.22712558457075,
              -28.97258260558941
            ],
            [
              -52.228598395630655,
              -28.975607902920782
            ],
            [
              -52.23078033794163,
              -28.98420358898928
            ],
            [
              -52.23078033794163,
              -28.987420968690902
            ],
            [
              -52.23028940092166,
              -28.988909607060307
            ],
            [
              -52.22881658986175,
              -28.98938981298592
            ],
            [
              -52.22477999658645,
              -28.988909607060307
            ],
            [
              -52.22439815668203,
              -28.991118554318135
            ],
            [
              -52.225380030721965,
              -28.99231906913217
            ],
            [
              -52.22788926437959,
              -28.993807707501574
            ],
            [
              -52.230616692268306,
              -28.99500822231561
            ],
            [
              -52.23208950332821,
              -28.996112695944525
            ],
            [
              -52.23252589179041,
              -28.99721716957344
            ],
            [
              -52.23159856630824,
              -28.9985137255726
            ],
            [
              -52.22718013312852,
              -28.999282055053584
            ],
            [
              -52.22477999658645,
              -29.000386528682498
            ],
            [
              -52.22199802013996,
              -29.002403393570077
            ],
            [
              -52.21888875234682,
              -29.00509254675352
            ],
            [
              -52.21790687830688,
              -29.0071094116411
            ],
            [
              -52.21479761051374,
              -29.01071095608321
            ],
            [
              -52.215124901860385,
              -29.011719388527002
            ],
            [
              -52.22052520908005,
              -29.010903038453456
            ],
            [
              -52.22297989417989,
              -29.013880315192267
            ],
            [
              -52.225325482164195,
              -29.015416974154235
            ],
            [
              -52.22848929851511,
              -29.015705097709603
            ],
            [
              -52.22979846390169,
              -29.017097694893884
            ],
            [
              -52.2289256869773,
              -29.01791404496743
            ],
            [
              -52.22652555043523,
              -29.01892247741122
            ],
            [
              -52.22548912783752,
              -29.01997893044757
            ],
            [
              -52.22101614610002,
              -29.024108701407858
            ],
            [
              -52.21888875234682,
              -29.025309216221896
            ],
            [
              -52.21501580474484,
              -29.026701813406177
            ],
            [
              -52.21730684417136,
              -29.030879604959026
            ],
            [
              -52.21937968936679,
              -29.032608346291237
            ],
            [
              -52.22341628264209,
              -29.03472125236394
            ],
            [
              -52.22598006485749,
              -29.037794570287875
            ],
            [
              -52.22810745861069,
              -29.040723826434125
            ],
            [
              -52.22761652159072,
              -29.041588197100232
            ],
            [
              -52.226089161973036,
              -29.042020382433282
            ],
            [
              -52.22068885475337,
              -29.041588197100232
            ],
            [
              -52.2165977129203,
              -29.03928320865728
            ],
            [
              -52.21528854753371,
              -29.03990747636058
            ],
            [
              -52.21490670762929,
              -29.04547786509771
            ],
            [
              -52.21572493599591,
              -29.046918482874553
            ],
            [
              -52.21681590715139,
              -29.047302647615044
            ],
            [
              -52.219979723502306,
              -29.04739868880017
            ],
            [
              -52.22177982590886,
              -29.048311080058834
            ],
            [
              -52.22270715139102,
              -29.05018388316873
            ],
            [
              -52.21948878648234,
              -29.053497304055472
            ],
            [
              -52.21719774705581,
              -29.05301709812986
            ],
            [
              -52.21452486772487,
              -29.05018388316873
            ],
            [
              -52.21321570233828,
              -29.049415553687748
            ],
            [
              -52.21092466291176,
              -29.04970367724312
            ],
            [
              -52.20890636627411,
              -29.050904192057153
            ],
            [
              -52.21032462877624,
              -29.054313654129018
            ],
            [
              -52.21032462877624,
              -29.05609041605379
            ],
            [
              -52.20917910906298,
              -29.05868352805211
            ],
            [
              -52.209779143198496,
              -29.062092990123976
            ],
            [
              -52.21032462877624,
              -29.062813299012397
            ],
            [
              -52.213815736473805,
              -29.064109855011555
            ],
            [
              -52.214688513398194,
              -29.06228507249422
            ],
            [
              -52.215997678784774,
              -29.061516743013236
            ],
            [
              -52.21817962109575,
              -29.06228507249422
            ],
            [
              -52.2185069124424,
              -29.063677669678505
            ],
            [
              -52.22052520908005,
              -29.06550245219584
            ],
            [
              -52.22297989417989,
              -29.066799008194998
            ],
            [
              -52.22379812254651,
              -29.06809556419416
            ],
            [
              -52.22297989417989,
              -29.069007955452825
            ],
            [
              -52.2185069124424,
              -29.070016387896615
            ],
            [
              -52.21337934801161,
              -29.072321376339566
            ],
            [
              -52.21152469704728,
              -29.072609499894934
            ],
            [
              -52.20917910906298,
              -29.07208127337676
            ],
            [
              -52.20628803550094,
              -29.071985232191636
            ],
            [
              -52.20470612732548,
              -29.072897623450306
            ],
            [
              -52.206997166752004,
              -29.080196753519648
            ],
            [
              -52.20912456050521,
              -29.080292794704768
            ],
            [
              -52.21157924560505,
              -29.078419991594874
            ],
            [
              -52.21490670762929,
              -29.078179888632064
            ],
            [
              -52.2204161119645,
              -29.076211044337047
            ],
            [
              -52.221616180235536,
              -29.07669125026266
            ],
            [
              -52.22008882061785,
              -29.078179888632064
            ],
            [
              -52.214197576378226,
              -29.082405700777475
            ],
            [
              -52.21141559993173,
              -29.08360621559151
            ],
            [
              -52.20950640040963,
              -29.08360621559151
            ],
            [
              -52.20672442396314,
              -29.084806730405546
            ],
            [
              -52.20677897252091,
              -29.086007245219584
            ],
            [
              -52.208579074927464,
              -29.087591924774113
            ],
            [
              -52.21081556579621,
              -29.090281077957552
            ],
            [
              -52.21217927974057,
              -29.09277814877075
            ],
            [
              -52.21228837685612,
              -29.094602931288087
            ],
            [
              -52.22057975763782,
              -29.097484166841774
            ],
            [
              -52.22472544802868,
              -29.099789155284725
            ],
            [
              -52.23001665813279,
              -29.100605505358267
            ],
            [
              -52.23241679467486,
              -29.100077278840093
            ],
            [
              -52.24021723843659,
              -29.102094143727673
            ],
            [
              -52.245508448540704,
              -29.102478308468164
            ],
            [
              -52.24692671104284,
              -29.101998102542552
            ],
            [
              -52.251617887011435,
              -29.109777438537506
            ],
            [
              -52.25221792114696,
              -29.11870926875394
            ],
            [
              -52.25549083461342,
              -29.12029394830847
            ],
            [
              -52.2634003754907,
              -29.11870926875394
            ],
            [
              -52.26487318655061,
              -29.11909343349443
            ],
            [
              -52.268309745690395,
              -29.117604795125025
            ],
            [
              -52.269182522614784,
              -29.118805309939063
            ],
            [
              -52.2716917562724,
              -29.11870926875394
            ],
            [
              -52.27360095579451,
              -29.11962166001261
            ],
            [
              -52.27469192694999,
              -29.121590504307626
            ],
            [
              -52.281074108209594,
              -29.124903925194367
            ],
            [
              -52.28238327359618,
              -29.12668068711914
            ],
            [
              -52.28161959378734,
              -29.1286015108216
            ],
            [
              -52.28391063321386,
              -29.130378272746373
            ],
            [
              -52.28767448370029,
              -29.130618375709183
            ],
            [
              -52.288820003413555,
              -29.12932181971002
            ],
            [
              -52.290511008704556,
              -29.129705984450514
            ],
            [
              -52.29302024236218,
              -29.13311544652238
            ],
            [
              -52.29269295101553,
              -29.134988249632276
            ],
            [
              -52.29389301928657,
              -29.135996682076065
            ],
            [
              -52.2936202764977,
              -29.138301670519017
            ],
            [
              -52.28942003754907,
              -29.13801354696365
            ],
            [
              -52.288001775046936,
              -29.13868583525951
            ],
            [
              -52.28767448370029,
              -29.141519050220634
            ],
            [
              -52.28581983273596,
              -29.144112162218953
            ],
            [
              -52.28669260966035,
              -29.145792882958606
            ],
            [
              -52.28669260966035,
              -29.148097871401554
            ],
            [
              -52.28440157023383,
              -29.150690983399873
            ],
            [
              -52.289583683222396,
              -29.151987539399034
            ],
            [
              -52.28631076975593,
              -29.15429252784198
            ],
            [
              -52.28669260966035,
              -29.15549304265602
            ],
            [
              -52.29220201399556,
              -29.154580651397353
            ],
            [
              -52.29067465437788,
              -29.159094587098128
            ],
            [
              -52.29242020822666,
              -29.162504049169993
            ],
            [
              -52.29242020822666,
              -29.163896646354274
            ],
            [
              -52.29929332650623,
              -29.164088728724522
            ],
            [
              -52.29989336064175,
              -29.154580651397353
            ],
            [
              -52.30027520054617,
              -29.152707848287456
            ],
            [
              -52.30218440006827,
              -29.1528999306577
            ],
            [
              -52.31047578084998,
              -29.158518339987392
            ],
            [
              -52.31320320873869,
              -29.157221783988234
            ],
            [
              -52.31560334528076,
              -29.152515765917208
            ],
            [
              -52.315985185185184,
              -29.146513191847028
            ],
            [
              -52.317076156340676,
              -29.145888924143726
            ],
            [
              -52.31991268134494,
              -29.145408718218114
            ],
            [
              -52.32269465779143,
              -29.14689735658752
            ],
            [
              -52.324603857313534,
              -29.15621335154444
            ],
            [
              -52.32727673664448,
              -29.156309392729565
            ],
            [
              -52.330604198668716,
              -29.15328409539819
            ],
            [
              -52.33387711213518,
              -29.14771370666106
            ],
            [
              -52.34249578426353,
              -29.140606658961968
            ],
            [
              -52.34358675541901,
              -29.140798741332212
            ],
            [
              -52.345495954941114,
              -29.14300768859004
            ],
            [
              -52.34740515446322,
              -29.146705274217272
            ],
            [
              -52.35002348523639,
              -29.149682550956083
            ],
            [
              -52.35138719918075,
              -29.15021077747426
            ],
            [
              -52.36987916026626,
              -29.14392007984871
            ],
            [
              -52.37309752517495,
              -29.14358393570078
            ],
            [
              -52.37380665642601,
              -29.14497653288506
            ],
            [
              -52.369224577572965,
              -29.150018695104013
            ],
            [
              -52.36938822324629,
              -29.150690983399873
            ],
            [
              -52.3770250213347,
              -29.15189149821391
            ],
            [
              -52.38629827615634,
              -29.14761766547594
            ],
            [
              -52.38782563577402,
              -29.14771370666106
            ],
            [
              -52.39289865164704,
              -29.151123168732926
            ],
            [
              -52.402008260795355,
              -29.148818180289975
            ],
            [
              -52.40549936849292,
              -29.151603374658542
            ],
            [
              -52.40708127666837,
              -29.156597516284933
            ],
            [
              -52.40800860215054,
              -29.156981681025425
            ],
            [
              -52.410190544461514,
              -29.15587720739651
            ],
            [
              -52.41280887523468,
              -29.152083580584154
            ],
            [
              -52.42050022188087,
              -29.150018695104013
            ],
            [
              -52.42350039255846,
              -29.147185480142888
            ],
            [
              -52.42508230073391,
              -29.14689735658752
            ],
            [
              -52.42579143198498,
              -29.148097871401554
            ],
            [
              -52.42420952380952,
              -29.150402859844505
            ],
            [
              -52.42431862092507,
              -29.152419724732088
            ],
            [
              -52.42540959208056,
              -29.15650147509981
            ],
            [
              -52.427318791602666,
              -29.156981681025425
            ],
            [
              -52.4283006656426,
              -29.158278237024586
            ],
            [
              -52.42840976275815,
              -29.16111145198571
            ],
            [
              -52.429009796893666,
              -29.163608522798906
            ],
            [
              -52.431082642089095,
              -29.164088728724522
            ],
            [
              -52.430209865164706,
              -29.166489758352593
            ],
            [
              -52.428573408431475,
              -29.167114026055895
            ],
            [
              -52.42890069977812,
              -29.16869870561042
            ],
            [
              -52.427373340160436,
              -29.170379426350074
            ],
            [
              -52.42939163679809,
              -29.171724002941794
            ],
            [
              -52.42960983102919,
              -29.173308682496323
            ],
            [
              -52.431082642089095,
              -29.173788888421935
            ],
            [
              -52.431900870455706,
              -29.179023133011135
            ],
            [
              -52.433919167093364,
              -29.178014700567346
            ],
            [
              -52.43501013824885,
              -29.18051177138054
            ],
            [
              -52.436810240655404,
              -29.183489048119352
            ],
            [
              -52.43588291517324,
              -29.185986118932547
            ],
            [
              -52.43861034306196,
              -29.18992380752259
            ],
            [
              -52.43871944017751,
              -29.191508487077115
            ],
            [
              -52.43751937190647,
              -29.193381290187013
            ],
            [
              -52.43539197815327,
              -29.193813475520066
            ],
            [
              -52.43610110940433,
              -29.195013990334104
            ],
            [
              -52.43577381805769,
              -29.19851949359109
            ],
            [
              -52.43501013824885,
              -29.20010417314562
            ],
            [
              -52.43550107526882,
              -29.20250520277369
            ],
            [
              -52.43817395459976,
              -29.206298829586046
            ],
            [
              -52.43779211469534,
              -29.207307262029836
            ],
            [
              -52.43381006997781,
              -29.207883509140576
            ],
            [
              -52.43479194401775,
              -29.210620682916577
            ],
            [
              -52.436373852193206,
              -29.21398212439588
            ],
            [
              -52.437192080559825,
              -29.21647919520908
            ],
            [
              -52.43948311998635,
              -29.218784183652026
            ],
            [
              -52.438883085850826,
              -29.220993130909854
            ],
            [
              -52.4393740228708,
              -29.222385728094135
            ],
            [
              -52.43779211469534,
              -29.224210510611474
            ],
            [
              -52.438883085850826,
              -29.225507066610632
            ],
            [
              -52.4393740228708,
              -29.22939673460811
            ],
            [
              -52.44237419354839,
              -29.230597249422146
            ],
            [
              -52.442592387779484,
              -29.231893805421308
            ],
            [
              -52.44439249018604,
              -29.23299827905022
            ],
            [
              -52.45061102577232,
              -29.234823061567557
            ],
            [
              -52.4563931728964,
              -29.240297409119563
            ],
            [
              -52.45781143539853,
              -29.240489491489807
            ],
            [
              -52.462611708482676,
              -29.238376585417104
            ],
            [
              -52.46408451954258,
              -29.236695864677454
            ],
            [
              -52.466702850315755,
              -29.238088461861736
            ],
            [
              -52.47352142003755,
              -29.23890481193528
            ],
            [
              -52.47832169312169,
              -29.23852064719479
            ],
            [
              -52.48099457245264,
              -29.237080029417946
            ],
            [
              -52.481103669568185,
              -29.2454836331162
            ],
            [
              -52.485194811401264,
              -29.244715303635218
            ],
            [
              -52.48917685611879,
              -29.24557967430132
            ],
            [
              -52.49577723160949,
              -29.243898953561672
            ],
            [
              -52.499104693633726,
              -29.247212374448413
            ],
            [
              -52.50101389315583,
              -29.247308415633537
            ],
            [
              -52.50717788018433,
              -29.242602397562514
            ],
            [
              -52.51252363884622,
              -29.24178604748897
            ],
            [
              -52.51530561529271,
              -29.23818450304686
            ],
            [
              -52.519614951356886,
              -29.23568743223366
            ],
            [
              -52.52032408260796,
              -29.233718587938643
            ],
            [
              -52.51699662058372,
              -29.22939673460811
            ],
            [
              -52.517105717699266,
              -29.22838830216432
            ],
            [
              -52.52310605905445,
              -29.2264194578693
            ],
            [
              -52.524087933094386,
              -29.225411025425508
            ],
            [
              -52.52632442396313,
              -29.21921636898508
            ],
            [
              -52.535597678784775,
              -29.224498634166842
            ],
            [
              -52.540125209080045,
              -29.22349020172305
            ],
            [
              -52.54650739033965,
              -29.22411446942635
            ],
            [
              -52.55048943505718,
              -29.223009995797437
            ],
            [
              -52.553216862945895,
              -29.22349020172305
            ],
            [
              -52.55872626728111,
              -29.21988865728094
            ],
            [
              -52.55998088410992,
              -29.22310603698256
            ],
            [
              -52.5612900494965,
              -29.22320207816768
            ],
            [
              -52.56369018603857,
              -29.2218094809834
            ],
            [
              -52.565981225465094,
              -29.224018428241227
            ],
            [
              -52.567999522102745,
              -29.224210510611474
            ],
            [
              -52.571217887011436,
              -29.226083313721368
            ],
            [
              -52.57678183990442,
              -29.224882798907334
            ],
            [
              -52.57710913125107,
              -29.227523931498215
            ],
            [
              -52.58010930192866,
              -29.228292260979195
            ],
            [
              -52.591291756272405,
              -29.224594675351963
            ],
            [
              -52.5915099505035,
              -29.22339416053793
            ],
            [
              -52.586491483188254,
              -29.217583668837992
            ],
            [
              -52.58910981396143,
              -29.21748762765287
            ],
            [
              -52.592600921658985,
              -29.215806906913215
            ],
            [
              -52.59560109233658,
              -29.21590294809834
            ],
            [
              -52.59838306878307,
              -29.21431826854381
            ],
            [
              -52.59980133128521,
              -29.21590294809834
            ],
            [
              -52.603619730329406,
              -29.216191071653707
            ],
            [
              -52.6047107014849,
              -29.218784183652026
            ],
            [
              -52.60918368322239,
              -29.222289686909015
            ],
            [
              -52.609674620242366,
              -29.225314984240388
            ],
            [
              -52.608201809182454,
              -29.225218943055264
            ],
            [
              -52.61027465437788,
              -29.227812055053583
            ],
            [
              -52.61578405871309,
              -29.228196219794075
            ],
            [
              -52.61660228707971,
              -29.2297808993486
            ],
            [
              -52.61502037890425,
              -29.23030912586678
            ],
            [
              -52.6149112817887,
              -29.231413599495692
            ],
            [
              -52.61851148660181,
              -29.232518073124606
            ],
            [
              -52.61949336064175,
              -29.230789331792394
            ],
            [
              -52.627402901519034,
              -29.22838830216432
            ],
            [
              -52.62718470728793,
              -29.229876940533725
            ],
            [
              -52.630675814985494,
              -29.23069329060727
            ],
            [
              -52.63400327700973,
              -29.2264194578693
            ],
            [
              -52.635203345280765,
              -29.23170172305106
            ],
            [
              -52.638421710189455,
              -29.232806196679974
            ],
            [
              -52.64038545826933,
              -29.23467899978987
            ],
            [
              -52.642076463560336,
              -29.233718587938643
            ],
            [
              -52.6476949650111,
              -29.23362254675352
            ],
            [
              -52.64802225635774,
              -29.23271015549485
            ],
            [
              -52.64567666837344,
              -29.231509640680816
            ],
            [
              -52.649604164533194,
              -29.22838830216432
            ],
            [
              -52.650695135688686,
              -29.228580384534567
            ],
            [
              -52.65020419866872,
              -29.230597249422146
            ],
            [
              -52.650695135688686,
              -29.231893805421308
            ],
            [
              -52.65347711213518,
              -29.23069329060727
            ],
            [
              -52.656477282812766,
              -29.231797764236184
            ],
            [
              -52.65762280252603,
              -29.228676425719687
            ],
            [
              -52.66138665301246,
              -29.227908096238703
            ],
            [
              -52.66242307561017,
              -29.229204652237865
            ],
            [
              -52.66198668714798,
              -29.231893805421308
            ],
            [
              -52.66520505205666,
              -29.2322779701618
            ],
            [
              -52.6666233145588,
              -29.236119617566715
            ],
            [
              -52.67000532514081,
              -29.234582958604747
            ],
            [
              -52.67262365591398,
              -29.233910670308887
            ],
            [
              -52.67398736985834,
              -29.23309432023534
            ],
            [
              -52.674423758320536,
              -29.23587951460391
            ],
            [
              -52.67540563236047,
              -29.23890481193528
            ],
            [
              -52.67420556408943,
              -29.24250635637739
            ],
            [
              -52.67420556408943,
              -29.243610830006304
            ],
            [
              -52.67649660351596,
              -29.24778862155915
            ],
            [
              -52.67720573476703,
              -29.248316848077327
            ],
            [
              -52.67927857996245,
              -29.24702029207817
            ],
            [
              -52.68058774534904,
              -29.247884662744273
            ],
            [
              -52.67922403140468,
              -29.250477774742592
            ],
            [
              -52.67638750640041,
              -29.25201443370456
            ],
            [
              -52.67578747226489,
              -29.253791195629333
            ],
            [
              -52.67998771121352,
              -29.257680863626813
            ],
            [
              -52.68380611025773,
              -29.259793769699517
            ],
            [
              -52.68527892131763,
              -29.261378449254046
            ],
            [
              -52.684787984297664,
              -29.26291510821601
            ],
            [
              -52.686478989588664,
              -29.266708735028367
            ],
            [
              -52.68822454343745,
              -29.266180508510192
            ],
            [
              -52.68887912613074,
              -29.26449978777054
            ],
            [
              -52.68991554872845,
              -29.263395314141626
            ],
            [
              -52.69111561699949,
              -29.261090325698675
            ],
            [
              -52.69280662229049,
              -29.26017793444001
            ],
            [
              -52.69471582181259,
              -29.260706160958183
            ],
            [
              -52.6964068271036,
              -29.262723025845766
            ],
            [
              -52.69902515787677,
              -29.270022155915107
            ],
            [
              -52.69858876941458,
              -29.271894959025005
            ],
            [
              -52.693788496330434,
              -29.271606835469637
            ],
            [
              -52.69302481652159,
              -29.272615267913427
            ],
            [
              -52.69351575354156,
              -29.276120771170415
            ],
            [
              -52.69520675883257,
              -29.27929013027947
            ],
            [
              -52.69520675883257,
              -29.280922830426558
            ],
            [
              -52.69340665642601,
              -29.28188324227779
            ],
            [
              -52.69100651988394,
              -29.285388745534775
            ],
            [
              -52.691279262672815,
              -29.286685301533936
            ],
            [
              -52.69607953575696,
              -29.286589260348812
            ],
            [
              -52.69858876941458,
              -29.287693733977726
            ],
            [
              -52.70098890595665,
              -29.289614557680185
            ],
            [
              -52.704807305000855,
              -29.293600266862786
            ],
            [
              -52.70628011606076,
              -29.292591834418996
            ],
            [
              -52.70688015019628,
              -29.290286845976045
            ],
            [
              -52.70780747567844,
              -29.28879820760664
            ],
            [
              -52.71031670933606,
              -29.287693733977726
            ],
            [
              -52.71538972520908,
              -29.288990289976887
            ],
            [
              -52.715498822324626,
              -29.29047892834629
            ],
            [
              -52.71331688001366,
              -29.292975999159488
            ],
            [
              -52.71282594299369,
              -29.295184946417315
            ],
            [
              -52.71402601126472,
              -29.295905255305737
            ],
            [
              -52.71528062809353,
              -29.295521090565245
            ],
            [
              -52.71680798771121,
              -29.292591834418996
            ],
            [
              -52.71909902713774,
              -29.292015587308256
            ],
            [
              -52.72220829493088,
              -29.29239975204875
            ],
            [
              -52.7264085338795,
              -29.29110319604959
            ],
            [
              -52.728590476190476,
              -29.29110319604959
            ],
            [
              -52.73011783580816,
              -29.291823504938012
            ],
            [
              -52.72880867042157,
              -29.296577543601597
            ],
            [
              -52.727826796381635,
              -29.29700972893465
            ],
            [
              -52.724608431472944,
              -29.295905255305737
            ],
            [
              -52.722808329066396,
              -29.29571317293549
            ],
            [
              -52.720790032428745,
              -29.29638546123135
            ],
            [
              -52.720026352619904,
              -29.298114202563564
            ],
            [
              -52.720790032428745,
              -29.299410758562722
            ],
            [
              -52.72111732377539,
              -29.301091479302375
            ],
            [
              -52.72051728963987,
              -29.30219595293129
            ],
            [
              -52.716698890595666,
              -29.302388035301533
            ],
            [
              -52.71320778289811,
              -29.303300426560202
            ],
            [
              -52.71102584058713,
              -29.304308859003992
            ],
            [
              -52.709607578085,
              -29.305797497373398
            ],
            [
              -52.70998941798942,
              -29.30690197100231
            ],
            [
              -52.711407680491554,
              -29.307478218113047
            ],
            [
              -52.71391691414917,
              -29.306805929817187
            ],
            [
              -52.71680798771121,
              -29.305413332632906
            ],
            [
              -52.71871718723332,
              -29.305701456188274
            ],
            [
              -52.71942631848438,
              -29.306998012187435
            ],
            [
              -52.719208124253285,
              -29.30911091826014
            ],
            [
              -52.72018999829322,
              -29.311896112628702
            ],
            [
              -52.72422659156853,
              -29.315977862996426
            ],
            [
              -52.72389930022188,
              -29.31770660432864
            ],
            [
              -52.720790032428745,
              -29.318186810254254
            ],
            [
              -52.71898993002219,
              -29.31938732506829
            ],
            [
              -52.71898993002219,
              -29.320779922252573
            ],
            [
              -52.719917255504356,
              -29.321500231140995
            ],
            [
              -52.72340836320191,
              -29.319483366253415
            ],
            [
              -52.7244993343574,
              -29.31938732506829
            ],
            [
              -52.7266267281106,
              -29.320203675141837
            ],
            [
              -52.72749950503499,
              -29.321692313511242
            ],
            [
              -52.727390407919444,
              -29.32399730195419
            ],
            [
              -52.72760860215054,
              -29.327694887581423
            ],
            [
              -52.7283177334016,
              -29.3282231140996
            ],
            [
              -52.73120880696364,
              -29.327598846396302
            ],
            [
              -52.732681618023555,
              -29.328703320025216
            ],
            [
              -52.732299778119135,
              -29.330384040764866
            ],
            [
              -52.72919051032599,
              -29.334897976465644
            ],
            [
              -52.7283177334016,
              -29.337923273797017
            ],
            [
              -52.72842683051715,
              -29.341188674091196
            ],
            [
              -52.72962689878819,
              -29.342581271275478
            ],
            [
              -52.73169974398362,
              -29.34229314772011
            ],
            [
              -52.73382713773682,
              -29.3393158709813
            ],
            [
              -52.73660911418331,
              -29.336290573649926
            ],
            [
              -52.73977293053422,
              -29.334513811725152
            ],
            [
              -52.74080935313194,
              -29.336002450094558
            ],
            [
              -52.740972998805255,
              -29.340276282832527
            ],
            [
              -52.741518484383,
              -29.342485230090354
            ],
            [
              -52.74119119303636,
              -29.34469417734818
            ],
            [
              -52.74037296466974,
              -29.345510527421727
            ],
            [
              -52.737209148318826,
              -29.346086774532463
            ],
            [
              -52.73502720600785,
              -29.347815515864678
            ],
            [
              -52.73420897764124,
              -29.34920811304896
            ],
            [
              -52.735190851681175,
              -29.35021654549275
            ],
            [
              -52.73628182283666,
              -29.349976442529943
            ],
            [
              -52.73911834784093,
              -29.348487804160538
            ],
            [
              -52.74070025601639,
              -29.34829572179029
            ],
            [
              -52.74157303294078,
              -29.34959227778945
            ],
            [
              -52.7410820959208,
              -29.353914131119982
            ],
            [
              -52.74140938726745,
              -29.355594851859635
            ],
            [
              -52.743318586789556,
              -29.359004313931496
            ],
            [
              -52.742991295442906,
              -29.361789508300063
            ],
            [
              -52.74348223246288,
              -29.365198970371928
            ],
            [
              -52.744573203618366,
              -29.3676
            ],
            [
              -52.74610056323605,
              -29.367407917629755
            ],
            [
              -52.7476824714115,
              -29.365102929186804
            ],
            [
              -52.74970076804915,
              -29.363518249632275
            ],
            [
              -52.75090083632019,
              -29.36342220844715
            ],
            [
              -52.75417374978665,
              -29.364190537928135
            ],
            [
              -52.75510107526882,
              -29.36308606429922
            ],
            [
              -52.757283017579795,
              -29.3629900231141
            ],
            [
              -52.75848308585083,
              -29.364478661483503
            ],
            [
              -52.759792251237414,
              -29.364094496743014
            ],
            [
              -52.76050138248848,
              -29.3629900231141
            ],
            [
              -52.76050138248848,
              -29.360588993486026
            ],
            [
              -52.76328335893497,
              -29.36001274637529
            ],
            [
              -52.764701621437105,
              -29.35751567556209
            ],
            [
              -52.76781088923025,
              -29.35669932548855
            ],
            [
              -52.76928370029015,
              -29.355210687119143
            ],
            [
              -52.771192899812256,
              -29.355306728304264
            ],
            [
              -52.77179293394777,
              -29.35410621349023
            ],
            [
              -52.7759931728964,
              -29.351705183862155
            ],
            [
              -52.77828421232292,
              -29.352905698676192
            ],
            [
              -52.78052070319167,
              -29.351993307417523
            ],
            [
              -52.77970247482506,
              -29.348823948308468
            ],
            [
              -52.77839330943847,
              -29.347911557049798
            ],
            [
              -52.77850240655402,
              -29.346422918680396
            ],
            [
              -52.77670230414746,
              -29.345990733347342
            ],
            [
              -52.7779023724185,
              -29.343781786089515
            ],
            [
              -52.77937518347841,
              -29.342485230090354
            ],
            [
              -52.780193411845026,
              -29.343397621349023
            ],
            [
              -52.78150257723161,
              -29.34301345660853
            ],
            [
              -52.78221170848268,
              -29.34171690060937
            ],
            [
              -52.78128438300051,
              -29.340516385795336
            ],
            [
              -52.78537552483359,
              -29.336578697205294
            ],
            [
              -52.78570281618023,
              -29.33571432653919
            ],
            [
              -52.78788475849121,
              -29.336194532464802
            ],
            [
              -52.788102952722305,
              -29.335186100021012
            ],
            [
              -52.792194094555384,
              -29.332304864467325
            ],
            [
              -52.79481242532856,
              -29.329999876024374
            ],
            [
              -52.796176139272916,
              -29.329519670098758
            ],
            [
              -52.796176139272916,
              -29.32731072284093
            ],
            [
              -52.797812596006146,
              -29.328319155284724
            ],
            [
              -52.79819443591057,
              -29.330287999579742
            ],
            [
              -52.80010363543267,
              -29.331008308468164
            ],
            [
              -52.80348564601468,
              -29.329519670098758
            ],
            [
              -52.80212193207032,
              -29.326782496322757
            ],
            [
              -52.80250377197474,
              -29.32529385795335
            ],
            [
              -52.804085680150195,
              -29.32390126076907
            ],
            [
              -52.808176821983274,
              -29.323805219583946
            ],
            [
              -52.80997692438983,
              -29.32159627232612
            ],
            [
              -52.80992237583205,
              -29.319291283883167
            ],
            [
              -52.81248615804745,
              -29.31708233662534
            ],
            [
              -52.815977265745005,
              -29.315881821811303
            ],
            [
              -52.82050479604028,
              -29.316314007144356
            ],
            [
              -52.82268673835125,
              -29.319483366253415
            ],
            [
              -52.82432319508449,
              -29.325389899138475
            ],
            [
              -52.82448684075781,
              -29.32750280521118
            ],
            [
              -52.83097811913296,
              -29.32731072284093
            ],
            [
              -52.83168725038402,
              -29.3282231140996
            ],
            [
              -52.83381464413723,
              -29.32788696995167
            ],
            [
              -52.83457832394607,
              -29.32630229039714
            ],
            [
              -52.83730575183478,
              -29.325822084471525
            ],
            [
              -52.840415019627926,
              -29.328607278840092
            ],
            [
              -52.84161508789896,
              -29.32851123765497
            ],
            [
              -52.84477890424987,
              -29.324093343139314
            ],
            [
              -52.84679720088752,
              -29.3229888695104
            ],
            [
              -52.849524628776244,
              -29.320779922252573
            ],
            [
              -52.8513247311828,
              -29.320491798697205
            ],
            [
              -52.85312483358935,
              -29.31938732506829
            ],
            [
              -52.85541587301587,
              -29.320107633956713
            ],
            [
              -52.85579771292029,
              -29.321884395881487
            ],
            [
              -52.85710687830688,
              -29.32159627232612
            ],
            [
              -52.857706912442396,
              -29.32001159277159
            ],
            [
              -52.85721597542243,
              -29.31770660432864
            ],
            [
              -52.85797965523127,
              -29.31732243958815
            ],
            [
              -52.860216146100015,
              -29.317802645513762
            ],
            [
              -52.863816350913126,
              -29.31972346921622
            ],
            [
              -52.867525652841785,
              -29.321020025215383
            ],
            [
              -52.86932575524833,
              -29.32039575751208
            ],
            [
              -52.869925789383856,
              -29.321116066400503
            ],
            [
              -52.872107731694825,
              -29.321788354696363
            ],
            [
              -52.87319870285032,
              -29.32039575751208
            ],
            [
              -52.874726062468,
              -29.31972346921622
            ],
            [
              -52.875326096603516,
              -29.32058783988233
            ],
            [
              -52.877780781703365,
              -29.32130814877075
            ],
            [
              -52.879417238436595,
              -29.321212107585627
            ],
            [
              -52.87952633555214,
              -29.319819510401345
            ],
            [
              -52.88399931728964,
              -29.3183788926245
            ],
            [
              -52.884817545656254,
              -29.316890254255096
            ],
            [
              -52.88629035671617,
              -29.315977862996426
            ],
            [
              -52.888417750469365,
              -29.31568973944106
            ],
            [
              -52.88858139614268,
              -29.31708233662534
            ],
            [
              -52.88989056152927,
              -29.319483366253415
            ],
            [
              -52.89098153268476,
              -29.319579407438535
            ],
            [
              -52.892508892302445,
              -29.318282851439378
            ],
            [
              -52.89518177163338,
              -29.318282851439378
            ],
            [
              -52.89687277692439,
              -29.31669817188485
            ],
            [
              -52.89889107356204,
              -29.315785780626182
            ],
            [
              -52.89561816009558,
              -29.313912977516285
            ],
            [
              -52.891799761051374,
              -29.313000586257616
            ],
            [
              -52.89098153268476,
              -29.31180007144358
            ],
            [
              -52.89141792114695,
              -29.309879247741122
            ],
            [
              -52.89109062980031,
              -29.308294568186593
            ],
            [
              -52.88901778460488,
              -29.306085620928766
            ],
            [
              -52.88258105478751,
              -29.300899396932127
            ],
            [
              -52.885526676907325,
              -29.298594408489176
            ],
            [
              -52.88759952210275,
              -29.297489934860263
            ],
            [
              -52.88852684758491,
              -29.29561713175037
            ],
            [
              -52.8879268134494,
              -29.2947047404917
            ],
            [
              -52.886017613927294,
              -29.294608699306576
            ],
            [
              -52.88672674517836,
              -29.290911113679343
            ],
            [
              -52.886017613927294,
              -29.288221960495903
            ],
            [
              -52.88650855094726,
              -29.28678134271906
            ],
            [
              -52.886017613927294,
              -29.285100621979407
            ],
            [
              -52.88912688172043,
              -29.283419901239757
            ],
            [
              -52.891308824031405,
              -29.281018871611682
            ],
            [
              -52.89299982932241,
              -29.279722315612524
            ],
            [
              -52.89561816009558,
              -29.273911823912588
            ],
            [
              -52.894581737497866,
              -29.272807350283674
            ],
            [
              -52.89310892643796,
              -29.272183082580373
            ],
            [
              -52.896272742788874,
              -29.267717167472156
            ],
            [
              -52.89638183990442,
              -29.266180508510192
            ],
            [
              -52.89518177163338,
              -29.26507603488128
            ],
            [
              -52.891308824031405,
              -29.26320323177138
            ],
            [
              -52.88918143027821,
              -29.263395314141626
            ],
            [
              -52.886017613927294,
              -29.26291510821601
            ],
            [
              -52.88579941969619,
              -29.260418037402815
            ],
            [
              -52.8849266427718,
              -29.25758482244169
            ],
            [
              -52.88449025430961,
              -29.255423895776424
            ],
            [
              -52.885526676907325,
              -29.249997568816976
            ],
            [
              -52.88672674517836,
              -29.249277259928554
            ],
            [
              -52.888417750469365,
              -29.249181218743434
            ],
            [
              -52.89119972691586,
              -29.246396024374867
            ],
            [
              -52.892508892302445,
              -29.245387591931078
            ],
            [
              -52.89021785287592,
              -29.241690006303845
            ],
            [
              -52.88978146441372,
              -29.2368879470477
            ],
            [
              -52.89299982932241,
              -29.232085887791552
            ],
            [
              -52.89392715480457,
              -29.232181928976676
            ],
            [
              -52.89610909711555,
              -29.234823061567557
            ],
            [
              -52.89900017067759,
              -29.23467899978987
            ],
            [
              -52.89981839904421,
              -29.232181928976676
            ],
            [
              -52.89850923365762,
              -29.229012569867617
            ],
            [
              -52.89921836490869,
              -29.22810017860895
            ],
            [
              -52.89900017067759,
              -29.225507066610632
            ],
            [
              -52.89938201058201,
              -29.223586242908173
            ],
            [
              -52.89850923365762,
              -29.22320207816768
            ],
            [
              -52.89818194231098,
              -29.220416883799118
            ],
            [
              -52.89730916538659,
              -29.217679710023113
            ],
            [
              -52.897472811059906,
              -29.21561482454297
            ],
            [
              -52.89561816009558,
              -29.21330983610002
            ],
            [
              -52.893818057689025,
              -29.213213794914896
            ],
            [
              -52.88530848267622,
              -29.209276106324857
            ],
            [
              -52.88449025430961,
              -29.20831569447363
            ],
            [
              -52.88378112305854,
              -29.20572258247531
            ],
            [
              -52.886017613927294,
              -29.2054824795125
            ],
            [
              -52.88819955623826,
              -29.206106747215802
            ],
            [
              -52.89272708653354,
              -29.2014967703299
            ],
            [
              -52.89589090288445,
              -29.201976976255516
            ],
            [
              -52.89610909711555,
              -29.20288936751418
            ],
            [
              -52.894690834613414,
              -29.204185923513343
            ],
            [
              -52.896218194231096,
              -29.205578520697625
            ],
            [
              -52.897581908175454,
              -29.20500227358689
            ],
            [
              -52.898672879330945,
              -29.206586953141414
            ],
            [
              -52.90347315241509,
              -29.20288936751418
            ],
            [
              -52.90538235193719,
              -29.202313120403446
            ],
            [
              -52.90718245434375,
              -29.202985408699305
            ],
            [
              -52.90947349377027,
              -29.198087308258035
            ],
            [
              -52.90718245434375,
              -29.196694711073754
            ],
            [
              -52.9070733572282,
              -29.19491794914898
            ],
            [
              -52.904782317801676,
              -29.192709001891153
            ],
            [
              -52.90390954087728,
              -29.188195066190374
            ],
            [
              -52.906418774534906,
              -29.189299539819288
            ],
            [
              -52.91007352790579,
              -29.19251691952091
            ],
            [
              -52.91438286396996,
              -29.192709001891153
            ],
            [
              -52.91607386926097,
              -29.1922768165581
            ],
            [
              -52.91809216589862,
              -29.19001984870771
            ],
            [
              -52.91700119474313,
              -29.18709059256146
            ],
            [
              -52.91721938897423,
              -29.18540987182181
            ],
            [
              -52.919183137054105,
              -29.183393006934228
            ],
            [
              -52.92321973032941,
              -29.18468956293339
            ],
            [
              -52.92649264379587,
              -29.184209357007774
            ],
            [
              -52.92681993514252,
              -29.18171228619458
            ],
            [
              -52.92998375149343,
              -29.180991977306157
            ],
            [
              -52.93298392217102,
              -29.179695421306995
            ],
            [
              -52.933583956306535,
              -29.17859094767808
            ],
            [
              -52.93549315582864,
              -29.178398865307837
            ],
            [
              -52.93942065198839,
              -29.177006268123556
            ],
            [
              -52.94100256016385,
              -29.1771983504938
            ],
            [
              -52.94187533708824,
              -29.176285959235134
            ],
            [
              -52.94602102747909,
              -29.176093876864886
            ],
            [
              -52.94760293565455,
              -29.176622103383064
            ],
            [
              -52.949075746714456,
              -29.174989403235973
            ],
            [
              -52.949021198156686,
              -29.17359680605169
            ],
            [
              -52.95098494623656,
              -29.172492332422777
            ],
            [
              -52.951203140467655,
              -29.171579941164108
            ],
            [
              -52.95382147124083,
              -29.17028338516495
            ],
            [
              -52.95420331114525,
              -29.16769027316663
            ],
            [
              -52.95660344768732,
              -29.166489758352593
            ],
            [
              -52.957312578938385,
              -29.164184769909646
            ],
            [
              -52.959276327018266,
              -29.163608522798906
            ],
            [
              -52.95922177846049,
              -29.161879781466695
            ],
            [
              -52.96080368663594,
              -29.160487184282413
            ],
            [
              -52.96118552654036,
              -29.15640543391469
            ],
            [
              -52.963912954429084,
              -29.156021269174197
            ],
            [
              -52.963912954429084,
              -29.154388569027105
            ],
            [
              -52.965876702508965,
              -29.15347617776844
            ],
            [
              -52.966804027991124,
              -29.154676692582473
            ],
            [
              -52.967185867895545,
              -29.15678959865518
            ],
            [
              -52.96860413039768,
              -29.157701989913846
            ],
            [
              -52.972095238095235,
              -29.15707772221055
            ],
            [
              -52.973295306366275,
              -29.158086154654338
            ],
            [
              -52.97351350059737,
              -29.15981489598655
            ],
            [
              -52.97542270011947,
              -29.15971885480143
            ],
            [
              -52.976895511179386,
              -29.158422298802268
            ],
            [
              -52.98120484724356,
              -29.15650147509981
            ],
            [
              -52.98300494965011,
              -29.157990113469214
            ],
            [
              -52.986823348694315,
              -29.1568856398403
            ],
            [
              -52.98687789725209,
              -29.15549304265602
            ],
            [
              -52.98589602321215,
              -29.152995971842824
            ],
            [
              -52.986386960232124,
              -29.15150733347342
            ],
            [
              -52.9857869260966,
              -29.14771370666106
            ],
            [
              -52.98747793138761,
              -29.144496326959445
            ],
            [
              -52.98829615975423,
              -29.142287379701617
            ],
            [
              -52.99031445639188,
              -29.1436799768859
            ],
            [
              -52.99102358764294,
              -29.145120594662743
            ],
            [
              -52.993423724185014,
              -29.144784450514813
            ],
            [
              -52.99647844342038,
              -29.144880491699936
            ],
            [
              -52.99838764294248,
              -29.142191338516493
            ],
            [
              -52.99849674005803,
              -29.140702700147088
            ],
            [
              -52.99947861409797,
              -29.13902197940744
            ],
            [
              -53.00231513910224,
              -29.1378214645934
            ],
            [
              -53.004824372759856,
              -29.13710115570498
            ],
            [
              -53.00809728622632,
              -29.13810958814877
            ],
            [
              -53.00880641747739,
              -29.138877917629753
            ],
            [
              -53.01049742276839,
              -29.13849375288926
            ],
            [
              -53.011806588154975,
              -29.13902197940744
            ],
            [
              -53.01109745690391,
              -29.142191338516493
            ],
            [
              -53.01158839392388,
              -29.144208203404077
            ],
            [
              -53.01087926267281,
              -29.14598496532885
            ],
            [
              -53.00662447516641,
              -29.147089438957764
            ],
            [
              -53.00509711554873,
              -29.1482899537718
            ],
            [
              -53.00629718381977,
              -29.15049890102963
            ],
            [
              -53.00831548045742,
              -29.152611807102332
            ],
            [
              -53.00842457757297,
              -29.154004404286614
            ],
            [
              -53.01371578767708,
              -29.15587720739651
            ],
            [
              -53.016825055470214,
              -29.155685125026267
            ],
            [
              -53.017916026625706,
              -29.157990113469214
            ],
            [
              -53.019225192012286,
              -29.158710422357636
            ],
            [
              -53.0242982078853,
              -29.157701989913846
            ],
            [
              -53.027025635774024,
              -29.1568856398403
            ],
            [
              -53.02849844683393,
              -29.156981681025425
            ],
            [
              -53.03051674347158,
              -29.15520491910065
            ],
            [
              -53.03411694828469,
              -29.153092013027948
            ],
            [
              -53.036080696364564,
              -29.15448461021223
            ],
            [
              -53.036026147806794,
              -29.157605948728722
            ],
            [
              -53.03548066222905,
              -29.16010301954192
            ],
            [
              -53.03629889059567,
              -29.160583225467533
            ],
            [
              -53.03902631848438,
              -29.160679266652657
            ],
            [
              -53.041317357910906,
              -29.163080296280732
            ],
            [
              -53.04349930022188,
              -29.16332039924354
            ],
            [
              -53.04649947089947,
              -29.16231196679975
            ],
            [
              -53.05091790407919,
              -29.16269613154024
            ],
            [
              -53.052827103601295,
              -29.1621198844295
            ],
            [
              -53.05309984639017,
              -29.16111145198571
            ],
            [
              -53.05108154975252,
              -29.157990113469214
            ],
            [
              -53.051190646868065,
              -29.156981681025425
            ],
            [
              -53.05271800648575,
              -29.15611731035932
            ],
            [
              -53.054899948796724,
              -29.15621335154444
            ],
            [
              -53.05757282812767,
              -29.15741386635848
            ],
            [
              -53.061009387267454,
              -29.156021269174197
            ],
            [
              -53.06319132957843,
              -29.15779803109897
            ],
            [
              -53.06439139784946,
              -29.160295101912165
            ],
            [
              -53.06297313534733,
              -29.160919369615463
            ],
            [
              -53.05910018774535,
              -29.167402149611263
            ],
            [
              -53.058118313705414,
              -29.169803179239334
            ],
            [
              -53.060572998805256,
              -29.175421588569026
            ],
            [
              -53.0587728963987,
              -29.17791865938222
            ],
            [
              -53.05659095408773,
              -29.179887503677243
            ],
            [
              -53.05757282812767,
              -29.180991977306157
            ],
            [
              -53.063900460829494,
              -29.181808327379702
            ],
            [
              -53.066791534391534,
              -29.180607812565665
            ],
            [
              -53.072519132957844,
              -29.1778226181971
            ],
            [
              -53.071319064686804,
              -29.1725883736079
            ],
            [
              -53.06908257381806,
              -29.170715570498004
            ],
            [
              -53.06897347670251,
              -29.169178911536036
            ],
            [
              -53.07311916709336,
              -29.165577367093928
            ],
            [
              -53.078192182966376,
              -29.163896646354274
            ],
            [
              -53.07950134835296,
              -29.161879781466695
            ],
            [
              -53.08288335893497,
              -29.16139957554108
            ],
            [
              -53.08408342720601,
              -29.156021269174197
            ],
            [
              -53.08659266086363,
              -29.155781166211387
            ],
            [
              -53.088392763270186,
              -29.154580651397353
            ],
            [
              -53.08861095750128,
              -29.151315251103174
            ],
            [
              -53.09150203106332,
              -29.150018695104013
            ],
            [
              -53.09079289981226,
              -29.1482899537718
            ],
            [
              -53.091283836832226,
              -29.14728152132801
            ],
            [
              -53.09412036183649,
              -29.14761766547594
            ],
            [
              -53.0955931728964,
              -29.146801315402396
            ],
            [
              -53.095374978665305,
              -29.144880491699936
            ],
            [
              -53.09412036183649,
              -29.142815606219795
            ],
            [
              -53.09428400750981,
              -29.139886350073546
            ],
            [
              -53.0977205666496,
              -29.13902197940744
            ],
            [
              -53.09941157194061,
              -29.141182906072704
            ],
            [
              -53.107321112817885,
              -29.14459236814457
            ],
            [
              -53.11097586618877,
              -29.145504759403234
            ],
            [
              -53.113812391193036,
              -29.14790578903131
            ],
            [
              -53.11512155657962,
              -29.148001830216433
            ],
            [
              -53.117576241679465,
              -29.145408718218114
            ],
            [
              -53.11861266427718,
              -29.146081006513974
            ],
            [
              -53.12188557774364,
              -29.14497653288506
            ],
            [
              -53.12259470899471,
              -29.146801315402396
            ],
            [
              -53.126904045058886,
              -29.145216635847866
            ],
            [
              -53.1277222734255,
              -29.143776018071023
            ],
            [
              -53.13012240996757,
              -29.14339185333053
            ],
            [
              -53.13050424987199,
              -29.141807173776
            ],
            [
              -53.13241344939409,
              -29.140702700147088
            ],
            [
              -53.13508632872504,
              -29.136284805631433
            ],
            [
              -53.13797740228708,
              -29.134604084891784
            ],
            [
              -53.1385774364226,
              -29.13311544652238
            ],
            [
              -53.14141396142686,
              -29.130810458079427
            ],
            [
              -53.14719610855095,
              -29.12999410800588
            ],
            [
              -53.1509054104796,
              -29.13181889052322
            ],
            [
              -53.15597842635262,
              -29.132395137633956
            ],
            [
              -53.156196620583714,
              -29.13349961126287
            ],
            [
              -53.15897859703021,
              -29.135708558520697
            ],
            [
              -53.16372432155658,
              -29.137197196890103
            ],
            [
              -53.169997405700634,
              -29.133211487707502
            ],
            [
              -53.17299757637822,
              -29.133019405337254
            ],
            [
              -53.17610684417136,
              -29.131482746375287
            ],
            [
              -53.18330725379758,
              -29.13181889052322
            ],
            [
              -53.18608923024407,
              -29.130282231561253
            ],
            [
              -53.188380269670596,
              -29.13249117881908
            ],
            [
              -53.18958033794163,
              -29.130714416894307
            ],
            [
              -53.19078040621267,
              -29.13052233452406
            ],
            [
              -53.19110769755931,
              -29.133211487707502
            ],
            [
              -53.19230776583035,
              -29.1325872200042
            ],
            [
              -53.19492609660352,
              -29.133691693633114
            ],
            [
              -53.196289810547874,
              -29.13748532044547
            ],
            [
              -53.20229015190306,
              -29.1378214645934
            ],
            [
              -53.2051812254651,
              -29.137005114519855
            ],
            [
              -53.208126847584914,
              -29.139982391258666
            ],
            [
              -53.21358170336235,
              -29.136284805631433
            ],
            [
              -53.216800068271034,
              -29.135708558520697
            ],
            [
              -53.21887291346646,
              -29.13767740281572
            ],
            [
              -53.22427322068612,
              -29.138301670519017
            ],
            [
              -53.235182932240996,
              -29.14142300903551
            ],
            [
              -53.23671029185868,
              -29.141182906072704
            ],
            [
              -53.24041959378734,
              -29.137917505778525
            ],
            [
              -53.25302031063321,
              -29.13609272326119
            ],
            [
              -53.25460221880867,
              -29.136284805631433
            ],
            [
              -53.25847516641065,
              -29.13940614414793
            ],
            [
              -53.26011162314388,
              -29.143295812145407
            ],
            [
              -53.261420788530465,
              -29.1443042445892
            ],
            [
              -53.26327543949479,
              -29.143487894515655
            ],
            [
              -53.26720293565455,
              -29.139886350073546
            ],
            [
              -53.26851210104113,
              -29.139502185333054
            ],
            [
              -53.26987581498549,
              -29.14041457659172
            ],
            [
              -53.27227595152756,
              -29.142815606219795
            ],
            [
              -53.27587615634067,
              -29.145696841773482
            ],
            [
              -53.27762171018945,
              -29.145120594662743
            ],
            [
              -53.27860358422939,
              -29.143487894515655
            ],
            [
              -53.27871268134494,
              -29.131386705190167
            ],
            [
              -53.28122191500256,
              -29.128793593191848
            ],
            [
              -53.28242198327359,
              -29.12932181971002
            ],
            [
              -53.28400389144905,
              -29.132923364152134
            ],
            [
              -53.28591309097116,
              -29.13518033200252
            ],
            [
              -53.286785867895546,
              -29.13551647615045
            ],
            [
              -53.29278620925073,
              -29.132683261189324
            ],
            [
              -53.2932771462707,
              -29.131482746375287
            ],
            [
              -53.29022242703533,
              -29.128409428451356
            ],
            [
              -53.29022242703533,
              -29.127785160748054
            ],
            [
              -53.29491360300393,
              -29.12620048119353
            ],
            [
              -53.299113841952554,
              -29.126296522378652
            ],
            [
              -53.300423007339134,
              -29.12898567556209
            ],
            [
              -53.301513978494626,
              -29.13018619037613
            ],
            [
              -53.303695920805595,
              -29.128793593191848
            ],
            [
              -53.307787062638674,
              -29.128121304895988
            ],
            [
              -53.30947806792968,
              -29.128697552006724
            ],
            [
              -53.31187820447175,
              -29.13210701407859
            ],
            [
              -53.31291462706947,
              -29.13210701407859
            ],
            [
              -53.31569660351596,
              -29.12989806682076
            ],
            [
              -53.31760580303806,
              -29.12898567556209
            ],
            [
              -53.32469711554873,
              -29.129609943265393
            ],
            [
              -53.327424543437445,
              -29.12917775793234
            ],
            [
              -53.33211571940604,
              -29.128217346081108
            ],
            [
              -53.33751602662571,
              -29.12360736919521
            ],
            [
              -53.34122532855436,
              -29.122118730825804
            ],
            [
              -53.343025430960914,
              -29.120389989493592
            ],
            [
              -53.344989179040795,
              -29.11928551586468
            ],
            [
              -53.34848028673835,
              -29.118517186383695
            ],
            [
              -53.349898549240486,
              -29.11611615675562
            ],
            [
              -53.348698480969446,
              -29.113282941794495
            ],
            [
              -53.350389486260454,
              -29.11150617986972
            ],
            [
              -53.352789622802526,
              -29.1135230447573
            ],
            [
              -53.359008158388804,
              -29.117988959865517
            ],
            [
              -53.35638982761564,
              -29.12620048119353
            ],
            [
              -53.35469882232463,
              -29.128121304895988
            ],
            [
              -53.35638982761564,
              -29.12917775793234
            ],
            [
              -53.35960819252432,
              -29.12951390208027
            ],
            [
              -53.36129919781533,
              -29.128697552006724
            ],
            [
              -53.36669950503499,
              -29.122118730825804
            ],
            [
              -53.37280894350572,
              -29.121398421937382
            ],
            [
              -53.38017299880526,
              -29.122118730825804
            ],
            [
              -53.38410049496501,
              -29.123511328010085
            ],
            [
              -53.38579150025602,
              -29.123703410380333
            ],
            [
              -53.38988264208909,
              -29.122791019121664
            ],
            [
              -53.391300904591226,
              -29.121110298382014
            ],
            [
              -53.3937010411333,
              -29.118997392309307
            ],
            [
              -53.40051961085509,
              -29.11770083631015
            ],
            [
              -53.40248335893497,
              -29.118181042235765
            ],
            [
              -53.40537443249701,
              -29.120197907123345
            ],
            [
              -53.40761092336576,
              -29.118901351124187
            ],
            [
              -53.4085927974057,
              -29.112322529943263
            ],
            [
              -53.413011230585425,
              -29.1082888001681
            ],
            [
              -53.41399310462536,
              -29.10588777054003
            ],
            [
              -53.418411537805085,
              -29.104783296911116
            ],
            [
              -53.42517555896911,
              -29.098588640470687
            ],
            [
              -53.428284826762244,
              -29.098012393359948
            ],
            [
              -53.42910305512886,
              -29.094891054843455
            ],
            [
              -53.42997583205325,
              -29.09498709602858
            ],
            [
              -53.43368513398191,
              -29.097820310989704
            ],
            [
              -53.437121693121696,
              -29.097580208026898
            ],
            [
              -53.43919453831712,
              -29.097003960916158
            ],
            [
              -53.440885543608125,
              -29.095611363731877
            ],
            [
              -53.438485407066054,
              -29.091097428031098
            ],
            [
              -53.44470394265233,
              -29.088792439588147
            ],
            [
              -53.445794913807816,
              -29.0864874511452
            ],
            [
              -53.448795084485404,
              -29.090185036772432
            ],
            [
              -53.45288622631848,
              -29.091385551586466
            ],
            [
              -53.4539226489162,
              -29.092682107585627
            ],
            [
              -53.45550455709165,
              -29.09239398403026
            ],
            [
              -53.455286362860555,
              -29.08850431603278
            ],
            [
              -53.45719556238266,
              -29.08749588358899
            ],
            [
              -53.46117760710019,
              -29.08917660432864
            ],
            [
              -53.46357774364226,
              -29.087784007144357
            ],
            [
              -53.464777811913294,
              -29.086007245219584
            ],
            [
              -53.46161399556238,
              -29.084710689220422
            ],
            [
              -53.46150489844683,
              -29.083414133221265
            ],
            [
              -53.46357774364226,
              -29.081013103593193
            ],
            [
              -53.46379593787336,
              -29.07808384744694
            ],
            [
              -53.46237767537122,
              -29.075922920781675
            ],
            [
              -53.465486943164365,
              -29.0760189619668
            ],
            [
              -53.466414268646524,
              -29.077123435595713
            ],
            [
              -53.466305171530976,
              -29.079092279890734
            ],
            [
              -53.46690520566649,
              -29.082021536036983
            ],
            [
              -53.46832346816863,
              -29.082405700777475
            ],
            [
              -53.46968718211299,
              -29.081781433074173
            ],
            [
              -53.47268735279058,
              -29.079284362260978
            ],
            [
              -53.47159638163509,
              -29.077891765076696
            ],
            [
              -53.47312374125277,
              -29.076883332632907
            ],
            [
              -53.476614848950334,
              -29.076787291447783
            ],
            [
              -53.47792401433692,
              -29.073281788190798
            ],
            [
              -53.48070599078341,
              -29.075778859003993
            ],
            [
              -53.482778835978834,
              -29.072897623450306
            ],
            [
              -53.48490622973203,
              -29.073617932338728
            ],
            [
              -53.486379040791945,
              -29.075106570708133
            ],
            [
              -53.49232483358935,
              -29.074194179449464
            ],
            [
              -53.49439767878478,
              -29.07308970582055
            ],
            [
              -53.49401583888036,
              -29.07049659382223
            ],
            [
              -53.494124935995906,
              -29.066078699306576
            ],
            [
              -53.49521590715139,
              -29.063389546123133
            ],
            [
              -53.49652507253798,
              -29.062813299012397
            ],
            [
              -53.50208902543096,
              -29.064013813826435
            ],
            [
              -53.504380064857486,
              -29.06579057575121
            ],
            [
              -53.50748933265062,
              -29.064397978566927
            ],
            [
              -53.507325686977296,
              -29.063677669678505
            ],
            [
              -53.50481645331968,
              -29.061084557680186
            ],
            [
              -53.50410732206861,
              -29.05829936331162
            ],
            [
              -53.5051982932241,
              -29.05628249842404
            ],
            [
              -53.503125448028676,
              -29.05469781886951
            ],
            [
              -53.50378003072197,
              -29.052584912796807
            ],
            [
              -53.50678020139956,
              -29.053881468795964
            ],
            [
              -53.50928943505718,
              -29.052008665686067
            ],
            [
              -53.50961672640382,
              -29.05008784198361
            ],
            [
              -53.50830756101724,
              -29.048695244799326
            ],
            [
              -53.505689230244066,
              -29.047878894725784
            ],
            [
              -53.504980098993,
              -29.046006091615887
            ],
            [
              -53.50928943505718,
              -29.04130007354486
            ],
            [
              -53.51152592592592,
              -29.03769852910275
            ],
            [
              -53.51130773169483,
              -29.036882179029206
            ],
            [
              -53.509398532172725,
              -29.03529749947468
            ],
            [
              -53.506889298515105,
              -29.034817293549064
            ],
            [
              -53.50748933265062,
              -29.03337667577222
            ],
            [
              -53.508907595152756,
              -29.03280042866148
            ],
            [
              -53.50999856630824,
              -29.031599913847447
            ],
            [
              -53.51419880525687,
              -29.02900680184913
            ],
            [
              -53.51490793650794,
              -29.027614204664847
            ],
            [
              -53.51730807305001,
              -29.02641368985081
            ],
            [
              -53.51828994708995,
              -29.026605772221053
            ],
            [
              -53.51949001536099,
              -29.028190451775583
            ],
            [
              -53.52118102065199,
              -29.028190451775583
            ],
            [
              -53.523308414405186,
              -29.024204742592982
            ],
            [
              -53.5222174432497,
              -29.021323507039295
            ],
            [
              -53.52592674517836,
              -29.016377386005463
            ],
            [
              -53.52718136200717,
              -29.012583759193106
            ],
            [
              -53.52958149854924,
              -29.00682128808573
            ],
            [
              -53.531490698071345,
              -29.006197020382434
            ],
            [
              -53.5354181942311,
              -29.006389102752678
            ],
            [
              -53.53661826250213,
              -29.008790132380753
            ],
            [
              -53.538909301928655,
              -29.010518873712964
            ],
            [
              -53.54147308414405,
              -29.009990647194787
            ],
            [
              -53.54387322068612,
              -29.01071095608321
            ],
            [
              -53.54469144905274,
              -29.007589617566715
            ],
            [
              -53.54310954087728,
              -29.007589617566715
            ],
            [
              -53.54021846731524,
              -29.008790132380753
            ],
            [
              -53.53989117596859,
              -29.007205452826224
            ],
            [
              -53.54109124423963,
              -29.00369994956924
            ],
            [
              -53.5420185697218,
              -29.002211311199833
            ],
            [
              -53.54387322068612,
              -29.00057861105274
            ],
            [
              -53.54409141491722,
              -28.999714240386634
            ],
            [
              -53.54207311827957,
              -28.998705807942844
            ],
            [
              -53.54070940433521,
              -28.99918601386846
            ],
            [
              -53.53770923365762,
              -29.001010796385795
            ],
            [
              -53.53459996586448,
              -29.002211311199833
            ],
            [
              -53.532418023553504,
              -29.00177912586678
            ],
            [
              -53.5313816009558,
              -28.999810281571758
            ],
            [
              -53.53170889230244,
              -28.9978894578693
            ],
            [
              -53.533127154804575,
              -28.996400819499893
            ],
            [
              -53.53372718894009,
              -28.994479995797438
            ],
            [
              -53.53301805768903,
              -28.993423542761082
            ],
            [
              -53.52979969278034,
              -28.993423542761082
            ],
            [
              -53.52712681344939,
              -28.99188688379912
            ],
            [
              -53.524508482676225,
              -28.99169480142887
            ],
            [
              -53.52172650622973,
              -28.989485854171043
            ],
            [
              -53.52172650622973,
              -28.987276906913216
            ],
            [
              -53.5203082437276,
              -28.985212021433075
            ],
            [
              -53.521617409114185,
              -28.983915465433913
            ],
            [
              -53.52429028844513,
              -28.98477983610002
            ],
            [
              -53.52549035671616,
              -28.98439567135953
            ],
            [
              -53.52592674517836,
              -28.98012183862156
            ],
            [
              -53.52472667690732,
              -28.976376232401766
            ],
            [
              -53.5247812254651,
              -28.97522373818029
            ],
            [
              -53.524181191329575,
              -28.97330291447783
            ],
            [
              -53.52559945383171,
              -28.970181575961337
            ],
            [
              -53.5266904249872,
              -28.966916175667155
            ],
            [
              -53.52892691585595,
              -28.96701221685228
            ],
            [
              -53.53209073220686,
              -28.970517720109267
            ],
            [
              -53.53590913125107,
              -28.973398955662955
            ],
            [
              -53.538472913466464,
              -28.974503429291868
            ],
            [
              -53.54207311827957,
              -28.97522373818029
            ],
            [
              -53.545782420208226,
              -28.974983635217484
            ],
            [
              -53.54889168800136,
              -28.97349499684808
            ],
            [
              -53.55287373271889,
              -28.972198440848917
            ],
            [
              -53.554510189452124,
              -28.97099792603488
            ],
            [
              -53.557292165898616,
              -28.969605328850598
            ],
            [
              -53.557292165898616,
              -28.967876587518386
            ],
            [
              -53.55641938897423,
              -28.96768450514814
            ],
            [
              -53.55227369858338,
              -28.969221164110106
            ],
            [
              -53.55129182454344,
              -28.970805843664635
            ],
            [
              -53.54998265915685,
              -28.97138209077537
            ],
            [
              -53.548618945212496,
              -28.970517720109267
            ],
            [
              -53.54670974569039,
              -28.96830877285144
            ],
            [
              -53.54730977982591,
              -28.96571566085312
            ],
            [
              -53.54807345963475,
              -28.9649953519647
            ],
            [
              -53.54921897934801,
              -28.962690363521748
            ],
            [
              -53.55167366444786,
              -28.962594322336624
            ],
            [
              -53.55227369858338,
              -28.962114116411012
            ],
            [
              -53.552382795698925,
              -28.959280901449883
            ],
            [
              -53.554401092336576,
              -28.9610096427821
            ],
            [
              -53.5586013312852,
              -28.963218590039926
            ],
            [
              -53.56318341013825,
              -28.963218590039926
            ],
            [
              -53.56651087216248,
              -28.963506713595294
            ],
            [
              -53.567110906298005,
              -28.9624982811515
            ],
            [
              -53.56700180918246,
              -28.960385375078797
            ],
            [
              -53.56487441542925,
              -28.95817642782097
            ],
            [
              -53.565419901007,
              -28.957216015969742
            ],
            [
              -53.56820187745349,
              -28.954286759823493
            ],
            [
              -53.56978378562895,
              -28.95351843034251
            ],
            [
              -53.57240211640212,
              -28.95299020382433
            ],
            [
              -53.57338399044205,
              -28.951789689010297
            ],
            [
              -53.57322034476873,
              -28.948812412271486
            ],
            [
              -53.57589322409967,
              -28.947707938642573
            ],
            [
              -53.57747513227513,
              -28.946507423828535
            ],
            [
              -53.57682054958184,
              -28.9446826413112
            ],
            [
              -53.57709329237071,
              -28.943914311830216
            ],
            [
              -53.57878429766172,
              -28.94329004412692
            ],
            [
              -53.58211175968595,
              -28.943914311830216
            ],
            [
              -53.58298453661034,
              -28.942185570498005
            ],
            [
              -53.58320273084144,
              -28.9406969321286
            ],
            [
              -53.585002833248,
              -28.94012068501786
            ],
            [
              -53.58898487796552,
              -28.942281611683125
            ],
            [
              -53.58740296979007,
              -28.945114826644254
            ],
            [
              -53.58898487796552,
              -28.94660346501366
            ],
            [
              -53.59018494623656,
              -28.944298476570708
            ],
            [
              -53.59280327700973,
              -28.942185570498005
            ],
            [
              -53.594112442396316,
              -28.94079297331372
            ],
            [
              -53.594985219320705,
              -28.938007778945156
            ],
            [
              -53.59727625874723,
              -28.939304334944314
            ],
            [
              -53.59678532172725,
              -28.940216726202983
            ],
            [
              -53.599512749615975,
              -28.94410639420046
            ],
            [
              -53.60169469192695,
              -28.944202435385584
            ],
            [
              -53.60131285202253,
              -28.94271379701618
            ],
            [
              -53.60267656596689,
              -28.940985055683967
            ],
            [
              -53.60627677078,
              -28.938680067241016
            ],
            [
              -53.60878600443762,
              -28.938007778945156
            ],
            [
              -53.61287714627069,
              -28.940600890943475
            ],
            [
              -53.6150045400239,
              -28.940889014498843
            ],
            [
              -53.61598641406383,
              -28.941609323387265
            ],
            [
              -53.61827745349036,
              -28.94108109686909
            ],
            [
              -53.61871384195255,
              -28.94309796175667
            ],
            [
              -53.62100488137907,
              -28.944298476570708
            ],
            [
              -53.62111397849462,
              -28.945595032569866
            ],
            [
              -53.624114149172215,
              -28.94540295019962
            ],
            [
              -53.62318682369005,
              -28.944490558940952
            ],
            [
              -53.62782345110087,
              -28.94309796175667
            ],
            [
              -53.62978719918075,
              -28.945306909014498
            ],
            [
              -53.63589663765148,
              -28.94669950619878
            ],
            [
              -53.63900590544461,
              -28.945595032569866
            ],
            [
              -53.63982413381123,
              -28.9446826413112
            ],
            [
              -53.6384058713091,
              -28.942905879386426
            ],
            [
              -53.63791493428913,
              -28.940408808573228
            ],
            [
              -53.63327830687831,
              -28.93949641731456
            ],
            [
              -53.63207823860727,
              -28.938680067241016
            ],
            [
              -53.63338740399386,
              -28.93719142887161
            ],
            [
              -53.638024031404676,
              -28.935606749317085
            ],
            [
              -53.63867861409797,
              -28.938295902500524
            ],
            [
              -53.647024543437446,
              -28.932485410800588
            ],
            [
              -53.648224611708486,
              -28.932917596133642
            ],
            [
              -53.648824645844,
              -28.935078522798907
            ],
            [
              -53.648279160266256,
              -28.938487984870772
            ],
            [
              -53.65269759344598,
              -28.941321199831897
            ],
            [
              -53.65482498719918,
              -28.94117713805421
            ],
            [
              -53.66082532855436,
              -28.939304334944314
            ],
            [
              -53.66278907663424,
              -28.94012068501786
            ],
            [
              -53.663880047789725,
              -28.93949641731456
            ],
            [
              -53.66420733913637,
              -28.937815696574912
            ],
            [
              -53.66780754394948,
              -28.937719655389788
            ],
            [
              -53.668789417989416,
              -28.936711222946
            ],
            [
              -53.66851667520054,
              -28.93450227568817
            ],
            [
              -53.66900761222051,
              -28.933109678503886
            ],
            [
              -53.670916811742615,
              -28.930708648875815
            ],
            [
              -53.669225806451614,
              -28.92989229880227
            ],
            [
              -53.670480423280424,
              -28.926578877915528
            ],
            [
              -53.67391698242021,
              -28.925810548434544
            ],
            [
              -53.67522614780679,
              -28.923889724732085
            ],
            [
              -53.67522614780679,
              -28.922881292288295
            ],
            [
              -53.679480935313194,
              -28.918223294809835
            ],
            [
              -53.6788263526199,
              -28.91687871821811
            ],
            [
              -53.681117392046424,
              -28.911788535406597
            ],
            [
              -53.68199016897081,
              -28.911020205925613
            ],
            [
              -53.6830811401263,
              -28.908811258667786
            ],
            [
              -53.68259020310633,
              -28.90237649926455
            ],
            [
              -53.6832993343574,
              -28.9013200462282
            ],
            [
              -53.687990510325996,
              -28.901608169783568
            ],
            [
              -53.69039064686807,
              -28.902280458079428
            ],
            [
              -53.69219074927462,
              -28.900791819710022
            ],
            [
              -53.694209045912274,
              -28.89680611052742
            ],
            [
              -53.69639098822324,
              -28.89541351334314
            ],
            [
              -53.70119126130739,
              -28.895893719268752
            ],
            [
              -53.70310046082949,
              -28.89469320445472
            ],
            [
              -53.703973237753885,
              -28.890707495272114
            ],
            [
              -53.70931899641577,
              -28.888018342088674
            ],
            [
              -53.71171913295784,
              -28.886481683126707
            ],
            [
              -53.71668305171531,
              -28.885377209497793
            ],
            [
              -53.72028325652842,
              -28.880911294389577
            ],
            [
              -53.72071964499061,
              -28.877597873502836
            ],
            [
              -53.719901416624,
              -28.875004761504517
            ],
            [
              -53.72148332479945,
              -28.87370820550536
            ],
            [
              -53.724101655572625,
              -28.87351612313511
            ],
            [
              -53.7243743983615,
              -28.87212352595083
            ],
            [
              -53.72808370029015,
              -28.870298743433494
            ],
            [
              -53.7284109916368,
              -28.863479819289765
            ],
            [
              -53.72972015702338,
              -28.863191695734397
            ],
            [
              -53.73141116231439,
              -28.864008045807942
            ],
            [
              -53.734411332991975,
              -28.864680334103802
            ],
            [
              -53.73697511520737,
              -28.864104086993066
            ],
            [
              -53.73899341184502,
              -28.861991180920363
            ],
            [
              -53.74292090800478,
              -28.862711489808785
            ],
            [
              -53.747012049837856,
              -28.86621699306577
            ],
            [
              -53.75088499743983,
              -28.868089796175667
            ],
            [
              -53.752794196961936,
              -28.86751354906493
            ],
            [
              -53.756503498890595,
              -28.867321466694683
            ],
            [
              -53.759394572452635,
              -28.864920437066612
            ],
            [
              -53.76037644649257,
              -28.865016478251732
            ],
            [
              -53.763485714285714,
              -28.8613188926245
            ],
            [
              -53.76441303976788,
              -28.859109945366672
            ],
            [
              -53.769104215736476,
              -28.851618732927086
            ],
            [
              -53.77232258064516,
              -28.844703767598233
            ],
            [
              -53.77472271718723,
              -28.843119088043707
            ],
            [
              -53.777777436422596,
              -28.839421502416474
            ],
            [
              -53.77750469363372,
              -28.834283299012398
            ],
            [
              -53.777013756613755,
              -28.83370705190166
            ],
            [
              -53.77750469363372,
              -28.831786228199203
            ],
            [
              -53.78317774364226,
              -28.83048967220004
            ],
            [
              -53.785196040279914,
              -28.818100359319185
            ],
            [
              -53.78661430278204,
              -28.816083494431602
            ],
            [
              -53.78710523980202,
              -28.809216549695314
            ],
            [
              -53.79141457586619,
              -28.806911561252363
            ],
            [
              -53.79141457586619,
              -28.805278861105275
            ],
            [
              -53.79397835808158,
              -28.804894696364784
            ],
            [
              -53.79430564942823,
              -28.803694181550746
            ],
            [
              -53.795887557603685,
              -28.802781790292077
            ],
            [
              -53.79937866530125,
              -28.803310016810254
            ],
            [
              -53.80090602491893,
              -28.801917419625973
            ],
            [
              -53.803578904249875,
              -28.801677316663163
            ],
            [
              -53.8035243556921,
              -28.80062086362681
            ],
            [
              -53.80630633213859,
              -28.80062086362681
            ],
            [
              -53.806088137907494,
              -28.798988163479724
            ],
            [
              -53.807724594640725,
              -28.797787648665686
            ],
            [
              -53.80761549752518,
              -28.796491092666525
            ],
            [
              -53.80908830858508,
              -28.796491092666525
            ],
            [
              -53.8096883427206,
              -28.7988921222946
            ],
            [
              -53.81317945041816,
              -28.801917419625973
            ],
            [
              -53.814706810035844,
              -28.805422922882958
            ],
            [
              -53.814706810035844,
              -28.806287293549065
            ],
            [
              -53.81721604369346,
              -28.80647937591931
            ],
            [
              -53.81781607782898,
              -28.808208117251525
            ],
            [
              -53.81928888888889,
              -28.808304158436645
            ],
            [
              -53.82092534562212,
              -28.80710364362261
            ],
            [
              -53.82168902543096,
              -28.805615005253205
            ],
            [
              -53.82348912783751,
              -28.804894696364784
            ],
            [
              -53.82310728793309,
              -28.80671947888212
            ],
            [
              -53.82790756101724,
              -28.807679890733347
            ],
            [
              -53.82932582351937,
              -28.80619125236394
            ],
            [
              -53.832380542754734,
              -28.806095211178818
            ],
            [
              -53.832325994196964,
              -28.807583849548223
            ],
            [
              -53.83259873698583,
              -28.811521538138265
            ],
            [
              -53.834780679296806,
              -28.812577991174617
            ],
            [
              -53.83532616487455,
              -28.811521538138265
            ],
            [
              -53.83712626728111,
              -28.810513105694472
            ],
            [
              -53.83941730670763,
              -28.810513105694472
            ],
            [
              -53.841326506229734,
              -28.808688323177137
            ],
            [
              -53.84072647209421,
              -28.807487808363103
            ],
            [
              -53.83909001536098,
              -28.807487808363103
            ],
            [
              -53.84001734084315,
              -28.805999169993697
            ],
            [
              -53.83958095238095,
              -28.80379022273587
            ],
            [
              -53.8418174432497,
              -28.802013460811093
            ],
            [
              -53.840890117767536,
              -28.80119711073755
            ],
            [
              -53.843726642771806,
              -28.798988163479724
            ],
            [
              -53.84519945383171,
              -28.79990055473839
            ],
            [
              -53.84618132787165,
              -28.79927628703509
            ],
            [
              -53.84890875576037,
              -28.79927628703509
            ],
            [
              -53.84852691585595,
              -28.802301584366464
            ],
            [
              -53.849890629800306,
              -28.80249366673671
            ],
            [
              -53.85130889230244,
              -28.79961243118302
            ],
            [
              -53.85338173749787,
              -28.797211401554947
            ],
            [
              -53.85469090288445,
              -28.79759556629544
            ],
            [
              -53.85550913125107,
              -28.799180245849968
            ],
            [
              -53.85441816009558,
              -28.799804513553266
            ],
            [
              -53.85409086874893,
              -28.80148523429292
            ],
            [
              -53.854909097115545,
              -28.802013460811093
            ],
            [
              -53.85801836490869,
              -28.80148523429292
            ],
            [
              -53.85921843317972,
              -28.80090898718218
            ],
            [
              -53.86107308414405,
              -28.803021893254886
            ],
            [
              -53.86358231780167,
              -28.801677316663163
            ],
            [
              -53.86450964328384,
              -28.80388626392099
            ],
            [
              -53.86418235193719,
              -28.80479865517966
            ],
            [
              -53.86270954087728,
              -28.80551896406808
            ],
            [
              -53.861400375490696,
              -28.8081120760664
            ],
            [
              -53.85758197644649,
              -28.809600714435806
            ],
            [
              -53.85589097115549,
              -28.80969675562093
            ],
            [
              -53.856109165386584,
              -28.811809661693633
            ],
            [
              -53.85709103942652,
              -28.813394341248163
            ],
            [
              -53.85867294760198,
              -28.8127220529523
            ],
            [
              -53.859382078853045,
              -28.810993311620088
            ],
            [
              -53.86167311827957,
              -28.810321023324228
            ],
            [
              -53.86287318655061,
              -28.811905702878757
            ],
            [
              -53.86210950674177,
              -28.814402773691953
            ],
            [
              -53.86407325482164,
              -28.814882979617565
            ],
            [
              -53.86647339136371,
              -28.813586423618407
            ],
            [
              -53.86821894521249,
              -28.81469089724732
            ],
            [
              -53.871982795698926,
              -28.815507247320866
            ],
            [
              -53.87400109233658,
              -28.814882979617565
            ],
            [
              -53.87678306878307,
              -28.812914135322547
            ],
            [
              -53.877710394265236,
              -28.810993311620088
            ],
            [
              -53.87760129714968,
              -28.808688323177137
            ],
            [
              -53.87961959378733,
              -28.808880405547384
            ],
            [
              -53.882401570233824,
              -28.8081120760664
            ],
            [
              -53.883601638504864,
              -28.80681552006724
            ],
            [
              -53.883110701484895,
              -28.80479865517966
            ],
            [
              -53.88338344427377,
              -28.8035020991805
            ],
            [
              -53.88169243898276,
              -28.8035020991805
            ],
            [
              -53.88141969619389,
              -28.801389193107795
            ],
            [
              -53.88491080389145,
              -28.801917419625973
            ],
            [
              -53.88627451783581,
              -28.801101069552427
            ],
            [
              -53.888020071684586,
              -28.801581275478043
            ],
            [
              -53.889601979860046,
              -28.803117934440007
            ],
            [
              -53.889383785628944,
              -28.804990737549904
            ],
            [
              -53.88987472264891,
              -28.805999169993697
            ],
            [
              -53.8916202764977,
              -28.806911561252363
            ],
            [
              -53.89151117938215,
              -28.807823952511033
            ],
            [
              -53.892493053422086,
              -28.809600714435806
            ],
            [
              -53.89200211640212,
              -28.81171362050851
            ],
            [
              -53.89282034476873,
              -28.812097785249
            ],
            [
              -53.89631145246629,
              -28.81171362050851
            ],
            [
              -53.89860249189282,
              -28.80969675562093
            ],
            [
              -53.90231179382147,
              -28.809600714435806
            ],
            [
              -53.906075644307904,
              -28.811521538138265
            ],
            [
              -53.90367550776583,
              -28.815219123765498
            ],
            [
              -53.902420890937016,
              -28.815795370876234
            ],
            [
              -53.8999116572794,
              -28.815891412061358
            ],
            [
              -53.898384297661714,
              -28.81829244168943
            ],
            [
              -53.90187540535928,
              -28.820981594872872
            ],
            [
              -53.90220269670592,
              -28.82261429501996
            ],
            [
              -53.901220822665984,
              -28.82458313931498
            ],
            [
              -53.90247543949479,
              -28.824679180500105
            ],
            [
              -53.90547561017238,
              -28.82251825383484
            ],
            [
              -53.90907581498549,
              -28.825399489388527
            ],
            [
              -53.91000314046766,
              -28.827320313090986
            ],
            [
              -53.9128942140297,
              -28.828904992645512
            ],
            [
              -53.91447612220515,
              -28.831594145828955
            ],
            [
              -53.91698535586278,
              -28.834379340197522
            ],
            [
              -53.9214037890425,
              -28.832794660642993
            ],
            [
              -53.923694828469024,
              -28.831209981088463
            ],
            [
              -53.92527673664448,
              -28.832890701828116
            ],
            [
              -53.92418576548899,
              -28.836876411010717
            ],
            [
              -53.92549493087557,
              -28.838220987602437
            ],
            [
              -53.92527673664448,
              -28.840477955452826
            ],
            [
              -53.926204062126644,
              -28.840814099600756
            ],
            [
              -53.92882239289981,
              -28.84321512922883
            ],
            [
              -53.93040430107527,
              -28.84518397352385
            ],
            [
              -53.93051339819082,
              -28.847200838411432
            ],
            [
              -53.93220440348182,
              -28.848305312040345
            ],
            [
              -53.933077180406215,
              -28.849601868039503
            ],
            [
              -53.93209530636627,
              -28.85109050640891
            ],
            [
              -53.93018610684417,
              -28.852002897667578
            ],
            [
              -53.9299133640553,
              -28.85281924774112
            ],
            [
              -53.931877112135176,
              -28.854019762555158
            ],
            [
              -53.93542276839051,
              -28.854211844925405
            ],
            [
              -53.93618644819935,
              -28.859109945366672
            ],
            [
              -53.942077692438986,
              -28.86170305736499
            ],
            [
              -53.942077692438986,
              -28.862711489808785
            ],
            [
              -53.94038668714798,
              -28.864488251733558
            ],
            [
              -53.93880477897252,
              -28.86520856062198
            ],
            [
              -53.93700467656597,
              -28.86751354906493
            ],
            [
              -53.937277419354835,
              -28.868714063878965
            ],
            [
              -53.93869568185697,
              -28.869914578693002
            ],
            [
              -53.937604710701486,
              -28.873996329060727
            ],
            [
              -53.93962300733914,
              -28.875917152763186
            ],
            [
              -53.94218678955453,
              -28.875821111578063
            ],
            [
              -53.94349595494111,
              -28.87438049380122
            ],
            [
              -53.945023314558796,
              -28.87212352595083
            ],
            [
              -53.946605222734256,
              -28.87438049380122
            ],
            [
              -53.94818713090971,
              -28.875004761504517
            ],
            [
              -53.94982358764294,
              -28.874908720319393
            ],
            [
              -53.94982358764294,
              -28.87380424669048
            ],
            [
              -53.951078204471756,
              -28.872891855431813
            ],
            [
              -53.95178733572282,
              -28.874812679134273
            ],
            [
              -53.95440566649599,
              -28.874620596764025
            ],
            [
              -53.9550057006315,
              -28.875292885059885
            ],
            [
              -53.952387369858336,
              -28.87942265602017
            ],
            [
              -53.953205598224955,
              -28.881391500315193
            ],
            [
              -53.954896603515955,
              -28.880815253204453
            ],
            [
              -53.95729674005803,
              -28.881583582685437
            ],
            [
              -53.957787677078,
              -28.88360044757302
            ],
            [
              -53.95740583717358,
              -28.884512838831686
            ],
            [
              -53.95909684246458,
              -28.88657772431183
            ],
            [
              -53.95789677419355,
              -28.888786671569658
            ],
            [
              -53.95751493428913,
              -28.891811968901028
            ],
            [
              -53.95598757467145,
              -28.89291644252994
            ],
            [
              -53.9558784775559,
              -28.89411695734398
            ],
            [
              -53.954514763611535,
              -28.895605595713384
            ],
            [
              -53.952878306878304,
              -28.89839079008195
            ],
            [
              -53.95380563236047,
              -28.898919016600125
            ],
            [
              -53.955278443420376,
              -28.89810266652658
            ],
            [
              -53.95767857996245,
              -28.899303181340617
            ],
            [
              -53.96209701314218,
              -28.89939922252574
            ],
            [
              -53.9624788530466,
              -28.90107994326539
            ],
            [
              -53.964278955453146,
              -28.902616602227358
            ],
            [
              -53.96662454343745,
              -28.901704210968692
            ],
            [
              -53.96831554872845,
              -28.90040765496953
            ],
            [
              -53.96989745690391,
              -28.902088375709184
            ],
            [
              -53.97240669056153,
              -28.903817117041395
            ],
            [
              -53.974097695852535,
              -28.90237649926455
            ],
            [
              -53.976115992490186,
              -28.904201281781887
            ],
            [
              -53.976225089605734,
              -28.9053057554108
            ],
            [
              -53.979825294418845,
              -28.90400919941164
            ],
            [
              -53.9792798088411,
              -28.901704210968692
            ],
            [
              -53.97971619730329,
              -28.900311613784407
            ],
            [
              -53.97938890595665,
              -28.898822975415
            ],
            [
              -53.979879842976615,
              -28.89800662534146
            ],
            [
              -53.98249817374979,
              -28.899303181340617
            ],
            [
              -53.98462556750299,
              -28.89939922252574
            ],
            [
              -53.98931674347158,
              -28.900887860895146
            ],
            [
              -53.99122594299369,
              -28.900503696154654
            ],
            [
              -53.99368062809353,
              -28.902280458079428
            ],
            [
              -53.99569892473118,
              -28.902904725782726
            ],
            [
              -53.99618986175115,
              -28.90400919941164
            ],
            [
              -53.99919003242874,
              -28.903817117041395
            ],
            [
              -54.002408397337426,
              -28.90199233452406
            ],
            [
              -54.00508127666837,
              -28.901800252153812
            ],
            [
              -54.00628134493941,
              -28.903288890523218
            ],
            [
              -54.01108161802355,
              -28.90338493170834
            ],
            [
              -54.0116271036013,
              -28.902184416894304
            ],
            [
              -54.01457272572111,
              -28.9013200462282
            ],
            [
              -54.01571824543437,
              -28.898919016600125
            ],
            [
              -54.01490001706776,
              -28.89800662534146
            ],
            [
              -54.01571824543437,
              -28.894597163269594
            ],
            [
              -54.01659102235876,
              -28.893876854381173
            ],
            [
              -54.02117310121181,
              -28.894885286824962
            ],
            [
              -54.021282198327356,
              -28.899495263710865
            ],
            [
              -54.02291865506059,
              -28.901512128598444
            ],
            [
              -54.023682334869434,
              -28.90400919941164
            ],
            [
              -54.02597337429595,
              -28.905017631855433
            ],
            [
              -54.027718928144736,
              -28.904105240596763
            ],
            [
              -54.02940993343574,
              -28.904777528892623
            ],
            [
              -54.03039180747568,
              -28.90650627022484
            ],
            [
              -54.03181006997781,
              -28.907418661483504
            ],
            [
              -54.03491933777095,
              -28.907610743853752
            ],
            [
              -54.040483290663936,
              -28.909099382223157
            ],
            [
              -54.040974227683904,
              -28.91121228829586
            ],
            [
              -54.042610684417134,
              -28.911788535406597
            ],
            [
              -54.045010820959206,
              -28.91029989703719
            ],
            [
              -54.04817463731012,
              -28.911788535406597
            ],
            [
              -54.04932015702338,
              -28.910011773481823
            ],
            [
              -54.05139300221881,
              -28.908283032149612
            ],
            [
              -54.05379313876088,
              -28.90698647615045
            ],
            [
              -54.05930254309609,
              -28.90631418785459
            ],
            [
              -54.06192087386926,
              -28.905497837781045
            ],
            [
              -54.06497559310463,
              -28.9053057554108
            ],
            [
              -54.06688479262673,
              -28.907514702668628
            ],
            [
              -54.06868489503328,
              -28.908379073334732
            ],
            [
              -54.071575968595326,
              -28.908090949779364
            ],
            [
              -54.07528527052398,
              -28.90660231140996
            ],
            [
              -54.07670353302611,
              -28.906410229039714
            ],
            [
              -54.08030373783922,
              -28.90698647615045
            ],
            [
              -54.085213108038914,
              -28.906218146669467
            ],
            [
              -54.08712230756102,
              -28.906122105484346
            ],
            [
              -54.09557733401604,
              -28.904777528892623
            ],
            [
              -54.10228680662229,
              -28.901896293338936
            ],
            [
              -54.10561426864653,
              -28.899879428451356
            ],
            [
              -54.10817805086192,
              -28.897382357638158
            ],
            [
              -54.11237828981055,
              -28.89282040134482
            ],
            [
              -54.118324082607955,
              -28.887682197940745
            ],
            [
              -54.121596996074416,
              -28.886481683126707
            ],
            [
              -54.12590633213859,
              -28.88619355957134
            ],
            [
              -54.129124697047274,
              -28.8849930447573
            ],
            [
              -54.13277945041816,
              -28.883312324017652
            ],
            [
              -54.13490684417136,
              -28.88259201512923
            ],
            [
              -54.142980030721965,
              -28.891091660012606
            ],
            [
              -54.14488923024407,
              -28.89282040134482
            ],
            [
              -54.14690752688172,
              -28.89411695734398
            ],
            [
              -54.15050773169483,
              -28.895221430972892
            ],
            [
              -54.163817579791775,
              -28.89680611052742
            ],
            [
              -54.166326813449395,
              -28.896998192897666
            ],
            [
              -54.169217887011435,
              -28.896710069342298
            ],
            [
              -54.18498242020823,
              -28.894212998529103
            ],
            [
              -54.189291756272404,
              -28.89450112208447
            ],
            [
              -54.19180098993002,
              -28.89541351334314
            ],
            [
              -54.197474039938555,
              -28.89839079008195
            ],
            [
              -54.199983273596175,
              -28.900311613784407
            ],
            [
              -54.201619730329405,
              -28.90199233452406
            ],
            [
              -54.214220447175286,
              -28.918607459550326
            ],
            [
              -54.21580235535074,
              -28.920288180289976
            ],
            [
              -54.21809339477726,
              -28.92177681865938
            ],
            [
              -54.22327550776583,
              -28.924417951250263
            ],
            [
              -54.22709390681003,
              -28.925810548434544
            ],
            [
              -54.23042136883427,
              -28.925906589619668
            ],
            [
              -54.23402157364738,
              -28.924994198361
            ],
            [
              -54.26107765830346,
              -28.912604885480143
            ],
            [
              -54.26489605734767,
              -28.911596453036353
            ],
            [
              -54.268387165045226,
              -28.911980617776845
            ],
            [
              -54.272096466973885,
              -28.914093523849548
            ],
            [
              -54.27727857996245,
              -28.918703500735447
            ],
            [
              -54.28087878477556,
              -28.921488695104014
            ],
            [
              -54.289715651135005,
              -28.92701106324858
            ],
            [
              -54.29358859873698,
              -28.92830761924774
            ],
            [
              -54.30728028673835,
              -28.928979907543603
            ],
            [
              -54.30989861751152,
              -28.930084381172517
            ],
            [
              -54.31328062809353,
              -28.931092813616306
            ],
            [
              -54.31448069636457,
              -28.930708648875815
            ],
            [
              -54.316717187233316,
              -28.92869178398823
            ],
            [
              -54.31939006656426,
              -28.928979907543603
            ],
            [
              -54.320481037719745,
              -28.929796257617145
            ],
            [
              -54.32800873869261,
              -28.930996772431183
            ],
            [
              -54.33089981225465,
              -28.931092813616306
            ],
            [
              -54.33248172043011,
              -28.930996772431183
            ],
            [
              -54.335972828127666,
              -28.929796257617145
            ],
            [
              -54.340609455538484,
              -28.92922001050641
            ],
            [
              -54.3437732718894,
              -28.929796257617145
            ],
            [
              -54.344591500256016,
              -28.932581451985712
            ],
            [
              -54.34617340843147,
              -28.934982481613783
            ],
            [
              -54.346718894009214,
              -28.93680726413112
            ],
            [
              -54.35708311998634,
              -28.96110568396722
            ],
            [
              -54.356919474313024,
              -28.96509139314982
            ],
            [
              -54.35168281276668,
              -28.970805843664635
            ],
            [
              -54.35108277863117,
              -28.97291874973734
            ],
            [
              -54.36417443249701,
              -28.985308062618195
            ],
            [
              -54.376175115207374,
              -29.001010796385795
            ],
            [
              -54.37770247482506,
              -29.00451629964278
            ],
            [
              -54.377811571940605,
              -29.00192318764446
            ],
            [
              -54.379120737327185,
              -28.99918601386846
            ],
            [
              -54.38048445127155,
              -28.996977066610633
            ],
            [
              -54.38348462194914,
              -28.996784984240385
            ],
            [
              -54.38801215224441,
              -28.989918039504097
            ],
            [
              -54.388121249359955,
              -28.988621483504936
            ],
            [
              -54.389321317630994,
              -28.98770909224627
            ],
            [
              -54.389321317630994,
              -28.98578826854381
            ],
            [
              -54.390521385902034,
              -28.983291197730615
            ],
            [
              -54.39150325994197,
              -28.97628019121664
            ],
            [
              -54.39199419696194,
              -28.974119264551376
            ],
            [
              -54.39357610513739,
              -28.972198440848917
            ],
            [
              -54.39439433350401,
              -28.969413246480354
            ],
            [
              -54.39532165898618,
              -28.968116690481192
            ],
            [
              -54.39941280081925,
              -28.964179001891154
            ],
            [
              -54.39837637822154,
              -28.961585889892834
            ],
            [
              -54.40017648062809,
              -28.957312057154866
            ],
            [
              -54.3993037037037,
              -28.955679357007774
            ],
            [
              -54.40050377197474,
              -28.953422389157385
            ],
            [
              -54.401922034476875,
              -28.944922744274006
            ],
            [
              -54.405685884963304,
              -28.94050484975835
            ],
            [
              -54.40759508448541,
              -28.937719655389788
            ],
            [
              -54.40950428400751,
              -28.936999346501366
            ],
            [
              -54.412613551800646,
              -28.93680726413112
            ],
            [
              -54.41332268305172,
              -28.935702790502205
            ],
            [
              -54.413813620071686,
              -28.933685925614625
            ],
            [
              -54.41201351766513,
              -28.931476978356798
            ],
            [
              -54.41190442054958,
              -28.929123969321285
            ],
            [
              -54.41070435227854,
              -28.926818980878334
            ],
            [
              -54.4103770609319,
              -28.922209003992435
            ],
            [
              -54.41190442054958,
              -28.921920880437067
            ],
            [
              -54.4169774364226,
              -28.92278525110317
            ],
            [
              -54.419213927291345,
              -28.92268920991805
            ],
            [
              -54.41970486431131,
              -28.921008489178398
            ],
            [
              -54.42232319508449,
              -28.92110453036352
            ],
            [
              -54.42270503498891,
              -28.91908766547594
            ],
            [
              -54.42450513739546,
              -28.91678267703299
            ],
            [
              -54.42401420037549,
              -28.914621750367726
            ],
            [
              -54.42777805086192,
              -28.91289300903551
            ],
            [
              -54.42832353643966,
              -28.91150041185123
            ],
            [
              -54.42772350230415,
              -28.91058802059256
            ],
            [
              -54.42919631336405,
              -28.9099157322967
            ],
            [
              -54.431814644137226,
              -28.90660231140996
            ],
            [
              -54.4312146100017,
              -28.9053057554108
            ],
            [
              -54.433178358081584,
              -28.903480972893465
            ],
            [
              -54.434378426352616,
              -28.90300076696785
            ],
            [
              -54.435578494623655,
              -28.899783387266233
            ],
            [
              -54.435196654719235,
              -28.89709423408279
            ],
            [
              -54.43748769414576,
              -28.896085801639
            ],
            [
              -54.439287796552314,
              -28.896517986972054
            ],
            [
              -54.44032421915002,
              -28.894597163269594
            ],
            [
              -54.4427243556921,
              -28.896181842824124
            ],
            [
              -54.44479720088752,
              -28.894885286824962
            ],
            [
              -54.44501539511862,
              -28.89349268964068
            ],
            [
              -54.443378938385386,
              -28.89219613364152
            ],
            [
              -54.44321529271207,
              -28.890995618827485
            ],
            [
              -54.44572452636969,
              -28.887778239125865
            ],
            [
              -54.448288308585084,
              -28.890995618827485
            ],
            [
              -54.449979313876085,
              -28.89219613364152
            ],
            [
              -54.451179382147124,
              -28.89152384534566
            ],
            [
              -54.45150667349377,
              -28.889122815717588
            ],
            [
              -54.45221580474484,
              -28.888018342088674
            ],
            [
              -54.45401590715139,
              -28.88691386845976
            ],
            [
              -54.4573979177334,
              -28.886289600756463
            ],
            [
              -54.4573979177334,
              -28.8856173124606
            ],
            [
              -54.46012534562212,
              -28.881919726833367
            ],
            [
              -54.460179894179895,
              -28.880383067871403
            ],
            [
              -54.45701607782898,
              -28.878798388316874
            ],
            [
              -54.458107048984466,
              -28.87678152342929
            ],
            [
              -54.45941621437105,
              -28.876013193948307
            ],
            [
              -54.460616282642086,
              -28.877405791132592
            ],
            [
              -54.46159815668203,
              -28.875821111578063
            ],
            [
              -54.46438013312852,
              -28.87678152342929
            ],
            [
              -54.4656892985151,
              -28.87678152342929
            ],
            [
              -54.46519836149513,
              -28.87870234713175
            ],
            [
              -54.46678026967059,
              -28.87942265602017
            ],
            [
              -54.46999863457928,
              -28.87908651187224
            ],
            [
              -54.47032592592593,
              -28.877885997058204
            ],
            [
              -54.47299880525687,
              -28.88028702668628
            ],
            [
              -54.47501710189452,
              -28.880190985501155
            ],
            [
              -54.476926301416626,
              -28.882111809203614
            ],
            [
              -54.47850820959208,
              -28.882111809203614
            ],
            [
              -54.47998102065199,
              -28.881391500315193
            ],
            [
              -54.481508380269666,
              -28.882495973944106
            ],
            [
              -54.483526676907324,
              -28.880815253204453
            ],
            [
              -54.48652684758491,
              -28.87942265602017
            ],
            [
              -54.48619955623826,
              -28.87870234713175
            ],
            [
              -54.48330848267622,
              -28.878222141206134
            ],
            [
              -54.47959918074757,
              -28.87630131750368
            ],
            [
              -54.478617306707626,
              -28.875196843874765
            ],
            [
              -54.47812636968766,
              -28.872987896616937
            ],
            [
              -54.48189022017409,
              -28.87370820550536
            ],
            [
              -54.48139928315412,
              -28.87279581424669
            ],
            [
              -54.48379941969619,
              -28.87121113469216
            ],
            [
              -54.48510858508278,
              -28.871979464173144
            ],
            [
              -54.48669049325824,
              -28.87212352595083
            ],
            [
              -54.48712688172043,
              -28.875196843874765
            ],
            [
              -54.48859969278033,
              -28.875292885059885
            ],
            [
              -54.488981532684754,
              -28.873996329060727
            ],
            [
              -54.49230899470899,
              -28.874908720319393
            ],
            [
              -54.494600034135516,
              -28.87438049380122
            ],
            [
              -54.494600034135516,
              -28.872603731876445
            ],
            [
              -54.49269083461341,
              -28.87111509350704
            ],
            [
              -54.49198170336235,
              -28.86881010506409
            ],
            [
              -54.492199897593444,
              -28.8678016726203
            ],
            [
              -54.49569100529101,
              -28.866120951880646
            ],
            [
              -54.49700017067759,
              -28.86828187854591
            ],
            [
              -54.49967305000853,
              -28.86852198150872
            ],
            [
              -54.49978214712408,
              -28.871691340617776
            ],
            [
              -54.5022913807817,
              -28.870106661063247
            ],
            [
              -54.504473323092675,
              -28.868089796175667
            ],
            [
              -54.50540064857484,
              -28.86881010506409
            ],
            [
              -54.5086735620413,
              -28.873276020172305
            ],
            [
              -54.51009182454344,
              -28.87418841143097
            ],
            [
              -54.51238286396996,
              -28.872699773061566
            ],
            [
              -54.51538303464755,
              -28.868906146249213
            ],
            [
              -54.517619525516295,
              -28.868618022693845
            ],
            [
              -54.52301983273596,
              -28.870923011136792
            ],
            [
              -54.52301983273596,
              -28.86948239335995
            ],
            [
              -54.524601740911415,
              -28.867081363731877
            ],
            [
              -54.52842013995562,
              -28.867177404916998
            ],
            [
              -54.52940201399556,
              -28.859782233662536
            ],
            [
              -54.52722007168459,
              -28.859782233662536
            ],
            [
              -54.525801809182454,
              -28.858101512922882
            ],
            [
              -54.52831104284007,
              -28.857477245219584
            ],
            [
              -54.52940201399556,
              -28.85829359529313
            ],
            [
              -54.53180215053764,
              -28.858821821811304
            ],
            [
              -54.533602252944185,
              -28.857813389367514
            ],
            [
              -54.53747520054617,
              -28.854307886110526
            ],
            [
              -54.53862072025943,
              -28.85498017440639
            ],
            [
              -54.53840252602833,
              -28.85738120403446
            ],
            [
              -54.5410208568015,
              -28.859205986551796
            ],
            [
              -54.54211182795699,
              -28.858581718848498
            ],
            [
              -54.54107540535927,
              -28.857093080479093
            ],
            [
              -54.54200273084144,
              -28.85579652447993
            ],
            [
              -54.545493838539,
              -28.854884133221265
            ],
            [
              -54.54680300392558,
              -28.854211844925405
            ],
            [
              -54.54642116402116,
              -28.853203412481612
            ],
            [
              -54.5435846390169,
              -28.852291021222946
            ],
            [
              -54.54140269670592,
              -28.849697909224627
            ],
            [
              -54.5391116572794,
              -28.84950582685438
            ],
            [
              -54.53862072025943,
              -28.847392920781676
            ],
            [
              -54.54020262843488,
              -28.845280014708973
            ],
            [
              -54.54402102747909,
              -28.844991891153605
            ],
            [
              -54.54489380440348,
              -28.848593435595713
            ],
            [
              -54.545493838539,
              -28.849313744484135
            ],
            [
              -54.547075746714455,
              -28.848305312040345
            ],
            [
              -54.54767578084997,
              -28.844991891153605
            ],
            [
              -54.545821129885645,
              -28.84331117041395
            ],
            [
              -54.54642116402116,
              -28.84230273797016
            ],
            [
              -54.55302153951186,
              -28.84259086152553
            ],
            [
              -54.554494350571765,
              -28.8435032527842
            ],
            [
              -54.55618535586277,
              -28.847392920781676
            ],
            [
              -54.55711268134494,
              -28.847681044337044
            ],
            [
              -54.55918552654036,
              -28.846720632485816
            ],
            [
              -54.560603789042496,
              -28.844799808783357
            ],
            [
              -54.56071288615804,
              -28.842782943895777
            ],
            [
              -54.564313090971154,
              -28.84359929396932
            ],
            [
              -54.56518586789554,
              -28.843023046858583
            ],
            [
              -54.565076770779996,
              -28.83759671989914
            ],
            [
              -54.56709506741765,
              -28.83658828745535
            ],
            [
              -54.568404232804234,
              -28.83538777264131
            ],
            [
              -54.56938610684417,
              -28.835483813826436
            ],
            [
              -54.5705861751152,
              -28.8370204727884
            ],
            [
              -54.5735863457928,
              -28.83658828745535
            ],
            [
              -54.57429547704386,
              -28.8370204727884
            ],
            [
              -54.57462276839051,
              -28.838893275898297
            ],
            [
              -54.57680471070148,
              -28.83807692582475
            ],
            [
              -54.57767748762588,
              -28.836876411010717
            ],
            [
              -54.57680471070148,
              -28.834811525530572
            ],
            [
              -54.57429547704386,
              -28.832602578272745
            ],
            [
              -54.57402273425499,
              -28.828376766127338
            ],
            [
              -54.57222263184844,
              -28.82511136583316
            ],
            [
              -54.573313603003925,
              -28.824295015759613
            ],
            [
              -54.57609557945042,
              -28.82059743013238
            ],
            [
              -54.57609557945042,
              -28.81968503887371
            ],
            [
              -54.57478641406383,
              -28.816899844505148
            ],
            [
              -54.578713910223584,
              -28.81310621769279
            ],
            [
              -54.58542338282983,
              -28.81228986761925
            ],
            [
              -54.586405256869774,
              -28.813586423618407
            ],
            [
              -54.58689619388974,
              -28.81762015339357
            ],
            [
              -54.588096262160775,
              -28.818388482874553
            ],
            [
              -54.58989636456733,
              -28.816803803320024
            ],
            [
              -54.59120552995392,
              -28.80897644673251
            ],
            [
              -54.59567851169141,
              -28.805711046438326
            ],
            [
              -54.594587540535926,
              -28.8035020991805
            ],
            [
              -54.59109643283837,
              -28.802301584366464
            ],
            [
              -54.58662345110087,
              -28.80638333473419
            ],
            [
              -54.58089585253456,
              -28.80647937591931
            ],
            [
              -54.57849571599249,
              -28.804990737549904
            ],
            [
              -54.576586516470385,
              -28.80081294599706
            ],
            [
              -54.578713910223584,
              -28.79860399873923
            ],
            [
              -54.58040491551459,
              -28.798796081109476
            ],
            [
              -54.5840051203277,
              -28.803310016810254
            ],
            [
              -54.58689619388974,
              -28.802685749106956
            ],
            [
              -54.590114558798426,
              -28.79990055473839
            ],
            [
              -54.59158736985834,
              -28.79529057785249
            ],
            [
              -54.593387472264894,
              -28.793513815927717
            ],
            [
              -54.59191466120498,
              -28.791592992225258
            ],
            [
              -54.58629615975422,
              -28.793177671779784
            ],
            [
              -54.58220501792115,
              -28.790584559781465
            ],
            [
              -54.58291414917221,
              -28.789288003782307
            ],
            [
              -54.58727803379416,
              -28.7877993654129
            ],
            [
              -54.59049639870285,
              -28.78482208867409
            ],
            [
              -54.594696637651474,
              -28.784389903341037
            ],
            [
              -54.59638764294248,
              -28.786598850598864
            ],
            [
              -54.597915002560164,
              -28.786598850598864
            ],
            [
              -54.60058788189111,
              -28.784293862155916
            ],
            [
              -54.60189704727769,
              -28.78189283252784
            ],
            [
              -54.60287892131763,
              -28.781700750157597
            ],
            [
              -54.60718825738181,
              -28.782613141416263
            ],
            [
              -54.60920655401946,
              -28.787319159487286
            ],
            [
              -54.61149759344598,
              -28.78707905652448
            ],
            [
              -54.613079501621435,
              -28.786214685858372
            ],
            [
              -54.61367953575695,
              -28.784293862155916
            ],
            [
              -54.61171578767708,
              -28.779683885270014
            ],
            [
              -54.607679194401776,
              -28.779683885270014
            ],
            [
              -54.60467902372418,
              -28.777811082160117
            ],
            [
              -54.612206724697046,
              -28.774785784828744
            ],
            [
              -54.61929803720771,
              -28.77718681445682
            ],
            [
              -54.619679877112134,
              -28.776418484975835
            ],
            [
              -54.61438866700802,
              -28.770223828535407
            ],
            [
              -54.62109813961427,
              -28.76839904601807
            ],
            [
              -54.62562566990954,
              -28.769887684387477
            ],
            [
              -54.627098480969444,
              -28.76940747846186
            ],
            [
              -54.62540747567844,
              -28.764605419205715
            ],
            [
              -54.623716470387436,
              -28.76278063668838
            ],
            [
              -54.62087994538317,
              -28.761003874763606
            ],
            [
              -54.61640696364567,
              -28.759899401134692
            ],
            [
              -54.61727974057006,
              -28.753320579953773
            ],
            [
              -54.61007933094385,
              -28.74602144988443
            ],
            [
              -54.613406792968085,
              -28.745013017440638
            ],
            [
              -54.618425260283324,
              -28.739106484555577
            ],
            [
              -54.62388011606076,
              -28.73939460811095
            ],
            [
              -54.627807612220515,
              -28.73881836100021
            ],
            [
              -54.62829854924048,
              -28.74112334944316
            ],
            [
              -54.626225704045055,
              -28.74208376129439
            ],
            [
              -54.625680218467316,
              -28.74347635847867
            ],
            [
              -54.627098480969444,
              -28.74669373818029
            ],
            [
              -54.628189452124936,
              -28.748086335364572
            ],
            [
              -54.62988045741594,
              -28.74799029417945
            ],
            [
              -54.631898754053594,
              -28.746213532254675
            ],
            [
              -54.63489892473118,
              -28.746213532254675
            ],
            [
              -54.63828093531319,
              -28.745013017440638
            ],
            [
              -54.64079016897081,
              -28.74338031729355
            ],
            [
              -54.641717494452976,
              -28.741891678924144
            ],
            [
              -54.64100836320191,
              -28.73752180500105
            ],
            [
              -54.640081037719746,
              -28.734688590039923
            ],
            [
              -54.64029923195084,
              -28.73358411641101
            ],
            [
              -54.64351759685953,
              -28.732719745744905
            ],
            [
              -54.645426796381635,
              -28.733103910485397
            ],
            [
              -54.646299573306024,
              -28.733776198781257
            ],
            [
              -54.64608137907493,
              -28.73550494011347
            ],
            [
              -54.64940884109916,
              -28.738098052111788
            ],
            [
              -54.652790851681175,
              -28.740499081739863
            ],
            [
              -54.65671834784093,
              -28.73939460811095
            ],
            [
              -54.66010035842294,
              -28.73449650766968
            ],
            [
              -54.65879119303635,
              -28.733007869300273
            ],
            [
              -54.6569910906298,
              -28.732191519226728
            ],
            [
              -54.655681925243215,
              -28.730222674931706
            ],
            [
              -54.65617286226318,
              -28.727197377600337
            ],
            [
              -54.657700221880866,
              -28.724796347972262
            ],
            [
              -54.659391227171874,
              -28.724220100861526
            ],
            [
              -54.661082232462874,
              -28.725276553897878
            ],
            [
              -54.66239139784946,
              -28.724220100861526
            ],
            [
              -54.66299143198498,
              -28.72268344189956
            ],
            [
              -54.665173374295954,
              -28.721002721159905
            ],
            [
              -54.665173374295954,
              -28.716200661903763
            ],
            [
              -54.66860993343574,
              -28.715720455978147
            ],
            [
              -54.671282812766684,
              -28.716008579533515
            ],
            [
              -54.672482881037716,
              -28.717017011977305
            ],
            [
              -54.674173886328724,
              -28.71941804160538
            ],
            [
              -54.6737920464243,
              -28.721578968270645
            ],
            [
              -54.67488301757979,
              -28.72268344189956
            ],
            [
              -54.67548305171531,
              -28.724220100861526
            ],
            [
              -54.67471937190647,
              -28.72498843034251
            ],
            [
              -54.67521030892644,
              -28.727293418785457
            ],
            [
              -54.67450117767537,
              -28.728782057154863
            ],
            [
              -54.67471937190647,
              -28.729886530783777
            ],
            [
              -54.676192182966375,
              -28.732383601596975
            ],
            [
              -54.67548305171531,
              -28.737713887371296
            ],
            [
              -54.677392251237414,
              -28.740499081739863
            ],
            [
              -54.678701416623994,
              -28.740499081739863
            ],
            [
              -54.67897415941287,
              -28.743284276108426
            ],
            [
              -54.679792387779486,
              -28.745685305736497
            ],
            [
              -54.681483393070486,
              -28.74871060306787
            ],
            [
              -54.68361078682369,
              -28.749911117881908
            ],
            [
              -54.68491995221027,
              -28.752504229880227
            ],
            [
              -54.68688370029015,
              -28.752792353435595
            ],
            [
              -54.687701928656764,
              -28.753992868249632
            ],
            [
              -54.68797467144564,
              -28.75759441269174
            ],
            [
              -54.68950203106332,
              -28.759083051061147
            ],
            [
              -54.690102065198836,
              -28.761916266022272
            ],
            [
              -54.69157487625875,
              -28.762588554318135
            ],
            [
              -54.69392046424304,
              -28.766286139945365
            ],
            [
              -54.695011435398534,
              -28.766814366463542
            ],
            [
              -54.697411571940606,
              -28.76671832527842
            ],
            [
              -54.69801160607612,
              -28.76902331372137
            ],
            [
              -54.69648424645844,
              -28.771808508089933
            ],
            [
              -54.698284348864995,
              -28.773393187644462
            ],
            [
              -54.700684485407066,
              -28.774881826013868
            ],
            [
              -54.7021027479092,
              -28.775217970161798
            ],
            [
              -54.70412104454685,
              -28.77790712334524
            ],
            [
              -54.70630298685782,
              -28.782997306156755
            ],
            [
              -54.70832128349548,
              -28.78410177978567
            ],
            [
              -54.710175934459805,
              -28.785686459340198
            ],
            [
              -54.71192148830858,
              -28.790776642151712
            ],
            [
              -54.71279426523297,
              -28.791881115780626
            ],
            [
              -54.714321624850655,
              -28.795194536667367
            ],
            [
              -54.71377613927291,
              -28.79629901029628
            ],
            [
              -54.71459436763953,
              -28.798700039924352
            ],
            [
              -54.713885236388464,
              -28.799420348812774
            ],
            [
              -54.714321624850655,
              -28.80220554318134
            ],
            [
              -54.715412596006146,
              -28.8035020991805
            ],
            [
              -54.714321624850655,
              -28.805615005253205
            ],
            [
              -54.71290336234852,
              -28.807007602437487
            ],
            [
              -54.71361249359959,
              -28.812001744063878
            ],
            [
              -54.71339429936849,
              -28.814786938432444
            ],
            [
              -54.71372159071514,
              -28.818100359319185
            ],
            [
              -54.71317610513739,
              -28.81987712124396
            ],
            [
              -54.71121235705752,
              -28.82458313931498
            ],
            [
              -54.70952135176651,
              -28.8271762513133
            ],
            [
              -54.70881222051545,
              -28.830585713385165
            ],
            [
              -54.709412254650964,
              -28.83149810464383
            ],
            [
              -54.70832128349548,
              -28.834187257827274
            ],
            [
              -54.70788489503328,
              -28.83668432864047
            ],
            [
              -54.719176446492575,
              -28.84191857322967
            ],
            [
              -54.720485611879155,
              -28.84321512922883
            ],
            [
              -54.72250390851681,
              -28.844079499894935
            ],
            [
              -54.72719508448541,
              -28.84820927085522
            ],
            [
              -54.73128622631848,
              -28.850514259298173
            ],
            [
              -54.73412275132275,
              -28.85041821811305
            ],
            [
              -54.73941396142686,
              -28.853491536036984
            ],
            [
              -54.7403958354668,
              -28.85478809203614
            ],
            [
              -54.74552339989759,
              -28.855508400924563
            ],
            [
              -54.747105308073046,
              -28.85498017440639
            ],
            [
              -54.74999638163509,
              -28.85570048329481
            ],
            [
              -54.752778358081585,
              -28.853587577222104
            ],
            [
              -54.754905751834784,
              -28.854884133221265
            ],
            [
              -54.75801501962792,
              -28.856084648035303
            ],
            [
              -54.76161522444103,
              -28.859109945366672
            ],
            [
              -54.76352442396313,
              -28.860118377810466
            ],
            [
              -54.76548817204301,
              -28.86227930447573
            ],
            [
              -54.76701553166069,
              -28.863191695734397
            ],
            [
              -54.76788830858508,
              -28.865304601807104
            ],
            [
              -54.769688410991634,
              -28.865304601807104
            ],
            [
              -54.770779382147126,
              -28.86621699306577
            ],
            [
              -54.77148851339819,
              -28.868714063878965
            ],
            [
              -54.770397542242705,
              -28.86948239335995
            ],
            [
              -54.77148851339819,
              -28.87049082580374
            ],
            [
              -54.77159761051374,
              -28.871691340617776
            ],
            [
              -54.77448868407578,
              -28.87250769069132
            ],
            [
              -54.776179689366785,
              -28.872411649506198
            ],
            [
              -54.7791253114866,
              -28.87370820550536
            ],
            [
              -54.780325379757635,
              -28.87317997898718
            ],
            [
              -54.783925584570746,
              -28.87250769069132
            ],
            [
              -54.78648936678614,
              -28.872891855431813
            ],
            [
              -54.78910769755931,
              -28.87471663794915
            ],
            [
              -54.790580508619215,
              -28.875004761504517
            ],
            [
              -54.792326062468,
              -28.874476534986343
            ],
            [
              -54.794180713432326,
              -28.87471663794915
            ],
            [
              -54.79761727257211,
              -28.871691340617776
            ],
            [
              -54.80072654036525,
              -28.870010619878126
            ],
            [
              -54.80361761392729,
              -28.86981853750788
            ],
            [
              -54.806508687489334,
              -28.868906146249213
            ],
            [
              -54.808908824031406,
              -28.867081363731877
            ],
            [
              -54.81010889230244,
              -28.86660115780626
            ],
            [
              -54.81289086874893,
              -28.86852198150872
            ],
            [
              -54.815181908175454,
              -28.869098228619457
            ],
            [
              -54.815891039426525,
              -28.86852198150872
            ],
            [
              -54.81949124423963,
              -28.866697198991385
            ],
            [
              -54.82090950674176,
              -28.862807530993905
            ],
            [
              -54.821291346646184,
              -28.85930202773692
            ],
            [
              -54.822109575012796,
              -28.857189121664216
            ],
            [
              -54.824182420208224,
              -28.854692050851018
            ],
            [
              -54.83089189281447,
              -28.850610300483293
            ],
            [
              -54.83307383512545,
              -28.848305312040345
            ],
            [
              -54.834819388974225,
              -28.847921147299854
            ],
            [
              -54.836401297149685,
              -28.848689476780837
            ],
            [
              -54.83940146782727,
              -28.850994465223785
            ],
            [
              -54.84191070148489,
              -28.850994465223785
            ],
            [
              -54.843383512544804,
              -28.851378629964277
            ],
            [
              -54.84431083802696,
              -28.850610300483293
            ],
            [
              -54.84398354668032,
              -28.847200838411432
            ],
            [
              -54.843383512544804,
              -28.844703767598233
            ],
            [
              -54.84207434715822,
              -28.842014614414794
            ],
            [
              -54.84060153609831,
              -28.83730859634377
            ],
            [
              -54.841692507253796,
              -28.834619443160328
            ],
            [
              -54.84229254138931,
              -28.83409121664215
            ],
            [
              -54.847911042840074,
              -28.832890701828116
            ],
            [
              -54.84840197986004,
              -28.833322887161167
            ],
            [
              -54.84862017409114,
              -28.837116513973523
            ],
            [
              -54.850420276497694,
              -28.841102223156124
            ],
            [
              -54.85429322409968,
              -28.840093790712334
            ],
            [
              -54.85500235535074,
              -28.839181399453665
            ],
            [
              -54.85511145246629,
              -28.835483813826436
            ],
            [
              -54.857675234681686,
              -28.83409121664215
            ],
            [
              -54.859311691414916,
              -28.832218413532253
            ],
            [
              -54.861002696705924,
              -28.832122372347133
            ],
            [
              -54.86258460488138,
              -28.832986743013237
            ],
            [
              -54.86482109575012,
              -28.833322887161167
            ],
            [
              -54.86940317460317,
              -28.83898931708342
            ],
            [
              -54.873276122205155,
              -28.838413069972685
            ],
            [
              -54.87502167605393,
              -28.83990170834209
            ],
            [
              -54.87638538999829,
              -28.83990170834209
            ],
            [
              -54.87938556067588,
              -28.841102223156124
            ],
            [
              -54.8816766001024,
              -28.84359929396932
            ],
            [
              -54.88309486260454,
              -28.84321512922883
            ],
            [
              -54.883913090971156,
              -28.84129430552637
            ],
            [
              -54.88647687318655,
              -28.8370204727884
            ],
            [
              -54.885604096262156,
              -28.834523401975204
            ],
            [
              -54.8816766001024,
              -28.82909707501576
            ],
            [
              -54.8821129885646,
              -28.826407921832317
            ],
            [
              -54.88347670250896,
              -28.82491928346291
            ],
            [
              -54.8882769755931,
              -28.82491928346291
            ],
            [
              -54.89209537463731,
              -28.824487098129858
            ],
            [
              -54.8931863457928,
              -28.82227815087203
            ],
            [
              -54.893022700119474,
              -28.81930087413322
            ],
            [
              -54.89351363713944,
              -28.81762015339357
            ],
            [
              -54.89471370541048,
              -28.816083494431602
            ],
            [
              -54.896677453490355,
              -28.815507247320866
            ],
            [
              -54.90049585253456,
              -28.816419638579532
            ],
            [
              -54.902077760710014,
              -28.81762015339357
            ],
            [
              -54.90142317801673,
              -28.81968503887371
            ],
            [
              -54.901695920805594,
              -28.82290241857533
            ],
            [
              -54.90109588667008,
              -28.82808864257197
            ],
            [
              -54.90229595494112,
              -28.829385198571128
            ],
            [
              -54.90518702850316,
              -28.829385198571128
            ],
            [
              -54.90698713090971,
              -28.829001033830636
            ],
            [
              -54.91080552995392,
              -28.823718768648874
            ],
            [
              -54.912278341013824,
              -28.823286583315824
            ],
            [
              -54.91489667178699,
              -28.823478665686068
            ],
            [
              -54.919206007851166,
              -28.825015324648035
            ],
            [
              -54.92198798429766,
              -28.825303448203403
            ],
            [
              -54.926679160266254,
              -28.82261429501996
            ],
            [
              -54.92858835978836,
              -28.82511136583316
            ],
            [
              -54.93098849633043,
              -28.82578365412902
            ],
            [
              -54.931915821812595,
              -28.82391085101912
            ],
            [
              -54.935516026625706,
              -28.823286583315824
            ],
            [
              -54.93540692951015,
              -28.819396915318343
            ],
            [
              -54.93878894009217,
              -28.817380050430764
            ],
            [
              -54.9404253968254,
              -28.815507247320866
            ],
            [
              -54.943425567502985,
              -28.815123082580374
            ],
            [
              -54.947025772316096,
              -28.81598745324648
            ],
            [
              -54.947080320873866,
              -28.81728400924564
            ],
            [
              -54.95018958866701,
              -28.817091926875392
            ],
            [
              -54.95182604540024,
              -28.81401860895146
            ],
            [
              -54.95351705069124,
              -28.812577991174617
            ],
            [
              -54.95471711896228,
              -28.80940863206556
            ],
            [
              -54.9572263526199,
              -28.80840019962177
            ],
            [
              -54.96060836320191,
              -28.80840019962177
            ],
            [
              -54.96459040791944,
              -28.808304158436645
            ],
            [
              -54.96819061273255,
              -28.805903128808573
            ],
            [
              -54.969227035330256,
              -28.80321397562513
            ],
            [
              -54.97337272572111,
              -28.801389193107795
            ],
            [
              -54.97588195937873,
              -28.797691607480562
            ],
            [
              -54.981500460829494,
              -28.795194536667367
            ],
            [
              -54.98237323775388,
              -28.78938404496743
            ],
            [
              -54.98979184161119,
              -28.785878541710442
            ],
            [
              -54.991319201228876,
              -28.783381470897247
            ],
            [
              -54.99530124594641,
              -28.780788358898928
            ],
            [
              -54.99639221710189,
              -28.777715040974993
            ],
            [
              -55.00337443249701,
              -28.77598629964278
            ],
            [
              -55.00430175797918,
              -28.776082340827905
            ],
            [
              -55.00511998634579,
              -28.777811082160117
            ],
            [
              -55.00511998634579,
              -28.78410177978567
            ],
            [
              -55.00697463731012,
              -28.78972018911536
            ],
            [
              -55.007792865676734,
              -28.796491092666525
            ],
            [
              -55.011393070489845,
              -28.79591484555579
            ],
            [
              -55.01461143539853,
              -28.794282145408697
            ],
            [
              -55.0189207714627,
              -28.78871175667157
            ],
            [
              -55.021320908004775,
              -28.787703324227778
            ],
            [
              -55.024921112817886,
              -28.79831587518386
            ],
            [
              -55.0280849291688,
              -28.7988921222946
            ],
            [
              -55.033976173408426,
              -28.79821983399874
            ],
            [
              -55.03272155657962,
              -28.792505383483924
            ],
            [
              -55.03059416282642,
              -28.78938404496743
            ],
            [
              -55.03452165898617,
              -28.780692317713804
            ],
            [
              -55.03708544120157,
              -28.778003164530364
            ],
            [
              -55.04281303976788,
              -28.774401620088252
            ],
            [
              -55.04330397678785,
              -28.770511952090775
            ],
            [
              -55.04308578255675,
              -28.762684595503256
            ],
            [
              -55.04368581669227,
              -28.762204389577644
            ],
            [
              -55.047395118620926,
              -28.76470146039084
            ],
            [
              -55.05061348352961,
              -28.76441333683547
            ],
            [
              -55.056013790749276,
              -28.76671832527842
            ],
            [
              -55.058195733060245,
              -28.769599560832106
            ],
            [
              -55.06092316094897,
              -28.770800075646143
            ],
            [
              -55.06108680662229,
              -28.77392141416264
            ],
            [
              -55.06457791431985,
              -28.777378896827063
            ],
            [
              -55.067523536439666,
              -28.77718681445682
            ],
            [
              -55.07112374125277,
              -28.77617838201303
            ],
            [
              -55.07881508789896,
              -28.76839904601807
            ],
            [
              -55.07821505376344,
              -28.765998016389997
            ],
            [
              -55.07308748933265,
              -28.763404904391678
            ],
            [
              -55.0729783922171,
              -28.76119595713385
            ],
            [
              -55.077396825396825,
              -28.759419195209077
            ],
            [
              -55.08590640040963,
              -28.756682021433075
            ],
            [
              -55.086779177334016,
              -28.75389682706451
            ],
            [
              -55.086888274449564,
              -28.75130371506619
            ],
            [
              -55.09572514080901,
              -28.75130371506619
            ],
            [
              -55.09861621437105,
              -28.753512662324017
            ],
            [
              -55.10232551629971,
              -28.751399756251313
            ],
            [
              -55.10772582351937,
              -28.747606129438957
            ],
            [
              -55.11208970814132,
              -28.742515946627442
            ],
            [
              -55.11481713603004,
              -28.74241990544232
            ],
            [
              -55.12272667690732,
              -28.745301140996006
            ],
            [
              -55.12649052739375,
              -28.742900111367934
            ],
            [
              -55.13259996586448,
              -28.745013017440638
            ],
            [
              -55.13620017067759,
              -28.74270802899769
            ],
            [
              -55.13909124423963,
              -28.741219390628284
            ],
            [
              -55.14329148318826,
              -28.74040304055474
            ],
            [
              -55.15011005291005,
              -28.737905969741544
            ],
            [
              -55.15540126301416,
              -28.736705454927506
            ],
            [
              -55.15861962792285,
              -28.739298566925825
            ],
            [
              -55.15971059907834,
              -28.74241990544232
            ],
            [
              -55.161401604369345,
              -28.744916976255517
            ],
            [
              -55.16211073562041,
              -28.747221964698465
            ],
            [
              -55.164783614951354,
              -28.75168787980668
            ],
            [
              -55.174875098139616,
              -28.753800785879385
            ],
            [
              -55.176184263526196,
              -28.75461713595293
            ],
            [
              -55.17520238948626,
              -28.756393897877704
            ],
            [
              -55.17602061785287,
              -28.757690453876865
            ],
            [
              -55.184693838539,
              -28.76182022483715
            ],
            [
              -55.18671213517665,
              -28.761916266022272
            ],
            [
              -55.19167605393412,
              -28.757978577432233
            ],
            [
              -55.19271247653183,
              -28.756105774322336
            ],
            [
              -55.18791220344769,
              -28.753704744694264
            ],
            [
              -55.18300283324799,
              -28.749190808993486
            ],
            [
              -55.1844756443079,
              -28.74602144988443
            ],
            [
              -55.18742126642772,
              -28.745013017440638
            ],
            [
              -55.18900317460317,
              -28.743620420256356
            ],
            [
              -55.19167605393412,
              -28.736417331372138
            ],
            [
              -55.194294384707284,
              -28.73262370455978
            ],
            [
              -55.19151240826079,
              -28.72758154234083
            ],
            [
              -55.19358525345622,
              -28.72542061567556
            ],
            [
              -55.20067656596689,
              -28.723211668417733
            ],
            [
              -55.20302215395118,
              -28.72172303004833
            ],
            [
              -55.204385867895546,
              -28.71812148560622
            ],
            [
              -55.20749513568868,
              -28.711494643832737
            ],
            [
              -55.211804471752856,
              -28.71019808783358
            ],
            [
              -55.222005052056666,
              -28.713079323387266
            ],
            [
              -55.225387062638674,
              -28.711398602647616
            ],
            [
              -55.226205291005286,
              -28.70861340827905
            ],
            [
              -55.2246779313876,
              -28.704387596133643
            ],
            [
              -55.22631438812084,
              -28.70141031939483
            ],
            [
              -55.23198743812937,
              -28.69872116621139
            ],
            [
              -55.23269656938044,
              -28.696416177768437
            ],
            [
              -55.22691442225636,
              -28.691998283252783
            ],
            [
              -55.22309602321215,
              -28.676583673040554
            ],
            [
              -55.2229869260966,
              -28.669284542971212
            ],
            [
              -55.22587799965864,
              -28.666211225047277
            ],
            [
              -55.23007823860727,
              -28.66659538978777
            ],
            [
              -55.23258747226489,
              -28.672405881487705
            ],
            [
              -55.23569674005803,
              -28.674518787560412
            ],
            [
              -55.23798777948455,
              -28.675383158226516
            ],
            [
              -55.242188018433176,
              -28.677496064299223
            ],
            [
              -55.242678955453144,
              -28.67932084681656
            ],
            [
              -55.24098795016214,
              -28.682586247110738
            ],
            [
              -55.23607857996245,
              -28.685083317923933
            ],
            [
              -55.236024031404675,
              -28.687388306366884
            ],
            [
              -55.23858781362007,
              -28.68820465644043
            ],
            [
              -55.24529728622632,
              -28.688396738810674
            ],
            [
              -55.25331592421915,
              -28.69089380962387
            ],
            [
              -55.25380686123912,
              -28.68921308888422
            ],
            [
              -55.254025055470215,
              -28.68498727673881
            ],
            [
              -55.25538876941457,
              -28.68268228829586
            ],
            [
              -55.261007270865335,
              -28.67932084681656
            ],
            [
              -55.275026250213344,
              -28.672309840302585
            ],
            [
              -55.276989998293224,
              -28.67322223156125
            ],
            [
              -55.27769912954429,
              -28.676199508300062
            ],
            [
              -55.279390134835296,
              -28.6774000231141
            ],
            [
              -55.28009926608636,
              -28.681289691111576
            ],
            [
              -55.28271759685953,
              -28.68301843244379
            ],
            [
              -55.28582686465267,
              -28.681481773481824
            ],
            [
              -55.287626967059225,
              -28.678600537928137
            ],
            [
              -55.28779061273254,
              -28.675287117041396
            ],
            [
              -55.285281379074924,
              -28.672309840302585
            ],
            [
              -55.28451769926608,
              -28.668996419415844
            ],
            [
              -55.2870269329237,
              -28.666403307417525
            ],
            [
              -55.290899880525686,
              -28.665202792603488
            ],
            [
              -55.2981002901519,
              -28.667411739861315
            ],
            [
              -55.30317330602492,
              -28.671301407858792
            ],
            [
              -55.305682539682536,
              -28.672021716747217
            ],
            [
              -55.308191773340155,
              -28.670917243118303
            ],
            [
              -55.31451940604198,
              -28.66457852490019
            ],
            [
              -55.31599221710189,
              -28.657615538978778
            ],
            [
              -55.32057429595494,
              -28.655310550535827
            ],
            [
              -55.32259259259259,
              -28.65550263290607
            ],
            [
              -55.32461088923024,
              -28.656511065349864
            ],
            [
              -55.323301723843656,
              -28.659488342088675
            ],
            [
              -55.32351991807475,
              -28.660208650977097
            ],
            [
              -55.33050213346987,
              -28.667411739861315
            ],
            [
              -55.33339320703192,
              -28.666115183862157
            ],
            [
              -55.336884314729474,
              -28.666019142677033
            ],
            [
              -55.34070271377368,
              -28.66558695734398
            ],
            [
              -55.343811981566816,
              -28.667123616305947
            ],
            [
              -55.34517569551118,
              -28.66688351334314
            ],
            [
              -55.34719399214883,
              -28.663378010086152
            ],
            [
              -55.3476849291688,
              -28.660880939272957
            ],
            [
              -55.34632121522444,
              -28.65742345660853
            ],
            [
              -55.34697579791773,
              -28.65468628283253
            ],
            [
              -55.34599392387779,
              -28.652381294389578
            ],
            [
              -55.34621211810889,
              -28.65079661483505
            ],
            [
              -55.34779402628435,
              -28.64978818239126
            ],
            [
              -55.3559763099505,
              -28.64950005883589
            ],
            [
              -55.35668544120157,
              -28.650700573649925
            ],
            [
              -55.354012561870626,
              -28.652909520907752
            ],
            [
              -55.354503498890594,
              -28.655214509350703
            ],
            [
              -55.3559763099505,
              -28.657711580163898
            ],
            [
              -55.360285646014674,
              -28.65900813616306
            ],
            [
              -55.36361310803891,
              -28.660784898087833
            ],
            [
              -55.3647040791944,
              -28.66040073334734
            ],
            [
              -55.36530411332992,
              -28.658816053792812
            ],
            [
              -55.36519501621437,
              -28.656607106534985
            ],
            [
              -55.36612234169653,
              -28.654013994536665
            ],
            [
              -55.367595152756444,
              -28.65382191216642
            ],
            [
              -55.371686294589516,
              -28.655886797646563
            ],
            [
              -55.375013756613754,
              -28.657279394830848
            ],
            [
              -55.375777436422595,
              -28.657903662534146
            ],
            [
              -55.37381368834272,
              -28.66160124816138
            ],
            [
              -55.37528649940263,
              -28.666019142677033
            ],
            [
              -55.37910489844683,
              -28.667411739861315
            ],
            [
              -55.37970493258235,
              -28.66890037823072
            ],
            [
              -55.38161413210445,
              -28.668804337045596
            ],
            [
              -55.38461430278204,
              -28.665010710233243
            ],
            [
              -55.38919638163509,
              -28.663185927715908
            ],
            [
              -55.38968731865506,
              -28.66068885690271
            ],
            [
              -55.3947057859703,
              -28.65799970371927
            ],
            [
              -55.395524014336914,
              -28.656607106534985
            ],
            [
              -55.39508762587472,
              -28.653197644463123
            ],
            [
              -55.395414917221366,
              -28.65118077957554
            ],
            [
              -55.39770595664789,
              -28.650412450094557
            ],
            [
              -55.40032428742106,
              -28.649019852910275
            ],
            [
              -55.40217893838539,
              -28.650412450094557
            ],
            [
              -55.405779143198494,
              -28.651901088463962
            ],
            [
              -55.408179279740565,
              -28.651276820760664
            ],
            [
              -55.410197576378216,
              -28.64950005883589
            ],
            [
              -55.41221587301587,
              -28.649019852910275
            ],
            [
              -55.413906878306875,
              -28.650076305946627
            ],
            [
              -55.41439781532684,
              -28.653293685648244
            ],
            [
              -55.41499784946237,
              -28.655790756461442
            ],
            [
              -55.41630701484895,
              -28.656511065349864
            ],
            [
              -55.420889093701994,
              -28.654590241647405
            ],
            [
              -55.42138003072196,
              -28.653677850388735
            ],
            [
              -55.42072544802867,
              -28.650892656020172
            ],
            [
              -55.420889093701994,
              -28.64959610002101
            ],
            [
              -55.42388926437958,
              -28.649211935280523
            ],
            [
              -55.425798463901685,
              -28.65079661483505
            ],
            [
              -55.42972596006144,
              -28.650988697205296
            ],
            [
              -55.43698091824543,
              -28.649980264761503
            ],
            [
              -55.438508277863114,
              -28.650604532464804
            ],
            [
              -55.43839918074757,
              -28.652285253204454
            ],
            [
              -55.43458078170336,
              -28.653677850388735
            ],
            [
              -55.431089674005804,
              -28.655982838831687
            ],
            [
              -55.43141696535245,
              -28.657183353645724
            ],
            [
              -55.432726130739034,
              -28.657903662534146
            ],
            [
              -55.43452623314558,
              -28.66059281571759
            ],
            [
              -55.435180815838876,
              -28.66299384534566
            ],
            [
              -55.43539901006998,
              -28.666691430972893
            ],
            [
              -55.43588994708995,
              -28.667987986972054
            ],
            [
              -55.438017340843146,
              -28.66990881067451
            ],
            [
              -55.439708346134154,
              -28.672982128598445
            ],
            [
              -55.44281761392729,
              -28.674518787560412
            ],
            [
              -55.44609052739375,
              -28.675287117041396
            ],
            [
              -55.44658146441372,
              -28.674710869930657
            ],
            [
              -55.447890629800305,
              -28.669284542971212
            ],
            [
              -55.44958163509131,
              -28.667699863416683
            ],
            [
              -55.45132718894009,
              -28.666787472158017
            ],
            [
              -55.452909097115544,
              -28.666787472158017
            ],
            [
              -55.4547091995221,
              -28.6681800693423
            ],
            [
              -55.45547287933094,
              -28.668084028157175
            ],
            [
              -55.459400375490695,
              -28.6663072662324
            ],
            [
              -55.4613095750128,
              -28.664818627862996
            ],
            [
              -55.463873357228195,
              -28.663810195419206
            ],
            [
              -55.472001092336576,
              -28.664722586677872
            ],
            [
              -55.477892336576204,
              -28.667795904601807
            ],
            [
              -55.48007427888718,
              -28.668612254675352
            ],
            [
              -55.4825835125448,
              -28.668084028157175
            ],
            [
              -55.48460180918245,
              -28.663714154234082
            ],
            [
              -55.48482000341355,
              -28.6623215570498
            ],
            [
              -55.48629281447346,
              -28.661793330531623
            ],
            [
              -55.48711104284007,
              -28.662705721790292
            ],
            [
              -55.48880204813108,
              -28.663089886530784
            ],
            [
              -55.490983990442054,
              -28.664722586677872
            ],
            [
              -55.493002287079705,
              -28.668420172305105
            ],
            [
              -55.49447509813961,
              -28.672405881487705
            ],
            [
              -55.49360232121522,
              -28.675383158226516
            ],
            [
              -55.49562061785287,
              -28.677688146669468
            ],
            [
              -55.49600245775729,
              -28.678888661483505
            ],
            [
              -55.495020583717356,
              -28.680185217482663
            ],
            [
              -55.489402082266594,
              -28.680617402815717
            ],
            [
              -55.48869295101553,
              -28.681817917629754
            ],
            [
              -55.488092916880014,
              -28.684122906072705
            ],
            [
              -55.48782017409114,
              -28.68758038873713
            ],
            [
              -55.48907479091995,
              -28.690509644883377
            ],
            [
              -55.4932204813108,
              -28.69478347762135
            ],
            [
              -55.49780256016385,
              -28.697904816137843
            ],
            [
              -55.50058453661034,
              -28.69872116621139
            ],
            [
              -55.50249373613244,
              -28.69752065139735
            ],
            [
              -55.505275712578936,
              -28.694591395251102
            ],
            [
              -55.50871227171872,
              -28.693919106955242
            ],
            [
              -55.509912339989754,
              -28.694687436436226
            ],
            [
              -55.51198518518518,
              -28.697088466064297
            ],
            [
              -55.51247612220515,
              -28.698817207396512
            ],
            [
              -55.513894384707285,
              -28.70078605169153
            ],
            [
              -55.51482171018945,
              -28.70361926665266
            ],
            [
              -55.51460351595835,
              -28.706116337465854
            ],
            [
              -55.51651271548045,
              -28.70698070813196
            ],
            [
              -55.518421915002556,
              -28.704819781466693
            ],
            [
              -55.51978562894692,
              -28.70400343139315
            ],
            [
              -55.52229486260454,
              -28.70337916368985
            ],
            [
              -55.52398586789554,
              -28.700017722210546
            ],
            [
              -55.52567687318655,
              -28.69550378650977
            ],
            [
              -55.526222358764294,
              -28.693102756881697
            ],
            [
              -55.526222358764294,
              -28.690413603698257
            ],
            [
              -55.53009530636627,
              -28.686716018071024
            ],
            [
              -55.53162266598395,
              -28.686379873923094
            ],
            [
              -55.53342276839051,
              -28.689021006513972
            ],
            [
              -55.53647748762587,
              -28.692622550956084
            ],
            [
              -55.53582290493258,
              -28.696608260138685
            ],
            [
              -55.53680477897252,
              -28.69872116621139
            ],
            [
              -55.54127776071002,
              -28.701218237024584
            ],
            [
              -55.54438702850315,
              -28.704195513763395
            ],
            [
              -55.546678067929676,
              -28.705876234503048
            ],
            [
              -55.54978733572282,
              -28.707508934650136
            ],
            [
              -55.55660590544461,
              -28.700305845765918
            ],
            [
              -55.56167892131763,
              -28.696992424879177
            ],
            [
              -55.571988598736986,
              -28.694495354065978
            ],
            [
              -55.571988598736986,
              -28.693006715696576
            ],
            [
              -55.57018849633043,
              -28.6906056860685
            ],
            [
              -55.563915412186375,
              -28.68469915318344
            ],
            [
              -55.56369721795528,
              -28.683402597184283
            ],
            [
              -55.57302502133469,
              -28.676295549485186
            ],
            [
              -55.574497832394606,
              -28.67639159067031
            ],
            [
              -55.57547970643454,
              -28.680185217482663
            ],
            [
              -55.57651612903226,
              -28.681097608741332
            ],
            [
              -55.58540754394948,
              -28.68589966799748
            ],
            [
              -55.58840771462707,
              -28.689501212439588
            ],
            [
              -55.590916948284686,
              -28.69079776843875
            ],
            [
              -55.59331708482676,
              -28.689981418365203
            ],
            [
              -55.59631725550435,
              -28.686379873923094
            ],
            [
              -55.6025903396484,
              -28.68589966799748
            ],
            [
              -55.60668148148148,
              -28.684411029628073
            ],
            [
              -55.61660931899641,
              -28.677976270224836
            ],
            [
              -55.61830032428742,
              -28.67840845555789
            ],
            [
              -55.62490069977812,
              -28.68369072073965
            ],
            [
              -55.62730083632019,
              -28.684795194368565
            ],
            [
              -55.62877364738009,
              -28.684507070813197
            ],
            [
              -55.63428305171531,
              -28.676007425929818
            ],
            [
              -55.63591950844854,
              -28.671685572599284
            ],
            [
              -55.64170165557262,
              -28.66918850178609
            ],
            [
              -55.64868387096774,
              -28.66981276948939
            ],
            [
              -55.658993548387095,
              -28.672021716747217
            ],
            [
              -55.6628119474313,
              -28.67187765496953
            ],
            [
              -55.665975763782214,
              -28.670004851859634
            ],
            [
              -55.671103328213,
              -28.671589531414163
            ],
            [
              -55.67568540706605,
              -28.67149349022904
            ],
            [
              -55.68168574842123,
              -28.665682998529103
            ],
            [
              -55.68959528929851,
              -28.66328196890103
            ],
            [
              -55.69450465949821,
              -28.656511065349864
            ],
            [
              -55.69657750469363,
              -28.65478232401765
            ],
            [
              -55.69957767537122,
              -28.655982838831687
            ],
            [
              -55.704105205666494,
              -28.660208650977097
            ],
            [
              -55.707323570575184,
              -28.66160124816138
            ],
            [
              -55.71719685953234,
              -28.657807621349022
            ],
            [
              -55.71899696193889,
              -28.65607888001681
            ],
            [
              -55.719978835978836,
              -28.653101603278
            ],
            [
              -55.71277842635262,
              -28.64690694683757
            ],
            [
              -55.70759631336405,
              -28.6380231372137
            ],
            [
              -55.69968677248677,
              -28.627410586257618
            ],
            [
              -55.69979586960232,
              -28.626114030258456
            ],
            [
              -55.70181416623997,
              -28.625105597814667
            ],
            [
              -55.71032374125277,
              -28.624001124185753
            ],
            [
              -55.71697866530124,
              -28.626114030258456
            ],
            [
              -55.722488069636455,
              -28.625585803740282
            ],
            [
              -55.725379143198495,
              -28.622416444631224
            ],
            [
              -55.72559733742959,
              -28.619679270855222
            ],
            [
              -55.72357904079194,
              -28.61799855011557
            ],
            [
              -55.7247245605052,
              -28.61699011767178
            ],
            [
              -55.72832476531831,
              -28.61891094137424
            ],
            [
              -55.7313249359959,
              -28.62260852700147
            ],
            [
              -55.73317958696023,
              -28.622704568186595
            ],
            [
              -55.75461717016555,
              -28.59859823072074
            ],
            [
              -55.75838102065199,
              -28.59691750998109
            ],
            [
              -55.76269035671616,
              -28.59730167472158
            ],
            [
              -55.766017818740394,
              -28.596485324648036
            ],
            [
              -55.76950892643796,
              -28.594516480353015
            ],
            [
              -55.77092718894009,
              -28.59168326539189
            ],
            [
              -55.7724,
              -28.58520048539609
            ],
            [
              -55.77070899470899,
              -28.581406858583737
            ],
            [
              -55.769618023553505,
              -28.58351976465644
            ],
            [
              -55.76492684758491,
              -28.583999970582056
            ],
            [
              -55.76050841440519,
              -28.581694982139105
            ],
            [
              -55.75712640382318,
              -28.582079146879597
            ],
            [
              -55.75368984468339,
              -28.580302384954823
            ],
            [
              -55.75030783410138,
              -28.581502899768857
            ],
            [
              -55.745125721112814,
              -28.578093437696996
            ],
            [
              -55.7440892985151,
              -28.57660479932759
            ],
            [
              -55.73421600955794,
              -28.573195337255726
            ],
            [
              -55.733125038402456,
              -28.570602225257407
            ],
            [
              -55.72957938214712,
              -28.567576927926034
            ],
            [
              -55.730397610513734,
              -28.56349517755831
            ],
            [
              -55.728215668202765,
              -28.559413427190584
            ],
            [
              -55.72930663935825,
              -28.557396562303005
            ],
            [
              -55.728979348011606,
              -28.551778152973313
            ],
            [
              -55.72832476531831,
              -28.550481596974155
            ],
            [
              -55.72379723502304,
              -28.54841671149401
            ],
            [
              -55.718887864823344,
              -28.54870483504938
            ],
            [
              -55.71741505376344,
              -28.54639984660643
            ],
            [
              -55.715505854241336,
              -28.54639984660643
            ],
            [
              -55.71250568356375,
              -28.542222055053582
            ],
            [
              -55.706505342208565,
              -28.539004675351965
            ],
            [
              -55.70312333162656,
              -28.538380407648667
            ],
            [
              -55.70137777777777,
              -28.536795728094138
            ],
            [
              -55.697122990271374,
              -28.531417421727255
            ],
            [
              -55.695486533538144,
              -28.519700397142255
            ],
            [
              -55.68719515275644,
              -28.51518646144148
            ],
            [
              -55.67928561187916,
              -28.498283212859846
            ],
            [
              -55.662975593104626,
              -28.495978224416895
            ],
            [
              -55.65872080559822,
              -28.497995089304474
            ],
            [
              -55.65468421232292,
              -28.498379254044966
            ],
            [
              -55.64650192865677,
              -28.498187171674722
            ],
            [
              -55.635101280081926,
              -28.4962183273797
            ],
            [
              -55.63177381805769,
              -28.493193030048328
            ],
            [
              -55.62419156852705,
              -28.48839097079218
            ],
            [
              -55.61120901177675,
              -28.4869983736079
            ],
            [
              -55.6030267281106,
              -28.488679094347553
            ],
            [
              -55.59042601126472,
              -28.48839097079218
            ],
            [
              -55.58742584058713,
              -28.485509735238494
            ],
            [
              -55.583989281447344,
              -28.484309220424457
            ],
            [
              -55.577879842976614,
              -28.47710613154024
            ],
            [
              -55.570515787677074,
              -28.474993225467536
            ],
            [
              -55.568006554019455,
              -28.46927877495272
            ],
            [
              -55.554914900153605,
              -28.462123706661064
            ],
            [
              -55.55147834101382,
              -28.46111527421727
            ],
            [
              -55.54187779484553,
              -28.462411830216432
            ],
            [
              -55.52878614097969,
              -28.45780185333053
            ],
            [
              -55.523385833760024,
              -28.44819773481824
            ],
            [
              -55.522076668373444,
              -28.42951772431183
            ],
            [
              -55.524476804915516,
              -28.42399535616726
            ],
            [
              -55.52442225635774,
              -28.415207587728514
            ],
            [
              -55.517603686635944,
              -28.41242239335995
            ],
            [
              -55.506912169312166,
              -28.40320243958815
            ],
            [
              -55.50271193036354,
              -28.399792977516285
            ],
            [
              -55.50347561017238,
              -28.392301765076695
            ],
            [
              -55.50151186209251,
              -28.381689214120613
            ],
            [
              -55.499984502474824,
              -28.36608252153814
            ],
            [
              -55.50047543949479,
              -28.365218150872032
            ],
            [
              -55.509421402969785,
              -28.36209681235554
            ],
            [
              -55.51978562894692,
              -28.3516763437697
            ],
            [
              -55.52060385731353,
              -28.34778667577222
            ],
            [
              -55.52529503328213,
              -28.343416801849127
            ],
            [
              -55.51367619047619,
              -28.33688600126077
            ],
            [
              -55.511003311145245,
              -28.33630975415003
            ],
            [
              -55.50920320873869,
              -28.333476539188904
            ],
            [
              -55.50729400921659,
              -28.333716642151714
            ],
            [
              -55.50418474142345,
              -28.331219571338515
            ],
            [
              -55.50467567844342,
              -28.328482397562514
            ],
            [
              -55.504021095750126,
              -28.32699375919311
            ],
            [
              -55.49802075439494,
              -28.32051097919731
            ],
            [
              -55.497911657279396,
              -28.316285167051902
            ],
            [
              -55.49480238948626,
              -28.30999446942635
            ],
            [
              -55.49027485919098,
              -28.305288451355327
            ],
            [
              -55.48842020822666,
              -28.29991014498844
            ],
            [
              -55.48820201399556,
              -28.291794664845554
            ],
            [
              -55.49022031063321,
              -28.285984173145618
            ],
            [
              -55.487220139955625,
              -28.28108607270435
            ],
            [
              -55.48749288274449,
              -28.27517953981929
            ],
            [
              -55.48618371735791,
              -28.2722983042656
            ],
            [
              -55.47881966205837,
              -28.265815524269804
            ],
            [
              -55.46398245434374,
              -28.25688369405337
            ],
            [
              -55.46070954087728,
              -28.251697470056733
            ],
            [
              -55.4483270182625,
              -28.25318610842614
            ],
            [
              -55.4445086192183,
              -28.249200399243538
            ],
            [
              -55.44358129373613,
              -28.248816234503046
            ],
            [
              -55.43861737497866,
              -28.257315879386425
            ],
            [
              -55.43659907834101,
              -28.259284723681446
            ],
            [
              -55.429398668714796,
              -28.26989727463753
            ],
            [
              -55.423289230244066,
              -28.274411210338307
            ],
            [
              -55.418379860044375,
              -28.277004322336627
            ],
            [
              -55.414288718211296,
              -28.283006896406807
            ],
            [
              -55.41292500426694,
              -28.286320317293548
            ],
            [
              -55.41319774705581,
              -28.289585717587727
            ],
            [
              -55.409815736473796,
              -28.29457985921412
            ],
            [
              -55.40032428742106,
              -28.29981410380332
            ],
            [
              -55.39557856289469,
              -28.300918577432235
            ],
            [
              -55.386414405188596,
              -28.30480824542971
            ],
            [
              -55.38368697729988,
              -28.304904286614835
            ],
            [
              -55.38177777777778,
              -28.297220991805002
            ],
            [
              -55.38090500085339,
              -28.287184687959655
            ],
            [
              -55.37021348352961,
              -28.272490386635848
            ],
            [
              -55.36437678784775,
              -28.261589712124398
            ],
            [
              -55.359412869090285,
              -28.262213979827695
            ],
            [
              -55.35139423109745,
              -28.254098499684808
            ],
            [
              -55.35052145417306,
              -28.24660728724522
            ],
            [
              -55.34190278204471,
              -28.239404198361
            ],
            [
              -55.34201187916027,
              -28.237579415843665
            ],
            [
              -55.33252043010752,
              -28.222116785038875
            ],
            [
              -55.3325749786653,
              -28.22029200252154
            ],
            [
              -55.32668373442567,
              -28.21251266652658
            ],
            [
              -55.326520088752346,
              -28.209295286824965
            ],
            [
              -55.32188346134152,
              -28.20790268964068
            ],
            [
              -55.31811961085509,
              -28.208911122084473
            ],
            [
              -55.31571947431302,
              -28.204397186383694
            ],
            [
              -55.316374057006314,
              -28.203004589199413
            ],
            [
              -55.3281019969278,
              -28.203100630384533
            ],
            [
              -55.335684246458435,
              -28.206990298382014
            ],
            [
              -55.34070271377368,
              -28.204781351124186
            ],
            [
              -55.342120976275815,
              -28.20358083631015
            ],
            [
              -55.34277555896911,
              -28.1994030447573
            ],
            [
              -55.340484519542585,
              -28.19181579113259
            ],
            [
              -55.33732070319167,
              -28.190903399873925
            ],
            [
              -55.32968390510326,
              -28.194985150241646
            ],
            [
              -55.32837473971667,
              -28.19440890313091
            ],
            [
              -55.32592005461683,
              -28.188790493801218
            ],
            [
              -55.31648315412186,
              -28.18922267913427
            ],
            [
              -55.303609694487115,
              -28.17841804580794
            ],
            [
              -55.30050042669397,
              -28.175200666106324
            ],
            [
              -55.298809421402964,
              -28.171887245219583
            ],
            [
              -55.299573101211806,
              -28.171599121664215
            ],
            [
              -55.308191773340155,
              -28.174576398403026
            ],
            [
              -55.32319262672811,
              -28.176977428031098
            ],
            [
              -55.32308352961256,
              -28.182499796175666
            ],
            [
              -55.32848383683222,
              -28.18518894935911
            ],
            [
              -55.332793172896395,
              -28.185813217062407
            ],
            [
              -55.338520771462704,
              -28.184804784618617
            ],
            [
              -55.345393889742276,
              -28.174288274847658
            ],
            [
              -55.35019416282642,
              -28.173808068922042
            ],
            [
              -55.355703567161626,
              -28.175584830846816
            ],
            [
              -55.357285475337086,
              -28.17500858373608
            ],
            [
              -55.35870373783922,
              -28.172895677663373
            ],
            [
              -55.354503498890594,
              -28.162379167892414
            ],
            [
              -55.355703567161626,
              -28.16161083841143
            ],
            [
              -55.358976480628094,
              -28.161706879596554
            ],
            [
              -55.36132206861239,
              -28.164011868039506
            ],
            [
              -55.36410404505888,
              -28.165020300483295
            ],
            [
              -55.36617689025431,
              -28.164780197520486
            ],
            [
              -55.36857702679638,
              -28.161706879596554
            ],
            [
              -55.36857702679638,
              -28.15969001470897
            ],
            [
              -55.36748605564089,
              -28.15800929396932
            ],
            [
              -55.3666132787165,
              -28.153495358268543
            ],
            [
              -55.36770424987199,
              -28.15008589619668
            ],
            [
              -55.36699511862092,
              -28.14878934019752
            ],
            [
              -55.3608856801502,
              -28.14552393990334
            ],
            [
              -55.357721863799284,
              -28.14091396301744
            ],
            [
              -55.35761276668373,
              -28.139185221685228
            ],
            [
              -55.35499443591056,
              -28.133614832948098
            ],
            [
              -55.35668544120157,
              -28.13241431813406
            ],
            [
              -55.35750366956818,
              -28.130589535616725
            ],
            [
              -55.3559763099505,
              -28.122618117251523
            ],
            [
              -55.35657634408602,
              -28.121081458289556
            ],
            [
              -55.358485543608126,
              -28.12050521117882
            ],
            [
              -55.363504010923364,
              -28.12381863206556
            ],
            [
              -55.36530411332992,
              -28.124010714435805
            ],
            [
              -55.36617689025431,
              -28.12348248791763
            ],
            [
              -55.367976992660864,
              -28.118104181550745
            ],
            [
              -55.3685224782386,
              -28.115799193107797
            ],
            [
              -55.37059532343403,
              -28.115799193107797
            ],
            [
              -55.371686294589516,
              -28.118104181550745
            ],
            [
              -55.37419552824714,
              -28.12060125236394
            ],
            [
              -55.37648656767366,
              -28.121417602437486
            ],
            [
              -55.37888670421574,
              -28.120697293549064
            ],
            [
              -55.38608711384195,
              -28.114118472368144
            ],
            [
              -55.38739627922853,
              -28.11368628703509
            ],
            [
              -55.38957822153951,
              -28.115799193107797
            ],
            [
              -55.39039644990613,
              -28.13001328850599
            ],
            [
              -55.391378323946064,
              -28.130493494431605
            ],
            [
              -55.39557856289469,
              -28.129917247320865
            ],
            [
              -55.396614985492405,
              -28.12910089724732
            ],
            [
              -55.394596688854755,
              -28.122810199621767
            ],
            [
              -55.39432394606588,
              -28.120409169993696
            ],
            [
              -55.39519672299027,
              -28.118392305106113
            ],
            [
              -55.39672408260795,
              -28.116807625551587
            ],
            [
              -55.40250622973203,
              -28.115078884219372
            ],
            [
              -55.403215360983104,
              -28.113782328220214
            ],
            [
              -55.402997166752,
              -28.105810909855013
            ],
            [
              -55.39868783068783,
              -28.096686997268336
            ],
            [
              -55.39977880184332,
              -28.09529440008405
            ],
            [
              -55.40337900665642,
              -28.095822626602228
            ],
            [
              -55.406924662911756,
              -28.099376150451775
            ],
            [
              -55.41079761051374,
              -28.100288541710444
            ],
            [
              -55.41199767878477,
              -28.09788751208237
            ],
            [
              -55.40877931387609,
              -28.08967599075436
            ],
            [
              -55.40997938214712,
              -28.088619537718007
            ],
            [
              -55.41488875234681,
              -28.087803187644464
            ],
            [
              -55.4181071172555,
              -28.090780464383272
            ],
            [
              -55.42192551629971,
              -28.09980833578483
            ],
            [
              -55.423398327359614,
              -28.10081676822862
            ],
            [
              -55.42530752688172,
              -28.10048062408069
            ],
            [
              -55.42830769755931,
              -28.098511779785667
            ],
            [
              -55.42808950332821,
              -28.09390180289977
            ],
            [
              -55.428689537463725,
              -28.092077020382433
            ],
            [
              -55.43158061102577,
              -28.090396299642784
            ],
            [
              -55.43370800477897,
              -28.087419022903973
            ],
            [
              -55.43839918074757,
              -28.08631454927506
            ],
            [
              -55.43048963987028,
              -28.07618220424459
            ],
            [
              -55.42519842976617,
              -28.06801870350914
            ],
            [
              -55.42219825908858,
              -28.062208211809203
            ],
            [
              -55.41401597542242,
              -28.054620958184493
            ],
            [
              -55.40217893838539,
              -28.05020306366884
            ],
            [
              -55.390505547021675,
              -28.045208922042445
            ],
            [
              -55.37632292200034,
              -28.034980535826854
            ],
            [
              -55.37550469363372,
              -28.034020123975626
            ],
            [
              -55.36939525516299,
              -28.02729724101702
            ],
            [
              -55.36901341525857,
              -28.01908571968901
            ],
            [
              -55.3715226489162,
              -28.013995536877495
            ],
            [
              -55.38248690902884,
              -28.0004057091826
            ],
            [
              -55.38592346816863,
              -27.993922929186805
            ],
            [
              -55.38717808499744,
              -27.989985240596763
            ],
            [
              -55.38717808499744,
              -27.98619161378441
            ],
            [
              -55.38232326335552,
              -27.979084566085312
            ],
            [
              -55.37719569892473,
              -27.976491454086993
            ],
            [
              -55.36808608977641,
              -27.974810733347343
            ],
            [
              -55.35761276668373,
              -27.97341813616306
            ],
            [
              -55.34708489503328,
              -27.972217621349024
            ],
            [
              -55.33999358252261,
              -27.96650317083421
            ],
            [
              -55.339775388291514,
              -27.966022964908593
            ],
            [
              -55.33737525174944,
              -27.959876329060727
            ],
            [
              -55.335302406554014,
              -27.950320231140996
            ],
            [
              -55.33328410991636,
              -27.93932351544442
            ],
            [
              -55.330283939238775,
              -27.931496158856902
            ],
            [
              -55.32728376856119,
              -27.926694099600756
            ],
            [
              -55.31931967912613,
              -27.92189204034461
            ],
            [
              -55.309391841611195,
              -27.92218016389998
            ],
            [
              -55.30050042669397,
              -27.925301502416474
            ],
            [
              -55.29280908004779,
              -27.929623355747005
            ],
            [
              -55.28582686465267,
              -27.932312508930448
            ],
            [
              -55.277808226659836,
              -27.932888756041184
            ],
            [
              -55.27529899300222,
              -27.93308083841143
            ],
            [
              -55.26651667520054,
              -27.929815438117252
            ],
            [
              -55.25789800307219,
              -27.922084122714857
            ],
            [
              -55.25009755931046,
              -27.914208745534776
            ],
            [
              -55.24567912613074,
              -27.905997224206764
            ],
            [
              -55.24038791602663,
              -27.898698094137423
            ],
            [
              -55.236896808329064,
              -27.89101479932759
            ],
            [
              -55.232314729476016,
              -27.88409983399874
            ],
            [
              -55.224896125618706,
              -27.877088827484766
            ],
            [
              -55.21289544290834,
              -27.867580750157597
            ],
            [
              -55.21011346646185,
              -27.863498999789872
            ],
            [
              -55.20269486260454,
              -27.85788059046018
            ],
            [
              -55.191403311145244,
              -27.855383519646985
            ],
            [
              -55.18049359959037,
              -27.85720830216432
            ],
            [
              -55.17160218467315,
              -27.861290052532045
            ],
            [
              -55.16571094043352,
              -27.866908461861737
            ],
            [
              -55.16167434715822,
              -27.874687797856694
            ],
            [
              -55.15338296637651,
              -27.882611195629334
            ],
            [
              -55.14530977982591,
              -27.889478140365622
            ],
            [
              -55.139309438470725,
              -27.895096549695314
            ],
            [
              -55.13309090288445,
              -27.896104982139104
            ],
            [
              -55.128181532684756,
              -27.893896034881276
            ],
            [
              -55.125399556238264,
              -27.887893460811096
            ],
            [
              -55.12398129373613,
              -27.88150672200042
            ],
            [
              -55.125290459122716,
              -27.875119983189744
            ],
            [
              -55.12621778460488,
              -27.869885738600548
            ],
            [
              -55.12730875576037,
              -27.864603473418786
            ],
            [
              -55.12632688172043,
              -27.85980141416264
            ],
            [
              -55.120817477385216,
              -27.853990922462703
            ],
            [
              -55.11378071343233,
              -27.84899678083631
            ],
            [
              -55.101125448028675,
              -27.846019504097498
            ],
            [
              -55.09108851339819,
              -27.843186289136373
            ],
            [
              -55.085306366274104,
              -27.84309024795125
            ],
            [
              -55.078324150878984,
              -27.84501107165371
            ],
            [
              -55.06697805086192,
              -27.846883874763606
            ],
            [
              -55.05677747055812,
              -27.850005213280102
            ],
            [
              -55.0517044546851,
              -27.852406242908174
            ],
            [
              -55.04439494794333,
              -27.855911746165162
            ],
            [
              -55.036376309950505,
              -27.857784549275056
            ],
            [
              -55.029775934459806,
              -27.854615190166
            ],
            [
              -55.02557569551118,
              -27.848420533725573
            ],
            [
              -55.02437562724014,
              -27.842177856692583
            ],
            [
              -55.02470291858679,
              -27.83531091195629
            ],
            [
              -55.02759399214883,
              -27.830220729144777
            ],
            [
              -55.03430346475508,
              -27.82469836100021
            ],
            [
              -55.04281303976788,
              -27.820184425299434
            ],
            [
              -55.05290452295613,
              -27.81610267493171
            ],
            [
              -55.06217777777778,
              -27.810484265602017
            ],
            [
              -55.07030551288616,
              -27.803521279680606
            ],
            [
              -55.07728772828128,
              -27.799919735238497
            ],
            [
              -55.08268803550094,
              -27.796894437907124
            ],
            [
              -55.08421539511862,
              -27.791996337465854
            ],
            [
              -55.083888103771976,
              -27.784120960285776
            ],
            [
              -55.08017880184332,
              -27.778310468585836
            ],
            [
              -55.07308748933265,
              -27.773700491699937
            ],
            [
              -55.06528704557091,
              -27.77048311199832
            ],
            [
              -55.05792299027138,
              -27.768082082370245
            ],
            [
              -55.05088622631848,
              -27.768802391258667
            ],
            [
              -55.0451040791944,
              -27.7724999768859
            ],
            [
              -55.038503703703704,
              -27.779222859844506
            ],
            [
              -55.031194196961934,
              -27.788106669468377
            ],
            [
              -55.02432107868237,
              -27.79420528472368
            ],
            [
              -55.01417504693634,
              -27.796990479092248
            ],
            [
              -55.00577456903908,
              -27.796222149611264
            ],
            [
              -55.000319713261646,
              -27.792380502206345
            ],
            [
              -54.99928329066393,
              -27.790507699096448
            ],
            [
              -54.99737409114183,
              -27.78690615465434
            ],
            [
              -54.9955194401775,
              -27.780279312880857
            ],
            [
              -54.993010206519884,
              -27.77547725362471
            ],
            [
              -54.98880996757126,
              -27.772211853330532
            ],
            [
              -54.983573306024915,
              -27.770723214961127
            ],
            [
              -54.97768206178529,
              -27.77091529733137
            ],
            [
              -54.97031800648575,
              -27.774612882958603
            ],
            [
              -54.96088110599078,
              -27.778502550956084
            ],
            [
              -54.94942590885817,
              -27.77931890102963
            ],
            [
              -54.9374252261478,
              -27.77048311199832
            ],
            [
              -54.92929749103943,
              -27.75641307837781
            ],
            [
              -54.92149704727769,
              -27.74560844505148
            ],
            [
              -54.91538760880696,
              -27.738117232611895
            ],
            [
              -54.90660529100529,
              -27.72980967009876
            ],
            [
              -54.90251414917221,
              -27.71559557470057
            ],
            [
              -54.90218685782557,
              -27.702485952931287
            ],
            [
              -54.90289598907663,
              -27.698884408489178
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "mesorregiao_nome": "Nordeste Rio-grandense",
        "mesorregiao_id": 4302,
        "num_municipios": 54
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -51.91831356745244,
              -29.02291102847516
            ],
            [
              -51.918880200110976,
              -29.02529414060895
            ],
            [
              -51.91788859295853,
              -29.02850945063073
            ],
            [
              -51.917983031734956,
              -29.03119518017833
            ],
            [
              -51.91751083785284,
              -29.034107872786294
            ],
            [
              -51.91330831230199,
              -29.04171113530838
            ],
            [
              -51.913497189854844,
              -29.042316370136007
            ],
            [
              -51.917794154182104,
              -29.0495035337141
            ],
            [
              -51.91769971540568,
              -29.057598549533633
            ],
            [
              -51.91670810825324,
              -29.059981661667422
            ],
            [
              -51.91769971540568,
              -29.062289119447755
            ],
            [
              -51.92360213893215,
              -29.065617910999713
            ],
            [
              -51.926293644060216,
              -29.068417122077495
            ],
            [
              -51.92591588895452,
              -29.074885569297777
            ],
            [
              -51.954719715763666,
              -29.074809914944325
            ],
            [
              -51.955286348422206,
              -29.073410309405432
            ],
            [
              -51.952594843294136,
              -29.072086358219995
            ],
            [
              -51.952594843294136,
              -29.070989370094917
            ],
            [
              -51.954719715763666,
              -29.069287147142212
            ],
            [
              -51.955286348422206,
              -29.067811887249867
            ],
            [
              -51.95580576169253,
              -29.06331045321938
            ],
            [
              -51.96029160357265,
              -29.061797366150305
            ],
            [
              -51.96241647604217,
              -29.057787685417267
            ],
            [
              -51.96388027707673,
              -29.056388079878374
            ],
            [
              -51.96558017505236,
              -29.053702350330774
            ],
            [
              -51.96501354239382,
              -29.051092275136625
            ],
            [
              -51.96728007302798,
              -29.049806151127914
            ],
            [
              -51.96770504752188,
              -29.04901178041665
            ],
            [
              -51.967091195475135,
              -29.047309557463944
            ],
            [
              -51.967091195475135,
              -29.043186395200724
            ],
            [
              -51.96770504752188,
              -29.042392024489462
            ],
            [
              -51.969688261826775,
              -29.042392024489462
            ],
            [
              -51.96931050672108,
              -29.0406141471833
            ],
            [
              -51.970018797544256,
              -29.03910106011423
            ],
            [
              -52.00590553258516,
              -29.039403677528043
            ],
            [
              -52.02111017558933,
              -29.03970629494186
            ],
            [
              -52.0226211960121,
              -29.038117553519335
            ],
            [
              -52.024084997046664,
              -29.03838234375642
            ],
            [
              -52.02550157869302,
              -29.037285355631344
            ],
            [
              -52.02927912974995,
              -29.03781493610552
            ],
            [
              -52.03008185934955,
              -29.03709621974771
            ],
            [
              -52.02998742057313,
              -29.03520486091137
            ],
            [
              -52.030695711396305,
              -29.034788761967377
            ],
            [
              -52.033387216524375,
              -29.034902243497555
            ],
            [
              -52.034520481841454,
              -29.034183527139746
            ],
            [
              -52.035181553276416,
              -29.028698586514363
            ],
            [
              -52.036409257369925,
              -29.026391128734026
            ],
            [
              -52.03650369614635,
              -29.024310634014054
            ],
            [
              -52.03872300739229,
              -29.0221166577639
            ],
            [
              -52.03938407882726,
              -29.019582236923203
            ],
            [
              -52.04132007374394,
              -29.017917841147224
            ],
            [
              -52.04481430847161,
              -29.017690878086864
            ],
            [
              -52.047222497270404,
              -29.01871221185849
            ],
            [
              -52.047222497270404,
              -29.019809199983566
            ],
            [
              -52.048686298304965,
              -29.020603570694828
            ],
            [
              -52.0459947931769,
              -29.05771203106381
            ],
            [
              -52.047789129928944,
              -29.05740941365
            ],
            [
              -52.049583466680986,
              -29.057901166947445
            ],
            [
              -52.051708339150515,
              -29.05930077248634
            ],
            [
              -52.052511068750114,
              -29.06081385955541
            ],
            [
              -52.05388043100825,
              -29.06058689649505
            ],
            [
              -52.05468316060785,
              -29.05941425401652
            ],
            [
              -52.05718578818308,
              -29.059489908369972
            ],
            [
              -52.058319053500156,
              -29.05880901918889
            ],
            [
              -52.0572802269595,
              -29.092702169536096
            ],
            [
              -52.078103977160865,
              -29.092815651066278
            ],
            [
              -52.078103977160865,
              -29.09028123022558
            ],
            [
              -52.08929497216704,
              -29.086914611496898
            ],
            [
              -52.089814385437364,
              -29.108211311994083
            ],
            [
              -52.09222257423616,
              -29.106282125981018
            ],
            [
              -52.09368637527073,
              -29.106811706455193
            ],
            [
              -52.09368637527073,
              -29.10518513785594
            ],
            [
              -52.095291834469926,
              -29.10469338455849
            ],
            [
              -52.0976055844923,
              -29.10268854419197
            ],
            [
              -52.10190254881956,
              -29.100986321239265
            ],
            [
              -52.1056800998765,
              -29.09811145580803
            ],
            [
              -52.10558566110008,
              -29.097203603566587
            ],
            [
              -52.1064828294761,
              -29.09531224473025
            ],
            [
              -52.10841882439278,
              -29.095690516497516
            ],
            [
              -52.1093159927688,
              -29.0975062209804
            ],
            [
              -52.11191305912045,
              -29.096598368738956
            ],
            [
              -52.11649333977698,
              -29.09599313391133
            ],
            [
              -52.1181932377526,
              -29.095009627316433
            ],
            [
              -52.11960981939895,
              -29.0953878990837
            ],
            [
              -52.12201800819775,
              -29.093193922833546
            ],
            [
              -52.124095661279064,
              -29.092702169536096
            ],
            [
              -52.12499282965509,
              -29.089789476928136
            ],
            [
              -52.12607887558396,
              -29.089297723630686
            ],
            [
              -52.125087268431514,
              -29.087217228910713
            ],
            [
              -52.12792043172421,
              -29.08441801783293
            ],
            [
              -52.13089525318155,
              -29.085893277725276
            ],
            [
              -52.132500712380754,
              -29.084909771130377
            ],
            [
              -52.13320900320392,
              -29.086385031022722
            ],
            [
              -52.1347200236267,
              -29.086611994083086
            ],
            [
              -52.136797676708014,
              -29.08820073550561
            ],
            [
              -52.138119819577945,
              -29.08831421703579
            ],
            [
              -52.1419918094113,
              -29.08680112996672
            ],
            [
              -52.14411668188083,
              -29.086498512552904
            ],
            [
              -52.14661930945605,
              -29.08509890701401
            ],
            [
              -52.14949969213696,
              -29.086006759255454
            ],
            [
              -52.15157734521828,
              -29.087784636561615
            ],
            [
              -52.16078512591957,
              -29.088616834449603
            ],
            [
              -52.16550706474074,
              -29.088805970333237
            ],
            [
              -52.16791525353953,
              -29.09198345317829
            ],
            [
              -52.16819856986881,
              -29.096711850269138
            ],
            [
              -52.168009692315955,
              -29.09928409828656
            ],
            [
              -52.16829300864523,
              -29.10079718535563
            ],
            [
              -52.17018178417369,
              -29.102802025722152
            ],
            [
              -52.17107895254972,
              -29.104996001972307
            ],
            [
              -52.17438430972454,
              -29.107492595636273
            ],
            [
              -52.17698137607618,
              -29.107000842338827
            ],
            [
              -52.17972010059246,
              -29.107681731519907
            ],
            [
              -52.18330877409655,
              -29.10828696634754
            ],
            [
              -52.187889054753086,
              -29.108703065291532
            ],
            [
              -52.18831402924699,
              -29.11051876977442
            ],
            [
              -52.19190270275108,
              -29.110291806714056
            ],
            [
              -52.19379147827955,
              -29.112788400378026
            ],
            [
              -52.19412201399703,
              -29.115398475572174
            ],
            [
              -52.195113621149474,
              -29.116798081111067
            ],
            [
              -52.19771068750112,
              -29.113809734149648
            ],
            [
              -52.19908004975926,
              -29.110897041541687
            ],
            [
              -52.201393799781634,
              -29.109989189300244
            ],
            [
              -52.205879641661745,
              -29.112183165550398
            ],
            [
              -52.2064934937085,
              -29.110897041541687
            ],
            [
              -52.20578520288532,
              -29.10881654682171
            ],
            [
              -52.20399086613328,
              -29.105109483502485
            ],
            [
              -52.20389642735685,
              -29.10049456794182
            ],
            [
              -52.20219652938123,
              -29.099397579816742
            ],
            [
              -52.19671908034868,
              -29.097317085096766
            ],
            [
              -52.19591635074908,
              -29.095917479557876
            ],
            [
              -52.197994003830395,
              -29.09489614578625
            ],
            [
              -52.20158267733448,
              -29.095085281669885
            ],
            [
              -52.20469915695645,
              -29.094290910958623
            ],
            [
              -52.20639905493208,
              -29.09410177507499
            ],
            [
              -52.20838226923697,
              -29.09459352837244
            ],
            [
              -52.21041270293007,
              -29.095803998027694
            ],
            [
              -52.21201816212927,
              -29.09561486214406
            ],
            [
              -52.21230147845854,
              -29.09459352837244
            ],
            [
              -52.21220703968211,
              -29.092815651066278
            ],
            [
              -52.21079045803577,
              -29.09028123022558
            ],
            [
              -52.20861836617803,
              -29.08759550067798
            ],
            [
              -52.20677681003777,
              -29.086006759255454
            ],
            [
              -52.206682371261344,
              -29.0847962896002
            ],
            [
              -52.20951553455405,
              -29.08358581994494
            ],
            [
              -52.211404310082514,
              -29.08358581994494
            ],
            [
              -52.214190253987006,
              -29.08241317746641
            ],
            [
              -52.22009267751347,
              -29.078214360849735
            ],
            [
              -52.221603697936246,
              -29.076701273780664
            ],
            [
              -52.22042321323095,
              -29.076209520483214
            ],
            [
              -52.21489854481018,
              -29.078214360849735
            ],
            [
              -52.211593187635366,
              -29.07840349673337
            ],
            [
              -52.20909056006014,
              -29.080294855569708
            ],
            [
              -52.207012906978825,
              -29.08018137403953
            ],
            [
              -52.20469915695645,
              -29.072918556107986
            ],
            [
              -52.206304616155656,
              -29.072010703866543
            ],
            [
              -52.20918499883657,
              -29.072086358219995
            ],
            [
              -52.21149874885894,
              -29.07261593869417
            ],
            [
              -52.21338752438741,
              -29.072313321280355
            ],
            [
              -52.21848721831427,
              -29.070005863500022
            ],
            [
              -52.2230202795826,
              -29.068984529728397
            ],
            [
              -52.2238230091822,
              -29.068114504663683
            ],
            [
              -52.2230202795826,
              -29.066790553478242
            ],
            [
              -52.22051765200738,
              -29.06550442946953
            ],
            [
              -52.21848721831427,
              -29.063688724986648
            ],
            [
              -52.21820390198501,
              -29.062289119447755
            ],
            [
              -52.215984590739055,
              -29.061494748736493
            ],
            [
              -52.21470966725734,
              -29.062289119447755
            ],
            [
              -52.21381249888132,
              -29.06410482393064
            ],
            [
              -52.21031826415365,
              -29.06281869992193
            ],
            [
              -52.20979885088332,
              -29.06209998356412
            ],
            [
              -52.20918499883657,
              -29.05869553765871
            ],
            [
              -52.21031826415365,
              -29.056085462464562
            ],
            [
              -52.21031826415365,
              -29.0543075851584
            ],
            [
              -52.208901682507296,
              -29.05090313925299
            ],
            [
              -52.21088489681219,
              -29.049692669597732
            ],
            [
              -52.21319864683456,
              -29.049390052183917
            ],
            [
              -52.21452078970449,
              -29.05018442289518
            ],
            [
              -52.21721229483256,
              -29.052983633972964
            ],
            [
              -52.21947882546672,
              -29.05351321444714
            ],
            [
              -52.22268974386512,
              -29.05018442289518
            ],
            [
              -52.2217925754891,
              -29.04829306405884
            ],
            [
              -52.21999823873705,
              -29.0473852118174
            ],
            [
              -52.21678732033865,
              -29.047309557463944
            ],
            [
              -52.21570127440978,
              -29.04689345851995
            ],
            [
              -52.21489854481018,
              -29.045493852981057
            ],
            [
              -52.21532351930409,
              -29.039895430825492
            ],
            [
              -52.2165984427858,
              -29.039290195997864
            ],
            [
              -52.220706529560225,
              -29.041597653778197
            ],
            [
              -52.22608953981636,
              -29.042013752722195
            ],
            [
              -52.22760056023913,
              -29.041597653778197
            ],
            [
              -52.228119973509465,
              -29.040689801536754
            ],
            [
              -52.225995101039935,
              -29.03781493610552
            ],
            [
              -52.223398034688294,
              -29.03471310761392
            ],
            [
              -52.219384386690294,
              -29.032594785717222
            ],
            [
              -52.21730673360898,
              -29.030892562764514
            ],
            [
              -52.214992983586605,
              -29.026693746147842
            ],
            [
              -52.218912192808176,
              -29.02529414060895
            ],
            [
              -52.22098984588949,
              -29.024083670953694
            ],
            [
              -52.22552290715782,
              -29.0199983358672
            ],
            [
              -52.22651451431027,
              -29.018901347742123
            ],
            [
              -52.22892270310906,
              -29.017917841147224
            ],
            [
              -52.229819871485084,
              -29.017085643259236
            ],
            [
              -52.22849772861515,
              -29.015686037720343
            ],
            [
              -52.22528681021676,
              -29.01538342030653
            ],
            [
              -52.2230202795826,
              -29.013908160414186
            ],
            [
              -52.22051765200738,
              -29.01088198627604
            ],
            [
              -52.215087422363034,
              -29.01171418416403
            ],
            [
              -52.21480410603376,
              -29.010692850392406
            ],
            [
              -52.21792058565573,
              -29.007099268603362
            ],
            [
              -52.218912192808176,
              -29.00509442823684
            ],
            [
              -52.22198145304194,
              -29.00240869868924
            ],
            [
              -52.22481461633464,
              -29.00040385832272
            ],
            [
              -52.22722280513344,
              -28.999306870197643
            ],
            [
              -52.231614208237126,
              -28.99851249948638
            ],
            [
              -52.232511376613154,
              -28.99718854830094
            ],
            [
              -52.23208640211924,
              -28.996091560175863
            ],
            [
              -52.23062260108468,
              -28.994994572050786
            ],
            [
              -52.227883876568406,
              -28.99378410239553
            ],
            [
              -52.22538124899318,
              -28.992308842503185
            ],
            [
              -52.22438964184074,
              -28.991098372847926
            ],
            [
              -52.22481461633464,
              -28.988904396597775
            ],
            [
              -52.22878104494443,
              -28.98939614989522
            ],
            [
              -52.2302920653672,
              -28.988904396597775
            ],
            [
              -52.23081147863753,
              -28.9873913095287
            ],
            [
              -52.23081147863753,
              -28.98421382668365
            ],
            [
              -52.22859216739158,
              -28.975589230389943
            ],
            [
              -52.22708114696881,
              -28.972600883428527
            ],
            [
              -52.226986708192385,
              -28.97150389530345
            ],
            [
              -52.22830885106231,
              -28.970104289764556
            ],
            [
              -52.229583774544025,
              -28.970709524592184
            ],
            [
              -52.231614208237126,
              -28.974000488967416
            ],
            [
              -52.23912209096279,
              -28.975513576036487
            ],
            [
              -52.240397014444504,
              -28.9746813781485
            ],
            [
              -52.23987760117418,
              -28.973811353083782
            ],
            [
              -52.23477790724731,
              -28.972109130131077
            ],
            [
              -52.23440015214162,
              -28.968704684225663
            ],
            [
              -52.23690277971684,
              -28.96851554834203
            ],
            [
              -52.23987760117418,
              -28.971693031187083
            ],
            [
              -52.24101086649126,
              -28.97180651271726
            ],
            [
              -52.24450510121893,
              -28.96980167235074
            ],
            [
              -52.24478841754819,
              -28.968893820109297
            ],
            [
              -52.2423802287494,
              -28.96639722644533
            ],
            [
              -52.24389124917217,
              -28.962803644656287
            ],
            [
              -52.246204999194546,
              -28.962690163126105
            ],
            [
              -52.248802065546194,
              -28.96488413937626
            ],
            [
              -52.25031308596897,
              -28.96450586760899
            ],
            [
              -52.25517668295477,
              -28.959890952048323
            ],
            [
              -52.25838760135317,
              -28.959890952048323
            ],
            [
              -52.25980418299952,
              -28.961101421703578
            ],
            [
              -52.26122076464587,
              -28.960193569462135
            ],
            [
              -52.26131520342229,
              -28.95860482803961
            ],
            [
              -52.25928476972919,
              -28.956713469203272
            ],
            [
              -52.25739599420072,
              -28.95198507211242
            ],
            [
              -52.26277900445686,
              -28.947597119612112
            ],
            [
              -52.26660377490201,
              -28.94740798372848
            ],
            [
              -52.267689820830874,
              -28.94540314336196
            ],
            [
              -52.26669821367843,
              -28.941998697456548
            ],
            [
              -52.26721762694876,
              -28.93961558532276
            ],
            [
              -52.26551772897314,
              -28.93821597978387
            ],
            [
              -52.262401249351164,
              -28.93851859719768
            ],
            [
              -52.26211793302189,
              -28.935908522003533
            ],
            [
              -52.260701351375545,
              -28.934508916464644
            ],
            [
              -52.26079579015197,
              -28.9326175576283
            ],
            [
              -52.27052298412358,
              -28.932693211981757
            ],
            [
              -52.27321448925164,
              -28.931217952089412
            ],
            [
              -52.27189234638172,
              -28.92819177795127
            ],
            [
              -52.265989922855255,
              -28.9256951842873
            ],
            [
              -52.26561216774956,
              -28.92229073838189
            ],
            [
              -52.27080630045285,
              -28.9177893043514
            ],
            [
              -52.27807808623745,
              -28.914611821506348
            ],
            [
              -52.2802973974834,
              -28.91249349960965
            ],
            [
              -52.281100127083,
              -28.905192854501376
            ],
            [
              -52.27779476990818,
              -28.90171275424251
            ],
            [
              -52.27821974440209,
              -28.900010531289805
            ],
            [
              -52.27968354543665,
              -28.898913543164728
            ],
            [
              -52.287899718985486,
              -28.897097838681844
            ],
            [
              -52.28922186185542,
              -28.895811714673133
            ],
            [
              -52.28100568830658,
              -28.893996010190246
            ],
            [
              -52.27977798421307,
              -28.892709886181535
            ],
            [
              -52.27821974440209,
              -28.8877166988536
            ],
            [
              -52.278691938284204,
              -28.886884500965607
            ],
            [
              -52.281383443412274,
              -28.88639274766816
            ],
            [
              -52.286199821009866,
              -28.888700205448494
            ],
            [
              -52.289599616961105,
              -28.886581883551795
            ],
            [
              -52.291582831266,
              -28.88839758803468
            ],
            [
              -52.293188290465196,
              -28.8882841065045
            ],
            [
              -52.29290497413593,
              -28.886317093314705
            ],
            [
              -52.29101619860746,
              -28.884614870362
            ],
            [
              -52.289694055737534,
              -28.878902966676254
            ],
            [
              -52.29111063738388,
              -28.877616842667543
            ],
            [
              -52.29942124970914,
              -28.875612002301022
            ],
            [
              -52.30131002523761,
              -28.87341802605087
            ],
            [
              -52.29961012726199,
              -28.86891659202038
            ],
            [
              -52.29828798439206,
              -28.867592640834943
            ],
            [
              -52.296115892534324,
              -28.868613974606568
            ],
            [
              -52.29488818844082,
              -28.866987406007315
            ],
            [
              -52.302490509942906,
              -28.862296836093194
            ],
            [
              -52.3081096171401,
              -28.863809923162265
            ],
            [
              -52.30929010184539,
              -28.863393824218267
            ],
            [
              -52.30428484669495,
              -28.859497625015408
            ],
            [
              -52.303293239542505,
              -28.85749278464889
            ],
            [
              -52.30640971916448,
              -28.854693573571105
            ],
            [
              -52.305984744670575,
              -28.853785721329665
            ],
            [
              -52.30112114768477,
              -28.854012684390025
            ],
            [
              -52.29828798439206,
              -28.85159174507951
            ],
            [
              -52.2960214537579,
              -28.851516090726054
            ],
            [
              -52.2963992088636,
              -28.84709031104902
            ],
            [
              -52.29838242316848,
              -28.846598557751573
            ],
            [
              -52.30452094363601,
              -28.851402609195876
            ],
            [
              -52.30749576509335,
              -28.84920863294572
            ],
            [
              -52.31268989779664,
              -28.848906015531906
            ],
            [
              -52.31287877534948,
              -28.847998163290463
            ],
            [
              -52.31108443859743,
              -28.84519895221268
            ],
            [
              -52.306693035493744,
              -28.844896334798868
            ],
            [
              -52.304993137518125,
              -28.842702358548713
            ],
            [
              -52.306079183447,
              -28.841189271479642
            ],
            [
              -52.31117887737386,
              -28.84130275300982
            ],
            [
              -52.31212326513809,
              -28.838692677815672
            ],
            [
              -52.30962063756287,
              -28.829198056457248
            ],
            [
              -52.312406581467364,
              -28.828403685745982
            ],
            [
              -52.31708130090033,
              -28.829008920573614
            ],
            [
              -52.32208655605076,
              -28.8256044746682
            ],
            [
              -52.32279484687394,
              -28.823902251715495
            ],
            [
              -52.32199211727434,
              -28.822502646176606
            ],
            [
              -52.323408698920694,
              -28.821783929818796
            ],
            [
              -52.326005765272335,
              -28.823107881004233
            ],
            [
              -52.3295,
              -28.821594793935162
            ],
            [
              -52.32940556122358,
              -28.82091390475408
            ],
            [
              -52.32411698974387,
              -28.818001212146115
            ],
            [
              -52.32581688771949,
              -28.81629898919341
            ],
            [
              -52.32539191322559,
              -28.81478590212434
            ],
            [
              -52.32728068875405,
              -28.813613259645805
            ],
            [
              -52.32898058672967,
              -28.812591925874184
            ],
            [
              -52.32378645402638,
              -28.80850659078769
            ],
            [
              -52.32548635200201,
              -28.806388268890988
            ],
            [
              -52.3206227550162,
              -28.80521562641246
            ],
            [
              -52.319820025416604,
              -28.80158421744669
            ],
            [
              -52.32137826522759,
              -28.79848238895509
            ],
            [
              -52.32118938767474,
              -28.79681799317911
            ],
            [
              -52.319820025416604,
              -28.795683177877308
            ],
            [
              -52.31448423454868,
              -28.795910140937668
            ],
            [
              -52.312406581467364,
              -28.793413547273698
            ],
            [
              -52.312501020243786,
              -28.789517348070838
            ],
            [
              -52.309903953892146,
              -28.78618855651888
            ],
            [
              -52.308581811022215,
              -28.785583321691252
            ],
            [
              -52.306315280388056,
              -28.786491173932696
            ],
            [
              -52.3048986987417,
              -28.785696803221434
            ],
            [
              -52.305182015070976,
              -28.783616308501458
            ],
            [
              -52.307212448764076,
              -28.781308850721125
            ],
            [
              -52.306079183447,
              -28.780211862596047
            ],
            [
              -52.30640971916448,
              -28.778509639643342
            ],
            [
              -52.30560698956488,
              -28.776618280807003
            ],
            [
              -52.30338767831893,
              -28.775294329621563
            ],
            [
              -52.30461538241243,
              -28.774310823026667
            ],
            [
              -52.30338767831893,
              -28.772797735957596
            ],
            [
              -52.30452094363601,
              -28.772116846776512
            ],
            [
              -52.30319880076608,
              -28.770301142293626
            ],
            [
              -52.30131002523761,
              -28.769204154168552
            ],
            [
              -52.301404464014034,
              -28.76719931380203
            ],
            [
              -52.295313162934725,
              -28.762584398241362
            ],
            [
              -52.295879795593265,
              -28.761600891646463
            ],
            [
              -52.2952187241583,
              -28.760693039405023
            ],
            [
              -52.295879795593265,
              -28.758688199038502
            ],
            [
              -52.29550204048757,
              -28.756418568434892
            ],
            [
              -52.29299941291235,
              -28.75490548136582
            ],
            [
              -52.296776963969286,
              -28.754413728068375
            ],
            [
              -52.29819354561564,
              -28.751690171344045
            ],
            [
              -52.297013060910345,
              -28.750593183218967
            ],
            [
              -52.30079061196729,
              -28.74798310802482
            ],
            [
              -52.29809910683922,
              -28.745789131774664
            ],
            [
              -52.296210331310746,
              -28.745410860007397
            ],
            [
              -52.29469931088797,
              -28.74359515552451
            ],
            [
              -52.29167727004242,
              -28.744692143649587
            ],
            [
              -52.29049678533713,
              -28.74438952623577
            ],
            [
              -52.28648313733913,
              -28.73969895632165
            ],
            [
              -52.282611147505776,
              -28.738488486666395
            ],
            [
              -52.28199729545902,
              -28.737202362657683
            ],
            [
              -52.27968354543665,
              -28.736710609360234
            ],
            [
              -52.27779476990818,
              -28.735197522291163
            ],
            [
              -52.276897601532156,
              -28.72850211201052
            ],
            [
              -52.27850306073136,
              -28.696084221555658
            ],
            [
              -52.2722228820992,
              -28.69510071496076
            ],
            [
              -52.27090073922927,
              -28.693890245305504
            ],
            [
              -52.267689820830874,
              -28.693398492008054
            ],
            [
              -52.26641489734916,
              -28.6912045157579
            ],
            [
              -52.26348729528004,
              -28.689994046102644
            ],
            [
              -52.26211793302189,
              -28.687913551382668
            ],
            [
              -52.25999306055237,
              -28.686400464313596
            ],
            [
              -52.25928476972919,
              -28.684395623947076
            ],
            [
              -52.25980418299952,
              -28.682315129227103
            ],
            [
              -52.25701823909503,
              -28.680499424744216
            ],
            [
              -52.253618443143786,
              -28.680385943214038
            ],
            [
              -52.25291015232061,
              -28.67951591814932
            ],
            [
              -52.25338234620273,
              -28.677586732136255
            ],
            [
              -52.252390739050284,
              -28.675581891769735
            ],
            [
              -52.25220186149743,
              -28.672404408924685
            ],
            [
              -52.24951035636937,
              -28.669794333730533
            ],
            [
              -52.25050196352181,
              -28.667411221596748
            ],
            [
              -52.24932147881652,
              -28.66430939310515
            ],
            [
              -52.24941591759294,
              -28.66241803426881
            ],
            [
              -52.2463938767474,
              -28.66230455273863
            ],
            [
              -52.24351349406648,
              -28.65969447754448
            ],
            [
              -52.24327739712542,
              -28.661018428729918
            ],
            [
              -52.240916427714836,
              -28.662493688622263
            ],
            [
              -52.24190803486728,
              -28.663704158277522
            ],
            [
              -52.241388621596954,
              -28.665406381230227
            ],
            [
              -52.23572229501155,
              -28.671118284915973
            ],
            [
              -52.23388073887129,
              -28.67100480338579
            ],
            [
              -52.22878104494443,
              -28.668092110777827
            ],
            [
              -52.22878104494443,
              -28.67100480338579
            ],
            [
              -52.227694999015554,
              -28.671307420799607
            ],
            [
              -52.22722280513344,
              -28.672782680691952
            ],
            [
              -52.22571178471067,
              -28.671799174097053
            ],
            [
              -52.225192371440336,
              -28.669113444549453
            ],
            [
              -52.22438964184074,
              -28.66869734560546
            ],
            [
              -52.217778927491096,
              -28.669113444549453
            ],
            [
              -52.217117856056134,
              -28.6696051978469
            ],
            [
              -52.21759004993825,
              -28.67138307515306
            ],
            [
              -52.21050714170649,
              -28.669907815260714
            ],
            [
              -52.20318813653368,
              -28.67361487857994
            ],
            [
              -52.20167711611091,
              -28.67338791551958
            ],
            [
              -52.19908004975926,
              -28.67161003821342
            ],
            [
              -52.193602600726706,
              -28.67100480338579
            ],
            [
              -52.1919971415275,
              -28.669794333730533
            ],
            [
              -52.192280457856775,
              -28.664195911574968
            ],
            [
              -52.193980355832394,
              -28.663288059333524
            ],
            [
              -52.19449976910273,
              -28.660602329785924
            ],
            [
              -52.193177626232796,
              -28.660488848255742
            ],
            [
              -52.1952080599259,
              -28.654890426100177
            ],
            [
              -52.193177626232796,
              -28.656100895755433
            ],
            [
              -52.18930563639944,
              -28.656895266466698
            ],
            [
              -52.18571696289535,
              -28.656592649052882
            ],
            [
              -52.1834976516494,
              -28.658105736121954
            ],
            [
              -52.18321433532013,
              -28.659391860130665
            ],
            [
              -52.17920068732213,
              -28.659505341660847
            ],
            [
              -52.17617864647658,
              -28.660715811316102
            ],
            [
              -52.1706067586676,
              -28.659807959074662
            ],
            [
              -52.168009692315955,
              -28.65840835353577
            ],
            [
              -52.16257946267161,
              -28.659391860130665
            ],
            [
              -52.15998239631997,
              -28.654890426100177
            ],
            [
              -52.156299284039456,
              -28.65258296831984
            ],
            [
              -52.15601596771018,
              -28.651712943255127
            ],
            [
              -52.1476109166085,
              -28.666881641122572
            ],
            [
              -52.139819717553564,
              -28.671307420799607
            ],
            [
              -52.1334923195332,
              -28.673009643752312
            ],
            [
              -52.12489839087866,
              -28.671685692566875
            ],
            [
              -52.12112083982173,
              -28.668016456424375
            ],
            [
              -52.12079030410425,
              -28.671307420799607
            ],
            [
              -52.111818620344025,
              -28.671799174097053
            ],
            [
              -52.10737999785212,
              -28.6674868759502
            ],
            [
              -52.102280303925255,
              -28.664914627932777
            ],
            [
              -52.10119425799639,
              -28.66760035748038
            ],
            [
              -52.10010821206752,
              -28.66899996301927
            ],
            [
              -52.100580405949636,
              -28.66760035748038
            ],
            [
              -52.10091094166712,
              -28.663401540863706
            ],
            [
              -52.10128869677281,
              -28.661699317911
            ],
            [
              -52.10091094166712,
              -28.659013588363397
            ],
            [
              -52.10119425799639,
              -28.65719788388051
            ],
            [
              -52.10279971719559,
              -28.655609142457987
            ],
            [
              -52.10511346721796,
              -28.655495660927805
            ],
            [
              -52.109693747874495,
              -28.65579827834162
            ],
            [
              -52.11077979380337,
              -28.655382179397627
            ],
            [
              -52.11111032952085,
              -28.65330168467765
            ],
            [
              -52.110590916250516,
              -28.652091215022395
            ],
            [
              -52.10690780397,
              -28.650805091013684
            ],
            [
              -52.10591619681756,
              -28.649708102888606
            ],
            [
              -52.1048773702769,
              -28.647589780991904
            ],
            [
              -52.10388576312445,
              -28.64410968073304
            ],
            [
              -52.10242196208989,
              -28.641688741422527
            ],
            [
              -52.101713671266715,
              -28.63960824670255
            ],
            [
              -52.102516400866314,
              -28.637603406336034
            ],
            [
              -52.100013773291096,
              -28.635787701853147
            ],
            [
              -52.09977767635004,
              -28.633896343016808
            ],
            [
              -52.100580405949636,
              -28.631097131939022
            ],
            [
              -52.10020265084394,
              -28.629886662283766
            ],
            [
              -52.09821943653905,
              -28.630000143813945
            ],
            [
              -52.09548071202277,
              -28.632118465710647
            ],
            [
              -52.09241145178901,
              -28.633215453835724
            ],
            [
              -52.09179759974226,
              -28.632383255947733
            ],
            [
              -52.089578288496305,
              -28.632118465710647
            ],
            [
              -52.08820892623817,
              -28.63030276122776
            ],
            [
              -52.090711553813385,
              -28.628487056744873
            ],
            [
              -52.09160872218941,
              -28.62878967415869
            ],
            [
              -52.09297808444755,
              -28.61589060689485
            ],
            [
              -52.06648800766078,
              -28.614415347002506
            ],
            [
              -51.99650887433103,
              -28.61048132062292
            ],
            [
              -51.9951867314611,
              -28.64838415170317
            ],
            [
              -51.99410068553223,
              -28.64868676911698
            ],
            [
              -51.997217165154204,
              -28.65299906726384
            ],
            [
              -51.99301463960336,
              -28.656290031639067
            ],
            [
              -51.992495226333034,
              -28.65768963717796
            ],
            [
              -51.99268410388588,
              -28.661510182027367
            ],
            [
              -51.99480897635541,
              -28.661699317911
            ],
            [
              -51.9943840018615,
              -28.672517890454863
            ],
            [
              -51.938004052336716,
              -28.66899996301927
            ],
            [
              -51.84819277595805,
              -28.663515022393888
            ],
            [
              -51.85050652598042,
              -28.66181279944118
            ],
            [
              -51.85678670461258,
              -28.662001935324813
            ],
            [
              -51.8605170362813,
              -28.658105736121954
            ],
            [
              -51.8600920617874,
              -28.657084402350332
            ],
            [
              -51.853717444378816,
              -28.65451215433291
            ],
            [
              -51.84927882188692,
              -28.648913732177345
            ],
            [
              -51.84578458715925,
              -28.649594621358425
            ],
            [
              -51.84229035243158,
              -28.652696449850023
            ],
            [
              -51.83959884730351,
              -28.65201556066894
            ],
            [
              -51.83860724015107,
              -28.650805091013684
            ],
            [
              -51.840920990173444,
              -28.647589780991904
            ],
            [
              -51.84299864325476,
              -28.646681928750464
            ],
            [
              -51.8496093576044,
              -28.64448795250031
            ],
            [
              -51.852820276002795,
              -28.643617927435592
            ],
            [
              -51.85300915355564,
              -28.64138612400871
            ],
            [
              -51.8520175464032,
              -28.63888953034474
            ],
            [
              -51.85310359233207,
              -28.637603406336034
            ],
            [
              -51.86287800569189,
              -28.635787701853147
            ],
            [
              -51.86188639853944,
              -28.63370720713317
            ],
            [
              -51.859478209740644,
              -28.63268587336155
            ],
            [
              -51.85702280155364,
              -28.630000143813945
            ],
            [
              -51.856408949506886,
              -28.62829792086124
            ],
            [
              -51.85730611788291,
              -28.627314414266344
            ],
            [
              -51.85801440870608,
              -28.62440172165838
            ],
            [
              -51.85650338828331,
              -28.621299893166782
            ],
            [
              -51.855181245413384,
              -28.617290212433744
            ],
            [
              -51.85499236786053,
              -28.615285372067223
            ],
            [
              -51.853623005602394,
              -28.613999248058512
            ],
            [
              -51.85178144946214,
              -28.613394013230884
            ],
            [
              -51.84828721473447,
              -28.61048132062292
            ],
            [
              -51.84828721473447,
              -28.60919519661421
            ],
            [
              -51.84908994433407,
              -28.60741731930805
            ],
            [
              -51.85060096475684,
              -28.60658512142006
            ],
            [
              -51.85390632193167,
              -28.605904232238977
            ],
            [
              -51.85631451073046,
              -28.605904232238977
            ],
            [
              -51.8576838729886,
              -28.60658512142006
            ],
            [
              -51.86117810771627,
              -28.610292184739286
            ],
            [
              -51.86221693425693,
              -28.61169179027818
            ],
            [
              -51.86670277613704,
              -28.61381011217488
            ],
            [
              -51.867222189407364,
              -28.61309139581707
            ],
            [
              -51.867411066960216,
              -28.610897419566914
            ],
            [
              -51.86689165368988,
              -28.608892579200393
            ],
            [
              -51.865286194490686,
              -28.599700575255785
            ],
            [
              -51.866088924090285,
              -28.59890620454452
            ],
            [
              -51.867977699618756,
              -28.599095340428153
            ],
            [
              -51.86958315881795,
              -28.598187488186714
            ],
            [
              -51.871377495569995,
              -28.595085659695116
            ],
            [
              -51.87128305679357,
              -28.593686054156223
            ],
            [
              -51.86901652615941,
              -28.59281602909151
            ],
            [
              -51.86481400060857,
              -28.593194300858777
            ],
            [
              -51.859100454634955,
              -28.59739311747545
            ],
            [
              -51.85758943421218,
              -28.597317463121996
            ],
            [
              -51.85659782705973,
              -28.596182647820193
            ],
            [
              -51.85499236786053,
              -28.591681213789702
            ],
            [
              -51.853717444378816,
              -28.59039508978099
            ],
            [
              -51.851120378027176,
              -28.59039508978099
            ],
            [
              -51.848098337181625,
              -28.58960071906973
            ],
            [
              -51.84469854123038,
              -28.589298101655917
            ],
            [
              -51.843612495301514,
              -28.588087632000658
            ],
            [
              -51.84351805652509,
              -28.586007137280685
            ],
            [
              -51.842809765701915,
              -28.584910149155608
            ],
            [
              -51.83851280137465,
              -28.58619627316432
            ],
            [
              -51.83761563299863,
              -28.58570451986687
            ],
            [
              -51.83681290339903,
              -28.58260269137527
            ],
            [
              -51.837096219728295,
              -28.581013949952748
            ],
            [
              -51.837993388104316,
              -28.579992616181123
            ],
            [
              -51.84049601567954,
              -28.579009109586227
            ],
            [
              -51.84040157690311,
              -28.577609504047334
            ],
            [
              -51.8367184646226,
              -28.577004269219707
            ],
            [
              -51.83478246970592,
              -28.574318539672106
            ],
            [
              -51.83289369417745,
              -28.573599823314296
            ],
            [
              -51.831004918648986,
              -28.574696811439374
            ],
            [
              -51.827888439027014,
              -28.579387381353495
            ],
            [
              -51.82680239309814,
              -28.57870649217241
            ],
            [
              -51.82680239309814,
              -28.574810292969552
            ],
            [
              -51.826519076768875,
              -28.572881106956487
            ],
            [
              -51.827416245144896,
              -28.571405847064142
            ],
            [
              -51.82831341352092,
              -28.56868229033981
            ],
            [
              -51.82859672985019,
              -28.56660179561984
            ],
            [
              -51.82831341352092,
              -28.565013054197312
            ],
            [
              -51.824394204299345,
              -28.56300821383079
            ],
            [
              -51.82297762265299,
              -28.563310831244607
            ],
            [
              -51.821702699171276,
              -28.567585302214734
            ],
            [
              -51.82061665324241,
              -28.56811488268891
            ],
            [
              -51.81929451037248,
              -28.567585302214734
            ],
            [
              -51.81679188279726,
              -28.56399172042569
            ],
            [
              -51.81098389804722,
              -28.560587274520277
            ],
            [
              -51.80862292863664,
              -28.55831764391667
            ],
            [
              -51.80862292863664,
              -28.556993692731233
            ],
            [
              -51.81070058171795,
              -28.555896704606155
            ],
            [
              -51.81240047969357,
              -28.554497099067262
            ],
            [
              -51.81410037766919,
              -28.552113986933477
            ],
            [
              -51.813817061339925,
              -28.5510169988084
            ],
            [
              -51.81098389804722,
              -28.54840692361425
            ],
            [
              -51.8092840000716,
              -28.545418576652832
            ],
            [
              -51.8076785408724,
              -28.544510724411392
            ],
            [
              -51.80380655103904,
              -28.544208106997576
            ],
            [
              -51.802814943886595,
              -28.542581538398323
            ],
            [
              -51.80597864289678,
              -28.54050104367835
            ],
            [
              -51.805412010238236,
              -28.539593191436907
            ],
            [
              -51.802814943886595,
              -28.53770183260057
            ],
            [
              -51.801492801016664,
              -28.534789139992604
            ],
            [
              -51.7996040254882,
              -28.532103410445004
            ],
            [
              -51.79738471424225,
              -28.532103410445004
            ],
            [
              -51.79252111725644,
              -28.531611657147554
            ],
            [
              -51.788979663140566,
              -28.53198992891482
            ],
            [
              -51.786288158012496,
              -28.531006422319926
            ],
            [
              -51.787515862106,
              -28.528509828655956
            ],
            [
              -51.79058512233976,
              -28.525786271931626
            ],
            [
              -51.79497652544345,
              -28.52408404897892
            ],
            [
              -51.7955903774902,
              -28.52328967826766
            ],
            [
              -51.793607163185314,
              -28.520301331306243
            ],
            [
              -51.79171838765684,
              -28.51969609647861
            ],
            [
              -51.790679561116185,
              -28.51988523236225
            ],
            [
              -51.78850746925845,
              -28.522306171672763
            ],
            [
              -51.78638259678892,
              -28.522306171672763
            ],
            [
              -51.78557986718932,
              -28.520301331306243
            ],
            [
              -51.78680757128282,
              -28.518712589883716
            ],
            [
              -51.78761030088243,
              -28.51651861363356
            ],
            [
              -51.78699644883567,
              -28.515081180917946
            ],
            [
              -51.78241616817914,
              -28.513189822081603
            ],
            [
              -51.780999586532786,
              -28.51110932736163
            ],
            [
              -51.78019685693319,
              -28.50649441180096
            ],
            [
              -51.77840252018114,
              -28.50448957143444
            ],
            [
              -51.779913540603914,
              -28.503506064839545
            ],
            [
              -51.78321889777874,
              -28.503884336606813
            ],
            [
              -51.78609928045965,
              -28.50119860705921
            ],
            [
              -51.78850746925845,
              -28.500215100464313
            ],
            [
              -51.7883185917056,
              -28.49730240785635
            ],
            [
              -51.789215760081625,
              -28.492611837942228
            ],
            [
              -51.79020736723407,
              -28.48951000945063
            ],
            [
              -51.789782392740165,
              -28.48739168755393
            ],
            [
              -51.78411606615476,
              -28.487202551670297
            ],
            [
              -51.78251060695556,
              -28.487694304967746
            ],
            [
              -51.78038573448603,
              -28.489699145334264
            ],
            [
              -51.78019685693319,
              -28.490682651929163
            ],
            [
              -51.777410913028696,
              -28.493708826067305
            ],
            [
              -51.775286040559166,
              -28.494200579364755
            ],
            [
              -51.77391667830103,
              -28.49340620865349
            ],
            [
              -51.77358614258355,
              -28.491703985700784
            ],
            [
              -51.773822239524605,
              -28.48610556354522
            ],
            [
              -51.77538047933559,
              -28.48459247647615
            ],
            [
              -51.776419305876246,
              -28.48459247647615
            ],
            [
              -51.780102418156766,
              -28.485802946131404
            ],
            [
              -51.78029129570961,
              -28.48398724164852
            ],
            [
              -51.77759979058154,
              -28.48149064798455
            ],
            [
              -51.77599433138234,
              -28.478918399967128
            ],
            [
              -51.7758054538295,
              -28.476686596540247
            ],
            [
              -51.7766081834291,
              -28.475211336647902
            ],
            [
              -51.78151899980311,
              -28.4783131651395
            ],
            [
              -51.7830772396141,
              -28.47608136171262
            ],
            [
              -51.7846826988133,
              -28.474492620290093
            ],
            [
              -51.782605045731984,
              -28.47169340921231
            ],
            [
              -51.78071627020351,
              -28.469991186259605
            ],
            [
              -51.77811920385187,
              -28.4682889633069
            ],
            [
              -51.77538047933559,
              -28.467494592595635
            ],
            [
              -51.77401111707745,
              -28.467608074125817
            ],
            [
              -51.77141405072581,
              -28.469310297078522
            ],
            [
              -51.7717918058315,
              -28.470785556970867
            ],
            [
              -51.771697367055076,
              -28.473887385462465
            ],
            [
              -51.77108351500833,
              -28.475097855117724
            ],
            [
              -51.765511627199345,
              -28.474114348522825
            ],
            [
              -51.76230070880095,
              -28.474000866992647
            ],
            [
              -51.7608841271546,
              -28.472601261453754
            ],
            [
              -51.7621118312481,
              -28.470104667789784
            ],
            [
              -51.76329231595339,
              -28.468894198134528
            ],
            [
              -51.768108693550985,
              -28.4682889633069
            ],
            [
              -51.77070575990263,
              -28.467305456712
            ],
            [
              -51.77221678032541,
              -28.46450624563422
            ],
            [
              -51.77509716300632,
              -28.463295775978963
            ],
            [
              -51.77618320893519,
              -28.46110179972881
            ],
            [
              -51.77391667830103,
              -28.461215281258987
            ],
            [
              -51.772688974207526,
              -28.460799182314993
            ],
            [
              -51.7693836170327,
              -28.457810835353577
            ],
            [
              -51.76730596395139,
              -28.4576973538234
            ],
            [
              -51.76409504555299,
              -28.45860520606484
            ],
            [
              -51.76300899962413,
              -28.457810835353577
            ],
            [
              -51.76178129553062,
              -28.458113452767392
            ],
            [
              -51.762489586353794,
              -28.454406389448167
            ],
            [
              -51.76409504555299,
              -28.45281764802564
            ],
            [
              -51.764189484329414,
              -28.451001943542753
            ],
            [
              -51.763717290447296,
              -28.449791473887498
            ],
            [
              -51.762489586353794,
              -28.44918623905987
            ],
            [
              -51.76031749449606,
              -28.449299720590048
            ],
            [
              -51.758098183250105,
              -28.450018436947857
            ],
            [
              -51.75568999445131,
              -28.449299720590048
            ],
            [
              -51.75399009647569,
              -28.450283227184944
            ],
            [
              -51.75172356584152,
              -28.44869448576242
            ],
            [
              -51.75021254541875,
              -28.448997103176232
            ],
            [
              -51.747898795396374,
              -28.450396708715125
            ],
            [
              -51.7471905045732,
              -28.451607178370384
            ],
            [
              -51.74501841271546,
              -28.449791473887498
            ],
            [
              -51.74289354024594,
              -28.45069932612894
            ],
            [
              -51.738218820812975,
              -28.449715819534042
            ],
            [
              -51.73571619323776,
              -28.45081280765912
            ],
            [
              -51.73222195851009,
              -28.451493696840203
            ],
            [
              -51.72901104011169,
              -28.45130456095657
            ],
            [
              -51.72447797884337,
              -28.453006783909274
            ],
            [
              -51.7233919329145,
              -28.45281764802564
            ],
            [
              -51.719897698186834,
              -28.454406389448167
            ],
            [
              -51.71649790223559,
              -28.454292907917985
            ],
            [
              -51.71149264708515,
              -28.455087278629247
            ],
            [
              -51.709981626662376,
              -28.45610861240087
            ],
            [
              -51.708423386851386,
              -28.45860520606484
            ],
            [
              -51.70710124398146,
              -28.458416070181205
            ],
            [
              -51.70171823372532,
              -28.459702194189916
            ],
            [
              -51.69968780003222,
              -28.46238792373752
            ],
            [
              -51.69770458572733,
              -28.46340925750914
            ],
            [
              -51.69581581019886,
              -28.463598393392775
            ],
            [
              -51.690102264225246,
              -28.463484911862597
            ],
            [
              -51.687080223379695,
              -28.466700221884373
            ],
            [
              -51.685380325404076,
              -28.466700221884373
            ],
            [
              -51.68391652436951,
              -28.465905851173112
            ],
            [
              -51.680800044747535,
              -28.465414097875662
            ],
            [
              -51.67938346310119,
              -28.464317109750585
            ],
            [
              -51.677305810019874,
              -28.464014492336773
            ],
            [
              -51.67220611609301,
              -28.465716715289478
            ],
            [
              -51.6612984374161,
              -28.465905851173112
            ],
            [
              -51.657190350641685,
              -28.464884517401487
            ],
            [
              -51.654498845513615,
              -28.465905851173112
            ],
            [
              -51.65421552918434,
              -28.469083334018162
            ],
            [
              -51.651476804668064,
              -28.470482939557055
            ],
            [
              -51.648407544434306,
              -28.46980205037597
            ],
            [
              -51.64680208523511,
              -28.467986345893085
            ],
            [
              -51.644393896436306,
              -28.467191975181823
            ],
            [
              -51.64170239130824,
              -28.465603233759296
            ],
            [
              -51.63849147290985,
              -28.465603233759296
            ],
            [
              -51.635280554511446,
              -28.465981505526564
            ],
            [
              -51.63391119225331,
              -28.46700283929819
            ],
            [
              -51.632919585100865,
              -28.468591580720712
            ],
            [
              -51.63358065653583,
              -28.470709902617415
            ],
            [
              -51.632589049383384,
              -28.47161775485886
            ],
            [
              -51.63070027385491,
              -28.471882545095944
            ],
            [
              -51.62970866670247,
              -28.472790397337388
            ],
            [
              -51.628197646279695,
              -28.473017360397748
            ],
            [
              -51.6254117023752,
              -28.475513954061718
            ],
            [
              -51.62201190642396,
              -28.47608136171262
            ],
            [
              -51.62031200844834,
              -28.47819968360932
            ],
            [
              -51.619792595178005,
              -28.47959928914821
            ],
            [
              -51.61842323291987,
              -28.477405312898057
            ],
            [
              -51.61870654924914,
              -28.474492620290093
            ],
            [
              -51.61747884515563,
              -28.473017360397748
            ],
            [
              -51.62040644722476,
              -28.470104667789784
            ],
            [
              -51.62238966152965,
              -28.465905851173112
            ],
            [
              -51.62130361560078,
              -28.464317109750585
            ],
            [
              -51.61828157475524,
              -28.465300616345484
            ],
            [
              -51.61917874313126,
              -28.46318229444878
            ],
            [
              -51.61700665127352,
              -28.462009651970252
            ],
            [
              -51.616392799226766,
              -28.460118293133913
            ],
            [
              -51.61681777372067,
              -28.456411229814687
            ],
            [
              -51.61577894718001,
              -28.454217253564533
            ],
            [
              -51.61710109004994,
              -28.45308243826273
            ],
            [
              -51.61502343696863,
              -28.452515030611828
            ],
            [
              -51.61521231452147,
              -28.448997103176232
            ],
            [
              -51.61422070736903,
              -28.447105744339893
            ],
            [
              -51.61270968694625,
              -28.44740836175371
            ],
            [
              -51.610112620594606,
              -28.449299720590048
            ],
            [
              -51.60510736544417,
              -28.450510190245307
            ],
            [
              -51.60430463584457,
              -28.449110584706414
            ],
            [
              -51.60477682972668,
              -28.4466896453959
            ],
            [
              -51.60411575829172,
              -28.443398681020668
            ],
            [
              -51.6016131307165,
              -28.442604310309406
            ],
            [
              -51.59301920206197,
              -28.433904059662243
            ],
            [
              -51.59198037552131,
              -28.43371492377861
            ],
            [
              -51.58961940611073,
              -28.435303665201133
            ],
            [
              -51.5874945336412,
              -28.435303665201133
            ],
            [
              -51.5842836152428,
              -28.431785737765544
            ],
            [
              -51.58362254380784,
              -28.429402625631756
            ],
            [
              -51.584614150960284,
              -28.424295956773637
            ],
            [
              -51.57710626823462,
              -28.421988498993304
            ],
            [
              -51.572478768189875,
              -28.419718868389694
            ],
            [
              -51.56770960998049,
              -28.420891510868227
            ],
            [
              -51.56029616603126,
              -28.41979452274315
            ],
            [
              -51.55779353845603,
              -28.42081585651477
            ],
            [
              -51.54778302815515,
              -28.42179936310967
            ],
            [
              -51.5403223648177,
              -28.41669269425155
            ],
            [
              -51.536403155596126,
              -28.416087459423924
            ],
            [
              -51.533806089244486,
              -28.41468785388503
            ],
            [
              -51.53050073206967,
              -28.414498718001397
            ],
            [
              -51.528186982047295,
              -28.413099112462504
            ],
            [
              -51.52407889527287,
              -28.412418223281424
            ],
            [
              -51.52237899729725,
              -28.413590865759954
            ],
            [
              -51.51912085951064,
              -28.412607359165058
            ],
            [
              -51.51912085951064,
              -28.408900295845832
            ],
            [
              -51.5157210635594,
              -28.405987603237868
            ],
            [
              -51.5133128747606,
              -28.405911948884416
            ],
            [
              -51.51071580840896,
              -28.407689826190573
            ],
            [
              -51.50991307880936,
              -28.40738720877676
            ],
            [
              -51.50859093593943,
              -28.40458799769898
            ],
            [
              -51.50287738996582,
              -28.40360449110408
            ],
            [
              -51.5040106552829,
              -28.40159965073756
            ],
            [
              -51.50188578281337,
              -28.40148616920738
            ],
            [
              -51.50108305321377,
              -28.40050266261248
            ],
            [
              -51.50287738996582,
              -28.399292192957226
            ],
            [
              -51.5007997368845,
              -28.397892587418333
            ],
            [
              -51.49872208380319,
              -28.39819520483215
            ],
            [
              -51.49777769603895,
              -28.396190364465628
            ],
            [
              -51.49810823175643,
              -28.394715104573283
            ],
            [
              -51.50150802770768,
              -28.393202017504212
            ],
            [
              -51.50188578281337,
              -28.389003200887537
            ],
            [
              -51.5040106552829,
              -28.38888971935736
            ],
            [
              -51.508307619610164,
              -28.386317471339936
            ],
            [
              -51.513690629866296,
              -28.388284484529727
            ],
            [
              -51.512793461490276,
              -28.390213670542796
            ],
            [
              -51.51468223701874,
              -28.38991105312898
            ],
            [
              -51.51590994111225,
              -28.388700583473724
            ],
            [
              -51.517420961535024,
              -28.391613276081685
            ],
            [
              -51.520584660545204,
              -28.391613276081685
            ],
            [
              -51.52171792586229,
              -28.390591942310063
            ],
            [
              -51.52422055343751,
              -28.391991547848953
            ],
            [
              -51.52237899729725,
              -28.385598754982126
            ],
            [
              -51.52289841056758,
              -28.383518260262154
            ],
            [
              -51.52521216058995,
              -28.382913025434522
            ],
            [
              -51.52407889527287,
              -28.381286456835273
            ],
            [
              -51.527006497342,
              -28.379697715412746
            ],
            [
              -51.52880083409404,
              -28.381210802481817
            ],
            [
              -51.52950912491722,
              -28.377314603278958
            ],
            [
              -51.53120902289284,
              -28.378298109873853
            ],
            [
              -51.53201175249244,
              -28.375688034679705
            ],
            [
              -51.53328667597415,
              -28.375688034679705
            ],
            [
              -51.53522267089084,
              -28.37421277478736
            ],
            [
              -51.53470325762051,
              -28.371791835476845
            ],
            [
              -51.53890578317135,
              -28.367517364506718
            ],
            [
              -51.53862246684208,
              -28.366306894851462
            ],
            [
              -51.53692256886646,
              -28.365209906726385
            ],
            [
              -51.53970851277095,
              -28.359800620454454
            ],
            [
              -51.5382919311246,
              -28.35840101491556
            ],
            [
              -51.53862246684208,
              -28.354693951596335
            ],
            [
              -51.53479769639693,
              -28.34421582364301
            ],
            [
              -51.53300335964489,
              -28.342589255043762
            ],
            [
              -51.532578385150984,
              -28.33918480913835
            ],
            [
              -51.52979244124649,
              -28.334002485926778
            ],
            [
              -51.532720043315614,
              -28.330484558491186
            ],
            [
              -51.5342782831266,
              -28.326399223404692
            ],
            [
              -51.53881134439493,
              -28.32749621152977
            ],
            [
              -51.541597288299414,
              -28.326096605990877
            ],
            [
              -51.54169172707584,
              -28.32148169043021
            ],
            [
              -51.54471376792139,
              -28.313613637671036
            ],
            [
              -51.553591012905194,
              -28.30990657435181
            ],
            [
              -51.55769909967961,
              -28.309490475407816
            ],
            [
              -51.563695961982496,
              -28.30188721288573
            ],
            [
              -51.565490298734545,
              -28.306312992562766
            ],
            [
              -51.5842836152428,
              -28.30321116407117
            ],
            [
              -51.58621961015948,
              -28.303816398898796
            ],
            [
              -51.59401080921442,
              -28.30139545958828
            ],
            [
              -51.602793615421795,
              -28.294283950363646
            ],
            [
              -51.6032185899157,
              -28.292392591527303
            ],
            [
              -51.60501292666774,
              -28.292581727410937
            ],
            [
              -51.6112931052999,
              -28.279304388379835
            ],
            [
              -51.616298360450344,
              -28.2769969305995
            ],
            [
              -51.61828157475524,
              -28.27310073139664
            ],
            [
              -51.62182302887111,
              -28.2712093725603
            ],
            [
              -51.62229522275323,
              -28.269809767021407
            ],
            [
              -51.62130361560078,
              -28.26780492665489
            ],
            [
              -51.62767823300936,
              -28.261601269671694
            ],
            [
              -51.62961422792604,
              -28.256494600813575
            ],
            [
              -51.63570552900536,
              -28.252484920080537
            ],
            [
              -51.63679157493422,
              -28.250782697127832
            ],
            [
              -51.63721654942813,
              -28.24821044911041
            ],
            [
              -51.639105324956596,
              -28.2474917327526
            ],
            [
              -51.64000249333262,
              -28.24548689238608
            ],
            [
              -51.63721654942813,
              -28.23920758104943
            ],
            [
              -51.637405426980976,
              -28.23618140691129
            ],
            [
              -51.64071078415579,
              -28.23330654148005
            ],
            [
              -51.64680208523511,
              -28.23130170111353
            ],
            [
              -51.64609379441193,
              -28.227292020380492
            ],
            [
              -51.64670764645868,
              -28.22350930270781
            ],
            [
              -51.64911583525748,
              -28.221201844927478
            ],
            [
              -51.64930471281033,
              -28.21881873279369
            ],
            [
              -51.6524211924323,
              -28.212388112750133
            ],
            [
              -51.66219560579212,
              -28.20580618399967
            ],
            [
              -51.66691754461329,
              -28.205390085055676
            ],
            [
              -51.66819246809501,
              -28.20629793729712
            ],
            [
              -51.66951461096494,
              -28.206108801413485
            ],
            [
              -51.66927851402388,
              -28.204482232814232
            ],
            [
              -51.66682310583687,
              -28.201985639150266
            ],
            [
              -51.668523003812496,
              -28.20088865102519
            ],
            [
              -51.66838134564786,
              -28.198581193244856
            ],
            [
              -51.662809457838875,
              -28.19578198216707
            ],
            [
              -51.6629038966153,
              -28.18999442412787
            ],
            [
              -51.664178820097014,
              -28.190902276369314
            ],
            [
              -51.66229004456855,
              -28.186514323869005
            ],
            [
              -51.660920682310405,
              -28.185492990097384
            ],
            [
              -51.660117952710806,
              -28.185682125981018
            ],
            [
              -51.659220784334785,
              -28.18798958376135
            ],
            [
              -51.657190350641685,
              -28.18920005341661
            ],
            [
              -51.653176702643684,
              -28.187081731519907
            ],
            [
              -51.650107442409926,
              -28.18670345975264
            ],
            [
              -51.65209065671482,
              -28.182504643135967
            ],
            [
              -51.651476804668064,
              -28.18091590171344
            ],
            [
              -51.65770976391201,
              -28.173388293544807
            ],
            [
              -51.66030683026366,
              -28.17161041623865
            ],
            [
              -51.66729529971899,
              -28.169302958458314
            ],
            [
              -51.67211167731658,
              -28.166314611496897
            ],
            [
              -51.6858997386744,
              -28.15719826190574
            ],
            [
              -51.693690937729336,
              -28.15001109832765
            ],
            [
              -51.69628800408098,
              -28.1474010231335
            ],
            [
              -51.69411591222324,
              -28.145282701236802
            ],
            [
              -51.69458810610536,
              -28.14411005875827
            ],
            [
              -51.69378537650576,
              -28.141802600977936
            ],
            [
              -51.690007825448824,
              -28.138889908369972
            ],
            [
              -51.685191447851224,
              -28.137792920244895
            ],
            [
              -51.68231106517031,
              -28.13680941365
            ],
            [
              -51.67947790187761,
              -28.13510719069729
            ],
            [
              -51.67409489162147,
              -28.134691091753297
            ],
            [
              -51.67201723854016,
              -28.135901561408556
            ],
            [
              -51.67201723854016,
              -28.137187685417267
            ],
            [
              -51.67069509567023,
              -28.13760378436126
            ],
            [
              -51.66800359054216,
              -28.136695932119817
            ],
            [
              -51.66682310583687,
              -28.13559894399474
            ],
            [
              -51.66398994254417,
              -28.13680941365
            ],
            [
              -51.6612984374161,
              -28.13559894399474
            ],
            [
              -51.659220784334785,
              -28.13680941365
            ],
            [
              -51.65629318226566,
              -28.13510719069729
            ],
            [
              -51.65671815675957,
              -28.13359410362822
            ],
            [
              -51.65397943224328,
              -28.132610597033324
            ],
            [
              -51.65072129445668,
              -28.13298886880059
            ],
            [
              -51.648313105657884,
              -28.132497115503142
            ],
            [
              -51.6471798403408,
              -28.133102350330773
            ],
            [
              -51.643921702554195,
              -28.13291321444714
            ],
            [
              -51.64141907497897,
              -28.13359410362822
            ],
            [
              -51.638208156580575,
              -28.132799732916958
            ],
            [
              -51.637310988204554,
              -28.133404967744585
            ],
            [
              -51.637310988204554,
              -28.134691091753297
            ],
            [
              -51.636177722887474,
              -28.135296326580928
            ],
            [
              -51.634288947359,
              -28.13480457328348
            ],
            [
              -51.633486217759405,
              -28.1337075851584
            ],
            [
              -51.63310846265371,
              -28.131589263261702
            ],
            [
              -51.63400563102973,
              -28.13068141102026
            ],
            [
              -51.633722314700464,
              -28.128600916300282
            ],
            [
              -51.63240017183053,
              -28.12780654558902
            ],
            [
              -51.632022416724844,
              -28.126104322636316
            ],
            [
              -51.63107802896061,
              -28.125990841106134
            ],
            [
              -51.62951978914962,
              -28.12769306405884
            ],
            [
              -51.62829208505612,
              -28.12769306405884
            ],
            [
              -51.6265921870805,
              -28.13041662078317
            ],
            [
              -51.62531726359878,
              -28.131589263261702
            ],
            [
              -51.62290907479998,
              -28.13219449808933
            ],
            [
              -51.62210634520038,
              -28.130605756666803
            ],
            [
              -51.623617365623154,
              -28.12901701524428
            ],
            [
              -51.62668662585692,
              -28.12451558121379
            ],
            [
              -51.62937813098498,
              -28.122889012614536
            ],
            [
              -51.631786319783785,
              -28.11978718412294
            ],
            [
              -51.632683488159806,
              -28.116912318691703
            ],
            [
              -51.63490279940576,
              -28.11339439125611
            ],
            [
              -51.63320290143013,
              -28.113507872786293
            ],
            [
              -51.631786319783785,
              -28.112789156428484
            ],
            [
              -51.628197646279695,
              -28.115588367506266
            ],
            [
              -51.62611999319838,
              -28.11600446645026
            ],
            [
              -51.622484100306075,
              -28.11471834244155
            ],
            [
              -51.62130361560078,
              -28.112789156428484
            ],
            [
              -51.62031200844834,
              -28.109914290997246
            ],
            [
              -51.618989865578406,
              -28.1099899453507
            ],
            [
              -51.61747884515563,
              -28.11188130418704
            ],
            [
              -51.61700665127352,
              -28.113697008669927
            ],
            [
              -51.61511787574505,
              -28.112297403131034
            ],
            [
              -51.614692901251146,
              -28.109914290997246
            ],
            [
              -51.61738440637921,
              -28.104202387311503
            ],
            [
              -51.61780938087312,
              -28.102500164358794
            ],
            [
              -51.61620392167392,
              -28.09890658256975
            ],
            [
              -51.61431514614545,
              -28.09739349550068
            ],
            [
              -51.61299300327552,
              -28.097204359617045
            ],
            [
              -51.60869603894826,
              -28.097582631384313
            ],
            [
              -51.605390681773436,
              -28.098982236923202
            ],
            [
              -51.6040213195153,
              -28.098603965155935
            ],
            [
              -51.60298249297464,
              -28.096712606319596
            ],
            [
              -51.60581565626734,
              -28.09349729629782
            ],
            [
              -51.608979355277526,
              -28.091189838517483
            ],
            [
              -51.6125208093934,
              -28.09028198627604
            ],
            [
              -51.61459846247472,
              -28.09088722110367
            ],
            [
              -51.619887033954434,
              -28.09160593746148
            ],
            [
              -51.62139805437721,
              -28.092097690758926
            ],
            [
              -51.62352292684673,
              -28.09179507334511
            ],
            [
              -51.6270171615744,
              -28.091908554875292
            ],
            [
              -51.62829208505612,
              -28.091303320047665
            ],
            [
              -51.62881149832644,
              -28.08960109709496
            ],
            [
              -51.62498672788129,
              -28.085402280478284
            ],
            [
              -51.623806243176006,
              -28.084683564120475
            ],
            [
              -51.621681370706476,
              -28.079992994206354
            ],
            [
              -51.62300351357641,
              -28.078706870197642
            ],
            [
              -51.627206039127245,
              -28.079690376792538
            ],
            [
              -51.62980310547889,
              -28.079917339852898
            ],
            [
              -51.63230573305411,
              -28.079009487611454
            ],
            [
              -51.63150300345451,
              -28.077685536426017
            ],
            [
              -51.62918925343214,
              -28.078706870197642
            ],
            [
              -51.627819891174,
              -28.0777990179562
            ],
            [
              -51.62711160035082,
              -28.07670202983112
            ],
            [
              -51.62522282482235,
              -28.07530242429223
            ],
            [
              -51.62489228910487,
              -28.072805830628262
            ],
            [
              -51.62309795235283,
              -28.070498372847926
            ],
            [
              -51.621020299271514,
              -28.069817483666846
            ],
            [
              -51.620784202330455,
              -28.068607014011587
            ],
            [
              -51.619084304354836,
              -28.06690479105888
            ],
            [
              -51.61728996760279,
              -28.065883457287256
            ],
            [
              -51.61488177880399,
              -28.065316049636355
            ],
            [
              -51.613606855322274,
              -28.063311209269838
            ],
            [
              -51.61592060534465,
              -28.061684640670585
            ],
            [
              -51.616298360450344,
              -28.06028503513169
            ],
            [
              -51.61771494209669,
              -28.059112392653162
            ],
            [
              -51.62012313089549,
              -28.055291847803755
            ],
            [
              -51.62201190642396,
              -28.052795254139788
            ],
            [
              -51.62522282482235,
              -28.05018517894564
            ],
            [
              -51.62767823300936,
              -28.049996043062006
            ],
            [
              -51.631219687125245,
              -28.047385967867857
            ],
            [
              -51.63391119225331,
              -28.047612930928217
            ],
            [
              -51.6366971361578,
              -28.046705078686774
            ],
            [
              -51.63929420250945,
              -28.044889374203887
            ],
            [
              -51.63929420250945,
              -28.039517915108682
            ],
            [
              -51.64019137088547,
              -28.037588729095617
            ],
            [
              -51.64689652401153,
              -28.032292924353865
            ],
            [
              -51.64869086076357,
              -28.0324820602375
            ],
            [
              -51.652798947537995,
              -28.03588650614291
            ],
            [
              -51.65430996796077,
              -28.035016481078195
            ],
            [
              -51.653601677137594,
              -28.031687689526237
            ],
            [
              -51.6503907587392,
              -28.025786649956856
            ],
            [
              -51.64859642198715,
              -28.022987438879074
            ],
            [
              -51.64571603930624,
              -28.020982598512553
            ],
            [
              -51.645291064812334,
              -28.019204721206393
            ],
            [
              -51.64590491685908,
              -28.01791859719768
            ],
            [
              -51.65072129445668,
              -28.01769163413732
            ],
            [
              -51.65388499346686,
              -28.019393857090027
            ],
            [
              -51.65591542715997,
              -28.020982598512553
            ],
            [
              -51.65657649859493,
              -28.024614007478327
            ],
            [
              -51.658087519017705,
              -28.026883638081934
            ],
            [
              -51.660117952710806,
              -28.027110601142294
            ],
            [
              -51.66819246809501,
              -28.024387044417963
            ],
            [
              -51.67069509567023,
              -28.026316230431032
            ],
            [
              -51.675511473267825,
              -28.026089267370672
            ],
            [
              -51.676314202867424,
              -28.02491662489214
            ],
            [
              -51.674708743668226,
              -28.022117413814357
            ],
            [
              -51.67060065689381,
              -28.019696474503842
            ],
            [
              -51.668995197694606,
              -28.015308522003533
            ],
            [
              -51.66738973849541,
              -28.01451415129227
            ],
            [
              -51.654498845513615,
              -28.014589805645723
            ],
            [
              -51.65171290160912,
              -28.013908916464644
            ],
            [
              -51.65100461078595,
              -28.0130010642232
            ],
            [
              -51.65478216184289,
              -28.010088371615236
            ],
            [
              -51.660779024145775,
              -28.00910486502034
            ],
            [
              -51.66172341191,
              -28.00781874101163
            ],
            [
              -51.66200672823928,
              -28.00448994945967
            ],
            [
              -51.66441491703807,
              -28.000404614373178
            ],
            [
              -51.66328165172099,
              -27.997983675062663
            ],
            [
              -51.66030683026366,
              -27.99809715659284
            ],
            [
              -51.65827639657055,
              -28.00320382545096
            ],
            [
              -51.655396013889636,
              -28.00471691252003
            ],
            [
              -51.64590491685908,
              -28.003695578748406
            ],
            [
              -51.64411058010704,
              -28.0019933557957
            ],
            [
              -51.64411058010704,
              -28.00070723178699
            ],
            [
              -51.64590491685908,
              -27.993217450795086
            ],
            [
              -51.64689652401153,
              -27.992082635493283
            ],
            [
              -51.65057963629204,
              -27.991099128898384
            ],
            [
              -51.6519962179384,
              -27.9892834244155
            ],
            [
              -51.65511269756037,
              -27.9887160167646
            ],
            [
              -51.65648205981851,
              -27.990304758187122
            ],
            [
              -51.66238448334497,
              -27.989888659243128
            ],
            [
              -51.668098029318585,
              -27.991099128898384
            ],
            [
              -51.66918407524746,
              -27.984290237087563
            ],
            [
              -51.67149782526983,
              -27.98311759460903
            ],
            [
              -51.67371713651578,
              -27.98360934790648
            ],
            [
              -51.67650308042027,
              -27.98311759460903
            ],
            [
              -51.67428376917432,
              -27.982588014134855
            ],
            [
              -51.67451986611538,
              -27.980696655298516
            ],
            [
              -51.672678309975126,
              -27.977897444220734
            ],
            [
              -51.670222901788115,
              -27.977292209393106
            ],
            [
              -51.66970348851778,
              -27.97619522126803
            ],
            [
              -51.66729529971899,
              -27.97759482680692
            ],
            [
              -51.66559540174337,
              -27.97698959197929
            ],
            [
              -51.66318721294457,
              -27.977897444220734
            ],
            [
              -51.660684585369346,
              -27.974492998315323
            ],
            [
              -51.65780420268843,
              -27.974417343961868
            ],
            [
              -51.65440440673719,
              -27.97229902206517
            ],
            [
              -51.64991856485708,
              -27.97309339277643
            ],
            [
              -51.64670764645868,
              -27.974492998315323
            ],
            [
              -51.644818870930216,
              -27.968516304392487
            ],
            [
              -51.64038024843831,
              -27.966587118379422
            ],
            [
              -51.636177722887474,
              -27.966284500965607
            ],
            [
              -51.63150300345451,
              -27.96779758803468
            ],
            [
              -51.62791432995042,
              -27.967116698853598
            ],
            [
              -51.618895426801984,
              -27.96840282286231
            ],
            [
              -51.61577894718001,
              -27.969310675103753
            ],
            [
              -51.60850716139541,
              -27.97301773842298
            ],
            [
              -51.60548512054986,
              -27.97260163947898
            ],
            [
              -51.599204941917705,
              -27.974909097259317
            ],
            [
              -51.597410605165656,
              -27.976611320212022
            ],
            [
              -51.590799890816015,
              -27.976081739737847
            ],
            [
              -51.58570019688916,
              -27.974190380901508
            ],
            [
              -51.58338644686678,
              -27.977783962690552
            ],
            [
              -51.582583717267184,
              -27.982209742367587
            ],
            [
              -51.57432032433013,
              -27.987808164523155
            ],
            [
              -51.57049555388498,
              -27.986408558984262
            ],
            [
              -51.5612877731837,
              -27.986900312281712
            ],
            [
              -51.556518614974316,
              -27.985614188273
            ],
            [
              -51.54868019653117,
              -27.988110781936967
            ],
            [
              -51.54589425262668,
              -27.987808164523155
            ],
            [
              -51.543722160768944,
              -27.99079651148457
            ],
            [
              -51.540888997476245,
              -27.990418239717304
            ],
            [
              -51.532578385150984,
              -27.987883818876607
            ],
            [
              -51.53050073206967,
              -27.985916805686813
            ],
            [
              -51.52568435447207,
              -27.983987619673748
            ],
            [
              -51.52318172689685,
              -27.979297049759627
            ],
            [
              -51.51590994111225,
              -27.970483317582282
            ],
            [
              -51.51600437988867,
              -27.966284500965607
            ],
            [
              -51.51038527269148,
              -27.959816053745325
            ],
            [
              -51.509204787986185,
              -27.955390274068293
            ],
            [
              -51.50339680323614,
              -27.952401927106873
            ],
            [
              -51.4887115735023,
              -27.953612396762132
            ],
            [
              -51.47369580805098,
              -27.952893680404323
            ],
            [
              -51.468312797794844,
              -27.952288445576695
            ],
            [
              -51.46019106302243,
              -27.949186617085097
            ],
            [
              -51.45839672627039,
              -27.92898690471299
            ],
            [
              -51.45570522114232,
              -27.926792928462834
            ],
            [
              -51.45301371601425,
              -27.92649031104902
            ],
            [
              -51.45169157314432,
              -27.924788088096314
            ],
            [
              -51.44810289964023,
              -27.92509070551013
            ],
            [
              -51.44541139451216,
              -27.925695940337757
            ],
            [
              -51.44418369041866,
              -27.923388482557424
            ],
            [
              -51.44281432816052,
              -27.922404975962525
            ],
            [
              -51.442106037337346,
              -27.920891888893454
            ],
            [
              -51.43998116486782,
              -27.920097518182192
            ],
            [
              -51.439886726091395,
              -27.918281813699306
            ],
            [
              -51.437384098516176,
              -27.91718482557423
            ],
            [
              -51.436298052587304,
              -27.91631480050951
            ],
            [
              -51.43308713418891,
              -27.916201318979333
            ],
            [
              -51.43200108826004,
              -27.912305119776473
            ],
            [
              -51.42949846068482,
              -27.913893861198996
            ],
            [
              -51.4277985627092,
              -27.91340210790155
            ],
            [
              -51.42709027188602,
              -27.914612577556806
            ],
            [
              -51.42557925146325,
              -27.915217812384434
            ],
            [
              -51.42321828205266,
              -27.914990849324074
            ],
            [
              -51.42208501673558,
              -27.91408299708263
            ],
            [
              -51.41981848610142,
              -27.9155960841517
            ],
            [
              -51.417410297302624,
              -27.91631480050951
            ],
            [
              -51.41722141974977,
              -27.915217812384434
            ],
            [
              -51.41552152177415,
              -27.91408299708263
            ],
            [
              -51.415710399327,
              -27.912494255660107
            ],
            [
              -51.4141049401278,
              -27.912002502362657
            ],
            [
              -51.41231060337576,
              -27.909316772815057
            ],
            [
              -51.412782797257876,
              -27.907084969388173
            ],
            [
              -51.41419937890422,
              -27.907198450918354
            ],
            [
              -51.415804838103426,
              -27.9059879812631
            ],
            [
              -51.41519098605667,
              -27.905193610551834
            ],
            [
              -51.41349108808105,
              -27.905798845379465
            ],
            [
              -51.41212172582291,
              -27.90428575831039
            ],
            [
              -51.41141343499974,
              -27.902507881004233
            ],
            [
              -51.40801363904849,
              -27.90209178206024
            ],
            [
              -51.40768310333101,
              -27.898687336154826
            ],
            [
              -51.40858027170703,
              -27.89721207626248
            ],
            [
              -51.40928856253021,
              -27.894185902124338
            ],
            [
              -51.40891080742451,
              -27.89308891399926
            ],
            [
              -51.40711647067247,
              -27.89108407363274
            ],
            [
              -51.40721090944889,
              -27.890403184451657
            ],
            [
              -51.41051626662371,
              -27.889117060442945
            ],
            [
              -51.411791190105426,
              -27.887603973373874
            ],
            [
              -51.409996853353384,
              -27.886582639602253
            ],
            [
              -51.40791920027207,
              -27.886809602662613
            ],
            [
              -51.40588876657896,
              -27.888284862554958
            ],
            [
              -51.404377746156186,
              -27.888209208201506
            ],
            [
              -51.403811113497646,
              -27.88540999712372
            ],
            [
              -51.4023945318513,
              -27.88540999712372
            ],
            [
              -51.3991836134529,
              -27.886998738546247
            ],
            [
              -51.39691708281874,
              -27.887301355960062
            ],
            [
              -51.39498108790206,
              -27.88839834408514
            ],
            [
              -51.39181738889187,
              -27.88930619632658
            ],
            [
              -51.390778562351215,
              -27.88711222007643
            ],
            [
              -51.38888978682275,
              -27.885788268890987
            ],
            [
              -51.389314761316655,
              -27.88401039158483
            ],
            [
              -51.3878981796703,
              -27.88321602087357
            ],
            [
              -51.38888978682275,
              -27.88200555121831
            ],
            [
              -51.3887009092699,
              -27.879584611907795
            ],
            [
              -51.38690657251786,
              -27.879698093437977
            ],
            [
              -51.38501779698939,
              -27.877806734601634
            ],
            [
              -51.38520667454223,
              -27.877012363890373
            ],
            [
              -51.382704046967014,
              -27.873910535398775
            ],
            [
              -51.38397897044873,
              -27.872889201627153
            ],
            [
              -51.38430950616621,
              -27.868993002424293
            ],
            [
              -51.385489990871505,
              -27.86831211324321
            ],
            [
              -51.38582052658899,
              -27.866609890290505
            ],
            [
              -51.38520667454223,
              -27.864794185807618
            ],
            [
              -51.38397897044873,
              -27.86558855651888
            ],
            [
              -51.38119302654424,
              -27.865815519579243
            ],
            [
              -51.38057917449749,
              -27.863810679212722
            ],
            [
              -51.38260960819059,
              -27.860595369190943
            ],
            [
              -51.38152356226172,
              -27.858098775526976
            ],
            [
              -51.38128746532066,
              -27.85651003410445
            ],
            [
              -51.37968200612146,
              -27.855715663393187
            ],
            [
              -51.378076546922266,
              -27.855488700332828
            ],
            [
              -51.377415475487304,
              -27.851705982660146
            ],
            [
              -51.377509914263726,
              -27.849398524879813
            ],
            [
              -51.37840708263975,
              -27.848793290052186
            ],
            [
              -51.38010698061537,
              -27.84898242593582
            ],
            [
              -51.38209019492026,
              -27.847696301927108
            ],
            [
              -51.38308180207271,
              -27.84610756050458
            ],
            [
              -51.38161800103815,
              -27.84459447343551
            ],
            [
              -51.37689606221697,
              -27.84380010272425
            ],
            [
              -51.373590705042155,
              -27.843989238607882
            ],
            [
              -51.371088077466936,
              -27.843194867896617
            ],
            [
              -51.37080476113766,
              -27.841000891646466
            ],
            [
              -51.37118251624336,
              -27.838996051279945
            ],
            [
              -51.37099363869051,
              -27.836612939146157
            ],
            [
              -51.37141861318442,
              -27.834381135719276
            ],
            [
              -51.375810016288106,
              -27.83090103546041
            ],
            [
              -51.37519616424135,
              -27.83010666474915
            ],
            [
              -51.375715577511684,
              -27.82761007108518
            ],
            [
              -51.377415475487304,
              -27.827307453671366
            ],
            [
              -51.3782182050869,
              -27.826399601429923
            ],
            [
              -51.377982108145844,
              -27.823184291408143
            ],
            [
              -51.376282210170224,
              -27.820687697744177
            ],
            [
              -51.3745823121946,
              -27.81981767267946
            ],
            [
              -51.37028534786734,
              -27.82061204339072
            ],
            [
              -51.36867988866814,
              -27.819704191149278
            ],
            [
              -51.36679111313967,
              -27.818001968196572
            ],
            [
              -51.36598838354007,
              -27.81599712783005
            ],
            [
              -51.364807898834776,
              -27.814294904877347
            ],
            [
              -51.3640996080116,
              -27.81179831121338
            ],
            [
              -51.36438292434087,
              -27.80669164235526
            ],
            [
              -51.36438292434087,
              -27.804081567161113
            ],
            [
              -51.362777465141676,
              -27.80200107244114
            ],
            [
              -51.36339131718842,
              -27.798483145005548
            ],
            [
              -51.362210832483136,
              -27.797688774294283
            ],
            [
              -51.35890547530831,
              -27.79821835476846
            ],
            [
              -51.35829162326156,
              -27.799201861363358
            ],
            [
              -51.35630840895667,
              -27.800298849488435
            ],
            [
              -51.35508070486316,
              -27.80200107244114
            ],
            [
              -51.35588343446276,
              -27.805292036816372
            ],
            [
              -51.353711342605024,
              -27.805783790113818
            ],
            [
              -51.35328636811112,
              -27.80741035871307
            ],
            [
              -51.35168090891192,
              -27.8080155935407
            ],
            [
              -51.350122669100934,
              -27.80790211201052
            ],
            [
              -51.3491782813367,
              -27.806805123885443
            ],
            [
              -51.349083842560276,
              -27.80461114763529
            ],
            [
              -51.349508817054186,
              -27.802492825738586
            ],
            [
              -51.351114276253384,
              -27.801584973497143
            ],
            [
              -51.35220032218225,
              -27.799012725479724
            ],
            [
              -51.35588343446276,
              -27.79640265028557
            ],
            [
              -51.356497286509516,
              -27.794397809919055
            ],
            [
              -51.35550567935707,
              -27.792884722849983
            ],
            [
              -51.35508070486316,
              -27.791182499897275
            ],
            [
              -51.34960325583061,
              -27.78679454739697
            ],
            [
              -51.34780891907856,
              -27.78781588116859
            ],
            [
              -51.34780891907856,
              -27.791182499897275
            ],
            [
              -51.344598000680165,
              -27.793187340263795
            ],
            [
              -51.34237868943421,
              -27.793300821793977
            ],
            [
              -51.33968718430615,
              -27.792506451082712
            ],
            [
              -51.33510690364961,
              -27.79069074659983
            ],
            [
              -51.333218128121146,
              -27.78970724000493
            ],
            [
              -51.33170710769837,
              -27.78830763446604
            ],
            [
              -51.331093255651616,
              -27.7864162756297
            ],
            [
              -51.33180154647479,
              -27.785281460327894
            ],
            [
              -51.334918026096766,
              -27.783087484077743
            ],
            [
              -51.334823587320344,
              -27.78240659489666
            ],
            [
              -51.33128213320446,
              -27.780704371943955
            ],
            [
              -51.33029052605202,
              -27.779002148991246
            ],
            [
              -51.330998816875194,
              -27.777602543452357
            ],
            [
              -51.33250983729797,
              -27.776392073797098
            ],
            [
              -51.333595883226835,
              -27.77450071496076
            ],
            [
              -51.33387919955611,
              -27.770793651641533
            ],
            [
              -51.33510690364961,
              -27.769318391749188
            ],
            [
              -51.336617924072385,
              -27.768410539507745
            ],
            [
              -51.337609531224835,
              -27.76678397090849
            ],
            [
              -51.3370901179545,
              -27.765611328429962
            ],
            [
              -51.32958223522884,
              -27.762698635821998
            ],
            [
              -51.32892116379388,
              -27.761790783580558
            ],
            [
              -51.330196087275596,
              -27.759483325800222
            ],
            [
              -51.33241539852155,
              -27.75770544849406
            ],
            [
              -51.33529578120246,
              -27.75418752105847
            ],
            [
              -51.33557909753173,
              -27.752598779635946
            ],
            [
              -51.33468192915571,
              -27.752107026338496
            ],
            [
              -51.33029052605202,
              -27.751085692566875
            ],
            [
              -51.32519083212515,
              -27.752182680691952
            ],
            [
              -51.32197991372676,
              -27.752485298105764
            ],
            [
              -51.31928840859869,
              -27.752409643752312
            ],
            [
              -51.317399633070224,
              -27.752712261166124
            ],
            [
              -51.31399983711898,
              -27.753884903644657
            ],
            [
              -51.31211106159051,
              -27.75350663187739
            ],
            [
              -51.31229993914336,
              -27.75150179151087
            ],
            [
              -51.3156997350946,
              -27.75078307515306
            ],
            [
              -51.31777738817591,
              -27.74991305008834
            ],
            [
              -51.31688021979989,
              -27.747189493364015
            ],
            [
              -51.317305194293795,
              -27.744806381230227
            ],
            [
              -51.318296801446245,
              -27.742801540863706
            ],
            [
              -51.31858011777551,
              -27.740796700497185
            ],
            [
              -51.31810792389339,
              -27.739510576488474
            ],
            [
              -51.31659690347062,
              -27.738716205777212
            ],
            [
              -51.31220550036693,
              -27.738716205777212
            ],
            [
              -51.31149720954376,
              -27.73981319390229
            ],
            [
              -51.312583255472624,
              -27.741591071208447
            ],
            [
              -51.313008229966535,
              -27.74370939310515
            ],
            [
              -51.31281935241368,
              -27.746016850885482
            ],
            [
              -51.309513995238866,
              -27.75078307515306
            ],
            [
              -51.30838072992179,
              -27.753393150347208
            ],
            [
              -51.30658639316974,
              -27.7547927558861
            ],
            [
              -51.30247830639532,
              -27.75490623741628
            ],
            [
              -51.30002289820831,
              -27.754111866705017
            ],
            [
              -51.29799246451521,
              -27.751199174097053
            ],
            [
              -51.29799246451521,
              -27.74991305008834
            ],
            [
              -51.300778408419696,
              -27.747302974894193
            ],
            [
              -51.30181723496035,
              -27.744201146402595
            ],
            [
              -51.301581138019294,
              -27.740418428729917
            ],
            [
              -51.3023838676189,
              -27.73780835353577
            ],
            [
              -51.30469761764127,
              -27.735500895755433
            ],
            [
              -51.30701136766364,
              -27.73519827834162
            ],
            [
              -51.311686087096604,
              -27.736900501294325
            ],
            [
              -51.31310266874296,
              -27.73648440235033
            ],
            [
              -51.31192218403766,
              -27.734290426100177
            ],
            [
              -51.310316724838465,
              -27.732815166207832
            ],
            [
              -51.3068224901108,
              -27.731112943255127
            ],
            [
              -51.30417820437094,
              -27.728881139828246
            ],
            [
              -51.30488649519412,
              -27.726006274397008
            ],
            [
              -51.308191852368935,
              -27.722488346961416
            ],
            [
              -51.308994581968534,
              -27.720483506594896
            ],
            [
              -51.30880570441569,
              -27.7195
            ],
            [
              -51.3068224901108,
              -27.72101308706907
            ],
            [
              -51.30068396964327,
              -27.723698816616675
            ],
            [
              -51.293695500187944,
              -27.725514521099562
            ],
            [
              -51.29081511750703,
              -27.724984940625387
            ],
            [
              -51.28250450518177,
              -27.723017927435592
            ],
            [
              -51.27787700513702,
              -27.72339619920286
            ],
            [
              -51.27608266838497,
              -27.724001434030487
            ],
            [
              -51.27419389285651,
              -27.725817138513374
            ],
            [
              -51.27291896937479,
              -27.729713337716234
            ],
            [
              -51.272682872433734,
              -27.732209931380204
            ],
            [
              -51.27329672448048,
              -27.735500895755433
            ],
            [
              -51.274807744903256,
              -27.742385441919712
            ],
            [
              -51.27461886735041,
              -27.748513444549452
            ],
            [
              -51.27409945408008,
              -27.74991305008834
            ],
            [
              -51.272021800998765,
              -27.751690927394502
            ],
            [
              -51.26909419892964,
              -27.752598779635946
            ],
            [
              -51.26191685192146,
              -27.753317495993755
            ],
            [
              -51.2568171579946,
              -27.754414484118833
            ],
            [
              -51.254786724301496,
              -27.755284509183547
            ],
            [
              -51.247987132399004,
              -27.75880243661914
            ],
            [
              -51.245484504823786,
              -27.761412511813287
            ],
            [
              -51.245390066047364,
              -27.764211722891073
            ],
            [
              -51.24590947931769,
              -27.7675026872663
            ],
            [
              -51.24557894360021,
              -27.770301898344087
            ],
            [
              -51.242792999695716,
              -27.776316419443646
            ],
            [
              -51.240101494567654,
              -27.779002148991246
            ],
            [
              -51.236276724122504,
              -27.77979651970251
            ],
            [
              -51.235285116970054,
              -27.77968303817233
            ],
            [
              -51.231696443465964,
              -27.777905160866172
            ],
            [
              -51.22631343320983,
              -27.771209750585527
            ],
            [
              -51.22229978521184,
              -27.769810145046637
            ],
            [
              -51.21960828008377,
              -27.76999928093027
            ],
            [
              -51.2161140453561,
              -27.772306738710604
            ],
            [
              -51.21299756573413,
              -27.77529508567202
            ],
            [
              -51.21091991265281,
              -27.776883827094547
            ],
            [
              -51.20940889223004,
              -27.777489061922175
            ],
            [
              -51.20341202992715,
              -27.77779167933599
            ],
            [
              -51.19869009110598,
              -27.77729992603854
            ],
            [
              -51.19500697882547,
              -27.77601380202983
            ],
            [
              -51.19240991247383,
              -27.77590032049965
            ],
            [
              -51.18778241242908,
              -27.77771602498254
            ],
            [
              -51.18542144301849,
              -27.779493902288696
            ],
            [
              -51.18230496339652,
              -27.782595730780294
            ],
            [
              -51.17068899389644,
              -27.792582105436168
            ],
            [
              -51.160111850937014,
              -27.80150931914369
            ],
            [
              -51.15779810091464,
              -27.802908924682583
            ],
            [
              -51.15430386618698,
              -27.803816776924027
            ],
            [
              -51.14901529470726,
              -27.80400591280766
            ],
            [
              -51.14528496303854,
              -27.80340067798003
            ],
            [
              -51.14079912115842,
              -27.803098060566217
            ],
            [
              -51.13461338130269,
              -27.803703295393845
            ],
            [
              -51.133007922103495,
              -27.805481172700006
            ],
            [
              -51.13229963128032,
              -27.80741035871307
            ],
            [
              -51.130316416975425,
              -27.818909820438016
            ],
            [
              -51.12927759043477,
              -27.82288167399433
            ],
            [
              -51.13149690168072,
              -27.827685725438634
            ],
            [
              -51.131119146575024,
              -27.83010666474915
            ],
            [
              -51.12960812615225,
              -27.831581924641494
            ],
            [
              -51.127294376129875,
              -27.832603258413116
            ],
            [
              -51.12101419749772,
              -27.832603258413116
            ],
            [
              -51.11128700352611,
              -27.829085330977524
            ],
            [
              -51.10859549839804,
              -27.82840444179644
            ],
            [
              -51.102787513648,
              -27.82738310802482
            ],
            [
              -51.098301671767885,
              -27.82738310802482
            ],
            [
              -51.092682564570694,
              -27.828593577680074
            ],
            [
              -51.08951886556051,
              -27.829804047335333
            ],
            [
              -51.082199860387696,
              -27.833889382421827
            ],
            [
              -51.079413916483205,
              -27.837104692443603
            ],
            [
              -51.07710016646083,
              -27.840509138349017
            ],
            [
              -51.0765807531905,
              -27.841795262357728
            ],
            [
              -51.076486314414076,
              -27.844216201668242
            ],
            [
              -51.0773834827901,
              -27.848906771582364
            ],
            [
              -51.079083380765724,
              -27.85340820561285
            ],
            [
              -51.07950835525963,
              -27.858212257057154
            ],
            [
              -51.078611186883606,
              -27.861616702962568
            ],
            [
              -51.077477921566526,
              -27.862713691087645
            ],
            [
              -51.073889248062436,
              -27.864113296626535
            ],
            [
              -51.06708965615995,
              -27.865399420635246
            ],
            [
              -51.060998355080635,
              -27.865285939105068
            ],
            [
              -51.05707914585906,
              -27.866004655462877
            ],
            [
              -51.054812615224904,
              -27.86710164358795
            ],
            [
              -51.05339603357855,
              -27.868917348070838
            ],
            [
              -51.053018278472855,
              -27.869787373135555
            ],
            [
              -51.05320715602571,
              -27.873910535398775
            ],
            [
              -51.0556153448245,
              -27.880416809795783
            ],
            [
              -51.056276416259465,
              -27.882989057813205
            ],
            [
              -51.056701390753375,
              -27.886809602662613
            ],
            [
              -51.0567958295298,
              -27.88930619632658
            ],
            [
              -51.05830684995257,
              -27.896795977318487
            ],
            [
              -51.0580235336233,
              -27.89970866992645
            ],
            [
              -51.0559930999302,
              -27.90371835065949
            ],
            [
              -51.054387640731,
              -27.905307092082015
            ],
            [
              -51.050987844779755,
              -27.907690204215804
            ],
            [
              -51.04059957937318,
              -27.91219163824629
            ],
            [
              -51.03691646709267,
              -27.915104330854255
            ],
            [
              -51.02799200272065,
              -27.9186979126433
            ],
            [
              -51.01991748733645,
              -27.922518457492707
            ],
            [
              -51.016517691385204,
              -27.925506804454123
            ],
            [
              -51.015903839338456,
              -27.927700780704278
            ],
            [
              -51.01628159444415,
              -27.933299202859843
            ],
            [
              -51.01698988526732,
              -27.93590927805399
            ],
            [
              -51.01798149241977,
              -27.938103254304146
            ],
            [
              -51.02081465571247,
              -27.94230207092082
            ],
            [
              -51.02161738531207,
              -27.945214763528785
            ],
            [
              -51.02138128837101,
              -27.951304938981796
            ],
            [
              -51.02072021693605,
              -27.954406767473394
            ],
            [
              -51.01902031896043,
              -27.957016842667542
            ],
            [
              -51.00919868621239,
              -27.964393142129268
            ],
            [
              -51.0067904974136,
              -27.96518751284053
            ],
            [
              -51.00461840555586,
              -27.96518751284053
            ],
            [
              -51.002304655533486,
              -27.964204006245634
            ],
            [
              -51.00150192593388,
              -27.963182672474012
            ],
            [
              -51.00079363511071,
              -27.962085684348935
            ],
            [
              -50.998621543252966,
              -27.955617237128653
            ],
            [
              -50.99729940038304,
              -27.952515408637055
            ],
            [
              -50.99531618607815,
              -27.949186617085097
            ],
            [
              -50.99361628810253,
              -27.946009134240047
            ],
            [
              -50.990405369704135,
              -27.942793824218267
            ],
            [
              -50.986013966600446,
              -27.940486366437934
            ],
            [
              -50.98431406862482,
              -27.9402972305543
            ],
            [
              -50.98171700227318,
              -27.941091601265562
            ],
            [
              -50.980300420626826,
              -27.942604688334633
            ],
            [
              -50.97878940020405,
              -27.946387406007315
            ],
            [
              -50.978411645098355,
              -27.9482031104902
            ],
            [
              -50.97690062467558,
              -27.95198582816288
            ],
            [
              -50.97359526750076,
              -27.95448242182685
            ],
            [
              -50.96877888990317,
              -27.956487262193367
            ],
            [
              -50.958721160214075,
              -27.96000518962896
            ],
            [
              -50.95248820097013,
              -27.963409635534372
            ],
            [
              -50.949277282571735,
              -27.966095365081973
            ],
            [
              -50.94701075193757,
              -27.96719235320705
            ],
            [
              -50.94290266516315,
              -27.968289341332127
            ],
            [
              -50.940305598811506,
              -27.96870544027612
            ],
            [
              -50.93780297123629,
              -27.96840282286231
            ],
            [
              -50.9334115681326,
              -27.967494970620866
            ],
            [
              -50.93090894055738,
              -27.967608452151048
            ],
            [
              -50.92798133848825,
              -27.968289341332127
            ],
            [
              -50.92571480785409,
              -27.969386329457205
            ],
            [
              -50.924014909878466,
              -27.97169378723754
            ],
            [
              -50.92321218027887,
              -27.97630870279821
            ],
            [
              -50.92321218027887,
              -27.97959966717344
            ],
            [
              -50.92377881293741,
              -27.981301890126147
            ],
            [
              -50.92698973133581,
              -27.987808164523155
            ],
            [
              -50.92788689971183,
              -27.990607375600938
            ],
            [
              -50.927509144606134,
              -27.99291483338127
            ],
            [
              -50.92628144051263,
              -27.994503574803797
            ],
            [
              -50.922787205784964,
              -27.997000168467764
            ],
            [
              -50.9213234047504,
              -27.998891527304107
            ],
            [
              -50.92061511392723,
              -28.00059375025681
            ],
            [
              -50.92080399148007,
              -28.002598590623332
            ],
            [
              -50.924014909878466,
              -28.008688766076347
            ],
            [
              -50.92420378743132,
              -28.01039098902905
            ],
            [
              -50.92321218027887,
              -28.012017557628305
            ],
            [
              -50.91981238432763,
              -28.013190200106834
            ],
            [
              -50.91140733322594,
              -28.014211533878456
            ],
            [
              -50.9080075372747,
              -28.01489242305954
            ],
            [
              -50.900216338219764,
              -28.017805115667503
            ],
            [
              -50.89709985859779,
              -28.019393857090027
            ],
            [
              -50.89459723102257,
              -28.019999091917658
            ],
            [
              -50.88968641464856,
              -28.02291178452562
            ],
            [
              -50.88798651667293,
              -28.024614007478327
            ],
            [
              -50.88449228194527,
              -28.02930457739245
            ],
            [
              -50.876701082890335,
              -28.03800482803961
            ],
            [
              -50.875378940020404,
              -28.040198804289766
            ],
            [
              -50.87528450124398,
              -28.041295792414843
            ],
            [
              -50.874906746138294,
              -28.047196831984223
            ],
            [
              -50.875378940020404,
              -28.05438399556231
            ],
            [
              -50.87707883799603,
              -28.059112392653162
            ],
            [
              -50.87910927168913,
              -28.06361382668365
            ],
            [
              -50.881423021711505,
              -28.06728306282615
            ],
            [
              -50.882414628863955,
              -28.06849353248141
            ],
            [
              -50.88590886359162,
              -28.071784496856637
            ],
            [
              -50.887514322790814,
              -28.072616694744628
            ],
            [
              -50.89200016467093,
              -28.07390281875334
            ],
            [
              -50.896013812668926,
              -28.0746971894646
            ],
            [
              -50.898516440244144,
              -28.075491560175863
            ],
            [
              -50.899980241278705,
              -28.07719378312857
            ],
            [
              -50.90328559845353,
              -28.08271655093068
            ],
            [
              -50.903899450500276,
              -28.085818379422278
            ],
            [
              -50.90290784334783,
              -28.088504108969882
            ],
            [
              -50.899413608620165,
              -28.089714578625138
            ],
            [
              -50.89421947591688,
              -28.08910934379751
            ],
            [
              -50.88921422076644,
              -28.08899586226733
            ],
            [
              -50.88439784316884,
              -28.089714578625138
            ],
            [
              -50.88151746048793,
              -28.090698085220037
            ],
            [
              -50.87910927168913,
              -28.092211172289108
            ],
            [
              -50.87589835329074,
              -28.095086037720343
            ],
            [
              -50.874812307361864,
              -28.097582631384313
            ],
            [
              -50.870090368540694,
              -28.105904610264208
            ],
            [
              -50.869287638941096,
              -28.10821206804454
            ],
            [
              -50.86881544505898,
              -28.111503032419773
            ],
            [
              -50.86919320016467,
              -28.116382738217528
            ],
            [
              -50.870279246093546,
              -28.119295430825492
            ],
            [
              -50.87249855733949,
              -28.122889012614536
            ],
            [
              -50.87448177164438,
              -28.12701217487776
            ],
            [
              -50.87519006246756,
              -28.130794892550437
            ],
            [
              -50.874812307361864,
              -28.132497115503142
            ],
            [
              -50.871979144069165,
              -28.137414648477627
            ],
            [
              -50.870279246093546,
              -28.13881425401652
            ],
            [
              -50.8681071542358,
              -28.13998689649505
            ],
            [
              -50.86551008788416,
              -28.14078126720631
            ],
            [
              -50.861213123556894,
              -28.140516476969225
            ],
            [
              -50.85899381231094,
              -28.139684279081234
            ],
            [
              -50.854696847983675,
              -28.135901561408556
            ],
            [
              -50.850211006103564,
              -28.132383633972964
            ],
            [
              -50.84449746012995,
              -28.127201310761393
            ],
            [
              -50.84057825090838,
              -28.122889012614536
            ],
            [
              -50.83680069985144,
              -28.119408912355674
            ],
            [
              -50.8342036334998,
              -28.11778234375642
            ],
            [
              -50.830189985501804,
              -28.117706689402965
            ],
            [
              -50.82849008752618,
              -28.11850106011423
            ],
            [
              -50.8269790671034,
              -28.11990066565312
            ],
            [
              -50.824995852798516,
              -28.123986000739613
            ],
            [
              -50.824004245646066,
              -28.129092669597732
            ],
            [
              -50.82339039359931,
              -28.134501955869663
            ],
            [
              -50.822304347670446,
              -28.13809553765871
            ],
            [
              -50.821076643576944,
              -28.13960862472778
            ],
            [
              -50.81819626089602,
              -28.141310847680487
            ],
            [
              -50.81611860781471,
              -28.141613465094302
            ],
            [
              -50.80941345468865,
              -28.14100823026667
            ],
            [
              -50.80318049544471,
              -28.139306007313966
            ],
            [
              -50.79869465356459,
              -28.138700772486338
            ],
            [
              -50.794114372908055,
              -28.138587290956156
            ],
            [
              -50.78991184735721,
              -28.13938166166742
            ],
            [
              -50.787692536111265,
              -28.14028951390886
            ],
            [
              -50.78608707691206,
              -28.141689119447754
            ],
            [
              -50.78481215343035,
              -28.14399657722809
            ],
            [
              -50.78471771465392,
              -28.146493170892057
            ],
            [
              -50.78679536773524,
              -28.150616333155277
            ],
            [
              -50.79038404123933,
              -28.153112926819247
            ],
            [
              -50.791989500438525,
              -28.15519342153922
            ],
            [
              -50.7926977912617,
              -28.15780349673337
            ],
            [
              -50.792414474932436,
              -28.160791843694785
            ],
            [
              -50.79047848001575,
              -28.166390265850353
            ],
            [
              -50.787503658558414,
              -28.171194317294656
            ],
            [
              -50.78349001056042,
              -28.17501486214406
            ],
            [
              -50.782781719737244,
              -28.175998368738956
            ],
            [
              -50.782781719737244,
              -28.178608443933108
            ],
            [
              -50.784103862607175,
              -28.181899408308336
            ],
            [
              -50.78740921978199,
              -28.186287360808645
            ],
            [
              -50.789203556534034,
              -28.18920005341661
            ],
            [
              -50.78991184735721,
              -28.19411758639109
            ],
            [
              -50.789392434086885,
              -28.197181587705963
            ],
            [
              -50.78877858204013,
              -28.198316403007766
            ],
            [
              -50.786700928958815,
              -28.199905144430293
            ],
            [
              -50.784009423830746,
              -28.200812996671736
            ],
            [
              -50.78079850543235,
              -28.20100213255537
            ],
            [
              -50.777493148257534,
              -28.20001862596047
            ],
            [
              -50.7745183268002,
              -28.198089439947406
            ],
            [
              -50.772110138001395,
              -28.196008945227433
            ],
            [
              -50.76989082675545,
              -28.19109141225295
            ],
            [
              -50.76819092877982,
              -28.189010917532975
            ],
            [
              -50.766491030804204,
              -28.188405682705344
            ],
            [
              -50.76441337772289,
              -28.18920005341661
            ],
            [
              -50.762099627700515,
              -28.191394029666764
            ],
            [
              -50.761202459324494,
              -28.194987611455808
            ],
            [
              -50.76058860727774,
              -28.203498726219337
            ],
            [
              -50.7600219746192,
              -28.20709230800838
            ],
            [
              -50.75832207664358,
              -28.21019413649998
            ],
            [
              -50.756480520503324,
              -28.214506434646836
            ],
            [
              -50.75629164295047,
              -28.216284311952993
            ],
            [
              -50.754922280692334,
              -28.224908908246704
            ],
            [
              -50.753789015375254,
              -28.22869162591938
            ],
            [
              -50.75289184699923,
              -28.23319305994987
            ],
            [
              -50.752986285775656,
              -28.237997111394172
            ],
            [
              -50.75369457659883,
              -28.24041805070469
            ],
            [
              -50.753883454151676,
              -28.244616867321362
            ],
            [
              -50.75331682149314,
              -28.24571385544644
            ],
            [
              -50.751191949023614,
              -28.24760521428278
            ],
            [
              -50.7491142959423,
              -28.24851306652422
            ],
            [
              -50.74717830102561,
              -28.24911830135185
            ],
            [
              -50.741984168322325,
              -28.249799190532933
            ],
            [
              -50.73929266319426,
              -28.251085314541644
            ],
            [
              -50.73598730601944,
              -28.25350625385216
            ],
            [
              -50.73032097943403,
              -28.257099835641206
            ],
            [
              -50.72380470386082,
              -28.259709910835355
            ],
            [
              -50.71898832626322,
              -28.261109516374244
            ],
            [
              -50.71577740786483,
              -28.26258477626659
            ],
            [
              -50.71067771393796,
              -28.26651880264618
            ],
            [
              -50.70808064758632,
              -28.26719969182726
            ],
            [
              -50.70538914245825,
              -28.267388827710892
            ],
            [
              -50.701517152624895,
              -28.266291839585815
            ],
            [
              -50.69929784137894,
              -28.266291839585815
            ],
            [
              -50.69660633625087,
              -28.26780492665489
            ],
            [
              -50.69561472909843,
              -28.269885421374862
            ],
            [
              -50.69448146378135,
              -28.27450033693553
            ],
            [
              -50.69419814745208,
              -28.277413029543492
            ],
            [
              -50.69448146378135,
              -28.279909623207462
            ],
            [
              -50.695992484204126,
              -28.28301145169906
            ],
            [
              -50.69651189747445,
              -28.285016292065578
            ],
            [
              -50.69618136175697,
              -28.28679416937174
            ],
            [
              -50.69518975460452,
              -28.288496392324443
            ],
            [
              -50.68239330039915,
              -28.297196642971606
            ],
            [
              -50.677576922801556,
              -28.29999585404939
            ],
            [
              -50.670399575793375,
              -28.307409980687844
            ],
            [
              -50.664922126760814,
              -28.312781439783045
            ],
            [
              -50.66218340224454,
              -28.316904602046268
            ],
            [
              -50.66090847876282,
              -28.320309047951678
            ],
            [
              -50.6587836062933,
              -28.32348653079673
            ],
            [
              -50.65859472874045,
              -28.325793988577065
            ],
            [
              -50.6600113103868,
              -28.32821492788758
            ],
            [
              -50.664213835937645,
              -28.333094633685334
            ],
            [
              -50.66548875941936,
              -28.33680169700456
            ],
            [
              -50.66520544309009,
              -28.337898685129637
            ],
            [
              -50.66227784102096,
              -28.339790043965976
            ],
            [
              -50.65472273890709,
              -28.341794884332497
            ],
            [
              -50.65170069806154,
              -28.343497107285202
            ],
            [
              -50.64551495820581,
              -28.348301158729505
            ],
            [
              -50.64169018776066,
              -28.352689111229815
            ],
            [
              -50.63989585100861,
              -28.35499656901015
            ],
            [
              -50.636118299951676,
              -28.35840101491556
            ],
            [
              -50.63191577440083,
              -28.36150284340716
            ],
            [
              -50.62879929477886,
              -28.363999437071126
            ],
            [
              -50.62818544273211,
              -28.366117758967828
            ],
            [
              -50.629177049884554,
              -28.369597859226694
            ],
            [
              -50.63238796828295,
              -28.374515392201175
            ],
            [
              -50.63319069788255,
              -28.377390257632413
            ],
            [
              -50.63328513665897,
              -28.378903344701484
            ],
            [
              -50.63167967745977,
              -28.382913025434522
            ],
            [
              -50.629177049884554,
              -28.38650660722357
            ],
            [
              -50.628610417226014,
              -28.388095348646093
            ],
            [
              -50.625682815156885,
              -28.392105029379135
            ],
            [
              -50.623982917181266,
              -28.393012881620578
            ],
            [
              -50.61978039163042,
              -28.393391153387846
            ],
            [
              -50.61387796810396,
              -28.393618116448206
            ],
            [
              -50.61047817215272,
              -28.392899400090396
            ],
            [
              -50.60462296801447,
              -28.388095348646093
            ],
            [
              -50.60301750881526,
              -28.38571223651231
            ],
            [
              -50.60249809554494,
              -28.384199149443234
            ],
            [
              -50.60089263634574,
              -28.382194309076716
            ],
            [
              -50.59810669244125,
              -28.38109732095164
            ],
            [
              -50.59319587606723,
              -28.381589074249085
            ],
            [
              -50.59040993216274,
              -28.382913025434522
            ],
            [
              -50.58658516171759,
              -28.38578789086576
            ],
            [
              -50.576480212640284,
              -28.39429900562929
            ],
            [
              -50.57218324831302,
              -28.39970829190122
            ],
            [
              -50.57057778911382,
              -28.401410514853925
            ],
            [
              -50.56939730440853,
              -28.403415355220446
            ],
            [
              -50.56911398807926,
              -28.40799244360439
            ],
            [
              -50.56750852888006,
              -28.410489037268356
            ],
            [
              -50.56538365641053,
              -28.413212593992686
            ],
            [
              -50.56188942168287,
              -28.416011805070468
            ],
            [
              -50.55929235533122,
              -28.41741141060936
            ],
            [
              -50.55060398790027,
              -28.42009714015696
            ],
            [
              -50.548384676654315,
              -28.42191284463985
            ],
            [
              -50.54621258479658,
              -28.42569556231253
            ],
            [
              -50.54418215110348,
              -28.427511266795413
            ],
            [
              -50.54158508475183,
              -28.42860825492049
            ],
            [
              -50.53799641124774,
              -28.42959176151539
            ],
            [
              -50.53469105407292,
              -28.42959176151539
            ],
            [
              -50.53091350301599,
              -28.42860825492049
            ],
            [
              -50.52921360504036,
              -28.427284303735053
            ],
            [
              -50.52822199788792,
              -28.4250903274849
            ],
            [
              -50.52822199788792,
              -28.42319896864856
            ],
            [
              -50.52878863054646,
              -28.419416250975882
            ],
            [
              -50.52888306932288,
              -28.417184447549
            ],
            [
              -50.52940248259321,
              -28.414801335415213
            ],
            [
              -50.530394089745656,
              -28.412985630932326
            ],
            [
              -50.531621793839165,
              -28.407803307720755
            ],
            [
              -50.531291258121676,
              -28.40610108476805
            ],
            [
              -50.52841087544076,
              -28.40409624440153
            ],
            [
              -50.5257193703127,
              -28.4034910095739
            ],
            [
              -50.52269732946715,
              -28.403188392160086
            ],
            [
              -50.51920309473948,
              -28.40360449110408
            ],
            [
              -50.51358398754229,
              -28.40458799769898
            ],
            [
              -50.5107980436378,
              -28.405684985824053
            ],
            [
              -50.507917660956885,
              -28.40738720877676
            ],
            [
              -50.50399845173531,
              -28.41071600032872
            ],
            [
              -50.5011180690544,
              -28.412493877634876
            ],
            [
              -50.49852100270275,
              -28.413099112462504
            ],
            [
              -50.494790671034025,
              -28.412985630932326
            ],
            [
              -50.49247692101165,
              -28.412607359165058
            ],
            [
              -50.48921878322505,
              -28.412493877634876
            ],
            [
              -50.4845912831803,
              -28.413212593992686
            ],
            [
              -50.48048319640588,
              -28.414082619057403
            ],
            [
              -50.47538350247901,
              -28.414801335415213
            ],
            [
              -50.470378247328576,
              -28.41491481694539
            ],
            [
              -50.46820615547084,
              -28.414385236471215
            ],
            [
              -50.461406563568346,
              -28.41188864280725
            ],
            [
              -50.456920721688235,
              -28.41071600032872
            ],
            [
              -50.455220823712615,
              -28.411699506923615
            ],
            [
              -50.4519154665378,
              -28.416390076837736
            ],
            [
              -50.44931840018615,
              -28.421496745695855
            ],
            [
              -50.446579675669874,
              -28.424106820890003
            ],
            [
              -50.439921741932025,
              -28.42860825492049
            ],
            [
              -50.435908093934025,
              -28.43099136705428
            ],
            [
              -50.432177762265304,
              -28.432693590006984
            ],
            [
              -50.42877796631406,
              -28.43348796071825
            ],
            [
              -50.42481153770427,
              -28.433298824834615
            ],
            [
              -50.4224977876819,
              -28.43348796071825
            ],
            [
              -50.4192868692835,
              -28.433185343304434
            ],
            [
              -50.41631204782617,
              -28.432617935653532
            ],
            [
              -50.412203961051745,
              -28.43310968895098
            ],
            [
              -50.40970133347653,
              -28.434093195545877
            ],
            [
              -50.405215491596415,
              -28.434395812959693
            ],
            [
              -50.39907697112889,
              -28.433904059662243
            ],
            [
              -50.396904879271155,
              -28.432693590006984
            ],
            [
              -50.39449669047236,
              -28.433412306364794
            ],
            [
              -50.392513476167466,
              -28.435795418498582
            ],
            [
              -50.39199406289713,
              -28.43689240662366
            ],
            [
              -50.391285772073964,
              -28.441318186300695
            ],
            [
              -50.38968031287476,
              -28.4435878169043
            ],
            [
              -50.38198355259625,
              -28.446992262809715
            ],
            [
              -50.378914292362495,
              -28.44619789209845
            ],
            [
              -50.377781027045415,
              -28.445290039857007
            ],
            [
              -50.37641166478727,
              -28.442604310309406
            ],
            [
              -50.37608112906979,
              -28.440107716645436
            ],
            [
              -50.37660054234012,
              -28.437989394748737
            ],
            [
              -50.37688385866939,
              -28.43488756625714
            ],
            [
              -50.37641166478727,
              -28.43310968895098
            ],
            [
              -50.374900644364494,
              -28.43038613222665
            ],
            [
              -50.371311970860404,
              -28.42580904384271
            ],
            [
              -50.37032036370796,
              -28.422782869704566
            ],
            [
              -50.36838436879128,
              -28.42119412828204
            ],
            [
              -50.3644179401815,
              -28.419983658626784
            ],
            [
              -50.36111258300668,
              -28.419605386859516
            ],
            [
              -50.35818498093755,
              -28.420399757570777
            ],
            [
              -50.356107327856236,
              -28.421383264165673
            ],
            [
              -50.353085287010686,
              -28.42399333935982
            ],
            [
              -50.35100763392937,
              -28.424901191601265
            ],
            [
              -50.34911885840091,
              -28.42830563750668
            ],
            [
              -50.34760783797813,
              -28.431785737765544
            ],
            [
              -50.34760783797813,
              -28.434811911903687
            ],
            [
              -50.34878832268342,
              -28.43938900028763
            ],
            [
              -50.35058265943547,
              -28.444382187615567
            ],
            [
              -50.35199924108182,
              -28.44918623905987
            ],
            [
              -50.35209367985824,
              -28.4572812548794
            ],
            [
              -50.35001602677693,
              -28.46061004643136
            ],
            [
              -50.34581350122608,
              -28.463598393392775
            ],
            [
              -50.34321643487444,
              -28.46310664009533
            ],
            [
              -50.33991107769962,
              -28.46159355302626
            ],
            [
              -50.33750288890082,
              -28.45921044089247
            ],
            [
              -50.336794598077645,
              -28.455805994987056
            ],
            [
              -50.33769176645367,
              -28.44820273246497
            ],
            [
              -50.33840005727684,
              -28.446500509512266
            ],
            [
              -50.34009995525247,
              -28.44351216255085
            ],
            [
              -50.340383271581736,
              -28.44101556888688
            ],
            [
              -50.338919470547175,
              -28.43878376546
            ],
            [
              -50.33599186847805,
              -28.436816752270207
            ],
            [
              -50.328578424528814,
              -28.434017541192425
            ],
            [
              -50.325084189801146,
              -28.43348796071825
            ],
            [
              -50.323195414272675,
              -28.433904059662243
            ],
            [
              -50.31889844994541,
              -28.43560628261495
            ],
            [
              -50.31460148561814,
              -28.437800258865103
            ],
            [
              -50.31299602641894,
              -28.43810287627892
            ],
            [
              -50.30841574576241,
              -28.437497641451287
            ],
            [
              -50.306101995740036,
              -28.43738415992111
            ],
            [
              -50.303882684494084,
              -28.437913740395285
            ],
            [
              -50.301285618142444,
              -28.439313345934174
            ],
            [
              -50.299916255884305,
              -28.44078860582652
            ],
            [
              -50.29661089870948,
              -28.44551700291737
            ],
            [
              -50.29481656195744,
              -28.44918623905987
            ],
            [
              -50.292077837441155,
              -28.451493696840203
            ],
            [
              -50.28631707207933,
              -28.452893302379096
            ],
            [
              -50.28121737815246,
              -28.454784661215434
            ],
            [
              -50.27668431688414,
              -28.455616859103422
            ],
            [
              -50.2729067658272,
              -28.457092118995767
            ],
            [
              -50.26950696987596,
              -28.455805994987056
            ],
            [
              -50.26620161270114,
              -28.453687673090357
            ],
            [
              -50.26228240347957,
              -28.45209893166783
            ],
            [
              -50.25911870446939,
              -28.450510190245307
            ],
            [
              -50.25538837280066,
              -28.449299720590048
            ],
            [
              -50.25109140847339,
              -28.44918623905987
            ],
            [
              -50.250288678873794,
              -28.447105744339893
            ],
            [
              -50.2531218421665,
              -28.44608441056827
            ],
            [
              -50.25751324527019,
              -28.445592657270822
            ],
            [
              -50.26011031162183,
              -28.44608441056827
            ],
            [
              -50.262990694302744,
              -28.446008756214816
            ],
            [
              -50.2644072759491,
              -28.44419305173193
            ],
            [
              -50.26421839839625,
              -28.44290692772322
            ],
            [
              -50.260488066727525,
              -28.439691617701442
            ],
            [
              -50.25661607689416,
              -28.43768677733492
            ],
            [
              -50.25179969929657,
              -28.432807071537166
            ],
            [
              -50.249816484991676,
              -28.430196996343017
            ],
            [
              -50.24679444414613,
              -28.42830563750668
            ],
            [
              -50.24528342372336,
              -28.429213489748122
            ],
            [
              -50.242403041042444,
              -28.432012700825904
            ],
            [
              -50.24197806654853,
              -28.43310968895098
            ],
            [
              -50.24131699511357,
              -28.44018337099889
            ],
            [
              -50.238719928761924,
              -28.444987422443194
            ],
            [
              -50.237917199162325,
              -28.449110584706414
            ],
            [
              -50.236783933845246,
              -28.452212413198012
            ],
            [
              -50.23640617873956,
              -28.45531424168961
            ],
            [
              -50.23569788791638,
              -28.457016464642315
            ],
            [
              -50.233997989940754,
              -28.458416070181205
            ],
            [
              -50.23140092358911,
              -28.459286095245922
            ],
            [
              -50.22682064293257,
              -28.46159355302626
            ],
            [
              -50.222618117381735,
              -28.463295775978963
            ],
            [
              -50.22039880613578,
              -28.46310664009533
            ],
            [
              -50.21780173978414,
              -28.461782688909892
            ],
            [
              -50.21581852547925,
              -28.460307429017547
            ],
            [
              -50.212182632586945,
              -28.45610861240087
            ],
            [
              -50.2103882958349,
              -28.45448204380162
            ],
            [
              -50.20698849988366,
              -28.450510190245307
            ],
            [
              -50.20628020906048,
              -28.447105744339893
            ],
            [
              -50.20561913762552,
              -28.44551700291737
            ],
            [
              -50.20401367842632,
              -28.44381477996466
            ],
            [
              -50.201605489627525,
              -28.4435878169043
            ],
            [
              -50.1991028620523,
              -28.44479828655956
            ],
            [
              -50.19338931607869,
              -28.449299720590048
            ],
            [
              -50.19098112727989,
              -28.451493696840203
            ],
            [
              -50.18828962215182,
              -28.453498537206723
            ],
            [
              -50.18668416295262,
              -28.453801154620535
            ],
            [
              -50.18219832107251,
              -28.45308243826273
            ],
            [
              -50.17969569349729,
              -28.45179631425402
            ],
            [
              -50.178515208792,
              -28.451909795784196
            ],
            [
              -50.17629589754605,
              -28.45399029050417
            ],
            [
              -50.172612785265535,
              -28.45860520606484
            ],
            [
              -50.16921298931429,
              -28.463484911862597
            ],
            [
              -50.16841025971469,
              -28.465300616345484
            ],
            [
              -50.16510490253987,
              -28.47089903850105
            ],
            [
              -50.163499443340676,
              -28.475097855117724
            ],
            [
              -50.162177300470745,
              -28.479296671734396
            ],
            [
              -50.1619884229179,
              -28.4814149936311
            ],
            [
              -50.162413397411804,
              -28.485802946131404
            ],
            [
              -50.16189398414148,
              -28.490985269342975
            ],
            [
              -50.16208286169432,
              -28.49340620865349
            ],
            [
              -50.16260227496465,
              -28.495297567489832
            ],
            [
              -50.158919162684136,
              -28.49741588938653
            ],
            [
              -50.156322096332495,
              -28.49790764268398
            ],
            [
              -50.15438610141582,
              -28.497718506800346
            ],
            [
              -50.148578116665774,
              -28.496016283847638
            ],
            [
              -50.14640602480804,
              -28.495486703373466
            ],
            [
              -50.141400769657594,
              -28.49590280231746
            ],
            [
              -50.139700871681974,
              -28.49541104902001
            ],
            [
              -50.1394175553527,
              -28.49329272712331
            ],
            [
              -50.141495208434016,
              -28.490682651929163
            ],
            [
              -50.14291179008037,
              -28.487505169084113
            ],
            [
              -50.14281735130395,
              -28.485008575420142
            ],
            [
              -50.14390339723281,
              -28.4809988946871
            ],
            [
              -50.146217147255186,
              -28.476497460656613
            ],
            [
              -50.14838923911293,
              -28.47441696593664
            ],
            [
              -50.15339449426337,
              -28.470218149319965
            ],
            [
              -50.15740814226136,
              -28.465981505526564
            ],
            [
              -50.15920247901341,
              -28.464695381517853
            ],
            [
              -50.16061906065976,
              -28.46189617044007
            ],
            [
              -50.160477402495125,
              -28.459513058306282
            ],
            [
              -50.159485795342675,
              -28.45860520606484
            ],
            [
              -50.15707760654388,
              -28.45799997123721
            ],
            [
              -50.15348893303979,
              -28.45849172453466
            ],
            [
              -50.15122240240563,
              -28.459096959362288
            ],
            [
              -50.148578116665774,
              -28.461215281258987
            ],
            [
              -50.147208754407636,
              -28.459513058306282
            ],
            [
              -50.14659490236088,
              -28.45720560052595
            ],
            [
              -50.14730319318406,
              -28.449488856473682
            ],
            [
              -50.146311586031615,
              -28.448013596581337
            ],
            [
              -50.14158964721044,
              -28.444609150675927
            ],
            [
              -50.13918145841164,
              -28.443209545137034
            ],
            [
              -50.135309468578285,
              -28.441885593951596
            ],
            [
              -50.13238186650916,
              -28.441318186300695
            ],
            [
              -50.12940704505182,
              -28.44101556888688
            ],
            [
              -50.126904417476595,
              -28.439691617701442
            ],
            [
              -50.12629056542985,
              -28.43810287627892
            ],
            [
              -50.12662110114733,
              -28.43689240662366
            ],
            [
              -50.1293126062754,
              -28.43348796071825
            ],
            [
              -50.13020977465142,
              -28.43171008341209
            ],
            [
              -50.13020977465142,
              -28.430196996343017
            ],
            [
              -50.12832099912295,
              -28.428910872334306
            ],
            [
              -50.12591281032415,
              -28.429213489748122
            ],
            [
              -50.121285310279404,
              -28.432807071537166
            ],
            [
              -50.11911321842167,
              -28.434811911903687
            ],
            [
              -50.11580786124685,
              -28.437081542507293
            ],
            [
              -50.11231362651918,
              -28.44101556888688
            ],
            [
              -50.11151089691958,
              -28.442982582076674
            ],
            [
              -50.11141645814316,
              -28.44540352138719
            ],
            [
              -50.112408065295604,
              -28.44941320212023
            ],
            [
              -50.113494111224476,
              -28.45179631425402
            ],
            [
              -50.116893907175715,
              -28.455881649340512
            ],
            [
              -50.120718677620864,
              -28.459513058306282
            ],
            [
              -50.12331574397251,
              -28.461404417142624
            ],
            [
              -50.126007249100574,
              -28.46238792373752
            ],
            [
              -50.12680997870017,
              -28.46340925750914
            ],
            [
              -50.12709329502945,
              -28.465489752229118
            ],
            [
              -50.12638500420627,
              -28.46851592636726
            ],
            [
              -50.12671553992375,
              -28.471882545095944
            ],
            [
              -50.12638500420627,
              -28.474000866992647
            ],
            [
              -50.12459066745423,
              -28.476005707359164
            ],
            [
              -50.122182478655425,
              -28.47630832477298
            ],
            [
              -50.118688243927764,
              -28.474984373587542
            ],
            [
              -50.11670502962287,
              -28.474606101820275
            ],
            [
              -50.11368298877732,
              -28.47358476804865
            ],
            [
              -50.11051928976713,
              -28.47290387886757
            ],
            [
              -50.106883396874835,
              -28.473395632165015
            ],
            [
              -50.10480574379352,
              -28.475703089945352
            ],
            [
              -50.10348360092359,
              -28.48031800550602
            ],
            [
              -50.10268087132399,
              -28.4841007231787
            ],
            [
              -50.10168926417155,
              -28.485992082015038
            ],
            [
              -50.10041434068983,
              -28.486294699428854
            ],
            [
              -50.097203422291436,
              -28.484403340592515
            ],
            [
              -50.09309533551701,
              -28.479107535850762
            ],
            [
              -50.090923243659276,
              -28.47558960841517
            ],
            [
              -50.08908168751902,
              -28.474000866992647
            ],
            [
              -50.08629574361453,
              -28.472714742983936
            ],
            [
              -50.084879161968175,
              -28.472601261453754
            ],
            [
              -50.08199877928726,
              -28.473395632165015
            ],
            [
              -50.07571860065511,
              -28.477783584665325
            ],
            [
              -50.07387704451485,
              -28.480091042445657
            ],
            [
              -50.07279099858598,
              -28.480809758803467
            ],
            [
              -50.07061890672824,
              -28.480582795743107
            ],
            [
              -50.068682911811564,
              -28.479183190204218
            ],
            [
              -50.0656136515778,
              -28.476913559600607
            ],
            [
              -50.06041951887451,
              -28.475892225828986
            ],
            [
              -50.0555087025005,
              -28.47581657147553
            ],
            [
              -50.051400615726074,
              -28.47608136171262
            ],
            [
              -50.04852023304516,
              -28.476913559600607
            ],
            [
              -50.04460102382359,
              -28.478994054320584
            ],
            [
              -50.041390105425194,
              -28.480091042445657
            ],
            [
              -50.03950132989672,
              -28.480015388092205
            ],
            [
              -50.036195972721906,
              -28.478502301023134
            ],
            [
              -50.03359890637026,
              -28.476497460656613
            ],
            [
              -50.02717706957347,
              -28.47430348440646
            ],
            [
              -50.02538273282142,
              -28.472298644039938
            ],
            [
              -50.02439112566898,
              -28.46851592636726
            ],
            [
              -50.02439112566898,
              -28.46238792373752
            ],
            [
              -50.02391893178686,
              -28.459399576776104
            ],
            [
              -50.02151074298806,
              -28.454406389448167
            ],
            [
              -50.019716406236014,
              -28.451909795784196
            ],
            [
              -50.01811094703682,
              -28.450888462012575
            ],
            [
              -50.0164110490612,
              -28.450510190245307
            ],
            [
              -50.01390842148598,
              -28.45081280765912
            ],
            [
              -50.00819487551236,
              -28.453801154620535
            ],
            [
              -50.00522005405502,
              -28.45648688416814
            ],
            [
              -50.002481329538746,
              -28.45799997123721
            ],
            [
              -49.998703778481804,
              -28.457583872293217
            ],
            [
              -49.99487900803666,
              -28.45660036569832
            ],
            [
              -49.992612477402496,
              -28.45720560052595
            ],
            [
              -49.9894015590041,
              -28.45720560052595
            ],
            [
              -49.98770166102848,
              -28.45660036569832
            ],
            [
              -49.98637951815855,
              -28.454784661215434
            ],
            [
              -49.986993370205305,
              -28.451909795784196
            ],
            [
              -49.98888214573377,
              -28.449715819534042
            ],
            [
              -49.98949599778052,
              -28.44820273246497
            ],
            [
              -49.98921268145126,
              -28.446008756214816
            ],
            [
              -49.987890538581325,
              -28.444609150675927
            ],
            [
              -49.98099650790242,
              -28.440599469942885
            ],
            [
              -49.97641622724588,
              -28.439199864403996
            ],
            [
              -49.97268589557716,
              -28.43901072852036
            ],
            [
              -49.97079712004869,
              -28.44018337099889
            ],
            [
              -49.96999439044909,
              -28.443398681020668
            ],
            [
              -49.96999439044909,
              -28.446387027982084
            ],
            [
              -49.96938053840233,
              -28.452515030611828
            ],
            [
              -49.968908344520216,
              -28.454217253564533
            ],
            [
              -49.967208446544596,
              -28.455881649340512
            ],
            [
              -49.965980742451094,
              -28.455881649340512
            ],
            [
              -49.964091966922624,
              -28.454406389448167
            ],
            [
              -49.96281704344091,
              -28.452212413198012
            ],
            [
              -49.96088104852423,
              -28.45081280765912
            ],
            [
              -49.95729237502014,
              -28.449299720590048
            ],
            [
              -49.95568691582094,
              -28.449110584706414
            ],
            [
              -49.95290097191645,
              -28.449791473887498
            ],
            [
              -49.95219268109327,
              -28.45081280765912
            ],
            [
              -49.95219268109327,
              -28.455692513456878
            ],
            [
              -49.95181492598758,
              -28.460912663845175
            ],
            [
              -49.95129551271725,
              -28.464203628220407
            ],
            [
              -49.951389951493674,
              -28.466889357768007
            ],
            [
              -49.95020946678838,
              -28.46980205037597
            ],
            [
              -49.94799015554243,
              -28.47290387886757
            ],
            [
              -49.94662079328429,
              -28.476989213954063
            ],
            [
              -49.94662079328429,
              -28.480015388092205
            ],
            [
              -49.94600694123754,
              -28.48171761104491
            ],
            [
              -49.944401482038344,
              -28.48270111763981
            ],
            [
              -49.942276609568815,
              -28.482398500225994
            ],
            [
              -49.939915640158226,
              -28.48031800550602
            ],
            [
              -49.936421405430565,
              -28.476686596540247
            ],
            [
              -49.930377323739464,
              -28.47369824957883
            ],
            [
              -49.928819083928474,
              -28.472109508156304
            ],
            [
              -49.928205231881726,
              -28.468818543781076
            ],
            [
              -49.9289135227049,
              -28.466813703414555
            ],
            [
              -49.93179390538582,
              -28.463295775978963
            ],
            [
              -49.93410765540819,
              -28.46110179972881
            ],
            [
              -49.935618675830966,
              -28.460383083371
            ],
            [
              -49.938121303406184,
              -28.45989133007355
            ],
            [
              -49.93849905851188,
              -28.45860520606484
            ],
            [
              -49.93741301258301,
              -28.456902983112133
            ],
            [
              -49.935288140113485,
              -28.455616859103422
            ],
            [
              -49.93207722171508,
              -28.454406389448167
            ],
            [
              -49.9305189819041,
              -28.45338505567654
            ],
            [
              -49.929810691080924,
              -28.45209893166783
            ],
            [
              -49.92848854821099,
              -28.451191079426387
            ],
            [
              -49.92678865023537,
              -28.451001943542753
            ],
            [
              -49.92499431348333,
              -28.451682832723836
            ],
            [
              -49.92319997673128,
              -28.453006783909274
            ],
            [
              -49.91861969607475,
              -28.458302588651026
            ],
            [
              -49.91691979809913,
              -28.45921044089247
            ],
            [
              -49.913614440924306,
              -28.460383083371
            ],
            [
              -49.90842030822102,
              -28.461782688909892
            ],
            [
              -49.907098165351094,
              -28.462501405267698
            ],
            [
              -49.906200996975066,
              -28.46390101080659
            ],
            [
              -49.90280120102383,
              -28.464884517401487
            ],
            [
              -49.90039301222503,
              -28.464695381517853
            ],
            [
              -49.89581273156849,
              -28.46378752927641
            ],
            [
              -49.89288512949937,
              -28.462993158565148
            ],
            [
              -49.8901936243713,
              -28.46159355302626
            ],
            [
              -49.888777042724946,
              -28.459399576776104
            ],
            [
              -49.88920201721885,
              -28.45660036569832
            ],
            [
              -49.893404542769694,
              -28.45020757283149
            ],
            [
              -49.89798482342623,
              -28.445592657270822
            ],
            [
              -49.89840979792014,
              -28.444382187615567
            ],
            [
              -49.89760706832054,
              -28.443096063606855
            ],
            [
              -49.89288512949937,
              -28.44029685252907
            ],
            [
              -49.890476940700566,
              -28.44041033405925
            ],
            [
              -49.88769099679608,
              -28.442112557011956
            ],
            [
              -49.88580222126761,
              -28.446387027982084
            ],
            [
              -49.88358291002166,
              -28.447597497637343
            ],
            [
              -49.88178857326962,
              -28.447597497637343
            ],
            [
              -49.88018311407042,
              -28.44691660845626
            ],
            [
              -49.877113853836654,
              -28.44381477996466
            ],
            [
              -49.87319464461508,
              -28.441999075481778
            ],
            [
              -49.87021982315775,
              -28.44158297653778
            ],
            [
              -49.86450627718413,
              -28.44230169289559
            ],
            [
              -49.85978433836296,
              -28.44230169289559
            ],
            [
              -49.85850941488124,
              -28.442490828779224
            ],
            [
              -49.85709283323489,
              -28.4435878169043
            ],
            [
              -49.85501518015357,
              -28.4440039158483
            ],
            [
              -49.85421245055397,
              -28.44468480502938
            ],
            [
              -49.85459020565967,
              -28.44608441056827
            ],
            [
              -49.85647898118814,
              -28.44820273246497
            ],
            [
              -49.85817887916376,
              -28.449299720590048
            ],
            [
              -49.86049262918613,
              -28.45020757283149
            ],
            [
              -49.866111736383324,
              -28.451115425072935
            ],
            [
              -49.871022552757346,
              -28.45058584459876
            ],
            [
              -49.872722450732965,
              -28.451115425072935
            ],
            [
              -49.8765000017899,
              -28.453006783909274
            ],
            [
              -49.87782214465983,
              -28.45448204380162
            ],
            [
              -49.87749160894235,
              -28.455805994987056
            ],
            [
              -49.8756972721903,
              -28.45788648970703
            ],
            [
              -49.87338352216793,
              -28.459286095245922
            ],
            [
              -49.867197782312196,
              -28.461290935612443
            ],
            [
              -49.864978471066244,
              -28.461707034556436
            ],
            [
              -49.863609108808106,
              -28.462804022681514
            ],
            [
              -49.863278573090625,
              -28.464014492336773
            ],
            [
              -49.863278573090625,
              -28.467986345893085
            ],
            [
              -49.86290081798493,
              -28.471996026626126
            ],
            [
              -49.86512012923088,
              -28.47608136171262
            ],
            [
              -49.86899211906424,
              -28.480582795743107
            ],
            [
              -49.86941709355815,
              -28.481793265398366
            ],
            [
              -49.86899211906424,
              -28.48349548835107
            ],
            [
              -49.86748109864147,
              -28.486294699428854
            ],
            [
              -49.86658393026544,
              -28.488602157209186
            ],
            [
              -49.86389242513738,
              -28.48939652792045
            ],
            [
              -49.85761224650522,
              -28.488413021325552
            ],
            [
              -49.85208757808445,
              -28.48811040391174
            ],
            [
              -49.84391862392383,
              -28.485197711303776
            ],
            [
              -49.84051882797258,
              -28.485802946131404
            ],
            [
              -49.839904975925826,
              -28.48731603320048
            ],
            [
              -49.840896583078276,
              -28.488413021325552
            ],
            [
              -49.843399210653494,
              -28.489812626864445
            ],
            [
              -49.84491023107627,
              -28.49121223240334
            ],
            [
              -49.84538242495839,
              -28.493103591239677
            ],
            [
              -49.84481579229985,
              -28.4946923326622
            ],
            [
              -49.842596481053896,
              -28.496205419731275
            ],
            [
              -49.83929112387908,
              -28.496508037145087
            ],
            [
              -49.836221863645314,
              -28.494314060894933
            ],
            [
              -49.835088598328234,
              -28.492687492295683
            ],
            [
              -49.832491531976586,
              -28.48731603320048
            ],
            [
              -49.82871398091965,
              -28.485311192833958
            ],
            [
              -49.82758071560257,
              -28.48300373505362
            ],
            [
              -49.8272973992733,
              -28.479788425031845
            ],
            [
              -49.82602247579159,
              -28.478388819492952
            ],
            [
              -49.824180919651326,
              -28.47880491843695
            ],
            [
              -49.82040336859439,
              -28.482285018695812
            ],
            [
              -49.81827849612486,
              -28.483684624234705
            ],
            [
              -49.8147842613972,
              -28.4841007231787
            ],
            [
              -49.81242329198661,
              -28.48489509388996
            ],
            [
              -49.811006710340266,
              -28.484289859062333
            ],
            [
              -49.81110114911669,
              -28.483117216583803
            ],
            [
              -49.81582308793786,
              -28.479901906562024
            ],
            [
              -49.81648415937282,
              -28.478615782553312
            ],
            [
              -49.8163897205964,
              -28.476194843242798
            ],
            [
              -49.81672025631388,
              -28.472298644039938
            ],
            [
              -49.81728688897242,
              -28.469915531906153
            ],
            [
              -49.816295281819976,
              -28.46900767966471
            ],
            [
              -49.81261216953946,
              -28.467910691539632
            ],
            [
              -49.811006710340266,
              -28.468099827423266
            ],
            [
              -49.808787399094314,
              -28.469196815548344
            ],
            [
              -49.80581257763697,
              -28.477405312898057
            ],
            [
              -49.80387658272029,
              -28.480507141389655
            ],
            [
              -49.80378214394387,
              -28.48398724164852
            ],
            [
              -49.80198780719183,
              -28.48610556354522
            ],
            [
              -49.79910742451091,
              -28.486408180959035
            ],
            [
              -49.795188215289336,
              -28.488904774623002
            ],
            [
              -49.79410216936047,
              -28.492687492295683
            ],
            [
              -49.79311056220802,
              -28.49438971524839
            ],
            [
              -49.790891250962076,
              -28.49639455561491
            ],
            [
              -49.787113699905134,
              -28.496999790442537
            ],
            [
              -49.78229732230754,
              -28.49669717302872
            ],
            [
              -49.78059742433192,
              -28.495108431606198
            ],
            [
              -49.78177790903722,
              -28.49389796195094
            ],
            [
              -49.78380834273032,
              -28.493595344537123
            ],
            [
              -49.78531936315309,
              -28.492309220528412
            ],
            [
              -49.785980434588055,
              -28.487694304967746
            ],
            [
              -49.78498882743561,
              -28.485802946131404
            ],
            [
              -49.783383368236414,
              -28.48421420470888
            ],
            [
              -49.78111683760225,
              -28.480885413156923
            ],
            [
              -49.77918084268557,
              -28.479107535850762
            ],
            [
              -49.778000357980275,
              -28.477291831367875
            ],
            [
              -49.778991965132725,
              -28.475286991001354
            ],
            [
              -49.78149459270794,
              -28.47419000287628
            ],
            [
              -49.781022398825826,
              -28.471806890742492
            ],
            [
              -49.77908640390915,
              -28.470596421087233
            ],
            [
              -49.774411684476185,
              -28.468894198134528
            ],
            [
              -49.77318398038268,
              -28.468213308953445
            ],
            [
              -49.77228681200666,
              -28.46651108600074
            ],
            [
              -49.77228681200666,
              -28.464014492336773
            ],
            [
              -49.770586914031036,
              -28.461707034556436
            ],
            [
              -49.767423215020855,
              -28.459588712659738
            ],
            [
              -49.765298342551326,
              -28.459513058306282
            ],
            [
              -49.764401174175305,
              -28.460988318198627
            ],
            [
              -49.76430673539888,
              -28.462690541151332
            ],
            [
              -49.76581775582166,
              -28.46579236964293
            ],
            [
              -49.76581775582166,
              -28.468894198134528
            ],
            [
              -49.766998240526945,
              -28.472109508156304
            ],
            [
              -49.766289949703776,
              -28.47441696593664
            ],
            [
              -49.7676120925737,
              -28.476610942186795
            ],
            [
              -49.766998240526945,
              -28.48031800550602
            ],
            [
              -49.76501502622206,
              -28.482890253523443
            ],
            [
              -49.7652039037749,
              -28.484289859062333
            ],
            [
              -49.769689745655015,
              -28.48761865061429
            ],
            [
              -49.771011888524946,
              -28.492309220528412
            ],
            [
              -49.770823010972094,
              -28.494314060894933
            ],
            [
              -49.769123112996475,
              -28.496016283847638
            ],
            [
              -49.7671871180798,
              -28.49930724822287
            ],
            [
              -49.76548722010418,
              -28.50119860705921
            ],
            [
              -49.762701276199685,
              -28.50108512552903
            ],
            [
              -49.758876505754536,
              -28.49919376669269
            ],
            [
              -49.754390663874425,
              -28.498285914451248
            ],
            [
              -49.75221857201668,
              -28.497113271972715
            ],
            [
              -49.74829936279511,
              -28.49401144348112
            ],
            [
              -49.74570229644347,
              -28.494200579364755
            ],
            [
              -49.7430107913154,
              -28.49518408595965
            ],
            [
              -49.739799872917004,
              -28.498399395981426
            ],
            [
              -49.73928045964667,
              -28.50029075481777
            ],
            [
              -49.74008318924628,
              -28.50131208858939
            ],
            [
              -49.742491378045074,
              -28.50248473106792
            ],
            [
              -49.744521811738174,
              -28.502900830011917
            ],
            [
              -49.74579673521989,
              -28.504111299667173
            ],
            [
              -49.74669390359591,
              -28.505889176973334
            ],
            [
              -49.74589117399631,
              -28.507402264042405
            ],
            [
              -49.74438015357354,
              -28.50770488145622
            ],
            [
              -49.7409803576223,
              -28.50759139992604
            ],
            [
              -49.73880826576456,
              -28.508499252167482
            ],
            [
              -49.73739168411821,
              -28.51031495665037
            ],
            [
              -49.737297245341786,
              -28.51171456218926
            ],
            [
              -49.736211199412914,
              -28.513303303611785
            ],
            [
              -49.73470017899014,
              -28.51451377326704
            ],
            [
              -49.7329058422381,
              -28.51500552656449
            ],
            [
              -49.730119898333605,
              -28.51500552656449
            ],
            [
              -49.72761727075838,
              -28.5162916505732
            ],
            [
              -49.72681454115878,
              -28.517312984344827
            ],
            [
              -49.72690897993521,
              -28.51890172576735
            ],
            [
              -49.72950604628685,
              -28.520717430250237
            ],
            [
              -49.73219755141492,
              -28.5215118009615
            ],
            [
              -49.73550290858974,
              -28.523592295681475
            ],
            [
              -49.73758056167105,
              -28.526504988289435
            ],
            [
              -49.73951655658773,
              -28.527601976414513
            ],
            [
              -49.74121645456336,
              -28.530098570078483
            ],
            [
              -49.743813520915,
              -28.532292546328634
            ],
            [
              -49.74669390359591,
              -28.535394374820232
            ],
            [
              -49.747779949524784,
              -28.53898795660928
            ],
            [
              -49.74929096994756,
              -28.542316748161237
            ],
            [
              -49.74938540872398,
              -28.54568336688992
            ],
            [
              -49.74820492401869,
              -28.54840692361425
            ],
            [
              -49.746080051549164,
              -28.54980652915314
            ],
            [
              -49.741688648445475,
              -28.54950391173933
            ],
            [
              -49.739894311693426,
              -28.54749907137281
            ],
            [
              -49.73880826576456,
              -28.547612552902986
            ],
            [
              -49.73828885249423,
              -28.549693047622963
            ],
            [
              -49.73677783207145,
              -28.5510169988084
            ],
            [
              -49.733283597343785,
              -28.550714381394585
            ],
            [
              -49.73111150548605,
              -28.5510169988084
            ],
            [
              -49.73030877588645,
              -28.55218964128693
            ],
            [
              -49.72827834219335,
              -28.559187668981387
            ],
            [
              -49.7280894646405,
              -28.561381645231542
            ],
            [
              -49.72700341871163,
              -28.563310831244607
            ],
            [
              -49.726106250335604,
              -28.566790931503473
            ],
            [
              -49.72601181155918,
              -28.569514488227803
            ],
            [
              -49.72502020440674,
              -28.570914093766692
            ],
            [
              -49.720581581914836,
              -28.574810292969552
            ],
            [
              -49.72119543396159,
              -28.575982935448085
            ],
            [
              -49.71958997476239,
              -28.577306886633522
            ],
            [
              -49.71770119923392,
              -28.57719340510334
            ],
            [
              -49.7151985716587,
              -28.574999428853186
            ],
            [
              -49.71378199001235,
              -28.57450767555574
            ],
            [
              -49.71368755123593,
              -28.572389353659037
            ],
            [
              -49.71231818897779,
              -28.572313699305585
            ],
            [
              -49.71160989815461,
              -28.57518856473682
            ],
            [
              -49.712507066530634,
              -28.576815133336073
            ],
            [
              -49.709107270579395,
              -28.578517356288778
            ],
            [
              -49.709012831802966,
              -28.58029523359494
            ],
            [
              -49.70802122465052,
              -28.582186592431277
            ],
            [
              -49.710004438955416,
              -28.58619627316432
            ],
            [
              -49.71109048488428,
              -28.58721760693594
            ],
            [
              -49.71019331650826,
              -28.58948723753955
            ],
            [
              -49.71208209203673,
              -28.59088684307844
            ],
            [
              -49.712601505307056,
              -28.591794695319884
            ],
            [
              -49.71179877570746,
              -28.59311864650532
            ],
            [
              -49.711704336931035,
              -28.595312622755475
            ],
            [
              -49.70948502568508,
              -28.597809216419442
            ],
            [
              -49.71061829100217,
              -28.60280240374738
            ],
            [
              -49.71019331650826,
              -28.604315490816454
            ],
            [
              -49.70651020422775,
              -28.605601614825165
            ],
            [
              -49.704290892981795,
              -28.605715096355343
            ],
            [
              -49.70221323990048,
              -28.60469376258372
            ],
            [
              -49.70131607152446,
              -28.605715096355343
            ],
            [
              -49.69919119905494,
              -28.60601771376916
            ],
            [
              -49.69768017863216,
              -28.60809820848913
            ],
            [
              -49.69711354597362,
              -28.610783938036736
            ],
            [
              -49.69758573985573,
              -28.61199440769199
            ],
            [
              -49.69659413270329,
              -28.61471796441632
            ],
            [
              -49.69309989797562,
              -28.616684977606113
            ],
            [
              -49.693713750022376,
              -28.617403693963922
            ],
            [
              -49.6922027295996,
              -28.61861416361918
            ],
            [
              -49.6914,
              -28.621413374696964
            ],
            [
              -49.69210829082318,
              -28.623191252003124
            ],
            [
              -49.69361931124595,
              -28.624590857542014
            ],
            [
              -49.693713750022376,
              -28.62561219131364
            ],
            [
              -49.695980280656535,
              -28.62678483379217
            ],
            [
              -49.69961617354884,
              -28.627314414266344
            ],
            [
              -49.70098553580698,
              -28.62829792086124
            ],
            [
              -49.70311040827651,
              -28.628903155688867
            ],
            [
              -49.70410201542895,
              -28.630000143813945
            ],
            [
              -49.707879566485886,
              -28.63018927969758
            ],
            [
              -49.70580191340457,
              -28.628108784977606
            ],
            [
              -49.70769068893304,
              -28.627806167563794
            ],
            [
              -49.70821010220337,
              -28.626482216378353
            ],
            [
              -49.70972112262614,
              -28.625801327197273
            ],
            [
              -49.71109048488428,
              -28.62629308049472
            ],
            [
              -49.71458471961195,
              -28.62538522825328
            ],
            [
              -49.71590686248188,
              -28.623796486830752
            ],
            [
              -49.71940109720955,
              -28.624590857542014
            ],
            [
              -49.72341474520754,
              -28.626217426141267
            ],
            [
              -49.72752283198196,
              -28.624212585774746
            ],
            [
              -49.73219755141492,
              -28.624099104244568
            ],
            [
              -49.73677783207145,
              -28.62360735094712
            ],
            [
              -49.740697041293025,
              -28.624590857542014
            ],
            [
              -49.744285714797115,
              -28.6242882401282
            ],
            [
              -49.746080051549164,
              -28.62561219131364
            ],
            [
              -49.74740219441909,
              -28.62561219131364
            ],
            [
              -49.749904821994306,
              -28.627881821917246
            ],
            [
              -49.75141584241708,
              -28.627314414266344
            ],
            [
              -49.75391846999231,
              -28.627390068619796
            ],
            [
              -49.75481563836833,
              -28.628108784977606
            ],
            [
              -49.756987730226065,
              -28.627314414266344
            ],
            [
              -49.7550989546976,
              -28.623909968360934
            ],
            [
              -49.75519339347402,
              -28.62311559764967
            ],
            [
              -49.756987730226065,
              -28.62179164646423
            ],
            [
              -49.756421097567525,
              -28.618916781032997
            ],
            [
              -49.75660997512037,
              -28.616004088425033
            ],
            [
              -49.75821543431957,
              -28.6158149525414
            ],
            [
              -49.75930148024844,
              -28.61721455808029
            ],
            [
              -49.76199298537651,
              -28.619181571270083
            ],
            [
              -49.76331512824643,
              -28.618008928791554
            ],
            [
              -49.76539278132775,
              -28.619295052800265
            ],
            [
              -49.7655816588806,
              -28.621413374696964
            ],
            [
              -49.7676120925737,
              -28.62300211611949
            ],
            [
              -49.769689745655015,
              -28.623985622714386
            ],
            [
              -49.771578521183486,
              -28.627200932736162
            ],
            [
              -49.773608954876586,
              -28.627692686033612
            ],
            [
              -49.77469500080546,
              -28.62878967415869
            ],
            [
              -49.7788975263563,
              -28.6295083905165
            ],
            [
              -49.779794694732324,
              -28.628487056744873
            ],
            [
              -49.77941693962663,
              -28.627200932736162
            ],
            [
              -49.78111683760225,
              -28.62561219131364
            ],
            [
              -49.784280536612435,
              -28.62440172165838
            ],
            [
              -49.78442219477707,
              -28.622094263878047
            ],
            [
              -49.78489438865919,
              -28.62050552245552
            ],
            [
              -49.78442219477707,
              -28.617706311377738
            ],
            [
              -49.78347780701284,
              -28.614982754653408
            ],
            [
              -49.7813057151551,
              -28.612107889222173
            ],
            [
              -49.782580638636816,
              -28.609800431441837
            ],
            [
              -49.78380834273032,
              -28.60991391297202
            ],
            [
              -49.785980434588055,
              -28.611805271808358
            ],
            [
              -49.787113699905134,
              -28.61169179027818
            ],
            [
              -49.78971076625678,
              -28.61388576652833
            ],
            [
              -49.795093776512914,
              -28.614982754653408
            ],
            [
              -49.795518751006824,
              -28.617290212433744
            ],
            [
              -49.798115817358465,
              -28.617706311377738
            ],
            [
              -49.79769084286456,
              -28.62179164646423
            ],
            [
              -49.79821025613489,
              -28.623985622714386
            ],
            [
              -49.80071288371011,
              -28.62519609236964
            ],
            [
              -49.802601659238576,
              -28.627390068619796
            ],
            [
              -49.80401824088493,
              -28.62841140239142
            ],
            [
              -49.80557648069592,
              -28.628714019805237
            ],
            [
              -49.8075124756126,
              -28.62841140239142
            ],
            [
              -49.807890230718286,
              -28.630416242757942
            ],
            [
              -49.80902349603537,
              -28.631702366766653
            ],
            [
              -49.807890230718286,
              -28.633782861486626
            ],
            [
              -49.808787399094314,
              -28.635295948555697
            ],
            [
              -49.813178802198,
              -28.635901183383325
            ],
            [
              -49.81657859814924,
              -28.63809515963348
            ],
            [
              -49.81898678694804,
              -28.642899211077783
            ],
            [
              -49.81738132774884,
              -28.643617927435592
            ],
            [
              -49.8155869909968,
              -28.643617927435592
            ],
            [
              -49.81672025631388,
              -28.646303656983196
            ],
            [
              -49.815303674667526,
              -28.648497633233347
            ],
            [
              -49.81790074101917,
              -28.650994226897318
            ],
            [
              -49.81908122572447,
              -28.65118336278095
            ],
            [
              -49.822481021675706,
              -28.653604302091466
            ],
            [
              -49.82200882779359,
              -28.65451215433291
            ],
            [
              -49.81690913386672,
              -28.653604302091466
            ],
            [
              -49.810817832787414,
              -28.65190207913876
            ],
            [
              -49.81289548586873,
              -28.6537934379751
            ],
            [
              -49.81468982262078,
              -28.655987414225255
            ],
            [
              -49.81549255222038,
              -28.657992254591775
            ],
            [
              -49.817098011419574,
              -28.65890010683322
            ],
            [
              -49.82290599616961,
              -28.65890010683322
            ],
            [
              -49.824086480874904,
              -28.66041319390229
            ],
            [
              -49.82309487372246,
              -28.66120756461355
            ],
            [
              -49.823614286992786,
              -28.66359067674734
            ],
            [
              -49.824605894145236,
              -28.66570899864404
            ],
            [
              -49.82611691456801,
              -28.66620075194149
            ],
            [
              -49.82828900642575,
              -28.665898134527673
            ],
            [
              -49.82871398091965,
              -28.668092110777827
            ],
            [
              -49.83079163400097,
              -28.66820559230801
            ],
            [
              -49.83400255239936,
              -28.665784652997495
            ],
            [
              -49.83801620039736,
              -28.66548203558368
            ],
            [
              -49.83919668510265,
              -28.666503369355304
            ],
            [
              -49.83848839427948,
              -28.66828124666146
            ],
            [
              -49.83820507795021,
              -28.671685692566875
            ],
            [
              -49.83910224632623,
              -28.672707026338497
            ],
            [
              -49.83929112387908,
              -28.674295767761024
            ],
            [
              -49.840377169807944,
              -28.67611147224391
            ],
            [
              -49.84009385347868,
              -28.67800283108025
            ],
            [
              -49.836977373856705,
              -28.677813695196615
            ],
            [
              -49.836410741198165,
              -28.678910683321693
            ],
            [
              -49.836882935080276,
              -28.680915523688213
            ],
            [
              -49.83929112387908,
              -28.684093006533264
            ],
            [
              -49.84028273103152,
              -28.685908711016147
            ],
            [
              -49.839904975925826,
              -28.686703081727412
            ],
            [
              -49.83749678712703,
              -28.68681656325759
            ],
            [
              -49.83801620039736,
              -28.689994046102644
            ],
            [
              -49.83678849630385,
              -28.690183181986278
            ],
            [
              -49.83357757790546,
              -28.689010539507745
            ],
            [
              -49.830697195224545,
              -28.68919967539138
            ],
            [
              -49.82739183804973,
              -28.687686588322308
            ],
            [
              -49.824511455368814,
              -28.686892217611046
            ],
            [
              -49.82262267984034,
              -28.688216168796483
            ],
            [
              -49.81700357264315,
              -28.687383970908492
            ],
            [
              -49.81421762873866,
              -28.686400464313596
            ],
            [
              -49.813509337915484,
              -28.687005699141224
            ],
            [
              -49.81487870017362,
              -28.688405304680117
            ],
            [
              -49.818797909395194,
              -28.690788416813906
            ],
            [
              -49.820922781864724,
              -28.692793257180426
            ],
            [
              -49.823283751275305,
              -28.693511973538236
            ],
            [
              -49.826305792120856,
              -28.692793257180426
            ],
            [
              -49.8272973992733,
              -28.692188022352795
            ],
            [
              -49.83041387889527,
              -28.69241498541316
            ],
            [
              -49.83409699117579,
              -28.693285010477872
            ],
            [
              -49.83551357282214,
              -28.69498723343058
            ],
            [
              -49.835985766704255,
              -28.697294691210914
            ],
            [
              -49.835419134045715,
              -28.697786444508363
            ],
            [
              -49.8377801034563,
              -28.700699137116324
            ],
            [
              -49.83948000143192,
              -28.700585655586146
            ],
            [
              -49.84009385347868,
              -28.702817459013026
            ],
            [
              -49.842502042277474,
              -28.706297559271892
            ],
            [
              -49.84188819023072,
              -28.707999782224597
            ],
            [
              -49.836882935080276,
              -28.708113263754775
            ],
            [
              -49.837119032021334,
              -28.70958852364712
            ],
            [
              -49.8401882922551,
              -28.713106451082712
            ],
            [
              -49.84198262900714,
              -28.71420343920779
            ],
            [
              -49.844721353523425,
              -28.714014303324156
            ],
            [
              -49.844296379029515,
              -28.712198598841272
            ],
            [
              -49.84269091983032,
              -28.709891141060936
            ],
            [
              -49.84420194025309,
              -28.708302399638413
            ],
            [
              -49.84708232293401,
              -28.70951286929367
            ],
            [
              -49.846987884157585,
              -28.707583683280603
            ],
            [
              -49.84627959333441,
              -28.704481854789005
            ],
            [
              -49.847885052533606,
              -28.703914447138104
            ],
            [
              -49.84991548622671,
              -28.70561667009081
            ],
            [
              -49.852276455637295,
              -28.704897953733
            ],
            [
              -49.85421245055397,
              -28.704708817849365
            ],
            [
              -49.85501518015357,
              -28.703384866663928
            ],
            [
              -49.856620639352776,
              -28.703800965607922
            ],
            [
              -49.86370354758453,
              -28.70289311336648
            ],
            [
              -49.86308969553778,
              -28.7017961252414
            ],
            [
              -49.8631841343142,
              -28.70028303817233
            ],
            [
              -49.86941709355815,
              -28.70100175453014
            ],
            [
              -49.87177806296873,
              -28.70300659489666
            ],
            [
              -49.87121143031019,
              -28.705994941858076
            ],
            [
              -49.869794848663844,
              -28.706486695155526
            ],
            [
              -49.87021982315775,
              -28.708718498582407
            ],
            [
              -49.86870880273497,
              -28.709399387763487
            ],
            [
              -49.871589185415885,
              -28.712501216255085
            ],
            [
              -49.87140030786304,
              -28.713295586966346
            ],
            [
              -49.872722450732965,
              -28.71541390886305
            ],
            [
              -49.87229747623906,
              -28.717002650285572
            ],
            [
              -49.86899211906424,
              -28.71598131651395
            ],
            [
              -49.87031426193417,
              -28.718288774294283
            ],
            [
              -49.8748945425907,
              -28.721693220199697
            ],
            [
              -49.87338352216793,
              -28.72248759091096
            ],
            [
              -49.87121143031019,
              -28.721806701729875
            ],
            [
              -49.86828382824107,
              -28.72131494843243
            ],
            [
              -49.868000511911795,
              -28.721995837613512
            ],
            [
              -49.87050313948701,
              -28.724303295393845
            ],
            [
              -49.87177806296873,
              -28.72600551834655
            ],
            [
              -49.87399737421468,
              -28.726799889057812
            ],
            [
              -49.87739717016593,
              -28.73118784155812
            ],
            [
              -49.88150525694034,
              -28.735500139704975
            ],
            [
              -49.88329959369239,
              -28.73769411595513
            ],
            [
              -49.8813163793875,
              -28.737618461601677
            ],
            [
              -49.87819989976553,
              -28.736786263713686
            ],
            [
              -49.88008867529399,
              -28.739812437851832
            ],
            [
              -49.879899797741146,
              -28.741817278218353
            ],
            [
              -49.878105460989104,
              -28.74370863705469
            ],
            [
              -49.87480010381428,
              -28.74370863705469
            ],
            [
              -49.87480010381428,
              -28.744616489296135
            ],
            [
              -49.87668887934275,
              -28.744503007765953
            ],
            [
              -49.879002629365125,
              -28.744994761063403
            ],
            [
              -49.8813163793875,
              -28.746507848132474
            ],
            [
              -49.88410232329199,
              -28.746507848132474
            ],
            [
              -49.885613343714766,
              -28.745713477421212
            ],
            [
              -49.88920201721885,
              -28.745713477421212
            ],
            [
              -49.88660495086721,
              -28.74049332703291
            ],
            [
              -49.88802153251356,
              -28.739093721494022
            ],
            [
              -49.8917990835705,
              -28.7392072030242
            ],
            [
              -49.89109079274732,
              -28.73818586925258
            ],
            [
              -49.890713037641625,
              -28.73629451041624
            ],
            [
              -49.88821041006641,
              -28.73391139828245
            ],
            [
              -49.885991098820455,
              -28.730317816493404
            ],
            [
              -49.88551890493834,
              -28.72778339565271
            ],
            [
              -49.88471617533874,
              -28.725816382462916
            ],
            [
              -49.88108028244644,
              -28.722298455027325
            ],
            [
              -49.88079696611717,
              -28.72139060278588
            ],
            [
              -49.882591302869216,
              -28.71741874922957
            ],
            [
              -49.885093930444434,
              -28.71821311994083
            ],
            [
              -49.88740768046681,
              -28.719801861363358
            ],
            [
              -49.8877854355725,
              -28.72059623207462
            ],
            [
              -49.890713037641625,
              -28.72210931914369
            ],
            [
              -49.89331010399327,
              -28.722903689854952
            ],
            [
              -49.89420727236929,
              -28.72449243127748
            ],
            [
              -49.89661546116809,
              -28.72600551834655
            ],
            [
              -49.89741819076769,
              -28.723206307268768
            ],
            [
              -49.89751262954411,
              -28.72131494843243
            ],
            [
              -49.900015257119335,
              -28.7207097136048
            ],
            [
              -49.90129018060105,
              -28.719007490652093
            ],
            [
              -49.90421778267017,
              -28.71938576241936
            ],
            [
              -49.90487885410514,
              -28.718515737354647
            ],
            [
              -49.907192604127516,
              -28.719196626535727
            ],
            [
              -49.90818421127996,
              -28.719990997246992
            ],
            [
              -49.908892502103136,
              -28.72188235608333
            ],
            [
              -49.91148956845478,
              -28.722298455027325
            ],
            [
              -49.91200898172511,
              -28.72108798537207
            ],
            [
              -49.91049796130233,
              -28.718288774294283
            ],
            [
              -49.90922303782062,
              -28.716510896988126
            ],
            [
              -49.90790089495069,
              -28.713787340263796
            ],
            [
              -49.9059176806458,
              -28.71231208037145
            ],
            [
              -49.90502051226977,
              -28.709702005177302
            ],
            [
              -49.90487885410514,
              -28.707583683280603
            ],
            [
              -49.906106558198644,
              -28.70769716481078
            ],
            [
              -49.907806456174264,
              -28.70928590623331
            ],
            [
              -49.90908137965598,
              -28.711215092246373
            ],
            [
              -49.91380331847715,
              -28.71480867403542
            ],
            [
              -49.91507824195887,
              -28.71469519250524
            ],
            [
              -49.91658926238164,
              -28.71741874922957
            ],
            [
              -49.91810028280442,
              -28.717797020996837
            ],
            [
              -49.92112232364997,
              -28.717683539466655
            ],
            [
              -49.92310553795486,
              -28.71881835476846
            ],
            [
              -49.925985920635775,
              -28.718288774294283
            ],
            [
              -49.92650533390611,
              -28.719196626535727
            ],
            [
              -49.928677425763844,
              -28.720785367958253
            ],
            [
              -49.93080229823337,
              -28.723395443152402
            ],
            [
              -49.93321048703216,
              -28.72521114763529
            ],
            [
              -49.93472150745494,
              -28.72570290093274
            ],
            [
              -49.93481594623137,
              -28.726989024941446
            ],
            [
              -49.93287995131468,
              -28.728199494596705
            ],
            [
              -49.93330492580859,
              -28.7291830011916
            ],
            [
              -49.93198278293866,
              -28.731603940502115
            ],
            [
              -49.9297162523045,
              -28.731490458971937
            ],
            [
              -49.9289135227049,
              -28.732890064510826
            ],
            [
              -49.93179390538582,
              -28.735613621235157
            ],
            [
              -49.93141615028012,
              -28.737883251838763
            ],
            [
              -49.93061342068052,
              -28.73890458561039
            ],
            [
              -49.929007961481325,
              -28.739093721494022
            ],
            [
              -49.92749694105855,
              -28.74170379668817
            ],
            [
              -49.92669421145895,
              -28.740304191149278
            ],
            [
              -49.924616558377636,
              -28.74370863705469
            ],
            [
              -49.922491685908106,
              -28.743784291408144
            ],
            [
              -49.92168895630851,
              -28.74548651436085
            ],
            [
              -49.92357773183698,
              -28.7471130829601
            ],
            [
              -49.928819083928474,
              -28.749685330977524
            ],
            [
              -49.92759137983497,
              -28.752295406171672
            ],
            [
              -49.92759137983497,
              -28.753808493240744
            ],
            [
              -49.92948015536344,
              -28.753997629124378
            ],
            [
              -49.931699466609395,
              -28.755208098779637
            ],
            [
              -49.93401321663177,
              -28.755094617249455
            ],
            [
              -49.93580755338381,
              -28.755699852077086
            ],
            [
              -49.936988038089105,
              -28.75668335867198
            ],
            [
              -49.940907247310676,
              -28.75460286395201
            ],
            [
              -49.94161553813385,
              -28.753203258413116
            ],
            [
              -49.94350431366232,
              -28.752181924641494
            ],
            [
              -49.94567640552006,
              -28.751917134404405
            ],
            [
              -49.9495011759652,
              -28.752408887701854
            ],
            [
              -49.950823318835134,
              -28.753316739943298
            ],
            [
              -49.948698446365604,
              -28.75588898796072
            ],
            [
              -49.94921785963594,
              -28.757212939146157
            ],
            [
              -49.952381558646124,
              -28.75691032173234
            ],
            [
              -49.953420385186774,
              -28.75800730985742
            ],
            [
              -49.95290097191645,
              -28.759482569749764
            ],
            [
              -49.950823318835134,
              -28.76330311459917
            ],
            [
              -49.95200380354043,
              -28.76519447343551
            ],
            [
              -49.951389951493674,
              -28.766896696388216
            ],
            [
              -49.953420385186774,
              -28.7665940789744
            ],
            [
              -49.95478974744492,
              -28.767501931215843
            ],
            [
              -49.954978624997764,
              -28.768901536754736
            ],
            [
              -49.95748125257298,
              -28.768485437810742
            ],
            [
              -49.95861451789007,
              -28.770414623823807
            ],
            [
              -49.96130602301813,
              -28.772192501129968
            ],
            [
              -49.96111714546529,
              -28.773289489255045
            ],
            [
              -49.95852007911364,
              -28.776088700332828
            ],
            [
              -49.96220319139415,
              -28.7776017874019
            ],
            [
              -49.96210875261773,
              -28.779417491884786
            ],
            [
              -49.960692170971384,
              -28.78149798660476
            ],
            [
              -49.958897834219336,
              -28.78278411061347
            ],
            [
              -49.957009058690865,
              -28.783616308501458
            ],
            [
              -49.95729237502014,
              -28.784599815096357
            ],
            [
              -49.95951168626609,
              -28.786718136993056
            ],
            [
              -49.95908671177218,
              -28.790614336195915
            ],
            [
              -49.95781178829047,
              -28.79469967128241
            ],
            [
              -49.956300767867695,
              -28.79681799317911
            ],
            [
              -49.95379814029247,
              -28.799314586843078
            ],
            [
              -49.950917757611556,
              -28.800411574968155
            ],
            [
              -49.95110663516441,
              -28.802416415334676
            ],
            [
              -49.953514823963204,
              -28.80139508156305
            ],
            [
              -49.95748125257298,
              -28.798785006368902
            ],
            [
              -49.95960612504251,
              -28.798104117187822
            ],
            [
              -49.96210875261773,
              -28.798406734601635
            ],
            [
              -49.962722604664485,
              -28.799087623782718
            ],
            [
              -49.962392068947004,
              -28.80109246414924
            ],
            [
              -49.96300592099375,
              -28.80339992192957
            ],
            [
              -49.96168377812383,
              -28.806690886304803
            ],
            [
              -49.96220319139415,
              -28.808582245141142
            ],
            [
              -49.964422502640105,
              -28.81119232033529
            ],
            [
              -49.96489469652222,
              -28.8150128651847
            ],
            [
              -49.965414109792555,
              -28.81580723589596
            ],
            [
              -49.96612240061573,
              -28.819816916629
            ],
            [
              -49.96588630367467,
              -28.82299439947405
            ],
            [
              -49.965414109792555,
              -28.82371311583186
            ],
            [
              -49.96470581896938,
              -28.828403685745982
            ],
            [
              -49.962486507723426,
              -28.82961415540124
            ],
            [
              -49.96050329341853,
              -28.828403685745982
            ],
            [
              -49.95781178829047,
              -28.829084574927066
            ],
            [
              -49.95691461991444,
              -28.83460734272918
            ],
            [
              -49.95852007911364,
              -28.83468299708263
            ],
            [
              -49.96040885464211,
              -28.838087442988044
            ],
            [
              -49.95960612504251,
              -28.84058403665201
            ],
            [
              -49.96088104852423,
              -28.842097123721082
            ],
            [
              -49.96050329341853,
              -28.844101964087603
            ],
            [
              -49.96177821690025,
              -28.844593717385052
            ],
            [
              -49.96021997708927,
              -28.847506409993017
            ],
            [
              -49.961589339347405,
              -28.84958690471299
            ],
            [
              -49.962392068947004,
              -28.85238611579077
            ],
            [
              -49.96210875261773,
              -28.85348310391585
            ],
            [
              -49.95951168626609,
              -28.854012684390025
            ],
            [
              -49.95601745153842,
              -28.857114512881623
            ],
            [
              -49.956300767867695,
              -28.860594613140485
            ],
            [
              -49.957103497467294,
              -28.861805082795744
            ],
            [
              -49.96168377812383,
              -28.863885577515717
            ],
            [
              -49.9639975281462,
              -28.86600389941242
            ],
            [
              -49.96730288532102,
              -28.86789525824876
            ],
            [
              -49.96871946696737,
              -28.869710962731645
            ],
            [
              -49.969002783296645,
              -28.873607161934505
            ],
            [
              -49.969899951672666,
              -28.87530938488721
            ],
            [
              -49.969002783296645,
              -28.877011607839915
            ],
            [
              -49.967114007768174,
              -28.8767089904261
            ],
            [
              -49.96380865059336,
              -28.87379629781814
            ],
            [
              -49.961400461794554,
              -28.872888445576695
            ],
            [
              -49.95951168626609,
              -28.871602321567984
            ],
            [
              -49.95682018113802,
              -28.870391851912725
            ],
            [
              -49.951484390270096,
              -28.870391851912725
            ],
            [
              -49.95110663516441,
              -28.870883605210174
            ],
            [
              -49.952381558646124,
              -28.873001927106873
            ],
            [
              -49.95200380354043,
              -28.87409891523195
            ],
            [
              -49.94959561474163,
              -28.874704150059582
            ],
            [
              -49.9495011759652,
              -28.875687656654478
            ],
            [
              -49.95120107394083,
              -28.877616842667543
            ],
            [
              -49.95422311478638,
              -28.878411213378808
            ],
            [
              -49.95389257906889,
              -28.880302572215147
            ],
            [
              -49.95049278311765,
              -28.88060518962896
            ],
            [
              -49.94879288514203,
              -28.879583855857337
            ],
            [
              -49.94638469634323,
              -28.879016448206436
            ],
            [
              -49.94119056363994,
              -28.876292891482105
            ],
            [
              -49.93831018095903,
              -28.87258582816288
            ],
            [
              -49.935996430936655,
              -28.871791457451618
            ],
            [
              -49.93472150745494,
              -28.872283210749067
            ],
            [
              -49.93207722171508,
              -28.87220755639561
            ],
            [
              -49.93302160947932,
              -28.873607161934505
            ],
            [
              -49.936421405430565,
              -28.874704150059582
            ],
            [
              -49.93750745135943,
              -28.878789485146076
            ],
            [
              -49.93911291055863,
              -28.880189090684965
            ],
            [
              -49.9410016860871,
              -28.87871383079262
            ],
            [
              -49.943598752438746,
              -28.87969733738752
            ],
            [
              -49.94369319121517,
              -28.88121042445659
            ],
            [
              -49.946195818790386,
              -28.885182278012902
            ],
            [
              -49.948698446365604,
              -28.88590099437071
            ],
            [
              -49.95039834434123,
              -28.886884500965607
            ],
            [
              -49.95110663516441,
              -28.888208452151048
            ],
            [
              -49.94879288514203,
              -28.88900282286231
            ],
            [
              -49.94817903309528,
              -28.889986329457205
            ],
            [
              -49.95110663516441,
              -28.891499416526276
            ],
            [
              -49.95157882904652,
              -28.892482923121175
            ],
            [
              -49.950917757611556,
              -28.893504256892797
            ],
            [
              -49.949690053518054,
              -28.893504256892797
            ],
            [
              -49.94959561474163,
              -28.898005690923284
            ],
            [
              -49.951484390270096,
              -28.900502284587255
            ],
            [
              -49.95488418622134,
              -28.901183173768338
            ],
            [
              -49.95568691582094,
              -28.901901890126148
            ],
            [
              -49.95828398217258,
              -28.902393643423594
            ],
            [
              -49.95899227299576,
              -28.90371759460903
            ],
            [
              -49.95828398217258,
              -28.905911570859185
            ],
            [
              -49.95932280871324,
              -28.907197694867897
            ],
            [
              -49.96031441586569,
              -28.910186041829313
            ],
            [
              -49.96258094649985,
              -28.913817450795086
            ],
            [
              -49.961919875064886,
              -28.91578446398488
            ],
            [
              -49.963289237323025,
              -28.916881452109955
            ],
            [
              -49.9631947985466,
              -28.918886292476476
            ],
            [
              -49.96489469652222,
              -28.920399379545547
            ],
            [
              -49.96701956899175,
              -28.920815478489544
            ],
            [
              -49.96871946696737,
              -28.922101602498255
            ],
            [
              -49.96508357407507,
              -28.925506048403665
            ],
            [
              -49.96201431384131,
              -28.925884320170933
            ],
            [
              -49.959700563818934,
              -28.926603036528743
            ],
            [
              -49.95648964542054,
              -28.926603036528743
            ],
            [
              -49.95521472193882,
              -28.925581702757118
            ],
            [
              -49.953278727022145,
              -28.925506048403665
            ],
            [
              -49.950917757611556,
              -28.92690565394256
            ],
            [
              -49.94978449229448,
              -28.931217952089412
            ],
            [
              -49.94940673718878,
              -28.934092817520646
            ],
            [
              -49.94959561474163,
              -28.93560590458972
            ],
            [
              -49.95181492598758,
              -28.932201458684307
            ],
            [
              -49.95181492598758,
              -28.929894000903975
            ],
            [
              -49.9543175535628,
              -28.92898614866253
            ],
            [
              -49.95639520664412,
              -28.92898614866253
            ],
            [
              -49.95818954339616,
              -28.930688371615236
            ],
            [
              -49.95861451789007,
              -28.933411928339567
            ],
            [
              -49.95979500259536,
              -28.93560590458972
            ],
            [
              -49.95837842094901,
              -28.93878338743477
            ],
            [
              -49.958897834219336,
              -28.941204326745286
            ],
            [
              -49.95852007911364,
              -28.944987044417964
            ],
            [
              -49.95568691582094,
              -28.948883243620823
            ],
            [
              -49.95469530866849,
              -28.952098553642603
            ],
            [
              -49.957197936243716,
              -28.957886111681802
            ],
            [
              -49.95762291073762,
              -28.960382705345772
            ],
            [
              -49.95738681379656,
              -28.962917126186465
            ],
            [
              -49.95422311478638,
              -28.96178231088466
            ],
            [
              -49.948698446365604,
              -28.962084928298477
            ],
            [
              -49.94411816570907,
              -28.963484533837367
            ],
            [
              -49.942276609568815,
              -28.963295397953733
            ],
            [
              -49.9393962268879,
              -28.964316731725358
            ],
            [
              -49.93368268091428,
              -28.965791991617703
            ],
            [
              -49.932596634985416,
              -28.965413719850435
            ],
            [
              -49.93089673700979,
              -28.975891847803755
            ],
            [
              -49.92480543593048,
              -28.975589230389943
            ],
            [
              -49.92031959405037,
              -28.977783206640098
            ],
            [
              -49.92017793588573,
              -28.97880454041172
            ],
            [
              -49.92400270633088,
              -28.983003357028394
            ],
            [
              -49.924286022660155,
              -28.980695899248058
            ],
            [
              -49.92650533390611,
              -28.979485429592803
            ],
            [
              -49.92792191555245,
              -28.979409775239347
            ],
            [
              -49.93108561456264,
              -28.980506763364424
            ],
            [
              -49.93401321663177,
              -28.98209550478695
            ],
            [
              -49.93457984929031,
              -28.983381628795662
            ],
            [
              -49.93439097173746,
              -28.985689086575995
            ],
            [
              -49.936421405430565,
              -28.984592098450918
            ],
            [
              -49.93661028298341,
              -28.983381628795662
            ],
            [
              -49.93580755338381,
              -28.980885035131692
            ],
            [
              -49.93580755338381,
              -28.979712392653163
            ],
            [
              -49.93821574218261,
              -28.978691058881537
            ],
            [
              -49.94251270650987,
              -28.98220898631713
            ],
            [
              -49.94421260448549,
              -28.986483457287257
            ],
            [
              -49.94468479836761,
              -28.989207014011587
            ],
            [
              -49.943409874885894,
              -28.990909236964292
            ],
            [
              -49.941379441192794,
              -28.991098372847926
            ],
            [
              -49.940482272816766,
              -28.991817089205735
            ],
            [
              -49.9410016860871,
              -28.995108053580967
            ],
            [
              -49.94270158406272,
              -28.998096400542384
            ],
            [
              -49.94241826773345,
              -29.00119822903398
            ],
            [
              -49.94322099733305,
              -29.001009093150348
            ],
            [
              -49.94350431366232,
              -28.997718128775116
            ],
            [
              -49.94270158406272,
              -28.995410670994783
            ],
            [
              -49.943409874885894,
              -28.993405830628262
            ],
            [
              -49.94539308919079,
              -28.992195360973003
            ],
            [
              -49.94662079328429,
              -28.99298973168427
            ],
            [
              -49.94629025756681,
              -28.995108053580967
            ],
            [
              -49.94709298716641,
              -28.99601590582241
            ],
            [
              -49.94860400758918,
              -28.996318523236226
            ],
            [
              -49.94921785963594,
              -28.998701635370015
            ],
            [
              -49.951389951493674,
              -28.999004252783827
            ],
            [
              -49.95209824231685,
              -29.000101240908904
            ],
            [
              -49.95110663516441,
              -29.00180346386161
            ],
            [
              -49.953609262739626,
              -29.004716156469573
            ],
            [
              -49.953609262739626,
              -29.00569966306447
            ],
            [
              -49.956678522973384,
              -29.008007120844805
            ],
            [
              -49.95918115054861,
              -29.010503714508772
            ],
            [
              -49.95738681379656,
              -29.0120924559313
            ],
            [
              -49.95918115054861,
              -29.01360554300037
            ],
            [
              -49.95951168626609,
              -29.015307765953075
            ],
            [
              -49.96040885464211,
              -29.016518235608334
            ],
            [
              -49.96201431384131,
              -29.016404754078152
            ],
            [
              -49.962722604664485,
              -29.01750174220323
            ],
            [
              -49.96177821690025,
              -29.01871221185849
            ],
            [
              -49.96371421181693,
              -29.01950658256975
            ],
            [
              -49.965980742451094,
              -29.021700558819905
            ],
            [
              -49.966311278168575,
              -29.0226840654148
            ],
            [
              -49.96470581896938,
              -29.023705399186426
            ],
            [
              -49.961022706688865,
              -29.02328930024243
            ],
            [
              -49.95408145662174,
              -29.02090618810864
            ],
            [
              -49.95049278311765,
              -29.020717052225006
            ],
            [
              -49.95020946678838,
              -29.0221166577639
            ],
            [
              -49.950917757611556,
              -29.024499769897687
            ],
            [
              -49.94978449229448,
              -29.02461325142787
            ],
            [
              -49.948698446365604,
              -29.0226840654148
            ],
            [
              -49.94680967083714,
              -29.021095323992277
            ],
            [
              -49.945298650414365,
              -29.02139794140609
            ],
            [
              -49.941379441192794,
              -29.02128445987591
            ],
            [
              -49.940718369757825,
              -29.022305793647533
            ],
            [
              -49.94152109935743,
              -29.02340278177261
            ],
            [
              -49.94378762999159,
              -29.02389453507006
            ],
            [
              -49.94520421163794,
              -29.025105004725315
            ],
            [
              -49.94761240043674,
              -29.02601285696676
            ],
            [
              -49.94799015554243,
              -29.026996363561654
            ],
            [
              -49.946101380013964,
              -29.03081690841106
            ],
            [
              -49.94690410961356,
              -29.031800415005957
            ],
            [
              -49.94959561474163,
              -29.032783921600856
            ],
            [
              -49.951389951493674,
              -29.03391873690266
            ],
            [
              -49.95408145662174,
              -29.034183527139746
            ],
            [
              -49.956300767867695,
              -29.03520486091137
            ],
            [
              -49.95460086989207,
              -29.038306689402965
            ],
            [
              -49.95568691582094,
              -29.040084566709126
            ],
            [
              -49.95601745153842,
              -29.041597653778197
            ],
            [
              -49.95818954339616,
              -29.04178678966183
            ],
            [
              -49.95908671177218,
              -29.04311074084727
            ],
            [
              -49.96121158424171,
              -29.043791630028352
            ],
            [
              -49.95960612504251,
              -29.047082594403584
            ],
            [
              -49.96021997708927,
              -29.04761217487776
            ],
            [
              -49.961022706688865,
              -29.05078965772281
            ],
            [
              -49.964422502640105,
              -29.05090313925299
            ],
            [
              -49.96749176287387,
              -29.051697509964253
            ],
            [
              -49.969805512896244,
              -29.05150837408062
            ],
            [
              -49.969711074119814,
              -29.053891486214408
            ],
            [
              -49.97131653331902,
              -29.054610202572217
            ],
            [
              -49.97197760475398,
              -29.05619894399474
            ],
            [
              -49.9736775027296,
              -29.055593709167113
            ],
            [
              -49.977218956845476,
              -29.05880901918889
            ],
            [
              -49.98061875279672,
              -29.059489908369972
            ],
            [
              -49.98321581914837,
              -29.060889513908865
            ],
            [
              -49.985199033453256,
              -29.06160823026667
            ],
            [
              -49.98637951815855,
              -29.063386107572832
            ],
            [
              -49.989779314109796,
              -29.063007835805564
            ],
            [
              -49.98968487533337,
              -29.06459657722809
            ],
            [
              -49.990912579426876,
              -29.064899194641903
            ],
            [
              -49.993509645778516,
              -29.064293959814275
            ],
            [
              -49.99450125293097,
              -29.065088330525537
            ],
            [
              -49.99412349782527,
              -29.066185318650614
            ],
            [
              -49.99648446723586,
              -29.06750926983605
            ],
            [
              -49.99931763052856,
              -29.068303640547317
            ],
            [
              -50.00167859993915,
              -29.069514110202572
            ],
            [
              -50.00399234996152,
              -29.071216333155277
            ],
            [
              -50.004417324455424,
              -29.07238897563381
            ],
            [
              -50.002717426479805,
              -29.072994210461438
            ],
            [
              -50.00012036012816,
              -29.071708086452727
            ],
            [
              -49.993981839660634,
              -29.069589764556028
            ],
            [
              -49.989779314109796,
              -29.070194999383656
            ],
            [
              -49.98930712022768,
              -29.07189722233636
            ],
            [
              -49.986001763052855,
              -29.072805074577804
            ],
            [
              -49.986190640605706,
              -29.070800234211283
            ],
            [
              -49.98831551307523,
              -29.068795393844763
            ],
            [
              -49.98491571712399,
              -29.067811887249867
            ],
            [
              -49.98279084465446,
              -29.06849277643095
            ],
            [
              -49.97948548747964,
              -29.06849277643095
            ],
            [
              -49.97679398235157,
              -29.067093170892058
            ],
            [
              -49.97301643129464,
              -29.065807046883346
            ],
            [
              -49.96952219656697,
              -29.065693565353165
            ],
            [
              -49.96810561492062,
              -29.06520181205572
            ],
            [
              -49.969805512896244,
              -29.06909801125858
            ],
            [
              -49.968577808802735,
              -29.068795393844763
            ],
            [
              -49.964989135298644,
              -29.065807046883346
            ],
            [
              -49.962486507723426,
              -29.065315293585897
            ],
            [
              -49.96021997708927,
              -29.06648793606443
            ],
            [
              -49.95748125257298,
              -29.066601417594608
            ],
            [
              -49.956678522973384,
              -29.065807046883346
            ],
            [
              -49.95738681379656,
              -29.063386107572832
            ],
            [
              -49.955923012762,
              -29.06209998356412
            ],
            [
              -49.952287119869695,
              -29.0600951431976
            ],
            [
              -49.951484390270096,
              -29.060284279081234
            ],
            [
              -49.94898176269488,
              -29.058506401775077
            ],
            [
              -49.94709298716641,
              -29.059716871430332
            ],
            [
              -49.94728186471926,
              -29.057787685417267
            ],
            [
              -49.946195818790386,
              -29.056388079878374
            ],
            [
              -49.94208773201597,
              -29.05820378436126
            ],
            [
              -49.94161553813385,
              -29.058998155072523
            ],
            [
              -49.94322099733305,
              -29.060397760611416
            ],
            [
              -49.945109772861514,
              -29.061192131322677
            ],
            [
              -49.94322099733305,
              -29.063007835805564
            ],
            [
              -49.94492089530867,
              -29.06331045321938
            ],
            [
              -49.95110663516441,
              -29.06138126720631
            ],
            [
              -49.952381558646124,
              -29.063083490159016
            ],
            [
              -49.952523216810754,
              -29.06550442946953
            ],
            [
              -49.95101219638798,
              -29.067698405719685
            ],
            [
              -49.952523216810754,
              -29.06860625796113
            ],
            [
              -49.95601745153842,
              -29.067811887249867
            ],
            [
              -49.95762291073762,
              -29.068190159017135
            ],
            [
              -49.96031441586569,
              -29.0706867526811
            ],
            [
              -49.95918115054861,
              -29.07401554423306
            ],
            [
              -49.95837842094901,
              -29.074809914944325
            ],
            [
              -49.955923012762,
              -29.07530166824177
            ],
            [
              -49.95478974744492,
              -29.07628517483667
            ],
            [
              -49.95450643111565,
              -29.077495644491925
            ],
            [
              -49.955309160715245,
              -29.07840349673337
            ],
            [
              -49.956206329091266,
              -29.08120270781115
            ],
            [
              -49.95549803826809,
              -29.08241317746641
            ],
            [
              -49.956206329091266,
              -29.084909771130377
            ],
            [
              -49.95941724748967,
              -29.08358581994494
            ],
            [
              -49.96078660974781,
              -29.08358581994494
            ],
            [
              -49.965178012851496,
              -29.081997078522416
            ],
            [
              -49.96782229859135,
              -29.083018412294038
            ],
            [
              -49.96829449247347,
              -29.084191054772567
            ],
            [
              -49.96678347205069,
              -29.087784636561615
            ],
            [
              -49.96588630367467,
              -29.088881624686692
            ],
            [
              -49.96579186489824,
              -29.090810810699757
            ],
            [
              -49.96730288532102,
              -29.093685676130995
            ],
            [
              -49.96678347205069,
              -29.09610661544151
            ],
            [
              -49.96489469652222,
              -29.097014467682953
            ],
            [
              -49.96300592099375,
              -29.099813678760736
            ],
            [
              -49.96347811487587,
              -29.10049456794182
            ],
            [
              -49.96739732409745,
              -29.100116296174548
            ],
            [
              -49.969805512896244,
              -29.100608049471997
            ],
            [
              -49.97051380371941,
              -29.10128893865308
            ],
            [
              -49.97018326800193,
              -29.10461773020504
            ],
            [
              -49.96829449247347,
              -29.109194818588982
            ],
            [
              -49.96829449247347,
              -29.114793240744547
            ],
            [
              -49.96739732409745,
              -29.11570109298599
            ],
            [
              -49.96531967101613,
              -29.114906722274725
            ],
            [
              -49.964422502640105,
              -29.11520933968854
            ],
            [
              -49.96258094649985,
              -29.117516797468873
            ],
            [
              -49.964422502640105,
              -29.11861378559395
            ],
            [
              -49.96928609962591,
              -29.12039166290011
            ],
            [
              -49.968200053697046,
              -29.11831116818014
            ],
            [
              -49.968200053697046,
              -29.11638198216707
            ],
            [
              -49.968908344520216,
              -29.116003710399802
            ],
            [
              -49.97278033435358,
              -29.117895069236145
            ],
            [
              -49.97471632927026,
              -29.11861378559395
            ],
            [
              -49.97537740070522,
              -29.11770593335251
            ],
            [
              -49.976982859904425,
              -29.117289834408513
            ],
            [
              -49.97740783439833,
              -29.116003710399802
            ],
            [
              -49.97948548747964,
              -29.118197686649957
            ],
            [
              -49.981704798725595,
              -29.1191055388914
            ],
            [
              -49.98250752832519,
              -29.118802921477585
            ],
            [
              -49.98288528343088,
              -29.1169872169947
            ],
            [
              -49.98548234978253,
              -29.116911562641246
            ],
            [
              -49.98798497735775,
              -29.1191055388914
            ],
            [
              -49.98850439062808,
              -29.117781587705963
            ],
            [
              -49.9918097478029,
              -29.117289834408513
            ],
            [
              -49.992612477402496,
              -29.11861378559395
            ],
            [
              -49.99218750290859,
              -29.12088341619756
            ],
            [
              -49.98949599778052,
              -29.12451482516333
            ],
            [
              -49.98680449265245,
              -29.125687467641864
            ],
            [
              -49.98652117632319,
              -29.12769230800838
            ],
            [
              -49.98741834469921,
              -29.12841102436619
            ],
            [
              -49.985293472229685,
              -29.129999765788718
            ],
            [
              -49.984490742630086,
              -29.132685495336318
            ],
            [
              -49.98491571712399,
              -29.135484706414104
            ],
            [
              -49.984301865077235,
              -29.13669517606936
            ],
            [
              -49.98151592117274,
              -29.135711669474464
            ],
            [
              -49.97948548747964,
              -29.134198582405393
            ],
            [
              -49.97858831910362,
              -29.13431206393557
            ],
            [
              -49.97778558950402,
              -29.135900805358098
            ],
            [
              -49.978210563997926,
              -29.13718692936681
            ],
            [
              -49.981704798725595,
              -29.139116115379874
            ],
            [
              -49.98269640587804,
              -29.137716509840985
            ],
            [
              -49.986096201829284,
              -29.13741389242717
            ],
            [
              -49.98637951815855,
              -29.13631690430209
            ],
            [
              -49.99029872738012,
              -29.137111275013353
            ],
            [
              -49.9918097478029,
              -29.135598187944282
            ],
            [
              -49.991479212085416,
              -29.133895964991577
            ],
            [
              -49.9894015590041,
              -29.131588507211244
            ],
            [
              -49.99129033453257,
              -29.129999765788718
            ],
            [
              -49.993604084554946,
              -29.13128588979743
            ],
            [
              -49.99681500295334,
              -29.13151285285779
            ],
            [
              -49.99842046215254,
              -29.13090761803016
            ],
            [
              -50.00167859993915,
              -29.127087073180753
            ],
            [
              -50.00290630403265,
              -29.127200554710935
            ],
            [
              -50.00602278365462,
              -29.128600160249825
            ],
            [
              -50.00739214591276,
              -29.12841102436619
            ],
            [
              -50.00928092144123,
              -29.12629270246949
            ],
            [
              -50.00739214591276,
              -29.123190873977894
            ],
            [
              -50.004181227514366,
              -29.121186033611373
            ],
            [
              -50.00460620200827,
              -29.120089045486296
            ],
            [
              -50.00602278365462,
              -29.120202527016477
            ],
            [
              -50.00791155918309,
              -29.121186033611373
            ],
            [
              -50.009705895935134,
              -29.123682627275343
            ],
            [
              -50.01338900821565,
              -29.12678445576694
            ],
            [
              -50.0140028602624,
              -29.129318876607634
            ],
            [
              -50.01230296228678,
              -29.131588507211244
            ],
            [
              -50.01112247758149,
              -29.131891124625056
            ],
            [
              -50.007108829583494,
              -29.134387718289027
            ],
            [
              -50.00691995203064,
              -29.136997793483175
            ],
            [
              -50.00980033471156,
              -29.1385865349057
            ],
            [
              -50.00951701838229,
              -29.13941873279369
            ],
            [
              -50.00488951833754,
              -29.14059137527222
            ],
            [
              -50.005078395890386,
              -29.14259621563874
            ],
            [
              -50.00791155918309,
              -29.14308796893619
            ],
            [
              -50.00871428878269,
              -29.143806685294
            ],
            [
              -50.00918648266481,
              -29.145887180013972
            ],
            [
              -50.00861985000627,
              -29.14770288449686
            ],
            [
              -50.005881125489985,
              -29.15038861404446
            ],
            [
              -50.007108829583494,
              -29.150804712988453
            ],
            [
              -50.01008365104083,
              -29.149405107449564
            ],
            [
              -50.010697503087584,
              -29.14989686074701
            ],
            [
              -50.01017808981725,
              -29.1534147881826
            ],
            [
              -50.00909204388839,
              -29.15678140691129
            ],
            [
              -50.01088638064043,
              -29.156894888441467
            ],
            [
              -50.01371954393313,
              -29.154814393721495
            ],
            [
              -50.01527778374412,
              -29.1543982947775
            ],
            [
              -50.0164110490612,
              -29.153301306652423
            ],
            [
              -50.017213778660796,
              -29.15451177630768
            ],
            [
              -50.02028303889456,
              -29.151296466285903
            ],
            [
              -50.01999972256529,
              -29.154890048074947
            ],
            [
              -50.020708013388465,
              -29.157991876566545
            ],
            [
              -50.01929143174211,
              -29.15901321033817
            ],
            [
              -50.019716406236014,
              -29.161207186588324
            ],
            [
              -50.018016508260395,
              -29.162795928010848
            ],
            [
              -50.01848870214251,
              -29.165406003204996
            ],
            [
              -50.019810845012444,
              -29.16608689238608
            ],
            [
              -50.02080245216489,
              -29.167713460985333
            ],
            [
              -50.022407911364084,
              -29.166994744627523
            ],
            [
              -50.022407911364084,
              -29.165292521674818
            ],
            [
              -50.023305079740105,
              -29.163892916135925
            ],
            [
              -50.02500497771573,
              -29.163401162838475
            ],
            [
              -50.02750760529095,
              -29.16480076837737
            ],
            [
              -50.023493957292956,
              -29.166616472860255
            ],
            [
              -50.0260910236446,
              -29.168507831696594
            ],
            [
              -50.02840477366697,
              -29.171382697127832
            ],
            [
              -50.02590214609175,
              -29.171912277602004
            ],
            [
              -50.022596788916935,
              -29.173690154908165
            ],
            [
              -50.018819237859994,
              -29.174484525619427
            ],
            [
              -50.021605181764485,
              -29.17728373669721
            ],
            [
              -50.02169962054091,
              -29.178494206352468
            ],
            [
              -50.019810845012444,
              -29.179704676007724
            ],
            [
              -50.015986074567294,
              -29.181104281546617
            ],
            [
              -50.01291681433353,
              -29.180385565188807
            ],
            [
              -50.01201964595751,
              -29.182617368615688
            ],
            [
              -50.014286176591675,
              -29.182314751201876
            ],
            [
              -50.015183344967696,
              -29.1839034926244
            ],
            [
              -50.0135778857685,
              -29.185492234046926
            ],
            [
              -50.015183344967696,
              -29.18670270370218
            ],
            [
              -50.01622217150835,
              -29.18568136993056
            ],
            [
              -50.016316610284775,
              -29.18280650449932
            ],
            [
              -50.01749709499007,
              -29.1817851707277
            ],
            [
              -50.019905283788866,
              -29.181482553313884
            ],
            [
              -50.022407911364084,
              -29.180612528249167
            ],
            [
              -50.025996584868174,
              -29.179818157537905
            ],
            [
              -50.02859365121982,
              -29.180196429305173
            ],
            [
              -50.03119071757146,
              -29.178418551999016
            ],
            [
              -50.03109627879504,
              -29.177586354111025
            ],
            [
              -50.032276763500334,
              -29.175203241977236
            ],
            [
              -50.033410028817414,
              -29.175316723507418
            ],
            [
              -50.035298804345885,
              -29.17660284751613
            ],
            [
              -50.0386041615207,
              -29.17739721822739
            ],
            [
              -50.040020743167055,
              -29.180688182602623
            ],
            [
              -50.04209839624837,
              -29.18201213378806
            ],
            [
              -50.043420539118294,
              -29.183714356740765
            ],
            [
              -50.04639536057564,
              -29.18329825779677
            ],
            [
              -50.04852023304516,
              -29.18379001109422
            ],
            [
              -50.0506923249029,
              -29.185113962279658
            ],
            [
              -50.052722758596005,
              -29.18379001109422
            ],
            [
              -50.051920028996406,
              -29.182201269671694
            ],
            [
              -50.0506923249029,
              -29.183109121913137
            ],
            [
              -50.0498895953033,
              -29.18201213378806
            ],
            [
              -50.049795156526876,
              -29.179818157537905
            ],
            [
              -50.051495054502496,
              -29.18049904671899
            ],
            [
              -50.05291163614885,
              -29.182390405555328
            ],
            [
              -50.05399768207772,
              -29.183109121913137
            ],
            [
              -50.05791689129929,
              -29.1839034926244
            ],
            [
              -50.06008898315703,
              -29.185983987344372
            ],
            [
              -50.06079727398021,
              -29.18518961663311
            ],
            [
              -50.0627804882851,
              -29.18590833299092
            ],
            [
              -50.0643859474843,
              -29.187610555943625
            ],
            [
              -50.06580252913065,
              -29.190901520318857
            ],
            [
              -50.06528311586032,
              -29.193398113982823
            ],
            [
              -50.06707745261237,
              -29.19498685540535
            ],
            [
              -50.06740798832985,
              -29.19109065620249
            ],
            [
              -50.0643859474843,
              -29.18568136993056
            ],
            [
              -50.06292214644973,
              -29.184206110038215
            ],
            [
              -50.06018342193345,
              -29.179704676007724
            ],
            [
              -50.06041951887451,
              -29.178796823766284
            ],
            [
              -50.059711228051334,
              -29.175203241977236
            ],
            [
              -50.06131668725053,
              -29.175203241977236
            ],
            [
              -50.06410263115502,
              -29.178418551999016
            ],
            [
              -50.06490536075462,
              -29.179591194477545
            ],
            [
              -50.07331041185631,
              -29.187988827710893
            ],
            [
              -50.0752936261612,
              -29.188404926654886
            ],
            [
              -50.076190794537226,
              -29.185605715577104
            ],
            [
              -50.078693422112444,
              -29.184811344865842
            ],
            [
              -50.07798513128927,
              -29.184092628508033
            ],
            [
              -50.07458533533803,
              -29.182087788141512
            ],
            [
              -50.0744908965616,
              -29.1808016641328
            ],
            [
              -50.07911839660635,
              -29.18201213378806
            ],
            [
              -50.08110161091124,
              -29.182201269671694
            ],
            [
              -50.081384927240514,
              -29.18049904671899
            ],
            [
              -50.08237653439296,
              -29.179591194477545
            ],
            [
              -50.08459584563891,
              -29.17951554012409
            ],
            [
              -50.084879161968175,
              -29.178683342236102
            ],
            [
              -50.081479366016936,
              -29.178305070468834
            ],
            [
              -50.08039332008806,
              -29.178418551999016
            ],
            [
              -50.07798513128927,
              -29.176186748572132
            ],
            [
              -50.07798513128927,
              -29.175316723507418
            ],
            [
              -50.08001556498237,
              -29.174900624563424
            ],
            [
              -50.08931778446008,
              -29.17539237786087
            ],
            [
              -50.09012051405968,
              -29.175089760447058
            ],
            [
              -50.0902149528361,
              -29.173198401610716
            ],
            [
              -50.085115258909234,
              -29.171798796071826
            ],
            [
              -50.08549301401493,
              -29.170512672063115
            ],
            [
              -50.08950666201292,
              -29.171307042774377
            ],
            [
              -50.093284213069865,
              -29.17100442536056
            ],
            [
              -50.09337865184629,
              -29.167902596868966
            ],
            [
              -50.091395437541394,
              -29.165292521674818
            ],
            [
              -50.08988441711862,
              -29.16419553354974
            ],
            [
              -50.08761788648446,
              -29.16408205201956
            ],
            [
              -50.08360423848646,
              -29.161888075769404
            ],
            [
              -50.08067663641734,
              -29.161282840941777
            ],
            [
              -50.078221228230326,
              -29.159996716933065
            ],
            [
              -50.07831566700675,
              -29.157613604799277
            ],
            [
              -50.072979876138824,
              -29.157386641738917
            ],
            [
              -50.067785743435536,
              -29.159391482105438
            ],
            [
              -50.06570809035422,
              -29.15980758104943
            ],
            [
              -50.0627804882851,
              -29.159391482105438
            ],
            [
              -50.062497171955826,
              -29.161282840941777
            ],
            [
              -50.059711228051334,
              -29.161207186588324
            ],
            [
              -50.05952235049849,
              -29.160488470230515
            ],
            [
              -50.057114161699694,
              -29.159618445165798
            ],
            [
              -50.057208600476116,
              -29.157916222213093
            ],
            [
              -50.06079727398021,
              -29.160110198463247
            ],
            [
              -50.06221385562656,
              -29.159618445165798
            ],
            [
              -50.062497171955826,
              -29.158218839626905
            ],
            [
              -50.064999799531044,
              -29.157613604799277
            ],
            [
              -50.068021840376595,
              -29.1575001232691
            ],
            [
              -50.064291508707875,
              -29.155911381846572
            ],
            [
              -50.06830515670587,
              -29.155192665488762
            ],
            [
              -50.0720827077628,
              -29.155684418786212
            ],
            [
              -50.07387704451485,
              -29.15511701113531
            ],
            [
              -50.07590747820795,
              -29.155381801372396
            ],
            [
              -50.07977946804131,
              -29.155381801372396
            ],
            [
              -50.081290488464084,
              -29.15840797551054
            ],
            [
              -50.08629574361453,
              -29.160110198463247
            ],
            [
              -50.09030939161252,
              -29.160791087644327
            ],
            [
              -50.09210372836457,
              -29.15980758104943
            ],
            [
              -50.093614748787346,
              -29.1601858528167
            ],
            [
              -50.096211815138986,
              -29.159618445165798
            ],
            [
              -50.096778447797526,
              -29.158899728807988
            ],
            [
              -50.099706049866654,
              -29.15980758104943
            ],
            [
              -50.10112263151301,
              -29.161509804002137
            ],
            [
              -50.10187814172439,
              -29.164384669433375
            ],
            [
              -50.09998936619593,
              -29.16419553354974
            ],
            [
              -50.09630625391541,
              -29.16620037391626
            ],
            [
              -50.09658957024468,
              -29.168999584994044
            ],
            [
              -50.09739229984428,
              -29.170588326416567
            ],
            [
              -50.09630625391541,
              -29.171798796071826
            ],
            [
              -50.09602293758614,
              -29.173311883140897
            ],
            [
              -50.09729786106786,
              -29.17399277232198
            ],
            [
              -50.09380362634019,
              -29.17611109421868
            ],
            [
              -50.09337865184629,
              -29.177813317171385
            ],
            [
              -50.093992503893034,
              -29.178418551999016
            ],
            [
              -50.09819502944388,
              -29.18049904671899
            ],
            [
              -50.0974867386207,
              -29.180915145662983
            ],
            [
              -50.095078549821906,
              -29.180082947774995
            ],
            [
              -50.09120655998855,
              -29.179818157537905
            ],
            [
              -50.09040383038895,
              -29.180082947774995
            ],
            [
              -50.090923243659276,
              -29.18189865225788
            ],
            [
              -50.089223345683656,
              -29.182314751201876
            ],
            [
              -50.08761788648446,
              -29.183714356740765
            ],
            [
              -50.0886094936369,
              -29.18590833299092
            ],
            [
              -50.08851505486048,
              -29.187005321115997
            ],
            [
              -50.08672071810843,
              -29.18791317335744
            ],
            [
              -50.08681515688486,
              -29.189388433249785
            ],
            [
              -50.08931778446008,
              -29.190712384435223
            ],
            [
              -50.09158431509424,
              -29.19298201503883
            ],
            [
              -50.09200928958815,
              -29.194911201051898
            ],
            [
              -50.088798371189746,
              -29.191506755146484
            ],
            [
              -50.08709847321413,
              -29.191506755146484
            ],
            [
              -50.08539857523851,
              -29.193587249866457
            ],
            [
              -50.08809008036658,
              -29.194684237991535
            ],
            [
              -50.08960110078935,
              -29.196386460944243
            ],
            [
              -50.0910176824357,
              -29.19721865883223
            ],
            [
              -50.095078549821906,
              -29.198618264371124
            ],
            [
              -50.09692010596216,
              -29.200282660147103
            ],
            [
              -50.09432303961052,
              -29.200509623207463
            ],
            [
              -50.09380362634019,
              -29.20111485803509
            ],
            [
              -50.09040383038895,
              -29.201303993918724
            ],
            [
              -50.08988441711862,
              -29.200282660147103
            ],
            [
              -50.086201304838106,
              -29.198504782840942
            ],
            [
              -50.08539857523851,
              -29.1997152524962
            ],
            [
              -50.08568189156777,
              -29.202703599457617
            ],
            [
              -50.08502082013281,
              -29.20501105723795
            ],
            [
              -50.085209697685656,
              -29.206183699716483
            ],
            [
              -50.08629574361453,
              -29.20750765090192
            ],
            [
              -50.08827895791942,
              -29.208718120557176
            ],
            [
              -50.09012051405968,
              -29.210609479393515
            ],
            [
              -50.09049826916537,
              -29.211895603402226
            ],
            [
              -50.08950666201292,
              -29.212500838229857
            ],
            [
              -50.09238704469384,
              -29.21658617331635
            ],
            [
              -50.08931778446008,
              -29.215791802605086
            ],
            [
              -50.09158431509424,
              -29.21881797674323
            ],
            [
              -50.09012051405968,
              -29.21870449521305
            ],
            [
              -50.08601242728526,
              -29.214694814480012
            ],
            [
              -50.083981993592154,
              -29.21378696223857
            ],
            [
              -50.07708796291325,
              -29.215716148251634
            ],
            [
              -50.07401870267948,
              -29.215791802605086
            ],
            [
              -50.06740798832985,
              -29.213597826354935
            ],
            [
              -50.06490536075462,
              -29.2134086904713
            ],
            [
              -50.052722758596005,
              -29.213106073057485
            ],
            [
              -50.05050344735005,
              -29.213900443768747
            ],
            [
              -50.05281719737243,
              -29.21480829601019
            ],
            [
              -50.057680794358234,
              -29.21431654271274
            ],
            [
              -50.067219110776996,
              -29.21458133294983
            ],
            [
              -50.07028837101076,
              -29.2160944200189
            ],
            [
              -50.07411314145591,
              -29.21681313637671
            ],
            [
              -50.07779625373642,
              -29.21658617331635
            ],
            [
              -50.081479366016936,
              -29.215110913424006
            ],
            [
              -50.08379311603931,
              -29.215413530837818
            ],
            [
              -50.085304136462085,
              -29.217002272260345
            ],
            [
              -50.08827895791942,
              -29.223016793359903
            ],
            [
              -50.0889872487426,
              -29.223508546657353
            ],
            [
              -50.087004034437705,
              -29.225210769610058
            ],
            [
              -50.08549301401493,
              -29.224908152196246
            ],
            [
              -50.083981993592154,
              -29.226686029502403
            ],
            [
              -50.084879161968175,
              -29.228085635041296
            ],
            [
              -50.0878067640373,
              -29.22971220364055
            ],
            [
              -50.09111212121212,
              -29.232587069071784
            ],
            [
              -50.09389806511661,
              -29.23391102025722
            ],
            [
              -50.09522020798654,
              -29.237315466162634
            ],
            [
              -50.096211815138986,
              -29.236104996507375
            ],
            [
              -50.09791171311461,
              -29.236104996507375
            ],
            [
              -50.09781727433818,
              -29.234818872498664
            ],
            [
              -50.09540908553939,
              -29.23088484611908
            ],
            [
              -50.09238704469384,
              -29.226799511032585
            ],
            [
              -50.09210372836457,
              -29.225210769610058
            ],
            [
              -50.093614748787346,
              -29.223697682540987
            ],
            [
              -50.09540908553939,
              -29.225210769610058
            ],
            [
              -50.09918663659633,
              -29.22721560997658
            ],
            [
              -50.10168926417155,
              -29.23050657435181
            ],
            [
              -50.10490018256994,
              -29.232587069071784
            ],
            [
              -50.106883396874835,
              -29.23360840284341
            ],
            [
              -50.10848885607403,
              -29.23489452685212
            ],
            [
              -50.11151089691958,
              -29.239206824998973
            ],
            [
              -50.11269138162488,
              -29.238715071701524
            ],
            [
              -50.1111803612021,
              -29.23701284874882
            ],
            [
              -50.11099148364925,
              -29.235197144265932
            ],
            [
              -50.10929158567363,
              -29.233797538727043
            ],
            [
              -50.10792222341549,
              -29.231490080946706
            ],
            [
              -50.105986228498814,
              -29.229409586226733
            ],
            [
              -50.10641120299272,
              -29.22861521551547
            ],
            [
              -50.108913830567936,
              -29.229787857994
            ],
            [
              -50.11108592242567,
              -29.228804351399106
            ],
            [
              -50.11302191734236,
              -29.225286423963514
            ],
            [
              -50.1119830908017,
              -29.22320592924354
            ],
            [
              -50.109810998943956,
              -29.22248721288573
            ],
            [
              -50.10622232543987,
              -29.22449205325225
            ],
            [
              -50.105419595840274,
              -29.225589041377326
            ],
            [
              -50.10168926417155,
              -29.225513387023874
            ],
            [
              -50.097581177397124,
              -29.222411558532276
            ],
            [
              -50.09729786106786,
              -29.221617187821014
            ],
            [
              -50.09862000393778,
              -29.21949886592431
            ],
            [
              -50.093284213069865,
              -29.21280345564367
            ],
            [
              -50.09432303961052,
              -29.212009084932408
            ],
            [
              -50.09739229984428,
              -29.211706467518592
            ],
            [
              -50.0990921978199,
              -29.211214714221146
            ],
            [
              -50.107780565250856,
              -29.210987751160786
            ],
            [
              -50.11108592242567,
              -29.207810268315733
            ],
            [
              -50.11547732552936,
              -29.20879377491063
            ],
            [
              -50.11547732552936,
              -29.20629718124666
            ],
            [
              -50.1135885500009,
              -29.20478409417759
            ],
            [
              -50.116893907175715,
              -29.20501105723795
            ],
            [
              -50.11717722350499,
              -29.205389329005218
            ],
            [
              -50.120718677620864,
              -29.203914069112873
            ],
            [
              -50.11949097352736,
              -29.202590117927436
            ],
            [
              -50.120718677620864,
              -29.20160661133254
            ],
            [
              -50.12440178990138,
              -29.20160661133254
            ],
            [
              -50.125204519500976,
              -29.200207005793647
            ],
            [
              -50.123504621525356,
              -29.1997152524962
            ],
            [
              -50.120482580679806,
              -29.198013029543493
            ],
            [
              -50.123410182748934,
              -29.19771041212968
            ],
            [
              -50.126904417476595,
              -29.197899548013314
            ],
            [
              -50.1293126062754,
              -29.196083843530428
            ],
            [
              -50.12950148382824,
              -29.197899548013314
            ],
            [
              -50.13020977465142,
              -29.198315646957308
            ],
            [
              -50.13299571855591,
              -29.197294313185687
            ],
            [
              -50.13568722368397,
              -29.198504782840942
            ],
            [
              -50.13800097370635,
              -29.197899548013314
            ],
            [
              -50.13828429003562,
              -29.19619732506061
            ],
            [
              -50.1378120961535,
              -29.19370073139664
            ],
            [
              -50.13960643290555,
              -29.192187644327568
            ],
            [
              -50.1402202849523,
              -29.194305966224267
            ],
            [
              -50.14220349925719,
              -29.194608583638082
            ],
            [
              -50.142722912527525,
              -29.19570557176316
            ],
            [
              -50.14560329520844,
              -29.197786066483133
            ],
            [
              -50.147208754407636,
              -29.19771041212968
            ],
            [
              -50.15089186668815,
              -29.19960177096602
            ],
            [
              -50.157785897367056,
              -29.201984883099808
            ],
            [
              -50.159485795342675,
              -29.20361145169906
            ],
            [
              -50.152402887110924,
              -29.201909228746352
            ],
            [
              -50.14900309115968,
              -29.20160661133254
            ],
            [
              -50.14569773398486,
              -29.201795747216174
            ],
            [
              -50.14281735130395,
              -29.201417475448906
            ],
            [
              -50.14069247883442,
              -29.202098364629986
            ],
            [
              -50.14069247883442,
              -29.20421668652669
            ],
            [
              -50.1389925808588,
              -29.20478409417759
            ],
            [
              -50.1402202849523,
              -29.206183699716483
            ],
            [
              -50.139700871681974,
              -29.207318515018287
            ],
            [
              -50.13762321860066,
              -29.206713280190655
            ],
            [
              -50.133987325708354,
              -29.20788592266919
            ],
            [
              -50.136112198177884,
              -29.209701627152075
            ],
            [
              -50.13710380533033,
              -29.21208473928586
            ],
            [
              -50.13691492777748,
              -29.213106073057485
            ],
            [
              -50.135309468578285,
              -29.21408957965238
            ],
            [
              -50.13559278490755,
              -29.215413530837818
            ],
            [
              -50.13837872881204,
              -29.215186567777458
            ],
            [
              -50.13988974923482,
              -29.215489185191274
            ],
            [
              -50.14111745332832,
              -29.216510518962895
            ],
            [
              -50.14338398396249,
              -29.216888790730163
            ],
            [
              -50.143997836009234,
              -29.218212741915604
            ],
            [
              -50.143620080903545,
              -29.21949886592431
            ],
            [
              -50.147019876854785,
              -29.219082766980318
            ],
            [
              -50.148908652383255,
              -29.22108760734684
            ],
            [
              -50.1499002595357,
              -29.224908152196246
            ],
            [
              -50.14640602480804,
              -29.224416398898796
            ],
            [
              -50.146217147255186,
              -29.225589041377326
            ],
            [
              -50.15051411158245,
              -29.226194276204957
            ],
            [
              -50.15122240240563,
              -29.230203956937995
            ],
            [
              -50.14848367788935,
              -29.229182623166373
            ],
            [
              -50.14569773398486,
              -29.228804351399106
            ],
            [
              -50.14069247883442,
              -29.22838825245511
            ],
            [
              -50.14158964721044,
              -29.229787857994
            ],
            [
              -50.14158964721044,
              -29.231981834244156
            ],
            [
              -50.13932311657628,
              -29.231792698360522
            ],
            [
              -50.13988974923482,
              -29.23561324320993
            ],
            [
              -50.14111745332832,
              -29.23829897275753
            ],
            [
              -50.145083881938106,
              -29.24019033159387
            ],
            [
              -50.148011484007235,
              -29.2407955664215
            ],
            [
              -50.15041967280603,
              -29.24268692525784
            ],
            [
              -50.15188347384059,
              -29.243216505732015
            ],
            [
              -50.15528326979184,
              -29.243216505732015
            ],
            [
              -50.15788033614348,
              -29.244313493857092
            ],
            [
              -50.16061906065976,
              -29.24491872868472
            ],
            [
              -50.16557709642199,
              -29.24548613633562
            ],
            [
              -50.172282249548054,
              -29.24688574187451
            ],
            [
              -50.17752360163955,
              -29.248512310473764
            ],
            [
              -50.1769097495928,
              -29.24938233553848
            ],
            [
              -50.17001571891389,
              -29.249495817068663
            ],
            [
              -50.16718255562119,
              -29.249117545301395
            ],
            [
              -50.159910769836586,
              -29.24881492788758
            ],
            [
              -50.15651097388534,
              -29.247717939762502
            ],
            [
              -50.15481107590972,
              -29.24820969305995
            ],
            [
              -50.15750258103779,
              -29.249495817068663
            ],
            [
              -50.15849418819023,
              -29.251084558491186
            ],
            [
              -50.16099681576545,
              -29.251689793318814
            ],
            [
              -50.16208286169432,
              -29.25248416403008
            ],
            [
              -50.160288524942274,
              -29.253316361918067
            ],
            [
              -50.1611856933183,
              -29.254791621810412
            ],
            [
              -50.156322096332495,
              -29.25271112709044
            ],
            [
              -50.154622198356876,
              -29.250403669310103
            ],
            [
              -50.151600157511325,
              -29.24809621152977
            ],
            [
              -50.15018357586497,
              -29.248701446357398
            ],
            [
              -50.14919196871253,
              -29.250290187779925
            ],
            [
              -50.15041967280603,
              -29.252900262974073
            ],
            [
              -50.14999469831213,
              -29.254186386982784
            ],
            [
              -50.14848367788935,
              -29.254413350043144
            ],
            [
              -50.14281735130395,
              -29.25320288038789
            ],
            [
              -50.139700871681974,
              -29.25320288038789
            ],
            [
              -50.13880370330595,
              -29.2535054978017
            ],
            [
              -50.13837872881204,
              -29.255018584870772
            ],
            [
              -50.1402202849523,
              -29.256909943707115
            ],
            [
              -50.14380895845639,
              -29.256909943707115
            ],
            [
              -50.14550885643201,
              -29.25740169700456
            ],
            [
              -50.145319978879165,
              -29.25978480913835
            ],
            [
              -50.146217147255186,
              -29.261713995151418
            ],
            [
              -50.144517249279566,
              -29.26379448987139
            ],
            [
              -50.14201462170435,
              -29.264097107285203
            ],
            [
              -50.139795310458396,
              -29.26651804659572
            ],
            [
              -50.14121189210475,
              -29.26689631836299
            ],
            [
              -50.14390339723281,
              -29.26640456506554
            ],
            [
              -50.145083881938106,
              -29.267501553190616
            ],
            [
              -50.14461168805599,
              -29.270187282738217
            ],
            [
              -50.14300622885679,
              -29.270792517565848
            ],
            [
              -50.14258125436289,
              -29.272002987221104
            ],
            [
              -50.14347842273891,
              -29.27309997534618
            ],
            [
              -50.14347842273891,
              -29.275785704893785
            ],
            [
              -50.14598105031413,
              -29.278584915971567
            ],
            [
              -50.14640602480804,
              -29.27949276821301
            ],
            [
              -50.148908652383255,
              -29.281989361876978
            ],
            [
              -50.150278014641394,
              -29.284485955540948
            ],
            [
              -50.14730319318406,
              -29.283199831532237
            ],
            [
              -50.143620080903545,
              -29.280514101984632
            ],
            [
              -50.14121189210475,
              -29.28021148457082
            ],
            [
              -50.13960643290555,
              -29.281989361876978
            ],
            [
              -50.14371451967997,
              -29.284296819657314
            ],
            [
              -50.14380895845639,
              -29.285885561079837
            ],
            [
              -50.14078691761084,
              -29.286490795907465
            ],
            [
              -50.1410230145519,
              -29.287814747092906
            ],
            [
              -50.14040916250515,
              -29.289706105929245
            ],
            [
              -50.14258125436289,
              -29.290500476640506
            ],
            [
              -50.143620080903545,
              -29.292089218063033
            ],
            [
              -50.144989443161684,
              -29.292505317007027
            ],
            [
              -50.14489500438526,
              -29.293602305132104
            ],
            [
              -50.14338398396249,
              -29.293602305132104
            ],
            [
              -50.1410230145519,
              -29.29261879853721
            ],
            [
              -50.14031472372872,
              -29.29118136582159
            ],
            [
              -50.138709264529524,
              -29.291597464765584
            ],
            [
              -50.13918145841164,
              -29.29318620618811
            ],
            [
              -50.13837872881204,
              -29.293715786662283
            ],
            [
              -50.13682048900106,
              -29.296401516209887
            ],
            [
              -50.1357816624604,
              -29.29719588692115
            ],
            [
              -50.13630107573073,
              -29.298898109873853
            ],
            [
              -50.13290127977949,
              -29.300297715412746
            ],
            [
              -50.134081764484776,
              -29.302189074249085
            ],
            [
              -50.13157913690956,
              -29.303513025434523
            ],
            [
              -50.128698754228644,
              -29.30358867978798
            ],
            [
              -50.13020977465142,
              -29.300600332826562
            ],
            [
              -50.128698754228644,
              -29.299389863171303
            ],
            [
              -50.12832099912295,
              -29.297914603278958
            ],
            [
              -50.13020977465142,
              -29.292013563709578
            ],
            [
              -50.12940704505182,
              -29.2919000821794
            ],
            [
              -50.128793193005066,
              -29.28951697004561
            ],
            [
              -50.13039865220426,
              -29.286982549204915
            ],
            [
              -50.130115335875,
              -29.285809906726385
            ],
            [
              -50.12841543789937,
              -29.28410768377368
            ],
            [
              -50.1277071470762,
              -29.281686744463165
            ],
            [
              -50.126196126653426,
              -29.281308472695894
            ],
            [
              -50.122985208255024,
              -29.281989361876978
            ],
            [
              -50.122276917431854,
              -29.284296819657314
            ],
            [
              -50.12421291234853,
              -29.286112524140197
            ],
            [
              -50.1236934990782,
              -29.287209512265274
            ],
            [
              -50.11939653475093,
              -29.28989524181288
            ],
            [
              -50.11708278472857,
              -29.291786600649218
            ],
            [
              -50.11887712148061,
              -29.293602305132104
            ],
            [
              -50.12001038679769,
              -29.296704133623702
            ],
            [
              -50.11628005512897,
              -29.298898109873853
            ],
            [
              -50.11410796327122,
              -29.29920072728767
            ],
            [
              -50.10570291216954,
              -29.298292875046226
            ],
            [
              -50.105183498899216,
              -29.299389863171303
            ],
            [
              -50.10641120299272,
              -29.30071381435674
            ],
            [
              -50.112502504072026,
              -29.304004778731972
            ],
            [
              -50.112502504072026,
              -29.305782656038133
            ],
            [
              -50.11051928976713,
              -29.305707001684677
            ],
            [
              -50.10570291216954,
              -29.307182261577022
            ],
            [
              -50.10357803970001,
              -29.307409224637382
            ],
            [
              -50.10357803970001,
              -29.309905818301353
            ],
            [
              -50.10168926417155,
              -29.310813670542796
            ],
            [
              -50.09918663659633,
              -29.311418905370424
            ],
            [
              -50.094417478386944,
              -29.31149455972388
            ],
            [
              -50.091489876317816,
              -29.310813670542796
            ],
            [
              -50.08761788648446,
              -29.314596388215474
            ],
            [
              -50.085209697685656,
              -29.314482906685296
            ],
            [
              -50.08582354973241,
              -29.318000834120888
            ],
            [
              -50.087004034437705,
              -29.320497427784854
            ],
            [
              -50.08827895791942,
              -29.32151876155648
            ],
            [
              -50.0886094936369,
              -29.32318315733246
            ],
            [
              -50.08771232526088,
              -29.32431797263426
            ],
            [
              -50.08539857523851,
              -29.32348577474627
            ],
            [
              -50.08379311603931,
              -29.322388786621193
            ],
            [
              -50.079590590488465,
              -29.321216144142664
            ],
            [
              -50.07807957006569,
              -29.32151876155648
            ],
            [
              -50.07831566700675,
              -29.32269140403501
            ],
            [
              -50.076190794537226,
              -29.322615749681557
            ],
            [
              -50.07359372818558,
              -29.321102662612482
            ],
            [
              -50.072177146539225,
              -29.320989181082304
            ],
            [
              -50.07458533533803,
              -29.324393626987714
            ],
            [
              -50.07231880470386,
              -29.32469624440153
            ],
            [
              -50.06731354955342,
              -29.32280488556519
            ],
            [
              -50.0656136515778,
              -29.32280488556519
            ],
            [
              -50.07009949345791,
              -29.32571757817315
            ],
            [
              -50.0744908965616,
              -29.32821417183712
            ],
            [
              -50.0728854373624,
              -29.328289826190574
            ],
            [
              -50.07099666183394,
              -29.329500295845833
            ],
            [
              -50.06849403425871,
              -29.32938681431565
            ],
            [
              -50.06580252913065,
              -29.329008542548383
            ],
            [
              -50.06178888113265,
              -29.327684591362946
            ],
            [
              -50.05820020762856,
              -29.327608937009494
            ],
            [
              -50.05829464640499,
              -29.32999204914328
            ],
            [
              -50.06122224847411,
              -29.331505136212353
            ],
            [
              -50.06301658522616,
              -29.3319968895098
            ],
            [
              -50.064999799531044,
              -29.33328301351851
            ],
            [
              -50.06651081995382,
              -29.33551481694539
            ],
            [
              -50.06018342193345,
              -29.33528785388503
            ],
            [
              -50.05980566682776,
              -29.337103558367918
            ],
            [
              -50.06211941685013,
              -29.33801141060936
            ],
            [
              -50.06509423830747,
              -29.33978928791552
            ],
            [
              -50.06618028423634,
              -29.33910839873444
            ],
            [
              -50.06849403425871,
              -29.342210227226033
            ],
            [
              -50.068021840376595,
              -29.34251284463985
            ],
            [
              -50.06537755463674,
              -29.341604992398405
            ],
            [
              -50.06259161073225,
              -29.34118889345441
            ],
            [
              -50.06018342193345,
              -29.340016250975882
            ],
            [
              -50.05952235049849,
              -29.34118889345441
            ],
            [
              -50.05999454438061,
              -29.34379896864856
            ],
            [
              -50.05820020762856,
              -29.343609832764926
            ],
            [
              -50.05579201882976,
              -29.34141585651477
            ],
            [
              -50.052722758596005,
              -29.339600152031885
            ],
            [
              -50.05088120245575,
              -29.33910839873444
            ],
            [
              -50.04682033506954,
              -29.34039452274315
            ],
            [
              -50.04238171257764,
              -29.344782475243456
            ],
            [
              -50.03850972274428,
              -29.34720341455397
            ],
            [
              -50.0386041615207,
              -29.349813489748122
            ],
            [
              -50.04068181460202,
              -29.3535962074208
            ],
            [
              -50.0410123503195,
              -29.35510929448987
            ],
            [
              -50.04219283502479,
              -29.353217935653532
            ],
            [
              -50.04729252895166,
              -29.35560104778732
            ],
            [
              -50.05291163614885,
              -29.356887171796032
            ],
            [
              -50.06008898315703,
              -29.364793051731933
            ],
            [
              -50.06211941685013,
              -29.363696063606856
            ],
            [
              -50.06339434033185,
              -29.36388519949049
            ],
            [
              -50.065188677083896,
              -29.363090828779224
            ],
            [
              -50.067219110776996,
              -29.36161556888688
            ],
            [
              -50.07000505468149,
              -29.36138860582652
            ],
            [
              -50.07099666183394,
              -29.35998900028763
            ],
            [
              -50.075199187384776,
              -29.358513740395285
            ],
            [
              -50.07557694249047,
              -29.356017146731315
            ],
            [
              -50.07751293740715,
              -29.356017146731315
            ],
            [
              -50.07751293740715,
              -29.354693195545877
            ],
            [
              -50.07628523331365,
              -29.354504059662244
            ],
            [
              -50.077890692512845,
              -29.352612700825905
            ],
            [
              -50.07888229966529,
              -29.35280183670954
            ],
            [
              -50.082282095616534,
              -29.351893984468095
            ],
            [
              -50.08199877928726,
              -29.3509104778732
            ],
            [
              -50.08421809053321,
              -29.349510872334307
            ],
            [
              -50.083179263992555,
              -29.347884303735054
            ],
            [
              -50.08539857523851,
              -29.346787315609976
            ],
            [
              -50.08728735076697,
              -29.346900797140158
            ],
            [
              -50.088184519143,
              -29.34531205571763
            ],
            [
              -50.08591798850883,
              -29.34239936310967
            ],
            [
              -50.08728735076697,
              -29.34190760981222
            ],
            [
              -50.09078158549464,
              -29.34228588157949
            ],
            [
              -50.09158431509424,
              -29.340697140156962
            ],
            [
              -50.09130099876497,
              -29.339486670501707
            ],
            [
              -50.089789978342196,
              -29.337708793195546
            ],
            [
              -50.0886094936369,
              -29.334985236471216
            ],
            [
              -50.08629574361453,
              -29.332791260221065
            ],
            [
              -50.08842061608406,
              -29.33260212433743
            ],
            [
              -50.09210372836457,
              -29.33400172987632
            ],
            [
              -50.09460635593979,
              -29.333812593992686
            ],
            [
              -50.09649513146826,
              -29.334304347290136
            ],
            [
              -50.0990921978199,
              -29.334115211406502
            ],
            [
              -50.101594825395125,
              -29.33271560586761
            ],
            [
              -50.10400301419392,
              -29.334909582117763
            ],
            [
              -50.10660008054556,
              -29.336082224596293
            ],
            [
              -50.108016662191915,
              -29.334682619057403
            ],
            [
              -50.10678895809841,
              -29.33260212433743
            ],
            [
              -50.10560847339312,
              -29.329500295845833
            ],
            [
              -50.10579735094596,
              -29.32798720877676
            ],
            [
              -50.10929158567363,
              -29.329197678432017
            ],
            [
              -50.110708167319984,
              -29.330181185026916
            ],
            [
              -50.11188865202527,
              -29.33010553067346
            ],
            [
              -50.11269138162488,
              -29.32908419690184
            ],
            [
              -50.11231362651918,
              -29.32738197394913
            ],
            [
              -50.1132107948952,
              -29.32681456629823
            ],
            [
              -50.11580786124685,
              -29.327608937009494
            ],
            [
              -50.11618561635254,
              -29.325793232526607
            ],
            [
              -50.11849936637491,
              -29.324091009573902
            ],
            [
              -50.12010482557411,
              -29.32571757817315
            ],
            [
              -50.117885514328165,
              -29.326890220651684
            ],
            [
              -50.11797995310459,
              -29.329008542548383
            ],
            [
              -50.11708278472857,
              -29.330710765501088
            ],
            [
              -50.11760219799889,
              -29.333093877634877
            ],
            [
              -50.11571342247042,
              -29.33400172987632
            ],
            [
              -50.115618983694,
              -29.335098718001397
            ],
            [
              -50.11797995310459,
              -29.336309187656656
            ],
            [
              -50.12019926435054,
              -29.334304347290136
            ],
            [
              -50.122607453149335,
              -29.33521219953158
            ],
            [
              -50.12558227460667,
              -29.335590471298847
            ],
            [
              -50.12737661135871,
              -29.33528785388503
            ],
            [
              -50.12907650933434,
              -29.33638484201011
            ],
            [
              -50.130918065474596,
              -29.33649832354029
            ],
            [
              -50.13370400937909,
              -29.33528785388503
            ],
            [
              -50.13479005530795,
              -29.335401335415213
            ],
            [
              -50.13568722368397,
              -29.33789792907918
            ],
            [
              -50.13719824410675,
              -29.338994917204257
            ],
            [
              -50.14050360128157,
              -29.338503163906807
            ],
            [
              -50.142486815586466,
              -29.33869229979044
            ],
            [
              -50.143620080903545,
              -29.339486670501707
            ],
            [
              -50.146217147255186,
              -29.339297534618073
            ],
            [
              -50.148011484007235,
              -29.340091905329334
            ],
            [
              -50.15098630546457,
              -29.340205386859516
            ],
            [
              -50.15400834631012,
              -29.33910839873444
            ],
            [
              -50.15618043816786,
              -29.33918405308789
            ],
            [
              -50.157219264708516,
              -29.33789792907918
            ],
            [
              -50.15868306574308,
              -29.33910839873444
            ],
            [
              -50.16061906065976,
              -29.33941101614825
            ],
            [
              -50.1619884229179,
              -29.34118889345441
            ],
            [
              -50.163877198446365,
              -29.342096745695855
            ],
            [
              -50.16538821886914,
              -29.343912450178742
            ],
            [
              -50.16652148418622,
              -29.3430045979373
            ],
            [
              -50.167890846444365,
              -29.34429072194601
            ],
            [
              -50.17020459646674,
              -29.34500943830382
            ],
            [
              -50.17360439241798,
              -29.34848953856268
            ],
            [
              -50.17568204549929,
              -29.349889144101574
            ],
            [
              -50.175776484275715,
              -29.350607860459384
            ],
            [
              -50.17360439241798,
              -29.351515712700827
            ],
            [
              -50.1736988311944,
              -29.352915318239717
            ],
            [
              -50.17827911185094,
              -29.354504059662244
            ],
            [
              -50.17889296389769,
              -29.35548756625714
            ],
            [
              -50.178704086344844,
              -29.357908505567654
            ],
            [
              -50.17969569349729,
              -29.359799864403996
            ],
            [
              -50.182292759848934,
              -29.362296458067963
            ],
            [
              -50.18290661189569,
              -29.364717397378477
            ],
            [
              -50.184889826200575,
              -29.365095669145745
            ],
            [
              -50.186117530294084,
              -29.364603915848296
            ],
            [
              -50.184984264977004,
              -29.35949724699018
            ],
            [
              -50.185881433353025,
              -29.35749240662366
            ],
            [
              -50.1886201578693,
              -29.358589394748737
            ],
            [
              -50.1886201578693,
              -29.36021596334799
            ],
            [
              -50.192303270149814,
              -29.36259907548178
            ],
            [
              -50.19471145894861,
              -29.36339344619304
            ],
            [
              -50.19518365283073,
              -29.364603915848296
            ],
            [
              -50.195089214054306,
              -29.366608756214816
            ],
            [
              -50.19570306610106,
              -29.36778139869335
            ],
            [
              -50.199480617157995,
              -29.367894880223528
            ],
            [
              -50.20188880595679,
              -29.36740312692608
            ],
            [
              -50.20368314270884,
              -29.367592262809715
            ],
            [
              -50.20401367842632,
              -29.366306138801004
            ],
            [
              -50.20207768350964,
              -29.364490434318117
            ],
            [
              -50.1991028620523,
              -29.36259907548178
            ],
            [
              -50.199811152875476,
              -29.361691223240335
            ],
            [
              -50.201605489627525,
              -29.36161556888688
            ],
            [
              -50.20628020906048,
              -29.361918186300695
            ],
            [
              -50.20741347437756,
              -29.36138860582652
            ],
            [
              -50.20509972435519,
              -29.358892012162553
            ],
            [
              -50.203305387603145,
              -29.35821112298147
            ],
            [
              -50.204202555979165,
              -29.356508900028764
            ],
            [
              -50.2023137804507,
              -29.35548756625714
            ],
            [
              -50.20188880595679,
              -29.354617541192425
            ],
            [
              -50.1999055916519,
              -29.35431492377861
            ],
            [
              -50.19929173960515,
              -29.352915318239717
            ],
            [
              -50.197214086523836,
              -29.35348272589062
            ],
            [
              -50.194522581395766,
              -29.35238573776554
            ],
            [
              -50.19527809160716,
              -29.348716501623045
            ],
            [
              -50.193294877302264,
              -29.34769516785142
            ],
            [
              -50.19291712219657,
              -29.34629556231253
            ],
            [
              -50.194192045678285,
              -29.344404203476188
            ],
            [
              -50.19348375485511,
              -29.342210227226033
            ],
            [
              -50.19527809160716,
              -29.34141585651477
            ],
            [
              -50.1974974028531,
              -29.341718473928587
            ],
            [
              -50.19740296407668,
              -29.339713633562067
            ],
            [
              -50.198016816123435,
              -29.338805781320623
            ],
            [
              -50.20089719880435,
              -29.339600152031885
            ],
            [
              -50.20179436718037,
              -29.337595311665368
            ],
            [
              -50.2047219692495,
              -29.33869229979044
            ],
            [
              -50.206091331507636,
              -29.33801141060936
            ],
            [
              -50.207696790706834,
              -29.338200546492995
            ],
            [
              -50.20731903560114,
              -29.336309187656656
            ],
            [
              -50.20618577028406,
              -29.334417828820314
            ],
            [
              -50.206894061107235,
              -29.332186025393433
            ],
            [
              -50.20571357640194,
              -29.331013382914904
            ],
            [
              -50.206091331507636,
              -29.330181185026916
            ],
            [
              -50.20911337235319,
              -29.33131600032872
            ],
            [
              -50.21019941828205,
              -29.332904741751243
            ],
            [
              -50.21289092341012,
              -29.334304347290136
            ],
            [
              -50.21369365300972,
              -29.332791260221065
            ],
            [
              -50.21492135710322,
              -29.33400172987632
            ],
            [
              -50.215204673432495,
              -29.336195706126475
            ],
            [
              -50.216101841808516,
              -29.33661180507047
            ],
            [
              -50.21539355098534,
              -29.338805781320623
            ],
            [
              -50.216904571408115,
              -29.340318868389694
            ],
            [
              -50.218698908160164,
              -29.340583658626784
            ],
            [
              -50.22110709695896,
              -29.342210227226033
            ],
            [
              -50.2224764592171,
              -29.341302374984593
            ],
            [
              -50.2224764592171,
              -29.33978928791552
            ],
            [
              -50.22058768368863,
              -29.336800940954102
            ],
            [
              -50.22020992858294,
              -29.334190865759954
            ],
            [
              -50.21888778571301,
              -29.3319968895098
            ],
            [
              -50.217896178560565,
              -29.328895061018205
            ],
            [
              -50.21921832143049,
              -29.32810069030694
            ],
            [
              -50.220493244912205,
              -29.32810069030694
            ],
            [
              -50.2220987041114,
              -29.330786419854544
            ],
            [
              -50.226206790885826,
              -29.334115211406502
            ],
            [
              -50.23088151031878,
              -29.33661180507047
            ],
            [
              -50.23220365318871,
              -29.33649832354029
            ],
            [
              -50.23480071954035,
              -29.33449348317377
            ],
            [
              -50.23650061751598,
              -29.33661180507047
            ],
            [
              -50.2390032450912,
              -29.336990076837736
            ],
            [
              -50.23990041346722,
              -29.335401335415213
            ],
            [
              -50.24188362777211,
              -29.336082224596293
            ],
            [
              -50.24400850024164,
              -29.335098718001397
            ],
            [
              -50.24641668904044,
              -29.332412988453797
            ],
            [
              -50.24929707172135,
              -29.330408148087276
            ],
            [
              -50.24958038805062,
              -29.33211037103998
            ],
            [
              -50.25142194419088,
              -29.334606964703948
            ],
            [
              -50.249722046215254,
              -29.334985236471216
            ],
            [
              -50.24641668904044,
              -29.33941101614825
            ],
            [
              -50.24821102579248,
              -29.340205386859516
            ],
            [
              -50.249816484991676,
              -29.3399027694457
            ],
            [
              -50.249816484991676,
              -29.343912450178742
            ],
            [
              -50.24901375539208,
              -29.345501191601265
            ],
            [
              -50.24660556659328,
              -29.3456903274849
            ],
            [
              -50.24481122984124,
              -29.344706820890003
            ],
            [
              -50.24301689308919,
              -29.344782475243456
            ],
            [
              -50.24041982673755,
              -29.346484698196164
            ],
            [
              -50.23848383182087,
              -29.34629556231253
            ],
            [
              -50.23928656142047,
              -29.348111266795414
            ],
            [
              -50.24108089817251,
              -29.34818692114887
            ],
            [
              -50.24537786249978,
              -29.35041872457575
            ],
            [
              -50.24698332169898,
              -29.35170484858446
            ],
            [
              -50.24278079614813,
              -29.35238573776554
            ],
            [
              -50.23909768386762,
              -29.354693195545877
            ],
            [
              -50.24221416348959,
              -29.35749240662366
            ],
            [
              -50.24339464819489,
              -29.35821112298147
            ],
            [
              -50.24580283699368,
              -29.36161556888688
            ],
            [
              -50.24367796452415,
              -29.362296458067963
            ],
            [
              -50.24079758184324,
              -29.361199469942886
            ],
            [
              -50.2382005154916,
              -29.36161556888688
            ],
            [
              -50.23952265836152,
              -29.365587422443195
            ],
            [
              -50.24108089817251,
              -29.367213991042448
            ],
            [
              -50.24178918899569,
              -29.36880273246497
            ],
            [
              -50.24481122984124,
              -29.37069409130131
            ],
            [
              -50.24811658701606,
              -29.371110190245307
            ],
            [
              -50.2486832196746,
              -29.372585450137652
            ],
            [
              -50.24759717374573,
              -29.37390940132309
            ],
            [
              -50.245094546170506,
              -29.374212018736902
            ],
            [
              -50.2470777604754,
              -29.37591424168961
            ],
            [
              -50.248022148239635,
              -29.377692118995768
            ],
            [
              -50.25000536254453,
              -29.379016070181205
            ],
            [
              -50.249722046215254,
              -29.380302194189916
            ],
            [
              -50.247786051298576,
              -29.380983083371
            ],
            [
              -50.2470777604754,
              -29.382307034556437
            ],
            [
              -50.24518898494693,
              -29.381890935612443
            ],
            [
              -50.24462235228839,
              -29.380907429017547
            ],
            [
              -50.24490566861766,
              -29.378789107120845
            ],
            [
              -50.24141143388999,
              -29.37508204380162
            ],
            [
              -50.238011637938754,
              -29.375006389448167
            ],
            [
              -50.2390032450912,
              -29.37659513087069
            ],
            [
              -50.23829495426802,
              -29.377502983112134
            ],
            [
              -50.23961709713795,
              -29.378297353823395
            ],
            [
              -50.24197806654853,
              -29.378410835353577
            ],
            [
              -50.24188362777211,
              -29.37981044089247
            ],
            [
              -50.23687837262167,
              -29.380188712659738
            ],
            [
              -50.23338413789401,
              -29.37909172453466
            ],
            [
              -50.23158980114196,
              -29.37981044089247
            ],
            [
              -50.23272306645904,
              -29.38321488679788
            ],
            [
              -50.23347857667043,
              -29.38370664009533
            ],
            [
              -50.23300638278831,
              -29.385484517401487
            ],
            [
              -50.23517847464605,
              -29.38839721000945
            ],
            [
              -50.2382005154916,
              -29.386997604470558
            ],
            [
              -50.240278168572914,
              -29.386505851173112
            ],
            [
              -50.24131699511357,
              -29.384690146690225
            ],
            [
              -50.24041982673755,
              -29.38298792373752
            ],
            [
              -50.242308602266014,
              -29.38298792373752
            ],
            [
              -50.24197806654853,
              -29.384084911862598
            ],
            [
              -50.24410293901806,
              -29.384690146690225
            ],
            [
              -50.24311133186561,
              -29.387716320828368
            ],
            [
              -50.24188362777211,
              -29.388813308953445
            ],
            [
              -50.24141143388999,
              -29.39040205037597
            ],
            [
              -50.238011637938754,
              -29.391915137445043
            ],
            [
              -50.237208908339156,
              -29.392482545095945
            ],
            [
              -50.2378227603859,
              -29.394109113695198
            ],
            [
              -50.24008929102007,
              -29.395092620290093
            ],
            [
              -50.237917199162325,
              -29.395811336647903
            ],
            [
              -50.23517847464605,
              -29.39418476804865
            ],
            [
              -50.23088151031878,
              -29.393882150634838
            ],
            [
              -50.22781225008502,
              -29.393087779923572
            ],
            [
              -50.22710395926185,
              -29.391688174384683
            ],
            [
              -50.226017913332974,
              -29.391082939557055
            ],
            [
              -50.22002105103009,
              -29.389418543781076
            ],
            [
              -50.21737676529023,
              -29.390212914492338
            ],
            [
              -50.21671569385527,
              -29.392104273328677
            ],
            [
              -50.21459082138574,
              -29.393314742983936
            ],
            [
              -50.21289092341012,
              -29.393806496281382
            ],
            [
              -50.210482734611325,
              -29.392596026626126
            ],
            [
              -50.209585566235305,
              -29.393087779923572
            ],
            [
              -50.210813270328806,
              -29.39479000287628
            ],
            [
              -50.213976969338994,
              -29.395584373587543
            ],
            [
              -50.213315897904025,
              -29.39879968360932
            ],
            [
              -50.21459082138574,
              -29.40008580761803
            ],
            [
              -50.21851003060731,
              -29.40209064798455
            ],
            [
              -50.22299587248743,
              -29.401788030570735
            ],
            [
              -50.22309031126385,
              -29.403603735053622
            ],
            [
              -50.22181538778214,
              -29.405381612359783
            ],
            [
              -50.21978495408903,
              -29.405797711303777
            ],
            [
              -50.22011548980652,
              -29.40670556354522
            ],
            [
              -50.22309031126385,
              -29.408105169084113
            ],
            [
              -50.22309031126385,
              -29.40939129309282
            ],
            [
              -50.2220987041114,
              -29.40988304639027
            ],
            [
              -50.22077656124148,
              -29.408899539795375
            ],
            [
              -50.21841559183089,
              -29.409807392036818
            ],
            [
              -50.21459082138574,
              -29.410790898631713
            ],
            [
              -50.21171043870483,
              -29.410185663804086
            ],
            [
              -50.21208819381052,
              -29.411509614989523
            ],
            [
              -50.21558242853819,
              -29.41211484981715
            ],
            [
              -50.21647959691421,
              -29.4126066031146
            ],
            [
              -50.22030436735936,
              -29.413287492295684
            ],
            [
              -50.22110709695896,
              -29.41400620865349
            ],
            [
              -50.222382020440676,
              -29.416805419731276
            ],
            [
              -50.22460133168663,
              -29.417410654558903
            ],
            [
              -50.22630122966225,
              -29.416805419731276
            ],
            [
              -50.22998434194276,
              -29.41661628384764
            ],
            [
              -50.232392530741556,
              -29.417599790442537
            ],
            [
              -50.235886765469225,
              -29.416086703373466
            ],
            [
              -50.23310082156473,
              -29.4157084316062
            ],
            [
              -50.23248696951798,
              -29.414800579364755
            ],
            [
              -50.233997989940754,
              -29.413287492295684
            ],
            [
              -50.23631173996313,
              -29.413211837942228
            ],
            [
              -50.239805974690796,
              -29.416389320787278
            ],
            [
              -50.24141143388999,
              -29.41661628384764
            ],
            [
              -50.24301689308919,
              -29.415897567489832
            ],
            [
              -50.24367796452415,
              -29.414914060894933
            ],
            [
              -50.243300209418464,
              -29.413590109709496
            ],
            [
              -50.24481122984124,
              -29.413400973825862
            ],
            [
              -50.24561395944084,
              -29.412303985700785
            ],
            [
              -50.244197377794485,
              -29.410412626864446
            ],
            [
              -50.24400850024164,
              -29.40821865061429
            ],
            [
              -50.246322250264015,
              -29.407310798372848
            ],
            [
              -50.245991714546534,
              -29.40931563873937
            ],
            [
              -50.247219418640036,
              -29.411206997575707
            ],
            [
              -50.24929707172135,
              -29.411017861692073
            ],
            [
              -50.24839990334533,
              -29.415594950076017
            ],
            [
              -50.24740829619288,
              -29.41661628384764
            ],
            [
              -50.24518898494693,
              -29.417599790442537
            ],
            [
              -50.24292245431277,
              -29.419604630809058
            ],
            [
              -50.24367796452415,
              -29.42240384188684
            ],
            [
              -50.24292245431277,
              -29.42308473106792
            ],
            [
              -50.24098645939609,
              -29.423198212598102
            ],
            [
              -50.239805974690796,
              -29.42240384188684
            ],
            [
              -50.238578270597294,
              -29.423387348481736
            ],
            [
              -50.23990041346722,
              -29.424597818136995
            ],
            [
              -50.24079758184324,
              -29.426791794387146
            ],
            [
              -50.237917199162325,
              -29.427888782512223
            ],
            [
              -50.23560344913995,
              -29.428115745572587
            ],
            [
              -50.234422964434664,
              -29.428796634753667
            ],
            [
              -50.23517847464605,
              -29.430385376176194
            ],
            [
              -50.23258140829441,
              -29.431406709947815
            ],
            [
              -50.23102316848342,
              -29.433108932900524
            ],
            [
              -50.23220365318871,
              -29.43458419279287
            ],
            [
              -50.23130648481269,
              -29.43560552656449
            ],
            [
              -50.23031487766024,
              -29.435000291736863
            ],
            [
              -50.22828444396714,
              -29.435416390680857
            ],
            [
              -50.22719839803827,
              -29.43231456218926
            ],
            [
              -50.22422357658093,
              -29.43091495665037
            ],
            [
              -50.22271255615816,
              -29.431406709947815
            ],
            [
              -50.22190982655856,
              -29.432995451370342
            ],
            [
              -50.22309031126385,
              -29.435189427620497
            ],
            [
              -50.22639566843867,
              -29.43950172576735
            ],
            [
              -50.225781816391915,
              -29.44078784977606
            ],
            [
              -50.224081918416296,
              -29.441582220487323
            ],
            [
              -50.2277178113086,
              -29.442490072728766
            ],
            [
              -50.23007878071918,
              -29.442414418375314
            ],
            [
              -50.23140092358911,
              -29.443700542384025
            ],
            [
              -50.223515285757756,
              -29.44388967826766
            ],
            [
              -50.22512074495695,
              -29.449488100423224
            ],
            [
              -50.225309622509805,
              -29.451492940789745
            ],
            [
              -50.22360972453418,
              -29.45081205160866
            ],
            [
              -50.220918219406116,
              -29.445516246866912
            ],
            [
              -50.21832115305447,
              -29.442603554258948
            ],
            [
              -50.21501579587965,
              -29.440485232362246
            ],
            [
              -50.212985362186544,
              -29.441809183547687
            ],
            [
              -50.209916101952786,
              -29.44199831943132
            ],
            [
              -50.20642186722512,
              -29.44150656613387
            ],
            [
              -50.205996892731214,
              -29.442490072728766
            ],
            [
              -50.20731903560114,
              -29.44351140650039
            ],
            [
              -50.210813270328806,
              -29.44460839462547
            ],
            [
              -50.21109658665808,
              -29.44740760570325
            ],
            [
              -50.212182632586945,
              -29.448618075358507
            ],
            [
              -50.21638515813779,
              -29.451492940789745
            ],
            [
              -50.21581852547925,
              -29.452400793031188
            ],
            [
              -50.21208819381052,
              -29.451114669022477
            ],
            [
              -50.209491127458875,
              -29.45168207667338
            ],
            [
              -50.20968000501173,
              -29.456107856350414
            ],
            [
              -50.21010497950563,
              -29.457696597772937
            ],
            [
              -50.21227707136337,
              -29.460117537083455
            ],
            [
              -50.211615999928405,
              -29.460684944734357
            ],
            [
              -50.20788566825968,
              -29.459398820725646
            ],
            [
              -50.20661074477796,
              -29.457015708591857
            ],
            [
              -50.204202555979165,
              -29.454292151867527
            ],
            [
              -50.203305387603145,
              -29.45508652257879
            ],
            [
              -50.20509972435519,
              -29.45709136294531
            ],
            [
              -50.20491084680234,
              -29.459209684842012
            ],
            [
              -50.20528860190804,
              -29.460684944734357
            ],
            [
              -50.206894061107235,
              -29.462198031803428
            ],
            [
              -50.20670518355439,
              -29.462916748161238
            ],
            [
              -50.20368314270884,
              -29.46310588404487
            ],
            [
              -50.20439143353202,
              -29.46651032995028
            ],
            [
              -50.206894061107235,
              -29.470482183506597
            ],
            [
              -50.210813270328806,
              -29.471692653161853
            ],
            [
              -50.21057717338775,
              -29.47290312281711
            ],
            [
              -50.21388253056257,
              -29.474491864239635
            ],
            [
              -50.21548798976177,
              -29.476383223075974
            ],
            [
              -50.21718788773739,
              -29.476307568722522
            ],
            [
              -50.21921832143049,
              -29.477291075317417
            ],
            [
              -50.219596076536185,
              -29.479598533097754
            ],
            [
              -50.218793346936586,
              -29.481489891934093
            ],
            [
              -50.21449638260932,
              -29.477593692731233
            ],
            [
              -50.213410336680454,
              -29.476988457903605
            ],
            [
              -50.2103882958349,
              -29.478009791675227
            ],
            [
              -50.20760235193041,
              -29.477707174261415
            ],
            [
              -50.20547747946088,
              -29.47789631014505
            ],
            [
              -50.201180515133615,
              -29.477593692731233
            ],
            [
              -50.198913984499455,
              -29.478615026502855
            ],
            [
              -50.199480617157995,
              -29.48058203969265
            ],
            [
              -50.200708321251504,
              -29.48281384311953
            ],
            [
              -50.19900842327588,
              -29.484213448658423
            ],
            [
              -50.19759184162953,
              -29.484516066072235
            ],
            [
              -50.19381429057259,
              -29.484289103011875
            ],
            [
              -50.191406101773794,
              -29.485499572667134
            ],
            [
              -50.188997912975,
              -29.488412265275095
            ],
            [
              -50.18748689255222,
              -29.487504413033655
            ],
            [
              -50.188478499704665,
              -29.484213448658423
            ],
            [
              -50.188006305822555,
              -29.483116460533346
            ],
            [
              -50.18640084662335,
              -29.48281384311953
            ],
            [
              -50.18389821904813,
              -29.47891764391667
            ],
            [
              -50.18290661189569,
              -29.477782828614867
            ],
            [
              -50.18120671392006,
              -29.478009791675227
            ],
            [
              -50.17719306592207,
              -29.47679932201997
            ],
            [
              -50.174879315899695,
              -29.476496704606156
            ],
            [
              -50.17190449444236,
              -29.47668584048979
            ],
            [
              -50.17081844851349,
              -29.476383223075974
            ],
            [
              -50.16751309133867,
              -29.47400011094219
            ],
            [
              -50.167796407667936,
              -29.47290312281711
            ],
            [
              -50.166899239291915,
              -29.470293047622963
            ],
            [
              -50.167796407667936,
              -29.46700208324773
            ],
            [
              -50.167890846444365,
              -29.46560247770884
            ],
            [
              -50.16699367806834,
              -29.463597637342318
            ],
            [
              -50.16571875458662,
              -29.463408501458684
            ],
            [
              -50.163877198446365,
              -29.46450548958376
            ],
            [
              -50.16189398414148,
              -29.469082577967704
            ],
            [
              -50.160713499436184,
              -29.470217393269508
            ],
            [
              -50.15731370348494,
              -29.47101176398077
            ],
            [
              -50.155094392238986,
              -29.473394876114558
            ],
            [
              -50.152402887110924,
              -29.473205740230924
            ],
            [
              -50.15098630546457,
              -29.474491864239635
            ],
            [
              -50.151600157511325,
              -29.475815815425072
            ],
            [
              -50.158777504519506,
              -29.47479448165345
            ],
            [
              -50.162177300470745,
              -29.4752862349509
            ],
            [
              -50.16628538724517,
              -29.476610186136337
            ],
            [
              -50.168693576043964,
              -29.47789631014505
            ],
            [
              -50.17502097406433,
              -29.482397744175536
            ],
            [
              -50.17539872917003,
              -29.483192114886798
            ],
            [
              -50.1793179383916,
              -29.487088314089657
            ],
            [
              -50.182292759848934,
              -29.48988752516744
            ],
            [
              -50.17719306592207,
              -29.48920663598636
            ],
            [
              -50.17908184145054,
              -29.490984513292517
            ],
            [
              -50.18191500474324,
              -29.49461592225829
            ],
            [
              -50.18300105067211,
              -29.495485947323008
            ],
            [
              -50.18248163740178,
              -29.496885552861897
            ],
            [
              -50.184417632318464,
              -29.498890393228418
            ],
            [
              -50.18640084662335,
              -29.503505308789087
            ],
            [
              -50.18918679052784,
              -29.50558580350906
            ],
            [
              -50.1881951833754,
              -29.50641800139705
            ],
            [
              -50.18470094864773,
              -29.506607137280685
            ],
            [
              -50.18460650987131,
              -29.509292866828286
            ],
            [
              -50.18389821904813,
              -29.51148684307844
            ],
            [
              -50.18361490271886,
              -29.51421039980277
            ],
            [
              -50.18120671392006,
              -29.516517857583104
            ],
            [
              -50.17950681594444,
              -29.519090105600526
            ],
            [
              -50.176107019993196,
              -29.52200279820849
            ],
            [
              -50.173509953641556,
              -29.52079232855323
            ],
            [
              -50.172282249548054,
              -29.52071667419978
            ],
            [
              -50.17039347401958,
              -29.5232889222172
            ],
            [
              -50.170912887289916,
              -29.527601220364055
            ],
            [
              -50.17081844851349,
              -29.528698208489132
            ],
            [
              -50.16850469849111,
              -29.531610901097096
            ],
            [
              -50.167890846444365,
              -29.53308616098944
            ],
            [
              -50.16798528522079,
              -29.535091001355962
            ],
            [
              -50.17081844851349,
              -29.5333131240498
            ],
            [
              -50.17388770874725,
              -29.533388778403253
            ],
            [
              -50.17502097406433,
              -29.532102654394542
            ],
            [
              -50.17558760672287,
              -29.52990867814439
            ],
            [
              -50.1777124791924,
              -29.532405271808358
            ],
            [
              -50.17941237716802,
              -29.532783543575626
            ],
            [
              -50.18130115269649,
              -29.53251875333854
            ],
            [
              -50.18281217311926,
              -29.53058956732547
            ],
            [
              -50.184984264977004,
              -29.530703048855653
            ],
            [
              -50.184889826200575,
              -29.526995985536427
            ],
            [
              -50.186211969070506,
              -29.524802009286272
            ],
            [
              -50.18928122930427,
              -29.524802009286272
            ],
            [
              -50.19017839768029,
              -29.52400763857501
            ],
            [
              -50.19187829565591,
              -29.520187093725603
            ],
            [
              -50.19258658647909,
              -29.519581858897975
            ],
            [
              -50.195089214054306,
              -29.521813662324856
            ],
            [
              -50.19678911202993,
              -29.52128408185068
            ],
            [
              -50.197780719182376,
              -29.519695340428154
            ],
            [
              -50.197214086523836,
              -29.51689612935037
            ],
            [
              -50.19839457122913,
              -29.516404376052925
            ],
            [
              -50.1999055916519,
              -29.51731222829437
            ],
            [
              -50.20207768350964,
              -29.51761484570818
            ],
            [
              -50.20358870393242,
              -29.518711833833258
            ],
            [
              -50.20788566825968,
              -29.519317068660886
            ],
            [
              -50.2103882958349,
              -29.519014451247074
            ],
            [
              -50.210482734611325,
              -29.51810659900563
            ],
            [
              -50.20731903560114,
              -29.51659351193656
            ],
            [
              -50.21001054072921,
              -29.513907782388955
            ],
            [
              -50.2103882958349,
              -29.515799141225294
            ],
            [
              -50.213504775456876,
              -29.515193906397666
            ],
            [
              -50.21539355098534,
              -29.51371864650532
            ],
            [
              -50.21841559183089,
              -29.51371864650532
            ],
            [
              -50.22002105103009,
              -29.512583831203518
            ],
            [
              -50.22360972453418,
              -29.51220555943625
            ],
            [
              -50.226584545991514,
              -29.512508176850066
            ],
            [
              -50.228803857237466,
              -29.512016423552616
            ],
            [
              -50.23078707154236,
              -29.512508176850066
            ],
            [
              -50.23130648481269,
              -29.511184225664625
            ],
            [
              -50.2261123521094,
              -29.51008723753955
            ],
            [
              -50.224884648015895,
              -29.5095954842421
            ],
            [
              -50.221720949005714,
              -29.506493655750504
            ],
            [
              -50.21987939286546,
              -29.505699285039242
            ],
            [
              -50.216007403032094,
              -29.50490491432798
            ],
            [
              -50.21378809178614,
              -29.50418619797017
            ],
            [
              -50.21180487748125,
              -29.5016896043062
            ],
            [
              -50.21019941828205,
              -29.50040348029749
            ],
            [
              -50.20590245395479,
              -29.498890393228418
            ],
            [
              -50.20439143353202,
              -29.499495628056046
            ],
            [
              -50.20302207127388,
              -29.499117356288778
            ],
            [
              -50.20188880595679,
              -29.497490787689525
            ],
            [
              -50.20018890798117,
              -29.497604269219707
            ],
            [
              -50.199716714099054,
              -29.496015527797184
            ],
            [
              -50.201180515133615,
              -29.49499419402556
            ],
            [
              -50.20321094882672,
              -29.494918539672106
            ],
            [
              -50.20831064275359,
              -29.496091182150636
            ],
            [
              -50.213504775456876,
              -29.496885552861897
            ],
            [
              -50.216007403032094,
              -29.496809898508445
            ],
            [
              -50.21681013263169,
              -29.495902046267002
            ],
            [
              -50.21940719898334,
              -29.495410292969552
            ],
            [
              -50.21940719898334,
              -29.492913699305586
            ],
            [
              -50.22011548980652,
              -29.492800217775404
            ],
            [
              -50.2224764592171,
              -29.49461592225829
            ],
            [
              -50.22389304086345,
              -29.49438895919793
            ],
            [
              -50.224884648015895,
              -29.493216316719398
            ],
            [
              -50.227009520485424,
              -29.492686736245226
            ],
            [
              -50.2285205409082,
              -29.49438895919793
            ],
            [
              -50.229606586837065,
              -29.494691576611743
            ],
            [
              -50.23310082156473,
              -29.493481106956487
            ],
            [
              -50.2357923266928,
              -29.493291971072853
            ],
            [
              -50.23668949506882,
              -29.494918539672106
            ],
            [
              -50.23810607671518,
              -29.49510767555574
            ],
            [
              -50.23961709713795,
              -29.494086341784115
            ],
            [
              -50.24098645939609,
              -29.49389720590048
            ],
            [
              -50.247219418640036,
              -29.49461592225829
            ],
            [
              -50.249816484991676,
              -29.493291971072853
            ],
            [
              -50.250619214591275,
              -29.491400612236514
            ],
            [
              -50.25260242889617,
              -29.491703229650327
            ],
            [
              -50.25260242889617,
              -29.49261108189177
            ],
            [
              -50.250619214591275,
              -29.496318145210996
            ],
            [
              -50.250383117650216,
              -29.499306492172412
            ],
            [
              -50.25179969929657,
              -29.499911727000043
            ],
            [
              -50.254207888095365,
              -29.497604269219707
            ],
            [
              -50.25671051567059,
              -29.496696416978263
            ],
            [
              -50.26067694428037,
              -29.496091182150636
            ],
            [
              -50.262612939197055,
              -29.495183329909192
            ],
            [
              -50.26379342390234,
              -29.493708070016847
            ],
            [
              -50.263982301455194,
              -29.490190142581255
            ],
            [
              -50.26738209740643,
              -29.489509253400172
            ],
            [
              -50.26898755660563,
              -29.49000100669762
            ],
            [
              -50.27021526069914,
              -29.490984513292517
            ],
            [
              -50.2716790617337,
              -29.490795377408883
            ],
            [
              -50.27219847500403,
              -29.489811870813988
            ],
            [
              -50.272623449497935,
              -29.48459172042569
            ],
            [
              -50.27380393420323,
              -29.48360821383079
            ],
            [
              -50.27479554135567,
              -29.484516066072235
            ],
            [
              -50.274087250532496,
              -29.48599132596458
            ],
            [
              -50.27460666380283,
              -29.487807030447467
            ],
            [
              -50.276212123002026,
              -29.489395771869994
            ],
            [
              -50.277014852601624,
              -29.492686736245226
            ],
            [
              -50.27899806690652,
              -29.49499419402556
            ],
            [
              -50.277912020977645,
              -29.50040348029749
            ],
            [
              -50.278903628130095,
              -29.503316172905453
            ],
            [
              -50.27918694445936,
              -29.506493655750504
            ],
            [
              -50.28088684243498,
              -29.506001902453054
            ],
            [
              -50.28490049043298,
              -29.505888420922876
            ],
            [
              -50.28730867923178,
              -29.50641800139705
            ],
            [
              -50.2890085772074,
              -29.506191038336688
            ],
            [
              -50.29089735273587,
              -29.506682791634137
            ],
            [
              -50.292313934382214,
              -29.50641800139705
            ],
            [
              -50.29188895988831,
              -29.50369444467272
            ],
            [
              -50.29321110275824,
              -29.502294839133828
            ],
            [
              -50.29302222520539,
              -29.501008715125117
            ],
            [
              -50.29132232722977,
              -29.49979824546986
            ],
            [
              -50.289811306806996,
              -29.497188170275713
            ],
            [
              -50.289811306806996,
              -29.496015527797184
            ],
            [
              -50.29141676600619,
              -29.494010687430663
            ],
            [
              -50.29481656195744,
              -29.49499419402556
            ],
            [
              -50.29651645993306,
              -29.49510767555574
            ],
            [
              -50.29679977626233,
              -29.494010687430663
            ],
            [
              -50.2954776333924,
              -29.492081501417594
            ],
            [
              -50.295902607886305,
              -29.49000100669762
            ],
            [
              -50.29458046501638,
              -29.488109647861283
            ],
            [
              -50.29439158746353,
              -29.4853104367835
            ],
            [
              -50.29132232722977,
              -29.484894337839503
            ],
            [
              -50.29099179151229,
              -29.483494732300613
            ],
            [
              -50.28962242925415,
              -29.483116460533346
            ],
            [
              -50.287214240455356,
              -29.483910831244607
            ],
            [
              -50.28631707207933,
              -29.48258688005917
            ],
            [
              -50.285892097585425,
              -29.479787668981388
            ],
            [
              -50.28527824553867,
              -29.478501544972676
            ],
            [
              -50.28409776083338,
              -29.478009791675227
            ],
            [
              -50.281500694481736,
              -29.478085446028683
            ],
            [
              -50.279706357729694,
              -29.477593692731233
            ],
            [
              -50.278809189353666,
              -29.47668584048979
            ],
            [
              -50.278478653636185,
              -29.47400011094219
            ],
            [
              -50.27640100055487,
              -29.473810975058555
            ],
            [
              -50.274512225026406,
              -29.475097099067263
            ],
            [
              -50.273992811756074,
              -29.475891469778528
            ],
            [
              -50.27337895970932,
              -29.47940939721412
            ],
            [
              -50.272623449497935,
              -29.479485051567572
            ],
            [
              -50.26950696987596,
              -29.47751803837778
            ],
            [
              -50.268704240276364,
              -29.476610186136337
            ],
            [
              -50.26860980149994,
              -29.473205740230924
            ],
            [
              -50.26931809232312,
              -29.471692653161853
            ],
            [
              -50.26809038822961,
              -29.470217393269508
            ],
            [
              -50.26780707190034,
              -29.468590824670255
            ],
            [
              -50.26681546474789,
              -29.4663968484201
            ],
            [
              -50.26648492903041,
              -29.462803266631056
            ],
            [
              -50.265210005548695,
              -29.46030667296709
            ],
            [
              -50.26648492903041,
              -29.45909620331183
            ],
            [
              -50.26568219943081,
              -29.45731832600567
            ],
            [
              -50.265776638207235,
              -29.454897386695155
            ],
            [
              -50.267098781077166,
              -29.454594769281343
            ],
            [
              -50.267098781077166,
              -29.45641047376423
            ],
            [
              -50.26931809232312,
              -29.459701438139458
            ],
            [
              -50.269601408652385,
              -29.460798426264535
            ],
            [
              -50.26908199538206,
              -29.46348415581214
            ],
            [
              -50.26941253109954,
              -29.465110724411392
            ],
            [
              -50.27271788827436,
              -29.46651032995028
            ],
            [
              -50.2729067658272,
              -29.467796453958993
            ],
            [
              -50.27441778624998,
              -29.468515170316802
            ],
            [
              -50.27498441890852,
              -29.467304700661543
            ],
            [
              -50.27281232705078,
              -29.46450548958376
            ],
            [
              -50.27271788827436,
              -29.462803266631056
            ],
            [
              -50.27479554135567,
              -29.46299240251469
            ],
            [
              -50.285892097585425,
              -29.46560247770884
            ],
            [
              -50.29000018435984,
              -29.46768297242881
            ],
            [
              -50.29221949560579,
              -29.46840168878662
            ],
            [
              -50.29401383235784,
              -29.467418182191725
            ],
            [
              -50.292502811935066,
              -29.465905095122654
            ],
            [
              -50.291511204782616,
              -29.4637111188725
            ],
            [
              -50.287922531278525,
              -29.461403661092167
            ],
            [
              -50.28438107716265,
              -29.45981491966964
            ],
            [
              -50.283389470010206,
              -29.458490968484202
            ],
            [
              -50.28551434247973,
              -29.45830183260057
            ],
            [
              -50.28560878125616,
              -29.457393980359125
            ],
            [
              -50.28310615368093,
              -29.45470825081152
            ],
            [
              -50.28291727612809,
              -29.45398953445371
            ],
            [
              -50.28381444450411,
              -29.45190903973374
            ],
            [
              -50.286789265961445,
              -29.455502621522786
            ],
            [
              -50.28919745476024,
              -29.45720484447549
            ],
            [
              -50.29070847518302,
              -29.45781007930312
            ],
            [
              -50.292502811935066,
              -29.459398820725646
            ],
            [
              -50.2954776333924,
              -29.45958795660928
            ],
            [
              -50.296894215038755,
              -29.458490968484202
            ],
            [
              -50.2970830925916,
              -29.456107856350414
            ],
            [
              -50.29651645993306,
              -29.45470825081152
            ],
            [
              -50.29099179151229,
              -29.44979071783704
            ],
            [
              -50.29070847518302,
              -29.448391112298147
            ],
            [
              -50.288914138430975,
              -29.44600800016436
            ],
            [
              -50.29259725071149,
              -29.446499753461808
            ],
            [
              -50.29358885786393,
              -29.448882865595596
            ],
            [
              -50.29528875583956,
              -29.450282471134486
            ],
            [
              -50.29642202115664,
              -29.449601581953406
            ],
            [
              -50.29651645993306,
              -29.44801284053088
            ],
            [
              -50.29528875583956,
              -29.44600800016436
            ],
            [
              -50.295005439510284,
              -29.442981826026216
            ],
            [
              -50.296280362992,
              -29.441582220487323
            ],
            [
              -50.29840523546153,
              -29.44071219542261
            ],
            [
              -50.29939684261397,
              -29.441582220487323
            ],
            [
              -50.29741362830908,
              -29.443095307556398
            ],
            [
              -50.2970830925916,
              -29.445818864280724
            ],
            [
              -50.29769694463835,
              -29.446386271931626
            ],
            [
              -50.30119117936602,
              -29.4469158524058
            ],
            [
              -50.30279663856522,
              -29.447710223117067
            ],
            [
              -50.30581867941076,
              -29.445213629453097
            ],
            [
              -50.30921847536201,
              -29.44468404897892
            ],
            [
              -50.30987954679697,
              -29.445705382750546
            ],
            [
              -50.31011564373803,
              -29.448882865595596
            ],
            [
              -50.31110725089048,
              -29.449412446069772
            ],
            [
              -50.31327934274822,
              -29.448201976414513
            ],
            [
              -50.314884801947414,
              -29.44528928380655
            ],
            [
              -50.315781970323435,
              -29.444986666392737
            ],
            [
              -50.31568753154701,
              -29.44339792497021
            ],
            [
              -50.31379875601854,
              -29.440598713892427
            ],
            [
              -50.31209885804292,
              -29.43878300940954
            ],
            [
              -50.31110725089048,
              -29.436513378805934
            ],
            [
              -50.31309046519537,
              -29.436702514689568
            ],
            [
              -50.313987633571394,
              -29.438291256112095
            ],
            [
              -50.316112506040916,
              -29.440182614948434
            ],
            [
              -50.31800128156939,
              -29.44101481283642
            ],
            [
              -50.31989005709786,
              -29.441203948720055
            ],
            [
              -50.323998143872274,
              -29.440182614948434
            ],
            [
              -50.324895312248294,
              -29.441582220487323
            ],
            [
              -50.323195414272675,
              -29.442603554258948
            ],
            [
              -50.3224871234495,
              -29.444986666392737
            ],
            [
              -50.323195414272675,
              -29.446499753461808
            ],
            [
              -50.322392684673076,
              -29.447596741586885
            ],
            [
              -50.320503909144605,
              -29.44740760570325
            ],
            [
              -50.31970117954501,
              -29.44918548300941
            ],
            [
              -50.317906842792965,
              -29.451114669022477
            ],
            [
              -50.316584699923034,
              -29.453006027858816
            ],
            [
              -50.316206944817345,
              -29.454783905164977
            ],
            [
              -50.31479036317099,
              -29.45709136294531
            ],
            [
              -50.31568753154701,
              -29.458112696716935
            ],
            [
              -50.31908732749826,
              -29.45781007930312
            ],
            [
              -50.32220380712023,
              -29.458188351070387
            ],
            [
              -50.32517862857757,
              -29.45898272178165
            ],
            [
              -50.32720906227067,
              -29.460911907794717
            ],
            [
              -50.32480087347187,
              -29.461517142622345
            ],
            [
              -50.32140107752063,
              -29.45958795660928
            ],
            [
              -50.31998449587428,
              -29.46030667296709
            ],
            [
              -50.31951230199216,
              -29.462614130747422
            ],
            [
              -50.31800128156939,
              -29.46450548958376
            ],
            [
              -50.31809572034581,
              -29.46700208324773
            ],
            [
              -50.315781970323435,
              -29.469687812795332
            ],
            [
              -50.314884801947414,
              -29.474302728356
            ],
            [
              -50.31512089888847,
              -29.474983617537085
            ],
            [
              -50.31738742952263,
              -29.475097099067263
            ],
            [
              -50.317906842792965,
              -29.47290312281711
            ],
            [
              -50.32040947036818,
              -29.474189246825823
            ],
            [
              -50.32310097549625,
              -29.474302728356
            ],
            [
              -50.324517557142606,
              -29.47619408719234
            ],
            [
              -50.32739793982352,
              -29.477215420963965
            ],
            [
              -50.328720082693444,
              -29.47869068085631
            ],
            [
              -50.33108105210403,
              -29.478312409089042
            ],
            [
              -50.33518913887845,
              -29.479901150511566
            ],
            [
              -50.334008654173154,
              -29.48130075605046
            ],
            [
              -50.33391421539673,
              -29.483192114886798
            ],
            [
              -50.335094700102026,
              -29.485499572667134
            ],
            [
              -50.3374084501244,
              -29.48769354891729
            ],
            [
              -50.34770227675455,
              -29.494313304844475
            ],
            [
              -50.35199924108182,
              -29.49639379956445
            ],
            [
              -50.354312991104194,
              -29.49699903439208
            ],
            [
              -50.35728781256153,
              -29.498701257344784
            ],
            [
              -50.36101814423026,
              -29.499609109586228
            ],
            [
              -50.36300135853514,
              -29.498814738874966
            ],
            [
              -50.36550398611037,
              -29.49851212146115
            ],
            [
              -50.36942319533194,
              -29.498814738874966
            ],
            [
              -50.3708869963665,
              -29.50028999876731
            ],
            [
              -50.37032036370796,
              -29.501311332538933
            ],
            [
              -50.370603680037235,
              -29.503807926202903
            ],
            [
              -50.37518396069377,
              -29.506607137280685
            ],
            [
              -50.377781027045415,
              -29.506682791634137
            ],
            [
              -50.37990589951494,
              -29.508990249414474
            ],
            [
              -50.382408527090156,
              -29.508498496117024
            ],
            [
              -50.3845806189479,
              -29.510503336483545
            ],
            [
              -50.38599720059425,
              -29.509784620125735
            ],
            [
              -50.39057748125079,
              -29.511297707194807
            ],
            [
              -50.39100245574469,
              -29.51209207790607
            ],
            [
              -50.39378839964918,
              -29.513302547561327
            ],
            [
              -50.39647990477725,
              -29.513113411677693
            ],
            [
              -50.39662156294188,
              -29.51489128898385
            ],
            [
              -50.399690823175646,
              -29.515004770514032
            ],
            [
              -50.403893348726484,
              -29.515988277108928
            ],
            [
              -50.40469607832608,
              -29.517917463121996
            ],
            [
              -50.406679292630976,
              -29.518711833833258
            ],
            [
              -50.40989021102938,
              -29.519090105600526
            ],
            [
              -50.411401231452146,
              -29.518409216419446
            ],
            [
              -50.41258171615744,
              -29.519090105600526
            ],
            [
              -50.4144232722977,
              -29.519014451247074
            ],
            [
              -50.41749253253146,
              -29.519581858897975
            ],
            [
              -50.418720236624964,
              -29.518900969716892
            ],
            [
              -50.4192868692835,
              -29.51738788264782
            ],
            [
              -50.42122286420018,
              -29.518295734889264
            ],
            [
              -50.42221447135263,
              -29.51999795784197
            ],
            [
              -50.42188393563515,
              -29.520981464436865
            ],
            [
              -50.42268666523475,
              -29.52249455150594
            ],
            [
              -50.42391436932825,
              -29.52279716891975
            ],
            [
              -50.42481153770427,
              -29.526088133294984
            ],
            [
              -50.42641699690347,
              -29.526806849652793
            ],
            [
              -50.42750304283234,
              -29.528395591075316
            ],
            [
              -50.429722354078294,
              -29.53051391297202
            ],
            [
              -50.42958069591366,
              -29.532783543575626
            ],
            [
              -50.432083323488875,
              -29.53308616098944
            ],
            [
              -50.43260273675921,
              -29.53369139581707
            ],
            [
              -50.43142225205391,
              -29.53618798948104
            ],
            [
              -50.432886053088474,
              -29.537284977606113
            ],
            [
              -50.46112324723908,
              -29.538608928791554
            ],
            [
              -50.53672148776602,
              -29.538798064675188
            ],
            [
              -50.55282329914622,
              -29.538608928791554
            ],
            [
              -50.55480651345111,
              -29.539100682089
            ],
            [
              -50.55697860530885,
              -29.54031115174426
            ],
            [
              -50.558489625731625,
              -29.54231599211078
            ],
            [
              -50.55900903900195,
              -29.54420735094712
            ],
            [
              -50.560283962483666,
              -29.544585622714386
            ],
            [
              -50.56089781453042,
              -29.546401327197273
            ],
            [
              -50.562078299235715,
              -29.5470065620249
            ],
            [
              -50.56561975335159,
              -29.547800932736163
            ],
            [
              -50.57071944727846,
              -29.549994908986317
            ],
            [
              -50.5709083248313,
              -29.551583650408844
            ],
            [
              -50.57218324831302,
              -29.55241584829683
            ],
            [
              -50.57520528915857,
              -29.552983255947733
            ],
            [
              -50.57888840143908,
              -29.552983255947733
            ],
            [
              -50.582288197390326,
              -29.551583650408844
            ],
            [
              -50.58431863108343,
              -29.55211323088302
            ],
            [
              -50.588379498469635,
              -29.552302366766654
            ],
            [
              -50.590079396445255,
              -29.55328587336155
            ],
            [
              -50.59291255973796,
              -29.55290760159428
            ],
            [
              -50.59470689649,
              -29.55211323088302
            ],
            [
              -50.59598181997172,
              -29.552604984180466
            ],
            [
              -50.602403656768516,
              -29.551810613469204
            ],
            [
              -50.60528403944943,
              -29.552718465710647
            ],
            [
              -50.60608676904903,
              -29.554193725602993
            ],
            [
              -50.60821164151855,
              -29.55608508443933
            ],
            [
              -50.610289294599866,
              -29.55729555409459
            ],
            [
              -50.61260304462224,
              -29.556992936680775
            ],
            [
              -50.61581396302064,
              -29.557787307392037
            ],
            [
              -50.61789161610196,
              -29.557598171508403
            ],
            [
              -50.62218858042922,
              -29.558392542219668
            ],
            [
              -50.623085748805245,
              -29.55729555409459
            ],
            [
              -50.62842153967317,
              -29.560510864116367
            ],
            [
              -50.629507585602035,
              -29.5607
            ],
            [
              -50.63087694786017,
              -29.5585816781033
            ],
            [
              -50.65118128479121,
              -29.502483975017462
            ],
            [
              -50.65170069806154,
              -29.503807926202903
            ],
            [
              -50.65472273890709,
              -29.506001902453054
            ],
            [
              -50.66048350426892,
              -29.50630451986687
            ],
            [
              -50.661616769586,
              -29.50441316103053
            ],
            [
              -50.66459159104333,
              -29.501008715125117
            ],
            [
              -50.666810902289285,
              -29.497604269219707
            ],
            [
              -50.666810902289285,
              -29.495599428853186
            ],
            [
              -50.667377534947825,
              -29.494918539672106
            ],
            [
              -50.671202305392974,
              -29.493216316719398
            ],
            [
              -50.672193912545424,
              -29.49189236553396
            ],
            [
              -50.67408268807389,
              -29.487882684800923
            ],
            [
              -50.673988249297466,
              -29.480884657106465
            ],
            [
              -50.67497985644991,
              -29.479295915683938
            ],
            [
              -50.67450766256779,
              -29.478009791675227
            ],
            [
              -50.67497985644991,
              -29.475097099067263
            ],
            [
              -50.67408268807389,
              -29.472108752105846
            ],
            [
              -50.675121514614546,
              -29.471806134692034
            ],
            [
              -50.67710472891944,
              -29.47301660434729
            ],
            [
              -50.679276820777176,
              -29.475097099067263
            ],
            [
              -50.68088227997637,
              -29.47819892755886
            ],
            [
              -50.68371544326908,
              -29.479295915683938
            ],
            [
              -50.68560421879754,
              -29.480884657106465
            ],
            [
              -50.68659582594999,
              -29.482397744175536
            ],
            [
              -50.68810684637277,
              -29.48360821383079
            ],
            [
              -50.68990118312481,
              -29.479787668981388
            ],
            [
              -50.688815137195945,
              -29.476307568722522
            ],
            [
              -50.687823530043495,
              -29.47551319801126
            ],
            [
              -50.68900401474879,
              -29.47400011094219
            ],
            [
              -50.69259268825288,
              -29.471200899864403
            ],
            [
              -50.69301766274678,
              -29.470595665036775
            ],
            [
              -50.69698409135657,
              -29.467304700661543
            ],
            [
              -50.70010057097854,
              -29.466207712536466
            ],
            [
              -50.70288651488303,
              -29.46450548958376
            ],
            [
              -50.705011387352556,
              -29.463900254756133
            ],
            [
              -50.70708904043387,
              -29.462387167687062
            ],
            [
              -50.7079862088099,
              -29.46110104367835
            ],
            [
              -50.7108193721026,
              -29.459398820725646
            ],
            [
              -50.71110268843187,
              -29.45860445001438
            ],
            [
              -50.71521077520629,
              -29.45569175740642
            ],
            [
              -50.71549409153556,
              -29.45520000410897
            ],
            [
              -50.71842169360468,
              -29.45591872046678
            ],
            [
              -50.72087710179169,
              -29.45569175740642
            ],
            [
              -50.722907535484794,
              -29.454103015983893
            ],
            [
              -50.72319085181407,
              -29.4558052389366
            ],
            [
              -50.72408802019009,
              -29.455994374820232
            ],
            [
              -50.72729893858848,
              -29.454292151867527
            ],
            [
              -50.72810166818809,
              -29.453006027858816
            ],
            [
              -50.72640177021246,
              -29.451984694087194
            ],
            [
              -50.726118453883196,
              -29.447710223117067
            ],
            [
              -50.72441855590757,
              -29.44729412417307
            ],
            [
              -50.7237102650844,
              -29.44438143156511
            ],
            [
              -50.72271865793195,
              -29.44351140650039
            ],
            [
              -50.72191592833235,
              -29.441695702017505
            ],
            [
              -50.72078266301527,
              -29.440296096478612
            ],
            [
              -50.71898832626322,
              -29.439312589883716
            ],
            [
              -50.717713402781506,
              -29.4368916505732
            ],
            [
              -50.71270814763107,
              -29.43360068619797
            ],
            [
              -50.7116221017022,
              -29.431784981715083
            ],
            [
              -50.7087889384095,
              -29.4289857706373
            ],
            [
              -50.70619187205785,
              -29.425694806262072
            ],
            [
              -50.705011387352556,
              -29.42478695402063
            ],
            [
              -50.70420865775296,
              -29.420588137403954
            ],
            [
              -50.70458641285865,
              -29.418999395981427
            ],
            [
              -50.702414321000916,
              -29.416389320787278
            ],
            [
              -50.69910896382609,
              -29.414081863006945
            ],
            [
              -50.695000877051676,
              -29.411585269342975
            ],
            [
              -50.68437651470404,
              -29.407689070140115
            ],
            [
              -50.684801489197945,
              -29.406894699428854
            ],
            [
              -50.682204422846304,
              -29.410412626864446
            ],
            [
              -50.680504524870685,
              -29.41461144348112
            ],
            [
              -50.67819077484831,
              -29.415897567489832
            ],
            [
              -50.673893810521044,
              -29.415897567489832
            ],
            [
              -50.671391182945825,
              -29.41990724822287
            ],
            [
              -50.66841636148848,
              -29.418583297037433
            ],
            [
              -50.664922126760814,
              -29.41790240785635
            ],
            [
              -50.66260837673845,
              -29.41790240785635
            ],
            [
              -50.66029462671607,
              -29.41888591445125
            ],
            [
              -50.65968077466932,
              -29.42089075481777
            ],
            [
              -50.65750868281158,
              -29.422101224473025
            ],
            [
              -50.655997662388806,
              -29.419604630809058
            ],
            [
              -50.654108886860335,
              -29.418205025270165
            ],
            [
              -50.649717483756646,
              -29.412001368286973
            ],
            [
              -50.64697875924037,
              -29.411206997575707
            ],
            [
              -50.64527886126475,
              -29.40821865061429
            ],
            [
              -50.64461778982978,
              -29.40598684718741
            ],
            [
              -50.64372062145376,
              -29.39940491843695
            ],
            [
              -50.643909499006604,
              -29.393390397337388
            ],
            [
              -50.64480666738263,
              -29.391688174384683
            ],
            [
              -50.64740373373427,
              -29.389796815548344
            ],
            [
              -50.647498172510694,
              -29.38839721000945
            ],
            [
              -50.645798274535075,
              -29.386808468586924
            ],
            [
              -50.64461778982978,
              -29.38510624563422
            ],
            [
              -50.64461778982978,
              -29.38219355302626
            ],
            [
              -50.64721485618143,
              -29.377994736409583
            ],
            [
              -50.64929250926274,
              -29.375687278629247
            ],
            [
              -50.65250342766114,
              -29.37368243826273
            ],
            [
              -50.65458108074245,
              -29.37341764802564
            ],
            [
              -50.65779199914085,
              -29.37368243826273
            ],
            [
              -50.66171120836242,
              -29.373001549081646
            ],
            [
              -50.66520544309009,
              -29.371110190245307
            ],
            [
              -50.667377534947825,
              -29.370391473887498
            ],
            [
              -50.67030513701695,
              -29.37118584459876
            ],
            [
              -50.67351605541535,
              -29.373985055676542
            ],
            [
              -50.67488541767349,
              -29.374817253564533
            ],
            [
              -50.676018682990566,
              -29.373985055676542
            ],
            [
              -50.67719916769586,
              -29.370996708715126
            ],
            [
              -50.67719916769586,
              -29.366987027982084
            ],
            [
              -50.67738804524871,
              -29.36611700291737
            ],
            [
              -50.680410086094255,
              -29.36528480502938
            ],
            [
              -50.682582177952,
              -29.363696063606856
            ],
            [
              -50.683101591222325,
              -29.361993840654147
            ],
            [
              -50.68239330039915,
              -29.359610728520362
            ],
            [
              -50.67989067282393,
              -29.35700065332621
            ],
            [
              -50.67497985644991,
              -29.35280183670954
            ],
            [
              -50.67488541767349,
              -29.35170484858446
            ],
            [
              -50.676113121766996,
              -29.34898129186013
            ],
            [
              -50.67578258604951,
              -29.34720341455397
            ],
            [
              -50.673988249297466,
              -29.34330721535111
            ],
            [
              -50.673091080921445,
              -29.340583658626784
            ],
            [
              -50.673091080921445,
              -29.338314028023174
            ],
            [
              -50.673988249297466,
              -29.33649832354029
            ],
            [
              -50.67521595339097,
              -29.335590471298847
            ],
            [
              -50.67908794322433,
              -29.334190865759954
            ],
            [
              -50.68201554529345,
              -29.332412988453797
            ],
            [
              -50.68470705042152,
              -29.32961377737601
            ],
            [
              -50.68517924430364,
              -29.327608937009494
            ],
            [
              -50.68631250962072,
              -29.325906714056785
            ],
            [
              -50.68900401474879,
              -29.324091009573902
            ],
            [
              -50.6918843974297,
              -29.32269140403501
            ],
            [
              -50.695803606651275,
              -29.32269140403501
            ],
            [
              -50.69868398933219,
              -29.32420449110408
            ],
            [
              -50.69830623422649,
              -29.327306319595678
            ],
            [
              -50.696795213803725,
              -29.32810069030694
            ],
            [
              -50.69660633625087,
              -29.33010553067346
            ],
            [
              -50.70831674452738,
              -29.334190865759954
            ],
            [
              -50.71148044353756,
              -29.334417828820314
            ],
            [
              -50.7237102650844,
              -29.328289826190574
            ],
            [
              -50.74302299486298,
              -29.327003702181862
            ],
            [
              -50.74481733161503,
              -29.323107502979003
            ],
            [
              -50.74472289283861,
              -29.321291798496116
            ],
            [
              -50.74571449999105,
              -29.319703057073593
            ],
            [
              -50.74708386224919,
              -29.31879520483215
            ],
            [
              -50.74840600511912,
              -29.318681723301967
            ],
            [
              -50.75369457659883,
              -29.316109475284545
            ],
            [
              -50.75709437255007,
              -29.31368853597403
            ],
            [
              -50.759077586854964,
              -29.311418905370424
            ],
            [
              -50.76172187259482,
              -29.308014459465014
            ],
            [
              -50.76139133687734,
              -29.306501372395942
            ],
            [
              -50.762996796076536,
              -29.304118260262154
            ],
            [
              -50.762996796076536,
              -29.302302555779267
            ],
            [
              -50.76191075014767,
              -29.300184233882565
            ],
            [
              -50.76068304605416,
              -29.29708240539097
            ],
            [
              -50.759502561348874,
              -29.29579628138226
            ],
            [
              -50.76021085217205,
              -29.2919000821794
            ],
            [
              -50.75978587767814,
              -29.291105711468134
            ],
            [
              -50.757708224596826,
              -29.290803094054322
            ],
            [
              -50.75690549499723,
              -29.289781760282697
            ],
            [
              -50.75751934704398,
              -29.287701265562724
            ],
            [
              -50.75808597970252,
              -29.28210284340716
            ],
            [
              -50.76068304605416,
              -29.279190150799195
            ],
            [
              -50.761202459324494,
              -29.277298791962856
            ],
            [
              -50.763091234852965,
              -29.27620180383778
            ],
            [
              -50.766018836922086,
              -29.277109656079222
            ],
            [
              -50.77159072473107,
              -29.27559656901015
            ],
            [
              -50.776690418657935,
              -29.275293951596336
            ],
            [
              -50.77829587785713,
              -29.276012667954145
            ],
            [
              -50.77990133705633,
              -29.27828229855775
            ],
            [
              -50.7809873829852,
              -29.27900101491556
            ],
            [
              -50.783395571784,
              -29.27888753338538
            ],
            [
              -50.787598097334836,
              -29.278093162674118
            ],
            [
              -50.79099789328608,
              -29.277185310432674
            ],
            [
              -50.79439768923733,
              -29.277412273493034
            ],
            [
              -50.796805878036125,
              -29.276882693018862
            ],
            [
              -50.79968626071704,
              -29.2751048157127
            ],
            [
              -50.80138615869266,
              -29.272910839462547
            ],
            [
              -50.80190557196299,
              -29.269317257673503
            ],
            [
              -50.80261386278616,
              -29.267312417306982
            ],
            [
              -50.80809131181872,
              -29.265118441056828
            ],
            [
              -50.81219939859314,
              -29.262092266918685
            ],
            [
              -50.81522143943869,
              -29.258006931832192
            ],
            [
              -50.816496362920404,
              -29.25740169700456
            ],
            [
              -50.81829069967245,
              -29.257590832888194
            ],
            [
              -50.8229181997172,
              -29.26061700702634
            ],
            [
              -50.82490141402209,
              -29.26379448987139
            ],
            [
              -50.825704143621685,
              -29.26568584870773
            ],
            [
              -50.82712072526804,
              -29.26591281176809
            ],
            [
              -50.82811233242049,
              -29.264891477996468
            ],
            [
              -50.82792345486764,
              -29.26228140280232
            ],
            [
              -50.8269790671034,
              -29.261411377737602
            ],
            [
              -50.82679018955056,
              -29.259482191724537
            ],
            [
              -50.82778179670301,
              -29.257704314418376
            ],
            [
              -50.83118159265425,
              -29.258082586185644
            ],
            [
              -50.83401475594695,
              -29.259217401487447
            ],
            [
              -50.83562021514615,
              -29.259217401487447
            ],
            [
              -50.83949220497951,
              -29.258006931832192
            ],
            [
              -50.84138098050798,
              -29.258196067715826
            ],
            [
              -50.84341141420108,
              -29.2592930558409
            ],
            [
              -50.844119705024255,
              -29.260806142909974
            ],
            [
              -50.843789169306774,
              -29.264286243168836
            ],
            [
              -50.84449746012995,
              -29.266782836832807
            ],
            [
              -50.845489067282394,
              -29.267312417306982
            ],
            [
              -50.84931383772754,
              -29.26689631836299
            ],
            [
              -50.85101373570316,
              -29.266101947651723
            ],
            [
              -50.85417743471335,
              -29.263189255043763
            ],
            [
              -50.85578289391255,
              -29.259595673254715
            ],
            [
              -50.854791286760104,
              -29.256909943707115
            ],
            [
              -50.85460240920725,
              -29.255018584870772
            ],
            [
              -50.854885725536526,
              -29.252597645560257
            ],
            [
              -50.8563967459593,
              -29.249684952952297
            ],
            [
              -50.859277128640215,
              -29.24760445823232
            ],
            [
              -50.86437682256708,
              -29.249193199654847
            ],
            [
              -50.864801797060984,
              -29.25010105189629
            ],
            [
              -50.86451848073171,
              -29.253694633685335
            ],
            [
              -50.864896235837406,
              -29.25551033816822
            ],
            [
              -50.86711554708336,
              -29.255207720754406
            ],
            [
              -50.86938207771752,
              -29.256191227349305
            ],
            [
              -50.86990149098785,
              -29.256909943707115
            ],
            [
              -50.86919320016467,
              -29.2592930558409
            ],
            [
              -50.86999592976427,
              -29.260995278793608
            ],
            [
              -50.87339572571552,
              -29.262205748448864
            ],
            [
              -50.87552059818504,
              -29.263718835517935
            ],
            [
              -50.87877873597165,
              -29.26769068907425
            ],
            [
              -50.882320190087526,
              -29.270603381682214
            ],
            [
              -50.88189521559362,
              -29.27309997534618
            ],
            [
              -50.88071473088833,
              -29.27559656901015
            ],
            [
              -50.88047863394727,
              -29.279190150799195
            ],
            [
              -50.88161189926435,
              -29.28021148457082
            ],
            [
              -50.88439784316884,
              -29.280589756338088
            ],
            [
              -50.88538945032129,
              -29.28138412704935
            ],
            [
              -50.88609774114447,
              -29.283010695648603
            ],
            [
              -50.888505929943264,
              -29.28501553601512
            ],
            [
              -50.89011138914246,
              -29.287814747092906
            ],
            [
              -50.89200016467093,
              -29.28830650039035
            ],
            [
              -50.89440835346973,
              -29.286906894851462
            ],
            [
              -50.90012189944334,
              -29.286188178493653
            ],
            [
              -50.90451330254703,
              -29.287096030735096
            ],
            [
              -50.908715828097876,
              -29.287209512265274
            ],
            [
              -50.90970743525032,
              -29.287701265562724
            ],
            [
              -50.90989631280317,
              -29.29341316924847
            ],
            [
              -50.909518557697474,
              -29.295115392201176
            ],
            [
              -50.90729924645152,
              -29.30071381435674
            ],
            [
              -50.90748812400437,
              -29.302189074249085
            ],
            [
              -50.908715828097876,
              -29.302907790606895
            ],
            [
              -50.91107679750846,
              -29.303286062374163
            ],
            [
              -50.914004399577586,
              -29.304685667913056
            ],
            [
              -50.91778195063452,
              -29.307900977934832
            ],
            [
              -50.919717945551206,
              -29.308203595348647
            ],
            [
              -50.92179559863252,
              -29.30521524838723
            ],
            [
              -50.92240945067927,
              -29.302189074249085
            ],
            [
              -50.92269276700854,
              -29.298406356576407
            ],
            [
              -50.923684374160985,
              -29.295909762912437
            ],
            [
              -50.92661197623011,
              -29.29019785922669
            ],
            [
              -50.93072006300453,
              -29.286604277437647
            ],
            [
              -50.933883762014716,
              -29.28550728931257
            ],
            [
              -50.937708532459865,
              -29.284599437071126
            ],
            [
              -50.93959730798833,
              -29.28350244894605
            ],
            [
              -50.94181661923428,
              -29.28350244894605
            ],
            [
              -50.94261934883388,
              -29.284599437071126
            ],
            [
              -50.942997103939575,
              -29.28679341332128
            ],
            [
              -50.944885879468046,
              -29.28800388297654
            ],
            [
              -50.94701075193757,
              -29.287814747092906
            ],
            [
              -50.949513379512794,
              -29.289100871101617
            ],
            [
              -50.94899396624246,
              -29.290500476640506
            ],
            [
              -50.94748294581969,
              -29.292391835476845
            ],
            [
              -50.946821874384725,
              -29.294094058429554
            ],
            [
              -50.94668021622009,
              -29.297611985865146
            ],
            [
              -50.94719962949042,
              -29.29999509799893
            ],
            [
              -50.94800235909002,
              -29.301281222007642
            ],
            [
              -50.951213277488414,
              -29.302605173193083
            ],
            [
              -50.952110445864434,
              -29.304004778731972
            ],
            [
              -50.95192156831159,
              -29.306501372395942
            ],
            [
              -50.95059942544166,
              -29.308695348646093
            ],
            [
              -50.948616211136766,
              -29.310397571598802
            ],
            [
              -50.94889952746604,
              -29.3125158934955
            ],
            [
              -50.95088274177093,
              -29.313310264206763
            ],
            [
              -50.95310205301688,
              -29.312099794551507
            ],
            [
              -50.95687960407382,
              -29.306803989809755
            ],
            [
              -50.95829618572017,
              -29.306009619098493
            ],
            [
              -50.96150710411857,
              -29.306501372395942
            ],
            [
              -50.96358475719988,
              -29.30589613756831
            ],
            [
              -50.96509577762266,
              -29.3046100135596
            ],
            [
              -50.96660679804543,
              -29.30241603730945
            ],
            [
              -50.96821225724463,
              -29.299011591404035
            ],
            [
              -50.96958161950277,
              -29.297611985865146
            ],
            [
              -50.972792537901164,
              -29.297611985865146
            ],
            [
              -50.97439799710036,
              -29.29870897399022
            ],
            [
              -50.97690062467558,
              -29.301508185068005
            ],
            [
              -50.97959212980365,
              -29.303286062374163
            ],
            [
              -50.98440850740124,
              -29.304004778731972
            ],
            [
              -50.98629728292971,
              -29.305404384270865
            ],
            [
              -50.98728889008216,
              -29.306917471339936
            ],
            [
              -50.98809161968176,
              -29.309187101943543
            ],
            [
              -50.987713864576065,
              -29.311191942310064
            ],
            [
              -50.986486160482556,
              -29.3125158934955
            ],
            [
              -50.98521123700084,
              -29.31539075892674
            ],
            [
              -50.98478626250694,
              -29.318114315651066
            ],
            [
              -50.98540011455369,
              -29.32080004519867
            ],
            [
              -50.98719445130573,
              -29.320610909315036
            ],
            [
              -50.991302538080156,
              -29.31701732752599
            ],
            [
              -51.00107695143998,
              -29.317509080823438
            ],
            [
              -50.99692164527735,
              -29.31179717713769
            ],
            [
              -50.99630779323059,
              -29.306690508279576
            ],
            [
              -50.99810212998264,
              -29.304307396145788
            ],
            [
              -51.002115777980634,
              -29.304118260262154
            ],
            [
              -51.007498788236774,
              -29.308090113818466
            ],
            [
              -51.010095854588414,
              -29.307787496404654
            ],
            [
              -51.01170131378761,
              -29.303286062374163
            ],
            [
              -51.014015063809985,
              -29.301508185068005
            ],
            [
              -51.02530049759258,
              -29.298103739162592
            ],
            [
              -51.03068350784872,
              -29.293715786662283
            ],
            [
              -51.03228896704792,
              -29.294283194313188
            ],
            [
              -51.038616365068286,
              -29.301583839421458
            ],
            [
              -51.049099069251284,
              -29.307711842051198
            ],
            [
              -51.05471817644848,
              -29.301810802481818
            ],
            [
              -51.06992281945265,
              -29.291710946295765
            ],
            [
              -51.07440866133276,
              -29.292013563709578
            ],
            [
              -51.088621697184486,
              -29.2909165755845
            ],
            [
              -51.090982666595075,
              -29.292997070304477
            ],
            [
              -51.092210370688576,
              -29.297006751037515
            ],
            [
              -51.09202149313573,
              -29.304912630973416
            ],
            [
              -51.094901875816646,
              -29.307787496404654
            ],
            [
              -51.094712998263795,
              -29.310889324896248
            ],
            [
              -51.09669621256869,
              -29.3125158934955
            ],
            [
              -51.09981269219066,
              -29.31758473517689
            ],
            [
              -51.102315319765886,
              -29.317698216707072
            ],
            [
              -51.112892462725306,
              -29.30911144759009
            ],
            [
              -51.11600894234728,
              -29.307787496404654
            ],
            [
              -51.118983763804614,
              -29.308317076878826
            ],
            [
              -51.12148639137984,
              -29.310700189012614
            ],
            [
              -51.122997411802615,
              -29.312705029379135
            ],
            [
              -51.12601945264816,
              -29.313915499034394
            ],
            [
              -51.126916621024186,
              -29.315806857870733
            ],
            [
              -51.12701105980061,
              -29.32341012039282
            ],
            [
              -51.130316416975425,
              -29.32870592513457
            ],
            [
              -51.13399952925594,
              -29.33260212433743
            ],
            [
              -51.13687991193685,
              -29.338805781320623
            ],
            [
              -51.14197960586372,
              -29.34239936310967
            ],
            [
              -51.144576672215365,
              -29.341491510868227
            ],
            [
              -51.145379401814964,
              -29.33861664543699
            ],
            [
              -51.14698486101416,
              -29.3372170398981
            ],
            [
              -51.15340669781095,
              -29.33600657024284
            ],
            [
              -51.158978585619934,
              -29.33131600032872
            ],
            [
              -51.16048960604271,
              -29.331089037268356
            ],
            [
              -51.1640782795468,
              -29.331807753626165
            ],
            [
              -51.169414070414724,
              -29.33131600032872
            ],
            [
              -51.16979182552041,
              -29.330294666557094
            ],
            [
              -51.1701223612379,
              -29.32609584994042
            ],
            [
              -51.1741832286241,
              -29.32609584994042
            ],
            [
              -51.176921953140386,
              -29.325793232526607
            ],
            [
              -51.17881072866885,
              -29.324998861815345
            ],
            [
              -51.18051062664448,
              -29.3262093314706
            ],
            [
              -51.18107725930302,
              -29.32810069030694
            ],
            [
              -51.182682718502214,
              -29.329008542548383
            ],
            [
              -51.18712134099411,
              -29.333888248346142
            ],
            [
              -51.18882123896974,
              -29.33649832354029
            ],
            [
              -51.19037947878072,
              -29.34118889345441
            ],
            [
              -51.19198493797992,
              -29.34368548711838
            ],
            [
              -51.193684835955544,
              -29.344706820890003
            ],
            [
              -51.197415167624264,
              -29.344895956773637
            ],
            [
              -51.19779292272996,
              -29.346106426428896
            ],
            [
              -51.200201111528756,
              -29.34841388420923
            ],
            [
              -51.20048442785803,
              -29.350796996343018
            ],
            [
              -51.20171213195153,
              -29.35280183670954
            ],
            [
              -51.203789785032846,
              -29.35548756625714
            ],
            [
              -51.21077825448818,
              -29.357303270740026
            ],
            [
              -51.21228927491096,
              -29.358589394748737
            ],
            [
              -51.2132808820634,
              -29.357189789209844
            ],
            [
              -51.21927774436629,
              -29.355411911903687
            ],
            [
              -51.219986035189464,
              -29.35159136705428
            ],
            [
              -51.222677540317534,
              -29.349510872334307
            ],
            [
              -51.2241885607403,
              -29.346598179726342
            ],
            [
              -51.227493917915126,
              -29.344215067592554
            ],
            [
              -51.232121417959874,
              -29.344782475243456
            ],
            [
              -51.23311302511232,
              -29.342815462053665
            ],
            [
              -51.23500180064079,
              -29.34330721535111
            ],
            [
              -51.237504428216006,
              -29.341604992398405
            ],
            [
              -51.216491800461796,
              -29.336687459423924
            ],
            [
              -51.25067863752707,
              -29.307711842051198
            ],
            [
              -51.26271958152106,
              -29.295115392201176
            ],
            [
              -51.26668601013085,
              -29.295115392201176
            ],
            [
              -51.27839641840735,
              -29.294888429140816
            ],
            [
              -51.27948246433622,
              -29.296288034679705
            ],
            [
              -51.2798130000537,
              -29.299616826231663
            ],
            [
              -51.27688539798457,
              -29.304193914615606
            ],
            [
              -51.271880142834135,
              -29.30438305049924
            ],
            [
              -51.268291469330045,
              -29.307182261577022
            ],
            [
              -51.26550552542555,
              -29.307484878990838
            ],
            [
              -51.263805627449926,
              -29.308808830176275
            ],
            [
              -51.259886418228355,
              -29.308808830176275
            ],
            [
              -51.25960310189909,
              -29.31051105312898
            ],
            [
              -51.258422617193794,
              -29.31149455972388
            ],
            [
              -51.263805627449926,
              -29.313083301146403
            ],
            [
              -51.26970805097639,
              -29.312818510909317
            ],
            [
              -51.282787821511036,
              -29.318606068948515
            ],
            [
              -51.28580986235659,
              -29.318984340715783
            ],
            [
              -51.29119287261272,
              -29.317811698237254
            ],
            [
              -51.29870075533838,
              -29.31758473517689
            ],
            [
              -51.30148669924287,
              -29.319097822245965
            ],
            [
              -51.30431986253558,
              -29.322994021448824
            ],
            [
              -51.309419556462444,
              -29.32318315733246
            ],
            [
              -51.33652348529596,
              -29.333018223281424
            ],
            [
              -51.35271973545258,
              -29.333093877634877
            ],
            [
              -51.35040598543021,
              -29.34531205571763
            ],
            [
              -51.35050042420663,
              -29.351893984468095
            ],
            [
              -51.3536169038286,
              -29.35170484858446
            ],
            [
              -51.375810016288106,
              -29.35181833011464
            ],
            [
              -51.39809756752403,
              -29.35159136705428
            ],
            [
              -51.481911981599815,
              -29.35121309528701
            ],
            [
              -51.520584660545204,
              -29.3509104778732
            ],
            [
              -51.52181236463871,
              -29.351893984468095
            ],
            [
              -51.52979244124649,
              -29.352007465998273
            ],
            [
              -51.532578385150984,
              -29.350494378929202
            ],
            [
              -51.53390052802091,
              -29.351515712700827
            ],
            [
              -51.535505987220105,
              -29.354504059662244
            ],
            [
              -51.535505987220105,
              -29.355903665201133
            ],
            [
              -51.53781973724248,
              -29.356017146731315
            ],
            [
              -51.539000221947774,
              -29.35510929448987
            ],
            [
              -51.542588895451864,
              -29.355903665201133
            ],
            [
              -51.54660254344986,
              -29.355411911903687
            ],
            [
              -51.55207999248242,
              -29.355411911903687
            ],
            [
              -51.553591012905194,
              -29.356811517442576
            ],
            [
              -51.55661305375074,
              -29.356698035912398
            ],
            [
              -51.55779353845603,
              -29.357189789209844
            ],
            [
              -51.558879584384904,
              -29.358513740395285
            ],
            [
              -51.560579482360524,
              -29.358816357809097
            ],
            [
              -51.56350708442965,
              -29.358097641451288
            ],
            [
              -51.5633182068768,
              -29.368689250934793
            ],
            [
              -51.561098895630856,
              -29.368689250934793
            ],
            [
              -51.56100445685443,
              -29.374212018736902
            ],
            [
              -51.56260991605363,
              -29.375006389448167
            ],
            [
              -51.56709575793374,
              -29.375611624275795
            ],
            [
              -51.56770960998049,
              -29.3778812548794
            ],
            [
              -51.56851233958009,
              -29.378789107120845
            ],
            [
              -51.571912135531335,
              -29.380718293133913
            ],
            [
              -51.57568968658827,
              -29.382382688909892
            ],
            [
              -51.57790899783422,
              -29.382382688909892
            ],
            [
              -51.579420018257,
              -29.381285700784815
            ],
            [
              -51.584378054019226,
              -29.37909172453466
            ],
            [
              -51.58640848771233,
              -29.377011229814688
            ],
            [
              -51.58891111528755,
              -29.375611624275795
            ],
            [
              -51.58999716121642,
              -29.375498142745613
            ],
            [
              -51.593916370437995,
              -29.376216859103423
            ],
            [
              -51.59892162558843,
              -29.3778812548794
            ],
            [
              -51.602793615421795,
              -29.377994736409583
            ],
            [
              -51.60609897259661,
              -29.37859997123721
            ],
            [
              -51.6112931052999,
              -29.37810821793976
            ],
            [
              -51.61681777372067,
              -29.3778812548794
            ],
            [
              -51.61601504412107,
              -29.381815281258987
            ],
            [
              -51.61407904920439,
              -29.383782294448782
            ],
            [
              -51.61398461042797,
              -29.388208074125817
            ],
            [
              -51.6104903757003,
              -29.40080452397584
            ],
            [
              -51.657520886359166,
              -29.39929143690677
            ],
            [
              -51.65860693228803,
              -29.40209064798455
            ],
            [
              -51.664698233367346,
              -29.411017861692073
            ],
            [
              -51.66578427929621,
              -29.414308826067305
            ],
            [
              -51.66951461096494,
              -29.418318506800347
            ],
            [
              -51.68028063147721,
              -29.413400973825862
            ],
            [
              -51.69118831015411,
              -29.423500830011918
            ],
            [
              -51.69118831015411,
              -29.415103196778567
            ],
            [
              -51.69109387137769,
              -29.37141280765912
            ],
            [
              -51.72750001968892,
              -29.3694079672926
            ],
            [
              -51.727877774794614,
              -29.36218297653778
            ],
            [
              -51.72929435644096,
              -29.33941101614825
            ],
            [
              -51.72901104011169,
              -29.334115211406502
            ],
            [
              -51.701907111278175,
              -29.334417828820314
            ],
            [
              -51.701812672501745,
              -29.32420449110408
            ],
            [
              -51.700679407184666,
              -29.322994021448824
            ],
            [
              -51.70610963682901,
              -29.32318315733246
            ],
            [
              -51.70870670318066,
              -29.324507108517896
            ],
            [
              -51.711020453203034,
              -29.324393626987714
            ],
            [
              -51.714703565483546,
              -29.323599256276452
            ],
            [
              -51.71668677978844,
              -29.320913526728848
            ],
            [
              -51.71900052981081,
              -29.32348577474627
            ],
            [
              -51.72041711145716,
              -29.323901873690268
            ],
            [
              -51.7233919329145,
              -29.322502268151375
            ],
            [
              -51.72679172886574,
              -29.324998861815345
            ],
            [
              -51.72901104011169,
              -29.324885380285163
            ],
            [
              -51.72891660133527,
              -29.316185129638
            ],
            [
              -51.72372246863198,
              -29.313802017504212
            ],
            [
              -51.71668677978844,
              -29.313083301146403
            ],
            [
              -51.71399527466037,
              -29.31361288162058
            ],
            [
              -51.70908445828635,
              -29.312591547848953
            ],
            [
              -51.708895580733504,
              -29.30839273123228
            ],
            [
              -51.706204075605434,
              -29.30759836052102
            ],
            [
              -51.70351257047737,
              -29.304988285326868
            ],
            [
              -51.700915504125724,
              -29.304307396145788
            ],
            [
              -51.70610963682901,
              -29.30438305049924
            ],
            [
              -51.709792749109525,
              -29.301583839421458
            ],
            [
              -51.711587085861574,
              -29.304193914615606
            ],
            [
              -51.71319254506077,
              -29.30381564284834
            ],
            [
              -51.715317417530294,
              -29.297006751037515
            ],
            [
              -51.71319254506077,
              -29.294510157373548
            ],
            [
              -51.7254223666076,
              -29.294585811727
            ],
            [
              -51.72509183089012,
              -29.29908724575749
            ],
            [
              -51.726508412536475,
              -29.301583839421458
            ],
            [
              -51.72981376971129,
              -29.300789468710196
            ],
            [
              -51.7342996115914,
              -29.29719588692115
            ],
            [
              -51.73491346363816,
              -29.297385022804782
            ],
            [
              -51.73859657591867,
              -29.299881616468753
            ],
            [
              -51.73661336161378,
              -29.304912630973416
            ],
            [
              -51.737085555495895,
              -29.307295743107204
            ],
            [
              -51.737982723871916,
              -29.307787496404654
            ],
            [
              -51.74119364227031,
              -29.306917471339936
            ],
            [
              -51.743507392292685,
              -29.309187101943543
            ],
            [
              -51.749220938266305,
              -29.3055935201545
            ],
            [
              -51.752809611770395,
              -29.306690508279576
            ],
            [
              -51.75229019850006,
              -29.303286062374163
            ],
            [
              -51.75077917807729,
              -29.300902950240374
            ],
            [
              -51.75479282607529,
              -29.300297715412746
            ],
            [
              -51.76159241797777,
              -29.29530452808481
            ],
            [
              -51.776891499758364,
              -29.29908724575749
            ],
            [
              -51.780007979380336,
              -29.298898109873853
            ],
            [
              -51.79700695913655,
              -29.299389863171303
            ],
            [
              -51.801492801016664,
              -29.25978480913835
            ],
            [
              -51.77561657627665,
              -29.260200908082343
            ],
            [
              -51.77509716300632,
              -29.25271112709044
            ],
            [
              -51.771602928278654,
              -29.25471596745696
            ],
            [
              -51.768203132327415,
              -29.255018584870772
            ],
            [
              -51.76839200988026,
              -29.257590832888194
            ],
            [
              -51.76758928028066,
              -29.25868782101327
            ],
            [
              -51.765181091481864,
              -29.260390043965977
            ],
            [
              -51.75479282607529,
              -29.26061700702634
            ],
            [
              -51.75432063219317,
              -29.22449205325225
            ],
            [
              -51.752809611770395,
              -29.22460553478243
            ],
            [
              -51.7520068821708,
              -29.221692842174466
            ],
            [
              -51.75602053016879,
              -29.221806323704648
            ],
            [
              -51.755501116898465,
              -29.21870449521305
            ],
            [
              -51.7504014229716,
              -29.21768316144143
            ],
            [
              -51.747521040290685,
              -29.218893631096684
            ],
            [
              -51.74690718824393,
              -29.215489185191274
            ],
            [
              -51.74997644847769,
              -29.211706467518592
            ],
            [
              -51.748890402548824,
              -29.210495997863337
            ],
            [
              -51.74997644847769,
              -29.20811288572955
            ],
            [
              -51.75210132094722,
              -29.203914069112873
            ],
            [
              -51.752479076052914,
              -29.199185672022026
            ],
            [
              -51.754178974028534,
              -29.198315646957308
            ],
            [
              -51.75512336179277,
              -29.194381620577722
            ],
            [
              -51.75691769854481,
              -29.19260374327156
            ],
            [
              -51.75682325976839,
              -29.188404926654886
            ],
            [
              -51.75800374447368,
              -29.18518961663311
            ],
            [
              -51.75432063219317,
              -29.186589222172003
            ],
            [
              -51.740107596341446,
              -29.18640008628837
            ],
            [
              -51.73581063201418,
              -29.183714356740765
            ],
            [
              -51.733496881991805,
              -29.18049904671899
            ],
            [
              -51.73378019832108,
              -29.177813317171385
            ],
            [
              -51.738407698365826,
              -29.17198793195546
            ],
            [
              -51.74681274946751,
              -29.164989904261002
            ],
            [
              -51.75649272405091,
              -29.1407048568024
            ],
            [
              -51.756398285274486,
              -29.138889152319514
            ],
            [
              -51.75342346381715,
              -29.13680865759954
            ],
            [
              -51.74870152499597,
              -29.13669517606936
            ],
            [
              -51.73930486674185,
              -29.13790564572462
            ],
            [
              -51.739115989188996,
              -29.13680865759954
            ],
            [
              -51.73717999427232,
              -29.136014286888276
            ],
            [
              -51.7359050707906,
              -29.13291245839668
            ],
            [
              -51.73311912688611,
              -29.130302383202533
            ],
            [
              -51.73208030034545,
              -29.129016259193822
            ],
            [
              -51.734394050367825,
              -29.12538485022805
            ],
            [
              -51.73571619323776,
              -29.122585639150266
            ],
            [
              -51.73902155041257,
              -29.118802921477585
            ],
            [
              -51.74218524942276,
              -29.118689439947406
            ],
            [
              -51.74700162702035,
              -29.11471758639109
            ],
            [
              -51.75219575972364,
              -29.11441496897728
            ],
            [
              -51.75512336179277,
              -29.108400447877717
            ],
            [
              -51.75852315774401,
              -29.103709877963595
            ],
            [
              -51.77958300488643,
              -29.09421525660517
            ],
            [
              -51.80838683169558,
              -29.0816944611086
            ],
            [
              -51.803617673486194,
              -29.065390947939353
            ],
            [
              -51.809000683742326,
              -29.064293959814275
            ],
            [
              -51.80531757146181,
              -29.04568298886469
            ],
            [
              -51.81410037766919,
              -29.014513395241813
            ],
            [
              -51.85159257190929,
              -29.0257858939064
            ],
            [
              -51.849987112710096,
              -29.01871221185849
            ],
            [
              -51.85230086273246,
              -29.01678302584542
            ],
            [
              -51.8685915516655,
              -29.020187471750834
            ],
            [
              -51.868780429218354,
              -29.01738826067305
            ],
            [
              -51.87921591401314,
              -29.01700998890578
            ],
            [
              -51.878790939519234,
              -29.019203965155935
            ],
            [
              -51.91831356745244,
              -29.02291102847516
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "mesorregiao_nome": "Centro Ocidental Rio-grandense",
        "mesorregiao_id": 4303,
        "num_municipios": 31
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -53.26541661077737,
              -29.449312382790378
            ],
            [
              -53.263201527840046,
              -29.44939092949592
            ],
            [
              -53.261619325741954,
              -29.44750580856286
            ],
            [
              -53.25610422128575,
              -29.447780722032263
            ],
            [
              -53.25569736931767,
              -29.448880375909884
            ],
            [
              -53.25388913834843,
              -29.449116016026515
            ],
            [
              -53.2537083152515,
              -29.450215669904136
            ],
            [
              -53.25058911682955,
              -29.450412036667995
            ],
            [
              -53.24909732627992,
              -29.451904424073337
            ],
            [
              -53.24900691473146,
              -29.455910306056094
            ],
            [
              -53.24652059714875,
              -29.45598885276164
            ],
            [
              -53.24561648166413,
              -29.457913247047472
            ],
            [
              -53.2434013987268,
              -29.457481240166977
            ],
            [
              -53.242316460145254,
              -29.457991793753017
            ],
            [
              -53.24019178875639,
              -29.461094388622016
            ],
            [
              -53.235309565139424,
              -29.46529663736863
            ],
            [
              -53.233410922621715,
              -29.464786083782595
            ],
            [
              -53.23142186855554,
              -29.46549300413249
            ],
            [
              -53.2302013126513,
              -29.46470753707705
            ],
            [
              -53.22739855464897,
              -29.46619992448239
            ],
            [
              -53.22690129113243,
              -29.464982450546454
            ],
            [
              -53.224505385098176,
              -29.464982450546454
            ],
            [
              -53.22590676409934,
              -29.466789024773973
            ],
            [
              -53.22509306016318,
              -29.46839923223763
            ],
            [
              -53.22012042499776,
              -29.46710321159615
            ],
            [
              -53.21899028064198,
              -29.46839923223763
            ],
            [
              -53.21338476463732,
              -29.469381066056933
            ],
            [
              -53.2116217394423,
              -29.470598539992867
            ],
            [
              -53.206694310051105,
              -29.468517052295944
            ],
            [
              -53.204388815565316,
              -29.468713419059807
            ],
            [
              -53.20348470008069,
              -29.46659265801011
            ],
            [
              -53.20230934995069,
              -29.46600355771853
            ],
            [
              -53.19977782659374,
              -29.46639629124625
            ],
            [
              -53.19738192055949,
              -29.465689370896353
            ],
            [
              -53.1944887510087,
              -29.467495945123872
            ],
            [
              -53.1923188738456,
              -29.46788867865159
            ],
            [
              -53.18960652739173,
              -29.46710321159615
            ],
            [
              -53.18431745180669,
              -29.467417398418327
            ],
            [
              -53.180113314803194,
              -29.470912726815044
            ],
            [
              -53.13698700618668,
              -29.4947909253005
            ],
            [
              -53.13481712902358,
              -29.49581203247257
            ],
            [
              -53.13088422666547,
              -29.496715319586333
            ],
            [
              -53.12839790908276,
              -29.496401132764156
            ],
            [
              -53.12921161301892,
              -29.498796807283256
            ],
            [
              -53.12618282614543,
              -29.49981791445533
            ],
            [
              -53.12591159150004,
              -29.502488502443835
            ],
            [
              -53.12148142562539,
              -29.503195422793734
            ],
            [
              -53.115604674975344,
              -29.505787464076693
            ],
            [
              -53.09661824979826,
              -29.516391269325165
            ],
            [
              -53.09661824979826,
              -29.520200784544063
            ],
            [
              -53.094810018829016,
              -29.523381926118606
            ],
            [
              -53.095894957410565,
              -29.5247957668184
            ],
            [
              -53.09381549179593,
              -29.528683828742842
            ],
            [
              -53.086582567918946,
              -29.529783482620463
            ],
            [
              -53.084322279207385,
              -29.527309261395818
            ],
            [
              -53.08278528288353,
              -29.52699507457364
            ],
            [
              -53.07690853223348,
              -29.528487461978983
            ],
            [
              -53.07541674168385,
              -29.529508569151055
            ],
            [
              -53.07338248184345,
              -29.5326897107256
            ],
            [
              -53.070398900744195,
              -29.534810471775295
            ],
            [
              -53.070398900744195,
              -29.536499225944496
            ],
            [
              -53.06949478525957,
              -29.53771669988043
            ],
            [
              -53.063798857706445,
              -29.539091267227455
            ],
            [
              -53.061222128575274,
              -29.538187980113698
            ],
            [
              -53.0579221070564,
              -29.54030874116339
            ],
            [
              -53.0516837102125,
              -29.540583654632798
            ],
            [
              -53.03798636062046,
              -29.547417218015145
            ],
            [
              -53.034098664036584,
              -29.550284172767512
            ],
            [
              -53.033013725455035,
              -29.552797667344926
            ],
            [
              -53.02921644041962,
              -29.553190400872648
            ],
            [
              -53.0289,
              -29.554015141280864
            ],
            [
              -53.032878108132344,
              -29.554996975100167
            ],
            [
              -53.03631374697391,
              -29.554486421514127
            ],
            [
              -53.03821238949162,
              -29.55511479515848
            ],
            [
              -53.04029185510625,
              -29.55511479515848
            ],
            [
              -53.043411053528196,
              -29.55358313440037
            ],
            [
              -53.04870012911324,
              -29.554800608336304
            ],
            [
              -53.051096035147495,
              -29.557314102913722
            ],
            [
              -53.052316591051735,
              -29.557981749910848
            ],
            [
              -53.05407961624675,
              -29.559709777432822
            ],
            [
              -53.05629469918408,
              -29.5648153132932
            ],
            [
              -53.056385110732535,
              -29.566896800990122
            ],
            [
              -53.05751525508832,
              -29.56780008810388
            ],
            [
              -53.058102930153325,
              -29.569606662331395
            ],
            [
              -53.0688166986461,
              -29.564618946529336
            ],
            [
              -53.07030848919573,
              -29.56351929265172
            ],
            [
              -53.07288521832691,
              -29.55951341066896
            ],
            [
              -53.075281124361155,
              -29.558806490319064
            ],
            [
              -53.083101723303145,
              -29.558099569969166
            ],
            [
              -53.08789353537165,
              -29.559199223846782
            ],
            [
              -53.093182610956696,
              -29.55821739002748
            ],
            [
              -53.099285390477895,
              -29.55908140378847
            ],
            [
              -53.1013196503183,
              -29.557981749910848
            ],
            [
              -53.10570461041872,
              -29.559002857082923
            ],
            [
              -53.136489742670136,
              -29.55908140378847
            ],
            [
              -53.13671577154129,
              -29.608212368106397
            ],
            [
              -53.14521445709674,
              -29.608212368106397
            ],
            [
              -53.14507883977405,
              -29.612610983616875
            ],
            [
              -53.15050353268179,
              -29.612610983616875
            ],
            [
              -53.150684355778715,
              -29.62651375049821
            ],
            [
              -53.15389396574913,
              -29.62639593043989
            ],
            [
              -53.15411999462028,
              -29.63260112017789
            ],
            [
              -53.1868037693894,
              -29.632012019886304
            ],
            [
              -53.18761747332556,
              -29.669714438547544
            ],
            [
              -53.20389155204877,
              -29.669518071783685
            ],
            [
              -53.204117580919934,
              -29.69331772356359
            ],
            [
              -53.213294353088855,
              -29.701486580940195
            ],
            [
              -53.21279708957231,
              -29.704000075517612
            ],
            [
              -53.21107927015153,
              -29.704785542573052
            ],
            [
              -53.21071762395768,
              -29.70690630362275
            ],
            [
              -53.208186100600734,
              -29.710715818841646
            ],
            [
              -53.20967789115036,
              -29.713111493360746
            ],
            [
              -53.20990392002152,
              -29.719591596568144
            ],
            [
              -53.217995753608896,
              -29.7267000734199
            ],
            [
              -53.22079851161123,
              -29.73058813534434
            ],
            [
              -53.22021083654622,
              -29.734083463741058
            ],
            [
              -53.21691081502735,
              -29.739385366365298
            ],
            [
              -53.21550943602618,
              -29.739306819659753
            ],
            [
              -53.21320394154039,
              -29.740681387006777
            ],
            [
              -53.212616266475386,
              -29.742291594470434
            ],
            [
              -53.2108984470546,
              -29.74331270164251
            ],
            [
              -53.20931624495651,
              -29.745512009397746
            ],
            [
              -53.20990392002152,
              -29.746611663275367
            ],
            [
              -53.20949706805344,
              -29.750303358435946
            ],
            [
              -53.207101162019185,
              -29.752502666191187
            ],
            [
              -53.20728198511611,
              -29.755212527532464
            ],
            [
              -53.208999804536894,
              -29.758786402634726
            ],
            [
              -53.20678472159957,
              -29.761182077153826
            ],
            [
              -53.20289702501569,
              -29.761888997503725
            ],
            [
              -53.20068194207836,
              -29.763813391789558
            ],
            [
              -53.19778877252757,
              -29.76491304566718
            ],
            [
              -53.19259010849099,
              -29.76369557173124
            ],
            [
              -53.19019420245674,
              -29.764284672022825
            ],
            [
              -53.188612000358646,
              -29.765109412431038
            ],
            [
              -53.188205148390566,
              -29.766209066308658
            ],
            [
              -53.18689418093786,
              -29.766012699544795
            ],
            [
              -53.185402390388234,
              -29.766915986658557
            ],
            [
              -53.18278045548283,
              -29.764991592372724
            ],
            [
              -53.17599958934816,
              -29.76349920496738
            ],
            [
              -53.172292715861204,
              -29.76738726689182
            ],
            [
              -53.169309134761946,
              -29.76848692076944
            ],
            [
              -53.17450779879853,
              -29.76970439470538
            ],
            [
              -53.173513271765444,
              -29.770411315055274
            ],
            [
              -53.17179545234466,
              -29.772492802752197
            ],
            [
              -53.16551184972653,
              -29.775399030857336
            ],
            [
              -53.1632967667892,
              -29.777205605084852
            ],
            [
              -53.161081683851876,
              -29.780190379895533
            ],
            [
              -53.16130771272304,
              -29.78290024123681
            ],
            [
              -53.16451732269344,
              -29.78470681546433
            ],
            [
              -53.16560226127499,
              -29.78639556963353
            ],
            [
              -53.165692672823454,
              -29.789301797738666
            ],
            [
              -53.164020059176906,
              -29.79428951354073
            ],
            [
              -53.163794030305745,
              -29.795506987476664
            ],
            [
              -53.16478855733883,
              -29.798099028759623
            ],
            [
              -53.16510499775845,
              -29.800101969751
            ],
            [
              -53.16438170537075,
              -29.802301277506242
            ],
            [
              -53.1632967667892,
              -29.80740681336662
            ],
            [
              -53.16261868017574,
              -29.810116674707896
            ],
            [
              -53.16130771272304,
              -29.812905082754714
            ],
            [
              -53.159318658656865,
              -29.815104390509955
            ],
            [
              -53.157193987268,
              -29.816282591093117
            ],
            [
              -53.152311763651035,
              -29.817696431792914
            ],
            [
              -53.147203511162914,
              -29.819895739548155
            ],
            [
              -53.14241169909442,
              -29.82229141406725
            ],
            [
              -53.13911167757554,
              -29.824412175116947
            ],
            [
              -53.13621850802475,
              -29.82590456252229
            ],
            [
              -53.12970887653546,
              -29.829910444505046
            ],
            [
              -53.12550473953196,
              -29.832306119024146
            ],
            [
              -53.120080046624224,
              -29.835015980365423
            ],
            [
              -53.11809099255805,
              -29.838707675526003
            ],
            [
              -53.11619235004035,
              -29.84161390363114
            ],
            [
              -53.112621093876086,
              -29.84499141196954
            ],
            [
              -53.110993686003766,
              -29.84770127331082
            ],
            [
              -53.10950189545414,
              -29.852217708879614
            ],
            [
              -53.10918545503452,
              -29.855202483690295
            ],
            [
              -53.110179982067606,
              -29.859601099200773
            ],
            [
              -53.11108409755223,
              -29.865806288938767
            ],
            [
              -53.11131012642338,
              -29.86918379727717
            ],
            [
              -53.113299180489555,
              -29.873189679259927
            ],
            [
              -53.11659920200843,
              -29.877391928006546
            ],
            [
              -53.11768414058997,
              -29.88029815611168
            ],
            [
              -53.11867866762306,
              -29.884186218036124
            ],
            [
              -53.11899510804268,
              -29.88768154643284
            ],
            [
              -53.120893750560384,
              -29.89581113045667
            ],
            [
              -53.12080333901193,
              -29.90001337920329
            ],
            [
              -53.1198992235273,
              -29.90429417465545
            ],
            [
              -53.119221136913836,
              -29.912698672148686
            ],
            [
              -53.11958278310768,
              -29.914897979903927
            ],
            [
              -53.1198992235273,
              -29.91980714900044
            ],
            [
              -53.119221136913836,
              -29.922517010341718
            ],
            [
              -53.11750331749305,
              -29.92440213127478
            ],
            [
              -53.114384119071104,
              -29.92679780579388
            ],
            [
              -53.11338959203802,
              -29.927111992616055
            ],
            [
              -53.10801010490451,
              -29.9271905393216
            ],
            [
              -53.103986790997936,
              -29.92699417255774
            ],
            [
              -53.09978265399444,
              -29.927111992616055
            ],
            [
              -53.0944935784094,
              -29.927583272849322
            ],
            [
              -53.093182610956696,
              -29.928093826435358
            ],
            [
              -53.091193556890524,
              -29.93009676742674
            ],
            [
              -53.088481210436655,
              -29.931510608126533
            ],
            [
              -53.08689900833856,
              -29.931706974890396
            ],
            [
              -53.08400583878777,
              -29.930803687776635
            ],
            [
              -53.082288019366985,
              -29.92919348031298
            ],
            [
              -53.08138390388236,
              -29.930489500954458
            ],
            [
              -53.08160993275352,
              -29.931903341654255
            ],
            [
              -53.083101723303145,
              -29.933709915881774
            ],
            [
              -53.08979217788936,
              -29.935712856873153
            ],
            [
              -53.09209767237515,
              -29.937087424220177
            ],
            [
              -53.09381549179593,
              -29.937597977806213
            ],
            [
              -53.09458398995786,
              -29.93861908497829
            ],
            [
              -53.094810018829016,
              -29.94211441337501
            ],
            [
              -53.09648263247557,
              -29.945217008244008
            ],
            [
              -53.0986977154129,
              -29.947416315999245
            ],
            [
              -53.09729633641173,
              -29.94859451658241
            ],
            [
              -53.09688948444365,
              -29.950715277632103
            ],
            [
              -53.098878538509815,
              -29.954210606028823
            ],
            [
              -53.09851689231597,
              -29.956017180256342
            ],
            [
              -53.0958045458621,
              -29.95668482725347
            ],
            [
              -53.0944935784094,
              -29.957784481131085
            ],
            [
              -53.0944935784094,
              -29.958884135008706
            ],
            [
              -53.09621139783018,
              -29.96131908288058
            ],
            [
              -53.095894957410565,
              -29.9624187367582
            ],
            [
              -53.09390590334439,
              -29.962693650227603
            ],
            [
              -53.09169082040707,
              -29.961593996349983
            ],
            [
              -53.089701766340895,
              -29.961593996349983
            ],
            [
              -53.08789353537165,
              -29.963518390635816
            ],
            [
              -53.08879765085627,
              -29.965010778041158
            ],
            [
              -53.090786704922444,
              -29.965914065154916
            ],
            [
              -53.09539769389402,
              -29.967013719032536
            ],
            [
              -53.09661824979826,
              -29.966385345388183
            ],
            [
              -53.096708661346725,
              -29.96430385769126
            ],
            [
              -53.097522365282884,
              -29.9634005705775
            ],
            [
              -53.10027991751098,
              -29.96371475739968
            ],
            [
              -53.10308267551331,
              -29.96599261186046
            ],
            [
              -53.102404588899844,
              -29.9681919196157
            ],
            [
              -53.10348952748139,
              -29.970312680665394
            ],
            [
              -53.10687996054873,
              -29.969998493843217
            ],
            [
              -53.10877860306644,
              -29.970194860607076
            ],
            [
              -53.112078624585315,
              -29.97168724801242
            ],
            [
              -53.11420329597418,
              -29.971883614776278
            ],
            [
              -53.11831702142921,
              -29.971412334543015
            ],
            [
              -53.122882804626556,
              -29.970312680665394
            ],
            [
              -53.12568556262889,
              -29.968309739674016
            ],
            [
              -53.126815706984665,
              -29.96929157349332
            ],
            [
              -53.126680089661974,
              -29.970194860607076
            ],
            [
              -53.12821708598583,
              -29.971412334543015
            ],
            [
              -53.13201437102125,
              -29.973218908770534
            ],
            [
              -53.134093836635884,
              -29.972708355184494
            ],
            [
              -53.13748426970322,
              -29.974593476117555
            ],
            [
              -53.13951852954362,
              -29.976085863522897
            ],
            [
              -53.14028702770555,
              -29.97761752428101
            ],
            [
              -53.1426829337398,
              -29.978795724864174
            ],
            [
              -53.14331581457904,
              -29.980680845797234
            ],
            [
              -53.14629939567829,
              -29.98468672777999
            ],
            [
              -53.14860489016408,
              -29.98350852719683
            ],
            [
              -53.150006269165246,
              -29.983587073902374
            ],
            [
              -53.15091038464987,
              -29.98519728136603
            ],
            [
              -53.15348711378105,
              -29.98449036101613
            ],
            [
              -53.15479808123375,
              -29.98590420171593
            ],
            [
              -53.15710357571954,
              -29.987514409179585
            ],
            [
              -53.15859536626917,
              -29.989281710054332
            ],
            [
              -53.159589893302254,
              -29.992187938159468
            ],
            [
              -53.16017756836725,
              -29.99281631180382
            ],
            [
              -53.16438170537075,
              -29.992502124981645
            ],
            [
              -53.16718446337308,
              -29.9948192527952
            ],
            [
              -53.16831460772886,
              -29.997686207547567
            ],
            [
              -53.16817899040617,
              -29.9996106018334
            ],
            [
              -53.164607734241905,
              -29.999885515302804
            ],
            [
              -53.16438170537075,
              -30.00180990958864
            ],
            [
              -53.16542143817807,
              -30.003498663757842
            ],
            [
              -53.1688118712454,
              -30.00569797151308
            ],
            [
              -53.17138860037658,
              -30.006601258626837
            ],
            [
              -53.17541191428315,
              -30.00699399215456
            ],
            [
              -53.17640644131624,
              -30.0075045457406
            ],
            [
              -53.17690370483278,
              -30.009507486731977
            ],
            [
              -53.17581876625123,
              -30.012099528014936
            ],
            [
              -53.17789823186587,
              -30.013513368714733
            ],
            [
              -53.176994116381245,
              -30.01528066958948
            ],
            [
              -53.17708452792971,
              -30.017401430639172
            ],
            [
              -53.17581876625123,
              -30.018383264458475
            ],
            [
              -53.182509220837446,
              -30.02121094585807
            ],
            [
              -53.18440786335515,
              -30.02101457909421
            ],
            [
              -53.1854928019367,
              -30.02140731262193
            ],
            [
              -53.18571883080786,
              -30.02490264101865
            ],
            [
              -53.18721062135748,
              -30.025216827840826
            ],
            [
              -53.18870241190711,
              -30.02659139518785
            ],
            [
              -53.18919967542365,
              -30.028201602651507
            ],
            [
              -53.1910079063929,
              -30.028201602651507
            ],
            [
              -53.19268052003945,
              -30.02718049547943
            ],
            [
              -53.193177783555996,
              -30.02969399005685
            ],
            [
              -53.19489560297678,
              -30.03421042562564
            ],
            [
              -53.19372025284677,
              -30.036095546558705
            ],
            [
              -53.19218325652291,
              -30.036488280086427
            ],
            [
              -53.19218325652291,
              -30.038805407899982
            ],
            [
              -53.19408189904062,
              -30.04080834889136
            ],
            [
              -53.19471477987985,
              -30.042889836588284
            ],
            [
              -53.20032029588452,
              -30.04281128988274
            ],
            [
              -53.20172167488568,
              -30.041790182710663
            ],
            [
              -53.20502169640456,
              -30.043086203352143
            ],
            [
              -53.208999804536894,
              -30.04988049338172
            ],
            [
              -53.208592952568814,
              -30.053611461895073
            ],
            [
              -53.209406656504974,
              -30.055889316355856
            ],
            [
              -53.21211900295884,
              -30.058402810933273
            ],
            [
              -53.21849301712544,
              -30.060287931866334
            ],
            [
              -53.219894396126605,
              -30.06260505967989
            ],
            [
              -53.220301248094685,
              -30.06519710096285
            ],
            [
              -53.223284829193936,
              -30.06979208323719
            ],
            [
              -53.22427935622702,
              -30.06908516288729
            ],
            [
              -53.22739855464897,
              -30.070695370350947
            ],
            [
              -53.22839308168206,
              -30.069595716473327
            ],
            [
              -53.23038213574823,
              -30.070616823645402
            ],
            [
              -53.230291724199766,
              -30.073601598456086
            ],
            [
              -53.23359174571864,
              -30.075093985861425
            ],
            [
              -53.23630409217251,
              -30.074387065511527
            ],
            [
              -53.237298619205596,
              -30.075604539447465
            ],
            [
              -53.23558079978481,
              -30.07721474691112
            ],
            [
              -53.23499312471981,
              -30.0809064420717
            ],
            [
              -53.236484915269436,
              -30.083380663296346
            ],
            [
              -53.23869999820676,
              -30.08349848335466
            ],
            [
              -53.24010137720793,
              -30.08479450399614
            ],
            [
              -53.23928767327177,
              -30.08609052463762
            ],
            [
              -53.23969452523985,
              -30.088682565920582
            ],
            [
              -53.24181919662871,
              -30.089703673092657
            ],
            [
              -53.24358222182372,
              -30.090017859914834
            ],
            [
              -53.24498360082489,
              -30.090803326970274
            ],
            [
              -53.24670142024567,
              -30.08958585303434
            ],
            [
              -53.249187737828386,
              -30.089114572801073
            ],
            [
              -53.25221652470187,
              -30.090214226678693
            ],
            [
              -53.2537083152515,
              -30.090214226678693
            ],
            [
              -53.255380928898056,
              -30.08938948627048
            ],
            [
              -53.2571891598673,
              -30.090214226678693
            ],
            [
              -53.259991917869634,
              -30.090606960206415
            ],
            [
              -53.26261385277504,
              -30.090489140148097
            ],
            [
              -53.26238782390388,
              -30.09198152755344
            ],
            [
              -53.26410564332467,
              -30.092884814667197
            ],
            [
              -53.26261385277504,
              -30.095398309244615
            ],
            [
              -53.26491934726083,
              -30.096301596358373
            ],
            [
              -53.26600428584237,
              -30.097401250235993
            ],
            [
              -53.26740566484354,
              -30.097087063413817
            ],
            [
              -53.26907827849009,
              -30.098618724171928
            ],
            [
              -53.271202949878955,
              -30.09881509093579
            ],
            [
              -53.27368926746167,
              -30.103881353443395
            ],
            [
              -53.27689887743208,
              -30.103881353443395
            ],
            [
              -53.27879751994979,
              -30.108515609070505
            ],
            [
              -53.280515339370574,
              -30.108515609070505
            ],
            [
              -53.28300165695329,
              -30.11098983029515
            ],
            [
              -53.284990711019454,
              -30.11381751169474
            ],
            [
              -53.28670853044024,
              -30.114406611986322
            ],
            [
              -53.28729620550524,
              -30.117391386797006
            ],
            [
              -53.288607172957946,
              -30.12041543496046
            ],
            [
              -53.2902797866045,
              -30.121318722074218
            ],
            [
              -53.29000855195911,
              -30.122693289421242
            ],
            [
              -53.291997606025284,
              -30.123518029829455
            ],
            [
              -53.29339898502645,
              -30.124617683707076
            ],
            [
              -53.29339898502645,
              -30.1259922510541
            ],
            [
              -53.29461954093069,
              -30.12858429233706
            ],
            [
              -53.29461954093069,
              -30.131411973736654
            ],
            [
              -53.29810038554649,
              -30.131804707264376
            ],
            [
              -53.29819079709495,
              -30.13361128149189
            ],
            [
              -53.300586703129206,
              -30.134593115311198
            ],
            [
              -53.30090314354882,
              -30.13651750959703
            ],
            [
              -53.303299049583075,
              -30.138795364057813
            ],
            [
              -53.31121006007352,
              -30.14091612510751
            ],
            [
              -53.31229499865507,
              -30.143783079859872
            ],
            [
              -53.31830736662781,
              -30.14221214574899
            ],
            [
              -53.3185786012732,
              -30.14331179962661
            ],
            [
              -53.323822471084014,
              -30.147710415137087
            ],
            [
              -53.32490740966556,
              -30.14708204149273
            ],
            [
              -53.326399200215185,
              -30.14818169537035
            ],
            [
              -53.32847866582982,
              -30.148810069014704
            ],
            [
              -53.33001566215368,
              -30.14778896184263
            ],
            [
              -53.33078416031561,
              -30.148417335486982
            ],
            [
              -53.33051292567022,
              -30.153012317761323
            ],
            [
              -53.332592391284855,
              -30.157882213505065
            ],
            [
              -53.3344006222541,
              -30.156900379685762
            ],
            [
              -53.338514347709136,
              -30.158510587149422
            ],
            [
              -53.33950887474222,
              -30.158510587149422
            ],
            [
              -53.34181436922801,
              -30.160592074846342
            ],
            [
              -53.3428088962611,
              -30.162280829015543
            ],
            [
              -53.34032257867838,
              -30.16420522330138
            ],
            [
              -53.33978010938761,
              -30.16828965198968
            ],
            [
              -53.340819842194925,
              -30.169899859453338
            ],
            [
              -53.34199519232494,
              -30.17029259298106
            ],
            [
              -53.346380152425354,
              -30.170214046275515
            ],
            [
              -53.3489116757823,
              -30.170999513330955
            ],
            [
              -53.35099114139693,
              -30.170999513330955
            ],
            [
              -53.35212128575271,
              -30.173002454322337
            ],
            [
              -53.35157881646194,
              -30.175083942019256
            ],
            [
              -53.35248293194656,
              -30.176301415955194
            ],
            [
              -53.35157881646194,
              -30.178382903652118
            ],
            [
              -53.35261854926925,
              -30.18050366470181
            ],
            [
              -53.356596657401596,
              -30.18340989280695
            ],
            [
              -53.35939941540393,
              -30.186316120912085
            ],
            [
              -53.36170490988972,
              -30.185412833798328
            ],
            [
              -53.3626994369228,
              -30.18580556732605
            ],
            [
              -53.3626994369228,
              -30.187494321495247
            ],
            [
              -53.36477890253743,
              -30.188201241845146
            ],
            [
              -53.366315898861295,
              -30.18788705502297
            ],
            [
              -53.36911865686363,
              -30.192403490591765
            ],
            [
              -53.37291594189904,
              -30.194288611524826
            ],
            [
              -53.37368444006097,
              -30.195388265402446
            ],
            [
              -53.376984461579845,
              -30.197705393216
            ],
            [
              -53.378883104097554,
              -30.197783939921546
            ],
            [
              -53.378883104097554,
              -30.199315600679657
            ],
            [
              -53.382499566036046,
              -30.20029743449896
            ],
            [
              -53.382906418004126,
              -30.202810929076378
            ],
            [
              -53.384579031650674,
              -30.203989129659544
            ],
            [
              -53.38308724110105,
              -30.20689535776468
            ],
            [
              -53.38299682955259,
              -30.20929103228378
            ],
            [
              -53.38390094503721,
              -30.210115772691992
            ],
            [
              -53.38530232403838,
              -30.209801585869815
            ],
            [
              -53.390094136106875,
              -30.213100547502673
            ],
            [
              -53.39149551510804,
              -30.211804526861194
            ],
            [
              -53.39488594817538,
              -30.211293973275158
            ],
            [
              -53.39981337756657,
              -30.212315080447233
            ],
            [
              -53.40559971666816,
              -30.209801585869815
            ],
            [
              -53.410979203801666,
              -30.210115772691992
            ],
            [
              -53.41418881377208,
              -30.211490340039017
            ],
            [
              -53.41672033712902,
              -30.21749916301315
            ],
            [
              -53.41658471980633,
              -30.218480996832458
            ],
            [
              -53.41911624316327,
              -30.22170141175977
            ],
            [
              -53.41979432977674,
              -30.230302276016864
            ],
            [
              -53.42078885680983,
              -30.231205563130626
            ],
            [
              -53.42508340536178,
              -30.232894317299827
            ],
            [
              -53.43597799695149,
              -30.238785320215644
            ],
            [
              -53.4420807764727,
              -30.2434981225483
            ],
            [
              -53.446601353895815,
              -30.247896738058778
            ],
            [
              -53.45112193131893,
              -30.250802966163917
            ],
            [
              -53.45401510086972,
              -30.254691028088356
            ],
            [
              -53.456998681968976,
              -30.257597256193492
            ],
            [
              -53.458219237873216,
              -30.260896217826353
            ],
            [
              -53.46219734600556,
              -30.262192238467833
            ],
            [
              -53.46649189455752,
              -30.262310058526147
            ],
            [
              -53.46952068143101,
              -30.26879016173355
            ],
            [
              -53.471419323948716,
              -30.268907981791866
            ],
            [
              -53.472820702949875,
              -30.270086182375028
            ],
            [
              -53.472006999013715,
              -30.270793102724927
            ],
            [
              -53.4730015260468,
              -30.27228549013027
            ],
            [
              -53.472006999013715,
              -30.274798984707683
            ],
            [
              -53.4730015260468,
              -30.27680192569906
            ],
            [
              -53.47318234914373,
              -30.278490679868263
            ],
            [
              -53.471419323948716,
              -30.27931542027648
            ],
            [
              -53.47259467407872,
              -30.281907461559438
            ],
            [
              -53.472413850981795,
              -30.28339984896478
            ],
            [
              -53.473091937595264,
              -30.285716976778335
            ],
            [
              -53.47449331659643,
              -30.286816630655956
            ],
            [
              -53.4764823706626,
              -30.28709154412536
            ],
            [
              -53.478200190083385,
              -30.285913343542195
            ],
            [
              -53.47960156908455,
              -30.28579552348388
            ],
            [
              -53.48018924414956,
              -30.284303136078538
            ],
            [
              -53.48281117905496,
              -30.283714035786957
            ],
            [
              -53.4848906446696,
              -30.284813689664578
            ],
            [
              -53.483986529184975,
              -30.287602097711396
            ],
            [
              -53.48538790818614,
              -30.290390505758218
            ],
            [
              -53.48511667354075,
              -30.292000713221874
            ],
            [
              -53.484122146507666,
              -30.292982547041177
            ],
            [
              -53.484122146507666,
              -30.295299674854736
            ],
            [
              -53.48159062315072,
              -30.296085141910176
            ],
            [
              -53.47869745359993,
              -30.295613861676912
            ],
            [
              -53.47449331659643,
              -30.294514207799292
            ],
            [
              -53.47340837801488,
              -30.293689467391076
            ],
            [
              -53.47069603156101,
              -30.294003654213252
            ],
            [
              -53.47291111449834,
              -30.29710624908225
            ],
            [
              -53.47331796646642,
              -30.298480816429276
            ],
            [
              -53.46450284049135,
              -30.30040521071511
            ],
            [
              -53.46251378642518,
              -30.300994311006693
            ],
            [
              -53.46219734600556,
              -30.302486698412032
            ],
            [
              -53.46450284049135,
              -30.306414033689247
            ],
            [
              -53.46581380794405,
              -30.307906421094586
            ],
            [
              -53.46920424101138,
              -30.30998790879151
            ],
            [
              -53.46961109297947,
              -30.312305036605064
            ],
            [
              -53.46911382946293,
              -30.313404690482685
            ],
            [
              -53.465904219492515,
              -30.313993790774266
            ],
            [
              -53.46260419797364,
              -30.313993790774266
            ],
            [
              -53.460795967004394,
              -30.315682544943467
            ],
            [
              -53.46070555545593,
              -30.31890295987078
            ],
            [
              -53.462016522908634,
              -30.31980624698454
            ],
            [
              -53.46658230610598,
              -30.320198980512263
            ],
            [
              -53.468480948623686,
              -30.321416454448197
            ],
            [
              -53.46608504258944,
              -30.32848565794718
            ],
            [
              -53.46698915807406,
              -30.3302922321747
            ],
            [
              -53.47150973549717,
              -30.334690847685177
            ],
            [
              -53.47399605307989,
              -30.337989809318035
            ],
            [
              -53.4764823706626,
              -30.338696729667934
            ],
            [
              -53.4827207675065,
              -30.34329171194227
            ],
            [
              -53.48299200215189,
              -30.34749396068889
            ],
            [
              -53.48579476015422,
              -30.352010396257683
            ],
            [
              -53.4904057491258,
              -30.355505724654403
            ],
            [
              -53.491987951223884,
              -30.35770503240964
            ],
            [
              -53.4923043916435,
              -30.36010070692874
            ],
            [
              -53.49402221106429,
              -30.362417834742295
            ],
            [
              -53.49402221106429,
              -30.3657953430807
            ],
            [
              -53.50111951761858,
              -30.3705866921189
            ],
            [
              -53.49989896171434,
              -30.376791881856896
            ],
            [
              -53.50120992916704,
              -30.379619563256487
            ],
            [
              -53.5097086147225,
              -30.385000012586268
            ],
            [
              -53.5116072572402,
              -30.38649239999161
            ],
            [
              -53.512194932305206,
              -30.389005894569024
            ],
            [
              -53.51657989240563,
              -30.3972140252984
            ],
            [
              -53.52250184882991,
              -30.3989027794676
            ],
            [
              -53.524581314444546,
              -30.401809007572737
            ],
            [
              -53.52761010131803,
              -30.403183574919762
            ],
            [
              -53.53389370393616,
              -30.4020053743366
            ],
            [
              -53.534616996323855,
              -30.400591533636803
            ],
            [
              -53.533622469290776,
              -30.398195859117703
            ],
            [
              -53.5351142598404,
              -30.397881672295526
            ],
            [
              -53.53520467138886,
              -30.39591800465692
            ],
            [
              -53.53741975432619,
              -30.395289631012567
            ],
            [
              -53.53800742939119,
              -30.396192918126324
            ],
            [
              -53.53760057742311,
              -30.398117312412158
            ],
            [
              -53.539182779521205,
              -30.39831367917602
            ],
            [
              -53.539589631489285,
              -30.397096205240082
            ],
            [
              -53.5427992414597,
              -30.394189977134946
            ],
            [
              -53.54668693804358,
              -30.39281540978792
            ],
            [
              -53.54709379001166,
              -30.390301915210507
            ],
            [
              -53.54691296691473,
              -30.38849534098299
            ],
            [
              -53.54881160943244,
              -30.38609966646389
            ],
            [
              -53.55061984040169,
              -30.382918524889345
            ],
            [
              -53.54768146507666,
              -30.380719217134107
            ],
            [
              -53.54750064197974,
              -30.37620278156531
            ],
            [
              -53.54921846140052,
              -30.371018698999393
            ],
            [
              -53.54921846140052,
              -30.368819391244152
            ],
            [
              -53.55021298843361,
              -30.36548115625852
            ],
            [
              -53.54980613646553,
              -30.3643815023809
            ],
            [
              -53.54768146507666,
              -30.36300693503388
            ],
            [
              -53.61399833587375,
              -30.37781298902897
            ],
            [
              -53.61901617681341,
              -30.384018178766965
            ],
            [
              -53.6205983789115,
              -30.384882192527954
            ],
            [
              -53.62308469649422,
              -30.384410912294687
            ],
            [
              -53.625797042948086,
              -30.38598184640557
            ],
            [
              -53.62869021249888,
              -30.388809527805165
            ],
            [
              -53.62991076840312,
              -30.391205202324265
            ],
            [
              -53.63289434950237,
              -30.39301177655178
            ],
            [
              -53.634386140052,
              -30.394307797193264
            ],
            [
              -53.63397928808392,
              -30.39980606658136
            ],
            [
              -53.63461216892316,
              -30.403183574919762
            ],
            [
              -53.643382089124,
              -30.41119533888528
            ],
            [
              -53.64442182193132,
              -30.41830381573703
            ],
            [
              -53.64668211064288,
              -30.42230969771979
            ],
            [
              -53.64790266654712,
              -30.42568720605819
            ],
            [
              -53.65020816103291,
              -30.427807967107885
            ],
            [
              -53.65599450013449,
              -30.43228512932391
            ],
            [
              -53.692611177261725,
              -30.42230969771979
            ],
            [
              -53.692385148390564,
              -30.41991402320069
            ],
            [
              -53.694916671747514,
              -30.41700779509555
            ],
            [
              -53.69658928539406,
              -30.41630087474565
            ],
            [
              -53.6999797184614,
              -30.416497241509514
            ],
            [
              -53.70088383394602,
              -30.41551540769021
            ],
            [
              -53.702601653366806,
              -30.409192397893896
            ],
            [
              -53.70730305388685,
              -30.407503643724695
            ],
            [
              -53.70508797094952,
              -30.404518868914014
            ],
            [
              -53.704907147852595,
              -30.4027122946865
            ],
            [
              -53.705585234466064,
              -30.400984267164525
            ],
            [
              -53.70911128485609,
              -30.39760675882612
            ],
            [
              -53.71259212947189,
              -30.3948183507793
            ],
            [
              -53.71589215099076,
              -30.396899838476223
            ],
            [
              -53.71647982605577,
              -30.397881672295526
            ],
            [
              -53.71340583340805,
              -30.402908661450358
            ],
            [
              -53.71688667802385,
              -30.40628616978876
            ],
            [
              -53.7158017394423,
              -30.408210564074594
            ],
            [
              -53.71670585492692,
              -30.409506584716077
            ],
            [
              -53.71670585492692,
              -30.411313158943592
            ],
            [
              -53.71498803550614,
              -30.414297933754273
            ],
            [
              -53.71241130637497,
              -30.414887034045858
            ],
            [
              -53.71010581188918,
              -30.41869654926475
            ],
            [
              -53.707981140500316,
              -30.41999256990623
            ],
            [
              -53.70820716937147,
              -30.421013677078307
            ],
            [
              -53.71177842553573,
              -30.42380208512513
            ],
            [
              -53.71290856989151,
              -30.422191877661472
            ],
            [
              -53.71738394154039,
              -30.419599836378513
            ],
            [
              -53.719192172509636,
              -30.42011038996455
            ],
            [
              -53.71941820138079,
              -30.42109222378385
            ],
            [
              -53.72140725544696,
              -30.42238824442533
            ],
            [
              -53.72140725544696,
              -30.424312638711168
            ],
            [
              -53.718920937864254,
              -30.429810908099263
            ],
            [
              -53.71770038196001,
              -30.430007274863126
            ],
            [
              -53.714083920021515,
              -30.42988945480481
            ],
            [
              -53.71308939298843,
              -30.43181384909064
            ],
            [
              -53.7139030969246,
              -30.436408831364982
            ],
            [
              -53.71828805702501,
              -30.44618789620524
            ],
            [
              -53.71991546489733,
              -30.448112290491075
            ],
            [
              -53.719599024477716,
              -30.449094124310378
            ],
            [
              -53.71620859141038,
              -30.447994470432757
            ],
            [
              -53.712185277503806,
              -30.448112290491075
            ],
            [
              -53.71019622343764,
              -30.451411252123933
            ],
            [
              -53.71331542185959,
              -30.4518825323572
            ],
            [
              -53.71779079350847,
              -30.451411252123933
            ],
            [
              -53.719599024477716,
              -30.452707272765412
            ],
            [
              -53.7205935515108,
              -30.455102947284512
            ],
            [
              -53.720412728413876,
              -30.457302255039753
            ],
            [
              -53.71910176096117,
              -30.45769498856747
            ],
            [
              -53.71738394154039,
              -30.456398967925992
            ],
            [
              -53.715982562539224,
              -30.45651678798431
            ],
            [
              -53.71530447592576,
              -30.46001211638103
            ],
            [
              -53.71629900295884,
              -30.46319325795557
            ],
            [
              -53.7158017394423,
              -30.46539256571081
            ],
            [
              -53.71281815834305,
              -30.47191194227098
            ],
            [
              -53.71177842553573,
              -30.47701747813136
            ],
            [
              -53.71141677934188,
              -30.480316439764216
            ],
            [
              -53.71177842553573,
              -30.48298702775272
            ],
            [
              -53.71340583340805,
              -30.484715055274695
            ],
            [
              -53.715982562539224,
              -30.484715055274695
            ],
            [
              -53.71770038196001,
              -30.485618342388456
            ],
            [
              -53.7205935515108,
              -30.48518633550796
            ],
            [
              -53.72280863444813,
              -30.48660017620776
            ],
            [
              -53.72362233838429,
              -30.48648235614944
            ],
            [
              -53.72637989061239,
              -30.48828893037696
            ],
            [
              -53.72628947906393,
              -30.492294812359717
            ],
            [
              -53.73311555097283,
              -30.498814188919887
            ],
            [
              -53.742292323141754,
              -30.511892215393008
            ],
            [
              -53.74369370214292,
              -30.5133060560928
            ],
            [
              -53.74518549269255,
              -30.513698789620523
            ],
            [
              -53.74608960817717,
              -30.513384602798347
            ],
            [
              -53.75070059714875,
              -30.514602076734285
            ],
            [
              -53.753684178248,
              -30.516683564431204
            ],
            [
              -53.756712965121494,
              -30.51821522518932
            ],
            [
              -53.76168560028692,
              -30.519197059008622
            ],
            [
              -53.76679385277504,
              -30.519589792536344
            ],
            [
              -53.77741720971936,
              -30.51841159195318
            ],
            [
              -53.784921368241726,
              -30.51750830483942
            ],
            [
              -53.79500225589528,
              -30.51841159195318
            ],
            [
              -53.804495468483815,
              -30.5212
            ],
            [
              -53.809603720971936,
              -30.519982526064066
            ],
            [
              -53.81322018291043,
              -30.52010034612238
            ],
            [
              -53.81670102752623,
              -30.519118512303077
            ],
            [
              -53.81828322962431,
              -30.519000692244763
            ],
            [
              -53.8205887241101,
              -30.51750830483942
            ],
            [
              -53.825787388146686,
              -30.51138166180697
            ],
            [
              -53.82569697659822,
              -30.508907440582323
            ],
            [
              -53.82519971308168,
              -30.506511766063227
            ],
            [
              -53.82840932305209,
              -30.503409171194228
            ],
            [
              -53.829720290504795,
              -30.50160259696671
            ],
            [
              -53.83311072357213,
              -30.498617822156028
            ],
            [
              -53.83500936608984,
              -30.497596714983953
            ],
            [
              -53.83907788577064,
              -30.496497061106332
            ],
            [
              -53.84138338025643,
              -30.49351228629565
            ],
            [
              -53.84138338025643,
              -30.492491179123576
            ],
            [
              -53.83668197973639,
              -30.488681663904682
            ],
            [
              -53.83609430467139,
              -30.48789619684924
            ],
            [
              -53.8427847592576,
              -30.48408668163034
            ],
            [
              -53.84518066529185,
              -30.48298702775272
            ],
            [
              -53.84748615977764,
              -30.481494640347382
            ],
            [
              -53.850921798619204,
              -30.480787719997483
            ],
            [
              -53.85227797184614,
              -30.478902599064423
            ],
            [
              -53.85449305478347,
              -30.477488758364625
            ],
            [
              -53.858878014883885,
              -30.47631055778146
            ],
            [
              -53.86272050569353,
              -30.477292391600763
            ],
            [
              -53.86511641172778,
              -30.4792167858866
            ],
            [
              -53.871806866313996,
              -30.481416093641837
            ],
            [
              -53.87867814399713,
              -30.488799483962996
            ],
            [
              -53.88062199228907,
              -30.494415573409412
            ],
            [
              -53.882882281000626,
              -30.495986507520296
            ],
            [
              -53.88731244687528,
              -30.49720398145623
            ],
            [
              -53.89599195552766,
              -30.495790140756434
            ],
            [
              -53.89712209988344,
              -30.492098445595854
            ],
            [
              -53.9012810311127,
              -30.489899137840617
            ],
            [
              -53.90738381063391,
              -30.490213324662793
            ],
            [
              -53.91511399802744,
              -30.492805365945753
            ],
            [
              -53.91827840222361,
              -30.492883912651298
            ],
            [
              -53.92438118174482,
              -30.490409691426652
            ],
            [
              -53.94558268985923,
              -30.489113670785173
            ],
            [
              -53.96068141845243,
              -30.482005193933418
            ],
            [
              -53.961811562808215,
              -30.4785098655367
            ],
            [
              -53.961178681968974,
              -30.474582530259486
            ],
            [
              -53.9591896279028,
              -30.47151920874326
            ],
            [
              -53.96099785887205,
              -30.465117652241403
            ],
            [
              -53.95900880480588,
              -30.464214365127646
            ],
            [
              -53.96099785887205,
              -30.462211424136267
            ],
            [
              -53.962399237873214,
              -30.458087722095193
            ],
            [
              -53.96059100690397,
              -30.45471021375679
            ],
            [
              -53.965608847843626,
              -30.452196719179376
            ],
            [
              -53.966422551779786,
              -30.450900698537897
            ],
            [
              -53.9689088693625,
              -30.450704331774034
            ],
            [
              -53.970219836815204,
              -30.4494868578381
            ],
            [
              -53.970988334977136,
              -30.447209003377317
            ],
            [
              -53.973113006366,
              -30.4463842629691
            ],
            [
              -53.97460479691563,
              -30.443910041744456
            ],
            [
              -53.96868284049135,
              -30.44410640850832
            ],
            [
              -53.967778725006724,
              -30.442182014222485
            ],
            [
              -53.960319772258586,
              -30.43790121877032
            ],
            [
              -53.95620604680355,
              -30.433306236495984
            ],
            [
              -53.940384025822645,
              -30.42439118541671
            ],
            [
              -53.93830456020802,
              -30.41991402320069
            ],
            [
              -53.937807296691474,
              -30.416693608273373
            ],
            [
              -53.938214148659554,
              -30.415593954395753
            ],
            [
              -53.9400223796288,
              -30.414690667281995
            ],
            [
              -53.94192102214651,
              -30.410017138302113
            ],
            [
              -53.94128814130727,
              -30.40758219043024
            ],
            [
              -53.93920867569264,
              -30.40569706949718
            ],
            [
              -53.93839497175648,
              -30.403615581800256
            ],
            [
              -53.940610054693806,
              -30.400984267164525
            ],
            [
              -53.93911826414418,
              -30.398784959409284
            ],
            [
              -53.94169499327535,
              -30.395800184598603
            ],
            [
              -53.941197729758805,
              -30.395014717543162
            ],
            [
              -53.93920867569264,
              -30.394189977134946
            ],
            [
              -53.94169499327535,
              -30.39281540978792
            ],
            [
              -53.94531145521384,
              -30.389005894569024
            ],
            [
              -53.94689365731193,
              -30.381308317425688
            ],
            [
              -53.95109779431543,
              -30.37930537643431
            ],
            [
              -53.94992244418542,
              -30.377380982148477
            ],
            [
              -53.95182108670313,
              -30.371882712760378
            ],
            [
              -53.958692364386266,
              -30.36929067147742
            ],
            [
              -53.961178681968974,
              -30.367091363722178
            ],
            [
              -53.96131429929167,
              -30.36618807660842
            ],
            [
              -53.95878277593472,
              -30.364185135617042
            ],
            [
              -53.958692364386266,
              -30.363281848503284
            ],
            [
              -53.962399237873214,
              -30.361082540748043
            ],
            [
              -53.966422551779786,
              -30.36308548173942
            ],
            [
              -53.97171162736483,
              -30.359197419814983
            ],
            [
              -53.971395186945216,
              -30.352992230076985
            ],
            [
              -53.973113006366,
              -30.349614721738583
            ],
            [
              -53.97279656594638,
              -30.34808306098047
            ],
            [
              -53.96868284049135,
              -30.34639430681127
            ],
            [
              -53.9675979019098,
              -30.34458773258375
            ],
            [
              -53.9675979019098,
              -30.34348807870613
            ],
            [
              -53.96551843629516,
              -30.34230987812297
            ],
            [
              -53.964388291939386,
              -30.33979638354555
            ],
            [
              -53.96429788039092,
              -30.33720434226259
            ],
            [
              -53.965201995875546,
              -30.336497421912693
            ],
            [
              -53.96701022684479,
              -30.33720434226259
            ],
            [
              -53.968185576974804,
              -30.336497421912693
            ],
            [
              -53.9723897139783,
              -30.332491539929936
            ],
            [
              -53.97189245046176,
              -30.330999152524598
            ],
            [
              -53.97361026988254,
              -30.3302922321747
            ],
            [
              -53.97401712185062,
              -30.328917664827674
            ],
            [
              -53.97740755491796,
              -30.3271896373057
            ],
            [
              -53.97849249349951,
              -30.320081160453945
            ],
            [
              -53.981114428404915,
              -30.3183138595792
            ],
            [
              -53.98021031292029,
              -30.316782198821087
            ],
            [
              -53.98228977853492,
              -30.3152112647102
            ],
            [
              -53.98201854388954,
              -30.313011956954963
            ],
            [
              -53.98360074598762,
              -30.313286870424367
            ],
            [
              -53.98468568456917,
              -30.31238358331061
            ],
            [
              -53.98441444992379,
              -30.310694829141408
            ],
            [
              -53.987488442571504,
              -30.310616282435863
            ],
            [
              -53.989477496637676,
              -30.30908462167775
            ],
            [
              -53.991782991123465,
              -30.309398808499928
            ],
            [
              -53.99291313547924,
              -30.307906421094586
            ],
            [
              -53.990291200573836,
              -30.304214725934006
            ],
            [
              -53.98798570608805,
              -30.30260451847035
            ],
            [
              -53.98730761947458,
              -30.300287390656795
            ],
            [
              -53.98848296960459,
              -30.298716456545908
            ],
            [
              -53.987488442571504,
              -30.297184795787796
            ],
            [
              -53.9903816121223,
              -30.296792062260074
            ],
            [
              -53.99228025464001,
              -30.29761680266829
            ],
            [
              -53.99711727248274,
              -30.297891716137695
            ],
            [
              -54.00050770555008,
              -30.297184795787796
            ],
            [
              -54.00091455751816,
              -30.29149015963584
            ],
            [
              -54.000010442033535,
              -30.288505384825157
            ],
            [
              -53.99992003048507,
              -30.28540278995616
            ],
            [
              -54.00159264413162,
              -30.283714035786957
            ],
            [
              -54.00308443468125,
              -30.285599156720018
            ],
            [
              -54.00498307719896,
              -30.28398894925636
            ],
            [
              -54.006113221554735,
              -30.281396907973402
            ],
            [
              -54.00819268716937,
              -30.280100887331923
            ],
            [
              -54.00859953913745,
              -30.27880486669044
            ],
            [
              -54.01090503362324,
              -30.276998292462924
            ],
            [
              -54.012306412624405,
              -30.274798984707683
            ],
            [
              -54.01289408768941,
              -30.272010576660865
            ],
            [
              -54.01501875907827,
              -30.26988981561117
            ],
            [
              -54.01642013807944,
              -30.269614902141765
            ],
            [
              -54.01642013807944,
              -30.268318881500285
            ],
            [
              -54.01800234017753,
              -30.26639448721445
            ],
            [
              -54.01818316327446,
              -30.26490209980911
            ],
            [
              -54.01709822469291,
              -30.26380244593149
            ],
            [
              -54.0138886147225,
              -30.26309552558159
            ],
            [
              -54.013798203174034,
              -30.261603138176252
            ],
            [
              -54.01248723572133,
              -30.259089643598834
            ],
            [
              -54.01009132968708,
              -30.258618363365567
            ],
            [
              -54.008780362234376,
              -30.259718017243188
            ],
            [
              -54.00828309871783,
              -30.261485318117934
            ],
            [
              -54.00629404465166,
              -30.261485318117934
            ],
            [
              -54.00520910607011,
              -30.258186356485076
            ],
            [
              -54.003807727068946,
              -30.256693969079734
            ],
            [
              -54.000688528647,
              -30.255005214910533
            ],
            [
              -54.00132140948624,
              -30.2530808206247
            ],
            [
              -54.00077894019546,
              -30.252413173627573
            ],
            [
              -54.00050770555008,
              -30.24738618447274
            ],
            [
              -53.99869947458083,
              -30.24958549222798
            ],
            [
              -53.994902189545414,
              -30.25009604581402
            ],
            [
              -53.993003547027705,
              -30.248603658408676
            ],
            [
              -53.989884348605756,
              -30.2475825512366
            ],
            [
              -53.989477496637676,
              -30.242987568962263
            ],
            [
              -53.98780488299112,
              -30.24051334773762
            ],
            [
              -53.98739803102304,
              -30.237685666338027
            ],
            [
              -53.98509253653725,
              -30.234190337941307
            ],
            [
              -53.98631309244149,
              -30.229713175725283
            ],
            [
              -53.98798570608805,
              -30.228181514967172
            ],
            [
              -53.98780488299112,
              -30.22558947368421
            ],
            [
              -53.98179251501838,
              -30.221583591701453
            ],
            [
              -53.97591576436833,
              -30.219698470768392
            ],
            [
              -53.96701022684479,
              -30.21800971659919
            ],
            [
              -53.96578967094055,
              -30.218284630068595
            ],
            [
              -53.96447870348785,
              -30.22020902435443
            ],
            [
              -53.962806089841294,
              -30.22001265759057
            ],
            [
              -53.959280039451265,
              -30.21651732919385
            ],
            [
              -53.959686891419345,
              -30.215692588785636
            ],
            [
              -53.961585533937054,
              -30.215692588785636
            ],
            [
              -53.961992385905134,
              -30.214592934908016
            ],
            [
              -53.95900880480588,
              -30.212707813974955
            ],
            [
              -53.95457863893123,
              -30.20748445805626
            ],
            [
              -53.953990963866225,
              -30.2055993371232
            ],
            [
              -53.95652248722317,
              -30.204617503303897
            ],
            [
              -53.95760742580472,
              -30.2032036626041
            ],
            [
              -53.95851154128934,
              -30.201082901554404
            ],
            [
              -53.96059100690397,
              -30.20061162132114
            ],
            [
              -53.964117057294004,
              -30.200690168026682
            ],
            [
              -53.964704732359,
              -30.1984123135659
            ],
            [
              -53.96330335335784,
              -30.197783939921546
            ],
            [
              -53.964795143907466,
              -30.196487919280067
            ],
            [
              -53.96908969245943,
              -30.19401369805542
            ],
            [
              -53.967100638393255,
              -30.192796224119487
            ],
            [
              -53.965880082489015,
              -30.191303836714145
            ],
            [
              -53.96691981529633,
              -30.18898670890059
            ],
            [
              -53.96719104994172,
              -30.186316120912085
            ],
            [
              -53.96850201739442,
              -30.18600193408991
            ],
            [
              -53.97071710033175,
              -30.186787401145352
            ],
            [
              -53.97388150452793,
              -30.186787401145352
            ],
            [
              -53.97379109297947,
              -30.18458809339011
            ],
            [
              -53.9723897139783,
              -30.182388785634874
            ],
            [
              -53.97189245046176,
              -30.179404010824193
            ],
            [
              -53.97351985833408,
              -30.178186536888255
            ],
            [
              -53.973022594817536,
              -30.175790862369155
            ],
            [
              -53.974514385367165,
              -30.175005395313715
            ],
            [
              -53.97469520846409,
              -30.173002454322337
            ],
            [
              -53.97428835649601,
              -30.171902800444716
            ],
            [
              -53.97618699901372,
              -30.169899859453338
            ],
            [
              -53.975192471980634,
              -30.169114392397894
            ],
            [
              -53.97379109297947,
              -30.1693893058673
            ],
            [
              -53.97121436384829,
              -30.167307818170375
            ],
            [
              -53.97189245046176,
              -30.165304877178997
            ],
            [
              -53.96990339639559,
              -30.16369466971534
            ],
            [
              -53.96651296332825,
              -30.164715776887416
            ],
            [
              -53.965608847843626,
              -30.164008856537517
            ],
            [
              -53.964795143907466,
              -30.162280829015543
            ],
            [
              -53.962806089841294,
              -30.16180954878228
            ],
            [
              -53.96248964942168,
              -30.16070989490466
            ],
            [
              -53.96298691293822,
              -30.158196400327242
            ],
            [
              -53.961404710840135,
              -30.15760730003566
            ],
            [
              -53.95891839325742,
              -30.15591854586646
            ],
            [
              -53.95878277593472,
              -30.151794843825385
            ],
            [
              -53.95769783735318,
              -30.149909722892325
            ],
            [
              -53.956703310320094,
              -30.14739622831491
            ],
            [
              -53.95878277593472,
              -30.145314740617987
            ],
            [
              -53.957517014256254,
              -30.144293633445912
            ],
            [
              -53.95900880480588,
              -30.14350816639047
            ],
            [
              -53.9586019528378,
              -30.141191038576913
            ],
            [
              -53.957517014256254,
              -30.140091384699293
            ],
            [
              -53.95579919483547,
              -30.140484118227015
            ],
            [
              -53.953719729220836,
              -30.14020920475761
            ],
            [
              -53.95299643683314,
              -30.138481177235636
            ],
            [
              -53.95457863893123,
              -30.13471093536951
            ],
            [
              -53.953990963866225,
              -30.132118894086553
            ],
            [
              -53.952092321348516,
              -30.12991958633131
            ],
            [
              -53.95218273289698,
              -30.126306437876277
            ],
            [
              -53.953312877252756,
              -30.12559951752638
            ],
            [
              -53.95471425625392,
              -30.126384984581822
            ],
            [
              -53.957381396933556,
              -30.123910763357177
            ],
            [
              -53.95959647987089,
              -30.123518029829455
            ],
            [
              -53.95819510086972,
              -30.121515088838077
            ],
            [
              -53.9559800179324,
              -30.121397268779763
            ],
            [
              -53.95349370034968,
              -30.120101248138283
            ],
            [
              -53.95118820586389,
              -30.119590694552244
            ],
            [
              -53.948882711378104,
              -30.117784120324725
            ],
            [
              -53.947797772796555,
              -30.119590694552244
            ],
            [
              -53.94639639379539,
              -30.119197961024522
            ],
            [
              -53.94598954182731,
              -30.117705573619183
            ],
            [
              -53.947390920828475,
              -30.116802286505422
            ],
            [
              -53.947390920828475,
              -30.115781179333347
            ],
            [
              -53.94458816282614,
              -30.114288791928008
            ],
            [
              -53.943503224244594,
              -30.113110591344842
            ],
            [
              -53.941604581726885,
              -30.112207304231084
            ],
            [
              -53.94128814130727,
              -30.110007996475844
            ],
            [
              -53.94359363579306,
              -30.10859415577605
            ],
            [
              -53.94381966466422,
              -30.106316301315264
            ],
            [
              -53.94449775127768,
              -30.105216647437647
            ],
            [
              -53.94368404734152,
              -30.102310419332508
            ],
            [
              -53.9427799318569,
              -30.102192599274193
            ],
            [
              -53.94051964314534,
              -30.10380280673785
            ],
            [
              -53.93771688514301,
              -30.10321370644627
            ],
            [
              -53.935501802205685,
              -30.102192599274193
            ],
            [
              -53.93310589617143,
              -30.10250678609637
            ],
            [
              -53.933196307719896,
              -30.101014398691028
            ],
            [
              -53.93170451717027,
              -30.099796924755093
            ],
            [
              -53.932789455751816,
              -30.09901145769965
            ],
            [
              -53.93301548462297,
              -30.097401250235993
            ],
            [
              -53.931614105621804,
              -30.097087063413817
            ],
            [
              -53.93170451717027,
              -30.096105229594514
            ],
            [
              -53.92939902268448,
              -30.094416475425312
            ],
            [
              -53.92831408410293,
              -30.09198152755344
            ],
            [
              -53.92691270510176,
              -30.090214226678693
            ],
            [
              -53.92352227203443,
              -30.08848619915672
            ],
            [
              -53.92157842374249,
              -30.090017859914834
            ],
            [
              -53.91981539854748,
              -30.089900039856516
            ],
            [
              -53.918911283062855,
              -30.088014918923456
            ],
            [
              -53.91692222899668,
              -30.087111631809695
            ],
            [
              -53.91561126154398,
              -30.084715957290598
            ],
            [
              -53.9152044095759,
              -30.08110280883556
            ],
            [
              -53.91411947099435,
              -30.07721474691112
            ],
            [
              -53.91249206312203,
              -30.073601598456086
            ],
            [
              -53.91181397650856,
              -30.06920298294561
            ],
            [
              -53.91018656863624,
              -30.06798550900967
            ],
            [
              -53.90738381063391,
              -30.069006616181746
            ],
            [
              -53.906118048955435,
              -30.067514228776407
            ],
            [
              -53.905982431632744,
              -30.066218208134924
            ],
            [
              -53.906796135568904,
              -30.06500073419899
            ],
            [
              -53.90851395498969,
              -30.064018900379686
            ],
            [
              -53.907202987536984,
              -30.06240869291603
            ],
            [
              -53.907609839505064,
              -30.05950246481089
            ],
            [
              -53.90860436653815,
              -30.057892257347234
            ],
            [
              -53.90901121850623,
              -30.055300216064275
            ],
            [
              -53.91009615708778,
              -30.054200562186654
            ],
            [
              -53.910412597507396,
              -30.052904541545175
            ],
            [
              -53.90738381063391,
              -30.050194680203898
            ],
            [
              -53.91009615708778,
              -30.04618879822114
            ],
            [
              -53.90688654711737,
              -30.04520696440184
            ],
            [
              -53.905982431632744,
              -30.044382223993622
            ],
            [
              -53.904219406437726,
              -30.044617864110258
            ],
            [
              -53.901778294629246,
              -30.04379312370204
            ],
            [
              -53.90028650407962,
              -30.0423007362967
            ],
            [
              -53.899789240563074,
              -30.041201082419082
            ],
            [
              -53.89847827311037,
              -30.040690528833043
            ],
            [
              -53.897890598045365,
              -30.036488280086427
            ],
            [
              -53.896489219044206,
              -30.036095546558705
            ],
            [
              -53.89508784004304,
              -30.03711665373078
            ],
            [
              -53.893822078364565,
              -30.03688101361415
            ],
            [
              -53.89318919752533,
              -30.035192259444948
            ],
            [
              -53.88997958755492,
              -30.035506446267124
            ],
            [
              -53.88898506052183,
              -30.033817692097923
            ],
            [
              -53.89061246839415,
              -30.031814751106545
            ],
            [
              -53.89061246839415,
              -30.030715097228924
            ],
            [
              -53.88740285842374,
              -30.02839796941537
            ],
            [
              -53.888306973908364,
              -30.02600229489627
            ],
            [
              -53.88469051196987,
              -30.022192779677372
            ],
            [
              -53.88319872142024,
              -30.017794164166894
            ],
            [
              -53.881390490451,
              -30.017283610580858
            ],
            [
              -53.8773219707702,
              -30.017008697111454
            ],
            [
              -53.87668908993096,
              -30.016183956703237
            ],
            [
              -53.876011003317494,
              -30.012492261542658
            ],
            [
              -53.874790447413254,
              -30.01178534119276
            ],
            [
              -53.87420277234825,
              -30.010410773845734
            ],
            [
              -53.872484952927465,
              -30.00978240020138
            ],
            [
              -53.87280139334708,
              -30.00829001279604
            ],
            [
              -53.871806866313996,
              -30.00719035891842
            ],
            [
              -53.872078100959385,
              -30.00479468439932
            ],
            [
              -53.87347947996055,
              -30.00479468439932
            ],
            [
              -53.8731178337667,
              -30.002988110171803
            ],
            [
              -53.87347947996055,
              -30.000788802416565
            ],
            [
              -53.872484952927465,
              -29.99831458119192
            ],
            [
              -53.871400014345916,
              -29.998196761133602
            ],
            [
              -53.87049589886129,
              -29.995408353086784
            ],
            [
              -53.86918493140859,
              -29.993994512386987
            ],
            [
              -53.87149042589438,
              -29.9941123324453
            ],
            [
              -53.87230412983054,
              -29.993405412095406
            ],
            [
              -53.87592059176903,
              -29.99258067168719
            ],
            [
              -53.8771863534475,
              -29.98829987623503
            ],
            [
              -53.87949184793329,
              -29.988417696293343
            ],
            [
              -53.88098363848292,
              -29.986807488829687
            ],
            [
              -53.883289132968706,
              -29.98759295588513
            ],
            [
              -53.884780923518335,
              -29.985590014893752
            ],
            [
              -53.887222035326815,
              -29.985590014893752
            ],
            [
              -53.890702879942616,
              -29.98339070713851
            ],
            [
              -53.89201384739532,
              -29.98339070713851
            ],
            [
              -53.89698648256074,
              -29.987907142707307
            ],
            [
              -53.89911115394961,
              -29.98818205617671
            ],
            [
              -53.90498790459966,
              -29.983587073902374
            ],
            [
              -53.90779066260199,
              -29.982919426905248
            ],
            [
              -53.9138934421232,
              -29.984883094543854
            ],
            [
              -53.91750990406169,
              -29.98480454783831
            ],
            [
              -53.918097579126695,
              -29.98629693524365
            ],
            [
              -53.93021272662064,
              -29.98869260976275
            ],
            [
              -53.93758126782031,
              -29.98778932264899
            ],
            [
              -53.9387114121761,
              -29.98590420171593
            ],
            [
              -53.94110731821035,
              -29.98590420171593
            ],
            [
              -53.94128814130727,
              -29.986611122065828
            ],
            [
              -53.9454018667623,
              -29.987396589121268
            ],
            [
              -53.946984068860395,
              -29.98888897652661
            ],
            [
              -53.9496060037658,
              -29.989281710054332
            ],
            [
              -53.95150464628351,
              -29.991009737576306
            ],
            [
              -53.95322246570429,
              -29.98959589687651
            ],
            [
              -53.955211519770465,
              -29.990106450462545
            ],
            [
              -53.95878277593472,
              -29.98829987623503
            ],
            [
              -53.96000333183897,
              -29.98888897652661
            ],
            [
              -53.96131429929167,
              -29.988417696293343
            ],
            [
              -53.962806089841294,
              -29.99018499716809
            ],
            [
              -53.964388291939386,
              -29.989792263640368
            ],
            [
              -53.96660337487671,
              -29.98759295588513
            ],
            [
              -53.96918010400789,
              -29.989006796584928
            ],
            [
              -53.97031024836367,
              -29.987318042415726
            ],
            [
              -53.97361026988254,
              -29.98539364812989
            ],
            [
              -53.97668426253026,
              -29.985118734660485
            ],
            [
              -53.97871852237066,
              -29.986100568479788
            ],
            [
              -53.98459527302071,
              -29.985982748421474
            ],
            [
              -53.98730761947458,
              -29.986807488829687
            ],
            [
              -53.98920626199229,
              -29.98590420171593
            ],
            [
              -53.99318437012463,
              -29.987318042415726
            ],
            [
              -54.00050770555008,
              -29.98590420171593
            ],
            [
              -54.00059811709854,
              -29.98350852719683
            ],
            [
              -54.00498307719896,
              -29.984019080782865
            ],
            [
              -54.00819268716937,
              -29.981309219441588
            ],
            [
              -54.0075146005559,
              -29.974986209645277
            ],
            [
              -54.01049818165516,
              -29.974004375825974
            ],
            [
              -54.00850912758899,
              -29.97149088124856
            ],
            [
              -54.01058859320362,
              -29.970194860607076
            ],
            [
              -54.01280367614095,
              -29.97039122737094
            ],
            [
              -54.01759548820945,
              -29.96540351156888
            ],
            [
              -54.0247832063122,
              -29.965285691510562
            ],
            [
              -54.02519005828028,
              -29.9634005705775
            ],
            [
              -54.028218845153766,
              -29.962615103522058
            ],
            [
              -54.027405141217606,
              -29.95990524218078
            ],
            [
              -54.02989145880032,
              -29.958884135008706
            ],
            [
              -54.03070516273648,
              -29.95750956766168
            ],
            [
              -54.03350792073881,
              -29.957588114367226
            ],
            [
              -54.03409559580382,
              -29.955506626670303
            ],
            [
              -54.033598332287276,
              -29.953189498856748
            ],
            [
              -54.03188051286649,
              -29.951304377923687
            ],
            [
              -54.029710635703395,
              -29.950793824337648
            ],
            [
              -54.02907775486416,
              -29.94989053722389
            ],
            [
              -54.02962022415493,
              -29.94160385978897
            ],
            [
              -54.028896931767235,
              -29.93901181850601
            ],
            [
              -54.0302983107684,
              -29.935712856873153
            ],
            [
              -54.029981870348784,
              -29.93378846258732
            ],
            [
              -54.03138324934995,
              -29.932217528476432
            ],
            [
              -54.03138324934995,
              -29.93088223448218
            ],
            [
              -54.03391477270689,
              -29.929114933607433
            ],
            [
              -54.036988765354614,
              -29.920592616055885
            ],
            [
              -54.04010796377656,
              -29.91741147448134
            ],
            [
              -54.04318195642428,
              -29.918000574772922
            ],
            [
              -54.045216216264684,
              -29.91611545383986
            ],
            [
              -54.04729568187931,
              -29.915408533489963
            ],
            [
              -54.04869706088048,
              -29.913601959262444
            ],
            [
              -54.049691587913564,
              -29.913405592498584
            ],
            [
              -54.05149981888281,
              -29.911716838329383
            ],
            [
              -54.05638204249978,
              -29.91089209792117
            ],
            [
              -54.05900397740518,
              -29.91148119821275
            ],
            [
              -54.06230399892406,
              -29.91049936439345
            ],
            [
              -54.065197168474846,
              -29.91038154433513
            ],
            [
              -54.067321839863716,
              -29.911402651507206
            ],
            [
              -54.06849718999372,
              -29.911009917979484
            ],
            [
              -54.06971774589796,
              -29.908810610224247
            ],
            [
              -54.070983507576436,
              -29.908614243460384
            ],
            [
              -54.07360544248184,
              -29.910813551215625
            ],
            [
              -54.07667943512956,
              -29.910617184451763
            ],
            [
              -54.07898492961535,
              -29.91289503891255
            ],
            [
              -54.08490688603963,
              -29.915801267017684
            ],
            [
              -54.08540414955617,
              -29.91701874095362
            ],
            [
              -54.09001513852775,
              -29.915919087076002
            ],
            [
              -54.093812423563165,
              -29.919492962178264
            ],
            [
              -54.096886416210886,
              -29.92090680287806
            ],
            [
              -54.1006837012463,
              -29.922988290574985
            ],
            [
              -54.10240152066709,
              -29.9247948648025
            ],
            [
              -54.10579195373442,
              -29.92589451868012
            ],
            [
              -54.109589238769836,
              -29.925815971974576
            ],
            [
              -54.11157829283601,
              -29.924284311216464
            ],
            [
              -54.113793375773334,
              -29.923616664219338
            ],
            [
              -54.12030300726262,
              -29.9223991902834
            ],
            [
              -54.12301535371649,
              -29.92031770258648
            ],
            [
              -54.126315375235365,
              -29.920082062469845
            ],
            [
              -54.128485252398455,
              -29.91961078223658
            ],
            [
              -54.12988663139962,
              -29.921417356464097
            ],
            [
              -54.132418154756564,
              -29.92090680287806
            ],
            [
              -54.13499488388774,
              -29.921417356464097
            ],
            [
              -54.137119555276605,
              -29.92051406935034
            ],
            [
              -54.14281548282973,
              -29.9247948648025
            ],
            [
              -54.148014146866316,
              -29.92459849803864
            ],
            [
              -54.14991278938402,
              -29.925815971974576
            ],
            [
              -54.15271554738635,
              -29.9255017851524
            ],
            [
              -54.153981309064825,
              -29.926915625852196
            ],
            [
              -54.1614854675872,
              -29.927386906085463
            ],
            [
              -54.16238958307182,
              -29.9278974596715
            ],
            [
              -54.16460466600915,
              -29.927504726143777
            ],
            [
              -54.16618686810723,
              -29.92829019319922
            ],
            [
              -54.16781427597956,
              -29.92829019319922
            ],
            [
              -54.16930606652918,
              -29.927583272849322
            ],
            [
              -54.17152114946651,
              -29.927386906085463
            ],
            [
              -54.173012940016136,
              -29.928093826435358
            ],
            [
              -54.17699104814848,
              -29.928093826435358
            ],
            [
              -54.18160203712006,
              -29.927583272849322
            ],
            [
              -54.184088354702766,
              -29.928211646493676
            ],
            [
              -54.18779522818972,
              -29.92840801325754
            ],
            [
              -54.19199936519322,
              -29.926915625852196
            ],
            [
              -54.19290348067784,
              -29.926287252207842
            ],
            [
              -54.194892534744014,
              -29.92660143903002
            ],
            [
              -54.196113090648254,
              -29.923891577688742
            ],
            [
              -54.19900626019905,
              -29.921888636697364
            ],
            [
              -54.20031722765175,
              -29.921495903169642
            ],
            [
              -54.201899429749844,
              -29.919689328942123
            ],
            [
              -54.20370766071909,
              -29.918589675064506
            ],
            [
              -54.207007682237965,
              -29.918393308300644
            ],
            [
              -54.20818303236797,
              -29.91701874095362
            ],
            [
              -54.20818303236797,
              -29.915801267017684
            ],
            [
              -54.21089537882184,
              -29.91501579996224
            ],
            [
              -54.21211593472608,
              -29.915801267017684
            ],
            [
              -54.21717898143997,
              -29.915997633781544
            ],
            [
              -54.221202295346544,
              -29.91501579996224
            ],
            [
              -54.22188038196001,
              -29.913994692790165
            ],
            [
              -54.22432149376849,
              -29.912109571857105
            ],
            [
              -54.22558725544696,
              -29.91049936439345
            ],
            [
              -54.22599410741505,
              -29.908810610224247
            ],
            [
              -54.22748589796467,
              -29.90629711564683
            ],
            [
              -54.229700980901995,
              -29.904686908183173
            ],
            [
              -54.23471882184165,
              -29.90390144112773
            ],
            [
              -54.23639143548821,
              -29.90319452077783
            ],
            [
              -54.23801884336053,
              -29.900484659436554
            ],
            [
              -54.23788322603784,
              -29.89761770468419
            ],
            [
              -54.24190653994441,
              -29.895693310398357
            ],
            [
              -54.245613413431364,
              -29.892708535587673
            ],
            [
              -54.24728602707791,
              -29.89298344905708
            ],
            [
              -54.250088785080244,
              -29.89710715109815
            ],
            [
              -54.25271071998565,
              -29.900288292672695
            ],
            [
              -54.25460936250336,
              -29.901584313314174
            ],
            [
              -54.25569430108491,
              -29.903390887541693
            ],
            [
              -54.256417593472605,
              -29.90680766923287
            ],
            [
              -54.25700526853761,
              -29.90759313628831
            ],
            [
              -54.26039570160495,
              -29.909399710515828
            ],
            [
              -54.26319845960728,
              -29.911402651507206
            ],
            [
              -54.26500669057653,
              -29.913798326026306
            ],
            [
              -54.26799027167578,
              -29.915212166726104
            ],
            [
              -54.269210827580025,
              -29.917686387950745
            ],
            [
              -54.27169714516273,
              -29.920788982819744
            ],
            [
              -54.27278208374428,
              -29.9216922699335
            ],
            [
              -54.275720459069305,
              -29.922517010341718
            ],
            [
              -54.277980747780866,
              -29.922085003461223
            ],
            [
              -54.27929171523357,
              -29.922517010341718
            ],
            [
              -54.27969856720165,
              -29.923695210924883
            ],
            [
              -54.27911089213664,
              -29.925187598330222
            ],
            [
              -54.281506798170895,
              -29.926719259088337
            ],
            [
              -54.28159720971936,
              -29.928211646493676
            ],
            [
              -54.28268214830091,
              -29.9302931341906
            ],
            [
              -54.28449037927015,
              -29.931706974890396
            ],
            [
              -54.28679587375594,
              -29.932885175473558
            ],
            [
              -54.28968904330673,
              -29.932217528476432
            ],
            [
              -54.293395916793685,
              -29.93351354911791
            ],
            [
              -54.29868499237873,
              -29.934299016173355
            ],
            [
              -54.29981513673451,
              -29.934102649409496
            ],
            [
              -54.30171377925222,
              -29.932492441945836
            ],
            [
              -54.30361242176993,
              -29.933199362295735
            ],
            [
              -54.30668641441764,
              -29.932296075181977
            ],
            [
              -54.30849464538689,
              -29.930410954248917
            ],
            [
              -54.30849464538689,
              -29.927504726143777
            ],
            [
              -54.31278919393885,
              -29.92609088544398
            ],
            [
              -54.31631524432888,
              -29.9264836189717
            ],
            [
              -54.31988650049314,
              -29.9255017851524
            ],
            [
              -54.32169473146239,
              -29.925815971974576
            ],
            [
              -54.32598928001435,
              -29.927386906085463
            ],
            [
              -54.32919888998476,
              -29.927504726143777
            ],
            [
              -54.331007120954,
              -29.92840801325754
            ],
            [
              -54.33340302698825,
              -29.928800746785257
            ],
            [
              -54.33539208105442,
              -29.928604380021397
            ],
            [
              -54.340183893122926,
              -29.92770109290764
            ],
            [
              -54.34271541647987,
              -29.92829019319922
            ],
            [
              -54.34488529364297,
              -29.929900400662877
            ],
            [
              -54.348004492064916,
              -29.933906282645633
            ],
            [
              -54.350716838518785,
              -29.93551649010929
            ],
            [
              -54.35320315610149,
              -29.935791403578698
            ],
            [
              -54.36549912669237,
              -29.934102649409496
            ],
            [
              -54.36888955975971,
              -29.934102649409496
            ],
            [
              -54.372189581278576,
              -29.934691749701077
            ],
            [
              -54.373681371828205,
              -29.937087424220177
            ],
            [
              -54.37539919124899,
              -29.937519431100668
            ],
            [
              -54.38611295974177,
              -29.938697631683834
            ],
            [
              -54.387695161839865,
              -29.940190019089176
            ],
            [
              -54.38918695238949,
              -29.940504205911353
            ],
            [
              -54.39289382587644,
              -29.939993652325313
            ],
            [
              -54.394882879942614,
              -29.93861908497829
            ],
            [
              -54.40071442481843,
              -29.939090365211555
            ],
            [
              -54.40112127678651,
              -29.939483098739277
            ],
            [
              -54.40338156549807,
              -29.943488980722034
            ],
            [
              -54.40500897337039,
              -29.948398149818548
            ],
            [
              -54.41567753608894,
              -29.950518910868244
            ],
            [
              -54.42381457545055,
              -29.950990191101507
            ],
            [
              -54.431589968618304,
              -29.952600398565167
            ],
            [
              -54.439410567560294,
              -29.954014239264964
            ],
            [
              -54.44488046624227,
              -29.955702993434166
            ],
            [
              -54.453695592217336,
              -29.96010160894464
            ],
            [
              -54.45441888460504,
              -29.959787422122464
            ],
            [
              -54.470421728682865,
              -29.959001955067023
            ],
            [
              -54.47168749036133,
              -29.957195380839504
            ],
            [
              -54.47168749036133,
              -29.95428915273437
            ],
            [
              -54.47091899219941,
              -29.951618564745864
            ],
            [
              -54.471777901909796,
              -29.94859451658241
            ],
            [
              -54.47521354075137,
              -29.94509918818569
            ],
            [
              -54.47548477539675,
              -29.943881714249756
            ],
            [
              -54.477202594817534,
              -29.941093306202934
            ],
            [
              -54.47910123733524,
              -29.939993652325313
            ],
            [
              -54.480412204787946,
              -29.938501264919974
            ],
            [
              -54.482717699273735,
              -29.938108531392253
            ],
            [
              -54.48389304940375,
              -29.93861908497829
            ],
            [
              -54.485791691921456,
              -29.937990711333935
            ],
            [
              -54.48669580740608,
              -29.937087424220177
            ],
            [
              -54.49221091186228,
              -29.935987770342557
            ],
            [
              -54.493612290863446,
              -29.935280849992658
            ],
            [
              -54.49451640634807,
              -29.93378846258732
            ],
            [
              -54.49560134492961,
              -29.933395729059598
            ],
            [
              -54.4979068394154,
              -29.933592095823457
            ],
            [
              -54.500121922352726,
              -29.93308154223742
            ],
            [
              -54.5021109764189,
              -29.934495382937214
            ],
            [
              -54.504280853581996,
              -29.937008877514632
            ],
            [
              -54.50518496906662,
              -29.936812510750773
            ],
            [
              -54.50749046355241,
              -29.938187078097794
            ],
            [
              -54.50880143100511,
              -29.93971873885591
            ],
            [
              -54.5103836331032,
              -29.939915105619768
            ],
            [
              -54.511287748587826,
              -29.941093306202934
            ],
            [
              -54.51079048507128,
              -29.94250714690273
            ],
            [
              -54.51350283152515,
              -29.94321406725263
            ],
            [
              -54.51558229713978,
              -29.942782060372135
            ],
            [
              -54.52041931498251,
              -29.943096247194312
            ],
            [
              -54.52390015959831,
              -29.944706454657968
            ],
            [
              -54.527516621536805,
              -29.945413375007867
            ],
            [
              -54.529415264054514,
              -29.947809049526967
            ],
            [
              -54.531178289249524,
              -29.948005416290826
            ],
            [
              -54.53312213754147,
              -29.950401090809926
            ],
            [
              -54.53800436115843,
              -29.949419256990623
            ],
            [
              -54.53958656325652,
              -29.95008690398775
            ],
            [
              -54.54121397112884,
              -29.952089844979128
            ],
            [
              -54.54460440419618,
              -29.951618564745864
            ],
            [
              -54.54618660629427,
              -29.952914585387344
            ],
            [
              -54.54808524881198,
              -29.953503685678925
            ],
            [
              -54.54808524881198,
              -29.954996073084267
            ],
            [
              -54.54740716219851,
              -29.956881194017328
            ],
            [
              -54.55048115484623,
              -29.957195380839504
            ],
            [
              -54.55251541468663,
              -29.955899360198025
            ],
            [
              -54.553690764816636,
              -29.956095726961884
            ],
            [
              -54.55567981888281,
              -29.95821648801158
            ],
            [
              -54.555589407334345,
              -29.96041579576682
            ],
            [
              -54.555996259302425,
              -29.961083442763943
            ],
            [
              -54.5579853133686,
              -29.961083442763943
            ],
            [
              -54.559115457724374,
              -29.959001955067023
            ],
            [
              -54.56169218685555,
              -29.958491401480984
            ],
            [
              -54.561782598404015,
              -29.957195380839504
            ],
            [
              -54.563410006276335,
              -29.956488460489606
            ],
            [
              -54.564901796825964,
              -29.957195380839504
            ],
            [
              -54.56557988343943,
              -29.959080501772565
            ],
            [
              -54.56738811440868,
              -29.959080501772565
            ],
            [
              -54.56951278579754,
              -29.959787422122464
            ],
            [
              -54.57181828028333,
              -29.957784481131085
            ],
            [
              -54.57281280731642,
              -29.957705934425544
            ],
            [
              -54.57538953644759,
              -29.958491401480984
            ],
            [
              -54.577016944319915,
              -29.959787422122464
            ],
            [
              -54.577016944319915,
              -29.96131908288058
            ],
            [
              -54.57561556531875,
              -29.961986729877705
            ],
            [
              -54.577197767416834,
              -29.963086383755325
            ],
            [
              -54.58198957948534,
              -29.962811470285917
            ],
            [
              -54.58397863355151,
              -29.96190818317216
            ],
            [
              -54.58592248184345,
              -29.96249728346374
            ],
            [
              -54.588092359006545,
              -29.965089324746703
            ],
            [
              -54.58791153590962,
              -29.966306798682638
            ],
            [
              -54.585380012552676,
              -29.96799555285184
            ],
            [
              -54.585380012552676,
              -29.9698806737849
            ],
            [
              -54.588499210974625,
              -29.971098147720838
            ],
            [
              -54.58791153590962,
              -29.973886555767656
            ],
            [
              -54.58940332645925,
              -29.97561458328963
            ],
            [
              -54.59130196897696,
              -29.976203683581215
            ],
            [
              -54.593607463462746,
              -29.977696070986553
            ],
            [
              -54.59582254640007,
              -29.97761752428101
            ],
            [
              -54.59898695059625,
              -29.975496763231316
            ],
            [
              -54.60219656056666,
              -29.975104029703594
            ],
            [
              -54.60377876266475,
              -29.976400050345074
            ],
            [
              -54.60377876266475,
              -29.97730333745883
            ],
            [
              -54.601608885501655,
              -29.98020956556397
            ],
            [
              -54.60301026450282,
              -29.98111285267773
            ],
            [
              -54.606581520667085,
              -29.981898319733173
            ],
            [
              -54.608480163184794,
              -29.98350852719683
            ],
            [
              -54.61200621357482,
              -29.98480454783831
            ],
            [
              -54.61340759257599,
              -29.986886035535232
            ],
            [
              -54.6166172025464,
              -29.988496242998888
            ],
            [
              -54.61828981619295,
              -29.993012678567684
            ],
            [
              -54.61978160674258,
              -29.993719598917583
            ],
            [
              -54.62371450910069,
              -29.992894858509366
            ],
            [
              -54.625884386263785,
              -29.99148101780957
            ],
            [
              -54.628596732717654,
              -29.991598837867887
            ],
            [
              -54.6304049636869,
              -29.993719598917583
            ],
            [
              -54.63271045817269,
              -29.99591890667282
            ],
            [
              -54.632620046624226,
              -29.997489840783704
            ],
            [
              -54.63008852326728,
              -30.00071025571102
            ],
            [
              -54.62932002510535,
              -30.0027131967024
            ],
            [
              -54.62959125975074,
              -30.00459831763546
            ],
            [
              -54.632620046624226,
              -30.007111812212877
            ],
            [
              -54.634789923787324,
              -30.009311119968114
            ],
            [
              -54.638406385725816,
              -30.011706794487214
            ],
            [
              -54.64188723034161,
              -30.014691569297895
            ],
            [
              -54.642610522729306,
              -30.015909043233833
            ],
            [
              -54.642610522729306,
              -30.01810835098907
            ],
            [
              -54.64170640724468,
              -30.019286551572236
            ],
            [
              -54.63831597417735,
              -30.020189838685994
            ],
            [
              -54.63799953375773,
              -30.02160367938579
            ],
            [
              -54.63949132430736,
              -30.025216827840826
            ],
            [
              -54.64089270330852,
              -30.02600229489627
            ],
            [
              -54.64500642876356,
              -30.02549174131023
            ],
            [
              -54.64789959831435,
              -30.02541319460469
            ],
            [
              -54.65079276786515,
              -30.024392087432613
            ],
            [
              -54.653007850802474,
              -30.024588454196472
            ],
            [
              -54.655403756836726,
              -30.026080841601814
            ],
            [
              -54.65739281090289,
              -30.030008176879026
            ],
            [
              -54.65960789384022,
              -30.03208966457595
            ],
            [
              -54.66372161929525,
              -30.033699872039605
            ],
            [
              -54.666479171523356,
              -30.03448533909505
            ],
            [
              -54.66860384291222,
              -30.03448533909505
            ],
            [
              -54.6738025069488,
              -30.031893297812086
            ],
            [
              -54.677418968887295,
              -30.030911463992783
            ],
            [
              -54.67990528647,
              -30.031107830756646
            ],
            [
              -54.68221078095579,
              -30.03208966457595
            ],
            [
              -54.68510395050659,
              -30.03601699985316
            ],
            [
              -54.687002593024296,
              -30.037195200436326
            ],
            [
              -54.688901235542005,
              -30.037587933964044
            ],
            [
              -54.69147796467318,
              -30.037195200436326
            ],
            [
              -54.69342181296512,
              -30.035584992972666
            ],
            [
              -54.69459716309513,
              -30.031814751106545
            ],
            [
              -54.69581771899937,
              -30.029890356820708
            ],
            [
              -54.69970541558325,
              -30.02879070294309
            ],
            [
              -54.70300543710212,
              -30.02898706970695
            ],
            [
              -54.704316404554824,
              -30.028712156237546
            ],
            [
              -54.706305458620996,
              -30.025688108074092
            ],
            [
              -54.709017805074865,
              -30.02470627425479
            ],
            [
              -54.71118768223796,
              -30.025216827840826
            ],
            [
              -54.712091797722586,
              -30.02659139518785
            ],
            [
              -54.71218220927105,
              -30.030715097228924
            ],
            [
              -54.71340276517529,
              -30.031893297812086
            ],
            [
              -54.715482230789924,
              -30.032286031339808
            ],
            [
              -54.71909869272841,
              -30.032286031339808
            ],
            [
              -54.72099733524612,
              -30.031618384342682
            ],
            [
              -54.72312200663499,
              -30.03008672358457
            ],
            [
              -54.72447817986192,
              -30.029615443351304
            ],
            [
              -54.7290891688335,
              -30.029301256529127
            ],
            [
              -54.73130425177082,
              -30.028319422709824
            ],
            [
              -54.732479601900835,
              -30.02678776195171
            ],
            [
              -54.7317111037389,
              -30.02399935390489
            ],
            [
              -54.7359152407424,
              -30.02101457909421
            ],
            [
              -54.73758785438895,
              -30.020896759035892
            ],
            [
              -54.74061664126244,
              -30.022585513205094
            ],
            [
              -54.744911189814395,
              -30.02348880031885
            ],
            [
              -54.75078794046445,
              -30.02121094585807
            ],
            [
              -54.754992077467946,
              -30.02101457909421
            ],
            [
              -54.75571536985564,
              -30.022389146441235
            ],
            [
              -54.75481125437102,
              -30.024392087432613
            ],
            [
              -54.75571536985564,
              -30.025688108074092
            ],
            [
              -54.755805781404106,
              -30.028515789473683
            ],
            [
              -54.75698113153411,
              -30.029811810115167
            ],
            [
              -54.759603066439524,
              -30.03079364393447
            ],
            [
              -54.75720716040527,
              -30.03248239810367
            ],
            [
              -54.75698113153411,
              -30.033896238803464
            ],
            [
              -54.75557975253295,
              -30.034681705858908
            ],
            [
              -54.75680030843719,
              -30.036409733380882
            ],
            [
              -54.75670989688873,
              -30.03860904113612
            ],
            [
              -54.757885247018734,
              -30.04041561536364
            ],
            [
              -54.75910580292298,
              -30.04080834889136
            ],
            [
              -54.761501708957226,
              -30.04041561536364
            ],
            [
              -54.76398802653994,
              -30.043518210232637
            ],
            [
              -54.76462090737918,
              -30.046581531748863
            ],
            [
              -54.76660996144535,
              -30.047288452098762
            ],
            [
              -54.767694900026896,
              -30.0487808395041
            ],
            [
              -54.769186690576525,
              -30.049095026326277
            ],
            [
              -54.769593542544605,
              -30.050194680203898
            ],
            [
              -54.77158259661078,
              -30.051097967317656
            ],
            [
              -54.77289356406348,
              -30.052511808017453
            ],
            [
              -54.77298397561194,
              -30.054986029242098
            ],
            [
              -54.77361685645118,
              -30.05651769000021
            ],
            [
              -54.775922350936966,
              -30.05781371064169
            ],
            [
              -54.776600437550435,
              -30.058991911224854
            ],
            [
              -54.776600437550435,
              -30.06311561326593
            ],
            [
              -54.777414141486595,
              -30.067514228776407
            ],
            [
              -54.77750455303506,
              -30.069595716473327
            ],
            [
              -54.77840866851968,
              -30.07038118352877
            ],
            [
              -54.7780018165516,
              -30.071716477523022
            ],
            [
              -54.77867990316506,
              -30.074112152042122
            ],
            [
              -54.777820993454675,
              -30.076193639739046
            ],
            [
              -54.77691687797005,
              -30.07721474691112
            ],
            [
              -54.77641961445351,
              -30.08039588848566
            ],
            [
              -54.7780018165516,
              -30.08290938306308
            ],
            [
              -54.77981004752085,
              -30.083812670176837
            ],
            [
              -54.78238677665202,
              -30.083105749826938
            ],
            [
              -54.789619700529,
              -30.094298655366995
            ],
            [
              -54.790116964045545,
              -30.093905921839273
            ],
            [
              -54.79368822020981,
              -30.095280489186298
            ],
            [
              -54.79929373621447,
              -30.095987409536196
            ],
            [
              -54.80110196718372,
              -30.097087063413817
            ],
            [
              -54.801599230700255,
              -30.098186717291437
            ],
            [
              -54.80399513673451,
              -30.100189658282815
            ],
            [
              -54.80580336770375,
              -30.10081803192717
            ],
            [
              -54.81000750470725,
              -30.10321370644627
            ],
            [
              -54.81000750470725,
              -30.104313360323886
            ],
            [
              -54.81321711467766,
              -30.106002114493087
            ],
            [
              -54.81488972832422,
              -30.106512668079127
            ],
            [
              -54.81719522281001,
              -30.10788723542615
            ],
            [
              -54.819681540392715,
              -30.10808360219001
            ],
            [
              -54.82578431991392,
              -30.10509882737933
            ],
            [
              -54.83188709943513,
              -30.104784640557153
            ],
            [
              -54.83468985743746,
              -30.10380280673785
            ],
            [
              -54.836000824890164,
              -30.102899519624092
            ],
            [
              -54.83749261543979,
              -30.103410073210128
            ],
            [
              -54.8393912579575,
              -30.10199623251033
            ],
            [
              -54.84088304850712,
              -30.100189658282815
            ],
            [
              -54.84318854299291,
              -30.100189658282815
            ],
            [
              -54.845177597059084,
              -30.09940419122737
            ],
            [
              -54.84608171254371,
              -30.10121076545489
            ],
            [
              -54.847618708867564,
              -30.10199623251033
            ],
            [
              -54.84929132251412,
              -30.099993291518953
            ],
            [
              -54.85358587106608,
              -30.098500904113614
            ],
            [
              -54.85720233300457,
              -30.09791180382203
            ],
            [
              -54.85779000806958,
              -30.098383084055296
            ],
            [
              -54.86271743746077,
              -30.097087063413817
            ],
            [
              -54.86497772617233,
              -30.097597616999852
            ],
            [
              -54.86669554559311,
              -30.09641941641669
            ],
            [
              -54.87130653456469,
              -30.095594676008474
            ],
            [
              -54.87419970411548,
              -30.096497963122236
            ],
            [
              -54.877002462117815,
              -30.096105229594514
            ],
            [
              -54.87921754505514,
              -30.096890696649954
            ],
            [
              -54.879307956603604,
              -30.098108170585892
            ],
            [
              -54.88301483009056,
              -30.098500904113614
            ],
            [
              -54.8835120936071,
              -30.09960055799123
            ],
            [
              -54.888620346095216,
              -30.099207824463512
            ],
            [
              -54.891603927194474,
              -30.099993291518953
            ],
            [
              -54.89332174661526,
              -30.096497963122236
            ],
            [
              -54.89662176813413,
              -30.09461284218917
            ],
            [
              -54.896712179682595,
              -30.092099347611757
            ],
            [
              -54.89720944319914,
              -30.09088187367582
            ],
            [
              -54.89992178965301,
              -30.087504365337416
            ],
            [
              -54.89969576078185,
              -30.08530505758218
            ],
            [
              -54.90118755133148,
              -30.08408758364624
            ],
            [
              -54.899379320362236,
              -30.079688968135763
            ],
            [
              -54.90069028781494,
              -30.078903501080323
            ],
            [
              -54.90200125526764,
              -30.07941405466636
            ],
            [
              -54.906702655787676,
              -30.078785681022005
            ],
            [
              -54.90909856182193,
              -30.078785681022005
            ],
            [
              -54.91149446785618,
              -30.077686027144384
            ],
            [
              -54.91348352192235,
              -30.075800906211324
            ],
            [
              -54.91470407782659,
              -30.073287411633906
            ],
            [
              -54.91691916076392,
              -30.07238412452015
            ],
            [
              -54.91850136286201,
              -30.07108810387867
            ],
            [
              -54.92162056128396,
              -30.070106270059366
            ],
            [
              -54.924920582802834,
              -30.069517169767785
            ],
            [
              -54.928311015870165,
              -30.06798550900967
            ],
            [
              -54.93269597597059,
              -30.063586893499192
            ],
            [
              -54.934504206939835,
              -30.06558983449057
            ],
            [
              -54.93631243790908,
              -30.06558983449057
            ],
            [
              -54.93848231507218,
              -30.06610038807661
            ],
            [
              -54.94060698646104,
              -30.068613882654024
            ],
            [
              -54.942596040527214,
              -30.06998845000105
            ],
            [
              -54.94268645207567,
              -30.071284470642528
            ],
            [
              -54.941511101945665,
              -30.072305577814603
            ],
            [
              -54.94331933291491,
              -30.07348377839777
            ],
            [
              -54.94530838698108,
              -30.073208864928365
            ],
            [
              -54.946393325562624,
              -30.07430851880598
            ],
            [
              -54.94648373711109,
              -30.075408172683602
            ],
            [
              -54.94860840849995,
              -30.076586373266768
            ],
            [
              -54.94829196808033,
              -30.0792176879025
            ],
            [
              -54.94887964314534,
              -30.082595196240902
            ],
            [
              -54.951094726082665,
              -30.08420540370456
            ],
            [
              -54.95570571505424,
              -30.0856977911099
            ],
            [
              -54.957287917152335,
              -30.085383604287724
            ],
            [
              -54.959593411638124,
              -30.08719017851524
            ],
            [
              -54.961582465704296,
              -30.087111631809695
            ],
            [
              -54.96379754864162,
              -30.088682565920582
            ],
            [
              -54.96578660270779,
              -30.088093465629
            ],
            [
              -54.96709757016049,
              -30.088800385978896
            ],
            [
              -54.968092097193576,
              -30.087386545279102
            ],
            [
              -54.969312653097816,
              -30.087818552159593
            ],
            [
              -54.971618147583605,
              -30.087111631809695
            ],
            [
              -54.9745113171344,
              -30.087386545279102
            ],
            [
              -54.97491816910248,
              -30.08899675274276
            ],
            [
              -54.9766811942975,
              -30.088918206037214
            ],
            [
              -54.97839901371828,
              -30.091706614084035
            ],
            [
              -54.980116833139064,
              -30.09268844790334
            ],
            [
              -54.98038806778445,
              -30.09461284218917
            ],
            [
              -54.986310024208734,
              -30.09618377630006
            ],
            [
              -54.99431144624764,
              -30.107219588429025
            ],
            [
              -54.99648132341074,
              -30.108515609070505
            ],
            [
              -54.99851558325114,
              -30.110597096767428
            ],
            [
              -55.00000737380077,
              -30.110597096767428
            ],
            [
              -55.00158957589886,
              -30.112089484172767
            ],
            [
              -55.00131834125347,
              -30.11511353233622
            ],
            [
              -55.00068546041424,
              -30.115898999391664
            ],
            [
              -55.00109231238232,
              -30.117195020033144
            ],
            [
              -55.00050463731731,
              -30.1188052274968
            ],
            [
              -55.00131834125347,
              -30.122614742715697
            ],
            [
              -55.002086839415405,
              -30.123282389712823
            ],
            [
              -55.00271972025464,
              -30.125088963940343
            ],
            [
              -55.00579371290235,
              -30.128113012103796
            ],
            [
              -55.005884124450816,
              -30.129291212686958
            ],
            [
              -55.00719509190352,
              -30.130312319859033
            ],
            [
              -55.009681409486234,
              -30.12968394621468
            ],
            [
              -55.01230334439164,
              -30.12948757945082
            ],
            [
              -55.01501569084551,
              -30.129998133036857
            ],
            [
              -55.01718556800861,
              -30.12968394621468
            ],
            [
              -55.019084210526316,
              -30.128702112395377
            ],
            [
              -55.02202258585134,
              -30.12991958633131
            ],
            [
              -55.023017112884425,
              -30.1314905204422
            ],
            [
              -55.02468972653098,
              -30.132197440792098
            ],
            [
              -55.027085632565225,
              -30.1338861949613
            ],
            [
              -55.03079250605218,
              -30.134789482075057
            ],
            [
              -55.03978845512418,
              -30.135496402424955
            ],
            [
              -55.04349532861114,
              -30.135103668897234
            ],
            [
              -55.0443090325473,
              -30.1362818694804
            ],
            [
              -55.04589123464538,
              -30.136203322774854
            ],
            [
              -55.0483775522281,
              -30.13730297665247
            ],
            [
              -55.050004960100416,
              -30.13730297665247
            ],
            [
              -55.05009537164888,
              -30.138284810471777
            ],
            [
              -55.052581689231594,
              -30.138991730821672
            ],
            [
              -55.05470636062046,
              -30.13891318411613
            ],
            [
              -55.05610773962162,
              -30.139895017935434
            ],
            [
              -55.056605003138166,
              -30.141819412221267
            ],
            [
              -55.05818720523626,
              -30.14339034633215
            ],
            [
              -55.06049269972205,
              -30.144882733737493
            ],
            [
              -55.06139681520667,
              -30.14350816639047
            ],
            [
              -55.06261737111091,
              -30.14331179962661
            ],
            [
              -55.06569136375863,
              -30.14170159216295
            ],
            [
              -55.068087269792876,
              -30.141819412221267
            ],
            [
              -55.06948864879404,
              -30.137106609888612
            ],
            [
              -55.0697146776652,
              -30.1338861949613
            ],
            [
              -55.07048317582713,
              -30.129291212686958
            ],
            [
              -55.071477702860214,
              -30.12779882528162
            ],
            [
              -55.075094164798706,
              -30.127209724990035
            ],
            [
              -55.07608869183179,
              -30.12469623041262
            ],
            [
              -55.07708321886488,
              -30.1243034968849
            ],
            [
              -55.07681198421949,
              -30.120101248138283
            ],
            [
              -55.07532019366986,
              -30.11931578108284
            ],
            [
              -55.07500375325024,
              -30.1171164733276
            ],
            [
              -55.075501016766786,
              -30.114406611986322
            ],
            [
              -55.07360237424908,
              -30.111814570703363
            ],
            [
              -55.073511962700614,
              -30.110714916825742
            ],
            [
              -55.0745064897337,
              -30.10918325606763
            ],
            [
              -55.07541060521832,
              -30.109418896184263
            ],
            [
              -55.07771609970411,
              -30.10659121478467
            ],
            [
              -55.07979556531875,
              -30.10560938096537
            ],
            [
              -55.082191471353,
              -30.103017339682406
            ],
            [
              -55.08110653277145,
              -30.10160349898261
            ],
            [
              -55.08119694431991,
              -30.09901145769965
            ],
            [
              -55.08368326190263,
              -30.098697270877473
            ],
            [
              -55.0835024388057,
              -30.096812149944412
            ],
            [
              -55.08467778893571,
              -30.09551612930293
            ],
            [
              -55.08431614274186,
              -30.094416475425312
            ],
            [
              -55.084813406258405,
              -30.09221716767007
            ],
            [
              -55.08467778893571,
              -30.083616303412978
            ],
            [
              -55.08689287187304,
              -30.077686027144384
            ],
            [
              -55.090509333811525,
              -30.071598657464705
            ],
            [
              -55.09109700887653,
              -30.07018481676491
            ],
            [
              -55.092407976329234,
              -30.06920298294561
            ],
            [
              -55.0938093553304,
              -30.06610038807661
            ],
            [
              -55.093583326459246,
              -30.06480436743513
            ],
            [
              -55.094397030395406,
              -30.06390108032137
            ],
            [
              -55.09869157894737,
              -30.060680665394056
            ],
            [
              -55.098194315430824,
              -30.059816651633067
            ],
            [
              -55.09828472697929,
              -30.056007136414173
            ],
            [
              -55.10108748498162,
              -30.053493641836756
            ],
            [
              -55.10031898681969,
              -30.050391046967757
            ],
            [
              -55.10090666188469,
              -30.049212846384595
            ],
            [
              -55.09968610598045,
              -30.04768118562648
            ],
            [
              -55.09991213485161,
              -30.04618879822114
            ],
            [
              -55.09918884246391,
              -30.044892777579662
            ],
            [
              -55.09719978839774,
              -30.043007656646598
            ],
            [
              -55.093990178427326,
              -30.040690528833043
            ],
            [
              -55.094803882363486,
              -30.039787241719285
            ],
            [
              -55.09570799784811,
              -30.037195200436326
            ],
            [
              -55.094803882363486,
              -30.035506446267124
            ],
            [
              -55.09611484981619,
              -30.034603159153363
            ],
            [
              -55.09927925401237,
              -30.035702813030984
            ],
            [
              -55.10049980991661,
              -30.035113712739403
            ],
            [
              -55.10257927553125,
              -30.036409733380882
            ],
            [
              -55.1028053044024,
              -30.03770575402236
            ],
            [
              -55.10511079888819,
              -30.03951232824988
            ],
            [
              -55.105879297050116,
              -30.03900177466384
            ],
            [
              -55.107777939567825,
              -30.03970869501374
            ],
            [
              -55.11080672644131,
              -30.045010597637976
            ],
            [
              -55.11320263247556,
              -30.046110251515596
            ],
            [
              -55.11718074060791,
              -30.046817171865495
            ],
            [
              -55.11939582354523,
              -30.04599243145728
            ],
            [
              -55.11980267551331,
              -30.0439894904659
            ],
            [
              -55.12468489913028,
              -30.04261492311888
            ],
            [
              -55.12599586658298,
              -30.04269346982442
            ],
            [
              -55.12839177261723,
              -30.04151526924126
            ],
            [
              -55.132595909620726,
              -30.041318902477396
            ],
            [
              -55.133816465524966,
              -30.04190800276898
            ],
            [
              -55.135715108042675,
              -30.041790182710663
            ],
            [
              -55.137206898592304,
              -30.042418556355017
            ],
            [
              -55.14077815475657,
              -30.046110251515596
            ],
            [
              -55.14091377207926,
              -30.048505926034697
            ],
            [
              -55.14168227024119,
              -30.0487808395041
            ],
            [
              -55.14208912220927,
              -30.054082742128337
            ],
            [
              -55.14398776472698,
              -30.053886375364478
            ],
            [
              -55.14679052272931,
              -30.05211907448973
            ],
            [
              -55.14710696314893,
              -30.05058741373162
            ],
            [
              -55.14941245763472,
              -30.049487759854
            ],
            [
              -55.150678219313185,
              -30.048113192506975
            ],
            [
              -55.15198918676589,
              -30.047799005684798
            ],
            [
              -55.15438509280014,
              -30.048505926034697
            ],
            [
              -55.15578647180131,
              -30.050508867026075
            ],
            [
              -55.157685114319015,
              -30.050508867026075
            ],
            [
              -55.15899608177172,
              -30.049605579912317
            ],
            [
              -55.16089472428943,
              -30.0470920853349
            ],
            [
              -55.162793366807136,
              -30.043714576996496
            ],
            [
              -55.165505713261005,
              -30.0439894904659
            ],
            [
              -55.1683988828118,
              -30.042889836588284
            ],
            [
              -55.172286579395674,
              -30.044814230874117
            ],
            [
              -55.17441125078454,
              -30.044814230874117
            ],
            [
              -55.178208535819955,
              -30.04579606469342
            ],
            [
              -55.177801683851875,
              -30.04768118562648
            ],
            [
              -55.17979073791805,
              -30.04819173921252
            ],
            [
              -55.17979073791805,
              -30.05078378049548
            ],
            [
              -55.18177979198422,
              -30.053807828658933
            ],
            [
              -55.18232226127499,
              -30.055418036122592
            ],
            [
              -55.183316788308076,
              -30.056282049883578
            ],
            [
              -55.184401726889625,
              -30.058795544460992
            ],
            [
              -55.186978456020796,
              -30.060994852216233
            ],
            [
              -55.18679763292388,
              -30.063390526735333
            ],
            [
              -55.18738530798888,
              -30.064686547376812
            ],
            [
              -55.187520925311574,
              -30.067906962304125
            ],
            [
              -55.18471816730924,
              -30.068299695831847
            ],
            [
              -55.184401726889625,
              -30.069909903295503
            ],
            [
              -55.18539625392271,
              -30.071402290700846
            ],
            [
              -55.186300369407334,
              -30.074387065511527
            ],
            [
              -55.18761133686004,
              -30.076586373266768
            ],
            [
              -55.18801818882812,
              -30.078982047785868
            ],
            [
              -55.19131821034699,
              -30.08031734178012
            ],
            [
              -55.194392202994706,
              -30.080081701663484
            ],
            [
              -55.19611002241549,
              -30.081181355541105
            ],
            [
              -55.1993196323859,
              -30.08239882947704
            ],
            [
              -55.201489509549,
              -30.083694850118523
            ],
            [
              -55.209219696942526,
              -30.0856977911099
            ],
            [
              -55.2123841011387,
              -30.08530505758218
            ],
            [
              -55.214915624495646,
              -30.08279156300476
            ],
            [
              -55.21509644759257,
              -30.081299175599423
            ],
            [
              -55.21609097462566,
              -30.08031734178012
            ],
            [
              -55.218712909531064,
              -30.080199521721802
            ],
            [
              -55.22228416569533,
              -30.079492601371904
            ],
            [
              -55.223007458083025,
              -30.07811803402488
            ],
            [
              -55.22278142921187,
              -30.075800906211324
            ],
            [
              -55.22522254102035,
              -30.076586373266768
            ],
            [
              -55.22712118353806,
              -30.076782740030627
            ],
            [
              -55.2276184470546,
              -30.07811803402488
            ],
            [
              -55.23308834573657,
              -30.077882393908247
            ],
            [
              -55.23521301712543,
              -30.078903501080323
            ],
            [
              -55.24018565229086,
              -30.07941405466636
            ],
            [
              -55.24208429480857,
              -30.08039588848566
            ],
            [
              -55.244977464359366,
              -30.08110280883556
            ],
            [
              -55.247282958845155,
              -30.079885334899625
            ],
            [
              -55.24900077826594,
              -30.08051370854398
            ],
            [
              -55.25058298036402,
              -30.079492601371904
            ],
            [
              -55.2538830018829,
              -30.079688968135763
            ],
            [
              -55.25428985385098,
              -30.08200609594932
            ],
            [
              -55.255917261723305,
              -30.08200609594932
            ],
            [
              -55.25641452523984,
              -30.0833021165908
            ],
            [
              -55.25921728324217,
              -30.083694850118523
            ],
            [
              -55.260392633372184,
              -30.084715957290598
            ],
            [
              -55.262788539406436,
              -30.084401770468418
            ],
            [
              -55.2649132107953,
              -30.083105749826938
            ],
            [
              -55.266314589796465,
              -30.0833021165908
            ],
            [
              -55.2691173477988,
              -30.08239882947704
            ],
            [
              -55.27128722496189,
              -30.08110280883556
            ],
            [
              -55.27408998296422,
              -30.080984988777246
            ],
            [
              -55.27879138348426,
              -30.083184296532483
            ],
            [
              -55.28041879135658,
              -30.085815611168215
            ],
            [
              -55.28109687797005,
              -30.088211285687315
            ],
            [
              -55.28240784542275,
              -30.090214226678693
            ],
            [
              -55.28512019187662,
              -30.091588794025718
            ],
            [
              -55.28512019187662,
              -30.096301596358373
            ],
            [
              -55.28719965749126,
              -30.098383084055296
            ],
            [
              -55.28738048058818,
              -30.100896578632714
            ],
            [
              -55.28701883439433,
              -30.102310419332508
            ],
            [
              -55.2884202133955,
              -30.103606439973987
            ],
            [
              -55.29090653097821,
              -30.103017339682406
            ],
            [
              -55.291810646462835,
              -30.102192599274193
            ],
            [
              -55.2919010580113,
              -30.100386025046674
            ],
            [
              -55.29131338294629,
              -30.095712496066792
            ],
            [
              -55.29312161391554,
              -30.092295714375616
            ],
            [
              -55.295607931498246,
              -30.08848619915672
            ],
            [
              -55.29741616246749,
              -30.088014918923456
            ],
            [
              -55.300580566663676,
              -30.087897098865138
            ],
            [
              -55.302479209181385,
              -30.088682565920582
            ],
            [
              -55.30550799605487,
              -30.087897098865138
            ],
            [
              -55.307994313637586,
              -30.087818552159593
            ],
            [
              -55.31079707163992,
              -30.08660107822366
            ],
            [
              -55.313283389222626,
              -30.084912324054457
            ],
            [
              -55.31450394512687,
              -30.083105749826938
            ],
            [
              -55.31310256612571,
              -30.081299175599423
            ],
            [
              -55.31228886218954,
              -30.080081701663484
            ],
            [
              -55.309214869541826,
              -30.0785107675526
            ],
            [
              -55.30858198870259,
              -30.077096926852803
            ],
            [
              -55.30749705012104,
              -30.07701838014726
            ],
            [
              -55.304513469021785,
              -30.074897619097566
            ],
            [
              -55.30428744015063,
              -30.07348377839777
            ],
            [
              -55.30528196718372,
              -30.072109211050744
            ],
            [
              -55.302479209181385,
              -30.06979208323719
            ],
            [
              -55.30039974356675,
              -30.06759277548195
            ],
            [
              -55.29759698556442,
              -30.064215267143545
            ],
            [
              -55.29447778714247,
              -30.063508346793647
            ],
            [
              -55.29068050210705,
              -30.060287931866334
            ],
            [
              -55.28719965749126,
              -30.05820644416941
            ],
            [
              -55.285481838070474,
              -30.054907482536553
            ],
            [
              -55.28340237245584,
              -30.052590354722998
            ],
            [
              -55.28109687797005,
              -30.05168706760924
            ],
            [
              -55.28041879135658,
              -30.048505926034697
            ],
            [
              -55.28078043755043,
              -30.04618879822114
            ],
            [
              -55.278881795032724,
              -30.045717517987875
            ],
            [
              -55.27838453151618,
              -30.0446964108158
            ],
            [
              -55.2779776795481,
              -30.041986549474522
            ],
            [
              -55.27531053886846,
              -30.040886895596906
            ],
            [
              -55.27359271944768,
              -30.04139744918294
            ],
            [
              -55.27160366538151,
              -30.03951232824988
            ],
            [
              -55.27069954989689,
              -30.04041561536364
            ],
            [
              -55.26961461131534,
              -30.039905061777603
            ],
            [
              -55.268981730476106,
              -30.03841267437226
            ],
            [
              -55.27002146328342,
              -30.036095546558705
            ],
            [
              -55.26848446695956,
              -30.034995892681085
            ],
            [
              -55.26758035147494,
              -30.031893297812086
            ],
            [
              -55.26789679189456,
              -30.03079364393447
            ],
            [
              -55.26681185331301,
              -30.029301256529127
            ],
            [
              -55.267806380346094,
              -30.023213886849447
            ],
            [
              -55.26640500134493,
              -30.021917866207968
            ],
            [
              -55.26649541289339,
              -30.019011638102832
            ],
            [
              -55.26721870528109,
              -30.017597797403035
            ],
            [
              -55.26681185331301,
              -30.01661596358373
            ],
            [
              -55.26518444544069,
              -30.016694510289273
            ],
            [
              -55.26310497982605,
              -30.014887936061758
            ],
            [
              -55.26088989688873,
              -30.014613022592354
            ],
            [
              -55.2593981063391,
              -30.013906102242455
            ],
            [
              -55.258900842822555,
              -30.012806448364834
            ],
            [
              -55.25948851788756,
              -30.010214407081875
            ],
            [
              -55.25831316775755,
              -30.008211466090497
            ],
            [
              -55.259985781404104,
              -30.004480497577145
            ],
            [
              -55.25948851788756,
              -30.002084823058045
            ],
            [
              -55.25799672733793,
              -30.0012993560026
            ],
            [
              -55.25578164440061,
              -29.997882574311426
            ],
            [
              -55.25510355778714,
              -29.995604719850643
            ],
            [
              -55.252978886398274,
              -29.993719598917583
            ],
            [
              -55.25221038823635,
              -29.99199157139561
            ],
            [
              -55.2496788648794,
              -29.99128465104571
            ],
            [
              -55.24881995516901,
              -29.990302817226407
            ],
            [
              -55.24520349323052,
              -29.987907142707307
            ],
            [
              -55.244977464359366,
              -29.98649330200751
            ],
            [
              -55.24610760871514,
              -29.984215447546728
            ],
            [
              -55.2448870528109,
              -29.982291053260894
            ],
            [
              -55.24389252577782,
              -29.976596417108933
            ],
            [
              -55.244615818165514,
              -29.97219780159846
            ],
            [
              -55.24348567380974,
              -29.96968430702104
            ],
            [
              -55.24181306016318,
              -29.967681366029662
            ],
            [
              -55.24090894467856,
              -29.965010778041158
            ],
            [
              -55.240004829193936,
              -29.963911124163538
            ],
            [
              -55.240411681162016,
              -29.96249728346374
            ],
            [
              -55.2400952407424,
              -29.961083442763943
            ],
            [
              -55.240004829193936,
              -29.957391747603364
            ],
            [
              -55.237202071191604,
              -29.954681886262087
            ],
            [
              -55.23702124809468,
              -29.953700052442784
            ],
            [
              -55.23539384022236,
              -29.95271821862348
            ],
            [
              -55.235303428673895,
              -29.950793824337648
            ],
            [
              -55.23331437460773,
              -29.94859451658241
            ],
            [
              -55.23430890164081,
              -29.946709395649346
            ],
            [
              -55.23430890164081,
              -29.94270351366659
            ],
            [
              -55.23317875728503,
              -29.93971873885591
            ],
            [
              -55.23209381870348,
              -29.939090365211555
            ],
            [
              -55.230421205056935,
              -29.934416836231673
            ],
            [
              -55.23028558773424,
              -29.932413895240295
            ],
            [
              -55.229607501120775,
              -29.92938984707684
            ],
            [
              -55.22440883708419,
              -29.92181008999182
            ],
            [
              -55.22251019456648,
              -29.9200035157643
            ],
            [
              -55.21979784811261,
              -29.91980714900044
            ],
            [
              -55.216678649690664,
              -29.921495903169642
            ],
            [
              -55.21509644759257,
              -29.921181716347466
            ],
            [
              -55.21202245494486,
              -29.92290974386944
            ],
            [
              -55.211118339460235,
              -29.922006456755682
            ],
            [
              -55.2083155814579,
              -29.921888636697364
            ],
            [
              -55.20578405810096,
              -29.920082062469845
            ],
            [
              -55.20469911951941,
              -29.918903861886683
            ],
            [
              -55.20320732896978,
              -29.91921804870886
            ],
            [
              -55.20072101138707,
              -29.916900920895305
            ],
            [
              -55.197511401416655,
              -29.915801267017684
            ],
            [
              -55.196019610867026,
              -29.916194000545406
            ],
            [
              -55.194392202994706,
              -29.915487080195508
            ],
            [
              -55.19271958934816,
              -29.913209225734725
            ],
            [
              -55.191408621895455,
              -29.912109571857105
            ],
            [
              -55.189690802474665,
              -29.909596077279687
            ],
            [
              -55.18860586389312,
              -29.908810610224247
            ],
            [
              -55.18738530798888,
              -29.906611302469006
            ],
            [
              -55.18381405182462,
              -29.90370507436387
            ],
            [
              -55.18159896888729,
              -29.90001337920329
            ],
            [
              -55.179700326369584,
              -29.899581372322796
            ],
            [
              -55.17689756836725,
              -29.895182756812318
            ],
            [
              -55.17608386443109,
              -29.893219089173712
            ],
            [
              -55.17608386443109,
              -29.892001615237778
            ],
            [
              -55.17490851430108,
              -29.890980508065702
            ],
            [
              -55.17432083923608,
              -29.889016840427093
            ],
            [
              -55.17441125078454,
              -29.887406632963437
            ],
            [
              -55.17328110642876,
              -29.88508950514988
            ],
            [
              -55.17368795839684,
              -29.883086564158504
            ],
            [
              -55.17169890433067,
              -29.88021960940614
            ],
            [
              -55.16961943871604,
              -29.87860940194248
            ],
            [
              -55.1670879153591,
              -29.877706114828722
            ],
            [
              -55.165912565229085,
              -29.876685007656647
            ],
            [
              -55.164420774679456,
              -29.874407153195865
            ],
            [
              -55.163200218775216,
              -29.874289333137547
            ],
            [
              -55.16089472428943,
              -29.875310440309622
            ],
            [
              -55.155922089124,
              -29.875388987015167
            ],
            [
              -55.15262206760513,
              -29.875192620251305
            ],
            [
              -55.15031657311934,
              -29.87209002538231
            ],
            [
              -55.14941245763472,
              -29.871893658618447
            ],
            [
              -55.14859875369856,
              -29.870008537685386
            ],
            [
              -55.14900560566664,
              -29.868516150280044
            ],
            [
              -55.15158233479781,
              -29.864981548530555
            ],
            [
              -55.15049739621626,
              -29.862389507247592
            ],
            [
              -55.15090424818435,
              -29.86101493990057
            ],
            [
              -55.152712479153585,
              -29.859797465964633
            ],
            [
              -55.15311933112167,
              -29.855595217218017
            ],
            [
              -55.151085071281265,
              -29.853710096284953
            ],
            [
              -55.14611243611584,
              -29.8530817226406
            ],
            [
              -55.144620645566214,
              -29.852099888821297
            ],
            [
              -55.14159185869273,
              -29.852099888821297
            ],
            [
              -55.140280891240025,
              -29.851118055001994
            ],
            [
              -55.140416508562716,
              -29.84990058106606
            ],
            [
              -55.13951239307809,
              -29.848211826896858
            ],
            [
              -55.1401000681431,
              -29.84699435296092
            ],
            [
              -55.13978362772348,
              -29.84389175809192
            ],
            [
              -55.14059733165964,
              -29.843616844622517
            ],
            [
              -55.14199871066081,
              -29.84149608357282
            ],
            [
              -55.1443042051466,
              -29.841888817100543
            ],
            [
              -55.14651928808392,
              -29.840985529986785
            ],
            [
              -55.14719737469739,
              -29.83890404228986
            ],
            [
              -55.14719737469739,
              -29.836901101298483
            ],
            [
              -55.148915194118175,
              -29.83591926747918
            ],
            [
              -55.14737819779431,
              -29.834191239957207
            ],
            [
              -55.14751381511701,
              -29.831795565438107
            ],
            [
              -55.14900560566664,
              -29.83128501185207
            ],
            [
              -55.1509946597328,
              -29.828418057099704
            ],
            [
              -55.14819190173048,
              -29.825708195758427
            ],
            [
              -55.144620645566214,
              -29.823116154475468
            ],
            [
              -55.141501447144265,
              -29.821388126953494
            ],
            [
              -55.139195952658476,
              -29.82221286736171
            ],
            [
              -55.13580551959114,
              -29.820995393425772
            ],
            [
              -55.13318358468573,
              -29.82060265989805
            ],
            [
              -55.1311041190711,
              -29.82150594701181
            ],
            [
              -55.12929588810185,
              -29.82170231377567
            ],
            [
              -55.127306834035686,
              -29.82111321348409
            ],
            [
              -55.1263123070026,
              -29.82001355960647
            ],
            [
              -55.12540819151798,
              -29.81781425185123
            ],
            [
              -55.12540819151798,
              -29.816086224329258
            ],
            [
              -55.123283520129114,
              -29.815693490801536
            ],
            [
              -55.12129446606294,
              -29.814201103396194
            ],
            [
              -55.120706790997936,
              -29.812512349226992
            ],
            [
              -55.1207972025464,
              -29.810313041471755
            ],
            [
              -55.11980267551331,
              -29.80929193429968
            ],
            [
              -55.119893087061776,
              -29.807210446602756
            ],
            [
              -55.11740676947906,
              -29.80501113884752
            ],
            [
              -55.11577936160674,
              -29.80430421849762
            ],
            [
              -55.11419715950865,
              -29.80131944368694
            ],
            [
              -55.11189166502286,
              -29.800180516456546
            ],
            [
              -55.11229851699094,
              -29.799198682637243
            ],
            [
              -55.113699895992106,
              -29.79931650269556
            ],
            [
              -55.115598538509815,
              -29.798295395523485
            ],
            [
              -55.11419715950865,
              -29.795781900946068
            ],
            [
              -55.11379030754057,
              -29.79428951354073
            ],
            [
              -55.112479340087866,
              -29.792797126135387
            ],
            [
              -55.11577936160674,
              -29.788712697447085
            ],
            [
              -55.116819094414055,
              -29.785413735814227
            ],
            [
              -55.1152820980902,
              -29.781486400537016
            ],
            [
              -55.11591497892943,
              -29.779994013131674
            ],
            [
              -55.11550812696135,
              -29.77771615867089
            ],
            [
              -55.11690950596252,
              -29.776891418262675
            ],
            [
              -55.11858211960907,
              -29.777794705376436
            ],
            [
              -55.11971226396485,
              -29.777598338612574
            ],
            [
              -55.1221081699991,
              -29.775909584443372
            ],
            [
              -55.12509175109836,
              -29.77551685091565
            ],
            [
              -55.12509175109836,
              -29.77398519015754
            ],
            [
              -55.12359996054873,
              -29.77268916951606
            ],
            [
              -55.125317779969514,
              -29.77139314887458
            ],
            [
              -55.1255890146149,
              -29.770097128233097
            ],
            [
              -55.12468489913028,
              -29.768408374063895
            ],
            [
              -55.12378078364566,
              -29.768408374063895
            ],
            [
              -55.123283520129114,
              -29.77029349499696
            ],
            [
              -55.121384877611405,
              -29.771000415346858
            ],
            [
              -55.12011911593293,
              -29.77068622852468
            ],
            [
              -55.11980267551331,
              -29.76919384111934
            ],
            [
              -55.121520494934096,
              -29.768918927649935
            ],
            [
              -55.12170131803102,
              -29.7669945333641
            ],
            [
              -55.12482051645297,
              -29.766915986658557
            ],
            [
              -55.12789450910069,
              -29.766405433072517
            ],
            [
              -55.13160138258764,
              -29.765187959136583
            ],
            [
              -55.134901404106515,
              -29.76310647143966
            ],
            [
              -55.1358959311396,
              -29.76129989721214
            ],
            [
              -55.135986342688064,
              -29.75921840951522
            ],
            [
              -55.13539866762306,
              -29.757097648465525
            ],
            [
              -55.13390687707343,
              -29.755605261060182
            ],
            [
              -55.13101370752264,
              -29.754112873654844
            ],
            [
              -55.127713686003766,
              -29.751717199135744
            ],
            [
              -55.12640271855106,
              -29.749203704558326
            ],
            [
              -55.126086278131446,
              -29.745786922867154
            ],
            [
              -55.1263123070026,
              -29.74319488158419
            ],
            [
              -55.127306834035686,
              -29.738207165782132
            ],
            [
              -55.12739724558415,
              -29.732394709571857
            ],
            [
              -55.126899982067606,
              -29.73039176858048
            ],
            [
              -55.12830136106877,
              -29.724186578842485
            ],
            [
              -55.12911506500493,
              -29.719591596568144
            ],
            [
              -55.12848218416569,
              -29.716096268171427
            ],
            [
              -55.127487657132605,
              -29.713190040066287
            ],
            [
              -55.12590545503452,
              -29.710597998783328
            ],
            [
              -55.12482051645297,
              -29.707809590736506
            ],
            [
              -55.12418763561374,
              -29.703489521931573
            ],
            [
              -55.12482051645297,
              -29.700308380357033
            ],
            [
              -55.12622189545414,
              -29.69771633907407
            ],
            [
              -55.12888903613377,
              -29.696302498374273
            ],
            [
              -55.13160138258764,
              -29.69571339808269
            ],
            [
              -55.13698086972115,
              -29.696695231901995
            ],
            [
              -55.14208912220927,
              -29.695909764846554
            ],
            [
              -55.14407817627544,
              -29.695085024438338
            ],
            [
              -55.141501447144265,
              -29.693592637032996
            ],
            [
              -55.13811101407693,
              -29.693396270269137
            ],
            [
              -55.136393194656144,
              -29.69378900379686
            ],
            [
              -55.13472058100959,
              -29.69488865767448
            ],
            [
              -55.133409613556886,
              -29.695085024438338
            ],
            [
              -55.13128494216802,
              -29.69378900379686
            ],
            [
              -55.131510971039184,
              -29.6911969625139
            ],
            [
              -55.13282193849189,
              -29.690490042164
            ],
            [
              -55.13417811171882,
              -29.688408554467077
            ],
            [
              -55.13399728862189,
              -29.686012879947977
            ],
            [
              -55.131917823007264,
              -29.684913226070357
            ],
            [
              -55.12780409755223,
              -29.684716859306498
            ],
            [
              -55.12640271855106,
              -29.682988831784524
            ],
            [
              -55.12671915897068,
              -29.68149644437918
            ],
            [
              -55.128798624585315,
              -29.67961132344612
            ],
            [
              -55.1316917941361,
              -29.679297136623944
            ],
            [
              -55.13350002510535,
              -29.678708036332363
            ],
            [
              -55.13399728862189,
              -29.676312361813263
            ],
            [
              -55.13227946920111,
              -29.67368104717753
            ],
            [
              -55.1305164440061,
              -29.67348468041367
            ],
            [
              -55.127487657132605,
              -29.675212707935643
            ],
            [
              -55.12590545503452,
              -29.67458433429129
            ],
            [
              -55.12540819151798,
              -29.67328831364981
            ],
            [
              -55.1255890146149,
              -29.67128537265843
            ],
            [
              -55.1250013395499,
              -29.670107172075266
            ],
            [
              -55.12359996054873,
              -29.66959661848923
            ],
            [
              -55.12228899309603,
              -29.670107172075266
            ],
            [
              -55.120299939029856,
              -29.66908606490319
            ],
            [
              -55.120978025643325,
              -29.667083123911812
            ],
            [
              -55.12310269703219,
              -29.665983470034192
            ],
            [
              -55.12418763561374,
              -29.664687449392712
            ],
            [
              -55.124910928001434,
              -29.661506307818172
            ],
            [
              -55.124097224065274,
              -29.660288833882234
            ],
            [
              -55.121384877611405,
              -29.658600079713032
            ],
            [
              -55.118717736931764,
              -29.657382605777098
            ],
            [
              -55.113699895992106,
              -29.65718623901324
            ],
            [
              -55.108410820407066,
              -29.65761824589373
            ],
            [
              -55.10257927553125,
              -29.658403712949173
            ],
            [
              -55.09891760781852,
              -29.659385546768476
            ],
            [
              -55.09652170178427,
              -29.660681567409956
            ],
            [
              -55.09389976687886,
              -29.66060302070441
            ],
            [
              -55.09331209181386,
              -29.658600079713032
            ],
            [
              -55.094803882363486,
              -29.652198523211176
            ],
            [
              -55.09498470546041,
              -29.65039194898366
            ],
            [
              -55.09448744194387,
              -29.649017381636636
            ],
            [
              -55.092001124361154,
              -29.647289354114662
            ],
            [
              -55.08820383932574,
              -29.647092987350803
            ],
            [
              -55.085491492871874,
              -29.64858537475614
            ],
            [
              -55.082507911772616,
              -29.651491602861277
            ],
            [
              -55.08020241728683,
              -29.654397830966417
            ],
            [
              -55.07730924773603,
              -29.657304059071553
            ],
            [
              -55.07491334170178,
              -29.658796446476895
            ],
            [
              -55.07441607818524,
              -29.65981755364897
            ],
            [
              -55.07708321886488,
              -29.66959661848923
            ],
            [
              -55.076992807316415,
              -29.672306479830507
            ],
            [
              -55.076179103380255,
              -29.67328831364981
            ],
            [
              -55.07301469918407,
              -29.674387967527426
            ],
            [
              -55.071884554828294,
              -29.675291254641188
            ],
            [
              -55.07251743566753,
              -29.678786583037905
            ],
            [
              -55.07211058369945,
              -29.68031824379602
            ],
            [
              -55.070211941181746,
              -29.681182257557005
            ],
            [
              -55.06519410024209,
              -29.68200699796522
            ],
            [
              -55.06297901730476,
              -29.682792465020665
            ],
            [
              -55.06148722675513,
              -29.684795406012043
            ],
            [
              -55.06098996323859,
              -29.686484160181244
            ],
            [
              -55.061577638303596,
              -29.688604921230937
            ],
            [
              -55.06352148659553,
              -29.690804228986178
            ],
            [
              -55.062798194207836,
              -29.693906823855176
            ],
            [
              -55.06130640365821,
              -29.694417377441212
            ],
            [
              -55.05981461310858,
              -29.693985370560718
            ],
            [
              -55.05719267820317,
              -29.692296616391516
            ],
            [
              -55.05561047610508,
              -29.691903882863794
            ],
            [
              -55.05307895274814,
              -29.69249298315538
            ],
            [
              -55.04977893122926,
              -29.695085024438338
            ],
            [
              -55.04991454855196,
              -29.697912705837933
            ],
            [
              -55.04507753070922,
              -29.70301824169831
            ],
            [
              -55.03929119160764,
              -29.706081563214532
            ],
            [
              -55.03657884515377,
              -29.70639575003671
            ],
            [
              -55.031018534923334,
              -29.705413916217406
            ],
            [
              -55.02459931498252,
              -29.70678848356443
            ],
            [
              -55.020711618398636,
              -29.70619938327285
            ],
            [
              -55.01718556800861,
              -29.70690630362275
            ],
            [
              -55.01420198690935,
              -29.70808450420591
            ],
            [
              -55.01040470187393,
              -29.710597998783328
            ],
            [
              -55.00710468035506,
              -29.710715818841646
            ],
            [
              -55.00027860844616,
              -29.70879142455581
            ],
            [
              -54.99458268089303,
              -29.70659211680057
            ],
            [
              -54.992005951761854,
              -29.70490336263137
            ],
            [
              -54.99069498430915,
              -29.70270405487613
            ],
            [
              -54.98988128037299,
              -29.700386927062574
            ],
            [
              -54.987801814758356,
              -29.699719280065448
            ],
            [
              -54.98549632027257,
              -29.700583293826437
            ],
            [
              -54.98260315072178,
              -29.702389868053952
            ],
            [
              -54.981292183269076,
              -29.702586234817815
            ],
            [
              -54.978896277234824,
              -29.701997134526234
            ],
            [
              -54.97772092710481,
              -29.700897480648614
            ],
            [
              -54.97731407513673,
              -29.699483639948816
            ],
            [
              -54.97790175020174,
              -29.698383986071196
            ],
            [
              -54.97998121581637,
              -29.696695231901995
            ],
            [
              -54.980885331300996,
              -29.693396270269137
            ],
            [
              -54.98038806778445,
              -29.692218069685975
            ],
            [
              -54.97921271765444,
              -29.69198242956934
            ],
            [
              -54.9737880247467,
              -29.695517031318833
            ],
            [
              -54.96831812606474,
              -29.696616685196453
            ],
            [
              -54.96452084102932,
              -29.696695231901995
            ],
            [
              -54.96230575809199,
              -29.69571339808269
            ],
            [
              -54.958508473056575,
              -29.692414436449834
            ],
            [
              -54.952586516632294,
              -29.688919108053113
            ],
            [
              -54.950416639469196,
              -29.68679834700342
            ],
            [
              -54.94860840849995,
              -29.68310665184284
            ],
            [
              -54.945805650497626,
              -29.6785116695685
            ],
            [
              -54.94399741952838,
              -29.676587275282667
            ],
            [
              -54.94119466152605,
              -29.676194541754946
            ],
            [
              -54.938391903523716,
              -29.677097828868703
            ],
            [
              -54.93622202636062,
              -29.67980769020998
            ],
            [
              -54.93468503003676,
              -29.6809073440876
            ],
            [
              -54.933283651035595,
              -29.680396790501565
            ],
            [
              -54.933012416390206,
              -29.676194541754946
            ],
            [
              -54.93228912400251,
              -29.67328831364981
            ],
            [
              -54.93161103738904,
              -29.672110113066644
            ],
            [
              -54.92889869093517,
              -29.670107172075266
            ],
            [
              -54.927497311934005,
              -29.668614784669927
            ],
            [
              -54.92577949251322,
              -29.664412535923308
            ],
            [
              -54.9250109943513,
              -29.66350924880955
            ],
            [
              -54.92247947099435,
              -29.66260596169579
            ],
            [
              -54.91841095131355,
              -29.662488141637475
            ],
            [
              -54.915201341343135,
              -29.663195061987373
            ],
            [
              -54.91000267730655,
              -29.666886757147953
            ],
            [
              -54.90810403478884,
              -29.66790786432003
            ],
            [
              -54.90579854030305,
              -29.667711497556166
            ],
            [
              -54.903719074688425,
              -29.666219110150827
            ],
            [
              -54.90109713978302,
              -29.665787103270333
            ],
            [
              -54.89409024477719,
              -29.663784162278954
            ],
            [
              -54.88871075764368,
              -29.663784162278954
            ],
            [
              -54.88541073612481,
              -29.663312882045688
            ],
            [
              -54.88319565318748,
              -29.66350924880955
            ],
            [
              -54.87899151618399,
              -29.664687449392712
            ],
            [
              -54.877002462117815,
              -29.665787103270333
            ],
            [
              -54.8737928521474,
              -29.668182777789433
            ],
            [
              -54.87049283062853,
              -29.670107172075266
            ],
            [
              -54.86741883798081,
              -29.670696272366847
            ],
            [
              -54.862581820138075,
              -29.670499905602988
            ],
            [
              -54.85977906213574,
              -29.66959661848923
            ],
            [
              -54.858920152425355,
              -29.66830059784775
            ],
            [
              -54.85801603694073,
              -29.665590736506473
            ],
            [
              -54.855394102035326,
              -29.66299869522351
            ],
            [
              -54.85480642697032,
              -29.65871789977135
            ],
            [
              -54.85530369048686,
              -29.656989872249376
            ],
            [
              -54.85399272303416,
              -29.656597138721654
            ],
            [
              -54.85200366896799,
              -29.657814612657592
            ],
            [
              -54.850285849547205,
              -29.660485200646097
            ],
            [
              -54.84911049941719,
              -29.661388487759854
            ],
            [
              -54.84540362593024,
              -29.662095408109753
            ],
            [
              -54.84138031202367,
              -29.663587795515095
            ],
            [
              -54.83789946740787,
              -29.66551218980093
            ],
            [
              -54.833695330404375,
              -29.666415476914686
            ],
            [
              -54.83211312830628,
              -29.665708556564788
            ],
            [
              -54.82718569891509,
              -29.65981755364897
            ],
            [
              -54.82537746794584,
              -29.65691132554383
            ],
            [
              -54.82510623330045,
              -29.65479056449414
            ],
            [
              -54.82659802385008,
              -29.650117035514256
            ],
            [
              -54.82732131623778,
              -29.643990392481804
            ],
            [
              -54.826417200753156,
              -29.639984510499048
            ],
            [
              -54.82469938133237,
              -29.637588835979948
            ],
            [
              -54.82148977136196,
              -29.635389528224707
            ],
            [
              -54.81931989419887,
              -29.635193161460847
            ],
            [
              -54.81651713619654,
              -29.6382172096243
            ],
            [
              -54.81461849367883,
              -29.638884856621427
            ],
            [
              -54.812493822289966,
              -29.637313922510543
            ],
            [
              -54.81082120864341,
              -29.63428987434709
            ],
            [
              -54.809691064287634,
              -29.63338658723333
            ],
            [
              -54.80648145431722,
              -29.63209056659185
            ],
            [
              -54.80539651573567,
              -29.63079454595037
            ],
            [
              -54.80489925221913,
              -29.627809771139688
            ],
            [
              -54.80440198870259,
              -29.626906484025927
            ],
            [
              -54.80191567111988,
              -29.62529627656227
            ],
            [
              -54.80001702860217,
              -29.622782781984856
            ],
            [
              -54.800604703667176,
              -29.62121184787397
            ],
            [
              -54.80010744015063,
              -29.619994373938034
            ],
            [
              -54.79762112256792,
              -29.619287453588136
            ],
            [
              -54.796988241728684,
              -29.61791288624111
            ],
            [
              -54.79260328162826,
              -29.618384166474378
            ],
            [
              -54.78989093517439,
              -29.615792125191415
            ],
            [
              -54.790116964045545,
              -29.61178624320866
            ],
            [
              -54.78518953465435,
              -29.60730908099264
            ],
            [
              -54.78451144804088,
              -29.60499195317908
            ],
            [
              -54.78329089213664,
              -29.604010119359778
            ],
            [
              -54.78550597507397,
              -29.601889358310085
            ],
            [
              -54.783788155653184,
              -29.598511849971683
            ],
            [
              -54.78469227113781,
              -29.597412196094062
            ],
            [
              -54.78708817717206,
              -29.59678382244971
            ],
            [
              -54.787811469559756,
              -29.59478088145833
            ],
            [
              -54.79129231417556,
              -29.594505967988926
            ],
            [
              -54.79301013359634,
              -29.593209947347443
            ],
            [
              -54.79151834304671,
              -29.590382265947852
            ],
            [
              -54.79531562808213,
              -29.58390216274045
            ],
            [
              -54.795089599210975,
              -29.581192301399174
            ],
            [
              -54.796988241728684,
              -29.577500606238594
            ],
            [
              -54.795903303147135,
              -29.574515831427913
            ],
            [
              -54.79138272572402,
              -29.573101990728116
            ],
            [
              -54.79260328162826,
              -29.569017562039814
            ],
            [
              -54.797395093696764,
              -29.568114274926057
            ],
            [
              -54.80218690576526,
              -29.572395070378217
            ],
            [
              -54.805080075316056,
              -29.570706316209016
            ],
            [
              -54.80621021967183,
              -29.574790744897317
            ],
            [
              -54.807385569801845,
              -29.575694032011075
            ],
            [
              -54.80910338922263,
              -29.575890398774938
            ],
            [
              -54.8110924432888,
              -29.57431946466405
            ],
            [
              -54.814121230162286,
              -29.575615485305534
            ],
            [
              -54.817918515197704,
              -29.574201644605736
            ],
            [
              -54.81841577871425,
              -29.572002336850495
            ],
            [
              -54.821580182910424,
              -29.569410295567536
            ],
            [
              -54.82230347529813,
              -29.570117215917435
            ],
            [
              -54.821399359813505,
              -29.57168815002832
            ],
            [
              -54.825196644848916,
              -29.57388745778356
            ],
            [
              -54.83279121491975,
              -29.574594378133458
            ],
            [
              -54.83509670940554,
              -29.572905623964257
            ],
            [
              -54.83609123643863,
              -29.569803029095258
            ],
            [
              -54.840295373442125,
              -29.565482960290325
            ],
            [
              -54.836814528826324,
              -29.559395590610645
            ],
            [
              -54.838577554021334,
              -29.558806490319064
            ],
            [
              -54.839210434860576,
              -29.556882096033227
            ],
            [
              -54.84138031202367,
              -29.555703895450065
            ],
            [
              -54.843278954541375,
              -29.551894380231168
            ],
            [
              -54.84291730834753,
              -29.550401992825826
            ],
            [
              -54.848794058997576,
              -29.549812892534245
            ],
            [
              -54.851506405451445,
              -29.547613584779008
            ],
            [
              -54.855800954003406,
              -29.549380885653754
            ],
            [
              -54.85968865058729,
              -29.547692131484553
            ],
            [
              -54.86059276607191,
              -29.54549282372931
            ],
            [
              -54.86222017394423,
              -29.54490372343773
            ],
            [
              -54.86249140858961,
              -29.542311682154768
            ],
            [
              -54.86050235452345,
              -29.539209087285773
            ],
            [
              -54.86050235452345,
              -29.5374810597638
            ],
            [
              -54.86118044113691,
              -29.53618503912232
            ],
            [
              -54.86167770465345,
              -29.532886077489458
            ],
            [
              -54.859598239038824,
              -29.5326897107256
            ],
            [
              -54.861090029588446,
              -29.531315143378574
            ],
            [
              -54.85910097552228,
              -29.529901302678777
            ],
            [
              -54.85901056397382,
              -29.52829109521512
            ],
            [
              -54.85268175558146,
              -29.52809472845126
            ],
            [
              -54.84978858603066,
              -29.526091787459883
            ],
            [
              -54.84811597238411,
              -29.52640597428206
            ],
            [
              -54.84861323590065,
              -29.52349974617692
            ],
            [
              -54.84698582802833,
              -29.52291064588534
            ],
            [
              -54.846398152963324,
              -29.519886597721886
            ],
            [
              -54.84201319286291,
              -29.51961168425248
            ],
            [
              -54.8401145503452,
              -29.515487982211408
            ],
            [
              -54.83871317134403,
              -29.514113414864383
            ],
            [
              -54.83690494037479,
              -29.51478106186151
            ],
            [
              -54.836000824890164,
              -29.516587636089028
            ],
            [
              -54.83441862279207,
              -29.515802169033584
            ],
            [
              -54.834599445889,
              -29.514702515155964
            ],
            [
              -54.833695330404375,
              -29.51328867445617
            ],
            [
              -54.83468985743746,
              -29.512110473873005
            ],
            [
              -54.83649808840671,
              -29.511717740345283
            ],
            [
              -54.836000824890164,
              -29.50979334605945
            ],
            [
              -54.838396730924416,
              -29.50869369218183
            ],
            [
              -54.83468985743746,
              -29.508183138595793
            ],
            [
              -54.834509034340535,
              -29.50551255060729
            ],
            [
              -54.837221380794404,
              -29.50260632250215
            ],
            [
              -54.83401177082399,
              -29.501192481802356
            ],
            [
              -54.83609123643863,
              -29.499896461160873
            ],
            [
              -54.836407676858244,
              -29.49820770699167
            ],
            [
              -54.83197751098359,
              -29.493887638186738
            ],
            [
              -54.832610391822826,
              -29.491217050198234
            ],
            [
              -54.83188709943513,
              -29.48889992238468
            ],
            [
              -54.833288478436295,
              -29.487918088565376
            ],
            [
              -54.83898440598942,
              -29.489214109206856
            ],
            [
              -54.84178716399175,
              -29.488389368798643
            ],
            [
              -54.84061181386174,
              -29.486582794571124
            ],
            [
              -54.842600867927914,
              -29.48630788110172
            ],
            [
              -54.84350498341253,
              -29.483087466174403
            ],
            [
              -54.850014614901816,
              -29.47711791655304
            ],
            [
              -54.8510091419349,
              -29.47158037381217
            ],
            [
              -54.85060228996682,
              -29.469813072937427
            ],
            [
              -54.84811597238411,
              -29.46710321159615
            ],
            [
              -54.84540362593024,
              -29.46659265801011
            ],
            [
              -54.84938173406258,
              -29.46290096284953
            ],
            [
              -54.85159681699991,
              -29.464393350254873
            ],
            [
              -54.85358587106608,
              -29.464393350254873
            ],
            [
              -54.85507766161571,
              -29.46529663736863
            ],
            [
              -54.85349545951762,
              -29.460701655094294
            ],
            [
              -54.85159681699991,
              -29.459091447630634
            ],
            [
              -54.84902008786873,
              -29.459484181158356
            ],
            [
              -54.850692701515285,
              -29.456303039583815
            ],
            [
              -54.852591344032994,
              -29.45488919888402
            ],
            [
              -54.851777640096834,
              -29.45159023725116
            ],
            [
              -54.853405047969154,
              -29.450883316901262
            ],
            [
              -54.85308860754954,
              -29.44679888821296
            ],
            [
              -54.85159681699991,
              -29.44569923433534
            ],
            [
              -54.85118996503183,
              -29.443185739757926
            ],
            [
              -54.8539023114857,
              -29.44051515176942
            ],
            [
              -54.85950782749036,
              -29.437412556900423
            ],
            [
              -54.85950782749036,
              -29.433406674917666
            ],
            [
              -54.863621552945396,
              -29.42629819806591
            ],
            [
              -54.86470649152694,
              -29.42221376937761
            ],
            [
              -54.867690072626196,
              -29.420289375091777
            ],
            [
              -54.86818733614274,
              -29.417893700572677
            ],
            [
              -54.867690072626196,
              -29.4151838392314
            ],
            [
              -54.86990515556352,
              -29.41219906442072
            ],
            [
              -54.86538457814041,
              -29.405286954332823
            ],
            [
              -54.86538457814041,
              -29.403912386985798
            ],
            [
              -54.86990515556352,
              -29.40230217952214
            ],
            [
              -54.86701198601273,
              -29.400691972058485
            ],
            [
              -54.865701018560024,
              -29.397707197247804
            ],
            [
              -54.86759966107773,
              -29.395704256256426
            ],
            [
              -54.87139694611315,
              -29.39539006943425
            ],
            [
              -54.872301061597774,
              -29.394604602378806
            ],
            [
              -54.87099009414507,
              -29.39000962010447
            ],
            [
              -54.87600793508473,
              -29.38820304587695
            ],
            [
              -54.87338600017932,
              -29.387417578821506
            ],
            [
              -54.8732051770824,
              -29.38580737135785
            ],
            [
              -54.875510671568186,
              -29.383293876780435
            ],
            [
              -54.881297010669776,
              -29.379680728325397
            ],
            [
              -54.8840997686721,
              -29.378188340920058
            ],
            [
              -54.884009357123645,
              -29.37378972540958
            ],
            [
              -54.88491347260827,
              -29.3717867844182
            ],
            [
              -54.888077876804445,
              -29.370215850307314
            ],
            [
              -54.8883039056756,
              -29.368095089257622
            ],
            [
              -54.89029295974177,
              -29.368016542552077
            ],
            [
              -54.89169433874294,
              -29.36550304797466
            ],
            [
              -54.89418065632565,
              -29.364285574038725
            ],
            [
              -54.893186129292566,
              -29.3622040863418
            ],
            [
              -54.89368339280911,
              -29.359690591764387
            ],
            [
              -54.895898475746435,
              -29.35921931153112
            ],
            [
              -54.896712179682595,
              -29.356391630131526
            ],
            [
              -54.894813537164886,
              -29.353603222084708
            ],
            [
              -54.89571765264951,
              -29.34928315327977
            ],
            [
              -54.898610822200304,
              -29.34720166558285
            ],
            [
              -54.89969576078185,
              -29.348301319460468
            ],
            [
              -54.90109713978302,
              -29.348183499402154
            ],
            [
              -54.9015039917511,
              -29.34570927817751
            ],
            [
              -54.90041905316955,
              -29.34390270394999
            ],
            [
              -54.901006728234556,
              -29.34241031654465
            ],
            [
              -54.90729033085268,
              -29.339700455203374
            ],
            [
              -54.91321228727696,
              -29.340603742317132
            ],
            [
              -54.92247947099435,
              -29.332081424765583
            ],
            [
              -54.9250109943513,
              -29.328389729605
            ],
            [
              -54.92767813503093,
              -29.32701516225798
            ],
            [
              -54.92889869093517,
              -29.326386788613622
            ],
            [
              -54.93228912400251,
              -29.32100633928384
            ],
            [
              -54.934097354971755,
              -29.320888519225527
            ],
            [
              -54.93699052452255,
              -29.32210599316146
            ],
            [
              -54.940290546041425,
              -29.32560132155818
            ],
            [
              -54.94779470456379,
              -29.314604782781984
            ],
            [
              -54.959593411638124,
              -29.314290595959807
            ],
            [
              -54.96262219851161,
              -29.31279820855447
            ],
            [
              -54.96370713709316,
              -29.30600391852489
            ],
            [
              -54.961582465704296,
              -29.303097690419754
            ],
            [
              -54.961582465704296,
              -29.301683849719957
            ],
            [
              -54.96411398906124,
              -29.30011291560907
            ],
            [
              -54.967685245225496,
              -29.294811012984834
            ],
            [
              -54.97008115125975,
              -29.294300459398798
            ],
            [
              -54.96831812606474,
              -29.291983331585243
            ],
            [
              -54.96840853761319,
              -29.290216030710496
            ],
            [
              -54.97008115125975,
              -29.288213089719118
            ],
            [
              -54.971211295615525,
              -29.28420720773636
            ],
            [
              -54.97329076123016,
              -29.2809082461035
            ],
            [
              -54.97527981529633,
              -29.278708938348263
            ],
            [
              -54.977811338653275,
              -29.277609284470643
            ],
            [
              -54.98490864520757,
              -29.277687831176188
            ],
            [
              -54.98811825517798,
              -29.274310322837785
            ],
            [
              -54.99232239218147,
              -29.272111015082544
            ],
            [
              -54.99489912131265,
              -29.269204786977408
            ],
            [
              -54.99761146776652,
              -29.26790876633593
            ],
            [
              -54.99969093338115,
              -29.26849786662751
            ],
            [
              -55.003307395319645,
              -29.26771239957207
            ],
            [
              -55.00448274544965,
              -29.264884718172475
            ],
            [
              -55.00498000896619,
              -29.25848316167062
            ],
            [
              -55.00579371290235,
              -29.25718714102914
            ],
            [
              -55.00728550345198,
              -29.256519494032013
            ],
            [
              -55.01402116381242,
              -29.256087487151518
            ],
            [
              -55.01958147404286,
              -29.256912227559734
            ],
            [
              -55.02048558952748,
              -29.256087487151518
            ],
            [
              -55.02148011656057,
              -29.250314304294015
            ],
            [
              -55.01881297588093,
              -29.245483681903046
            ],
            [
              -55.01921982784901,
              -29.24391274779216
            ],
            [
              -55.02120888191518,
              -29.243284374147805
            ],
            [
              -55.023695199497894,
              -29.2454051351975
            ],
            [
              -55.027899336501385,
              -29.248389910008182
            ],
            [
              -55.03119935802026,
              -29.249018283652536
            ],
            [
              -55.033007588989506,
              -29.2485077300665
            ],
            [
              -55.0324199139245,
              -29.24670115583898
            ],
            [
              -55.029391127051014,
              -29.2454051351975
            ],
            [
              -55.02821577692101,
              -29.244384028025426
            ],
            [
              -55.028984275082934,
              -29.238885758637327
            ],
            [
              -55.030611682955254,
              -29.237511191290302
            ],
            [
              -55.03278156011835,
              -29.237589737995847
            ],
            [
              -55.03391170447413,
              -29.238493025109605
            ],
            [
              -55.03847748767148,
              -29.244384028025426
            ],
            [
              -55.04290765354613,
              -29.24450184808374
            ],
            [
              -55.04729261364655,
              -29.240417419395442
            ],
            [
              -55.04769946561463,
              -29.238296658345746
            ],
            [
              -55.042591213126514,
              -29.232012921902204
            ],
            [
              -55.04372135748229,
              -29.227889219861133
            ],
            [
              -55.04729261364655,
              -29.22690738604183
            ],
            [
              -55.04991454855196,
              -29.224315344758867
            ],
            [
              -55.05750911862279,
              -29.225414998636488
            ],
            [
              -55.06989550076212,
              -29.222901504059074
            ],
            [
              -55.07179414327983,
              -29.223490604350655
            ],
            [
              -55.07500375325024,
              -29.217992334962556
            ],
            [
              -55.07532019366986,
              -29.214418459860294
            ],
            [
              -55.078213363220655,
              -29.21210133204674
            ],
            [
              -55.07961474222182,
              -29.209980570997043
            ],
            [
              -55.08137776741684,
              -29.2091951039416
            ],
            [
              -55.085491492871874,
              -29.209116557236058
            ],
            [
              -55.09001207029499,
              -29.213593719452078
            ],
            [
              -55.09408058997579,
              -29.214811193388016
            ],
            [
              -55.09638608446158,
              -29.2163821274989
            ],
            [
              -55.10257927553125,
              -29.214104273038117
            ],
            [
              -55.10461353537165,
              -29.214418459860294
            ],
            [
              -55.10768752801936,
              -29.209391470705462
            ],
            [
              -55.10990261095669,
              -29.21198351198842
            ],
            [
              -55.11419715950865,
              -29.2139864529798
            ],
            [
              -55.114920451896346,
              -29.204717941725576
            ],
            [
              -55.1173163579306,
              -29.200083686098466
            ],
            [
              -55.11939582354523,
              -29.2003193262151
            ],
            [
              -55.120299939029856,
              -29.19941603910134
            ],
            [
              -55.12251502196718,
              -29.20110479327054
            ],
            [
              -55.12378078364566,
              -29.199808772629062
            ],
            [
              -55.127080805164525,
              -29.200594239684506
            ],
            [
              -55.13241508652381,
              -29.198394931929265
            ],
            [
              -55.133409613556886,
              -29.198787665456987
            ],
            [
              -55.13820142562539,
              -29.196981091229468
            ],
            [
              -55.13978362772348,
              -29.193799949654927
            ],
            [
              -55.14132062404734,
              -29.193996316418787
            ],
            [
              -55.14448502824352,
              -29.197609464873825
            ],
            [
              -55.14670011118085,
              -29.198905485515304
            ],
            [
              -55.15009054424818,
              -29.198787665456987
            ],
            [
              -55.15537961983323,
              -29.19548870382413
            ],
            [
              -55.1586796413521,
              -29.201497526798263
            ],
            [
              -55.15791114319017,
              -29.203696834553504
            ],
            [
              -55.1607139011925,
              -29.204992855194984
            ],
            [
              -55.16301939567829,
              -29.20491430848944
            ],
            [
              -55.166183799874474,
              -29.20181171362044
            ],
            [
              -55.16582215368062,
              -29.196509810996204
            ],
            [
              -55.1670879153591,
              -29.195802890646306
            ],
            [
              -55.168082442392176,
              -29.196981091229468
            ],
            [
              -55.170613965749126,
              -29.196902544523926
            ],
            [
              -55.175496189366086,
              -29.191207908371968
            ],
            [
              -55.17938388594997,
              -29.195292337060266
            ],
            [
              -55.18069485340267,
              -29.197805831637684
            ],
            [
              -55.18141814579037,
              -29.20840963688616
            ],
            [
              -55.18431131534116,
              -29.209902024291498
            ],
            [
              -55.18788257150542,
              -29.210608944641397
            ],
            [
              -55.191001769927375,
              -29.210216211113675
            ],
            [
              -55.1938045279297,
              -29.206995796186362
            ],
            [
              -55.19570317044741,
              -29.2027150007342
            ],
            [
              -55.20090183448399,
              -29.202989914203606
            ],
            [
              -55.20501555993903,
              -29.20589614230874
            ],
            [
              -55.206416938940194,
              -29.205817595603197
            ],
            [
              -55.20858681610329,
              -29.20071205974282
            ],
            [
              -55.206416938940194,
              -29.196195624174027
            ],
            [
              -55.20338815206671,
              -29.197491644815507
            ],
            [
              -55.201805949968616,
              -29.196706177760063
            ],
            [
              -55.20171553842015,
              -29.195213790354725
            ],
            [
              -55.205603235004034,
              -29.193289396068888
            ],
            [
              -55.20980737200753,
              -29.189715520966626
            ],
            [
              -55.21771838249798,
              -29.192111195485726
            ],
            [
              -55.2249965121492,
              -29.196981091229468
            ],
            [
              -55.2263074796019,
              -29.196117077468482
            ],
            [
              -55.22621706805344,
              -29.192700295777307
            ],
            [
              -55.23317875728503,
              -29.194703236768685
            ],
            [
              -55.23521301712543,
              -29.188615867089005
            ],
            [
              -55.23738289428853,
              -29.189008600616727
            ],
            [
              -55.23891989061239,
              -29.190304621258207
            ],
            [
              -55.24280758719627,
              -29.190108254494348
            ],
            [
              -55.244208966197434,
              -29.192307562249585
            ],
            [
              -55.24669528378015,
              -29.19238610895513
            ],
            [
              -55.24841310320093,
              -29.194506870004826
            ],
            [
              -55.253792590334434,
              -29.197216731346103
            ],
            [
              -55.257680286918315,
              -29.200201506156784
            ],
            [
              -55.25790631578947,
              -29.203186280967465
            ],
            [
              -55.262381687438356,
              -29.20860600365002
            ],
            [
              -55.26798720344302,
              -29.205817595603197
            ],
            [
              -55.272507780866135,
              -29.20789908330012
            ],
            [
              -55.27639547745001,
              -29.207506349772398
            ],
            [
              -55.278881795032724,
              -29.21100167816912
            ],
            [
              -55.28100646642159,
              -29.209312923999917
            ],
            [
              -55.28200099345467,
              -29.209509290763776
            ],
            [
              -55.28240784542275,
              -29.2115907784607
            ],
            [
              -55.286295542006634,
              -29.213200985924356
            ],
            [
              -55.292217498430915,
              -29.213515172746533
            ],
            [
              -55.29551751994979,
              -29.214614826624153
            ],
            [
              -55.29949562808213,
              -29.214497006565836
            ],
            [
              -55.30338332466601,
              -29.213318805982674
            ],
            [
              -55.304920320989865,
              -29.207388529714084
            ],
            [
              -55.307180609701426,
              -29.2091951039416
            ],
            [
              -55.307994313637586,
              -29.207584896477943
            ],
            [
              -55.309486104187215,
              -29.20770271653626
            ],
            [
              -55.312605302609164,
              -29.20479648843112
            ],
            [
              -55.31079707163992,
              -29.20291136749806
            ],
            [
              -55.309486104187215,
              -29.203893201317364
            ],
            [
              -55.30740663857258,
              -29.20291136749806
            ],
            [
              -55.30311209002062,
              -29.203186280967465
            ],
            [
              -55.30008330314713,
              -29.20251863397034
            ],
            [
              -55.30089700708329,
              -29.199808772629062
            ],
            [
              -55.300218920469824,
              -29.19788437834323
            ],
            [
              -55.29741616246749,
              -29.194506870004826
            ],
            [
              -55.29610519501479,
              -29.193407216127206
            ],
            [
              -55.292217498430915,
              -29.193603582891065
            ],
            [
              -55.29090653097821,
              -29.193014482599484
            ],
            [
              -55.29049967901013,
              -29.191011541608106
            ],
            [
              -55.28918871155743,
              -29.190304621258207
            ],
            [
              -55.28661198242625,
              -29.18570963898387
            ],
            [
              -55.28489416300547,
              -29.184492165047935
            ],
            [
              -55.280509202905044,
              -29.184492165047935
            ],
            [
              -55.27919823545234,
              -29.182096490528835
            ],
            [
              -55.2821818165516,
              -29.177894241782216
            ],
            [
              -55.28308593203622,
              -29.174909466971535
            ],
            [
              -55.27811329687079,
              -29.170510851461056
            ],
            [
              -55.27558177351385,
              -29.163480921314846
            ],
            [
              -55.27558177351385,
              -29.161399433617923
            ],
            [
              -55.27431601183538,
              -29.160692513268025
            ],
            [
              -55.27639547745001,
              -29.1586110255711
            ],
            [
              -55.276711917869626,
              -29.153309122946865
            ],
            [
              -55.27458724648076,
              -29.149381787669654
            ],
            [
              -55.27192010580113,
              -29.14730029997273
            ],
            [
              -55.270609138348426,
              -29.14470825868977
            ],
            [
              -55.2683940554111,
              -29.14250895093453
            ],
            [
              -55.2691173477988,
              -29.141095110234733
            ],
            [
              -55.26871049583072,
              -29.137796148601876
            ],
            [
              -55.26947899399264,
              -29.13488992049674
            ],
            [
              -55.2683940554111,
              -29.1319836923916
            ],
            [
              -55.268620084282254,
              -29.12899891758092
            ],
            [
              -55.270609138348426,
              -29.125896322711924
            ],
            [
              -55.26961461131534,
              -29.121497707201446
            ],
            [
              -55.27621465435308,
              -29.112386289358312
            ],
            [
              -55.281277701066976,
              -29.10979424807535
            ],
            [
              -55.28308593203622,
              -29.107712760378426
            ],
            [
              -55.28457772258585,
              -29.107594940320112
            ],
            [
              -55.285481838070474,
              -29.10480653227329
            ],
            [
              -55.28059961445351,
              -29.099190442826878
            ],
            [
              -55.27399957141576,
              -29.089607744750477
            ],
            [
              -55.275220127320004,
              -29.0845022088901
            ],
            [
              -55.27381874831884,
              -29.08081051372952
            ],
            [
              -55.27418039451268,
              -29.078886119443688
            ],
            [
              -55.27137763651035,
              -29.07059944200877
            ],
            [
              -55.272281751994974,
              -29.06730048037591
            ],
            [
              -55.272914632834215,
              -29.057010861949614
            ],
            [
              -55.27110640186497,
              -29.05528283442764
            ],
            [
              -55.26450635882722,
              -29.053711900316756
            ],
            [
              -55.26021181027526,
              -29.056107574835856
            ],
            [
              -55.253792590334434,
              -29.05469373413606
            ],
            [
              -55.24601719716668,
              -29.056107574835856
            ],
            [
              -55.24990489375056,
              -29.053515533552893
            ],
            [
              -55.26188442392181,
              -29.048213630928657
            ],
            [
              -55.265500885860305,
              -29.043500828596002
            ],
            [
              -55.27051872679996,
              -29.04051605378532
            ],
            [
              -55.27852014883887,
              -29.03069771559229
            ],
            [
              -55.28150372993813,
              -29.024217612384888
            ],
            [
              -55.27910782390388,
              -29.016912768769274
            ],
            [
              -55.2800119393885,
              -29.013417440372553
            ],
            [
              -55.27910782390388,
              -29.01019702544524
            ],
            [
              -55.27960508742042,
              -29.008194084453862
            ],
            [
              -55.28141331838967,
              -29.00611259675694
            ],
            [
              -55.28231743387429,
              -29.001988894715865
            ],
            [
              -55.285617455393165,
              -28.997904466027563
            ],
            [
              -55.28968597507397,
              -28.993898584044807
            ],
            [
              -55.293212025464,
              -28.992406196639468
            ],
            [
              -55.29298599659284,
              -28.991502909525707
            ],
            [
              -55.29108735407513,
              -28.98451225273227
            ],
            [
              -55.29389011207746,
              -28.981291837804957
            ],
            [
              -55.29420655249709,
              -28.97269097354786
            ],
            [
              -55.297099722047875,
              -28.972180419961823
            ],
            [
              -55.29768739711288,
              -28.971316406200835
            ],
            [
              -55.297506574015955,
              -28.96829235803738
            ],
            [
              -55.2993148049852,
              -28.967389070923623
            ],
            [
              -55.30659293463642,
              -28.9660145035766
            ],
            [
              -55.309892956155295,
              -28.96330464223532
            ],
            [
              -55.31459435667533,
              -28.964286476054625
            ],
            [
              -55.317894378194204,
              -28.9629119087076
            ],
            [
              -55.31848205325921,
              -28.96090896771622
            ],
            [
              -55.32227933829463,
              -28.960202047366323
            ],
            [
              -55.32268619026271,
              -28.95898457343039
            ],
            [
              -55.319521786066524,
              -28.95399685762833
            ],
            [
              -55.31897931677575,
              -28.951915369931406
            ],
            [
              -55.319521786066524,
              -28.94790948794865
            ],
            [
              -55.32101357661615,
              -28.945081806549055
            ],
            [
              -55.32101357661615,
              -28.94201848503283
            ],
            [
              -55.323002630682325,
              -28.940604644333032
            ],
            [
              -55.32928623330046,
              -28.939112256927693
            ],
            [
              -55.33669998027436,
              -28.941704298210652
            ],
            [
              -55.338417799695144,
              -28.94131156468293
            ],
            [
              -55.342305496279025,
              -28.942803952088273
            ],
            [
              -55.34551510624944,
              -28.941900664974515
            ],
            [
              -55.34510825428136,
              -28.940290457510855
            ],
            [
              -55.34759457186407,
              -28.9362845755281
            ],
            [
              -55.34831786425177,
              -28.932907067189696
            ],
            [
              -55.34990006634986,
              -28.931611046548216
            ],
            [
              -55.355505582354525,
              -28.931218313020494
            ],
            [
              -55.358082311485695,
              -28.93180741331208
            ],
            [
              -55.360116571326095,
              -28.929215372029116
            ],
            [
              -55.36540564691114,
              -28.92689824421556
            ],
            [
              -55.36920293194656,
              -28.921792708355184
            ],
            [
              -55.37150842643235,
              -28.921910528413502
            ],
            [
              -55.37300021698198,
              -28.920614507772022
            ],
            [
              -55.373994744015064,
              -28.912916930628686
            ],
            [
              -55.37309062853044,
              -28.908793228587612
            ],
            [
              -55.37580297498431,
              -28.905101533427032
            ],
            [
              -55.375893386532766,
              -28.900702917916554
            ],
            [
              -55.37340706895006,
              -28.89489046170628
            ],
            [
              -55.374401595983144,
              -28.88990274590422
            ],
            [
              -55.37281939388505,
              -28.888685271968285
            ],
            [
              -55.37300021698198,
              -28.887192884562943
            ],
            [
              -55.36929334349502,
              -28.88511139686602
            ],
            [
              -55.36960978391464,
              -28.88420810975226
            ],
            [
              -55.36748511252578,
              -28.880005861005642
            ],
            [
              -55.36888649152694,
              -28.878395653541986
            ],
            [
              -55.373316657401595,
              -28.878199286778127
            ],
            [
              -55.37661667892047,
              -28.874507591617547
            ],
            [
              -55.378018057921636,
              -28.873997038031508
            ],
            [
              -55.38339754505514,
              -28.874703958381406
            ],
            [
              -55.38497974715323,
              -28.87368285120933
            ],
            [
              -55.385883862637854,
              -28.875410878731305
            ],
            [
              -55.38800853402672,
              -28.87548942543685
            ],
            [
              -55.38809894557518,
              -28.876510532608926
            ],
            [
              -55.389500324576346,
              -28.876903266136647
            ],
            [
              -55.39121814399713,
              -28.879809494241783
            ],
            [
              -55.39641680803371,
              -28.880084407711188
            ],
            [
              -55.398993537164884,
              -28.878788387069708
            ],
            [
              -55.40039491616605,
              -28.875803612259027
            ],
            [
              -55.40071135658567,
              -28.871012263220827
            ],
            [
              -55.40541275710571,
              -28.869794789284892
            ],
            [
              -55.413685413790006,
              -28.86441433995511
            ],
            [
              -55.41608131982426,
              -28.863982333074617
            ],
            [
              -55.42801564422128,
              -28.864885620188375
            ],
            [
              -55.43221978122478,
              -28.862607765727592
            ],
            [
              -55.432717044741324,
              -28.86111537832225
            ],
            [
              -55.43118004841747,
              -28.857816416689392
            ],
            [
              -55.427699203801666,
              -28.854517455056534
            ],
            [
              -55.41901969514929,
              -28.84960828596002
            ],
            [
              -55.41838681431005,
              -28.846898424618743
            ],
            [
              -55.41938134134313,
              -28.84501330368568
            ],
            [
              -55.421912864700076,
              -28.843206729458164
            ],
            [
              -55.42869373083475,
              -28.84481693692182
            ],
            [
              -55.43140607728862,
              -28.844384930041326
            ],
            [
              -55.43240060432171,
              -28.842696175872124
            ],
            [
              -55.43249101587017,
              -28.840811054939063
            ],
            [
              -55.43140607728862,
              -28.8382190136561
            ],
            [
              -55.43280745628979,
              -28.827418841643766
            ],
            [
              -55.43479651035596,
              -28.82749738834931
            ],
            [
              -55.43750885680983,
              -28.825298080594074
            ],
            [
              -55.43967873397292,
              -28.825494447357933
            ],
            [
              -55.440808878328696,
              -28.823609326424872
            ],
            [
              -55.4442897229445,
              -28.822391852488934
            ],
            [
              -55.447408921366446,
              -28.817993236978456
            ],
            [
              -55.44881030036761,
              -28.812887701118083
            ],
            [
              -55.4498048274007,
              -28.812298600826498
            ],
            [
              -55.45351170088765,
              -28.81379098823184
            ],
            [
              -55.45830351295615,
              -28.814615728640053
            ],
            [
              -55.46178435757195,
              -28.814105175054017
            ],
            [
              -55.46580767147852,
              -28.81210223406264
            ],
            [
              -55.46797754864162,
              -28.809902926307398
            ],
            [
              -55.46797754864162,
              -28.80770361855216
            ],
            [
              -55.46960495651394,
              -28.80491521050534
            ],
            [
              -55.46992139693356,
              -28.8027159027501
            ],
            [
              -55.47448718013091,
              -28.799299121058926
            ],
            [
              -55.47891734600556,
              -28.79808164712299
            ],
            [
              -55.47982146149018,
              -28.79230846426549
            ],
            [
              -55.48339271765444,
              -28.788813135868768
            ],
            [
              -55.483709158074056,
              -28.78421815359443
            ],
            [
              -55.48470368510714,
              -28.781390472194836
            ],
            [
              -55.48917905675603,
              -28.779505351261776
            ],
            [
              -55.49198181475836,
              -28.776716943214954
            ],
            [
              -55.49198181475836,
              -28.77070812024082
            ],
            [
              -55.494920190083384,
              -28.767880438841225
            ],
            [
              -55.49550786514839,
              -28.764817117325
            ],
            [
              -55.5029216121223,
              -28.76520985085272
            ],
            [
              -55.50400655070384,
              -28.7641101969751
            ],
            [
              -55.50540792970501,
              -28.76018286169789
            ],
            [
              -55.505995604770014,
              -28.753702758490487
            ],
            [
              -55.50482025464,
              -28.75099289714921
            ],
            [
              -55.507577806868106,
              -28.744787707411216
            ],
            [
              -55.50378052183269,
              -28.741881479306077
            ],
            [
              -55.49718047879494,
              -28.740899645486774
            ],
            [
              -55.496095540213396,
              -28.739799991609154
            ],
            [
              -55.49600512866493,
              -28.738307604203815
            ],
            [
              -55.4974065076661,
              -28.737404317090057
            ],
            [
              -55.4979941827311,
              -28.73540137609868
            ],
            [
              -55.496683215278395,
              -28.732809334815716
            ],
            [
              -55.49718047879494,
              -28.731513314174236
            ],
            [
              -55.49930515018381,
              -28.73049220700216
            ],
            [
              -55.50188187931498,
              -28.73061002706048
            ],
            [
              -55.50929562628889,
              -28.733280615048983
            ],
            [
              -55.512595647807764,
              -28.731081307293742
            ],
            [
              -55.5159860808751,
              -28.727389612133162
            ],
            [
              -55.52009980633013,
              -28.726289958255546
            ],
            [
              -55.534294419438716,
              -28.73009947347444
            ],
            [
              -55.53569579843988,
              -28.72880345283296
            ],
            [
              -55.53768485250605,
              -28.722401896331103
            ],
            [
              -55.534294419438716,
              -28.71788546076231
            ],
            [
              -55.53537935802026,
              -28.71069843720501
            ],
            [
              -55.54319995696225,
              -28.707281655513835
            ],
            [
              -55.54600271496458,
              -28.70720310880829
            ],
            [
              -55.54772053438536,
              -28.708616949508087
            ],
            [
              -55.5498,
              -28.707517295630467
            ],
            [
              -55.54668080157805,
              -28.70590708816681
            ],
            [
              -55.54442051286649,
              -28.70421833399761
            ],
            [
              -55.54130131444454,
              -28.701194285834156
            ],
            [
              -55.536780737021424,
              -28.69868079125674
            ],
            [
              -55.535786209988345,
              -28.696599303559818
            ],
            [
              -55.53650950237604,
              -28.69259342157706
            ],
            [
              -55.53339030395409,
              -28.689019546474796
            ],
            [
              -55.53158207298485,
              -28.686388231839064
            ],
            [
              -55.53009028243522,
              -28.68670241866124
            ],
            [
              -55.52620258585134,
              -28.69039411382182
            ],
            [
              -55.52620258585134,
              -28.693103975163098
            ],
            [
              -55.525705322334794,
              -28.695499649682198
            ],
            [
              -55.52398750291401,
              -28.700016085250994
            ],
            [
              -55.522314889267456,
              -28.703393593589396
            ],
            [
              -55.51978336591051,
              -28.703982693880977
            ],
            [
              -55.51838198690935,
              -28.70480743428919
            ],
            [
              -55.51648334439164,
              -28.70700674204443
            ],
            [
              -55.514584701873936,
              -28.70610345493067
            ],
            [
              -55.51481073074509,
              -28.703589960353256
            ],
            [
              -55.51390661526047,
              -28.700801552306434
            ],
            [
              -55.5125052362593,
              -28.698798611315055
            ],
            [
              -55.51200797274276,
              -28.697109857145854
            ],
            [
              -55.509883301353895,
              -28.694714182626754
            ],
            [
              -55.50870795122388,
              -28.69388944221854
            ],
            [
              -55.505317518156545,
              -28.69459636256844
            ],
            [
              -55.50251476015421,
              -28.697502590673576
            ],
            [
              -55.50061611763651,
              -28.69868079125674
            ],
            [
              -55.49781335963418,
              -28.697895324201298
            ],
            [
              -55.4932023706626,
              -28.6947927293323
            ],
            [
              -55.489088645207566,
              -28.69051193388014
            ],
            [
              -55.48777767775486,
              -28.687605705775
            ],
            [
              -55.48809411817448,
              -28.684110377378282
            ],
            [
              -55.488681793239486,
              -28.681793249564727
            ],
            [
              -55.48940508562718,
              -28.68061504898156
            ],
            [
              -55.49501060163185,
              -28.680183042101067
            ],
            [
              -55.49600512866493,
              -28.678887021459587
            ],
            [
              -55.49559827669685,
              -28.677708820876425
            ],
            [
              -55.49360922263068,
              -28.67539169306287
            ],
            [
              -55.494513338115304,
              -28.672406918252186
            ],
            [
              -55.493021547565675,
              -28.66840103626943
            ],
            [
              -55.490987287725275,
              -28.66470934110885
            ],
            [
              -55.48881741056218,
              -28.663099133645193
            ],
            [
              -55.487099591141394,
              -28.66270640011747
            ],
            [
              -55.486285887205234,
              -28.661803113003714
            ],
            [
              -55.484794096655605,
              -28.66231366658975
            ],
            [
              -55.48461327355868,
              -28.663688233936774
            ],
            [
              -55.48257901371828,
              -28.668086849447253
            ],
            [
              -55.480092696135564,
              -28.668597403033292
            ],
            [
              -55.47787761319824,
              -28.66781193597785
            ],
            [
              -55.47200086254819,
              -28.66470934110885
            ],
            [
              -55.46390902896081,
              -28.663806053995092
            ],
            [
              -55.46128709405541,
              -28.664787887814395
            ],
            [
              -55.4593884515377,
              -28.66631954857251
            ],
            [
              -55.455500754953825,
              -28.668086849447253
            ],
            [
              -55.454687051017665,
              -28.66820466950557
            ],
            [
              -55.45287882004842,
              -28.666790828805773
            ],
            [
              -55.45129661795033,
              -28.666790828805773
            ],
            [
              -55.449578798529544,
              -28.66769411591953
            ],
            [
              -55.44790618488299,
              -28.66930432338319
            ],
            [
              -55.446595217430286,
              -28.674684772712972
            ],
            [
              -55.44609795391374,
              -28.675313146357325
            ],
            [
              -55.44279793239487,
              -28.67448840594911
            ],
            [
              -55.43967873397292,
              -28.67299601854377
            ],
            [
              -55.43800612032637,
              -28.669893423674772
            ],
            [
              -55.4358814489375,
              -28.66800830274171
            ],
            [
              -55.43538418542096,
              -28.666712282100228
            ],
            [
              -55.43520336232404,
              -28.662981313586876
            ],
            [
              -55.434480069936335,
              -28.66058563906778
            ],
            [
              -55.432717044741324,
              -28.65791505107927
            ],
            [
              -55.43140607728862,
              -28.657208130729376
            ],
            [
              -55.431089636869004,
              -28.65599065679344
            ],
            [
              -55.43461568725903,
              -28.653712802332656
            ],
            [
              -55.43841297229445,
              -28.65229896163286
            ],
            [
              -55.43850338384291,
              -28.650610207463657
            ],
            [
              -55.437011593293285,
              -28.649981833819304
            ],
            [
              -55.42968825786784,
              -28.65100294099138
            ],
            [
              -55.42580056128396,
              -28.65080657422752
            ],
            [
              -55.42390191876625,
              -28.64919636676386
            ],
            [
              -55.42091833766699,
              -28.649589100291582
            ],
            [
              -55.420692308795836,
              -28.65088512093306
            ],
            [
              -55.42141560118353,
              -28.653712802332656
            ],
            [
              -55.42091833766699,
              -28.654616089446414
            ],
            [
              -55.41630734869542,
              -28.656501210379478
            ],
            [
              -55.414996381242716,
              -28.65579429002958
            ],
            [
              -55.41440870617771,
              -28.65328079545216
            ],
            [
              -55.41391144266117,
              -28.65009965387762
            ],
            [
              -55.412193623240384,
              -28.649
            ],
            [
              -55.41020456917421,
              -28.64951055358604
            ],
            [
              -55.40821551510804,
              -28.651317127813556
            ],
            [
              -55.40581960907379,
              -28.651906228105137
            ],
            [
              -55.402203147135296,
              -28.650413840699798
            ],
            [
              -55.40030450461759,
              -28.649
            ],
            [
              -55.39768256971218,
              -28.650413840699798
            ],
            [
              -55.39542228100063,
              -28.65119930775524
            ],
            [
              -55.39510584058101,
              -28.653202248746616
            ],
            [
              -55.39551269254909,
              -28.656619030437792
            ],
            [
              -55.39469898861293,
              -28.657993597784817
            ],
            [
              -55.38968114767327,
              -28.660703459126093
            ],
            [
              -55.38918388415673,
              -28.66321695370351
            ],
            [
              -55.38461810095938,
              -28.664984254578258
            ],
            [
              -55.38158931408589,
              -28.66879376979715
            ],
            [
              -55.379690671568184,
              -28.66891158985547
            ],
            [
              -55.37910299650318,
              -28.667419202450127
            ],
            [
              -55.37530571146777,
              -28.66600536175033
            ],
            [
              -55.37381392091814,
              -28.661606746239855
            ],
            [
              -55.37580297498431,
              -28.65791505107927
            ],
            [
              -55.37498927104814,
              -28.657286677434918
            ],
            [
              -55.371689249529275,
              -28.655912110087897
            ],
            [
              -55.36762072984847,
              -28.6537913490382
            ],
            [
              -55.36608373352461,
              -28.65398771580206
            ],
            [
              -55.36517961803999,
              -28.656619030437792
            ],
            [
              -55.36531523536268,
              -28.658818338193033
            ],
            [
              -55.364682354523445,
              -28.660389272303917
            ],
            [
              -55.363597415941896,
              -28.66078200583164
            ],
            [
              -55.36029739442302,
              -28.659014704956892
            ],
            [
              -55.35600284587106,
              -28.657718684315412
            ],
            [
              -55.35451105532144,
              -28.655205189738
            ],
            [
              -55.354013791804896,
              -28.65288806192444
            ],
            [
              -55.35668093248453,
              -28.650688754169202
            ],
            [
              -55.35600284587106,
              -28.64951055358604
            ],
            [
              -55.347820600735226,
              -28.649785467055445
            ],
            [
              -55.346193192862906,
              -28.65080657422752
            ],
            [
              -55.34601236976598,
              -28.652416781691176
            ],
            [
              -55.347006896799066,
              -28.65469463615196
            ],
            [
              -55.34628360441137,
              -28.657404497493236
            ],
            [
              -55.347684983412535,
              -28.660899825889956
            ],
            [
              -55.34718771989599,
              -28.66341332046737
            ],
            [
              -55.34519866582982,
              -28.66690864886409
            ],
            [
              -55.343797286828654,
              -28.66710501562795
            ],
            [
              -55.340678088406705,
              -28.66561262822261
            ],
            [
              -55.33688080337129,
              -28.66600536175033
            ],
            [
              -55.33339995875549,
              -28.666083908455875
            ],
            [
              -55.3305067892047,
              -28.667419202450127
            ],
            [
              -55.32349989419887,
              -28.660192905540057
            ],
            [
              -55.32331907110194,
              -28.65948598519016
            ],
            [
              -55.32458483278042,
              -28.656501210379478
            ],
            [
              -55.322595778714245,
              -28.655519376560175
            ],
            [
              -55.32060672464807,
              -28.65528373644354
            ],
            [
              -55.315995735676495,
              -28.657600864257095
            ],
            [
              -55.31450394512687,
              -28.664591521050536
            ],
            [
              -55.30822034250874,
              -28.670914530846847
            ],
            [
              -55.3056888191518,
              -28.672014184724468
            ],
            [
              -55.30320250156908,
              -28.67130726437457
            ],
            [
              -55.29809424908096,
              -28.667419202450127
            ],
            [
              -55.29090653097821,
              -28.665180621342117
            ],
            [
              -55.28701883439433,
              -28.66639809527805
            ],
            [
              -55.28448731103739,
              -28.668990136561014
            ],
            [
              -55.28530101497355,
              -28.672289098193872
            ],
            [
              -55.28778733255626,
              -28.675313146357325
            ],
            [
              -55.28760650945934,
              -28.678612107990183
            ],
            [
              -55.28579827849009,
              -28.68151833609532
            ],
            [
              -55.28267908006814,
              -28.68301072350066
            ],
            [
              -55.280102350936964,
              -28.681282695978688
            ],
            [
              -55.27937905854927,
              -28.67739463405425
            ],
            [
              -55.27770644490271,
              -28.676216433471083
            ],
            [
              -55.276983152515015,
              -28.67319238530763
            ],
            [
              -55.27499409844884,
              -28.672289098193872
            ],
            [
              -55.26098030843719,
              -28.679319028340082
            ],
            [
              -55.25541999820676,
              -28.682696536678485
            ],
            [
              -55.254018619205596,
              -28.68501366449204
            ],
            [
              -55.253792590334434,
              -28.68921591323866
            ],
            [
              -55.25329532681789,
              -28.69090466740786
            ],
            [
              -55.24529390477898,
              -28.688391172830443
            ],
            [
              -55.23860345019277,
              -28.688194806066583
            ],
            [
              -55.235981515287364,
              -28.68740933901114
            ],
            [
              -55.236117132610055,
              -28.685092211197585
            ],
            [
              -55.24099935622702,
              -28.68261798997294
            ],
            [
              -55.242717175647805,
              -28.679319028340082
            ],
            [
              -55.24221991213126,
              -28.677512454112563
            ],
            [
              -55.238015775127764,
              -28.67539169306287
            ],
            [
              -55.235710280641975,
              -28.67448840594911
            ],
            [
              -55.232591082220026,
              -28.672406918252186
            ],
            [
              -55.23010476463732,
              -28.666594462041914
            ],
            [
              -55.22590062763382,
              -28.666201728514192
            ],
            [
              -55.223007458083025,
              -28.66930432338319
            ],
            [
              -55.22309786963149,
              -28.676609166998805
            ],
            [
              -55.226895154666906,
              -28.692004321285477
            ],
            [
              -55.23268149376849,
              -28.696402936795955
            ],
            [
              -55.23200340715503,
              -28.69868079125674
            ],
            [
              -55.2263074796019,
              -28.701390652598015
            ],
            [
              -55.22468007172958,
              -28.70441470076147
            ],
            [
              -55.22621706805344,
              -28.708616949508087
            ],
            [
              -55.22540336411728,
              -28.71140535755491
            ],
            [
              -55.22201293104994,
              -28.71309411172411
            ],
            [
              -55.2117964260737,
              -28.71018788361897
            ],
            [
              -55.20750187752174,
              -28.711483904260454
            ],
            [
              -55.204382679099794,
              -28.71808182752617
            ],
            [
              -55.20298130009863,
              -28.721694975981205
            ],
            [
              -55.20072101138707,
              -28.723187363386547
            ],
            [
              -55.193578499058546,
              -28.725386671141784
            ],
            [
              -55.19149903344391,
              -28.727585978897025
            ],
            [
              -55.19430179144624,
              -28.732612968051857
            ],
            [
              -55.19167985654084,
              -28.73638320991798
            ],
            [
              -55.1890127158612,
              -28.74360950682805
            ],
            [
              -55.18738530798888,
              -28.744984074175076
            ],
            [
              -55.18449213843809,
              -28.74600518134715
            ],
            [
              -55.18300034788846,
              -28.749186322921695
            ],
            [
              -55.18788257150542,
              -28.753702758490487
            ],
            [
              -55.19271958934816,
              -28.756098433009587
            ],
            [
              -55.19167985654084,
              -28.75798355394265
            ],
            [
              -55.186707221375414,
              -28.761910889219862
            ],
            [
              -55.18471816730924,
              -28.761793069161545
            ],
            [
              -55.17599345288263,
              -28.757708640473243
            ],
            [
              -55.17517974894647,
              -28.756412619831764
            ],
            [
              -55.17621948175378,
              -28.75460604560425
            ],
            [
              -55.17490851430108,
              -28.753781305196032
            ],
            [
              -55.16478242087331,
              -28.75169981749911
            ],
            [
              -55.16211528019367,
              -28.747183381930316
            ],
            [
              -55.16139198780597,
              -28.74490552746953
            ],
            [
              -55.159719374159415,
              -28.742392032892116
            ],
            [
              -55.15858922980364,
              -28.739289438023118
            ],
            [
              -55.15537961983323,
              -28.73669739674016
            ],
            [
              -55.15009054424818,
              -28.737914870676093
            ],
            [
              -55.14330967811351,
              -28.740389091900738
            ],
            [
              -55.13910554111001,
              -28.74121383230895
            ],
            [
              -55.13621237155922,
              -28.742706219714293
            ],
            [
              -55.132595909620726,
              -28.744984074175076
            ],
            [
              -55.126493130099526,
              -28.742902586478152
            ],
            [
              -55.12269584506411,
              -28.745298260997252
            ],
            [
              -55.114784834573655,
              -28.742392032892116
            ],
            [
              -55.11211769389402,
              -28.74250985295043
            ],
            [
              -55.10768752801936,
              -28.747615388810807
            ],
            [
              -55.10230804088586,
              -28.751385630676932
            ],
            [
              -55.098601167398904,
              -28.753506391726628
            ],
            [
              -55.09570799784811,
              -28.751307083971387
            ],
            [
              -55.08689287187304,
              -28.751307083971387
            ],
            [
              -55.08680246032458,
              -28.75389912525435
            ],
            [
              -55.085898344839954,
              -28.756687533301168
            ],
            [
              -55.077399659284495,
              -28.759397394642445
            ],
            [
              -55.07301469918407,
              -28.761203968869964
            ],
            [
              -55.073105110732534,
              -28.7634032766252
            ],
            [
              -55.078213363220655,
              -28.765995317908164
            ],
            [
              -55.07880103828566,
              -28.768390992427264
            ],
            [
              -55.07111605666637,
              -28.776206389628914
            ],
            [
              -55.06749959472788,
              -28.77718822344822
            ],
            [
              -55.06460642517708,
              -28.77738459021208
            ],
            [
              -55.06108037478705,
              -28.77388926181536
            ],
            [
              -55.06089955169013,
              -28.770786666946364
            ],
            [
              -55.05818720523626,
              -28.7696084663632
            ],
            [
              -55.05601732807316,
              -28.766702238258063
            ],
            [
              -55.05059263516542,
              -28.764385110444508
            ],
            [
              -55.04738302519501,
              -28.764699297266684
            ],
            [
              -55.04372135748229,
              -28.762185802689267
            ],
            [
              -55.04308847664306,
              -28.762696356275306
            ],
            [
              -55.04331450551421,
              -28.770511753476956
            ],
            [
              -55.04281724199767,
              -28.7743998154014
            ],
            [
              -55.03712131444454,
              -28.778012963856433
            ],
            [
              -55.034499379539135,
              -28.780683551844938
            ],
            [
              -55.030611682955254,
              -28.78940223616035
            ],
            [
              -55.03269114856989,
              -28.792504831029348
            ],
            [
              -55.03400211602259,
              -28.798199467181306
            ],
            [
              -55.02808015959831,
              -28.798906387531204
            ],
            [
              -55.024915755402134,
              -28.798317287239623
            ],
            [
              -55.02129929346364,
              -28.787713481991148
            ],
            [
              -55.01890338742939,
              -28.78869531581045
            ],
            [
              -55.01460883887743,
              -28.794311405256867
            ],
            [
              -55.01139922890702,
              -28.79588233936775
            ],
            [
              -55.007782766968525,
              -28.796510713012104
            ],
            [
              -55.0070142688066,
              -28.789716422982526
            ],
            [
              -55.00511562628889,
              -28.784100333536113
            ],
            [
              -55.00511562628889,
              -28.777816597092574
            ],
            [
              -55.00430192235273,
              -28.7760885695706
            ],
            [
              -55.00339780686811,
              -28.776010022865055
            ],
            [
              -54.99639091186228,
              -28.777698777034256
            ],
            [
              -54.99530597328073,
              -28.780801371903255
            ],
            [
              -54.99128265937416,
              -28.783393413186214
            ],
            [
              -54.98979086882453,
              -28.785906907763632
            ],
            [
              -54.98242232762485,
              -28.78940223616035
            ],
            [
              -54.98151821214023,
              -28.795214692370624
            ],
            [
              -54.975912696135566,
              -28.79768891359527
            ],
            [
              -54.97338117277862,
              -28.80138060875585
            ],
            [
              -54.96922224154936,
              -28.803187182983365
            ],
            [
              -54.96818250874204,
              -28.80589704432464
            ],
            [
              -54.96461125257778,
              -28.80829271884374
            ],
            [
              -54.96058793867121,
              -28.80841053890206
            ],
            [
              -54.95719750560387,
              -28.80841053890206
            ],
            [
              -54.95471118802116,
              -28.809392372721362
            ],
            [
              -54.95349063211692,
              -28.812612787648675
            ],
            [
              -54.95181801847036,
              -28.8139873549957
            ],
            [
              -54.95019061059804,
              -28.817089949864698
            ],
            [
              -54.94711661795033,
              -28.81728631662856
            ],
            [
              -54.94698100062763,
              -28.815990295987078
            ],
            [
              -54.943409744463374,
              -28.81508700887332
            ],
            [
              -54.94038095758989,
              -28.815519015753814
            ],
            [
              -54.938798755491796,
              -28.817404136686875
            ],
            [
              -54.93540832242446,
              -28.819407077678253
            ],
            [
              -54.93549873397292,
              -28.823295139602696
            ],
            [
              -54.93188227203443,
              -28.823884239894277
            ],
            [
              -54.930978156549806,
              -28.82580863418011
            ],
            [
              -54.928582250515554,
              -28.82510171383021
            ],
            [
              -54.926683607997845,
              -28.822588219252797
            ],
            [
              -54.921982207477804,
              -28.825298080594074
            ],
            [
              -54.91917944947548,
              -28.824983893771897
            ],
            [
              -54.91488490092352,
              -28.823491506366555
            ],
            [
              -54.91230817179234,
              -28.823295139602696
            ],
            [
              -54.91081638124271,
              -28.823687873130417
            ],
            [
              -54.9070190962073,
              -28.828989775754653
            ],
            [
              -54.905210865238054,
              -28.829382509282375
            ],
            [
              -54.90231769568726,
              -28.829382509282375
            ],
            [
              -54.90109713978302,
              -28.828086488640892
            ],
            [
              -54.90168481484802,
              -28.822902406074974
            ],
            [
              -54.901413580202636,
              -28.819681991147657
            ],
            [
              -54.902091666816105,
              -28.817600503450738
            ],
            [
              -54.90050946471801,
              -28.8163830295148
            ],
            [
              -54.896712179682595,
              -28.815519015753814
            ],
            [
              -54.894677919842195,
              -28.816108116045395
            ],
            [
              -54.89350256971218,
              -28.817600503450738
            ],
            [
              -54.89300530619564,
              -28.81928925761994
            ],
            [
              -54.893186129292566,
              -28.822313305783393
            ],
            [
              -54.89210119071102,
              -28.82451261353863
            ],
            [
              -54.8883039056756,
              -28.824905347066352
            ],
            [
              -54.8835120936071,
              -28.824905347066352
            ],
            [
              -54.882110714605936,
              -28.82639773447169
            ],
            [
              -54.881703862637856,
              -28.829107595812967
            ],
            [
              -54.88559155922173,
              -28.83448804514275
            ],
            [
              -54.88649567470635,
              -28.837001539720166
            ],
            [
              -54.88391894557518,
              -28.841282335172327
            ],
            [
              -54.88310524163902,
              -28.843206729458164
            ],
            [
              -54.881703862637856,
              -28.843599462985882
            ],
            [
              -54.87939836815207,
              -28.841085968408468
            ],
            [
              -54.87641478705281,
              -28.839907767825302
            ],
            [
              -54.87501340805164,
              -28.839907767825302
            ],
            [
              -54.87329558863086,
              -28.838415380419963
            ],
            [
              -54.86940789204698,
              -28.839004480711544
            ],
            [
              -54.8647969030754,
              -28.833309844559587
            ],
            [
              -54.862581820138075,
              -28.83299565773741
            ],
            [
              -54.86099961803999,
              -28.832092370623652
            ],
            [
              -54.85928179861921,
              -28.832210190681966
            ],
            [
              -54.857699596521115,
              -28.83409531161503
            ],
            [
              -54.85507766161571,
              -28.835509152314824
            ],
            [
              -54.854987250067246,
              -28.839200847475404
            ],
            [
              -54.85430916345378,
              -28.840104134589165
            ],
            [
              -54.850421466869896,
              -28.841085968408468
            ],
            [
              -54.84861323590065,
              -28.837119359778484
            ],
            [
              -54.848387207029496,
              -28.833309844559587
            ],
            [
              -54.84788994351295,
              -28.832917111031865
            ],
            [
              -54.84228442750829,
              -28.83409531161503
            ],
            [
              -54.84169675244328,
              -28.834605865201066
            ],
            [
              -54.84061181386174,
              -28.837315726542343
            ],
            [
              -54.84210360441137,
              -28.841989255522225
            ],
            [
              -54.84341457186407,
              -28.844699116863502
            ],
            [
              -54.84400224692907,
              -28.84721261144092
            ],
            [
              -54.8443186873487,
              -28.850590119779323
            ],
            [
              -54.84341457186407,
              -28.851414860187536
            ],
            [
              -54.84187757554021,
              -28.85098285330704
            ],
            [
              -54.8393912579575,
              -28.85098285330704
            ],
            [
              -54.836407676858244,
              -28.84870499884626
            ],
            [
              -54.834780268985924,
              -28.84791953179082
            ],
            [
              -54.83310765533937,
              -28.848312265318537
            ],
            [
              -54.83089257240204,
              -28.850590119779323
            ],
            [
              -54.82420211781583,
              -28.854713821820393
            ],
            [
              -54.82207744642697,
              -28.85718804304504
            ],
            [
              -54.82130894826504,
              -28.859308804094734
            ],
            [
              -54.82090209629696,
              -28.86280413249145
            ],
            [
              -54.819500717295796,
              -28.866692194415894
            ],
            [
              -54.815884255357304,
              -28.868498768643413
            ],
            [
              -54.815206168743835,
              -28.869087868934994
            ],
            [
              -54.812900674258046,
              -28.868498768643413
            ],
            [
              -54.810097916255714,
              -28.86661364771035
            ],
            [
              -54.8089225661257,
              -28.867084927943615
            ],
            [
              -54.80648145431722,
              -28.86889150217113
            ],
            [
              -54.80358828476643,
              -28.869794789284892
            ],
            [
              -54.80069511521563,
              -28.86999115604875
            ],
            [
              -54.79762112256792,
              -28.871719183570725
            ],
            [
              -54.79418548372635,
              -28.874703958381406
            ],
            [
              -54.79228684120864,
              -28.874507591617547
            ],
            [
              -54.79061422756209,
              -28.875018145203583
            ],
            [
              -54.78912243701246,
              -28.874703958381406
            ],
            [
              -54.78650050210705,
              -28.872897384153887
            ],
            [
              -54.78387856720165,
              -28.87250465062617
            ],
            [
              -54.78030731103739,
              -28.873211570976068
            ],
            [
              -54.77908675513314,
              -28.87368285120933
            ],
            [
              -54.776193585582355,
              -28.87238683056785
            ],
            [
              -54.7745209719358,
              -28.87250465062617
            ],
            [
              -54.77158259661078,
              -28.871719183570725
            ],
            [
              -54.771492185062314,
              -28.87050170963479
            ],
            [
              -54.770407246480765,
              -28.869480602462716
            ],
            [
              -54.771492185062314,
              -28.868695135407272
            ],
            [
              -54.770814098448845,
              -28.866181640829854
            ],
            [
              -54.76968395409307,
              -28.86531762706887
            ],
            [
              -54.76792092889805,
              -28.86531762706887
            ],
            [
              -54.76701681341343,
              -28.863196866019173
            ],
            [
              -54.76547981708957,
              -28.862293578905415
            ],
            [
              -54.7634907630234,
              -28.860094271150174
            ],
            [
              -54.76159212050569,
              -28.85911243733087
            ],
            [
              -54.75802086434143,
              -28.856088389167418
            ],
            [
              -54.75490166591948,
              -28.854910188584256
            ],
            [
              -54.75282220030485,
              -28.853614167942776
            ],
            [
              -54.750019442302516,
              -28.8556956556397
            ],
            [
              -54.74708106697749,
              -28.8549887352898
            ],
            [
              -54.7454988648794,
              -28.855499288875837
            ],
            [
              -54.74039061239128,
              -28.85479236852594
            ],
            [
              -54.739396085358194,
              -28.85349634788446
            ],
            [
              -54.734107009773155,
              -28.85039375301546
            ],
            [
              -54.73130425177082,
              -28.850511573073778
            ],
            [
              -54.72719052631579,
              -28.848194445260223
            ],
            [
              -54.72248912579575,
              -28.84411001657192
            ],
            [
              -54.720500071729575,
              -28.843206729458164
            ],
            [
              -54.71918910427687,
              -28.84191070881668
            ],
            [
              -54.70788766071909,
              -28.83668735289799
            ],
            [
              -54.70829451268717,
              -28.834213131673344
            ],
            [
              -54.70937945126872,
              -28.831503270332068
            ],
            [
              -54.70879177620371,
              -28.83059998321831
            ],
            [
              -54.70951506859141,
              -28.827183201527134
            ],
            [
              -54.71118768223796,
              -28.824591160244175
            ],
            [
              -54.71322194207836,
              -28.819917631264293
            ],
            [
              -54.713719205594906,
              -28.818111057036774
            ],
            [
              -54.71340276517529,
              -28.814812095403916
            ],
            [
              -54.713583588272215,
              -28.81198441400432
            ],
            [
              -54.712905501658746,
              -28.806996698202262
            ],
            [
              -54.71430688065991,
              -28.805582857502465
            ],
            [
              -54.71539181924146,
              -28.80350136980554
            ],
            [
              -54.71430688065991,
              -28.802205349164062
            ],
            [
              -54.71390002869183,
              -28.799416941117244
            ],
            [
              -54.7145781153053,
              -28.798710020767345
            ],
            [
              -54.71380961714337,
              -28.796314346248245
            ],
            [
              -54.71430688065991,
              -28.795214692370624
            ],
            [
              -54.71281509011028,
              -28.791915730737767
            ],
            [
              -54.71191097462566,
              -28.790816076860146
            ],
            [
              -54.71019315520488,
              -28.78571054099977
            ],
            [
              -54.70829451268717,
              -28.784100333536113
            ],
            [
              -54.706305458620996,
              -28.783000679658493
            ],
            [
              -54.70409037568367,
              -28.777895143798116
            ],
            [
              -54.7021013216175,
              -28.77518528245684
            ],
            [
              -54.70069994261633,
              -28.774910368987435
            ],
            [
              -54.69830403658209,
              -28.773417981582096
            ],
            [
              -54.69649580561284,
              -28.771807774118436
            ],
            [
              -54.69798759616246,
              -28.769019366071618
            ],
            [
              -54.697399921097464,
              -28.766702238258063
            ],
            [
              -54.69500401506321,
              -28.766780784963604
            ],
            [
              -54.69391907648166,
              -28.76630950473034
            ],
            [
              -54.691613581995874,
              -28.76261780956976
            ],
            [
              -54.690121791446245,
              -28.761910889219862
            ],
            [
              -54.68948891060701,
              -28.759083207820268
            ],
            [
              -54.68799712005738,
              -28.75759082041493
            ],
            [
              -54.687680679637765,
              -28.754016945312664
            ],
            [
              -54.68691218147583,
              -28.75279947137673
            ],
            [
              -54.68487792163543,
              -28.752485284554552
            ],
            [
              -54.68361215995696,
              -28.749893243271593
            ],
            [
              -54.681487488568095,
              -28.748715042688428
            ],
            [
              -54.67981487492155,
              -28.745690994524974
            ],
            [
              -54.67900117098538,
              -28.743295320005874
            ],
            [
              -54.67868473056576,
              -28.740506911959052
            ],
            [
              -54.677418968887295,
              -28.740506911959052
            ],
            [
              -54.675520326369586,
              -28.737718503912234
            ],
            [
              -54.676198412983055,
              -28.732416601287994
            ],
            [
              -54.674706622433426,
              -28.72990310671058
            ],
            [
              -54.674480593562265,
              -28.72880345283296
            ],
            [
              -54.67520388594997,
              -28.72731106542762
            ],
            [
              -54.674706622433426,
              -28.724993937614062
            ],
            [
              -54.675520326369586,
              -28.724208470558622
            ],
            [
              -54.67488744553035,
              -28.72271608315328
            ],
            [
              -54.6738025069488,
              -28.72161642927566
            ],
            [
              -54.67420935891688,
              -28.719417121520422
            ],
            [
              -54.6724915394961,
              -28.71698217364855
            ],
            [
              -54.67131618936609,
              -28.716000339829247
            ],
            [
              -54.66860384291222,
              -28.71568615300707
            ],
            [
              -54.66521340984488,
              -28.71619670659311
            ],
            [
              -54.66521340984488,
              -28.720988055631306
            ],
            [
              -54.662998326907555,
              -28.72271608315328
            ],
            [
              -54.66241065184255,
              -28.724208470558622
            ],
            [
              -54.661099684389846,
              -28.72530812443624
            ],
            [
              -54.65938186496906,
              -28.724208470558622
            ],
            [
              -54.657709251322515,
              -28.724797570850203
            ],
            [
              -54.656217460772886,
              -28.727193245369303
            ],
            [
              -54.65572019725634,
              -28.730217293532757
            ],
            [
              -54.65698595893481,
              -28.732180961171363
            ],
            [
              -54.65879418990406,
              -28.73300570157958
            ],
            [
              -54.66010515735676,
              -28.734498088984918
            ],
            [
              -54.65671472428943,
              -28.739407258081435
            ],
            [
              -54.65278182193132,
              -28.740506911959052
            ],
            [
              -54.64939138886398,
              -28.738111237439952
            ],
            [
              -54.64609136734511,
              -28.735519196156993
            ],
            [
              -54.64631739621626,
              -28.73379116863502
            ],
            [
              -54.64541328073164,
              -28.73308424828512
            ],
            [
              -54.64351463821393,
              -28.732691514757402
            ],
            [
              -54.64030502824352,
              -28.73359480187116
            ],
            [
              -54.64007899937236,
              -28.73469445574878
            ],
            [
              -54.640983114856986,
              -28.7374828637956
            ],
            [
              -54.64170640724468,
              -28.741881479306077
            ],
            [
              -54.64080229176006,
              -28.74341314006419
            ],
            [
              -54.63831597417735,
              -28.744984074175076
            ],
            [
              -54.63488033533578,
              -28.74620154811101
            ],
            [
              -54.63189675423653,
              -28.74620154811101
            ],
            [
              -54.62990770017036,
              -28.74800812233853
            ],
            [
              -54.628189880749574,
              -28.748086669044074
            ],
            [
              -54.627104942168025,
              -28.74671210169705
            ],
            [
              -54.62570356316686,
              -28.743491686769737
            ],
            [
              -54.6262008266834,
              -28.742117119422712
            ],
            [
              -54.62828029229804,
              -28.741096012250637
            ],
            [
              -54.627783028781494,
              -28.73881815778985
            ],
            [
              -54.62389533219761,
              -28.739407258081435
            ],
            [
              -54.61838022774141,
              -28.73909307125926
            ],
            [
              -54.61340759257599,
              -28.744984074175076
            ],
            [
              -54.610107571057114,
              -28.74600518134715
            ],
            [
              -54.61729528915986,
              -28.753310024962765
            ],
            [
              -54.61639117367524,
              -28.759907948228484
            ],
            [
              -54.620911751098355,
              -28.761007602106105
            ],
            [
              -54.62371450910069,
              -28.76281417633362
            ],
            [
              -54.62538712274724,
              -28.764581477208367
            ],
            [
              -54.627104942168025,
              -28.76941209959934
            ],
            [
              -54.625613151618396,
              -28.769883379832603
            ],
            [
              -54.62109257419528,
              -28.768390992427264
            ],
            [
              -54.614402119609075,
              -28.77019756665478
            ],
            [
              -54.619691195194115,
              -28.776402756392777
            ],
            [
              -54.619284343226035,
              -28.77718822344822
            ],
            [
              -54.61218703667175,
              -28.77479254892912
            ],
            [
              -54.604682878149376,
              -28.777816597092574
            ],
            [
              -54.60771166502286,
              -28.779701718025635
            ],
            [
              -54.611689773155206,
              -28.779701718025635
            ],
            [
              -54.61367882722137,
              -28.784296700299972
            ],
            [
              -54.61309115215637,
              -28.786181821233036
            ],
            [
              -54.61150895005828,
              -28.787085108346794
            ],
            [
              -54.60920345557249,
              -28.787281475110657
            ],
            [
              -54.60721440150632,
              -28.78260794613077
            ],
            [
              -54.60291985295436,
              -28.781704659017013
            ],
            [
              -54.601880120147044,
              -28.781901025780876
            ],
            [
              -54.60061435846857,
              -28.784296700299972
            ],
            [
              -54.5979020120147,
              -28.78661382811353
            ],
            [
              -54.59641022146508,
              -28.78661382811353
            ],
            [
              -54.59469240204429,
              -28.78441452035829
            ],
            [
              -54.5904882650408,
              -28.78480725388601
            ],
            [
              -54.587278655070385,
              -28.787792028696693
            ],
            [
              -54.58289369496996,
              -28.789284416102035
            ],
            [
              -54.58221560835649,
              -28.790580436743515
            ],
            [
              -54.5862841280373,
              -28.793211751379246
            ],
            [
              -54.59188964404196,
              -28.79160154391559
            ],
            [
              -54.593381434591585,
              -28.79348666484865
            ],
            [
              -54.591618409396574,
              -28.79529323907617
            ],
            [
              -54.59008141307272,
              -28.799888221350507
            ],
            [
              -54.58691700887653,
              -28.8027159027501
            ],
            [
              -54.58397863355151,
              -28.803305003041682
            ],
            [
              -54.580407377387246,
              -28.798788567472887
            ],
            [
              -54.57868955796646,
              -28.798592200709027
            ],
            [
              -54.576610092351835,
              -28.800791508464265
            ],
            [
              -54.57850873486954,
              -28.804993757210884
            ],
            [
              -54.58090464090379,
              -28.806486144616226
            ],
            [
              -54.586600568456916,
              -28.80640759791068
            ],
            [
              -54.59112114588003,
              -28.802283895869607
            ],
            [
              -54.59460199049583,
              -28.80350136980554
            ],
            [
              -54.595686929077374,
              -28.805700677560782
            ],
            [
              -54.591211557428494,
              -28.80899963919364
            ],
            [
              -54.58990058997579,
              -28.816815036395294
            ],
            [
              -54.588092359006545,
              -28.818385970506178
            ],
            [
              -54.58691700887653,
              -28.817600503450738
            ],
            [
              -54.58641974535999,
              -28.813594621467978
            ],
            [
              -54.585380012552676,
              -28.812298600826498
            ],
            [
              -54.57868955796646,
              -28.81308406788194
            ],
            [
              -54.57480186138259,
              -28.81689358310084
            ],
            [
              -54.57611282883529,
              -28.819681991147657
            ],
            [
              -54.57611282883529,
              -28.82058527826142
            ],
            [
              -54.57331007083296,
              -28.82431624677477
            ],
            [
              -54.572179926477176,
              -28.82510171383021
            ],
            [
              -54.57398815744642,
              -28.828400675463072
            ],
            [
              -54.574304597866046,
              -28.832602924209688
            ],
            [
              -54.576790915448754,
              -28.83480223196493
            ],
            [
              -54.57769503093338,
              -28.83688371966185
            ],
            [
              -54.576790915448754,
              -28.838101193597787
            ],
            [
              -54.57462103828566,
              -28.838886660653227
            ],
            [
              -54.574304597866046,
              -28.837001539720166
            ],
            [
              -54.57358130547834,
              -28.836608806192444
            ],
            [
              -54.57059772437909,
              -28.837001539720166
            ],
            [
              -54.56942237424908,
              -28.835509152314824
            ],
            [
              -54.568382641441765,
              -28.83539133225651
            ],
            [
              -54.56711687976329,
              -28.836608806192444
            ],
            [
              -54.56508261992289,
              -28.837590640011747
            ],
            [
              -54.56521823724558,
              -28.8430103626943
            ],
            [
              -54.56431412176096,
              -28.843599462985882
            ],
            [
              -54.560697659822466,
              -28.84281399593044
            ],
            [
              -54.560607248274,
              -28.84481693692182
            ],
            [
              -54.55920586927284,
              -28.84670205785488
            ],
            [
              -54.557081197883974,
              -28.847683891674183
            ],
            [
              -54.556222288173586,
              -28.84740897820478
            ],
            [
              -54.5545044687528,
              -28.843481642927568
            ],
            [
              -54.553012678203174,
              -28.84261762916658
            ],
            [
              -54.546412635165424,
              -28.842303442344402
            ],
            [
              -54.54577975432619,
              -28.843285276163705
            ],
            [
              -54.5476783968439,
              -28.84501330368568
            ],
            [
              -54.54709072177889,
              -28.848312265318537
            ],
            [
              -54.5455085196808,
              -28.849294099137843
            ],
            [
              -54.544920844615795,
              -28.848587178787945
            ],
            [
              -54.54401672913117,
              -28.84501330368568
            ],
            [
              -54.540219444095754,
              -28.845288217155083
            ],
            [
              -54.538592036223434,
              -28.84740897820478
            ],
            [
              -54.53908929973998,
              -28.849490465901702
            ],
            [
              -54.541394794225766,
              -28.84968683266556
            ],
            [
              -54.54360987716309,
              -28.852318147301297
            ],
            [
              -54.546412635165424,
              -28.853182161062282
            ],
            [
              -54.546819487133504,
              -28.854203268234357
            ],
            [
              -54.5455085196808,
              -28.854910188584256
            ],
            [
              -54.54198246929077,
              -28.855813475698014
            ],
            [
              -54.54107835380615,
              -28.857109496339493
            ],
            [
              -54.54211808661346,
              -28.858601883744836
            ],
            [
              -54.540987942257686,
              -28.859190984036417
            ],
            [
              -54.53841121312651,
              -28.857384409808898
            ],
            [
              -54.538592036223434,
              -28.8549887352898
            ],
            [
              -54.537507097641885,
              -28.854281814939903
            ],
            [
              -54.53361940105801,
              -28.857816416689392
            ],
            [
              -54.531811170088766,
              -28.858798250508695
            ],
            [
              -54.529415264054514,
              -28.85828769692266
            ],
            [
              -54.52828511969874,
              -28.857502229867215
            ],
            [
              -54.52579880211602,
              -28.858091330158796
            ],
            [
              -54.52720018111719,
              -28.85981935768077
            ],
            [
              -54.529415264054514,
              -28.85981935768077
            ],
            [
              -54.52842073702143,
              -28.86720274800193
            ],
            [
              -54.52457824621178,
              -28.867084927943615
            ],
            [
              -54.52299604411369,
              -28.869480602462716
            ],
            [
              -54.52299604411369,
              -28.87089444316251
            ],
            [
              -54.51761655698019,
              -28.868616588701727
            ],
            [
              -54.515401474042854,
              -28.86889150217113
            ],
            [
              -54.5124178929436,
              -28.87270101739003
            ],
            [
              -54.510112398457814,
              -28.87419340479537
            ],
            [
              -54.50871101945665,
              -28.87329011768161
            ],
            [
              -54.50541099793777,
              -28.86881295546559
            ],
            [
              -54.50450688245315,
              -28.86810603511569
            ],
            [
              -54.502291799515824,
              -28.87010897610707
            ],
            [
              -54.49980548193311,
              -28.871719183570725
            ],
            [
              -54.499715070384646,
              -28.868498768643413
            ],
            [
              -54.49700272393078,
              -28.86830240187955
            ],
            [
              -54.495691756478074,
              -28.866103094124313
            ],
            [
              -54.49221091186228,
              -28.867791848293514
            ],
            [
              -54.49198488299112,
              -28.86881295546559
            ],
            [
              -54.49270817537882,
              -28.871090809926372
            ],
            [
              -54.49460681789653,
              -28.87258319733171
            ],
            [
              -54.49460681789653,
              -28.87438977155923
            ],
            [
              -54.49230132341074,
              -28.87490032514527
            ],
            [
              -54.48900130189187,
              -28.873997038031508
            ],
            [
              -54.48859444992379,
              -28.875293058672987
            ],
            [
              -54.48710265937416,
              -28.875214511967446
            ],
            [
              -54.48669580740608,
              -28.872111917098447
            ],
            [
              -54.48511360530799,
              -28.87199409704013
            ],
            [
              -54.483802637855284,
              -28.871208629984686
            ],
            [
              -54.48140673182103,
              -28.872818837448346
            ],
            [
              -54.481903995337575,
              -28.87368285120933
            ],
            [
              -54.47810671030216,
              -28.873015204212205
            ],
            [
              -54.4786039738187,
              -28.875214511967446
            ],
            [
              -54.479598500851786,
              -28.876314165845063
            ],
            [
              -54.48330537433874,
              -28.878199286778127
            ],
            [
              -54.486198543889536,
              -28.878709840364163
            ],
            [
              -54.48651498430915,
              -28.87941676071406
            ],
            [
              -54.48348619743567,
              -28.880791328061086
            ],
            [
              -54.481497143369495,
              -28.88251935558306
            ],
            [
              -54.480005352819866,
              -28.881380428352667
            ],
            [
              -54.47851356227024,
              -28.882087348702566
            ],
            [
              -54.47688615439792,
              -28.882087348702566
            ],
            [
              -54.47498751188021,
              -28.880202227769505
            ],
            [
              -54.47299845781404,
              -28.880280774475047
            ],
            [
              -54.47028611136017,
              -28.87788509995595
            ],
            [
              -54.470014876714785,
              -28.879102573891885
            ],
            [
              -54.46680526674437,
              -28.87941676071406
            ],
            [
              -54.46517785887205,
              -28.878709840364163
            ],
            [
              -54.465720328162824,
              -28.87678544607833
            ],
            [
              -54.46440936071012,
              -28.87678544607833
            ],
            [
              -54.46160660270779,
              -28.875803612259027
            ],
            [
              -54.4606120756747,
              -28.877413819722683
            ],
            [
              -54.45939151977046,
              -28.875999979022886
            ],
            [
              -54.45808055231776,
              -28.87678544607833
            ],
            [
              -54.45699561373621,
              -28.878788387069708
            ],
            [
              -54.46020522370662,
              -28.880398594533364
            ],
            [
              -54.46011481215816,
              -28.881890981938707
            ],
            [
              -54.45740246570429,
              -28.885582677099286
            ],
            [
              -54.45740246570429,
              -28.886289597449185
            ],
            [
              -54.45401203263696,
              -28.88691797109354
            ],
            [
              -54.452203801667714,
              -28.88801762497116
            ],
            [
              -54.45148050928001,
              -28.889117278848776
            ],
            [
              -54.45120927463463,
              -28.891512953367876
            ],
            [
              -54.44998871873039,
              -28.892180600365002
            ],
            [
              -54.44831610508383,
              -28.89100239978184
            ],
            [
              -54.44569417017843,
              -28.887781984854524
            ],
            [
              -54.44320785259571,
              -28.89100239978184
            ],
            [
              -54.44338867569264,
              -28.892180600365002
            ],
            [
              -54.44501608356496,
              -28.893515894359254
            ],
            [
              -54.444790054693804,
              -28.89489046170628
            ],
            [
              -54.44271058907917,
              -28.89618648234776
            ],
            [
              -54.44031468304492,
              -28.894615548236875
            ],
            [
              -54.43932015601183,
              -28.896500669169935
            ],
            [
              -54.437511925042585,
              -28.896107935642213
            ],
            [
              -54.435206430556796,
              -28.89708976946152
            ],
            [
              -54.435613282524876,
              -28.899799630802796
            ],
            [
              -54.434392726620636,
              -28.902980772377337
            ],
            [
              -54.43321737649063,
              -28.903491325963376
            ],
            [
              -54.431183116650224,
              -28.90529790019089
            ],
            [
              -54.431815997489466,
              -28.90659392083237
            ],
            [
              -54.42919406258406,
              -28.909892882465233
            ],
            [
              -54.42770227203443,
              -28.910599802815128
            ],
            [
              -54.42828994709944,
              -28.91150308992889
            ],
            [
              -54.427792683582894,
              -28.912916930628686
            ],
            [
              -54.423995398547476,
              -28.914605684797888
            ],
            [
              -54.42449266206402,
              -28.916804992553125
            ],
            [
              -54.42268443109477,
              -28.919082847013907
            ],
            [
              -54.42227757912669,
              -28.921085788005286
            ],
            [
              -54.419700849995515,
              -28.921007241299744
            ],
            [
              -54.41920358647897,
              -28.922695995468946
            ],
            [
              -54.416988503541646,
              -28.92281381552726
            ],
            [
              -54.411880251053525,
              -28.921910528413502
            ],
            [
              -54.410388460503896,
              -28.922185441882906
            ],
            [
              -54.41070490092352,
              -28.926780424157243
            ],
            [
              -54.411880251053525,
              -28.929097551970802
            ],
            [
              -54.41201586837622,
              -28.9314932264899
            ],
            [
              -54.413778893571234,
              -28.93369253424514
            ],
            [
              -54.41328163005469,
              -28.935695475236518
            ],
            [
              -54.41260354344122,
              -28.936795129114138
            ],
            [
              -54.40948434501927,
              -28.936991495877997
            ],
            [
              -54.40758570250157,
              -28.937698416227896
            ],
            [
              -54.40568705998386,
              -28.940486824274718
            ],
            [
              -54.401889774948444,
              -28.944885439785196
            ],
            [
              -54.40048839594728,
              -28.953407757336745
            ],
            [
              -54.399313045817266,
              -28.95568561179753
            ],
            [
              -54.40021716130189,
              -28.957295819261187
            ],
            [
              -54.39840893033264,
              -28.96161588806612
            ],
            [
              -54.39940345736573,
              -28.96420792934908
            ],
            [
              -54.395289731910694,
              -28.968095991273522
            ],
            [
              -54.39438561642607,
              -28.969392011915
            ],
            [
              -54.393617118264146,
              -28.972180419961823
            ],
            [
              -54.39198971039182,
              -28.974104814247656
            ],
            [
              -54.391492446875276,
              -28.976304122002894
            ],
            [
              -54.3904979198422,
              -28.983294778796335
            ],
            [
              -54.389322569712185,
              -28.98580827337375
            ],
            [
              -54.389322569712185,
              -28.987693394306813
            ],
            [
              -54.388102013807945,
              -28.98859668142057
            ],
            [
              -54.38801160225948,
              -28.98989270206205
            ],
            [
              -54.38349102483637,
              -28.996804812149946
            ],
            [
              -54.38050744373711,
              -28.997001178913806
            ],
            [
              -54.37910606473594,
              -28.999200486669046
            ],
            [
              -54.37779509728324,
              -29.00191034801032
            ],
            [
              -54.37770468573478,
              -29.004502389293283
            ],
            [
              -54.37621289518515,
              -29.001007060896562
            ],
            [
              -54.36418815923967,
              -28.985297719787713
            ],
            [
              -54.35107848471263,
              -28.972887340311722
            ],
            [
              -54.35171136555187,
              -28.9708058526148
            ],
            [
              -54.35691002958845,
              -28.96511121646284
            ],
            [
              -54.357090852685374,
              -28.961105334480084
            ],
            [
              -54.34669352461221,
              -28.936795129114138
            ],
            [
              -54.34619626109567,
              -28.93498855488662
            ],
            [
              -54.34461405899758,
              -28.93259288036752
            ],
            [
              -54.34380035506142,
              -28.929804472320697
            ],
            [
              -54.340590745091006,
              -28.929215372029116
            ],
            [
              -54.33597975611943,
              -28.929804472320697
            ],
            [
              -54.33249891150363,
              -28.930982672903863
            ],
            [
              -54.33091670940554,
              -28.93110049296218
            ],
            [
              -54.32797833408051,
              -28.930982672903863
            ],
            [
              -54.320519381332375,
              -28.929804472320697
            ],
            [
              -54.3193892369766,
              -28.929019005265257
            ],
            [
              -54.31672209629696,
              -28.92870481844308
            ],
            [
              -54.31450701335963,
              -28.93070775943446
            ],
            [
              -54.31328645745539,
              -28.93110049296218
            ],
            [
              -54.30989602438805,
              -28.930118659142877
            ],
            [
              -54.30731929525688,
              -28.929019005265257
            ],
            [
              -54.29362194566484,
              -28.92831208491536
            ],
            [
              -54.28968904330673,
              -28.92701606427388
            ],
            [
              -54.28091912310589,
              -28.92151779488578
            ],
            [
              -54.2773026611674,
              -28.918690113486186
            ],
            [
              -54.27210399713081,
              -28.914095131211848
            ],
            [
              -54.26839712364386,
              -28.912013643514925
            ],
            [
              -54.264916279028064,
              -28.911581636634434
            ],
            [
              -54.261118993992646,
              -28.91260274380651
            ],
            [
              -54.233995529453956,
              -28.9250131232825
            ],
            [
              -54.230379067515464,
              -28.92591641039626
            ],
            [
              -54.22707904599659,
              -28.92579859033794
            ],
            [
              -54.22328176096117,
              -28.924384749638147
            ],
            [
              -54.218083096924595,
              -28.921792708355184
            ],
            [
              -54.215777602438806,
              -28.920300320949845
            ],
            [
              -54.214195400340714,
              -28.918611566780644
            ],
            [
              -54.20158298933023,
              -28.901998938558034
            ],
            [
              -54.200000787232135,
              -28.900310184388832
            ],
            [
              -54.19751446964942,
              -28.898385790103
            ],
            [
              -54.19181854209629,
              -28.895401015292318
            ],
            [
              -54.18928701873935,
              -28.894497728178557
            ],
            [
              -54.184992470187396,
              -28.89418354135638
            ],
            [
              -54.16921565498072,
              -28.896697035933798
            ],
            [
              -54.16632248542993,
              -28.897011222755975
            ],
            [
              -54.16379096207298,
              -28.896814855992112
            ],
            [
              -54.150500464449024,
              -28.895204648528455
            ],
            [
              -54.14688400251053,
              -28.89410499465084
            ],
            [
              -54.14489494844436,
              -28.892808974009355
            ],
            [
              -54.14299630592666,
              -28.89108094648738
            ],
            [
              -54.13490447233928,
              -28.882597902288605
            ],
            [
              -54.132779800950416,
              -28.883304822638504
            ],
            [
              -54.12911813323769,
              -28.8849935768077
            ],
            [
              -54.125908523267285,
              -28.88621105074364
            ],
            [
              -54.12161397471532,
              -28.886485964213044
            ],
            [
              -54.11831395319645,
              -28.887703438148982
            ],
            [
              -54.11239199677217,
              -28.892808974009355
            ],
            [
              -54.10818785976867,
              -28.897403956283696
            ],
            [
              -54.1056111306375,
              -28.89991745086111
            ],
            [
              -54.102311109118624,
              -28.901881118499716
            ],
            [
              -54.09562065453241,
              -28.904787346604856
            ],
            [
              -54.08712196897696,
              -28.906083367246335
            ],
            [
              -54.085178120685015,
              -28.906201187304653
            ],
            [
              -54.080295897068055,
              -28.906986654360093
            ],
            [
              -54.07667943512956,
              -28.906397554068512
            ],
            [
              -54.0752780561284,
              -28.90659392083237
            ],
            [
              -54.07161638841567,
              -28.908086308237714
            ],
            [
              -54.06867801309065,
              -28.90840049505989
            ],
            [
              -54.06691498789563,
              -28.907497207946133
            ],
            [
              -54.06501634537793,
              -28.90529790019089
            ],
            [
              -54.06189714695598,
              -28.905494266954754
            ],
            [
              -54.0593204178248,
              -28.906319007362967
            ],
            [
              -54.0538053133686,
              -28.906986654360093
            ],
            [
              -54.05140940733435,
              -28.908282675001573
            ],
            [
              -54.049284735945484,
              -28.910010702523547
            ],
            [
              -54.048199797363935,
              -28.911817276751066
            ],
            [
              -54.04499018739352,
              -28.91028561599295
            ],
            [
              -54.04259428135927,
              -28.911817276751066
            ],
            [
              -54.041012079261186,
              -28.911188903106712
            ],
            [
              -54.04051481574464,
              -28.90910741540979
            ],
            [
              -54.03490929973998,
              -28.907615028004447
            ],
            [
              -54.03179010131803,
              -28.907418661240587
            ],
            [
              -54.030388722316864,
              -28.90651537412683
            ],
            [
              -54.02939419528378,
              -28.904787346604856
            ],
            [
              -54.02772158163722,
              -28.904080426254957
            ],
            [
              -54.02600376221644,
              -28.904983713368715
            ],
            [
              -54.02369826773065,
              -28.904001879549412
            ],
            [
              -54.02288456379449,
              -28.901488384971998
            ],
            [
              -54.02130236169641,
              -28.899485443980616
            ],
            [
              -54.02121195014794,
              -28.89489046170628
            ],
            [
              -54.016600961176366,
              -28.893908627886976
            ],
            [
              -54.01569684569174,
              -28.894615548236875
            ],
            [
              -54.01488314175558,
              -28.897993056575277
            ],
            [
              -54.01569684569174,
              -28.898896343689035
            ],
            [
              -54.014611907110194,
              -28.901292018208135
            ],
            [
              -54.01158312023671,
              -28.902195305321893
            ],
            [
              -54.011085856720165,
              -28.90341277925783
            ],
            [
              -54.00629404465166,
              -28.903294959199513
            ],
            [
              -54.005118694521656,
              -28.901802571794175
            ],
            [
              -54.00240634806779,
              -28.901998938558034
            ],
            [
              -53.999196738097375,
              -28.903805512785553
            ],
            [
              -53.99621315699812,
              -28.904001879549412
            ],
            [
              -53.995715893481574,
              -28.90290222567179
            ],
            [
              -53.993681633641174,
              -28.90231312538021
            ],
            [
              -53.99119531605846,
              -28.900506551152695
            ],
            [
              -53.98929667354075,
              -28.900899284680413
            ],
            [
              -53.98459527302071,
              -28.899406897275075
            ],
            [
              -53.98251580740608,
              -28.899289077216757
            ],
            [
              -53.97989387250067,
              -28.897993056575277
            ],
            [
              -53.97939660898413,
              -28.898817796983494
            ],
            [
              -53.97971304940375,
              -28.900310184388832
            ],
            [
              -53.97930619743567,
              -28.901684751735857
            ],
            [
              -53.97980346095221,
              -28.904001879549412
            ],
            [
              -53.97618699901372,
              -28.90529790019089
            ],
            [
              -53.97609658746526,
              -28.90419824631327
            ],
            [
              -53.974107533399085,
              -28.902391672085756
            ],
            [
              -53.9723897139783,
              -28.903805512785553
            ],
            [
              -53.96990339639559,
              -28.90211675861635
            ],
            [
              -53.968321194297495,
              -28.900388731094377
            ],
            [
              -53.96660337487671,
              -28.901684751735857
            ],
            [
              -53.96429788039092,
              -28.902588038849615
            ],
            [
              -53.96248964942168,
              -28.901095651444276
            ],
            [
              -53.9620827974536,
              -28.899406897275075
            ],
            [
              -53.95769783735318,
              -28.899289077216757
            ],
            [
              -53.95530193131893,
              -28.898110876633595
            ],
            [
              -53.9538101407693,
              -28.898896343689035
            ],
            [
              -53.952906025284676,
              -28.898385790103
            ],
            [
              -53.95448822738277,
              -28.895597382056177
            ],
            [
              -53.955889606383934,
              -28.89410499465084
            ],
            [
              -53.9559800179324,
              -28.8928875207149
            ],
            [
              -53.957517014256254,
              -28.89178786683728
            ],
            [
              -53.9578786604501,
              -28.8888030920266
            ],
            [
              -53.959099216354346,
              -28.88660378427136
            ],
            [
              -53.957381396933556,
              -28.884483023221666
            ],
            [
              -53.95778824890164,
              -28.88361900946068
            ],
            [
              -53.9572909853851,
              -28.881616068469302
            ],
            [
              -53.95489507935085,
              -28.880791328061086
            ],
            [
              -53.95322246570429,
              -28.881380428352667
            ],
            [
              -53.95240876176813,
              -28.87941676071406
            ],
            [
              -53.95498549089931,
              -28.875293058672987
            ],
            [
              -53.954397815834305,
              -28.87458613832309
            ],
            [
              -53.95182108670313,
              -28.87478250508695
            ],
            [
              -53.95109779431543,
              -28.872897384153887
            ],
            [
              -53.94978682686273,
              -28.87380067126765
            ],
            [
              -53.94978682686273,
              -28.87490032514527
            ],
            [
              -53.948204624764635,
              -28.875018145203583
            ],
            [
              -53.94662242266654,
              -28.87438977155923
            ],
            [
              -53.94499501479422,
              -28.872111917098447
            ],
            [
              -53.943503224244594,
              -28.87438977155923
            ],
            [
              -53.94219225679189,
              -28.875803612259027
            ],
            [
              -53.93961552766072,
              -28.875882158964572
            ],
            [
              -53.93758126782031,
              -28.873997038031508
            ],
            [
              -53.9387114121761,
              -28.869912609343206
            ],
            [
              -53.93731003317493,
              -28.868695135407272
            ],
            [
              -53.936993592755314,
              -28.867516934824106
            ],
            [
              -53.93880182372456,
              -28.86519980701055
            ],
            [
              -53.940384025822645,
              -28.864492886660653
            ],
            [
              -53.94210184524343,
              -28.862686312433137
            ],
            [
              -53.94210184524343,
              -28.861704478613834
            ],
            [
              -53.936179888819154,
              -28.85911243733087
            ],
            [
              -53.93541139065722,
              -28.854203268234357
            ],
            [
              -53.93188534026719,
              -28.8540069014705
            ],
            [
              -53.92989628620102,
              -28.85278942753456
            ],
            [
              -53.93021272662064,
              -28.852003960479117
            ],
            [
              -53.93211136913835,
              -28.85110067336536
            ],
            [
              -53.93310589617143,
              -28.84960828596002
            ],
            [
              -53.93220178068681,
              -28.848312265318537
            ],
            [
              -53.93048396126603,
              -28.84721261144092
            ],
            [
              -53.930393549717564,
              -28.84520967044954
            ],
            [
              -53.92881134761947,
              -28.843206729458164
            ],
            [
              -53.926189412714066,
              -28.840811054939063
            ],
            [
              -53.92528529722944,
              -28.840496868116887
            ],
            [
              -53.9255113261006,
              -28.8382190136561
            ],
            [
              -53.924200358647894,
              -28.83688371966185
            ],
            [
              -53.92528529722944,
              -28.832917111031865
            ],
            [
              -53.92370309513135,
              -28.83118908350989
            ],
            [
              -53.92139760064556,
              -28.832799290973547
            ],
            [
              -53.917012640545146,
              -28.834409498437207
            ],
            [
              -53.9144811171882,
              -28.831581817037613
            ],
            [
              -53.91289891509011,
              -28.82891122904911
            ],
            [
              -53.910005745539316,
              -28.827301021585452
            ],
            [
              -53.90910163005469,
              -28.825415900652388
            ],
            [
              -53.9054851681162,
              -28.822509672547252
            ],
            [
              -53.90250158701694,
              -28.82470898030249
            ],
            [
              -53.90119061956424,
              -28.824591160244175
            ],
            [
              -53.902185146597326,
              -28.822588219252797
            ],
            [
              -53.90191391195194,
              -28.82101728514191
            ],
            [
              -53.89838786156191,
              -28.818307423800633
            ],
            [
              -53.89987965211154,
              -28.815911749281536
            ],
            [
              -53.90241117546848,
              -28.81579392922322
            ],
            [
              -53.90372214292118,
              -28.815204828931638
            ],
            [
              -53.906118048955435,
              -28.811513133771058
            ],
            [
              -53.902320763920024,
              -28.80958873948522
            ],
            [
              -53.89861389043307,
              -28.80970655954354
            ],
            [
              -53.89630839594728,
              -28.811709500534917
            ],
            [
              -53.89278234555725,
              -28.81210223406264
            ],
            [
              -53.89201384739532,
              -28.811709500534917
            ],
            [
              -53.89251111091186,
              -28.80958873948522
            ],
            [
              -53.891516583878776,
              -28.807782165257706
            ],
            [
              -53.89160699542724,
              -28.806918151496717
            ],
            [
              -53.889889176006456,
              -28.80601486438296
            ],
            [
              -53.88939191248991,
              -28.804993757210884
            ],
            [
              -53.88961794136107,
              -28.803108636277823
            ],
            [
              -53.88799053348875,
              -28.80161624887248
            ],
            [
              -53.88631791984219,
              -28.801105695286445
            ],
            [
              -53.884916540841026,
              -28.801891162341885
            ],
            [
              -53.881390490451,
              -28.80138060875585
            ],
            [
              -53.881706930870614,
              -28.80350136980554
            ],
            [
              -53.88337954451717,
              -28.80350136980554
            ],
            [
              -53.88310830987178,
              -28.804797390447025
            ],
            [
              -53.88360557338832,
              -28.806800331438403
            ],
            [
              -53.88238501748408,
              -28.808096352079883
            ],
            [
              -53.87958225948175,
              -28.808881819135323
            ],
            [
              -53.87759320541558,
              -28.808685452371463
            ],
            [
              -53.87768361696404,
              -28.81100258018502
            ],
            [
              -53.87677950147942,
              -28.812887701118083
            ],
            [
              -53.87402194925132,
              -28.81489064210946
            ],
            [
              -53.87198768941092,
              -28.815519015753814
            ],
            [
              -53.868190404375504,
              -28.814694275345598
            ],
            [
              -53.86651779072895,
              -28.813594621467978
            ],
            [
              -53.8641218846947,
              -28.81489064210946
            ],
            [
              -53.8620876248543,
              -28.814419361876194
            ],
            [
              -53.86290132879046,
              -28.811905867298776
            ],
            [
              -53.86168077288622,
              -28.81029565983512
            ],
            [
              -53.85942048417466,
              -28.81100258018502
            ],
            [
              -53.85869719178696,
              -28.81269133435422
            ],
            [
              -53.857114989688874,
              -28.81339825470412
            ],
            [
              -53.85612046265579,
              -28.811788047240462
            ],
            [
              -53.855894433784634,
              -28.80970655954354
            ],
            [
              -53.85761225320542,
              -28.80958873948522
            ],
            [
              -53.86140953824083,
              -28.808096352079883
            ],
            [
              -53.86272050569353,
              -28.80550431079692
            ],
            [
              -53.86421229624316,
              -28.804797390447025
            ],
            [
              -53.86448353088855,
              -28.803894103333263
            ],
            [
              -53.863579415403926,
              -28.801694795578026
            ],
            [
              -53.86109309782121,
              -28.802990816219506
            ],
            [
              -53.8591944553035,
              -28.800909328522582
            ],
            [
              -53.8580191051735,
              -28.801498428814163
            ],
            [
              -53.85489990675155,
              -28.802008982400203
            ],
            [
              -53.85408620281539,
              -28.801498428814163
            ],
            [
              -53.854402643235005,
              -28.799809674644962
            ],
            [
              -53.85548758181655,
              -28.79918130100061
            ],
            [
              -53.85471908365462,
              -28.797610366889725
            ],
            [
              -53.85340811620192,
              -28.797217633362003
            ],
            [
              -53.851283444813056,
              -28.799613307881103
            ],
            [
              -53.84988206581189,
              -28.80251953598624
            ],
            [
              -53.848480686810724,
              -28.802283895869607
            ],
            [
              -53.848887538778804,
              -28.799299121058926
            ],
            [
              -53.84622039809916,
              -28.799299121058926
            ],
            [
              -53.84518066529185,
              -28.799888221350507
            ],
            [
              -53.84368887474222,
              -28.79898493423675
            ],
            [
              -53.84088611673989,
              -28.801184241991987
            ],
            [
              -53.84179023222451,
              -28.802008982400203
            ],
            [
              -53.83962035506142,
              -28.80381555662772
            ],
            [
              -53.839982001255265,
              -28.80601486438296
            ],
            [
              -53.83907788577064,
              -28.8075072517883
            ],
            [
              -53.84070529364296,
              -28.8075072517883
            ],
            [
              -53.84129296870797,
              -28.808685452371463
            ],
            [
              -53.83939432619026,
              -28.810492026598983
            ],
            [
              -53.83708883170447,
              -28.810492026598983
            ],
            [
              -53.835280600735224,
              -28.811513133771058
            ],
            [
              -53.83478333721868,
              -28.812612787648675
            ],
            [
              -53.83261346005559,
              -28.811513133771058
            ],
            [
              -53.83229701963597,
              -28.807585798493843
            ],
            [
              -53.832387431184436,
              -28.806093411088504
            ],
            [
              -53.829313438536715,
              -28.80621123114682
            ],
            [
              -53.82791205953555,
              -28.80770361855216
            ],
            [
              -53.823120247467045,
              -28.806682511380085
            ],
            [
              -53.8234818936609,
              -28.80491521050534
            ],
            [
              -53.82171886846588,
              -28.805582857502465
            ],
            [
              -53.82090516452972,
              -28.80711451826058
            ],
            [
              -53.8192777566574,
              -28.80829271884374
            ],
            [
              -53.81778596610777,
              -28.808214172138197
            ],
            [
              -53.81719829104277,
              -28.806486144616226
            ],
            [
              -53.81471197346006,
              -28.806289777852363
            ],
            [
              -53.81471197346006,
              -28.805386490738606
            ],
            [
              -53.81322018291043,
              -28.801891162341885
            ],
            [
              -53.8096941325204,
              -28.798906387531204
            ],
            [
              -53.80910645745539,
              -28.796510713012104
            ],
            [
              -53.807614666905764,
              -28.796510713012104
            ],
            [
              -53.80770507845423,
              -28.797806733653584
            ],
            [
              -53.80607767058191,
              -28.79898493423675
            ],
            [
              -53.80630369945306,
              -28.800595141700406
            ],
            [
              -53.80350094145073,
              -28.800595141700406
            ],
            [
              -53.80359135299919,
              -28.801694795578026
            ],
            [
              -53.80087900654532,
              -28.801891162341885
            ],
            [
              -53.799387215995694,
              -28.803305003041682
            ],
            [
              -53.7959063713799,
              -28.802794449455646
            ],
            [
              -53.79427896350757,
              -28.803697736569404
            ],
            [
              -53.79400772886219,
              -28.80491521050534
            ],
            [
              -53.791385793956785,
              -28.80530794403306
            ],
            [
              -53.791385793956785,
              -28.806918151496717
            ],
            [
              -53.787091245404824,
              -28.809196005957503
            ],
            [
              -53.78659398188828,
              -28.816108116045395
            ],
            [
              -53.785192602887115,
              -28.818111057036774
            ],
            [
              -53.78320354882094,
              -28.830482163159992
            ],
            [
              -53.777507621267816,
              -28.831817457154244
            ],
            [
              -53.77701035775128,
              -28.83370257808731
            ],
            [
              -53.777507621267816,
              -28.83429167837889
            ],
            [
              -53.777778855913205,
              -28.839397214239266
            ],
            [
              -53.77470486326549,
              -28.843088909399846
            ],
            [
              -53.77230895723124,
              -28.844699116863502
            ],
            [
              -53.76909934726083,
              -28.8516112269514
            ],
            [
              -53.764397946740786,
              -28.85911243733087
            ],
            [
              -53.76349383125616,
              -28.861311745086113
            ],
            [
              -53.76041983860844,
              -28.865003440246692
            ],
            [
              -53.75938010580113,
              -28.864885620188375
            ],
            [
              -53.75648693625033,
              -28.867281294707475
            ],
            [
              -53.75278006276338,
              -28.867516934824106
            ],
            [
              -53.750881420245676,
              -28.86810603511569
            ],
            [
              -53.746993723661795,
              -28.866181640829854
            ],
            [
              -53.74287999820676,
              -28.862686312433137
            ],
            [
              -53.73899230162288,
              -28.86201866543601
            ],
            [
              -53.73700324755671,
              -28.864100153132934
            ],
            [
              -53.7343813126513,
              -28.864689253424515
            ],
            [
              -53.73139773155205,
              -28.863982333074617
            ],
            [
              -53.72967991213127,
              -28.863196866019173
            ],
            [
              -53.72841415045279,
              -28.86351105284135
            ],
            [
              -53.728097710033175,
              -28.870305342870928
            ],
            [
              -53.72439083654622,
              -28.872111917098447
            ],
            [
              -53.72411960190083,
              -28.873486484445472
            ],
            [
              -53.721497666995425,
              -28.87368285120933
            ],
            [
              -53.71991546489733,
              -28.875018145203583
            ],
            [
              -53.720683963059265,
              -28.877610186486542
            ],
            [
              -53.72032231686541,
              -28.880909148119404
            ],
            [
              -53.71670585492692,
              -28.885386310335424
            ],
            [
              -53.71168801398727,
              -28.886485964213044
            ],
            [
              -53.70929210795302,
              -28.88801762497116
            ],
            [
              -53.70400303236797,
              -28.890688212959663
            ],
            [
              -53.70309891688335,
              -28.89469409494242
            ],
            [
              -53.70120027436564,
              -28.895911568878354
            ],
            [
              -53.696408462297136,
              -28.895401015292318
            ],
            [
              -53.69419337935981,
              -28.896814855992112
            ],
            [
              -53.692204325293645,
              -28.9007814646221
            ],
            [
              -53.6903960943244,
              -28.90231312538021
            ],
            [
              -53.68800018829015,
              -28.901606205030312
            ],
            [
              -53.683298787770106,
              -28.901292018208135
            ],
            [
              -53.68262070115664,
              -28.902391672085756
            ],
            [
              -53.68311796467318,
              -28.908793228587612
            ],
            [
              -53.6819878203174,
              -28.91099253634285
            ],
            [
              -53.68108370483278,
              -28.911817276751066
            ],
            [
              -53.67877821034699,
              -28.91688353925867
            ],
            [
              -53.67950150273469,
              -28.918218833252922
            ],
            [
              -53.67520695418273,
              -28.922892362232805
            ],
            [
              -53.67520695418273,
              -28.92391346940488
            ],
            [
              -53.673895986730024,
              -28.92579859033794
            ],
            [
              -53.67050555366269,
              -28.926584057393384
            ],
            [
              -53.66919458620999,
              -28.929883019026242
            ],
            [
              -53.67091240563077,
              -28.93070775943446
            ],
            [
              -53.669013763113064,
              -28.93310343395356
            ],
            [
              -53.66851649959652,
              -28.934517274653352
            ],
            [
              -53.66878773424191,
              -28.936716582408593
            ],
            [
              -53.667793207208824,
              -28.937698416227896
            ],
            [
              -53.66422195104456,
              -28.937816236286213
            ],
            [
              -53.66390551062494,
              -28.939504990455415
            ],
            [
              -53.662820572043394,
              -28.940094090746996
            ],
            [
              -53.660786312202994,
              -28.939308623691552
            ],
            [
              -53.654819150004485,
              -28.941193744624616
            ],
            [
              -53.652694478615615,
              -28.94131156468293
            ],
            [
              -53.6483095185152,
              -28.93848388328334
            ],
            [
              -53.64880678203174,
              -28.935106374944937
            ],
            [
              -53.648219106966735,
              -28.932907067189696
            ],
            [
              -53.646998551062495,
              -28.932514333661977
            ],
            [
              -53.63868068860396,
              -28.938287516519477
            ],
            [
              -53.63800260199049,
              -28.935616928530973
            ],
            [
              -53.633391613018915,
              -28.93718786264186
            ],
            [
              -53.63208064556621,
              -28.93871952339997
            ],
            [
              -53.63330120147046,
              -28.939504990455415
            ],
            [
              -53.63791219044203,
              -28.940408277569173
            ],
            [
              -53.63840945395857,
              -28.942882498793818
            ],
            [
              -53.63981083295974,
              -28.944689073021333
            ],
            [
              -53.63899712902358,
              -28.945592360135095
            ],
            [
              -53.63587793060163,
              -28.94669201401271
            ],
            [
              -53.62982035685466,
              -28.945317446665687
            ],
            [
              -53.62778609701426,
              -28.94311813891045
            ],
            [
              -53.62322031381691,
              -28.944492706257474
            ],
            [
              -53.6240792235273,
              -28.945395993371232
            ],
            [
              -53.621095642428045,
              -28.945592360135095
            ],
            [
              -53.62100523087958,
              -28.94429633949361
            ],
            [
              -53.61869973639379,
              -28.94311813891045
            ],
            [
              -53.61829288442571,
              -28.94111519791907
            ],
            [
              -53.615987389939924,
              -28.941586478152338
            ],
            [
              -53.61499286290684,
              -28.94091883115521
            ],
            [
              -53.61291339729221,
              -28.940604644333032
            ],
            [
              -53.608799671837176,
              -28.938012603050073
            ],
            [
              -53.60631335425446,
              -28.93871952339997
            ],
            [
              -53.60269689231597,
              -28.940997377860754
            ],
            [
              -53.6012955133148,
              -28.942686132029955
            ],
            [
              -53.60170236528288,
              -28.94421779278807
            ],
            [
              -53.59948728234556,
              -28.944099972729752
            ],
            [
              -53.596820141665916,
              -28.940211910805314
            ],
            [
              -53.59731740518246,
              -28.939308623691552
            ],
            [
              -53.59501191069667,
              -28.938012603050073
            ],
            [
              -53.59410779521205,
              -28.940801011096895
            ],
            [
              -53.592796827759344,
              -28.94221485179669
            ],
            [
              -53.59022009862817,
              -28.94429633949361
            ],
            [
              -53.58899954272393,
              -28.94661346730717
            ],
            [
              -53.58741734062584,
              -28.945081806549055
            ],
            [
              -53.58899954272393,
              -28.942293398502233
            ],
            [
              -53.58502143459159,
              -28.940094090746996
            ],
            [
              -53.58321320362234,
              -28.940683191038577
            ],
            [
              -53.58298717475119,
              -28.94221485179669
            ],
            [
              -53.582083059266566,
              -28.943903605965893
            ],
            [
              -53.57878303774769,
              -28.94331450567431
            ],
            [
              -53.577110424101136,
              -28.943903605965893
            ],
            [
              -53.57679398368152,
              -28.944689073021333
            ],
            [
              -53.577517276069216,
              -28.946495647248852
            ],
            [
              -53.575889868196896,
              -28.947713121184787
            ],
            [
              -53.57317752174303,
              -28.948812775062407
            ],
            [
              -53.57340355061418,
              -28.95179754987309
            ],
            [
              -53.5724090235811,
              -28.953015023809026
            ],
            [
              -53.56978708867569,
              -28.95348630404229
            ],
            [
              -53.568204886577604,
              -28.954311044450506
            ],
            [
              -53.56540212857527,
              -28.957217272555642
            ],
            [
              -53.56490486505873,
              -28.958199106374945
            ],
            [
              -53.566984330673364,
              -28.960398414130186
            ],
            [
              -53.567119947996055,
              -28.962519175179878
            ],
            [
              -53.56648706715682,
              -28.96350100899918
            ],
            [
              -53.563187045637946,
              -28.963186822177004
            ],
            [
              -53.558621262440596,
              -28.963186822177004
            ],
            [
              -53.5544171254371,
              -28.960987514421767
            ],
            [
              -53.5523828655967,
              -28.959298760252565
            ],
            [
              -53.552292454048235,
              -28.962087168299387
            ],
            [
              -53.551704778983236,
              -28.962597721885423
            ],
            [
              -53.54921846140052,
              -28.96271554194374
            ],
            [
              -53.548088317044744,
              -28.964993396404523
            ],
            [
              -53.54731981888281,
              -28.965700316754422
            ],
            [
              -53.54668693804358,
              -28.96829235803738
            ],
            [
              -53.54858558056128,
              -28.970491665792622
            ],
            [
              -53.549986959562446,
              -28.97139495290638
            ],
            [
              -53.55129792701515,
              -28.9708058526148
            ],
            [
              -53.552292454048235,
              -28.969195645151142
            ],
            [
              -53.55640617950327,
              -28.9677032577458
            ],
            [
              -53.55731029498789,
              -28.96789962450966
            ],
            [
              -53.55731029498789,
              -28.96958837867886
            ],
            [
              -53.55450753698556,
              -28.971002219378658
            ],
            [
              -53.55288012911324,
              -28.972180419961823
            ],
            [
              -53.548902020980904,
              -28.973515713956076
            ],
            [
              -53.545782822558955,
              -28.975008101361414
            ],
            [
              -53.54212115484623,
              -28.975204468125277
            ],
            [
              -53.538504692907736,
              -28.97449754777538
            ],
            [
              -53.53588275800233,
              -28.973397893897758
            ],
            [
              -53.53208547296691,
              -28.970491665792622
            ],
            [
              -53.528921068770735,
              -28.9669963373959
            ],
            [
              -53.52670598583341,
              -28.966917790690356
            ],
            [
              -53.52562104725186,
              -28.970216752323218
            ],
            [
              -53.524219668250694,
              -28.973319347192213
            ],
            [
              -53.5248073433157,
              -28.975204468125277
            ],
            [
              -53.52471693176724,
              -28.97638266870844
            ],
            [
              -53.52589228189725,
              -28.98011363722179
            ],
            [
              -53.52548542992917,
              -28.98439443267395
            ],
            [
              -53.52431007979916,
              -28.984787166201674
            ],
            [
              -53.52159773334529,
              -28.983883879087916
            ],
            [
              -53.520286765892585,
              -28.985219173082168
            ],
            [
              -53.52168814489375,
              -28.98730066077909
            ],
            [
              -53.52168814489375,
              -28.98949996853433
            ],
            [
              -53.52449090289608,
              -28.99169927628957
            ],
            [
              -53.52711283780149,
              -28.99189564305343
            ],
            [
              -53.52977997848112,
              -28.99338803045877
            ],
            [
              -53.532989588451535,
              -28.99338803045877
            ],
            [
              -53.53371288083923,
              -28.99448768433639
            ],
            [
              -53.53308,
              -28.996412078622225
            ],
            [
              -53.53167862099883,
              -28.997904466027563
            ],
            [
              -53.53140738635345,
              -28.999789586960627
            ],
            [
              -53.53240191338653,
              -29.001792527952006
            ],
            [
              -53.534616996323855,
              -29.002185261479728
            ],
            [
              -53.537690988971576,
              -29.001007060896562
            ],
            [
              -53.54071977584506,
              -28.999200486669046
            ],
            [
              -53.54212115484623,
              -28.998689933083007
            ],
            [
              -53.5441102089124,
              -28.999711040255082
            ],
            [
              -53.543884180041246,
              -29.00061432736884
            ],
            [
              -53.54198553752354,
              -29.002185261479728
            ],
            [
              -53.541081422038914,
              -29.00371692223784
            ],
            [
              -53.5399060719089,
              -29.00721225063456
            ],
            [
              -53.54022251232852,
              -29.008783184745443
            ],
            [
              -53.543115681879314,
              -29.00760498416228
            ],
            [
              -53.544697883977406,
              -29.00760498416228
            ],
            [
              -53.543884180041246,
              -29.010707579031276
            ],
            [
              -53.541488274006994,
              -29.010000658681378
            ],
            [
              -53.538911544875816,
              -29.010511212267417
            ],
            [
              -53.53660605039003,
              -29.008783184745443
            ],
            [
              -53.53538549448579,
              -29.006387510226343
            ],
            [
              -53.531497797901906,
              -29.006191143462484
            ],
            [
              -53.529599155384204,
              -29.006819517106837
            ],
            [
              -53.52720324934995,
              -29.01259269996434
            ],
            [
              -53.52589228189725,
              -29.016402215183234
            ],
            [
              -53.522185408410294,
              -29.021311384279752
            ],
            [
              -53.52331555276607,
              -29.024217612384888
            ],
            [
              -53.52119088137721,
              -29.028184221014875
            ],
            [
              -53.51951826773065,
              -29.028184221014875
            ],
            [
              -53.51829771182641,
              -29.026613286903988
            ],
            [
              -53.51730318479333,
              -29.02641692014013
            ],
            [
              -53.514907278759075,
              -29.02759512072329
            ],
            [
              -53.51418398637138,
              -29.029008961423088
            ],
            [
              -53.50997984936788,
              -29.031601002706047
            ],
            [
              -53.50889491078634,
              -29.032818476641985
            ],
            [
              -53.50749353178517,
              -29.033407576933566
            ],
            [
              -53.50690585672017,
              -29.03478214428059
            ],
            [
              -53.509392174302874,
              -29.035292697866627
            ],
            [
              -53.51129081682058,
              -29.036902905330287
            ],
            [
              -53.511516845691744,
              -29.037688372385727
            ],
            [
              -53.50930176275442,
              -29.041301520840765
            ],
            [
              -53.50500721420246,
              -29.04601432317342
            ],
            [
              -53.50568530081593,
              -29.04789944410648
            ],
            [
              -53.50830723572133,
              -29.048684911161924
            ],
            [
              -53.509618203174036,
              -29.050098751861718
            ],
            [
              -53.50930176275442,
              -29.051983872794782
            ],
            [
              -53.5068154451717,
              -29.053908267080615
            ],
            [
              -53.50378665829822,
              -29.052612246439136
            ],
            [
              -53.50310857168475,
              -29.05469373413606
            ],
            [
              -53.50518803729938,
              -29.056303941599715
            ],
            [
              -53.504103098717835,
              -29.058306882591094
            ],
            [
              -53.504781185331304,
              -29.061095290637915
            ],
            [
              -53.50731270868825,
              -29.063687331920875
            ],
            [
              -53.50749353178517,
              -29.064394252270773
            ],
            [
              -53.50441953913745,
              -29.06580809297057
            ],
            [
              -53.50211404465166,
              -29.06400151874305
            ],
            [
              -53.496508528647,
              -29.062784044807117
            ],
            [
              -53.495197561194296,
              -29.06341241845147
            ],
            [
              -53.49411262261275,
              -29.066083006439975
            ],
            [
              -53.49402221106429,
              -29.070481621950453
            ],
            [
              -53.494383857258136,
              -29.073112936586185
            ],
            [
              -53.4923043916435,
              -29.074212590463805
            ],
            [
              -53.48638243521922,
              -29.075115877577563
            ],
            [
              -53.4848906446696,
              -29.07358421681945
            ],
            [
              -53.48281117905496,
              -29.072916569822326
            ],
            [
              -53.4806865076661,
              -29.07578352457469
            ],
            [
              -53.47788374966377,
              -29.073309303350047
            ],
            [
              -53.47661798798529,
              -29.076804631746764
            ],
            [
              -53.473091937595264,
              -29.07688317845231
            ],
            [
              -53.471600147045635,
              -29.077904285624385
            ],
            [
              -53.472685085627184,
              -29.079318126324182
            ],
            [
              -53.469701504527926,
              -29.081792347548824
            ],
            [
              -53.46830012552677,
              -29.082381447840408
            ],
            [
              -53.4668987465256,
              -29.081988714312686
            ],
            [
              -53.466311071460595,
              -29.079082486207547
            ],
            [
              -53.46640148300906,
              -29.07711881856894
            ],
            [
              -53.465497367524435,
              -29.076019164691324
            ],
            [
              -53.462378169102486,
              -29.075901344633007
            ],
            [
              -53.46377954810365,
              -29.078100652388244
            ],
            [
              -53.463598725006726,
              -29.081006880493383
            ],
            [
              -53.46151925939209,
              -29.083402555012484
            ],
            [
              -53.461609670940554,
              -29.084698575653963
            ],
            [
              -53.464819280910966,
              -29.085994596295443
            ],
            [
              -53.463598725006726,
              -29.08780117052296
            ],
            [
              -53.461202818972474,
              -29.089215011222755
            ],
            [
              -53.4571795050659,
              -29.087486983700785
            ],
            [
              -53.45528086254819,
              -29.088508090872857
            ],
            [
              -53.45550689141935,
              -29.0923961527973
            ],
            [
              -53.45387948354703,
              -29.092710339619476
            ],
            [
              -53.45288495651394,
              -29.091414318977996
            ],
            [
              -53.44881643683314,
              -29.09019684504206
            ],
            [
              -53.445787649959655,
              -29.08650514988148
            ],
            [
              -53.444702711378106,
              -29.088783004342265
            ],
            [
              -53.438509520308436,
              -29.09110013215582
            ],
            [
              -53.44090542634269,
              -29.095616567724612
            ],
            [
              -53.439187606921905,
              -29.096991135071637
            ],
            [
              -53.43710814130727,
              -29.09761950871599
            ],
            [
              -53.43371770823993,
              -29.097815875479853
            ],
            [
              -53.43001083475298,
              -29.09498819408026
            ],
            [
              -53.42910671926836,
              -29.094909647374713
            ],
            [
              -53.428293015332194,
              -29.098012242243712
            ],
            [
              -53.42521902268448,
              -29.098601342535297
            ],
            [
              -53.418392950775576,
              -29.10480653227329
            ],
            [
              -53.41400799067515,
              -29.10590618615091
            ],
            [
              -53.413013463642066,
              -29.10830186067001
            ],
            [
              -53.408583297767414,
              -29.112307742652767
            ],
            [
              -53.40758877073433,
              -29.118905665918483
            ],
            [
              -53.40541889357124,
              -29.120201686559962
            ],
            [
              -53.402480518246215,
              -29.118198745568584
            ],
            [
              -53.40049146418004,
              -29.11768819198255
            ],
            [
              -53.39371059804537,
              -29.118984212624028
            ],
            [
              -53.391314692011115,
              -29.121104973673724
            ],
            [
              -53.389913313009956,
              -29.122793727842925
            ],
            [
              -53.38579958755492,
              -29.123697014956683
            ],
            [
              -53.38408176813413,
              -29.123500648192824
            ],
            [
              -53.38019407155026,
              -29.122086807493027
            ],
            [
              -53.37278032457635,
              -29.1214191604959
            ],
            [
              -53.36667754505514,
              -29.122086807493027
            ],
            [
              -53.36129805792164,
              -29.128684730758742
            ],
            [
              -53.359580238500854,
              -29.12950947116696
            ],
            [
              -53.35641583430467,
              -29.12919528434478
            ],
            [
              -53.35469801488389,
              -29.12809563046716
            ],
            [
              -53.35641583430467,
              -29.1262105095341
            ],
            [
              -53.35899256343585,
              -29.118002378804725
            ],
            [
              -53.35279937236618,
              -29.11348594323593
            ],
            [
              -53.350403466331926,
              -29.11148300224455
            ],
            [
              -53.34868564691114,
              -29.11328957647207
            ],
            [
              -53.34990620281538,
              -29.116117257871664
            ],
            [
              -53.34850482381422,
              -29.11851293239076
            ],
            [
              -53.34497877342419,
              -29.119298399446205
            ],
            [
              -53.342989719358016,
              -29.120398053323825
            ],
            [
              -53.34118148838878,
              -29.122086807493027
            ],
            [
              -53.33751982067605,
              -29.123618468251138
            ],
            [
              -53.33209512776831,
              -29.12821345052548
            ],
            [
              -53.32739372724827,
              -29.12919528434478
            ],
            [
              -53.3246813807944,
              -29.1295880178725
            ],
            [
              -53.317584074240116,
              -29.12899891758092
            ],
            [
              -53.31568543172241,
              -29.12990220469468
            ],
            [
              -53.312882673720075,
              -29.132101512449918
            ],
            [
              -53.31188814668699,
              -29.132101512449918
            ],
            [
              -53.30949224065274,
              -29.128684730758742
            ],
            [
              -53.30781962700619,
              -29.12809563046716
            ],
            [
              -53.303705901551155,
              -29.12880255081706
            ],
            [
              -53.30149081861383,
              -29.130216391516857
            ],
            [
              -53.30040588003228,
              -29.12899891758092
            ],
            [
              -53.29909491257958,
              -29.126289056239642
            ],
            [
              -53.29489077557608,
              -29.1262105095341
            ],
            [
              -53.29018937505604,
              -29.127781443644984
            ],
            [
              -53.29018937505604,
              -29.128409817289338
            ],
            [
              -53.29330857347799,
              -29.131512412158337
            ],
            [
              -53.292811309961444,
              -29.1326906127415
            ],
            [
              -53.2867989419887,
              -29.135518294141093
            ],
            [
              -53.28589482650408,
              -29.135204107318916
            ],
            [
              -53.283996183986375,
              -29.13288697950536
            ],
            [
              -53.28241398188828,
              -29.129313104403096
            ],
            [
              -53.28119342598404,
              -29.12880255081706
            ],
            [
              -53.27870710840133,
              -29.13139459210002
            ],
            [
              -53.278616696852865,
              -29.143490784753833
            ],
            [
              -53.27762216981978,
              -29.145100992217493
            ],
            [
              -53.275904350398996,
              -29.145690092509074
            ],
            [
              -53.272287888460504,
              -29.142783864403935
            ],
            [
              -53.26989198242625,
              -29.140388189884835
            ],
            [
              -53.268490603425086,
              -29.139484902771077
            ],
            [
              -53.26717963597238,
              -29.13991690965157
            ],
            [
              -53.2632919393885,
              -29.143490784753833
            ],
            [
              -53.2613932968708,
              -29.14431552516205
            ],
            [
              -53.25990150632117,
              -29.14710393320887
            ],
            [
              -53.25868095041693,
              -29.150088708019553
            ],
            [
              -53.258093275351925,
              -29.15279856936083
            ],
            [
              -53.25800286380346,
              -29.15539061064379
            ],
            [
              -53.25868095041693,
              -29.162381267437226
            ],
            [
              -53.257008336770376,
              -29.166819156300477
            ],
            [
              -53.25510969425267,
              -29.1696075643473
            ],
            [
              -53.253391874831884,
              -29.170510851461056
            ],
            [
              -53.25171926118533,
              -29.170118117933335
            ],
            [
              -53.24728909531068,
              -29.166897703006022
            ],
            [
              -53.24380825069488,
              -29.1672118898282
            ],
            [
              -53.24308495830718,
              -29.168586457175223
            ],
            [
              -53.24349181027526,
              -29.171689052044222
            ],
            [
              -53.24439592575988,
              -29.175891300790838
            ],
            [
              -53.250815145700706,
              -29.178286975309938
            ],
            [
              -53.257008336770376,
              -29.177501508254494
            ],
            [
              -53.25840971577154,
              -29.179308082482013
            ],
            [
              -53.257912452255,
              -29.18480635187011
            ],
            [
              -53.259720683224245,
              -29.187987493444652
            ],
            [
              -53.26170973729042,
              -29.189008600616727
            ],
            [
              -53.26659196090738,
              -29.19069735478593
            ],
            [
              -53.26668237245584,
              -29.192307562249585
            ],
            [
              -53.265687845422754,
              -29.193799949654927
            ],
            [
              -53.26261385277504,
              -29.19658835770175
            ],
            [
              -53.26030835828925,
              -29.197098911287785
            ],
            [
              -53.25551654622075,
              -29.197216731346103
            ],
            [
              -53.253391874831884,
              -29.196902544523926
            ],
            [
              -53.251900084282255,
              -29.19548870382413
            ],
            [
              -53.25049870528109,
              -29.193014482599484
            ],
            [
              -53.248012387698374,
              -29.192307562249585
            ],
            [
              -53.24548086434143,
              -29.193603582891065
            ],
            [
              -53.24389866224334,
              -29.19588143735185
            ],
            [
              -53.24249728324217,
              -29.19918039898471
            ],
            [
              -53.242316460145254,
              -29.20181171362044
            ],
            [
              -53.242587694790636,
              -29.205189221958843
            ],
            [
              -53.2434013987268,
              -29.206917249480817
            ],
            [
              -53.24548086434143,
              -29.208213270122297
            ],
            [
              -53.24810279924684,
              -29.209116557236058
            ],
            [
              -53.24941376669954,
              -29.211708598519017
            ],
            [
              -53.24909732627992,
              -29.214811193388016
            ],
            [
              -53.248012387698374,
              -29.218110155020874
            ],
            [
              -53.24778635882722,
              -29.221801850181453
            ],
            [
              -53.24810279924684,
              -29.226082645633614
            ],
            [
              -53.24991103021608,
              -29.234919150007343
            ],
            [
              -53.24941376669954,
              -29.238493025109605
            ],
            [
              -53.247017860665295,
              -29.240417419395442
            ],
            [
              -53.24349181027526,
              -29.240299599337124
            ],
            [
              -53.239197261723305,
              -29.241006519687023
            ],
            [
              -53.23499312471981,
              -29.242891640620083
            ],
            [
              -53.23268763023402,
              -29.2454051351975
            ],
            [
              -53.23200954362055,
              -29.2478008097166
            ],
            [
              -53.23359174571864,
              -29.24988229741352
            ],
            [
              -53.23761505962521,
              -29.251610324935495
            ],
            [
              -53.238519175109836,
              -29.254005999454595
            ],
            [
              -53.23761505962521,
              -29.256794407501417
            ],
            [
              -53.23558079978481,
              -29.25718714102914
            ],
            [
              -53.23318489375056,
              -29.255302020096075
            ],
            [
              -53.23002048955438,
              -29.254202366218458
            ],
            [
              -53.227082114229354,
              -29.254516553040634
            ],
            [
              -53.22459579664664,
              -29.25589112038766
            ],
            [
              -53.221521803998925,
              -29.258600981728936
            ],
            [
              -53.21401764547655,
              -29.26221413018397
            ],
            [
              -53.21080803550614,
              -29.26409925111703
            ],
            [
              -53.208999804536894,
              -29.266691292399994
            ],
            [
              -53.2103107719896,
              -29.27018662079671
            ],
            [
              -53.21270667802385,
              -29.27238592855195
            ],
            [
              -53.21428888012194,
              -29.273407035724027
            ],
            [
              -53.22269715412894,
              -29.273996136015608
            ],
            [
              -53.22491223706626,
              -29.27328921566571
            ],
            [
              -53.226810879583965,
              -29.271089907910472
            ],
            [
              -53.229116374069754,
              -29.26739821274989
            ],
            [
              -53.23241639558863,
              -29.264295617880894
            ],
            [
              -53.234495861203264,
              -29.263195964003273
            ],
            [
              -53.236891767237516,
              -29.262489043653375
            ],
            [
              -53.23910685017484,
              -29.263392330767132
            ],
            [
              -53.24019178875639,
              -29.26460980470307
            ],
            [
              -53.24141234466063,
              -29.26849786662751
            ],
            [
              -53.24118631578947,
              -29.270382987560573
            ],
            [
              -53.239378084820224,
              -29.27458523630719
            ],
            [
              -53.23779588272214,
              -29.278905305112122
            ],
            [
              -53.23738903075406,
              -29.282597000272702
            ],
            [
              -53.2386095866583,
              -29.28440357450022
            ],
            [
              -53.242316460145254,
              -29.284089387678044
            ],
            [
              -53.2439890737918,
              -29.28440357450022
            ],
            [
              -53.24652059714875,
              -29.28660288225546
            ],
            [
              -53.24751512418183,
              -29.2880952696608
            ],
            [
              -53.247605535730294,
              -29.292101151643557
            ],
            [
              -53.24710827221375,
              -29.29398627257662
            ],
            [
              -53.245706893212585,
              -29.296617587212353
            ],
            [
              -53.24028220030485,
              -29.29968090872858
            ],
            [
              -53.23639450372097,
              -29.30431516435569
            ],
            [
              -53.23169310320093,
              -29.307417759224688
            ],
            [
              -53.23002048955438,
              -29.30918506009943
            ],
            [
              -53.2302013126513,
              -29.310206167271506
            ],
            [
              -53.231512280104006,
              -29.312012741499025
            ],
            [
              -53.23390818613826,
              -29.314212049254266
            ],
            [
              -53.236078063301356,
              -29.31731464412326
            ],
            [
              -53.23589724020443,
              -29.319199765056325
            ],
            [
              -53.23458627275173,
              -29.32041723899226
            ],
            [
              -53.229116374069754,
              -29.32320564703908
            ],
            [
              -53.22798622971398,
              -29.32450166768056
            ],
            [
              -53.22848349323052,
              -29.32760426254956
            ],
            [
              -53.23060816461938,
              -29.3307854041241
            ],
            [
              -53.23241639558863,
              -29.33278834511548
            ],
            [
              -53.23399859768672,
              -29.33369163222924
            ],
            [
              -53.23549038823635,
              -29.333613085523695
            ],
            [
              -53.238519175109836,
              -29.332317064882215
            ],
            [
              -53.24059864072447,
              -29.33278834511548
            ],
            [
              -53.24181919662871,
              -29.334202185815275
            ],
            [
              -53.24181919662871,
              -29.33608730674834
            ],
            [
              -53.24068905227293,
              -29.338797168089616
            ],
            [
              -53.23951370214292,
              -29.340407375553273
            ],
            [
              -53.237705471173676,
              -29.341389209372576
            ],
            [
              -53.233682157267104,
              -29.342488863250196
            ],
            [
              -53.23142186855554,
              -29.343784883891676
            ],
            [
              -53.230291724199766,
              -29.34669111199681
            ],
            [
              -53.23101501658746,
              -29.350107893687987
            ],
            [
              -53.23209995516901,
              -29.35238574814877
            ],
            [
              -53.23200954362055,
              -29.355409796312223
            ],
            [
              -53.23060816461938,
              -29.35870875794508
            ],
            [
              -53.22839308168206,
              -29.360908065700322
            ],
            [
              -53.22251633103201,
              -29.36491394768308
            ],
            [
              -53.220708100062765,
              -29.36730962220218
            ],
            [
              -53.219894396126605,
              -29.369901663485138
            ],
            [
              -53.22021083654622,
              -29.372415158062555
            ],
            [
              -53.22120536357931,
              -29.374418099053933
            ],
            [
              -53.225590323679725,
              -29.377795607392336
            ],
            [
              -53.226404027615885,
              -29.380387648675296
            ],
            [
              -53.22631361606742,
              -29.38400079713033
            ],
            [
              -53.22581635255088,
              -29.387613945585368
            ],
            [
              -53.22771499506859,
              -29.39169837427367
            ],
            [
              -53.227895818165514,
              -29.394918789200982
            ],
            [
              -53.227082114229354,
              -29.401006158880662
            ],
            [
              -53.22730814310051,
              -29.40300909987204
            ],
            [
              -53.22861911055321,
              -29.405286954332823
            ],
            [
              -53.231105428135926,
              -29.407682628851923
            ],
            [
              -53.23417942078365,
              -29.409214289610038
            ],
            [
              -53.23820273469022,
              -29.411884877598542
            ],
            [
              -53.24141234466063,
              -29.41671549998951
            ],
            [
              -53.24439592575988,
              -29.42260650290533
            ],
            [
              -53.249504178248,
              -29.42480581066057
            ],
            [
              -53.250815145700706,
              -29.424295257074533
            ],
            [
              -53.257686423383845,
              -29.432817574626085
            ],
            [
              -53.26112206222541,
              -29.434899062323005
            ],
            [
              -53.26510017035775,
              -29.434192141973107
            ],
            [
              -53.269711159329326,
              -29.430382626754213
            ],
            [
              -53.27278515197705,
              -29.429086606112733
            ],
            [
              -53.27599476194746,
              -29.429086606112733
            ],
            [
              -53.2793851950148,
              -29.43010771328481
            ],
            [
              -53.2862112669237,
              -29.435605982672904
            ],
            [
              -53.287386617053706,
              -29.439219131127942
            ],
            [
              -53.28530715143907,
              -29.44420684693
            ],
            [
              -53.28169068950058,
              -29.447309441799
            ],
            [
              -53.278209844884785,
              -29.447584355268404
            ],
            [
              -53.266501549358914,
              -29.444717400516037
            ],
            [
              -53.263789202905045,
              -29.44609196786306
            ],
            [
              -53.26541661077737,
              -29.449312382790378
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "mesorregiao_nome": "Centro Oriental Rio-grandense",
        "mesorregiao_id": 4304,
        "num_municipios": 54
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -53.06389798130955,
              -29.18179997884877
            ],
            [
              -53.057617624602976,
              -29.180995893639526
            ],
            [
              -53.056623234791104,
              -29.17989027647681
            ],
            [
              -53.05882135963841,
              -29.177880063453696
            ],
            [
              -53.0606007940386,
              -29.17541755250038
            ],
            [
              -53.05808865135597,
              -29.169788956035656
            ],
            [
              -53.059083041167845,
              -29.167376700407917
            ],
            [
              -53.063008264109456,
              -29.16089376340837
            ],
            [
              -53.064421344368434,
              -29.160290699501438
            ],
            [
              -53.06321760933301,
              -29.157777933222544
            ],
            [
              -53.061019484485705,
              -29.156018996827317
            ],
            [
              -53.057617624602976,
              -29.15737589061792
            ],
            [
              -53.0548961366968,
              -29.15622001812963
            ],
            [
              -53.0526980118495,
              -29.156119507478472
            ],
            [
              -53.05118025897874,
              -29.157024103338873
            ],
            [
              -53.05107558636696,
              -29.157978954524854
            ],
            [
              -53.0531167022966,
              -29.161094784710684
            ],
            [
              -53.05280268446128,
              -29.16209989122224
            ],
            [
              -53.0509185774493,
              -29.162702955129177
            ],
            [
              -53.0465223277547,
              -29.162300912524554
            ],
            [
              -53.04348682201319,
              -29.16330601903611
            ],
            [
              -53.04128869716589,
              -29.163104997733797
            ],
            [
              -53.038985899706816,
              -29.16069274210606
            ],
            [
              -53.03631674810652,
              -29.160592231454906
            ],
            [
              -53.03547936721231,
              -29.160089678199125
            ],
            [
              -53.03600273027119,
              -29.15757691192023
            ],
            [
              -53.03610740288297,
              -29.15451133705998
            ],
            [
              -53.03411862325922,
              -29.1531041879438
            ],
            [
              -53.03050741815294,
              -29.15521491161807
            ],
            [
              -53.02851863852919,
              -29.157024103338873
            ],
            [
              -53.02700088565844,
              -29.15692359268772
            ],
            [
              -53.02427939775226,
              -29.15767742257139
            ],
            [
              -53.01920277608111,
              -29.158682529082945
            ],
            [
              -53.01789436843391,
              -29.157978954524854
            ],
            [
              -53.01679530601026,
              -29.15571746487385
            ],
            [
              -53.01370746396286,
              -29.155918486176162
            ],
            [
              -53.00842149706816,
              -29.1540087838042
            ],
            [
              -53.00831682445639,
              -29.152601634688022
            ],
            [
              -53.00627570852675,
              -29.15049091101375
            ],
            [
              -53.00512430979721,
              -29.148279676688322
            ],
            [
              -53.00658972636208,
              -29.14712380420003
            ],
            [
              -53.010881303444904,
              -29.146018187037317
            ],
            [
              -53.01161401172734,
              -29.144208995316514
            ],
            [
              -53.01109064866846,
              -29.1421987822934
            ],
            [
              -53.01182335695089,
              -29.138982441456417
            ],
            [
              -53.01051494930369,
              -29.138479888200635
            ],
            [
              -53.00878785120938,
              -29.13888193080526
            ],
            [
              -53.008107479232834,
              -29.138077845596012
            ],
            [
              -53.00481029196188,
              -29.137122994410035
            ],
            [
              -53.002298149279255,
              -29.137776313642547
            ],
            [
              -52.999524325067185,
              -29.138982441456417
            ],
            [
              -52.99847759894942,
              -29.140691122526064
            ],
            [
              -52.998425262643536,
              -29.1421987822934
            ],
            [
              -52.99648881932568,
              -29.144912569874606
            ],
            [
              -52.99340097727828,
              -29.14481205922345
            ],
            [
              -52.99099350720743,
              -29.145113591176916
            ],
            [
              -52.99031313523088,
              -29.143706442060736
            ],
            [
              -52.98832435560713,
              -29.142299292944557
            ],
            [
              -52.98748697471292,
              -29.144510527269983
            ],
            [
              -52.9858122129245,
              -29.14767661278139
            ],
            [
              -52.986387912289274,
              -29.151496017525307
            ],
            [
              -52.98591688553628,
              -29.153003677292645
            ],
            [
              -52.986911275348156,
              -29.15551644357154
            ],
            [
              -52.98680660273638,
              -29.15692359268772
            ],
            [
              -52.982986052406545,
              -29.157978954524854
            ],
            [
              -52.981206618006354,
              -29.156521550083095
            ],
            [
              -52.97691504092353,
              -29.158380997129477
            ],
            [
              -52.97539728805277,
              -29.1596876355945
            ],
            [
              -52.9735131810408,
              -29.15978814624566
            ],
            [
              -52.97330383581725,
              -29.15807946517601
            ],
            [
              -52.97210010078182,
              -29.15712461399003
            ],
            [
              -52.96859356828732,
              -29.15767742257139
            ],
            [
              -52.96718048802834,
              -29.156823082036563
            ],
            [
              -52.96681413388712,
              -29.154712358362293
            ],
            [
              -52.965924416687024,
              -29.153506230548423
            ],
            [
              -52.96388330075739,
              -29.154410826408824
            ],
            [
              -52.96388330075739,
              -29.156018996827317
            ],
            [
              -52.961214149157094,
              -29.15642103943194
            ],
            [
              -52.96079545870999,
              -29.160491720803748
            ],
            [
              -52.95922536953335,
              -29.16189886991993
            ],
            [
              -52.959277705839234,
              -29.16360755098958
            ],
            [
              -52.95728892621549,
              -29.16421061489651
            ],
            [
              -52.95660855423894,
              -29.166522359873095
            ],
            [
              -52.95420108416809,
              -29.167678232361386
            ],
            [
              -52.953782393720985,
              -29.170291509291435
            ],
            [
              -52.95121791473247,
              -29.17159814775646
            ],
            [
              -52.951008569508915,
              -29.172502743616864
            ],
            [
              -52.94901978988517,
              -29.173608360779575
            ],
            [
              -52.94912446249695,
              -29.175015509895758
            ],
            [
              -52.947606709626186,
              -29.17662368031425
            ],
            [
              -52.945984284143655,
              -29.17612112705847
            ],
            [
              -52.941902052284384,
              -29.176322148360782
            ],
            [
              -52.94101233508429,
              -29.177176488895604
            ],
            [
              -52.93938990960176,
              -29.176975467593294
            ],
            [
              -52.93551702296604,
              -29.178382616709474
            ],
            [
              -52.93358057964818,
              -29.178583638011787
            ],
            [
              -52.933004880283406,
              -29.179689255174498
            ],
            [
              -52.93002171084779,
              -29.180995893639526
            ],
            [
              -52.92677685988272,
              -29.181699468197614
            ],
            [
              -52.926515178353284,
              -29.184212234476508
            ],
            [
              -52.92321799108233,
              -29.184714787732286
            ],
            [
              -52.91918809552895,
              -29.18340814926726
            ],
            [
              -52.9171993159052,
              -29.185418362290378
            ],
            [
              -52.91698997068165,
              -29.18707678803445
            ],
            [
              -52.9180890331053,
              -29.189991596917967
            ],
            [
              -52.91610025348155,
              -29.192303341894547
            ],
            [
              -52.91442549169313,
              -29.19270538449917
            ],
            [
              -52.91008157830442,
              -29.19250436319686
            ],
            [
              -52.906418036892255,
              -29.189288022359875
            ],
            [
              -52.90390589420962,
              -29.18818240519716
            ],
            [
              -52.904795611409725,
              -29.19270538449917
            ],
            [
              -52.9070984088688,
              -29.194916618824596
            ],
            [
              -52.907203081480574,
              -29.196675555219823
            ],
            [
              -52.909505878939655,
              -29.198082704336006
            ],
            [
              -52.907203081480574,
              -29.203007726242635
            ],
            [
              -52.90542364708038,
              -29.202304151684547
            ],
            [
              -52.903487203762516,
              -29.20290721559148
            ],
            [
              -52.8987245999267,
              -29.206575854358665
            ],
            [
              -52.89762553750305,
              -29.20501793926575
            ],
            [
              -52.896212457244076,
              -29.205621003172688
            ],
            [
              -52.89469470437332,
              -29.204213854056505
            ],
            [
              -52.8961077846323,
              -29.20290721559148
            ],
            [
              -52.89589843940875,
              -29.20200261973108
            ],
            [
              -52.89270592474957,
              -29.2015000664753
            ],
            [
              -52.88820500244319,
              -29.206123556428466
            ],
            [
              -52.8860068775959,
              -29.20552049252153
            ],
            [
              -52.88380875274859,
              -29.205721513823843
            ],
            [
              -52.884489124725135,
              -29.208284535428316
            ],
            [
              -52.88527416931346,
              -29.209289641939872
            ],
            [
              -52.89380498717322,
              -29.213209557334945
            ],
            [
              -52.89558442157342,
              -29.213310067986104
            ],
            [
              -52.89752086489128,
              -29.215621812962684
            ],
            [
              -52.897311519667724,
              -29.21768228131138
            ],
            [
              -52.89820123686782,
              -29.220396068892583
            ],
            [
              -52.89851525470315,
              -29.223210367124945
            ],
            [
              -52.899404971903245,
              -29.22361240972957
            ],
            [
              -52.898986281456146,
              -29.225522112101526
            ],
            [
              -52.89919562667969,
              -29.228085133706
            ],
            [
              -52.89851525470315,
              -29.2289897295664
            ],
            [
              -52.89982366235035,
              -29.232206070403386
            ],
            [
              -52.898986281456146,
              -29.23471883668228
            ],
            [
              -52.8961077846323,
              -29.234819347333435
            ],
            [
              -52.893909659784995,
              -29.232206070403386
            ],
            [
              -52.8930199425849,
              -29.23210555975223
            ],
            [
              -52.88977509161984,
              -29.23687981568213
            ],
            [
              -52.890193782066945,
              -29.241704326937604
            ],
            [
              -52.89249657952602,
              -29.245423221030368
            ],
            [
              -52.89118817187882,
              -29.24637807221635
            ],
            [
              -52.888414347666746,
              -29.24919237044871
            ],
            [
              -52.88668724957244,
              -29.249292881099866
            ],
            [
              -52.885483514537015,
              -29.249996455657957
            ],
            [
              -52.884489124725135,
              -29.255424030820368
            ],
            [
              -52.88490781517224,
              -29.257585009820218
            ],
            [
              -52.885797532372344,
              -29.260399308052577
            ],
            [
              -52.8860068775959,
              -29.26291207433147
            ],
            [
              -52.889199392255065,
              -29.263414627587252
            ],
            [
              -52.89129284449059,
              -29.26321360628494
            ],
            [
              -52.8952180674322,
              -29.2651233086569
            ],
            [
              -52.89642180246763,
              -29.266178670494035
            ],
            [
              -52.89631712985585,
              -29.26768633026137
            ],
            [
              -52.893124615196676,
              -29.27220930956338
            ],
            [
              -52.894590031761545,
              -29.272812373470316
            ],
            [
              -52.89558442157342,
              -29.273917990633027
            ],
            [
              -52.8930199425849,
              -29.279697353074486
            ],
            [
              -52.89129284449059,
              -29.28100399153951
            ],
            [
              -52.88909471964329,
              -29.28341624716725
            ],
            [
              -52.8860068775959,
              -29.285124928236897
            ],
            [
              -52.88647790434889,
              -29.286783353980965
            ],
            [
              -52.8860068775959,
              -29.288190503097148
            ],
            [
              -52.88668724957244,
              -29.290904290678352
            ],
            [
              -52.8860068775959,
              -29.294623184771115
            ],
            [
              -52.887890984607864,
              -29.29472369542227
            ],
            [
              -52.88851902027852,
              -29.295578035957096
            ],
            [
              -52.887576966772535,
              -29.297487738329053
            ],
            [
              -52.885483514537015,
              -29.298593355491768
            ],
            [
              -52.88260501771317,
              -29.300905100468352
            ],
            [
              -52.88899004703151,
              -29.30608139900287
            ],
            [
              -52.89108349926704,
              -29.3082926333283
            ],
            [
              -52.89139751710237,
              -29.309900803746793
            ],
            [
              -52.890978826655264,
              -29.31181050611875
            ],
            [
              -52.891816207549475,
              -29.31301663393262
            ],
            [
              -52.89558442157342,
              -29.31392122979302
            ],
            [
              -52.89888160884437,
              -29.315780676839402
            ],
            [
              -52.89689282922062,
              -29.316685272699804
            ],
            [
              -52.8952180674322,
              -29.318293443118296
            ],
            [
              -52.89249657952602,
              -29.318293443118296
            ],
            [
              -52.890978826655264,
              -29.31960008158332
            ],
            [
              -52.889879764231615,
              -29.319499570932166
            ],
            [
              -52.8886236928903,
              -29.317087315304427
            ],
            [
              -52.888414347666746,
              -29.315680166188248
            ],
            [
              -52.886320895431226,
              -29.315981698141716
            ],
            [
              -52.884803142560465,
              -29.316886294002117
            ],
            [
              -52.884018097972145,
              -29.318393953769455
            ],
            [
              -52.87951717566577,
              -29.319801102885634
            ],
            [
              -52.87941250305399,
              -29.321208252001814
            ],
            [
              -52.87779007757146,
              -29.321308762652972
            ],
            [
              -52.875277934888835,
              -29.32060518809488
            ],
            [
              -52.87470223552406,
              -29.31970059223448
            ],
            [
              -52.87318448265331,
              -29.320404166792567
            ],
            [
              -52.87208542022966,
              -29.32181131590875
            ],
            [
              -52.869887295382355,
              -29.32110774135066
            ],
            [
              -52.86931159601759,
              -29.320404166792567
            ],
            [
              -52.867479825311506,
              -29.321007230699504
            ],
            [
              -52.86381628389934,
              -29.31970059223448
            ],
            [
              -52.86020507879306,
              -29.31779088986252
            ],
            [
              -52.85800695394576,
              -29.31728833660674
            ],
            [
              -52.857221909357435,
              -29.317690379211363
            ],
            [
              -52.85769293611043,
              -29.320002124187944
            ],
            [
              -52.85711723674566,
              -29.321610294606437
            ],
            [
              -52.85580882909846,
              -29.321911826559905
            ],
            [
              -52.85539013865135,
              -29.320102634839103
            ],
            [
              -52.85308734119228,
              -29.31939906028101
            ],
            [
              -52.85130790679208,
              -29.320504677443726
            ],
            [
              -52.849476136086,
              -29.32080620939719
            ],
            [
              -52.8468069844857,
              -29.32301744372262
            ],
            [
              -52.84481820486196,
              -29.32412306088533
            ],
            [
              -52.84162569020278,
              -29.328495274210606
            ],
            [
              -52.84042195516736,
              -29.328595784861765
            ],
            [
              -52.83728177681407,
              -29.325781486629403
            ],
            [
              -52.83461262521378,
              -29.32628403988518
            ],
            [
              -52.83377524431957,
              -29.327892210303673
            ],
            [
              -52.83168179208405,
              -29.32819374225714
            ],
            [
              -52.8310014201075,
              -29.327289146396737
            ],
            [
              -52.82451171817738,
              -29.32749016769905
            ],
            [
              -52.824302372953824,
              -29.32537944402478
            ],
            [
              -52.82267994747129,
              -29.319499570932166
            ],
            [
              -52.82048182262399,
              -29.31628323009518
            ],
            [
              -52.81598090031761,
              -29.31588118749056
            ],
            [
              -52.812474367823114,
              -29.317087315304427
            ],
            [
              -52.809909888834596,
              -29.319298549629856
            ],
            [
              -52.81001456144637,
              -29.321610294606437
            ],
            [
              -52.80818279074029,
              -29.323821528931866
            ],
            [
              -52.80410055888102,
              -29.32392203958302
            ],
            [
              -52.80247813339848,
              -29.325278933373625
            ],
            [
              -52.80211177925727,
              -29.32678659314096
            ],
            [
              -52.803524859516244,
              -29.329500380722166
            ],
            [
              -52.80012299963352,
              -29.3310080404895
            ],
            [
              -52.798186556315656,
              -29.330304465931412
            ],
            [
              -52.79782020217444,
              -29.328294252908297
            ],
            [
              -52.79619777669191,
              -29.327289146396737
            ],
            [
              -52.79619777669191,
              -29.329500380722166
            ],
            [
              -52.794784696432934,
              -29.330002933977944
            ],
            [
              -52.79222021744442,
              -29.332314678954525
            ],
            [
              -52.78808564927925,
              -29.335179232512466
            ],
            [
              -52.7878763040557,
              -29.336184339024022
            ],
            [
              -52.7856781792084,
              -29.335681785768244
            ],
            [
              -52.785416497678966,
              -29.336586381628646
            ],
            [
              -52.7812819295138,
              -29.340506297023722
            ],
            [
              -52.78222398301979,
              -29.341712424837592
            ],
            [
              -52.781491274737355,
              -29.343019063302616
            ],
            [
              -52.780182867090154,
              -29.34342110590724
            ],
            [
              -52.77939782250183,
              -29.342516510046835
            ],
            [
              -52.777880069631074,
              -29.343823148511863
            ],
            [
              -52.77667633459565,
              -29.34598412751171
            ],
            [
              -52.77850810530173,
              -29.346386170116332
            ],
            [
              -52.778403432689956,
              -29.34789382988367
            ],
            [
              -52.77971184033716,
              -29.34879842574407
            ],
            [
              -52.78049688492548,
              -29.352014766581057
            ],
            [
              -52.77829876007818,
              -29.352919362441458
            ],
            [
              -52.775995962619106,
              -29.35171323462759
            ],
            [
              -52.77180905814806,
              -29.35407523492975
            ],
            [
              -52.7711810224774,
              -29.355281362743618
            ],
            [
              -52.769296915465425,
              -29.355180852092463
            ],
            [
              -52.76777916259467,
              -29.3566885118598
            ],
            [
              -52.76469132054727,
              -29.357492597069047
            ],
            [
              -52.763278240288294,
              -29.360005363347938
            ],
            [
              -52.76050441607622,
              -29.360608427254874
            ],
            [
              -52.76050441607622,
              -29.363020682882613
            ],
            [
              -52.75982404409968,
              -29.36407604471975
            ],
            [
              -52.75851563645248,
              -29.364478087324372
            ],
            [
              -52.757311901417054,
              -29.363020682882613
            ],
            [
              -52.75511377656975,
              -29.363121193533768
            ],
            [
              -52.754224059369655,
              -29.364176555370904
            ],
            [
              -52.75087453579282,
              -29.363422725487236
            ],
            [
              -52.74972313706328,
              -29.36352323613839
            ],
            [
              -52.74768202113364,
              -29.365081151231305
            ],
            [
              -52.746111931956996,
              -29.36739289620789
            ],
            [
              -52.74459417908624,
              -29.3675939175102
            ],
            [
              -52.743495116662594,
              -29.36518166188246
            ],
            [
              -52.7430240899096,
              -29.361814555068744
            ],
            [
              -52.74328577143904,
              -29.35900025683638
            ],
            [
              -52.741401664427066,
              -29.355582894697086
            ],
            [
              -52.741087646591744,
              -29.353924468953014
            ],
            [
              -52.74161100965062,
              -29.349602510953318
            ],
            [
              -52.74072129245052,
              -29.348295872488293
            ],
            [
              -52.73909886696799,
              -29.348496893790603
            ],
            [
              -52.73632504275592,
              -29.35000455355794
            ],
            [
              -52.735225980332274,
              -29.350205574860254
            ],
            [
              -52.73417925421451,
              -29.349200468348695
            ],
            [
              -52.73501663510872,
              -29.347793319232515
            ],
            [
              -52.73721475995602,
              -29.346084638162868
            ],
            [
              -52.740407274615194,
              -29.34548157425593
            ],
            [
              -52.74119231920352,
              -29.344677489046685
            ],
            [
              -52.74150633703884,
              -29.342516510046835
            ],
            [
              -52.74098297397997,
              -29.34030527572141
            ],
            [
              -52.7408259650623,
              -29.335983317721713
            ],
            [
              -52.739779238944536,
              -29.334475657954375
            ],
            [
              -52.73658672428537,
              -29.33628484967518
            ],
            [
              -52.733812900073296,
              -29.339300169209853
            ],
            [
              -52.73171944783777,
              -29.342315488744525
            ],
            [
              -52.72962599560225,
              -29.342617020697993
            ],
            [
              -52.72842226056682,
              -29.34120987158181
            ],
            [
              -52.72831758795505,
              -29.33789302009367
            ],
            [
              -52.72920730515514,
              -29.334877700558998
            ],
            [
              -52.73229514720254,
              -29.330404976582567
            ],
            [
              -52.73271383764965,
              -29.32869629551292
            ],
            [
              -52.73119608477889,
              -29.327590678350205
            ],
            [
              -52.72831758795505,
              -29.32819374225714
            ],
            [
              -52.72758487967261,
              -29.32769118900136
            ],
            [
              -52.72737553444906,
              -29.324022550234176
            ],
            [
              -52.727480207060836,
              -29.321710805257595
            ],
            [
              -52.72659048986073,
              -29.320203145490257
            ],
            [
              -52.72449703762521,
              -29.31939906028101
            ],
            [
              -52.723397975201564,
              -29.319499570932166
            ],
            [
              -52.71989144270706,
              -29.321509783955282
            ],
            [
              -52.71900172550696,
              -29.32080620939719
            ],
            [
              -52.71900172550696,
              -29.31939906028101
            ],
            [
              -52.720781159907155,
              -29.31819293246714
            ],
            [
              -52.723921338260446,
              -29.317690379211363
            ],
            [
              -52.72418301978988,
              -29.315981698141716
            ],
            [
              -52.72020546054239,
              -29.311911016769905
            ],
            [
              -52.719211070730516,
              -29.309096718537546
            ],
            [
              -52.71942041595407,
              -29.306985994863275
            ],
            [
              -52.718687707671634,
              -29.30567935639825
            ],
            [
              -52.71680360065966,
              -29.305377824444783
            ],
            [
              -52.71392510383581,
              -29.306784973560962
            ],
            [
              -52.71141296115319,
              -29.307488548119053
            ],
            [
              -52.70999988089421,
              -29.306885484212117
            ],
            [
              -52.7095811904471,
              -29.305779867049406
            ],
            [
              -52.71099427070608,
              -29.304322462607647
            ],
            [
              -52.713192395553385,
              -29.303317356096088
            ],
            [
              -52.71669892804788,
              -29.302412760235686
            ],
            [
              -52.72051947837772,
              -29.302211738933376
            ],
            [
              -52.721095177742484,
              -29.301106121770662
            ],
            [
              -52.720781159907155,
              -29.299397440701014
            ],
            [
              -52.719996115318835,
              -29.29809080223599
            ],
            [
              -52.720781159907155,
              -29.296382121166342
            ],
            [
              -52.72282227583679,
              -29.29567854660825
            ],
            [
              -52.72460171023699,
              -29.29587956791056
            ],
            [
              -52.727794224896165,
              -29.296985185073275
            ],
            [
              -52.72878861470804,
              -29.296583142468652
            ],
            [
              -52.73009702235524,
              -29.291808886538753
            ],
            [
              -52.728579269484484,
              -29.291105311980665
            ],
            [
              -52.72638114463719,
              -29.291105311980665
            ],
            [
              -52.72219424016614,
              -29.29241195044569
            ],
            [
              -52.71910639811874,
              -29.292009907841067
            ],
            [
              -52.71680360065966,
              -29.292612971748
            ],
            [
              -52.715285847788905,
              -29.29547752530594
            ],
            [
              -52.713977440141704,
              -29.29587956791056
            ],
            [
              -52.712826041412164,
              -29.295175993352473
            ],
            [
              -52.71329706816516,
              -29.293015014352623
            ],
            [
              -52.71549519301246,
              -29.29050224807373
            ],
            [
              -52.71539052040068,
              -29.28899458830639
            ],
            [
              -52.71031389872954,
              -29.287687949841366
            ],
            [
              -52.707801756046905,
              -29.28879356700408
            ],
            [
              -52.70691203884681,
              -29.29030122677142
            ],
            [
              -52.70628400317615,
              -29.292612971748
            ],
            [
              -52.70481858661129,
              -29.29361807825956
            ],
            [
              -52.700998036281455,
              -29.289597652213327
            ],
            [
              -52.698590566210605,
              -29.287687949841366
            ],
            [
              -52.69607842352797,
              -29.286582332678655
            ],
            [
              -52.69131581969216,
              -29.28668284332981
            ],
            [
              -52.69100180185683,
              -29.285376204864786
            ],
            [
              -52.69340927192768,
              -29.28190858739991
            ],
            [
              -52.695188706327876,
              -29.280903480888355
            ],
            [
              -52.695188706327876,
              -29.279295310469863
            ],
            [
              -52.693513944539454,
              -29.276078969632877
            ],
            [
              -52.69299058148057,
              -29.272611352168003
            ],
            [
              -52.6937756260689,
              -29.271606245656447
            ],
            [
              -52.698590566210605,
              -29.27190777760991
            ],
            [
              -52.69900925665771,
              -29.269998075237954
            ],
            [
              -52.6963924413633,
              -29.26271105302916
            ],
            [
              -52.694717679574886,
              -29.260700840006045
            ],
            [
              -52.69278123625703,
              -29.260198286750267
            ],
            [
              -52.691106474468604,
              -29.26110288261067
            ],
            [
              -52.68990273943318,
              -29.263414627587252
            ],
            [
              -52.6889083496213,
              -29.264520244749963
            ],
            [
              -52.68817564133887,
              -29.266178670494035
            ],
            [
              -52.68650087955045,
              -29.266681223749814
            ],
            [
              -52.68482611776203,
              -29.26291207433147
            ],
            [
              -52.685297144515026,
              -29.261404414564137
            ],
            [
              -52.68377939164427,
              -29.259796244145644
            ],
            [
              -52.68001117762033,
              -29.257685520471373
            ],
            [
              -52.67582427314928,
              -29.253815860401875
            ],
            [
              -52.67639997251405,
              -29.252006668681073
            ],
            [
              -52.679226133032,
              -29.250499008913735
            ],
            [
              -52.680586876985096,
              -29.247885731983686
            ],
            [
              -52.679278469337895,
              -29.24698113612328
            ],
            [
              -52.67718501710237,
              -29.24828777458831
            ],
            [
              -52.676504645125824,
              -29.247785221332528
            ],
            [
              -52.674201847666744,
              -29.243614029309565
            ],
            [
              -52.674201847666744,
              -29.24250841214685
            ],
            [
              -52.675405582702176,
              -29.238890028705246
            ],
            [
              -52.6744111928903,
              -29.23592496449615
            ],
            [
              -52.67399250244319,
              -29.233110666263787
            ],
            [
              -52.672579422184214,
              -29.233914751473034
            ],
            [
              -52.670014943195696,
              -29.234618326031125
            ],
            [
              -52.666613083312974,
              -29.236075730472884
            ],
            [
              -52.665200003054,
              -29.23230658105454
            ],
            [
              -52.66200748839482,
              -29.231904538449918
            ],
            [
              -52.662373842536034,
              -29.229190750868714
            ],
            [
              -52.66137945272416,
              -29.22788411240369
            ],
            [
              -52.65761123870022,
              -29.228688197612936
            ],
            [
              -52.65651217627657,
              -29.231804027798763
            ],
            [
              -52.653476670535056,
              -29.230698410636048
            ],
            [
              -52.650702846322986,
              -29.231904538449918
            ],
            [
              -52.65017948326411,
              -29.230597899984893
            ],
            [
              -52.650702846322986,
              -29.228587686961777
            ],
            [
              -52.64960378389934,
              -29.228386665659468
            ],
            [
              -52.645678560957734,
              -29.231502495845294
            ],
            [
              -52.64798135841681,
              -29.232708623659164
            ],
            [
              -52.64771967688737,
              -29.233613219519565
            ],
            [
              -52.642119692157344,
              -29.233713730170724
            ],
            [
              -52.64039259406303,
              -29.23471883668228
            ],
            [
              -52.638403814439286,
              -29.23280913431032
            ],
            [
              -52.63521129978011,
              -29.231703517147608
            ],
            [
              -52.634007564744685,
              -29.22637645263635
            ],
            [
              -52.63071037747373,
              -29.230698410636048
            ],
            [
              -52.627203844979235,
              -29.2298943254268
            ],
            [
              -52.62741319020279,
              -29.228386665659468
            ],
            [
              -52.61951040801368,
              -29.230798921287207
            ],
            [
              -52.61851601820181,
              -29.232507602356854
            ],
            [
              -52.61490481309553,
              -29.23140198519414
            ],
            [
              -52.615009485707304,
              -29.230296368031425
            ],
            [
              -52.61657957488395,
              -29.229793814775647
            ],
            [
              -52.615794530295624,
              -29.228185644357154
            ],
            [
              -52.610299218177374,
              -29.22778360175253
            ],
            [
              -52.608205765941854,
              -29.22522058014806
            ],
            [
              -52.60972351881261,
              -29.225321090799216
            ],
            [
              -52.609200155753726,
              -29.222305771264544
            ],
            [
              -52.60469923344735,
              -29.21878789847409
            ],
            [
              -52.6036001710237,
              -29.21622487686962
            ],
            [
              -52.599779620693866,
              -29.215923344916153
            ],
            [
              -52.59841887674077,
              -29.21431517449766
            ],
            [
              -52.59559271622282,
              -29.215923344916153
            ],
            [
              -52.592609546787195,
              -29.215822834264998
            ],
            [
              -52.5891030142927,
              -29.217481260009066
            ],
            [
              -52.58648619899829,
              -29.21758177066022
            ],
            [
              -52.591510484363546,
              -29.223411388427255
            ],
            [
              -52.59130113913999,
              -29.224617516241125
            ],
            [
              -52.58010116967994,
              -29.228286155008313
            ],
            [
              -52.57711800024432,
              -29.227482069799066
            ],
            [
              -52.57680398240899,
              -29.224919048194593
            ],
            [
              -52.571203997678964,
              -29.226074920682883
            ],
            [
              -52.56801148301979,
              -29.2242154736365
            ],
            [
              -52.566022703396044,
              -29.224014452334192
            ],
            [
              -52.56371990593696,
              -29.221803218008766
            ],
            [
              -52.561312435866114,
              -29.223210367124945
            ],
            [
              -52.56000402821891,
              -29.22310985647379
            ],
            [
              -52.558695620571704,
              -29.219893515636805
            ],
            [
              -52.553200308453455,
              -29.223511899078414
            ],
            [
              -52.550478820547276,
              -29.223009345822632
            ],
            [
              -52.54650126129978,
              -29.224114962985347
            ],
            [
              -52.54011623198143,
              -29.223511899078414
            ],
            [
              -52.53561530967505,
              -29.22451700558997
            ],
            [
              -52.526299447226975,
              -29.219189941078714
            ],
            [
              -52.52410132237967,
              -29.22542160145037
            ],
            [
              -52.5231069325678,
              -29.22637645263635
            ],
            [
              -52.51708825739067,
              -29.228386665659468
            ],
            [
              -52.51698358477889,
              -29.229391772171024
            ],
            [
              -52.52028077204984,
              -29.233713730170724
            ],
            [
              -52.519600400073294,
              -29.235723943193836
            ],
            [
              -52.51530882299047,
              -29.238186454147154
            ],
            [
              -52.512482662472515,
              -29.241804837588763
            ],
            [
              -52.50719669557782,
              -29.242608922798006
            ],
            [
              -52.50102101148302,
              -29.24728266807675
            ],
            [
              -52.49908456816516,
              -29.247182157425595
            ],
            [
              -52.49578738089421,
              -29.243915561263034
            ],
            [
              -52.48919300635231,
              -29.24562424233268
            ],
            [
              -52.485215447104814,
              -29.24471964647228
            ],
            [
              -52.48108087893965,
              -29.245523731681523
            ],
            [
              -52.480976206327874,
              -29.23708083698444
            ],
            [
              -52.47830705472758,
              -29.238487986100623
            ],
            [
              -52.47349211458588,
              -29.238890028705246
            ],
            [
              -52.46668839482042,
              -29.238085943496
            ],
            [
              -52.464123915831905,
              -29.236678794379817
            ],
            [
              -52.46260616296115,
              -29.238387475449464
            ],
            [
              -52.457791222819445,
              -29.240498199123735
            ],
            [
              -52.45637814256047,
              -29.240297177821425
            ],
            [
              -52.45062114891278,
              -29.234819347333435
            ],
            [
              -52.44439312851209,
              -29.233010155612632
            ],
            [
              -52.4426136941119,
              -29.231904538449918
            ],
            [
              -52.442404348888346,
              -29.230597899984893
            ],
            [
              -52.43942117945272,
              -29.229391772171024
            ],
            [
              -52.43889781639384,
              -29.225522112101526
            ],
            [
              -52.43779875397019,
              -29.2242154736365
            ],
            [
              -52.43942117945272,
              -29.2224062819157
            ],
            [
              -52.43889781639384,
              -29.22099913279952
            ],
            [
              -52.4395258520645,
              -29.21878789847409
            ],
            [
              -52.437223054605425,
              -29.21647615349751
            ],
            [
              -52.436385673711214,
              -29.21401364254419
            ],
            [
              -52.43481558453457,
              -29.210596280404896
            ],
            [
              -52.4338211947227,
              -29.207882492823693
            ],
            [
              -52.43779875397019,
              -29.207279428916756
            ],
            [
              -52.4382174444173,
              -29.206324577730776
            ],
            [
              -52.43549595651112,
              -29.202505172986857
            ],
            [
              -52.43502492975812,
              -29.200092917359118
            ],
            [
              -52.43580997434645,
              -29.19848474694063
            ],
            [
              -52.43612399218177,
              -29.195017129475755
            ],
            [
              -52.43539128389934,
              -29.193811001661885
            ],
            [
              -52.43748473613486,
              -29.193408959057262
            ],
            [
              -52.43868847117029,
              -29.1914992566853
            ],
            [
              -52.43858379855851,
              -29.189891086266808
            ],
            [
              -52.435914646958224,
              -29.186021426197314
            ],
            [
              -52.43680436415832,
              -29.183508659918417
            ],
            [
              -52.43502492975812,
              -29.180493340383745
            ],
            [
              -52.43392586733447,
              -29.17798057410485
            ],
            [
              -52.43188475140484,
              -29.17898568061641
            ],
            [
              -52.43109970681652,
              -29.17380938208189
            ],
            [
              -52.429581953945764,
              -29.173306828826107
            ],
            [
              -52.429424945028096,
              -29.171698658407617
            ],
            [
              -52.42738382909846,
              -29.17039201994259
            ],
            [
              -52.428901581969214,
              -29.168683338872942
            ],
            [
              -52.428587564133885,
              -29.167075168454453
            ],
            [
              -52.430209989616415,
              -29.166522359873095
            ],
            [
              -52.43109970681652,
              -29.164110104245356
            ],
            [
              -52.42900625458099,
              -29.16360755098958
            ],
            [
              -52.42837821891033,
              -29.161094784710684
            ],
            [
              -52.42832588260445,
              -29.158280486478322
            ],
            [
              -52.427279156486684,
              -29.157024103338873
            ],
            [
              -52.425395049474716,
              -29.156521550083095
            ],
            [
              -52.42429598705106,
              -29.15240061338571
            ],
            [
              -52.424191314439284,
              -29.150390400362596
            ],
            [
              -52.425813739921814,
              -29.148078655386012
            ],
            [
              -52.42508103163939,
              -29.14692278289772
            ],
            [
              -52.42351094246274,
              -29.147224314851186
            ],
            [
              -52.42047543672123,
              -29.14998835775797
            ],
            [
              -52.41278199975568,
              -29.152099081432244
            ],
            [
              -52.41021752076716,
              -29.155918486176162
            ],
            [
              -52.408019395919865,
              -29.157024103338873
            ],
            [
              -52.40707734241388,
              -29.15662206073425
            ],
            [
              -52.40550725323723,
              -29.151596528176462
            ],
            [
              -52.402000720742734,
              -29.148782229944104
            ],
            [
              -52.3928942035182,
              -29.151093974920684
            ],
            [
              -52.38781758184705,
              -29.14767661278139
            ],
            [
              -52.3862998289763,
              -29.147576102130234
            ],
            [
              -52.376983966528215,
              -29.15189806012993
            ],
            [
              -52.369395202174445,
              -29.15069193231606
            ],
            [
              -52.36918585695089,
              -29.14998835775797
            ],
            [
              -52.373791451869046,
              -29.14501308052576
            ],
            [
              -52.373111079892496,
              -29.14360593140958
            ],
            [
              -52.36991856523333,
              -29.143907463363046
            ],
            [
              -52.351391512948936,
              -29.150189379060283
            ],
            [
              -52.34997843268996,
              -29.149686825804505
            ],
            [
              -52.34741395370144,
              -29.14672176159541
            ],
            [
              -52.34547751038358,
              -29.143002867502645
            ],
            [
              -52.34359340337161,
              -29.14079163317722
            ],
            [
              -52.34249434094796,
              -29.140590611874906
            ],
            [
              -52.33391118678231,
              -29.14767661278139
            ],
            [
              -52.330613999511364,
              -29.153305209246113
            ],
            [
              -52.32731681224041,
              -29.156320528780785
            ],
            [
              -52.324595324334226,
              -29.15622001812963
            ],
            [
              -52.32271121732226,
              -29.14692278289772
            ],
            [
              -52.3198850568043,
              -29.145415123130384
            ],
            [
              -52.31711123259223,
              -29.145917676386162
            ],
            [
              -52.31601217016858,
              -29.1465207402931
            ],
            [
              -52.31559347972148,
              -29.152501124036867
            ],
            [
              -52.31318600965062,
              -29.157225124641187
            ],
            [
              -52.31051685805033,
              -29.158481507780632
            ],
            [
              -52.30219538541412,
              -29.152903166641487
            ],
            [
              -52.30031127840215,
              -29.152702145339177
            ],
            [
              -52.29989258795504,
              -29.154611847711138
            ],
            [
              -52.299316888590276,
              -29.164110104245356
            ],
            [
              -52.29240849621305,
              -29.163909082943043
            ],
            [
              -52.29240849621305,
              -29.162501933826864
            ],
            [
              -52.290681398118736,
              -29.15908457168757
            ],
            [
              -52.2921991509895,
              -29.154611847711138
            ],
            [
              -52.28670383887124,
              -29.15551644357154
            ],
            [
              -52.28628514842414,
              -29.15431031575767
            ],
            [
              -52.28958233569509,
              -29.151998570781085
            ],
            [
              -52.28440104141217,
              -29.15069193231606
            ],
            [
              -52.28670383887124,
              -29.148078655386012
            ],
            [
              -52.28670383887124,
              -29.145817165735007
            ],
            [
              -52.285814121671145,
              -29.14410848466536
            ],
            [
              -52.28769822868312,
              -29.14149520773531
            ],
            [
              -52.28801224651845,
              -29.13868090950295
            ],
            [
              -52.289425326777426,
              -29.137977334944857
            ],
            [
              -52.293612231248474,
              -29.138278866898325
            ],
            [
              -52.29387391277791,
              -29.13601737724732
            ],
            [
              -52.29272251404838,
              -29.135012270735764
            ],
            [
              -52.292984195577816,
              -29.133102568363803
            ],
            [
              -52.290524389201074,
              -29.129685206224508
            ],
            [
              -52.28879729110677,
              -29.129283163619885
            ],
            [
              -52.28769822868312,
              -29.13058980208491
            ],
            [
              -52.283877678353285,
              -29.130388780782596
            ],
            [
              -52.28157488089421,
              -29.128579589061793
            ],
            [
              -52.282412261788416,
              -29.12672014201541
            ],
            [
              -52.281103854141215,
              -29.12491095029461
            ],
            [
              -52.27471882482287,
              -29.12159409880647
            ],
            [
              -52.27361976239922,
              -29.119583885783353
            ],
            [
              -52.27168331908136,
              -29.11867928992295
            ],
            [
              -52.26922351270462,
              -29.118779800574107
            ],
            [
              -52.26828145919863,
              -29.117623928085816
            ],
            [
              -52.264879599315904,
              -29.119081332527575
            ],
            [
              -52.263414182751035,
              -29.11867928992295
            ],
            [
              -52.255511400561936,
              -29.120287460341444
            ],
            [
              -52.25221421329098,
              -29.11867928992295
            ],
            [
              -52.251586177620325,
              -29.109784097295666
            ],
            [
              -52.246875910090395,
              -29.101994521831095
            ],
            [
              -52.24551516613731,
              -29.102497075086873
            ],
            [
              -52.24017686293672,
              -29.10209503248225
            ],
            [
              -52.23237875335939,
              -29.100084819459134
            ],
            [
              -52.23002361959443,
              -29.100587372714912
            ],
            [
              -52.224685316393845,
              -29.099783287505666
            ],
            [
              -52.220603084534574,
              -29.09752179785466
            ],
            [
              -52.21228161189836,
              -29.094606988971144
            ],
            [
              -52.212019930368925,
              -29.095612095482704
            ],
            [
              -52.210397504886394,
              -29.095813116785013
            ],
            [
              -52.20840872526264,
              -29.094606988971144
            ],
            [
              -52.2064199456389,
              -29.094104435715366
            ],
            [
              -52.204692847544585,
              -29.09430545701768
            ],
            [
              -52.20160500549719,
              -29.095109542226925
            ],
            [
              -52.19799380039091,
              -29.094908520924612
            ],
            [
              -52.19590034815539,
              -29.095913627436172
            ],
            [
              -52.19668539274371,
              -29.09732077655235
            ],
            [
              -52.20218070486196,
              -29.099381244901043
            ],
            [
              -52.203907802956266,
              -29.100486862063757
            ],
            [
              -52.20401247556804,
              -29.105110352016922
            ],
            [
              -52.20579190996824,
              -29.10877899078411
            ],
            [
              -52.20652461825067,
              -29.11088971445838
            ],
            [
              -52.20589658258002,
              -29.112196352923405
            ],
            [
              -52.20139566027364,
              -29.109985118597976
            ],
            [
              -52.19909286281456,
              -29.11088971445838
            ],
            [
              -52.19767978255558,
              -29.113804523341898
            ],
            [
              -52.195115303567064,
              -29.11681984287657
            ],
            [
              -52.19412091375519,
              -29.115412693760387
            ],
            [
              -52.19380689591986,
              -29.112799416830338
            ],
            [
              -52.19192278890789,
              -29.110286650551444
            ],
            [
              -52.188311583801614,
              -29.110487671853758
            ],
            [
              -52.18789289335451,
              -29.10867848013295
            ],
            [
              -52.183287298436355,
              -29.10827643752833
            ],
            [
              -52.17967609333007,
              -29.10772362894697
            ],
            [
              -52.177006941729786,
              -29.107020054388883
            ],
            [
              -52.17439012643538,
              -29.10752260764466
            ],
            [
              -52.171092939164424,
              -29.105009841365767
            ],
            [
              -52.17020322196433,
              -29.10279860704034
            ],
            [
              -52.16831911495236,
              -29.100788394017226
            ],
            [
              -52.16800509711703,
              -29.099280734249888
            ],
            [
              -52.168214442340584,
              -29.096717712645418
            ],
            [
              -52.167900424505255,
              -29.091993712041095
            ],
            [
              -52.1654929544344,
              -29.08877737120411
            ],
            [
              -52.16078268690447,
              -29.0885763499018
            ],
            [
              -52.15162383337405,
              -29.087822520018133
            ],
            [
              -52.14947804483264,
              -29.086013328297327
            ],
            [
              -52.146599548008794,
              -29.085108732436925
            ],
            [
              -52.14408740532617,
              -29.086515881553105
            ],
            [
              -52.14199395309064,
              -29.086817413506573
            ],
            [
              -52.13812106645492,
              -29.08832507327391
            ],
            [
              -52.13681265880772,
              -29.088224562622756
            ],
            [
              -52.1347192065722,
              -29.086616392204263
            ],
            [
              -52.13320145370144,
              -29.08641537090195
            ],
            [
              -52.132521081724896,
              -29.084907711134615
            ],
            [
              -52.130898656242366,
              -29.08591281764617
            ],
            [
              -52.12791548680674,
              -29.084405157878834
            ],
            [
              -52.12508932628879,
              -29.087219456111196
            ],
            [
              -52.12608371610066,
              -29.08927992445989
            ],
            [
              -52.12498465367701,
              -29.08978247771567
            ],
            [
              -52.124094936476915,
              -29.092697286599186
            ],
            [
              -52.12200148424139,
              -29.093199839854964
            ],
            [
              -52.11959401417054,
              -29.09541107418039
            ],
            [
              -52.11818093391155,
              -29.095009031575767
            ],
            [
              -52.11650617212314,
              -29.096014138087327
            ],
            [
              -52.111900577204985,
              -29.09661720199426
            ],
            [
              -52.10928376191058,
              -29.09752179785466
            ],
            [
              -52.10839404471048,
              -29.09571260613386
            ],
            [
              -52.10650993769851,
              -29.095310563529235
            ],
            [
              -52.10562022049841,
              -29.097220265901196
            ],
            [
              -52.105724893110185,
              -29.098124861761598
            ],
            [
              -52.10190434278036,
              -29.100989415319535
            ],
            [
              -52.097612765697534,
              -29.102698096389183
            ],
            [
              -52.09530996823845,
              -29.1047083094123
            ],
            [
              -52.09368754275592,
              -29.105210862668077
            ],
            [
              -52.09368754275592,
              -29.10681903308657
            ],
            [
              -52.09222212619106,
              -29.10631647983079
            ],
            [
              -52.089814656120204,
              -29.108175926877173
            ],
            [
              -52.08929129306132,
              -29.08691792415773
            ],
            [
              -52.07809132360127,
              -29.090285030971447
            ],
            [
              -52.07809132360127,
              -29.09279779725034
            ],
            [
              -52.05731381016369,
              -29.092697286599186
            ],
            [
              -52.05830819997557,
              -29.058774941834116
            ],
            [
              -52.057209137551915,
              -29.059478516392208
            ],
            [
              -52.05469699486929,
              -29.05937800574105
            ],
            [
              -52.05391195028097,
              -29.06058413355492
            ],
            [
              -52.05249887002199,
              -29.060785154857232
            ],
            [
              -52.051713825433666,
              -29.059277495089894
            ],
            [
              -52.049620373198145,
              -29.05792060129929
            ],
            [
              -52.04778860249206,
              -29.057418048043512
            ],
            [
              -52.046009168091864,
              -29.05771957999698
            ],
            [
              -52.04867831969216,
              -29.020580894394925
            ],
            [
              -52.04721290312729,
              -29.01977680918568
            ],
            [
              -52.04721290312729,
              -29.018721447348543
            ],
            [
              -52.04480543305644,
              -29.017716340836987
            ],
            [
              -52.041298900561934,
              -29.017917362139297
            ],
            [
              -52.039414793549966,
              -29.01957578788337
            ],
            [
              -52.03868208526753,
              -29.022088554162263
            ],
            [
              -52.03648396042023,
              -29.02429978848769
            ],
            [
              -52.03637928780845,
              -29.02641051216196
            ],
            [
              -52.035175552773026,
              -29.028722257138543
            ],
            [
              -52.03449518079648,
              -29.03420008762653
            ],
            [
              -52.033396118372835,
              -29.03490366218462
            ],
            [
              -52.03067463046665,
              -29.034803151533467
            ],
            [
              -52.029994258490106,
              -29.03520519413809
            ],
            [
              -52.03009893110188,
              -29.037114896510047
            ],
            [
              -52.02931388651356,
              -29.03781847106814
            ],
            [
              -52.02549333618373,
              -29.03731591781236
            ],
            [
              -52.02408025592475,
              -29.038421534975072
            ],
            [
              -52.02261483935988,
              -29.038120003021607
            ],
            [
              -52.02109708648913,
              -29.03967791811452
            ],
            [
              -52.00591955778158,
              -29.039376386161052
            ],
            [
              -51.97001685194234,
              -29.039125109533163
            ],
            [
              -51.969284143659905,
              -29.040582513974922
            ],
            [
              -51.96970283410701,
              -29.042391705695728
            ],
            [
              -51.96771405448327,
              -29.042391705695728
            ],
            [
              -51.96708601881261,
              -29.04319579090497
            ],
            [
              -51.96708601881261,
              -29.047316727602357
            ],
            [
              -51.96771405448327,
              -29.04897515334643
            ],
            [
              -51.96729536403616,
              -29.049779238555676
            ],
            [
              -51.96499256657708,
              -29.0510858770207
            ],
            [
              -51.96562060224774,
              -29.05369915395075
            ],
            [
              -51.96389350415343,
              -29.056412941531956
            ],
            [
              -51.96237575128268,
              -29.057820090648136
            ],
            [
              -51.96028229904715,
              -29.061790261368788
            ],
            [
              -51.95578137674078,
              -29.063297921136126
            ],
            [
              -51.95531034998778,
              -29.067820900438136
            ],
            [
              -51.954682314317125,
              -29.069278304879894
            ],
            [
              -51.952588862081605,
              -29.070986985949542
            ],
            [
              -51.952588862081605,
              -29.072092603112253
            ],
            [
              -51.95531034998778,
              -29.073399241577278
            ],
            [
              -51.954682314317125,
              -29.07480639069346
            ],
            [
              -51.92589734607867,
              -29.074906901344615
            ],
            [
              -51.926316036525776,
              -29.06842396434507
            ],
            [
              -51.9235945486196,
              -29.065609666112707
            ],
            [
              -51.91768054605424,
              -29.062292814624566
            ],
            [
              -51.91668615624236,
              -29.059981069647986
            ],
            [
              -51.91768054605424,
              -29.057619069345826
            ],
            [
              -51.91778521866602,
              -29.049477706602207
            ],
            [
              -51.913493641583194,
              -29.04229119504457
            ],
            [
              -51.91328429635964,
              -29.041688131137636
            ],
            [
              -51.917523537136574,
              -29.034099576975375
            ],
            [
              -51.917994563889565,
              -29.031184768091858
            ],
            [
              -51.917889891277795,
              -29.02852123583623
            ],
            [
              -51.91888428108967,
              -29.025304894999245
            ],
            [
              -51.918308581724894,
              -29.02289263937151
            ],
            [
              -51.87879467077938,
              -29.01922400060432
            ],
            [
              -51.87921336122648,
              -29.017012766278896
            ],
            [
              -51.86879843635475,
              -29.01741480888352
            ],
            [
              -51.8685890911312,
              -29.020178851790302
            ],
            [
              -51.852312500000004,
              -29.016811744976586
            ],
            [
              -51.85000970254092,
              -29.018721447348543
            ],
            [
              -51.85157979171757,
              -29.025807448255026
            ],
            [
              -51.81410699670169,
              -29.0145
            ],
            [
              -51.80531449731249,
              -29.045708557183865
            ],
            [
              -51.80897803872465,
              -29.064303027647682
            ],
            [
              -51.80358739921818,
              -29.065408644810397
            ],
            [
              -51.80840233935989,
              -29.08169137029763
            ],
            [
              -51.779617371121425,
              -29.094204946366524
            ],
            [
              -51.758525839848524,
              -29.103703202900743
            ],
            [
              -51.755123979965795,
              -29.108376948179487
            ],
            [
              -51.75219314683606,
              -29.11440758724883
            ],
            [
              -51.74701185255314,
              -29.1147091192023
            ],
            [
              -51.74219691241144,
              -29.11867928992295
            ],
            [
              -51.73900439775226,
              -29.118779800574107
            ],
            [
              -51.73570721048131,
              -29.122599205318025
            ],
            [
              -51.73439880283411,
              -29.125413503550387
            ],
            [
              -51.732096005375034,
              -29.128981631666417
            ],
            [
              -51.733090395186906,
              -29.13028827013144
            ],
            [
              -51.73591655570486,
              -29.13290154706149
            ],
            [
              -51.73722496335206,
              -29.13601737724732
            ],
            [
              -51.73910907036404,
              -29.136821462456567
            ],
            [
              -51.73931841558759,
              -29.137876824293702
            ],
            [
              -51.74868661434156,
              -29.13672095180541
            ],
            [
              -51.75339688187149,
              -29.136821462456567
            ],
            [
              -51.75638005130711,
              -29.13888193080526
            ],
            [
              -51.75648472391889,
              -29.140691122526064
            ],
            [
              -51.74680250732959,
              -29.165014700105758
            ],
            [
              -51.7383763620816,
              -29.172000190361082
            ],
            [
              -51.73382310346934,
              -29.17777955280254
            ],
            [
              -51.73350908563401,
              -29.180493340383745
            ],
            [
              -51.735811883093085,
              -29.18370968122073
            ],
            [
              -51.74010346017591,
              -29.186423468801934
            ],
            [
              -51.754286599071584,
              -29.186624490104247
            ],
            [
              -51.75800247678964,
              -29.185217340988068
            ],
            [
              -51.75679874175422,
              -29.188383426499474
            ],
            [
              -51.75690341436599,
              -29.192604873848016
            ],
            [
              -51.755123979965795,
              -29.194414065568818
            ],
            [
              -51.75418192645981,
              -29.198283725638316
            ],
            [
              -51.75250716467139,
              -29.199188321498717
            ],
            [
              -51.75208847422429,
              -29.20391232210304
            ],
            [
              -51.74999502198876,
              -29.208083514126002
            ],
            [
              -51.74889595956511,
              -29.21049576975374
            ],
            [
              -51.74999502198876,
              -29.21170189756761
            ],
            [
              -51.74690717994137,
              -29.21552130231153
            ],
            [
              -51.74748287930613,
              -29.21888840912525
            ],
            [
              -51.750413712435865,
              -29.21768228131138
            ],
            [
              -51.755490334107016,
              -29.218687387822936
            ],
            [
              -51.75601369716589,
              -29.221803218008766
            ],
            [
              -51.75198380161251,
              -29.221702707357608
            ],
            [
              -51.75282118250672,
              -29.224617516241125
            ],
            [
              -51.754286599071584,
              -29.22451700558997
            ],
            [
              -51.754809962130466,
              -29.26060032935489
            ],
            [
              -51.7652248870022,
              -29.260399308052577
            ],
            [
              -51.76758002076716,
              -29.25869062698293
            ],
            [
              -51.768417401661374,
              -29.257585009820218
            ],
            [
              -51.76820805643782,
              -29.255021988215745
            ],
            [
              -51.77160991632055,
              -29.254720456262277
            ],
            [
              -51.77511644881505,
              -29.25271024323916
            ],
            [
              -51.775587475568045,
              -29.260198286750267
            ],
            [
              -51.80149394698265,
              -29.259796244145644
            ],
            [
              -51.796993024676276,
              -29.299397440701014
            ],
            [
              -51.779983725262646,
              -29.298894887445236
            ],
            [
              -51.776895883215246,
              -29.299095908747546
            ],
            [
              -51.76161368189592,
              -29.295276504003628
            ],
            [
              -51.754809962130466,
              -29.300302036561416
            ],
            [
              -51.750780066577086,
              -29.300905100468352
            ],
            [
              -51.75229781944784,
              -29.303317356096088
            ],
            [
              -51.75282118250672,
              -29.306684462909807
            ],
            [
              -51.74920997740044,
              -29.305578845747092
            ],
            [
              -51.74350532005864,
              -29.3091972291887
            ],
            [
              -51.741202522599565,
              -29.306885484212117
            ],
            [
              -51.73801000794039,
              -29.30779008007252
            ],
            [
              -51.737120290740286,
              -29.30728752681674
            ],
            [
              -51.73659692768141,
              -29.304875271189005
            ],
            [
              -51.738585707305155,
              -29.299899993956792
            ],
            [
              -51.73492216589299,
              -29.2973872276779
            ],
            [
              -51.73429413022233,
              -29.29718620637559
            ],
            [
              -51.729793207915954,
              -29.300804589817194
            ],
            [
              -51.726496020645,
              -29.30160867502644
            ],
            [
              -51.725082940386024,
              -29.299095908747546
            ],
            [
              -51.72539695822135,
              -29.294623184771115
            ],
            [
              -51.71320259894943,
              -29.29452267411996
            ],
            [
              -51.71529605118495,
              -29.296985185073275
            ],
            [
              -51.71320259894943,
              -29.30381990935187
            ],
            [
              -51.7115801734669,
              -29.304221951956492
            ],
            [
              -51.7098007390667,
              -29.30160867502644
            ],
            [
              -51.70608486134864,
              -29.304422973258802
            ],
            [
              -51.70090356706572,
              -29.304322462607647
            ],
            [
              -51.703520382360125,
              -29.30497578184016
            ],
            [
              -51.70618953396042,
              -29.30758905877021
            ],
            [
              -51.708911021866605,
              -29.308393143979455
            ],
            [
              -51.70912036709016,
              -29.312614591327996
            ],
            [
              -51.71398764353775,
              -29.313619697839556
            ],
            [
              -51.71670913144393,
              -29.313117144583774
            ],
            [
              -51.72372219643294,
              -29.313820719141866
            ],
            [
              -51.72890349071586,
              -29.316182719444026
            ],
            [
              -51.729008163327634,
              -29.324876890769
            ],
            [
              -51.72681003848033,
              -29.324977401420156
            ],
            [
              -51.72340817859761,
              -29.322514890466838
            ],
            [
              -51.720425009161985,
              -29.32392203958302
            ],
            [
              -51.71901192890301,
              -29.323519996978398
            ],
            [
              -51.71670913144393,
              -29.32090672004835
            ],
            [
              -51.71472035182018,
              -29.323620507629553
            ],
            [
              -51.711004474102126,
              -29.3244245928388
            ],
            [
              -51.70870167664305,
              -29.324525103489954
            ],
            [
              -51.70608486134864,
              -29.32321846502493
            ],
            [
              -51.70069422184217,
              -29.32301744372262
            ],
            [
              -51.70179328426582,
              -29.32422357153649
            ],
            [
              -51.701897956877595,
              -29.33437514730322
            ],
            [
              -51.729008163327634,
              -29.33412387067533
            ],
            [
              -51.72932218116296,
              -29.339400679861008
            ],
            [
              -51.727909100903986,
              -29.362216597673367
            ],
            [
              -51.72749041045688,
              -29.369403109231005
            ],
            [
              -51.69111667786465,
              -29.371413322254117
            ],
            [
              -51.691221350476425,
              -29.4150852001813
            ],
            [
              -51.691221350476425,
              -29.423477839552802
            ],
            [
              -51.691378359394086,
              -29.443479459132803
            ],
            [
              -51.691378359394086,
              -29.45659609910863
            ],
            [
              -51.690907332641096,
              -29.470717845596013
            ],
            [
              -51.67049617334474,
              -29.470818356247168
            ],
            [
              -51.66939711092109,
              -29.480919676688323
            ],
            [
              -51.66808870327388,
              -29.487503124339025
            ],
            [
              -51.690383969582214,
              -29.487804656292493
            ],
            [
              -51.69080266002932,
              -29.500820785617165
            ],
            [
              -51.66500086122649,
              -29.500820785617165
            ],
            [
              -51.66432048924994,
              -29.5327831726847
            ],
            [
              -51.66337843574395,
              -29.581480583169665
            ],
            [
              -51.66212236440264,
              -29.588817860704037
            ],
            [
              -51.66269806376741,
              -29.59012449916906
            ],
            [
              -51.66180834656731,
              -29.59268752077353
            ],
            [
              -51.656993406425606,
              -29.595401308354738
            ],
            [
              -51.65249248411923,
              -29.600376585586947
            ],
            [
              -51.652597156731005,
              -29.604598032935492
            ],
            [
              -51.647101844612756,
              -29.612287097748908
            ],
            [
              -51.64841025225996,
              -29.61429731077202
            ],
            [
              -51.64762520767164,
              -29.615905481190513
            ],
            [
              -51.645793436965555,
              -29.61650854509745
            ],
            [
              -51.64458970193012,
              -29.620478715818102
            ],
            [
              -51.644485029318346,
              -29.62339352470162
            ],
            [
              -51.64218223185927,
              -29.626308333585136
            ],
            [
              -51.6381,
              -29.628921610515185
            ],
            [
              -51.64008877962375,
              -29.6313841214685
            ],
            [
              -51.63972242548253,
              -29.633394334491616
            ],
            [
              -51.64082148790618,
              -29.63500250491011
            ],
            [
              -51.641920550329836,
              -29.635806590119355
            ],
            [
              -51.64500839237723,
              -29.63781680314247
            ],
            [
              -51.64851492487173,
              -29.638721399002872
            ],
            [
              -51.650503704495485,
              -29.640982888653877
            ],
            [
              -51.65060837710726,
              -29.642490548421215
            ],
            [
              -51.655999016613734,
              -29.643194122979303
            ],
            [
              -51.657778451013925,
              -29.644601272095485
            ],
            [
              -51.65882517713169,
              -29.644400250793172
            ],
            [
              -51.65961022172001,
              -29.645505867955887
            ],
            [
              -51.6622793733203,
              -29.646008421211665
            ],
            [
              -51.66301208160274,
              -29.649978591932317
            ],
            [
              -51.66468684339116,
              -29.6513857410485
            ],
            [
              -51.66552422428536,
              -29.653295443420458
            ],
            [
              -51.67039150073296,
              -29.654401060583172
            ],
            [
              -51.673008316027364,
              -29.653194932769303
            ],
            [
              -51.67442139628634,
              -29.655305656443574
            ],
            [
              -51.67588681285121,
              -29.654602081885482
            ],
            [
              -51.67949801795749,
              -29.655305656443574
            ],
            [
              -51.68012605362814,
              -29.656712805559753
            ],
            [
              -51.68190548802834,
              -29.657818422722467
            ],
            [
              -51.681486797581236,
              -29.65967786976885
            ],
            [
              -51.68551669313462,
              -29.660783486931564
            ],
            [
              -51.68588304727584,
              -29.662592678652366
            ],
            [
              -51.685202675299294,
              -29.666713615349753
            ],
            [
              -51.68672042817005,
              -29.666814126000908
            ],
            [
              -51.68839518995847,
              -29.668120764465932
            ],
            [
              -51.6913260230882,
              -29.668321785768246
            ],
            [
              -51.691378359394086,
              -29.667517700559
            ],
            [
              -51.69341947532372,
              -29.667115657954376
            ],
            [
              -51.69467554666504,
              -29.669779190210004
            ],
            [
              -51.69619329953579,
              -29.67168889258196
            ],
            [
              -51.69629797214757,
              -29.674302169512014
            ],
            [
              -51.69551292755925,
              -29.68028255325578
            ],
            [
              -51.69692600781823,
              -29.681388170418494
            ],
            [
              -51.69692600781823,
              -29.68359940474392
            ],
            [
              -51.70048487661862,
              -29.68571012841819
            ],
            [
              -51.7032063645248,
              -29.68621268167397
            ],
            [
              -51.70472411739556,
              -29.687720341441306
            ],
            [
              -51.7032063645248,
              -29.688524426650552
            ],
            [
              -51.703520382360125,
              -29.694203278440853
            ],
            [
              -51.70529981676032,
              -29.694002257138543
            ],
            [
              -51.70770728683117,
              -29.695308895603567
            ],
            [
              -51.70948672123137,
              -29.700887236742712
            ],
            [
              -51.7111091467139,
              -29.699580598277688
            ],
            [
              -51.71309792633765,
              -29.70138978999849
            ],
            [
              -51.71670913144393,
              -29.70229438585889
            ],
            [
              -51.716813804055704,
              -29.704103577579698
            ],
            [
              -51.718122211702905,
              -29.70470664148663
            ],
            [
              -51.7207913633032,
              -29.708124003625926
            ],
            [
              -51.72068669069142,
              -29.713300302160448
            ],
            [
              -51.72220444356218,
              -29.713601834113916
            ],
            [
              -51.72419322318593,
              -29.715712557788187
            ],
            [
              -51.72241378878573,
              -29.719883749811153
            ],
            [
              -51.719116601514784,
              -29.723401622601603
            ],
            [
              -51.720425009161985,
              -29.725009793020096
            ],
            [
              -51.71969230087955,
              -29.72661796343859
            ],
            [
              -51.72058201807965,
              -29.72958302764768
            ],
            [
              -51.72032033655021,
              -29.73179426197311
            ],
            [
              -51.71827922062057,
              -29.733603453693913
            ],
            [
              -51.71869791106768,
              -29.742800178274667
            ],
            [
              -51.72199509833863,
              -29.745916008460494
            ],
            [
              -51.72858947288053,
              -29.749283115274213
            ],
            [
              -51.73162497862204,
              -29.753504562622755
            ],
            [
              -51.73638758245786,
              -29.756519882157427
            ],
            [
              -51.73738197226973,
              -29.75807779725034
            ],
            [
              -51.737277299657954,
              -29.7599874996223
            ],
            [
              -51.73978944234058,
              -29.76139464873848
            ],
            [
              -51.73989411495236,
              -29.76350537241275
            ],
            [
              -51.74350532005864,
              -29.765616096087022
            ],
            [
              -51.74711652516492,
              -29.76948575615652
            ],
            [
              -51.74900063217689,
              -29.773506182202752
            ],
            [
              -51.748791286953335,
              -29.776320480435114
            ],
            [
              -51.747221197776696,
              -29.777878395528028
            ],
            [
              -51.747221197776696,
              -29.77948656594652
            ],
            [
              -51.75051838504764,
              -29.78300443873697
            ],
            [
              -51.75088473918886,
              -29.785014651760086
            ],
            [
              -51.75371089970682,
              -29.788884311829584
            ],
            [
              -51.75768845895431,
              -29.79210065266657
            ],
            [
              -51.758211822013195,
              -29.79370882308506
            ],
            [
              -51.75768845895431,
              -29.79632210001511
            ],
            [
              -51.75878752137796,
              -29.799287164224204
            ],
            [
              -51.75611836977767,
              -29.803006058316967
            ],
            [
              -51.75669406914244,
              -29.80908695271189
            ],
            [
              -51.755490334107016,
              -29.813006868106967
            ],
            [
              -51.75831649462497,
              -29.816876528176465
            ],
            [
              -51.75831649462497,
              -29.818786230548422
            ],
            [
              -51.75407725384803,
              -29.82260563529234
            ],
            [
              -51.7516174474713,
              -29.823208699199277
            ],
            [
              -51.74931465001222,
              -29.825419933524703
            ],
            [
              -51.74931465001222,
              -29.829189082943046
            ],
            [
              -51.748320260200344,
              -29.83069674271038
            ],
            [
              -51.74549409968238,
              -29.832405423780028
            ],
            [
              -51.744918400317616,
              -29.8345161474543
            ],
            [
              -51.74162121304666,
              -29.8345161474543
            ],
            [
              -51.73879505252871,
              -29.83310899833812
            ],
            [
              -51.73722496335206,
              -29.835521253965858
            ],
            [
              -51.73021189836306,
              -29.835320232663545
            ],
            [
              -51.72968853530418,
              -29.840496531198067
            ],
            [
              -51.731781987539705,
              -29.84471797854661
            ],
            [
              -51.72890349071586,
              -29.848085085360328
            ],
            [
              -51.720110991326656,
              -29.851904490104246
            ],
            [
              -51.716185768385046,
              -29.858085895150328
            ],
            [
              -51.7163951136086,
              -29.860699172080377
            ],
            [
              -51.733980112387,
              -29.85351266052274
            ],
            [
              -51.74151654043489,
              -29.8520050007554
            ],
            [
              -51.748006242365015,
              -29.8520050007554
            ],
            [
              -51.76977814561447,
              -29.861704278591933
            ],
            [
              -51.78181549596873,
              -29.860297129475754
            ],
            [
              -51.8012846017591,
              -29.86250836380118
            ],
            [
              -51.81552007696067,
              -29.861804789243088
            ],
            [
              -51.82431257634987,
              -29.84728100015108
            ],
            [
              -51.82771443623259,
              -29.83858682882611
            ],
            [
              -51.834308810774495,
              -29.829993168152292
            ],
            [
              -51.840798512704616,
              -29.82381176310621
            ],
            [
              -51.85618538663572,
              -29.8192887838042
            ],
            [
              -51.8619947165893,
              -29.818886741199577
            ],
            [
              -51.87141525164916,
              -29.815921676990484
            ],
            [
              -51.8751834656731,
              -29.813710442665055
            ],
            [
              -51.880888123014905,
              -29.80918746336305
            ],
            [
              -51.884289982897634,
              -29.805116781991238
            ],
            [
              -51.886383435133155,
              -29.804011164828527
            ],
            [
              -51.89371051795749,
              -29.80441320743315
            ],
            [
              -51.89737405936965,
              -29.807378271642243
            ],
            [
              -51.89810676765209,
              -29.808986442060736
            ],
            [
              -51.904387124358664,
              -29.81149920833963
            ],
            [
              -51.90789365685316,
              -29.811901250944253
            ],
            [
              -51.910876826288785,
              -29.81119767638616
            ],
            [
              -51.91401700464207,
              -29.808383378153803
            ],
            [
              -51.91647681101881,
              -29.803106568968122
            ],
            [
              -51.92040203396042,
              -29.79250269527119
            ],
            [
              -51.92097773332519,
              -29.788281247922647
            ],
            [
              -51.920611379183974,
              -29.78561771566702
            ],
            [
              -51.91877960847789,
              -29.783406481341594
            ],
            [
              -51.910091781700466,
              -29.776722523039737
            ],
            [
              -51.90789365685316,
              -29.774209756760843
            ],
            [
              -51.907317957488395,
              -29.770993415923858
            ],
            [
              -51.90799832946494,
              -29.768782181598432
            ],
            [
              -51.91030112692402,
              -29.766621202598582
            ],
            [
              -51.92511230149035,
              -29.761093116785016
            ],
            [
              -51.93997581236257,
              -29.760088010273456
            ],
            [
              -51.943011318104084,
              -29.758580350506122
            ],
            [
              -51.94960569264598,
              -29.759484946366523
            ],
            [
              -51.95531034998778,
              -29.765515585435868
            ],
            [
              -51.957299129611535,
              -29.76571660673818
            ],
            [
              -51.961015007329586,
              -29.764309457621998
            ],
            [
              -51.96190472452969,
              -29.763304351110442
            ],
            [
              -51.96180005191791,
              -29.760791584831548
            ],
            [
              -51.9591832366235,
              -29.758278818552654
            ],
            [
              -51.95818884681163,
              -29.75571579694818
            ],
            [
              -51.959392581847055,
              -29.748378519413812
            ],
            [
              -51.95839819203518,
              -29.744508859344315
            ],
            [
              -51.95960192707061,
              -29.73988536939115
            ],
            [
              -51.96148603408258,
              -29.738076177670344
            ],
            [
              -51.961015007329586,
              -29.736015709321652
            ],
            [
              -51.96221874236501,
              -29.734709070856628
            ],
            [
              -51.96781872709504,
              -29.73320141108929
            ],
            [
              -51.96907479843635,
              -29.73390498564738
            ],
            [
              -51.970592551307114,
              -29.73651826257743
            ],
            [
              -51.972686003542634,
              -29.736719283879744
            ],
            [
              -51.976297208648916,
              -29.733804474996226
            ],
            [
              -51.98461868128512,
              -29.730688644810396
            ],
            [
              -51.98508970803812,
              -29.727422048647835
            ],
            [
              -51.98629344307354,
              -29.72631643148512
            ],
            [
              -51.997179394698264,
              -29.72511030367125
            ],
            [
              -52.001418635475204,
              -29.723602643903916
            ],
            [
              -52.003826105546054,
              -29.720989366973864
            ],
            [
              -52.0053961947227,
              -29.7168181749509
            ],
            [
              -52.004820495357926,
              -29.71350132346276
            ],
            [
              -52.00277937942829,
              -29.70897834416075
            ],
            [
              -52.004192459687275,
              -29.707219407765525
            ],
            [
              -52.00701862020523,
              -29.705510726695877
            ],
            [
              -52.00879805460542,
              -29.706013279951655
            ],
            [
              -52.014084021500125,
              -29.709380386765375
            ],
            [
              -52.0198933514537,
              -29.70917936546306
            ],
            [
              -52.027377443195704,
              -29.70611379060281
            ],
            [
              -52.030308276325435,
              -29.70289744976583
            ],
            [
              -52.036117606279014,
              -29.70239489651005
            ],
            [
              -52.037426013926215,
              -29.70380204562623
            ],
            [
              -52.03878675787931,
              -29.707219407765525
            ],
            [
              -52.04040918336184,
              -29.708224514277084
            ],
            [
              -52.04108955533838,
              -29.710486003928086
            ],
            [
              -52.04349702540924,
              -29.711491110439646
            ],
            [
              -52.04470076044466,
              -29.711089067835022
            ],
            [
              -52.046009168091864,
              -29.712898259555825
            ],
            [
              -52.04689888529196,
              -29.719079664601907
            ],
            [
              -52.04988205472758,
              -29.7215924308808
            ],
            [
              -52.051713825433666,
              -29.72179345218311
            ],
            [
              -52.052708215245545,
              -29.724004686508536
            ],
            [
              -52.05668577449304,
              -29.72390417585738
            ],
            [
              -52.05799418214024,
              -29.72631643148512
            ],
            [
              -52.06448388407036,
              -29.725009793020096
            ],
            [
              -52.065321264964574,
              -29.72420570781085
            ],
            [
              -52.06678668152944,
              -29.724607750415473
            ],
            [
              -52.07008386880039,
              -29.72279855869467
            ],
            [
              -52.082696918519424,
              -29.719883749811153
            ],
            [
              -52.094210905814805,
              -29.72269804804351
            ],
            [
              -52.097298747862204,
              -29.72299957999698
            ],
            [
              -52.0990781822624,
              -29.722195494787734
            ],
            [
              -52.10028191729783,
              -29.72370315455507
            ],
            [
              -52.10237536953335,
              -29.723602643903916
            ],
            [
              -52.10342209565111,
              -29.724708261066628
            ],
            [
              -52.11148188675788,
              -29.72390417585738
            ],
            [
              -52.113889356828736,
              -29.724708261066628
            ],
            [
              -52.118390279135106,
              -29.72299957999698
            ],
            [
              -52.12037905875886,
              -29.723803665206226
            ],
            [
              -52.122106156853164,
              -29.72561285692703
            ],
            [
              -52.125874370877106,
              -29.72611541018281
            ],
            [
              -52.135922941607625,
              -29.73410600694969
            ],
            [
              -52.137702376007816,
              -29.73867924157728
            ],
            [
              -52.13628929574884,
              -29.74888107266959
            ],
            [
              -52.13702200403127,
              -29.75008720048346
            ],
            [
              -52.141889280478864,
              -29.753203030669287
            ],
            [
              -52.148902345467874,
              -29.753906605227378
            ],
            [
              -52.154397657586124,
              -29.755816307599336
            ],
            [
              -52.16271913022233,
              -29.761093116785016
            ],
            [
              -52.1676910792817,
              -29.760892095482703
            ],
            [
              -52.17789665892988,
              -29.766520691947427
            ],
            [
              -52.17930973918886,
              -29.767978096389186
            ],
            [
              -52.18559009589543,
              -29.757575243994562
            ],
            [
              -52.20401247556804,
              -29.76501303218009
            ],
            [
              -52.20359378512094,
              -29.766018138691646
            ],
            [
              -52.20521621060347,
              -29.76978728810999
            ],
            [
              -52.20720499022722,
              -29.77049086266808
            ],
            [
              -52.21369469215734,
              -29.76928473485421
            ],
            [
              -52.216416180063526,
              -29.769586266807675
            ],
            [
              -52.232588098582944,
              -29.77541588457471
            ],
            [
              -52.22829652150012,
              -29.784110055899685
            ],
            [
              -52.222225510017104,
              -29.785215673062396
            ],
            [
              -52.21259562973369,
              -29.789788907689985
            ],
            [
              -52.211182549474714,
              -29.791497588759633
            ],
            [
              -52.21018815966284,
              -29.796121078712797
            ],
            [
              -52.20872274309797,
              -29.798583589666116
            ],
            [
              -52.20348911250916,
              -29.803508611572745
            ],
            [
              -52.20301808575617,
              -29.80582035654933
            ],
            [
              -52.20427415709749,
              -29.809589505967672
            ],
            [
              -52.18668915831908,
              -29.816323719595108
            ],
            [
              -52.18600878634253,
              -29.81959031575767
            ],
            [
              -52.18072281944784,
              -29.823007677896964
            ],
            [
              -52.17800133154166,
              -29.82667631666415
            ],
            [
              -52.177111614341555,
              -29.827078359268775
            ],
            [
              -52.17690226911801,
              -29.82959112554767
            ],
            [
              -52.17527984363547,
              -29.83260644508234
            ],
            [
              -52.17527984363547,
              -29.83491819005892
            ],
            [
              -52.1742854538236,
              -29.836576615802993
            ],
            [
              -52.174704144270706,
              -29.839893467291134
            ],
            [
              -52.17690226911801,
              -29.841300616407313
            ],
            [
              -52.1786817035182,
              -29.84099908445385
            ],
            [
              -52.18108917358906,
              -29.84190368031425
            ],
            [
              -52.18239758123626,
              -29.843913893337366
            ],
            [
              -52.18208356340093,
              -29.846778446895303
            ],
            [
              -52.18292094429514,
              -29.848889170569574
            ],
            [
              -52.18668915831908,
              -29.852708575313493
            ],
            [
              -52.18647981309553,
              -29.859091001661884
            ],
            [
              -52.18852092902517,
              -29.860799682731532
            ],
            [
              -52.18852092902517,
              -29.861804789243088
            ],
            [
              -52.184909723918885,
              -29.864217044870827
            ],
            [
              -52.18679383093086,
              -29.865724704638165
            ],
            [
              -52.18789289335451,
              -29.868488747544948
            ],
            [
              -52.18632280417786,
              -29.87039844991691
            ],
            [
              -52.18757887551918,
              -29.87220764163771
            ],
            [
              -52.18731719398974,
              -29.873112237498113
            ],
            [
              -52.18449103347178,
              -29.877383940172233
            ],
            [
              -52.18417701563645,
              -29.87939415319535
            ],
            [
              -52.18611345895431,
              -29.88411815379967
            ],
            [
              -52.18700317615441,
              -29.88502274966007
            ],
            [
              -52.190091018201805,
              -29.885676068892582
            ],
            [
              -52.19338820547276,
              -29.889696494938814
            ],
            [
              -52.19438259528463,
              -29.896782495845294
            ],
            [
              -52.192393815660886,
              -29.89929526212419
            ],
            [
              -52.195481657708285,
              -29.90401926272851
            ],
            [
              -52.19422558636697,
              -29.90849198670494
            ],
            [
              -52.19537698509651,
              -29.913718540565043
            ],
            [
              -52.19380689591986,
              -29.917487689983382
            ],
            [
              -52.19098073540191,
              -29.917487689983382
            ],
            [
              -52.19061438126069,
              -29.923317307750416
            ],
            [
              -52.18668915831908,
              -29.930302798005744
            ],
            [
              -52.185223741754214,
              -29.92939820214534
            ],
            [
              -52.179885438553626,
              -29.93341862819157
            ],
            [
              -52.175175171023696,
              -29.93251403233117
            ],
            [
              -52.172296674199856,
              -29.933318117540416
            ],
            [
              -52.16648734424628,
              -29.929297691494185
            ],
            [
              -52.160887359516245,
              -29.927589010424537
            ],
            [
              -52.156491109821644,
              -29.926885435866446
            ],
            [
              -52.15308924993892,
              -29.927488499773382
            ],
            [
              -52.14058087283166,
              -29.924824967517754
            ],
            [
              -52.128909876618614,
              -29.92708645716876
            ],
            [
              -52.121007094429515,
              -29.93160943647077
            ],
            [
              -52.11341833007574,
              -29.93251403233117
            ],
            [
              -52.11048749694601,
              -29.93462475600544
            ],
            [
              -52.10462583068654,
              -29.945580416981418
            ],
            [
              -52.10682395553384,
              -29.946786544795287
            ],
            [
              -52.11148188675788,
              -29.945178374376795
            ],
            [
              -52.126816424383094,
              -29.937589820214537
            ],
            [
              -52.13498088810164,
              -29.937187777609914
            ],
            [
              -52.13937713779624,
              -29.93939901193534
            ],
            [
              -52.14801262826777,
              -29.951510545399607
            ],
            [
              -52.147122911067676,
              -29.95437509895755
            ],
            [
              -52.14958271744442,
              -29.96000369542227
            ],
            [
              -52.14848365502077,
              -29.963722589515033
            ],
            [
              -52.150210753115076,
              -29.966084589817193
            ],
            [
              -52.15031542572685,
              -29.969602462607646
            ],
            [
              -52.152618223185925,
              -29.974376718537545
            ],
            [
              -52.15429298497435,
              -29.975984888956038
            ],
            [
              -52.15502569325678,
              -29.977291527421063
            ],
            [
              -52.15340326777425,
              -29.978196123281464
            ],
            [
              -52.15287990471537,
              -29.979502761746488
            ],
            [
              -52.152984577327146,
              -29.98231705997885
            ],
            [
              -52.15397896713902,
              -29.983623698443875
            ],
            [
              -52.15277523210359,
              -29.986990805257594
            ],
            [
              -52.15340326777425,
              -29.988900507629552
            ],
            [
              -52.15110047031517,
              -29.99372501888503
            ],
            [
              -52.15031542572685,
              -29.999504381326485
            ],
            [
              -52.14869300024432,
              -30.00302225411694
            ],
            [
              -52.150681779868066,
              -30.004278637256384
            ],
            [
              -52.15078645247984,
              -30.009304169814172
            ],
            [
              -52.14602384864403,
              -30.014580978999852
            ],
            [
              -52.1470182384559,
              -30.016993234627588
            ],
            [
              -52.146285530173465,
              -30.020310086115728
            ],
            [
              -52.149425708526756,
              -30.025184852696782
            ],
            [
              -52.15308924993892,
              -30.027094555068743
            ],
            [
              -52.15382195822136,
              -30.028501704184922
            ],
            [
              -52.153298595162475,
              -30.03242161958
            ],
            [
              -52.15042009833863,
              -30.038502513974922
            ],
            [
              -52.15340326777425,
              -30.0437793231606
            ],
            [
              -52.152304205350596,
              -30.05011149418341
            ],
            [
              -52.15251355057415,
              -30.05347860099713
            ],
            [
              -52.15387429452724,
              -30.05659443118296
            ],
            [
              -52.15528737478622,
              -30.057197495089895
            ],
            [
              -52.15591541045688,
              -30.05870515485723
            ],
            [
              -52.15591541045688,
              -30.061921495694214
            ],
            [
              -52.1597882970926,
              -30.062675325577885
            ],
            [
              -52.162823802834104,
              -30.06629370901949
            ],
            [
              -52.160887359516245,
              -30.07222383743768
            ],
            [
              -52.161881749328124,
              -30.073078177972505
            ],
            [
              -52.16162006779868,
              -30.074686348390998
            ],
            [
              -52.163818192645984,
              -30.0755909442514
            ],
            [
              -52.16502192768141,
              -30.07699809336758
            ],
            [
              -52.165911644881504,
              -30.08287796646019
            ],
            [
              -52.163818192645984,
              -30.08549124339024
            ],
            [
              -52.165911644881504,
              -30.089310648134163
            ],
            [
              -52.16622566271683,
              -30.093481840157125
            ],
            [
              -52.16339950219888,
              -30.09579358513371
            ],
            [
              -52.15858456205717,
              -30.10267856473788
            ],
            [
              -52.15999764231615,
              -30.105392352319083
            ],
            [
              -52.16439389201075,
              -30.106497969481797
            ],
            [
              -52.166277999022725,
              -30.108508182504913
            ],
            [
              -52.16648734424628,
              -30.11499111950446
            ],
            [
              -52.16570229965795,
              -30.116800311225262
            ],
            [
              -52.16941817737601,
              -30.120117162713402
            ],
            [
              -52.16889481431713,
              -30.122579673666717
            ],
            [
              -52.16957518629367,
              -30.125494482550234
            ],
            [
              -52.165597627046175,
              -30.130419504456867
            ],
            [
              -52.15779951746885,
              -30.13650039885179
            ],
            [
              -52.15738082702175,
              -30.139013165130685
            ],
            [
              -52.15240887796237,
              -30.146099166037168
            ],
            [
              -52.15308924993892,
              -30.148109379060283
            ],
            [
              -52.15110047031517,
              -30.152280571083246
            ],
            [
              -52.152618223185925,
              -30.155396401269076
            ],
            [
              -52.152618223185925,
              -30.157708146245657
            ],
            [
              -52.15162383337405,
              -30.159818869919928
            ],
            [
              -52.14801262826777,
              -30.1623818915244
            ],
            [
              -52.14869300024432,
              -30.164392104547517
            ],
            [
              -52.14811730087955,
              -30.167005381477566
            ],
            [
              -52.151780842291714,
              -30.16921661580299
            ],
            [
              -52.15162383337405,
              -30.17429240368636
            ],
            [
              -52.15219953273882,
              -30.176001084756006
            ],
            [
              -52.15382195822136,
              -30.177508744523344
            ],
            [
              -52.15921259772783,
              -30.180021510802238
            ],
            [
              -52.16099203212802,
              -30.1832881069648
            ],
            [
              -52.15811353530418,
              -30.190122831243393
            ],
            [
              -52.158793907280725,
              -30.191278703731683
            ],
            [
              -52.16209109455168,
              -30.196907300196408
            ],
            [
              -52.162876139139996,
              -30.19962108777761
            ],
            [
              -52.16099203212802,
              -30.20248564133555
            ],
            [
              -52.16141072257513,
              -30.204998407614443
            ],
            [
              -52.16067801429269,
              -30.205701982172535
            ],
            [
              -52.15748549963352,
              -30.20700862063756
            ],
            [
              -52.15429298497435,
              -30.210476238102434
            ],
            [
              -52.140005173466896,
              -30.213793089590574
            ],
            [
              -52.13597527791351,
              -30.21721045172987
            ],
            [
              -52.13702200403127,
              -30.22118062245052
            ],
            [
              -52.13628929574884,
              -30.227613304124493
            ],
            [
              -52.13859209320792,
              -30.229221474542985
            ],
            [
              -52.13848742059614,
              -30.23138245354283
            ],
            [
              -52.139010783655024,
              -30.232086028100923
            ],
            [
              -52.141104235890545,
              -30.232488070705546
            ],
            [
              -52.14539581297337,
              -30.236508496751778
            ],
            [
              -52.14649487539702,
              -30.240277646170117
            ],
            [
              -52.15188551490349,
              -30.24218734854208
            ],
            [
              -52.15199018751527,
              -30.246710327844088
            ],
            [
              -52.15612475568043,
              -30.24761492370449
            ],
            [
              -52.15942194295138,
              -30.250579987913582
            ],
            [
              -52.1588985798925,
              -30.254298882006346
            ],
            [
              -52.160102314927926,
              -30.25540449916906
            ],
            [
              -52.16439389201075,
              -30.254097860704036
            ],
            [
              -52.165597627046175,
              -30.254298882006346
            ],
            [
              -52.16648734424628,
              -30.25540449916906
            ],
            [
              -52.165283609210846,
              -30.258218797401423
            ],
            [
              -52.165597627046175,
              -30.259424925215292
            ],
            [
              -52.1641845467872,
              -30.261786925517452
            ],
            [
              -52.16570229965795,
              -30.26319407463363
            ],
            [
              -52.16502192768141,
              -30.26540530895906
            ],
            [
              -52.1663826716345,
              -30.271687224656294
            ],
            [
              -52.16601631749328,
              -30.274803054842124
            ],
            [
              -52.1676910792817,
              -30.275305608097902
            ],
            [
              -52.16920883215246,
              -30.273998969632878
            ],
            [
              -52.17041256718788,
              -30.273998969632878
            ],
            [
              -52.17292470987051,
              -30.27721531046986
            ],
            [
              -52.17601255191791,
              -30.275205097446747
            ],
            [
              -52.177111614341555,
              -30.276913778516395
            ],
            [
              -52.174704144270706,
              -30.280883949237047
            ],
            [
              -52.17329106401173,
              -30.28128599184167
            ],
            [
              -52.17067424871732,
              -30.28410029007403
            ],
            [
              -52.1729770461764,
              -30.28862326937604
            ],
            [
              -52.17182564744686,
              -30.291588333585135
            ],
            [
              -52.17041256718788,
              -30.292794461399005
            ],
            [
              -52.172610692035185,
              -30.295709270282522
            ],
            [
              -52.17140695699975,
              -30.29957893035202
            ],
            [
              -52.171092939164424,
              -30.3071172291887
            ],
            [
              -52.16941817737601,
              -30.308021825049103
            ],
            [
              -52.167220052528705,
              -30.306614675932924
            ],
            [
              -52.164812582457856,
              -30.306614675932924
            ],
            [
              -52.16449856462253,
              -30.309278208188548
            ],
            [
              -52.16732472514048,
              -30.31068535730473
            ],
            [
              -52.165597627046175,
              -30.313198123583625
            ],
            [
              -52.16271913022233,
              -30.313499655537093
            ],
            [
              -52.15868923466895,
              -30.31661548572292
            ],
            [
              -52.163190156975325,
              -30.322193826862065
            ],
            [
              -52.160102314927926,
              -30.32541016769905
            ],
            [
              -52.15868923466895,
              -30.325812210303674
            ],
            [
              -52.1580088626924,
              -30.33038544493126
            ],
            [
              -52.15350794038603,
              -30.333802807070555
            ],
            [
              -52.15350794038603,
              -30.3346068922798
            ],
            [
              -52.1602069875397,
              -30.337823233116787
            ],
            [
              -52.159317270339606,
              -30.339079616256235
            ],
            [
              -52.160102314927926,
              -30.341190339930506
            ],
            [
              -52.158479889445395,
              -30.342899021000154
            ],
            [
              -52.1588985798925,
              -30.345512297930203
            ],
            [
              -52.1619864219399,
              -30.34511025532558
            ],
            [
              -52.16407987417542,
              -30.346617915092917
            ],
            [
              -52.16360884742243,
              -30.350085532557788
            ],
            [
              -52.165597627046175,
              -30.35511106511558
            ],
            [
              -52.16659201685805,
              -30.360890427557035
            ],
            [
              -52.17198265636453,
              -30.36340319383593
            ],
            [
              -52.17098826655265,
              -30.37048919474241
            ],
            [
              -52.175018162106035,
              -30.376821365765224
            ],
            [
              -52.177111614341555,
              -30.37692187641638
            ],
            [
              -52.17800133154166,
              -30.378178259555824
            ],
            [
              -52.1786817035182,
              -30.384912473183263
            ],
            [
              -52.17978076594185,
              -30.386420132950597
            ],
            [
              -52.178891048741754,
              -30.389586218462004
            ],
            [
              -52.18030412900073,
              -30.39139541018281
            ],
            [
              -52.17951908441241,
              -30.392702048647834
            ],
            [
              -52.17800133154166,
              -30.392903069950144
            ],
            [
              -52.17878637612998,
              -30.396923495996376
            ],
            [
              -52.177006941729786,
              -30.39948651760085
            ],
            [
              -52.178577030906425,
              -30.401697751926275
            ],
            [
              -52.178577030906425,
              -30.403205411693612
            ],
            [
              -52.17669292389446,
              -30.404512050158637
            ],
            [
              -52.17439012643538,
              -30.408281199576976
            ],
            [
              -52.17538451624725,
              -30.41059294455356
            ],
            [
              -52.17512283471781,
              -30.4130052001813
            ],
            [
              -52.1755938614708,
              -30.413809285390546
            ],
            [
              -52.17360508184706,
              -30.42149835020396
            ],
            [
              -52.17020322196433,
              -30.42320703127361
            ],
            [
              -52.16889481431713,
              -30.426121840157126
            ],
            [
              -52.16392286525776,
              -30.429388436319687
            ],
            [
              -52.16271913022233,
              -30.434212947575165
            ],
            [
              -52.15868923466895,
              -30.442706097597824
            ],
            [
              -52.163818192645984,
              -30.444314268016317
            ],
            [
              -52.16941817737601,
              -30.442002523039736
            ],
            [
              -52.1720873289763,
              -30.44260558694667
            ],
            [
              -52.17732095956511,
              -30.445118353225563
            ],
            [
              -52.17899572135353,
              -30.446977800271945
            ],
            [
              -52.182188236012706,
              -30.44778188548119
            ],
            [
              -52.18391533410701,
              -30.449088523946216
            ],
            [
              -52.18548542328365,
              -30.448686481341593
            ],
            [
              -52.18810223857806,
              -30.445520395830187
            ],
            [
              -52.191713443684336,
              -30.445218863876722
            ],
            [
              -52.19422558636697,
              -30.446223970388278
            ],
            [
              -52.197889127779135,
              -30.446022949085965
            ],
            [
              -52.199825571096994,
              -30.44737984287657
            ],
            [
              -52.203384439897384,
              -30.44737984287657
            ],
            [
              -52.2064199456389,
              -30.445218863876722
            ],
            [
              -52.20851339787442,
              -30.44667626831848
            ],
            [
              -52.212804974957244,
              -30.44778188548119
            ],
            [
              -52.21908533166382,
              -30.446123459737123
            ],
            [
              -52.220603084534574,
              -30.445118353225563
            ],
            [
              -52.22290588199365,
              -30.44019333131893
            ],
            [
              -52.227877831053014,
              -30.43642418190059
            ],
            [
              -52.22892455717078,
              -30.436122649947123
            ],
            [
              -52.23201239921818,
              -30.437077501133103
            ],
            [
              -52.23389650623015,
              -30.436022139295968
            ],
            [
              -52.23478622343025,
              -30.43340886236592
            ],
            [
              -52.23290211641827,
              -30.42697618069195
            ],
            [
              -52.23578061324212,
              -30.42622235080828
            ],
            [
              -52.239601163571955,
              -30.42310652062245
            ],
            [
              -52.243788068043,
              -30.42099579694818
            ],
            [
              -52.25221421329098,
              -30.417980477413508
            ],
            [
              -52.25247589482043,
              -30.416623583622904
            ],
            [
              -52.25121982347911,
              -30.413407242785922
            ],
            [
              -52.255982427314926,
              -30.408783752832754
            ],
            [
              -52.25849456999756,
              -30.407577625018888
            ],
            [
              -52.25880858783289,
              -30.40632124187944
            ],
            [
              -52.25671513559736,
              -30.40270285843783
            ],
            [
              -52.261320730515514,
              -30.396420942740598
            ],
            [
              -52.263780536892256,
              -30.39461175101979
            ],
            [
              -52.26388520950403,
              -30.392702048647834
            ],
            [
              -52.261791757268504,
              -30.388882643903916
            ],
            [
              -52.26257680185683,
              -30.387324728811
            ],
            [
              -52.26477492670413,
              -30.386118600997133
            ],
            [
              -52.26398988211581,
              -30.38451043057864
            ],
            [
              -52.26121605790374,
              -30.382701238857834
            ],
            [
              -52.26367586428048,
              -30.373504514277084
            ],
            [
              -52.265873989127776,
              -30.373001961021306
            ],
            [
              -52.26760108722208,
              -30.36978562018432
            ],
            [
              -52.268804822257515,
              -30.36888102432392
            ],
            [
              -52.27309639934034,
              -30.36878051367276
            ],
            [
              -52.27759732164672,
              -30.368076939114673
            ],
            [
              -52.281417871976544,
              -30.364810342952108
            ],
            [
              -52.28099918152944,
              -30.363001151231305
            ],
            [
              -52.28481973185927,
              -30.361594002115126
            ],
            [
              -52.285814121671145,
              -30.359282257138542
            ],
            [
              -52.28869261849499,
              -30.356417703580604
            ],
            [
              -52.29031504397752,
              -30.347120468348695
            ],
            [
              -52.29418793061324,
              -30.345411787279048
            ],
            [
              -52.2979038083313,
              -30.342295957093217
            ],
            [
              -52.29779913571952,
              -30.3384765523493
            ],
            [
              -52.299578570119714,
              -30.334003828372868
            ],
            [
              -52.305597245296845,
              -30.33681812660523
            ],
            [
              -52.30549257268507,
              -30.33918012690739
            ],
            [
              -52.30381781089665,
              -30.34179340383744
            ],
            [
              -52.30428883764964,
              -30.344406680767488
            ],
            [
              -52.3066963077205,
              -30.34480872337211
            ],
            [
              -52.31407572685072,
              -30.343301063604777
            ],
            [
              -52.31622151539213,
              -30.344306170116333
            ],
            [
              -52.319414030051306,
              -30.346718425744072
            ],
            [
              -52.324124297581236,
              -30.356317192929446
            ],
            [
              -52.33391118678231,
              -30.35978481039432
            ],
            [
              -52.341499951136086,
              -30.358478171929296
            ],
            [
              -52.342913031395064,
              -30.358980725185074
            ],
            [
              -52.34532050146592,
              -30.359181746487387
            ],
            [
              -52.34788498045443,
              -30.357623831394474
            ],
            [
              -52.35118216772538,
              -30.357975618673517
            ],
            [
              -52.35699149767896,
              -30.36199604471975
            ],
            [
              -52.36410923527975,
              -30.36360421513824
            ],
            [
              -52.366307360127045,
              -30.363202172533615
            ],
            [
              -52.368714830197895,
              -30.364508810998643
            ],
            [
              -52.37028491937454,
              -30.36762464118447
            ],
            [
              -52.37719331175177,
              -30.369886130835475
            ],
            [
              -52.38452039457611,
              -30.376720855114066
            ],
            [
              -52.38797459076472,
              -30.376318812509446
            ],
            [
              -52.39169046848278,
              -30.377223408369847
            ],
            [
              -52.393417566577085,
              -30.37662034446291
            ],
            [
              -52.399383905448325,
              -30.378278770206983
            ],
            [
              -52.400221286342536,
              -30.380087961927785
            ],
            [
              -52.40221006596629,
              -30.380791536485876
            ],
            [
              -52.40508856279013,
              -30.380389493881253
            ],
            [
              -52.408804440508185,
              -30.377675706300046
            ],
            [
              -52.41440442523821,
              -30.375615237951354
            ],
            [
              -52.41702124053262,
              -30.371594811905123
            ],
            [
              -52.416288532250185,
              -30.368981534975074
            ],
            [
              -52.41681189530907,
              -30.367222598579847
            ],
            [
              -52.41890534754459,
              -30.363001151231305
            ],
            [
              -52.50149203823601,
              -30.362297576673214
            ],
            [
              -52.50442287136575,
              -30.359181746487387
            ],
            [
              -52.509080802589786,
              -30.352196256232062
            ],
            [
              -52.50897612997801,
              -30.345311276627893
            ],
            [
              -52.50840043061324,
              -30.34269799969784
            ],
            [
              -52.50709202296604,
              -30.34129085058166
            ],
            [
              -52.507301368189594,
              -30.33827553104699
            ],
            [
              -52.50897612997801,
              -30.33490842423327
            ],
            [
              -52.51080790068409,
              -30.326214252908297
            ],
            [
              -52.50688267774249,
              -30.32118872035051
            ],
            [
              -52.50751071341315,
              -30.31591191116483
            ],
            [
              -52.50520791595407,
              -30.31400220879287
            ],
            [
              -52.50719669557782,
              -30.311288421211664
            ],
            [
              -52.50588828793061,
              -30.309579740142016
            ],
            [
              -52.50740604080137,
              -30.304805484212118
            ],
            [
              -52.513320043366726,
              -30.300584036863576
            ],
            [
              -52.51729760261422,
              -30.291889865538604
            ],
            [
              -52.517192930002444,
              -30.283798758120565
            ],
            [
              -52.5187106828732,
              -30.283095183562473
            ],
            [
              -52.52038544466161,
              -30.279275778818555
            ],
            [
              -52.523211605179576,
              -30.27912501284182
            ],
            [
              -52.53132373259223,
              -30.272390799214385
            ],
            [
              -52.53247513132177,
              -30.27671275721408
            ],
            [
              -52.53221344979233,
              -30.27937628946971
            ],
            [
              -52.53530129183972,
              -30.280481906632424
            ],
            [
              -52.53739474407525,
              -30.282793651609005
            ],
            [
              -52.54890873137063,
              -30.28671356700408
            ],
            [
              -52.553514326288784,
              -30.28691458830639
            ],
            [
              -52.559375992548254,
              -30.285205907236744
            ],
            [
              -52.55932365624236,
              -30.28741714156217
            ],
            [
              -52.55670684094796,
              -30.294704163770962
            ],
            [
              -52.5573872129245,
              -30.299880462305484
            ],
            [
              -52.555817123747865,
              -30.307016718537547
            ],
            [
              -52.5582769301246,
              -30.313198123583625
            ],
            [
              -52.55717786770095,
              -30.316816507025234
            ],
            [
              -52.55717786770095,
              -30.321490252303974
            ],
            [
              -52.55461338871243,
              -30.328576253210457
            ],
            [
              -52.55571245113609,
              -30.33159157274513
            ],
            [
              -52.55649749572441,
              -30.33470740293096
            ],
            [
              -52.555503105912535,
              -30.33918012690739
            ],
            [
              -52.55728254031273,
              -30.34490923402327
            ],
            [
              -52.55618347788908,
              -30.346416893790604
            ],
            [
              -52.546396588688005,
              -30.34867838344161
            ],
            [
              -52.54210501160518,
              -30.353000341441305
            ],
            [
              -52.53948819631077,
              -30.35149268167397
            ],
            [
              -52.53598166381627,
              -30.35531208641789
            ],
            [
              -52.54351809186416,
              -30.362398087324372
            ],
            [
              -52.54812368678231,
              -30.361594002115126
            ],
            [
              -52.554979742853654,
              -30.36290064058015
            ],
            [
              -52.55618347788908,
              -30.361594002115126
            ],
            [
              -52.559218983630586,
              -30.36219706602206
            ],
            [
              -52.56089374541901,
              -30.36169451276628
            ],
            [
              -52.56199280784266,
              -30.360287363650098
            ],
            [
              -52.56481896836061,
              -30.36290064058015
            ],
            [
              -52.56717410212558,
              -30.36310166188246
            ],
            [
              -52.567488119960906,
              -30.364910853603266
            ],
            [
              -52.57020960786709,
              -30.364910853603266
            ],
            [
              -52.57020960786709,
              -30.367976428463514
            ],
            [
              -52.57078530723186,
              -30.368680003021606
            ],
            [
              -52.57580959259712,
              -30.37089123734703
            ],
            [
              -52.577222672856095,
              -30.372901450370147
            ],
            [
              -52.579002107256294,
              -30.37380604623055
            ],
            [
              -52.58140957732714,
              -30.37310247167246
            ],
            [
              -52.583084339115565,
              -30.370790726695876
            ],
            [
              -52.58219462191546,
              -30.36521238555673
            ],
            [
              -52.58397405631566,
              -30.36199604471975
            ],
            [
              -52.58690488944539,
              -30.35978481039432
            ],
            [
              -52.592975900928415,
              -30.357623831394474
            ],
            [
              -52.59240020156364,
              -30.355513107720203
            ],
            [
              -52.59632542450525,
              -30.35179421362744
            ],
            [
              -52.59658710603469,
              -30.350186043208947
            ],
            [
              -52.594598326410946,
              -30.345512297930203
            ],
            [
              -52.59512168946983,
              -30.34360259555824
            ],
            [
              -52.59747682323479,
              -30.34269799969784
            ],
            [
              -52.60197774554117,
              -30.344105148814023
            ],
            [
              -52.603181480576595,
              -30.34340157425593
            ],
            [
              -52.60391418885903,
              -30.341692893186284
            ],
            [
              -52.6071067035182,
              -30.34129085058166
            ],
            [
              -52.60899081053017,
              -30.339582169512013
            ],
            [
              -52.60339082580015,
              -30.328877785163925
            ],
            [
              -52.60412353408258,
              -30.326917827466385
            ],
            [
              -52.6018207366235,
              -30.326214252908297
            ],
            [
              -52.601402046176396,
              -30.323801997280558
            ],
            [
              -52.60260578121182,
              -30.323701486629403
            ],
            [
              -52.602501108600045,
              -30.321691273606287
            ],
            [
              -52.60438521561202,
              -30.32108820969935
            ],
            [
              -52.6049085786709,
              -30.32018361383895
            ],
            [
              -52.60328615318837,
              -30.317620592234476
            ],
            [
              -52.60291979904715,
              -30.31520833660674
            ],
            [
              -52.604489888223796,
              -30.31299710228131
            ],
            [
              -52.605798295871,
              -30.31299710228131
            ],
            [
              -52.60742072135353,
              -30.306614675932924
            ],
            [
              -52.60668801307109,
              -30.30500650551443
            ],
            [
              -52.60862445638895,
              -30.304604462909808
            ],
            [
              -52.61008987295382,
              -30.30068454751473
            ],
            [
              -52.614381450036646,
              -30.297819993956793
            ],
            [
              -52.615794530295624,
              -30.295709270282522
            ],
            [
              -52.61521883093086,
              -30.29269395074785
            ],
            [
              -52.61621322074273,
              -30.288723780027198
            ],
            [
              -52.61930106279013,
              -30.279979353376646
            ],
            [
              -52.61872536342536,
              -30.277114799818705
            ],
            [
              -52.62170853286098,
              -30.27490356549328
            ],
            [
              -52.619405735401905,
              -30.270782628795892
            ],
            [
              -52.61930106279013,
              -30.2687221604472
            ],
            [
              -52.62060947043733,
              -30.267817564586796
            ],
            [
              -52.61877769973125,
              -30.262188968122075
            ],
            [
              -52.620190779990224,
              -30.26037977640127
            ],
            [
              -52.62238890483753,
              -30.26037977640127
            ],
            [
              -52.62401133032006,
              -30.256912158936398
            ],
            [
              -52.62369731248473,
              -30.249574881402026
            ],
            [
              -52.626209455167356,
              -30.24429807221635
            ],
            [
              -52.62788421695578,
              -30.242388369844388
            ],
            [
              -52.63280382970926,
              -30.23977509291434
            ],
            [
              -52.6343739188859,
              -30.234196751775194
            ],
            [
              -52.63808979660396,
              -30.232990623961324
            ],
            [
              -52.64269539152211,
              -30.223994920682884
            ],
            [
              -52.63960754947471,
              -30.22002474996223
            ],
            [
              -52.64128231126313,
              -30.216607387822936
            ],
            [
              -52.64400379916931,
              -30.214697685450975
            ],
            [
              -52.64531220681651,
              -30.211380833962835
            ],
            [
              -52.650074810652335,
              -30.21037572745128
            ],
            [
              -52.65269162594674,
              -30.213491557637106
            ],
            [
              -52.65389536098216,
              -30.213592068288264
            ],
            [
              -52.65661684888835,
              -30.21218491917208
            ],
            [
              -52.65740189347667,
              -30.2094208762653
            ],
            [
              -52.65839628328854,
              -30.21158185526515
            ],
            [
              -52.66169347055949,
              -30.21459717479982
            ],
            [
              -52.66101309858295,
              -30.217813515636806
            ],
            [
              -52.6621121610066,
              -30.222487260915546
            ],
            [
              -52.663996268018565,
              -30.224899516543285
            ],
            [
              -52.6691252259956,
              -30.228517899984894
            ],
            [
              -52.670014943195696,
              -30.234900326333285
            ],
            [
              -52.66750280051307,
              -30.240076624867807
            ],
            [
              -52.6678168183484,
              -30.2416847952863
            ],
            [
              -52.67121867823113,
              -30.24379551896057
            ],
            [
              -52.66991027058392,
              -30.247916455657958
            ],
            [
              -52.67189905020767,
              -30.25118305182052
            ],
            [
              -52.67059064256047,
              -30.255303988517905
            ],
            [
              -52.67121867823113,
              -30.25681164828524
            ],
            [
              -52.67629529990227,
              -30.25997773379665
            ],
            [
              -52.68158126679697,
              -30.264601223749814
            ],
            [
              -52.688384986562426,
              -30.272692331167853
            ],
            [
              -52.68660555216223,
              -30.278722970237197
            ],
            [
              -52.68681489738578,
              -30.279677821423178
            ],
            [
              -52.68927470376252,
              -30.280883949237047
            ],
            [
              -52.690321429880285,
              -30.28249211965554
            ],
            [
              -52.69042610249206,
              -30.284904375283276
            ],
            [
              -52.6889083496213,
              -30.291085780329357
            ],
            [
              -52.689484048986074,
              -30.292794461399005
            ],
            [
              -52.69168217383337,
              -30.294603653119808
            ],
            [
              -52.69131581969216,
              -30.297819993956793
            ],
            [
              -52.6893793763743,
              -30.3009860794682
            ],
            [
              -52.6906877840215,
              -30.303699867049406
            ],
            [
              -52.68969339420963,
              -30.3062126333283
            ],
            [
              -52.686396206938674,
              -30.310182804048953
            ],
            [
              -52.68728592413877,
              -30.31239403837438
            ],
            [
              -52.68660555216223,
              -30.317419570932167
            ],
            [
              -52.68749526936232,
              -30.31897748602508
            ],
            [
              -52.6845120999267,
              -30.32319893337362
            ],
            [
              -52.68702424260933,
              -30.328777274512767
            ],
            [
              -52.686710224774004,
              -30.330586466233573
            ],
            [
              -52.6889083496213,
              -30.332697189907844
            ],
            [
              -52.690321429880285,
              -30.335410977489047
            ],
            [
              -52.68828031395065,
              -30.3384765523493
            ],
            [
              -52.6897980668214,
              -30.34129085058166
            ],
            [
              -52.69592141461031,
              -30.34390412751171
            ],
            [
              -52.70162607195211,
              -30.349281447348545
            ],
            [
              -52.70251578915221,
              -30.350990128418193
            ],
            [
              -52.70528961336428,
              -30.350186043208947
            ],
            [
              -52.70691203884681,
              -30.350990128418193
            ],
            [
              -52.70738306559981,
              -30.352497788185527
            ],
            [
              -52.70680736623503,
              -30.353703915999397
            ],
            [
              -52.70921483630589,
              -30.35501055446442
            ],
            [
              -52.71371575861227,
              -30.36048838495241
            ],
            [
              -52.71439613058881,
              -30.36189553406859
            ],
            [
              -52.71361108600049,
              -30.365614428161354
            ],
            [
              -52.719525088565845,
              -30.368076939114673
            ],
            [
              -52.72151386818959,
              -30.366116981417132
            ],
            [
              -52.723083957366235,
              -30.36219706602206
            ],
            [
              -52.72659048986073,
              -30.36078991690588
            ],
            [
              -52.73088206694356,
              -30.361594002115126
            ],
            [
              -52.73438859943806,
              -30.36099093820819
            ],
            [
              -52.74972313706328,
              -30.362599108626682
            ],
            [
              -52.76029507085267,
              -30.3502865538601
            ],
            [
              -52.76322590398241,
              -30.34299953165131
            ],
            [
              -52.76469132054727,
              -30.34179340383744
            ],
            [
              -52.76668010017102,
              -30.341089829279348
            ],
            [
              -52.77060532311263,
              -30.34129085058166
            ],
            [
              -52.77358849254825,
              -30.339280637558545
            ],
            [
              -52.77651932567799,
              -30.338677573651612
            ],
            [
              -52.78798097666748,
              -30.34249697839553
            ],
            [
              -52.789289384314685,
              -30.34269799969784
            ],
            [
              -52.79101648240899,
              -30.34129085058166
            ],
            [
              -52.79310993464451,
              -30.335410977489047
            ],
            [
              -52.79321460725629,
              -30.332194636652062
            ],
            [
              -52.79190619960909,
              -30.324304550536336
            ],
            [
              -52.79232489005619,
              -30.3171180389787
            ],
            [
              -52.78981274737356,
              -30.31259505967669
            ],
            [
              -52.788975366479356,
              -30.308624888956036
            ],
            [
              -52.790597791961886,
              -30.302292717933224
            ],
            [
              -52.79598843146836,
              -30.30520752681674
            ],
            [
              -52.795622077327145,
              -30.30782080374679
            ],
            [
              -52.796878148668455,
              -30.308624888956036
            ],
            [
              -52.79782020217444,
              -30.31088637860704
            ],
            [
              -52.79619777669191,
              -30.311388931862822
            ],
            [
              -52.79598843146836,
              -30.313700676839403
            ],
            [
              -52.79782020217444,
              -30.316213443118297
            ],
            [
              -52.79729683911556,
              -30.3171180389787
            ],
            [
              -52.79839590153921,
              -30.319781571234326
            ],
            [
              -52.80017533593941,
              -30.320786677745886
            ],
            [
              -52.80247813339848,
              -30.324606082489804
            ],
            [
              -52.80729307354019,
              -30.325711699652516
            ],
            [
              -52.8068220467872,
              -30.326515784861762
            ],
            [
              -52.80781643659907,
              -30.33108901948935
            ],
            [
              -52.811008951258245,
              -30.335209956186738
            ],
            [
              -52.81498651050574,
              -30.335511488140202
            ],
            [
              -52.816504263376494,
              -30.33470740293096
            ],
            [
              -52.81807435255314,
              -30.335511488140202
            ],
            [
              -52.81838837038847,
              -30.334305360326336
            ],
            [
              -52.820010795871,
              -30.33490842423327
            ],
            [
              -52.82158088504764,
              -30.33319974316362
            ],
            [
              -52.8235173283655,
              -30.33440587097749
            ],
            [
              -52.82487807231859,
              -30.33350127511709
            ],
            [
              -52.82759956022477,
              -30.334104339024023
            ],
            [
              -52.830478057048616,
              -30.338024254419096
            ],
            [
              -52.832414500366475,
              -30.3384765523493
            ],
            [
              -52.8384855118495,
              -30.334506381628646
            ],
            [
              -52.84078830930857,
              -30.336215062698294
            ],
            [
              -52.84251540740288,
              -30.33631557334945
            ],
            [
              -52.84350979721476,
              -30.33817502039583
            ],
            [
              -52.84089298192035,
              -30.34360259555824
            ],
            [
              -52.84162569020278,
              -30.345512297930203
            ],
            [
              -52.84340512460298,
              -30.346416893790604
            ],
            [
              -52.847696701685805,
              -30.341190339930506
            ],
            [
              -52.85130790679208,
              -30.341994425139752
            ],
            [
              -52.852720987051065,
              -30.344507191418646
            ],
            [
              -52.85109856156853,
              -30.345914340534826
            ],
            [
              -52.85057519850965,
              -30.347623021604473
            ],
            [
              -52.859995733569505,
              -30.356116171627136
            ],
            [
              -52.86088545076961,
              -30.358176639975827
            ],
            [
              -52.86219385841681,
              -30.35857868258045
            ],
            [
              -52.86350226606401,
              -30.357623831394474
            ],
            [
              -52.86402562912289,
              -30.355513107720203
            ],
            [
              -52.866485435499634,
              -30.35480953316211
            ],
            [
              -52.86360693867579,
              -30.351392171022816
            ],
            [
              -52.86517702785243,
              -30.349784000604323
            ],
            [
              -52.86962561385292,
              -30.350085532557788
            ],
            [
              -52.86690412594674,
              -30.34631638313945
            ],
            [
              -52.86402562912289,
              -30.344507191418646
            ],
            [
              -52.86517702785243,
              -30.341089829279348
            ],
            [
              -52.86721814378207,
              -30.340687786674724
            ],
            [
              -52.87041065844124,
              -30.342798510348995
            ],
            [
              -52.87307981004153,
              -30.341692893186284
            ],
            [
              -52.875225598582944,
              -30.341994425139752
            ],
            [
              -52.877685404959685,
              -30.344105148814023
            ],
            [
              -52.87470223552406,
              -30.349180936697387
            ],
            [
              -52.88072091070119,
              -30.35169370297628
            ],
            [
              -52.88328538968971,
              -30.359985831696633
            ],
            [
              -52.88427977950159,
              -30.360890427557035
            ],
            [
              -52.88328538968971,
              -30.362498597975527
            ],
            [
              -52.881087264842414,
              -30.361392980812813
            ],
            [
              -52.87988352980699,
              -30.35958378909201
            ],
            [
              -52.877999422795014,
              -30.361191959510503
            ],
            [
              -52.877214378206695,
              -30.364609321649798
            ],
            [
              -52.877999422795014,
              -30.3711927693005
            ],
            [
              -52.88009287503054,
              -30.371695322556278
            ],
            [
              -52.88359940752504,
              -30.370187662788943
            ],
            [
              -52.88527416931346,
              -30.369886130835475
            ],
            [
              -52.884018097972145,
              -30.373202982323615
            ],
            [
              -52.88469846994869,
              -30.375615237951354
            ],
            [
              -52.87951717566577,
              -30.375916769904823
            ],
            [
              -52.87758073234791,
              -30.377323919021002
            ],
            [
              -52.87888913999511,
              -30.379685919323162
            ],
            [
              -52.8829190355485,
              -30.38229919625321
            ],
            [
              -52.877999422795014,
              -30.386319622299442
            ],
            [
              -52.87569662533594,
              -30.386018090345974
            ],
            [
              -52.87480690813584,
              -30.386922686206375
            ],
            [
              -52.877214378206695,
              -30.39129489953165
            ],
            [
              -52.8829190355485,
              -30.397677325880043
            ],
            [
              -52.88229099987784,
              -30.403808475600545
            ],
            [
              -52.88307604446616,
              -30.407376603716575
            ],
            [
              -52.882709690324944,
              -30.40938681673969
            ],
            [
              -52.88181997312485,
              -30.41059294455356
            ],
            [
              -52.875905970559494,
              -30.412603157576676
            ],
            [
              -52.87292280112387,
              -30.41441234929748
            ],
            [
              -52.87030598582946,
              -30.414311838646324
            ],
            [
              -52.870201313217684,
              -30.41838252001813
            ],
            [
              -52.87292280112387,
              -30.41989017978547
            ],
            [
              -52.87820876801857,
              -30.419689158483155
            ],
            [
              -52.88359940752504,
              -30.420694264994715
            ],
            [
              -52.883180717077934,
              -30.42190039280858
            ],
            [
              -52.87988352980699,
              -30.423006009971296
            ],
            [
              -52.878993812606886,
              -30.424915712343257
            ],
            [
              -52.876900360371366,
              -30.425418265599035
            ],
            [
              -52.87648166992426,
              -30.42652388276175
            ],
            [
              -52.87878446738333,
              -30.429488946970842
            ],
            [
              -52.88328538968971,
              -30.43340886236592
            ],
            [
              -52.88427977950159,
              -30.437680565040036
            ],
            [
              -52.89029845467872,
              -30.436223160598278
            ],
            [
              -52.89270592474957,
              -30.43758005438888
            ],
            [
              -52.88799565721964,
              -30.4413994591328
            ],
            [
              -52.88878070180796,
              -30.448585970690438
            ],
            [
              -52.89202555277303,
              -30.450294651760085
            ],
            [
              -52.889199392255065,
              -30.45471712041094
            ],
            [
              -52.89129284449059,
              -30.45738065266657
            ],
            [
              -52.88851902027852,
              -30.457682184620033
            ],
            [
              -52.88621622281945,
              -30.461099546759332
            ],
            [
              -52.887105940019545,
              -30.46401435564285
            ],
            [
              -52.885797532372344,
              -30.464818440852095
            ],
            [
              -52.88778631199609,
              -30.46637635594501
            ],
            [
              -52.887890984607864,
              -30.468889122223903
            ],
            [
              -52.88878070180796,
              -30.46969320743315
            ],
            [
              -52.886425568043,
              -30.47150239915395
            ],
            [
              -52.88689659479599,
              -30.4732110802236
            ],
            [
              -52.88867602919618,
              -30.47512078259556
            ],
            [
              -52.884803142560465,
              -30.476879718990787
            ],
            [
              -52.887890984607864,
              -30.48291035806013
            ],
            [
              -52.88391342536037,
              -30.48461903912978
            ],
            [
              -52.88339006230149,
              -30.487584103338875
            ],
            [
              -52.885117160395794,
              -30.493815763710533
            ],
            [
              -52.88700126740777,
              -30.495675210756914
            ],
            [
              -52.88909471964329,
              -30.496278274663847
            ],
            [
              -52.88878070180796,
              -30.49838899833812
            ],
            [
              -52.88700126740777,
              -30.500700743314702
            ],
            [
              -52.88810032983142,
              -30.503716062849374
            ],
            [
              -52.89401433239677,
              -30.504620658709776
            ],
            [
              -52.89511339482042,
              -30.50808827617465
            ],
            [
              -52.89328162411434,
              -30.50929440398852
            ],
            [
              -52.89380498717322,
              -30.510601042453544
            ],
            [
              -52.89788721903249,
              -30.513214319383593
            ],
            [
              -52.89888160884437,
              -30.51522453240671
            ],
            [
              -52.898619927314925,
              -30.516581426197313
            ],
            [
              -52.89631712985585,
              -30.518893171173893
            ],
            [
              -52.89809656425604,
              -30.52040083094123
            ],
            [
              -52.89720684705595,
              -30.522712575917815
            ],
            [
              -52.90521430185683,
              -30.524421256987463
            ],
            [
              -52.906104019056926,
              -30.525476618824598
            ],
            [
              -52.90788345345712,
              -30.534723598730928
            ],
            [
              -52.906889063645245,
              -30.537387130986556
            ],
            [
              -52.908825506963105,
              -30.540502961172383
            ],
            [
              -52.91180867639873,
              -30.543317259404745
            ],
            [
              -52.91107596811629,
              -30.549297643148513
            ],
            [
              -52.90762177192768,
              -30.553720111799368
            ],
            [
              -52.90809279868067,
              -30.55839385707811
            ],
            [
              -52.90542364708038,
              -30.563921942891678
            ],
            [
              -52.90589467383337,
              -30.566484964496148
            ],
            [
              -52.9075170993159,
              -30.56789211361233
            ],
            [
              -52.90589467383337,
              -30.574224284635143
            ],
            [
              -52.9101862509162,
              -30.57739037014655
            ],
            [
              -52.9101862509162,
              -30.58040568968122
            ],
            [
              -52.91610025348155,
              -30.586888626680768
            ],
            [
              -52.91787968788175,
              -30.59161262728509
            ],
            [
              -52.92358434522355,
              -30.59638688321499
            ],
            [
              -52.925416115929636,
              -30.600507819912377
            ],
            [
              -52.92939367517713,
              -30.605282075842275
            ],
            [
              -52.9312777821891,
              -30.60648820365614
            ],
            [
              -52.93598804971903,
              -30.608096374074634
            ],
            [
              -52.94488522172001,
              -30.601613437075088
            ],
            [
              -52.94917679880283,
              -30.603121096842425
            ],
            [
              -52.964511336428046,
              -30.60322160749358
            ],
            [
              -52.96738983325189,
              -30.604276969330716
            ],
            [
              -52.972623463840705,
              -30.60322160749358
            ],
            [
              -52.97461224346445,
              -30.604075948028406
            ],
            [
              -52.974821588688,
              -30.605985650400363
            ],
            [
              -52.97298981798192,
              -30.60940301253966
            ],
            [
              -52.9757113058881,
              -30.613021395981267
            ],
            [
              -52.975815978499874,
              -30.617494119957698
            ],
            [
              -52.97539728805277,
              -30.61910229037619
            ],
            [
              -52.97330383581725,
              -30.619805864934282
            ],
            [
              -52.971786082946494,
              -30.621615056655084
            ],
            [
              -52.97398420779379,
              -30.62608778063152
            ],
            [
              -52.97251879122893,
              -30.633425058165887
            ],
            [
              -52.975501960664545,
              -30.642119229490863
            ],
            [
              -52.97330383581725,
              -30.643023825351264
            ],
            [
              -52.97251879122893,
              -30.644179697839554
            ],
            [
              -52.975501960664545,
              -30.645687357606892
            ],
            [
              -52.97497859760566,
              -30.64759705997885
            ],
            [
              -52.97157673772294,
              -30.649004209095033
            ],
            [
              -52.97361785365258,
              -30.651717996676236
            ],
            [
              -52.97152440141705,
              -30.65548714609458
            ],
            [
              -52.971786082946494,
              -30.659206040187343
            ],
            [
              -52.975187942829216,
              -30.661618295815078
            ],
            [
              -52.97691504092353,
              -30.66800072216347
            ],
            [
              -52.977804758123625,
              -30.66890531802387
            ],
            [
              -52.975187942829216,
              -30.669709403233117
            ],
            [
              -52.974716916076225,
              -30.67222216951201
            ],
            [
              -52.977490740288296,
              -30.672875488744523
            ],
            [
              -52.978118775958954,
              -30.673579063302615
            ],
            [
              -52.977490740288296,
              -30.675187233721108
            ],
            [
              -52.9787991479355,
              -30.67609182958151
            ],
            [
              -52.98042157341803,
              -30.67579029762804
            ],
            [
              -52.98078792755925,
              -30.6777
            ],
            [
              -52.98617856706572,
              -30.67609182958151
            ],
            [
              -52.98858603713657,
              -30.67468468046533
            ],
            [
              -52.98858603713657,
              -30.6777
            ],
            [
              -52.99167387918397,
              -30.6767954041396
            ],
            [
              -52.992720605301734,
              -30.67558927632573
            ],
            [
              -52.99282527791351,
              -30.673780084604928
            ],
            [
              -52.99167387918397,
              -30.671518594953923
            ],
            [
              -52.992720605301734,
              -30.670513488442364
            ],
            [
              -52.99502340276081,
              -30.670312467140054
            ],
            [
              -52.9976925543611,
              -30.66659357304729
            ],
            [
              -53.00119908685561,
              -30.667397658256537
            ],
            [
              -53.00360655692646,
              -30.667397658256537
            ],
            [
              -53.0064850537503,
              -30.66900582867503
            ],
            [
              -53.009101869044706,
              -30.668201743465783
            ],
            [
              -53.01020093146836,
              -30.670010935186585
            ],
            [
              -53.01150933911556,
              -30.669407871279653
            ],
            [
              -53.013812136574636,
              -30.673076510046837
            ],
            [
              -53.01648128817493,
              -30.67252370146548
            ],
            [
              -53.01632427925727,
              -30.670312467140054
            ],
            [
              -53.01758035059858,
              -30.668603786070406
            ],
            [
              -53.019987820669435,
              -30.66779970086116
            ],
            [
              -53.02040651111654,
              -30.665990509140354
            ],
            [
              -53.02569247801124,
              -30.66538744523342
            ],
            [
              -53.029408355729295,
              -30.66659357304729
            ],
            [
              -53.031501807964815,
              -30.668603786070406
            ],
            [
              -53.033909278035665,
              -30.669508381930807
            ],
            [
              -53.035374694600534,
              -30.67131757365161
            ],
            [
              -53.049191479354995,
              -30.665186423931107
            ],
            [
              -53.052279321402395,
              -30.663075700256837
            ],
            [
              -53.05332604752015,
              -30.661517785163923
            ],
            [
              -53.05432043733203,
              -30.656291231303825
            ],
            [
              -53.05280268446128,
              -30.65212003928086
            ],
            [
              -53.055524172367456,
              -30.64739603867654
            ],
            [
              -53.06389798130955,
              -30.64649144281614
            ],
            [
              -53.06750918641583,
              -30.64397867653724
            ],
            [
              -53.0702830106279,
              -30.644380719141864
            ],
            [
              -53.07211478133398,
              -30.64171718688624
            ],
            [
              -53.07347552528707,
              -30.64171718688624
            ],
            [
              -53.07577832274615,
              -30.639907995165434
            ],
            [
              -53.078395138040555,
              -30.64000850581659
            ],
            [
              -53.07991289091131,
              -30.637897782142318
            ],
            [
              -53.08200634314684,
              -30.639003399305032
            ],
            [
              -53.08399512277058,
              -30.635485526514582
            ],
            [
              -53.08949043488883,
              -30.635183994561114
            ],
            [
              -53.09001379794771,
              -30.633475313491466
            ],
            [
              -53.09289229477156,
              -30.631113313189307
            ],
            [
              -53.096084809430735,
              -30.624680631515336
            ],
            [
              -53.09938199670168,
              -30.623122716422422
            ],
            [
              -53.10089974957244,
              -30.62342424837589
            ],
            [
              -53.102888529196186,
              -30.61890126907388
            ],
            [
              -53.10430160945516,
              -30.61769514126001
            ],
            [
              -53.10472029990227,
              -30.613775225864934
            ],
            [
              -53.106604406914244,
              -30.613875736516093
            ],
            [
              -53.10801748717322,
              -30.613121906632422
            ],
            [
              -53.113408126679694,
              -30.607593820818856
            ],
            [
              -53.117490358538966,
              -30.607593820818856
            ],
            [
              -53.12178193562179,
              -30.609604033841972
            ],
            [
              -53.12340436110432,
              -30.609302501888504
            ],
            [
              -53.125288468116295,
              -30.605684118446895
            ],
            [
              -53.121677263010014,
              -30.60302058619127
            ],
            [
              -53.120892218421695,
              -30.601512926423933
            ],
            [
              -53.1243987509162,
              -30.597391989726546
            ],
            [
              -53.122619316516,
              -30.59352232965705
            ],
            [
              -53.12277632543366,
              -30.591009563378154
            ],
            [
              -53.12889967322257,
              -30.588396286448106
            ],
            [
              -53.13177817004642,
              -30.584777903006497
            ],
            [
              -53.13251087832885,
              -30.58311947726243
            ],
            [
              -53.13151648851698,
              -30.58040568968122
            ],
            [
              -53.13429031272905,
              -30.57548066777459
            ],
            [
              -53.135808065599804,
              -30.57497811451881
            ],
            [
              -53.139576279623746,
              -30.57618424233268
            ],
            [
              -53.140989359882724,
              -30.57548066777459
            ],
            [
              -53.14271645797703,
              -30.57070641184469
            ],
            [
              -53.1410940324945,
              -30.56809313491464
            ],
            [
              -53.14172206816516,
              -30.56688700710077
            ],
            [
              -53.14711270767163,
              -30.563519900287055
            ],
            [
              -53.14868279684828,
              -30.5600020274966
            ],
            [
              -53.152189329342775,
              -30.556584665357306
            ],
            [
              -53.15548651661373,
              -30.54658385556731
            ],
            [
              -53.16689583129733,
              -30.54768947273002
            ],
            [
              -53.16522106950892,
              -30.543518280707058
            ],
            [
              -53.161295846567306,
              -30.539799386614295
            ],
            [
              -53.16281359943806,
              -30.53748764163771
            ],
            [
              -53.164697706450035,
              -30.53748764163771
            ],
            [
              -53.17401356889812,
              -30.54231215289319
            ],
            [
              -53.17568833068653,
              -30.541608578335097
            ],
            [
              -53.17547898546298,
              -30.538191216195802
            ],
            [
              -53.176525711580744,
              -30.535477428614595
            ],
            [
              -53.17631636635719,
              -30.534120534823995
            ],
            [
              -53.173280860615684,
              -30.531909300498565
            ],
            [
              -53.17521730393354,
              -30.52969806617314
            ],
            [
              -53.17840981859272,
              -30.52849193835927
            ],
            [
              -53.18097429758124,
              -30.52849193835927
            ],
            [
              -53.183224758734426,
              -30.52919551291736
            ],
            [
              -53.183695785487416,
              -30.531909300498565
            ],
            [
              -53.18568456511116,
              -30.533617981568213
            ],
            [
              -53.189191097605665,
              -30.53231134310319
            ],
            [
              -53.189976142193984,
              -30.521305426801632
            ],
            [
              -53.1917032402883,
              -30.51859163922043
            ],
            [
              -53.18960978805277,
              -30.51617938359269
            ],
            [
              -53.191493895064745,
              -30.513214319383593
            ],
            [
              -53.19091819569997,
              -30.511807170267414
            ],
            [
              -53.191179877229416,
              -30.508289297476963
            ],
            [
              -53.192592957488394,
              -30.504922190663244
            ],
            [
              -53.19128454984119,
              -30.503012488291283
            ],
            [
              -53.186417273393594,
              -30.50100227526817
            ],
            [
              -53.19029016002931,
              -30.495675210756914
            ],
            [
              -53.18652194600537,
              -30.492107082640885
            ],
            [
              -53.185789237722936,
              -30.490498912222392
            ],
            [
              -53.18762100842902,
              -30.4879861459435
            ],
            [
              -53.19107520461764,
              -30.486377975525006
            ],
            [
              -53.19280230271195,
              -30.482508315455508
            ],
            [
              -53.19280230271195,
              -30.479794527874304
            ],
            [
              -53.195994817371115,
              -30.477382272246565
            ],
            [
              -53.2009144301246,
              -30.469291164828526
            ],
            [
              -53.206409742242855,
              -30.464416398247472
            ],
            [
              -53.2066190874664,
              -30.459792908294308
            ],
            [
              -53.208974221231365,
              -30.456275035503854
            ],
            [
              -53.20918356645492,
              -30.45371201389938
            ],
            [
              -53.21347514353774,
              -30.450897715667022
            ],
            [
              -53.21551625946738,
              -30.449892609155462
            ],
            [
              -53.216615321891034,
              -30.4470783109231
            ],
            [
              -53.21572560469093,
              -30.444012736062852
            ],
            [
              -53.213684488761295,
              -30.443409672155916
            ],
            [
              -53.212376081114094,
              -30.441298948481645
            ],
            [
              -53.21300411678475,
              -30.43878618220275
            ],
            [
              -53.20991627473735,
              -30.436775969179635
            ],
            [
              -53.21070131932568,
              -30.434011926272852
            ],
            [
              -53.208817212313704,
              -30.431800691947426
            ],
            [
              -53.20677609638407,
              -30.431800691947426
            ],
            [
              -53.19840228744197,
              -30.428785372412754
            ],
            [
              -53.19677986195944,
              -30.420895286297025
            ],
            [
              -53.19709387979477,
              -30.41818149871582
            ],
            [
              -53.195523790618125,
              -30.417879966762353
            ],
            [
              -53.197303225018324,
              -30.415618477111348
            ],
            [
              -53.195890144759346,
              -30.414914902553257
            ],
            [
              -53.19201725812362,
              -30.415517966460193
            ],
            [
              -53.19070885047642,
              -30.41501541320441
            ],
            [
              -53.188720070852675,
              -30.41129651911165
            ],
            [
              -53.18929577021744,
              -30.409085284786222
            ],
            [
              -53.1996060224774,
              -30.404512050158637
            ],
            [
              -53.19882097788908,
              -30.4030043903913
            ],
            [
              -53.198611632665525,
              -30.39938600694969
            ],
            [
              -53.1921219307354,
              -30.395717368182506
            ],
            [
              -53.1873069905937,
              -30.396219921438284
            ],
            [
              -53.18458550268751,
              -30.395214814926728
            ],
            [
              -53.18280606828732,
              -30.39591838948482
            ],
            [
              -53.17678739311019,
              -30.394310219066327
            ],
            [
              -53.17877617273393,
              -30.38898315455507
            ],
            [
              -53.176578047886636,
              -30.38350532406708
            ],
            [
              -53.179613553628144,
              -30.37998745127663
            ],
            [
              -53.17699673833374,
              -30.37898234476507
            ],
            [
              -53.174275250427556,
              -30.37571574860251
            ],
            [
              -53.17228647080381,
              -30.3755147273002
            ],
            [
              -53.17050703640361,
              -30.37380604623055
            ],
            [
              -53.17171077143904,
              -30.3711927693005
            ],
            [
              -53.17479861348644,
              -30.36888102432392
            ],
            [
              -53.17511263132177,
              -30.367222598579847
            ],
            [
              -53.17448459565111,
              -30.36380523644055
            ],
            [
              -53.17710141094551,
              -30.361795023417436
            ],
            [
              -53.17741542878084,
              -30.358478171929296
            ],
            [
              -53.17359487845101,
              -30.354608511859798
            ],
            [
              -53.169879000732955,
              -30.35199523492975
            ],
            [
              -53.169879000732955,
              -30.34968348995317
            ],
            [
              -53.172495816027364,
              -30.3493819579997
            ],
            [
              -53.17422291412167,
              -30.343100042302463
            ],
            [
              -53.176525711580744,
              -30.34299953165131
            ],
            [
              -53.180084580381134,
              -30.34480872337211
            ],
            [
              -53.184009803322745,
              -30.34179340383744
            ],
            [
              -53.18798736257024,
              -30.340888807977038
            ],
            [
              -53.188877079770336,
              -30.3393811482097
            ],
            [
              -53.18720231798192,
              -30.33631557334945
            ],
            [
              -53.187882689958464,
              -30.3346068922798
            ],
            [
              -53.187411663205474,
              -30.332697189907844
            ],
            [
              -53.18469017529929,
              -30.33299872186131
            ],
            [
              -53.18181167847544,
              -30.329078806466235
            ],
            [
              -53.17888084534571,
              -30.327822423326786
            ],
            [
              -53.17940420840459,
              -30.32440506118749
            ],
            [
              -53.18212569631077,
              -30.32229433751322
            ],
            [
              -53.18437615746396,
              -30.318123145490258
            ],
            [
              -53.18217803261666,
              -30.317620592234476
            ],
            [
              -53.18050327082824,
              -30.312796080979002
            ],
            [
              -53.18312008612265,
              -30.314404251397495
            ],
            [
              -53.18437615746396,
              -30.314102719444026
            ],
            [
              -53.1930116479355,
              -30.310584846653576
            ],
            [
              -53.19929200464207,
              -30.313198123583625
            ],
            [
              -53.20049573967749,
              -30.311690463816287
            ],
            [
              -53.2000247129245,
              -30.30947922949086
            ],
            [
              -53.201385456877595,
              -30.307921314397948
            ],
            [
              -53.203007882360126,
              -30.307418761142166
            ],
            [
              -53.203007882360126,
              -30.303699867049406
            ],
            [
              -53.20421161739555,
              -30.30219220728207
            ],
            [
              -53.204106944783774,
              -30.300282504910108
            ],
            [
              -53.206095724407525,
              -30.299980972956643
            ],
            [
              -53.2070901142194,
              -30.29741795135217
            ],
            [
              -53.20907889384314,
              -30.29691539809639
            ],
            [
              -53.211015337161,
              -30.297518462003325
            ],
            [
              -53.21269009894942,
              -30.299176887747397
            ],
            [
              -53.21431252443195,
              -30.29761897265448
            ],
            [
              -53.21651064927926,
              -30.297719483305638
            ],
            [
              -53.21902279196188,
              -30.306112122677142
            ],
            [
              -53.220174190691424,
              -30.307921314397948
            ],
            [
              -53.220017181773756,
              -30.30978076144433
            ],
            [
              -53.218499428903,
              -30.311790974467442
            ],
            [
              -53.2193891461031,
              -30.31450476204865
            ],
            [
              -53.21902279196188,
              -30.322696380117844
            ],
            [
              -53.223105023821155,
              -30.32661629551292
            ],
            [
              -53.22739660090398,
              -30.32681731681523
            ],
            [
              -53.22969939836305,
              -30.328475742559302
            ],
            [
              -53.23440966589298,
              -30.329681870373168
            ],
            [
              -53.23629377290496,
              -30.328877785163925
            ],
            [
              -53.24037600476423,
              -30.333300253814777
            ],
            [
              -53.25550119716589,
              -30.336717615954072
            ],
            [
              -53.26151987234302,
              -30.34179340383744
            ],
            [
              -53.268009574273144,
              -30.345311276627893
            ],
            [
              -53.27088807109699,
              -30.345512297930203
            ],
            [
              -53.27659272843879,
              -30.342899021000154
            ],
            [
              -53.280674960298064,
              -30.345512297930203
            ],
            [
              -53.31731037441974,
              -30.326716806164075
            ],
            [
              -53.321287933667236,
              -30.326214252908297
            ],
            [
              -53.324323439408744,
              -30.32731987007101
            ],
            [
              -53.32981875152699,
              -30.322394848164375
            ],
            [
              -53.336517798680674,
              -30.31877646472277
            ],
            [
              -53.33578509039824,
              -30.31470578335096
            ],
            [
              -53.33411032860982,
              -30.312494549025534
            ],
            [
              -53.333115938797945,
              -30.309579740142016
            ],
            [
              -53.333115938797945,
              -30.307519271793325
            ],
            [
              -53.334895373198144,
              -30.305810590723677
            ],
            [
              -53.335523408868795,
              -30.301187100770512
            ],
            [
              -53.33850657830442,
              -30.3009860794682
            ],
            [
              -53.34101872098705,
              -30.298724589817194
            ],
            [
              -53.342693482775466,
              -30.294905185073276
            ],
            [
              -53.34290282799902,
              -30.290884759027044
            ],
            [
              -53.3421177834107,
              -30.289176077957396
            ],
            [
              -53.34311217322257,
              -30.28359773681825
            ],
            [
              -53.34358319997556,
              -30.278722970237197
            ],
            [
              -53.34290282799902,
              -30.27560714005137
            ],
            [
              -53.34421123564622,
              -30.27339590572594
            ],
            [
              -53.345781324822866,
              -30.266008372865993
            ],
            [
              -53.344786935010994,
              -30.261686414866297
            ],
            [
              -53.34698505985829,
              -30.258419818703732
            ],
            [
              -53.34839814011727,
              -30.254399392657504
            ],
            [
              -53.350805610188125,
              -30.252891732890166
            ],
            [
              -53.3518,
              -30.24851951956489
            ],
            [
              -53.350491592352796,
              -30.245604710681373
            ],
            [
              -53.34860748534082,
              -30.244700114820972
            ],
            [
              -53.34761309552895,
              -30.243192455053634
            ],
            [
              -53.34829346750549,
              -30.242388369844388
            ],
            [
              -53.34672337832885,
              -30.240177135518962
            ],
            [
              -53.346409360493524,
              -30.238217177821426
            ],
            [
              -53.347194405081844,
              -30.236508496751778
            ],
            [
              -53.3421177834107,
              -30.23289011331017
            ],
            [
              -53.33950096811629,
              -30.227311772171024
            ],
            [
              -53.33500004580991,
              -30.225904623054845
            ],
            [
              -53.33191220376252,
              -30.222989814171328
            ],
            [
              -53.32992342413877,
              -30.218919132799517
            ],
            [
              -53.32992342413877,
              -30.21479819610213
            ],
            [
              -53.32777763559736,
              -30.212385940474395
            ],
            [
              -53.32851034387979,
              -30.205903003474848
            ],
            [
              -53.323224376985095,
              -30.20107849221937
            ],
            [
              -53.32018887124359,
              -30.19399249131289
            ],
            [
              -53.31971784449059,
              -30.190323852545703
            ],
            [
              -53.31521692218421,
              -30.18590138389485
            ],
            [
              -53.31469355912533,
              -30.182182489802088
            ],
            [
              -53.30689544954801,
              -30.172684233267866
            ],
            [
              -53.30412162533594,
              -30.164392104547517
            ],
            [
              -53.30757582152455,
              -30.157105082338724
            ],
            [
              -53.308308529806986,
              -30.151174953920535
            ],
            [
              -53.30658143171268,
              -30.149717549478776
            ],
            [
              -53.30480199731248,
              -30.143787421060583
            ],
            [
              -53.303074899218174,
              -30.141475676084003
            ],
            [
              -53.30328424444173,
              -30.138812143828375
            ],
            [
              -53.30087677437088,
              -30.13650039885179
            ],
            [
              -53.30061509284143,
              -30.134590696479833
            ],
            [
              -53.29820762277058,
              -30.133585589968273
            ],
            [
              -53.29810295015881,
              -30.13177639824747
            ],
            [
              -53.2945964176643,
              -30.131424610968427
            ],
            [
              -53.2945964176643,
              -30.128610312736065
            ],
            [
              -53.29339268262888,
              -30.125997035806016
            ],
            [
              -53.29339268262888,
              -30.124589886689833
            ],
            [
              -53.2919796023699,
              -30.123484269527122
            ],
            [
              -53.28999082274615,
              -30.122680184317876
            ],
            [
              -53.29030484058148,
              -30.121323290527272
            ],
            [
              -53.28857774248717,
              -30.12041869466687
            ],
            [
              -53.287321671145854,
              -30.1174033751322
            ],
            [
              -53.286693635475196,
              -30.114388055597523
            ],
            [
              -53.28501887368678,
              -30.11378499169059
            ],
            [
              -53.282977757757145,
              -30.111020948783807
            ],
            [
              -53.2805179513804,
              -30.108508182504913
            ],
            [
              -53.2787908532861,
              -30.108508182504913
            ],
            [
              -53.27690674627412,
              -30.10388469255175
            ],
            [
              -53.27371423161495,
              -30.10388469255175
            ],
            [
              -53.27120208893232,
              -30.09880890466838
            ],
            [
              -53.2691086366968,
              -30.098607883366068
            ],
            [
              -53.26738153860249,
              -30.097100223598733
            ],
            [
              -53.2660207946494,
              -30.097401755552198
            ],
            [
              -53.26492173222575,
              -30.096296138389487
            ],
            [
              -53.26261893476667,
              -30.095391542529086
            ],
            [
              -53.26408435133154,
              -30.092878776250192
            ],
            [
              -53.26240958954312,
              -30.092024435715366
            ],
            [
              -53.26261893476667,
              -30.09051677594803
            ],
            [
              -53.26000211947227,
              -30.090617286599187
            ],
            [
              -53.257175958954306,
              -30.090215243994564
            ],
            [
              -53.255396524554115,
              -30.089411158785317
            ],
            [
              -53.25372176276569,
              -30.090215243994564
            ],
            [
              -53.25220400989494,
              -30.090215243994564
            ],
            [
              -53.249220840459316,
              -30.08910962683185
            ],
            [
              -53.24670869777669,
              -30.089612180087627
            ],
            [
              -53.24498159968238,
              -30.090818307901497
            ],
            [
              -53.24362085572929,
              -30.09001422269225
            ],
            [
              -53.24178908502321,
              -30.089712690738786
            ],
            [
              -53.23969563278769,
              -30.088707584227226
            ],
            [
              -53.23927694234058,
              -30.086094307297177
            ],
            [
              -53.24011432323479,
              -30.084787668832153
            ],
            [
              -53.23870124297581,
              -30.08348103036713
            ],
            [
              -53.23650311812851,
              -30.08338051971597
            ],
            [
              -53.23498536525776,
              -30.080918008762655
            ],
            [
              -53.235613400928415,
              -30.07719911466989
            ],
            [
              -53.23728816271683,
              -30.0755909442514
            ],
            [
              -53.23629377290496,
              -30.07438481643753
            ],
            [
              -53.23362462130466,
              -30.07508839099562
            ],
            [
              -53.23027509772783,
              -30.073580731228283
            ],
            [
              -53.2303797703396,
              -30.07061566701919
            ],
            [
              -53.22839099071585,
              -30.06961056050763
            ],
            [
              -53.22739660090398,
              -30.070716177670345
            ],
            [
              -53.22430875885658,
              -30.069108007251852
            ],
            [
              -53.22331436904471,
              -30.069811581809944
            ],
            [
              -53.2202788633032,
              -30.06518809185678
            ],
            [
              -53.21991250916198,
              -30.062625070252306
            ],
            [
              -53.218499428903,
              -30.06031332527572
            ],
            [
              -53.21211439958466,
              -30.058403622903764
            ],
            [
              -53.20939291167847,
              -30.05589085662487
            ],
            [
              -53.20860786709015,
              -30.053579111648286
            ],
            [
              -53.208974221231365,
              -30.049910472881102
            ],
            [
              -53.20499666198387,
              -30.043075748602508
            ],
            [
              -53.201699474712925,
              -30.041819365463063
            ],
            [
              -53.20028639445394,
              -30.04282447197462
            ],
            [
              -53.194686409723914,
              -30.042924982625777
            ],
            [
              -53.19411071035915,
              -30.040814258951507
            ],
            [
              -53.19217426704129,
              -30.03880404592839
            ],
            [
              -53.19217426704129,
              -30.036492300951807
            ],
            [
              -53.19369201991204,
              -30.036090258347183
            ],
            [
              -53.19489575494747,
              -30.034180555975226
            ],
            [
              -53.19322099315905,
              -30.029707831998792
            ],
            [
              -53.19269763010017,
              -30.027195065719898
            ],
            [
              -53.19102286831175,
              -30.028200172231458
            ],
            [
              -53.189191097605665,
              -30.028200172231458
            ],
            [
              -53.188720070852675,
              -30.026592001812965
            ],
            [
              -53.18720231798192,
              -30.025184852696782
            ],
            [
              -53.18568456511116,
              -30.024883320743317
            ],
            [
              -53.18547521988761,
              -30.021415703278443
            ],
            [
              -53.18437615746396,
              -30.02101366067382
            ],
            [
              -53.18249205045199,
              -30.02121468197613
            ],
            [
              -53.17579300329831,
              -30.01840038374377
            ],
            [
              -53.17710141094551,
              -30.01739527723221
            ],
            [
              -53.17699673833374,
              -30.01528455355794
            ],
            [
              -53.17788645553384,
              -30.013475361837138
            ],
            [
              -53.17579300329831,
              -30.012118468046534
            ],
            [
              -53.176892065721965,
              -30.009505191116485
            ],
            [
              -53.17642103896897,
              -30.00749497809337
            ],
            [
              -53.175374312851204,
              -30.00699242483759
            ],
            [
              -53.17139675360371,
              -30.006590382232968
            ],
            [
              -53.16877993830931,
              -30.005685786372567
            ],
            [
              -53.16537807842658,
              -30.003524807372717
            ],
            [
              -53.164383688614706,
              -30.00181612630307
            ],
            [
              -53.16459303383826,
              -29.999906423931108
            ],
            [
              -53.16820423894454,
              -29.999604891977643
            ],
            [
              -53.168308911556316,
              -29.997695189605682
            ],
            [
              -53.16720984913266,
              -29.994780380722165
            ],
            [
              -53.164383688614706,
              -29.99251889107116
            ],
            [
              -53.16019678414366,
              -29.99282042302463
            ],
            [
              -53.15962108477889,
              -29.992217359117692
            ],
            [
              -53.15857435866113,
              -29.989302550234175
            ],
            [
              -53.15710894209626,
              -29.987493358513372
            ],
            [
              -53.154806144637185,
              -29.98588518809488
            ],
            [
              -53.15349773698998,
              -29.9844780389787
            ],
            [
              -53.150880921695574,
              -29.98518161353679
            ],
            [
              -53.14999120449548,
              -29.983623698443875
            ],
            [
              -53.1485781242365,
              -29.98352318779272
            ],
            [
              -53.14627532677742,
              -29.98467906028101
            ],
            [
              -53.143292157341804,
              -29.980708889560358
            ],
            [
              -53.14271645797703,
              -29.9787991871884
            ],
            [
              -53.14030898790618,
              -29.97759305937453
            ],
            [
              -53.139523943317855,
              -29.976085399607193
            ],
            [
              -53.13748282738822,
              -29.974577739839855
            ],
            [
              -53.1340809675055,
              -29.972718292793473
            ],
            [
              -53.13198751526997,
              -29.973220846049255
            ],
            [
              -53.12821930124603,
              -29.97141165432845
            ],
            [
              -53.12670154837527,
              -29.97020552651458
            ],
            [
              -53.12680622098705,
              -29.969300930654178
            ],
            [
              -53.1257071585634,
              -29.968295824142622
            ],
            [
              -53.12288099804544,
              -29.970306037165738
            ],
            [
              -53.118275403127285,
              -29.97141165432845
            ],
            [
              -53.11419317126801,
              -29.971914207584227
            ],
            [
              -53.11209971903249,
              -29.971713186281917
            ],
            [
              -53.10880253176154,
              -29.97020552651458
            ],
            [
              -53.10691842474957,
              -29.97000450521227
            ],
            [
              -53.103516564866844,
              -29.970306037165738
            ],
            [
              -53.102417502443195,
              -29.968195313491467
            ],
            [
              -53.10309787441974,
              -29.965984079166038
            ],
            [
              -53.10032405020767,
              -29.963722589515033
            ],
            [
              -53.09749788968971,
              -29.96342105756157
            ],
            [
              -53.09671284510139,
              -29.96427539809639
            ],
            [
              -53.09660817248962,
              -29.96638612177066
            ],
            [
              -53.095404437454185,
              -29.966989185677598
            ],
            [
              -53.09079884253603,
              -29.965883568514883
            ],
            [
              -53.08881006291229,
              -29.96497897265448
            ],
            [
              -53.08792034571219,
              -29.963521568212723
            ],
            [
              -53.08969978011238,
              -29.961611865840762
            ],
            [
              -53.091688559736134,
              -29.961611865840762
            ],
            [
              -53.09388668458343,
              -29.962717483003477
            ],
            [
              -53.09587546420718,
              -29.96241595105001
            ],
            [
              -53.09618948204251,
              -29.961310333887297
            ],
            [
              -53.09451472025409,
              -29.95889807825956
            ],
            [
              -53.09451472025409,
              -29.957792461096844
            ],
            [
              -53.09582312790129,
              -29.95668684393413
            ],
            [
              -53.098492279501585,
              -29.95598326937604
            ],
            [
              -53.09891096994869,
              -29.954224332980814
            ],
            [
              -53.096922190324946,
              -29.950706460190364
            ],
            [
              -53.09728854446616,
              -29.94859573651609
            ],
            [
              -53.09870162472514,
              -29.947389608702224
            ],
            [
              -53.09650349987784,
              -29.945178374376795
            ],
            [
              -53.094776401783534,
              -29.942112799516543
            ],
            [
              -53.094619392865866,
              -29.938594926726093
            ],
            [
              -53.093782011971655,
              -29.937589820214537
            ],
            [
              -53.09210725018324,
              -29.937087266958756
            ],
            [
              -53.08980445272416,
              -29.935680117842576
            ],
            [
              -53.083105405570485,
              -29.93372016014504
            ],
            [
              -53.08158765269973,
              -29.931910968424233
            ],
            [
              -53.08137830747618,
              -29.930503819308054
            ],
            [
              -53.082320360982166,
              -29.92919718084303
            ],
            [
              -53.08399512277058,
              -29.930805351261522
            ],
            [
              -53.08692595590031,
              -29.931709947121924
            ],
            [
              -53.08849604507696,
              -29.93150892581961
            ],
            [
              -53.09121753298314,
              -29.93010177670343
            ],
            [
              -53.09320631260689,
              -29.928091563680315
            ],
            [
              -53.09451472025409,
              -29.927589010424537
            ],
            [
              -53.099800687148786,
              -29.92708645716876
            ],
            [
              -53.103987591619834,
              -29.926985946517604
            ],
            [
              -53.10801748717322,
              -29.927186967819914
            ],
            [
              -53.113408126679694,
              -29.92708645716876
            ],
            [
              -53.114402516491566,
              -29.92678492521529
            ],
            [
              -53.117490358538966,
              -29.92442292491313
            ],
            [
              -53.11921745663327,
              -29.92251322254117
            ],
            [
              -53.11989782860982,
              -29.919799434959966
            ],
            [
              -53.11958381077449,
              -29.914924668378912
            ],
            [
              -53.11921745663327,
              -29.912713434053483
            ],
            [
              -53.11989782860982,
              -29.90432079468198
            ],
            [
              -53.12078754580992,
              -29.89999883668228
            ],
            [
              -53.120892218421695,
              -29.895777389333738
            ],
            [
              -53.11900811140972,
              -29.8876862819157
            ],
            [
              -53.11869409357439,
              -29.884218664450824
            ],
            [
              -53.11769970376252,
              -29.88029874905575
            ],
            [
              -53.11660064133887,
              -29.877383940172233
            ],
            [
              -53.11330345406792,
              -29.873212748149268
            ],
            [
              -53.11131467444417,
              -29.86919232210304
            ],
            [
              -53.11110532922062,
              -29.865774959963744
            ],
            [
              -53.11021561202052,
              -29.859593554917662
            ],
            [
              -53.109221222208646,
              -29.855221341592387
            ],
            [
              -53.10948290373809,
              -29.852206022057715
            ],
            [
              -53.111000656608844,
              -29.847683042755705
            ],
            [
              -53.112623082091375,
              -29.845019510500077
            ],
            [
              -53.116181950891765,
              -29.84160214836078
            ],
            [
              -53.118118394209624,
              -29.838687339477264
            ],
            [
              -53.120107173833375,
              -29.83501870071008
            ],
            [
              -53.12549781333985,
              -29.832304913128873
            ],
            [
              -53.129684717810896,
              -29.829892657501134
            ],
            [
              -53.13617441974102,
              -29.82592248678048
            ],
            [
              -53.139105252870756,
              -29.824414827013147
            ],
            [
              -53.1424024401417,
              -29.822304103338876
            ],
            [
              -53.14721738028341,
              -29.819891847711137
            ],
            [
              -53.15229400195455,
              -29.81768061338571
            ],
            [
              -53.157213614708034,
              -29.816323719595108
            ],
            [
              -53.15930706694356,
              -29.815117591781238
            ],
            [
              -53.161295846567306,
              -29.812906357455812
            ],
            [
              -53.16260425421451,
              -29.81009205922345
            ],
            [
              -53.16328462619106,
              -29.807378271642243
            ],
            [
              -53.164383688614706,
              -29.80230248375888
            ],
            [
              -53.16511639689714,
              -29.80009124943345
            ],
            [
              -53.16480237906181,
              -29.798081036410334
            ],
            [
              -53.16380798924994,
              -29.795518014805864
            ],
            [
              -53.16401733447349,
              -29.794311886991995
            ],
            [
              -53.16569209626191,
              -29.789286354434207
            ],
            [
              -53.16558742365013,
              -29.786421800876266
            ],
            [
              -53.16448836122648,
              -29.784713119806618
            ],
            [
              -53.161295846567306,
              -29.782903928085815
            ],
            [
              -53.16108650134375,
              -29.780190140504608
            ],
            [
              -53.16328462619106,
              -29.777225076295515
            ],
            [
              -53.165482751038354,
              -29.77541588457471
            ],
            [
              -53.171815444050814,
              -29.772501075691192
            ],
            [
              -53.17349020583924,
              -29.77039035201692
            ],
            [
              -53.17448459565111,
              -29.769686777458833
            ],
            [
              -53.16930330136819,
              -29.768480649644964
            ],
            [
              -53.17228647080381,
              -29.76737503248225
            ],
            [
              -53.17600234852186,
              -29.76350537241275
            ],
            [
              -53.18280606828732,
              -29.76501303218009
            ],
            [
              -53.18542288358172,
              -29.76692273455205
            ],
            [
              -53.18688830014659,
              -29.766018138691646
            ],
            [
              -53.18819670779379,
              -29.76621915999396
            ],
            [
              -53.1886153982409,
              -29.765113542831244
            ],
            [
              -53.19018548741754,
              -29.764309457621998
            ],
            [
              -53.192592957488394,
              -29.763706393715065
            ],
            [
              -53.197774251771314,
              -29.764912521528935
            ],
            [
              -53.200705084901045,
              -29.76380690436622
            ],
            [
              -53.20290320974835,
              -29.76189720199426
            ],
            [
              -53.20677609638407,
              -29.76119362743617
            ],
            [
              -53.208974221231365,
              -29.758781371808432
            ],
            [
              -53.20729945944295,
              -29.755213243692403
            ],
            [
              -53.2070901142194,
              -29.752499456111195
            ],
            [
              -53.20949758429025,
              -29.75028822178577
            ],
            [
              -53.20991627473735,
              -29.746619583018585
            ],
            [
              -53.209288239066694,
              -29.74551396585587
            ],
            [
              -53.210910664549225,
              -29.743302731530445
            ],
            [
              -53.21258542633765,
              -29.742297625018885
            ],
            [
              -53.213213462008305,
              -29.740689454600396
            ],
            [
              -53.21551625946738,
              -29.739282305484213
            ],
            [
              -53.21687700342047,
              -29.739382816135368
            ],
            [
              -53.220174190691424,
              -29.73410600694969
            ],
            [
              -53.22080222636208,
              -29.73058813415924
            ],
            [
              -53.21797606584412,
              -29.726718474089743
            ],
            [
              -53.20991627473735,
              -29.719582217857685
            ],
            [
              -53.2097069295138,
              -29.71309928085814
            ],
            [
              -53.208189176643046,
              -29.7106870252304
            ],
            [
              -53.21070131932568,
              -29.706917875812056
            ],
            [
              -53.21112000977278,
              -29.704807152137786
            ],
            [
              -53.2127947715612,
              -29.70400306692854
            ],
            [
              -53.21331813462008,
              -29.701490300649645
            ],
            [
              -53.204106944783774,
              -29.69329868258045
            ],
            [
              -53.20389759956022,
              -29.669477658256536
            ],
            [
              -53.18762100842902,
              -29.669678679558846
            ],
            [
              -53.186783627534815,
              -29.631987185375436
            ],
            [
              -53.154125772660635,
              -29.63259024928237
            ],
            [
              -53.15391642743708,
              -29.62640884423629
            ],
            [
              -53.15072391277791,
              -29.626509354887446
            ],
            [
              -53.15051456755436,
              -29.612588629702373
            ],
            [
              -53.14512392804789,
              -29.612588629702373
            ],
            [
              -53.14517626435377,
              -29.608216416377097
            ],
            [
              -53.1366977827999,
              -29.608216416377097
            ],
            [
              -53.13648843757635,
              -29.559116963287508
            ],
            [
              -53.10571468971414,
              -29.559016452636353
            ],
            [
              -53.10131844001954,
              -29.558011346124793
            ],
            [
              -53.099277324089904,
              -29.559116963287508
            ],
            [
              -53.09320631260689,
              -29.558212367427107
            ],
            [
              -53.08792034571219,
              -29.559217473938663
            ],
            [
              -53.083105405570485,
              -29.558111856775948
            ],
            [
              -53.075307295993156,
              -29.55881543133404
            ],
            [
              -53.072899825922306,
              -29.55951900589213
            ],
            [
              -53.0702830106279,
              -29.563489176612784
            ],
            [
              -53.068817594063034,
              -29.5645947937755
            ],
            [
              -53.05808865135597,
              -29.569620326333286
            ],
            [
              -53.0575129519912,
              -29.56781113461248
            ],
            [
              -53.05641388956755,
              -29.56690653875208
            ],
            [
              -53.056309216955775,
              -29.564795815077808
            ],
            [
              -53.05411109210848,
              -29.55972002719444
            ],
            [
              -53.052279321402395,
              -29.558011346124793
            ],
            [
              -53.05107558636696,
              -29.557307771566705
            ],
            [
              -53.048720452602,
              -29.554795005287808
            ],
            [
              -53.04338214940142,
              -29.553588877473942
            ],
            [
              -53.04029430735402,
              -29.555096537241276
            ],
            [
              -53.03820085511849,
              -29.555096537241276
            ],
            [
              -53.03631674810652,
              -29.554493473334343
            ],
            [
              -53.03291488822379,
              -29.55499602659012
            ],
            [
              -53.02888499267041,
              -29.553990920078565
            ],
            [
              -53.02919901050574,
              -29.55318683486932
            ],
            [
              -53.03301956083557,
              -29.552784792264696
            ],
            [
              -53.03411862325922,
              -29.550322281311377
            ],
            [
              -53.037991509894944,
              -29.54740747242786
            ],
            [
              -53.05170362203762,
              -29.540623003474845
            ],
            [
              -53.05787930613242,
              -29.54032147152138
            ],
            [
              -53.06117649340337,
              -29.53821074784711
            ],
            [
              -53.063793308697775,
              -29.53911534370751
            ],
            [
              -53.06949796603958,
              -29.53770819459133
            ],
            [
              -53.07038768323967,
              -29.53650206677746
            ],
            [
              -53.07038768323967,
              -29.53479338570781
            ],
            [
              -53.07342318898119,
              -29.53268266203354
            ],
            [
              -53.07541196860493,
              -29.529516576522134
            ],
            [
              -53.0768773851698,
              -29.528511470010578
            ],
            [
              -53.082791387735156,
              -29.52700381024324
            ],
            [
              -53.08430914060591,
              -29.52730534219671
            ],
            [
              -53.08661193806498,
              -29.529818108475602
            ],
            [
              -53.093782011971655,
              -29.528712491312888
            ],
            [
              -53.09587546420718,
              -29.524792575917814
            ],
            [
              -53.094776401783534,
              -29.52338542680163
            ],
            [
              -53.09660817248962,
              -29.520219341290225
            ],
            [
              -53.09660817248962,
              -29.516399936546307
            ],
            [
              -53.115606251527,
              -29.505796062849374
            ],
            [
              -53.12152025409235,
              -29.503182785919325
            ],
            [
              -53.125916503786954,
              -29.502479211361234
            ],
            [
              -53.12617818531639,
              -29.499815679105605
            ],
            [
              -53.1292136910579,
              -29.49881057259405
            ],
            [
              -53.128376310163695,
              -29.49639831696631
            ],
            [
              -53.13088845284632,
              -29.49669984891978
            ],
            [
              -53.13481367578793,
              -29.495795253059377
            ],
            [
              -53.13701180063523,
              -29.494790146547817
            ],
            [
              -53.180084580381134,
              -29.470918866898323
            ],
            [
              -53.184323821158074,
              -29.467400994107873
            ],
            [
              -53.18960978805277,
              -29.467099462154405
            ],
            [
              -53.192278939653065,
              -29.46790354736365
            ],
            [
              -53.19447706450036,
              -29.467501504759028
            ],
            [
              -53.1974078976301,
              -29.465692313038225
            ],
            [
              -53.19981536770095,
              -29.466395887596317
            ],
            [
              -53.20227517407769,
              -29.465993844991694
            ],
            [
              -53.203478909113116,
              -29.466596908898627
            ],
            [
              -53.2044209626191,
              -29.468707632572897
            ],
            [
              -53.20672376007818,
              -29.468506611270588
            ],
            [
              -53.211591036525775,
              -29.47061733494486
            ],
            [
              -53.21342280723186,
              -29.46941120713099
            ],
            [
              -53.21902279196188,
              -29.46840610061943
            ],
            [
              -53.22012185438553,
              -29.467099462154405
            ],
            [
              -53.225093803444906,
              -29.46840610061943
            ],
            [
              -53.225878848033226,
              -29.46679793020094
            ],
            [
              -53.22451810408013,
              -29.464988738480134
            ],
            [
              -53.22692557415099,
              -29.464988738480134
            ],
            [
              -53.22739660090398,
              -29.466194866294003
            ],
            [
              -53.230222761421935,
              -29.46468720652667
            ],
            [
              -53.231374160151475,
              -29.465491291735912
            ],
            [
              -53.23341527608111,
              -29.464787717177824
            ],
            [
              -53.235299383093086,
              -29.465290270433602
            ],
            [
              -53.24021899584656,
              -29.461119078410636
            ],
            [
              -53.24231244808209,
              -29.45800324822481
            ],
            [
              -53.24341151050574,
              -29.45750069496903
            ],
            [
              -53.24560963535304,
              -29.457902737573654
            ],
            [
              -53.24649935255314,
              -29.455993035201693
            ],
            [
              -53.24901149523576,
              -29.45589252455054
            ],
            [
              -53.24911616784754,
              -29.451922353829886
            ],
            [
              -53.25058158441241,
              -29.450414694062548
            ],
            [
              -53.25372176276569,
              -29.45021367276024
            ],
            [
              -53.25387877168336,
              -29.449108055597524
            ],
            [
              -53.255710542389444,
              -29.448907034295214
            ],
            [
              -53.25607689653066,
              -29.4478014171325
            ],
            [
              -53.2616245449548,
              -29.44749988517903
            ],
            [
              -53.263194634131445,
              -29.449409587550992
            ],
            [
              -53.26539275897874,
              -29.449309076899837
            ],
            [
              -53.263822669802096,
              -29.44609273606285
            ],
            [
              -53.26649182140239,
              -29.44468558694667
            ],
            [
              -53.27821515392132,
              -29.447600395830186
            ],
            [
              -53.28172168641583,
              -29.44729886387672
            ],
            [
              -53.28528055521622,
              -29.44418303369089
            ],
            [
              -53.287374007451746,
              -29.439207756458682
            ],
            [
              -53.286222608722206,
              -29.435589373017073
            ],
            [
              -53.279418888956755,
              -29.430111542529083
            ],
            [
              -53.276017029074026,
              -29.429106436017527
            ],
            [
              -53.27282451441485,
              -29.429106436017527
            ],
            [
              -53.269684336061566,
              -29.43041307448255
            ],
            [
              -53.26507874114341,
              -29.434182223900894
            ],
            [
              -53.26110118189592,
              -29.434885798458982
            ],
            [
              -53.25769932201319,
              -29.43277507478471
            ],
            [
              -53.25079092963596,
              -29.42428192476205
            ],
            [
              -53.24948252198876,
              -29.42478447801783
            ],
            [
              -53.244405900317616,
              -29.42262349901798
            ],
            [
              -53.24142273088199,
              -29.41669337059979
            ],
            [
              -53.238177879916925,
              -29.411919114669892
            ],
            [
              -53.23420032066943,
              -29.409205327088685
            ],
            [
              -53.23111247862204,
              -29.40769766732135
            ],
            [
              -53.228600335939404,
              -29.40528541169361
            ],
            [
              -53.2272919282922,
              -29.403023922042607
            ],
            [
              -53.22708258306865,
              -29.40101370901949
            ],
            [
              -53.22791996396286,
              -29.39488255929899
            ],
            [
              -53.22771061873931,
              -29.391716473787582
            ],
            [
              -53.22577417542145,
              -29.387595537090196
            ],
            [
              -53.22629753848033,
              -29.38397715364859
            ],
            [
              -53.22640221109211,
              -29.38040902553256
            ],
            [
              -53.22561716650378,
              -29.37779574860251
            ],
            [
              -53.22122091680919,
              -29.374378386463214
            ],
            [
              -53.220174190691424,
              -29.372418428765677
            ],
            [
              -53.21991250916198,
              -29.369905662486783
            ],
            [
              -53.220697553750306,
              -29.36729238555673
            ],
            [
              -53.2224769881505,
              -29.364880129928995
            ],
            [
              -53.22839099071585,
              -29.360909959208342
            ],
            [
              -53.230589115563156,
              -29.358698724882913
            ],
            [
              -53.23200219582213,
              -29.355381873394773
            ],
            [
              -53.23210686843391,
              -29.35241680918568
            ],
            [
              -53.23100780601026,
              -29.350105064209096
            ],
            [
              -53.23027509772783,
              -29.3466877020698
            ],
            [
              -53.231374160151475,
              -29.343823148511863
            ],
            [
              -53.233676957610555,
              -29.342516510046835
            ],
            [
              -53.237706853163935,
              -29.341410892884124
            ],
            [
              -53.239486287564134,
              -29.340405786372564
            ],
            [
              -53.24069002259956,
              -29.338797615954075
            ],
            [
              -53.24178908502321,
              -29.336083828372868
            ],
            [
              -53.24178908502321,
              -29.334224381326486
            ],
            [
              -53.24058534998778,
              -29.332817232210306
            ],
            [
              -53.238491897752255,
              -29.332314678954525
            ],
            [
              -53.23550872831664,
              -29.333621317419553
            ],
            [
              -53.23399097544588,
              -29.333721828070708
            ],
            [
              -53.23242088626924,
              -29.332817232210306
            ],
            [
              -53.230589115563156,
              -29.33080701918719
            ],
            [
              -53.22849566332763,
              -29.327590678350205
            ],
            [
              -53.22802463657464,
              -29.324525103489954
            ],
            [
              -53.229123698998286,
              -29.32321846502493
            ],
            [
              -53.234619011116536,
              -29.320404166792567
            ],
            [
              -53.23587508245785,
              -29.319198038978698
            ],
            [
              -53.236084427681405,
              -29.31728833660674
            ],
            [
              -53.23388630283411,
              -29.31422276174649
            ],
            [
              -53.23147883276325,
              -29.312011527421063
            ],
            [
              -53.230222761421935,
              -29.310202335700257
            ],
            [
              -53.23001341619838,
              -29.3091972291887
            ],
            [
              -53.231688177986804,
              -29.3073880374679
            ],
            [
              -53.236398445516734,
              -29.304322462607647
            ],
            [
              -53.24032366845834,
              -29.299698972654483
            ],
            [
              -53.24571430796482,
              -29.296583142468652
            ],
            [
              -53.2470750519179,
              -29.294020120864182
            ],
            [
              -53.247598414976785,
              -29.29211041849222
            ],
            [
              -53.24749374236501,
              -29.28808999244599
            ],
            [
              -53.24649935255314,
              -29.286582332678655
            ],
            [
              -53.24398720987051,
              -29.284421353678805
            ],
            [
              -53.24231244808209,
              -29.284119821725337
            ],
            [
              -53.23859657036403,
              -29.284421353678805
            ],
            [
              -53.237392835328606,
              -29.282612161958003
            ],
            [
              -53.23781152577571,
              -29.27889326786524
            ],
            [
              -53.23938161495236,
              -29.27462156519112
            ],
            [
              -53.24121338565844,
              -29.270400117842577
            ],
            [
              -53.24142273088199,
              -29.268490415470616
            ],
            [
              -53.24021899584656,
              -29.26462075540112
            ],
            [
              -53.23911993342291,
              -29.263414627587252
            ],
            [
              -53.236921808575616,
              -29.262510031726848
            ],
            [
              -53.23451433850476,
              -29.26321360628494
            ],
            [
              -53.23242088626924,
              -29.264319223447654
            ],
            [
              -53.229123698998286,
              -29.2673847983079
            ],
            [
              -53.22682090153921,
              -29.271103692400665
            ],
            [
              -53.224884458221354,
              -29.273314926726094
            ],
            [
              -53.22268633337405,
              -29.274018501284182
            ],
            [
              -53.21431252443195,
              -29.27341543737725
            ],
            [
              -53.21269009894942,
              -29.272410330865693
            ],
            [
              -53.21028262887857,
              -29.270199096540264
            ],
            [
              -53.208974221231365,
              -29.266681223749814
            ],
            [
              -53.21080599193745,
              -29.26411820214534
            ],
            [
              -53.213998506596624,
              -29.262208499773383
            ],
            [
              -53.221482598338625,
              -29.258590116331774
            ],
            [
              -53.22462277669191,
              -29.255876328750567
            ],
            [
              -53.22708258306865,
              -29.254519434959967
            ],
            [
              -53.23001341619838,
              -29.2542179030065
            ],
            [
              -53.23320593085756,
              -29.255323520169213
            ],
            [
              -53.235613400928415,
              -29.25718296721559
            ],
            [
              -53.23760218055216,
              -29.256780924610972
            ],
            [
              -53.238491897752255,
              -29.254016881704185
            ],
            [
              -53.23760218055216,
              -29.25160462607645
            ],
            [
              -53.23362462130466,
              -29.2498959450068
            ],
            [
              -53.23200219582213,
              -29.247785221332528
            ],
            [
              -53.232682567798676,
              -29.245423221030368
            ],
            [
              -53.23498536525776,
              -29.242910454751474
            ],
            [
              -53.23922460603469,
              -29.241000752379517
            ],
            [
              -53.243516183117514,
              -29.240297177821425
            ],
            [
              -53.24702271561202,
              -29.24039768847258
            ],
            [
              -53.249377849376984,
              -29.238487986100623
            ],
            [
              -53.249901212435866,
              -29.234919857984593
            ],
            [
              -53.24812177803567,
              -29.226074920682883
            ],
            [
              -53.24780776020034,
              -29.221803218008766
            ],
            [
              -53.24801710542389,
              -29.218084323916003
            ],
            [
              -53.24911616784754,
              -29.214817727753438
            ],
            [
              -53.249377849376984,
              -29.21170189756761
            ],
            [
              -53.24812177803567,
              -29.20908862063756
            ],
            [
              -53.245504962741265,
              -29.208184024777157
            ],
            [
              -53.24341151050574,
              -29.206877386312133
            ],
            [
              -53.242574129611526,
              -29.205218960568065
            ],
            [
              -53.24231244808209,
              -29.201801598428766
            ],
            [
              -53.24252179330564,
              -29.199188321498717
            ],
            [
              -53.243882537258735,
              -29.195921725336156
            ],
            [
              -53.245504962741265,
              -29.19360998035957
            ],
            [
              -53.24801710542389,
              -29.192303341894547
            ],
            [
              -53.25047691180063,
              -29.19300691645264
            ],
            [
              -53.25188999205961,
              -29.195519682731533
            ],
            [
              -53.253407744930364,
              -29.196876576522136
            ],
            [
              -53.25550119716589,
              -29.1971781084756
            ],
            [
              -53.2603161373076,
              -29.197077597824446
            ],
            [
              -53.26261893476667,
              -29.196575044568668
            ],
            [
              -53.26570677681407,
              -29.193811001661885
            ],
            [
              -53.26670116662594,
              -29.192303341894547
            ],
            [
              -53.266596494014166,
              -29.190695171476055
            ],
            [
              -53.261676881260684,
              -29.188986490406407
            ],
            [
              -53.25968810163694,
              -29.18798138389485
            ],
            [
              -53.25790866723674,
              -29.184815298383445
            ],
            [
              -53.25837969398974,
              -29.179287212569875
            ],
            [
              -53.257018950036645,
              -29.177478020849072
            ],
            [
              -53.25079092963596,
              -29.17828210605832
            ],
            [
              -53.244405900317616,
              -29.17592010575616
            ],
            [
              -53.243516183117514,
              -29.171698658407617
            ],
            [
              -53.24309749267041,
              -29.168582828221787
            ],
            [
              -53.24377786464696,
              -29.167175679105608
            ],
            [
              -53.247284397141456,
              -29.16692440247772
            ],
            [
              -53.25168064683606,
              -29.170090487989125
            ],
            [
              -53.253407744930364,
              -29.170492530593748
            ],
            [
              -53.255082506718786,
              -29.169587934733347
            ],
            [
              -53.257018950036645,
              -29.16682389182656
            ],
            [
              -53.25869371182507,
              -29.16240142317571
            ],
            [
              -53.25801333984852,
              -29.155415932920384
            ],
            [
              -53.258118012460294,
              -29.15280265599033
            ],
            [
              -53.25869371182507,
              -29.150088868409128
            ],
            [
              -53.25989744686049,
              -29.14712380420003
            ],
            [
              -53.261415199731246,
              -29.14430950596767
            ],
            [
              -53.260106792084045,
              -29.143304399456113
            ],
            [
              -53.258484366601515,
              -29.13938448406104
            ],
            [
              -53.254611479965796,
              -29.13631890920079
            ],
            [
              -53.25298905448326,
              -29.136117887898475
            ],
            [
              -53.24037600476423,
              -29.137876824293702
            ],
            [
              -53.23671246335206,
              -29.141193675781842
            ],
            [
              -53.23519471048131,
              -29.141394697084152
            ],
            [
              -53.22430875885658,
              -29.138278866898325
            ],
            [
              -53.21891811935011,
              -29.13767580299139
            ],
            [
              -53.21682466711459,
              -29.135715845293852
            ],
            [
              -53.21357981614952,
              -29.13631890920079
            ],
            [
              -53.20808450403127,
              -29.139987547967973
            ],
            [
              -53.20520600720742,
              -29.137022483758876
            ],
            [
              -53.20227517407769,
              -29.137776313642547
            ],
            [
              -53.196308835206445,
              -29.137525037014658
            ],
            [
              -53.19489575494747,
              -29.133705632270736
            ],
            [
              -53.192278939653065,
              -29.132600015108025
            ],
            [
              -53.19107520461764,
              -29.133203079014958
            ],
            [
              -53.190813523088195,
              -29.130489291433754
            ],
            [
              -53.18960978805277,
              -29.130690312736064
            ],
            [
              -53.188406053017346,
              -29.132499504456867
            ],
            [
              -53.186103255558265,
              -29.13028827013144
            ],
            [
              -53.18327709504031,
              -29.13179592989878
            ],
            [
              -53.17610702113364,
              -29.13149439794531
            ],
            [
              -53.17301917908624,
              -29.13300205771265
            ],
            [
              -53.16998367334473,
              -29.133203079014958
            ],
            [
              -53.16370331663816,
              -29.13722350506119
            ],
            [
              -53.15899304910823,
              -29.135715845293852
            ],
            [
              -53.15621922489616,
              -29.133504610968426
            ],
            [
              -53.15600987967261,
              -29.13239899380571
            ],
            [
              -53.150880921695574,
              -29.13179592989878
            ],
            [
              -53.14721738028341,
              -29.129986738177973
            ],
            [
              -53.14140805032983,
              -29.13079082338722
            ],
            [
              -53.138581889811874,
              -29.133102568363803
            ],
            [
              -53.1380061904471,
              -29.13461022813114
            ],
            [
              -53.13507535731737,
              -29.13631890920079
            ],
            [
              -53.132406205717075,
              -29.140691122526064
            ],
            [
              -53.13052209870511,
              -29.141796739688775
            ],
            [
              -53.130103408258,
              -29.143404910107268
            ],
            [
              -53.127695938187145,
              -29.14380695271189
            ],
            [
              -53.126910893598826,
              -29.145214101828074
            ],
            [
              -53.122619316516,
              -29.146822272246563
            ],
            [
              -53.12188660823357,
              -29.14501308052576
            ],
            [
              -53.118589420962614,
              -29.146118697688475
            ],
            [
              -53.11759503115074,
              -29.145415123130384
            ],
            [
              -53.115082888468116,
              -29.147978144734857
            ],
            [
              -53.113774480820915,
              -29.1478776340837
            ],
            [
              -53.111000656608844,
              -29.14551563378154
            ],
            [
              -53.10728477889079,
              -29.144611037921138
            ],
            [
              -53.09938199670168,
              -29.141193675781842
            ],
            [
              -53.097707234913265,
              -29.138982441456417
            ],
            [
              -53.09430537503054,
              -29.139887037316818
            ],
            [
              -53.094096029806984,
              -29.142801846200335
            ],
            [
              -53.095404437454185,
              -29.144912569874606
            ],
            [
              -53.09561378267774,
              -29.146822272246563
            ],
            [
              -53.094096029806984,
              -29.147576102130234
            ],
            [
              -53.09132220559491,
              -29.147324825502345
            ],
            [
              -53.09079884253603,
              -29.148279676688322
            ],
            [
              -53.09147921451258,
              -29.14998835775797
            ],
            [
              -53.088600717688735,
              -29.151294996222997
            ],
            [
              -53.08839137246518,
              -29.154611847711138
            ],
            [
              -53.08661193806498,
              -29.155817975525004
            ],
            [
              -53.08409979538236,
              -29.156018996827317
            ],
            [
              -53.08289606034693,
              -29.16139631666415
            ],
            [
              -53.079494200464204,
              -29.16189886991993
            ],
            [
              -53.078185792817,
              -29.163909082943043
            ],
            [
              -53.07310917114586,
              -29.165617764012694
            ],
            [
              -53.068974602980695,
              -29.169185892128723
            ],
            [
              -53.06907927559247,
              -29.170693551896058
            ],
            [
              -53.071277400439776,
              -29.17260325426802
            ],
            [
              -53.0724811354752,
              -29.17777955280254
            ],
            [
              -53.0667764781334,
              -29.1805938510349
            ],
            [
              -53.06389798130955,
              -29.18179997884877
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "mesorregiao_nome": "Metropolitana de Porto Alegre",
        "mesorregiao_id": 4305,
        "num_municipios": 98
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -51.3504915814288,
                -29.351926011560693
              ],
              [
                -51.3503820600927,
                -29.345320158959538
              ],
              [
                -51.35268200815087,
                -29.333084971098266
              ],
              [
                -51.336472850407546,
                -29.33302752890173
              ],
              [
                -51.30942108038996,
                -29.323204913294795
              ],
              [
                -51.304273577593094,
                -29.322975144508668
              ],
              [
                -51.30148078352246,
                -29.31912651734104
              ],
              [
                -51.298687989451814,
                -29.31757557803468
              ],
              [
                -51.29118577792872,
                -29.31780534682081
              ],
              [
                -51.285819232459644,
                -29.319011632947976
              ],
              [
                -51.282807395716794,
                -29.318609537572254
              ],
              [
                -51.26971959605242,
                -29.31280787572254
              ],
              [
                -51.263805443902825,
                -29.3130950867052
              ],
              [
                -51.2583841377657,
                -29.31148670520231
              ],
              [
                -51.25958887246284,
                -29.31051018786127
              ],
              [
                -51.25991743647115,
                -29.308786921965318
              ],
              [
                -51.263805443902825,
                -29.308786921965318
              ],
              [
                -51.265503024612435,
                -29.307523193641618
              ],
              [
                -51.26829581868307,
                -29.307178540462427
              ],
              [
                -51.27191002277449,
                -29.3044213150289
              ],
              [
                -51.2768932435672,
                -29.304191546242773
              ],
              [
                -51.27979555897395,
                -29.29959617052023
              ],
              [
                -51.27952175563369,
                -29.29632196531792
              ],
              [
                -51.278426542272655,
                -29.294885910404624
              ],
              [
                -51.266707759309575,
                -29.29511567919075
              ],
              [
                -51.26271023054179,
                -29.29511567919075
              ],
              [
                -51.25071764423845,
                -29.307695520231213
              ],
              [
                -51.21649222670609,
                -29.336703829479767
              ],
              [
                -51.23752032323797,
                -29.34158641618497
              ],
              [
                -51.23500133250759,
                -29.343309682080925
              ],
              [
                -51.23308470912578,
                -29.34279270231214
              ],
              [
                -51.23209901710084,
                -29.344803179190748
              ],
              [
                -51.2274991209845,
                -29.344171315028902
              ],
              [
                -51.22421348090139,
                -29.346583887283234
              ],
              [
                -51.22268018219594,
                -29.349513439306357
              ],
              [
                -51.2199969094614,
                -29.3515813583815
              ],
              [
                -51.21928502077673,
                -29.3553725433526
              ],
              [
                -51.21331610795909,
                -29.35721069364162
              ],
              [
                -51.212275655266104,
                -29.35858930635838
              ],
              [
                -51.2107971172287,
                -29.35732557803468
              ],
              [
                -51.203787751718075,
                -29.355487427745665
              ],
              [
                -51.20170684633211,
                -29.35278764450867
              ],
              [
                -51.20050211163497,
                -29.350777167630056
              ],
              [
                -51.200173547626655,
                -29.348422037572252
              ],
              [
                -51.19781883890043,
                -29.34612434971098
              ],
              [
                -51.19738075355602,
                -29.344918063583812
              ],
              [
                -51.19371178879655,
                -29.344688294797685
              ],
              [
                -51.192014208086945,
                -29.343711777456647
              ],
              [
                -51.19042614871344,
                -29.341184320809248
              ],
              [
                -51.18878332867189,
                -29.33647406069364
              ],
              [
                -51.18708574796228,
                -29.33388916184971
              ],
              [
                -51.18270489451814,
                -29.329006575144508
              ],
              [
                -51.181116835144636,
                -29.3280875
              ],
              [
                -51.180514467796066,
                -29.32619190751445
              ],
              [
                -51.17881688708646,
                -29.32498562138728
              ],
              [
                -51.17690026370465,
                -29.325789812138726
              ],
              [
                -51.174216990970116,
                -29.326077023121385
              ],
              [
                -51.17010994086623,
                -29.326077023121385
              ],
              [
                -51.16978137685792,
                -29.33032774566474
              ],
              [
                -51.169398052181556,
                -29.33130426300578
              ],
              [
                -51.16408626738053,
                -29.331821242774566
              ],
              [
                -51.16052682395717,
                -29.331074494219653
              ],
              [
                -51.15899352525172,
                -29.33130426300578
              ],
              [
                -51.15340793711044,
                -29.336014523121385
              ],
              [
                -51.14700093894838,
                -29.337220809248553
              ],
              [
                -51.14541287957488,
                -29.338599421965316
              ],
              [
                -51.1445914695541,
                -29.341471531791907
              ],
              [
                -51.142017718155664,
                -29.342390606936416
              ],
              [
                -51.13692497602685,
                -29.33877174855491
              ],
              [
                -51.134022660620104,
                -29.33262543352601
              ],
              [
                -51.130298935192585,
                -29.32871936416185
              ],
              [
                -51.12701329510948,
                -29.32337723988439
              ],
              [
                -51.12690377377337,
                -29.315794869942195
              ],
              [
                -51.125972842416495,
                -29.313899277456645
              ],
              [
                -51.123015766341695,
                -29.312692991329477
              ],
              [
                -51.12148246763625,
                -29.310682514450868
              ],
              [
                -51.11901823757392,
                -29.308327384393063
              ],
              [
                -51.11600640083107,
                -29.307810404624277
              ],
              [
                -51.11288504275212,
                -29.309074132947977
              ],
              [
                -51.10231623381812,
                -29.317690462427745
              ],
              [
                -51.09979724308774,
                -29.31757557803468
              ],
              [
                -51.09667588500879,
                -29.312520664739882
              ],
              [
                -51.094704500958926,
                -29.31091228323699
              ],
              [
                -51.09492354363113,
                -29.307810404624277
              ],
              [
                -51.09202122822439,
                -29.304880852601155
              ],
              [
                -51.092185510228546,
                -29.2970112716763
              ],
              [
                -51.090980775531406,
                -29.292990317919074
              ],
              [
                -51.088626066805176,
                -29.29092239884393
              ],
              [
                -51.07438829311172,
                -29.292013800578033
              ],
              [
                -51.06989791833147,
                -29.291726589595374
              ],
              [
                -51.05467445261307,
                -29.301778973988437
              ],
              [
                -51.04908886447179,
                -29.307695520231213
              ],
              [
                -51.03857481620585,
                -29.30160664739884
              ],
              [
                -51.032277339379895,
                -29.294311488439305
              ],
              [
                -51.03068928000639,
                -29.293679624277456
              ],
              [
                -51.02532273453732,
                -29.298102673410405
              ],
              [
                -51.013987276250596,
                -29.301491763005778
              ],
              [
                -51.01168732819242,
                -29.303272471098264
              ],
              [
                -51.01009926881892,
                -29.307810404624277
              ],
              [
                -51.00752551742049,
                -29.308097615606936
              ],
              [
                -51.00210421128336,
                -29.30407666184971
              ],
              [
                -50.99810668251558,
                -29.304306430635837
              ],
              [
                -50.99629958046987,
                -29.306719002890173
              ],
              [
                -50.99690194781844,
                -29.31177391618497
              ],
              [
                -51.00111851925843,
                -29.31751813583815
              ],
              [
                -50.991316359677164,
                -29.317001156069363
              ],
              [
                -50.98720930957328,
                -29.320620014450867
              ],
              [
                -50.98540220752757,
                -29.320792341040463
              ],
              [
                -50.984799840179,
                -29.318092557803467
              ],
              [
                -50.985183164855364,
                -29.315392774566472
              ],
              [
                -50.986497420888604,
                -29.312520664739882
              ],
              [
                -50.987702155585744,
                -29.31119949421965
              ],
              [
                -50.98808548026211,
                -29.30918901734104
              ],
              [
                -50.98731883090938,
                -29.306891329479768
              ],
              [
                -50.9862783782164,
                -29.30539783236994
              ],
              [
                -50.98441651550264,
                -29.304019219653178
              ],
              [
                -50.97959757671408,
                -29.303272471098264
              ],
              [
                -50.97691430397954,
                -29.301491763005778
              ],
              [
                -50.97439531324916,
                -29.298677095375723
              ],
              [
                -50.97280725387566,
                -29.29758569364162
              ],
              [
                -50.9695763744606,
                -29.29758569364162
              ],
              [
                -50.96820735775931,
                -29.299021748554914
              ],
              [
                -50.96661929838581,
                -29.302410838150287
              ],
              [
                -50.965085999680355,
                -29.304593641618496
              ],
              [
                -50.96360746164296,
                -29.305914812138727
              ],
              [
                -50.96152655625699,
                -29.306489234104045
              ],
              [
                -50.958295676841935,
                -29.30597225433526
              ],
              [
                -50.956926660140645,
                -29.306776445086705
              ],
              [
                -50.95309341337702,
                -29.31211856936416
              ],
              [
                -50.950902986654945,
                -29.313324855491327
              ],
              [
                -50.94887684193703,
                -29.312520664739882
              ],
              [
                -50.94860303859677,
                -29.310395303468205
              ],
              [
                -50.95057442264664,
                -29.308672037572254
              ],
              [
                -50.95188867867988,
                -29.306489234104045
              ],
              [
                -50.952107721352085,
                -29.304019219653178
              ],
              [
                -50.9511767899952,
                -29.302583164739882
              ],
              [
                -50.9480006712482,
                -29.301319436416183
              ],
              [
                -50.947179261227426,
                -29.29999826589595
              ],
              [
                -50.94668641521496,
                -29.29758569364162
              ],
              [
                -50.94679593655106,
                -29.294081719653178
              ],
              [
                -50.94750782523574,
                -29.292415895953756
              ],
              [
                -50.948986363273136,
                -29.290520303468206
              ],
              [
                -50.9494792092856,
                -29.28908424855491
              ],
              [
                -50.94701497922327,
                -29.28782052023121
              ],
              [
                -50.94487931316925,
                -29.287992846820806
              ],
              [
                -50.94301745045549,
                -29.286786560693642
              ],
              [
                -50.94257936511107,
                -29.284603757225433
              ],
              [
                -50.94181271575835,
                -29.28351235549133
              ],
              [
                -50.93962228903628,
                -29.28351235549133
              ],
              [
                -50.93770566565447,
                -29.284603757225433
              ],
              [
                -50.93392717955889,
                -29.285522832369942
              ],
              [
                -50.930696300143836,
                -29.286614234104043
              ],
              [
                -50.92658925003995,
                -29.290175650289015
              ],
              [
                -50.92368693463321,
                -29.295919869942196
              ],
              [
                -50.92270124260828,
                -29.29838988439306
              ],
              [
                -50.92237267859997,
                -29.30218106936416
              ],
              [
                -50.92182507191945,
                -29.305225505780346
              ],
              [
                -50.919689405865434,
                -29.3082125
              ],
              [
                -50.91777278248362,
                -29.30792528901734
              ],
              [
                -50.91399429638805,
                -29.30470852601156
              ],
              [
                -50.911091980981304,
                -29.303272471098264
              ],
              [
                -50.908682511587024,
                -29.302927817919073
              ],
              [
                -50.907477776889884,
                -29.30218106936416
              ],
              [
                -50.90731349488573,
                -29.300687572254333
              ],
              [
                -50.9095039216078,
                -29.29511567919075
              ],
              [
                -50.909887246284164,
                -29.293392413294796
              ],
              [
                -50.90972296428001,
                -29.287705635838147
              ],
              [
                -50.908682511587024,
                -29.28718865606936
              ],
              [
                -50.904520700815084,
                -29.287073771676297
              ],
              [
                -50.900085086702894,
                -29.286212138728324
              ],
              [
                -50.89438997722551,
                -29.286901445086706
              ],
              [
                -50.89198050783123,
                -29.288280057803465
              ],
              [
                -50.89011864511747,
                -29.28782052023121
              ],
              [
                -50.888475825075915,
                -29.285005852601156
              ],
              [
                -50.88612111634969,
                -29.282995375722543
              ],
              [
                -50.885409227665015,
                -29.281386994219652
              ],
              [
                -50.88442353564008,
                -29.280582803468207
              ],
              [
                -50.88157598090139,
                -29.280180708092484
              ],
              [
                -50.880480767540355,
                -29.279204190751443
              ],
              [
                -50.88069981021256,
                -29.275585332369943
              ],
              [
                -50.8819045449097,
                -29.273115317919075
              ],
              [
                -50.882287869586065,
                -29.270587861271675
              ],
              [
                -50.87878318683075,
                -29.267715751445085
              ],
              [
                -50.875497546747646,
                -29.26369479768786
              ],
              [
                -50.87341664136167,
                -29.262201300578035
              ],
              [
                -50.870021479942466,
                -29.260995014450867
              ],
              [
                -50.86920006992169,
                -29.259271748554912
              ],
              [
                -50.86991195860636,
                -29.256916618497108
              ],
              [
                -50.869419112593896,
                -29.256227312138726
              ],
              [
                -50.86711916453572,
                -29.255193352601154
              ],
              [
                -50.8648739771456,
                -29.255480563583813
              ],
              [
                -50.864490652469236,
                -29.253699855491327
              ],
              [
                -50.86481921647754,
                -29.250080997109826
              ],
              [
                -50.86438113113313,
                -29.24921936416185
              ],
              [
                -50.85928838900431,
                -29.24761098265896
              ],
              [
                -50.85638607359757,
                -29.249678901734104
              ],
              [
                -50.85490753556017,
                -29.252608453757222
              ],
              [
                -50.85457897155186,
                -29.25502102601156
              ],
              [
                -50.854798014224066,
                -29.256916618497108
              ],
              [
                -50.855783706249,
                -29.259616401734103
              ],
              [
                -50.854195646875496,
                -29.263177817919072
              ],
              [
                -50.8510195281285,
                -29.266107369942194
              ],
              [
                -50.84932194741889,
                -29.26691156069364
              ],
              [
                -50.84548870065527,
                -29.267313656069362
              ],
              [
                -50.84450300863033,
                -29.266796676300576
              ],
              [
                -50.843791119945664,
                -29.264326661849708
              ],
              [
                -50.84411968395397,
                -29.26082268786127
              ],
              [
                -50.8434077952693,
                -29.259271748554912
              ],
              [
                -50.841381650551384,
                -29.258180346820808
              ],
              [
                -50.839519787837624,
                -29.258008020231212
              ],
              [
                -50.8355770197379,
                -29.25921430635838
              ],
              [
                -50.833988960364394,
                -29.25921430635838
              ],
              [
                -50.83119616629375,
                -29.258122904624276
              ],
              [
                -50.827801004874544,
                -29.257720809248553
              ],
              [
                -50.82681531284961,
                -29.25950151734104
              ],
              [
                -50.82697959485376,
                -29.26139710982659
              ],
              [
                -50.827910526210644,
                -29.262316184971098
              ],
              [
                -50.8280748082148,
                -29.264901083815026
              ],
              [
                -50.82708911618987,
                -29.265877601156067
              ],
              [
                -50.82572009948857,
                -29.26570527456647
              ],
              [
                -50.824898689467794,
                -29.263809682080925
              ],
              [
                -50.822927305417934,
                -29.260592919075144
              ],
              [
                -50.81827264863353,
                -29.25760592485549
              ],
              [
                -50.81652030725587,
                -29.257376156069363
              ],
              [
                -50.81520605122263,
                -29.258008020231212
              ],
              [
                -50.81219421447978,
                -29.26208641618497
              ],
              [
                -50.8080871643759,
                -29.26507341040462
              ],
              [
                -50.80261109757072,
                -29.267313656069362
              ],
              [
                -50.80189920888605,
                -29.269324132947975
              ],
              [
                -50.80140636287358,
                -29.272885549132948
              ],
              [
                -50.799708782163975,
                -29.275125794797688
              ],
              [
                -50.79680646675723,
                -29.27690650289017
              ],
              [
                -50.79439699736295,
                -29.277423482658957
              ],
              [
                -50.791001835943746,
                -29.27719371387283
              ],
              [
                -50.78760667452453,
                -29.27811278901734
              ],
              [
                -50.78339010308454,
                -29.278916979768784
              ],
              [
                -50.78098063369027,
                -29.278974421965316
              ],
              [
                -50.77988542032923,
                -29.278285115606934
              ],
              [
                -50.77829736095573,
                -29.27598742774566
              ],
              [
                -50.77670930158223,
                -29.27529812138728
              ],
              [
                -50.77161655945341,
                -29.275585332369943
              ],
              [
                -50.76597621064408,
                -29.277078829479766
              ],
              [
                -50.76307389523733,
                -29.27621719653179
              ],
              [
                -50.761212032523574,
                -29.277308598265893
              ],
              [
                -50.76071918651111,
                -29.279204190751443
              ],
              [
                -50.758090674444624,
                -29.282076300578034
              ],
              [
                -50.757488307096054,
                -29.287705635838147
              ],
              [
                -50.756885939747484,
                -29.289773554913292
              ],
              [
                -50.75770734976826,
                -29.290807514450865
              ],
              [
                -50.75978825515423,
                -29.291094725433524
              ],
              [
                -50.76022634049864,
                -29.29189891618497
              ],
              [
                -50.75951445181397,
                -29.295804985549132
              ],
              [
                -50.76071918651111,
                -29.297126156069364
              ],
              [
                -50.76192392120825,
                -29.30022803468208
              ],
              [
                -50.763019134569284,
                -29.302295953757223
              ],
              [
                -50.763019134569284,
                -29.30407666184971
              ],
              [
                -50.76137631452773,
                -29.306489234104045
              ],
              [
                -50.76170487853604,
                -29.307982731213873
              ],
              [
                -50.75907636646956,
                -29.311371820809246
              ],
              [
                -50.75710498241969,
                -29.31372695086705
              ],
              [
                -50.75370982100048,
                -29.316082080924854
              ],
              [
                -50.748398036199454,
                -29.318724421965317
              ],
              [
                -50.747083780166214,
                -29.31878186416185
              ],
              [
                -50.74571476346492,
                -29.319700939306358
              ],
              [
                -50.744674310771934,
                -29.32130932080925
              ],
              [
                -50.74478383210804,
                -29.32309002890173
              ],
              [
                -50.74297673006233,
                -29.326996098265894
              ],
              [
                -50.723700974908105,
                -29.328317268786126
              ],
              [
                -50.711489345932556,
                -29.334406141618494
              ],
              [
                -50.708313227185556,
                -29.334176372832367
              ],
              [
                -50.69659444422247,
                -29.330097976878612
              ],
              [
                -50.696813486894676,
                -29.3280875
              ],
              [
                -50.69829202493208,
                -29.327283309248553
              ],
              [
                -50.698675349608436,
                -29.324181430635836
              ],
              [
                -50.69577303420169,
                -29.32268793352601
              ],
              [
                -50.69188502677002,
                -29.32268793352601
              ],
              [
                -50.68898271136327,
                -29.324123988439304
              ],
              [
                -50.68629943862874,
                -29.32590469653179
              ],
              [
                -50.685204225267704,
                -29.327627962427744
              ],
              [
                -50.68471137925523,
                -29.329580997109826
              ],
              [
                -50.68197334585265,
                -29.332395664739884
              ],
              [
                -50.679125791113954,
                -29.334176372832367
              ],
              [
                -50.67518302301423,
                -29.335612427745662
              ],
              [
                -50.67397828831709,
                -29.33647406069364
              ],
              [
                -50.673102117628254,
                -29.338312210982657
              ],
              [
                -50.673102117628254,
                -29.34060989884393
              ],
              [
                -50.67397828831709,
                -29.343309682080925
              ],
              [
                -50.6757853903628,
                -29.347215751445084
              ],
              [
                -50.676113954371104,
                -29.34899645953757
              ],
              [
                -50.674909219673964,
                -29.351696242774565
              ],
              [
                -50.67501874101007,
                -29.35278764450867
              ],
              [
                -50.67989244046668,
                -29.356980924855492
              ],
              [
                -50.68241143119706,
                -29.35962326589595
              ],
              [
                -50.68312331988173,
                -29.361978395953756
              ],
              [
                -50.68257571320122,
                -29.36370166184971
              ],
              [
                -50.680385286479144,
                -29.3653100433526
              ],
              [
                -50.677373449736294,
                -29.366114234104046
              ],
              [
                -50.677209167732144,
                -29.366975867052023
              ],
              [
                -50.677209167732144,
                -29.370996820809246
              ],
              [
                -50.676004433035004,
                -29.3739838150289
              ],
              [
                -50.674909219673964,
                -29.374788005780346
              ],
              [
                -50.67348544230462,
                -29.3739838150289
              ],
              [
                -50.67030932355762,
                -29.371226589595373
              ],
              [
                -50.667407008150875,
                -29.370422398843928
              ],
              [
                -50.6652165814288,
                -29.37111170520231
              ],
              [
                -50.66171189867349,
                -29.37300729768786
              ],
              [
                -50.65782389124181,
                -29.37369660404624
              ],
              [
                -50.654593011826755,
                -29.373409393063582
              ],
              [
                -50.65251210644079,
                -29.37369660404624
              ],
              [
                -50.64928122702573,
                -29.375707080924855
              ],
              [
                -50.647200321639765,
                -29.378004768786127
              ],
              [
                -50.64462657024133,
                -29.382198049132946
              ],
              [
                -50.64462657024133,
                -29.385127601156068
              ],
              [
                -50.64577654427042,
                -29.38679342485549
              ],
              [
                -50.64747412498002,
                -29.38840180635838
              ],
              [
                -50.64741936431197,
                -29.389780419075144
              ],
              [
                -50.644790852245485,
                -29.39167601156069
              ],
              [
                -50.64391468155666,
                -29.393399277456645
              ],
              [
                -50.64369563888445,
                -29.399373265895953
              ],
              [
                -50.64462657024133,
                -29.405979118497108
              ],
              [
                -50.64528369825795,
                -29.408219364161848
              ],
              [
                -50.64698127896756,
                -29.411206358381502
              ],
              [
                -50.649719312370145,
                -29.412010549132948
              ],
              [
                -50.65410016581429,
                -29.41821430635838
              ],
              [
                -50.6560167891961,
                -29.419592919075143
              ],
              [
                -50.6574953272335,
                -29.422120375722542
              ],
              [
                -50.65968575395557,
                -29.420914089595374
              ],
              [
                -50.66028812130414,
                -29.41890361271676
              ],
              [
                -50.662588069362315,
                -29.41792709537572
              ],
              [
                -50.66488801742049,
                -29.41792709537572
              ],
              [
                -50.6683927001758,
                -29.418616401734102
              ],
              [
                -50.67140453691865,
                -29.419880130057802
              ],
              [
                -50.67392352764903,
                -29.415916618497107
              ],
              [
                -50.67819485975707,
                -29.415916618497107
              ],
              [
                -50.68049480781525,
                -29.41459544797688
              ],
              [
                -50.682192388524854,
                -29.410402167630057
              ],
              [
                -50.68482090059134,
                -29.406898193641617
              ],
              [
                -50.68438281524693,
                -29.407702384393062
              ],
              [
                -50.695006384848966,
                -29.411608453757225
              ],
              [
                -50.69911343495286,
                -29.41407846820809
              ],
              [
                -50.70239907503596,
                -29.41637615606936
              ],
              [
                -50.70458950175803,
                -29.419018497109825
              ],
              [
                -50.704206177081666,
                -29.420626878612715
              ],
              [
                -50.70497282643439,
                -29.424820158959538
              ],
              [
                -50.70617756113153,
                -29.425681791907515
              ],
              [
                -50.70880607319802,
                -29.429013439306356
              ],
              [
                -50.71159886726866,
                -29.431828106936415
              ],
              [
                -50.712694080629696,
                -29.4336088150289
              ],
              [
                -50.717677301422405,
                -29.436883020231214
              ],
              [
                -50.71899155745565,
                -29.439295592485546
              ],
              [
                -50.72079865950136,
                -29.440272109826587
              ],
              [
                -50.721893872862395,
                -29.441708164739882
              ],
              [
                -50.72271528288317,
                -29.44348887283237
              ],
              [
                -50.723700974908105,
                -29.444407947976877
              ],
              [
                -50.724412863592775,
                -29.447280057803468
              ],
              [
                -50.72611044430238,
                -29.44768215317919
              ],
              [
                -50.72638424764264,
                -29.451990317919073
              ],
              [
                -50.728081828352245,
                -29.453024277456645
              ],
              [
                -50.72731517899952,
                -29.454288005780345
              ],
              [
                -50.72408429958447,
                -29.4560112716763
              ],
              [
                -50.723208128895635,
                -29.455781502890172
              ],
              [
                -50.72287956488733,
                -29.45411567919075
              ],
              [
                -50.72090818083746,
                -29.45572406069364
              ],
              [
                -50.71838919010708,
                -29.455896387283236
              ],
              [
                -50.71548687470034,
                -29.455207080924854
              ],
              [
                -50.715213071360076,
                -29.45572406069364
              ],
              [
                -50.71110602125619,
                -29.45859617052023
              ],
              [
                -50.710777457247886,
                -29.459400361271676
              ],
              [
                -50.70798466317724,
                -29.46112362716763
              ],
              [
                -50.707108492488416,
                -29.462387355491327
              ],
              [
                -50.70497282643439,
                -29.463880852601154
              ],
              [
                -50.702891921048426,
                -29.464512716763004
              ],
              [
                -50.70009912697778,
                -29.466178540462426
              ],
              [
                -50.69697776889883,
                -29.467327384393062
              ],
              [
                -50.69298024013106,
                -29.470601589595375
              ],
              [
                -50.69259691545469,
                -29.471176011560694
              ],
              [
                -50.68898271136327,
                -29.47399067919075
              ],
              [
                -50.68777797666613,
                -29.475484176300576
              ],
              [
                -50.68881842935912,
                -29.47628836705202
              ],
              [
                -50.68991364272016,
                -29.47979234104046
              ],
              [
                -50.68810654067445,
                -29.48358352601156
              ],
              [
                -50.68657324196899,
                -29.482377239884393
              ],
              [
                -50.68558754994406,
                -29.480883742774566
              ],
              [
                -50.6837256872303,
                -29.479275361271675
              ],
              [
                -50.68087813249161,
                -29.47818395953757
              ],
              [
                -50.67929007311811,
                -29.475082080924853
              ],
              [
                -50.67709964639604,
                -29.47301416184971
              ],
              [
                -50.67507350167812,
                -29.471807875722543
              ],
              [
                -50.67408780965319,
                -29.472095086705203
              ],
              [
                -50.67501874101007,
                -29.475082080924853
              ],
              [
                -50.6745258949976,
                -29.478011632947975
              ],
              [
                -50.67501874101007,
                -29.479275361271675
              ],
              [
                -50.67397828831709,
                -29.480883742774566
              ],
              [
                -50.67408780965319,
                -29.487891690751443
              ],
              [
                -50.67222594693943,
                -29.49191264450867
              ],
              [
                -50.671185494246444,
                -29.49317637283237
              ],
              [
                -50.667407008150875,
                -29.494899638728324
              ],
              [
                -50.666804640802305,
                -29.495588945086702
              ],
              [
                -50.666804640802305,
                -29.497599421965315
              ],
              [
                -50.66461421408023,
                -29.500988511560692
              ],
              [
                -50.66160237733738,
                -29.50437760115607
              ],
              [
                -50.66050716397635,
                -29.50627319364162
              ],
              [
                -50.65470253316286,
                -29.50598598265896
              ],
              [
                -50.65169069642001,
                -29.50380317919075
              ],
              [
                -50.65119785040754,
                -29.50248200867052
              ],
              [
                -50.63088164256033,
                -29.55860303468208
              ],
              [
                -50.629512625859036,
                -29.560728395953756
              ],
              [
                -50.628417412498,
                -29.56049862716763
              ],
              [
                -50.62310562769698,
                -29.557281864161848
              ],
              [
                -50.622174696340096,
                -29.558373265895952
              ],
              [
                -50.61790336423206,
                -29.55762651734104
              ],
              [
                -50.61582245884609,
                -29.557798843930634
              ],
              [
                -50.61259157943104,
                -29.55699465317919
              ],
              [
                -50.61029163137286,
                -29.557281864161848
              ],
              [
                -50.60821072598689,
                -29.55607557803468
              ],
              [
                -50.60607505993288,
                -29.554179985549133
              ],
              [
                -50.60530841058015,
                -29.552686488439306
              ],
              [
                -50.60240609517341,
                -29.55182485549133
              ],
              [
                -50.59599909701135,
                -29.552571604046243
              ],
              [
                -50.594684840978104,
                -29.55211206647399
              ],
              [
                -50.592877738932394,
                -29.552916257225434
              ],
              [
                -50.59008494486176,
                -29.553318352601156
              ],
              [
                -50.58838736415215,
                -29.552284393063584
              ],
              [
                -50.584280314048264,
                -29.55211206647399
              ],
              [
                -50.582308929998405,
                -29.551595086705202
              ],
              [
                -50.57891376857919,
                -29.552973699421965
              ],
              [
                -50.57519004315167,
                -29.552973699421965
              ],
              [
                -50.57217820640882,
                -29.552399277456647
              ],
              [
                -50.57091871104363,
                -29.551595086705202
              ],
              [
                -50.570699668371425,
                -29.54998670520231
              ],
              [
                -50.56560692624261,
                -29.547803901734103
              ],
              [
                -50.562102243487296,
                -29.546999710982657
              ],
              [
                -50.560897508790156,
                -29.54642528901734
              ],
              [
                -50.560295141441586,
                -29.54458713872832
              ],
              [
                -50.558980885408346,
                -29.5441850433526
              ],
              [
                -50.558488039395876,
                -29.542289450867052
              ],
              [
                -50.55700950135848,
                -29.54027897398844
              ],
              [
                -50.554819074636406,
                -29.53907268786127
              ],
              [
                -50.55279292991849,
                -29.538613150289017
              ],
              [
                -50.53669329351127,
                -29.538785476878612
              ],
              [
                -50.461123571599806,
                -29.538613150289017
              ],
              [
                -50.432921827553145,
                -29.537291979768785
              ],
              [
                -50.43138852884769,
                -29.53620057803468
              ],
              [
                -50.43259326354483,
                -29.53367312138728
              ],
              [
                -50.43210041753237,
                -29.533098699421963
              ],
              [
                -50.42958142680198,
                -29.532811488439304
              ],
              [
                -50.42969094813809,
                -29.530513800578035
              ],
              [
                -50.427500521416015,
                -29.528388439306358
              ],
              [
                -50.42640530805498,
                -29.526780057803467
              ],
              [
                -50.42481724868148,
                -29.526090751445086
              ],
              [
                -50.423886317324595,
                -29.522816546242773
              ],
              [
                -50.42268158262746,
                -29.52247189306358
              ],
              [
                -50.421914933274735,
                -29.520978395953755
              ],
              [
                -50.42218873661499,
                -29.520001878612714
              ],
              [
                -50.42120304459006,
                -29.518278612716763
              ],
              [
                -50.41928642120825,
                -29.517416979768786
              ],
              [
                -50.41868405385968,
                -29.518910476878613
              ],
              [
                -50.41747931916254,
                -29.51959978323699
              ],
              [
                -50.41441272175164,
                -29.519025361271677
              ],
              [
                -50.41260561970593,
                -29.51908280346821
              ],
              [
                -50.41140088500879,
                -29.518393497109827
              ],
              [
                -50.40992234697139,
                -29.51908280346821
              ],
              [
                -50.406691467556335,
                -29.518680708092486
              ],
              [
                -50.404720083506476,
                -29.51787651734104
              ],
              [
                -50.4038986734857,
                -29.51598092485549
              ],
              [
                -50.39968210204571,
                -29.51500440751445
              ],
              [
                -50.39661550463481,
                -29.514889523121386
              ],
              [
                -50.39650598329871,
                -29.5131088150289
              ],
              [
                -50.393822710564166,
                -29.513281141618496
              ],
              [
                -50.39097515582548,
                -29.512074855491328
              ],
              [
                -50.390591831149116,
                -29.511328106936414
              ],
              [
                -50.38599193503276,
                -29.509777167630055
              ],
              [
                -50.38462291833147,
                -29.51052391618497
              ],
              [
                -50.38237773094134,
                -29.508513439306356
              ],
              [
                -50.37991350087901,
                -29.50897297687861
              ],
              [
                -50.377777834825,
                -29.50667528901734
              ],
              [
                -50.37520408342656,
                -29.50661784682081
              ],
              [
                -50.370604187310214,
                -29.50380317919075
              ],
              [
                -50.3702756233019,
                -29.50127572254335
              ],
              [
                -50.37087799065047,
                -29.50029920520231
              ],
              [
                -50.369399452613074,
                -29.498805708092483
              ],
              [
                -50.3655114451814,
                -29.498518497109824
              ],
              [
                -50.36299245445102,
                -29.498805708092483
              ],
              [
                -50.36102107040115,
                -29.49960989884393
              ],
              [
                -50.35729734497363,
                -29.49869082369942
              ],
              [
                -50.35428550823078,
                -29.497024999999997
              ],
              [
                -50.35198556017261,
                -29.496393135838147
              ],
              [
                -50.34771422806457,
                -29.494325216763006
              ],
              [
                -50.337419222470835,
                -29.487719364161848
              ],
              [
                -50.33511927441266,
                -29.485479118497107
              ],
              [
                -50.33391453971552,
                -29.483181430635838
              ],
              [
                -50.33402406105162,
                -29.48128583815029
              ],
              [
                -50.33517403508071,
                -29.479907225433525
              ],
              [
                -50.33112174564488,
                -29.478298843930634
              ],
              [
                -50.3287122762506,
                -29.478700939306357
              ],
              [
                -50.32739802021736,
                -29.47720744219653
              ],
              [
                -50.324495704810616,
                -29.476173482658957
              ],
              [
                -50.32312668810932,
                -29.474277890173408
              ],
              [
                -50.32038865470673,
                -29.474220447976876
              ],
              [
                -50.3179244246444,
                -29.472899277456648
              ],
              [
                -50.31737681796388,
                -29.475082080924853
              ],
              [
                -50.31507686990571,
                -29.47502463872832
              ],
              [
                -50.31491258790155,
                -29.474277890173408
              ],
              [
                -50.31578875859038,
                -29.469682514450867
              ],
              [
                -50.31808870664855,
                -29.46698273121387
              ],
              [
                -50.31797918531245,
                -29.464512716763004
              ],
              [
                -50.3195124840179,
                -29.462617124277454
              ],
              [
                -50.32000533003037,
                -29.460319436416185
              ],
              [
                -50.32137434673166,
                -29.45957268786127
              ],
              [
                -50.32482426881892,
                -29.46152572254335
              ],
              [
                -50.32717897754515,
                -29.460893858381503
              ],
              [
                -50.325207593495286,
                -29.458998265895953
              ],
              [
                -50.322195756752436,
                -29.458194075144508
              ],
              [
                -50.319074398673486,
                -29.457791979768785
              ],
              [
                -50.31567923725427,
                -29.458079190751445
              ],
              [
                -50.314803066565446,
                -29.457102673410404
              ],
              [
                -50.31622684393479,
                -29.45480498554913
              ],
              [
                -50.316610168611156,
                -29.453024277456645
              ],
              [
                -50.3179244246444,
                -29.451128684971096
              ],
              [
                -50.319676766022056,
                -29.449175650289014
              ],
              [
                -50.32049817604283,
                -29.44739494219653
              ],
              [
                -50.32241479942464,
                -29.44762471098266
              ],
              [
                -50.32318144877737,
                -29.446475867052023
              ],
              [
                -50.32252432076075,
                -29.444982369942196
              ],
              [
                -50.32318144877737,
                -29.44262723988439
              ],
              [
                -50.32487902948698,
                -29.44159328034682
              ],
              [
                -50.324002858798146,
                -29.440214667630055
              ],
              [
                -50.31989580869426,
                -29.441191184971096
              ],
              [
                -50.31797918531245,
                -29.4410188583815
              ],
              [
                -50.31611732259869,
                -29.440214667630055
              ],
              [
                -50.31398165654467,
                -29.438319075144506
              ],
              [
                -50.31310548585584,
                -29.43671069364162
              ],
              [
                -50.311079341137926,
                -29.43648092485549
              ],
              [
                -50.31211979383091,
                -29.43877861271676
              ],
              [
                -50.31381737454051,
                -29.440616763005778
              ],
              [
                -50.31567923725427,
                -29.443373988439305
              ],
              [
                -50.31578875859038,
                -29.444982369942196
              ],
              [
                -50.31491258790155,
                -29.445327023121386
              ],
              [
                -50.31332452852805,
                -29.448199132947977
              ],
              [
                -50.311079341137926,
                -29.44940541907514
              ],
              [
                -50.31009364911299,
                -29.44888843930636
              ],
              [
                -50.309874606440786,
                -29.445671676300577
              ],
              [
                -50.309217478424166,
                -29.444695158959536
              ],
              [
                -50.30582231700495,
                -29.445212138728323
              ],
              [
                -50.30281048026211,
                -29.44768215317919
              ],
              [
                -50.30122242088861,
                -29.446877962427745
              ],
              [
                -50.297717738133294,
                -29.44641842485549
              ],
              [
                -50.297115370784724,
                -29.44578656069364
              ],
              [
                -50.29738917412498,
                -29.443086777456646
              ],
              [
                -50.2994153188429,
                -29.44159328034682
              ],
              [
                -50.29837486614991,
                -29.44067420520231
              ],
              [
                -50.29629396076395,
                -29.44159328034682
              ],
              [
                -50.2949797047307,
                -29.442971893063582
              ],
              [
                -50.295308268739014,
                -29.446016329479768
              ],
              [
                -50.296513003436154,
                -29.44802680635838
              ],
              [
                -50.29640348210005,
                -29.44957774566474
              ],
              [
                -50.295308268739014,
                -29.45032449421965
              ],
              [
                -50.29361068802941,
                -29.44888843930636
              ],
              [
                -50.29262499600448,
                -29.446475867052023
              ],
              [
                -50.28890127057696,
                -29.446016329479768
              ],
              [
                -50.29070837262266,
                -29.448371459537572
              ],
              [
                -50.290982175962924,
                -29.449807514450868
              ],
              [
                -50.296513003436154,
                -29.454690101156068
              ],
              [
                -50.297115370784724,
                -29.456126156069363
              ],
              [
                -50.29689632811252,
                -29.458481286127167
              ],
              [
                -50.29552731141122,
                -29.45957268786127
              ],
              [
                -50.29251547466837,
                -29.459400361271676
              ],
              [
                -50.29070837262266,
                -29.457791979768785
              ],
              [
                -50.289175073917214,
                -29.457217557803467
              ],
              [
                -50.28682036519099,
                -29.455494291907513
              ],
              [
                -50.28380852844814,
                -29.45187543352601
              ],
              [
                -50.28287759709126,
                -29.454000794797686
              ],
              [
                -50.283096639763464,
                -29.454690101156068
              ],
              [
                -50.28561563049385,
                -29.457389884393063
              ],
              [
                -50.285506109157744,
                -29.458308959537572
              ],
              [
                -50.28342520377178,
                -29.458481286127167
              ],
              [
                -50.28441089579671,
                -29.4598024566474
              ],
              [
                -50.287915578552024,
                -29.461410838150286
              ],
              [
                -50.29147502197539,
                -29.46370852601156
              ],
              [
                -50.29251547466837,
                -29.465891329479767
              ],
              [
                -50.293994012705774,
                -29.467384826589594
              ],
              [
                -50.292186910660064,
                -29.468418786127167
              ],
              [
                -50.28999648393799,
                -29.467672037572253
              ],
              [
                -50.28588943383411,
                -29.465604118497108
              ],
              [
                -50.2747730182196,
                -29.463019219653177
              ],
              [
                -50.272692112833624,
                -29.46278945086705
              ],
              [
                -50.27280163416973,
                -29.464512716763004
              ],
              [
                -50.274992060891805,
                -29.467327384393062
              ],
              [
                -50.274389693543235,
                -29.4684762283237
              ],
              [
                -50.27291115550584,
                -29.467786921965317
              ],
              [
                -50.272692112833624,
                -29.466523193641617
              ],
              [
                -50.26940647275052,
                -29.46508713872832
              ],
              [
                -50.26907790874221,
                -29.46347875722543
              ],
              [
                -50.269625515422725,
                -29.46077897398844
              ],
              [
                -50.26929695141442,
                -29.459687572254335
              ],
              [
                -50.267106524692345,
                -29.456413367052022
              ],
              [
                -50.267106524692345,
                -29.454575216763004
              ],
              [
                -50.265792268659105,
                -29.454919869942195
              ],
              [
                -50.265682747323,
                -29.457275
              ],
              [
                -50.266504157343775,
                -29.459113150289017
              ],
              [
                -50.265189901310535,
                -29.460319436416185
              ],
              [
                -50.266504157343775,
                -29.46278945086705
              ],
              [
                -50.26677796068404,
                -29.466408309248553
              ],
              [
                -50.26781841337702,
                -29.468591112716762
              ],
              [
                -50.26809221671728,
                -29.470199494219653
              ],
              [
                -50.26929695141442,
                -29.47169299132948
              ],
              [
                -50.26858506272974,
                -29.473186488439303
              ],
              [
                -50.26869458406585,
                -29.47657557803468
              ],
              [
                -50.269515994086625,
                -29.47749465317919
              ],
              [
                -50.272582591497525,
                -29.479505130057802
              ],
              [
                -50.2734040015183,
                -29.47939024566474
              ],
              [
                -50.27400636886687,
                -29.4758862716763
              ],
              [
                -50.274499214879334,
                -29.475082080924853
              ],
              [
                -50.27641583826115,
                -29.473818352601153
              ],
              [
                -50.27849674364712,
                -29.47399067919075
              ],
              [
                -50.278825307655424,
                -29.476690462427744
              ],
              [
                -50.27970147834426,
                -29.477609537572253
              ],
              [
                -50.28150858038997,
                -29.47812651734104
              ],
              [
                -50.2840823317884,
                -29.478011632947975
              ],
              [
                -50.28528706648554,
                -29.47852861271676
              ],
              [
                -50.28588943383411,
                -29.47979234104046
              ],
              [
                -50.28627275851047,
                -29.48260700867052
              ],
              [
                -50.28720368986735,
                -29.483928179190748
              ],
              [
                -50.28961315926163,
                -29.483123988439306
              ],
              [
                -50.290982175962924,
                -29.48352608381503
              ],
              [
                -50.29131073997123,
                -29.484904696531792
              ],
              [
                -50.29437733738213,
                -29.48530679190751
              ],
              [
                -50.294596380054344,
                -29.48812145953757
              ],
              [
                -50.295910636087584,
                -29.49001705202312
              ],
              [
                -50.29552731141122,
                -29.492084971098265
              ],
              [
                -50.29678680677641,
                -29.493980563583815
              ],
              [
                -50.296513003436154,
                -29.49507196531792
              ],
              [
                -50.29481542272655,
                -29.495014523121387
              ],
              [
                -50.29142026130734,
                -29.493980563583815
              ],
              [
                -50.289777441265784,
                -29.495991040462428
              ],
              [
                -50.289777441265784,
                -29.497197326589593
              ],
              [
                -50.29131073997123,
                -29.499782225433524
              ],
              [
                -50.29300832068084,
                -29.500988511560692
              ],
              [
                -50.29322736335305,
                -29.502309682080924
              ],
              [
                -50.2919131073198,
                -29.503688294797687
              ],
              [
                -50.292296431996164,
                -29.506388078034682
              ],
              [
                -50.29087265462682,
                -29.50667528901734
              ],
              [
                -50.28901079191306,
                -29.506215751445087
              ],
              [
                -50.287313211203454,
                -29.506388078034682
              ],
              [
                -50.284903741809174,
                -29.505928540462428
              ],
              [
                -50.2809062130414,
                -29.50598598265896
              ],
              [
                -50.27920863233179,
                -29.506502962427746
              ],
              [
                -50.27888006832348,
                -29.503286199421964
              ],
              [
                -50.27789437629855,
                -29.500414089595374
              ],
              [
                -50.27898958965958,
                -29.495014523121387
              ],
              [
                -50.27701820560972,
                -29.492716835260115
              ],
              [
                -50.276196795588945,
                -29.48938518786127
              ],
              [
                -50.27460873621544,
                -29.48777680635838
              ],
              [
                -50.27411589020297,
                -29.485996098265893
              ],
              [
                -50.2747730182196,
                -29.484502601156066
              ],
              [
                -50.273787326194665,
                -29.48358352601156
              ],
              [
                -50.272582591497525,
                -29.48461748554913
              ],
              [
                -50.27219926682116,
                -29.489787283236993
              ],
              [
                -50.2717064208087,
                -29.490821242774565
              ],
              [
                -50.270173122103245,
                -29.49099356936416
              ],
              [
                -50.269023148074155,
                -29.49001705202312
              ],
              [
                -50.2673803280326,
                -29.489500072254334
              ],
              [
                -50.263985166613395,
                -29.490189378612715
              ],
              [
                -50.26382088460924,
                -29.493693352601156
              ],
              [
                -50.2626161499121,
                -29.495186849710983
              ],
              [
                -50.26069952653029,
                -29.49610592485549
              ],
              [
                -50.256701997762505,
                -29.49668034682081
              ],
              [
                -50.254183007032125,
                -29.497599421965315
              ],
              [
                -50.251773537637845,
                -29.499897109826588
              ],
              [
                -50.250404520936556,
                -29.49932268786127
              ],
              [
                -50.25062356360876,
                -29.496278251445084
              ],
              [
                -50.25259494765862,
                -29.49260195086705
              ],
              [
                -50.25259494765862,
                -29.491682875722542
              ],
              [
                -50.25062356360876,
                -29.491395664739883
              ],
              [
                -50.249802153587986,
                -29.493291257225433
              ],
              [
                -50.2471736415215,
                -29.494612427745665
              ],
              [
                -50.24098568603164,
                -29.493923121387283
              ],
              [
                -50.23961666933035,
                -29.49409544797688
              ],
              [
                -50.2380833706249,
                -29.49507196531792
              ],
              [
                -50.23671435392361,
                -29.494899638728324
              ],
              [
                -50.235783422566726,
                -29.493291257225433
              ],
              [
                -50.23310014983219,
                -29.49352102601156
              ],
              [
                -50.22959546707688,
                -29.49472731213873
              ],
              [
                -50.228500253715836,
                -29.494382658959537
              ],
              [
                -50.22702171567844,
                -29.492716835260115
              ],
              [
                -50.22488604962442,
                -29.49317637283237
              ],
              [
                -50.22390035759949,
                -29.494382658959537
              ],
              [
                -50.22247658023014,
                -29.494612427745665
              ],
              [
                -50.22012187150392,
                -29.492774277456647
              ],
              [
                -50.21940998281924,
                -29.49288916184971
              ],
              [
                -50.21940998281924,
                -29.49541661849711
              ],
              [
                -50.21678147075276,
                -29.495876156069365
              ],
              [
                -50.21601482140003,
                -29.496795231213873
              ],
              [
                -50.21349583066965,
                -29.496910115606937
              ],
              [
                -50.208293567204734,
                -29.49610592485549
              ],
              [
                -50.20320082507592,
                -29.494899638728324
              ],
              [
                -50.201174680358,
                -29.495014523121387
              ],
              [
                -50.199696142320605,
                -29.495991040462428
              ],
              [
                -50.20018898833307,
                -29.497599421965315
              ],
              [
                -50.20188656904267,
                -29.49748453757225
              ],
              [
                -50.20298178240371,
                -29.499092919075142
              ],
              [
                -50.20440555977306,
                -29.499495014450865
              ],
              [
                -50.205884097810454,
                -29.498920592485547
              ],
              [
                -50.210210190586544,
                -29.500414089595374
              ],
              [
                -50.21179824996005,
                -29.501677817919074
              ],
              [
                -50.213824394677964,
                -29.504205274566473
              ],
              [
                -50.21601482140003,
                -29.504894580924855
              ],
              [
                -50.21990282883171,
                -29.5056987716763
              ],
              [
                -50.22170993087742,
                -29.506502962427746
              ],
              [
                -50.22488604962442,
                -29.50960484104046
              ],
              [
                -50.22609078432156,
                -29.510121820809246
              ],
              [
                -50.23129304778648,
                -29.51121322254335
              ],
              [
                -50.23080020177402,
                -29.51247695086705
              ],
              [
                -50.2287740570561,
                -29.512017413294796
              ],
              [
                -50.22658363033403,
                -29.51247695086705
              ],
              [
                -50.22362655425923,
                -29.51218973988439
              ],
              [
                -50.22001235016781,
                -29.512591835260114
              ],
              [
                -50.21842429079431,
                -29.51368323699422
              ],
              [
                -50.21541245405146,
                -29.51368323699422
              ],
              [
                -50.21349583066965,
                -29.515176734104045
              ],
              [
                -50.2103744725907,
                -29.515808598265895
              ],
              [
                -50.20999114791434,
                -29.513913005780346
              ],
              [
                -50.2073078751798,
                -29.51661278901734
              ],
              [
                -50.2104839939268,
                -29.518106286127168
              ],
              [
                -50.2103744725907,
                -29.519025361271677
              ],
              [
                -50.20791024252837,
                -29.519312572254336
              ],
              [
                -50.20358414975228,
                -29.518680708092486
              ],
              [
                -50.20210561171488,
                -29.51758930635838
              ],
              [
                -50.19991518499281,
                -29.517302095375722
              ],
              [
                -50.19838188628736,
                -29.516383020231213
              ],
              [
                -50.19717715159022,
                -29.5169
              ],
              [
                -50.19777951893879,
                -29.519714667630055
              ],
              [
                -50.19679382691386,
                -29.521323049132945
              ],
              [
                -50.19509624620425,
                -29.5217825867052
              ],
              [
                -50.19257725547387,
                -29.51959978323699
              ],
              [
                -50.19192012745725,
                -29.52017420520231
              ],
              [
                -50.19022254674764,
                -29.52402283236994
              ],
              [
                -50.189291615390765,
                -29.524827023121386
              ],
              [
                -50.186225017979865,
                -29.524827023121386
              ],
              [
                -50.18491076194662,
                -29.527009826589595
              ],
              [
                -50.185020283282725,
                -29.53068612716763
              ],
              [
                -50.1827750958926,
                -29.5306286849711
              ],
              [
                -50.181296557855205,
                -29.532524277456645
              ],
              [
                -50.17937993447339,
                -29.532811488439304
              ],
              [
                -50.177682353763785,
                -29.53240939306358
              ],
              [
                -50.17560144837782,
                -29.529881936416185
              ],
              [
                -50.17499908102925,
                -29.532122182080922
              ],
              [
                -50.173903867668216,
                -29.533385910404622
              ],
              [
                -50.17078250958926,
                -29.53332846820809
              ],
              [
                -50.16798971551862,
                -29.535109176300576
              ],
              [
                -50.167880194182516,
                -29.533098699421963
              ],
              [
                -50.168482561531086,
                -29.531605202312136
              ],
              [
                -50.17078250958926,
                -29.528675650289017
              ],
              [
                -50.170892030925366,
                -29.527584248554913
              ],
              [
                -50.170399184912895,
                -29.523276083815027
              ],
              [
                -50.17231580829471,
                -29.520691184971096
              ],
              [
                -50.17352054299185,
                -29.52080606936416
              ],
              [
                -50.17609429439028,
                -29.522012355491327
              ],
              [
                -50.179489455809495,
                -29.51908280346821
              ],
              [
                -50.1811870365191,
                -29.516497904624277
              ],
              [
                -50.18359650591338,
                -29.514200216763005
              ],
              [
                -50.18392506992169,
                -29.51150043352601
              ],
              [
                -50.18458219793831,
                -29.5093176300578
              ],
              [
                -50.18469171927441,
                -29.50661784682081
              ],
              [
                -50.188196402029725,
                -29.506388078034682
              ],
              [
                -50.18918209405466,
                -29.505583887283237
              ],
              [
                -50.18638929998402,
                -29.50351596820809
              ],
              [
                -50.184417915934155,
                -29.498920592485547
              ],
              [
                -50.182501292552345,
                -29.496910115606937
              ],
              [
                -50.18299413856481,
                -29.495474060693642
              ],
              [
                -50.181898925203775,
                -29.494612427745665
              ],
              [
                -50.17910613113313,
                -29.49099356936416
              ],
              [
                -50.17718950775132,
                -29.489212861271675
              ],
              [
                -50.18228224988014,
                -29.489902167630056
              ],
              [
                -50.17932517380534,
                -29.487087499999998
              ],
              [
                -50.17538240570561,
                -29.483181430635838
              ],
              [
                -50.17499908102925,
                -29.482377239884393
              ],
              [
                -50.16870160420329,
                -29.47789674855491
              ],
              [
                -50.16629213480901,
                -29.47657557803468
              ],
              [
                -50.16218508470513,
                -29.47531184971098
              ],
              [
                -50.15878992328592,
                -29.474794869942194
              ],
              [
                -50.15161627577114,
                -29.475771387283235
              ],
              [
                -50.15101390842257,
                -29.474507658959535
              ],
              [
                -50.15238292512386,
                -29.473186488439303
              ],
              [
                -50.15512095852645,
                -29.47341625722543
              ],
              [
                -50.15731138524852,
                -29.471003684971098
              ],
              [
                -50.16070654666773,
                -29.470199494219653
              ],
              [
                -50.16191128136487,
                -29.46910809248555
              ],
              [
                -50.16388266541474,
                -29.464512716763004
              ],
              [
                -50.16568976746044,
                -29.4634213150289
              ],
              [
                -50.16700402349369,
                -29.463593641618495
              ],
              [
                -50.167880194182516,
                -29.465604118497108
              ],
              [
                -50.167825433514466,
                -29.46698273121387
              ],
              [
                -50.16689450215758,
                -29.470314378612716
              ],
              [
                -50.167825433514466,
                -29.472899277456648
              ],
              [
                -50.16749686950615,
                -29.47399067919075
              ],
              [
                -50.17078250958926,
                -29.476403251445085
              ],
              [
                -50.1718777229503,
                -29.476690462427744
              ],
              [
                -50.17488955969314,
                -29.47651813583815
              ],
              [
                -50.17718950775132,
                -29.476805346820807
              ],
              [
                -50.1811870365191,
                -29.478011632947975
              ],
              [
                -50.18288461722871,
                -29.477781864161848
              ],
              [
                -50.18392506992169,
                -29.478873265895952
              ],
              [
                -50.18638929998402,
                -29.482779335260116
              ],
              [
                -50.18797735935752,
                -29.483123988439306
              ],
              [
                -50.18852496603804,
                -29.48421539017341
              ],
              [
                -50.187484513345055,
                -29.48748959537572
              ],
              [
                -50.18901781205051,
                -29.48840867052023
              ],
              [
                -50.19142728144478,
                -29.485479118497107
              ],
              [
                -50.19378199017101,
                -29.48427283236994
              ],
              [
                -50.19761523693464,
                -29.484502601156066
              ],
              [
                -50.19898425363593,
                -29.48421539017341
              ],
              [
                -50.20068183434553,
                -29.482779335260116
              ],
              [
                -50.1994770996484,
                -29.480596531791907
              ],
              [
                -50.19887473229983,
                -29.478586054913293
              ],
              [
                -50.201174680358,
                -29.477609537572253
              ],
              [
                -50.20550077313409,
                -29.47789674855491
              ],
              [
                -50.20758167852006,
                -29.477724421965316
              ],
              [
                -50.2103744725907,
                -29.478011632947975
              ],
              [
                -50.21338630933355,
                -29.476977673410403
              ],
              [
                -50.214481522694584,
                -29.477609537572253
              ],
              [
                -50.21880761547067,
                -29.481515606936416
              ],
              [
                -50.2195742648234,
                -29.479620014450866
              ],
              [
                -50.21919094014704,
                -29.477322326589594
              ],
              [
                -50.21721955609717,
                -29.47628836705202
              ],
              [
                -50.21552197538757,
                -29.476403251445085
              ],
              [
                -50.213879155346014,
                -29.474507658959535
              ],
              [
                -50.21059351526291,
                -29.472899277456648
              ],
              [
                -50.210812557935114,
                -29.47169299132948
              ],
              [
                -50.20692455050344,
                -29.470486705202312
              ],
              [
                -50.20440555977306,
                -29.466523193641617
              ],
              [
                -50.20369367108838,
                -29.46307666184971
              ],
              [
                -50.20670550783123,
                -29.462904335260113
              ],
              [
                -50.20692455050344,
                -29.46221502890173
              ],
              [
                -50.205281730461884,
                -29.460721531791904
              ],
              [
                -50.20489840578552,
                -29.45922803468208
              ],
              [
                -50.20511744845773,
                -29.457102673410404
              ],
              [
                -50.20331034641202,
                -29.45509219653179
              ],
              [
                -50.20418651710085,
                -29.454288005780345
              ],
              [
                -50.206595986495124,
                -29.45698778901734
              ],
              [
                -50.20791024252837,
                -29.459400361271676
              ],
              [
                -50.21157920728784,
                -29.460721531791904
              ],
              [
                -50.21229109597251,
                -29.460089667630058
              ],
              [
                -50.21010066925044,
                -29.457677095375722
              ],
              [
                -50.20971734457408,
                -29.456126156069363
              ],
              [
                -50.209498301901874,
                -29.451703106936414
              ],
              [
                -50.212126813968354,
                -29.451128684971096
              ],
              [
                -50.21579577872782,
                -29.452392413294795
              ],
              [
                -50.21639814607639,
                -29.451473338150286
              ],
              [
                -50.21218157463641,
                -29.4486012283237
              ],
              [
                -50.21108636127537,
                -29.44739494219653
              ],
              [
                -50.210812557935114,
                -29.444580274566473
              ],
              [
                -50.2073078751798,
                -29.44348887283237
              ],
              [
                -50.205993619146554,
                -29.442512355491328
              ],
              [
                -50.20637694382292,
                -29.441478395953755
              ],
              [
                -50.20988162657823,
                -29.44199537572254
              ],
              [
                -50.21300298465719,
                -29.441823049132946
              ],
              [
                -50.21497436870705,
                -29.440501878612714
              ],
              [
                -50.21831476945821,
                -29.44262723988439
              ],
              [
                -50.22088852085664,
                -29.445499349710982
              ],
              [
                -50.22362655425923,
                -29.450784031791905
              ],
              [
                -50.22532413496884,
                -29.451473338150286
              ],
              [
                -50.22510509229663,
                -29.449520303468205
              ],
              [
                -50.22351703292313,
                -29.44389096820809
              ],
              [
                -50.23140256912259,
                -29.443718641618496
              ],
              [
                -50.23008831308934,
                -29.442397471098264
              ],
              [
                -50.22767884369506,
                -29.442512355491328
              ],
              [
                -50.2241194002717,
                -29.44159328034682
              ],
              [
                -50.2258169809813,
                -29.440789089595373
              ],
              [
                -50.22641934832987,
                -29.439525361271674
              ],
              [
                -50.22307894757871,
                -29.43521719653179
              ],
              [
                -50.22187421288157,
                -29.43297695086705
              ],
              [
                -50.22269562290235,
                -29.431426011560692
              ],
              [
                -50.22417416093975,
                -29.430909031791906
              ],
              [
                -50.2271859976826,
                -29.43228764450867
              ],
              [
                -50.22828121104363,
                -29.435389523121387
              ],
              [
                -50.230307355761546,
                -29.434987427745664
              ],
              [
                -50.23129304778648,
                -29.435619291907514
              ],
              [
                -50.23222397914336,
                -29.43458533236994
              ],
              [
                -50.23101924444622,
                -29.433091835260115
              ],
              [
                -50.23260730381972,
                -29.431426011560692
              ],
              [
                -50.235181055218156,
                -29.43039205202312
              ],
              [
                -50.23441440586543,
                -29.42878367052023
              ],
              [
                -50.23561914056257,
                -29.428094364161847
              ],
              [
                -50.23791908862074,
                -29.42792203757225
              ],
              [
                -50.24082140402749,
                -29.426773193641615
              ],
              [
                -50.23989047267061,
                -29.42459039017341
              ],
              [
                -50.23857621663737,
                -29.423384104046242
              ],
              [
                -50.23978095133451,
                -29.4224075867052
              ],
              [
                -50.24098568603164,
                -29.423211777456647
              ],
              [
                -50.24290230941346,
                -29.423096893063583
              ],
              [
                -50.243723719434236,
                -29.4224075867052
              ],
              [
                -50.24290230941346,
                -29.419592919075143
              ],
              [
                -50.24520225747163,
                -29.41758244219653
              ],
              [
                -50.247392684193706,
                -29.41660592485549
              ],
              [
                -50.24837837621864,
                -29.415571965317916
              ],
              [
                -50.249309307575516,
                -29.410976589595375
              ],
              [
                -50.2471736415215,
                -29.411206358381502
              ],
              [
                -50.24602366749241,
                -29.409310765895952
              ],
              [
                -50.246297470832666,
                -29.40730028901734
              ],
              [
                -50.24399752277449,
                -29.408219364161848
              ],
              [
                -50.2442165654467,
                -29.410402167630057
              ],
              [
                -50.245585582147996,
                -29.412297760115607
              ],
              [
                -50.24481893279527,
                -29.41338916184971
              ],
              [
                -50.24328563408982,
                -29.413618930635838
              ],
              [
                -50.243723719434236,
                -29.414882658959534
              ],
              [
                -50.24301183074956,
                -29.415916618497107
              ],
              [
                -50.24142377137606,
                -29.41660592485549
              ],
              [
                -50.23978095133451,
                -29.41637615606936
              ],
              [
                -50.23627626857919,
                -29.413216835260116
              ],
              [
                -50.233976320521016,
                -29.413274277456647
              ],
              [
                -50.23249778248362,
                -29.414825216763006
              ],
              [
                -50.23310014983219,
                -29.41568684971098
              ],
              [
                -50.23589294390283,
                -29.416088945086702
              ],
              [
                -50.23238826114751,
                -29.41758244219653
              ],
              [
                -50.22997879175324,
                -29.41660592485549
              ],
              [
                -50.22630982699377,
                -29.416778251445084
              ],
              [
                -50.22461224628416,
                -29.417410115606934
              ],
              [
                -50.22242181956209,
                -29.416778251445084
              ],
              [
                -50.22110756352885,
                -29.41402102601156
              ],
              [
                -50.22028615350807,
                -29.413274277456647
              ],
              [
                -50.2165076674125,
                -29.412584971098266
              ],
              [
                -50.21557673605562,
                -29.41212543352601
              ],
              [
                -50.212126813968354,
                -29.41149356936416
              ],
              [
                -50.21168872862394,
                -29.41017239884393
              ],
              [
                -50.21459104403068,
                -29.41080426300578
              ],
              [
                -50.21842429079431,
                -29.40982774566474
              ],
              [
                -50.22077899952054,
                -29.40890867052023
              ],
              [
                -50.22209325555378,
                -29.40988518786127
              ],
              [
                -50.22307894757871,
                -29.409425650289016
              ],
              [
                -50.22307894757871,
                -29.408104479768785
              ],
              [
                -50.22012187150392,
                -29.40672586705202
              ],
              [
                -50.21979330749561,
                -29.405806791907512
              ],
              [
                -50.22181945221352,
                -29.40540469653179
              ],
              [
                -50.22307894757871,
                -29.403623988439307
              ],
              [
                -50.22302418691066,
                -29.40178583815029
              ],
              [
                -50.21847905146236,
                -29.402073049132948
              ],
              [
                -50.21459104403068,
                -29.400120014450867
              ],
              [
                -50.213276787997444,
                -29.398798843930635
              ],
              [
                -50.21398867668212,
                -29.395582080924854
              ],
              [
                -50.210812557935114,
                -29.39477789017341
              ],
              [
                -50.209607823237974,
                -29.393112066473986
              ],
              [
                -50.2104839939268,
                -29.3925950867052
              ],
              [
                -50.21289346332108,
                -29.393801372832367
              ],
              [
                -50.21459104403068,
                -29.39328439306358
              ],
              [
                -50.21672671008471,
                -29.392078106936417
              ],
              [
                -50.21738383810133,
                -29.390182514450867
              ],
              [
                -50.22001235016781,
                -29.38937832369942
              ],
              [
                -50.22598126298546,
                -29.391101589595372
              ],
              [
                -50.2270764763465,
                -29.39167601156069
              ],
              [
                -50.22778836503117,
                -29.393112066473986
              ],
              [
                -50.230909723110116,
                -29.39391625722543
              ],
              [
                -50.235181055218156,
                -29.39420346820809
              ],
              [
                -50.23791908862074,
                -29.39581184971098
              ],
              [
                -50.240109515342816,
                -29.3951225433526
              ],
              [
                -50.23780956728464,
                -29.394088583815027
              ],
              [
                -50.23720719993607,
                -29.392480202312136
              ],
              [
                -50.2379738492888,
                -29.391905780346818
              ],
              [
                -50.24142377137606,
                -29.390412283236994
              ],
              [
                -50.241916617388526,
                -29.388803901734104
              ],
              [
                -50.243121352085666,
                -29.3877125
              ],
              [
                -50.2441070441106,
                -29.384725505780345
              ],
              [
                -50.24202613872463,
                -29.384093641618495
              ],
              [
                -50.24229994206489,
                -29.38300223988439
              ],
              [
                -50.24038331868307,
                -29.38300223988439
              ],
              [
                -50.241314250039956,
                -29.384725505780345
              ],
              [
                -50.24027379734697,
                -29.38650621387283
              ],
              [
                -50.238192891961006,
                -29.387023193641618
              ],
              [
                -50.235181055218156,
                -29.38840180635838
              ],
              [
                -50.23299062849608,
                -29.38547225433526
              ],
              [
                -50.23348347450855,
                -29.383691546242773
              ],
              [
                -50.232716825155826,
                -29.383174566473986
              ],
              [
                -50.23162161179479,
                -29.37978547687861
              ],
              [
                -50.233373953172446,
                -29.37909617052023
              ],
              [
                -50.23687863592776,
                -29.380187572254336
              ],
              [
                -50.241916617388526,
                -29.37978547687861
              ],
              [
                -50.24202613872463,
                -29.37840686416185
              ],
              [
                -50.23961666933035,
                -29.378291979768786
              ],
              [
                -50.238302413297106,
                -29.37748778901734
              ],
              [
                -50.23901430198178,
                -29.376626156069364
              ],
              [
                -50.2379738492888,
                -29.375017774566473
              ],
              [
                -50.24142377137606,
                -29.375075216763005
              ],
              [
                -50.24487369346332,
                -29.378808959537572
              ],
              [
                -50.24459989012306,
                -29.380876878612714
              ],
              [
                -50.24520225747163,
                -29.381910838150286
              ],
              [
                -50.24711888085344,
                -29.38231293352601
              ],
              [
                -50.24777600887007,
                -29.380991763005778
              ],
              [
                -50.24969263225188,
                -29.3803024566474
              ],
              [
                -50.25002119626019,
                -29.378981286127168
              ],
              [
                -50.247995051542276,
                -29.377717557803468
              ],
              [
                -50.24711888085344,
                -29.37587940751445
              ],
              [
                -50.24509273613553,
                -29.374213583815028
              ],
              [
                -50.24761172686591,
                -29.37392637283237
              ],
              [
                -50.248706940226946,
                -29.372605202312137
              ],
              [
                -50.248104572878376,
                -29.37111170520231
              ],
              [
                -50.24481893279527,
                -29.370709609826587
              ],
              [
                -50.241807096052426,
                -29.368814017341037
              ],
              [
                -50.24109520736775,
                -29.36720563583815
              ],
              [
                -50.239507147994246,
                -29.36559725433526
              ],
              [
                -50.238192891961006,
                -29.361576300578033
              ],
              [
                -50.24082140402749,
                -29.36117420520231
              ],
              [
                -50.243723719434236,
                -29.362323049132947
              ],
              [
                -50.2458046248202,
                -29.361576300578033
              ],
              [
                -50.24339515542592,
                -29.358187210982656
              ],
              [
                -50.24219042072878,
                -29.357497904624275
              ],
              [
                -50.23912382331788,
                -29.35468323699422
              ],
              [
                -50.24279278807735,
                -29.352385549132947
              ],
              [
                -50.24700935951734,
                -29.351696242774565
              ],
              [
                -50.24542130014384,
                -29.350375072254334
              ],
              [
                -50.24109520736775,
                -29.348192268786125
              ],
              [
                -50.23928810532204,
                -29.34807738439306
              ],
              [
                -50.23852145596931,
                -29.346296676300575
              ],
              [
                -50.24038331868307,
                -29.346526445086702
              ],
              [
                -50.24301183074956,
                -29.344803179190748
              ],
              [
                -50.24481893279527,
                -29.344688294797685
              ],
              [
                -50.24662603484098,
                -29.345722254335257
              ],
              [
                -50.24898074356721,
                -29.34549248554913
              ],
              [
                -50.249802153587986,
                -29.343884104046243
              ],
              [
                -50.249802153587986,
                -29.339920592485548
              ],
              [
                -50.24821409421448,
                -29.340207803468207
              ],
              [
                -50.24640699216877,
                -29.33940361271676
              ],
              [
                -50.24969263225188,
                -29.334980563583812
              ],
              [
                -50.25139021296148,
                -29.33457846820809
              ],
              [
                -50.24958311091578,
                -29.332108453757225
              ],
              [
                -50.249309307575516,
                -29.33038518786127
              ],
              [
                -50.24640699216877,
                -29.332395664739884
              ],
              [
                -50.24399752277449,
                -29.335095447976876
              ],
              [
                -50.241916617388526,
                -29.336071965317917
              ],
              [
                -50.23989047267061,
                -29.335382658959535
              ],
              [
                -50.23901430198178,
                -29.336991040462426
              ],
              [
                -50.2364953112514,
                -29.336588945086703
              ],
              [
                -50.23479773054179,
                -29.334521026011558
              ],
              [
                -50.23222397914336,
                -29.33647406069364
              ],
              [
                -50.230909723110116,
                -29.336588945086703
              ],
              [
                -50.22620030565766,
                -29.334118930635835
              ],
              [
                -50.22209325555378,
                -29.330787283236994
              ],
              [
                -50.22050519618028,
                -29.3280875
              ],
              [
                -50.21919094014704,
                -29.3280875
              ],
              [
                -50.21787668411379,
                -29.328891690751444
              ],
              [
                -50.21891713680678,
                -29.331993569364162
              ],
              [
                -50.22017663217197,
                -29.334176372832367
              ],
              [
                -50.22061471751638,
                -29.33681871387283
              ],
              [
                -50.22247658023014,
                -29.339805708092484
              ],
              [
                -50.22247658023014,
                -29.34129920520231
              ],
              [
                -50.22110756352885,
                -29.34221828034682
              ],
              [
                -50.218698094134574,
                -29.34060989884393
              ],
              [
                -50.216890992088864,
                -29.34032268786127
              ],
              [
                -50.21541245405146,
                -29.33877174855491
              ],
              [
                -50.21612434273614,
                -29.336588945086703
              ],
              [
                -50.21519341137925,
                -29.33618684971098
              ],
              [
                -50.214919608039,
                -29.334004046242775
              ],
              [
                -50.21371487334186,
                -29.332797760115604
              ],
              [
                -50.21289346332108,
                -29.33429125722543
              ],
              [
                -50.210210190586544,
                -29.332912644508667
              ],
              [
                -50.20911497722551,
                -29.33130426300578
              ],
              [
                -50.20610314048266,
                -29.330212861271676
              ],
              [
                -50.2057198158063,
                -29.33101705202312
              ],
              [
                -50.20692455050344,
                -29.33222333815029
              ],
              [
                -50.20621266181877,
                -29.334406141618494
              ],
              [
                -50.2073078751798,
                -29.336301734104044
              ],
              [
                -50.207691199856164,
                -29.338197326589594
              ],
              [
                -50.20610314048266,
                -29.338025
              ],
              [
                -50.204679363113314,
                -29.33871430635838
              ],
              [
                -50.20177704770657,
                -29.337622904624276
              ],
              [
                -50.200900877017745,
                -29.339575939306357
              ],
              [
                -50.197998561610994,
                -29.33877174855491
              ],
              [
                -50.197396194262424,
                -29.33969082369942
              ],
              [
                -50.19750571559853,
                -29.341701300578034
              ],
              [
                -50.19531528887646,
                -29.341414089595375
              ],
              [
                -50.19350818683075,
                -29.34221828034682
              ],
              [
                -50.194220075515425,
                -29.34440108381503
              ],
              [
                -50.19290581948218,
                -29.346296676300575
              ],
              [
                -50.19328914415854,
                -29.34767528901734
              ],
              [
                -50.19531528887646,
                -29.34870924855491
              ],
              [
                -50.19449387885568,
                -29.352385549132947
              ],
              [
                -50.19717715159022,
                -29.35347695086705
              ],
              [
                -50.19931281764424,
                -29.352902528901733
              ],
              [
                -50.19991518499281,
                -29.354281141618497
              ],
              [
                -50.20188656904267,
                -29.354625794797688
              ],
              [
                -50.202324654387084,
                -29.355487427745665
              ],
              [
                -50.20418651710085,
                -29.356521387283237
              ],
              [
                -50.20331034641202,
                -29.358187210982656
              ],
              [
                -50.20511744845773,
                -29.358876517341038
              ],
              [
                -50.2074173965159,
                -29.361403973988438
              ],
              [
                -50.20632218315487,
                -29.361920953757224
              ],
              [
                -50.201612765702414,
                -29.361576300578033
              ],
              [
                -50.199805663656704,
                -29.361691184971097
              ],
              [
                -50.199093774972035,
                -29.362610260115606
              ],
              [
                -50.20210561171488,
                -29.364505852601155
              ],
              [
                -50.204022235096694,
                -29.36628656069364
              ],
              [
                -50.20369367108838,
                -29.367607731213873
              ],
              [
                -50.20188656904267,
                -29.367377962427746
              ],
              [
                -50.1994770996484,
                -29.36789494219653
              ],
              [
                -50.19569861355282,
                -29.367780057803465
              ],
              [
                -50.19509624620425,
                -29.3665737716763
              ],
              [
                -50.19520576754036,
                -29.36462073699422
              ],
              [
                -50.19471292152789,
                -29.36341445086705
              ],
              [
                -50.192303452133615,
                -29.362610260115606
              ],
              [
                -50.18857972670609,
                -29.36019768786127
              ],
              [
                -50.18857972670609,
                -29.35858930635838
              ],
              [
                -50.18589645397155,
                -29.357497904624275
              ],
              [
                -50.185020283282725,
                -29.359508381502888
              ],
              [
                -50.18611549664376,
                -29.36462073699422
              ],
              [
                -50.18491076194662,
                -29.365080274566473
              ],
              [
                -50.18288461722871,
                -29.36467817919075
              ],
              [
                -50.18228224988014,
                -29.362323049132947
              ],
              [
                -50.1797084984817,
                -29.359795592485547
              ],
              [
                -50.17872280645677,
                -29.357899999999997
              ],
              [
                -50.178887088460925,
                -29.355487427745665
              ],
              [
                -50.178284721112355,
                -29.354510910404624
              ],
              [
                -50.17368482499601,
                -29.352902528901733
              ],
              [
                -50.1735753036599,
                -29.35152391618497
              ],
              [
                -50.175820491050025,
                -29.35060484104046
              ],
              [
                -50.17571096971392,
                -29.34991553468208
              ],
              [
                -50.1735753036599,
                -29.348479479768784
              ],
              [
                -50.17018014224069,
                -29.344975505780347
              ],
              [
                -50.167880194182516,
                -29.344286199421965
              ],
              [
                -50.166511177481226,
                -29.343022471098266
              ],
              [
                -50.165415964120186,
                -29.343884104046243
              ],
              [
                -50.16388266541474,
                -29.342103395953757
              ],
              [
                -50.16202080270098,
                -29.341184320809248
              ],
              [
                -50.16059702533163,
                -29.33940361271676
              ],
              [
                -50.158680401949816,
                -29.339116401734103
              ],
              [
                -50.15720186391242,
                -29.337910115606935
              ],
              [
                -50.156216171887486,
                -29.339173843930634
              ],
              [
                -50.15402574516541,
                -29.339116401734103
              ],
              [
                -50.15101390842257,
                -29.340207803468207
              ],
              [
                -50.14800207167972,
                -29.340092919075143
              ],
              [
                -50.14619496963401,
                -29.339288728323698
              ],
              [
                -50.14362121823558,
                -29.339518497109825
              ],
              [
                -50.14252600487454,
                -29.33871430635838
              ],
              [
                -50.14049986015662,
                -29.338484537572253
              ],
              [
                -50.13721422007352,
                -29.33900151734104
              ],
              [
                -50.13568092136807,
                -29.337910115606935
              ],
              [
                -50.13480475067924,
                -29.335382658959535
              ],
              [
                -50.133709537318204,
                -29.335325216763003
              ],
              [
                -50.13091674324757,
                -29.33647406069364
              ],
              [
                -50.12910964120186,
                -29.336416618497108
              ],
              [
                -50.12741206049225,
                -29.335325216763003
              ],
              [
                -50.125604958446544,
                -29.335612427745662
              ],
              [
                -50.122593121703694,
                -29.33521033236994
              ],
              [
                -50.120183652309414,
                -29.33429125722543
              ],
              [
                -50.11799322558734,
                -29.336301734104044
              ],
              [
                -50.11558375619307,
                -29.335095447976876
              ],
              [
                -50.11569327752917,
                -29.334004046242775
              ],
              [
                -50.11760990091098,
                -29.333084971098266
              ],
              [
                -50.117117054898515,
                -29.33067239884393
              ],
              [
                -50.11799322558734,
                -29.329006575144508
              ],
              [
                -50.11788370425124,
                -29.32688121387283
              ],
              [
                -50.12007413097331,
                -29.325674927745663
              ],
              [
                -50.11848607159981,
                -29.324123988439304
              ],
              [
                -50.11618612354164,
                -29.325789812138726
              ],
              [
                -50.115802798865275,
                -29.327627962427744
              ],
              [
                -50.11317428679879,
                -29.3268237716763
              ],
              [
                -50.112298116109955,
                -29.327398193641617
              ],
              [
                -50.11268144078632,
                -29.32912145953757
              ],
              [
                -50.1119147914336,
                -29.330097976878612
              ],
              [
                -50.11071005673646,
                -29.330212861271676
              ],
              [
                -50.10928627936711,
                -29.329178901734103
              ],
              [
                -50.1057815966118,
                -29.327972615606935
              ],
              [
                -50.10561731460764,
                -29.329523554913294
              ],
              [
                -50.10682204930478,
                -29.33262543352601
              ],
              [
                -50.10802678400192,
                -29.334693352601153
              ],
              [
                -50.106603006632575,
                -29.336071965317917
              ],
              [
                -50.10397449456609,
                -29.33492312138728
              ],
              [
                -50.10161978583986,
                -29.33268287572254
              ],
              [
                -50.09910079510948,
                -29.334118930635835
              ],
              [
                -50.09652704371104,
                -29.33429125722543
              ],
              [
                -50.09461042032923,
                -29.333774277456648
              ],
              [
                -50.09209142959885,
                -29.334004046242775
              ],
              [
                -50.08842246483938,
                -29.33262543352601
              ],
              [
                -50.08628679878536,
                -29.332797760115604
              ],
              [
                -50.08858674684354,
                -29.334980563583812
              ],
              [
                -50.08979148154067,
                -29.337680346820807
              ],
              [
                -50.091324780246126,
                -29.339518497109825
              ],
              [
                -50.09159858358638,
                -29.340724783236993
              ],
              [
                -50.090777173565606,
                -29.342275722543352
              ],
              [
                -50.08732725147834,
                -29.34187362716763
              ],
              [
                -50.085903474109,
                -29.342390606936416
              ],
              [
                -50.088203422167176,
                -29.345320158959538
              ],
              [
                -50.08732725147834,
                -29.346928540462425
              ],
              [
                -50.08541062809653,
                -29.34681365606936
              ],
              [
                -50.08322020137446,
                -29.347905057803466
              ],
              [
                -50.08420589339939,
                -29.349513439306357
              ],
              [
                -50.08201546667732,
                -29.35089205202312
              ],
              [
                -50.08228927001758,
                -29.351926011560693
              ],
              [
                -50.07889410859837,
                -29.35278764450867
              ],
              [
                -50.077908416573436,
                -29.352615317919074
              ],
              [
                -50.07632035719994,
                -29.354510910404624
              ],
              [
                -50.07752509189708,
                -29.35468323699422
              ],
              [
                -50.07752509189708,
                -29.356004407514448
              ],
              [
                -50.07560846851526,
                -29.356004407514448
              ],
              [
                -50.0752251438389,
                -29.358474421965315
              ],
              [
                -50.07100857239892,
                -29.360025361271674
              ],
              [
                -50.07002288037398,
                -29.361403973988438
              ],
              [
                -50.06717532563529,
                -29.361576300578033
              ],
              [
                -50.06520394158542,
                -29.363127239884392
              ],
              [
                -50.06339683953972,
                -29.363873988439305
              ],
              [
                -50.062082583506474,
                -29.36370166184971
              ],
              [
                -50.06011119945661,
                -29.364793063583814
              ],
              [
                -50.052882791273774,
                -29.356923482658956
              ],
              [
                -50.047297203132494,
                -29.35560231213873
              ],
              [
                -50.04220446100368,
                -29.353189739884392
              ],
              [
                -50.04099972630654,
                -29.355085332369942
              ],
              [
                -50.03519509549305,
                -29.350317630057802
              ],
              [
                -50.03399036079591,
                -29.34962832369942
              ],
              [
                -50.03530461682915,
                -29.349111343930634
              ],
              [
                -50.034976052820845,
                -29.34767528901734
              ],
              [
                -50.03798788956369,
                -29.344918063583812
              ],
              [
                -50.04012355561771,
                -29.34342456647399
              ],
              [
                -50.042478264343934,
                -29.340380130057802
              ],
              [
                -50.043025871024454,
                -29.338599421965316
              ],
              [
                -50.04401156304939,
                -29.33739313583815
              ],
              [
                -50.044887733738214,
                -29.33521033236994
              ],
              [
                -50.048885262506,
                -29.333084971098266
              ],
              [
                -50.05008999720313,
                -29.331878684971098
              ],
              [
                -50.051075689228064,
                -29.329293786127167
              ],
              [
                -50.05080188588781,
                -29.326479118497108
              ],
              [
                -50.05140425323638,
                -29.326019580924854
              ],
              [
                -50.05118521056417,
                -29.324123988439304
              ],
              [
                -50.05271850926962,
                -29.322228395953758
              ],
              [
                -50.054087525970914,
                -29.32107955202312
              ],
              [
                -50.055292260668054,
                -29.319298843930635
              ],
              [
                -50.05622319202493,
                -29.319011632947976
              ],
              [
                -50.05918026809973,
                -29.315794869942195
              ],
              [
                -50.06180878016622,
                -29.315220447976877
              ],
              [
                -50.06252066885089,
                -29.314588583815027
              ],
              [
                -50.06230162617868,
                -29.312692991329477
              ],
              [
                -50.06410872822439,
                -29.310797398843928
              ],
              [
                -50.06509442024932,
                -29.31051018786127
              ],
              [
                -50.06887290634489,
                -29.311716473988437
              ],
              [
                -50.07199426442385,
                -29.31028041907514
              ],
              [
                -50.07391088780566,
                -29.308097615606936
              ],
              [
                -50.0764846392041,
                -29.307810404624277
              ],
              [
                -50.07878458726227,
                -29.304880852601155
              ],
              [
                -50.08190594534122,
                -29.303272471098264
              ],
              [
                -50.082727355361996,
                -29.302295953757223
              ],
              [
                -50.08541062809653,
                -29.302008742774564
              ],
              [
                -50.087710576154706,
                -29.298677095375723
              ],
              [
                -50.089408156864316,
                -29.297815462427742
              ],
              [
                -50.09148906225028,
                -29.29798778901734
              ],
              [
                -50.09302236095573,
                -29.29637940751445
              ],
              [
                -50.091981908262746,
                -29.293909393063583
              ],
              [
                -50.09411757431677,
                -29.293392413294796
              ],
              [
                -50.09450089899313,
                -29.292128684971097
              ],
              [
                -50.09959364112194,
                -29.28839494219653
              ],
              [
                -50.10101741849129,
                -29.285695158959538
              ],
              [
                -50.10079837581908,
                -29.28391445086705
              ],
              [
                -50.10397449456609,
                -29.28288049132948
              ],
              [
                -50.10517922926323,
                -29.281099783236993
              ],
              [
                -50.108519630014385,
                -29.280123265895952
              ],
              [
                -50.10928627936711,
                -29.279319075144507
              ],
              [
                -50.108410108678285,
                -29.278227673410402
              ],
              [
                -50.108410108678285,
                -29.276504407514448
              ],
              [
                -50.10939580070321,
                -29.275183236994216
              ],
              [
                -50.11021721072399,
                -29.272885549132948
              ],
              [
                -50.112298116109955,
                -29.269898554913294
              ],
              [
                -50.11372189347931,
                -29.268577384393062
              ],
              [
                -50.11251715878217,
                -29.267428540462426
              ],
              [
                -50.11547423485696,
                -29.262316184971098
              ],
              [
                -50.11558375619307,
                -29.26082268786127
              ],
              [
                -50.114707585504235,
                -29.259386632947976
              ],
              [
                -50.11432426082787,
                -29.25760592485549
              ],
              [
                -50.11328380813489,
                -29.257376156069363
              ],
              [
                -50.11081957807256,
                -29.258525
              ],
              [
                -50.10890295469075,
                -29.258122904624276
              ],
              [
                -50.10621968195621,
                -29.256514523121385
              ],
              [
                -50.10802678400192,
                -29.254906141618495
              ],
              [
                -50.10758869865751,
                -29.25352752890173
              ],
              [
                -50.10468638325076,
                -29.254618930635836
              ],
              [
                -50.10320784521336,
                -29.254676372832368
              ],
              [
                -50.10140074316765,
                -29.255882658959536
              ],
              [
                -50.09948411978584,
                -29.254274277456645
              ],
              [
                -50.09532230901391,
                -29.251574494219653
              ],
              [
                -50.09389853164456,
                -29.25289566473988
              ],
              [
                -50.09220095093495,
                -29.25318287572254
              ],
              [
                -50.08929863552821,
                -29.254274277456645
              ],
              [
                -50.08612251678121,
                -29.25318287572254
              ],
              [
                -50.08557491010069,
                -29.251689378612717
              ],
              [
                -50.083384483378616,
                -29.25019588150289
              ],
              [
                -50.081577381332906,
                -29.250023554913295
              ],
              [
                -50.07922267260668,
                -29.251402167630054
              ],
              [
                -50.07632035719994,
                -29.250080997109826
              ],
              [
                -50.07347280246125,
                -29.24950657514451
              ],
              [
                -50.07062524772255,
                -29.248185404624277
              ],
              [
                -50.06870862434074,
                -29.245600505780345
              ],
              [
                -50.068106256992166,
                -29.24571539017341
              ],
              [
                -50.06717532563529,
                -29.24801307803468
              ],
              [
                -50.06717532563529,
                -29.24927680635838
              ],
              [
                -50.06509442024932,
                -29.24950657514451
              ],
              [
                -50.06312303619946,
                -29.24697911849711
              ],
              [
                -50.06328731820361,
                -29.24542817919075
              ],
              [
                -50.06482061690906,
                -29.243992124277455
              ],
              [
                -50.06339683953972,
                -29.242498627167627
              ],
              [
                -50.060877848809334,
                -29.24129234104046
              ],
              [
                -50.05551130334026,
                -29.24060303468208
              ],
              [
                -50.052773269937674,
                -29.24129234104046
              ],
              [
                -50.051623295908584,
                -29.24221141618497
              ],
              [
                -50.05008999720313,
                -29.241809320809246
              ],
              [
                -50.046804357120024,
                -29.239396748554913
              ],
              [
                -50.04499725507432,
                -29.239224421965318
              ],
              [
                -50.04340919570082,
                -29.240200939306355
              ],
              [
                -50.0413830509829,
                -29.24008605491329
              ],
              [
                -50.039904512945505,
                -29.238190462427745
              ],
              [
                -50.03859025691226,
                -29.238420231213873
              ],
              [
                -50.03650935152629,
                -29.237788367052023
              ],
              [
                -50.035687941505515,
                -29.2361225433526
              ],
              [
                -50.03481177081669,
                -29.232790895953755
              ],
              [
                -50.0321832587502,
                -29.232101589595374
              ],
              [
                -50.02928094334346,
                -29.232101589595374
              ],
              [
                -50.026378627936715,
                -29.231182514450865
              ],
              [
                -50.02260014184114,
                -29.22911459537572
              ],
              [
                -50.020902561131535,
                -29.228482731213873
              ],
              [
                -50.01701455369986,
                -29.22819552023121
              ],
              [
                -50.014824126977786,
                -29.227678540462428
              ],
              [
                -50.013619392280646,
                -29.226702023121387
              ],
              [
                -50.01137420489052,
                -29.226702023121387
              ],
              [
                -50.009895666853126,
                -29.225380852601155
              ],
              [
                -50.00661002677002,
                -29.22589783236994
              ],
              [
                -50.00420055737574,
                -29.225782947976878
              ],
              [
                -50.00392675403548,
                -29.226874349710982
              ],
              [
                -50.00080539595653,
                -29.227506213872832
              ],
              [
                -49.99960066125939,
                -29.22647225433526
              ],
              [
                -49.997574516541476,
                -29.226299927745664
              ],
              [
                -49.99680786718875,
                -29.228310404624274
              ],
              [
                -49.99500076514304,
                -29.226874349710982
              ],
              [
                -49.994015073118106,
                -29.22681690751445
              ],
              [
                -49.98771759629216,
                -29.223715028901733
              ],
              [
                -49.98421291353684,
                -29.220900361271674
              ],
              [
                -49.980105863432954,
                -29.219406864161847
              ],
              [
                -49.97917493207608,
                -29.218774999999997
              ],
              [
                -49.97780591537478,
                -29.21590289017341
              ],
              [
                -49.97649165934154,
                -29.214811488439306
              ],
              [
                -49.974410753955574,
                -29.214696604046242
              ],
              [
                -49.972713173245964,
                -29.214122182080924
              ],
              [
                -49.968989447818444,
                -29.21147984104046
              ],
              [
                -49.96997513984338,
                -29.20952680635838
              ],
              [
                -49.97041322518779,
                -29.20671213872832
              ],
              [
                -49.97112511387247,
                -29.204816546242775
              ],
              [
                -49.97041322518779,
                -29.202920953757225
              ],
              [
                -49.967784713121304,
                -29.203323049132948
              ],
              [
                -49.96548476506313,
                -29.201599783236993
              ],
              [
                -49.96499191905067,
                -29.199416979768785
              ],
              [
                -49.96269197099249,
                -29.1989
              ],
              [
                -49.959789655585745,
                -29.199819075144507
              ],
              [
                -49.95759922886367,
                -29.199474421965316
              ],
              [
                -49.95387550343615,
                -29.201082803468207
              ],
              [
                -49.94982321400032,
                -29.200680708092484
              ],
              [
                -49.948016111954615,
                -29.20217420520231
              ],
              [
                -49.94527807855202,
                -29.20148489884393
              ],
              [
                -49.94341621583826,
                -29.203208164739884
              ],
              [
                -49.94330669450216,
                -29.204988872832367
              ],
              [
                -49.942594805817485,
                -29.20567817919075
              ],
              [
                -49.93810443103724,
                -29.206827023121384
              ],
              [
                -49.93799490970114,
                -29.207573771676298
              ],
              [
                -49.9354211583027,
                -29.20832052023121
              ],
              [
                -49.93317597091258,
                -29.208377962427743
              ],
              [
                -49.93131410819882,
                -29.207401445086703
              ],
              [
                -49.92868559613233,
                -29.20791842485549
              ],
              [
                -49.926604690746366,
                -29.206482369942194
              ],
              [
                -49.92501663137286,
                -29.206195158959535
              ],
              [
                -49.9199786499121,
                -29.206482369942194
              ],
              [
                -49.91729537717756,
                -29.20832052023121
              ],
              [
                -49.9153239931277,
                -29.20768865606936
              ],
              [
                -49.91291452373342,
                -29.20791842485549
              ],
              [
                -49.91072409701135,
                -29.209009826589593
              ],
              [
                -49.90979316565447,
                -29.21021611271676
              ],
              [
                -49.90601467955889,
                -29.211594725433525
              ],
              [
                -49.90327664615631,
                -29.214696604046242
              ],
              [
                -49.901579065446704,
                -29.215328468208092
              ],
              [
                -49.89889579271217,
                -29.214811488439306
              ],
              [
                -49.898019622023334,
                -29.214122182080924
              ],
              [
                -49.89341972590699,
                -29.21722406069364
              ],
              [
                -49.892488794550104,
                -29.217281502890174
              ],
              [
                -49.8909007351766,
                -29.219291979768784
              ],
              [
                -49.88958647914336,
                -29.219579190751443
              ],
              [
                -49.888217462442064,
                -29.218774999999997
              ],
              [
                -49.88717700974908,
                -29.219694075144506
              ],
              [
                -49.88339852365351,
                -29.22078547687861
              ],
              [
                -49.88098905425923,
                -29.220325939306356
              ],
              [
                -49.878908148873265,
                -29.221474783236992
              ],
              [
                -49.877812935512225,
                -29.22262362716763
              ],
              [
                -49.87759389284002,
                -29.2249213150289
              ],
              [
                -49.87660820081509,
                -29.225093641618496
              ],
              [
                -49.874691577433275,
                -29.224404335260115
              ],
              [
                -49.87129641601407,
                -29.22457666184971
              ],
              [
                -49.86948931396836,
                -29.224404335260115
              ],
              [
                -49.867791733258755,
                -29.225323410404624
              ],
              [
                -49.86461561451175,
                -29.227908309248555
              ],
              [
                -49.864122768499286,
                -29.2287125
              ],
              [
                -49.86078236774812,
                -29.230493208092483
              ],
              [
                -49.859303829710726,
                -29.231814378612714
              ],
              [
                -49.85711340298865,
                -29.233078106936414
              ],
              [
                -49.85782529167333,
                -29.234686488439305
              ],
              [
                -49.85711340298865,
                -29.236524638728323
              ],
              [
                -49.85722292432476,
                -29.23807557803468
              ],
              [
                -49.855689625619306,
                -29.240200939306355
              ],
              [
                -49.85782529167333,
                -29.240775361271673
              ],
              [
                -49.858591941026056,
                -29.24157955202312
              ],
              [
                -49.85727768499281,
                -29.243302817919073
              ],
              [
                -49.857387206328916,
                -29.245198410404623
              ],
              [
                -49.85470393359438,
                -29.244279335260114
              ],
              [
                -49.85421108758191,
                -29.245198410404623
              ],
              [
                -49.852623028208406,
                -29.244394219653177
              ],
              [
                -49.85098020816685,
                -29.24577283236994
              ],
              [
                -49.848899302780886,
                -29.246577023121386
              ],
              [
                -49.848899302780886,
                -29.249793786127167
              ],
              [
                -49.85037784081828,
                -29.24927680635838
              ],
              [
                -49.85289683154867,
                -29.249678901734104
              ],
              [
                -49.85349919889724,
                -29.2511149566474
              ],
              [
                -49.85218494286399,
                -29.253297760115604
              ],
              [
                -49.852513506872306,
                -29.25410195086705
              ],
              [
                -49.854977736934636,
                -29.25502102601156
              ],
              [
                -49.85470393359438,
                -29.25731871387283
              ],
              [
                -49.85098020816685,
                -29.258180346820808
              ],
              [
                -49.84802313209206,
                -29.25829523121387
              ],
              [
                -49.84347799664376,
                -29.259271748554912
              ],
              [
                -49.8417256552661,
                -29.26047803468208
              ],
              [
                -49.842108979942466,
                -29.263120375722544
              ],
              [
                -49.843916081988176,
                -29.265820158959535
              ],
              [
                -49.84501129534921,
                -29.268405057803466
              ],
              [
                -49.844573210004796,
                -29.270013439306357
              ],
              [
                -49.84298515063129,
                -29.271277167630057
              ],
              [
                -49.8446827313409,
                -29.27231112716763
              ],
              [
                -49.84681839739492,
                -29.27167926300578
              ],
              [
                -49.847694568083746,
                -29.27231112716763
              ],
              [
                -49.84747552541154,
                -29.273689739884393
              ],
              [
                -49.84528509868947,
                -29.273402528901734
              ],
              [
                -49.84429940666454,
                -29.27437904624277
              ],
              [
                -49.84358751797986,
                -29.277595809248552
              ],
              [
                -49.84068520257312,
                -29.276504407514448
              ],
              [
                -49.83822097251079,
                -29.278687210982657
              ],
              [
                -49.83800192983858,
                -29.275815101156066
              ],
              [
                -49.83597578512067,
                -29.275010910404625
              ],
              [
                -49.8354829391082,
                -29.276102312138725
              ],
              [
                -49.833018709045874,
                -29.27719371387283
              ],
              [
                -49.831211607000164,
                -29.27690650289017
              ],
              [
                -49.82967830829471,
                -29.27598742774566
              ],
              [
                -49.82841881292952,
                -29.27661929190751
              ],
              [
                -49.82781644558095,
                -29.278285115606934
              ],
              [
                -49.82611886487135,
                -29.279204190751443
              ],
              [
                -49.82409272015343,
                -29.27811278901734
              ],
              [
                -49.82288798545629,
                -29.2820188583815
              ],
              [
                -49.82239513944383,
                -29.28259328034682
              ],
              [
                -49.818397610676044,
                -29.28448887283237
              ],
              [
                -49.81757620065527,
                -29.285522832369942
              ],
              [
                -49.81571433794151,
                -29.285924927745665
              ],
              [
                -49.81297630453892,
                -29.284086777456647
              ],
              [
                -49.811607287837624,
                -29.28391445086705
              ],
              [
                -49.81188109117788,
                -29.285924927745665
              ],
              [
                -49.80990970712802,
                -29.286786560693642
              ],
              [
                -49.80689787038517,
                -29.28701632947977
              ],
              [
                -49.80569313568803,
                -29.28747586705202
              ],
              [
                -49.80191464959246,
                -29.287705635838147
              ],
              [
                -49.799395658862075,
                -29.28747586705202
              ],
              [
                -49.795617172766505,
                -29.289486343930633
              ],
              [
                -49.795014805417935,
                -29.288222615606934
              ],
              [
                -49.79348150671248,
                -29.28741842485549
              ],
              [
                -49.79178392600288,
                -29.285580274566474
              ],
              [
                -49.79052443063769,
                -29.285924927745665
              ],
              [
                -49.787019747882375,
                -29.28747586705202
              ],
              [
                -49.78548644917692,
                -29.28902680635838
              ],
              [
                -49.78329602245485,
                -29.29029053468208
              ],
              [
                -49.78011990370785,
                -29.2906926300578
              ],
              [
                -49.778422322998246,
                -29.292473338150288
              ],
              [
                -49.77820328032604,
                -29.2944838150289
              ],
              [
                -49.77688902429279,
                -29.296494291907514
              ],
              [
                -49.77431527289436,
                -29.298102673410405
              ],
              [
                -49.7677987533962,
                -29.299883381502887
              ],
              [
                -49.76511548066166,
                -29.30028547687861
              ],
              [
                -49.76232268659102,
                -29.30028547687861
              ],
              [
                -49.75777755114272,
                -29.29930895953757
              ],
              [
                -49.75372526170689,
                -29.299021748554914
              ],
              [
                -49.7493991689308,
                -29.297413367052023
              ],
              [
                -49.74211600007991,
                -29.298791979768787
              ],
              [
                -49.73970653068564,
                -29.299883381502887
              ],
              [
                -49.738775599328754,
                -29.301319436416183
              ],
              [
                -49.739980334025894,
                -29.30218106936416
              ],
              [
                -49.742389803420174,
                -29.301721531791905
              ],
              [
                -49.74211600007991,
                -29.304478757225432
              ],
              [
                -49.740692222710564,
                -29.30597225433526
              ],
              [
                -49.741185068723034,
                -29.307006213872832
              ],
              [
                -49.74359453811731,
                -29.306719002890173
              ],
              [
                -49.74458023014224,
                -29.30729342485549
              ],
              [
                -49.744415948138084,
                -29.309820881502887
              ],
              [
                -49.74359453811731,
                -29.31148670520231
              ],
              [
                -49.739377966677324,
                -29.314818352601154
              ],
              [
                -49.73789942863993,
                -29.315105563583813
              ],
              [
                -49.736913736614994,
                -29.31372695086705
              ],
              [
                -49.73800894997603,
                -29.311314378612714
              ],
              [
                -49.737516103963564,
                -29.309878323699422
              ],
              [
                -49.735709001917854,
                -29.31028041907514
              ],
              [
                -49.73428522454851,
                -29.311601589595373
              ],
              [
                -49.73357333586384,
                -29.31407160404624
              ],
              [
                -49.73242336183475,
                -29.315392774566472
              ],
              [
                -49.730123413776575,
                -29.317116040462427
              ],
              [
                -49.730780541793195,
                -29.318322326589595
              ],
              [
                -49.73598280525811,
                -29.319183959537572
              ],
              [
                -49.73921368467317,
                -29.31878186416185
              ],
              [
                -49.74200647874381,
                -29.31912651734104
              ],
              [
                -49.74359453811731,
                -29.319700939306358
              ],
              [
                -49.74660637486016,
                -29.323779335260113
              ],
              [
                -49.746715896196264,
                -29.32561748554913
              ],
              [
                -49.746113528847694,
                -29.327110982658958
              ],
              [
                -49.744415948138084,
                -29.32877680635838
              ],
              [
                -49.74321121344095,
                -29.32912145953757
              ],
              [
                -49.741185068723034,
                -29.32871936416185
              ],
              [
                -49.738775599328754,
                -29.325789812138726
              ],
              [
                -49.735818523253954,
                -29.32521539017341
              ],
              [
                -49.73401142120825,
                -29.32590469653179
              ],
              [
                -49.7324781225028,
                -29.328202384393062
              ],
              [
                -49.730780541793195,
                -29.32912145953757
              ],
              [
                -49.727713944382295,
                -29.328891690751444
              ],
              [
                -49.7232783302701,
                -29.326479118497108
              ],
              [
                -49.72207359557296,
                -29.326306791907513
              ],
              [
                -49.71780226346492,
                -29.326479118497108
              ],
              [
                -49.71287380334026,
                -29.32561748554913
              ],
              [
                -49.7126,
                -29.326708887283235
              ],
              [
                -49.71462614471792,
                -29.3306149566474
              ],
              [
                -49.715776118747,
                -29.332395664739884
              ],
              [
                -49.719116519498165,
                -29.336014523121385
              ],
              [
                -49.72420926162698,
                -29.342907586705202
              ],
              [
                -49.72667349168931,
                -29.345377601156066
              ],
              [
                -49.73039721711683,
                -29.35020274566474
              ],
              [
                -49.73039721711683,
                -29.351696242774565
              ],
              [
                -49.72979484976826,
                -29.35341950867052
              ],
              [
                -49.73050673845293,
                -29.356176734104046
              ],
              [
                -49.731985276490335,
                -29.358187210982656
              ],
              [
                -49.73302572918332,
                -29.358704190751443
              ],
              [
                -49.73461378855682,
                -29.35830209537572
              ],
              [
                -49.73800894997603,
                -29.3615188583815
              ],
              [
                -49.74321121344095,
                -29.367780057803465
              ],
              [
                -49.74638733218795,
                -29.371915895953755
              ],
              [
                -49.750384860955734,
                -29.376683598265895
              ],
              [
                -49.76610117268659,
                -29.3963862716763
              ],
              [
                -49.7679082747323,
                -29.398511632947976
              ],
              [
                -49.771686760827876,
                -29.40339421965318
              ],
              [
                -49.77530096491929,
                -29.407702384393062
              ],
              [
                -49.77951753635928,
                -29.413216835260116
              ],
              [
                -49.78137939907304,
                -29.41528475433526
              ],
              [
                -49.78559597051303,
                -29.420626878612715
              ],
              [
                -49.787019747882375,
                -29.422809682080924
              ],
              [
                -49.79490528408183,
                -29.432402528901733
              ],
              [
                -49.79611001877897,
                -29.434298121387283
              ],
              [
                -49.80350270896596,
                -29.443603757225432
              ],
              [
                -49.811114441825154,
                -29.453426372832368
              ],
              [
                -49.814783406584624,
                -29.458308959537572
              ],
              [
                -49.82058803739812,
                -29.46571900289017
              ],
              [
                -49.82611886487135,
                -29.47307160404624
              ],
              [
                -49.82858309493368,
                -29.475771387283235
              ],
              [
                -49.83028067564328,
                -29.478298843930634
              ],
              [
                -49.83269014503756,
                -29.48128583815029
              ],
              [
                -49.83822097251079,
                -29.489212861271675
              ],
              [
                -49.8509254474988,
                -29.506100867052023
              ],
              [
                -49.85607295029567,
                -29.513625794797687
              ],
              [
                -49.861220453092535,
                -29.520403973988437
              ],
              [
                -49.862315666453576,
                -29.52212723988439
              ],
              [
                -49.867189365910185,
                -29.528618208092485
              ],
              [
                -49.870310723989135,
                -29.53332846820809
              ],
              [
                -49.87551298745405,
                -29.54027897398844
              ],
              [
                -49.87797721751638,
                -29.5441850433526
              ],
              [
                -49.892981640562574,
                -29.564404696531792
              ],
              [
                -49.89949816006073,
                -29.574227312138728
              ],
              [
                -49.90240047546748,
                -29.577673843930633
              ],
              [
                -49.90727417492408,
                -29.58462434971098
              ],
              [
                -49.90908127696979,
                -29.5877262283237
              ],
              [
                -49.91160026770018,
                -29.590828106936414
              ],
              [
                -49.91247643838901,
                -29.592493930635836
              ],
              [
                -49.92019769258431,
                -29.603982369942194
              ],
              [
                -49.92222383730223,
                -29.607199132947976
              ],
              [
                -49.92649516941026,
                -29.613690101156067
              ],
              [
                -49.929780809493366,
                -29.619376878612716
              ],
              [
                -49.9337235775931,
                -29.625121098265893
              ],
              [
                -49.93569496164296,
                -29.62822297687861
              ],
              [
                -49.936516371663735,
                -29.630176011560692
              ],
              [
                -49.93870679838581,
                -29.63322044797688
              ],
              [
                -49.943799540514625,
                -29.64097514450867
              ],
              [
                -49.94418286519099,
                -29.642526083815028
              ],
              [
                -49.94730422326994,
                -29.64769588150289
              ],
              [
                -49.94850895796708,
                -29.649476589595373
              ],
              [
                -49.95349217875979,
                -29.657690823699422
              ],
              [
                -49.95568260548186,
                -29.661079913294795
              ],
              [
                -49.957818271535885,
                -29.665100867052022
              ],
              [
                -49.960282501598215,
                -29.669006936416185
              ],
              [
                -49.96389670568963,
                -29.6759
              ],
              [
                -49.96811327712962,
                -29.682678179190752
              ],
              [
                -49.9722203272335,
                -29.69037543352601
              ],
              [
                -49.976382138005434,
                -29.697211054913293
              ],
              [
                -49.97950349608439,
                -29.70278294797688
              ],
              [
                -49.98339150351606,
                -29.70927391618497
              ],
              [
                -49.98738903228384,
                -29.716683959537573
              ],
              [
                -49.99149608238773,
                -29.723806791907514
              ],
              [
                -49.99571265382772,
                -29.731676372832368
              ],
              [
                -50.00047683194822,
                -29.74000549132948
              ],
              [
                -50.003707711363276,
                -29.746324132947976
              ],
              [
                -50.00890997482819,
                -29.75637651734104
              ],
              [
                -50.01268846092377,
                -29.76309725433526
              ],
              [
                -50.01761692104843,
                -29.772517774566474
              ],
              [
                -50.02260014184114,
                -29.782512716763005
              ],
              [
                -50.026488149272815,
                -29.789578106936414
              ],
              [
                -50.03459272814448,
                -29.805202384393063
              ],
              [
                -50.03859025691226,
                -29.812325216763004
              ],
              [
                -50.040616401630174,
                -29.816575939306357
              ],
              [
                -50.049104305178204,
                -29.831510910404624
              ],
              [
                -50.053978004634814,
                -29.840471893063583
              ],
              [
                -50.05868742208726,
                -29.849892413294796
              ],
              [
                -50.06372540354803,
                -29.86000223988439
              ],
              [
                -50.06881814567684,
                -29.87057160404624
              ],
              [
                -50.07527990450696,
                -29.884472615606935
              ],
              [
                -50.07889410859837,
                -29.89188265895954
              ],
              [
                -50.08541062809653,
                -29.905381575144506
              ],
              [
                -50.08732725147834,
                -29.90997695086705
              ],
              [
                -50.08990100287678,
                -29.915089306358382
              ],
              [
                -50.099374598449735,
                -29.93519407514451
              ],
              [
                -50.102276913856485,
                -29.94231690751445
              ],
              [
                -50.106000639284005,
                -29.948520664739885
              ],
              [
                -50.10988864671568,
                -29.956677456647398
              ],
              [
                -50.11120290274892,
                -29.95989421965318
              ],
              [
                -50.11311952613073,
                -29.963685404624275
              ],
              [
                -50.1167884908902,
                -29.973508020231215
              ],
              [
                -50.11919796028448,
                -29.976207803468206
              ],
              [
                -50.119581284960844,
                -29.97982666184971
              ],
              [
                -50.121388387006554,
                -29.98361784682081
              ],
              [
                -50.12401689907304,
                -29.98947695086705
              ],
              [
                -50.128178709844974,
                -29.999816546242773
              ],
              [
                -50.129985811890684,
                -30.004699132947977
              ],
              [
                -50.13288812729743,
                -30.011075216763004
              ],
              [
                -50.136776134729104,
                -30.019289450867053
              ],
              [
                -50.14192363752597,
                -30.030490679190752
              ],
              [
                -50.14329265422727,
                -30.03399465317919
              ],
              [
                -50.14608544829791,
                -30.039623988439306
              ],
              [
                -50.15419002716957,
                -30.05812037572254
              ],
              [
                -50.158023273933196,
                -30.066506936416182
              ],
              [
                -50.1613089140163,
                -30.07472117052023
              ],
              [
                -50.16432075075915,
                -30.081614234104045
              ],
              [
                -50.166073092136806,
                -30.086784031791908
              ],
              [
                -50.170289663576796,
                -30.09712362716763
              ],
              [
                -50.17248009029887,
                -30.10269552023121
              ],
              [
                -50.17729902908742,
                -30.114298843930634
              ],
              [
                -50.17998230182196,
                -30.1218237716763
              ],
              [
                -50.18217272854403,
                -30.126821242774565
              ],
              [
                -50.18491076194662,
                -30.134173843930636
              ],
              [
                -50.18792259868947,
                -30.141813656069363
              ],
              [
                -50.18951065806297,
                -30.146926011560694
              ],
              [
                -50.196027177561135,
                -30.16318215317919
              ],
              [
                -50.20210561171488,
                -30.179323410404624
              ],
              [
                -50.2086768918811,
                -30.196383742774564
              ],
              [
                -50.211414925283684,
                -30.202989595375723
              ],
              [
                -50.21612434273614,
                -30.215511994219654
              ],
              [
                -50.21902665814288,
                -30.22251994219653
              ],
              [
                -50.22160040954132,
                -30.2298725433526
              ],
              [
                -50.2241194002717,
                -30.23630606936416
              ],
              [
                -50.22702171567844,
                -30.24308424855491
              ],
              [
                -50.23227873981141,
                -30.256410838150288
              ],
              [
                -50.235126294550106,
                -30.26382088150289
              ],
              [
                -50.24301183074956,
                -30.283810765895954
              ],
              [
                -50.245695103484096,
                -30.28978475433526
              ],
              [
                -50.24941882891162,
                -30.298975505780348
              ],
              [
                -50.25188305897395,
                -30.30489205202312
              ],
              [
                -50.2563734337542,
                -30.316495375722543
              ],
              [
                -50.25768768978744,
                -30.319712138728324
              ],
              [
                -50.25982335584146,
                -30.32539891618497
              ],
              [
                -50.26431373062171,
                -30.33602572254335
              ],
              [
                -50.26968027609078,
                -30.3503862716763
              ],
              [
                -50.271323096132335,
                -30.35452210982659
              ],
              [
                -50.27767533362634,
                -30.371180346820807
              ],
              [
                -50.28200142640243,
                -30.384219725433525
              ],
              [
                -50.28939411658942,
                -30.40530101156069
              ],
              [
                -50.29421305537798,
                -30.417191546242773
              ],
              [
                -50.30001768619147,
                -30.4324137283237
              ],
              [
                -50.30198907024133,
                -30.436779335260116
              ],
              [
                -50.30412473629535,
                -30.44240867052023
              ],
              [
                -50.30609612034522,
                -30.44711893063584
              ],
              [
                -50.31272216117948,
                -30.46027319364162
              ],
              [
                -50.31491258790155,
                -30.464983453757224
              ],
              [
                -50.32071721871504,
                -30.476873988439305
              ],
              [
                -50.32252432076075,
                -30.48020563583815
              ],
              [
                -50.33161459165734,
                -30.496404335260117
              ],
              [
                -50.334297864391885,
                -30.500827384393062
              ],
              [
                -50.337419222470835,
                -30.506571604046243
              ],
              [
                -50.34010249520537,
                -30.511224421965316
              ],
              [
                -50.342895289276015,
                -30.51541770231214
              ],
              [
                -50.345523801342495,
                -30.520127962427747
              ],
              [
                -50.34831659541314,
                -30.524608453757224
              ],
              [
                -50.35368314088221,
                -30.532707803468206
              ],
              [
                -50.35680449896117,
                -30.537820158959537
              ],
              [
                -50.365073359836984,
                -30.549997904624277
              ],
              [
                -50.36731854722711,
                -30.553099783236995
              ],
              [
                -50.37399934872943,
                -30.56292239884393
              ],
              [
                -50.38068015023174,
                -30.571711054913294
              ],
              [
                -50.38330866229823,
                -30.574927817919075
              ],
              [
                -50.38741571240211,
                -30.580384826589594
              ],
              [
                -50.392508454530926,
                -30.586875794797688
              ],
              [
                -50.39579409461403,
                -30.590781864161848
              ],
              [
                -50.428705256113155,
                -30.63219768786127
              ],
              [
                -50.45088332667412,
                -30.661780419075143
              ],
              [
                -50.45362136007672,
                -30.66522695086705
              ],
              [
                -50.45641415414735,
                -30.669190462427746
              ],
              [
                -50.46490205769538,
                -30.680678901734105
              ],
              [
                -50.47037812450056,
                -30.689122904624277
              ],
              [
                -50.4778255753556,
                -30.69888807803468
              ],
              [
                -50.48018028408183,
                -30.70267926300578
              ],
              [
                -50.48450637685792,
                -30.708883020231212
              ],
              [
                -50.48642300023973,
                -30.712501878612716
              ],
              [
                -50.48910627297427,
                -30.71669515895954
              ],
              [
                -50.49217287038517,
                -30.721175650289016
              ],
              [
                -50.50170122662618,
                -30.735880852601156
              ],
              [
                -50.50657492608279,
                -30.743520664739883
              ],
              [
                -50.51177718954771,
                -30.750988150289018
              ],
              [
                -50.5146247442864,
                -30.754721893063582
              ],
              [
                -50.52010081109158,
                -30.76259147398844
              ],
              [
                -50.52289360516222,
                -30.767014523121386
              ],
              [
                -50.53077914136168,
                -30.778790173410403
              ],
              [
                -50.53417430278088,
                -30.783328106936416
              ],
              [
                -50.541895556976186,
                -30.79470166184971
              ],
              [
                -50.54408598369826,
                -30.797688656069365
              ],
              [
                -50.54709782044111,
                -30.802628684971097
              ],
              [
                -50.549178725827076,
                -30.805098699421965
              ],
              [
                -50.55202628056577,
                -30.809291979768787
              ],
              [
                -50.55832375739172,
                -30.818195520231214
              ],
              [
                -50.561609397474825,
                -30.822273916184972
              ],
              [
                -50.568290198977145,
                -30.831579552023122
              ],
              [
                -50.574478154466995,
                -30.839104479768785
              ],
              [
                -50.577380469873745,
                -30.84272333815029
              ],
              [
                -50.583075579351124,
                -30.85047803468208
              ],
              [
                -50.5899206628576,
                -30.859324132947975
              ],
              [
                -50.595287208326674,
                -30.86610231213873
              ],
              [
                -50.599010933754194,
                -30.870295592485547
              ],
              [
                -50.60541793191626,
                -30.879026806358382
              ],
              [
                -50.62102472231101,
                -30.899303901734104
              ],
              [
                -50.62288658502477,
                -30.902176011560694
              ],
              [
                -50.62808884848969,
                -30.909011632947976
              ],
              [
                -50.63772672606681,
                -30.921821242774566
              ],
              [
                -50.6406838021416,
                -30.92578475433526
              ],
              [
                -50.641614733498486,
                -30.926588945086706
              ],
              [
                -50.64500989491769,
                -30.931701300578034
              ],
              [
                -50.65798817324597,
                -30.949393497109828
              ],
              [
                -50.66001431796388,
                -30.952495375722542
              ],
              [
                -50.663190436710885,
                -30.9565737716763
              ],
              [
                -50.66789985416334,
                -30.9628924132948
              ],
              [
                -50.672499750279684,
                -30.969498265895954
              ],
              [
                -50.6774829710724,
                -30.97650621387283
              ],
              [
                -50.68241143119706,
                -30.983916257225435
              ],
              [
                -50.68881842935912,
                -30.992704913294798
              ],
              [
                -50.69172074476586,
                -30.997300289017343
              ],
              [
                -50.70059197299025,
                -31.010397109826588
              ],
              [
                -50.7037133310692,
                -31.014820158959537
              ],
              [
                -50.709572722550746,
                -31.023723699421964
              ],
              [
                -50.71652732739332,
                -31.034695158959536
              ],
              [
                -50.71871775411539,
                -31.037797037572254
              ],
              [
                -50.72271528288317,
                -31.044402890173412
              ],
              [
                -50.72912228104523,
                -31.05428294797688
              ],
              [
                -50.73580308254755,
                -31.06450765895954
              ],
              [
                -50.74248388404986,
                -31.07547911849711
              ],
              [
                -50.7481242328592,
                -31.08352102601156
              ],
              [
                -50.75102654826594,
                -31.087886632947978
              ],
              [
                -50.75710498241969,
                -31.096502962427746
              ],
              [
                -50.7636762625859,
                -31.10529161849711
              ],
              [
                -50.76718094534122,
                -31.11011676300578
              ],
              [
                -50.77320461882692,
                -31.117124710982658
              ],
              [
                -50.77928305298066,
                -31.12390289017341
              ],
              [
                -50.78508768379415,
                -31.12999176300578
              ],
              [
                -50.79182324596452,
                -31.136884826589597
              ],
              [
                -50.80447296028448,
                -31.150728395953756
              ],
              [
                -50.811318043790955,
                -31.15750657514451
              ],
              [
                -50.82018927201534,
                -31.16721430635838
              ],
              [
                -50.82681531284961,
                -31.174796676300577
              ],
              [
                -50.83360563568803,
                -31.182091835260117
              ],
              [
                -50.84209353923605,
                -31.190018858381503
              ],
              [
                -50.85299091217836,
                -31.201392413294798
              ],
              [
                -50.86542158382611,
                -31.21328294797688
              ],
              [
                -50.86991195860636,
                -31.217993208092487
              ],
              [
                -50.87911175083906,
                -31.227011632947978
              ],
              [
                -50.88891391042033,
                -31.235627962427746
              ],
              [
                -50.898277984657184,
                -31.244301734104045
              ],
              [
                -50.91952512386128,
                -31.26239602601156
              ],
              [
                -50.92401549864152,
                -31.266416979768785
              ],
              [
                -50.94088178440147,
                -31.27997333815029
              ],
              [
                -50.95068394398274,
                -31.288187572254337
              ],
              [
                -50.95440766941026,
                -31.29151921965318
              ],
              [
                -50.961307513584785,
                -31.29691878612717
              ],
              [
                -50.97039778448138,
                -31.304903251445086
              ],
              [
                -50.975983372622665,
                -31.309211416184972
              ],
              [
                -50.98118563608758,
                -31.313577023121386
              ],
              [
                -50.98688074556497,
                -31.31782774566474
              ],
              [
                -50.99159016301742,
                -31.321504046242776
              ],
              [
                -51.00681362873581,
                -31.333279696531793
              ],
              [
                -51.010811157503596,
                -31.336209248554912
              ],
              [
                -51.013987276250596,
                -31.339081358381502
              ],
              [
                -51.021325205769536,
                -31.344883020231215
              ],
              [
                -51.024994170529006,
                -31.348214667630057
              ],
              [
                -51.02789648593575,
                -31.350397471098265
              ],
              [
                -51.03342731340898,
                -31.355107731213874
              ],
              [
                -51.0401081149113,
                -31.35987543352601
              ],
              [
                -51.0418056956209,
                -31.362173121387283
              ],
              [
                -51.047610326434395,
                -31.36711315028902
              ],
              [
                -51.05149833386607,
                -31.370617124277455
              ],
              [
                -51.055714905306054,
                -31.374810404624277
              ],
              [
                -51.06349092016941,
                -31.381990679190753
              ],
              [
                -51.06529802221512,
                -31.3838862716763
              ],
              [
                -51.072800233738214,
                -31.39118143063584
              ],
              [
                -51.07740012985456,
                -31.395374710982658
              ],
              [
                -51.08599755473869,
                -31.403818713872834
              ],
              [
                -51.09820918371424,
                -31.41582413294798
              ],
              [
                -51.104013814527725,
                -31.42139602601156
              ],
              [
                -51.113815974108995,
                -31.43162073699422
              ],
              [
                -51.12252292032923,
                -31.440409393063582
              ],
              [
                -51.1338036179479,
                -31.45149573699422
              ],
              [
                -51.14338673485696,
                -31.461203468208094
              ],
              [
                -51.15269604842576,
                -31.47068143063584
              ],
              [
                -51.16671477944702,
                -31.484582442196533
              ],
              [
                -51.17772167372543,
                -31.495898554913296
              ],
              [
                -51.185990534601245,
                -31.5044
              ],
              [
                -51.19360226746044,
                -31.498081358381505
              ],
              [
                -51.21802552541154,
                -31.475506575144507
              ],
              [
                -51.23122284641202,
                -31.463501156069366
              ],
              [
                -51.23752032323797,
                -31.457412283236994
              ],
              [
                -51.23319423046188,
                -31.452587138728322
              ],
              [
                -51.22870385568164,
                -31.447072687861272
              ],
              [
                -51.22498013025412,
                -31.442304985549132
              ],
              [
                -51.215397013345054,
                -31.427599783236996
              ],
              [
                -51.21271374061052,
                -31.42421069364162
              ],
              [
                -51.211782809253634,
                -31.422774638728324
              ],
              [
                -51.209318579191304,
                -31.420821604046242
              ],
              [
                -51.20729243447339,
                -31.418121820809247
              ],
              [
                -51.206306742448454,
                -31.415709248554915
              ],
              [
                -51.20389727305418,
                -31.413583887283238
              ],
              [
                -51.201980649672365,
                -31.41019479768786
              ],
              [
                -51.20028306896276,
                -31.407782225433525
              ],
              [
                -51.198421206249,
                -31.403876156069366
              ],
              [
                -51.19480700215758,
                -31.398189378612717
              ],
              [
                -51.18949521735656,
                -31.386988150289017
              ],
              [
                -51.184785799904105,
                -31.3764762283237
              ],
              [
                -51.18440247522774,
                -31.374810404624277
              ],
              [
                -51.1813906384849,
                -31.368376878612718
              ],
              [
                -51.17909069042672,
                -31.36498778901734
              ],
              [
                -51.17810499840179,
                -31.36240289017341
              ],
              [
                -51.176790742368546,
                -31.357405419075146
              ],
              [
                -51.17602409301582,
                -31.35562471098266
              ],
              [
                -51.174216990970116,
                -31.34930606936416
              ],
              [
                -51.17142419689947,
                -31.34000043352601
              ],
              [
                -51.16989089819402,
                -31.335519942196534
              ],
              [
                -51.16682430078312,
                -31.324778251445085
              ],
              [
                -51.16419578871664,
                -31.310302817919077
              ],
              [
                -51.16222440466677,
                -31.303984176300578
              ],
              [
                -51.161402994646,
                -31.301916257225432
              ],
              [
                -51.16058158462522,
                -31.301686488439305
              ],
              [
                -51.15997921727665,
                -31.297091112716764
              ],
              [
                -51.15751498721432,
                -31.284683598265897
              ],
              [
                -51.15707690186991,
                -31.27911170520231
              ],
              [
                -51.15691261986575,
                -31.272390968208093
              ],
              [
                -51.15647453452134,
                -31.268082803468207
              ],
              [
                -51.15647453452134,
                -31.264176734104048
              ],
              [
                -51.15702214120186,
                -31.246599421965318
              ],
              [
                -51.15767926921848,
                -31.237810765895954
              ],
              [
                -51.15850067923925,
                -31.232698410404623
              ],
              [
                -51.15877448257951,
                -31.22839024566474
              ],
              [
                -51.16052682395717,
                -31.216097615606937
              ],
              [
                -51.161402994646,
                -31.209089667630057
              ],
              [
                -51.163319618027806,
                -31.19731401734104
              ],
              [
                -51.16720762545948,
                -31.18059833815029
              ],
              [
                -51.168795684832986,
                -31.17462434971098
              ],
              [
                -51.17591457167972,
                -31.15302608381503
              ],
              [
                -51.17750263105322,
                -31.14848815028902
              ],
              [
                -51.178597844414256,
                -31.14498417630058
              ],
              [
                -51.17958353643919,
                -31.13832088150289
              ],
              [
                -51.17969305777529,
                -31.135276445086706
              ],
              [
                -51.17898116909062,
                -31.134185043352602
              ],
              [
                -51.17947401510308,
                -31.132404335260116
              ],
              [
                -51.17848832307815,
                -31.13091083815029
              ],
              [
                -51.17898116909062,
                -31.12809617052023
              ],
              [
                -51.18078827113633,
                -31.12539638728324
              ],
              [
                -51.18007638245165,
                -31.103281141618496
              ],
              [
                -51.17881688708646,
                -31.09018432080925
              ],
              [
                -51.17690026370465,
                -31.079787283236993
              ],
              [
                -51.16780999280805,
                -31.062726950867052
              ],
              [
                -51.16551004474988,
                -31.061922760115607
              ],
              [
                -51.16419578871664,
                -31.06651813583815
              ],
              [
                -51.16441483138885,
                -31.069505130057802
              ],
              [
                -51.16589336942624,
                -31.066920231213874
              ],
              [
                -51.166386215438706,
                -31.068298843930634
              ],
              [
                -51.162717250679236,
                -31.07542167630058
              ],
              [
                -51.16030778128496,
                -31.078408670520233
              ],
              [
                -51.14908184433435,
                -31.087484537572255
              ],
              [
                -51.141305829470994,
                -31.091677817919074
              ],
              [
                -51.124713347051305,
                -31.0982262283237
              ],
              [
                -51.11080413736615,
                -31.100006936416186
              ],
              [
                -51.10357572918331,
                -31.099375072254336
              ],
              [
                -51.09119981820361,
                -31.09351596820809
              ],
              [
                -51.08479282004156,
                -31.08759942196532
              ],
              [
                -51.07181454171328,
                -31.078580997109828
              ],
              [
                -51.067926534281604,
                -31.075019580924856
              ],
              [
                -51.05171737653828,
                -31.064679985549134
              ],
              [
                -51.04848649712322,
                -31.061578106936416
              ],
              [
                -51.03758912418092,
                -31.058418786127167
              ],
              [
                -51.03129164735496,
                -31.05497225433526
              ],
              [
                -51.02718459725108,
                -31.053880852601157
              ],
              [
                -51.023679914495766,
                -31.051525722543353
              ],
              [
                -51.00029710923766,
                -31.047791979768785
              ],
              [
                -50.994985324436634,
                -31.048079190751444
              ],
              [
                -50.991918727025734,
                -31.046872904624276
              ],
              [
                -50.988414044270414,
                -31.043828468208094
              ],
              [
                -50.981021354083424,
                -31.039807514450867
              ],
              [
                -50.98058326873901,
                -31.0411286849711
              ],
              [
                -50.97811903867668,
                -31.038773554913295
              ],
              [
                -50.975381005274095,
                -31.03412073699422
              ],
              [
                -50.972423929199294,
                -31.032914450867054
              ],
              [
                -50.97209536519099,
                -31.030386994219654
              ],
              [
                -50.97028826314528,
                -31.029410476878613
              ],
              [
                -50.9695763744606,
                -31.024987427745664
              ],
              [
                -50.967495469074635,
                -31.02062182080925
              ],
              [
                -50.96448363233179,
                -31.016083887283237
              ],
              [
                -50.96021230022375,
                -31.01361387283237
              ],
              [
                -50.956981420808695,
                -31.009592919075146
              ],
              [
                -50.954626712082465,
                -31.003216835260115
              ],
              [
                -50.95429814807416,
                -31.000574494219652
              ],
              [
                -50.955721925443505,
                -30.999023554913293
              ],
              [
                -50.95610525011987,
                -30.997127962427747
              ],
              [
                -50.95599572878376,
                -30.99310700867052
              ],
              [
                -50.954626712082465,
                -30.989775361271676
              ],
              [
                -50.95249104602845,
                -30.982078106936417
              ],
              [
                -50.95249104602845,
                -30.967372904624277
              ],
              [
                -50.951395832667416,
                -30.959503323699423
              ],
              [
                -50.95221724268819,
                -30.954907947976878
              ],
              [
                -50.9556124041074,
                -30.94657882947977
              ],
              [
                -50.96119799224868,
                -30.924406141618498
              ],
              [
                -50.9665097770497,
                -30.908896748554913
              ],
              [
                -50.968097836423205,
                -30.897810404624277
              ],
              [
                -50.966783580389965,
                -30.896087138728323
              ],
              [
                -50.957693309493365,
                -30.899878323699422
              ],
              [
                -50.94148415175004,
                -30.904014161849712
              ],
              [
                -50.91957988452933,
                -30.906426734104045
              ],
              [
                -50.91131102365351,
                -30.905794869942195
              ],
              [
                -50.90457546148314,
                -30.904014161849712
              ],
              [
                -50.89510186591018,
                -30.899705997109827
              ],
              [
                -50.882287869586065,
                -30.891606647398845
              ],
              [
                -50.878126058814125,
                -30.886207080924855
              ],
              [
                -50.878126058814125,
                -30.885000794797687
              ],
              [
                -50.875497546747646,
                -30.883392413294796
              ],
              [
                -50.87232142800064,
                -30.87931401734104
              ],
              [
                -50.86230022574716,
                -30.87098489884393
              ],
              [
                -50.860274081029246,
                -30.868227673410406
              ],
              [
                -50.85687891961004,
                -30.865413005780347
              ],
              [
                -50.84631011067604,
                -30.858922037572253
              ],
              [
                -50.835796062410104,
                -30.855992485549134
              ],
              [
                -50.831524730302064,
                -30.85300549132948
              ],
              [
                -50.8280748082148,
                -30.852201300578034
              ],
              [
                -50.82561057815247,
                -30.853522471098266
              ],
              [
                -50.8234201514304,
                -30.852201300578034
              ],
              [
                -50.822379698737414,
                -30.84950151734104
              ],
              [
                -50.82281778408183,
                -30.845480563583816
              ],
              [
                -50.82090116070002,
                -30.841689378612717
              ],
              [
                -50.81942262266262,
                -30.840597976878612
              ],
              [
                -50.817998845293275,
                -30.841402167630058
              ],
              [
                -50.81652030725587,
                -30.84117239884393
              ],
              [
                -50.7958207747323,
                -30.832383742774567
              ],
              [
                -50.790508989931276,
                -30.829396748554913
              ],
              [
                -50.775176002876776,
                -30.827271387283236
              ],
              [
                -50.76520956129136,
                -30.823078106936418
              ],
              [
                -50.7620882032124,
                -30.82319299132948
              ],
              [
                -50.759404930477864,
                -30.821699494219654
              ],
              [
                -50.7590216058015,
                -30.8199762283237
              ],
              [
                -50.753819342336584,
                -30.818884826589596
              ],
              [
                -50.7497122922327,
                -30.81428945086705
              ],
              [
                -50.74451002876778,
                -30.812278973988438
              ],
              [
                -50.744674310771934,
                -30.810785476878614
              ],
              [
                -50.741005346012464,
                -30.80779848265896
              ],
              [
                -50.74078630334026,
                -30.805385910404624
              ],
              [
                -50.73700781724469,
                -30.801307514450865
              ],
              [
                -50.73558403987534,
                -30.79849284682081
              ],
              [
                -50.72079865950136,
                -30.779709248554912
              ],
              [
                -50.71751301941825,
                -30.7740799132948
              ],
              [
                -50.71800586543072,
                -30.77000151734104
              ],
              [
                -50.717020173405785,
                -30.766727312138727
              ],
              [
                -50.71592496004475,
                -30.765406141618495
              ],
              [
                -50.715103550023976,
                -30.76718684971098
              ],
              [
                -50.713898815326836,
                -30.76621033236994
              ],
              [
                -50.71159886726866,
                -30.758915173410404
              ],
              [
                -50.709682243886846,
                -30.758915173410404
              ],
              [
                -50.7020157503596,
                -30.74627789017341
              ],
              [
                -50.70031816964999,
                -30.73318106936416
              ],
              [
                -50.69889439228064,
                -30.734215028901733
              ],
              [
                -50.69829202493208,
                -30.732778973988438
              ],
              [
                -50.69878487094454,
                -30.73122803468208
              ],
              [
                -50.6975801362474,
                -30.72571358381503
              ],
              [
                -50.69571827353364,
                -30.723415895953757
              ],
              [
                -50.69369212881573,
                -30.713995375722543
              ],
              [
                -50.69007792472431,
                -30.706872543352603
              ],
              [
                -50.68991364272016,
                -30.700324132947976
              ],
              [
                -50.68640895996484,
                -30.683723338150287
              ],
              [
                -50.68328760188589,
                -30.66361856936416
              ],
              [
                -50.67950911579032,
                -30.609220809248555
              ],
              [
                -50.683999490570564,
                -30.542875072254336
              ],
              [
                -50.683999490570564,
                -30.52920382947977
              ],
              [
                -50.68640895996484,
                -30.500827384393062
              ],
              [
                -50.69637540155026,
                -30.4410875
              ],
              [
                -50.698018221591816,
                -30.43660700867052
              ],
              [
                -50.700482451654146,
                -30.42477391618497
              ],
              [
                -50.707875141841136,
                -30.409207080924855
              ],
              [
                -50.7129131233019,
                -30.400590751445087
              ],
              [
                -50.72479618826914,
                -30.383989956647397
              ],
              [
                -50.72912228104523,
                -30.374971531791907
              ],
              [
                -50.72950560572159,
                -30.368078468208093
              ],
              [
                -50.726274726306535,
                -30.36509147398844
              ],
              [
                -50.721893872862395,
                -30.364000072254335
              ],
              [
                -50.721893872862395,
                -30.360898193641617
              ],
              [
                -50.71992248881253,
                -30.35848562138728
              ],
              [
                -50.71860823277929,
                -30.353086054913295
              ],
              [
                -50.71751301941825,
                -30.35199465317919
              ],
              [
                -50.715705917372546,
                -30.35130534682081
              ],
              [
                -50.71488450735177,
                -30.35228186416185
              ],
              [
                -50.712694080629696,
                -30.35228186416185
              ],
              [
                -50.710777457247886,
                -30.354005130057804
              ],
              [
                -50.708477509189706,
                -30.35389024566474
              ],
              [
                -50.70557519378296,
                -30.34757160404624
              ],
              [
                -50.69911343495286,
                -30.346020664739882
              ],
              [
                -50.69829202493208,
                -30.34688229768786
              ],
              [
                -50.69889439228064,
                -30.35009906069364
              ],
              [
                -50.69369212881573,
                -30.35170744219653
              ],
              [
                -50.69018744606041,
                -30.35521141618497
              ],
              [
                -50.6866827633051,
                -30.356819797687862
              ],
              [
                -50.68252095253316,
                -30.36509147398844
              ],
              [
                -50.67961863712642,
                -30.368825216763007
              ],
              [
                -50.67649727904747,
                -30.37060592485549
              ],
              [
                -50.67167834025891,
                -30.374971531791907
              ],
              [
                -50.669323631532684,
                -30.375890606936416
              ],
              [
                -50.66642131612594,
                -30.379394580924856
              ],
              [
                -50.66160237733738,
                -30.382726228323698
              ],
              [
                -50.65848101925843,
                -30.384277167630056
              ],
              [
                -50.653388277129615,
                -30.389676734104047
              ],
              [
                -50.64867885967716,
                -30.391285115606937
              ],
              [
                -50.64878838101327,
                -30.393582803468206
              ],
              [
                -50.647912210324435,
                -30.395478395953756
              ],
              [
                -50.64572178360237,
                -30.396684682080924
              ],
              [
                -50.64342183554419,
                -30.39588049132948
              ],
              [
                -50.641176648154065,
                -30.392893497109824
              ],
              [
                -50.644790852245485,
                -30.38818323699422
              ],
              [
                -50.641176648154065,
                -30.386689739884392
              ],
              [
                -50.64079332347771,
                -30.388700216763006
              ],
              [
                -50.63460536798785,
                -30.393180708092483
              ],
              [
                -50.633017308614356,
                -30.39341047687861
              ],
              [
                -50.62962214719514,
                -30.391514884393064
              ],
              [
                -50.623981798385806,
                -30.392089306358383
              ],
              [
                -50.63531725667253,
                -30.387379046242774
              ],
              [
                -50.63471488932396,
                -30.386115317919074
              ],
              [
                -50.631319727904746,
                -30.38657485549133
              ],
              [
                -50.63022451454371,
                -30.38312832369942
              ],
              [
                -50.6314840099089,
                -30.381979479768784
              ],
              [
                -50.636193427361356,
                -30.381117846820807
              ],
              [
                -50.63789100807096,
                -30.37887760115607
              ],
              [
                -50.63208637725747,
                -30.374914089595375
              ],
              [
                -50.630607839220076,
                -30.36761893063584
              ],
              [
                -50.63099116389644,
                -30.361415173410403
              ],
              [
                -50.633783957967076,
                -30.356992124277458
              ],
              [
                -50.63542677800863,
                -30.348088583815027
              ],
              [
                -50.635591060012786,
                -30.341023193641618
              ],
              [
                -50.632579223269936,
                -30.332521748554914
              ],
              [
                -50.6298959505354,
                -30.330913367052023
              ],
              [
                -50.62858169450216,
                -30.328328468208092
              ],
              [
                -50.62737695980502,
                -30.327811488439306
              ],
              [
                -50.625077011746846,
                -30.328385910404624
              ],
              [
                -50.62589842176762,
                -30.32959219653179
              ],
              [
                -50.62650078911619,
                -30.335623627167628
              ],
              [
                -50.626391267780086,
                -30.343722976878613
              ],
              [
                -50.6206961583027,
                -30.356819797687862
              ],
              [
                -50.61861525291673,
                -30.36072586705202
              ],
              [
                -50.614782006153106,
                -30.364689378612717
              ],
              [
                -50.59671098569602,
                -30.390997904624278
              ],
              [
                -50.593425345612914,
                -30.394214667630056
              ],
              [
                -50.5930967816046,
                -30.400303540462428
              ],
              [
                -50.593480106280964,
                -30.401107731213873
              ],
              [
                -50.59671098569602,
                -30.401797037572255
              ],
              [
                -50.6005989931277,
                -30.400475867052023
              ],
              [
                -50.60350130853444,
                -30.40041842485549
              ],
              [
                -50.603884633210804,
                -30.399614234104046
              ],
              [
                -50.60607505993288,
                -30.40041842485549
              ],
              [
                -50.60591077792872,
                -30.401222615606937
              ],
              [
                -50.60859405066326,
                -30.40392239884393
              ],
              [
                -50.61182493007831,
                -30.40530101156069
              ],
              [
                -50.61609626218635,
                -30.40432449421965
              ],
              [
                -50.619600944941666,
                -30.406679624277455
              ],
              [
                -50.620915200974906,
                -30.40937940751445
              ],
              [
                -50.619710466277766,
                -30.41029848265896
              ],
              [
                -50.622010414335946,
                -30.41219407514451
              ],
              [
                -50.62562461842736,
                -30.41190686416185
              ],
              [
                -50.62907454051462,
                -30.407024277456646
              ],
              [
                -50.63329111195461,
                -30.4062200867052
              ],
              [
                -50.63958858878057,
                -30.40937940751445
              ],
              [
                -50.642381382851205,
                -30.40972406069364
              ],
              [
                -50.64572178360237,
                -30.412711054913295
              ],
              [
                -50.6482955350008,
                -30.412423843930636
              ],
              [
                -50.650212158382615,
                -30.413572687861272
              ],
              [
                -50.65371684113793,
                -30.41747875722543
              ],
              [
                -50.656400113872465,
                -30.42632485549133
              ],
              [
                -50.656400113872465,
                -30.430805346820808
              ],
              [
                -50.653990644478185,
                -30.435802817919075
              ],
              [
                -50.65311447378936,
                -30.4398237716763
              ],
              [
                -50.65322399512546,
                -30.442983092485548
              ],
              [
                -50.652074021096375,
                -30.444706358381502
              ],
              [
                -50.652183542432475,
                -30.44648706647399
              ],
              [
                -50.650978807735335,
                -30.448899638728324
              ],
              [
                -50.64922646635768,
                -30.44872731213873
              ],
              [
                -50.64747412498002,
                -30.45142709537572
              ],
              [
                -50.64922646635768,
                -30.45360989884393
              ],
              [
                -50.640409998801346,
                -30.463375072254333
              ],
              [
                -50.636905316046025,
                -30.465902528901733
              ],
              [
                -50.63482441066006,
                -30.466189739884392
              ],
              [
                -50.63082688189228,
                -30.470727673410405
              ],
              [
                -50.62551509709126,
                -30.47377210982659
              ],
              [
                -50.61450820281285,
                -30.481986343930636
              ],
              [
                -50.61341298945182,
                -30.48399682080925
              ],
              [
                -50.61111304139364,
                -30.4857200867052
              ],
              [
                -50.597094310372384,
                -30.490889884393063
              ],
              [
                -50.59512292632252,
                -30.49020057803468
              ],
              [
                -50.58269225467477,
                -30.490085693641618
              ],
              [
                -50.574423393798945,
                -30.48152680635838
              ],
              [
                -50.5745876758031,
                -30.47762073699422
              ],
              [
                -50.571302035719995,
                -30.471072326589596
              ],
              [
                -50.573875787118425,
                -30.466821604046242
              ],
              [
                -50.574478154466995,
                -30.464294147398842
              ],
              [
                -50.57228772774493,
                -30.46090505780347
              ],
              [
                -50.56867352365351,
                -30.45837760115607
              ],
              [
                -50.56861876298546,
                -30.456022471098265
              ],
              [
                -50.56730450695221,
                -30.45487362716763
              ],
              [
                -50.56752354962442,
                -30.450622904624275
              ],
              [
                -50.56560692624261,
                -30.447980563583815
              ],
              [
                -50.565825968914815,
                -30.443902167630057
              ],
              [
                -50.564511712881576,
                -30.43758352601156
              ],
              [
                -50.566975942943905,
                -30.429713945086704
              ],
              [
                -50.56467599488573,
                -30.422993208092485
              ],
              [
                -50.564621234217675,
                -30.4174213150289
              ],
              [
                -50.56292365350807,
                -30.40972406069364
              ],
              [
                -50.56560692624261,
                -30.404209609826587
              ],
              [
                -50.56467599488573,
                -30.40001632947977
              ],
              [
                -50.565278362234295,
                -30.397890968208092
              ],
              [
                -50.56752354962442,
                -30.395708164739883
              ],
              [
                -50.56560692624261,
                -30.38789602601156
              ],
              [
                -50.559090406744446,
                -30.379279696531793
              ],
              [
                -50.55859756073198,
                -30.375488511560693
              ],
              [
                -50.55372386127537,
                -30.37158244219653
              ],
              [
                -50.553011972590696,
                -30.369112427745662
              ],
              [
                -50.551095349208886,
                -30.36641264450867
              ],
              [
                -50.5514239132172,
                -30.365608453757226
              ],
              [
                -50.553504818603166,
                -30.36572333815029
              ],
              [
                -50.55339529726706,
                -30.3641149566474
              ],
              [
                -50.54961681117149,
                -30.36388518786127
              ],
              [
                -50.5452907183954,
                -30.356015606936417
              ],
              [
                -50.543702659021896,
                -30.342172037572254
              ],
              [
                -50.54660497442864,
                -30.338782947976878
              ],
              [
                -50.54627641042033,
                -30.331200578034682
              ],
              [
                -50.54950728983538,
                -30.326605202312138
              ],
              [
                -50.555421441984976,
                -30.32212471098266
              ],
              [
                -50.55580476666134,
                -30.320114234104047
              ],
              [
                -50.555421441984976,
                -30.3167825867052
              ],
              [
                -50.54299077033723,
                -30.299894580924853
              ],
              [
                -50.5422241209845,
                -30.290588945086704
              ],
              [
                -50.543812180358,
                -30.281972615606936
              ],
              [
                -50.54238840298866,
                -30.27858352601156
              ],
              [
                -50.53921228424165,
                -30.27668793352601
              ],
              [
                -50.5377885068723,
                -30.273873265895954
              ],
              [
                -50.53910276290554,
                -30.269105563583814
              ],
              [
                -50.53850039555698,
                -30.264625072254333
              ],
              [
                -50.54151223229982,
                -30.256583164739883
              ],
              [
                -50.54299077033723,
                -30.254974783236992
              ],
              [
                -50.54260744566086,
                -30.252275
              ],
              [
                -50.544414547706566,
                -30.253194075144506
              ],
              [
                -50.54589308574397,
                -30.251183598265897
              ],
              [
                -50.549781093175646,
                -30.251700578034683
              ],
              [
                -50.548685879814606,
                -30.249575216763006
              ],
              [
                -50.549288247163176,
                -30.249000794797688
              ],
              [
                -50.55208104123382,
                -30.249919869942197
              ],
              [
                -50.553504818603166,
                -30.251987789017342
              ],
              [
                -50.555311920648876,
                -30.252389884393065
              ],
              [
                -50.558980885408346,
                -30.25129848265896
              ],
              [
                -50.56051418411379,
                -30.251700578034683
              ],
              [
                -50.563909345533006,
                -30.249919869942197
              ],
              [
                -50.568290198977145,
                -30.24658822254335
              ],
              [
                -50.56867352365351,
                -30.24337145953757
              ],
              [
                -50.570809189707525,
                -30.24118865606936
              ],
              [
                -50.57212344574077,
                -30.243199132947975
              ],
              [
                -50.573109137765705,
                -30.24302680635838
              ],
              [
                -50.5729996164296,
                -30.24009725433526
              ],
              [
                -50.57551860715998,
                -30.23820166184971
              ],
              [
                -50.577380469873745,
                -30.235386994219652
              ],
              [
                -50.57759951254595,
                -30.23400838150289
              ],
              [
                -50.575573367828035,
                -30.233204190751444
              ],
              [
                -50.57770903388205,
                -30.23119371387283
              ],
              [
                -50.5790232899153,
                -30.231021387283235
              ],
              [
                -50.58132323797347,
                -30.228379046242775
              ],
              [
                -50.58198036599009,
                -30.226483453757226
              ],
              [
                -50.58077563129295,
                -30.224472976878612
              ],
              [
                -50.58329462202333,
                -30.224013439306358
              ],
              [
                -50.585485048745404,
                -30.222002962427744
              ],
              [
                -50.585977894757875,
                -30.218384104046244
              ],
              [
                -50.59052303020617,
                -30.212525
              ],
              [
                -50.590906354882534,
                -30.208676372832368
              ],
              [
                -50.59260393559214,
                -30.204425650289018
              ],
              [
                -50.59572529367109,
                -30.200577023121387
              ],
              [
                -50.59501340498642,
                -30.198911199421964
              ],
              [
                -50.596491943023814,
                -30.194890245664737
              ],
              [
                -50.60191324916094,
                -30.192190462427746
              ],
              [
                -50.601310881812374,
                -30.193798843930637
              ],
              [
                -50.598299045069524,
                -30.1950051300578
              ],
              [
                -50.59818952373342,
                -30.195981647398842
              ],
              [
                -50.60432271855522,
                -30.19557955202312
              ],
              [
                -50.60738931596612,
                -30.197704913294796
              ],
              [
                -50.61100352005754,
                -30.197704913294796
              ],
              [
                -50.61292014343935,
                -30.20000260115607
              ],
              [
                -50.6175200395557,
                -30.200174927745664
              ],
              [
                -50.620805679638806,
                -30.198394219653178
              ],
              [
                -50.62310562769698,
                -30.19971539017341
              ],
              [
                -50.62622698577593,
                -30.199026083815028
              ],
              [
                -50.62737695980502,
                -30.196785838150287
              ],
              [
                -50.63022451454371,
                -30.196728395953755
              ],
              [
                -50.631976855921366,
                -30.194890245664737
              ],
              [
                -50.64429800623302,
                -30.192190462427746
              ],
              [
                -50.64632415095094,
                -30.194603034682082
              ],
              [
                -50.6482955350008,
                -30.194086054913296
              ],
              [
                -50.651581175083905,
                -30.195120014450865
              ],
              [
                -50.658919104602845,
                -30.199887716763005
              ],
              [
                -50.66121905266102,
                -30.208791257225432
              ],
              [
                -50.660726206648555,
                -30.214995014450867
              ],
              [
                -50.66412136806777,
                -30.222002962427744
              ],
              [
                -50.66329995804699,
                -30.22378367052023
              ],
              [
                -50.66340947938309,
                -30.23050440751445
              ],
              [
                -50.6652165814288,
                -30.232916979768785
              ],
              [
                -50.66642131612594,
                -30.23659328034682
              ],
              [
                -50.668009375499445,
                -30.245381936416184
              ],
              [
                -50.66779033282723,
                -30.251183598265897
              ],
              [
                -50.66861174284801,
                -30.25187290462428
              ],
              [
                -50.66888554618827,
                -30.25491734104046
              ],
              [
                -50.66789985416334,
                -30.257215028901733
              ],
              [
                -50.665709427441264,
                -30.25870852601156
              ],
              [
                -50.66718796547866,
                -30.25939783236994
              ],
              [
                -50.6635190007192,
                -30.270426734104046
              ],
              [
                -50.65497633650312,
                -30.28151307803468
              ],
              [
                -50.65492157583507,
                -30.284097976878613
              ],
              [
                -50.6561263105322,
                -30.285993569364162
              ],
              [
                -50.65979527529167,
                -30.28748706647399
              ],
              [
                -50.66220474468595,
                -30.289727312138726
              ],
              [
                -50.6683927001758,
                -30.291508020231213
              ],
              [
                -50.67069264823398,
                -30.295011994219653
              ],
              [
                -50.67321163896436,
                -30.296620375722544
              ],
              [
                -50.685806592616274,
                -30.29840108381503
              ],
              [
                -50.69199454810612,
                -30.297022471098266
              ],
              [
                -50.7037133310692,
                -30.296907586705203
              ],
              [
                -50.70858703052581,
                -30.29932015895954
              ],
              [
                -50.71001080789516,
                -30.29909039017341
              ],
              [
                -50.71170838860476,
                -30.29811387283237
              ],
              [
                -50.72151054818603,
                -30.29932015895954
              ],
              [
                -50.73071034041873,
                -30.297884104046243
              ],
              [
                -50.73432454451015,
                -30.29587362716763
              ],
              [
                -50.73651497123222,
                -30.295701300578035
              ],
              [
                -50.747083780166214,
                -30.2958161849711
              ],
              [
                -50.750697984257634,
                -30.296677817919075
              ],
              [
                -50.75212176162698,
                -30.29489710982659
              ],
              [
                -50.755078837701774,
                -30.29397803468208
              ],
              [
                -50.75677641841138,
                -30.292484537572253
              ],
              [
                -50.76137631452773,
                -30.292312210982658
              ],
              [
                -50.764826236614994,
                -30.29139313583815
              ],
              [
                -50.77199988412978,
                -30.296620375722544
              ],
              [
                -50.77369746483938,
                -30.2932887283237
              ],
              [
                -50.77309509749081,
                -30.288693352601154
              ],
              [
                -50.77408078951574,
                -30.28829125722543
              ],
              [
                -50.776325976905866,
                -30.289325216763004
              ],
              [
                -50.778187839619626,
                -30.288808236994218
              ],
              [
                -50.78202108638325,
                -30.284787283236994
              ],
              [
                -50.78470435911779,
                -30.28501705202312
              ],
              [
                -50.78590909381493,
                -30.285706358381503
              ],
              [
                -50.78760667452453,
                -30.28857846820809
              ],
              [
                -50.79488984337542,
                -30.31230209537572
              ],
              [
                -50.79488984337542,
                -30.316897471098265
              ],
              [
                -50.79280893798945,
                -30.32637543352601
              ],
              [
                -50.791713724628416,
                -30.330109176300578
              ],
              [
                -50.78892093055777,
                -30.33338338150289
              ],
              [
                -50.785525769138566,
                -30.330683598265896
              ],
              [
                -50.78169252237494,
                -30.329075216763005
              ],
              [
                -50.78788047786479,
                -30.326777528901733
              ],
              [
                -50.786073375819086,
                -30.324881936416183
              ],
              [
                -50.783773427760906,
                -30.32447984104046
              ],
              [
                -50.77670930158223,
                -30.327179624277456
              ],
              [
                -50.774518874860156,
                -30.329304985549133
              ],
              [
                -50.77347842216717,
                -30.332177095375723
              ],
              [
                -50.77588789156145,
                -30.33401524566474
              ],
              [
                -50.78689478583986,
                -30.33660014450867
              ],
              [
                -50.79280893798945,
                -30.336715028901732
              ],
              [
                -50.79702550942944,
                -30.338380852601155
              ],
              [
                -50.80507532763305,
                -30.336485260115605
              ],
              [
                -50.81460368387406,
                -30.332808959537573
              ],
              [
                -50.81608222191146,
                -30.331200578034682
              ],
              [
                -50.81942262266262,
                -30.32987940751445
              ],
              [
                -50.83141520896596,
                -30.3267200867052
              ],
              [
                -50.83240090099089,
                -30.325513800578033
              ],
              [
                -50.838315053140484,
                -30.32482449421965
              ],
              [
                -50.840779283202814,
                -30.32218215317919
              ],
              [
                -50.84401016261787,
                -30.32080354046243
              ],
              [
                -50.85222426282564,
                -30.321320520231215
              ],
              [
                -50.85457897155186,
                -30.32258424855491
              ],
              [
                -50.86531206249001,
                -30.321607731213874
              ],
              [
                -50.868816745245326,
                -30.32258424855491
              ],
              [
                -50.87839986215439,
                -30.322699132947974
              ],
              [
                -50.88491638165255,
                -30.323675650289015
              ],
              [
                -50.892692396515905,
                -30.321722615606937
              ],
              [
                -50.90118030006393,
                -30.32212471098266
              ],
              [
                -50.908189665574554,
                -30.32350332369942
              ],
              [
                -50.914815706408824,
                -30.32637543352601
              ],
              [
                -50.92209887525971,
                -30.332177095375723
              ],
              [
                -50.927027335384366,
                -30.33820852601156
              ],
              [
                -50.93458430757551,
                -30.355613511560694
              ],
              [
                -50.938581836343296,
                -30.37508641618497
              ],
              [
                -50.939184203691866,
                -30.394099783236992
              ],
              [
                -50.93759614431836,
                -30.406909393063582
              ],
              [
                -50.93507715358798,
                -30.412711054913295
              ],
              [
                -50.931901034840976,
                -30.425578106936417
              ],
              [
                -50.92719161738852,
                -30.433792341040462
              ],
              [
                -50.92511071200256,
                -30.434424205202312
              ],
              [
                -50.92292028528048,
                -30.436204913294798
              ],
              [
                -50.92100366189867,
                -30.435113511560694
              ],
              [
                -50.91821086782803,
                -30.437296315028902
              ],
              [
                -50.916020441105964,
                -30.437123988439307
              ],
              [
                -50.913118125699214,
                -30.438100505780348
              ],
              [
                -50.91010628895637,
                -30.43821539017341
              ],
              [
                -50.908189665574554,
                -30.43959400289017
              ],
              [
                -50.90112553939588,
                -30.44177680635838
              ],
              [
                -50.902604077433274,
                -30.443787283236993
              ],
              [
                -50.90857299025092,
                -30.442810765895953
              ],
              [
                -50.913008604363114,
                -30.440685404624276
              ],
              [
                -50.91350145037558,
                -30.441374710982657
              ],
              [
                -50.91651328711843,
                -30.440685404624276
              ],
              [
                -50.929984411459166,
                -30.435802817919075
              ],
              [
                -50.94608404786639,
                -30.426382297687862
              ],
              [
                -50.97340962122423,
                -30.407598699421964
              ],
              [
                -50.99838048585584,
                -30.395076300578033
              ],
              [
                -51.01300158422567,
                -30.389676734104047
              ],
              [
                -51.026691751238616,
                -30.386689739884392
              ],
              [
                -51.03868433754195,
                -30.386115317919074
              ],
              [
                -51.042079498961165,
                -30.38979161849711
              ],
              [
                -51.04591274572479,
                -30.388987427745665
              ],
              [
                -51.048322215119065,
                -30.391514884393064
              ],
              [
                -51.050074556496725,
                -30.391285115606937
              ],
              [
                -51.053086393239575,
                -30.39237651734104
              ],
              [
                -51.055605383969954,
                -30.39197442196532
              ],
              [
                -51.05960291273773,
                -30.385598338150288
              ],
              [
                -51.05352447858399,
                -30.38531112716763
              ],
              [
                -51.052484025891005,
                -30.384621820809247
              ],
              [
                -51.05231974388685,
                -30.38157738439306
              ],
              [
                -51.049417428480105,
                -30.38220924855491
              ],
              [
                -51.04739128376219,
                -30.38151994219653
              ],
              [
                -51.04531037837622,
                -30.379107369942197
              ],
              [
                -51.045200857040115,
                -30.377384104046243
              ],
              [
                -51.047719847770495,
                -30.37479920520231
              ],
              [
                -51.047610326434395,
                -30.373075939306357
              ],
              [
                -51.04251758430558,
                -30.372386632947975
              ],
              [
                -51.041477131612595,
                -30.37129523121387
              ],
              [
                -51.04131284960844,
                -30.36641264450867
              ],
              [
                -51.045091335704015,
                -30.36417239884393
              ],
              [
                -51.04602226706089,
                -30.362793786127167
              ],
              [
                -51.04607702772894,
                -30.359577023121386
              ],
              [
                -51.049581710484254,
                -30.357681430635836
              ],
              [
                -51.050622163177245,
                -30.358198410404622
              ],
              [
                -51.06529802221512,
                -30.356590028901735
              ],
              [
                -51.067981294949654,
                -30.358313294797686
              ],
              [
                -51.068583662298224,
                -30.357509104046244
              ],
              [
                -51.06809081628576,
                -30.353488150289017
              ],
              [
                -51.0510054878536,
                -30.34917998554913
              ],
              [
                -51.04969123182036,
                -30.347284393063582
              ],
              [
                -51.04980075315646,
                -30.34458460982659
              ],
              [
                -51.04618654906505,
                -30.343378323699422
              ],
              [
                -51.04481753236375,
                -30.341884826589595
              ],
              [
                -51.041477131612595,
                -30.343205997109827
              ],
              [
                -51.03977955090299,
                -30.342918786127168
              ],
              [
                -51.03742484217676,
                -30.34010411849711
              ],
              [
                -51.03638438948378,
                -30.336427817919073
              ],
              [
                -51.034193962761705,
                -30.33700223988439
              ],
              [
                -51.031620211363276,
                -30.333900361271677
              ],
              [
                -51.02970358798146,
                -30.327179624277456
              ],
              [
                -51.040217636247405,
                -30.325226589595374
              ],
              [
                -51.03928670489052,
                -30.323675650289015
              ],
              [
                -51.02767744326354,
                -30.323618208092483
              ],
              [
                -51.02581558054978,
                -30.321320520231215
              ],
              [
                -51.02630842656225,
                -30.319482369942197
              ],
              [
                -51.02389895716797,
                -30.31638049132948
              ],
              [
                -51.01979190706409,
                -30.29650549132948
              ],
              [
                -51.02209185512226,
                -30.28777427745665
              ],
              [
                -51.0232965898194,
                -30.28628078034682
              ],
              [
                -51.022475179798626,
                -30.284212861271676
              ],
              [
                -51.024391803180436,
                -30.284097976878613
              ],
              [
                -51.02461084585264,
                -30.282604479768786
              ],
              [
                -51.02751316125939,
                -30.278181430635836
              ],
              [
                -51.02888217796068,
                -30.27737723988439
              ],
              [
                -51.0307988013425,
                -30.274505130057804
              ],
              [
                -51.034796330110275,
                -30.271575578034682
              ],
              [
                -51.03682247482819,
                -30.27151813583815
              ],
              [
                -51.042681866309735,
                -30.26870346820809
              ],
              [
                -51.04837697578712,
                -30.267899277456646
              ],
              [
                -51.05670059733099,
                -30.271116040462427
              ],
              [
                -51.05779581069203,
                -30.27370093930636
              ],
              [
                -51.057522007351764,
                -30.27502210982659
              ],
              [
                -51.059219588061374,
                -30.27668793352601
              ],
              [
                -51.06469565486655,
                -30.27622839595376
              ],
              [
                -51.0692955509829,
                -30.271288367052023
              ],
              [
                -51.06951459365511,
                -30.269220447976878
              ],
              [
                -51.067926534281604,
                -30.266922760115605
              ],
              [
                -51.065407543551224,
                -30.266578106936414
              ],
              [
                -51.06332663816526,
                -30.26382088150289
              ],
              [
                -51.06381948417772,
                -30.261178540462428
              ],
              [
                -51.06288855282084,
                -30.25962760115607
              ],
              [
                -51.06338139883331,
                -30.255778973988438
              ],
              [
                -51.065407543551224,
                -30.253021748554914
              ],
              [
                -51.06639323557616,
                -30.25221755780347
              ],
              [
                -51.069186029646794,
                -30.249000794797688
              ],
              [
                -51.069788396995364,
                -30.247105202312138
              ],
              [
                -51.07608587382132,
                -30.24429053468208
              ],
              [
                -51.07652395916573,
                -30.24337145953757
              ],
              [
                -51.07920723190027,
                -30.242624710982657
              ],
              [
                -51.08052148793352,
                -30.242797037572252
              ],
              [
                -51.08331428200415,
                -30.241877962427743
              ],
              [
                -51.0893927161579,
                -30.24101632947977
              ],
              [
                -51.09262359557296,
                -30.240901445086706
              ],
              [
                -51.095909235656066,
                -30.24118865606936
              ],
              [
                -51.09881155106281,
                -30.24239494219653
              ],
              [
                -51.10127578112514,
                -30.244118208092484
              ],
              [
                -51.10280907983059,
                -30.246128684971097
              ],
              [
                -51.104616181876295,
                -30.24561170520231
              ],
              [
                -51.105218549224865,
                -30.243199132947975
              ],
              [
                -51.1060947199137,
                -30.242911921965316
              ],
              [
                -51.107080411938625,
                -30.244807514450866
              ],
              [
                -51.1062042412498,
                -30.248196604046242
              ],
              [
                -51.10478046388045,
                -30.24940289017341
              ],
              [
                -51.101494823797346,
                -30.249919869942197
              ],
              [
                -51.10248051582228,
                -30.252102673410405
              ],
              [
                -51.100892456448776,
                -30.25612362716763
              ],
              [
                -51.099085354403066,
                -30.256985260115606
              ],
              [
                -51.101385302461246,
                -30.259282947976878
              ],
              [
                -51.10478046388045,
                -30.260087138728323
              ],
              [
                -51.1060947199137,
                -30.259225505780346
              ],
              [
                -51.10598519857759,
                -30.257502239884392
              ],
              [
                -51.10499950655266,
                -30.256927817919074
              ],
              [
                -51.10439713920409,
                -30.255089667630056
              ],
              [
                -51.104506660540196,
                -30.252677095375724
              ],
              [
                -51.107080411938625,
                -30.249804985549133
              ],
              [
                -51.10899703532044,
                -30.249288005780347
              ],
              [
                -51.11469214479783,
                -30.246128684971097
              ],
              [
                -51.118580152229505,
                -30.24589891618497
              ],
              [
                -51.12328956968196,
                -30.24687543352601
              ],
              [
                -51.123618133690265,
                -30.248024277456647
              ],
              [
                -51.1261918850887,
                -30.247277528901733
              ],
              [
                -51.12821802980662,
                -30.24779450867052
              ],
              [
                -51.13259888325076,
                -30.25158569364162
              ],
              [
                -51.135282155985294,
                -30.25652572254335
              ],
              [
                -51.135775001997764,
                -30.258306430635837
              ],
              [
                -51.13681545469075,
                -30.259512716763005
              ],
              [
                -51.13692497602685,
                -30.261982731213873
              ],
              [
                -51.13752734337542,
                -30.264222976878614
              ],
              [
                -51.13670593335464,
                -30.266980202312137
              ],
              [
                -51.13500835264504,
                -30.267612066473987
              ],
              [
                -51.135884523333864,
                -30.269220447976878
              ],
              [
                -51.14048441945022,
                -30.26807160404624
              ],
              [
                -51.141908196819564,
                -30.2670950867052
              ],
              [
                -51.14218200015982,
                -30.266003684971096
              ],
              [
                -51.143715298865274,
                -30.265314378612715
              ],
              [
                -51.145686682915134,
                -30.265027167630056
              ],
              [
                -51.15488647514783,
                -30.26249971098266
              ],
              [
                -51.15932208926003,
                -30.261982731213873
              ],
              [
                -51.15740546587821,
                -30.261006213872832
              ],
              [
                -51.1554888424964,
                -30.25681293352601
              ],
              [
                -51.15450315047147,
                -30.251126156069365
              ],
              [
                -51.15510551782004,
                -30.248598699421965
              ],
              [
                -51.15247700575355,
                -30.248311488439306
              ],
              [
                -51.15187463840498,
                -30.24561170520231
              ],
              [
                -51.15340793711044,
                -30.241992846820807
              ],
              [
                -51.15620073118108,
                -30.239924927745665
              ],
              [
                -51.16321009669171,
                -30.237971893063584
              ],
              [
                -51.16709810412338,
                -30.237397471098266
              ],
              [
                -51.16928853084545,
                -30.237914450867052
              ],
              [
                -51.17027422287038,
                -30.23912073699422
              ],
              [
                -51.17158847890363,
                -30.23848887283237
              ],
              [
                -51.174983640322836,
                -30.23820166184971
              ],
              [
                -51.17772167372543,
                -30.236995375722543
              ],
              [
                -51.17898116909062,
                -30.23561676300578
              ],
              [
                -51.18401915055138,
                -30.235214667630057
              ],
              [
                -51.188400003995525,
                -30.235789089595375
              ],
              [
                -51.1906999520537,
                -30.238603757225434
              ],
              [
                -51.192178490091095,
                -30.239005852601156
              ],
              [
                -51.193383224788235,
                -30.23779956647399
              ],
              [
                -51.192178490091095,
                -30.235386994219652
              ],
              [
                -51.190809473389805,
                -30.233319075144507
              ],
              [
                -51.18987854203292,
                -30.23372117052023
              ],
              [
                -51.18697622662618,
                -30.23280209537572
              ],
              [
                -51.18401915055138,
                -30.233204190751444
              ],
              [
                -51.18259537318204,
                -30.231883020231212
              ],
              [
                -51.17909069042672,
                -30.22539205202312
              ],
              [
                -51.178597844414256,
                -30.221026445086704
              ],
              [
                -51.177885955729586,
                -30.219820158959536
              ],
              [
                -51.17848832307815,
                -30.21700549132948
              ],
              [
                -51.18007638245165,
                -30.21539710982659
              ],
              [
                -51.18018590378776,
                -30.21447803468208
              ],
              [
                -51.18259537318204,
                -30.212927095375722
              ],
              [
                -51.18801667931916,
                -30.211203829479768
              ],
              [
                -51.19009758470513,
                -30.212697326589595
              ],
              [
                -51.19431415614512,
                -30.213616401734104
              ],
              [
                -51.19721647155186,
                -30.21281221098266
              ],
              [
                -51.200009265622505,
                -30.2099975433526
              ],
              [
                -51.19721647155186,
                -30.207872182080923
              ],
              [
                -51.195683172846415,
                -30.207699855491327
              ],
              [
                -51.19469748082148,
                -30.20321936416185
              ],
              [
                -51.19431415614512,
                -30.19977283236994
              ],
              [
                -51.19491652349369,
                -30.198279335260114
              ],
              [
                -51.19798312090459,
                -30.194717919075146
              ],
              [
                -51.19968070161419,
                -30.193109537572255
              ],
              [
                -51.20181636766821,
                -30.192075578034682
              ],
              [
                -51.20669006712482,
                -30.19040975433526
              ],
              [
                -51.20718291313729,
                -30.19069696531792
              ],
              [
                -51.21452084265623,
                -30.190179985549133
              ],
              [
                -51.21742315806297,
                -30.189203468208092
              ],
              [
                -51.220325473469714,
                -30.188686488439306
              ],
              [
                -51.22300874620425,
                -30.18788229768786
              ],
              [
                -51.229087180358,
                -30.18822695086705
              ],
              [
                -51.23138712841617,
                -30.188973699421965
              ],
              [
                -51.23489181117149,
                -30.189203468208092
              ],
              [
                -51.23910838261148,
                -30.190294869942196
              ],
              [
                -51.24190117668211,
                -30.189720447976878
              ],
              [
                -51.24797961083586,
                -30.186676011560692
              ],
              [
                -51.248910542192746,
                -30.18569949421965
              ],
              [
                -51.24392732140003,
                -30.18208063583815
              ],
              [
                -51.24190117668211,
                -30.181621098265897
              ],
              [
                -51.23752032323797,
                -30.18328692196532
              ],
              [
                -51.23270138444941,
                -30.1827125
              ],
              [
                -51.22859433434553,
                -30.177772471098265
              ],
              [
                -51.22777292432475,
                -30.177083164739884
              ],
              [
                -51.227006274972034,
                -30.17438338150289
              ],
              [
                -51.22618486495126,
                -30.169788005780347
              ],
              [
                -51.22662295029567,
                -30.168179624277457
              ],
              [
                -51.23051095772735,
                -30.16668612716763
              ],
              [
                -51.23330375179798,
                -30.16450332369942
              ],
              [
                -51.23281090578552,
                -30.162377962427744
              ],
              [
                -51.23122284641202,
                -30.163009826589594
              ],
              [
                -51.22848481300943,
                -30.161516329479767
              ],
              [
                -51.2274991209845,
                -30.15829956647399
              ],
              [
                -51.226513428959564,
                -30.156576300578035
              ],
              [
                -51.22508965159022,
                -30.152497904624276
              ],
              [
                -51.225911061610994,
                -30.15002789017341
              ],
              [
                -51.22547297626658,
                -30.146409031791908
              ],
              [
                -51.2260205829471,
                -30.1442262283237
              ],
              [
                -51.22821100966917,
                -30.14049248554913
              ],
              [
                -51.23089428240371,
                -30.13762037572254
              ],
              [
                -51.23439896515902,
                -30.13497803468208
              ],
              [
                -51.23779412657823,
                -30.133197326589595
              ],
              [
                -51.24140833066965,
                -30.131991040462427
              ],
              [
                -51.24381780006393,
                -30.132220809248555
              ],
              [
                -51.24518681676522,
                -30.131014523121387
              ],
              [
                -51.24578918411379,
                -30.129406141618496
              ],
              [
                -51.24480349208886,
                -30.128199855491328
              ],
              [
                -51.24628203012626,
                -30.125500072254333
              ],
              [
                -51.25071764423845,
                -30.124178901734105
              ],
              [
                -51.25652227505194,
                -30.123604479768787
              ],
              [
                -51.25920554778648,
                -30.123489595375723
              ],
              [
                -51.26101264983219,
                -30.122915173410405
              ],
              [
                -51.26221738452933,
                -30.119985621387283
              ],
              [
                -51.26019123981141,
                -30.116883742774565
              ],
              [
                -51.259479351126735,
                -30.113724421965316
              ],
              [
                -51.25860318043791,
                -30.111426734104047
              ],
              [
                -51.260574564487776,
                -30.111024638728324
              ],
              [
                -51.26079360715998,
                -30.112288367052024
              ],
              [
                -51.26347687989452,
                -30.111599060693642
              ],
              [
                -51.264900657263865,
                -30.109416257225433
              ],
              [
                -51.26232690586543,
                -30.108784393063583
              ],
              [
                -51.261779299184916,
                -30.10958858381503
              ],
              [
                -51.258712701774016,
                -30.110507658959538
              ],
              [
                -51.258712701774016,
                -30.10901416184971
              ],
              [
                -51.26079360715998,
                -30.106314378612716
              ],
              [
                -51.2628197518779,
                -30.10522297687861
              ],
              [
                -51.26648871663737,
                -30.10482088150289
              ],
              [
                -51.266707759309575,
                -30.10292528901734
              ],
              [
                -51.26539350327633,
                -30.099823410404625
              ],
              [
                -51.264407811251395,
                -30.098617124277457
              ],
              [
                -51.261286453172445,
                -30.096893858381502
              ],
              [
                -51.2567960783922,
                -30.09712362716763
              ],
              [
                -51.256412753715836,
                -30.095802456647398
              ],
              [
                -51.25290807096052,
                -30.096606647398843
              ],
              [
                -51.25132001158702,
                -30.094711054913294
              ],
              [
                -51.25230570361195,
                -30.094079190751444
              ],
              [
                -51.25038908023014,
                -30.092298482658958
              ],
              [
                -51.25038908023014,
                -30.09080498554913
              ],
              [
                -51.24940338820521,
                -30.089196604046244
              ],
              [
                -51.248417696180276,
                -30.081614234104045
              ],
              [
                -51.24940338820521,
                -30.080982369942195
              ],
              [
                -51.249074824196896,
                -30.079316546242772
              ],
              [
                -51.24518681676522,
                -30.0771911849711
              ],
              [
                -51.241627373341856,
                -30.072021387283236
              ],
              [
                -51.24058692064887,
                -30.06891950867052
              ],
              [
                -51.24069644198498,
                -30.06690903179191
              ],
              [
                -51.2398750319642,
                -30.063290173410405
              ],
              [
                -51.23719175922966,
                -30.060820158959537
              ],
              [
                -51.23631558854083,
                -30.06030317919075
              ],
              [
                -51.23450848649512,
                -30.0584075867052
              ],
              [
                -51.23417992248682,
                -30.055305708092483
              ],
              [
                -51.23368707647435,
                -30.054271748554914
              ],
              [
                -51.23401564048266,
                -30.051686849710983
              ],
              [
                -51.23379659781045,
                -30.047608453757224
              ],
              [
                -51.2352203751798,
                -30.04651705202312
              ],
              [
                -51.23658939188109,
                -30.04617239884393
              ],
              [
                -51.23538465718396,
                -30.044506575144506
              ],
              [
                -51.2369179558894,
                -30.043185404624275
              ],
              [
                -51.24020359597251,
                -30.042725867052024
              ],
              [
                -51.241682134009906,
                -30.041577023121388
              ],
              [
                -51.24212021935432,
                -30.03589024566474
              ],
              [
                -51.24272258670289,
                -30.035086054913293
              ],
              [
                -51.250224798225986,
                -30.03531582369942
              ],
              [
                -51.25121049025092,
                -30.036177456647398
              ],
              [
                -51.253291395636886,
                -30.04197911849711
              ],
              [
                -51.25487945501039,
                -30.043415173410402
              ],
              [
                -51.255098497682596,
                -30.04559797687861
              ],
              [
                -51.25717940306856,
                -30.04841264450867
              ],
              [
                -51.258219855761546,
                -30.048527528901733
              ],
              [
                -51.262491187869585,
                -30.053582442196532
              ],
              [
                -51.266214913297105,
                -30.05519082369942
              ],
              [
                -51.26692680198178,
                -30.057316184971096
              ],
              [
                -51.26851486135528,
                -30.057488511560692
              ],
              [
                -51.2720195441106,
                -30.059211777456646
              ],
              [
                -51.27207430477865,
                -30.05771828034682
              ],
              [
                -51.271088612753715,
                -30.0547887283237
              ],
              [
                -51.2658863492888,
                -30.053410115606937
              ],
              [
                -51.26479113592776,
                -30.052491040462428
              ],
              [
                -51.26402448657504,
                -30.050710332369942
              ],
              [
                -51.26221738452933,
                -30.049504046242774
              ],
              [
                -51.26172453851686,
                -30.047723338150288
              ],
              [
                -51.26210786319322,
                -30.04559797687861
              ],
              [
                -51.2628197518779,
                -30.04462145953757
              ],
              [
                -51.26298403388205,
                -30.0423237716763
              ],
              [
                -51.26271023054179,
                -30.040313294797688
              ],
              [
                -51.26041028248362,
                -30.03749862716763
              ],
              [
                -51.259424590458686,
                -30.03502861271676
              ],
              [
                -51.26051980381972,
                -30.03370744219653
              ],
              [
                -51.264298289915295,
                -30.035717919075143
              ],
              [
                -51.26648871663737,
                -30.03589024566474
              ],
              [
                -51.268076776010865,
                -30.035200939306357
              ],
              [
                -51.26999339939268,
                -30.035488150289016
              ],
              [
                -51.27059576674125,
                -30.038073049132947
              ],
              [
                -51.27191002277449,
                -30.038992124277456
              ],
              [
                -51.27278619346332,
                -30.040600505780347
              ],
              [
                -51.279576516301745,
                -30.03778583815029
              ],
              [
                -51.275907551542275,
                -30.034224421965316
              ],
              [
                -51.27388140682436,
                -30.033477673410403
              ],
              [
                -51.2720195441106,
                -30.030203468208093
              ],
              [
                -51.26900770736775,
                -30.028422760115607
              ],
              [
                -51.26950055338021,
                -30.023999710982658
              ],
              [
                -51.2676934513345,
                -30.02181690751445
              ],
              [
                -51.26818629734697,
                -30.016474783236994
              ],
              [
                -51.27568850887007,
                -30.013717557803467
              ],
              [
                -51.27760513225188,
                -30.01090289017341
              ],
              [
                -51.27870034561291,
                -30.014579190751444
              ],
              [
                -51.27809797826434,
                -30.017393858381503
              ],
              [
                -51.28110981500719,
                -30.022104118497108
              ],
              [
                -51.28258835304459,
                -30.02187434971098
              ],
              [
                -51.2860930357999,
                -30.014923843930635
              ],
              [
                -51.28937867588301,
                -30.01187940751445
              ],
              [
                -51.29030960723989,
                -30.002171676300577
              ],
              [
                -51.29239051262586,
                -30.000276083815027
              ],
              [
                -51.29578567404507,
                -30.000505852601155
              ],
              [
                -51.29578567404507,
                -30.002114234104045
              ],
              [
                -51.299399878136484,
                -30.0025737716763
              ],
              [
                -51.30038557016142,
                -30.004297037572254
              ],
              [
                -51.302302193543234,
                -30.009926372832368
              ],
              [
                -51.30148078352246,
                -30.012281502890172
              ],
              [
                -51.30328788556816,
                -30.021472254335258
              ],
              [
                -51.3027950395557,
                -30.024172037572253
              ],
              [
                -51.304218816925044,
                -30.027503684971098
              ],
              [
                -51.30208315087103,
                -30.035775361271675
              ],
              [
                -51.299290356800384,
                -30.036120014450866
              ],
              [
                -51.297483254754674,
                -30.03589024566474
              ],
              [
                -51.29638804139364,
                -30.04128981213873
              ],
              [
                -51.2951833066965,
                -30.043415173410402
              ],
              [
                -51.29271907663417,
                -30.04559797687861
              ],
              [
                -51.29239051262586,
                -30.047608453757224
              ],
              [
                -51.29578567404507,
                -30.045425650289015
              ],
              [
                -51.29731897275052,
                -30.042208887283238
              ],
              [
                -51.300002245485054,
                -30.041577023121388
              ],
              [
                -51.301699826194664,
                -30.042725867052024
              ],
              [
                -51.30219267220713,
                -30.044678901734102
              ],
              [
                -51.3013165015183,
                -30.04657449421965
              ],
              [
                -51.30208315087103,
                -30.04812543352601
              ],
              [
                -51.301097458846094,
                -30.049791257225433
              ],
              [
                -51.299399878136484,
                -30.05030823699422
              ],
              [
                -51.29918083546428,
                -30.051227312138728
              ],
              [
                -51.3014260228544,
                -30.052376156069364
              ],
              [
                -51.30011176682116,
                -30.053410115606937
              ],
              [
                -51.301206980182194,
                -30.054214306358382
              ],
              [
                -51.30257599688349,
                -30.054271748554914
              ],
              [
                -51.30410929558894,
                -30.053410115606937
              ],
              [
                -51.30520450894998,
                -30.053984537572255
              ],
              [
                -51.30498546627777,
                -30.056971531791906
              ],
              [
                -51.30558783362634,
                -30.058005491329478
              ],
              [
                -51.30531403028608,
                -30.05961387283237
              ],
              [
                -51.306025918970754,
                -30.062083887283237
              ],
              [
                -51.309092516381654,
                -30.061796676300578
              ],
              [
                -51.309694883730224,
                -30.063405057803468
              ],
              [
                -51.308490149033084,
                -30.065185765895954
              ],
              [
                -51.30958536239412,
                -30.068172760115605
              ],
              [
                -51.31018772974269,
                -30.071676734104045
              ],
              [
                -51.31161150711203,
                -30.072021387283236
              ],
              [
                -51.31248767780086,
                -30.073285115606936
              ],
              [
                -51.3121043531245,
                -30.07472117052023
              ],
              [
                -51.310899618427364,
                -30.076386994219654
              ],
              [
                -51.31139246443983,
                -30.080695158959536
              ],
              [
                -51.31380193383411,
                -30.080293063583813
              ],
              [
                -51.31440430118268,
                -30.082590751445085
              ],
              [
                -51.31330908782164,
                -30.084716112716762
              ],
              [
                -51.31117342176762,
                -30.085405419075144
              ],
              [
                -51.30898299504555,
                -30.085520303468208
              ],
              [
                -51.30942108038996,
                -30.0871286849711
              ],
              [
                -51.3106258150871,
                -30.088392413294798
              ],
              [
                -51.30761397834426,
                -30.090575216763003
              ],
              [
                -51.30651876498322,
                -30.094423843930635
              ],
              [
                -51.30701161099569,
                -30.097295953757225
              ],
              [
                -51.31007820840659,
                -30.100512716763006
              ],
              [
                -51.310516293751,
                -30.102408309248553
              ],
              [
                -51.31161150711203,
                -30.10487832369942
              ],
              [
                -51.311501985775934,
                -30.107807875722543
              ],
              [
                -51.31248767780086,
                -30.10872695086705
              ],
              [
                -51.31440430118268,
                -30.113781864161847
              ],
              [
                -51.31309004514943,
                -30.114011632947975
              ],
              [
                -51.3135828911619,
                -30.116481647398842
              ],
              [
                -51.31237815646476,
                -30.119698410404624
              ],
              [
                -51.31380193383411,
                -30.121996098265896
              ],
              [
                -51.31347336982579,
                -30.12567239884393
              ],
              [
                -51.31440430118268,
                -30.127108453757224
              ],
              [
                -51.31319956648554,
                -30.130382658959537
              ],
              [
                -51.31128294310372,
                -30.130899638728323
              ],
              [
                -51.310297251078794,
                -30.131818713872832
              ],
              [
                -51.30619020097491,
                -30.131991040462427
              ],
              [
                -51.30580687629855,
                -30.13457593930636
              ],
              [
                -51.30657352565127,
                -30.13589710982659
              ],
              [
                -51.310899618427364,
                -30.136126878612718
              ],
              [
                -51.31007820840659,
                -30.137505491329478
              ],
              [
                -51.31117342176762,
                -30.138711777456646
              ],
              [
                -51.31538999320761,
                -30.14198598265896
              ],
              [
                -51.31768994126578,
                -30.14451343930636
              ],
              [
                -51.31922323997123,
                -30.147328106936417
              ],
              [
                -51.31988036798785,
                -30.14778764450867
              ],
              [
                -51.321796991369666,
                -30.15100440751445
              ],
              [
                -51.32168747003356,
                -30.153187210982658
              ],
              [
                -51.3227826833946,
                -30.15640397398844
              ],
              [
                -51.32322076873901,
                -30.159505852601157
              ],
              [
                -51.32322076873901,
                -30.163411921965317
              ],
              [
                -51.3244802641042,
                -30.16547984104046
              ],
              [
                -51.32469930677641,
                -30.16737543352601
              ],
              [
                -51.323713614751476,
                -30.172774999999998
              ],
              [
                -51.31478762585904,
                -30.188686488439306
              ],
              [
                -51.316375685232536,
                -30.19259255780347
              ],
              [
                -51.31511618986735,
                -30.194315823699423
              ],
              [
                -51.31840182995045,
                -30.19908352601156
              ],
              [
                -51.32020893199616,
                -30.202702384393064
              ],
              [
                -51.32048273533642,
                -30.205000072254336
              ],
              [
                -51.321194624021096,
                -30.206493569364163
              ],
              [
                -51.3214136666933,
                -30.210571965317918
              ],
              [
                -51.31960656464759,
                -30.213099421965318
              ],
              [
                -51.31988036798785,
                -30.214018497109826
              ],
              [
                -51.322399358718236,
                -30.21281221098266
              ],
              [
                -51.324918349448616,
                -30.214018497109826
              ],
              [
                -51.32628736614991,
                -30.216603395953758
              ],
              [
                -51.32820398953172,
                -30.222002962427744
              ],
              [
                -51.32831351086783,
                -30.226483453757226
              ],
              [
                -51.32869683554419,
                -30.229010910404625
              ],
              [
                -51.32968252756912,
                -30.231021387283235
              ],
              [
                -51.32842303220393,
                -30.232572326589594
              ],
              [
                -51.32579452013744,
                -30.23498489884393
              ],
              [
                -51.32327552940706,
                -30.235099783236993
              ],
              [
                -51.32228983738213,
                -30.23469768786127
              ],
              [
                -51.319387521975386,
                -30.23498489884393
              ],
              [
                -51.31730661658942,
                -30.232572326589594
              ],
              [
                -51.31768994126578,
                -30.230676734104044
              ],
              [
                -51.31659472790474,
                -30.230619291907512
              ],
              [
                -51.31692329191306,
                -30.234180708092484
              ],
              [
                -51.31549951454371,
                -30.237684682080925
              ],
              [
                -51.31330908782164,
                -30.24009725433526
              ],
              [
                -51.3106258150871,
                -30.24009725433526
              ],
              [
                -51.30717589299984,
                -30.238086777456648
              ],
              [
                -51.29841418611156,
                -30.23441047687861
              ],
              [
                -51.293814289995204,
                -30.23182557803468
              ],
              [
                -51.29277383730222,
                -30.233204190751444
              ],
              [
                -51.292609555298064,
                -30.234582803468207
              ],
              [
                -51.29452617867988,
                -30.23722514450867
              ],
              [
                -51.29611423805338,
                -30.237627239884393
              ],
              [
                -51.29841418611156,
                -30.23912073699422
              ],
              [
                -51.298687989451814,
                -30.240786560693643
              ],
              [
                -51.296223759389484,
                -30.24520960982659
              ],
              [
                -51.29490950335624,
                -30.24687543352601
              ],
              [
                -51.2922262306217,
                -30.24808171965318
              ],
              [
                -51.28751681316925,
                -30.249517774566474
              ],
              [
                -51.28680492448458,
                -30.250896387283237
              ],
              [
                -51.284504976426405,
                -30.250207080924856
              ],
              [
                -51.279686037637845,
                -30.250724060693642
              ],
              [
                -51.277221807575515,
                -30.24997731213873
              ],
              [
                -51.27492185951734,
                -30.248828468208092
              ],
              [
                -51.27322427880773,
                -30.249804985549133
              ],
              [
                -51.2750861415215,
                -30.25060917630058
              ],
              [
                -51.27760513225188,
                -30.25290686416185
              ],
              [
                -51.28061696899473,
                -30.25422803468208
              ],
              [
                -51.28247883170849,
                -30.25652572254335
              ],
              [
                -51.2842859337542,
                -30.256985260115606
              ],
              [
                -51.287078727824834,
                -30.256985260115606
              ],
              [
                -51.28740729183315,
                -30.258478757225433
              ],
              [
                -51.28850250519418,
                -30.258478757225433
              ],
              [
                -51.28861202653029,
                -30.256583164739883
              ],
              [
                -51.290090564567684,
                -30.255089667630056
              ],
              [
                -51.291404820600924,
                -30.254515245664738
              ],
              [
                -51.29332144398274,
                -30.25520455202312
              ],
              [
                -51.29797610076714,
                -30.25962760115607
              ],
              [
                -51.29967368147675,
                -30.265027167630056
              ],
              [
                -51.300604612833624,
                -30.27019696531792
              ],
              [
                -51.30087841617389,
                -30.27502210982659
              ],
              [
                -51.30011176682116,
                -30.27731979768786
              ],
              [
                -51.30011176682116,
                -30.27921539017341
              ],
              [
                -51.299290356800384,
                -30.2808237716763
              ],
              [
                -51.300002245485054,
                -30.282489595375722
              ],
              [
                -51.299290356800384,
                -30.2846149566474
              ],
              [
                -51.2996189208087,
                -30.287027528901735
              ],
              [
                -51.29890703212402,
                -30.29208244219653
              ],
              [
                -51.29792134009909,
                -30.296390606936416
              ],
              [
                -51.2952928280326,
                -30.302881575144507
              ],
              [
                -51.293595247323,
                -30.304087861271675
              ],
              [
                -51.29228099128976,
                -30.304317630057803
              ],
              [
                -51.28910487254275,
                -30.303800650289016
              ],
              [
                -51.28658588181237,
                -30.303800650289016
              ],
              [
                -51.28472401909861,
                -30.304375072254334
              ],
              [
                -51.28357404506952,
                -30.30581112716763
              ],
              [
                -51.281602661019654,
                -30.306213222543352
              ],
              [
                -51.27941223429759,
                -30.307821604046243
              ],
              [
                -51.275907551542275,
                -30.308510910404625
              ],
              [
                -51.26829581868307,
                -30.308223699421966
              ],
              [
                -51.265612545948535,
                -30.306328106936416
              ],
              [
                -51.26298403388205,
                -30.306328106936416
              ],
              [
                -51.26112217116829,
                -30.307017413294798
              ],
              [
                -51.25717940306856,
                -30.30581112716763
              ],
              [
                -51.25460565167013,
                -30.308281141618497
              ],
              [
                -51.248417696180276,
                -30.31121069364162
              ],
              [
                -51.247705807495606,
                -30.31327861271676
              ],
              [
                -51.24628203012626,
                -30.31511676300578
              ],
              [
                -51.24737724348729,
                -30.316323049132947
              ],
              [
                -51.247212961483136,
                -30.318218641618497
              ],
              [
                -51.246501072798466,
                -30.319080274566474
              ],
              [
                -51.24852721751638,
                -30.32080354046243
              ],
              [
                -51.25000575555378,
                -30.322699132947974
              ],
              [
                -51.250224798225986,
                -30.3241926300578
              ],
              [
                -51.248910542192746,
                -30.324881936416183
              ],
              [
                -51.249677191545466,
                -30.326777528901733
              ],
              [
                -51.249020063528846,
                -30.328213583815028
              ],
              [
                -51.246501072798466,
                -30.328385910404624
              ],
              [
                -51.242284501358476,
                -30.326605202312138
              ],
              [
                -51.24118928799744,
                -30.325628684971097
              ],
              [
                -51.241079766661336,
                -30.32321611271676
              ],
              [
                -51.24031311730862,
                -30.322297037572255
              ],
              [
                -51.239217903947576,
                -30.318218641618497
              ],
              [
                -51.23642510987694,
                -30.313393497109825
              ],
              [
                -51.23379659781045,
                -30.310521387283238
              ],
              [
                -51.22958002637046,
                -30.30741950867052
              ],
              [
                -51.22328254954451,
                -30.30362832369942
              ],
              [
                -51.22048975547387,
                -30.302709248554912
              ],
              [
                -51.219175499440624,
                -30.301905057803467
              ],
              [
                -51.21189233058974,
                -30.299607369942194
              ],
              [
                -51.21008522854403,
                -30.301273193641617
              ],
              [
                -51.210578074556494,
                -30.306213222543352
              ],
              [
                -51.21030427121624,
                -30.310521387283238
              ],
              [
                -51.2106875958926,
                -30.312474421965316
              ],
              [
                -51.210523313888444,
                -30.314025361271675
              ],
              [
                -51.2107971172287,
                -30.31741445086705
              ],
              [
                -51.2106875958926,
                -30.324077745664738
              ],
              [
                -51.21008522854403,
                -30.324996820809247
              ],
              [
                -51.20970190386767,
                -30.329017774566474
              ],
              [
                -51.2090995365191,
                -30.332291979768787
              ],
              [
                -51.208113844494164,
                -30.336083164739883
              ],
              [
                -51.207401955809495,
                -30.34079342485549
              ],
              [
                -51.20389727305418,
                -30.349984176300577
              ],
              [
                -51.201980649672365,
                -30.35452210982659
              ],
              [
                -51.200721154307175,
                -30.3567049132948
              ],
              [
                -51.20039259029887,
                -30.358313294797686
              ],
              [
                -51.19858548825316,
                -30.361127962427744
              ],
              [
                -51.19612125819083,
                -30.36388518786127
              ],
              [
                -51.197106950215755,
                -30.366584971098266
              ],
              [
                -51.19650458286719,
                -30.368710332369943
              ],
              [
                -51.195190326833945,
                -30.370376156069362
              ],
              [
                -51.193273703452135,
                -30.373995014450866
              ],
              [
                -51.19190468675084,
                -30.37600549132948
              ],
              [
                -51.191521362074475,
                -30.37732666184971
              ],
              [
                -51.18938569602046,
                -30.379681791907515
              ],
              [
                -51.18549768858878,
                -30.38312832369942
              ],
              [
                -51.181007313808536,
                -30.38600043352601
              ],
              [
                -51.17821451973789,
                -30.386402528901733
              ],
              [
                -51.17640741769218,
                -30.385598338150288
              ],
              [
                -51.17509316165894,
                -30.38439205202312
              ],
              [
                -51.17399794829791,
                -30.384277167630056
              ],
              [
                -51.1723003675883,
                -30.383185765895952
              ],
              [
                -51.169398052181556,
                -30.38249645953757
              ],
              [
                -51.16791951414416,
                -30.381002962427743
              ],
              [
                -51.16419578871664,
                -30.380083887283238
              ],
              [
                -51.16019825994886,
                -30.37790108381503
              ],
              [
                -51.15592692784082,
                -30.376522471098266
              ],
              [
                -51.15269604842576,
                -30.373420592485548
              ],
              [
                -51.15012229702733,
                -30.372616401734103
              ],
              [
                -51.14721998162059,
                -30.36997406069364
              ],
              [
                -51.14530335823877,
                -30.36767637283237
              ],
              [
                -51.14157963281125,
                -30.3653786849711
              ],
              [
                -51.13741782203932,
                -30.363080997109826
              ],
              [
                -51.1338036179479,
                -30.361472615606935
              ],
              [
                -51.13079178120505,
                -30.360496098265894
              ],
              [
                -51.12860135448298,
                -30.359289812138726
              ],
              [
                -51.12739661978584,
                -30.360208887283235
              ],
              [
                -51.12197531364871,
                -30.360783309248554
              ],
              [
                -51.11890871623781,
                -30.359921676300576
              ],
              [
                -51.1139254954451,
                -30.358083526011562
              ],
              [
                -51.10872323198018,
                -30.35710700867052
              ],
              [
                -51.10100197778488,
                -30.356992124277458
              ],
              [
                -51.097716337701776,
                -30.357623988439308
              ],
              [
                -51.09519734697139,
                -30.362506575144508
              ],
              [
                -51.094704500958926,
                -30.364689378612717
              ],
              [
                -51.09508782563529,
                -30.370491040462426
              ],
              [
                -51.09579971431996,
                -30.373420592485548
              ],
              [
                -51.096894927681,
                -30.37479920520231
              ],
              [
                -51.09629256033243,
                -30.378015968208093
              ],
              [
                -51.095416389643596,
                -30.37979667630058
              ],
              [
                -51.095306868307496,
                -30.38157738439306
              ],
              [
                -51.096894927681,
                -30.382381575144507
              ],
              [
                -51.09727825235736,
                -30.380715751445088
              ],
              [
                -51.101385302461246,
                -30.378015968208093
              ],
              [
                -51.10352096851526,
                -30.378418063583815
              ],
              [
                -51.103301925843056,
                -30.376522471098266
              ],
              [
                -51.105711395237336,
                -30.377384104046243
              ],
              [
                -51.10921607799265,
                -30.38157738439306
              ],
              [
                -51.11080413736615,
                -30.383185765895952
              ],
              [
                -51.11261123941186,
                -30.386402528901733
              ],
              [
                -51.11600640083107,
                -30.38950440751445
              ],
              [
                -51.11890871623781,
                -30.39168721098266
              ],
              [
                -51.120387254275215,
                -30.39369768786127
              ],
              [
                -51.12208483498482,
                -30.39691445086705
              ],
              [
                -51.122413398993125,
                -30.399212138728323
              ],
              [
                -51.12148246763625,
                -30.405817991329478
              ],
              [
                -51.12060629694742,
                -30.407885910404623
              ],
              [
                -51.119292040914175,
                -30.408288005780346
              ],
              [
                -51.12000392959885,
                -30.410183598265895
              ],
              [
                -51.12082533961963,
                -30.410815462427745
              ],
              [
                -51.12219435632092,
                -30.409896387283236
              ],
              [
                -51.123618133690265,
                -30.41070057803468
              ],
              [
                -51.1261918850887,
                -30.415583164739886
              ],
              [
                -51.127177577113635,
                -30.419489234104045
              ],
              [
                -51.12690377377337,
                -30.420810404624277
              ],
              [
                -51.127779944462205,
                -30.4224762283237
              ],
              [
                -51.12712281644558,
                -30.42471647398844
              ],
              [
                -51.125425235735975,
                -30.426726950867053
              ],
              [
                -51.125425235735975,
                -30.4286225433526
              ],
              [
                -51.12712281644558,
                -30.429771387283235
              ],
              [
                -51.127177577113635,
                -30.432528612716762
              ],
              [
                -51.129094200495445,
                -30.434194436416185
              ],
              [
                -51.13188699456609,
                -30.43528583815029
              ],
              [
                -51.14229152149593,
                -30.471416979768787
              ],
              [
                -51.14409862354163,
                -30.473197687861273
              ],
              [
                -51.14431766621384,
                -30.476184682080923
              ],
              [
                -51.146179528927604,
                -30.48399682080925
              ],
              [
                -51.14858899832188,
                -30.4895112716763
              ],
              [
                -51.14880804099408,
                -30.491291979768786
              ],
              [
                -51.15017705769538,
                -30.494508742774567
              ],
              [
                -51.150505621703694,
                -30.496978757225435
              ],
              [
                -51.15258652708966,
                -30.500310404624276
              ],
              [
                -51.15570788516861,
                -30.500310404624276
              ],
              [
                -51.15707690186991,
                -30.49887434971098
              ],
              [
                -51.15641977385329,
                -30.496691546242776
              ],
              [
                -51.15631025251718,
                -30.493187572254335
              ],
              [
                -51.154776953811734,
                -30.49238338150289
              ],
              [
                -51.15532456049225,
                -30.490775
              ],
              [
                -51.15461267180758,
                -30.488477312138727
              ],
              [
                -51.1524222450855,
                -30.485203106936417
              ],
              [
                -51.15088894638006,
                -30.484111705202313
              ],
              [
                -51.151107989052264,
                -30.482273554913295
              ],
              [
                -51.14941040834265,
                -30.48020563583815
              ],
              [
                -51.149300887006554,
                -30.478080274566473
              ],
              [
                -51.14858899832188,
                -30.477103757225432
              ],
              [
                -51.14902708366629,
                -30.47480606936416
              ],
              [
                -51.14858899832188,
                -30.47348489884393
              ],
              [
                -51.14700093894838,
                -30.47210628612717
              ],
              [
                -51.14338673485696,
                -30.471014884393064
              ],
              [
                -51.135775001997764,
                -30.436779335260116
              ],
              [
                -51.138293992728144,
                -30.434596531791907
              ],
              [
                -51.142510564168134,
                -30.433907225433526
              ],
              [
                -51.143879580869424,
                -30.432528612716762
              ],
              [
                -51.144427187549944,
                -30.430690462427744
              ],
              [
                -51.142017718155664,
                -30.428392774566472
              ],
              [
                -51.14240104283203,
                -30.42569299132948
              ],
              [
                -51.14481051222631,
                -30.422993208092485
              ],
              [
                -51.14492003356241,
                -30.421614595375722
              ],
              [
                -51.14831519498162,
                -30.420121098265895
              ],
              [
                -51.14902708366629,
                -30.41937434971098
              ],
              [
                -51.15099846771616,
                -30.415583164739886
              ],
              [
                -51.1537912617868,
                -30.413687572254336
              ],
              [
                -51.15691261986575,
                -30.413285476878613
              ],
              [
                -51.15997921727665,
                -30.412021748554913
              ],
              [
                -51.167481428799746,
                -30.410183598265895
              ],
              [
                -51.17772167372543,
                -30.408517774566473
              ],
              [
                -51.18018590378776,
                -30.408517774566473
              ],
              [
                -51.18248585184593,
                -30.407885910404623
              ],
              [
                -51.18511436391242,
                -30.408173121387282
              ],
              [
                -51.187797636646955,
                -30.40811567919075
              ],
              [
                -51.18998806336903,
                -30.407713583815028
              ],
              [
                -51.19289037877577,
                -30.408000794797687
              ],
              [
                -51.19787359956848,
                -30.408000794797687
              ],
              [
                -51.20050211163497,
                -30.40840289017341
              ],
              [
                -51.20269253835704,
                -30.409207080924855
              ],
              [
                -51.20608769977625,
                -30.411389884393063
              ],
              [
                -51.20789480182196,
                -30.413687572254336
              ],
              [
                -51.21517797067285,
                -30.416272471098267
              ],
              [
                -51.21698507271856,
                -30.41770852601156
              ],
              [
                -51.21868265342816,
                -30.417823410404623
              ],
              [
                -51.22081831948218,
                -30.419202023121386
              ],
              [
                -51.22311826754036,
                -30.419776445086704
              ],
              [
                -51.22508965159022,
                -30.421614595375722
              ],
              [
                -51.22821100966917,
                -30.422993208092485
              ],
              [
                -51.22968954770657,
                -30.424486705202312
              ],
              [
                -51.2307847610676,
                -30.42758858381503
              ],
              [
                -51.23341327313409,
                -30.432011632947976
              ],
              [
                -51.23658939188109,
                -30.43407955202312
              ],
              [
                -51.2382869725907,
                -30.436377239884393
              ],
              [
                -51.23927266461563,
                -30.438617485549134
              ],
              [
                -51.24069644198498,
                -30.440398193641617
              ],
              [
                -51.24491301342496,
                -30.442810765895953
              ],
              [
                -51.24628203012626,
                -30.445108453757225
              ],
              [
                -51.24622726945821,
                -30.44648706647399
              ],
              [
                -51.24507729542912,
                -30.447923121387284
              ],
              [
                -51.24518681676522,
                -30.449186849710983
              ],
              [
                -51.24732248281924,
                -30.451484537572252
              ],
              [
                -51.248910542192746,
                -30.45171430635838
              ],
              [
                -51.249622430877416,
                -30.452805708092484
              ],
              [
                -51.249512909541316,
                -30.45487362716763
              ],
              [
                -51.25000575555378,
                -30.45527572254335
              ],
              [
                -51.249020063528846,
                -30.457688294797688
              ],
              [
                -51.250115276889886,
                -30.460388078034683
              ],
              [
                -51.25241522494806,
                -30.461019942196533
              ],
              [
                -51.25487945501039,
                -30.46291553468208
              ],
              [
                -51.25739844574077,
                -30.465328106936415
              ],
              [
                -51.25860318043791,
                -30.466879046242774
              ],
              [
                -51.25991743647115,
                -30.46992348265896
              ],
              [
                -51.259479351126735,
                -30.47181907514451
              ],
              [
                -51.2628197518779,
                -30.475208164739882
              ],
              [
                -51.26407924724309,
                -30.47888446531792
              ],
              [
                -51.26539350327633,
                -30.479803540462427
              ],
              [
                -51.26539350327633,
                -30.483307514450868
              ],
              [
                -51.26780297267061,
                -30.487385910404623
              ],
              [
                -51.27919319162538,
                -30.51042023121387
              ],
              [
                -51.29841418611156,
                -30.5590737716763
              ],
              [
                -51.299892724148954,
                -30.56389891618497
              ],
              [
                -51.30208315087103,
                -30.576880852601157
              ],
              [
                -51.30328788556816,
                -30.588599060693642
              ],
              [
                -51.303616449576474,
                -30.60939313583815
              ],
              [
                -51.30219267220713,
                -30.63438049132948
              ],
              [
                -51.298797510787914,
                -30.65678294797688
              ],
              [
                -51.29857846811571,
                -30.664422760115606
              ],
              [
                -51.293102401310534,
                -30.707676734104044
              ],
              [
                -51.293211922646634,
                -30.71669515895954
              ],
              [
                -51.29490950335624,
                -30.731400361271675
              ],
              [
                -51.29408809333546,
                -30.751620014450868
              ],
              [
                -51.28992628256353,
                -30.77000151734104
              ],
              [
                -51.28412165175004,
                -30.787980924855493
              ],
              [
                -51.28110981500719,
                -30.801709609826588
              ],
              [
                -51.28242407104043,
                -30.812508742774565
              ],
              [
                -51.290419128576,
                -30.817506213872832
              ],
              [
                -51.294307136007674,
                -30.818827384393064
              ],
              [
                -51.296880887406104,
                -30.81808063583815
              ],
              [
                -51.29857846811571,
                -30.816299927745664
              ],
              [
                -51.28779061650951,
                -30.810498265895955
              ],
              [
                -51.285107343774975,
                -30.807281502890174
              ],
              [
                -51.2842859337542,
                -30.802513800578033
              ],
              [
                -51.28729777049704,
                -30.79751632947977
              ],
              [
                -51.29162386327313,
                -30.794586777456647
              ],
              [
                -51.298085622103244,
                -30.791886994219652
              ],
              [
                -51.31177578911619,
                -30.788612789017343
              ],
              [
                -51.31911371863513,
                -30.785510910404625
              ],
              [
                -51.32628736614991,
                -30.78189205202312
              ],
              [
                -51.33121582627457,
                -30.778502962427744
              ],
              [
                -51.33017537358159,
                -30.778273193641617
              ],
              [
                -51.323001726066806,
                -30.782294147398844
              ],
              [
                -51.31807326594215,
                -30.78350043352601
              ],
              [
                -51.305478312290234,
                -30.784304624277457
              ],
              [
                -51.300495091497524,
                -30.77999645953757
              ],
              [
                -51.29397857199936,
                -30.77092059248555
              ],
              [
                -51.29337620465079,
                -30.76477427745665
              ],
              [
                -51.29649756272974,
                -30.75070093930636
              ],
              [
                -51.29699040874221,
                -30.740016690751446
              ],
              [
                -51.29967368147675,
                -30.731400361271675
              ],
              [
                -51.30219267220713,
                -30.726804985549133
              ],
              [
                -51.303014082227904,
                -30.722094725433525
              ],
              [
                -51.30651876498322,
                -30.71548887283237
              ],
              [
                -51.31489714719514,
                -30.705321604046244
              ],
              [
                -51.31659472790474,
                -30.704115317919076
              ],
              [
                -51.31429477984657,
                -30.700898554913294
              ],
              [
                -51.31692329191306,
                -30.69727969653179
              ],
              [
                -51.3152804718715,
                -30.694809682080926
              ],
              [
                -51.315773317883966,
                -30.691822687861272
              ],
              [
                -51.31402097650631,
                -30.688491040462427
              ],
              [
                -51.316978052581106,
                -30.685504046242773
              ],
              [
                -51.31768994126578,
                -30.683321242774568
              ],
              [
                -51.31922323997123,
                -30.68217239884393
              ],
              [
                -51.319387521975386,
                -30.67987471098266
              ],
              [
                -51.31659472790474,
                -30.676600505780346
              ],
              [
                -51.31867563329072,
                -30.671315823699423
              ],
              [
                -51.31840182995045,
                -30.666605563583815
              ],
              [
                -51.319387521975386,
                -30.663503684971097
              ],
              [
                -51.31807326594215,
                -30.660516690751443
              ],
              [
                -51.31889467596292,
                -30.658276445086706
              ],
              [
                -51.31692329191306,
                -30.65431293352601
              ],
              [
                -51.31768994126578,
                -30.648224060693643
              ],
              [
                -51.318785154626816,
                -30.646098699421966
              ],
              [
                -51.32639688748601,
                -30.640009826589594
              ],
              [
                -51.32760162218315,
                -30.63799934971098
              ],
              [
                -51.33461098769378,
                -30.633806069364162
              ],
              [
                -51.34791783003037,
                -30.63150838150289
              ],
              [
                -51.364126987773695,
                -30.633174205202312
              ],
              [
                -51.371574438628734,
                -30.636103757225435
              ],
              [
                -51.38088375219754,
                -30.643513800578035
              ],
              [
                -51.38307417891961,
                -30.64839638728324
              ],
              [
                -51.3858122123222,
                -30.651498265895952
              ],
              [
                -51.38701694701934,
                -30.655002239884393
              ],
              [
                -51.38690742568323,
                -30.66040180635838
              ],
              [
                -51.38570269098609,
                -30.662182514450866
              ],
              [
                -51.38948117708167,
                -30.6645950867052
              ],
              [
                -51.39112399712322,
                -30.66867348265896
              ],
              [
                -51.39139780046348,
                -30.675394219653178
              ],
              [
                -51.39298585983698,
                -30.678783309248555
              ],
              [
                -51.39271205649672,
                -30.681597976878614
              ],
              [
                -51.39599769657983,
                -30.698026445086704
              ],
              [
                -51.39610721791593,
                -30.701817630057803
              ],
              [
                -51.3980786019658,
                -30.71008930635838
              ],
              [
                -51.39917381532683,
                -30.712501878612716
              ],
              [
                -51.40092615670449,
                -30.71709725433526
              ],
              [
                -51.402021370065526,
                -30.72858569364162
              ],
              [
                -51.40339038676682,
                -30.732319436416184
              ],
              [
                -51.4042117967876,
                -30.738006213872833
              ],
              [
                -51.40519748881253,
                -30.748575578034682
              ],
              [
                -51.405799856161096,
                -30.756789812138727
              ],
              [
                -51.40481416413617,
                -30.760121459537572
              ],
              [
                -51.40470464280006,
                -30.765808236994218
              ],
              [
                -51.403773711443186,
                -30.76678475433526
              ],
              [
                -51.4043213181237,
                -30.782926011560694
              ],
              [
                -51.40289754075435,
                -30.78378764450867
              ],
              [
                -51.401419002716956,
                -30.79148489884393
              ],
              [
                -51.395888175243726,
                -30.808315462427746
              ],
              [
                -51.39577865390762,
                -30.820205997109827
              ],
              [
                -51.3905763904427,
                -30.840310765895953
              ],
              [
                -51.38170516221832,
                -30.860875072254334
              ],
              [
                -51.372724412657824,
                -30.872478395953756
              ],
              [
                -51.369000687230304,
                -30.874373988439306
              ],
              [
                -51.37601005274093,
                -30.87741842485549
              ],
              [
                -51.39008354443024,
                -30.87988843930636
              ],
              [
                -51.39758575595333,
                -30.878107731213873
              ],
              [
                -51.4042117967876,
                -30.877820520231214
              ],
              [
                -51.40919501758031,
                -30.878509826589596
              ],
              [
                -51.414890127057696,
                -30.875924927745665
              ],
              [
                -51.42940170409142,
                -30.87517817919075
              ],
              [
                -51.43597298425763,
                -30.87351235549133
              ],
              [
                -51.43860149632412,
                -30.87098489884393
              ],
              [
                -51.44347519578073,
                -30.870582803468206
              ],
              [
                -51.44528229782643,
                -30.871214667630056
              ],
              [
                -51.44697987853604,
                -30.872478395953756
              ],
              [
                -51.44878698058175,
                -30.872191184971097
              ],
              [
                -51.452894030685634,
                -30.873971893063583
              ],
              [
                -51.45820581548666,
                -30.876901445086705
              ],
              [
                -51.46171049824197,
                -30.879026806358382
              ],
              [
                -51.46861034241649,
                -30.884024277456646
              ],
              [
                -51.473100717196736,
                -30.886781502890173
              ],
              [
                -51.47748157064088,
                -30.889998265895954
              ],
              [
                -51.48071245005594,
                -30.893100144508672
              ],
              [
                -51.48432665414735,
                -30.896776445086704
              ],
              [
                -51.48761229423046,
                -30.899878323699422
              ],
              [
                -51.49111697698577,
                -30.904416257225435
              ],
              [
                -51.49369072838421,
                -30.908322326589595
              ],
              [
                -51.49560735176602,
                -30.913779335260116
              ],
              [
                -51.49779777848809,
                -30.917627962427744
              ],
              [
                -51.49867394917692,
                -30.92067239884393
              ],
              [
                -51.50020724788237,
                -30.92768034682081
              ],
              [
                -51.50031676921847,
                -30.931701300578034
              ],
              [
                -51.50080961523094,
                -30.935607369942197
              ],
              [
                -51.500700093894835,
                -30.944281141618497
              ],
              [
                -51.499988205210165,
                -30.949680708092487
              ],
              [
                -51.49927631652549,
                -30.95140397398844
              ],
              [
                -51.500097726546265,
                -30.953471893063583
              ],
              [
                -51.500700093894835,
                -30.96042239884393
              ],
              [
                -51.500590572558735,
                -30.965477312138727
              ],
              [
                -51.49927631652549,
                -30.97581690751445
              ],
              [
                -51.49708588980342,
                -30.984490679190753
              ],
              [
                -51.496374001118745,
                -30.988511632947976
              ],
              [
                -51.49527878775771,
                -30.992704913294798
              ],
              [
                -51.492595515023176,
                -31.003906141618497
              ],
              [
                -51.487721815566566,
                -31.019472976878614
              ],
              [
                -51.48312191945021,
                -31.031018858381504
              ],
              [
                -51.477974416653346,
                -31.041415895953758
              ],
              [
                -51.47468877657024,
                -31.048481286127167
              ],
              [
                -51.4703079231261,
                -31.05692528901734
              ],
              [
                -51.46811749640403,
                -31.060314378612716
              ],
              [
                -51.46581754834585,
                -31.065024638728325
              ],
              [
                -51.46351760028768,
                -31.067896748554915
              ],
              [
                -51.45891770417133,
                -31.074387716763006
              ],
              [
                -51.455413021416014,
                -31.078580997109828
              ],
              [
                -51.4520178599968,
                -31.08219985549133
              ],
              [
                -51.44719892120825,
                -31.08547406069364
              ],
              [
                -51.441996657743324,
                -31.087427095375723
              ],
              [
                -51.44177761507112,
                -31.088116401734105
              ],
              [
                -51.445610861834744,
                -31.08949501445087
              ],
              [
                -51.4503202792872,
                -31.090299205202314
              ],
              [
                -51.45689155945341,
                -31.092079913294796
              ],
              [
                -51.45809629415055,
                -31.09351596820809
              ],
              [
                -51.461491455569764,
                -31.095296676300578
              ],
              [
                -51.46762465039156,
                -31.097422037572255
              ],
              [
                -51.47069124780246,
                -31.098111343930636
              ],
              [
                -51.47271739252038,
                -31.0982262283237
              ],
              [
                -51.48558614951254,
                -31.101213222543354
              ],
              [
                -51.48859798625539,
                -31.101328106936418
              ],
              [
                -51.49648352245485,
                -31.10282160404624
              ],
              [
                -51.50529999001119,
                -31.103223699421964
              ],
              [
                -51.5119807915135,
                -31.104602312138727
              ],
              [
                -51.51740209765063,
                -31.106210693641618
              ],
              [
                -51.52627332587502,
                -31.1094274566474
              ],
              [
                -51.53328269138565,
                -31.111610260115608
              ],
              [
                -51.534980272095254,
                -31.112471893063585
              ],
              [
                -51.53777306616589,
                -31.11499934971098
              ],
              [
                -51.53892304019498,
                -31.113678179190753
              ],
              [
                -51.54100394558095,
                -31.112701661849712
              ],
              [
                -51.54538479902509,
                -31.111610260115608
              ],
              [
                -51.55009421647755,
                -31.112184682080926
              ],
              [
                -51.554475069921686,
                -31.114080274566476
              ],
              [
                -51.567289066245806,
                -31.128613150289016
              ],
              [
                -51.57517460244526,
                -31.12970455202312
              ],
              [
                -51.577803114511745,
                -31.12970455202312
              ],
              [
                -51.58180064327953,
                -31.128325939306357
              ],
              [
                -51.585688650711205,
                -31.12999176300578
              ],
              [
                -51.60200732979063,
                -31.131715028901734
              ],
              [
                -51.61799744486176,
                -31.13958460982659
              ],
              [
                -51.62298066565447,
                -31.14469696531792
              ],
              [
                -51.62522585304459,
                -31.1491774566474
              ],
              [
                -51.62867577513185,
                -31.15302608381503
              ],
              [
                -51.63940886607,
                -31.180713222543353
              ],
              [
                -51.641325489451816,
                -31.18772117052023
              ],
              [
                -51.641489771455966,
                -31.195475867052025
              ],
              [
                -51.64302307016142,
                -31.20271358381503
              ],
              [
                -51.64362543750999,
                -31.21110014450867
              ],
              [
                -51.642584984817006,
                -31.22609255780347
              ],
              [
                -51.63918982339779,
                -31.24177427745665
              ],
              [
                -51.63448040594534,
                -31.255502962427745
              ],
              [
                -51.63141380853444,
                -31.26141950867052
              ],
              [
                -51.62829245045549,
                -31.26549790462428
              ],
              [
                -51.62270686231421,
                -31.267393497109826
              ],
              [
                -51.61832600887006,
                -31.266474421965317
              ],
              [
                -51.61668318882851,
                -31.267680708092485
              ],
              [
                -51.61909265822279,
                -31.269001878612716
              ],
              [
                -51.63908030206169,
                -31.27072514450867
              ],
              [
                -51.664215448697455,
                -31.271127239884393
              ],
              [
                -51.68080793111715,
                -31.270495375722543
              ],
              [
                -51.70670972710564,
                -31.265612789017343
              ],
              [
                -51.71339052860796,
                -31.26578511560694
              ],
              [
                -51.72428790155026,
                -31.271127239884393
              ],
              [
                -51.72609500359597,
                -31.274114234104047
              ],
              [
                -51.727792584305575,
                -31.274975867052024
              ],
              [
                -51.72970920768739,
                -31.27750332369942
              ],
              [
                -51.73228295908582,
                -31.278881936416184
              ],
              [
                -51.735678120505035,
                -31.27911170520231
              ],
              [
                -51.737485222550745,
                -31.280777528901734
              ],
              [
                -51.7408256233019,
                -31.281696604046243
              ],
              [
                -51.74279700735177,
                -31.280777528901734
              ],
              [
                -51.74542551941825,
                -31.27750332369942
              ],
              [
                -51.74909448417772,
                -31.277273554913297
              ],
              [
                -51.749915894198494,
                -31.278824494219652
              ],
              [
                -51.745589801422405,
                -31.280892413294797
              ],
              [
                -51.74580884409461,
                -31.282500794797688
              ],
              [
                -51.74717786079591,
                -31.28261567919075
              ],
              [
                -51.751503953572,
                -31.27939891618497
              ],
              [
                -51.7532015342816,
                -31.279915895953756
              ],
              [
                -51.753475337621865,
                -31.282385910404624
              ],
              [
                -51.75708954171328,
                -31.286119653179192
              ],
              [
                -51.75862284041873,
                -31.286119653179192
              ],
              [
                -51.75927996843535,
                -31.28387940751445
              ],
              [
                -51.762675129854564,
                -31.283994291907515
              ],
              [
                -51.76382510388365,
                -31.282098699421965
              ],
              [
                -51.767603589979224,
                -31.282673121387283
              ],
              [
                -51.768808324676364,
                -31.27842239884393
              ],
              [
                -51.77707718555218,
                -31.275320520231215
              ],
              [
                -51.79049354922487,
                -31.273310043352602
              ],
              [
                -51.79460059932875,
                -31.273999349710984
              ],
              [
                -51.80171948617548,
                -31.277905419075143
              ],
              [
                -51.81020738972351,
                -31.285315462427747
              ],
              [
                -51.811685927760905,
                -31.28571755780347
              ],
              [
                -51.80812648433754,
                -31.27779053468208
              ],
              [
                -51.80467656225028,
                -31.2745737716763
              ],
              [
                -51.799474298785356,
                -31.266187210982658
              ],
              [
                -51.799090974109,
                -31.259926011560694
              ],
              [
                -51.800076666133926,
                -31.257111343930635
              ],
              [
                -51.79969334145757,
                -31.25567528901734
              ],
              [
                -51.79837908542432,
                -31.254985982658958
              ],
              [
                -51.797010068723026,
                -31.256709248554913
              ],
              [
                -51.79607913736615,
                -31.256709248554913
              ],
              [
                -51.793176821959406,
                -31.254526445086704
              ],
              [
                -51.7898911818763,
                -31.255617846820808
              ],
              [
                -51.78857692584305,
                -31.254813656069363
              ],
              [
                -51.78868644717916,
                -31.2536073699422
              ],
              [
                -51.791314959245646,
                -31.253090390173412
              ],
              [
                -51.791698283922,
                -31.252171315028903
              ],
              [
                -51.789507857199936,
                -31.25171177745665
              ],
              [
                -51.789617378536036,
                -31.249011994219654
              ],
              [
                -51.792519693942786,
                -31.250390606936417
              ],
              [
                -51.79372442863992,
                -31.249011994219654
              ],
              [
                -51.7898911818763,
                -31.24510592485549
              ],
              [
                -51.78742695181397,
                -31.24568034682081
              ],
              [
                -51.78939833586383,
                -31.24671430635838
              ],
              [
                -51.78939833586383,
                -31.247403612716763
              ],
              [
                -51.78720790914176,
                -31.248322687861272
              ],
              [
                -51.78551032843215,
                -31.247805708092486
              ],
              [
                -51.7868245844654,
                -31.244703829479768
              ],
              [
                -51.78638649912099,
                -31.242693352601155
              ],
              [
                -51.78299133770177,
                -31.23580028901734
              ],
              [
                -51.78030806496724,
                -31.233387716763005
              ],
              [
                -51.782881816365666,
                -31.22798815028902
              ],
              [
                -51.785893653108516,
                -31.22649465317919
              ],
              [
                -51.785893653108516,
                -31.22459906069364
              ],
              [
                -51.784086551062806,
                -31.222703468208092
              ],
              [
                -51.78501748241969,
                -31.22011856936416
              ],
              [
                -51.77997950095892,
                -31.21810809248555
              ],
              [
                -51.77970569761867,
                -31.21649971098266
              ],
              [
                -51.7808009109797,
                -31.21558063583815
              ],
              [
                -51.78627697778488,
                -31.215408309248556
              ],
              [
                -51.78868644717916,
                -31.21397225433526
              ],
              [
                -51.788303122502796,
                -31.211904335260115
              ],
              [
                -51.78452463640722,
                -31.209893858381502
              ],
              [
                -51.78381274772255,
                -31.207825939306357
              ],
              [
                -51.78419607239891,
                -31.205528251445088
              ],
              [
                -51.78748171248202,
                -31.20081799132948
              ],
              [
                -51.78868644717916,
                -31.190478395953757
              ],
              [
                -51.79421727465239,
                -31.18680209537572
              ],
              [
                -51.79460059932875,
                -31.184676734104045
              ],
              [
                -51.790219745884606,
                -31.178300650289017
              ],
              [
                -51.78978166054019,
                -31.176405057803468
              ],
              [
                -51.79460059932875,
                -31.17100549132948
              ],
              [
                -51.798105282084066,
                -31.16842059248555
              ],
              [
                -51.80232185352405,
                -31.16721430635838
              ],
              [
                -51.80631938229183,
                -31.167099421965318
              ],
              [
                -51.80960502237494,
                -31.16847803468208
              ],
              [
                -51.81070023573597,
                -31.171809682080927
              ],
              [
                -51.81300018379415,
                -31.17330317919075
              ],
              [
                -51.81798340458686,
                -31.172326661849713
              ],
              [
                -51.82072143798945,
                -31.16750151734104
              ],
              [
                -51.820885719993605,
                -31.164801734104046
              ],
              [
                -51.82039287398114,
                -31.1591149566474
              ],
              [
                -51.81579297786479,
                -31.152279335260115
              ],
              [
                -51.812890662458045,
                -31.149407225433528
              ],
              [
                -51.80900265502637,
                -31.14659255780347
              ],
              [
                -51.801117118826916,
                -31.144811849710983
              ],
              [
                -51.7915887625859,
                -31.14021647398844
              ],
              [
                -51.789507857199936,
                -31.123615679190753
              ],
              [
                -51.78857692584305,
                -31.122179624277457
              ],
              [
                -51.79837908542432,
                -31.098800650289018
              ],
              [
                -51.81732627657024,
                -31.047504768786126
              ],
              [
                -51.81699771256193,
                -31.044977312138727
              ],
              [
                -51.810481193063765,
                -31.029812572254336
              ],
              [
                -51.818311968595175,
                -31.023723699421964
              ],
              [
                -51.8283879315167,
                -31.0199899566474
              ],
              [
                -51.84738988333067,
                -31.01079920520231
              ],
              [
                -51.85489209485376,
                -31.004078468208093
              ],
              [
                -51.85971103364232,
                -30.992590028901734
              ],
              [
                -51.86398236575036,
                -30.97932088150289
              ],
              [
                -51.86387284441425,
                -30.970819436416186
              ],
              [
                -51.86578946779607,
                -30.961513800578036
              ],
              [
                -51.864913297107236,
                -30.955195158959537
              ],
              [
                -51.867979894518136,
                -30.947727673410405
              ],
              [
                -51.87170361994566,
                -30.941409031791906
              ],
              [
                -51.87389404666773,
                -30.93537760115607
              ],
              [
                -51.87378452533163,
                -30.932275722543352
              ],
              [
                -51.87860346412018,
                -30.92348706647399
              ],
              [
                -51.881505779526925,
                -30.91297514450867
              ],
              [
                -51.8823271895477,
                -30.91228583815029
              ],
              [
                -51.94152347171168,
                -30.94370671965318
              ],
              [
                -51.949901853923606,
                -30.93882413294798
              ],
              [
                -51.951873237973466,
                -30.939685765895952
              ],
              [
                -51.95537792072878,
                -30.938996459537574
              ],
              [
                -51.9559255274093,
                -30.93761784682081
              ],
              [
                -51.959101646156306,
                -30.935894580924856
              ],
              [
                -51.960306380853446,
                -30.933424566473988
              ],
              [
                -51.966494336343295,
                -30.933596893063584
              ],
              [
                -51.968301438389005,
                -30.931184320809248
              ],
              [
                -51.96912284840978,
                -30.92699104046243
              ],
              [
                -51.97547508590379,
                -30.923372182080925
              ],
              [
                -51.97678934193703,
                -30.921419147398844
              ],
              [
                -51.98018450335624,
                -30.92348706647399
              ],
              [
                -51.98221064807416,
                -30.92641661849711
              ],
              [
                -51.98648198018219,
                -30.92411893063584
              ],
              [
                -51.993600867028924,
                -30.92319985549133
              ],
              [
                -52.00789340139044,
                -30.923716835260116
              ],
              [
                -52.01309566485536,
                -30.92262543352601
              ],
              [
                -52.01408135688029,
                -30.91877680635838
              ],
              [
                -52.017312236295346,
                -30.91607702312139
              ],
              [
                -52.020926440386766,
                -30.916191907514452
              ],
              [
                -52.026512028528046,
                -30.91871936416185
              ],
              [
                -52.03089288197219,
                -30.917972615606935
              ],
              [
                -52.03341187270257,
                -30.91659400289017
              ],
              [
                -52.04288546827553,
                -30.923027528901734
              ],
              [
                -52.05011387645836,
                -30.92601452312139
              ],
              [
                -52.05449472990251,
                -30.92601452312139
              ],
              [
                -52.05569946459965,
                -30.92699104046243
              ],
              [
                -52.06281835144638,
                -30.923027528901734
              ],
              [
                -52.066925401550264,
                -30.923027528901734
              ],
              [
                -52.068896785600124,
                -30.92101705202312
              ],
              [
                -52.06922534960844,
                -30.919580997109826
              ],
              [
                -52.07048484497363,
                -30.918891690751444
              ],
              [
                -52.070703887645834,
                -30.911883742774567
              ],
              [
                -52.07661803979543,
                -30.906484176300577
              ],
              [
                -52.0818750639284,
                -30.902922760115608
              ],
              [
                -52.08789873741409,
                -30.901888800578035
              ],
              [
                -52.08921299344734,
                -30.902922760115608
              ],
              [
                -52.09008916413617,
                -30.90590975433526
              ],
              [
                -52.09797470033562,
                -30.907116040462427
              ],
              [
                -52.0990151530286,
                -30.90912651734104
              ],
              [
                -52.09978180238133,
                -30.90912651734104
              ],
              [
                -52.10257459645197,
                -30.9056225433526
              ],
              [
                -52.10629832187949,
                -30.90332485549133
              ],
              [
                -52.10750305657663,
                -30.905507658959536
              ],
              [
                -52.108598269937666,
                -30.905507658959536
              ],
              [
                -52.10991252597091,
                -30.904014161849712
              ],
              [
                -52.1112815426722,
                -30.900510187861272
              ],
              [
                -52.113417208726226,
                -30.897982731213872
              ],
              [
                -52.115279071439986,
                -30.898097615606936
              ],
              [
                -52.11631952413297,
                -30.896489234104045
              ],
              [
                -52.1157171567844,
                -30.894191546242773
              ],
              [
                -52.11621000279687,
                -30.889481286127168
              ],
              [
                -52.115881438788556,
                -30.888102673410405
              ],
              [
                -52.11812662617868,
                -30.885977312138728
              ],
              [
                -52.1187837541953,
                -30.884713583815028
              ],
              [
                -52.120098010228546,
                -30.88419660404624
              ],
              [
                -52.122726522295025,
                -30.884713583815028
              ],
              [
                -52.1249169490171,
                -30.882703106936415
              ],
              [
                -52.1249169490171,
                -30.880979841040464
              ],
              [
                -52.1265050083906,
                -30.87770563583815
              ],
              [
                -52.126285965718395,
                -30.8758100433526
              ],
              [
                -52.12677881173086,
                -30.874718641618497
              ],
              [
                -52.12847639244046,
                -30.87448887283237
              ],
              [
                -52.1296811271376,
                -30.8732825867052
              ],
              [
                -52.13148822918331,
                -30.873684682080924
              ],
              [
                -52.13340485256513,
                -30.873397471098265
              ],
              [
                -52.134281023253955,
                -30.8720188583815
              ],
              [
                -52.13641668930797,
                -30.87167420520231
              ],
              [
                -52.13690953532044,
                -30.87069768786127
              ],
              [
                -52.13652621064408,
                -30.868916979768787
              ],
              [
                -52.1388809193703,
                -30.867883020231215
              ],
              [
                -52.13899044070641,
                -30.8658725433526
              ],
              [
                -52.14090706408822,
                -30.864379046242775
              ],
              [
                -52.14512363552821,
                -30.86518323699422
              ],
              [
                -52.147806908262744,
                -30.863976950867052
              ],
              [
                -52.150325898993124,
                -30.864321604046243
              ],
              [
                -52.1541043850887,
                -30.862426011560693
              ],
              [
                -52.15547340178999,
                -30.862885549132947
              ],
              [
                -52.15777334984817,
                -30.86012832369942
              ],
              [
                -52.15958045189388,
                -30.859094364161848
              ],
              [
                -52.16111375059933,
                -30.85622225433526
              ],
              [
                -52.16401606600607,
                -30.85432666184971
              ],
              [
                -52.16439939068243,
                -30.853177817919075
              ],
              [
                -52.16412558734218,
                -30.851511994219653
              ],
              [
                -52.1664802960684,
                -30.84892709537572
              ],
              [
                -52.1664802960684,
                -30.84789313583815
              ],
              [
                -52.16888976546268,
                -30.84530823699422
              ],
              [
                -52.16888976546268,
                -30.84341264450867
              ],
              [
                -52.17009450015982,
                -30.84278078034682
              ],
              [
                -52.16987545748761,
                -30.841000072254335
              ],
              [
                -52.17217540554579,
                -30.840310765895953
              ],
              [
                -52.17321585823877,
                -30.83927680635838
              ],
              [
                -52.17661101965798,
                -30.838874710982658
              ],
              [
                -52.178910967716156,
                -30.83761098265896
              ],
              [
                -52.17748719034681,
                -30.830373265895954
              ],
              [
                -52.17902048905226,
                -30.82870744219653
              ],
              [
                -52.178308600367586,
                -30.827903251445086
              ],
              [
                -52.178308600367586,
                -30.82457160404624
              ],
              [
                -52.17677530166214,
                -30.823997182080923
              ],
              [
                -52.17617293431357,
                -30.822905780346822
              ],
              [
                -52.177103865670446,
                -30.819401806358382
              ],
              [
                -52.17792527569122,
                -30.818597615606937
              ],
              [
                -52.17808955769538,
                -30.81589783236994
              ],
              [
                -52.178910967716156,
                -30.813485260115606
              ],
              [
                -52.17869192504395,
                -30.811474783236996
              ],
              [
                -52.179622856400826,
                -30.808889884393064
              ],
              [
                -52.182689453811726,
                -30.807281502890174
              ],
              [
                -52.183784667172766,
                -30.80619010115607
              ],
              [
                -52.18400370984497,
                -30.804524277456647
              ],
              [
                -52.182525171807576,
                -30.80337543352601
              ],
              [
                -52.1818132831229,
                -30.80182449421965
              ],
              [
                -52.18219660779926,
                -30.799584248554915
              ],
              [
                -52.1835108638325,
                -30.798090751445088
              ],
              [
                -52.18301801782004,
                -30.79717167630058
              ],
              [
                -52.1834013424964,
                -30.794873988439306
              ],
              [
                -52.18279897514783,
                -30.79372514450867
              ],
              [
                -52.1834013424964,
                -30.792576300578034
              ],
              [
                -52.18279897514783,
                -30.787693713872834
              ],
              [
                -52.183894188508866,
                -30.78407485549133
              ],
              [
                -52.1848798805338,
                -30.782121820809248
              ],
              [
                -52.18537272654627,
                -30.780111343930635
              ],
              [
                -52.1848798805338,
                -30.77901994219653
              ],
              [
                -52.182525171807576,
                -30.77672225433526
              ],
              [
                -52.177706233019016,
                -30.77379270231214
              ],
              [
                -52.183894188508866,
                -30.769484537572254
              ],
              [
                -52.18958929798625,
                -30.76419985549133
              ],
              [
                -52.19282017740131,
                -30.763625433526013
              ],
              [
                -52.19451775811091,
                -30.764601950867053
              ],
              [
                -52.19599629614831,
                -30.763395664739885
              ],
              [
                -52.19747483418571,
                -30.765693352601154
              ],
              [
                -52.199117654227265,
                -30.771207803468208
              ],
              [
                -52.204703242368545,
                -30.7740799132948
              ],
              [
                -52.20820792512386,
                -30.77712434971098
              ],
              [
                -52.21280782124021,
                -30.777813656069362
              ],
              [
                -52.21357447059293,
                -30.778905057803467
              ],
              [
                -52.21412207727345,
                -30.77448200867052
              ],
              [
                -52.213191145916575,
                -30.770116401734104
              ],
              [
                -52.20798888245165,
                -30.763108453757226
              ],
              [
                -52.208974574476585,
                -30.760121459537572
              ],
              [
                -52.20881029247243,
                -30.757594002890173
              ],
              [
                -52.21061739451814,
                -30.75558352601156
              ],
              [
                -52.21910529806616,
                -30.75460700867052
              ],
              [
                -52.22140524612434,
                -30.75558352601156
              ],
              [
                -52.22540277489212,
                -30.75558352601156
              ],
              [
                -52.22770272295029,
                -30.75747911849711
              ],
              [
                -52.22961934633211,
                -30.755813294797687
              ],
              [
                -52.232412140402744,
                -30.757421676300577
              ],
              [
                -52.23509541313729,
                -30.756617485549132
              ],
              [
                -52.24040719793831,
                -30.756617485549132
              ],
              [
                -52.24440472670609,
                -30.760293786127168
              ],
              [
                -52.24467853004634,
                -30.762017052023122
              ],
              [
                -52.24610230741569,
                -30.76477427745665
              ],
              [
                -52.2477998881253,
                -30.76557846820809
              ],
              [
                -52.24851177680997,
                -30.76718684971098
              ],
              [
                -52.245116615390764,
                -30.769599421965317
              ],
              [
                -52.24610230741569,
                -30.770518497109826
              ],
              [
                -52.2477998881253,
                -30.770575939306358
              ],
              [
                -52.24900462282244,
                -30.771782225433526
              ],
              [
                -52.25037363952373,
                -30.772011994219653
              ],
              [
                -52.25278310891801,
                -30.77350549132948
              ],
              [
                -52.25141409221671,
                -30.77511387283237
              ],
              [
                -52.25152361355282,
                -30.7776987716763
              ],
              [
                -52.25212598090139,
                -30.778790173410403
              ],
              [
                -52.25229026290555,
                -30.781317630057803
              ],
              [
                -52.25398784361515,
                -30.783328106936416
              ],
              [
                -52.25689015902189,
                -30.783902528901734
              ],
              [
                -52.256999680358,
                -30.785281141618498
              ],
              [
                -52.257985372382926,
                -30.785913005780348
              ],
              [
                -52.257273483698256,
                -30.789187210982657
              ],
              [
                -52.25760204770657,
                -30.79022117052023
              ],
              [
                -52.256123509669166,
                -30.79280606936416
              ],
              [
                -52.25891630373981,
                -30.794184682080925
              ],
              [
                -52.25831393639124,
                -30.796482369942197
              ],
              [
                -52.25929962841617,
                -30.798607731213874
              ],
              [
                -52.26077816645357,
                -30.798320520231215
              ],
              [
                -52.26258526849928,
                -30.79969913294798
              ],
              [
                -52.265323301901866,
                -30.79941192196532
              ],
              [
                -52.26680183993927,
                -30.798607731213874
              ],
              [
                -52.26740420728783,
                -30.796195158959538
              ],
              [
                -52.26921130933354,
                -30.79590794797688
              ],
              [
                -52.27030652269458,
                -30.794184682080925
              ],
              [
                -52.26877322398913,
                -30.793610260115607
              ],
              [
                -52.26921130933354,
                -30.788899999999998
              ],
              [
                -52.270689847370946,
                -30.787176734104047
              ],
              [
                -52.27309931676522,
                -30.78729161849711
              ],
              [
                -52.27468737613872,
                -30.784879046242775
              ],
              [
                -52.275673068163655,
                -30.782581358381503
              ],
              [
                -52.27490641881093,
                -30.780513439306358
              ],
              [
                -52.276220674844176,
                -30.7776987716763
              ],
              [
                -52.27611115350807,
                -30.776607369942198
              ],
              [
                -52.27830158023014,
                -30.774826661849712
              ],
              [
                -52.28010868227585,
                -30.774309682080926
              ],
              [
                -52.280601528288315,
                -30.773103395953758
              ],
              [
                -52.281806262985455,
                -30.77287362716763
              ],
              [
                -52.284215732379735,
                -30.771092919075144
              ],
              [
                -52.28388716837142,
                -30.77000151734104
              ],
              [
                -52.28591331308934,
                -30.766899638728322
              ],
              [
                -52.29018464519738,
                -30.765980563583813
              ],
              [
                -52.291717943902825,
                -30.764716835260117
              ],
              [
                -52.29259411459166,
                -30.763108453757226
              ],
              [
                -52.29308696060412,
                -30.76069588150289
              ],
              [
                -52.291717943902825,
                -30.757996098265895
              ],
              [
                -52.292210789915295,
                -30.75650260115607
              ],
              [
                -52.293579806616584,
                -30.755411199421964
              ],
              [
                -52.29379884928879,
                -30.753917702312137
              ],
              [
                -52.29489406264983,
                -30.75368793352601
              ],
              [
                -52.294784541313724,
                -30.751505130057804
              ],
              [
                -52.29571547267061,
                -30.74978186416185
              ],
              [
                -52.29757733538437,
                -30.748116040462428
              ],
              [
                -52.300315368786954,
                -30.746392774566473
              ],
              [
                -52.302122470832664,
                -30.74599067919075
              ],
              [
                -52.30420337621863,
                -30.743520664739883
              ],
              [
                -52.30529858957967,
                -30.743176011560692
              ],
              [
                -52.306393802940704,
                -30.740303901734105
              ],
              [
                -52.30601047826434,
                -30.73949971098266
              ],
              [
                -52.30792710164616,
                -30.73829342485549
              ],
              [
                -52.310774656384844,
                -30.738408309248555
              ],
              [
                -52.310719895716794,
                -30.73697225433526
              ],
              [
                -52.311924630413934,
                -30.734674566473988
              ],
              [
                -52.31570311650951,
                -30.733008742774565
              ],
              [
                -52.31630548385807,
                -30.731974783236993
              ],
              [
                -52.31570311650951,
                -30.730021748554915
              ],
              [
                -52.31761973989132,
                -30.728183598265897
              ],
              [
                -52.31460790314847,
                -30.72479450867052
              ],
              [
                -52.31510074916094,
                -30.723990317919075
              ],
              [
                -52.31751021855521,
                -30.723128684971098
              ],
              [
                -52.31767450055937,
                -30.72129053468208
              ],
              [
                -52.31997444861754,
                -30.718820520231212
              ],
              [
                -52.32287676402429,
                -30.716982369942198
              ],
              [
                -52.324683866069996,
                -30.714627239884393
              ],
              [
                -52.32928376218635,
                -30.71388049132948
              ],
              [
                -52.33601932435672,
                -30.71359328034682
              ],
              [
                -52.33788118707048,
                -30.712789089595375
              ],
              [
                -52.33859307575515,
                -30.7119274566474
              ],
              [
                -52.341221587821636,
                -30.71100838150289
              ],
              [
                -52.34220727984657,
                -30.7045174132948
              ],
              [
                -52.33667645237334,
                -30.6981987716763
              ],
              [
                -52.33601932435672,
                -30.69210989884393
              ],
              [
                -52.33519791433594,
                -30.688203829479768
              ],
              [
                -52.33590980302061,
                -30.687227312138727
              ],
              [
                -52.33711453771775,
                -30.687227312138727
              ],
              [
                -52.33859307575515,
                -30.68860592485549
              ],
              [
                -52.33968828911619,
                -30.687514523121386
              ],
              [
                -52.340016853124496,
                -30.68538916184971
              ],
              [
                -52.33897640043151,
                -30.683780780346822
              ],
              [
                -52.33662169170529,
                -30.682574494219654
              ],
              [
                -52.33640264903308,
                -30.681023554913295
              ],
              [
                -52.342973929199296,
                -30.67861098265896
              ],
              [
                -52.341604912498,
                -30.676313294797687
              ],
              [
                -52.34439770656864,
                -30.671603034682082
              ],
              [
                -52.34198823717436,
                -30.66959255780347
              ],
              [
                -52.340509699136966,
                -30.666892774566474
              ],
              [
                -52.340016853124496,
                -30.66201018786127
              ],
              [
                -52.34089302381333,
                -30.658506213872833
              ],
              [
                -52.33892163976346,
                -30.65368106936416
              ],
              [
                -52.341878715838256,
                -30.64810917630058
              ],
              [
                -52.34412390322838,
                -30.64810917630058
              ],
              [
                -52.344178663896436,
                -30.646385910404625
              ],
              [
                -52.3433024932076,
                -30.64460520231214
              ],
              [
                -52.34439770656864,
                -30.64150332369942
              ],
              [
                -52.34379533922007,
                -30.64018215317919
              ],
              [
                -52.34220727984657,
                -30.640297037572253
              ],
              [
                -52.34067398114112,
                -30.63897586705202
              ],
              [
                -52.34209775851047,
                -30.63771213872832
              ],
              [
                -52.345492919929676,
                -30.637424927745663
              ],
              [
                -52.34642385128656,
                -30.635816546242776
              ],
              [
                -52.34560244126578,
                -30.633806069364162
              ],
              [
                -52.34270012585903,
                -30.632599783236994
              ],
              [
                -52.342316801182676,
                -30.630991401734104
              ],
              [
                -52.34341201454371,
                -30.629383020231213
              ],
              [
                -52.34587624460604,
                -30.628119291907513
              ],
              [
                -52.345985765942146,
                -30.626913005780345
              ],
              [
                -52.349819012705765,
                -30.625419508670518
              ],
              [
                -52.35480223349848,
                -30.626510910404622
              ],
              [
                -52.354692712162375,
                -30.624500433526013
              ],
              [
                -52.35639029287198,
                -30.622087861271677
              ],
              [
                -52.355897446859515,
                -30.6212262283237
              ],
              [
                -52.356499814208085,
                -30.619215751445086
              ],
              [
                -52.35622601086783,
                -30.61588410404624
              ],
              [
                -52.357814070241325,
                -30.612092919075145
              ],
              [
                -52.36060686431197,
                -30.609508020231214
              ],
              [
                -52.36252348769378,
                -30.60847406069364
              ],
              [
                -52.36219492368547,
                -30.606004046242774
              ],
              [
                -52.36619245245325,
                -30.60870382947977
              ],
              [
                -52.36838287917532,
                -30.60910592485549
              ],
              [
                -52.36980665654467,
                -30.608301734104046
              ],
              [
                -52.36969713520856,
                -30.60680823699422
              ],
              [
                -52.36799955449896,
                -30.60652102601156
              ],
              [
                -52.36909476785999,
                -30.60428078034682
              ],
              [
                -52.36838287917532,
                -30.60330426300578
              ],
              [
                -52.3692042891961,
                -30.602212861271674
              ],
              [
                -52.370573305897395,
                -30.602787283236992
              ],
              [
                -52.374406552661014,
                -30.602787283236992
              ],
              [
                -52.37599461203452,
                -30.605314739884392
              ],
              [
                -52.37938977345373,
                -30.604108453757224
              ],
              [
                -52.379773098130094,
                -30.605774277456646
              ],
              [
                -52.380977832827234,
                -30.605716835260115
              ],
              [
                -52.38130639683554,
                -30.604108453757224
              ],
              [
                -52.38070402948697,
                -30.60238518786127
              ],
              [
                -52.38152543950775,
                -30.60169588150289
              ],
              [
                -52.38398966957008,
                -30.601523554913296
              ],
              [
                -52.38492060092696,
                -30.600604479768787
              ],
              [
                -52.385413446939424,
                -30.598306791907515
              ],
              [
                -52.38809671967396,
                -30.597100505780347
              ],
              [
                -52.39001334305578,
                -30.596985621387283
              ],
              [
                -52.39160140242927,
                -30.598306791907515
              ],
              [
                -52.39318946180278,
                -30.598077023121387
              ],
              [
                -52.39280613712641,
                -30.596698410404624
              ],
              [
                -52.395106085184594,
                -30.596181430635838
              ],
              [
                -52.396310819881734,
                -30.595377239884392
              ],
              [
                -52.39959645996484,
                -30.596009104046242
              ],
              [
                -52.39921313528848,
                -30.593883742774565
              ],
              [
                -52.40041786998562,
                -30.592620014450866
              ],
              [
                -52.40189640802301,
                -30.59342420520231
              ],
              [
                -52.40370351006872,
                -30.593194436416184
              ],
              [
                -52.40457968075755,
                -30.592275361271675
              ],
              [
                -52.40540109077833,
                -30.590207442196533
              ],
              [
                -52.40660582547547,
                -30.589690462427747
              ],
              [
                -52.40868673086143,
                -30.59009255780347
              ],
              [
                -52.41011050823078,
                -30.58819696531792
              ],
              [
                -52.410384311571036,
                -30.586416257225434
              ],
              [
                -52.412793780965316,
                -30.584578106936416
              ],
              [
                -52.414108036998556,
                -30.58440578034682
              ],
              [
                -52.4154222930318,
                -30.585726950867052
              ],
              [
                -52.419584103803736,
                -30.587392774566474
              ],
              [
                -52.42051503516062,
                -30.58658858381503
              ],
              [
                -52.41991266781205,
                -30.58411856936416
              ],
              [
                -52.42150072718555,
                -30.582280419075143
              ],
              [
                -52.423198307895156,
                -30.583027167630057
              ],
              [
                -52.4261006233019,
                -30.582682514450866
              ],
              [
                -52.42708631532683,
                -30.581476228323698
              ],
              [
                -52.429386263385005,
                -30.581993208092484
              ],
              [
                -52.43031719474189,
                -30.581418786127166
              ],
              [
                -52.43020767340578,
                -30.57992528901734
              ],
              [
                -52.431193365430715,
                -30.578316907514452
              ],
              [
                -52.43321951014863,
                -30.577685043352602
              ],
              [
                -52.433000467476425,
                -30.576421315028902
              ],
              [
                -52.43398615950136,
                -30.574583164739884
              ],
              [
                -52.44088600367588,
                -30.57412362716763
              ],
              [
                -52.44630730981301,
                -30.576823410404625
              ],
              [
                -52.44910010388365,
                -30.576593641618498
              ],
              [
                -52.45068816325715,
                -30.57728294797688
              ],
              [
                -52.4522214619626,
                -30.577110621387284
              ],
              [
                -52.45282382931117,
                -30.57601921965318
              ],
              [
                -52.452714307975064,
                -30.570791979768785
              ],
              [
                -52.449592949896115,
                -30.56602427745665
              ],
              [
                -52.449702471232214,
                -30.564415895953758
              ],
              [
                -52.45118100926962,
                -30.563611705202312
              ],
              [
                -52.4537,
                -30.56068215317919
              ],
              [
                -52.451400051941825,
                -30.558327023121386
              ],
              [
                -52.44948342856001,
                -30.55551235549133
              ],
              [
                -52.44570494246444,
                -30.555627239884394
              ],
              [
                -52.444774011107555,
                -30.55390397398844
              ],
              [
                -52.44329547307016,
                -30.553099783236995
              ],
              [
                -52.43962650831069,
                -30.55447839595376
              ],
              [
                -52.43781940626498,
                -30.554708164739885
              ],
              [
                -52.434807569522135,
                -30.55660375722543
              ],
              [
                -52.43278142480422,
                -30.55488049132948
              ],
              [
                -52.430481476746046,
                -30.55488049132948
              ],
              [
                -52.427579161339295,
                -30.55108930635838
              ],
              [
                -52.42582681996164,
                -30.551893497109827
              ],
              [
                -52.421391205849446,
                -30.550285115606936
              ],
              [
                -52.418379369106596,
                -30.547987427745664
              ],
              [
                -52.421281684513346,
                -30.544885549132946
              ],
              [
                -52.42429352125619,
                -30.54327716763006
              ],
              [
                -52.423800675243726,
                -30.54201343930636
              ],
              [
                -52.424512563928396,
                -30.539600867052023
              ],
              [
                -52.422595940546586,
                -30.53850946531792
              ],
              [
                -52.42308878655905,
                -30.536096893063583
              ],
              [
                -52.42171976985776,
                -30.533224783236992
              ],
              [
                -52.42122692384529,
                -30.530295231213874
              ],
              [
                -52.419474582467636,
                -30.528399638728324
              ],
              [
                -52.415203250359596,
                -30.529778251445087
              ],
              [
                -52.414108036998556,
                -30.527480563583815
              ],
              [
                -52.4154222930318,
                -30.524608453757224
              ],
              [
                -52.41481992568323,
                -30.522483092485547
              ],
              [
                -52.409781944222466,
                -30.519208887283238
              ],
              [
                -52.4062225007991,
                -30.514326300578034
              ],
              [
                -52.40457968075755,
                -30.513981647398843
              ],
              [
                -52.40310114272015,
                -30.51541770231214
              ],
              [
                -52.40167736535081,
                -30.51541770231214
              ],
              [
                -52.40151308334665,
                -30.513694436416184
              ],
              [
                -52.39992502397315,
                -30.511913728323698
              ],
              [
                -52.39932265662458,
                -30.510190462427744
              ],
              [
                -52.39811792192744,
                -30.508524638728325
              ],
              [
                -52.39800840059134,
                -30.50737579479769
              ],
              [
                -52.4000893059773,
                -30.50708858381503
              ],
              [
                -52.40129404067444,
                -30.509213945086707
              ],
              [
                -52.40271781804379,
                -30.509213945086707
              ],
              [
                -52.40468920209365,
                -30.50680137283237
              ],
              [
                -52.40271781804379,
                -30.50490578034682
              ],
              [
                -52.40282733937989,
                -30.50232088150289
              ],
              [
                -52.39992502397315,
                -30.499678540462426
              ],
              [
                -52.39921313528848,
                -30.495312933526012
              ],
              [
                -52.40091071599808,
                -30.49272803468208
              ],
              [
                -52.40337494606041,
                -30.492785476878613
              ],
              [
                -52.40441539875339,
                -30.49209617052023
              ],
              [
                -52.40441539875339,
                -30.489683598265895
              ],
              [
                -52.40490824476586,
                -30.488477312138727
              ],
              [
                -52.40441539875339,
                -30.486926372832368
              ],
              [
                -52.40457968075755,
                -30.48468612716763
              ],
              [
                -52.40359398873262,
                -30.48399682080925
              ],
              [
                -52.40167736535081,
                -30.48428403179191
              ],
              [
                -52.39729651190666,
                -30.48279053468208
              ],
              [
                -52.39477752117628,
                -30.482675650289018
              ],
              [
                -52.39121807775292,
                -30.481584248554913
              ],
              [
                -52.390889513744604,
                -30.48049284682081
              ],
              [
                -52.39302517979862,
                -30.47802283236994
              ],
              [
                -52.39050618906824,
                -30.476012355491328
              ],
              [
                -52.389575257711364,
                -30.471589306358382
              ],
              [
                -52.38639913896436,
                -30.47210628612717
              ],
              [
                -52.38557772894358,
                -30.47118721098266
              ],
              [
                -52.386672942304614,
                -30.470095809248555
              ],
              [
                -52.3861253356241,
                -30.46871719653179
              ],
              [
                -52.38218256752437,
                -30.466304624277456
              ],
              [
                -52.380977832827234,
                -30.464983453757224
              ],
              [
                -52.37960881612594,
                -30.465672760115606
              ],
              [
                -52.378677884769054,
                -30.463087861271674
              ],
              [
                -52.37342086063609,
                -30.459411560693642
              ],
              [
                -52.37270897195141,
                -30.456711777456647
              ],
              [
                -52.37539224468595,
                -30.45521828034682
              ],
              [
                -52.375008920009584,
                -30.451599421965316
              ],
              [
                -52.37221612593895,
                -30.451312210982657
              ],
              [
                -52.368875725187785,
                -30.453724783236993
              ],
              [
                -52.3677257511587,
                -30.451312210982657
              ],
              [
                -52.36548056376858,
                -30.450910115606938
              ],
              [
                -52.36301633370625,
                -30.44941661849711
              ],
              [
                -52.360716385648075,
                -30.446084971098266
              ],
              [
                -52.361702077673,
                -30.44212145953757
              ],
              [
                -52.36120923166054,
                -30.440685404624276
              ],
              [
                -52.356609335544185,
                -30.44022586705202
              ],
              [
                -52.35567840418731,
                -30.43919190751445
              ],
              [
                -52.354692712162375,
                -30.432586054913294
              ],
              [
                -52.35359749880134,
                -30.432298843930635
              ],
              [
                -52.35179039675563,
                -30.43471141618497
              ],
              [
                -52.35058566205849,
                -30.435228395953757
              ],
              [
                -52.34949044869746,
                -30.434481647398844
              ],
              [
                -52.348011910660055,
                -30.43092023121387
              ],
              [
                -52.34872379934473,
                -30.429082080924854
              ],
              [
                -52.350914226066806,
                -30.428794869942195
              ],
              [
                -52.353487977465235,
                -30.423222976878613
              ],
              [
                -52.3506951833946,
                -30.417995736994218
              ],
              [
                -52.35179039675563,
                -30.416215028901732
              ],
              [
                -52.351680875419525,
                -30.41472153179191
              ],
              [
                -52.35359749880134,
                -30.413113150289018
              ],
              [
                -52.35261180677641,
                -30.412481286127168
              ],
              [
                -52.350476140722385,
                -30.407024277456646
              ],
              [
                -52.34828571400032,
                -30.404611705202313
              ],
              [
                -52.34839523533642,
                -30.402773554913296
              ],
              [
                -52.3508047047307,
                -30.40191192196532
              ],
              [
                -52.35562364351926,
                -30.403118208092486
              ],
              [
                -52.35792359157743,
                -30.402773554913296
              ],
              [
                -52.3600044969634,
                -30.400820520231214
              ],
              [
                -52.360716385648075,
                -30.39909725433526
              ],
              [
                -52.358909283602365,
                -30.39559328034682
              ],
              [
                -52.35858071959405,
                -30.392089306358383
              ],
              [
                -52.35622601086783,
                -30.39071069364162
              ],
              [
                -52.35392606280965,
                -30.391227673410405
              ],
              [
                -52.351023747402905,
                -30.39007882947977
              ],
              [
                -52.35189991809173,
                -30.387493930635838
              ],
              [
                -52.351516593415376,
                -30.385483453757224
              ],
              [
                -52.35419986614991,
                -30.382898554913293
              ],
              [
                -52.355897446859515,
                -30.379107369942197
              ],
              [
                -52.35480223349848,
                -30.378303179190752
              ],
              [
                -52.35430938748601,
                -30.374282225433525
              ],
              [
                -52.351078508070955,
                -30.371812210982657
              ],
              [
                -52.34899760268499,
                -30.367504046242775
              ],
              [
                -52.34642385128656,
                -30.3653786849711
              ],
              [
                -52.346095287278246,
                -30.361874710982658
              ],
              [
                -52.342919168531246,
                -30.359002601156067
              ],
              [
                -52.3414953911619,
                -30.35848562138728
              ],
              [
                -52.333883658302696,
                -30.359806791907513
              ],
              [
                -52.324081498721426,
                -30.356302817919076
              ],
              [
                -52.31942684193703,
                -30.346709971098264
              ],
              [
                -52.316195962521974,
                -30.34429739884393
              ],
              [
                -52.31411505713601,
                -30.34332088150289
              ],
              [
                -52.30672236694902,
                -30.344814378612718
              ],
              [
                -52.30431289755474,
                -30.344412283236995
              ],
              [
                -52.30382005154227,
                -30.341827384393063
              ],
              [
                -52.30551763225188,
                -30.3391850433526
              ],
              [
                -52.30562715358798,
                -30.336772471098264
              ],
              [
                -52.299603480102284,
                -30.33401524566474
              ],
              [
                -52.297796378056574,
                -30.33849573699422
              ],
              [
                -52.29790589939268,
                -30.342286921965318
              ],
              [
                -52.294182173965154,
                -30.345388800578036
              ],
              [
                -52.29029416653348,
                -30.347112066473986
              ],
              [
                -52.28870610715998,
                -30.35641770231214
              ],
              [
                -52.28580379175323,
                -30.359289812138726
              ],
              [
                -52.284818099728305,
                -30.3615875
              ],
              [
                -52.28098485296468,
                -30.363023554913294
              ],
              [
                -52.28142293830909,
                -30.36480426300578
              ],
              [
                -52.277589691545465,
                -30.368078468208093
              ],
              [
                -52.27309931676522,
                -30.368825216763007
              ],
              [
                -52.26877322398913,
                -30.36888265895954
              ],
              [
                -52.267623249960046,
                -30.369801734104044
              ],
              [
                -52.265925669250436,
                -30.373018497109825
              ],
              [
                -52.26368048186031,
                -30.37347803468208
              ],
              [
                -52.26121625179798,
                -30.382726228323698
              ],
              [
                -52.264009045868626,
                -30.384506936416184
              ],
              [
                -52.26477569522135,
                -30.386115317919074
              ],
              [
                -52.26258526849928,
                -30.387321604046242
              ],
              [
                -52.26181861914655,
                -30.3888725433526
              ],
              [
                -52.26389952453252,
                -30.392721170520232
              ],
              [
                -52.26379000319642,
                -30.39461676300578
              ],
              [
                -52.26132577313409,
                -30.396397471098265
              ],
              [
                -52.256725877017736,
                -30.402716112716764
              ],
              [
                -52.2588067824037,
                -30.406277528901732
              ],
              [
                -52.258478218395396,
                -30.407598699421964
              ],
              [
                -52.256013988333066,
                -30.408804985549132
              ],
              [
                -52.251195049544506,
                -30.413400361271677
              ],
              [
                -52.25250930557775,
                -30.416617124277455
              ],
              [
                -52.25218074156944,
                -30.417995736994218
              ],
              [
                -52.24380235935752,
                -30.420982731213872
              ],
              [
                -52.239585787917534,
                -30.42310809248555
              ],
              [
                -52.23580730182196,
                -30.426209971098267
              ],
              [
                -52.232904986415214,
                -30.427014161849712
              ],
              [
                -52.234821609797024,
                -30.43339024566474
              ],
              [
                -52.23389067844015,
                -30.43597514450867
              ],
              [
                -52.23197405505833,
                -30.437123988439307
              ],
              [
                -52.22890745764743,
                -30.436090028901734
              ],
              [
                -52.227921765622504,
                -30.436377239884393
              ],
              [
                -52.22288378416174,
                -30.44022586705202
              ],
              [
                -52.220583836103565,
                -30.445108453757225
              ],
              [
                -52.21910529806616,
                -30.446084971098266
              ],
              [
                -52.21280782124021,
                -30.44780823699422
              ],
              [
                -52.20848172846412,
                -30.446716835260116
              ],
              [
                -52.20640082307815,
                -30.44522333815029
              ],
              [
                -52.203388986335305,
                -30.447406141618497
              ],
              [
                -52.199774782243885,
                -30.447406141618497
              ],
              [
                -52.197912919530125,
                -30.446027528901734
              ],
              [
                -52.194189194102606,
                -30.44619985549133
              ],
              [
                -52.191724964040276,
                -30.44522333815029
              ],
              [
                -52.188110759948856,
                -30.445510549132948
              ],
              [
                -52.18548224788237,
                -30.44872731213873
              ],
              [
                -52.183894188508866,
                -30.44907196531792
              ],
              [
                -52.18219660779926,
                -30.44780823699422
              ],
              [
                -52.17902048905226,
                -30.447004046242775
              ],
              [
                -52.17732290834265,
                -30.445108453757225
              ],
              [
                -52.17212064487774,
                -30.442580997109825
              ],
              [
                -52.16938261147514,
                -30.442006575144507
              ],
              [
                -52.16379702333386,
                -30.44430426300578
              ],
              [
                -52.15870428120505,
                -30.44269588150289
              ],
              [
                -52.16270180997283,
                -30.434194436416185
              ],
              [
                -52.16390654466997,
                -30.429426734104045
              ],
              [
                -52.16888976546268,
                -30.426095086705203
              ],
              [
                -52.17020402149592,
                -30.423222976878613
              ],
              [
                -52.17359918291513,
                -30.42149971098266
              ],
              [
                -52.17562532763305,
                -30.4138024566474
              ],
              [
                -52.17507772095253,
                -30.412998265895954
              ],
              [
                -52.17540628496084,
                -30.410585693641618
              ],
              [
                -52.17442059293591,
                -30.408288005780346
              ],
              [
                -52.17672054099408,
                -30.40449682080925
              ],
              [
                -52.17858240370784,
                -30.40317565028902
              ],
              [
                -52.17858240370784,
                -30.40168215317919
              ],
              [
                -52.17699434433435,
                -30.399499349710982
              ],
              [
                -52.17880144638005,
                -30.39691445086705
              ],
              [
                -52.17798003635927,
                -30.392893497109824
              ],
              [
                -52.179513335064726,
                -30.392721170520232
              ],
              [
                -52.18027998441745,
                -30.3914
              ],
              [
                -52.178910967716156,
                -30.389619291907515
              ],
              [
                -52.17978713840498,
                -30.386402528901733
              ],
              [
                -52.17869192504395,
                -30.384909031791906
              ],
              [
                -52.17798003635927,
                -30.37818829479769
              ],
              [
                -52.177103865670446,
                -30.37692456647399
              ],
              [
                -52.17502296028448,
                -30.376809682080925
              ],
              [
                -52.171025431516696,
                -30.370491040462426
              ],
              [
                -52.17201112354163,
                -30.363425650289017
              ],
              [
                -52.16658981740451,
                -30.360898193641617
              ],
              [
                -52.16560412537957,
                -30.355096531791908
              ],
              [
                -52.16357798066166,
                -30.35009906069364
              ],
              [
                -52.16412558734218,
                -30.3465950867052
              ],
              [
                -52.16198992128815,
                -30.345101589595377
              ],
              [
                -52.158923323877254,
                -30.3455036849711
              ],
              [
                -52.15848523853284,
                -30.342918786127168
              ],
              [
                -52.160073297906344,
                -30.341195520231214
              ],
              [
                -52.15930664855362,
                -30.33912760115607
              ],
              [
                -52.16018281924244,
                -30.337806430635837
              ],
              [
                -52.15350201774013,
                -30.334589667630055
              ],
              [
                -52.15350201774013,
                -30.333785476878614
              ],
              [
                -52.15799239252038,
                -30.330396387283237
              ],
              [
                -52.15870428120505,
                -30.325801011560692
              ],
              [
                -52.160073297906344,
                -30.32539891618497
              ],
              [
                -52.16319465598529,
                -30.32218215317919
              ],
              [
                -52.15870428120505,
                -30.316610260115606
              ],
              [
                -52.16270180997283,
                -30.31350838150289
              ],
              [
                -52.16560412537957,
                -30.31322117052023
              ],
              [
                -52.16730170608918,
                -30.310693713872833
              ],
              [
                -52.16450891201854,
                -30.30931510115607
              ],
              [
                -52.1647827153588,
                -30.306615317919075
              ],
              [
                -52.16719218475308,
                -30.306615317919075
              ],
              [
                -52.16938261147514,
                -30.30799393063584
              ],
              [
                -52.17108019218475,
                -30.30707485549133
              ],
              [
                -52.17140875619306,
                -30.299607369942194
              ],
              [
                -52.1726134908902,
                -30.295701300578035
              ],
              [
                -52.17042306416813,
                -30.292771748554912
              ],
              [
                -52.17179208086942,
                -30.291622904624276
              ],
              [
                -52.17299681556656,
                -30.28857846820809
              ],
              [
                -52.17069686750839,
                -30.284097976878613
              ],
              [
                -52.17332537957488,
                -30.281283309248554
              ],
              [
                -52.174694396276166,
                -30.28088121387283
              ],
              [
                -52.177103865670446,
                -30.276917702312137
              ],
              [
                -52.17600865230941,
                -30.275194436416186
              ],
              [
                -52.17288729423046,
                -30.277204913294796
              ],
              [
                -52.17042306416813,
                -30.273988150289018
              ],
              [
                -52.16921832947099,
                -30.273988150289018
              ],
              [
                -52.16768503076554,
                -30.27530932080925
              ],
              [
                -52.16598745005594,
                -30.274792341040463
              ],
              [
                -52.16642553540035,
                -30.271690462427745
              ],
              [
                -52.165001758031,
                -30.265371820809246
              ],
              [
                -52.16571364671567,
                -30.26318901734104
              ],
              [
                -52.16418034801023,
                -30.261810404624278
              ],
              [
                -52.16560412537957,
                -30.25939783236994
              ],
              [
                -52.16527556137126,
                -30.258191546242774
              ],
              [
                -52.1664802960684,
                -30.255376878612715
              ],
              [
                -52.16560412537957,
                -30.25428547687861
              ],
              [
                -52.16439939068243,
                -30.254113150289015
              ],
              [
                -52.160073297906344,
                -30.255376878612715
              ],
              [
                -52.158923323877254,
                -30.25428547687861
              ],
              [
                -52.159416169889724,
                -30.25060917630058
              ],
              [
                -52.15607576913856,
                -30.247622182080924
              ],
              [
                -52.152023479702734,
                -30.246703106936415
              ],
              [
                -52.15191395836663,
                -30.242222615606934
              ],
              [
                -52.146492652229504,
                -30.240327023121388
              ],
              [
                -52.145397438868464,
                -30.236478395953757
              ],
              [
                -52.141126106760424,
                -30.232514884393062
              ],
              [
                -52.13899044070641,
                -30.23211278901734
              ],
              [
                -52.13849759469394,
                -30.231423482658958
              ],
              [
                -52.138607116030045,
                -30.22918323699422
              ],
              [
                -52.13630716797187,
                -30.22757485549133
              ],
              [
                -52.13701905665654,
                -30.2211987716763
              ],
              [
                -52.13597860396356,
                -30.217177817919076
              ],
              [
                -52.13997613273134,
                -30.2137887283237
              ],
              [
                -52.15432342776091,
                -30.210514523121386
              ],
              [
                -52.15749954650791,
                -30.207010549132946
              ],
              [
                -52.160675665254914,
                -30.205689378612718
              ],
              [
                -52.16138755393958,
                -30.205000072254336
              ],
              [
                -52.16100422926322,
                -30.202472615606936
              ],
              [
                -52.16292085264504,
                -30.199600505780346
              ],
              [
                -52.16209944262426,
                -30.19690072254335
              ],
              [
                -52.158813802541154,
                -30.191271387283237
              ],
              [
                -52.15810191385648,
                -30.1901225433526
              ],
              [
                -52.16100422926322,
                -30.18328692196532
              ],
              [
                -52.15919712721752,
                -30.180012716763006
              ],
              [
                -52.15377582108039,
                -30.177485260115606
              ],
              [
                -52.152187761706884,
                -30.17599176300578
              ],
              [
                -52.151585394358314,
                -30.174325939306357
              ],
              [
                -52.15180443703052,
                -30.16921358381503
              ],
              [
                -52.148080711603,
                -30.16697333815029
              ],
              [
                -52.14868307895157,
                -30.164388439306357
              ],
              [
                -52.14802595093495,
                -30.162377962427744
              ],
              [
                -52.151585394358314,
                -30.159793063583813
              ],
              [
                -52.152625847051304,
                -30.15772514450867
              ],
              [
                -52.152625847051304,
                -30.1554274566474
              ],
              [
                -52.15109254834585,
                -30.15232557803468
              ],
              [
                -52.15311869306377,
                -30.14807485549133
              ],
              [
                -52.15240680437909,
                -30.14612182080925
              ],
              [
                -52.15739002517181,
                -30.138998988439305
              ],
              [
                -52.15777334984817,
                -30.136471531791905
              ],
              [
                -52.16560412537957,
                -30.130382658959537
              ],
              [
                -52.16960165414735,
                -30.125500072254333
              ],
              [
                -52.16888976546268,
                -30.122627962427746
              ],
              [
                -52.16938261147514,
                -30.120100505780346
              ],
              [
                -52.16571364671567,
                -30.116826300578033
              ],
              [
                -52.1664802960684,
                -30.114988150289015
              ],
              [
                -52.16631601406424,
                -30.108497182080924
              ],
              [
                -52.16439939068243,
                -30.10648670520231
              ],
              [
                -52.160018537238294,
                -30.105395303468207
              ],
              [
                -52.15859475986895,
                -30.10269552023121
              ],
              [
                -52.1634136986575,
                -30.095802456647398
              ],
              [
                -52.16620649272814,
                -30.093504768786126
              ],
              [
                -52.16587792871983,
                -30.089311488439307
              ],
              [
                -52.16379702333386,
                -30.085520303468208
              ],
              [
                -52.16587792871983,
                -30.082877962427744
              ],
              [
                -52.165001758031,
                -30.077018858381503
              ],
              [
                -52.16379702333386,
                -30.07558280346821
              ],
              [
                -52.16160659661179,
                -30.07472117052023
              ],
              [
                -52.161880399952054,
                -30.07311278901734
              ],
              [
                -52.16089470792712,
                -30.07219371387283
              ],
              [
                -52.16281133130893,
                -30.06627716763006
              ],
              [
                -52.15979949456609,
                -30.062715751445086
              ],
              [
                -52.15591148713441,
                -30.06191156069364
              ],
              [
                -52.15591148713441,
                -30.05869479768786
              ],
              [
                -52.15530911978584,
                -30.057201300578033
              ],
              [
                -52.153885342416494,
                -30.056626878612715
              ],
              [
                -52.1525163257152,
                -30.053525
              ],
              [
                -52.15229728304299,
                -30.050078468208092
              ],
              [
                -52.153392496404024,
                -30.043817268786125
              ],
              [
                -52.15038065966118,
                -30.03847514450867
              ],
              [
                -52.153282975067924,
                -30.032386271676298
              ],
              [
                -52.15377582108039,
                -30.02848020231214
              ],
              [
                -52.15311869306377,
                -30.027101589595375
              ],
              [
                -52.14939496763625,
                -30.025205997109826
              ],
              [
                -52.14627360955729,
                -30.02032341040462
              ],
              [
                -52.14698549824197,
                -30.01699176300578
              ],
              [
                -52.145999806217034,
                -30.014579190751444
              ],
              [
                -52.150818745005594,
                -30.009294508670518
              ],
              [
                -52.15070922366949,
                -30.004297037572254
              ],
              [
                -52.14868307895157,
                -30.002975867052022
              ],
              [
                -52.150325898993124,
                -29.999471893063582
              ],
              [
                -52.15109254834585,
                -29.993727673410405
              ],
              [
                -52.153392496404024,
                -29.988902528901733
              ],
              [
                -52.152790129055454,
                -29.987006936416183
              ],
              [
                -52.153994863752594,
                -29.98361784682081
              ],
              [
                -52.15300917172766,
                -29.982296676300578
              ],
              [
                -52.15289965039156,
                -29.97948200867052
              ],
              [
                -52.153392496404024,
                -29.97821828034682
              ],
              [
                -52.15498055577753,
                -29.97729920520231
              ],
              [
                -52.15432342776091,
                -29.97597803468208
              ],
              [
                -52.152625847051304,
                -29.97442709537572
              ],
              [
                -52.150325898993124,
                -29.96960195086705
              ],
              [
                -52.150216377657024,
                -29.96609797687861
              ],
              [
                -52.148518796947414,
                -29.963685404624275
              ],
              [
                -52.149614010308454,
                -29.960009104046243
              ],
              [
                -52.14709501957807,
                -29.954379768786126
              ],
              [
                -52.14802595093495,
                -29.951507658959535
              ],
              [
                -52.13937376538277,
                -29.939387355491327
              ],
              [
                -52.134992911938625,
                -29.937204552023122
              ],
              [
                -52.12677881173086,
                -29.937606647398844
              ],
              [
                -52.111500585344416,
                -29.94518901734104
              ],
              [
                -52.106791167891956,
                -29.94679739884393
              ],
              [
                -52.10460074116989,
                -29.945591112716762
              ],
              [
                -52.11051489331948,
                -29.93461965317919
              ],
              [
                -52.113417208726226,
                -29.932494291907513
              ],
              [
                -52.12097418091737,
                -29.931575216763004
              ],
              [
                -52.12891447778488,
                -29.927094725433527
              ],
              [
                -52.14057850007991,
                -29.924797037572255
              ],
              [
                -52.15311869306377,
                -29.927496820809246
              ],
              [
                -52.15651385448298,
                -29.926922398843928
              ],
              [
                -52.16089470792712,
                -29.92761170520231
              ],
              [
                -52.1664802960684,
                -29.929277528901732
              ],
              [
                -52.17228492688189,
                -29.93329848265896
              ],
              [
                -52.17518724228864,
                -29.932494291907513
              ],
              [
                -52.17989665974109,
                -29.933413367052022
              ],
              [
                -52.18520844454211,
                -29.929392413294796
              ],
              [
                -52.18668698257951,
                -29.930311488439305
              ],
              [
                -52.190574990011186,
                -29.923303540462427
              ],
              [
                -52.1910130753556,
                -29.917501878612715
              ],
              [
                -52.19380586942624,
                -29.917501878612715
              ],
              [
                -52.195393928799746,
                -29.91371069364162
              ],
              [
                -52.194189194102606,
                -29.908483453757224
              ],
              [
                -52.195503450135845,
                -29.904002962427747
              ],
              [
                -52.192382092056896,
                -29.899292702312138
              ],
              [
                -52.19440823677481,
                -29.89682268786127
              ],
              [
                -52.19342254474988,
                -29.88969985549133
              ],
              [
                -52.19008214399872,
                -29.885678901734103
              ],
              [
                -52.18701554658782,
                -29.88498959537572
              ],
              [
                -52.18608461523094,
                -29.884127962427744
              ],
              [
                -52.18422275251718,
                -29.87941770231214
              ],
              [
                -52.184496555857436,
                -29.877407225433526
              ],
              [
                -52.18728934992808,
                -29.87309906069364
              ],
              [
                -52.18761791393639,
                -29.87217998554913
              ],
              [
                -52.186303657903146,
                -29.870399277456645
              ],
              [
                -52.18789171727665,
                -29.868503684971095
              ],
              [
                -52.186796503915616,
                -29.86568901734104
              ],
              [
                -52.1848798805338,
                -29.864195520231213
              ],
              [
                -52.18849408462522,
                -29.861782947976877
              ],
              [
                -52.18849408462522,
                -29.860806430635837
              ],
              [
                -52.18652270057535,
                -29.859083164739882
              ],
              [
                -52.18668698257951,
                -29.852707080924855
              ],
              [
                -52.18290849648394,
                -29.848915895953755
              ],
              [
                -52.18208708646316,
                -29.84679053468208
              ],
              [
                -52.18241565047147,
                -29.84391842485549
              ],
              [
                -52.18110139443823,
                -29.84190794797688
              ],
              [
                -52.17869192504395,
                -29.84098887283237
              ],
              [
                -52.17688482299824,
                -29.84127608381503
              ],
              [
                -52.174694396276166,
                -29.839897471098265
              ],
              [
                -52.1743110715998,
                -29.836623265895952
              ],
              [
                -52.175296763624736,
                -29.834899999999998
              ],
              [
                -52.175296763624736,
                -29.83260231213873
              ],
              [
                -52.17688482299824,
                -29.829615317919075
              ],
              [
                -52.177103865670446,
                -29.827087861271675
              ],
              [
                -52.17798003635927,
                -29.826685765895952
              ],
              [
                -52.180718069761866,
                -29.823009465317917
              ],
              [
                -52.18597509389484,
                -29.819620375722543
              ],
              [
                -52.18668698257951,
                -29.8162887283237
              ],
              [
                -52.20431991769218,
                -29.809625433526012
              ],
              [
                -52.20300566165894,
                -29.80577680635838
              ],
              [
                -52.203498507671405,
                -29.80347911849711
              ],
              [
                -52.20870077113633,
                -29.798596531791908
              ],
              [
                -52.210179309173725,
                -29.79612651734104
              ],
              [
                -52.21121976186671,
                -29.791473699421964
              ],
              [
                -52.212588778568005,
                -29.78980787572254
              ],
              [
                -52.22222665614512,
                -29.7852125
              ],
              [
                -52.22830509029886,
                -29.784121098265896
              ],
              [
                -52.2325764224069,
                -29.775389884393064
              ],
              [
                -52.216422025331624,
                -29.76958822254335
              ],
              [
                -52.21368399192904,
                -29.769301011560692
              ],
              [
                -52.207222233098925,
                -29.77050729768786
              ],
              [
                -52.20519608838101,
                -29.76981799132948
              ],
              [
                -52.20360802900751,
                -29.76602680635838
              ],
              [
                -52.203991353683875,
                -29.764992846820807
              ],
              [
                -52.185591769218476,
                -29.757582803468207
              ],
              [
                -52.17929429239252,
                -29.76797984104046
              ],
              [
                -52.17792527569122,
                -29.766486343930634
              ],
              [
                -52.16768503076554,
                -29.760914450867052
              ],
              [
                -52.16270180997283,
                -29.761086777456647
              ],
              [
                -52.15437818842896,
                -29.75580209537572
              ],
              [
                -52.14890212162378,
                -29.75390650289017
              ],
              [
                -52.14189275611315,
                -29.75321719653179
              ],
              [
                -52.13701905665654,
                -29.750115317919075
              ],
              [
                -52.13630716797187,
                -29.748909031791907
              ],
              [
                -52.13767618467316,
                -29.73868432080925
              ],
              [
                -52.13592384329551,
                -29.734088945086704
              ],
              [
                -52.12590264104203,
                -29.726104479768786
              ],
              [
                -52.122124154946455,
                -29.7255875
              ],
              [
                -52.12042657423685,
                -29.723806791907514
              ],
              [
                -52.118400429518935,
                -29.723002601156068
              ],
              [
                -52.11391005473869,
                -29.724725867052022
              ],
              [
                -52.111500585344416,
                -29.723921676300577
              ],
              [
                -52.10339600647275,
                -29.724725867052022
              ],
              [
                -52.102410314447816,
                -29.723577023121386
              ],
              [
                -52.1002746483938,
                -29.72369190751445
              ],
              [
                -52.09912467436471,
                -29.722198410404623
              ],
              [
                -52.097317572319,
                -29.723002601156068
              ],
              [
                -52.09419621424005,
                -29.72271539017341
              ],
              [
                -52.08269647394918,
                -29.71990072254335
              ],
              [
                -52.070101520297264,
                -29.72277283236994
              ],
              [
                -52.06681588021416,
                -29.72461098265896
              ],
              [
                -52.06528258150871,
                -29.724208887283236
              ],
              [
                -52.064515932155985,
                -29.72501307803468
              ],
              [
                -52.05799941265782,
                -29.72627680635838
              ],
              [
                -52.05668515662458,
                -29.723921676300577
              ],
              [
                -52.0526876278568,
                -29.72397911849711
              ],
              [
                -52.051701935831865,
                -29.7217963150289
              ],
              [
                -52.049894833786155,
                -29.721623988439305
              ],
              [
                -52.04688299704331,
                -29.719096531791905
              ],
              [
                -52.04600682635448,
                -29.712892774566473
              ],
              [
                -52.04469257032124,
                -29.711112066473987
              ],
              [
                -52.0434878356241,
                -29.71151416184971
              ],
              [
                -52.04107836622982,
                -29.710480202312137
              ],
              [
                -52.0404212382132,
                -29.708182514450865
              ],
              [
                -52.038778418171646,
                -29.707205997109824
              ],
              [
                -52.03740940147035,
                -29.70381690751445
              ],
              [
                -52.03609514543711,
                -29.702380852601156
              ],
              [
                -52.03029051462362,
                -29.702897832369942
              ],
              [
                -52.02738819921687,
                -29.706114595375723
              ],
              [
                -52.01988598769378,
                -29.709216473988437
              ],
              [
                -52.01408135688029,
                -29.709388800578033
              ],
              [
                -52.008824332747324,
                -29.70599971098266
              ],
              [
                -52.007017230701614,
                -29.70548273121387
              ],
              [
                -52.00422443663097,
                -29.707205997109824
              ],
              [
                -52.002800659261624,
                -29.70898670520231
              ],
              [
                -52.00482680397954,
                -29.713524638728323
              ],
              [
                -52.00537441066006,
                -29.716798843930636
              ],
              [
                -52.00378635128656,
                -29.720992124277455
              ],
              [
                -52.00137688189228,
                -29.723577023121386
              ],
              [
                -51.997215071120344,
                -29.725127962427745
              ],
              [
                -51.98631769817804,
                -29.72627680635838
              ],
              [
                -51.9851129634809,
                -29.727425650289018
              ],
              [
                -51.98462011746843,
                -29.730699855491327
              ],
              [
                -51.976296495924565,
                -29.733801734104045
              ],
              [
                -51.972682291833145,
                -29.736673843930635
              ],
              [
                -51.97060138644718,
                -29.73650151734104
              ],
              [
                -51.96912284840978,
                -29.73391661849711
              ],
              [
                -51.967808592376535,
                -29.733227312138727
              ],
              [
                -51.962223004235256,
                -29.734720809248554
              ],
              [
                -51.961018269538116,
                -29.735984537572254
              ],
              [
                -51.96151111555058,
                -29.73810989884393
              ],
              [
                -51.95959449216877,
                -29.739890606936417
              ],
              [
                -51.95838975747163,
                -29.744485982658958
              ],
              [
                -51.95937544949656,
                -29.74839205202312
              ],
              [
                -51.95822547546747,
                -29.755687210982657
              ],
              [
                -51.959211167492406,
                -29.75827210982659
              ],
              [
                -51.96178491889084,
                -29.760799566473988
              ],
              [
                -51.96189444022694,
                -29.763327023121388
              ],
              [
                -51.961018269538116,
                -29.76430354046243
              ],
              [
                -51.957294544110596,
                -29.76568215317919
              ],
              [
                -51.95532316006073,
                -29.765509826589593
              ],
              [
                -51.94957328991529,
                -29.759478395953757
              ],
              [
                -51.94300200974908,
                -29.75861676300578
              ],
              [
                -51.93999017300623,
                -29.760110260115606
              ],
              [
                -51.92509527129614,
                -29.761086777456647
              ],
              [
                -51.910309890922164,
                -29.766601228323697
              ],
              [
                -51.90800994286399,
                -29.768784031791906
              ],
              [
                -51.907298054179314,
                -29.771024277456647
              ],
              [
                -51.907900421527884,
                -29.774183598265896
              ],
              [
                -51.91009084824996,
                -29.776711054913292
              ],
              [
                -51.918797794470194,
                -29.783374349710982
              ],
              [
                -51.920604896515904,
                -29.785614595375723
              ],
              [
                -51.92098822119226,
                -29.788314378612714
              ],
              [
                -51.92038585384369,
                -29.792507658959536
              ],
              [
                -51.916497846412014,
                -29.803077023121386
              ],
              [
                -51.913978855681634,
                -29.808419147398844
              ],
              [
                -51.910912258270734,
                -29.811176372832367
              ],
              [
                -51.907900421527884,
                -29.81192312138728
              ],
              [
                -51.90439573877257,
                -29.811521026011558
              ],
              [
                -51.89809826194662,
                -29.808993569364162
              ],
              [
                -51.897386373261945,
                -29.80738518786127
              ],
              [
                -51.893717408502475,
                -29.804398193641617
              ],
              [
                -51.886379478983535,
                -29.803996098265895
              ],
              [
                -51.88429857359757,
                -29.8050875
              ],
              [
                -51.880903412178355,
                -29.80922333815029
              ],
              [
                -51.875208302700976,
                -29.813703829479767
              ],
              [
                -51.87137505593735,
                -29.815886632947976
              ],
              [
                -51.86201098170049,
                -29.81887362716763
              ],
              [
                -51.85620635088701,
                -29.819275722543352
              ],
              [
                -51.84081860316446,
                -29.823813656069362
              ],
              [
                -51.834302083666294,
                -29.830017413294797
              ],
              [
                -51.827676042832024,
                -29.838576300578033
              ],
              [
                -51.82428088141282,
                -29.847307514450865
              ],
              [
                -51.81551917452453,
                -29.861782947976877
              ],
              [
                -51.801281400831066,
                -29.86247225433526
              ],
              [
                -51.78178660300463,
                -29.86028945086705
              ],
              [
                -51.76979401670129,
                -29.861725505780345
              ],
              [
                -51.747999270816685,
                -29.852017774566473
              ],
              [
                -51.74148275131852,
                -29.852017774566473
              ],
              [
                -51.733980539795425,
                -29.8535112716763
              ],
              [
                -51.7164023653508,
                -29.860691546242773
              ],
              [
                -51.716183322678596,
                -29.85810664739884
              ],
              [
                -51.72012609077833,
                -29.85190289017341
              ],
              [
                -51.728887797666616,
                -29.84811170520231
              ],
              [
                -51.73179011307336,
                -29.844722615606937
              ],
              [
                -51.72970920768739,
                -29.840471893063583
              ],
              [
                -51.730202053699855,
                -29.83530209537572
              ],
              [
                -51.73721141921048,
                -29.835474421965316
              ],
              [
                -51.738799478583985,
                -29.833119291907515
              ],
              [
                -51.74159227265463,
                -29.834497904624275
              ],
              [
                -51.744877912737735,
                -29.834497904624275
              ],
              [
                -51.745480280086305,
                -29.8323725433526
              ],
              [
                -51.74827307415694,
                -29.83070671965318
              ],
              [
                -51.749313526849924,
                -29.829213222543352
              ],
              [
                -51.749313526849924,
                -29.825422037572253
              ],
              [
                -51.751613474908105,
                -29.823181791907512
              ],
              [
                -51.754077704970435,
                -29.822607369942194
              ],
              [
                -51.75829427641042,
                -29.818816184971098
              ],
              [
                -51.75829427641042,
                -29.81692059248555
              ],
              [
                -51.75550148233978,
                -29.813014523121385
              ],
              [
                -51.756706217036914,
                -29.809108453757226
              ],
              [
                -51.75610384968835,
                -29.803019580924854
              ],
              [
                -51.75878712242289,
                -29.79928583815029
              ],
              [
                -51.75769190906185,
                -29.796298843930636
              ],
              [
                -51.75818475507432,
                -29.793713945086704
              ],
              [
                -51.75769190906185,
                -29.792105563583814
              ],
              [
                -51.75369438029407,
                -29.788888800578032
              ],
              [
                -51.75090158622343,
                -29.784982731213873
              ],
              [
                -51.750518261547064,
                -29.78297225433526
              ],
              [
                -51.74717786079591,
                -29.77952572254335
              ],
              [
                -51.74717786079591,
                -29.77791734104046
              ],
              [
                -51.74882068083746,
                -29.77630895953757
              ],
              [
                -51.74898496284162,
                -29.773494291907515
              ],
              [
                -51.74712310012786,
                -29.769473338150288
              ],
              [
                -51.74350889603644,
                -29.765624710982657
              ],
              [
                -51.73989469194502,
                -29.763499349710983
              ],
              [
                -51.73978517060892,
                -29.761373988439306
              ],
              [
                -51.73732094054659,
                -29.759995375722543
              ],
              [
                -51.73737570121464,
                -29.758099783236993
              ],
              [
                -51.736390009189705,
                -29.756491401734102
              ],
              [
                -51.7316258310692,
                -29.75350440751445
              ],
              [
                -51.72861399432635,
                -29.74931112716763
              ],
              [
                -51.72198795349209,
                -29.745922037572253
              ],
              [
                -51.71870231340898,
                -29.742820158959535
              ],
              [
                -51.71831898873262,
                -29.733571965317918
              ],
              [
                -51.720290372782486,
                -29.73179125722543
              ],
              [
                -51.72061893679079,
                -29.729608453757223
              ],
              [
                -51.719688005433916,
                -29.726621459537572
              ],
              [
                -51.720399894118586,
                -29.72501307803468
              ],
              [
                -51.719085638085346,
                -29.72340469653179
              ],
              [
                -51.7224260388365,
                -29.71990072254335
              ],
              [
                -51.724178380214155,
                -29.715707442196532
              ],
              [
                -51.722206996164296,
                -29.713582080924855
              ],
              [
                -51.72067369745884,
                -29.713294869942196
              ],
              [
                -51.72078321879495,
                -29.708125072254333
              ],
              [
                -51.71809994606041,
                -29.704678540462428
              ],
              [
                -51.716785690027166,
                -29.70410411849711
              ],
              [
                -51.716676168691066,
                -29.702323410404624
              ],
              [
                -51.713116725267696,
                -29.701404335260115
              ],
              [
                -51.71109058054979,
                -29.69962362716763
              ],
              [
                -51.70950252117628,
                -29.70088735549133
              ],
              [
                -51.70769541913057,
                -29.695315462427743
              ],
              [
                -51.70528594973629,
                -29.693994291907515
              ],
              [
                -51.70347884769058,
                -29.694224060693642
              ],
              [
                -51.70320504435033,
                -29.68847984104046
              ],
              [
                -51.70468358238772,
                -29.687675650289016
              ],
              [
                -51.70320504435033,
                -29.68618215317919
              ],
              [
                -51.70052177161579,
                -29.685722615606934
              ],
              [
                -51.69690756752437,
                -29.683597254335258
              ],
              [
                -51.69690756752437,
                -29.681414450867052
              ],
              [
                -51.69548379015502,
                -29.680323049132948
              ],
              [
                -51.6963052001758,
                -29.674291618497108
              ],
              [
                -51.6961956788397,
                -29.671706719653177
              ],
              [
                -51.694717140802304,
                -29.66981112716763
              ],
              [
                -51.69340288476906,
                -29.667111343930635
              ],
              [
                -51.69137674005114,
                -29.667513439306358
              ],
              [
                -51.69132197938309,
                -29.668317630057803
              ],
              [
                -51.68841966397635,
                -29.668087861271676
              ],
              [
                -51.68672208326674,
                -29.666824132947976
              ],
              [
                -51.68518878456129,
                -29.666709248554913
              ],
              [
                -51.68590067324596,
                -29.662573410404622
              ],
              [
                -51.685517348569604,
                -29.660792702312136
              ],
              [
                -51.68151981980182,
                -29.659701300578032
              ],
              [
                -51.681903144478184,
                -29.657805708092486
              ],
              [
                -51.680096042432474,
                -29.65671430635838
              ],
              [
                -51.679493675083904,
                -29.655278251445086
              ],
              [
                -51.675879470992484,
                -29.654588945086704
              ],
              [
                -51.67440093295509,
                -29.655278251445086
              ],
              [
                -51.67297715558574,
                -29.65321033236994
              ],
              [
                -51.67040340418731,
                -29.65441661849711
              ],
              [
                -51.66547494406265,
                -29.653325216763005
              ],
              [
                -51.664708294709925,
                -29.651372182080923
              ],
              [
                -51.66301071400032,
                -29.64999356936416
              ],
              [
                -51.662298825315645,
                -29.645972615606937
              ],
              [
                -51.65961555258111,
                -29.645513078034682
              ],
              [
                -51.65879414256033,
                -29.644421676300578
              ],
              [
                -51.6578084505354,
                -29.644594002890173
              ],
              [
                -51.65600134848969,
                -29.64321539017341
              ],
              [
                -51.650580042352566,
                -29.642526083815028
              ],
              [
                -51.650525281684516,
                -29.64097514450867
              ],
              [
                -51.6484991369666,
                -29.638677456647397
              ],
              [
                -51.64499445421128,
                -29.63781582369942
              ],
              [
                -51.64187309613233,
                -29.63580534682081
              ],
              [
                -51.640777882771296,
                -29.635001156069364
              ],
              [
                -51.63968266941026,
                -29.633392774566474
              ],
              [
                -51.640120754754676,
                -29.63138229768786
              ],
              [
                -51.63809461003676,
                -29.628912283236993
              ],
              [
                -51.64220166014064,
                -29.62632738439306
              ],
              [
                -51.644501608198816,
                -29.623397832369943
              ],
              [
                -51.64461112953492,
                -29.620525722543352
              ],
              [
                -51.64581586423206,
                -29.616504768786125
              ],
              [
                -51.647622966277765,
                -29.615872904624275
              ],
              [
                -51.64838961563049,
                -29.614321965317917
              ],
              [
                -51.64707535959725,
                -29.612311488439307
              ],
              [
                -51.65260618707048,
                -29.604614234104044
              ],
              [
                -51.652496665734375,
                -29.600420953757226
              ],
              [
                -51.65698704051462,
                -29.59542348265896
              ],
              [
                -51.66180597930318,
                -29.592723699421963
              ],
              [
                -51.66268214999201,
                -29.5900813583815
              ],
              [
                -51.66207978264344,
                -29.588817630057804
              ],
              [
                -51.66339403867668,
                -29.581522471098264
              ],
              [
                -51.66432497003356,
                -29.532811488439304
              ],
              [
                -51.66498209805018,
                -29.500816184971097
              ],
              [
                -51.69077437270257,
                -29.500816184971097
              ],
              [
                -51.69039104802621,
                -29.48777680635838
              ],
              [
                -51.66810345612913,
                -29.48748959537572
              ],
              [
                -51.66941771216238,
                -29.480883742774566
              ],
              [
                -51.67051292552341,
                -29.47077391618497
              ],
              [
                -51.69088389403868,
                -29.47071647398844
              ],
              [
                -51.69137674005114,
                -29.456585693641617
              ],
              [
                -51.69137674005114,
                -29.44348887283237
              ],
              [
                -51.691212458046984,
                -29.423498988439306
              ],
              [
                -51.68031508510468,
                -29.41338916184971
              ],
              [
                -51.66952723349848,
                -29.41827174855491
              ],
              [
                -51.66580350807096,
                -29.414308236994216
              ],
              [
                -51.664708294709925,
                -29.410976589595375
              ],
              [
                -51.658575099888125,
                -29.402073049132948
              ],
              [
                -51.65747988652709,
                -29.39931582369942
              ],
              [
                -51.61049523333866,
                -29.40080932080925
              ],
              [
                -51.613999916093974,
                -29.388172037572254
              ],
              [
                -51.61410943743008,
                -29.383806430635836
              ],
              [
                -51.61602606081189,
                -29.381795953757223
              ],
              [
                -51.61679271016462,
                -29.377889884393063
              ],
              [
                -51.61131664335944,
                -29.37811965317919
              ],
              [
                -51.606114379894514,
                -29.378579190751445
              ],
              [
                -51.60277397914336,
                -29.378004768786127
              ],
              [
                -51.59888597171168,
                -29.377889884393063
              ],
              [
                -51.59390275091897,
                -29.37622406069364
              ],
              [
                -51.590014743487295,
                -29.375477312138727
              ],
              [
                -51.588919530126255,
                -29.37559219653179
              ],
              [
                -51.586400539395875,
                -29.377028251445086
              ],
              [
                -51.58437439467796,
                -29.37909617052023
              ],
              [
                -51.57939117388525,
                -29.381278973988437
              ],
              [
                -51.57791263584785,
                -29.382427817919073
              ],
              [
                -51.57572220912578,
                -29.382427817919073
              ],
              [
                -51.57188896236215,
                -29.38070455202312
              ],
              [
                -51.568493800942946,
                -29.378808959537572
              ],
              [
                -51.56772715159022,
                -29.377889884393063
              ],
              [
                -51.56712478424165,
                -29.37559219653179
              ],
              [
                -51.56257964879335,
                -29.375017774566473
              ],
              [
                -51.56099158941985,
                -29.374213583815028
              ],
              [
                -51.56110111075595,
                -29.368699132947974
              ],
              [
                -51.56329153747802,
                -29.368699132947974
              ],
              [
                -51.56351058015023,
                -29.358072326589593
              ],
              [
                -51.560608264743486,
                -29.358819075144506
              ],
              [
                -51.55891068403388,
                -29.358474421965315
              ],
              [
                -51.55781547067284,
                -29.35721069364162
              ],
              [
                -51.55661073597571,
                -29.35669371387283
              ],
              [
                -51.55359889923286,
                -29.356808598265893
              ],
              [
                -51.55212036119546,
                -29.3553725433526
              ],
              [
                -51.54658953372223,
                -29.3553725433526
              ],
              [
                -51.54259200495445,
                -29.355889523121384
              ],
              [
                -51.53897780086303,
                -29.355085332369942
              ],
              [
                -51.53777306616589,
                -29.356004407514448
              ],
              [
                -51.53547311810772,
                -29.355889523121384
              ],
              [
                -51.53547311810772,
                -29.354510910404624
              ],
              [
                -51.533885058734214,
                -29.35152391618497
              ],
              [
                -51.532625563369024,
                -29.350489956647397
              ],
              [
                -51.52977800863033,
                -29.351983453757224
              ],
              [
                -51.52178295109477,
                -29.351926011560693
              ],
              [
                -51.52057821639763,
                -29.35089205202312
              ],
              [
                -51.48191718475307,
                -29.35117926300578
              ],
              [
                -51.3980786019658,
                -29.3515813583815
              ],
              [
                -51.375791010068724,
                -29.35181112716763
              ],
              [
                -51.35361293950775,
                -29.351696242774565
              ],
              [
                -51.3504915814288,
                -29.351926011560693
              ]
            ]
          ],
          [
            [
              [
                -51.29469046068403,
                -30.054214306358382
              ],
              [
                -51.293211922646634,
                -30.05610989884393
              ],
              [
                -51.29058341058015,
                -30.0584075867052
              ],
              [
                -51.28899535120665,
                -30.058924566473987
              ],
              [
                -51.28872154786639,
                -30.060188294797687
              ],
              [
                -51.28560018978744,
                -30.060188294797687
              ],
              [
                -51.28691444582068,
                -30.063290173410405
              ],
              [
                -51.290200085903784,
                -30.06501343930636
              ],
              [
                -51.29151434193703,
                -30.065128323699422
              ],
              [
                -51.29151434193703,
                -30.06317528901734
              ],
              [
                -51.29102149592456,
                -30.06030317919075
              ],
              [
                -51.29277383730222,
                -30.058809682080923
              ],
              [
                -51.29469046068403,
                -30.054214306358382
              ]
            ]
          ],
          [
            [
              [
                -51.167590950135846,
                -30.262672037572255
              ],
              [
                -51.16441483138885,
                -30.262097615606937
              ],
              [
                -51.16260772934314,
                -30.26278692196532
              ],
              [
                -51.16282677201534,
                -30.265084609826587
              ],
              [
                -51.16529100207767,
                -30.26617601156069
              ],
              [
                -51.166879061451176,
                -30.265084609826587
              ],
              [
                -51.168083796148316,
                -30.265027167630056
              ],
              [
                -51.17021946220233,
                -30.263705997109827
              ],
              [
                -51.16989089819402,
                -30.262901806358382
              ],
              [
                -51.167590950135846,
                -30.262672037572255
              ]
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "mesorregiao_nome": "Sudoeste Rio-grandense",
        "mesorregiao_id": 4306,
        "num_municipios": 19
      },
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -53.90581875752498,
              -31.80787812656537
            ],
            [
              -53.908018668156146,
              -31.809081408773228
            ],
            [
              -53.91048047291007,
              -31.80898884860339
            ],
            [
              -53.91168518587476,
              -31.807415325716196
            ],
            [
              -53.91650403773351,
              -31.803805479092624
            ],
            [
              -53.917708750698196,
              -31.803712918922788
            ],
            [
              -53.91959438838205,
              -31.805101321470314
            ],
            [
              -53.92121813194315,
              -31.805379001979823
            ],
            [
              -53.924622755539005,
              -31.80440712019655
            ],
            [
              -53.926194120275554,
              -31.804314560026718
            ],
            [
              -53.92781786383665,
              -31.805702962574244
            ],
            [
              -53.92640363557376,
              -31.807600446055865
            ],
            [
              -53.92519892260907,
              -31.8111177325096
            ],
            [
              -53.92357517904797,
              -31.812783815566636
            ],
            [
              -53.923313284925214,
              -31.81500525964268
            ],
            [
              -53.92357517904797,
              -31.817180423633804
            ],
            [
              -53.9228942543288,
              -31.817920904992487
            ],
            [
              -53.92069434369763,
              -31.8176895045679
            ],
            [
              -53.91948963073295,
              -31.818198585501992
            ],
            [
              -53.91959438838205,
              -31.819679548219355
            ],
            [
              -53.922003814311424,
              -31.81940186770985
            ],
            [
              -53.92179429901322,
              -31.820697710087543
            ],
            [
              -53.91990866132936,
              -31.82171587195573
            ],
            [
              -53.92022293427667,
              -31.82361335543735
            ],
            [
              -53.917708750698196,
              -31.826205040192736
            ],
            [
              -53.915980249487994,
              -31.82629760036257
            ],
            [
              -53.91582311301433,
              -31.827917403334688
            ],
            [
              -53.912208974120276,
              -31.830879328769413
            ],
            [
              -53.9113185341029,
              -31.83360985377955
            ],
            [
              -53.9096947905418,
              -31.834905696157243
            ],
            [
              -53.908018668156146,
              -31.83721970040312
            ],
            [
              -53.908018668156146,
              -31.838885783460153
            ],
            [
              -53.90990430584,
              -31.83971882498867
            ],
            [
              -53.90838531992801,
              -31.84069070677194
            ],
            [
              -53.90770439520884,
              -31.842079109319467
            ],
            [
              -53.909118623471734,
              -31.843513791951914
            ],
            [
              -53.911580428225655,
              -31.842310509744056
            ],
            [
              -53.91252324706758,
              -31.843421231782077
            ],
            [
              -53.91519456711972,
              -31.845411275433534
            ],
            [
              -53.915980249487994,
              -31.84740131908499
            ],
            [
              -53.914199369453236,
              -31.84781783984925
            ],
            [
              -53.913099414137655,
              -31.849622763161033
            ],
            [
              -53.91409461180413,
              -31.85161280681249
            ],
            [
              -53.91388509650593,
              -31.85508381318131
            ],
            [
              -53.913780338856824,
              -31.85661105598359
            ],
            [
              -53.9147755365233,
              -31.85721269708752
            ],
            [
              -53.91760399304909,
              -31.857490377597024
            ],
            [
              -53.9180230236455,
              -31.858786219974718
            ],
            [
              -53.91561359771613,
              -31.8613779047301
            ],
            [
              -53.915718355365236,
              -31.863414228466475
            ],
            [
              -53.918389675417366,
              -31.864802631014
            ],
            [
              -53.91901822131199,
              -31.8655893924576
            ],
            [
              -53.923313284925214,
              -31.868181077212988
            ],
            [
              -53.925303680258175,
              -31.871096722562793
            ],
            [
              -53.927294075591135,
              -31.872392564940487
            ],
            [
              -53.931012972134305,
              -31.874012367912602
            ],
            [
              -53.931693896853474,
              -31.8755858907998
            ],
            [
              -53.93158913920437,
              -31.879103177253537
            ],
            [
              -53.93200816980078,
              -31.884888187868235
            ],
            [
              -53.93289860981816,
              -31.89289464255898
            ],
            [
              -53.932793852169056,
              -31.894005364597
            ],
            [
              -53.93137962390616,
              -31.894977246380268
            ],
            [
              -53.93027966859058,
              -31.897013570116645
            ],
            [
              -53.931012972134305,
              -31.90210437945758
            ],
            [
              -53.932112927449886,
              -31.90529770531689
            ],
            [
              -53.93541279339664,
              -31.9090001121103
            ],
            [
              -53.93640799106312,
              -31.91149923669585
            ],
            [
              -53.93797935579966,
              -31.911591796865682
            ],
            [
              -53.9389221746416,
              -31.912702518903707
            ],
            [
              -53.94169825234283,
              -31.912517398564034
            ],
            [
              -53.9440029206231,
              -31.913304160007634
            ],
            [
              -53.944579087693164,
              -31.914322321875822
            ],
            [
              -53.9437934053249,
              -31.91571072442335
            ],
            [
              -53.945888558306955,
              -31.915895844763018
            ],
            [
              -53.94662186185068,
              -31.917006566801042
            ],
            [
              -53.947878953639915,
              -31.917099126970875
            ],
            [
              -53.9489789089555,
              -31.918117288839063
            ],
            [
              -53.95301207844597,
              -31.919181730792168
            ],
            [
              -53.952697805498666,
              -31.92047757316986
            ],
            [
              -53.95348348786694,
              -31.92200481597214
            ],
            [
              -53.952488290200456,
              -31.923208098179998
            ],
            [
              -53.954007276112456,
              -31.92390229945376
            ],
            [
              -53.95510723142804,
              -31.925383262171124
            ],
            [
              -53.954007276112456,
              -31.927512146077333
            ],
            [
              -53.95379776081425,
              -31.929594749898623
            ],
            [
              -53.95421679141066,
              -31.931307113040575
            ],
            [
              -53.952697805498666,
              -31.932510395248432
            ],
            [
              -53.95107406193757,
              -31.932602955418268
            ],
            [
              -53.95117881958667,
              -31.934685559239558
            ],
            [
              -53.94829798423633,
              -31.93699956348544
            ],
            [
              -53.94761705951716,
              -31.93811028552346
            ],
            [
              -53.9489789089555,
              -31.939406127901155
            ],
            [
              -53.94950269720102,
              -31.94121105121294
            ],
            [
              -53.94772181716626,
              -31.94310853469456
            ],
            [
              -53.94698851362254,
              -31.94500601817618
            ],
            [
              -53.948088468938124,
              -31.948106783865658
            ],
            [
              -53.94599331595606,
              -31.948477024545
            ],
            [
              -53.94368864767579,
              -31.951022429215467
            ],
            [
              -53.94567904300875,
              -31.952595952102666
            ],
            [
              -53.94709327127164,
              -31.95208687116857
            ],
            [
              -53.94829798423633,
              -31.95329015337643
            ],
            [
              -53.94751230186806,
              -31.954585995754123
            ],
            [
              -53.94997410662198,
              -31.954493435584286
            ],
            [
              -53.95390251846335,
              -31.9569
            ],
            [
              -53.954897716129835,
              -31.9569
            ],
            [
              -53.956207186743626,
              -31.95541903728264
            ],
            [
              -53.95830233972569,
              -31.954909956348544
            ],
            [
              -53.96029273505865,
              -31.95541903728264
            ],
            [
              -53.96228313039161,
              -31.951485230064645
            ],
            [
              -53.96479731397009,
              -31.94981914700761
            ],
            [
              -53.96610678458388,
              -31.949911707177446
            ],
            [
              -53.96788766461863,
              -31.944080416477828
            ],
            [
              -53.970192332898904,
              -31.94371017579849
            ],
            [
              -53.971501803512695,
              -31.9426920139303
            ],
            [
              -53.972601758828276,
              -31.940100329174918
            ],
            [
              -53.972182728231864,
              -31.936120241872004
            ],
            [
              -53.97082087879352,
              -31.935009519833983
            ],
            [
              -53.96982568112704,
              -31.935194640173652
            ],
            [
              -53.96877810463601,
              -31.936907003315604
            ],
            [
              -53.967101982250355,
              -31.936814443145767
            ],
            [
              -53.966682951653944,
              -31.933389716861868
            ],
            [
              -53.96469255632098,
              -31.933621117286453
            ],
            [
              -53.9636973586545,
              -31.931492233380247
            ],
            [
              -53.964011631601814,
              -31.929779870238296
            ],
            [
              -53.96170696332154,
              -31.930196391002553
            ],
            [
              -53.96191647861975,
              -31.926910504973403
            ],
            [
              -53.96327832805809,
              -31.92200481597214
            ],
            [
              -53.965321102215604,
              -31.921495735038047
            ],
            [
              -53.96919713523242,
              -31.9224213367364
            ],
            [
              -53.96940665053063,
              -31.920801533764283
            ],
            [
              -53.96752101284677,
              -31.920708973594447
            ],
            [
              -53.96951140817973,
              -31.917885888414474
            ],
            [
              -53.971292288214485,
              -31.918996610452496
            ],
            [
              -53.97312554707379,
              -31.918811490112827
            ],
            [
              -53.974592154161236,
              -31.917793328244638
            ],
            [
              -53.97642541302054,
              -31.917515647735133
            ],
            [
              -53.97768250480978,
              -31.918302409178732
            ],
            [
              -53.98009193073916,
              -31.917006566801042
            ],
            [
              -53.98108712840563,
              -31.915988404932854
            ],
            [
              -53.9847012672997,
              -31.91760820790497
            ],
            [
              -53.988315406193756,
              -31.916682606206617
            ],
            [
              -53.9897820132812,
              -31.91760820790497
            ],
            [
              -53.99308187922795,
              -31.91529420365909
            ],
            [
              -53.996119851051944,
              -31.914877682894833
            ],
            [
              -53.99769121578849,
              -31.913813240941728
            ],
            [
              -53.99957685347235,
              -31.915201643489254
            ],
            [
              -54.00088632408614,
              -31.914600002385328
            ],
            [
              -54.0043957053311,
              -31.914600002385328
            ],
            [
              -54.006909888909576,
              -31.91260995873387
            ],
            [
              -54.00722416185688,
              -31.908907551940462
            ],
            [
              -54.007800328926955,
              -31.908398471006368
            ],
            [
              -54.01209539254018,
              -31.90798195024211
            ],
            [
              -54.01387627257494,
              -31.908907551940462
            ],
            [
              -54.01539525848693,
              -31.90858359134604
            ],
            [
              -54.01680948674983,
              -31.906778668034253
            ],
            [
              -54.01471433376776,
              -31.907102628628678
            ],
            [
              -54.01288107490846,
              -31.90668610786442
            ],
            [
              -54.01220015018929,
              -31.905205145147058
            ],
            [
              -54.01371913610129,
              -31.90418698327887
            ],
            [
              -54.016599971451626,
              -31.9047886243828
            ],
            [
              -54.01811895736362,
              -31.903585342174942
            ],
            [
              -54.01539525848693,
              -31.902520900221838
            ],
            [
              -54.01639045615342,
              -31.900993657419555
            ],
            [
              -54.018014199714514,
              -31.901919259117907
            ],
            [
              -54.02079027741575,
              -31.901178777759228
            ],
            [
              -54.02377587041519,
              -31.90108621758939
            ],
            [
              -54.023304460994225,
              -31.89881849342843
            ],
            [
              -54.0239853857134,
              -31.897707771390408
            ],
            [
              -54.026394811642774,
              -31.89692100994681
            ],
            [
              -54.02859472227394,
              -31.898494532834007
            ],
            [
              -54.032208861168,
              -31.898679653173676
            ],
            [
              -54.03142317879973,
              -31.895995408248456
            ],
            [
              -54.03268027058897,
              -31.895486327314362
            ],
            [
              -54.03378022590455,
              -31.897013570116645
            ],
            [
              -54.035875378886615,
              -31.89761521122057
            ],
            [
              -54.03901810835971,
              -31.897383810795983
            ],
            [
              -54.042317974306464,
              -31.899096173937934
            ],
            [
              -54.042317974306464,
              -31.900577136655297
            ],
            [
              -54.044989294358594,
              -31.902011819287743
            ],
            [
              -54.045198809656796,
              -31.903585342174942
            ],
            [
              -54.04792250853348,
              -31.90340022183527
            ],
            [
              -54.048708190901756,
              -31.90529770531689
            ],
            [
              -54.050489070936514,
              -31.905205145147058
            ],
            [
              -54.051589026252095,
              -31.904094423109033
            ],
            [
              -54.05368417923416,
              -31.90511258497722
            ],
            [
              -54.05467937690064,
              -31.907611709562772
            ],
            [
              -54.05640787811084,
              -31.908722431600793
            ],
            [
              -54.05619836281264,
              -31.91168435703552
            ],
            [
              -54.05808400049649,
              -31.91339672017747
            ],
            [
              -54.06080769937318,
              -31.914877682894833
            ],
            [
              -54.06169813939056,
              -31.915988404932854
            ],
            [
              -54.06300761000434,
              -31.916404925697112
            ],
            [
              -54.06248382175883,
              -31.917793328244638
            ],
            [
              -54.06347901942531,
              -31.920199892660353
            ],
            [
              -54.067512188915785,
              -31.92279157741574
            ],
            [
              -54.069973993669706,
              -31.922606457076068
            ],
            [
              -54.07091681251163,
              -31.921310614698378
            ],
            [
              -54.073483374914666,
              -31.918811490112827
            ],
            [
              -54.078406984422514,
              -31.92218993631181
            ],
            [
              -54.07929742443989,
              -31.923717179114092
            ],
            [
              -54.080816410351886,
              -31.92431882021802
            ],
            [
              -54.08071165270279,
              -31.925984903275054
            ],
            [
              -54.0795069397381,
              -31.92700306514324
            ],
            [
              -54.081287819772854,
              -31.929594749898623
            ],
            [
              -54.082597290386644,
              -31.929594749898623
            ],
            [
              -54.08731138459629,
              -31.93079803210648
            ],
            [
              -54.08830658226277,
              -31.932788075757937
            ],
            [
              -54.08710186929808,
              -31.933204596522195
            ],
            [
              -54.08668283870167,
              -31.93510208000382
            ],
            [
              -54.08909226463104,
              -31.935379760513324
            ],
            [
              -54.09040173524483,
              -31.934592999069725
            ],
            [
              -54.09019221994663,
              -31.932880635927773
            ],
            [
              -54.09181596350773,
              -31.93028895117239
            ],
            [
              -54.094277768261655,
              -31.931677353719916
            ],
            [
              -54.09579675417365,
              -31.92968731006846
            ],
            [
              -54.09841569540123,
              -31.928206347351097
            ],
            [
              -54.099620408365915,
              -31.928484027860602
            ],
            [
              -54.10140128840067,
              -31.927095625313076
            ],
            [
              -54.101610803698875,
              -31.92621630369964
            ],
            [
              -54.10019657543598,
              -31.925013021491782
            ],
            [
              -54.10328692608453,
              -31.922513896906235
            ],
            [
              -54.10349644138273,
              -31.92107921427379
            ],
            [
              -54.105120184943836,
              -31.919690811726262
            ],
            [
              -54.10810577794327,
              -31.918580089688238
            ],
            [
              -54.107110580276796,
              -31.917700768074805
            ],
            [
              -54.10637727673307,
              -31.914090921451233
            ],
            [
              -54.10527732141749,
              -31.912887639243376
            ],
            [
              -54.1072153379259,
              -31.911776917205355
            ],
            [
              -54.10842005089059,
              -31.91200831762994
            ],
            [
              -54.10852480853969,
              -31.909509193044393
            ],
            [
              -54.11061996152175,
              -31.907889390072278
            ],
            [
              -54.11391982746851,
              -31.907519149392936
            ],
            [
              -54.11559594985415,
              -31.906917508289006
            ],
            [
              -54.116224495748774,
              -31.904696064212963
            ],
            [
              -54.118214891081735,
              -31.903585342174942
            ],
            [
              -54.12010052876559,
              -31.903816742599528
            ],
            [
              -54.12381942530876,
              -31.901410178183813
            ],
            [
              -54.12450035002793,
              -31.900021775636286
            ],
            [
              -54.127014533606406,
              -31.89960525487203
            ],
            [
              -54.12811448892199,
              -31.898494532834007
            ],
            [
              -54.12979061130764,
              -31.89840197266417
            ],
            [
              -54.13220003723701,
              -31.89650448918255
            ],
            [
              -54.13419043256997,
              -31.896319368842878
            ],
            [
              -54.13419043256997,
              -31.898216852324502
            ],
            [
              -54.13628558555204,
              -31.896782169692056
            ],
            [
              -54.138118844411345,
              -31.896411929012714
            ],
            [
              -54.14131395270899,
              -31.894097924766836
            ],
            [
              -54.143409105691056,
              -31.889516196359995
            ],
            [
              -54.14419478805933,
              -31.888312914152138
            ],
            [
              -54.142990075094644,
              -31.887618712878375
            ],
            [
              -54.14251866567368,
              -31.885998909906256
            ],
            [
              -54.14267580214734,
              -31.884286546764308
            ],
            [
              -54.14461381865574,
              -31.881787422178757
            ],
            [
              -54.14597566809409,
              -31.88169486200892
            ],
            [
              -54.149589806988146,
              -31.879380857763042
            ],
            [
              -54.153780112952276,
              -31.878779216659115
            ],
            [
              -54.15550861416248,
              -31.876280092073564
            ],
            [
              -54.15849420716192,
              -31.873503286978508
            ],
            [
              -54.160903633091294,
              -31.872207444600818
            ],
            [
              -54.17399833922919,
              -31.862303506428454
            ],
            [
              -54.20390664804816,
              -31.84008906566801
            ],
            [
              -54.23601486749829,
              -31.816301102020372
            ],
            [
              -54.28608902376963,
              -31.77890679340696
            ],
            [
              -54.31809248557066,
              -31.75521138992916
            ],
            [
              -54.33469657295352,
              -31.742715767001407
            ],
            [
              -54.35171969093279,
              -31.729988743649074
            ],
            [
              -54.38361839508472,
              -31.70620078000143
            ],
            [
              -54.40221287780054,
              -31.692316754526157
            ],
            [
              -54.42138352758642,
              -31.67787736803187
            ],
            [
              -54.45202513994911,
              -31.654783605657993
            ],
            [
              -54.45459170235214,
              -31.652793562006536
            ],
            [
              -54.45621544591324,
              -31.651682839968515
            ],
            [
              -54.45532500589586,
              -31.65080351835508
            ],
            [
              -54.45401553528207,
              -31.648304393769532
            ],
            [
              -54.45349174703655,
              -31.645620148844312
            ],
            [
              -54.45391077763297,
              -31.644000345872197
            ],
            [
              -54.45302033761559,
              -31.64219542256041
            ],
            [
              -54.45218227642277,
              -31.64251938315483
            ],
            [
              -54.45150135170359,
              -31.640020258569283
            ],
            [
              -54.451815624650905,
              -31.638585575936837
            ],
            [
              -54.45328223173835,
              -31.639418617465353
            ],
            [
              -54.452915579966486,
              -31.636780652625053
            ],
            [
              -54.455115490597656,
              -31.635392250077523
            ],
            [
              -54.455115490597656,
              -31.634096407699833
            ],
            [
              -54.45370126233476,
              -31.629977480142166
            ],
            [
              -54.45422505058028,
              -31.628403957254967
            ],
            [
              -54.45731540122882,
              -31.629190718698567
            ],
            [
              -54.459305796561786,
              -31.628079996660546
            ],
            [
              -54.46108667659654,
              -31.62590483266942
            ],
            [
              -54.46040575187737,
              -31.621693344941917
            ],
            [
              -54.46192473778936,
              -31.62187846528159
            ],
            [
              -54.46339134487681,
              -31.62072146315865
            ],
            [
              -54.46449130019239,
              -31.619101660186534
            ],
            [
              -54.46428178489418,
              -31.616880216110488
            ],
            [
              -54.4630770719295,
              -31.6147976122892
            ],
            [
              -54.46381037547322,
              -31.61359433008134
            ],
            [
              -54.466219801402595,
              -31.61359433008134
            ],
            [
              -54.46658645317446,
              -31.61299268897741
            ],
            [
              -54.46569601315708,
              -31.60998448345777
            ],
            [
              -54.464177027245086,
              -31.608596080910242
            ],
            [
              -54.46181998014026,
              -31.608179560145985
            ],
            [
              -54.46082478247378,
              -31.60628207666436
            ],
            [
              -54.45909628126358,
              -31.605680435560433
            ],
            [
              -54.4565820976851,
              -31.607392798702385
            ],
            [
              -54.45679161298331,
              -31.604801113946998
            ],
            [
              -54.45611068826413,
              -31.60419947284307
            ],
            [
              -54.45742015887792,
              -31.602579669870956
            ],
            [
              -54.45731540122882,
              -31.601191267323426
            ],
            [
              -54.45532500589586,
              -31.601283827493262
            ],
            [
              -54.45370126233476,
              -31.60308875080505
            ],
            [
              -54.45260130701918,
              -31.602579669870956
            ],
            [
              -54.45349174703655,
              -31.600821026644088
            ],
            [
              -54.45239179172097,
              -31.599293783841805
            ],
            [
              -54.454277429404826,
              -31.599201223671972
            ],
            [
              -54.457996325947995,
              -31.598321902058537
            ],
            [
              -54.45899152361447,
              -31.59730374019035
            ],
            [
              -54.457996325947995,
              -31.594110414331038
            ],
            [
              -54.46108667659654,
              -31.59327737280252
            ],
            [
              -54.46250090485943,
              -31.592583171528755
            ],
            [
              -54.46360086017501,
              -31.5905931278773
            ],
            [
              -54.467110241419974,
              -31.59212037067958
            ],
            [
              -54.46789592378825,
              -31.59309225246285
            ],
            [
              -54.469310152051136,
              -31.592212930849414
            ],
            [
              -54.46831495438466,
              -31.59100964864156
            ],
            [
              -54.46988631912121,
              -31.58827912363142
            ],
            [
              -54.469100636752934,
              -31.58619651981013
            ],
            [
              -54.469310152051136,
              -31.58179991174296
            ],
            [
              -54.47261001799789,
              -31.57388601722205
            ],
            [
              -54.4729242909452,
              -31.57041501085323
            ],
            [
              -54.475124201576364,
              -31.569581969324716
            ],
            [
              -54.479209749891396,
              -31.570507571023068
            ],
            [
              -54.48088587227704,
              -31.569813369749305
            ],
            [
              -54.48381908645193,
              -31.56569444219164
            ],
            [
              -54.486804679451375,
              -31.565601882021802
            ],
            [
              -54.488795074784335,
              -31.56412091930444
            ],
            [
              -54.4924092136784,
              -31.559215230303174
            ],
            [
              -54.493613926643086,
              -31.558104508265153
            ],
            [
              -54.493404411344876,
              -31.556114464613696
            ],
            [
              -54.490104545398125,
              -31.551902976886197
            ],
            [
              -54.490314060696335,
              -31.550977375187845
            ],
            [
              -54.492304456029295,
              -31.547506368819025
            ],
            [
              -54.495604321976046,
              -31.543109760751854
            ],
            [
              -54.49670427729163,
              -31.540379235741717
            ],
            [
              -54.499113703221,
              -31.539916434892543
            ],
            [
              -54.49948035499286,
              -31.53880571285452
            ],
            [
              -54.50157550797493,
              -31.537000789542734
            ],
            [
              -54.501889780922234,
              -31.533714903513584
            ],
            [
              -54.502518326816855,
              -31.532789301815235
            ],
            [
              -54.50157550797493,
              -31.531400899267705
            ],
            [
              -54.503408766834234,
              -31.529503415786085
            ],
            [
              -54.50330400918513,
              -31.52709685137037
            ],
            [
              -54.504718237448024,
              -31.52519936788875
            ],
            [
              -54.506708632780985,
              -31.523209324237293
            ],
            [
              -54.5103751504996,
              -31.52149696109534
            ],
            [
              -54.51100369639422,
              -31.519877158123226
            ],
            [
              -54.513779774095454,
              -31.51520286954655
            ],
            [
              -54.51461783528828,
              -31.511916983517402
            ],
            [
              -54.51561303295476,
              -31.51020462037545
            ],
            [
              -54.5187033836033,
              -31.511083941988886
            ],
            [
              -54.520222369515295,
              -31.50867737757317
            ],
            [
              -54.52210800719916,
              -31.508816217827924
            ],
            [
              -54.52299844721654,
              -31.510713701309545
            ],
            [
              -54.52451743312853,
              -31.50988065978103
            ],
            [
              -54.524412675479425,
              -31.50752037545023
            ],
            [
              -54.52378412958481,
              -31.506085692817784
            ],
            [
              -54.5249888425495,
              -31.504789850440094
            ],
            [
              -54.528393466145346,
              -31.505900572478115
            ],
            [
              -54.52891725439086,
              -31.504789850440094
            ],
            [
              -54.531483816793894,
              -31.503679128402073
            ],
            [
              -54.532793287407685,
              -31.501503964410944
            ],
            [
              -54.53420751567057,
              -31.50141140424111
            ],
            [
              -54.547406979457584,
              -31.498403198721466
            ],
            [
              -54.54672605473841,
              -31.497616437277866
            ],
            [
              -54.54772125240489,
              -31.495811513966082
            ],
            [
              -54.55039257245702,
              -31.494793352097894
            ],
            [
              -54.55238296778998,
              -31.493682630059872
            ],
            [
              -54.55379719605288,
              -31.491785146578252
            ],
            [
              -54.555316181964876,
              -31.492710748276604
            ],
            [
              -54.55662565257866,
              -31.494978472437566
            ],
            [
              -54.5578827443679,
              -31.493590069890036
            ],
            [
              -54.56008265499907,
              -31.492710748276604
            ],
            [
              -54.560920716191895,
              -31.49030418386089
            ],
            [
              -54.559506487929,
              -31.489008341483196
            ],
            [
              -54.55982076087631,
              -31.48780505927534
            ],
            [
              -54.56118261031465,
              -31.486694337237317
            ],
            [
              -54.56270159622665,
              -31.486509216897648
            ],
            [
              -54.56668238689257,
              -31.487110858001575
            ],
            [
              -54.56919657047105,
              -31.48572245545405
            ],
            [
              -54.57071555638304,
              -31.482482849509818
            ],
            [
              -54.573282118786075,
              -31.48262168976457
            ],
            [
              -54.57600581766276,
              -31.481881208405888
            ],
            [
              -54.57742004592565,
              -31.481001886792452
            ],
            [
              -54.57941044125861,
              -31.47591107745152
            ],
            [
              -54.57961995655682,
              -31.470403747346325
            ],
            [
              -54.58318171662633,
              -31.46628481978866
            ],
            [
              -54.58291982250357,
              -31.465220377835557
            ],
            [
              -54.58318171662633,
              -31.462813813419842
            ],
            [
              -54.5855911425557,
              -31.46299893375951
            ],
            [
              -54.58658634022218,
              -31.462212172315912
            ],
            [
              -54.5871101284677,
              -31.45920396679627
            ],
            [
              -54.58690061316949,
              -31.45651972187105
            ],
            [
              -54.642107894246884,
              -31.454899918898935
            ],
            [
              -54.67028770185564,
              -31.454113157455335
            ],
            [
              -54.67091624775026,
              -31.453187555756983
            ],
            [
              -54.673482810153295,
              -31.452400794313384
            ],
            [
              -54.674216113697014,
              -31.451012391765858
            ],
            [
              -54.67578747843356,
              -31.45078099134127
            ],
            [
              -54.67667791845094,
              -31.447819065906543
            ],
            [
              -54.67730646434556,
              -31.44730998497245
            ],
            [
              -54.680292057345,
              -31.447217424802616
            ],
            [
              -54.68291099857258,
              -31.44518110106624
            ],
            [
              -54.68558231862471,
              -31.444486899792476
            ],
            [
              -54.68809650220319,
              -31.445088540896407
            ],
            [
              -54.68888218457146,
              -31.446199262934428
            ],
            [
              -54.693177248184696,
              -31.44541250149083
            ],
            [
              -54.69548191646496,
              -31.443191057414786
            ],
            [
              -54.69579618941228,
              -31.439905171385636
            ],
            [
              -54.69658187178055,
              -31.438007687904015
            ],
            [
              -54.698991297709924,
              -31.436295324762064
            ],
            [
              -54.7012959659902,
              -31.435693683658137
            ],
            [
              -54.70260543660399,
              -31.436804405696158
            ],
            [
              -54.70349587662136,
              -31.43930353028171
            ],
            [
              -54.70742428846273,
              -31.439210970111873
            ],
            [
              -54.71140507912865,
              -31.439488650621378
            ],
            [
              -54.71240027679514,
              -31.43810024807385
            ],
            [
              -54.7144954297772,
              -31.436896965865994
            ],
            [
              -54.715385869794574,
              -31.43828536841352
            ],
            [
              -54.71858097809223,
              -31.438007687904015
            ],
            [
              -54.71910476633774,
              -31.43851676883811
            ],
            [
              -54.721304676968906,
              -31.436989526035827
            ],
            [
              -54.72319031465277,
              -31.433194559072586
            ],
            [
              -54.722614147582696,
              -31.43199127686473
            ],
            [
              -54.72460454291566,
              -31.429584712449014
            ],
            [
              -54.729004364177996,
              -31.429214471769672
            ],
            [
              -54.7356040960715,
              -31.42967727261885
            ],
            [
              -54.73628502079067,
              -31.428011189561815
            ],
            [
              -54.738799204369144,
              -31.425604625146104
            ],
            [
              -54.74168003971948,
              -31.425604625146104
            ],
            [
              -54.743199025631476,
              -31.42620626625003
            ],
            [
              -54.74518942096444,
              -31.42620626625003
            ],
            [
              -54.74812263513933,
              -31.427085587863466
            ],
            [
              -54.748908317507606,
              -31.426715347184125
            ],
            [
              -54.75058443989325,
              -31.427409548457888
            ],
            [
              -54.75199866815615,
              -31.42449390310808
            ],
            [
              -54.75267959287532,
              -31.425188104381842
            ],
            [
              -54.75487950350649,
              -31.42467902344775
            ],
            [
              -54.759384082417924,
              -31.425604625146104
            ],
            [
              -54.760693553031714,
              -31.426900467523794
            ],
            [
              -54.763102978961086,
              -31.426715347184125
            ],
            [
              -54.76540764724136,
              -31.4271781480333
            ],
            [
              -54.766193329609635,
              -31.426483946759536
            ],
            [
              -54.76860275553901,
              -31.42602114591036
            ],
            [
              -54.77038363557376,
              -31.4271781480333
            ],
            [
              -54.77457394153789,
              -31.42870539083558
            ],
            [
              -54.775673896853476,
              -31.428011189561815
            ],
            [
              -54.77672147334451,
              -31.429584712449014
            ],
            [
              -54.778397595730155,
              -31.429816112873603
            ],
            [
              -54.78332120523801,
              -31.43199127686473
            ],
            [
              -54.78641155588655,
              -31.433009438732917
            ],
            [
              -54.78892573946503,
              -31.433287119242422
            ],
            [
              -54.78929239123689,
              -31.4348143620447
            ],
            [
              -54.79180657481537,
              -31.433796200176516
            ],
            [
              -54.79248749953454,
              -31.432315237459154
            ],
            [
              -54.79510644076212,
              -31.43120451542113
            ],
            [
              -54.796520669025014,
              -31.43000123321327
            ],
            [
              -54.799191989077144,
              -31.432500357798823
            ],
            [
              -54.802491855023895,
              -31.43000123321327
            ],
            [
              -54.80490128095327,
              -31.42990867304344
            ],
            [
              -54.80741546453174,
              -31.430602874317202
            ],
            [
              -54.809405859864704,
              -31.430695434487035
            ],
            [
              -54.81171052814498,
              -31.43180615652506
            ],
            [
              -54.811396255197664,
              -31.433796200176516
            ],
            [
              -54.81181528579408,
              -31.4348143620447
            ],
            [
              -54.81438184819711,
              -31.434721801874865
            ],
            [
              -54.81579607646,
              -31.4356011234883
            ],
            [
              -54.82339100601998,
              -31.435878803997806
            ],
            [
              -54.82700514491405,
              -31.436295324762064
            ],
            [
              -54.82951932849252,
              -31.437313486630252
            ],
            [
              -54.832609679141065,
              -31.44078449299907
            ],
            [
              -54.833919149754855,
              -31.439997731555472
            ],
            [
              -54.83648571215789,
              -31.441895215037093
            ],
            [
              -54.83821421336809,
              -31.4405993726594
            ],
            [
              -54.840099851051946,
              -31.438377928583357
            ],
            [
              -54.84460442996338,
              -31.433981320516185
            ],
            [
              -54.84591390057717,
              -31.43101939508146
            ],
            [
              -54.84759002296283,
              -31.430510314147366
            ],
            [
              -54.85078513126047,
              -31.42509554421201
            ],
            [
              -54.8549754372246,
              -31.423614581494647
            ],
            [
              -54.85717534785577,
              -31.418199811559287
            ],
            [
              -54.86010856203066,
              -31.41870889249338
            ],
            [
              -54.86152279029355,
              -31.41792213104978
            ],
            [
              -54.86099900204804,
              -31.416117207737997
            ],
            [
              -54.85790865139949,
              -31.408018192877417
            ],
            [
              -54.86408935269658,
              -31.404315786084013
            ],
            [
              -54.868174901011606,
              -31.40301994370632
            ],
            [
              -54.869798644572704,
              -31.402094342007967
            ],
            [
              -54.878388771799166,
              -31.398114254705057
            ],
            [
              -54.88357427542978,
              -31.38918219831596
            ],
            [
              -54.88451709427171,
              -31.385896312286814
            ],
            [
              -54.88739792962205,
              -31.38321206736159
            ],
            [
              -54.88671700490288,
              -31.380898063115712
            ],
            [
              -54.8843075789735,
              -31.381083183455384
            ],
            [
              -54.88598370135915,
              -31.37728821649214
            ],
            [
              -54.890278764972386,
              -31.37728821649214
            ],
            [
              -54.89059303791969,
              -31.375714693604944
            ],
            [
              -54.89179775088438,
              -31.374789091906592
            ],
            [
              -54.895202374480235,
              -31.375020492331178
            ],
            [
              -54.89960219574257,
              -31.37631633470887
            ],
            [
              -54.89991646868988,
              -31.37812125802066
            ],
            [
              -54.89797845218147,
              -31.381407144049806
            ],
            [
              -54.90478769937318,
              -31.384091388975026
            ],
            [
              -54.90719712530255,
              -31.38131458387997
            ],
            [
              -54.908925626512755,
              -31.38099062328555
            ],
            [
              -54.912487386582264,
              -31.379602220738022
            ],
            [
              -54.914425403090675,
              -31.381083183455384
            ],
            [
              -54.918196678458386,
              -31.378908019464255
            ],
            [
              -54.92092037733507,
              -31.378908019464255
            ],
            [
              -54.92092037733507,
              -31.38001874150228
            ],
            [
              -54.92788676100044,
              -31.384507909739284
            ],
            [
              -54.93118662694719,
              -31.383721148295685
            ],
            [
              -54.93249609756098,
              -31.385109550843215
            ],
            [
              -54.93590072115683,
              -31.38381370846552
            ],
            [
              -54.936581645876004,
              -31.382008785153737
            ],
            [
              -54.94061481536647,
              -31.380620382606207
            ],
            [
              -54.94108622478744,
              -31.379278260143597
            ],
            [
              -54.93888631415627,
              -31.37788985759607
            ],
            [
              -54.937891116489794,
              -31.37617749445412
            ],
            [
              -54.939881511822755,
              -31.375298172840687
            ],
            [
              -54.93710543412152,
              -31.370114803329916
            ],
            [
              -54.93380556817477,
              -31.3692817618014
            ],
            [
              -54.933491295227455,
              -31.367291718149943
            ],
            [
              -54.93511503878856,
              -31.36442235288505
            ],
            [
              -54.936791161174206,
              -31.364190952460465
            ],
            [
              -54.93511503878856,
              -31.360303425327388
            ],
            [
              -54.936110236455036,
              -31.358683622355272
            ],
            [
              -54.93511503878856,
              -31.356508458364143
            ],
            [
              -54.93867679885807,
              -31.35410189394843
            ],
            [
              -54.94218618010302,
              -31.354796095222195
            ],
            [
              -54.9447003636815,
              -31.3542870142881
            ],
            [
              -54.9462193495935,
              -31.3535002528445
            ],
            [
              -54.94789547197915,
              -31.35410189394843
            ],
            [
              -54.949204942592935,
              -31.352713491400902
            ],
            [
              -54.95150961087321,
              -31.351695329532717
            ],
            [
              -54.952923839136105,
              -31.353315132504832
            ],
            [
              -54.952923839136105,
              -31.354610974882522
            ],
            [
              -54.956223705082856,
              -31.3535002528445
            ],
            [
              -54.956485599205614,
              -31.351695329532717
            ],
            [
              -54.957795069819404,
              -31.351695329532717
            ],
            [
              -54.95920929808229,
              -31.352482090976313
            ],
            [
              -54.96041401104698,
              -31.34910364477733
            ],
            [
              -54.95999498045057,
              -31.34780780239964
            ],
            [
              -54.961094935766155,
              -31.346697080361615
            ],
            [
              -54.95999498045057,
              -31.34567891849343
            ],
            [
              -54.959785465152365,
              -31.34378143501181
            ],
            [
              -54.960204495748776,
              -31.342022791784938
            ],
            [
              -54.958685509836776,
              -31.339616227369227
            ],
            [
              -54.95480947681996,
              -31.33970878753906
            ],
            [
              -54.952819081487,
              -31.3392922667748
            ],
            [
              -54.95329049090796,
              -31.337117102783676
            ],
            [
              -54.952819081487,
              -31.336098940915488
            ],
            [
              -54.95308097560976,
              -31.331980013357825
            ],
            [
              -54.95501899211817,
              -31.330221370130957
            ],
            [
              -54.957795069819404,
              -31.32439007943134
            ],
            [
              -54.95952357102961,
              -31.32318679722348
            ],
            [
              -54.96408052876559,
              -31.321381873911697
            ],
            [
              -54.9642900440638,
              -31.320595112468098
            ],
            [
              -54.96612330292311,
              -31.320317431958593
            ],
            [
              -54.97492294544777,
              -31.31689270567469
            ],
            [
              -54.977699023149015,
              -31.317586906948453
            ],
            [
              -54.978798978464596,
              -31.316985265844526
            ],
            [
              -54.98042272202569,
              -31.312403537437685
            ],
            [
              -54.98209884441135,
              -31.31231097726785
            ],
            [
              -54.98277976913052,
              -31.311385375569497
            ],
            [
              -54.98120840439397,
              -31.308192049710183
            ],
            [
              -54.98000369142928,
              -31.303008680199415
            ],
            [
              -54.98230835970955,
              -31.296112947546693
            ],
            [
              -54.98351307267424,
              -31.295696426782435
            ],
            [
              -54.98361783032334,
              -31.293984063640483
            ],
            [
              -54.985712983305405,
              -31.292410540753288
            ],
            [
              -54.989222364550365,
              -31.294122903895236
            ],
            [
              -54.989012849252155,
              -31.291901459819194
            ],
            [
              -54.993412670514495,
              -31.289911416167737
            ],
            [
              -54.994722141128285,
              -31.28792137251628
            ],
            [
              -54.99440786818097,
              -31.285885048779907
            ],
            [
              -54.994774519952834,
              -31.28310824368485
            ],
            [
              -54.998283901197794,
              -31.283478484364192
            ],
            [
              -55.00048381182896,
              -31.283015683515018
            ],
            [
              -55.00147900949544,
              -31.28158100088257
            ],
            [
              -55.00168852479364,
              -31.27699927247573
            ],
            [
              -55.00121711537268,
              -31.275009228824274
            ],
            [
              -55.00147900949544,
              -31.272510104238723
            ],
            [
              -55.00242182833737,
              -31.271214261861033
            ],
            [
              -55.00242182833737,
              -31.269177938124656
            ],
            [
              -55.00718830137156,
              -31.266910213963698
            ],
            [
              -55.008497771985354,
              -31.26991841948334
            ],
            [
              -55.011588122633896,
              -31.269085377954823
            ],
            [
              -55.01232142617762,
              -31.267882095746966
            ],
            [
              -55.015307019177065,
              -31.269316778379412
            ],
            [
              -55.01682600508906,
              -31.267511855067625
            ],
            [
              -55.02028300750946,
              -31.26700277413353
            ],
            [
              -55.02080679575498,
              -31.268622577105646
            ],
            [
              -55.023478115807116,
              -31.26950189871908
            ],
            [
              -55.028192210016755,
              -31.268992817784987
            ],
            [
              -55.031911106559924,
              -31.26968701905875
            ],
            [
              -55.031701591261715,
              -31.27158450254037
            ],
            [
              -55.032382515980885,
              -31.273620826276748
            ],
            [
              -55.036520443120466,
              -31.275703430098037
            ],
            [
              -55.03180634891082,
              -31.278619075447846
            ],
            [
              -55.03332533482281,
              -31.280007477995373
            ],
            [
              -55.03578713957674,
              -31.28389500512845
            ],
            [
              -55.034582426612054,
              -31.2871808911576
            ],
            [
              -55.03322057717371,
              -31.287504851752022
            ],
            [
              -55.032801546577296,
              -31.28949489540348
            ],
            [
              -55.033482471296466,
              -31.291484939054936
            ],
            [
              -55.03531573015577,
              -31.29199401998903
            ],
            [
              -55.036520443120466,
              -31.291484939054936
            ],
            [
              -55.036991852541426,
              -31.294122903895236
            ],
            [
              -55.03887749022528,
              -31.296483188226034
            ],
            [
              -55.0394012784708,
              -31.29791787085848
            ],
            [
              -55.03887749022528,
              -31.300509555613864
            ],
            [
              -55.04018696083907,
              -31.30268471960499
            ],
            [
              -55.04202021969838,
              -31.30328636070892
            ],
            [
              -55.04348682678582,
              -31.30518384419054
            ],
            [
              -55.04238687147024,
              -31.306988767502325
            ],
            [
              -55.043224932663065,
              -31.308377170049855
            ],
            [
              -55.04767713274995,
              -31.30731272809675
            ],
            [
              -55.04841043629368,
              -31.309302771748207
            ],
            [
              -55.050505589275744,
              -31.310598614125897
            ],
            [
              -55.05281025755601,
              -31.31110769505999
            ],
            [
              -55.052286469310495,
              -31.31207957684326
            ],
            [
              -55.05312453050332,
              -31.313884500155048
            ],
            [
              -55.05862430708124,
              -31.31397706032488
            ],
            [
              -55.05862430708124,
              -31.31499522219307
            ],
            [
              -55.06009091416868,
              -31.315411742957327
            ],
            [
              -55.058414791783036,
              -31.318095987882547
            ],
            [
              -55.057105321169246,
              -31.319299270090404
            ],
            [
              -55.057576730590206,
              -31.322122355270377
            ],
            [
              -55.059095716502206,
              -31.323695878157576
            ],
            [
              -55.061819415378885,
              -31.32471404002576
            ],
            [
              -55.05920047415131,
              -31.326981764186723
            ],
            [
              -55.0589909588531,
              -31.328277606564416
            ],
            [
              -55.05741959411655,
              -31.33170233284832
            ],
            [
              -55.06019567181779,
              -31.332303973952246
            ],
            [
              -55.06428122013281,
              -31.331794893018152
            ],
            [
              -55.064700250729224,
              -31.330591610810295
            ],
            [
              -55.06590496369391,
              -31.330221370130957
            ],
            [
              -55.06831438962329,
              -31.331008131574553
            ],
            [
              -55.07051430025445,
              -31.331008131574553
            ],
            [
              -55.07449509092038,
              -31.332118853612577
            ],
            [
              -55.07538553093775,
              -31.32989740953653
            ],
            [
              -55.077690199218026,
              -31.327722245545406
            ],
            [
              -55.080623413392914,
              -31.326981764186723
            ],
            [
              -55.0816186110594,
              -31.325593361639196
            ],
            [
              -55.08119958046298,
              -31.324482639601175
            ],
            [
              -55.08360900639236,
              -31.32439007943134
            ],
            [
              -55.08601843232173,
              -31.322677716289387
            ],
            [
              -55.085704159374416,
              -31.321104193402192
            ],
            [
              -55.08769455470738,
              -31.32091907306252
            ],
            [
              -55.08910878297027,
              -31.31939183026024
            ],
            [
              -55.090103980636755,
              -31.320595112468098
            ],
            [
              -55.091203935952336,
              -31.320086031534004
            ],
            [
              -55.09178010302241,
              -31.31781830737304
            ],
            [
              -55.09638943958295,
              -31.316291064570763
            ],
            [
              -55.09848459256501,
              -31.316198504400926
            ],
            [
              -55.098903623161426,
              -31.314486141258975
            ],
            [
              -55.10277965617824,
              -31.31499522219307
            ],
            [
              -55.10398436914293,
              -31.312218417098013
            ],
            [
              -55.1062890374232,
              -31.31041349378623
            ],
            [
              -55.10607952212499,
              -31.309302771748207
            ],
            [
              -55.10901273629988,
              -31.30768296877609
            ],
            [
              -55.113779209334076,
              -31.311200255229828
            ],
            [
              -55.11781237882455,
              -31.31207957684326
            ],
            [
              -55.119488501210206,
              -31.311616775994086
            ],
            [
              -55.12210744243778,
              -31.312820058201943
            ],
            [
              -55.12189792713958,
              -31.308793690814113
            ],
            [
              -55.122421715385094,
              -31.304906163681036
            ],
            [
              -55.12430735306895,
              -31.303888001812847
            ],
            [
              -55.125773960156394,
              -31.302407039095485
            ],
            [
              -55.1276072190157,
              -31.303008680199415
            ],
            [
              -55.12938809905046,
              -31.30189795816139
            ],
            [
              -55.13221655557624,
              -31.301990518331227
            ],
            [
              -55.13467836033017,
              -31.300879796293206
            ],
            [
              -55.13651161918948,
              -31.301296317057464
            ],
            [
              -55.1404924098554,
              -31.297593910264055
            ],
            [
              -55.14468271581953,
              -31.296899708990292
            ],
            [
              -55.14599218643332,
              -31.296298067886365
            ],
            [
              -55.14578267113511,
              -31.295279906018177
            ],
            [
              -55.147615929994416,
              -31.29430802423491
            ],
            [
              -55.14929205238007,
              -31.29518734584834
            ],
            [
              -55.152277645379506,
              -31.293197302196887
            ],
            [
              -55.152487160677715,
              -31.289217214893974
            ],
            [
              -55.15662508781729,
              -31.285422247930732
            ],
            [
              -55.16060587848321,
              -31.284404086062544
            ],
            [
              -55.163591471482654,
              -31.285699928440238
            ],
            [
              -55.164691426798235,
              -31.2821826419865
            ],
            [
              -55.16631517035934,
              -31.281118200033394
            ],
            [
              -55.16542473034196,
              -31.280007477995373
            ],
            [
              -55.16380098678086,
              -31.28010003816521
            ],
            [
              -55.16301530441259,
              -31.279220716551773
            ],
            [
              -55.16411525972817,
              -31.275981110607542
            ],
            [
              -55.16547710916651,
              -31.2756108699282
            ],
            [
              -55.16940552100788,
              -31.271908463134796
            ],
            [
              -55.16940552100788,
              -31.269409338549245
            ],
            [
              -55.17422437286663,
              -31.268206056341388
            ],
            [
              -55.17548146465587,
              -31.269409338549245
            ],
            [
              -55.17647666232235,
              -31.269409338549245
            ],
            [
              -55.18009080121641,
              -31.270520060587266
            ],
            [
              -55.179881285918206,
              -31.268807697445318
            ],
            [
              -55.1830240153913,
              -31.267696975407294
            ],
            [
              -55.18380969775957,
              -31.265382971161415
            ],
            [
              -55.188785686091975,
              -31.265382971161415
            ],
            [
              -55.19339502265252,
              -31.264688769887652
            ],
            [
              -55.19538541798548,
              -31.26339292750996
            ],
            [
              -55.19569969093279,
              -31.264503649547983
            ],
            [
              -55.199209072177744,
              -31.264179688953558
            ],
            [
              -55.200518542791535,
              -31.263809448274216
            ],
            [
              -55.200518542791535,
              -31.262513605896526
            ],
            [
              -55.203399378141874,
              -31.261911964792596
            ],
            [
              -55.20947532178986,
              -31.26242104572669
            ],
            [
              -55.21151809594737,
              -31.262282205471937
            ],
            [
              -55.21371800657854,
              -31.26320780717029
            ],
            [
              -55.217803554893564,
              -31.261819404622763
            ],
            [
              -55.221784345559485,
              -31.261588004198174
            ],
            [
              -55.224403286787066,
              -31.26107892326408
            ],
            [
              -55.2286983504003,
              -31.259783080886386
            ],
            [
              -55.23362195990815,
              -31.259412840207048
            ],
            [
              -55.2352980822938,
              -31.25839467833886
            ],
            [
              -55.23807415999504,
              -31.26168056436801
            ],
            [
              -55.240116934152546,
              -31.260616122414906
            ],
            [
              -55.23912173648607,
              -31.257515356725428
            ],
            [
              -55.24027407062621,
              -31.25571043341364
            ],
            [
              -55.240378828275304,
              -31.253720389762183
            ],
            [
              -55.24378345187116,
              -31.252193146959904
            ],
            [
              -55.24682142369515,
              -31.252193146959904
            ],
            [
              -55.246978560168806,
              -31.250203103308447
            ],
            [
              -55.24860230372991,
              -31.24821305965699
            ],
            [
              -55.24750234841432,
              -31.245991615580948
            ],
            [
              -55.248078515484394,
              -31.244695773203254
            ],
            [
              -55.24891657667722,
              -31.24117848674952
            ],
            [
              -55.24729283311612,
              -31.237800040550535
            ],
            [
              -55.24729283311612,
              -31.23539347613482
            ],
            [
              -55.24661190839695,
              -31.233310872313528
            ],
            [
              -55.24729283311612,
              -31.229284504925698
            ],
            [
              -55.24902133432632,
              -31.227201901104408
            ],
            [
              -55.24891657667722,
              -31.22558209813229
            ],
            [
              -55.24729283311612,
              -31.224517656179188
            ],
            [
              -55.24729283311612,
              -31.221278050234954
            ],
            [
              -55.24881181902811,
              -31.218408684970065
            ],
            [
              -55.24771186371253,
              -31.21600212055435
            ],
            [
              -55.248497546080806,
              -31.21391951673306
            ],
            [
              -55.2501212896419,
              -31.21581700021468
            ],
            [
              -55.251378381431145,
              -31.21521535911075
            ],
            [
              -55.25158789672935,
              -31.213179035374377
            ],
            [
              -55.25310688264135,
              -31.212484834100614
            ],
            [
              -55.253997322658726,
              -31.211096431553088
            ],
            [
              -55.25158789672935,
              -31.20818078620328
            ],
            [
              -55.2501212896419,
              -31.206005622212153
            ],
            [
              -55.25132600260659,
              -31.204802340004296
            ],
            [
              -55.25368304971141,
              -31.20392301839086
            ],
            [
              -55.25577820269348,
              -31.201377613720393
            ],
            [
              -55.25698291565816,
              -31.19818428786108
            ],
            [
              -55.25860665921927,
              -31.197119845907974
            ],
            [
              -55.261592252218705,
              -31.196610764973883
            ],
            [
              -55.26279696518339,
              -31.19471328149226
            ],
            [
              -55.265101633463665,
              -31.19489840183193
            ],
            [
              -55.266201588779246,
              -31.195777723445364
            ],
            [
              -55.271020440638,
              -31.195916563700116
            ],
            [
              -55.27442506423385,
              -31.194111640388332
            ],
            [
              -55.278877264320734,
              -31.1950835221716
            ],
            [
              -55.279924840811766,
              -31.193880239963743
            ],
            [
              -55.282700918513,
              -31.193880239963743
            ],
            [
              -55.282700918513,
              -31.19221415690671
            ],
            [
              -55.283696116179485,
              -31.189900152660833
            ],
            [
              -55.283696116179485,
              -31.18800266917921
            ],
            [
              -55.285686511512445,
              -31.18550354459366
            ],
            [
              -55.28380087382859,
              -31.184392822555637
            ],
            [
              -55.28191523614473,
              -31.183883741621546
            ],
            [
              -55.27641545956681,
              -31.17842269160127
            ],
            [
              -55.27191088065537,
              -31.178700372110775
            ],
            [
              -55.271020440638,
              -31.176988008968824
            ],
            [
              -55.27191088065537,
              -31.17282280132624
            ],
            [
              -55.27468695835661,
              -31.17018483648594
            ],
            [
              -55.2761011866195,
              -31.17148067886363
            ],
            [
              -55.27830109725067,
              -31.170092276316105
            ],
            [
              -55.28071052318004,
              -31.1698145958066
            ],
            [
              -55.285005586793275,
              -31.166297309352863
            ],
            [
              -55.284377040898654,
              -31.164816346635497
            ],
            [
              -55.28861972568733,
              -31.16578822841877
            ],
            [
              -55.28872448333644,
              -31.16439982587124
            ],
            [
              -55.29061012102029,
              -31.163705624597476
            ],
            [
              -55.2907148786694,
              -31.162780022899124
            ],
            [
              -55.288986377459196,
              -31.161113939842092
            ],
            [
              -55.29008633277478,
              -31.159216456360472
            ],
            [
              -55.28531985974058,
              -31.1563933711805
            ],
            [
              -55.28799117979271,
              -31.152505844047422
            ],
            [
              -55.29050536337119,
              -31.15019183980154
            ],
            [
              -55.29040060572209,
              -31.14787783555566
            ],
            [
              -55.28971968100292,
              -31.145286150800278
            ],
            [
              -55.29040060572209,
              -31.144499389356678
            ],
            [
              -55.29092439396761,
              -31.142277945280632
            ],
            [
              -55.294119502265254,
              -31.14431426901701
            ],
            [
              -55.29752412586111,
              -31.144406829186842
            ],
            [
              -55.301609674176134,
              -31.143388667318657
            ],
            [
              -55.30522381307019,
              -31.140982102902942
            ],
            [
              -55.306690420157636,
              -31.143388667318657
            ],
            [
              -55.31150927201639,
              -31.145517551224867
            ],
            [
              -55.31171878731459,
              -31.14732247453665
            ],
            [
              -55.31297587910383,
              -31.14699851394223
            ],
            [
              -55.31391869794576,
              -31.145795231734372
            ],
            [
              -55.31659001799789,
              -31.146119192328793
            ],
            [
              -55.31858041333085,
              -31.14510103046061
            ],
            [
              -55.318685170979954,
              -31.140982102902942
            ],
            [
              -55.31789948861168,
              -31.139917660949838
            ],
            [
              -55.32078032396202,
              -31.13579873339217
            ],
            [
              -55.322194552224914,
              -31.137094575769865
            ],
            [
              -55.32392305343512,
              -31.136307814326265
            ],
            [
              -55.326175342890835,
              -31.138020177468217
            ],
            [
              -55.329894239434,
              -31.13579873339217
            ],
            [
              -55.33057516415317,
              -31.134410330844645
            ],
            [
              -55.33429406069634,
              -31.13279052787253
            ],
            [
              -55.33617969838019,
              -31.13279052787253
            ],
            [
              -55.33848436666046,
              -31.13371612957088
            ],
            [
              -55.340108110221564,
              -31.131402125325
            ],
            [
              -55.33827485136226,
              -31.13029140328698
            ],
            [
              -55.33848436666046,
              -31.1279773990411
            ],
            [
              -55.33958432197605,
              -31.127098077427664
            ],
            [
              -55.33827485136226,
              -31.125894795219807
            ],
            [
              -55.338379609011355,
              -31.123488230804092
            ],
            [
              -55.337017759573015,
              -31.119878384180524
            ],
            [
              -55.33067992180227,
              -31.117379259594973
            ],
            [
              -55.32978948178489,
              -31.116499937981537
            ],
            [
              -55.33099419474958,
              -31.11529665577368
            ],
            [
              -55.33109895239868,
              -31.112797531188132
            ],
            [
              -55.32868952646931,
              -31.110390966772417
            ],
            [
              -55.329894239434,
              -31.109696765498654
            ],
            [
              -55.329684724135795,
              -31.107891842186866
            ],
            [
              -55.33277507478434,
              -31.105300157431483
            ],
            [
              -55.33387503009992,
              -31.105022476921977
            ],
            [
              -55.333089347731644,
              -31.102291951911837
            ],
            [
              -55.332984590082546,
              -31.100301908260384
            ],
            [
              -55.33350837832806,
              -31.09868210528827
            ],
            [
              -55.33230366536337,
              -31.09729370274074
            ],
            [
              -55.33188463476696,
              -31.09521109891945
            ],
            [
              -55.32832287469745,
              -31.093498735777498
            ],
            [
              -55.329684724135795,
              -31.092017773060135
            ],
            [
              -55.328375253522005,
              -31.091416131956205
            ],
            [
              -55.327484813504626,
              -31.088222806096894
            ],
            [
              -55.32900379941662,
              -31.087991405672305
            ],
            [
              -55.3299989970831,
              -31.087019523889037
            ],
            [
              -55.33382265127537,
              -31.08581624168118
            ],
            [
              -55.33602256190654,
              -31.085677401426427
            ],
            [
              -55.339008154905976,
              -31.085122040407413
            ],
            [
              -55.33947956432694,
              -31.08331711709563
            ],
            [
              -55.341208065537145,
              -31.082622915821865
            ],
            [
              -55.34419365853659,
              -31.079013069198293
            ],
            [
              -55.34550312915037,
              -31.07558834291439
            ],
            [
              -55.34979819276361,
              -31.072302456885243
            ],
            [
              -55.35058387513188,
              -31.070312413233786
            ],
            [
              -55.35021722336002,
              -31.067813288648235
            ],
            [
              -55.35131717867561,
              -31.06758188822365
            ],
            [
              -55.35267902811395,
              -31.070404973403623
            ],
            [
              -55.354721802271456,
              -31.069016570856093
            ],
            [
              -55.36011682120027,
              -31.067396767883977
            ],
            [
              -55.35859783528828,
              -31.062583639052548
            ],
            [
              -55.35639792465711,
              -31.06198199794862
            ],
            [
              -55.35278378576305,
              -31.057215149202108
            ],
            [
              -55.35320281635946,
              -31.053697862748372
            ],
            [
              -55.35178858809657,
              -31.050782217398563
            ],
            [
              -55.3512124210265,
              -31.050504536889058
            ],
            [
              -55.350112465710914,
              -31.048283092813016
            ],
            [
              -55.350321981009124,
              -31.04721865085991
            ],
            [
              -55.34880299509713,
              -31.042914602962576
            ],
            [
              -55.350112465710914,
              -31.040600598716697
            ],
            [
              -55.349379162167196,
              -31.039212196169167
            ],
            [
              -55.351421936324705,
              -31.037592393197052
            ],
            [
              -55.35419801402594,
              -31.039212196169167
            ],
            [
              -55.35749787997269,
              -31.040415478377025
            ],
            [
              -55.35948827530566,
              -31.040184077952436
            ],
            [
              -55.360483472972135,
              -31.039212196169167
            ],
            [
              -55.3625786259542,
              -31.03898079574458
            ],
            [
              -55.36357382362068,
              -31.03569490971543
            ],
            [
              -55.36708320486564,
              -31.035602349545595
            ],
            [
              -55.369283115496806,
              -31.034399067337738
            ],
            [
              -55.37247822379445,
              -31.030696660544333
            ],
            [
              -55.37342104263638,
              -31.028012415619113
            ],
            [
              -55.37310676968907,
              -31.026207492307325
            ],
            [
              -55.371325889654315,
              -31.023384407127352
            ],
            [
              -55.37389245205735,
              -31.019080359230017
            ],
            [
              -55.37520192267114,
              -31.021810884240153
            ],
            [
              -55.38002077452988,
              -31.02347696729719
            ],
            [
              -55.38321588282753,
              -31.022782766023425
            ],
            [
              -55.38630623347608,
              -31.020422481692627
            ],
            [
              -55.387196673493456,
              -31.0206076020323
            ],
            [
              -55.39248693477317,
              -31.025790971543067
            ],
            [
              -55.395420148948055,
              -31.026392612646998
            ],
            [
              -55.39992472785949,
              -31.02861405672304
            ],
            [
              -55.40071041022777,
              -31.027179374090593
            ],
            [
              -55.40212463849066,
              -31.02750333468502
            ],
            [
              -55.4049007161919,
              -31.02731821434535
            ],
            [
              -55.40589591385837,
              -31.021209243136227
            ],
            [
              -55.40689111152486,
              -31.021486923645732
            ],
            [
              -55.40668159622665,
              -31.018710118550676
            ],
            [
              -55.41129093278719,
              -31.017599396512654
            ],
            [
              -55.41411938931298,
              -31.015609352861198
            ],
            [
              -55.414905071681254,
              -31.014498630823176
            ],
            [
              -55.418204937628005,
              -31.015609352861198
            ],
            [
              -55.419304892943586,
              -31.01500771175727
            ],
            [
              -55.42192383417117,
              -31.016210993965128
            ],
            [
              -55.42318092596041,
              -31.01810847744675
            ],
            [
              -55.42501418481971,
              -31.016488674474633
            ],
            [
              -55.42480466952151,
              -31.014822591417598
            ],
            [
              -55.42559035188978,
              -31.013804429549413
            ],
            [
              -55.42527607894247,
              -31.01172182572812
            ],
            [
              -55.430618719046734,
              -31.01019458292584
            ],
            [
              -55.4309853708186,
              -31.00769545834029
            ],
            [
              -55.43700893564203,
              -31.00468725282065
            ],
            [
              -55.43638038974741,
              -31.003206290103286
            ],
            [
              -55.434389994414445,
              -31.000892285857407
            ],
            [
              -55.435018540309066,
              -30.998809682036114
            ],
            [
              -55.43690417799293,
              -30.995801476516473
            ],
            [
              -55.437480345062994,
              -30.99432051379911
            ],
            [
              -55.43601373797555,
              -30.9921916298929
            ],
            [
              -55.432399599081485,
              -30.992885831166664
            ],
            [
              -55.42878546018743,
              -30.99001646590177
            ],
            [
              -55.429099733134734,
              -30.986684299787708
            ],
            [
              -55.42679506485447,
              -30.985388457410014
            ],
            [
              -55.4245951542233,
              -30.985619857834603
            ],
            [
              -55.42669030720536,
              -30.981315809937268
            ],
            [
              -55.427685504871846,
              -30.98108440951268
            ],
            [
              -55.43161391671322,
              -30.97821504424779
            ],
            [
              -55.432923387327,
              -30.974882878133723
            ],
            [
              -55.432923387327,
              -30.972707714142594
            ],
            [
              -55.43580422267734,
              -30.971411871764904
            ],
            [
              -55.438108890957615,
              -30.97261515397276
            ],
            [
              -55.4375851027121,
              -30.969282987858694
            ],
            [
              -55.43957549804506,
              -30.96669130310331
            ],
            [
              -55.4395231192205,
              -30.964701259451854
            ],
            [
              -55.44119924160616,
              -30.962803775970233
            ],
            [
              -55.44130399925526,
              -30.959703010280755
            ],
            [
              -55.4443943499038,
              -30.958499728072898
            ],
            [
              -55.4458085781667,
              -30.95900880900699
            ],
            [
              -55.44821800409607,
              -30.958916248837156
            ],
            [
              -55.45151787004282,
              -30.96048977172435
            ],
            [
              -55.45261782535841,
              -30.958777408582403
            ],
            [
              -55.45209403711289,
              -30.957898086968967
            ],
            [
              -55.4572795407435,
              -30.951418875080506
            ],
            [
              -55.45837949605908,
              -30.95169655559001
            ],
            [
              -55.46209839260225,
              -30.950308153042485
            ],
            [
              -55.464717333829824,
              -30.950678393721823
            ],
            [
              -55.46639345621548,
              -30.953084958137538
            ],
            [
              -55.46901239744306,
              -30.95461220093982
            ],
            [
              -55.47032186805685,
              -30.954288240345395
            ],
            [
              -55.47252177868802,
              -30.952622157288364
            ],
            [
              -55.47739300937132,
              -30.952622157288364
            ],
            [
              -55.478388207037796,
              -30.9537791594113
            ],
            [
              -55.4867164401415,
              -30.947716468287098
            ],
            [
              -55.486611682492395,
              -30.945680144550725
            ],
            [
              -55.48729260721157,
              -30.941885177587483
            ],
            [
              -55.489702033140944,
              -30.93980257376619
            ],
            [
              -55.489021108421774,
              -30.937581129690148
            ],
            [
              -55.48959727549184,
              -30.9335084822174
            ],
            [
              -55.48781639545709,
              -30.93119447797152
            ],
            [
              -55.48640216719419,
              -30.92827883262171
            ],
            [
              -55.48860207782536,
              -30.925409467356822
            ],
            [
              -55.493682823806864,
              -30.92471526608306
            ],
            [
              -55.49792550859554,
              -30.92661274956468
            ],
            [
              -55.49949687333209,
              -30.926890430074184
            ],
            [
              -55.501801541612366,
              -30.925409467356822
            ],
            [
              -55.50421096754174,
              -30.92480782625289
            ],
            [
              -55.50578233227829,
              -30.922678942346685
            ],
            [
              -55.50698704524297,
              -30.920087257591298
            ],
            [
              -55.50662039347111,
              -30.918282334279514
            ],
            [
              -55.50751083348849,
              -30.917079052071657
            ],
            [
              -55.50829651585676,
              -30.914394807146437
            ],
            [
              -55.50929171352324,
              -30.91397828638218
            ],
            [
              -55.510077395891514,
              -30.91129404145696
            ],
            [
              -55.51039166883883,
              -30.906203232116024
            ],
            [
              -55.508087000558554,
              -30.904999949908166
            ],
            [
              -55.508087000558554,
              -30.904305748634403
            ],
            [
              -55.51018215354062,
              -30.901806624048852
            ],
            [
              -55.51699140073233,
              -30.898705858359374
            ],
            [
              -55.518877038416186,
              -30.89838189776495
            ],
            [
              -55.52139122199466,
              -30.898890978699043
            ],
            [
              -55.52500536088873,
              -30.89801165708561
            ],
            [
              -55.52720527151989,
              -30.900001700737064
            ],
            [
              -55.529300424501955,
              -30.8993074994633
            ],
            [
              -55.529719455098366,
              -30.900186821076737
            ],
            [
              -55.532809805746915,
              -30.902176864728194
            ],
            [
              -55.534119276360705,
              -30.898613298189538
            ],
            [
              -55.533700245764294,
              -30.897317455811844
            ],
            [
              -55.53668583876373,
              -30.89551253250006
            ],
            [
              -55.53710486936014,
              -30.8958827731794
            ],
            [
              -55.545904511884814,
              -30.89051428332896
            ],
            [
              -55.54841869546329,
              -30.886996996875226
            ],
            [
              -55.54999006019984,
              -30.885608594327696
            ],
            [
              -55.551823319059146,
              -30.882692948977887
            ],
            [
              -55.551404288462734,
              -30.880610345156597
            ],
            [
              -55.55260900142742,
              -30.878897982014646
            ],
            [
              -55.551823319059146,
              -30.876815378193356
            ],
            [
              -55.55480891205859,
              -30.872603890465854
            ],
            [
              -55.557584989759825,
              -30.87190968919209
            ],
            [
              -55.55988965804009,
              -30.870613846814397
            ],
            [
              -55.56109437100478,
              -30.86890148367245
            ],
            [
              -55.563608554583254,
              -30.868716363332776
            ],
            [
              -55.56350379693416,
              -30.864782556114783
            ],
            [
              -55.56460375224974,
              -30.862977632802995
            ],
            [
              -55.563608554583254,
              -30.8606173484722
            ],
            [
              -55.56428947930243,
              -30.85959918660401
            ],
            [
              -55.56470850989884,
              -30.85682238150896
            ],
            [
              -55.56308476633774,
              -30.855387698876513
            ],
            [
              -55.56397520635512,
              -30.853397655225056
            ],
            [
              -55.56528467696891,
              -30.852703453951293
            ],
            [
              -55.56612273816173,
              -30.848399406053957
            ],
            [
              -55.56727507230187,
              -30.845391200534312
            ],
            [
              -55.57188440886241,
              -30.845992841638243
            ],
            [
              -55.57361291007261,
              -30.843216036543186
            ],
            [
              -55.57518427480916,
              -30.842290434844834
            ],
            [
              -55.57738418544033,
              -30.843216036543186
            ],
            [
              -55.57769845838764,
              -30.841688793740907
            ],
            [
              -55.57932220194874,
              -30.84011527085371
            ],
            [
              -55.57848414075591,
              -30.837893826777666
            ],
            [
              -55.57701753366847,
              -30.837107065334067
            ],
            [
              -55.57717467014212,
              -30.83590378312621
            ],
            [
              -55.57822224663315,
              -30.834978181427857
            ],
            [
              -55.577488943089435,
              -30.83340465854066
            ],
            [
              -55.578588898405016,
              -30.832895577606564
            ],
            [
              -55.58518863029852,
              -30.835996343296042
            ],
            [
              -55.585712418544034,
              -30.837708706437994
            ],
            [
              -55.58738854092969,
              -30.838495467881593
            ],
            [
              -55.586812373859615,
              -30.841179712806813
            ],
            [
              -55.59068840687644,
              -30.840902032297308
            ],
            [
              -55.59461681871781,
              -30.84279951577893
            ],
            [
              -55.59561201638429,
              -30.844187918326455
            ],
            [
              -55.5992785341029,
              -30.84608540180808
            ],
            [
              -55.600116595295724,
              -30.847612644610358
            ],
            [
              -55.60121655061131,
              -30.8471961238461
            ],
            [
              -55.604725931856265,
              -30.84890848698805
            ],
            [
              -55.60451641655806,
              -30.84988036877132
            ],
            [
              -55.60682108483833,
              -30.849695248431647
            ],
            [
              -55.608025797803016,
              -30.848121725544452
            ],
            [
              -55.61080187550425,
              -30.84830684588412
            ],
            [
              -55.61232086141625,
              -30.84608540180808
            ],
            [
              -55.613106543784525,
              -30.843216036543186
            ],
            [
              -55.61541121206479,
              -30.84261439543926
            ],
            [
              -55.61981103332713,
              -30.84238299501467
            ],
            [
              -55.62122526159002,
              -30.841688793740907
            ],
            [
              -55.62248235337926,
              -30.842197874675
            ],
            [
              -55.62311089927388,
              -30.844419318751044
            ],
            [
              -55.624210854589464,
              -30.84580772129857
            ],
            [
              -55.6287154335009,
              -30.8479828852897
            ],
            [
              -55.63028679823745,
              -30.8464093624025
            ],
            [
              -55.63259146651772,
              -30.845206080194643
            ],
            [
              -55.637881727797435,
              -30.84617796197791
            ],
            [
              -55.63929595606032,
              -30.84849196622379
            ],
            [
              -55.643014852603486,
              -30.84988036877132
            ],
            [
              -55.646576612673,
              -30.854786057772582
            ],
            [
              -55.645214763234655,
              -30.857609142952555
            ],
            [
              -55.64888128095327,
              -30.865106516709204
            ],
            [
              -55.64998123626885,
              -30.86598583832264
            ],
            [
              -55.65218114690002,
              -30.86598583832264
            ],
            [
              -55.65170973747905,
              -30.864504875605277
            ],
            [
              -55.655585770495875,
              -30.863579273906925
            ],
            [
              -55.65778568112704,
              -30.863810674331514
            ],
            [
              -55.65930466703904,
              -30.86621723874723
            ],
            [
              -55.66071889530193,
              -30.86899404384228
            ],
            [
              -55.663075942406756,
              -30.87190968919209
            ],
            [
              -55.663180700055854,
              -30.873899732843547
            ],
            [
              -55.66040462235462,
              -30.87459393411731
            ],
            [
              -55.65909515174083,
              -30.876815378193356
            ],
            [
              -55.657576165828836,
              -30.878712861674977
            ],
            [
              -55.652914450443745,
              -30.883294590081817
            ],
            [
              -55.65569052814498,
              -30.884914393053933
            ],
            [
              -55.6532811022156,
              -30.88958868163061
            ],
            [
              -55.65401440575933,
              -30.89051428332896
            ],
            [
              -55.653385859864706,
              -30.89181012570665
            ],
            [
              -55.654904845776706,
              -30.892411766810582
            ],
            [
              -55.65401440575933,
              -30.896576974453165
            ],
            [
              -55.65191925277726,
              -30.896715814707918
            ],
            [
              -55.65040026686526,
              -30.89990914056723
            ],
            [
              -55.651185949233536,
              -30.901204982944922
            ],
            [
              -55.648724144479615,
              -30.901390103284594
            ],
            [
              -55.648095598584995,
              -30.902685945662284
            ],
            [
              -55.64987647861975,
              -30.904305748634403
            ],
            [
              -55.648095598584995,
              -30.906712313050114
            ],
            [
              -55.64500524793645,
              -30.908980037211077
            ],
            [
              -55.64568617265562,
              -30.9100907592491
            ],
            [
              -55.64338150437535,
              -30.910414719843523
            ],
            [
              -55.642124412586114,
              -30.91161800205138
            ],
            [
              -55.64348626202445,
              -30.912821284259238
            ],
            [
              -55.64270057965618,
              -30.914394807146437
            ],
            [
              -55.64380053497176,
              -30.916014610118552
            ],
            [
              -55.64531952088376,
              -30.916893931731984
            ],
            [
              -55.64579093030473,
              -30.91800465377001
            ],
            [
              -55.647205158567616,
              -30.918606294873936
            ],
            [
              -55.64767656798858,
              -30.920318658015887
            ],
            [
              -55.64689088562031,
              -30.920920299119814
            ],
            [
              -55.6484098715323,
              -30.923002902941107
            ],
            [
              -55.651395464531745,
              -30.923002902941107
            ],
            [
              -55.653385859864706,
              -30.925178066932233
            ],
            [
              -55.65600480109229,
              -30.924900386422728
            ],
            [
              -55.656319074039594,
              -30.926103668630585
            ],
            [
              -55.65930466703904,
              -30.930315156358084
            ],
            [
              -55.66087603177559,
              -30.930500276697757
            ],
            [
              -55.66218550238938,
              -30.93137959831119
            ],
            [
              -55.66349497300317,
              -30.933184521622977
            ],
            [
              -55.662499775336684,
              -30.934711764425256
            ],
            [
              -55.66328545770496,
              -30.935498525868855
            ],
            [
              -55.66029986470552,
              -30.940080254275696
            ],
            [
              -55.66019510705642,
              -30.942810779285836
            ],
            [
              -55.65862374231987,
              -30.943782661069104
            ],
            [
              -55.66098078942469,
              -30.946698306418913
            ],
            [
              -55.66171409296841,
              -30.948595789900534
            ],
            [
              -55.663809245950475,
              -30.946790866588746
            ],
            [
              -55.66522347421337,
              -30.94790158862677
            ],
            [
              -55.664490170669644,
              -30.948919750494955
            ],
            [
              -55.66621867187985,
              -30.95401055983589
            ],
            [
              -55.66899474958109,
              -30.953316358562127
            ],
            [
              -55.67182320610687,
              -30.953594039071632
            ],
            [
              -55.67171844845777,
              -30.955306402213584
            ],
            [
              -55.67370884379073,
              -30.956093163657183
            ],
            [
              -55.676223027369204,
              -30.956093163657183
            ],
            [
              -55.68627976168312,
              -30.952390756863775
            ],
            [
              -55.68847967231428,
              -30.952390756863775
            ],
            [
              -55.68957962762987,
              -30.947207387353004
            ],
            [
              -55.688793945261594,
              -30.944893383107125
            ],
            [
              -55.69492226773413,
              -30.9435049805596
            ],
            [
              -55.69727931483895,
              -30.946605746249077
            ],
            [
              -55.69717455718985,
              -30.94831810939103
            ],
            [
              -55.69911257369826,
              -30.948595789900534
            ],
            [
              -55.7005791807857,
              -30.949521391598886
            ],
            [
              -55.70068393843481,
              -30.951603995420175
            ],
            [
              -55.70277909141687,
              -30.952992397967705
            ],
            [
              -55.70398380438156,
              -30.955213842043747
            ],
            [
              -55.707178912679204,
              -30.95438080051523
            ],
            [
              -55.70969309625768,
              -30.95461220093982
            ],
            [
              -55.710478778625955,
              -30.952714717458196
            ],
            [
              -55.71100256687147,
              -30.94998419244806
            ],
            [
              -55.71210252218705,
              -30.948780910240203
            ],
            [
              -55.71430243281822,
              -30.94841066956086
            ],
            [
              -55.71639758580029,
              -30.946004105145146
            ],
            [
              -55.71582141873022,
              -30.944893383107125
            ],
            [
              -55.715978555203876,
              -30.942995899625505
            ],
            [
              -55.71880701172966,
              -30.941607497077978
            ],
            [
              -55.72011648234345,
              -30.941792617417647
            ],
            [
              -55.72231639297462,
              -30.942995899625505
            ],
            [
              -55.723206832992,
              -30.944476862342867
            ],
            [
              -55.72100692236083,
              -30.94558758438089
            ],
            [
              -55.72210687767641,
              -30.94901231066479
            ],
            [
              -55.72451630360579,
              -30.951187474655917
            ],
            [
              -55.724411545956684,
              -30.953408918731963
            ],
            [
              -55.722421150623724,
              -30.95729644586504
            ],
            [
              -55.72587815304413,
              -30.962711215800397
            ],
            [
              -55.724411545956684,
              -30.965997101829544
            ],
            [
              -55.72650669893875,
              -30.96821854590559
            ],
            [
              -55.727501896605226,
              -30.96821854590559
            ],
            [
              -55.731482687271146,
              -30.974096116690124
            ],
            [
              -55.73111603549929,
              -30.975808479832075
            ],
            [
              -55.72912564016632,
              -30.97779852348353
            ],
            [
              -55.7282875789735,
              -30.97951088662548
            ],
            [
              -55.733892113200525,
              -30.9814083701071
            ],
            [
              -55.73687770619996,
              -30.97988112730482
            ],
            [
              -55.738815722708374,
              -30.98011252772941
            ],
            [
              -55.74112039098864,
              -30.978816685351717
            ],
            [
              -55.744315499286294,
              -30.978816685351717
            ],
            [
              -55.74662016756656,
              -30.97951088662548
            ],
            [
              -55.74751060758394,
              -30.981176969682515
            ],
            [
              -55.74599162167194,
              -30.983120733249052
            ],
            [
              -55.74578210637374,
              -30.985295897240178
            ],
            [
              -55.74719633463663,
              -30.98890574386375
            ],
            [
              -55.74882007819773,
              -30.989090864203423
            ],
            [
              -55.74908197232049,
              -30.990386706581113
            ],
            [
              -55.75060095823248,
              -30.991682548958806
            ],
            [
              -55.750077169986966,
              -30.99450563413878
            ],
            [
              -55.75222470179359,
              -30.997421279488588
            ],
            [
              -55.75348179358282,
              -30.998022920592515
            ],
            [
              -55.75667690188047,
              -30.997791520167926
            ],
            [
              -55.75861491838888,
              -30.999503883309877
            ],
            [
              -55.76191478433563,
              -30.998994802375783
            ],
            [
              -55.763119497300316,
              -31.00001296424397
            ],
            [
              -55.76568605970335,
              -30.998809682036114
            ],
            [
              -55.76678601501893,
              -30.997189879064
            ],
            [
              -55.769509713895616,
              -30.99658823796007
            ],
            [
              -55.77317623161423,
              -30.997097318894163
            ],
            [
              -55.77459045987712,
              -31.00001296424397
            ],
            [
              -55.77170962452678,
              -31.001401366791498
            ],
            [
              -55.77118583628126,
              -31.002280688404934
            ],
            [
              -55.76788597033451,
              -31.00348397061279
            ],
            [
              -55.76778121268541,
              -31.006492176132433
            ],
            [
              -55.76657649972072,
              -31.01000946258617
            ],
            [
              -55.77207627629864,
              -31.013480468954988
            ],
            [
              -55.77668561285918,
              -31.015609352861198
            ],
            [
              -55.780614024700554,
              -31.01500771175727
            ],
            [
              -55.78087591882331,
              -31.01709031557856
            ],
            [
              -55.785485255383854,
              -31.016720074899222
            ],
            [
              -55.7951753379259,
              -31.015285392266776
            ],
            [
              -55.79648480853969,
              -31.016812635069055
            ],
            [
              -55.801408418047544,
              -31.015887033370703
            ],
            [
              -55.80722246757277,
              -31.016488674474633
            ],
            [
              -55.80921286290573,
              -31.01500771175727
            ],
            [
              -55.81219845590517,
              -31.014683751162845
            ],
            [
              -55.81350792651896,
              -31.015701913031034
            ],
            [
              -55.81371744181717,
              -31.017599396512654
            ],
            [
              -55.81188418295786,
              -31.02171832407032
            ],
            [
              -55.81460788183455,
              -31.023384407127352
            ],
            [
              -55.81450312418544,
              -31.02518933043914
            ],
            [
              -55.816179246571096,
              -31.02708681392076
            ],
            [
              -55.81989814311426,
              -31.029817338930897
            ],
            [
              -55.821102856078944,
              -31.032177623261695
            ],
            [
              -55.82262184199094,
              -31.033288345299717
            ],
            [
              -55.82267422081549,
              -31.035000708441668
            ],
            [
              -55.82560743499038,
              -31.038101474131146
            ],
            [
              -55.82702166325328,
              -31.04050803854686
            ],
            [
              -55.83021677155092,
              -31.04050803854686
            ],
            [
              -55.82979774095451,
              -31.043701364406175
            ],
            [
              -55.83231192453299,
              -31.044395565679938
            ],
            [
              -55.83288809160305,
              -31.04360880423634
            ],
            [
              -55.837497428163594,
              -31.04240552202848
            ],
            [
              -55.84001161174207,
              -31.04282204279274
            ],
            [
              -55.84242103767145,
              -31.043793924576008
            ],
            [
              -55.843678129460685,
              -31.04259064236815
            ],
            [
              -55.846506585986475,
              -31.04319228347208
            ],
            [
              -55.847606541302056,
              -31.04208156143406
            ],
            [
              -55.84938742133681,
              -31.043886484745844
            ],
            [
              -55.85211112021349,
              -31.04471952627436
            ],
            [
              -55.85530622851114,
              -31.0450897669537
            ],
            [
              -55.85907750387886,
              -31.050504536889058
            ],
            [
              -55.8590251250543,
              -31.051522698757246
            ],
            [
              -55.86012508036989,
              -31.052911101304773
            ],
            [
              -55.86059648979085,
              -31.054392064022135
            ],
            [
              -55.8638963557376,
              -31.058279591155213
            ],
            [
              -55.86457728045678,
              -31.060177074636833
            ],
            [
              -55.86641053931608,
              -31.06161175726928
            ],
            [
              -55.86719622168435,
              -31.06489764329843
            ],
            [
              -55.86929137466642,
              -31.064990203468263
            ],
            [
              -55.8701818146838,
              -31.06971077212986
            ],
            [
              -55.871124633525724,
              -31.07021985306395
            ],
            [
              -55.87081036057842,
              -31.07160825561148
            ],
            [
              -55.87321978650779,
              -31.07160825561148
            ],
            [
              -55.87589110655992,
              -31.07290409798917
            ],
            [
              -55.877724365419226,
              -31.07258013739475
            ],
            [
              -55.88039568547136,
              -31.07558834291439
            ],
            [
              -55.88228132315522,
              -31.076282544188157
            ],
            [
              -55.882386080804324,
              -31.07730070605634
            ],
            [
              -55.88589546204928,
              -31.076513944612742
            ],
            [
              -55.89092382920623,
              -31.077115585716673
            ],
            [
              -55.89181426922361,
              -31.07392225985736
            ],
            [
              -55.895218892819464,
              -31.073089218328843
            ],
            [
              -55.89479986222305,
              -31.07059009374329
            ],
            [
              -55.89537602929312,
              -31.068507489922002
            ],
            [
              -55.89867589523987,
              -31.066702566610214
            ],
            [
              -55.90129483646745,
              -31.067396767883977
            ],
            [
              -55.90192338236207,
              -31.06887773060134
            ],
            [
              -55.90412329299323,
              -31.069294251365598
            ],
            [
              -55.908889766027436,
              -31.073413178923264
            ],
            [
              -55.91051350958853,
              -31.0750792619803
            ],
            [
              -55.91308007199156,
              -31.07558834291439
            ],
            [
              -55.91857984856948,
              -31.07369085943277
            ],
            [
              -55.924184382796504,
              -31.075680903084226
            ],
            [
              -55.925912884006706,
              -31.076791625122247
            ],
            [
              -55.92701283932229,
              -31.081280793359255
            ],
            [
              -55.92989367467263,
              -31.083178276840876
            ],
            [
              -55.93031270526904,
              -31.086279042530354
            ],
            [
              -55.93361257121579,
              -31.08711208405887
            ],
            [
              -55.93581248184696,
              -31.086788123464448
            ],
            [
              -55.93848380189909,
              -31.08581624168118
            ],
            [
              -55.94141701607398,
              -31.08331711709563
            ],
            [
              -55.94508353379259,
              -31.081697314123513
            ],
            [
              -55.94880243033575,
              -31.081604753953677
            ],
            [
              -55.95089758331782,
              -31.080910552679914
            ],
            [
              -55.954092691615465,
              -31.080494031915656
            ],
            [
              -55.956711632843046,
              -31.079799830641893
            ],
            [
              -55.958911543474215,
              -31.077393266226178
            ],
            [
              -55.96530176006951,
              -31.077485826396014
            ],
            [
              -55.96828735306895,
              -31.074801581470794
            ],
            [
              -55.974887084962454,
              -31.074709021300958
            ],
            [
              -55.979286906224786,
              -31.073181778498675
            ],
            [
              -55.98269152982064,
              -31.07447762087637
            ],
            [
              -55.98672469931112,
              -31.07730070605634
            ],
            [
              -55.98939601936325,
              -31.081512193783844
            ],
            [
              -55.99018170173152,
              -31.083594797605134
            ],
            [
              -55.99269588531,
              -31.08498320015266
            ],
            [
              -56.00531918202694,
              -31.081882434463182
            ],
            [
              -56.0075190926581,
              -31.08211383488777
            ],
            [
              -56.011080852727616,
              -31.081604753953677
            ],
            [
              -56.00888094209645,
              -31.079198189537962
            ],
            [
              -56.007414335009,
              -31.076513944612742
            ],
            [
              -56.00788574442996,
              -31.073089218328843
            ],
            [
              -56.00767622913176,
              -31.071700815781313
            ],
            [
              -56.00898569974555,
              -31.06869261026167
            ],
            [
              -56.01060944330665,
              -31.067119087374472
            ],
            [
              -56.010923716253956,
              -31.064388562364336
            ],
            [
              -56.012023671569544,
              -31.06387948143024
            ],
            [
              -56.012704596288714,
              -31.061519197099443
            ],
            [
              -56.01207605039409,
              -31.060917555995516
            ],
            [
              -56.012914111586916,
              -31.05781679030604
            ],
            [
              -56.014014066902504,
              -31.05628954750376
            ],
            [
              -56.014014066902504,
              -31.054993705126066
            ],
            [
              -56.01569018928815,
              -31.053882983088045
            ],
            [
              -56.015323537516295,
              -31.051383858502493
            ],
            [
              -56.017313932849255,
              -31.048514493237604
            ],
            [
              -56.01841388816484,
              -31.04800541230351
            ],
            [
              -56.01809961521753,
              -31.04610792882189
            ],
            [
              -56.0187805399367,
              -31.04360880423634
            ],
            [
              -56.01768058462112,
              -31.04208156143406
            ],
            [
              -56.01789009991932,
              -31.037684953366888
            ],
            [
              -56.018204372866634,
              -31.036990752093125
            ],
            [
              -56.01752344814746,
              -31.03458418767741
            ],
            [
              -56.01741869049836,
              -31.031020621138754
            ],
            [
              -56.016423492831876,
              -31.029493378336475
            ],
            [
              -56.01621397753367,
              -31.024680249505046
            ],
            [
              -56.01427596102526,
              -31.02190344440999
            ],
            [
              -56.014485476323465,
              -31.019682000333948
            ],
            [
              -56.016894902252844,
              -31.01597959354054
            ],
            [
              -56.01699965990194,
              -31.013480468954988
            ],
            [
              -56.017994857568425,
              -31.010796224029768
            ],
            [
              -56.01768058462112,
              -31.008621060038642
            ],
            [
              -56.016475871656425,
              -31.006214495622928
            ],
            [
              -56.01757582697201,
              -31.003021169763613
            ],
            [
              -56.01521877986719,
              -30.99931876297021
            ],
            [
              -56.01411882455161,
              -30.995894036686305
            ],
            [
              -56.012704596288714,
              -30.993209791761085
            ],
            [
              -56.013176005709674,
              -30.990109026071607
            ],
            [
              -56.01149988332403,
              -30.987887581995565
            ],
            [
              -56.00888094209645,
              -30.986499179448035
            ],
            [
              -56.00710006206169,
              -30.983814934522815
            ],
            [
              -56.00898569974555,
              -30.980806729003174
            ],
            [
              -56.01060944330665,
              -30.979696006965153
            ],
            [
              -56.01081895860486,
              -30.978307604417623
            ],
            [
              -56.00710006206169,
              -30.97548451923765
            ],
            [
              -56.0056858337988,
              -30.973216795076688
            ],
            [
              -56.0075190926581,
              -30.971411871764904
            ],
            [
              -56.00861904797369,
              -30.97108791117048
            ],
            [
              -56.01060944330665,
              -30.96858878658493
            ],
            [
              -56.01149988332403,
              -30.963821937838418
            ],
            [
              -56.011185610376714,
              -30.96150793359254
            ],
            [
              -56.01008565506113,
              -30.958083207308636
            ],
            [
              -56.01097609507851,
              -30.956185723827016
            ],
            [
              -56.01259983863961,
              -30.95401055983589
            ],
            [
              -56.01170939862223,
              -30.95109491448608
            ],
            [
              -56.00987613976292,
              -30.949521391598886
            ],
            [
              -56.00940473034196,
              -30.947022267013335
            ],
            [
              -56.01060944330665,
              -30.946004105145146
            ],
            [
              -56.015323537516295,
              -30.945078503446794
            ],
            [
              -56.01500926456898,
              -30.941977737757316
            ],
            [
              -56.01369979395519,
              -30.94040421487012
            ],
            [
              -56.011185610376714,
              -30.939108372492427
            ],
            [
              -56.01039992800844,
              -30.937581129690148
            ],
            [
              -56.01071420095575,
              -30.93230520000954
            ],
            [
              -56.01097609507851,
              -30.931101917801683
            ],
            [
              -56.01019041271024,
              -30.927121830498773
            ],
            [
              -56.00547631850059,
              -30.922308701667344
            ],
            [
              -56.005895349097,
              -30.919207935977866
            ],
            [
              -56.00767622913176,
              -30.915505529184458
            ],
            [
              -56.011080852727616,
              -30.91198824273072
            ],
            [
              -56.010923716253956,
              -30.911016360947453
            ],
            [
              -56.00820001737728,
              -30.906388352455693
            ],
            [
              -56.00799050207907,
              -30.903102466426546
            ],
            [
              -56.00710006206169,
              -30.898890978699043
            ],
            [
              -56.00652389499162,
              -30.89819677742528
            ],
            [
              -56.00799050207907,
              -30.894818331226297
            ],
            [
              -56.00668103146528,
              -30.89111592443289
            ],
            [
              -56.00479539378142,
              -30.8898200820552
            ],
            [
              -56.00479539378142,
              -30.88880192018701
            ],
            [
              -56.0009193607646,
              -30.882692948977887
            ],
            [
              -55.99777663129151,
              -30.87348321207929
            ],
            [
              -55.99510531123937,
              -30.871817129022254
            ],
            [
              -55.99039121702973,
              -30.866402359086898
            ],
            [
              -55.990600732327934,
              -30.86228343152923
            ],
            [
              -55.989710292310555,
              -30.859876867113517
            ],
            [
              -55.989919807608764,
              -30.85770170312239
            ],
            [
              -55.99070548997704,
              -30.855896779810607
            ],
            [
              -55.99290540060821,
              -30.85237949335687
            ],
            [
              -55.99149117234531,
              -30.84849196622379
            ],
            [
              -55.99500055359027,
              -30.84488211960022
            ],
            [
              -55.996781433625024,
              -30.84451187892088
            ],
            [
              -55.99887658660709,
              -30.843308596713022
            ],
            [
              -56.00259548315025,
              -30.840300391193377
            ],
            [
              -56.00437636318501,
              -30.839791310259287
            ],
            [
              -56.00510966672873,
              -30.832710457266895
            ],
            [
              -56.00421922671135,
              -30.83187741573838
            ],
            [
              -56.00421922671135,
              -30.830396453021017
            ],
            [
              -56.00510966672873,
              -30.827897328435466
            ],
            [
              -56.00652389499162,
              -30.82590728478401
            ],
            [
              -56.008514290324584,
              -30.821001595782747
            ],
            [
              -56.00872380562279,
              -30.819705753405053
            ],
            [
              -56.01369979395519,
              -30.8179933902631
            ],
            [
              -56.01621397753367,
              -30.8187801517067
            ],
            [
              -56.017104417551046,
              -30.818085950432938
            ],
            [
              -56.01658062930553,
              -30.81688266822508
            ],
            [
              -56.017104417551046,
              -30.814800064403787
            ],
            [
              -56.016475871656425,
              -30.811606738544477
            ],
            [
              -56.012495080990504,
              -30.807302690647138
            ],
            [
              -56.012914111586916,
              -30.805497767335353
            ],
            [
              -56.016004462235465,
              -30.80230444147604
            ],
            [
              -56.02448983181282,
              -30.79962019655082
            ],
            [
              -56.02522313535655,
              -30.798602034682634
            ],
            [
              -56.02459458946193,
              -30.794714507549557
            ],
            [
              -56.02118996586607,
              -30.791521181690243
            ],
            [
              -56.02118996586607,
              -30.789901378718127
            ],
            [
              -56.02359939179544,
              -30.785689890990625
            ],
            [
              -56.03182286725005,
              -30.78388496767884
            ],
            [
              -56.0351227331968,
              -30.784579168952604
            ],
            [
              -56.036379824986035,
              -30.783422166829663
            ],
            [
              -56.036379824986035,
              -30.782218884621805
            ],
            [
              -56.03868449326631,
              -30.778886718507742
            ],
            [
              -56.03779405324893,
              -30.77740575579038
            ],
            [
              -56.03800356854714,
              -30.776109913412686
            ],
            [
              -56.03910352386272,
              -30.775184311714334
            ],
            [
              -56.0465936957736,
              -30.77370334899697
            ],
            [
              -56.04722224166822,
              -30.77388846933664
            ],
            [
              -56.04868884875567,
              -30.77638759392219
            ],
            [
              -56.04947453112394,
              -30.77680411468645
            ],
            [
              -56.05198871470242,
              -30.77578595281826
            ],
            [
              -56.05371721591262,
              -30.775508272308755
            ],
            [
              -56.05507906535096,
              -30.77411986976123
            ],
            [
              -56.05790752187675,
              -30.77337938840255
            ],
            [
              -56.06000267485881,
              -30.77472151086516
            ],
            [
              -56.06209782784087,
              -30.774999191374665
            ],
            [
              -56.06571196673494,
              -30.769399301099636
            ],
            [
              -56.06681192205052,
              -30.763290329890513
            ],
            [
              -56.06461201141935,
              -30.76148540657873
            ],
            [
              -56.06351205610377,
              -30.756903678171888
            ],
            [
              -56.06319778315646,
              -30.75278475061422
            ],
            [
              -56.06482152671756,
              -30.751997989170622
            ],
            [
              -56.06571196673494,
              -30.749313744245402
            ],
            [
              -56.0679118773661,
              -30.74760138110345
            ],
            [
              -56.0726783504003,
              -30.74537993702741
            ],
            [
              -56.074197336312295,
              -30.745611337451997
            ],
            [
              -56.07781147520636,
              -30.748480702716886
            ],
            [
              -56.079278082293804,
              -30.749313744245402
            ],
            [
              -56.08299697883697,
              -30.75320127137848
            ],
            [
              -56.085196889468136,
              -30.755978076473536
            ],
            [
              -56.08697776950289,
              -30.757320198936146
            ],
            [
              -56.08839199776578,
              -30.757505319275815
            ],
            [
              -56.090801423695154,
              -30.75681111800205
            ],
            [
              -56.095725033203,
              -30.75398803282208
            ],
            [
              -56.09661547322038,
              -30.751997989170622
            ],
            [
              -56.096982124992245,
              -30.747786501443123
            ],
            [
              -56.10012485446534,
              -30.744778295923478
            ],
            [
              -56.102324765096505,
              -30.744500615413973
            ],
            [
              -56.10222000744741,
              -30.742418011592683
            ],
            [
              -56.10279617451747,
              -30.7401040073468
            ],
            [
              -56.10478656985043,
              -30.735290878515375
            ],
            [
              -56.10730075342891,
              -30.732004992486225
            ],
            [
              -56.11678132067275,
              -30.732976874269493
            ],
            [
              -56.11840506423385,
              -30.73441155690194
            ],
            [
              -56.118195548935645,
              -30.735707399279633
            ],
            [
              -56.11908598895302,
              -30.737512322591417
            ],
            [
              -56.12432387140818,
              -30.74001144717697
            ],
            [
              -56.12678567616211,
              -30.740613088280895
            ],
            [
              -56.129090344442375,
              -30.738484204374686
            ],
            [
              -56.13019029975796,
              -30.733578515373424
            ],
            [
              -56.13081884565258,
              -30.732699193759988
            ],
            [
              -56.13270448333644,
              -30.732004992486225
            ],
            [
              -56.131918800968165,
              -30.73020006917444
            ],
            [
              -56.13228545274003,
              -30.72751582424922
            ],
            [
              -56.13092360330168,
              -30.722980375927296
            ],
            [
              -56.12898558679328,
              -30.722008494144028
            ],
            [
              -56.128409419723205,
              -30.720296131002076
            ],
            [
              -56.13008554210886,
              -30.718398647520456
            ],
            [
              -56.13029505740707,
              -30.716501164038835
            ],
            [
              -56.13569007633588,
              -30.71191943563199
            ],
            [
              -56.13579483398498,
              -30.710207072490043
            ],
            [
              -56.13752333519518,
              -30.710484752999548
            ],
            [
              -56.140089897598216,
              -30.709605431386112
            ],
            [
              -56.14658487184261,
              -30.706088144932377
            ],
            [
              -56.15009425308757,
              -30.705486503828446
            ],
            [
              -56.15077517780674,
              -30.70469974238485
            ],
            [
              -56.149675222491155,
              -30.703403900007157
            ],
            [
              -56.149884737789364,
              -30.6979891300718
            ],
            [
              -56.15040852603488,
              -30.694101602938723
            ],
            [
              -56.14909905542109,
              -30.69262064022136
            ],
            [
              -56.14171364115931,
              -30.68859427283353
            ],
            [
              -56.13888518463353,
              -30.6879926317296
            ],
            [
              -56.138099502265256,
              -30.687113310116167
            ],
            [
              -56.137418577546086,
              -30.683596023662428
            ],
            [
              -56.13862329051077,
              -30.682485301624407
            ],
            [
              -56.14061368584373,
              -30.68188366052048
            ],
            [
              -56.14228980822938,
              -30.680078737208692
            ],
            [
              -56.14391355179048,
              -30.679615936359518
            ],
            [
              -56.14538015887793,
              -30.68109689907688
            ],
            [
              -56.14857526717557,
              -30.680402697803117
            ],
            [
              -56.151875133122324,
              -30.68049525797295
            ],
            [
              -56.15260843666605,
              -30.67859777449133
            ],
            [
              -56.15491310494632,
              -30.676792851179545
            ],
            [
              -56.1607795332961,
              -30.671192960904516
            ],
            [
              -56.164707945137465,
              -30.666379832073087
            ],
            [
              -56.16669834047043,
              -30.66341790663836
            ],
            [
              -56.16701261341774,
              -30.661890663836083
            ],
            [
              -56.16921252404891,
              -30.65767917610858
            ],
            [
              -56.170207721715386,
              -30.65291232736207
            ],
            [
              -56.16858397815429,
              -30.650505762946356
            ],
            [
              -56.16460318748837,
              -30.643193509529375
            ],
            [
              -56.165598385154844,
              -30.640879505283497
            ],
            [
              -56.1672745075405,
              -30.638982021801876
            ],
            [
              -56.1754979829951,
              -30.63328957135701
            ],
            [
              -56.17769789362627,
              -30.633613531951436
            ],
            [
              -56.18010731955564,
              -30.63241024974358
            ],
            [
              -56.181312032520324,
              -30.631299527705554
            ],
            [
              -56.18031683485385,
              -30.63028136583737
            ],
            [
              -56.18230723018681,
              -30.62792108150657
            ],
            [
              -56.18298815490598,
              -30.626393838704292
            ],
            [
              -56.18288339725687,
              -30.624588915392504
            ],
            [
              -56.17900736424006,
              -30.6208865085991
            ],
            [
              -56.17591701359151,
              -30.620793948429263
            ],
            [
              -56.17188384410104,
              -30.618803904777806
            ],
            [
              -56.1705219946627,
              -30.61639734036209
            ],
            [
              -56.170888646434555,
              -30.61449985688047
            ],
            [
              -56.17298379941662,
              -30.61449985688047
            ],
            [
              -56.176388423012476,
              -30.612694933568687
            ],
            [
              -56.178588333643646,
              -30.611723051785418
            ],
            [
              -56.17937401601192,
              -30.61070488991723
            ],
            [
              -56.18602612672997,
              -30.60630828185006
            ],
            [
              -56.187702249115624,
              -30.604688478877943
            ],
            [
              -56.192992510395335,
              -30.60380915726451
            ],
            [
              -56.19582096692112,
              -30.60380915726451
            ],
            [
              -56.2015826376218,
              -30.605197559812037
            ],
            [
              -56.20420157884938,
              -30.60552152040646
            ],
            [
              -56.207396687147025,
              -30.6066785225294
            ],
            [
              -56.21410117668963,
              -30.608483445841184
            ],
            [
              -56.21572492025073,
              -30.60839088567135
            ],
            [
              -56.21991522621486,
              -30.607095043293658
            ],
            [
              -56.22148659095141,
              -30.605197559812037
            ],
            [
              -56.22169610624962,
              -30.60288355556616
            ],
            [
              -56.224419805126296,
              -30.59728366529113
            ],
            [
              -56.2278768075467,
              -30.595802702573767
            ],
            [
              -56.232590901756346,
              -30.59478454070558
            ],
            [
              -56.23421464531745,
              -30.59358125849772
            ],
            [
              -56.234581297089306,
              -30.58960117119481
            ],
            [
              -56.23510508533482,
              -30.587981368222696
            ],
            [
              -56.23332420530007,
              -30.586685525845002
            ],
            [
              -56.230810021721595,
              -30.587194606779097
            ],
            [
              -56.22567689691554,
              -30.586222724995825
            ],
            [
              -56.223791259231675,
              -30.584788042363382
            ],
            [
              -56.224419805126296,
              -30.582196357607994
            ],
            [
              -56.22567689691554,
              -30.578910471578848
            ],
            [
              -56.227981565195805,
              -30.577614629201154
            ],
            [
              -56.23007671817787,
              -30.57770718937099
            ],
            [
              -56.23311469000186,
              -30.574884104191018
            ],
            [
              -56.23798592068516,
              -30.573403141473655
            ],
            [
              -56.24149530193012,
              -30.573403141473655
            ],
            [
              -56.24510944082418,
              -30.57368082198316
            ],
            [
              -56.2490902314901,
              -30.576781587672638
            ],
            [
              -56.25029494445479,
              -30.578308830474917
            ],
            [
              -56.25191868801589,
              -30.581687276673904
            ],
            [
              -56.25312340098058,
              -30.58520456312764
            ],
            [
              -56.254118598647054,
              -30.587009486439424
            ],
            [
              -56.256685161050086,
              -30.587611127543354
            ],
            [
              -56.261818285856144,
              -30.58460292202371
            ],
            [
              -56.26260396822442,
              -30.583677320325357
            ],
            [
              -56.2619754223298,
              -30.58150215633423
            ],
            [
              -56.25977551169863,
              -30.58039143429621
            ],
            [
              -56.26139925525973,
              -30.57599482622904
            ],
            [
              -56.26218493762801,
              -30.57178333850154
            ],
            [
              -56.261818285856144,
              -30.569978415189752
            ],
            [
              -56.25788987401477,
              -30.56808093170813
            ],
            [
              -56.256685161050086,
              -30.566877649500274
            ],
            [
              -56.258308904611184,
              -30.562018240583928
            ],
            [
              -56.26019454229505,
              -30.559981916847555
            ],
            [
              -56.265222909452,
              -30.55512250793121
            ],
            [
              -56.26658475889034,
              -30.55452086682728
            ],
            [
              -56.268418017749646,
              -30.556186949884314
            ],
            [
              -56.27491299199404,
              -30.559796796507882
            ],
            [
              -56.2766938720288,
              -30.560722398206234
            ],
            [
              -56.28109369329113,
              -30.56049099778165
            ],
            [
              -56.282193648606714,
              -30.559796796507882
            ],
            [
              -56.27931281325638,
              -30.554983667676456
            ],
            [
              -56.27899854030907,
              -30.55331758461942
            ],
            [
              -56.28119845094024,
              -30.54989285833552
            ],
            [
              -56.28580778750078,
              -30.546005331202444
            ],
            [
              -56.285703029851675,
              -30.54392272738115
            ],
            [
              -56.28758866753553,
              -30.541978963814614
            ],
            [
              -56.289002895798426,
              -30.53989635999332
            ],
            [
              -56.28999809346491,
              -30.533509708274693
            ],
            [
              -56.289893335815805,
              -30.53230642606684
            ],
            [
              -56.290312366412216,
              -30.529205660377357
            ],
            [
              -56.28957906286849,
              -30.52841889893376
            ],
            [
              -56.28758866753553,
              -30.52841889893376
            ],
            [
              -56.28758866753553,
              -30.526613975621974
            ],
            [
              -56.28947430521939,
              -30.52559581375379
            ],
            [
              -56.2897885781667,
              -30.523698330272165
            ],
            [
              -56.290574260534974,
              -30.521985967130217
            ],
            [
              -56.29219800409607,
              -30.520505004412854
            ],
            [
              -56.29429315707814,
              -30.520597564582687
            ],
            [
              -56.29418839942903,
              -30.523790890442
            ],
            [
              -56.29727875007758,
              -30.526290015027552
            ],
            [
              -56.29911200893689,
              -30.524716492140353
            ],
            [
              -56.30178332898902,
              -30.525780934093458
            ],
            [
              -56.302988041953704,
              -30.528511459103594
            ],
            [
              -56.3060260137777,
              -30.529899861651124
            ],
            [
              -56.30969253149631,
              -30.531010583689145
            ],
            [
              -56.31299239744306,
              -30.531010583689145
            ],
            [
              -56.31529706572333,
              -30.529992421820957
            ],
            [
              -56.317077945758086,
              -30.53017754216063
            ],
            [
              -56.320220675231184,
              -30.531612224793072
            ],
            [
              -56.322891995283314,
              -30.531797345132745
            ],
            [
              -56.32430622354621,
              -30.531010583689145
            ],
            [
              -56.32561569416,
              -30.528696579443267
            ],
            [
              -56.32692516477379,
              -30.5280023781695
            ],
            [
              -56.329282211878606,
              -30.52971474131145
            ],
            [
              -56.33132498603612,
              -30.52939078071703
            ],
            [
              -56.3323201837026,
              -30.526382575197385
            ],
            [
              -56.334415336684664,
              -30.523698330272165
            ],
            [
              -56.33682476261404,
              -30.523096689168238
            ],
            [
              -56.33672000496494,
              -30.520690124752523
            ],
            [
              -56.33740092968411,
              -30.518792641270903
            ],
            [
              -56.33541053435115,
              -30.517913319657467
            ],
            [
              -56.33389154843915,
              -30.516386076855188
            ],
            [
              -56.33378679079005,
              -30.514905114137825
            ],
            [
              -56.33630097436853,
              -30.51078618658016
            ],
            [
              -56.339024673245206,
              -30.510415945900817
            ],
            [
              -56.343476873332094,
              -30.506806099277245
            ],
            [
              -56.34661960280519,
              -30.506111898003482
            ],
            [
              -56.348976649910014,
              -30.504121854352025
            ],
            [
              -56.35080990876932,
              -30.501113648832384
            ],
            [
              -56.351386075839386,
              -30.499401285690432
            ],
            [
              -56.35049563582201,
              -30.49657820051046
            ],
            [
              -56.35238127350587,
              -30.49528235813277
            ],
            [
              -56.354319290014274,
              -30.493292314481312
            ],
            [
              -56.35720012536461,
              -30.491718791594113
            ],
            [
              -56.36081426425868,
              -30.492783233547218
            ],
            [
              -56.36390461490722,
              -30.491903911933782
            ],
            [
              -56.36521408552101,
              -30.492690673377382
            ],
            [
              -56.364009372556325,
              -30.497688922548484
            ],
            [
              -56.36259514429343,
              -30.497596362378648
            ],
            [
              -56.36149518897785,
              -30.49528235813277
            ],
            [
              -56.359819066592195,
              -30.496115399661285
            ],
            [
              -56.3599238242413,
              -30.497596362378648
            ],
            [
              -56.36081426425868,
              -30.500095486964195
            ],
            [
              -56.36411413020543,
              -30.501298769172053
            ],
            [
              -56.36830443616955,
              -30.503196252653673
            ],
            [
              -56.37191857506362,
              -30.501622729766478
            ],
            [
              -56.37500892571216,
              -30.501113648832384
            ],
            [
              -56.37809927636071,
              -30.501483889511725
            ],
            [
              -56.38349429528952,
              -30.498799644586505
            ],
            [
              -56.385903721218895,
              -30.49560631872719
            ],
            [
              -56.38930834481475,
              -30.49310719414164
            ],
            [
              -56.38831314714827,
              -30.492089032273455
            ],
            [
              -56.38579896356979,
              -30.49347743482098
            ],
            [
              -56.384384735306895,
              -30.49347743482098
            ],
            [
              -56.383703810587726,
              -30.49259811320755
            ],
            [
              -56.385275175324274,
              -30.490608069556092
            ],
            [
              -56.38757984360454,
              -30.489497347518068
            ],
            [
              -56.38731794948178,
              -30.48699822293252
            ],
            [
              -56.38899407186744,
              -30.485980061064332
            ],
            [
              -56.39171777074412,
              -30.485378419960405
            ],
            [
              -56.39491287904177,
              -30.485378419960405
            ],
            [
              -56.39559380376094,
              -30.484915619111227
            ],
            [
              -56.395489046111834,
              -30.482786735205018
            ],
            [
              -56.39721754732204,
              -30.47889920807194
            ],
            [
              -56.39711278967294,
              -30.475983562722135
            ],
            [
              -56.39637948612921,
              -30.47218859575889
            ],
            [
              -56.398317502637624,
              -30.471494394485127
            ],
            [
              -56.400517413268794,
              -30.474595160174605
            ],
            [
              -56.40282208154906,
              -30.474086079240514
            ],
            [
              -56.404288688636505,
              -30.471216713975622
            ],
            [
              -56.40617432632036,
              -30.468578749135318
            ],
            [
              -56.40638384161857,
              -30.466218464804523
            ],
            [
              -56.407117145162296,
              -30.4616830164826
            ],
            [
              -56.40701238751319,
              -30.459878093170815
            ],
            [
              -56.40481247688202,
              -30.45899877155738
            ],
            [
              -56.402088778005336,
              -30.4601094935954
            ],
            [
              -56.40077930739155,
              -30.45978553300098
            ],
            [
              -56.39978410972507,
              -30.45858225079312
            ],
            [
              -56.399679352075964,
              -30.4566847673115
            ],
            [
              -56.39889366970769,
              -30.454694723660044
            ],
            [
              -56.398788912058585,
              -30.451408837630893
            ],
            [
              -56.39821274498852,
              -30.44840063211125
            ],
            [
              -56.39952221560231,
              -30.44752131049782
            ],
            [
              -56.401407853286166,
              -30.447382470243063
            ],
            [
              -56.405388643952094,
              -30.44770643083749
            ],
            [
              -56.40800758517967,
              -30.44691966939389
            ],
            [
              -56.413402604108484,
              -30.440718138014933
            ],
            [
              -56.41481683237138,
              -30.43808017317463
            ],
            [
              -56.41507872649414,
              -30.432804243494026
            ],
            [
              -56.41638819710793,
              -30.431415840946496
            ],
            [
              -56.41769766772172,
              -30.431091880352074
            ],
            [
              -56.4203166089493,
              -30.43271168332419
            ],
            [
              -56.42330220194874,
              -30.432110042220263
            ],
            [
              -56.42429739961522,
              -30.4324802828996
            ],
            [
              -56.425502112579906,
              -30.434701726975646
            ],
            [
              -56.42791153850928,
              -30.43521080790974
            ],
            [
              -56.433306557438094,
              -30.433591004937625
            ],
            [
              -56.4400110469807,
              -30.4324802828996
            ],
            [
              -56.44111100229628,
              -30.431091880352074
            ],
            [
              -56.44462038354124,
              -30.427991114662596
            ],
            [
              -56.44582509650593,
              -30.426093631180976
            ],
            [
              -56.44750121889158,
              -30.424705228633446
            ],
            [
              -56.451010600136534,
              -30.42350194642559
            ],
            [
              -56.4531057531186,
              -30.422992865491498
            ],
            [
              -56.453891435486874,
              -30.421280502349546
            ],
            [
              -56.45158676720661,
              -30.41910533835842
            ],
            [
              -56.44949161422454,
              -30.41771693581089
            ],
            [
              -56.444882277664,
              -30.41581945232927
            ],
            [
              -56.44420135294483,
              -30.414014529017486
            ],
            [
              -56.44451562589214,
              -30.41160796460177
            ],
            [
              -56.44619174827779,
              -30.409293960355892
            ],
            [
              -56.44991064482095,
              -30.40619319466641
            ],
            [
              -56.453891435486874,
              -30.4022131073635
            ],
            [
              -56.45478187550425,
              -30.399806542947786
            ],
            [
              -56.45551517904798,
              -30.396890897597977
            ],
            [
              -56.45577707317074,
              -30.392910810295064
            ],
            [
              -56.456510376714455,
              -30.391614967917373
            ],
            [
              -56.46080544032769,
              -30.385598556878087
            ],
            [
              -56.46221966859058,
              -30.384487834840066
            ],
            [
              -56.46389579097623,
              -30.384996915774156
            ],
            [
              -56.46698614162478,
              -30.38532087636858
            ],
            [
              -56.46860988518588,
              -30.386801839085944
            ],
            [
              -56.47170023583442,
              -30.387310920020038
            ],
            [
              -56.476414330044065,
              -30.389393523841328
            ],
            [
              -56.48049987835909,
              -30.392494289530806
            ],
            [
              -56.48180934897288,
              -30.39550249505045
            ],
            [
              -56.48212362192019,
              -30.397122298022566
            ],
            [
              -56.483904501954946,
              -30.398788381079598
            ],
            [
              -56.48521397256874,
              -30.399112341674023
            ],
            [
              -56.49139467386583,
              -30.398094179805835
            ],
            [
              -56.4921803562341,
              -30.397307418362235
            ],
            [
              -56.491708946813134,
              -30.396104136154378
            ],
            [
              -56.4922851138832,
              -30.394206652672757
            ],
            [
              -56.493699342146094,
              -30.391522407747537
            ],
            [
              -56.49647541984733,
              -30.38707951959545
            ],
            [
              -56.498989603425805,
              -30.385783677217756
            ],
            [
              -56.50590360826662,
              -30.382682911528278
            ],
            [
              -56.50731783652951,
              -30.380785428046657
            ],
            [
              -56.50459413765283,
              -30.373010373780502
            ],
            [
              -56.50522268354745,
              -30.37051124919495
            ],
            [
              -56.50731783652951,
              -30.368984006392672
            ],
            [
              -56.51260809780923,
              -30.365883240703194
            ],
            [
              -56.514912766089495,
              -30.365096479259595
            ],
            [
              -56.51721743436977,
              -30.36329155594781
            ],
            [
              -56.518003116738036,
              -30.36139407246619
            ],
            [
              -56.51941734500093,
              -30.35982054957899
            ],
            [
              -56.5216172556321,
              -30.358987508050475
            ],
            [
              -56.52360765096506,
              -30.359080068220308
            ],
            [
              -56.52502187922796,
              -30.35982054957899
            ],
            [
              -56.52748368398188,
              -30.360283350428166
            ],
            [
              -56.53099306522684,
              -30.36019079025833
            ],
            [
              -56.536388084155654,
              -30.358987508050475
            ],
            [
              -56.539007025383235,
              -30.35982054957899
            ],
            [
              -56.54152120896171,
              -30.36111639195668
            ],
            [
              -56.54419252901384,
              -30.361208952126518
            ],
            [
              -56.5460781666977,
              -30.36060731102259
            ],
            [
              -56.54702098553963,
              -30.358200746606876
            ],
            [
              -56.54461155961025,
              -30.35658094363476
            ],
            [
              -56.54408777136474,
              -30.353387617775446
            ],
            [
              -56.54471631725936,
              -30.351814094888248
            ],
            [
              -56.54691622789053,
              -30.349685210982038
            ],
            [
              -56.54979706324087,
              -30.34760260716075
            ],
            [
              -56.55199697387203,
              -30.344177880876845
            ],
            [
              -56.55157794327562,
              -30.341308515611956
            ],
            [
              -56.54969230559176,
              -30.33908707153591
            ],
            [
              -56.541887860733574,
              -30.33751354864871
            ],
            [
              -56.53858799478682,
              -30.33547722491234
            ],
            [
              -56.537016630050275,
              -30.334088822364812
            ],
            [
              -56.53780231241855,
              -30.33297810032679
            ],
            [
              -56.537697554769444,
              -30.33071037616583
            ],
            [
              -56.540787905417986,
              -30.327285649881926
            ],
            [
              -56.5411021783653,
              -30.320389917229207
            ],
            [
              -56.54089266306709,
              -30.31469746678434
            ],
            [
              -56.541625966610816,
              -30.313077663812226
            ],
            [
              -56.544297286662946,
              -30.311411580755195
            ],
            [
              -56.54702098553963,
              -30.31150414092503
            ],
            [
              -56.55089701855645,
              -30.316594950265966
            ],
            [
              -56.55351595978403,
              -30.319094074851513
            ],
            [
              -56.555820628064296,
              -30.32029735705937
            ],
            [
              -56.55781102339726,
              -30.31918663502135
            ],
            [
              -56.559382388133805,
              -30.31548422822794
            ],
            [
              -56.56310128467697,
              -30.3116892612647
            ],
            [
              -56.574205595481914,
              -30.305395169715908
            ],
            [
              -56.576615021411286,
              -30.302201843856594
            ],
            [
              -56.576195990814874,
              -30.29998039978055
            ],
            [
              -56.574677004902874,
              -30.29711103451566
            ],
            [
              -56.57431035313101,
              -30.291279743816045
            ],
            [
              -56.575515066095704,
              -30.289289700164588
            ],
            [
              -56.57740070377956,
              -30.288919459485246
            ],
            [
              -56.58530990628685,
              -30.29040042220261
            ],
            [
              -56.58750981691802,
              -30.291696264580303
            ],
            [
              -56.591700122882145,
              -30.293778868401592
            ],
            [
              -56.59578567119717,
              -30.29539867137371
            ],
            [
              -56.59898077949482,
              -30.295491231543544
            ],
            [
              -56.602123508967914,
              -30.294287949335686
            ],
            [
              -56.60390438900267,
              -30.292806986618324
            ],
            [
              -56.60510910196736,
              -30.292806986618324
            ],
            [
              -56.60730901259853,
              -30.29539867137371
            ],
            [
              -56.61081839384348,
              -30.298777117572694
            ],
            [
              -56.61338495624651,
              -30.300489480714646
            ],
            [
              -56.6163181704214,
              -30.30150764258283
            ],
            [
              -56.618675217526224,
              -30.30118368198841
            ],
            [
              -56.62097988580649,
              -30.296092872647474
            ],
            [
              -56.62150367405201,
              -30.29401026882618
            ],
            [
              -56.62097988580649,
              -30.292992106957996
            ],
            [
              -56.61888473282443,
              -30.292390465854066
            ],
            [
              -56.61438015391299,
              -30.290122741693104
            ],
            [
              -56.61128980326445,
              -30.287808737447225
            ],
            [
              -56.608723240861416,
              -30.28507821243709
            ],
            [
              -56.60720425494942,
              -30.281422085728597
            ],
            [
              -56.60919465028238,
              -30.273415631037857
            ],
            [
              -56.60950892322969,
              -30.269389263650027
            ],
            [
              -56.61081839384348,
              -30.268278541612002
            ],
            [
              -56.61280878917644,
              -30.26550173651695
            ],
            [
              -56.613803986842925,
              -30.262493530997304
            ],
            [
              -56.616003897474094,
              -30.261614209383872
            ],
            [
              -56.621294158753805,
              -30.26508521575269
            ],
            [
              -56.62537970706883,
              -30.26661245855497
            ],
            [
              -56.62757961769999,
              -30.266890139064476
            ],
            [
              -56.629517634208405,
              -30.266519898385134
            ],
            [
              -56.63098424129585,
              -30.265594296686782
            ],
            [
              -56.639207716750455,
              -30.25911508479832
            ],
            [
              -56.64020291441693,
              -30.257495281826206
            ],
            [
              -56.64051718736424,
              -30.25550523817475
            ],
            [
              -56.63941723204866,
              -30.254209395797055
            ],
            [
              -56.637688730838455,
              -30.254116835627222
            ],
            [
              -56.63391745547074,
              -30.255412678004912
            ],
            [
              -56.63129851424316,
              -30.255181277580327
            ],
            [
              -56.62967477068206,
              -30.254116835627222
            ],
            [
              -56.62852243654193,
              -30.25240447248527
            ],
            [
              -56.62522257059517,
              -30.249488827135462
            ],
            [
              -56.62412261527959,
              -30.247683903823678
            ],
            [
              -56.62501305529697,
              -30.24550873983255
            ],
            [
              -56.62658442003352,
              -30.244721978388952
            ],
            [
              -56.63072234717309,
              -30.241204691935216
            ],
            [
              -56.637688730838455,
              -30.23708576437755
            ],
            [
              -56.641198112083416,
              -30.234818040216588
            ],
            [
              -56.64308374976727,
              -30.232781716480215
            ],
            [
              -56.64538841804754,
              -30.22519178255373
            ],
            [
              -56.646802646310434,
              -30.223016618562603
            ],
            [
              -56.652092907590145,
              -30.2195918922787
            ],
            [
              -56.657592684168065,
              -30.220795174486557
            ],
            [
              -56.664506689008874,
              -30.221905896524582
            ],
            [
              -56.666497084341835,
              -30.22130425542065
            ],
            [
              -56.668225585552044,
              -30.219684452448536
            ],
            [
              -56.668696994973004,
              -30.218110929561337
            ],
            [
              -56.668016070253834,
              -30.217092767693153
            ],
            [
              -56.662516293675914,
              -30.21579692531546
            ],
            [
              -56.657802199466275,
              -30.21288127996565
            ],
            [
              -56.65308810525663,
              -30.21269615962598
            ],
            [
              -56.650312027555394,
              -30.212187078691887
            ],
            [
              -56.64601696394216,
              -30.208808632492904
            ],
            [
              -56.64528366039844,
              -30.206818588841447
            ],
            [
              -56.64648837336313,
              -30.203810383321805
            ],
            [
              -56.648321632222434,
              -30.2043194642559
            ],
            [
              -56.64968348166077,
              -30.206818588841447
            ],
            [
              -56.65057392167815,
              -30.207420229945377
            ],
            [
              -56.65240718053746,
              -30.206911149011283
            ],
            [
              -56.654292818221315,
              -30.205383906209
            ],
            [
              -56.65811647241358,
              -30.201311258736254
            ],
            [
              -56.66078779246571,
              -30.198303053216613
            ],
            [
              -56.6637210066406,
              -30.19737745151826
            ],
            [
              -56.66990170793769,
              -30.199413775254634
            ],
            [
              -56.6766061974803,
              -30.20029309686807
            ],
            [
              -56.67870135046236,
              -30.20029309686807
            ],
            [
              -56.68022033637436,
              -30.198580733726118
            ],
            [
              -56.68032509402346,
              -30.194785766762877
            ],
            [
              -56.68189645876001,
              -30.194508086253368
            ],
            [
              -56.68551059765407,
              -30.196081609140567
            ],
            [
              -56.692110329547575,
              -30.202607101113948
            ],
            [
              -56.6963006355117,
              -30.205106225699495
            ],
            [
              -56.69818627319556,
              -30.204412024425732
            ],
            [
              -56.698291030844665,
              -30.20269966128378
            ],
            [
              -56.70049094147583,
              -30.19760885194285
            ],
            [
              -56.70211468503693,
              -30.195618808291393
            ],
            [
              -56.70420983801899,
              -30.193489924385183
            ],
            [
              -56.70750970396574,
              -30.189694957421942
            ],
            [
              -56.70840014398312,
              -30.188121434534743
            ],
            [
              -56.70620023335196,
              -30.183308305703314
            ],
            [
              -56.70478600508906,
              -30.179281938315484
            ],
            [
              -56.704995520387264,
              -30.17701421415452
            ],
            [
              -56.705624066281885,
              -30.17608861245617
            ],
            [
              -56.70991912989512,
              -30.175810931946664
            ],
            [
              -56.71348088996463,
              -30.17701421415452
            ],
            [
              -56.715314148823936,
              -30.17858773704172
            ],
            [
              -56.71772357475331,
              -30.17988357941941
            ],
            [
              -56.71992348538448,
              -30.17969845907974
            ],
            [
              -56.72139009247192,
              -30.178078656107626
            ],
            [
              -56.72558039843605,
              -30.17451508956897
            ],
            [
              -56.72982308322473,
              -30.171692004388998
            ],
            [
              -56.73647519394278,
              -30.170396162011308
            ],
            [
              -56.74139880345063,
              -30.167989597595593
            ],
            [
              -56.74658430708124,
              -30.1666937552179
            ],
            [
              -56.751612674238196,
              -30.164703711566442
            ],
            [
              -56.7582124061317,
              -30.160816184433365
            ],
            [
              -56.76088372618383,
              -30.160399663669107
            ],
            [
              -56.76439310742879,
              -30.161417825537296
            ],
            [
              -56.769107201638434,
              -30.163083908594327
            ],
            [
              -56.77298323465525,
              -30.164287190802185
            ],
            [
              -56.77492125116366,
              -30.164194630632352
            ],
            [
              -56.7779068441631,
              -30.162389707320564
            ],
            [
              -56.78188763482902,
              -30.158779860696992
            ],
            [
              -56.78298759014461,
              -30.156095615771772
            ],
            [
              -56.783982787811084,
              -30.15118992677051
            ],
            [
              -56.78361613603923,
              -30.148089161081028
            ],
            [
              -56.78162574070626,
              -30.145312355985975
            ],
            [
              -56.777802086513994,
              -30.13369605467166
            ],
            [
              -56.77822111711041,
              -30.130687849152018
            ],
            [
              -56.78031627009248,
              -30.126615201679268
            ],
            [
              -56.784611333705705,
              -30.12541191947141
            ],
            [
              -56.79241577856389,
              -30.123606996159626
            ],
            [
              -56.79707749394899,
              -30.123005355055696
            ],
            [
              -56.79938216222926,
              -30.122311153781933
            ],
            [
              -56.801896345807734,
              -30.119904589366218
            ],
            [
              -56.801896345807734,
              -30.116109622402977
            ],
            [
              -56.80299630112332,
              -30.11009321136369
            ],
            [
              -56.80462004468442,
              -30.106020563890944
            ],
            [
              -56.808077047104824,
              -30.10319747871097
            ],
            [
              -56.810015063613235,
              -30.1030123583713
            ],
            [
              -56.812476868367156,
              -30.106483364740118
            ],
            [
              -56.81451964252467,
              -30.107594086778143
            ],
            [
              -56.81682431080494,
              -30.107316406268637
            ],
            [
              -56.8186051908397,
              -30.106113124060776
            ],
            [
              -56.82080510147087,
              -30.10180907616344
            ],
            [
              -56.822219329733755,
              -30.097921549030364
            ],
            [
              -56.824209725066716,
              -30.095607544784485
            ],
            [
              -56.83358553466145,
              -30.09232165875534
            ],
            [
              -56.84269945013344,
              -30.09028533501896
            ],
            [
              -56.85039913734252,
              -30.088896932471435
            ],
            [
              -56.85422279153479,
              -30.088804372301603
            ],
            [
              -56.857417899832434,
              -30.089082052811108
            ],
            [
              -56.86459379879601,
              -30.090100214679293
            ],
            [
              -56.86920313535655,
              -30.09361750113303
            ],
            [
              -56.87208397070688,
              -30.093710061302865
            ],
            [
              -56.87370771426799,
              -30.092691899434676
            ],
            [
              -56.87381247191709,
              -30.090377895188798
            ],
            [
              -56.873288683671575,
              -30.088711812131766
            ],
            [
              -56.87449339663626,
              -30.086212687546215
            ],
            [
              -56.87611714019736,
              -30.08672176848031
            ],
            [
              -56.878578944951286,
              -30.088110171027836
            ],
            [
              -56.88119788617887,
              -30.088480411707177
            ],
            [
              -56.884812025072925,
              -30.08709200915965
            ],
            [
              -56.88601673803761,
              -30.087415969754073
            ],
            [
              -56.88889757338795,
              -30.089082052811108
            ],
            [
              -56.88952611928257,
              -30.093710061302865
            ],
            [
              -56.89041655929994,
              -30.096995947332015
            ],
            [
              -56.891883166387395,
              -30.100281833361162
            ],
            [
              -56.895183032334145,
              -30.10449332108866
            ],
            [
              -56.898482898280896,
              -30.1080106075424
            ],
            [
              -56.90089232421027,
              -30.110185771533526
            ],
            [
              -56.90262082542047,
              -30.112314655439736
            ],
            [
              -56.905396903121705,
              -30.113517937647593
            ],
            [
              -56.906706373735496,
              -30.11240721560957
            ],
            [
              -56.906496858437286,
              -30.11148161391122
            ],
            [
              -56.904715978402535,
              -30.10912132958042
            ],
            [
              -56.905396903121705,
              -30.107686646947975
            ],
            [
              -56.90712540433191,
              -30.107316406268637
            ],
            [
              -56.91000623968225,
              -30.10819572788207
            ],
            [
              -56.912310907962514,
              -30.110509732127948
            ],
            [
              -56.91388227269906,
              -30.111018813062042
            ],
            [
              -56.91540125861106,
              -30.110185771533526
            ],
            [
              -56.91508698566375,
              -30.107501526608306
            ],
            [
              -56.91199663501521,
              -30.104308200748992
            ],
            [
              -56.91142046794514,
              -30.101114874889678
            ],
            [
              -56.914877470365546,
              -30.099078551153305
            ],
            [
              -56.91618694097934,
              -30.09690338716218
            ],
            [
              -56.917810684540434,
              -30.096209185888416
            ],
            [
              -56.92608653881959,
              -30.095283584190064
            ],
            [
              -56.93069587538013,
              -30.09398774181237
            ],
            [
              -56.93242437659033,
              -30.093895181642534
            ],
            [
              -56.93598613665984,
              -30.094496822746464
            ],
            [
              -56.940385957922174,
              -30.096995947332015
            ],
            [
              -56.944314369763546,
              -30.098476910049378
            ],
            [
              -56.95091410165705,
              -30.099680192257235
            ],
            [
              -56.95358542170918,
              -30.100790914295256
            ],
            [
              -56.955575817042146,
              -30.101114874889678
            ],
            [
              -56.96338026190033,
              -30.09898599098347
            ],
            [
              -56.967780083162666,
              -30.09769014860578
            ],
            [
              -56.97149897970583,
              -30.097181067671684
            ],
            [
              -56.97479884565258,
              -30.097505028266106
            ],
            [
              -56.97610831626637,
              -30.0980141092002
            ],
            [
              -56.97741778688016,
              -30.097597588435942
            ],
            [
              -56.97830822689754,
              -30.094913343510722
            ],
            [
              -56.980403379879604,
              -30.092182818500586
            ],
            [
              -56.98160809284429,
              -30.089683693915035
            ],
            [
              -56.98448892819463,
              -30.087415969754073
            ],
            [
              -56.98742214236952,
              -30.08709200915965
            ],
            [
              -56.9933933283684,
              -30.08570360661212
            ],
            [
              -56.99779314963074,
              -30.08630524771605
            ],
            [
              -57.0017215614721,
              -30.08727712949932
            ],
            [
              -57.00580710978713,
              -30.087786210433414
            ],
            [
              -57.01392582759263,
              -30.08750852992391
            ],
            [
              -57.01832564885496,
              -30.087786210433414
            ],
            [
              -57.02078745360889,
              -30.08727712949932
            ],
            [
              -57.02387780425743,
              -30.08750852992391
            ],
            [
              -57.02890617141439,
              -30.092784459604513
            ],
            [
              -57.03011088437908,
              -30.095283584190064
            ],
            [
              -57.03000612672997,
              -30.09898599098347
            ],
            [
              -57.03032039967728,
              -30.100605793955584
            ],
            [
              -57.03131559734376,
              -30.102086756672946
            ],
            [
              -57.03351550797493,
              -30.103104918541135
            ],
            [
              -57.0358201762552,
              -30.103521439305393
            ],
            [
              -57.04032475516664,
              -30.105002402022755
            ],
            [
              -57.044776955253525,
              -30.10569660329652
            ],
            [
              -57.04650545646373,
              -30.105418922787013
            ],
            [
              -57.0489148823931,
              -30.103706559645065
            ],
            [
              -57.04991008005958,
              -30.10180907616344
            ],
            [
              -57.05090527772606,
              -30.101022314719845
            ],
            [
              -57.053419461304536,
              -30.100605793955584
            ],
            [
              -57.05792404021598,
              -30.09861575030413
            ],
            [
              -57.06090963321542,
              -30.099309951577894
            ],
            [
              -57.063999983863965,
              -30.101022314719845
            ],
            [
              -57.06640940979334,
              -30.101577675738856
            ],
            [
              -57.06782363805623,
              -30.101207435059514
            ],
            [
              -57.06929024514368,
              -30.099217391408057
            ],
            [
              -57.06782363805623,
              -30.09421914223696
            ],
            [
              -57.06709033451251,
              -30.091210936717314
            ],
            [
              -57.06562372742506,
              -30.090007654509456
            ],
            [
              -57.063790468565756,
              -30.09028533501896
            ],
            [
              -57.06148580028549,
              -30.0895911337452
            ],
            [
              -57.061590557934586,
              -30.08760109009374
            ],
            [
              -57.06389522621486,
              -30.086120127376383
            ],
            [
              -57.06651416744244,
              -30.085287085847863
            ],
            [
              -57.06908072984547,
              -30.08561104644229
            ],
            [
              -57.07138539812574,
              -30.086999448989815
            ],
            [
              -57.073585308756904,
              -30.090007654509456
            ],
            [
              -57.07829940296655,
              -30.091488617226823
            ],
            [
              -57.08290873952709,
              -30.095283584190064
            ],
            [
              -57.08411345249178,
              -30.098291789709705
            ],
            [
              -57.087203803140326,
              -30.101022314719845
            ],
            [
              -57.087203803140326,
              -30.105002402022755
            ],
            [
              -57.08767521256129,
              -30.10662220499487
            ],
            [
              -57.08898468317508,
              -30.107918047372564
            ],
            [
              -57.09118459380625,
              -30.10898248932567
            ],
            [
              -57.092179791472724,
              -30.110509732127948
            ],
            [
              -57.092075033823626,
              -30.112684896119077
            ],
            [
              -57.08940371377149,
              -30.11337909739284
            ],
            [
              -57.087884727859496,
              -30.112684896119077
            ],
            [
              -57.087203803140326,
              -30.110602292297784
            ],
            [
              -57.085894332526536,
              -30.110278331703363
            ],
            [
              -57.084584861912745,
              -30.1122220952699
            ],
            [
              -57.08479437721095,
              -30.11448981943086
            ],
            [
              -57.08699428784212,
              -30.118099666054434
            ],
            [
              -57.08929895612239,
              -30.120413670300312
            ],
            [
              -57.09238930677093,
              -30.12180207284784
            ],
            [
              -57.095479657419475,
              -30.121292991913748
            ],
            [
              -57.09511300564762,
              -30.118886427498033
            ],
            [
              -57.09532252094582,
              -30.114998900364956
            ],
            [
              -57.09867476571713,
              -30.114397259261025
            ],
            [
              -57.10150322224291,
              -30.115184020704625
            ],
            [
              -57.10632207410166,
              -30.115322860959377
            ],
            [
              -57.10820771178552,
              -30.116711263506907
            ],
            [
              -57.11161233538137,
              -30.11490634019512
            ],
            [
              -57.11517409545088,
              -30.113703057987262
            ],
            [
              -57.11637880841557,
              -30.114582379600698
            ],
            [
              -57.116693081362875,
              -30.119997149536054
            ],
            [
              -57.11512171662633,
              -30.122681394461274
            ],
            [
              -57.114702686029915,
              -30.12619868091501
            ],
            [
              -57.11297418481971,
              -30.128003604226798
            ],
            [
              -57.11098378948675,
              -30.12869780550056
            ],
            [
              -57.109202909451994,
              -30.127818483887125
            ],
            [
              -57.10831246943462,
              -30.125597039811083
            ],
            [
              -57.105222118786074,
              -30.125504479641247
            ],
            [
              -57.10480308818966,
              -30.127494523292704
            ],
            [
              -57.10558877055794,
              -30.130502728812345
            ],
            [
              -57.10731727176814,
              -30.13290929322806
            ],
            [
              -57.10569352820704,
              -30.135084457219186
            ],
            [
              -57.10899339415379,
              -30.13809266273883
            ],
            [
              -57.11098378948675,
              -30.142720671230588
            ],
            [
              -57.11449317073171,
              -30.145497476325644
            ],
            [
              -57.11747876373115,
              -30.14559003649548
            ],
            [
              -57.119783432011424,
              -30.144618154712212
            ],
            [
              -57.121092902625215,
              -30.142581830975836
            ],
            [
              -57.12292616148452,
              -30.141100868258473
            ],
            [
              -57.12612126978217,
              -30.140499227154546
            ],
            [
              -57.12921162043071,
              -30.14077690766405
            ],
            [
              -57.13020681809719,
              -30.14211903012666
            ],
            [
              -57.13010206044809,
              -30.14387767335353
            ],
            [
              -57.13177818283374,
              -30.14711727929776
            ],
            [
              -57.133506684043944,
              -30.15230064880853
            ],
            [
              -57.13581135232421,
              -30.15790053908356
            ],
            [
              -57.137696990008074,
              -30.159612902225508
            ],
            [
              -57.14031593123565,
              -30.162898788254658
            ],
            [
              -57.1417825383231,
              -30.164287190802185
            ],
            [
              -57.14382531248061,
              -30.1651202323307
            ],
            [
              -57.14461099484888,
              -30.166184674283805
            ],
            [
              -57.14492526779619,
              -30.167989597595593
            ],
            [
              -57.14482051014709,
              -30.171599444219165
            ],
            [
              -57.14560619251536,
              -30.172802726427022
            ],
            [
              -57.1500060137777,
              -30.177615855258452
            ],
            [
              -57.154091562092724,
              -30.18201246332562
            ],
            [
              -57.15817711040775,
              -30.184187627316746
            ],
            [
              -57.15911992924968,
              -30.18571487011903
            ],
            [
              -57.158491383355056,
              -30.191314760394057
            ],
            [
              -57.15948658102154,
              -30.19311968370584
            ],
            [
              -57.16221027989822,
              -30.1951097273573
            ],
            [
              -57.16367688698567,
              -30.195711368461225
            ],
            [
              -57.16718626823062,
              -30.196313009565156
            ],
            [
              -57.168181465897106,
              -30.19760885194285
            ],
            [
              -57.16839098119531,
              -30.200894737971996
            ],
            [
              -57.16708151058152,
              -30.203578982897216
            ],
            [
              -57.16708151058152,
              -30.204782265105074
            ],
            [
              -57.16849573884441,
              -30.20718882952079
            ],
            [
              -57.16839098119531,
              -30.208392111728646
            ],
            [
              -57.16509111524856,
              -30.21190939818238
            ],
            [
              -57.16477684230125,
              -30.213390360899744
            ],
            [
              -57.165614903494074,
              -30.214917603702027
            ],
            [
              -57.168076708248,
              -30.21690764735348
            ],
            [
              -57.166924374107865,
              -30.21829604990101
            ],
            [
              -57.1632054775647,
              -30.21727788803282
            ],
            [
              -57.16257693167008,
              -30.218203489731174
            ],
            [
              -57.1632054775647,
              -30.220517493977052
            ],
            [
              -57.16509111524856,
              -30.22172077618491
            ],
            [
              -57.16571966114318,
              -30.22310917873244
            ],
            [
              -57.16540538819587,
              -30.224497581279966
            ],
            [
              -57.16331023521381,
              -30.227598346969444
            ],
            [
              -57.158700898653265,
              -30.229912351215322
            ],
            [
              -57.15681526096941,
              -30.231393313932685
            ],
            [
              -57.1550867597592,
              -30.233198237244473
            ],
            [
              -57.155191517408305,
              -30.234077558857905
            ],
            [
              -57.157181912741265,
              -30.236391563103787
            ],
            [
              -57.159381823372435,
              -30.239816289387687
            ],
            [
              -57.1614769763545,
              -30.24208401354865
            ],
            [
              -57.16341499286291,
              -30.242917055077164
            ],
            [
              -57.164724463476695,
              -30.242500534312907
            ],
            [
              -57.166295828213244,
              -30.24088073134079
            ],
            [
              -57.16739578352883,
              -30.241389812274885
            ],
            [
              -57.16901952708993,
              -30.243518696181095
            ],
            [
              -57.16739578352883,
              -30.24759134365384
            ],
            [
              -57.16791957177435,
              -30.24897974620137
            ],
            [
              -57.1694909365109,
              -30.250090468239392
            ],
            [
              -57.17190036244027,
              -30.250784669513155
            ],
            [
              -57.175985910755294,
              -30.250784669513155
            ],
            [
              -57.17891912493018,
              -30.25240447248527
            ],
            [
              -57.179914322596666,
              -30.253607754693128
            ],
            [
              -57.18509982622727,
              -30.256291999618348
            ],
            [
              -57.18562361447279,
              -30.257819242420627
            ],
            [
              -57.18672356978837,
              -30.2587911242039
            ],
            [
              -57.18991867808602,
              -30.260410927176014
            ],
            [
              -57.196308894681316,
              -30.26448357464876
            ],
            [
              -57.196989819400486,
              -30.266103377620876
            ],
            [
              -57.19772312294421,
              -30.269990904753953
            ],
            [
              -57.19929448768076,
              -30.27489659375522
            ],
            [
              -57.20028968534724,
              -30.277395718340767
            ],
            [
              -57.202489595978406,
              -30.280311363690576
            ],
            [
              -57.20280386892571,
              -30.28179232640794
            ],
            [
              -57.2022800806802,
              -30.28331956921022
            ],
            [
              -57.20421809718861,
              -30.28507821243709
            ],
            [
              -57.20929884317011,
              -30.284522851418075
            ],
            [
              -57.212912982064175,
              -30.286698015409204
            ],
            [
              -57.21589857506362,
              -30.28831781838132
            ],
            [
              -57.22029839632595,
              -30.289289700164588
            ],
            [
              -57.229307554148825,
              -30.28910457982492
            ],
            [
              -57.238316711971706,
              -30.28910457982492
            ],
            [
              -57.24601639918079,
              -30.289521100589177
            ],
            [
              -57.250101947495814,
              -30.28919713999475
            ],
            [
              -57.253611328740774,
              -30.286281494644946
            ],
            [
              -57.25591599702104,
              -30.28179232640794
            ],
            [
              -57.25439701110904,
              -30.277997359444697
            ],
            [
              -57.2528256463725,
              -30.274804033585383
            ],
            [
              -57.253192298144356,
              -30.27332307086802
            ],
            [
              -57.25858731707317,
              -30.267214099658897
            ],
            [
              -57.26178242537082,
              -30.267214099658897
            ],
            [
              -57.266496519580464,
              -30.270592545857884
            ],
            [
              -57.26901070315894,
              -30.27161070772607
            ],
            [
              -57.27021541612363,
              -30.27869156071846
            ],
            [
              -57.26880118786074,
              -30.282810488276127
            ],
            [
              -57.27011065847453,
              -30.284985652267252
            ],
            [
              -57.274877131508724,
              -30.287021976003626
            ],
            [
              -57.275977086824305,
              -30.289521100589177
            ],
            [
              -57.27781034568361,
              -30.292483026023902
            ],
            [
              -57.280900696332154,
              -30.294287949335686
            ],
            [
              -57.28461959287532,
              -30.29368630823176
            ],
            [
              -57.289019414137655,
              -30.29058554254228
            ],
            [
              -57.293209720101785,
              -30.2864203348997
            ],
            [
              -57.297400026065915,
              -30.279987403096154
            ],
            [
              -57.30101416495997,
              -30.274017272141784
            ],
            [
              -57.30269028734563,
              -30.26869506237626
            ],
            [
              -57.306985350958854,
              -30.262308410657635
            ],
            [
              -57.31138517222119,
              -30.258096922930132
            ],
            [
              -57.31431838639608,
              -30.257680402165875
            ],
            [
              -57.31651829702725,
              -30.259207644968157
            ],
            [
              -57.31761825234283,
              -30.261382808959283
            ],
            [
              -57.31950389002669,
              -30.269713224244448
            ],
            [
              -57.32180855830696,
              -30.271286747131647
            ],
            [
              -57.32568459132378,
              -30.272119788660163
            ],
            [
              -57.329298730217836,
              -30.272490029339505
            ],
            [
              -57.33317476323466,
              -30.27387843188703
            ],
            [
              -57.343021982250356,
              -30.277719678935192
            ],
            [
              -57.34647898467077,
              -30.27970972258665
            ],
            [
              -57.34867889530193,
              -30.281283245473844
            ],
            [
              -57.35197876124868,
              -30.284522851418075
            ],
            [
              -57.353602504809786,
              -30.284893092097416
            ],
            [
              -57.35601193073916,
              -30.284198890823653
            ],
            [
              -57.35768805312481,
              -30.282579087851538
            ],
            [
              -57.35821184137033,
              -30.280681604369917
            ],
            [
              -57.3574785378266,
              -30.27540567468931
            ],
            [
              -57.35878800844039,
              -30.27239746916967
            ],
            [
              -57.361878359088934,
              -30.270916506452306
            ],
            [
              -57.36491633091293,
              -30.271101626791975
            ],
            [
              -57.369787561596226,
              -30.2729991102736
            ],
            [
              -57.374815928753186,
              -30.276377556472582
            ],
            [
              -57.37879671941911,
              -30.279385761992224
            ],
            [
              -57.38089187240117,
              -30.28239396751187
            ],
            [
              -57.384610768944334,
              -30.288595498890825
            ],
            [
              -57.38932486315398,
              -30.295722631968133
            ],
            [
              -57.38979627257494,
              -30.29771267561959
            ],
            [
              -57.38937724197853,
              -30.3024795243661
            ],
            [
              -57.390791470241425,
              -30.30400676716838
            ],
            [
              -57.39241521380252,
              -30.304700968442145
            ],
            [
              -57.39760071743313,
              -30.304515848102476
            ],
            [
              -57.40001014336251,
              -30.303220005724782
            ],
            [
              -57.40210529634457,
              -30.301415082412994
            ],
            [
              -57.40399093402843,
              -30.30072088113923
            ],
            [
              -57.40770983057159,
              -30.300489480714646
            ],
            [
              -57.41132396946565,
              -30.29998039978055
            ],
            [
              -57.41357625892137,
              -30.30058204088448
            ],
            [
              -57.41577616955254,
              -30.301877883262172
            ],
            [
              -57.41860462607833,
              -30.30261836462085
            ],
            [
              -57.42012361199032,
              -30.302201843856594
            ],
            [
              -57.42138070377956,
              -30.300906001478904
            ],
            [
              -57.422009249674176,
              -30.29900851799728
            ],
            [
              -57.42127594613046,
              -30.29461190993011
            ],
            [
              -57.422009249674176,
              -30.292020225174724
            ],
            [
              -57.42169497672687,
              -30.28919713999475
            ],
            [
              -57.41980933904301,
              -30.28558729337118
            ],
            [
              -57.41808083783281,
              -30.28368980988956
            ],
            [
              -57.415304760131576,
              -30.28197744674761
            ],
            [
              -57.41478097188606,
              -30.27970972258665
            ],
            [
              -57.41640471544716,
              -30.277997359444697
            ],
            [
              -57.42399964500714,
              -30.27619243613291
            ],
            [
              -57.429289906286854,
              -30.274618913245714
            ],
            [
              -57.43578488053125,
              -30.27568335519882
            ],
            [
              -57.44489879600323,
              -30.27540567468931
            ],
            [
              -57.44819866194998,
              -30.27600731579324
            ],
            [
              -57.452284210265006,
              -30.27600731579324
            ],
            [
              -57.45547931856265,
              -30.27448007299096
            ],
            [
              -57.45767922919382,
              -30.27119418696181
            ],
            [
              -57.46061244336871,
              -30.26739921999857
            ],
            [
              -57.46349327871905,
              -30.265409176347113
            ],
            [
              -57.46611221994663,
              -30.26508521575269
            ],
            [
              -57.47182151182275,
              -30.266195937790712
            ],
            [
              -57.47658798485695,
              -30.26679757889464
            ],
            [
              -57.481721109663006,
              -30.26661245855497
            ],
            [
              -57.486801855644515,
              -30.26679757889464
            ],
            [
              -57.490101721591266,
              -30.269019022970685
            ],
            [
              -57.49319207223981,
              -30.275914755623404
            ],
            [
              -57.49528722522187,
              -30.278599000548624
            ],
            [
              -57.49680621113387,
              -30.284384011163322
            ],
            [
              -57.497906166449454,
              -30.28729965651313
            ],
            [
              -57.500315592378826,
              -30.288919459485246
            ],
            [
              -57.503877352448335,
              -30.28850293872099
            ],
            [
              -57.506705808974125,
              -30.28651289506953
            ],
            [
              -57.51278175262211,
              -30.28521705269184
            ],
            [
              -57.521319501024024,
              -30.285911253965605
            ],
            [
              -57.52540504933904,
              -30.285494733201347
            ],
            [
              -57.527919232917526,
              -30.283597249719726
            ],
            [
              -57.53158575063613,
              -30.281422085728597
            ],
            [
              -57.53698076956495,
              -30.279293201822387
            ],
            [
              -57.54729939800162,
              -30.27489659375522
            ],
            [
              -57.55080877924657,
              -30.272582589509337
            ],
            [
              -57.55510384285981,
              -30.264992655582855
            ],
            [
              -57.55819419350835,
              -30.263095172101234
            ],
            [
              -57.56238449947248,
              -30.261706769553705
            ],
            [
              -57.56631291131385,
              -30.25911508479832
            ],
            [
              -57.56767476075219,
              -30.25550523817475
            ],
            [
              -57.5679890336995,
              -30.2522193521456
            ],
            [
              -57.565789123068335,
              -30.249581387305298
            ],
            [
              -57.564217758331786,
              -30.246017820766642
            ],
            [
              -57.561389301805995,
              -30.24051049066145
            ],
            [
              -57.55861322410476,
              -30.235604801660187
            ],
            [
              -57.55772278408739,
              -30.233198237244473
            ],
            [
              -57.556308555824494,
              -30.22500666221406
            ],
            [
              -57.5564133134736,
              -30.21862001049543
            ],
            [
              -57.55777516291194,
              -30.213390360899744
            ],
            [
              -57.5631178030162,
              -30.20908631300241
            ],
            [
              -57.573279294979216,
              -30.204782265105074
            ],
            [
              -57.584383605784154,
              -30.199089814660212
            ],
            [
              -57.603397119096385,
              -30.189694957421942
            ],
            [
              -57.61120156395457,
              -30.18909331631801
            ],
            [
              -57.61471094519953,
              -30.18927843665768
            ],
            [
              -57.620420237075656,
              -30.18761235360065
            ],
            [
              -57.62639142307454,
              -30.186686751902297
            ],
            [
              -57.63210071495067,
              -30.187010712496722
            ],
            [
              -57.636500536213,
              -30.188491675214085
            ],
            [
              -57.63980040215975,
              -30.190204038356033
            ],
            [
              -57.64509066343946,
              -30.193721324809772
            ],
            [
              -57.6497,
              -30.18927843665768
            ],
            [
              -57.64839052938621,
              -30.184881828590512
            ],
            [
              -57.64681916464966,
              -30.181595942561362
            ],
            [
              -57.644619254018494,
              -30.17969845907974
            ],
            [
              -57.63959088686154,
              -30.1766902535601
            ],
            [
              -57.63267688202073,
              -30.174792770078476
            ],
            [
              -57.62508195246075,
              -30.17497789041815
            ],
            [
              -57.60931592627072,
              -30.177615855258452
            ],
            [
              -57.60030676844784,
              -30.178680297211553
            ],
            [
              -57.594126067150754,
              -30.17900425780598
            ],
            [
              -57.58799774467821,
              -30.178310056532215
            ],
            [
              -57.5696127772606,
              -30.171784564558834
            ],
            [
              -57.54672323093155,
              -30.161278985282543
            ],
            [
              -57.52561456463725,
              -30.151421327195095
            ],
            [
              -57.503405943027374,
              -30.135778658492953
            ],
            [
              -57.48559714267983,
              -30.124393757603226
            ],
            [
              -57.47601181778688,
              -30.11837734656394
            ],
            [
              -57.46459323403463,
              -30.110278331703363
            ],
            [
              -57.45820301743934,
              -30.101207435059514
            ],
            [
              -57.453803196177006,
              -30.08158467905446
            ],
            [
              -57.447622494879916,
              -30.07228238198602
            ],
            [
              -57.43667532054863,
              -30.05987931922811
            ],
            [
              -57.42918514863775,
              -30.050577022159672
            ],
            [
              -57.41750467076274,
              -30.03840535982635
            ],
            [
              -57.40770983057159,
              -30.03030634496577
            ],
            [
              -57.39629124681934,
              -30.022808971209123
            ],
            [
              -57.383091783032334,
              -30.017579321613436
            ],
            [
              -57.36208787438714,
              -30.01188687116857
            ],
            [
              -57.35197876124868,
              -30.00809190420533
            ],
            [
              -57.34501237758332,
              -29.9982805262028
            ],
            [
              -57.33757458449699,
              -29.989996391002553
            ],
            [
              -57.32809401725315,
              -29.971900877799776
            ],
            [
              -57.32547507602557,
              -29.954499565870762
            ],
            [
              -57.324008468938125,
              -29.939782498866972
            ],
            [
              -57.32411322658723,
              -29.921686985664195
            ],
            [
              -57.328617805498666,
              -29.902480750423393
            ],
            [
              -57.329717760814255,
              -29.887578563079934
            ],
            [
              -57.3245846360082,
              -29.87281521599122
            ],
            [
              -57.314475522869735,
              -29.859903072299215
            ],
            [
              -57.30468068267859,
              -29.844815764616083
            ],
            [
              -57.29781905666233,
              -29.83468042601913
            ],
            [
              -57.28718615527835,
              -29.82320296495957
            ],
            [
              -57.282210166945944,
              -29.817279114090116
            ],
            [
              -57.267805990194255,
              -29.809504059823965
            ],
            [
              -57.24847820393472,
              -29.792796949168714
            ],
            [
              -57.23538349779681,
              -29.78081040717506
            ],
            [
              -57.221084078694226,
              -29.776321238938053
            ],
            [
              -57.20798937255633,
              -29.777802201655415
            ],
            [
              -57.19531369701483,
              -29.779792245306872
            ],
            [
              -57.18070000496494,
              -29.7811806478544
            ],
            [
              -57.17200512008937,
              -29.780717847005224
            ],
            [
              -57.15199640911066,
              -29.774793996135774
            ],
            [
              -57.13188294048284,
              -29.770212267728933
            ],
            [
              -57.12062149320425,
              -29.762113252868353
            ],
            [
              -57.09972234220816,
              -29.74832178756291
            ],
            [
              -57.08290873952709,
              -29.734622882427306
            ],
            [
              -57.06918548749457,
              -29.72189585907497
            ],
            [
              -57.05729549432136,
              -29.713704284044557
            ],
            [
              -57.05210999069075,
              -29.7075027526656
            ],
            [
              -57.04551025879724,
              -29.70157890179615
            ],
            [
              -57.03341075032583,
              -29.695701331011616
            ],
            [
              -57.02702053373053,
              -29.689407239462824
            ],
            [
              -57.021101726556196,
              -29.683298268253704
            ],
            [
              -57.01617811704835,
              -29.674782732628866
            ],
            [
              -57.01151640166326,
              -29.664508553777164
            ],
            [
              -57.0065927921554,
              -29.658214462228372
            ],
            [
              -57.00088350027928,
              -29.65192037067958
            ],
            [
              -56.990617250667164,
              -29.646690721083893
            ],
            [
              -56.980193864581395,
              -29.644515557092767
            ],
            [
              -56.971079949109416,
              -29.643404835054742
            ],
            [
              -56.9674134313908,
              -29.637295863845623
            ],
            [
              -56.9673086737417,
              -29.630122450683395
            ],
            [
              -56.96950858437287,
              -29.62239367650216
            ],
            [
              -56.9720751467759,
              -29.617302867161225
            ],
            [
              -56.97139422205672,
              -29.61031457433867
            ],
            [
              -56.967780083162666,
              -29.601799038713832
            ],
            [
              -56.95882330416434,
              -29.58958109629559
            ],
            [
              -56.95091410165705,
              -29.580695319991413
            ],
            [
              -56.94001930615032,
              -29.573012825895095
            ],
            [
              -56.929491162415445,
              -29.56620965341221
            ],
            [
              -56.920691519890774,
              -29.55450079192806
            ],
            [
              -56.91210139266431,
              -29.544596853755696
            ],
            [
              -56.90199227952585,
              -29.533813593969896
            ],
            [
              -56.88800713337057,
              -29.526408780383083
            ],
            [
              -56.87281727425061,
              -29.514699918898934
            ],
            [
              -56.86082252342829,
              -29.50729510531212
            ],
            [
              -56.84400892074723,
              -29.49919609045154
            ],
            [
              -56.83080945696022,
              -29.49438296162011
            ],
            [
              -56.82211457208466,
              -29.489986353552943
            ],
            [
              -56.81389109663005,
              -29.481100577248764
            ],
            [
              -56.80818180475393,
              -29.473094122558024
            ],
            [
              -56.805405727052694,
              -29.466290950075138
            ],
            [
              -56.8039914987898,
              -29.45971917801684
            ],
            [
              -56.80142493638677,
              -29.45490604918541
            ],
            [
              -56.797025115124434,
              -29.449121038570713
            ],
            [
              -56.785501773723084,
              -29.441808785153732
            ],
            [
              -56.77947820889965,
              -29.437412177086564
            ],
            [
              -56.7779068441631,
              -29.432413927915462
            ],
            [
              -56.777802086513994,
              -29.428989201631563
            ],
            [
              -56.77947820889965,
              -29.423990952460464
            ],
            [
              -56.78000199714516,
              -29.42001086515755
            ],
            [
              -56.780421027741575,
              -29.416308458364142
            ],
            [
              -56.77528790293552,
              -29.394788218877466
            ],
            [
              -56.77319274995346,
              -29.38701316461131
            ],
            [
              -56.76837389809471,
              -29.377988548052382
            ],
            [
              -56.758683815552665,
              -29.37090769505999
            ],
            [
              -56.74621765530938,
              -29.36840857047444
            ],
            [
              -56.73008497734749,
              -29.368917651408534
            ],
            [
              -56.71300948054366,
              -29.367390408606255
            ],
            [
              -56.70001953205487,
              -29.356422028480786
            ],
            [
              -56.68912473654813,
              -29.334022467380674
            ],
            [
              -56.664506689008874,
              -29.295008355795147
            ],
            [
              -56.657592684168065,
              -29.280800369725448
            ],
            [
              -56.65067867932726,
              -29.26427837940987
            ],
            [
              -56.649212072239806,
              -29.255022362426352
            ],
            [
              -56.652302422888354,
              -29.2398887746583
            ],
            [
              -56.654921364115935,
              -29.231188118693794
            ],
            [
              -56.65481660646683,
              -29.22378330510698
            ],
            [
              -56.65120246757277,
              -29.21401820718937
            ],
            [
              -56.64580744864396,
              -29.200319302053764
            ],
            [
              -56.640779081487,
              -29.19471941177874
            ],
            [
              -56.63381269782164,
              -29.18870300073945
            ],
            [
              -56.616894337491466,
              -29.17111656847077
            ],
            [
              -56.61081839384348,
              -29.160287028600052
            ],
            [
              -56.60102355365233,
              -29.145801362020848
            ],
            [
              -56.5948952311798,
              -29.13631394461274
            ],
            [
              -56.593900033513314,
              -29.126317446270544
            ],
            [
              -56.588819287531805,
              -29.119791954297163
            ],
            [
              -56.57781973437597,
              -29.11530278606016
            ],
            [
              -56.56802489418482,
              -29.1140995038523
            ],
            [
              -56.55702534102898,
              -29.115117665720486
            ],
            [
              -56.55011133618817,
              -29.116691188607685
            ],
            [
              -56.544297286662946,
              -29.115719306824417
            ],
            [
              -56.537697554769444,
              -29.111507819096914
            ],
            [
              -56.53277394526159,
              -29.10470464661403
            ],
            [
              -56.52350289331596,
              -29.097901474131145
            ],
            [
              -56.514912766089495,
              -29.092718104620374
            ],
            [
              -56.50302277291628,
              -29.088691737232544
            ],
            [
              -56.48919476323466,
              -29.08688681392076
            ],
            [
              -56.47651908769317,
              -29.086192612646997
            ],
            [
              -56.46211491094148,
              -29.084017448655867
            ],
            [
              -56.44598223297958,
              -29.081981124919494
            ],
            [
              -56.430425722087755,
              -29.079482000333947
            ],
            [
              -56.421783216036744,
              -29.075501913031033
            ],
            [
              -56.416021545336065,
              -29.069022701142572
            ],
            [
              -56.41308833116118,
              -29.06189556806526
            ],
            [
              -56.41308833116118,
              -29.054398194308614
            ],
            [
              -56.4123026487929,
              -29.04717850106147
            ],
            [
              -56.40999798051263,
              -29.038709245521552
            ],
            [
              -56.40439344628561,
              -29.032507714142596
            ],
            [
              -56.40077930739155,
              -29.024593819621685
            ],
            [
              -56.3991031850059,
              -29.01742040645946
            ],
            [
              -56.40219353565444,
              -29.012098196693938
            ],
            [
              -56.40722190281139,
              -29.00881231066479
            ],
            [
              -56.41287881586297,
              -29.005295024211055
            ],
            [
              -56.41617868180972,
              -29.00071329580421
            ],
            [
              -56.41581203003786,
              -28.99590016697278
            ],
            [
              -56.416021545336065,
              -28.992290320349213
            ],
            [
              -56.4121978911438,
              -28.982988023280775
            ],
            [
              -56.406279083969466,
              -28.972621284259237
            ],
            [
              -56.38977975423571,
              -28.95531253250006
            ],
            [
              -56.37898971637808,
              -28.948000279083082
            ],
            [
              -56.362490386644325,
              -28.944205312119838
            ],
            [
              -56.34421017687582,
              -28.94008638456217
            ],
            [
              -56.33289635077267,
              -28.932218770126184
            ],
            [
              -56.327291816545646,
              -28.928192402738354
            ],
            [
              -56.323311025879725,
              -28.924721396369534
            ],
            [
              -56.32158252466952,
              -28.923286713737088
            ],
            [
              -56.308906849128036,
              -28.90870848698805
            ],
            [
              -56.30382610314653,
              -28.903016036543185
            ],
            [
              -56.300107206603364,
              -28.895611222956372
            ],
            [
              -56.29822156891951,
              -28.884411442406318
            ],
            [
              -56.29858822069137,
              -28.873119101686424
            ],
            [
              -56.29748826537578,
              -28.85729131264461
            ],
            [
              -56.29727875007758,
              -28.841417243517878
            ],
            [
              -56.29848346304227,
              -28.83100422441142
            ],
            [
              -56.30120716191895,
              -28.816981358681392
            ],
            [
              -56.29968817600695,
              -28.808095582377216
            ],
            [
              -56.294502672376346,
              -28.799904007346804
            ],
            [
              -56.28910765344753,
              -28.793702475967844
            ],
            [
              -56.28250792155403,
              -28.788796786966582
            ],
            [
              -56.2767986296779,
              -28.785603461107268
            ],
            [
              -56.27098458015267,
              -28.78190105431386
            ],
            [
              -56.260875467014216,
              -28.778985408964054
            ],
            [
              -56.24971877738472,
              -28.77792096701095
            ],
            [
              -56.236990723018685,
              -28.777597006416524
            ],
            [
              -56.223319849810714,
              -28.776810244972925
            ],
            [
              -56.21059179544467,
              -28.77468136106672
            ],
            [
              -56.201215985849934,
              -28.774311120387377
            ],
            [
              -56.19419722336002,
              -28.77519044200081
            ],
            [
              -56.188121279712036,
              -28.77232107673592
            ],
            [
              -56.18230723018681,
              -28.766998866970397
            ],
            [
              -56.1771217265562,
              -28.760612215251772
            ],
            [
              -56.17209335939924,
              -28.753485082174464
            ],
            [
              -56.16570314280395,
              -28.74658934952174
            ],
            [
              -56.160674775646996,
              -28.739693616869022
            ],
            [
              -56.15527975671818,
              -28.73048387997042
            ],
            [
              -56.15171799664867,
              -28.721783224005915
            ],
            [
              -56.1493085707193,
              -28.717710576533168
            ],
            [
              -56.14349452119407,
              -28.709102480738498
            ],
            [
              -56.13778522931794,
              -28.703687710803138
            ],
            [
              -56.13139501272265,
              -28.694709374329125
            ],
            [
              -56.125790478495624,
              -28.687998762016075
            ],
            [
              -56.11919074660212,
              -28.681195589533193
            ],
            [
              -56.10881973934091,
              -28.674716377644728
            ],
            [
              -56.1021152497983,
              -28.669810688643466
            ],
            [
              -56.094782214361075,
              -28.6641182381986
            ],
            [
              -56.08640160243282,
              -28.65708366529113
            ],
            [
              -56.08200178117048,
              -28.65421430002624
            ],
            [
              -56.07660676224167,
              -28.648706969921044
            ],
            [
              -56.07178791038292,
              -28.643384760155524
            ],
            [
              -56.06387870787563,
              -28.63560970588937
            ],
            [
              -56.056283778315645,
              -28.62922305417074
            ],
            [
              -56.04727462049277,
              -28.62408596474489
            ],
            [
              -56.03737502265252,
              -28.621910800753763
            ],
            [
              -56.02600881772482,
              -28.617097671922334
            ],
            [
              -56.01768058462112,
              -28.61288618419483
            ],
            [
              -56.009823760938374,
              -28.605805331202443
            ],
            [
              -56.003381165518526,
              -28.5977988765117
            ],
            [
              -56.00128601253646,
              -28.588080058679004
            ],
            [
              -56.00238596785205,
              -28.578314960761396
            ],
            [
              -56.00710006206169,
              -28.56901266369296
            ],
            [
              -56.01301886923602,
              -28.562996252653676
            ],
            [
              -56.020875692918764,
              -28.553184874651144
            ],
            [
              -56.024175558865515,
              -28.545687500894495
            ],
            [
              -56.02569454477751,
              -28.534811680938862
            ],
            [
              -56.02318036119903,
              -28.522778858860292
            ],
            [
              -56.01809961521753,
              -28.514217043150538
            ],
            [
              -56.011185610376714,
              -28.506904789733557
            ],
            [
              -56.00128601253646,
              -28.501582579968037
            ],
            [
              -55.98819130639856,
              -28.498111573599218
            ],
            [
              -55.97090629429653,
              -28.496399210457266
            ],
            [
              -55.96032577173711,
              -28.49477940748515
            ],
            [
              -55.94927383975672,
              -28.494594287145482
            ],
            [
              -55.94000278781109,
              -28.492002602390095
            ],
            [
              -55.928793719357046,
              -28.486402712115066
            ],
            [
              -55.9111944343077,
              -28.48270030532166
            ],
            [
              -55.90721364364178,
              -28.48158958328364
            ],
            [
              -55.89752356109973,
              -28.48098794217971
            ],
            [
              -55.88400982436542,
              -28.479183018867925
            ],
            [
              -55.881286125488735,
              -28.47349056842306
            ],
            [
              -55.882595596102526,
              -28.463818030675284
            ],
            [
              -55.88909057034692,
              -28.444796915774155
            ],
            [
              -55.89548078694222,
              -28.429478207666435
            ],
            [
              -55.90098056352014,
              -28.41878750805047
            ],
            [
              -55.90302333767765,
              -28.407587727500417
            ],
            [
              -55.90040439645007,
              -28.398285430431983
            ],
            [
              -55.89569030224043,
              -28.389908735061898
            ],
            [
              -55.89008576801341,
              -28.38120807909739
            ],
            [
              -55.88448123378639,
              -28.374821427378766
            ],
            [
              -55.87871956308571,
              -28.361816723516924
            ],
            [
              -55.871124633525724,
              -28.357281275195
            ],
            [
              -55.85949653447527,
              -28.3549209908642
            ],
            [
              -55.8505921343015,
              -28.35538379171338
            ],
            [
              -55.83859738347918,
              -28.358484557402857
            ],
            [
              -55.82167902314901,
              -28.363621646828708
            ],
            [
              -55.809579514677594,
              -28.36570425065
            ],
            [
              -55.79638005089058,
              -28.367416613791953
            ],
            [
              -55.78139970706883,
              -28.367277773537197
            ],
            [
              -55.76710028796624,
              -28.368203375235552
            ],
            [
              -55.75662452305592,
              -28.369406657443406
            ],
            [
              -55.74641065226836,
              -28.37320162440665
            ],
            [
              -55.74002043567306,
              -28.376996591369892
            ],
            [
              -55.73441590144604,
              -28.38120807909739
            ],
            [
              -55.7282875789735,
              -28.392500419817285
            ],
            [
              -55.723102075342894,
              -28.407402607160748
            ],
            [
              -55.71969745174704,
              -28.41869494788064
            ],
            [
              -55.71351675044995,
              -28.425822080957946
            ],
            [
              -55.704298077328865,
              -28.427580724184814
            ],
            [
              -55.695184161856886,
              -28.422998995777974
            ],
            [
              -55.69219856885744,
              -28.41638094363476
            ],
            [
              -55.69067958294545,
              -28.413280177945282
            ],
            [
              -55.690574825296345,
              -28.404718362235528
            ],
            [
              -55.690574825296345,
              -28.39601770627102
            ],
            [
              -55.688793945261594,
              -28.388196371919946
            ],
            [
              -55.68549407931484,
              -28.381393199437063
            ],
            [
              -55.68009906038603,
              -28.3699157383775
            ],
            [
              -55.67459928380811,
              -28.356401953581567
            ],
            [
              -55.67077562961584,
              -28.345711253965604
            ],
            [
              -55.66920426487929,
              -28.340805564964338
            ],
            [
              -55.67040897784398,
              -28.334418913245713
            ],
            [
              -55.67459928380811,
              -28.32798598144217
            ],
            [
              -55.680203818035125,
              -28.322200970827467
            ],
            [
              -55.686803549928634,
              -28.318822524628484
            ],
            [
              -55.69429372183951,
              -28.31521267800491
            ],
            [
              -55.70178389375039,
              -28.31118631061708
            ],
            [
              -55.71189300688885,
              -28.30392033728502
            ],
            [
              -55.716711858747594,
              -28.29901464828376
            ],
            [
              -55.72362586358841,
              -28.292720556734967
            ],
            [
              -55.73289691553404,
              -28.286009944421917
            ],
            [
              -55.74311078632161,
              -28.28152077618491
            ],
            [
              -55.75468650654751,
              -28.279808413042957
            ],
            [
              -55.76877641035189,
              -28.275504365145622
            ],
            [
              -55.77317623161423,
              -28.274208522767932
            ],
            [
              -55.77998547880593,
              -28.265183906209003
            ],
            [
              -55.782604420033515,
              -28.256113009565155
            ],
            [
              -55.77851887171849,
              -28.247690034110153
            ],
            [
              -55.77118583628126,
              -28.241488502731197
            ],
            [
              -55.76301473965121,
              -28.23871169763614
            ],
            [
              -55.75002479116242,
              -28.233713448465043
            ],
            [
              -55.733892113200525,
              -28.22931684039787
            ],
            [
              -55.71817846583504,
              -28.226678875557567
            ],
            [
              -55.704717107925276,
              -28.224318591226773
            ],
            [
              -55.69261759945386,
              -28.21881126112158
            ],
            [
              -55.68428936635016,
              -28.210619686091167
            ],
            [
              -55.67831818035127,
              -28.205204916155807
            ],
            [
              -55.67072325079129,
              -28.19867942418243
            ],
            [
              -55.66208074474027,
              -28.189192006774324
            ],
            [
              -55.65301920809284,
              -28.182111153781932
            ],
            [
              -55.643276746726244,
              -28.18021367030031
            ],
            [
              -55.63421521007882,
              -28.177807105884597
            ],
            [
              -55.62808688760628,
              -28.172299775779404
            ],
            [
              -55.62232521690561,
              -28.161007435059513
            ],
            [
              -55.61970627567803,
              -28.153510061302864
            ],
            [
              -55.62159191336188,
              -28.145688726951793
            ],
            [
              -55.62237759573016,
              -28.138422753619732
            ],
            [
              -55.62080623099361,
              -28.131017940032915
            ],
            [
              -55.61609213678396,
              -28.123890806955608
            ],
            [
              -55.610697117855146,
              -28.117504155236983
            ],
            [
              -55.604306901259854,
              -28.11542155141569
            ],
            [
              -55.59629294110346,
              -28.11579179209503
            ],
            [
              -55.58691713150872,
              -28.11949419888844
            ],
            [
              -55.58340775026376,
              -28.1251866493333
            ],
            [
              -55.58539814559673,
              -28.13189726164635
            ],
            [
              -55.587702813876994,
              -28.135877348949265
            ],
            [
              -55.58911704213989,
              -28.141801199818715
            ],
            [
              -55.58529338794762,
              -28.14800273119767
            ],
            [
              -55.57701753366847,
              -28.153510061302864
            ],
            [
              -55.57120348414324,
              -28.156981067671683
            ],
            [
              -55.56418472165333,
              -28.163506559645064
            ],
            [
              -55.55748023211072,
              -28.164617281683086
            ],
            [
              -55.55218997083101,
              -28.160220673615914
            ],
            [
              -55.54930913548067,
              -28.156009185888415
            ],
            [
              -55.54841869546329,
              -28.147401090093744
            ],
            [
              -55.54820918016509,
              -28.141801199818715
            ],
            [
              -55.54758063427047,
              -28.13647899005319
            ],
            [
              -55.543704601253644,
              -28.129907217994894
            ],
            [
              -55.53977618941228,
              -28.122594964577917
            ],
            [
              -55.53631918699187,
              -28.118614877275004
            ],
            [
              -55.530609895115745,
              -28.115514111585526
            ],
            [
              -55.52479584559052,
              -28.11468107005701
            ],
            [
              -55.51898179606529,
              -28.11560667175536
            ],
            [
              -55.51322012536461,
              -28.114588509887174
            ],
            [
              -55.509815501768756,
              -28.10931258020657
            ],
            [
              -55.506725151120214,
              -28.10278708823319
            ],
            [
              -55.50552043815553,
              -28.097881399231923
            ],
            [
              -55.50201105691057,
              -28.090013784795936
            ],
            [
              -55.49939211568299,
              -28.08108172840684
            ],
            [
              -55.49551608266617,
              -28.076916520764257
            ],
            [
              -55.487921153106186,
              -28.0765
            ],
            [
              -55.477916797616835,
              -28.081498249171098
            ],
            [
              -55.46880288214486,
              -28.08797746105956
            ],
            [
              -55.46298883261962,
              -28.090893106409368
            ],
            [
              -55.4587985266555,
              -28.093577351334588
            ],
            [
              -55.454503463042265,
              -28.095613675070965
            ],
            [
              -55.452513067709305,
              -28.098020239486676
            ],
            [
              -55.44790373114876,
              -28.09741859838275
            ],
            [
              -55.44261346986905,
              -28.09431783269327
            ],
            [
              -55.4395231192205,
              -28.08779234071989
            ],
            [
              -55.43842316390492,
              -28.086311378002527
            ],
            [
              -55.433709069695276,
              -28.08742210004055
            ],
            [
              -55.43161391671322,
              -28.090384025475274
            ],
            [
              -55.42868070253832,
              -28.092096388617225
            ],
            [
              -55.42810453546826,
              -28.093901311929013
            ],
            [
              -55.42831405076646,
              -28.098483040335854
            ],
            [
              -55.42527607894247,
              -28.100519364072227
            ],
            [
              -55.42339044125861,
              -28.100797044581732
            ],
            [
              -55.42192383417117,
              -28.099778882713544
            ],
            [
              -55.4181001799789,
              -28.090800546239535
            ],
            [
              -55.414905071681254,
              -28.08779234071989
            ],
            [
              -55.4099814621734,
              -28.08857910216349
            ],
            [
              -55.40877674920871,
              -28.08968982420151
            ],
            [
              -55.412024236330915,
              -28.097881399231923
            ],
            [
              -55.41081952336623,
              -28.100287963647638
            ],
            [
              -55.40689111152486,
              -28.099408642034206
            ],
            [
              -55.4033817302799,
              -28.095798795410634
            ],
            [
              -55.39981997021039,
              -28.09528971447654
            ],
            [
              -55.398720014894806,
              -28.096678117024066
            ],
            [
              -55.40301507850804,
              -28.10579529375283
            ],
            [
              -55.40322459380624,
              -28.113801748443574
            ],
            [
              -55.402491290262525,
              -28.115097590821268
            ],
            [
              -55.3966772407373,
              -28.11680995396322
            ],
            [
              -55.395210633649846,
              -28.118383476850415
            ],
            [
              -55.394320193632474,
              -28.120419800586788
            ],
            [
              -55.39458208775523,
              -28.122780084917586
            ],
            [
              -55.39662486191274,
              -28.129120456551295
            ],
            [
              -55.39557728542171,
              -28.129907217994894
            ],
            [
              -55.39138697945758,
              -28.130508859098825
            ],
            [
              -55.3903917817911,
              -28.12999977816473
            ],
            [
              -55.38960609942283,
              -28.11579179209503
            ],
            [
              -55.38740618879166,
              -28.113709188273738
            ],
            [
              -55.38609671817787,
              -28.11407942895308
            ],
            [
              -55.3789208192143,
              -28.120697481096293
            ],
            [
              -55.37651139328493,
              -28.12139168237006
            ],
            [
              -55.374206725004655,
              -28.12060492092646
            ],
            [
              -55.37169254142618,
              -28.11810579634091
            ],
            [
              -55.3705925861106,
              -28.11579179209503
            ],
            [
              -55.36849743312853,
              -28.11579179209503
            ],
            [
              -55.368026023707564,
              -28.11810579634091
            ],
            [
              -55.36619276484826,
              -28.12352056627627
            ],
            [
              -55.365302324830886,
              -28.123983367125444
            ],
            [
              -55.36352144479613,
              -28.123798246785775
            ],
            [
              -55.358493077639174,
              -28.120512360756624
            ],
            [
              -55.35660743995532,
              -28.121114001860555
            ],
            [
              -55.3559788940607,
              -28.122594964577917
            ],
            [
              -55.35749787997269,
              -28.130601419268658
            ],
            [
              -55.35671219760442,
              -28.132406342580445
            ],
            [
              -55.354983696394214,
              -28.133609624788303
            ],
            [
              -55.357602637621795,
              -28.139209515063328
            ],
            [
              -55.3577073952709,
              -28.14092187820528
            ],
            [
              -55.360902503568546,
              -28.14550360661212
            ],
            [
              -55.36697844721653,
              -28.14878949264127
            ],
            [
              -55.36771175076026,
              -28.150085335018964
            ],
            [
              -55.366611795444676,
              -28.153510061302864
            ],
            [
              -55.36750223546205,
              -28.15799922953987
            ],
            [
              -55.36860219077764,
              -28.15971159268182
            ],
            [
              -55.36860219077764,
              -28.161701636333277
            ],
            [
              -55.36619276484826,
              -28.164802402022755
            ],
            [
              -55.3640976118662,
              -28.164987522362427
            ],
            [
              -55.36132153416496,
              -28.164015640579155
            ],
            [
              -55.35901686588469,
              -28.161701636333277
            ],
            [
              -55.35571699993794,
              -28.16160907616344
            ],
            [
              -55.354512286973254,
              -28.16239583760704
            ],
            [
              -55.358702592937384,
              -28.172901416883334
            ],
            [
              -55.35728836467449,
              -28.174984020704624
            ],
            [
              -55.35571699993794,
              -28.175585661808555
            ],
            [
              -55.35021722336002,
              -28.173780738496767
            ],
            [
              -55.345398371501275,
              -28.17428981943086
            ],
            [
              -55.33848436666046,
              -28.184795398707152
            ],
            [
              -55.33277507478434,
              -28.18581356057534
            ],
            [
              -55.3284800111711,
              -28.18521191947141
            ],
            [
              -55.323084992242286,
              -28.182481394461274
            ],
            [
              -55.32318974989139,
              -28.177020344440997
            ],
            [
              -55.308209406069636,
              -28.174613780025282
            ],
            [
              -55.299619278843174,
              -28.17160557450564
            ],
            [
              -55.298781217650344,
              -28.171883255015146
            ],
            [
              -55.300509718860546,
              -28.175215421129213
            ],
            [
              -55.303600069509095,
              -28.178408746988527
            ],
            [
              -55.316485260348784,
              -28.189192006774324
            ],
            [
              -55.32591344876808,
              -28.188821766094982
            ],
            [
              -55.328375253522005,
              -28.19442165637001
            ],
            [
              -55.329684724135795,
              -28.19497701738902
            ],
            [
              -55.337279653695774,
              -28.190904369916275
            ],
            [
              -55.34047476199342,
              -28.191783691529707
            ],
            [
              -55.342779430273694,
              -28.19941990554111
            ],
            [
              -55.342098505554524,
              -28.203585113183692
            ],
            [
              -55.34068427729163,
              -28.20478839539155
            ],
            [
              -55.335708288959225,
              -28.207009839467595
            ],
            [
              -55.32811335939925,
              -28.203122312334518
            ],
            [
              -55.31638050269969,
              -28.202983472079765
            ],
            [
              -55.31569957798051,
              -28.204418154712208
            ],
            [
              -55.31810900390989,
              -28.208907322949216
            ],
            [
              -55.3218802792776,
              -28.207889161081027
            ],
            [
              -55.32648961583814,
              -28.209277563628557
            ],
            [
              -55.32669913113635,
              -28.212517169572788
            ],
            [
              -55.33261793831068,
              -28.220292223838943
            ],
            [
              -55.33251318066158,
              -28.222097147150727
            ],
            [
              -55.34199374790542,
              -28.23760097559812
            ],
            [
              -55.341888990256315,
              -28.239405898909904
            ],
            [
              -55.35047911748278,
              -28.246579312072132
            ],
            [
              -55.351421936324705,
              -28.254122965913698
            ],
            [
              -55.35938351765655,
              -28.262221980774274
            ],
            [
              -55.36441188481351,
              -28.261620339670348
            ],
            [
              -55.370225934338734,
              -28.27249615962598
            ],
            [
              -55.38091121454726,
              -28.287213226629774
            ],
            [
              -55.38180165456464,
              -28.29720972497197
            ],
            [
              -55.383687292248496,
              -28.304892219068293
            ],
            [
              -55.38641099112518,
              -28.304799658898457
            ],
            [
              -55.39557728542171,
              -28.30091213176538
            ],
            [
              -55.400291379631355,
              -28.29980140972736
            ],
            [
              -55.409824325699745,
              -28.294618040216587
            ],
            [
              -55.41317657047105,
              -28.28961979104549
            ],
            [
              -55.412914676348294,
              -28.286287624931422
            ],
            [
              -55.41427652578663,
              -28.28300173890227
            ],
            [
              -55.41841445292621,
              -28.276985327862988
            ],
            [
              -55.42328568360951,
              -28.2743936431076
            ],
            [
              -55.42941400608205,
              -28.269904474870597
            ],
            [
              -55.436589905045615,
              -28.25930633542447
            ],
            [
              -55.438580300378575,
              -28.257316291773012
            ],
            [
              -55.44360866753553,
              -28.248800756148174
            ],
            [
              -55.44449910755291,
              -28.249217276912432
            ],
            [
              -55.448322761745175,
              -28.253197364215346
            ],
            [
              -55.460684164339355,
              -28.251716401497983
            ],
            [
              -55.463984030286106,
              -28.256899771008754
            ],
            [
              -55.47880723763421,
              -28.26578554731293
            ],
            [
              -55.48619265189598,
              -28.27231103928631
            ],
            [
              -55.487502122509774,
              -28.2751804045512
            ],
            [
              -55.48718784956247,
              -28.28110425542065
            ],
            [
              -55.49022582138646,
              -28.286009944421917
            ],
            [
              -55.488183047228944,
              -28.291794955036615
            ],
            [
              -55.48839256252715,
              -28.29989396989719
            ],
            [
              -55.49027820021101,
              -28.30530873983255
            ],
            [
              -55.494782779122446,
              -28.309983028409228
            ],
            [
              -55.49792550859554,
              -28.316277119958016
            ],
            [
              -55.4979778874201,
              -28.32048860768552
            ],
            [
              -55.50400145224353,
              -28.327014099658896
            ],
            [
              -55.504682376962705,
              -28.328495062376263
            ],
            [
              -55.50421096754174,
              -28.331179307301483
            ],
            [
              -55.50730131819028,
              -28.33367843188703
            ],
            [
              -55.50918695587414,
              -28.33349331154736
            ],
            [
              -55.51102021473345,
              -28.336316396727334
            ],
            [
              -55.51369153478558,
              -28.33691803783126
            ],
            [
              -55.525319633836034,
              -28.34339724971972
            ],
            [
              -55.52060553962639,
              -28.347793857786893
            ],
            [
              -55.51981985725811,
              -28.35168138491997
            ],
            [
              -55.509396471172344,
              -28.36209440402643
            ],
            [
              -55.500492070998575,
              -28.365195169715907
            ],
            [
              -55.50002066157761,
              -28.36612077141426
            ],
            [
              -55.50148726866505,
              -28.381717160031485
            ],
            [
              -55.50347766399801,
              -28.392315299477612
            ],
            [
              -55.50269198162974,
              -28.399812673234262
            ],
            [
              -55.50688228759387,
              -28.403191119433245
            ],
            [
              -55.51761994662695,
              -28.412400856331846
            ],
            [
              -55.524376814994106,
              -28.415177661426902
            ],
            [
              -55.52448157264321,
              -28.424017157646162
            ],
            [
              -55.52212452553839,
              -28.429478207666435
            ],
            [
              -55.52338161732762,
              -28.44822164205806
            ],
            [
              -55.52877663625644,
              -28.457801619635998
            ],
            [
              -55.54192372121889,
              -28.46238334804284
            ],
            [
              -55.55150904611184,
              -28.461087505665148
            ],
            [
              -55.55491366970769,
              -28.462105667533336
            ],
            [
              -55.568008375845594,
              -28.46927908069556
            ],
            [
              -55.57052255942407,
              -28.475017811225342
            ],
            [
              -55.577907973685846,
              -28.477100415046632
            ],
            [
              -55.58398391733383,
              -28.484320108293776
            ],
            [
              -55.58738854092969,
              -28.485477110416717
            ],
            [
              -55.590374133929124,
              -28.488392755766522
            ],
            [
              -55.60299743064606,
              -28.488716716360948
            ],
            [
              -55.61122090610066,
              -28.487004353218996
            ],
            [
              -55.624210854589464,
              -28.488392755766522
            ],
            [
              -55.63180578414945,
              -28.493205884597952
            ],
            [
              -55.6351056500962,
              -28.496214090117597
            ],
            [
              -55.646524233848446,
              -28.49820413376905
            ],
            [
              -55.654695330478496,
              -28.498389254108723
            ],
            [
              -55.65867612114442,
              -28.49801901342938
            ],
            [
              -55.6630235635822,
              -28.495982689693008
            ],
            [
              -55.67931337801775,
              -28.498296693938887
            ],
            [
              -55.687222580525045,
              -28.515188924933806
            ],
            [
              -55.69549843480419,
              -28.519678093170814
            ],
            [
              -55.6971221783653,
              -28.531386954654963
            ],
            [
              -55.701417241978525,
              -28.53680172459032
            ],
            [
              -55.70309336436418,
              -28.538421527562434
            ],
            [
              -55.706497987960034,
              -28.538976888581445
            ],
            [
              -55.71252155278347,
              -28.54221649452568
            ],
            [
              -55.71550714578291,
              -28.54638170216826
            ],
            [
              -55.717392783466764,
              -28.54638170216826
            ],
            [
              -55.718911769378764,
              -28.54869570641414
            ],
            [
              -55.72378300006206,
              -28.548418025904635
            ],
            [
              -55.7282875789735,
              -28.550500629725924
            ],
            [
              -55.729020882517226,
              -28.551796472103618
            ],
            [
              -55.729282776639984,
              -28.557396362378647
            ],
            [
              -55.728182821324395,
              -28.559386406030104
            ],
            [
              -55.730382731955565,
              -28.563505333587766
            ],
            [
              -55.72959704958729,
              -28.567577981060516
            ],
            [
              -55.73310643083225,
              -28.570586186580158
            ],
            [
              -55.73420638614783,
              -28.57317787133554
            ],
            [
              -55.744105983988085,
              -28.576602597619445
            ],
            [
              -55.74510118165457,
              -28.578083560336808
            ],
            [
              -55.750286685285175,
              -28.58150828662071
            ],
            [
              -55.75369130888103,
              -28.58030500441285
            ],
            [
              -55.757095932476886,
              -28.582109927724638
            ],
            [
              -55.760500556072735,
              -28.58169340696038
            ],
            [
              -55.764900377335074,
              -28.584007411206258
            ],
            [
              -55.76961447154471,
              -28.583498330272164
            ],
            [
              -55.7707144268603,
              -28.581415726450874
            ],
            [
              -55.772390549245955,
              -28.585210693414115
            ],
            [
              -55.770923942158504,
              -28.591689905302577
            ],
            [
              -55.769509713895616,
              -28.59451299048255
            ],
            [
              -55.766000332650655,
              -28.596503034134006
            ],
            [
              -55.762700466703905,
              -28.597289795577606
            ],
            [
              -55.75840540309068,
              -28.596919554898264
            ],
            [
              -55.7545817488984,
              -28.5985856379553
            ],
            [
              -55.73321118848135,
              -28.62269756219736
            ],
            [
              -55.73132555079749,
              -28.622605002027527
            ],
            [
              -55.7282875789735,
              -28.61890259523412
            ],
            [
              -55.72472581890399,
              -28.617005111752498
            ],
            [
              -55.72362586358841,
              -28.617976993535766
            ],
            [
              -55.72561625892137,
              -28.619689356677718
            ],
            [
              -55.72540674362316,
              -28.622419881687854
            ],
            [
              -55.72252590827282,
              -28.62561320754717
            ],
            [
              -55.71702613169491,
              -28.626122288481263
            ],
            [
              -55.7103216421523,
              -28.623993404575053
            ],
            [
              -55.70178389375039,
              -28.625104126613074
            ],
            [
              -55.69979349841743,
              -28.626122288481263
            ],
            [
              -55.69968874076832,
              -28.627418130858956
            ],
            [
              -55.707597943275616,
              -28.638016270305084
            ],
            [
              -55.71278344690623,
              -28.64690204660926
            ],
            [
              -55.720011724694345,
              -28.653103577988215
            ],
            [
              -55.71901652702787,
              -28.65611178350786
            ],
            [
              -55.71718326816856,
              -28.657777866564892
            ],
            [
              -55.70728367032831,
              -28.661619113613053
            ],
            [
              -55.70408856203066,
              -28.660184430980607
            ],
            [
              -55.69958398311922,
              -28.656019223338024
            ],
            [
              -55.69659839011978,
              -28.654815941130167
            ],
            [
              -55.69450323713772,
              -28.6564820241872
            ],
            [
              -55.68957962762987,
              -28.663285196670085
            ],
            [
              -55.681722803947125,
              -28.6656917610858
            ],
            [
              -55.67569923912369,
              -28.671523051785414
            ],
            [
              -55.671089902563146,
              -28.67161561195525
            ],
            [
              -55.666009156581644,
              -28.669995808983135
            ],
            [
              -55.662814048284,
              -28.671893292464755
            ],
            [
              -55.65899039409173,
              -28.67198585263459
            ],
            [
              -55.648724144479615,
              -28.669810688643466
            ],
            [
              -55.6417053819897,
              -28.669209047539535
            ],
            [
              -55.63589133246447,
              -28.671708172125086
            ],
            [
              -55.634319967727926,
              -28.67601222002242
            ],
            [
              -55.628820191150005,
              -28.68448147556234
            ],
            [
              -55.627301205238005,
              -28.684805436156765
            ],
            [
              -55.62489177930863,
              -28.68369471411874
            ],
            [
              -55.61829204741513,
              -28.678418784438136
            ],
            [
              -55.61661592502948,
              -28.67800226367388
            ],
            [
              -55.606716327189226,
              -28.684388915392503
            ],
            [
              -55.60257840004965,
              -28.685916158194786
            ],
            [
              -55.59629294110346,
              -28.68637895904396
            ],
            [
              -55.59330734810402,
              -28.689988805667532
            ],
            [
              -55.59089792217464,
              -28.690821847196048
            ],
            [
              -55.588383738596164,
              -28.689479724733438
            ],
            [
              -55.58539814559673,
              -28.685916158194786
            ],
            [
              -55.57649374542295,
              -28.681103029363356
            ],
            [
              -55.575498547756474,
              -28.680177427665004
            ],
            [
              -55.57450335008999,
              -28.676382460701763
            ],
            [
              -55.572984364178,
              -28.676289900531927
            ],
            [
              -55.56371331223236,
              -28.683417033609235
            ],
            [
              -55.56392282753057,
              -28.68471287598693
            ],
            [
              -55.570208286476756,
              -28.690590446771463
            ],
            [
              -55.571989166511514,
              -28.692997011187177
            ],
            [
              -55.571989166511514,
              -28.69447797390454
            ],
            [
              -55.5617229168994,
              -28.696977098490088
            ],
            [
              -55.55658979209334,
              -28.700309264604154
            ],
            [
              -55.54978054490164,
              -28.707482677766382
            ],
            [
              -55.54768539191957,
              -28.708593399804403
            ],
            [
              -55.54600926953392,
              -28.707204997256873
            ],
            [
              -55.543180813008135,
              -28.70729755742671
            ],
            [
              -55.53537636814994,
              -28.710722283710613
            ],
            [
              -55.53427641283436,
              -28.717895696872837
            ],
            [
              -55.537681036430214,
              -28.722384865109845
            ],
            [
              -55.535690641097254,
              -28.72881779691339
            ],
            [
              -55.53427641283436,
              -28.73011363929108
            ],
            [
              -55.52008175138087,
              -28.72631867232784
            ],
            [
              -55.515996203065846,
              -28.727383114280943
            ],
            [
              -55.51259157947,
              -28.73108552107435
            ],
            [
              -55.50929171352324,
              -28.733306965150394
            ],
            [
              -55.501906299261464,
              -28.730622720225174
            ],
            [
              -55.49928735803389,
              -28.73048387997042
            ],
            [
              -55.497192205051824,
              -28.73150204183861
            ],
            [
              -55.49672079563086,
              -28.7327978842163
            ],
            [
              -55.4979778874201,
              -28.735389568971687
            ],
            [
              -55.49740172035003,
              -28.737379612623144
            ],
            [
              -55.49598749208714,
              -28.738305214321493
            ],
            [
              -55.496092249736236,
              -28.739786177038855
            ],
            [
              -55.497192205051824,
              -28.74089689907688
            ],
            [
              -55.503791936945326,
              -28.741915060945065
            ],
            [
              -55.50761559113759,
              -28.744784426209957
            ],
            [
              -55.5047871346118,
              -28.750985957588913
            ],
            [
              -55.505991847576496,
              -28.75371648259905
            ],
            [
              -55.505415680506424,
              -28.760195694487514
            ],
            [
              -55.50400145224353,
              -28.764083221620588
            ],
            [
              -55.50290149692795,
              -28.765193943658613
            ],
            [
              -55.49551608266617,
              -28.764777422894355
            ],
            [
              -55.49488753677155,
              -28.767878188583833
            ],
            [
              -55.49200670142121,
              -28.770701273763805
            ],
            [
              -55.49200670142121,
              -28.776717684803092
            ],
            [
              -55.48917824489543,
              -28.779494489898145
            ],
            [
              -55.48472604480854,
              -28.78139197337977
            ],
            [
              -55.48367846831751,
              -28.78421505855974
            ],
            [
              -55.48341657419475,
              -28.788796786966582
            ],
            [
              -55.47980243530069,
              -28.792314073420318
            ],
            [
              -55.47891199528331,
              -28.798099084035016
            ],
            [
              -55.47451217402098,
              -28.799302366242873
            ],
            [
              -55.46990283746044,
              -28.802680812441857
            ],
            [
              -55.469588564513124,
              -28.804902256517902
            ],
            [
              -55.46801719977658,
              -28.80767906161296
            ],
            [
              -55.46801719977658,
              -28.809900505689
            ],
            [
              -55.46581728914541,
              -28.812121949765046
            ],
            [
              -55.461784119654936,
              -28.8141119934165
            ],
            [
              -55.45827473840998,
              -28.814621074350594
            ],
            [
              -55.45350826537579,
              -28.813788032822078
            ],
            [
              -55.44978936883262,
              -28.812307070104715
            ],
            [
              -55.44879417116614,
              -28.812908711208642
            ],
            [
              -55.44737994290325,
              -28.817999520549577
            ],
            [
              -55.444289592254705,
              -28.82239612861675
            ],
            [
              -55.440780211009745,
              -28.823599410824606
            ],
            [
              -55.439680255694164,
              -28.825496894306227
            ],
            [
              -55.437480345062994,
              -28.825311773966558
            ],
            [
              -55.434809025010864,
              -28.827486937957683
            ],
            [
              -55.432818629677904,
              -28.827394377787847
            ],
            [
              -55.43140440141501,
              -28.838177637573647
            ],
            [
              -55.43250435673059,
              -28.840815602413947
            ],
            [
              -55.432399599081485,
              -28.84271308589557
            ],
            [
              -55.43140440141501,
              -28.844379168952603
            ],
            [
              -55.42868070253832,
              -28.84479568971686
            ],
            [
              -55.42192383417117,
              -28.843222166829662
            ],
            [
              -55.41940965059269,
              -28.844980810056533
            ],
            [
              -55.41841445292621,
              -28.846878293538154
            ],
            [
              -55.41899061999628,
              -28.84960881854829
            ],
            [
              -55.427685504871846,
              -28.854514507549556
            ],
            [
              -55.4311948861168,
              -28.857800393578703
            ],
            [
              -55.4327138720288,
              -28.861086279607854
            ],
            [
              -55.43219008378328,
              -28.862613522410133
            ],
            [
              -55.42799977781915,
              -28.864881246571095
            ],
            [
              -55.41610978464594,
              -28.86400192495766
            ],
            [
              -55.41370035871657,
              -28.864418445721917
            ],
            [
              -55.40542450443741,
              -28.869786935572357
            ],
            [
              -55.40071041022777,
              -28.870990217780214
            ],
            [
              -55.40039613728046,
              -28.875803346611644
            ],
            [
              -55.398981909017564,
              -28.87881155213129
            ],
            [
              -55.39641534661454,
              -28.88010739450898
            ],
            [
              -55.39117746415938,
              -28.879783433914557
            ],
            [
              -55.38950134177372,
              -28.87691406864967
            ],
            [
              -55.38808711351083,
              -28.876497547885407
            ],
            [
              -55.38798235586173,
              -28.875479386017222
            ],
            [
              -55.385887202879665,
              -28.875386825847386
            ],
            [
              -55.384996762862286,
              -28.873720742790354
            ],
            [
              -55.38342539812574,
              -28.874692624573623
            ],
            [
              -55.37797800037237,
              -28.87399842329986
            ],
            [
              -55.37661615093403,
              -28.874507504233954
            ],
            [
              -55.373316284987276,
              -28.87820991102736
            ],
            [
              -55.36891646372494,
              -28.87839503136703
            ],
            [
              -55.36750223546205,
              -28.880014834339146
            ],
            [
              -55.36959738844411,
              -28.88418004198173
            ],
            [
              -55.369283115496806,
              -28.88510564368008
            ],
            [
              -55.37300201203997,
              -28.88718824750137
            ],
            [
              -55.37279249674176,
              -28.888715490303653
            ],
            [
              -55.374416240302864,
              -28.889918772511507
            ],
            [
              -55.37342104263638,
              -28.89491702168261
            ],
            [
              -55.37588284739031,
              -28.900702032297307
            ],
            [
              -55.3757780897412,
              -28.90509864036448
            ],
            [
              -55.37310676968907,
              -28.908801047157883
            ],
            [
              -55.37399720970645,
              -28.91291997471555
            ],
            [
              -55.37300201203997,
              -28.920602468811868
            ],
            [
              -55.371483026127976,
              -28.921898311189562
            ],
            [
              -55.3691783578477,
              -28.921805751019726
            ],
            [
              -55.36540708247998,
              -28.92689656036066
            ],
            [
              -55.36011682120027,
              -28.92921056460654
            ],
            [
              -55.35807404704276,
              -28.931802249361926
            ],
            [
              -55.35550748463973,
              -28.931200608257996
            ],
            [
              -55.34990295041271,
              -28.931617129022253
            ],
            [
              -55.348279206851615,
              -28.932912971399947
            ],
            [
              -55.34759828213244,
              -28.93629141759893
            ],
            [
              -55.34508409855396,
              -28.94031778498676
            ],
            [
              -55.34550312915037,
              -28.94189130787396
            ],
            [
              -55.34230802085273,
              -28.94281690957231
            ],
            [
              -55.338379609011355,
              -28.941289666770032
            ],
            [
              -55.33670348662571,
              -28.94170618753429
            ],
            [
              -55.32931807236393,
              -28.939114502778903
            ],
            [
              -55.32298023459319,
              -28.940595465496266
            ],
            [
              -55.32098983926023,
              -28.941983868043796
            ],
            [
              -55.32098983926023,
              -28.945084633733273
            ],
            [
              -55.319523232172784,
              -28.947907718913246
            ],
            [
              -55.31899944392727,
              -28.951887806216156
            ],
            [
              -55.319523232172784,
              -28.954016690122366
            ],
            [
              -55.32271834047043,
              -28.959014939293468
            ],
            [
              -55.32229930987402,
              -28.960218221501325
            ],
            [
              -55.31847565568175,
              -28.96091242277509
            ],
            [
              -55.31789948861168,
              -28.962902466426545
            ],
            [
              -55.31459962266493,
              -28.96429086897407
            ],
            [
              -55.30988552845528,
              -28.963318987190803
            ],
            [
              -55.30658566250853,
              -28.966003232116023
            ],
            [
              -55.29930500589586,
              -28.96739163466355
            ],
            [
              -55.29752412586111,
              -28.9683172363619
            ],
            [
              -55.29768126233476,
              -28.971279161796627
            ],
            [
              -55.2971050952647,
              -28.97220476349498
            ],
            [
              -55.29422425991436,
              -28.972713844429073
            ],
            [
              -55.293909986967044,
              -28.981321940223744
            ],
            [
              -55.29108153044126,
              -28.984515266083058
            ],
            [
              -55.293019546949665,
              -28.991503558905613
            ],
            [
              -55.293176683423326,
              -28.992382880519045
            ],
            [
              -55.28971968100292,
              -28.993910123321328
            ],
            [
              -55.28558175386334,
              -28.997890210624238
            ],
            [
              -55.28228188791659,
              -29.002009138181904
            ],
            [
              -55.28139144789921,
              -29.00608178565465
            ],
            [
              -55.27961056786446,
              -29.00821066956086
            ],
            [
              -55.27908677961894,
              -29.010200713212317
            ],
            [
              -55.27997721963632,
              -29.01339403907163
            ],
            [
              -55.27908677961894,
              -29.016911325525367
            ],
            [
              -55.281496205548315,
              -29.024177298857428
            ],
            [
              -55.27851061254887,
              -29.03070279083081
            ],
            [
              -55.27049665239248,
              -29.040514168833337
            ],
            [
              -55.26552066406008,
              -29.043522374352982
            ],
            [
              -55.26190652516602,
              -29.048196662929655
            ],
            [
              -55.2499117743437,
              -29.05351887269518
            ],
            [
              -55.24598336250233,
              -29.056110557450562
            ],
            [
              -55.25378780736052,
              -29.054722154903036
            ],
            [
              -55.26017802395582,
              -29.056110557450562
            ],
            [
              -55.26452546639359,
              -29.05370399303485
            ],
            [
              -55.271125198287095,
              -29.055277515922047
            ],
            [
              -55.27290607832185,
              -29.056989879063998
            ],
            [
              -55.27227753242723,
              -29.06731033800062
            ],
            [
              -55.27138709240985,
              -29.070596224029767
            ],
            [
              -55.27421554893564,
              -29.078880359230016
            ],
            [
              -55.27379651833923,
              -29.080777842711637
            ],
            [
              -55.27521074660213,
              -29.084480249505045
            ],
            [
              -55.274006033637434,
              -29.089617338930896
            ],
            [
              -55.280605765530936,
              -29.09919731650884
            ],
            [
              -55.285476996214236,
              -29.104797206783864
            ],
            [
              -55.284586556196864,
              -29.107620291963837
            ],
            [
              -55.28311994910941,
              -29.107712852133673
            ],
            [
              -55.28128669025011,
              -29.109795455954966
            ],
            [
              -55.276205944268604,
              -29.11238714071035
            ],
            [
              -55.2696062123751,
              -29.121504317439115
            ],
            [
              -55.270601410041586,
              -29.125900925506286
            ],
            [
              -55.26861101470862,
              -29.129001691195764
            ],
            [
              -55.268401499410416,
              -29.132009896715406
            ],
            [
              -55.269501454726,
              -29.134879261980295
            ],
            [
              -55.26871577235772,
              -29.137794907330104
            ],
            [
              -55.269082424129586,
              -29.141080793359254
            ],
            [
              -55.268401499410416,
              -29.1425154759917
            ],
            [
              -55.270601410041586,
              -29.144690639982826
            ],
            [
              -55.27191088065537,
              -29.14728232473821
            ],
            [
              -55.274582200707506,
              -29.14941120864442
            ],
            [
              -55.27667735368957,
              -29.153298735777497
            ],
            [
              -55.27641545956681,
              -29.15862094554302
            ],
            [
              -55.27432030658475,
              -29.16070354936431
            ],
            [
              -55.27557739837398,
              -29.161397750638073
            ],
            [
              -55.27557739837398,
              -29.163480354459367
            ],
            [
              -55.27809158195246,
              -29.17051492736684
            ],
            [
              -55.28311994910941,
              -29.17491153543401
            ],
            [
              -55.282177130267485,
              -29.17791974095365
            ],
            [
              -55.27919153726805,
              -29.182084948596234
            ],
            [
              -55.28050100788184,
              -29.18449151301195
            ],
            [
              -55.28490082914417,
              -29.18449151301195
            ],
            [
              -55.286576951529824,
              -29.185694795219806
            ],
            [
              -55.289195892757405,
              -29.190322803711567
            ],
            [
              -55.29050536337119,
              -29.19101700498533
            ],
            [
              -55.29092439396761,
              -29.193007048636787
            ],
            [
              -55.29218148575684,
              -29.193608689740714
            ],
            [
              -55.296109897598214,
              -29.19337728931613
            ],
            [
              -55.297419368212005,
              -29.19448801135415
            ],
            [
              -55.30019544591324,
              -29.19791273763805
            ],
            [
              -55.30087637063241,
              -29.199810221119673
            ],
            [
              -55.300090688264135,
              -29.202494466044893
            ],
            [
              -55.30307628126358,
              -29.203188667318656
            ],
            [
              -55.30742372370136,
              -29.20291098680915
            ],
            [
              -55.30951887668343,
              -29.20388286859242
            ],
            [
              -55.31077596847266,
              -29.20291098680915
            ],
            [
              -55.31260922733197,
              -29.20480847029077
            ],
            [
              -55.30951887668343,
              -29.20767783555566
            ],
            [
              -55.30799989077143,
              -29.207585275385824
            ],
            [
              -55.30721420840315,
              -29.209205078357943
            ],
            [
              -55.304909540122885,
              -29.207400155046155
            ],
            [
              -55.303390554210885,
              -29.21327772583069
            ],
            [
              -55.29951452119407,
              -29.214481008038547
            ],
            [
              -55.29548135170359,
              -29.2146198482933
            ],
            [
              -55.29218148575684,
              -29.21350912625528
            ],
            [
              -55.286315057407066,
              -29.213185165660853
            ],
            [
              -55.282386645565694,
              -29.211611642773654
            ],
            [
              -55.28201999379383,
              -29.20948275886745
            ],
            [
              -55.281024796127355,
              -29.209297638527776
            ],
            [
              -55.278877264320734,
              -29.211010001669727
            ],
            [
              -55.27641545956681,
              -29.20749271521599
            ],
            [
              -55.27248704772544,
              -29.20790923598025
            ],
            [
              -55.267982468814004,
              -29.20578035207404
            ],
            [
              -55.26237793458698,
              -29.208603437254013
            ],
            [
              -55.25792573450009,
              -29.203188667318656
            ],
            [
              -55.25771621920189,
              -29.20018046179901
            ],
            [
              -55.25378780736052,
              -29.197218536364286
            ],
            [
              -55.2483927884317,
              -29.19448801135415
            ],
            [
              -55.24671666604605,
              -29.192405407532856
            ],
            [
              -55.24420248246757,
              -29.192312847363024
            ],
            [
              -55.24278825420468,
              -29.190091403286978
            ],
            [
              -55.23891222118786,
              -29.190322803711567
            ],
            [
              -55.23739323527587,
              -29.188980681248957
            ],
            [
              -55.2351933246447,
              -29.188610440569615
            ],
            [
              -55.23320292931174,
              -29.19471941177874
            ],
            [
              -55.226184166821824,
              -29.192683088042365
            ],
            [
              -55.22628892447092,
              -29.196107814326265
            ],
            [
              -55.22497945385714,
              -29.1969871359397
            ],
            [
              -55.21769879724446,
              -29.192081446938435
            ],
            [
              -55.20978959473717,
              -29.189721162607636
            ],
            [
              -55.205599288773044,
              -29.193284729146292
            ],
            [
              -55.20172325575622,
              -29.195182212627913
            ],
            [
              -55.20177563458078,
              -29.196709455430195
            ],
            [
              -55.203399378141874,
              -29.19749621687379
            ],
            [
              -55.20638497114132,
              -29.1962003744961
            ],
            [
              -55.20858488177248,
              -29.200689542733105
            ],
            [
              -55.20638497114132,
              -29.20578035207404
            ],
            [
              -55.20502312170297,
              -29.205919192328793
            ],
            [
              -55.2008851945634,
              -29.203003546978984
            ],
            [
              -55.19569969093279,
              -29.202679586384562
            ],
            [
              -55.19381405324893,
              -29.206983634281897
            ],
            [
              -55.190985596723145,
              -29.21017696014121
            ],
            [
              -55.187895246074596,
              -29.21059348090547
            ],
            [
              -55.18428110718054,
              -29.209899279631706
            ],
            [
              -55.1814002718302,
              -29.208418316914344
            ],
            [
              -55.18071934711103,
              -29.197820177468216
            ],
            [
              -55.17940987649724,
              -29.195321052882665
            ],
            [
              -55.17548146465587,
              -29.191202125325
            ],
            [
              -55.17061023397257,
              -29.196894575769864
            ],
            [
              -55.16809605039409,
              -29.1969871359397
            ],
            [
              -55.167100852727614,
              -29.195783853731843
            ],
            [
              -55.165791382113824,
              -29.196478055005606
            ],
            [
              -55.166210412710235,
              -29.201800264771126
            ],
            [
              -55.16301530441259,
              -29.204901030460604
            ],
            [
              -55.160710636132315,
              -29.20499359063044
            ],
            [
              -55.15788217960653,
              -29.20369774825275
            ],
            [
              -55.158720240799354,
              -29.20152258426162
            ],
            [
              -55.1554203748526,
              -29.195506173222334
            ],
            [
              -55.15007773474834,
              -29.198792059251485
            ],
            [
              -55.14672548997704,
              -29.19888461942132
            ],
            [
              -55.14452557934587,
              -29.197588777043627
            ],
            [
              -55.14127809222367,
              -29.193978930420055
            ],
            [
              -55.13981148513623,
              -29.193793810080386
            ],
            [
              -55.13818774157512,
              -29.1969871359397
            ],
            [
              -55.13342126854093,
              -29.198792059251485
            ],
            [
              -55.13242607087445,
              -29.198421818572143
            ],
            [
              -55.127083430770185,
              -29.20059698256327
            ],
            [
              -55.123783564823434,
              -29.199810221119673
            ],
            [
              -55.12247409420964,
              -29.201106063497363
            ],
            [
              -55.12027418357848,
              -29.199393700355415
            ],
            [
              -55.1193837435611,
              -29.200319302053764
            ],
            [
              -55.11728859057904,
              -29.20008790162918
            ],
            [
              -55.114879164649665,
              -29.204715910120935
            ],
            [
              -55.114198239930495,
              -29.21401820718937
            ],
            [
              -55.10990317631726,
              -29.211981883452996
            ],
            [
              -55.10770326568609,
              -29.209390198697612
            ],
            [
              -55.10461291503755,
              -29.21438844786871
            ],
            [
              -55.10262251970459,
              -29.214110767359205
            ],
            [
              -55.09638943958295,
              -29.216378491520167
            ],
            [
              -55.094084771302676,
              -29.21480496863297
            ],
            [
              -55.08999922298765,
              -29.21360168642511
            ],
            [
              -55.08549464407621,
              -29.209112518188107
            ],
            [
              -55.08140909576119,
              -29.209205078357943
            ],
            [
              -55.07957583690188,
              -29.20999183980154
            ],
            [
              -55.07821398746354,
              -29.21212072370775
            ],
            [
              -55.07528077328865,
              -29.21438844786871
            ],
            [
              -55.07501887916589,
              -29.217998294492283
            ],
            [
              -55.07182377086824,
              -29.223505624597475
            ],
            [
              -55.06988575435983,
              -29.22290398349355
            ],
            [
              -55.05752435176566,
              -29.225403108079096
            ],
            [
              -55.04987704338112,
              -29.224292386041075
            ],
            [
              -55.04731048097809,
              -29.22688407079646
            ],
            [
              -55.04369634208403,
              -29.227902232664647
            ],
            [
              -55.04259638676845,
              -29.232021160222313
            ],
            [
              -55.04767713274995,
              -29.238315251771105
            ],
            [
              -55.04731048097809,
              -29.240397855592395
            ],
            [
              -55.04291065971576,
              -29.24451678315006
            ],
            [
              -55.038510838453426,
              -29.24437794289531
            ],
            [
              -55.033901501892885,
              -29.238500372110774
            ],
            [
              -55.032801546577296,
              -29.23762105049734
            ],
            [
              -55.030601635946134,
              -29.237482210242586
            ],
            [
              -55.02897789238503,
              -29.238916892875032
            ],
            [
              -55.028192210016755,
              -29.24437794289531
            ],
            [
              -55.02939692298145,
              -29.245396104763493
            ],
            [
              -55.032382515980885,
              -29.246691947141187
            ],
            [
              -55.033011061875506,
              -29.248496870452975
            ],
            [
              -55.0311778030162,
              -29.249005951387065
            ],
            [
              -55.02787793706945,
              -29.24840431028314
            ],
            [
              -55.02368763110532,
              -29.245396104763493
            ],
            [
              -55.0212258263514,
              -29.243313500942204
            ],
            [
              -55.01918305219388,
              -29.24391514204613
            ],
            [
              -55.01881640042202,
              -29.24548866493333
            ],
            [
              -55.021487720474155,
              -29.25030179376476
            ],
            [
              -55.02049252280767,
              -29.256086804379457
            ],
            [
              -55.01960208279029,
              -29.256919845907973
            ],
            [
              -55.013997548563275,
              -29.256086804379457
            ],
            [
              -55.00729305902067,
              -29.256503325143715
            ],
            [
              -55.00577407310867,
              -29.257197526417478
            ],
            [
              -55.004988390740394,
              -29.258493368795172
            ],
            [
              -55.00451698131943,
              -29.2648800205138
            ],
            [
              -55.00331226835475,
              -29.267703105693773
            ],
            [
              -54.99969812946068,
              -29.26848986713737
            ],
            [
              -54.99760297647862,
              -29.267888226033442
            ],
            [
              -54.99487927760194,
              -29.269184068411136
            ],
            [
              -54.992312715198906,
              -29.272099713760944
            ],
            [
              -54.98812240923478,
              -29.274321157836987
            ],
            [
              -54.98487492211258,
              -29.27769960403597
            ],
            [
              -54.97780378079811,
              -29.277607043866134
            ],
            [
              -54.975289597219636,
              -29.278717765904158
            ],
            [
              -54.973299201886675,
              -29.280892929895284
            ],
            [
              -54.97120404890461,
              -29.284178815924435
            ],
            [
              -54.97010409358903,
              -29.288205183312265
            ],
            [
              -54.96837559237883,
              -29.290195226963718
            ],
            [
              -54.96832321355427,
              -29.292000150275506
            ],
            [
              -54.97010409358903,
              -29.294314154521384
            ],
            [
              -54.96769466765966,
              -29.29477695537056
            ],
            [
              -54.96408052876559,
              -29.300099165136082
            ],
            [
              -54.96161872401167,
              -29.301718968108197
            ],
            [
              -54.96161872401167,
              -29.303107370655727
            ],
            [
              -54.96371387699373,
              -29.306023016005533
            ],
            [
              -54.96261392167815,
              -29.312779908403503
            ],
            [
              -54.959575949854155,
              -29.31430715120578
            ],
            [
              -54.94779071433005,
              -29.314584831715287
            ],
            [
              -54.940300542419166,
              -29.325599491925672
            ],
            [
              -54.937000676472415,
              -29.322082205471936
            ],
            [
              -54.934119841122076,
              -29.32087892326408
            ],
            [
              -54.93228658226277,
              -29.32101776351883
            ],
            [
              -54.92888195866691,
              -29.32638625336927
            ],
            [
              -54.92767724570223,
              -29.326987894473202
            ],
            [
              -54.9250059256501,
              -29.328422577105645
            ],
            [
              -54.92249174207162,
              -29.332078703814133
            ],
            [
              -54.91322069012599,
              -29.34059423943897
            ],
            [
              -54.90730188295166,
              -29.33971491782554
            ],
            [
              -54.90101642400546,
              -29.34239916275076
            ],
            [
              -54.90038787811084,
              -29.343880125468118
            ],
            [
              -54.90148783342643,
              -29.345685048779906
            ],
            [
              -54.90112118165457,
              -29.348184173365457
            ],
            [
              -54.89970695339167,
              -29.34832301362021
            ],
            [
              -54.89860699807609,
              -29.347212291582185
            ],
            [
              -54.89572616272575,
              -29.349294895403478
            ],
            [
              -54.89478334388382,
              -29.353598943300813
            ],
            [
              -54.89672136039223,
              -29.356422028480786
            ],
            [
              -54.895883299199404,
              -29.359198833575842
            ],
            [
              -54.893683388568235,
              -29.359707914509933
            ],
            [
              -54.893211979147274,
              -29.362207039095484
            ],
            [
              -54.89420717681375,
              -29.364289642916777
            ],
            [
              -54.891692993235274,
              -29.365492925124634
            ],
            [
              -54.890278764972386,
              -29.367992049710182
            ],
            [
              -54.888288369639426,
              -29.368084609880018
            ],
            [
              -54.88807885434122,
              -29.370213493786228
            ],
            [
              -54.88488374604357,
              -29.371787016673423
            ],
            [
              -54.88399330602619,
              -29.37377706032488
            ],
            [
              -54.884098063675296,
              -29.378219948476968
            ],
            [
              -54.88132198597406,
              -29.379700911194334
            ],
            [
              -54.875507936448834,
              -29.383310757817902
            ],
            [
              -54.87320326816856,
              -29.385809882403453
            ],
            [
              -54.87341278346677,
              -29.387383405290652
            ],
            [
              -54.875979345869794,
              -29.38821644681917
            ],
            [
              -54.87100335753739,
              -29.390021370130953
            ],
            [
              -54.87231282815118,
              -29.394603098537797
            ],
            [
              -54.87142238813381,
              -29.395389859981393
            ],
            [
              -54.86759873394154,
              -29.395713820575818
            ],
            [
              -54.86571309625768,
              -29.397703864227275
            ],
            [
              -54.86702256687147,
              -29.400712069746916
            ],
            [
              -54.86990340222181,
              -29.402285592634115
            ],
            [
              -54.86539882331037,
              -29.40390539560623
            ],
            [
              -54.86539882331037,
              -29.405293798153757
            ],
            [
              -54.86990340222181,
              -29.41218953080648
            ],
            [
              -54.86770349159064,
              -29.41519773632612
            ],
            [
              -54.868174901011606,
              -29.41788198125134
            ],
            [
              -54.86770349159064,
              -29.420288545667056
            ],
            [
              -54.8647178985912,
              -29.422186029148676
            ],
            [
              -54.863617943275614,
              -29.426304956706343
            ],
            [
              -54.85948001613604,
              -29.433385809698734
            ],
            [
              -54.85948001613604,
              -29.437412177086564
            ],
            [
              -54.85387548190902,
              -29.440512942776042
            ],
            [
              -54.851204161856884,
              -29.443197187701262
            ],
            [
              -54.851623192453296,
              -29.445696312286813
            ],
            [
              -54.85308979954075,
              -29.446807034324834
            ],
            [
              -54.853404072488054,
              -29.45087968179758
            ],
            [
              -54.85178032892696,
              -29.451620163156264
            ],
            [
              -54.85261839011978,
              -29.45490604918541
            ],
            [
              -54.85068037361137,
              -29.456294451732937
            ],
            [
              -54.84900425122572,
              -29.45948777759225
            ],
            [
              -54.851623192453296,
              -29.459117536912913
            ],
            [
              -54.85350883013716,
              -29.46069105980011
            ],
            [
              -54.85508019487371,
              -29.46531906829187
            ],
            [
              -54.85361358778626,
              -29.464393466593517
            ],
            [
              -54.851623192453296,
              -29.464393466593517
            ],
            [
              -54.84942328182213,
              -29.462912503876154
            ],
            [
              -54.84539011233166,
              -29.466614910669563
            ],
            [
              -54.84811381120834,
              -29.467077711518737
            ],
            [
              -54.85057561596227,
              -29.469808236528873
            ],
            [
              -54.85099464655868,
              -29.47161315984066
            ],
            [
              -54.8499994488922,
              -29.477120489945854
            ],
            [
              -54.8435044746478,
              -29.48309062090022
            ],
            [
              -54.84261403463042,
              -29.486283946759535
            ],
            [
              -54.84062363929746,
              -29.486607907353957
            ],
            [
              -54.8417759734376,
              -29.488412830665744
            ],
            [
              -54.838999895736364,
              -29.489199592109344
            ],
            [
              -54.833290603860235,
              -29.48790374973165
            ],
            [
              -54.831876375597346,
              -29.48892191159984
            ],
            [
              -54.832609679141065,
              -29.4911896357608
            ],
            [
              -54.831981133246444,
              -29.493920160770937
            ],
            [
              -54.83638095450878,
              -29.498177928583356
            ],
            [
              -54.836119060386025,
              -29.499890291725308
            ],
            [
              -54.83402390740396,
              -29.501186134102998
            ],
            [
              -54.837219015701606,
              -29.502620816735444
            ],
            [
              -54.83449531682493,
              -29.505490182000333
            ],
            [
              -54.83470483212313,
              -29.508220707010473
            ],
            [
              -54.83842372866629,
              -29.508683507859647
            ],
            [
              -54.83601430273692,
              -29.50979422989767
            ],
            [
              -54.83648571215789,
              -29.511691713379292
            ],
            [
              -54.83470483212313,
              -29.51210823414355
            ],
            [
              -54.83370963445665,
              -29.513311516351408
            ],
            [
              -54.834600074474025,
              -29.514699918898934
            ],
            [
              -54.83439055917582,
              -29.515810640936955
            ],
            [
              -54.83601430273692,
              -29.516597402380555
            ],
            [
              -54.8369047427543,
              -29.51479247906877
            ],
            [
              -54.83868562278905,
              -29.514098277795004
            ],
            [
              -54.840099851051946,
              -29.515486680342534
            ],
            [
              -54.8419854887358,
              -29.519605607900196
            ],
            [
              -54.84638530999814,
              -29.5198832884097
            ],
            [
              -54.847013855892754,
              -29.522891493929347
            ],
            [
              -54.8485852206293,
              -29.523493135033277
            ],
            [
              -54.84811381120834,
              -29.526408780383083
            ],
            [
              -54.849789933593996,
              -29.52608481978866
            ],
            [
              -54.852723147768884,
              -29.528121143525034
            ],
            [
              -54.85900860671507,
              -29.528306263864703
            ],
            [
              -54.85911336436418,
              -29.529879786751902
            ],
            [
              -54.86110375969714,
              -29.53131446938435
            ],
            [
              -54.859584773785144,
              -29.532702871931875
            ],
            [
              -54.86167992676721,
              -29.532887992271547
            ],
            [
              -54.86120851734624,
              -29.53622015838561
            ],
            [
              -54.86047521380252,
              -29.537516000763304
            ],
            [
              -54.86047521380252,
              -29.539182083820336
            ],
            [
              -54.86251798796003,
              -29.542282849509817
            ],
            [
              -54.862203715012726,
              -29.544920814350117
            ],
            [
              -54.86057997145162,
              -29.545522455454048
            ],
            [
              -54.85968953143425,
              -29.547697619445174
            ],
            [
              -54.855813498417426,
              -29.549409982587125
            ],
            [
              -54.8515184348042,
              -29.547605059275337
            ],
            [
              -54.84879473592751,
              -29.549780223266463
            ],
            [
              -54.84287592875318,
              -29.550381864370394
            ],
            [
              -54.84329495934959,
              -29.551909107172673
            ],
            [
              -54.841409321665736,
              -29.555704074135917
            ],
            [
              -54.83920941103457,
              -29.55690735634377
            ],
            [
              -54.83858086513995,
              -29.558804839825395
            ],
            [
              -54.836799985105195,
              -29.559406480929322
            ],
            [
              -54.840309366350155,
              -29.565515452138445
            ],
            [
              -54.836119060386025,
              -29.56981950003578
            ],
            [
              -54.83512386271954,
              -29.57292026572526
            ],
            [
              -54.832819194439274,
              -29.57458634878229
            ],
            [
              -54.82522426487929,
              -29.573892147508527
            ],
            [
              -54.82140061068702,
              -29.5717169835174
            ],
            [
              -54.8222910507044,
              -29.570097180545286
            ],
            [
              -54.82161012598523,
              -29.569402979271523
            ],
            [
              -54.818415017687585,
              -29.571994664026906
            ],
            [
              -54.81789122944207,
              -29.574216108102952
            ],
            [
              -54.81411995407435,
              -29.57560451065048
            ],
            [
              -54.81108198225036,
              -29.574308668272785
            ],
            [
              -54.8090915869174,
              -29.575882191159984
            ],
            [
              -54.80741546453174,
              -29.575697070820315
            ],
            [
              -54.80621075156706,
              -29.57481774920688
            ],
            [
              -54.805110796251476,
              -29.570698821649213
            ],
            [
              -54.80217758207658,
              -29.572411184791164
            ],
            [
              -54.797411109042386,
              -29.56810713689383
            ],
            [
              -54.79259225718364,
              -29.56898645850726
            ],
            [
              -54.791387544218956,
              -29.573105386064928
            ],
            [
              -54.79589212313039,
              -29.574493788612457
            ],
            [
              -54.796992078445975,
              -29.5775019941321
            ],
            [
              -54.79510644076212,
              -29.581204400925508
            ],
            [
              -54.79531595606032,
              -29.583888645850728
            ],
            [
              -54.79149230186806,
              -29.590414137824105
            ],
            [
              -54.793011287780054,
              -29.59319094291916
            ],
            [
              -54.79128278656985,
              -29.594486785296855
            ],
            [
              -54.78782578414945,
              -29.594810745891277
            ],
            [
              -54.78709248060572,
              -29.596800789542733
            ],
            [
              -54.78468305467635,
              -29.59740243064666
            ],
            [
              -54.78379261465897,
              -29.598513152684685
            ],
            [
              -54.78552111586917,
              -29.601891598883668
            ],
            [
              -54.78332120523801,
              -29.604020482789878
            ],
            [
              -54.7845259182027,
              -29.604992364573146
            ],
            [
              -54.785206842921866,
              -29.607306368819025
            ],
            [
              -54.790078073605166,
              -29.611795537056032
            ],
            [
              -54.78992093713151,
              -29.615821904443862
            ],
            [
              -54.79259225718364,
              -29.618413589199246
            ],
            [
              -54.796992078445975,
              -29.617904508265152
            ],
            [
              -54.797620624340595,
              -29.619292910812682
            ],
            [
              -54.80008242909452,
              -29.619987112086445
            ],
            [
              -54.80060621734004,
              -29.621190394294302
            ],
            [
              -54.79997767144542,
              -29.622810197266418
            ],
            [
              -54.80191568795383,
              -29.625309321851965
            ],
            [
              -54.80437749270775,
              -29.626882844739164
            ],
            [
              -54.80490128095327,
              -29.627808446437516
            ],
            [
              -54.80542506919878,
              -29.63081665195716
            ],
            [
              -54.80652502451437,
              -29.63211249433485
            ],
            [
              -54.80972013281202,
              -29.633408336712545
            ],
            [
              -54.8108200881276,
              -29.634287658325977
            ],
            [
              -54.81249621051325,
              -29.637295863845623
            ],
            [
              -54.81459136349532,
              -29.638915666817738
            ],
            [
              -54.81647700117917,
              -29.638221465543975
            ],
            [
              -54.81930545770496,
              -29.63521326002433
            ],
            [
              -54.821505368336126,
              -29.635398380364002
            ],
            [
              -54.82470047663377,
              -29.637619824440044
            ],
            [
              -54.826376599019426,
              -29.639980108770843
            ],
            [
              -54.827319417861354,
              -29.644006476158673
            ],
            [
              -54.826586114317635,
              -29.650115447367792
            ],
            [
              -54.825119507230184,
              -29.65478973594447
            ],
            [
              -54.82538140135294,
              -29.65691861985068
            ],
            [
              -54.82721466021225,
              -29.659787985115567
            ],
            [
              -54.83208589089555,
              -29.66571183598502
            ],
            [
              -54.83370963445665,
              -29.666406037258785
            ],
            [
              -54.837899940420776,
              -29.665480435560433
            ],
            [
              -54.841409321665736,
              -29.663582952078812
            ],
            [
              -54.84539011233166,
              -29.66210198936145
            ],
            [
              -54.84910900887482,
              -29.661407788087686
            ],
            [
              -54.85031372183951,
              -29.660482186389334
            ],
            [
              -54.85198984422516,
              -29.657797941464114
            ],
            [
              -54.85398023955812,
              -29.656594659256257
            ],
            [
              -54.85528971017191,
              -29.657011180020515
            ],
            [
              -54.85481830075095,
              -29.658677263077546
            ],
            [
              -54.855394467821014,
              -29.66298131097488
            ],
            [
              -54.858013409048596,
              -29.665619275815185
            ],
            [
              -54.858903849065975,
              -29.668303520740405
            ],
            [
              -54.85979428908335,
              -29.6695993631181
            ],
            [
              -54.86262274560914,
              -29.67047868473153
            ],
            [
              -54.86738921864333,
              -29.67071008515612
            ],
            [
              -54.870479569291874,
              -29.67010844405219
            ],
            [
              -54.87377943523863,
              -29.66821096057057
            ],
            [
              -54.87697454353628,
              -29.665804396154854
            ],
            [
              -54.87901731769379,
              -29.664693674116833
            ],
            [
              -54.88320762365792,
              -29.663490391908976
            ],
            [
              -54.88540753428909,
              -29.663305271569307
            ],
            [
              -54.88870740023584,
              -29.6638143525034
            ],
            [
              -54.89410241916465,
              -29.6638143525034
            ],
            [
              -54.90112118165457,
              -29.665804396154854
            ],
            [
              -54.90368774405759,
              -29.666220916919112
            ],
            [
              -54.90578289703966,
              -29.667701879636475
            ],
            [
              -54.90808756531993,
              -29.667886999976147
            ],
            [
              -54.910025581828336,
              -29.666915118192875
            ],
            [
              -54.91521108545895,
              -29.66321271139947
            ],
            [
              -54.918406193756596,
              -29.662518510125707
            ],
            [
              -54.92249174207162,
              -29.66261107029554
            ],
            [
              -54.9250059256501,
              -29.663490391908976
            ],
            [
              -54.92579160801837,
              -29.664415993607328
            ],
            [
              -54.927520109228574,
              -29.66858120124991
            ],
            [
              -54.92888195866691,
              -29.67010844405219
            ],
            [
              -54.9316056575436,
              -29.672098487703646
            ],
            [
              -54.93228658226277,
              -29.673301769911504
            ],
            [
              -54.933019885806495,
              -29.676217415261313
            ],
            [
              -54.93328177992925,
              -29.680382622903895
            ],
            [
              -54.93469600819214,
              -29.68089170383799
            ],
            [
              -54.93621499410414,
              -29.679780981799965
            ],
            [
              -54.93841490473531,
              -29.677096736874745
            ],
            [
              -54.941190982436545,
              -29.676217415261313
            ],
            [
              -54.94401943896233,
              -29.676587655940654
            ],
            [
              -54.94580031899709,
              -29.678485139422275
            ],
            [
              -54.94857639669832,
              -29.68311314791403
            ],
            [
              -54.95040965555763,
              -29.68681555470744
            ],
            [
              -54.95260956618879,
              -29.68889815852873
            ],
            [
              -54.958475994538574,
              -29.69241544498247
            ],
            [
              -54.96229964873084,
              -29.695701331011616
            ],
            [
              -54.964499559362004,
              -29.696719492879804
            ],
            [
              -54.96832321355427,
              -29.69658065262505
            ],
            [
              -54.97382299013219,
              -29.695516210671947
            ],
            [
              -54.97921800906101,
              -29.69199892421821
            ],
            [
              -54.98042272202569,
              -29.69218404455788
            ],
            [
              -54.98089413144666,
              -29.693387326765738
            ],
            [
              -54.98000369142928,
              -29.696719492879804
            ],
            [
              -54.97790853844722,
              -29.698385575936836
            ],
            [
              -54.977279992552596,
              -29.699496297974857
            ],
            [
              -54.977699023149015,
              -29.700884700522387
            ],
            [
              -54.9789037361137,
              -29.701995422560408
            ],
            [
              -54.98131316204307,
              -29.702597063664335
            ],
            [
              -54.98262263265686,
              -29.702411943324666
            ],
            [
              -54.9855034680072,
              -29.70060702001288
            ],
            [
              -54.98780813628747,
              -29.69968141831453
            ],
            [
              -54.989903289269535,
              -29.70042189967321
            ],
            [
              -54.99068897163781,
              -29.70268962383417
            ],
            [
              -54.9919984422516,
              -29.704911067910217
            ],
            [
              -54.99461738347918,
              -29.70657715096725
            ],
            [
              -55.000274296530755,
              -29.708798595043294
            ],
            [
              -55.00708354372246,
              -29.710696078524915
            ],
            [
              -55.01038340966921,
              -29.71060351835508
            ],
            [
              -55.01420706386148,
              -29.70810439376953
            ],
            [
              -55.01719265686092,
              -29.706901111561674
            ],
            [
              -55.02070203810588,
              -29.70620691028791
            ],
            [
              -55.0245780711227,
              -29.706808551391838
            ],
            [
              -55.031020666542545,
              -29.70542014884431
            ],
            [
              -55.03662520076956,
              -29.70639203062758
            ],
            [
              -55.0392965208217,
              -29.706114350118074
            ],
            [
              -55.04511057034693,
              -29.703013584428597
            ],
            [
              -55.04987704338112,
              -29.69792277508766
            ],
            [
              -55.04982466455657,
              -29.69509968990769
            ],
            [
              -55.05312453050332,
              -29.692508005152302
            ],
            [
              -55.055586335257246,
              -29.691906364048375
            ],
            [
              -55.05721007881834,
              -29.692322884812633
            ],
            [
              -55.059776641221376,
              -29.693988967869664
            ],
            [
              -55.06129562713337,
              -29.694405488633926
            ],
            [
              -55.06281461304537,
              -29.69389640769983
            ],
            [
              -55.06349553776454,
              -29.690795642010354
            ],
            [
              -55.06160990008068,
              -29.688620478019224
            ],
            [
              -55.06098135418606,
              -29.686491594113015
            ],
            [
              -55.06150514243158,
              -29.684779230971067
            ],
            [
              -55.06302412834357,
              -29.68278918731961
            ],
            [
              -55.06522403897474,
              -29.68200242587601
            ],
            [
              -55.070200027307145,
              -29.68121566443241
            ],
            [
              -55.072085664991,
              -29.68029006273406
            ],
            [
              -55.07250469558741,
              -29.678809100016696
            ],
            [
              -55.0718761496928,
              -29.67529181356296
            ],
            [
              -55.07297610500838,
              -29.674412491949525
            ],
            [
              -55.07622359213058,
              -29.673301769911504
            ],
            [
              -55.077009274498856,
              -29.67228360804332
            ],
            [
              -55.07711403214795,
              -29.6695993631181
            ],
            [
              -55.074390333271275,
              -29.659787985115567
            ],
            [
              -55.07491412151679,
              -29.6588161033323
            ],
            [
              -55.07732354744616,
              -29.65728886053002
            ],
            [
              -55.0802043827965,
              -29.654419495265127
            ],
            [
              -55.08250905107677,
              -29.651503849915322
            ],
            [
              -55.08549464407621,
              -29.648588204565513
            ],
            [
              -55.0882183429529,
              -29.64710724184815
            ],
            [
              -55.09198961832061,
              -29.64729236218782
            ],
            [
              -55.09450380189909,
              -29.64900472532977
            ],
            [
              -55.094975211320055,
              -29.650393127877297
            ],
            [
              -55.0948180748464,
              -29.652198051189085
            ],
            [
              -55.0932990889344,
              -29.65858470290771
            ],
            [
              -55.093875256004466,
              -29.660621026644087
            ],
            [
              -55.09649419723205,
              -29.66071358681392
            ],
            [
              -55.098903623161426,
              -29.65941774443623
            ],
            [
              -55.10262251970459,
              -29.65839958256804
            ],
            [
              -55.10838419040526,
              -29.65761282112444
            ],
            [
              -55.11367445168498,
              -29.657196300360184
            ],
            [
              -55.11870281884193,
              -29.657381420699856
            ],
            [
              -55.12137413889406,
              -29.65858470290771
            ],
            [
              -55.12409783777075,
              -29.66029706604966
            ],
            [
              -55.12488352013902,
              -29.66150034825752
            ],
            [
              -55.124202595419845,
              -29.664693674116833
            ],
            [
              -55.123102640104264,
              -29.665989516494527
            ],
            [
              -55.1210074871222,
              -29.667100238532548
            ],
            [
              -55.12027418357848,
              -29.669090282184005
            ],
            [
              -55.12231695773599,
              -29.67010844405219
            ],
            [
              -55.12357404952523,
              -29.6695993631181
            ],
            [
              -55.12498827778812,
              -29.67010844405219
            ],
            [
              -55.12561682368274,
              -29.671311726260047
            ],
            [
              -55.12540730838454,
              -29.673301769911504
            ],
            [
              -55.1258787178055,
              -29.674597612289197
            ],
            [
              -55.127502461366596,
              -29.675199253393124
            ],
            [
              -55.13048805436604,
              -29.673486890251176
            ],
            [
              -55.13232131322535,
              -29.67371829067576
            ],
            [
              -55.133997435611,
              -29.67630997543115
            ],
            [
              -55.13352602619003,
              -29.67871653984686
            ],
            [
              -55.131692767330726,
              -29.67931818095079
            ],
            [
              -55.12881193198039,
              -29.679595861460296
            ],
            [
              -55.12671677899833,
              -29.681493344941916
            ],
            [
              -55.126402506051015,
              -29.6830205877442
            ],
            [
              -55.12781673431391,
              -29.68468667080123
            ],
            [
              -55.131902282628936,
              -29.68491807122582
            ],
            [
              -55.133997435611,
              -29.685982513178924
            ],
            [
              -55.1342069509092,
              -29.68838907759464
            ],
            [
              -55.132792722646315,
              -29.690517961500845
            ],
            [
              -55.131483252032524,
              -29.69121216277461
            ],
            [
              -55.13132611555886,
              -29.693803847529995
            ],
            [
              -55.13342126854093,
              -29.69509968990769
            ],
            [
              -55.13467836033017,
              -29.694914569568017
            ],
            [
              -55.13640686154037,
              -29.693803847529995
            ],
            [
              -55.138082983926026,
              -29.693387326765738
            ],
            [
              -55.14148760752188,
              -29.693618727190326
            ],
            [
              -55.144106548749455,
              -29.69509968990769
            ],
            [
              -55.142116153416495,
              -29.695886451351285
            ],
            [
              -55.13698302861044,
              -29.696719492879804
            ],
            [
              -55.13158800968162,
              -29.695701331011616
            ],
            [
              -55.12891668962949,
              -29.696302972115546
            ],
            [
              -55.12619299075281,
              -29.697691374663073
            ],
            [
              -55.12477876248992,
              -29.700283059418457
            ],
            [
              -55.124202595419845,
              -29.70352266536269
            ],
            [
              -55.12477876248992,
              -29.707780433175106
            ],
            [
              -55.1258787178055,
              -29.71060351835508
            ],
            [
              -55.127502461366596,
              -29.713195203110466
            ],
            [
              -55.12849765903308,
              -29.71611084846027
            ],
            [
              -55.129073826103145,
              -29.71958185482909
            ],
            [
              -55.12828814373487,
              -29.72420986332085
            ],
            [
              -55.12687391547198,
              -29.730411394699807
            ],
            [
              -55.1273977037175,
              -29.732401438351264
            ],
            [
              -55.127292946068394,
              -29.738186448965962
            ],
            [
              -55.12629774840191,
              -29.74318469813706
            ],
            [
              -55.12608823310371,
              -29.745822662977364
            ],
            [
              -55.126402506051015,
              -29.749201109176347
            ],
            [
              -55.127711976664806,
              -29.7517002337619
            ],
            [
              -55.13101184261156,
              -29.75410679817761
            ],
            [
              -55.133892677961896,
              -29.755587760894976
            ],
            [
              -55.13541166387389,
              -29.757115003697255
            ],
            [
              -55.13598783094396,
              -29.759197607518544
            ],
            [
              -55.135883073294856,
              -29.761280211339837
            ],
            [
              -55.13488787562837,
              -29.763085134651625
            ],
            [
              -55.13158800968162,
              -29.76521401855783
            ],
            [
              -55.127921491963015,
              -29.76641730076569
            ],
            [
              -55.12477876248992,
              -29.766880101614866
            ],
            [
              -55.12168841184137,
              -29.76701894186962
            ],
            [
              -55.12147889654317,
              -29.76891642535124
            ],
            [
              -55.11980277415751,
              -29.769194105860745
            ],
            [
              -55.12011704710482,
              -29.770721348663024
            ],
            [
              -55.12137413889406,
              -29.77099902917253
            ],
            [
              -55.12331215540247,
              -29.770304827898766
            ],
            [
              -55.123783564823434,
              -29.768407344417145
            ],
            [
              -55.12467400484081,
              -29.768407344417145
            ],
            [
              -55.12561682368274,
              -29.770119707559097
            ],
            [
              -55.125302550735434,
              -29.77141554993679
            ],
            [
              -55.12357404952523,
              -29.77271139231448
            ],
            [
              -55.125093035437224,
              -29.774007234692174
            ],
            [
              -55.125093035437224,
              -29.775488197409537
            ],
            [
              -55.12210744243778,
              -29.775904718173795
            ],
            [
              -55.11969801650841,
              -29.777617081315746
            ],
            [
              -55.11859806119283,
              -29.777802201655415
            ],
            [
              -55.116921938807174,
              -29.776922880041983
            ],
            [
              -55.11550771054428,
              -29.77770964148558
            ],
            [
              -55.11587436231614,
              -29.77997736564654
            ],
            [
              -55.115298195246076,
              -29.781504608448824
            ],
            [
              -55.11681718115807,
              -29.7853921355819
            ],
            [
              -55.11582198349159,
              -29.788678021611048
            ],
            [
              -55.11252211754484,
              -29.792796949168714
            ],
            [
              -55.113779209334076,
              -29.794277911886077
            ],
            [
              -55.114198239930495,
              -29.795805154688356
            ],
            [
              -55.11561246819338,
              -29.798304279273907
            ],
            [
              -55.11367445168498,
              -29.799322441142095
            ],
            [
              -55.11231260224663,
              -29.79918360088734
            ],
            [
              -55.11189357165022,
              -29.800201762755528
            ],
            [
              -55.114198239930495,
              -29.80131248479355
            ],
            [
              -55.11582198349159,
              -29.804320690313194
            ],
            [
              -55.11739334822814,
              -29.805014891586957
            ],
            [
              -55.11990753180662,
              -29.807190055578083
            ],
            [
              -55.11980277415751,
              -29.809318939484292
            ],
            [
              -55.120797971824,
              -29.81029082126756
            ],
            [
              -55.12069321417489,
              -29.812512265343607
            ],
            [
              -55.12132176006951,
              -29.814178348400638
            ],
            [
              -55.12331215540247,
              -29.81570559120292
            ],
            [
              -55.12540730838454,
              -29.81612211196718
            ],
            [
              -55.12540730838454,
              -29.81778819502421
            ],
            [
              -55.12629774840191,
              -29.820009639100256
            ],
            [
              -55.127292946068394,
              -29.821120361138277
            ],
            [
              -55.129283341401354,
              -29.821722002242204
            ],
            [
              -55.13111660026066,
              -29.82149060181762
            ],
            [
              -55.133211753242726,
              -29.820611280204183
            ],
            [
              -55.13577831564575,
              -29.820981520883524
            ],
            [
              -55.13918293924161,
              -29.822184803091382
            ],
            [
              -55.14148760752188,
              -29.821398041647782
            ],
            [
              -55.14457795817042,
              -29.823110404789734
            ],
            [
              -55.14819209706448,
              -29.825702089545118
            ],
            [
              -55.15102055359027,
              -29.828386334470338
            ],
            [
              -55.148977779432755,
              -29.831301979820147
            ],
            [
              -55.14751117234531,
              -29.83181106075424
            ],
            [
              -55.147406414696206,
              -29.834217625169956
            ],
            [
              -55.148925400608206,
              -29.835883708226987
            ],
            [
              -55.147196899398004,
              -29.836901870095176
            ],
            [
              -55.147196899398004,
              -29.83889191374663
            ],
            [
              -55.146515974678834,
              -29.84102079765284
            ],
            [
              -55.144316064047665,
              -29.841900119266274
            ],
            [
              -55.14201139576739,
              -29.841483598502016
            ],
            [
              -55.1405971675045,
              -29.843612482408226
            ],
            [
              -55.13981148513623,
              -29.84389016291773
            ],
            [
              -55.140125758083535,
              -29.84699092860721
            ],
            [
              -55.139497212188914,
              -29.848194210815066
            ],
            [
              -55.14038765220629,
              -29.849906573957018
            ],
            [
              -55.14028289455719,
              -29.851109856164875
            ],
            [
              -55.14159236517098,
              -29.852081737948144
            ],
            [
              -55.14457795817042,
              -29.852081737948144
            ],
            [
              -55.146096944082416,
              -29.85309989981633
            ],
            [
              -55.151125311239376,
              -29.85370154092026
            ],
            [
              -55.153115706572336,
              -29.85559902440188
            ],
            [
              -55.15269667597592,
              -29.85981051212938
            ],
            [
              -55.15091579594117,
              -29.86101379433724
            ],
            [
              -55.150496765344755,
              -29.862402196884766
            ],
            [
              -55.151596720660336,
              -29.86499388164015
            ],
            [
              -55.148977779432755,
              -29.868511168093885
            ],
            [
              -55.1486111276609,
              -29.869992130811248
            ],
            [
              -55.14939681002917,
              -29.87188961429287
            ],
            [
              -55.150287250046546,
              -29.872121014717457
            ],
            [
              -55.15259191832682,
              -29.875221780406935
            ],
            [
              -55.15589178427357,
              -29.875406900746608
            ],
            [
              -55.160920151430524,
              -29.87531434057677
            ],
            [
              -55.16322481971079,
              -29.874296178708583
            ],
            [
              -55.16437715385093,
              -29.87438873887842
            ],
            [
              -55.16589613976293,
              -29.876702743124298
            ],
            [
              -55.167100852727614,
              -29.877720904992486
            ],
            [
              -55.16961503630609,
              -29.87860022660592
            ],
            [
              -55.171710189288156,
              -29.880220029578037
            ],
            [
              -55.173700584621116,
              -29.883089394842926
            ],
            [
              -55.173281554024705,
              -29.885079438494383
            ],
            [
              -55.174381509340286,
              -29.88739344274026
            ],
            [
              -55.17427675169118,
              -29.889013245712377
            ],
            [
              -55.1749052975858,
              -29.891003289363834
            ],
            [
              -55.17611001055049,
              -29.892021451232022
            ],
            [
              -55.17611001055049,
              -29.89317845335496
            ],
            [
              -55.17689569291876,
              -29.895214777091333
            ],
            [
              -55.179724149444546,
              -29.899611385158504
            ],
            [
              -55.18160978712841,
              -29.899981625837846
            ],
            [
              -55.18380969775957,
              -29.903684032631254
            ],
            [
              -55.187423836653636,
              -29.90659967798106
            ],
            [
              -55.18857617079377,
              -29.908821122057105
            ],
            [
              -55.189676126109354,
              -29.909607883500705
            ],
            [
              -55.19140462731956,
              -29.912107008086252
            ],
            [
              -55.19271409793335,
              -29.913217730124277
            ],
            [
              -55.194390220319,
              -29.91548545428524
            ],
            [
              -55.1960139638801,
              -29.916179655559002
            ],
            [
              -55.19748057096754,
              -29.91580941487966
            ],
            [
              -55.20067567926519,
              -29.916920136917682
            ],
            [
              -55.203189862843665,
              -29.919187861078644
            ],
            [
              -55.204708848755665,
              -29.91891018056914
            ],
            [
              -55.205808804071246,
              -29.920113462776996
            ],
            [
              -55.20832298764972,
              -29.921918386088784
            ],
            [
              -55.21109906535096,
              -29.922010946258617
            ],
            [
              -55.21198950536834,
              -29.922890267872052
            ],
            [
              -55.215079856016885,
              -29.9211779047301
            ],
            [
              -55.21670359957798,
              -29.921501865324522
            ],
            [
              -55.219793950226524,
              -29.919789502182574
            ],
            [
              -55.22251764910321,
              -29.92002090260716
            ],
            [
              -55.224403286787066,
              -29.921779545834028
            ],
            [
              -55.22958879041768,
              -29.92941575984543
            ],
            [
              -55.2303220939614,
              -29.932377685280155
            ],
            [
              -55.230374472785954,
              -29.934414009016532
            ],
            [
              -55.232102973996156,
              -29.93908829759321
            ],
            [
              -55.23320292931174,
              -29.939689938697136
            ],
            [
              -55.23430288462732,
              -29.942698144216777
            ],
            [
              -55.23430288462732,
              -29.94667823151969
            ],
            [
              -55.23330768696084,
              -29.948621995086228
            ],
            [
              -55.2352980822938,
              -29.950797159077357
            ],
            [
              -55.23540283994291,
              -29.952694642558978
            ],
            [
              -55.236974204679456,
              -29.953712804427163
            ],
            [
              -55.23718371997766,
              -29.954684686210435
            ],
            [
              -55.24001217650345,
              -29.95741521122057
            ],
            [
              -55.240116934152546,
              -29.96111761801398
            ],
            [
              -55.240378828275304,
              -29.962506020561506
            ],
            [
              -55.24001217650345,
              -29.963894423109032
            ],
            [
              -55.24090261652082,
              -29.965005145147057
            ],
            [
              -55.2417930565382,
              -29.967689390072277
            ],
            [
              -55.2435215577484,
              -29.969679433723734
            ],
            [
              -55.24462151306399,
              -29.97217855830928
            ],
            [
              -55.243888209520264,
              -29.97662144646137
            ],
            [
              -55.24488340718675,
              -29.982313896906234
            ],
            [
              -55.246088120151434,
              -29.984211380387855
            ],
            [
              -55.244988164835846,
              -29.986479104548817
            ],
            [
              -55.245197680134055,
              -29.98791378718126
            ],
            [
              -55.24881181902811,
              -29.990320351596974
            ],
            [
              -55.24970225904549,
              -29.991292233380246
            ],
            [
              -55.25221644262397,
              -29.99198643465401
            ],
            [
              -55.25300212499224,
              -29.99369879779596
            ],
            [
              -55.25509727797431,
              -29.99559628127758
            ],
            [
              -55.25577820269348,
              -29.99791028552346
            ],
            [
              -55.25797811332465,
              -30.001288731722443
            ],
            [
              -55.25949709923664,
              -30.00212177325096
            ],
            [
              -55.260020887482156,
              -30.004482057581757
            ],
            [
              -55.258292386271954,
              -30.008184464375162
            ],
            [
              -55.25949709923664,
              -30.01022078811154
            ],
            [
              -55.258920932166575,
              -30.012812472866923
            ],
            [
              -55.25939234158754,
              -30.013876914820028
            ],
            [
              -55.260911327499535,
              -30.014617396178707
            ],
            [
              -55.263111238130705,
              -30.014895076688216
            ],
            [
              -55.26520639111277,
              -30.0167
            ],
            [
              -55.26677775584932,
              -30.016607439830164
            ],
            [
              -55.26719678644573,
              -30.017579321613436
            ],
            [
              -55.26651586172656,
              -30.01901400424588
            ],
            [
              -55.266411104077456,
              -30.02188336951077
            ],
            [
              -55.26782533234035,
              -30.02317921188846
            ],
            [
              -55.26677775584932,
              -30.029288183097584
            ],
            [
              -55.2678777111649,
              -30.030815425899863
            ],
            [
              -55.26761581704214,
              -30.031879867852968
            ],
            [
              -55.26850625705952,
              -30.034980633542446
            ],
            [
              -55.27002524297151,
              -30.03609135558047
            ],
            [
              -55.26897766648048,
              -30.03840535982635
            ],
            [
              -55.2696062123751,
              -30.039886322543712
            ],
            [
              -55.27070616769068,
              -30.040395403477806
            ],
            [
              -55.27159660770806,
              -30.03951608186437
            ],
            [
              -55.27358700304102,
              -30.04141356534599
            ],
            [
              -55.275315504251225,
              -30.040904484411897
            ],
            [
              -55.27798682430336,
              -30.04201520644992
            ],
            [
              -55.27840585489977,
              -30.04469945137514
            ],
            [
              -55.278877264320734,
              -30.045717613243326
            ],
            [
              -55.280815280829145,
              -30.046180414092504
            ],
            [
              -55.280396250232734,
              -30.048494418338382
            ],
            [
              -55.2810771749519,
              -30.051687744197697
            ],
            [
              -55.28338184323217,
              -30.05261334589605
            ],
            [
              -55.285476996214236,
              -30.05488107005701
            ],
            [
              -55.28720549742444,
              -30.058213236171074
            ],
            [
              -55.2907148786694,
              -30.060295839992367
            ],
            [
              -55.294486154037116,
              -30.06348916585168
            ],
            [
              -55.29757650468566,
              -30.064183367125445
            ],
            [
              -55.30040496121144,
              -30.067608093409348
            ],
            [
              -55.302500114193506,
              -30.069783257400474
            ],
            [
              -55.30527619189474,
              -30.072097261646352
            ],
            [
              -55.304280994228264,
              -30.07348566419388
            ],
            [
              -55.304490509526474,
              -30.074920346826325
            ],
            [
              -55.30747610252591,
              -30.077002950647618
            ],
            [
              -55.30857605784149,
              -30.07709551081745
            ],
            [
              -55.30920460373611,
              -30.07848391336498
            ],
            [
              -55.31229495438466,
              -30.080103716337096
            ],
            [
              -55.313080636752936,
              -30.081306998544953
            ],
            [
              -55.314494865015824,
              -30.083111921856737
            ],
            [
              -55.31329015205114,
              -30.08491684516852
            ],
            [
              -55.31077596847266,
              -30.086582928225557
            ],
            [
              -55.30799989077143,
              -30.087786210433414
            ],
            [
              -55.30548570719295,
              -30.08787877060325
            ],
            [
              -55.302500114193506,
              -30.088711812131766
            ],
            [
              -55.30061447650965,
              -30.08787877060325
            ],
            [
              -55.297419368212005,
              -30.088017610858003
            ],
            [
              -55.2955861093527,
              -30.088480411707177
            ],
            [
              -55.29312430459877,
              -30.09232165875534
            ],
            [
              -55.29129104573946,
              -30.09570010495432
            ],
            [
              -55.291919591634084,
              -30.100420673615915
            ],
            [
              -55.29181483398498,
              -30.102179316842783
            ],
            [
              -55.29092439396761,
              -30.1030123583713
            ],
            [
              -55.28841021038913,
              -30.10361399947523
            ],
            [
              -55.286995982126236,
              -30.102318157097535
            ],
            [
              -55.28741501272265,
              -30.100883474465093
            ],
            [
              -55.28720549742444,
              -30.09838434987954
            ],
            [
              -55.28511034444238,
              -30.09630174605825
            ],
            [
              -55.28511034444238,
              -30.091581177396655
            ],
            [
              -55.282386645565694,
              -30.09019277484913
            ],
            [
              -55.2810771749519,
              -30.088202731197672
            ],
            [
              -55.280396250232734,
              -30.085796166781957
            ],
            [
              -55.278824885496185,
              -30.083204482026574
            ],
            [
              -55.27411079128654,
              -30.080983037950528
            ],
            [
              -55.271282334760755,
              -30.08112187820528
            ],
            [
              -55.269082424129586,
              -30.082417720582974
            ],
            [
              -55.26630634642835,
              -30.083297042196406
            ],
            [
              -55.264892118165456,
              -30.083111921856737
            ],
            [
              -55.26279696518339,
              -30.08440776423443
            ],
            [
              -55.26038753925402,
              -30.084685444743936
            ],
            [
              -55.25918282628933,
              -30.083713562960668
            ],
            [
              -55.2564067485881,
              -30.083297042196406
            ],
            [
              -55.25588296034258,
              -30.082001199818716
            ],
            [
              -55.25431159560603,
              -30.082001199818716
            ],
            [
              -55.25389256500962,
              -30.079687195572838
            ],
            [
              -55.25059269906287,
              -30.079502075233165
            ],
            [
              -55.24902133432632,
              -30.080520237101354
            ],
            [
              -55.24729283311612,
              -30.079918595997423
            ],
            [
              -55.244988164835846,
              -30.08112187820528
            ],
            [
              -55.242107329485506,
              -30.0803813968466
            ],
            [
              -55.24022169180165,
              -30.07940951506333
            ],
            [
              -55.2351933246447,
              -30.07890043412924
            ],
            [
              -55.23309817166263,
              -30.07788227226105
            ],
            [
              -55.22759839508471,
              -30.07811367268564
            ],
            [
              -55.227074606839196,
              -30.076817830307945
            ],
            [
              -55.22518896915534,
              -30.076586429883356
            ],
            [
              -55.22277954322597,
              -30.07579966843976
            ],
            [
              -55.22298905852418,
              -30.07811367268564
            ],
            [
              -55.222308133805,
              -30.079502075233165
            ],
            [
              -55.21869399491094,
              -30.08019627650693
            ],
            [
              -55.21607505368336,
              -30.080288836676765
            ],
            [
              -55.215079856016885,
              -30.081306998544953
            ],
            [
              -55.214922719543225,
              -30.082787961262316
            ],
            [
              -55.21240853596475,
              -30.085287085847863
            ],
            [
              -55.2092134276671,
              -30.08570360661212
            ],
            [
              -55.20151374045802,
              -30.083713562960668
            ],
            [
              -55.19931382982685,
              -30.082417720582974
            ],
            [
              -55.1961187215292,
              -30.081214438375117
            ],
            [
              -55.194390220319,
              -30.080103716337096
            ],
            [
              -55.19129986967045,
              -30.080288836676765
            ],
            [
              -55.1880000037237,
              -30.07899299429907
            ],
            [
              -55.18758097312729,
              -30.076586429883356
            ],
            [
              -55.18632388133805,
              -30.07441126589223
            ],
            [
              -55.18538106249612,
              -30.07140306037259
            ],
            [
              -55.18438586482964,
              -30.069922097655226
            ],
            [
              -55.18470013777695,
              -30.06830229468311
            ],
            [
              -55.187476215478185,
              -30.067885773918853
            ],
            [
              -55.187423836653636,
              -30.06469244805954
            ],
            [
              -55.186795290759015,
              -30.063396605681845
            ],
            [
              -55.187004806057224,
              -30.06099004126613
            ],
            [
              -55.18438586482964,
              -30.058814877275005
            ],
            [
              -55.183285909514055,
              -30.056315752689454
            ],
            [
              -55.18229071184758,
              -30.0553901509911
            ],
            [
              -55.18181930242661,
              -30.053816628103906
            ],
            [
              -55.1797765282691,
              -30.05080842258426
            ],
            [
              -55.1797765282691,
              -30.048216737828877
            ],
            [
              -55.17778613293614,
              -30.047707656894783
            ],
            [
              -55.17820516353255,
              -30.045810173413162
            ],
            [
              -55.174381509340286,
              -30.044792011544974
            ],
            [
              -55.17228635635822,
              -30.044792011544974
            ],
            [
              -55.168410323341405,
              -30.042894528063353
            ],
            [
              -55.16547710916651,
              -30.044005250101378
            ],
            [
              -55.16280578911438,
              -30.043681289506953
            ],
            [
              -55.160920151430524,
              -30.047106015790856
            ],
            [
              -55.15898213492211,
              -30.049605140376404
            ],
            [
              -55.15772504313288,
              -30.05048446198984
            ],
            [
              -55.155787026624466,
              -30.05048446198984
            ],
            [
              -55.15442517718613,
              -30.048494418338382
            ],
            [
              -55.15201575125675,
              -30.04780021706462
            ],
            [
              -55.15070628064296,
              -30.048077897574125
            ],
            [
              -55.14939681002917,
              -30.04951258020657
            ],
            [
              -55.1470921417489,
              -30.050577022159672
            ],
            [
              -55.14677786880159,
              -30.052104264961955
            ],
            [
              -55.14400179110036,
              -30.05390918827374
            ],
            [
              -55.142116153416495,
              -30.05409430861341
            ],
            [
              -55.141697122820084,
              -30.048818378932804
            ],
            [
              -55.14091144045181,
              -30.048494418338382
            ],
            [
              -55.140806682802705,
              -30.046087853922668
            ],
            [
              -55.13719254390865,
              -30.04238544712926
            ],
            [
              -55.1357259368212,
              -30.041783806025332
            ],
            [
              -55.13378792031279,
              -30.041922646280085
            ],
            [
              -55.132583207348105,
              -30.041321005176158
            ],
            [
              -55.128392901383975,
              -30.041506125515827
            ],
            [
              -55.1259834754546,
              -30.042709407723684
            ],
            [
              -55.12467400484081,
              -30.042616847553848
            ],
            [
              -55.11980277415751,
              -30.044005250101378
            ],
            [
              -55.1193837435611,
              -30.04599529375283
            ],
            [
              -55.11718383292993,
              -30.04678205519643
            ],
            [
              -55.11320304226401,
              -30.046087853922668
            ],
            [
              -55.11079361633464,
              -30.044977131884647
            ],
            [
              -55.107808023335195,
              -30.03970120220404
            ],
            [
              -55.10592238565134,
              -30.039007000930276
            ],
            [
              -55.10508432445851,
              -30.03951608186437
            ],
            [
              -55.10277965617824,
              -30.037711158552586
            ],
            [
              -55.10262251970459,
              -30.036415316174892
            ],
            [
              -55.10047498789797,
              -30.0351194737972
            ],
            [
              -55.09932265375784,
              -30.03572111490113
            ],
            [
              -55.096075166635636,
              -30.034610392863108
            ],
            [
              -55.0948180748464,
              -30.03548971447654
            ],
            [
              -55.09570851486377,
              -30.037202077618492
            ],
            [
              -55.0948180748464,
              -30.039793762373876
            ],
            [
              -55.09398001365357,
              -30.040719364072228
            ],
            [
              -55.09717512195122,
              -30.04298708823319
            ],
            [
              -55.09921789610873,
              -30.04488457171481
            ],
            [
              -55.0998988208279,
              -30.046180414092504
            ],
            [
              -55.099689305529694,
              -30.047707656894783
            ],
            [
              -55.10089401849439,
              -30.049188619612146
            ],
            [
              -55.100317851424315,
              -30.050391901820003
            ],
            [
              -55.10110353379259,
              -30.05349266750948
            ],
            [
              -55.098275077266806,
              -30.055991792095032
            ],
            [
              -55.09822269844225,
              -30.059786759058273
            ],
            [
              -55.09869410786322,
              -30.060712360756625
            ],
            [
              -55.09439904424998,
              -30.06390568661594
            ],
            [
              -55.09361336188171,
              -30.06478500822937
            ],
            [
              -55.09382287717992,
              -30.066080850607065
            ],
            [
              -55.09240864891702,
              -30.069181616296543
            ],
            [
              -55.09109917830323,
              -30.07019977816473
            ],
            [
              -55.09052301123317,
              -30.071588180712258
            ],
            [
              -55.08690887233911,
              -30.07769715192138
            ],
            [
              -55.08470896170794,
              -30.08362100279083
            ],
            [
              -55.084813719357044,
              -30.092182818500586
            ],
            [
              -55.08428993111153,
              -30.094404262576628
            ],
            [
              -55.08470896170794,
              -30.095514984614653
            ],
            [
              -55.08350424874325,
              -30.096810826992343
            ],
            [
              -55.083713764041455,
              -30.098708310473963
            ],
            [
              -55.08119958046298,
              -30.09898599098347
            ],
            [
              -55.08109482281388,
              -30.101577675738856
            ],
            [
              -55.08219477812946,
              -30.1030123583713
            ],
            [
              -55.07978535220009,
              -30.105604043126686
            ],
            [
              -55.077690199218026,
              -30.10662220499487
            ],
            [
              -55.07538553093775,
              -30.109399010089927
            ],
            [
              -55.07449509092038,
              -30.109213889750258
            ],
            [
              -55.073499893253896,
              -30.11069485246762
            ],
            [
              -55.073604650903,
              -30.11180557450564
            ],
            [
              -55.075490288586856,
              -30.114397259261025
            ],
            [
              -55.07501887916589,
              -30.117081504186245
            ],
            [
              -55.07528077328865,
              -30.11930294826229
            ],
            [
              -55.07679975920065,
              -30.12008970970589
            ],
            [
              -55.07711403214795,
              -30.12430119743339
            ],
            [
              -55.07611883448148,
              -30.124717718197648
            ],
            [
              -55.07512363681499,
              -30.1272168427832
            ],
            [
              -55.071509497920935,
              -30.127818483887125
            ],
            [
              -55.07051430025445,
              -30.129299446604488
            ],
            [
              -55.06967623906163,
              -30.133881175011332
            ],
            [
              -55.069519102587975,
              -30.137120780955563
            ],
            [
              -55.06810487432508,
              -30.141795069532236
            ],
            [
              -55.06569544839571,
              -30.141702509362403
            ],
            [
              -55.06260509774716,
              -30.14332231233452
            ],
            [
              -55.06140038478247,
              -30.143507432674188
            ],
            [
              -55.060509944765094,
              -30.144895835221718
            ],
            [
              -55.05820527648483,
              -30.143414872504355
            ],
            [
              -55.05658153292373,
              -30.141795069532236
            ],
            [
              -55.05611012350276,
              -30.139897586050616
            ],
            [
              -55.05469589523987,
              -30.13887942418243
            ],
            [
              -55.0526007422578,
              -30.139018264437183
            ],
            [
              -55.050086558679325,
              -30.1382777830785
            ],
            [
              -55.04998180103023,
              -30.137305901295232
            ],
            [
              -55.04841043629368,
              -30.137305901295232
            ],
            [
              -55.0458962527152,
              -30.13619517925721
            ],
            [
              -55.044324887978654,
              -30.136287739427043
            ],
            [
              -55.04348682678582,
              -30.135084457219186
            ],
            [
              -55.03982030906722,
              -30.135500977983448
            ],
            [
              -55.030811151244336,
              -30.13480677670968
            ],
            [
              -55.027092254701174,
              -30.133881175011332
            ],
            [
              -55.0246828287718,
              -30.132215091954297
            ],
            [
              -55.02300670638615,
              -30.131520890680534
            ],
            [
              -55.02201150871967,
              -30.12990108770842
            ],
            [
              -55.01907829454478,
              -30.12869780550056
            ],
            [
              -55.01719265686092,
              -30.129715967368746
            ],
            [
              -55.01499274622975,
              -30.12999364787825
            ],
            [
              -55.01232142617762,
              -30.12948456694416
            ],
            [
              -55.00970248495004,
              -30.129715967368746
            ],
            [
              -55.00718830137156,
              -30.130317608472676
            ],
            [
              -55.00587883075777,
              -30.129299446604488
            ],
            [
              -55.00577407310867,
              -30.12809616439663
            ],
            [
              -55.00268372246013,
              -30.12508795887699
            ],
            [
              -55.00210755539006,
              -30.1232830355652
            ],
            [
              -55.00132187302179,
              -30.122588834291438
            ],
            [
              -55.00048381182896,
              -30.118793867328197
            ],
            [
              -55.00111235772358,
              -30.117220344440998
            ],
            [
              -55.000693327127166,
              -30.115878221978388
            ],
            [
              -55.00132187302179,
              -30.11509146053479
            ],
            [
              -55.001583767144545,
              -30.112083255015147
            ],
            [
              -55.000012402408,
              -30.110602292297784
            ],
            [
              -54.998493416496,
              -30.110602292297784
            ],
            [
              -54.996503021163036,
              -30.10851968847649
            ],
            [
              -54.99430311053187,
              -30.10717756601388
            ],
            [
              -54.98628915037548,
              -30.096209185888416
            ],
            [
              -54.98042272202569,
              -30.0945893829163
            ],
            [
              -54.98010844907839,
              -30.092691899434676
            ],
            [
              -54.978379947868184,
              -30.091720017651408
            ],
            [
              -54.97670382548253,
              -30.088896932471435
            ],
            [
              -54.97492294544777,
              -30.08898949264127
            ],
            [
              -54.97450391485136,
              -30.087415969754073
            ],
            [
              -54.97162307950102,
              -30.08709200915965
            ],
            [
              -54.969318411220755,
              -30.087786210433414
            ],
            [
              -54.96811369825607,
              -30.087415969754073
            ],
            [
              -54.967118500589585,
              -30.088804372301603
            ],
            [
              -54.965809029975794,
              -30.088110171027836
            ],
            [
              -54.963818634642834,
              -30.088711812131766
            ],
            [
              -54.96161872401167,
              -30.08709200915965
            ],
            [
              -54.959575949854155,
              -30.087184569329484
            ],
            [
              -54.95732366039844,
              -30.0853796460177
            ],
            [
              -54.95569991683734,
              -30.08570360661212
            ],
            [
              -54.9510905802768,
              -30.08422264389476
            ],
            [
              -54.94889066964563,
              -30.082602840922643
            ],
            [
              -54.94831450257556,
              -30.079178114638744
            ],
            [
              -54.94857639669832,
              -30.076586429883356
            ],
            [
              -54.946481243716256,
              -30.0753831476755
            ],
            [
              -54.94637648606715,
              -30.074318705722398
            ],
            [
              -54.94527653075157,
              -30.073207983684373
            ],
            [
              -54.94328613541861,
              -30.07348566419388
            ],
            [
              -54.94150525538385,
              -30.07228238198602
            ],
            [
              -54.94270996834854,
              -30.071310500202753
            ],
            [
              -54.94260521069943,
              -30.07001465782506
            ],
            [
              -54.94061481536647,
              -30.068579975192616
            ],
            [
              -54.93851966238441,
              -30.066080850607065
            ],
            [
              -54.936319751753246,
              -30.06561804975789
            ],
            [
              -54.93448649289394,
              -30.06561804975789
            ],
            [
              -54.93270561285918,
              -30.063581726021514
            ],
            [
              -54.92830579159685,
              -30.067978334088686
            ],
            [
              -54.92490116800099,
              -30.06950557689097
            ],
            [
              -54.92160130205424,
              -30.070107217994895
            ],
            [
              -54.9185109514057,
              -30.071079099778164
            ],
            [
              -54.916887207844596,
              -30.072421222240774
            ],
            [
              -54.91468729721343,
              -30.07330054385421
            ],
            [
              -54.91348258424875,
              -30.07579966843976
            ],
            [
              -54.91149218891578,
              -30.07769715192138
            ],
            [
              -54.90908276298641,
              -30.078807873959402
            ],
            [
              -54.906725715881585,
              -30.078807873959402
            ],
            [
              -54.902011621671946,
              -30.07940951506333
            ],
            [
              -54.900702151058155,
              -30.07890043412924
            ],
            [
              -54.899392680444365,
              -30.079687195572838
            ],
            [
              -54.90122593930367,
              -30.084083803640006
            ],
            [
              -54.89970695339167,
              -30.085287085847863
            ],
            [
              -54.89991646868988,
              -30.08750852992391
            ],
            [
              -54.897192769813195,
              -30.090886976122892
            ],
            [
              -54.89672136039223,
              -30.09209025833075
            ],
            [
              -54.89661660274313,
              -30.0945893829163
            ],
            [
              -54.89331673679638,
              -30.09648686639792
            ],
            [
              -54.89158823558617,
              -30.100004152851657
            ],
            [
              -54.88860264258673,
              -30.099217391408057
            ],
            [
              -54.883521896605224,
              -30.0995876320874
            ],
            [
              -54.88299810835971,
              -30.098476910049378
            ],
            [
              -54.879279211816545,
              -30.098106669370036
            ],
            [
              -54.87917445416744,
              -30.09690338716218
            ],
            [
              -54.87697454353628,
              -30.09611662571858
            ],
            [
              -54.87419846583504,
              -30.09648686639792
            ],
            [
              -54.871317630484704,
              -30.095607544784485
            ],
            [
              -54.86670829392416,
              -30.096394306228085
            ],
            [
              -54.86497979271396,
              -30.097597588435942
            ],
            [
              -54.862675124433686,
              -30.097088507501848
            ],
            [
              -54.857803893750386,
              -30.09838434987954
            ],
            [
              -54.85717534785577,
              -30.097921549030364
            ],
            [
              -54.85361358778626,
              -30.098476910049378
            ],
            [
              -54.84931852417303,
              -30.100004152851657
            ],
            [
              -54.84759002296283,
              -30.101994196503114
            ],
            [
              -54.84612341587538,
              -30.101207435059514
            ],
            [
              -54.845180597033455,
              -30.099402511747726
            ],
            [
              -54.843190201700494,
              -30.100189273191326
            ],
            [
              -54.84088553342022,
              -30.100189273191326
            ],
            [
              -54.839418926332776,
              -30.101994196503114
            ],
            [
              -54.837480909824365,
              -30.10338259905064
            ],
            [
              -54.83601430273692,
              -30.102919798201466
            ],
            [
              -54.83470483212313,
              -30.103799119814898
            ],
            [
              -54.831876375597346,
              -30.104817281683086
            ],
            [
              -54.82580043194936,
              -30.10509496219259
            ],
            [
              -54.819724488301375,
              -30.108103167712233
            ],
            [
              -54.81721030472289,
              -30.107918047372564
            ],
            [
              -54.814905636442624,
              -30.106483364740118
            ],
            [
              -54.81317713523242,
              -30.106020563890944
            ],
            [
              -54.809982026934776,
              -30.104308200748992
            ],
            [
              -54.809982026934776,
              -30.10319747871097
            ],
            [
              -54.805791720970646,
              -30.100790914295256
            ],
            [
              -54.80401084093589,
              -30.100189273191326
            ],
            [
              -54.801601415006516,
              -30.098199229539873
            ],
            [
              -54.801077626761,
              -30.097088507501848
            ],
            [
              -54.79929674672625,
              -30.095977785463827
            ],
            [
              -54.793692212499224,
              -30.095283584190064
            ],
            [
              -54.790078073605166,
              -30.093895181642534
            ],
            [
              -54.7896066641842,
              -30.094311702406795
            ],
            [
              -54.782378386396076,
              -30.083111921856737
            ],
            [
              -54.77981182399305,
              -30.0838061231305
            ],
            [
              -54.77797856513374,
              -30.08288052143215
            ],
            [
              -54.776407200397195,
              -30.0803813968466
            ],
            [
              -54.77687860981816,
              -30.077188070987287
            ],
            [
              -54.77782142866009,
              -30.07621618920402
            ],
            [
              -54.77871186867747,
              -30.07408730529781
            ],
            [
              -54.77797856513374,
              -30.071680740882094
            ],
            [
              -54.778397595730155,
              -30.0703848985044
            ],
            [
              -54.777507155712776,
              -30.0695981370608
            ],
            [
              -54.77740239806368,
              -30.06751553323951
            ],
            [
              -54.776616715695404,
              -30.06311892517234
            ],
            [
              -54.776616715695404,
              -30.058999997614674
            ],
            [
              -54.77588341215168,
              -30.057796715406816
            ],
            [
              -54.77357874387141,
              -30.056500873029126
            ],
            [
              -54.77300257680134,
              -30.055019910311763
            ],
            [
              -54.772897819152234,
              -30.052520785726212
            ],
            [
              -54.77158834853845,
              -30.051086103093766
            ],
            [
              -54.76959795320549,
              -30.050206781480334
            ],
            [
              -54.76917892260907,
              -30.049096059442313
            ],
            [
              -54.76771231552163,
              -30.048818378932804
            ],
            [
              -54.76661236020605,
              -30.047291136130525
            ],
            [
              -54.764621964873086,
              -30.046596934856762
            ],
            [
              -54.763993418978465,
              -30.043496169167284
            ],
            [
              -54.76147923539999,
              -30.040395403477806
            ],
            [
              -54.759122188295166,
              -30.040811924242064
            ],
            [
              -54.75791747533048,
              -30.040395403477806
            ],
            [
              -54.756712762365794,
              -30.038590480166018
            ],
            [
              -54.7568175200149,
              -30.036415316174892
            ],
            [
              -54.755612807050206,
              -30.03470295303294
            ],
            [
              -54.75697465648855,
              -30.03391619158934
            ],
            [
              -54.757184171786754,
              -30.0324815089569
            ],
            [
              -54.75959359771613,
              -30.030815425899863
            ],
            [
              -54.75697465648855,
              -30.02979726403168
            ],
            [
              -54.755822322348415,
              -30.028501421653985
            ],
            [
              -54.75571756469931,
              -30.025678336474012
            ],
            [
              -54.75477474585738,
              -30.02438249409632
            ],
            [
              -54.75571756469931,
              -30.022392450444862
            ],
            [
              -54.75498426115559,
              -30.021004047897335
            ],
            [
              -54.75079395519146,
              -30.021189168237004
            ],
            [
              -54.74487514801713,
              -30.023503172482886
            ],
            [
              -54.740580084403895,
              -30.022577570784534
            ],
            [
              -54.73759449140446,
              -30.0209114877275
            ],
            [
              -54.735918369018805,
              -30.021004047897335
            ],
            [
              -54.731675684230126,
              -30.024012253416977
            ],
            [
              -54.73251374542295,
              -30.026789058512033
            ],
            [
              -54.73130903245826,
              -30.028316301314316
            ],
            [
              -54.72910912182709,
              -30.029288183097584
            ],
            [
              -54.72449978526656,
              -30.029612143692006
            ],
            [
              -54.723085557003664,
              -30.0301212246261
            ],
            [
              -54.7209904040216,
              -30.031602187343463
            ],
            [
              -54.71910476633774,
              -30.032296388617226
            ],
            [
              -54.71549062744368,
              -30.032296388617226
            ],
            [
              -54.71339547446161,
              -30.031879867852968
            ],
            [
              -54.71219076149693,
              -30.030722865730027
            ],
            [
              -54.71208600384782,
              -30.026603938172364
            ],
            [
              -54.71119556383045,
              -30.025215535624838
            ],
            [
              -54.70899565319928,
              -30.024706454690744
            ],
            [
              -54.70632433314715,
              -30.025678336474012
            ],
            [
              -54.704281558989635,
              -30.028686541993654
            ],
            [
              -54.7030244672004,
              -30.02901050258808
            ],
            [
              -54.69972460125365,
              -30.02877910216349
            ],
            [
              -54.69579618941228,
              -30.02988982420151
            ],
            [
              -54.69459147644759,
              -30.031787307683132
            ],
            [
              -54.693386763482906,
              -30.035582274646377
            ],
            [
              -54.69150112579904,
              -30.037202077618492
            ],
            [
              -54.68888218457146,
              -30.03761859838275
            ],
            [
              -54.686996546887606,
              -30.037202077618492
            ],
            [
              -54.68511090920375,
              -30.035998795410634
            ],
            [
              -54.68217769502886,
              -30.032111268277557
            ],
            [
              -54.679925405573144,
              -30.03109310640937
            ],
            [
              -54.67741122199466,
              -30.0309079860697
            ],
            [
              -54.6737970831006,
              -30.031879867852968
            ],
            [
              -54.668611579469996,
              -30.034517832693272
            ],
            [
              -54.66651642648793,
              -30.034517832693272
            ],
            [
              -54.66368796996214,
              -30.033684791164756
            ],
            [
              -54.659602421647115,
              -30.032111268277557
            ],
            [
              -54.65740251101595,
              -30.029982384371348
            ],
            [
              -54.65541211568299,
              -30.02609485723827
            ],
            [
              -54.65300268975361,
              -30.024613894520908
            ],
            [
              -54.65080277912245,
              -30.02438249409632
            ],
            [
              -54.64792194377211,
              -30.025400655964507
            ],
            [
              -54.64498872959722,
              -30.025493216134343
            ],
            [
              -54.6409031812822,
              -30.026002297068434
            ],
            [
              -54.6394889530193,
              -30.025215535624838
            ],
            [
              -54.63802234593186,
              -30.021605689001266
            ],
            [
              -54.63828424005462,
              -30.020217286453736
            ],
            [
              -54.64168886365047,
              -30.019291684755384
            ],
            [
              -54.642579303667844,
              -30.018088402547527
            ],
            [
              -54.642579303667844,
              -30.0159132385564
            ],
            [
              -54.641898378948675,
              -30.014709956348543
            ],
            [
              -54.638388997703714,
              -30.0117017508289
            ],
            [
              -54.63477485880966,
              -30.009295186413187
            ],
            [
              -54.63257494817849,
              -30.00712002242206
            ],
            [
              -54.62958935517905,
              -30.00462089783651
            ],
            [
              -54.629275082231736,
              -30.00267713426997
            ],
            [
              -54.630113143424566,
              -30.000687090618516
            ],
            [
              -54.63257494817849,
              -29.997493764759202
            ],
            [
              -54.63267970582759,
              -29.995920241872003
            ],
            [
              -54.630375037547324,
              -29.99369879779596
            ],
            [
              -54.628594157512566,
              -29.991616193974668
            ],
            [
              -54.625922837460436,
              -29.991477353719915
            ],
            [
              -54.62372292682927,
              -29.99291203635236
            ],
            [
              -54.6197945149879,
              -29.99369879779596
            ],
            [
              -54.6182755290759,
              -29.993004596522194
            ],
            [
              -54.61659940669025,
              -29.98851542828519
            ],
            [
              -54.6134042983926,
              -29.986895625313075
            ],
            [
              -54.61199007012971,
              -29.98481302149178
            ],
            [
              -54.608480688884754,
              -29.98351717911409
            ],
            [
              -54.60659505120089,
              -29.981897376141976
            ],
            [
              -54.60298091230683,
              -29.981110614698377
            ],
            [
              -54.601619062868494,
              -29.980185013000025
            ],
            [
              -54.603818973499656,
              -29.977315647735132
            ],
            [
              -54.603818973499656,
              -29.976390046036784
            ],
            [
              -54.60219522993856,
              -29.97509420365909
            ],
            [
              -54.59900012164091,
              -29.975510724423348
            ],
            [
              -54.595805013343266,
              -29.977593328244637
            ],
            [
              -54.5936051027121,
              -29.977685888414474
            ],
            [
              -54.59130043443182,
              -29.97620492569711
            ],
            [
              -54.58941479674797,
              -29.975603284593184
            ],
            [
              -54.587895810835974,
              -29.973890921451233
            ],
            [
              -54.58852435673059,
              -29.971114116356176
            ],
            [
              -54.5853816272575,
              -29.96991083414832
            ],
            [
              -54.5853816272575,
              -29.9680133506667
            ],
            [
              -54.587895810835974,
              -29.966300987524747
            ],
            [
              -54.588105326134176,
              -29.96509770531689
            ],
            [
              -54.585905415503014,
              -29.962506020561506
            ],
            [
              -54.58401977781915,
              -29.96190437945758
            ],
            [
              -54.58197700366164,
              -29.96278370107101
            ],
            [
              -54.57721053062745,
              -29.963107661665433
            ],
            [
              -54.57558678706634,
              -29.96199693962741
            ],
            [
              -54.57700101532924,
              -29.96130273835365
            ],
            [
              -54.57700101532924,
              -29.959821775636286
            ],
            [
              -54.57537727176814,
              -29.958479653173676
            ],
            [
              -54.57281070936511,
              -29.957692891730076
            ],
            [
              -54.57181551169863,
              -29.957785451899912
            ],
            [
              -54.56951084341836,
              -29.959821775636286
            ],
            [
              -54.56741569043629,
              -29.959081294277603
            ],
            [
              -54.565582431576985,
              -29.959081294277603
            ],
            [
              -54.564901506857815,
              -29.957183810795982
            ],
            [
              -54.56338252094582,
              -29.95648960952222
            ],
            [
              -54.561811156209274,
              -29.957183810795982
            ],
            [
              -54.56170639856017,
              -29.958479653173676
            ],
            [
              -54.55908745733259,
              -29.95898873410777
            ],
            [
              -54.557987502017006,
              -29.96111761801398
            ],
            [
              -54.555997106684046,
              -29.96111761801398
            ],
            [
              -54.555578076087635,
              -29.960377136655296
            ],
            [
              -54.55568283373673,
              -29.95820197266417
            ],
            [
              -54.55369243840377,
              -29.956119368842877
            ],
            [
              -54.552487725439086,
              -29.955887968418292
            ],
            [
              -54.550497330106126,
              -29.957183810795982
            ],
            [
              -54.547406979457584,
              -29.956906130286477
            ],
            [
              -54.548087904176754,
              -29.955008646804856
            ],
            [
              -54.548087904176754,
              -29.953481404002577
            ],
            [
              -54.5462022664929,
              -29.952879762898647
            ],
            [
              -54.54457852293179,
              -29.951583920520957
            ],
            [
              -54.54117389933594,
              -29.952093001455047
            ],
            [
              -54.53960253459939,
              -29.950102957803594
            ],
            [
              -54.53797879103829,
              -29.949408756529827
            ],
            [
              -54.53310756035499,
              -29.9503806383131
            ],
            [
              -54.531221922671136,
              -29.9480203539823
            ],
            [
              -54.52938866381183,
              -29.947788953557712
            ],
            [
              -54.527503026127974,
              -29.945382389141997
            ],
            [
              -54.52388888723391,
              -29.944688187868234
            ],
            [
              -54.520379505988956,
              -29.94311466498104
            ],
            [
              -54.51561303295476,
              -29.942790704386613
            ],
            [
              -54.513517879972696,
              -29.94320722515087
            ],
            [
              -54.51079418109601,
              -29.94251302387711
            ],
            [
              -54.511317969341526,
              -29.941078341244662
            ],
            [
              -54.5103751504996,
              -29.939921339121724
            ],
            [
              -54.50880378576305,
              -29.939689938697136
            ],
            [
              -54.50749431514926,
              -29.938208975979773
            ],
            [
              -54.505189646868985,
              -29.936820573432243
            ],
            [
              -54.50429920685161,
              -29.937005693771916
            ],
            [
              -54.50209929622044,
              -29.934506569186365
            ],
            [
              -54.50010890088748,
              -29.933118166638838
            ],
            [
              -54.49790899025631,
              -29.933580967488012
            ],
            [
              -54.495604321976046,
              -29.933395847148343
            ],
            [
              -54.49450436666046,
              -29.9338123679126
            ],
            [
              -54.493613926643086,
              -29.935293330629964
            ],
            [
              -54.49219969838019,
              -29.935987531903727
            ],
            [
              -54.48669992180227,
              -29.937098253941752
            ],
            [
              -54.4858094817849,
              -29.937977575555184
            ],
            [
              -54.483923844101035,
              -29.938579216659114
            ],
            [
              -54.48271913113635,
              -29.938116415809937
            ],
            [
              -54.48041446285608,
              -29.938486656489278
            ],
            [
              -54.47910499224229,
              -29.940013899291557
            ],
            [
              -54.47721935455843,
              -29.941078341244662
            ],
            [
              -54.47549085334823,
              -29.943901426424635
            ],
            [
              -54.47517658040092,
              -29.945104708632492
            ],
            [
              -54.47182433562962,
              -29.948621995086228
            ],
            [
              -54.470881516787685,
              -29.951583920520957
            ],
            [
              -54.471719577980515,
              -29.954314445531093
            ],
            [
              -54.471719577980515,
              -29.957183810795982
            ],
            [
              -54.470410107366725,
              -29.95898873410777
            ],
            [
              -54.45438218705393,
              -29.959821775636286
            ],
            [
              -54.45370126233476,
              -29.96009945614579
            ],
            [
              -54.44490161981009,
              -29.95570284807862
            ],
            [
              -54.439401843232176,
              -29.953990484936668
            ],
            [
              -54.43159739837398,
              -29.95260208238914
            ],
            [
              -54.42379295351579,
              -29.950982279417026
            ],
            [
              -54.4156742357103,
              -29.950519478567852
            ],
            [
              -54.40498895550177,
              -29.948390594661642
            ],
            [
              -54.40341759076522,
              -29.943484905660377
            ],
            [
              -54.40111292248495,
              -29.939504818357463
            ],
            [
              -54.40069389188854,
              -29.93908829759321
            ],
            [
              -54.39487984236331,
              -29.938579216659114
            ],
            [
              -54.39288944703035,
              -29.940013899291557
            ],
            [
              -54.389222929311735,
              -29.94052298022565
            ],
            [
              -54.38770394339974,
              -29.94019901963123
            ],
            [
              -54.38608019983864,
              -29.938718056913867
            ],
            [
              -54.37539491963011,
              -29.93751477470601
            ],
            [
              -54.373718797244464,
              -29.937098253941752
            ],
            [
              -54.372199811332464,
              -29.934691689526037
            ],
            [
              -54.368899945385714,
              -29.934090048422107
            ],
            [
              -54.36549532178986,
              -29.934090048422107
            ],
            [
              -54.35318629802023,
              -29.935802411564058
            ],
            [
              -54.350724493266306,
              -29.935478450969633
            ],
            [
              -54.34800079438963,
              -29.933904928082438
            ],
            [
              -54.34491044374108,
              -29.929878560694608
            ],
            [
              -54.34271053310991,
              -29.92830503780741
            ],
            [
              -54.34019634953143,
              -29.927703396703482
            ],
            [
              -54.33537749767269,
              -29.928582718316914
            ],
            [
              -54.33338710233973,
              -29.928814118741503
            ],
            [
              -54.33097767641035,
              -29.928397597977245
            ],
            [
              -54.3291967963756,
              -29.92751827636381
            ],
            [
              -54.32600168807795,
              -29.927379436109057
            ],
            [
              -54.32170662446472,
              -29.925805913221858
            ],
            [
              -54.319925744429966,
              -29.925481952627436
            ],
            [
              -54.3163116055359,
              -29.926500114495624
            ],
            [
              -54.31280222429095,
              -29.926083593731363
            ],
            [
              -54.30850716067771,
              -29.92751827636381
            ],
            [
              -54.30850716067771,
              -29.930387641628702
            ],
            [
              -54.30667390181841,
              -29.932285125110322
            ],
            [
              -54.303583551169865,
              -29.933210726808674
            ],
            [
              -54.301697913486,
              -29.932516525534908
            ],
            [
              -54.29981227580215,
              -29.934090048422107
            ],
            [
              -54.298712320486565,
              -29.934321448846696
            ],
            [
              -54.293422059206854,
              -29.93348840731818
            ],
            [
              -54.289703162663685,
              -29.932192564940486
            ],
            [
              -54.28682232731335,
              -29.93288676621425
            ],
            [
              -54.28451765903308,
              -29.931683484006392
            ],
            [
              -54.28268440017377,
              -29.930295081458866
            ],
            [
              -54.28158444485819,
              -29.928212477637572
            ],
            [
              -54.281479687209085,
              -29.926685234835293
            ],
            [
              -54.27912264010426,
              -29.92520427211793
            ],
            [
              -54.279698807174334,
              -29.92367702931565
            ],
            [
              -54.279279776577916,
              -29.92252002719271
            ],
            [
              -54.27802268478868,
              -29.922103506428453
            ],
            [
              -54.27571801650841,
              -29.92252002719271
            ],
            [
              -54.27278480233352,
              -29.921686985664195
            ],
            [
              -54.27168484701794,
              -29.92080766405076
            ],
            [
              -54.26922304226401,
              -29.91770689836128
            ],
            [
              -54.26801832929932,
              -29.91520777377573
            ],
            [
              -54.26498035747533,
              -29.913819371228204
            ],
            [
              -54.26319947744058,
              -29.91141280681249
            ],
            [
              -54.26042339973934,
              -29.909422763161032
            ],
            [
              -54.25701877614349,
              -29.907617839849248
            ],
            [
              -54.25639023024887,
              -29.906784798320732
            ],
            [
              -54.2557093055297,
              -29.90340635212175
            ],
            [
              -54.25460935021411,
              -29.90160142880996
            ],
            [
              -54.252723712530255,
              -29.900305586432268
            ],
            [
              -54.250104771302674,
              -29.897112260572953
            ],
            [
              -54.24727631477689,
              -29.89299333301529
            ],
            [
              -54.24560019239124,
              -29.892715652505785
            ],
            [
              -54.241881295848074,
              -29.89567757794051
            ],
            [
              -54.237900505182154,
              -29.897621341507048
            ],
            [
              -54.23800526283125,
              -29.90049070677194
            ],
            [
              -54.236381519270154,
              -29.903221231782076
            ],
            [
              -54.2347053968845,
              -29.90391543305584
            ],
            [
              -54.22967702972755,
              -29.90470219449944
            ],
            [
              -54.227477119096385,
              -29.906321997471554
            ],
            [
              -54.22601051200894,
              -29.908821122057105
            ],
            [
              -54.22559148141252,
              -29.910487205114137
            ],
            [
              -54.22428201079873,
              -29.912107008086252
            ],
            [
              -54.22192496369391,
              -29.914004491567873
            ],
            [
              -54.22119166015019,
              -29.91502265343606
            ],
            [
              -54.21721086948427,
              -29.91599453521933
            ],
            [
              -54.21207774467821,
              -29.91580941487966
            ],
            [
              -54.210925410538074,
              -29.91502265343606
            ],
            [
              -54.20820171166139,
              -29.91580941487966
            ],
            [
              -54.20820171166139,
              -29.917012697087518
            ],
            [
              -54.2069969986967,
              -29.918401099635044
            ],
            [
              -54.20369713274995,
              -29.918586219974717
            ],
            [
              -54.2019162527152,
              -29.919696942012738
            ],
            [
              -54.200292509154096,
              -29.921501865324522
            ],
            [
              -54.19898303854031,
              -29.921918386088784
            ],
            [
              -54.19610220318997,
              -29.923908429740237
            ],
            [
              -54.19489749022529,
              -29.926592674665457
            ],
            [
              -54.19290709489232,
              -29.926314994155952
            ],
            [
              -54.19201665487495,
              -29.926916635259882
            ],
            [
              -54.18777397008627,
              -29.928397597977245
            ],
            [
              -54.184107452367655,
              -29.928212477637572
            ],
            [
              -54.18159326878918,
              -29.927610836533646
            ],
            [
              -54.17698393222864,
              -29.92811991746774
            ],
            [
              -54.17300314156272,
              -29.92811991746774
            ],
            [
              -54.17148415565072,
              -29.927379436109057
            ],
            [
              -54.16928424501955,
              -29.927610836533646
            ],
            [
              -54.1678176379321,
              -29.92830503780741
            ],
            [
              -54.166193894371006,
              -29.92830503780741
            ],
            [
              -54.16462252963446,
              -29.92751827636381
            ],
            [
              -54.16242261900329,
              -29.92788851704315
            ],
            [
              -54.16147980016136,
              -29.927379436109057
            ],
            [
              -54.15398962825048,
              -29.926916635259882
            ],
            [
              -54.15268015763669,
              -29.925481952627436
            ],
            [
              -54.14990407993545,
              -29.925805913221858
            ],
            [
              -54.1480184422516,
              -29.924602631014004
            ],
            [
              -54.142780559796435,
              -29.924787751353673
            ],
            [
              -54.13712364674487,
              -29.920483703456338
            ],
            [
              -54.13497611493825,
              -29.92140930515469
            ],
            [
              -54.13240955253522,
              -29.920900224220595
            ],
            [
              -54.129895368956745,
              -29.92140930515469
            ],
            [
              -54.12848114069385,
              -29.919604381842902
            ],
            [
              -54.12628123006268,
              -29.920113462776996
            ],
            [
              -54.12298136411593,
              -29.920298583116665
            ],
            [
              -54.1203100440638,
              -29.922381186937958
            ],
            [
              -54.1138150698194,
              -29.923584469145815
            ],
            [
              -54.11161515918823,
              -29.92427867041958
            ],
            [
              -54.10962476385527,
              -29.925805913221858
            ],
            [
              -54.105801109663005,
              -29.925898473391694
            ],
            [
              -54.10239648606715,
              -29.924787751353673
            ],
            [
              -54.100720363681496,
              -29.922982828041885
            ],
            [
              -54.09689670948923,
              -29.920900224220595
            ],
            [
              -54.09380635884069,
              -29.91951182167307
            ],
            [
              -54.08998270464842,
              -29.915901975049497
            ],
            [
              -54.08542574691243,
              -29.917012697087518
            ],
            [
              -54.08490195866692,
              -29.91580941487966
            ],
            [
              -54.07898315149259,
              -29.912893769529852
            ],
            [
              -54.07667848321231,
              -29.910579765283973
            ],
            [
              -54.07358813256377,
              -29.910811165708562
            ],
            [
              -54.07102157016074,
              -29.908589721632517
            ],
            [
              -54.06971209954695,
              -29.908821122057105
            ],
            [
              -54.06850738658226,
              -29.91099628604823
            ],
            [
              -54.067302673617576,
              -29.91141280681249
            ],
            [
              -54.06520752063551,
              -29.910394644944304
            ],
            [
              -54.06227430646062,
              -29.910487205114137
            ],
            [
              -54.05897444051387,
              -29.911505366982325
            ],
            [
              -54.05640787811084,
              -29.910903725878395
            ],
            [
              -54.05148426860299,
              -29.911690487321994
            ],
            [
              -54.04970338856824,
              -29.913402850463946
            ],
            [
              -54.048708190901756,
              -29.913587970803615
            ],
            [
              -54.04729396263886,
              -29.915392894115403
            ],
            [
              -54.045198809656796,
              -29.916087095389166
            ],
            [
              -54.043208414323836,
              -29.917984578870787
            ],
            [
              -54.040118063675294,
              -29.91738293776686
            ],
            [
              -54.0369753342022,
              -29.92062254371109
            ],
            [
              -54.033884983553655,
              -29.929091799251008
            ],
            [
              -54.03142317879973,
              -29.930896722562792
            ],
            [
              -54.03142317879973,
              -29.932192564940486
            ],
            [
              -54.03000895053683,
              -29.9338123679126
            ],
            [
              -54.030323223484146,
              -29.935709851394222
            ],
            [
              -54.02890899522125,
              -29.938995737423372
            ],
            [
              -54.02958991994042,
              -29.941587422178756
            ],
            [
              -54.02911851051945,
              -29.94991783746392
            ],
            [
              -54.029694677589525,
              -29.950797159077357
            ],
            [
              -54.031894588220695,
              -29.951306240011448
            ],
            [
              -54.0336230894309,
              -29.953203723493072
            ],
            [
              -54.03409449885186,
              -29.95551772773895
            ],
            [
              -54.03351833178179,
              -29.95760033156024
            ],
            [
              -54.030689875256,
              -29.957507771390407
            ],
            [
              -54.02990419288773,
              -29.958896173937934
            ],
            [
              -54.02739000930925,
              -29.959914335806122
            ],
            [
              -54.028175691677525,
              -29.962598580731342
            ],
            [
              -54.02519009867809,
              -29.96338534217494
            ],
            [
              -54.024823446906225,
              -29.965282825656562
            ],
            [
              -54.0175951691181,
              -29.965421665911315
            ],
            [
              -54.01277631725936,
              -29.970419915082413
            ],
            [
              -54.01057640662819,
              -29.970188514657824
            ],
            [
              -54.008481253646124,
              -29.971484357035518
            ],
            [
              -54.01052402780364,
              -29.97398348162107
            ],
            [
              -54.00748605597964,
              -29.975001643489254
            ],
            [
              -54.008219359523366,
              -29.981295735038046
            ],
            [
              -54.00502425122572,
              -29.983979979963266
            ],
            [
              -54.00062442996338,
              -29.98351717911409
            ],
            [
              -54.00051967231428,
              -29.985877463444886
            ],
            [
              -53.993186636877056,
              -29.987312146077333
            ],
            [
              -53.989205846211135,
              -29.985877463444886
            ],
            [
              -53.98732020852728,
              -29.98680306514324
            ],
            [
              -53.98459650965059,
              -29.98601630369964
            ],
            [
              -53.97867770247626,
              -29.986108863869475
            ],
            [
              -53.9766873071433,
              -29.985090702001287
            ],
            [
              -53.97359695649476,
              -29.985414662595712
            ],
            [
              -53.970297090548,
              -29.987312146077333
            ],
            [
              -53.96919713523242,
              -29.988978229134364
            ],
            [
              -53.96657819400484,
              -29.987589826586838
            ],
            [
              -53.96437828337368,
              -29.989811270662884
            ],
            [
              -53.96280691863713,
              -29.99018151134222
            ],
            [
              -53.96128793272513,
              -29.988422868115354
            ],
            [
              -53.95997846211134,
              -29.98888566896453
            ],
            [
              -53.95882612797121,
              -29.9882840278606
            ],
            [
              -53.95521198907714,
              -29.99008895117239
            ],
            [
              -53.95322159374418,
              -29.989579870238295
            ],
            [
              -53.95149309253398,
              -29.991014552870737
            ],
            [
              -53.949607454850124,
              -29.98930218972879
            ],
            [
              -53.94698851362254,
              -29.98888566896453
            ],
            [
              -53.945417148885994,
              -29.98740470624717
            ],
            [
              -53.94127922174641,
              -29.98661794480357
            ],
            [
              -53.94112208527276,
              -29.985877463444886
            ],
            [
              -53.93871265934339,
              -29.985877463444886
            ],
            [
              -53.937612704027806,
              -29.987821227011427
            ],
            [
              -53.930174910941474,
              -29.98870054862486
            ],
            [
              -53.91807540247005,
              -29.986293984209144
            ],
            [
              -53.91749923539999,
              -29.98481302149178
            ],
            [
              -53.91388509650593,
              -29.984905581661618
            ],
            [
              -53.90780915285794,
              -29.98291553801016
            ],
            [
              -53.90498069633215,
              -29.983609739283924
            ],
            [
              -53.89911426798238,
              -29.98819146769077
            ],
            [
              -53.89701911500031,
              -29.98791378718126
            ],
            [
              -53.89199074784336,
              -29.98337833885934
            ],
            [
              -53.89068127722957,
              -29.98337833885934
            ],
            [
              -53.88722427480916,
              -29.98559978293538
            ],
            [
              -53.884814848879785,
              -29.98559978293538
            ],
            [
              -53.88329586296779,
              -29.987589826586838
            ],
            [
              -53.88099119468752,
              -29.98680306514324
            ],
            [
              -53.87952458760007,
              -29.988422868115354
            ],
            [
              -53.877219919319806,
              -29.9882840278606
            ],
            [
              -53.875910448706016,
              -29.992588075757936
            ],
            [
              -53.87229630981195,
              -29.993421117286452
            ],
            [
              -53.871510627443676,
              -29.99411531856022
            ],
            [
              -53.86920595916341,
              -29.994022758390383
            ],
            [
              -53.8705154297772,
              -29.99541116093791
            ],
            [
              -53.87140586979458,
              -29.998187966032965
            ],
            [
              -53.87250582511016,
              -29.9982805262028
            ],
            [
              -53.87350102277664,
              -30.00077965078835
            ],
            [
              -53.873081992180225,
              -30.003001094864395
            ],
            [
              -53.87350102277664,
              -30.00480601817618
            ],
            [
              -53.87208679451375,
              -30.00480601817618
            ],
            [
              -53.87182490039099,
              -30.007212582591894
            ],
            [
              -53.87282009805747,
              -30.008277024545
            ],
            [
              -53.87250582511016,
              -30.00980426734728
            ],
            [
              -53.87418194749581,
              -30.010405908451208
            ],
            [
              -53.87481049339043,
              -30.011794310998734
            ],
            [
              -53.87601520635512,
              -30.0124885122725
            ],
            [
              -53.87669613107429,
              -30.016190919065906
            ],
            [
              -53.877324676968904,
              -30.016977680509505
            ],
            [
              -53.88141022528393,
              -30.017301641103927
            ],
            [
              -53.88319110531869,
              -30.01781072203802
            ],
            [
              -53.88471009123068,
              -30.022207330105193
            ],
            [
              -53.888324230124745,
              -30.026002297068434
            ],
            [
              -53.88738141128282,
              -30.02840886148415
            ],
            [
              -53.89057651958046,
              -30.030722865730027
            ],
            [
              -53.89057651958046,
              -30.031787307683132
            ],
            [
              -53.889005154843915,
              -30.03377735133459
            ],
            [
              -53.8900003525104,
              -30.03548971447654
            ],
            [
              -53.893195460808045,
              -30.035212033967035
            ],
            [
              -53.893824006702665,
              -30.036878117024067
            ],
            [
              -53.8950810984919,
              -30.037109517448656
            ],
            [
              -53.896495326754795,
              -30.03609135558047
            ],
            [
              -53.89790955501769,
              -30.03650787634473
            ],
            [
              -53.898485722087756,
              -30.040719364072228
            ],
            [
              -53.899795192701546,
              -30.041182164921402
            ],
            [
              -53.90031898094706,
              -30.042292886959427
            ],
            [
              -53.90178558803451,
              -30.043820129761706
            ],
            [
              -53.90419501396388,
              -30.044606891205305
            ],
            [
              -53.90597589399864,
              -30.044421770865636
            ],
            [
              -53.906918712840564,
              -30.045208532309232
            ],
            [
              -53.91011382113821,
              -30.046180414092504
            ],
            [
              -53.907390122261525,
              -30.050206781480334
            ],
            [
              -53.91037571526097,
              -30.052891026405554
            ],
            [
              -53.91011382113821,
              -30.054186868783244
            ],
            [
              -53.90901386582263,
              -30.05529759082127
            ],
            [
              -53.90859483522622,
              -30.057889275576652
            ],
            [
              -53.907599637559734,
              -30.059509078548768
            ],
            [
              -53.90718060696332,
              -30.062378443813657
            ],
            [
              -53.90849007757711,
              -30.063998246785776
            ],
            [
              -53.90681395519146,
              -30.06501640865396
            ],
            [
              -53.90597589399864,
              -30.066219690861818
            ],
            [
              -53.90608065164774,
              -30.06751553323951
            ],
            [
              -53.907390122261525,
              -30.068996495956874
            ],
            [
              -53.910218578787315,
              -30.067978334088686
            ],
            [
              -53.911789943523864,
              -30.069181616296543
            ],
            [
              -53.91252324706758,
              -30.073578224363715
            ],
            [
              -53.91409461180413,
              -30.077188070987287
            ],
            [
              -53.91519456711972,
              -30.08112187820528
            ],
            [
              -53.91561359771613,
              -30.084685444743936
            ],
            [
              -53.91692306832992,
              -30.08709200915965
            ],
            [
              -53.91891346366288,
              -30.088017610858003
            ],
            [
              -53.91980390368026,
              -30.089915094339624
            ],
            [
              -53.92158478371501,
              -30.090007654509456
            ],
            [
              -53.923522800223424,
              -30.088480411707177
            ],
            [
              -53.92687504499472,
              -30.09019277484913
            ],
            [
              -53.92828927325762,
              -30.091997698160913
            ],
            [
              -53.9293892285732,
              -30.094404262576628
            ],
            [
              -53.931693896853474,
              -30.09611662571858
            ],
            [
              -53.93158913920437,
              -30.097088507501848
            ],
            [
              -53.933003367467265,
              -30.097412468096273
            ],
            [
              -53.932793852169056,
              -30.09898599098347
            ],
            [
              -53.931693896853474,
              -30.099819032511988
            ],
            [
              -53.93321288276547,
              -30.101022314719845
            ],
            [
              -53.93310812511636,
              -30.102503277437208
            ],
            [
              -53.93551755104574,
              -30.102179316842783
            ],
            [
              -53.937717461676904,
              -30.10319747871097
            ],
            [
              -53.94049353937814,
              -30.103799119814898
            ],
            [
              -53.94279820765841,
              -30.102179316842783
            ],
            [
              -53.94368864767579,
              -30.102318157097535
            ],
            [
              -53.944474330044066,
              -30.105187522362428
            ],
            [
              -53.9437934053249,
              -30.10629824440045
            ],
            [
              -53.94358389002669,
              -30.108612248646327
            ],
            [
              -53.94127922174641,
              -30.110000651193857
            ],
            [
              -53.94159349469373,
              -30.1122220952699
            ],
            [
              -53.94347913237758,
              -30.113101416883335
            ],
            [
              -53.944579087693164,
              -30.114304699091193
            ],
            [
              -53.947407544218954,
              -30.115785661808555
            ],
            [
              -53.947407544218954,
              -30.11680382367674
            ],
            [
              -53.94599331595606,
              -30.117683145290176
            ],
            [
              -53.94641234655247,
              -30.119210388092455
            ],
            [
              -53.94777419599082,
              -30.119580628771796
            ],
            [
              -53.9488741513064,
              -30.11782198554493
            ],
            [
              -53.95117881958667,
              -30.119580628771796
            ],
            [
              -53.95348348786694,
              -30.12008970970589
            ],
            [
              -53.95599767144542,
              -30.12138555208358
            ],
            [
              -53.958197582076586,
              -30.121478112253417
            ],
            [
              -53.959611810339474,
              -30.12351443598979
            ],
            [
              -53.95741189970831,
              -30.12388467666913
            ],
            [
              -53.954688200831626,
              -30.126383801254683
            ],
            [
              -53.95327397256873,
              -30.125597039811083
            ],
            [
              -53.95217401725315,
              -30.126291241084846
            ],
            [
              -53.9521216384286,
              -30.12990108770842
            ],
            [
              -53.954007276112456,
              -30.13212253178446
            ],
            [
              -53.95458344318252,
              -30.134714216539848
            ],
            [
              -53.95301207844597,
              -30.13850918350309
            ],
            [
              -53.95369300316515,
              -30.14022154664504
            ],
            [
              -53.95578815614721,
              -30.140499227154546
            ],
            [
              -53.95751665735742,
              -30.140082706390288
            ],
            [
              -53.958616612673,
              -30.14119342842831
            ],
            [
              -53.95898326444486,
              -30.143507432674188
            ],
            [
              -53.95751665735742,
              -30.144294194117787
            ],
            [
              -53.95882612797121,
              -30.145312355985975
            ],
            [
              -53.956678596164586,
              -30.147394959807265
            ],
            [
              -53.95772617265562,
              -30.149894084392816
            ],
            [
              -53.95882612797121,
              -30.151791567874437
            ],
            [
              -53.958878506795756,
              -30.155910495432103
            ],
            [
              -53.96139269037423,
              -30.15762285857405
            ],
            [
              -53.96301643393533,
              -30.158178219593065
            ],
            [
              -53.962492645689814,
              -30.160677344178612
            ],
            [
              -53.96280691863713,
              -30.161788066216637
            ],
            [
              -53.96479731397009,
              -30.162297147150728
            ],
            [
              -53.96558299633836,
              -30.16400951029268
            ],
            [
              -53.96652581518029,
              -30.164703711566442
            ],
            [
              -53.96987805995159,
              -30.163685549698258
            ],
            [
              -53.971920834109106,
              -30.165305352670373
            ],
            [
              -53.97118753056538,
              -30.16729539632183
            ],
            [
              -53.97380647179296,
              -30.16937800014312
            ],
            [
              -53.97522070005586,
              -30.169100319633614
            ],
            [
              -53.976215897722334,
              -30.169887081077214
            ],
            [
              -53.97427788121393,
              -30.17187712472867
            ],
            [
              -53.97469691181034,
              -30.17298784676669
            ],
            [
              -53.97448739651213,
              -30.17497789041815
            ],
            [
              -53.97302078942469,
              -30.175810931946664
            ],
            [
              -53.973492198845655,
              -30.17821749636238
            ],
            [
              -53.971920834109106,
              -30.179420778570236
            ],
            [
              -53.97239224353007,
              -30.18238270400496
            ],
            [
              -53.97380647179296,
              -30.184604148081007
            ],
            [
              -53.973911229442066,
              -30.186779312072133
            ],
            [
              -53.97071612114442,
              -30.186779312072133
            ],
            [
              -53.96851621051325,
              -30.185992550628534
            ],
            [
              -53.96720673989946,
              -30.186316511222955
            ],
            [
              -53.96689246695215,
              -30.189000756148175
            ],
            [
              -53.96589726928567,
              -30.191314760394057
            ],
            [
              -53.967101982250355,
              -30.19279572311142
            ],
            [
              -53.969092377583316,
              -30.193999005319277
            ],
            [
              -53.96479731397009,
              -30.196498129904825
            ],
            [
              -53.96327832805809,
              -30.19779397228252
            ],
            [
              -53.96469255632098,
              -30.198395613386445
            ],
            [
              -53.96411638925092,
              -30.200709617632327
            ],
            [
              -53.96060700800596,
              -30.20061705746249
            ],
            [
              -53.95851185502389,
              -30.201079858311665
            ],
            [
              -53.957621415006514,
              -30.203208742217875
            ],
            [
              -53.95652145969093,
              -30.204597144765405
            ],
            [
              -53.954007276112456,
              -30.20561530663359
            ],
            [
              -53.95458344318252,
              -30.20751279011521
            ],
            [
              -53.95898326444486,
              -30.21269615962598
            ],
            [
              -53.96202123626885,
              -30.2145936431076
            ],
            [
              -53.961602205672435,
              -30.215704365145623
            ],
            [
              -53.95971656798858,
              -30.215704365145623
            ],
            [
              -53.95929753739217,
              -30.216491126589222
            ],
            [
              -53.96280691863713,
              -30.22000841304296
            ],
            [
              -53.964483041022774,
              -30.22019353338263
            ],
            [
              -53.965792511636565,
              -30.21829604990101
            ],
            [
              -53.96699722460125,
              -30.218018369391505
            ],
            [
              -53.97590162477503,
              -30.219684452448536
            ],
            [
              -53.98182043194936,
              -30.221581935930157
            ],
            [
              -53.98779161794824,
              -30.225608303317987
            ],
            [
              -53.98800113324645,
              -30.228199988073374
            ],
            [
              -53.986325010860796,
              -30.229680950790737
            ],
            [
              -53.98512029789611,
              -30.234216399112658
            ],
            [
              -53.98742496617638,
              -30.237687405481477
            ],
            [
              -53.98779161794824,
              -30.24051049066145
            ],
            [
              -53.98952011915844,
              -30.243009615247
            ],
            [
              -53.989886770930305,
              -30.24759134365384
            ],
            [
              -53.992977121578846,
              -30.24860950552203
            ],
            [
              -53.99491513808726,
              -30.250090468239392
            ],
            [
              -53.998686413454976,
              -30.249581387305298
            ],
            [
              -54.00051967231428,
              -30.247406223314172
            ],
            [
              -54.00078156643704,
              -30.25240447248527
            ],
            [
              -54.00130535468256,
              -30.253098673759034
            ],
            [
              -54.00067680878794,
              -30.254996157240654
            ],
            [
              -54.003819538261034,
              -30.256708520382606
            ],
            [
              -54.00518138769937,
              -30.25818948309997
            ],
            [
              -54.006281343014955,
              -30.261521649214036
            ],
            [
              -54.00832411717247,
              -30.261521649214036
            ],
            [
              -54.00879552659343,
              -30.25971672590225
            ],
            [
              -54.01010499720722,
              -30.258606003864227
            ],
            [
              -54.0125144231366,
              -30.25911508479832
            ],
            [
              -54.013823893750384,
              -30.261614209383872
            ],
            [
              -54.01387627257494,
              -30.263095172101234
            ],
            [
              -54.01712375969714,
              -30.263789373374998
            ],
            [
              -54.018223715012724,
              -30.26490009541302
            ],
            [
              -54.018014199714514,
              -30.26638105813038
            ],
            [
              -54.01639045615342,
              -30.268278541612002
            ],
            [
              -54.01639045615342,
              -30.269620664074612
            ],
            [
              -54.01497622789052,
              -30.269898344584117
            ],
            [
              -54.01288107490846,
              -30.27198094840541
            ],
            [
              -54.01230490783839,
              -30.274804033585383
            ],
            [
              -54.010890679575496,
              -30.27697919757651
            ],
            [
              -54.00858601129523,
              -30.278784120888297
            ],
            [
              -54.008219359523366,
              -30.280079963265987
            ],
            [
              -54.0061242065413,
              -30.281422085728597
            ],
            [
              -54.00502425122572,
              -30.284013770483984
            ],
            [
              -54.00308623471731,
              -30.28558729337118
            ],
            [
              -54.001619627629864,
              -30.28368980988956
            ],
            [
              -53.99989112641966,
              -30.28540217303151
            ],
            [
              -53.99999588406877,
              -30.28850293872099
            ],
            [
              -54.00088632408614,
              -30.291511144240634
            ],
            [
              -54.00051967231428,
              -30.297203594685495
            ],
            [
              -53.99711504871843,
              -30.29789779595926
            ],
            [
              -53.99229619685968,
              -30.297620115449753
            ],
            [
              -53.99041055917582,
              -30.296787073921237
            ],
            [
              -53.98747734500093,
              -30.297203594685495
            ],
            [
              -53.988524921491965,
              -30.298684557402858
            ],
            [
              -53.98732020852728,
              -30.300304360374973
            ],
            [
              -53.98800113324645,
              -30.30261836462085
            ],
            [
              -53.990305801526716,
              -30.30419188750805
            ],
            [
              -53.9929247427543,
              -30.30789429430146
            ],
            [
              -53.991824787438716,
              -30.309421537103738
            ],
            [
              -53.98952011915844,
              -30.309097576509316
            ],
            [
              -53.98747734500093,
              -30.31057853922668
            ],
            [
              -53.984386994352384,
              -30.31071737948143
            ],
            [
              -53.9847012672997,
              -30.312383462538463
            ],
            [
              -53.98360131198411,
              -30.313309064236815
            ],
            [
              -53.98197756842301,
              -30.312985103642394
            ],
            [
              -53.98229184137032,
              -30.315206547718436
            ],
            [
              -53.98019668838826,
              -30.316780070605635
            ],
            [
              -53.98108712840563,
              -30.318307313407914
            ],
            [
              -53.97852056600261,
              -30.3201122367197
            ],
            [
              -53.97742061068702,
              -30.32719308971209
            ],
            [
              -53.97401598709117,
              -30.32890545285404
            ],
            [
              -53.97359695649476,
              -30.33029385540157
            ],
            [
              -53.971920834109106,
              -30.330988056675334
            ],
            [
              -53.97239224353007,
              -30.332515299477613
            ],
            [
              -53.968201937565944,
              -30.336495386780527
            ],
            [
              -53.96699722460125,
              -30.33718958805429
            ],
            [
              -53.9652163445665,
              -30.336495386780527
            ],
            [
              -53.96432590454912,
              -30.33718958805429
            ],
            [
              -53.96437828337368,
              -30.339781272809674
            ],
            [
              -53.96547823868926,
              -30.342280397395225
            ],
            [
              -53.96762577049587,
              -30.343483679603082
            ],
            [
              -53.96762577049587,
              -30.344594401641103
            ],
            [
              -53.96872572581146,
              -30.34639932495289
            ],
            [
              -53.972811274126485,
              -30.34811168809484
            ],
            [
              -53.97312554707379,
              -30.349592650812205
            ],
            [
              -53.97139704586359,
              -30.353017377096105
            ],
            [
              -53.9717113188109,
              -30.35921890847506
            ],
            [
              -53.966421057531186,
              -30.363106435608138
            ],
            [
              -53.96238788804071,
              -30.36111639195668
            ],
            [
              -53.9587213703221,
              -30.36329155594781
            ],
            [
              -53.95882612797121,
              -30.36421715764616
            ],
            [
              -53.96128793272513,
              -30.366207201297616
            ],
            [
              -53.96118317507602,
              -30.367086522911052
            ],
            [
              -53.9587213703221,
              -30.369307966987094
            ],
            [
              -53.95180736548129,
              -30.37189965174248
            ],
            [
              -53.94992172779743,
              -30.377406981847674
            ],
            [
              -53.95107406193757,
              -30.379304465329295
            ],
            [
              -53.94688375597344,
              -30.38129450898075
            ],
            [
              -53.94531239123689,
              -30.38897700307707
            ],
            [
              -53.94169825234283,
              -30.39281825012523
            ],
            [
              -53.93918406876435,
              -30.394206652672757
            ],
            [
              -53.941174464097315,
              -30.394993414116357
            ],
            [
              -53.94169825234283,
              -30.395780175559956
            ],
            [
              -53.93907931111525,
              -30.398788381079598
            ],
            [
              -53.94059829702724,
              -30.401009825155644
            ],
            [
              -53.93839838639608,
              -30.403601509911027
            ],
            [
              -53.93918406876435,
              -30.40568411373232
            ],
            [
              -53.94127922174641,
              -30.40758159721394
            ],
            [
              -53.941907767641034,
              -30.409988161629656
            ],
            [
              -53.94002212995718,
              -30.41470873029125
            ],
            [
              -53.93818887109787,
              -30.41558805190468
            ],
            [
              -53.93782221932601,
              -30.416698773942706
            ],
            [
              -53.938293628746976,
              -30.41989209980202
            ],
            [
              -53.94038878172904,
              -30.424381268039024
            ],
            [
              -53.956207186743626,
              -30.43331332442812
            ],
            [
              -53.96029273505865,
              -30.43789505283496
            ],
            [
              -53.967782906969525,
              -30.442199100732296
            ],
            [
              -53.96872572581146,
              -30.444096584213916
            ],
            [
              -53.974592154161236,
              -30.443911463874247
            ],
            [
              -53.97312554707379,
              -30.446410588459795
            ],
            [
              -53.97097801526718,
              -30.447197349903394
            ],
            [
              -53.970192332898904,
              -30.449511354149273
            ],
            [
              -53.96888286228511,
              -30.45071463635713
            ],
            [
              -53.966421057531186,
              -30.450899756696803
            ],
            [
              -53.96558299633836,
              -30.452195599074493
            ],
            [
              -53.96060700800596,
              -30.454694723660044
            ],
            [
              -53.96238788804071,
              -30.458119449943943
            ],
            [
              -53.96102603860237,
              -30.462192097416693
            ],
            [
              -53.95898326444486,
              -30.46418214106815
            ],
            [
              -53.96102603860237,
              -30.465107742766502
            ],
            [
              -53.95919277974306,
              -30.471494394485127
            ],
            [
              -53.96118317507602,
              -30.474595160174605
            ],
            [
              -53.961811720970644,
              -30.478482687307682
            ],
            [
              -53.96071176565506,
              -30.48199997376142
            ],
            [
              -53.94557428535965,
              -30.48908082675381
            ],
            [
              -53.924413240240796,
              -30.49042294921642
            ],
            [
              -53.91828491776826,
              -30.49292207380197
            ],
            [
              -53.915089809470615,
              -30.492783233547218
            ],
            [
              -53.907390122261525,
              -30.490191548791834
            ],
            [
              -53.90131417861354,
              -30.48991386828233
            ],
            [
              -53.897123872649416,
              -30.492089032273455
            ],
            [
              -53.89602391733383,
              -30.49579143906686
            ],
            [
              -53.88727665363371,
              -30.49717984161439
            ],
            [
              -53.88287683237138,
              -30.49602283949145
            ],
            [
              -53.880624542915655,
              -30.494403036519333
            ],
            [
              -53.87868652640725,
              -30.488803146244305
            ],
            [
              -53.87182490039099,
              -30.48139833265749
            ],
            [
              -53.865120410848384,
              -30.47917688858145
            ],
            [
              -53.86271098491901,
              -30.477279405099825
            ],
            [
              -53.858887330726745,
              -30.476307523316557
            ],
            [
              -53.854487509464406,
              -30.477510805524414
            ],
            [
              -53.85228759883324,
              -30.47889920807194
            ],
            [
              -53.8509257493949,
              -30.480796691553564
            ],
            [
              -53.84752112579904,
              -30.481490892827328
            ],
            [
              -53.845216457518774,
              -30.483018135629607
            ],
            [
              -53.8428070315894,
              -30.48408257758271
            ],
            [
              -53.836102542046795,
              -30.487877544545952
            ],
            [
              -53.83667870911686,
              -30.488710586074472
            ],
            [
              -53.84139280332651,
              -30.492505553037713
            ],
            [
              -53.84139280332651,
              -30.49347743482098
            ],
            [
              -53.83908813504624,
              -30.496485640340623
            ],
            [
              -53.83500258673121,
              -30.497596362378648
            ],
            [
              -53.83311694904735,
              -30.498614524246833
            ],
            [
              -53.829712325451496,
              -30.501622729766478
            ],
            [
              -53.828402854837705,
              -30.503381372993346
            ],
            [
              -53.82520774654006,
              -30.506482138682824
            ],
            [
              -53.825679155961026,
              -30.50888870309854
            ],
            [
              -53.82578391361013,
              -30.51138782768409
            ],
            [
              -53.82059840997952,
              -30.51749679889321
            ],
            [
              -53.81829374169925,
              -30.51897776161057
            ],
            [
              -53.8167223769627,
              -30.519116601865324
            ],
            [
              -53.81321299571774,
              -30.520088483648593
            ],
            [
              -53.80959885682368,
              -30.51999592347876
            ],
            [
              -53.804518110842174,
              -30.521199205686617
            ],
            [
              -53.794985164773784,
              -30.51842240059156
            ],
            [
              -53.78487605163532,
              -30.51749679889321
            ],
            [
              -53.77738587972445,
              -30.51842240059156
            ],
            [
              -53.76680535716502,
              -30.519579402714502
            ],
            [
              -53.76172461118352,
              -30.51920916203516
            ],
            [
              -53.756696244026564,
              -30.518191000166972
            ],
            [
              -53.75371065102712,
              -30.51671003744961
            ],
            [
              -53.750725058027676,
              -30.5145811535434
            ],
            [
              -53.746115721467135,
              -30.513377871335543
            ],
            [
              -53.74522528144976,
              -30.513701831929968
            ],
            [
              -53.74391581083597,
              -30.51559931541159
            ],
            [
              -53.74512052380066,
              -30.51629351668535
            ],
            [
              -53.74580144851983,
              -30.518792641270903
            ],
            [
              -53.74239682492397,
              -30.523096689168238
            ],
            [
              -53.74197779432756,
              -30.52610489468788
            ],
            [
              -53.746115721467135,
              -30.53050150275505
            ],
            [
              -53.747582328554586,
              -30.531195704028814
            ],
            [
              -53.748996556817474,
              -30.533093187510435
            ],
            [
              -53.74842038974741,
              -30.535222071416644
            ],
            [
              -53.744701493204246,
              -30.53549975192615
            ],
            [
              -53.74292061316949,
              -30.540220320587743
            ],
            [
              -53.73888744367902,
              -30.54170128330511
            ],
            [
              -53.738782686029914,
              -30.545311129928677
            ],
            [
              -53.73668753304785,
              -30.547486293919807
            ],
            [
              -53.73621612362688,
              -30.549013536722086
            ],
            [
              -53.73841603425805,
              -30.54929121723159
            ],
            [
              -53.73831127660895,
              -30.551281260883048
            ],
            [
              -53.73951598957363,
              -30.552808503685327
            ],
            [
              -53.738782686029914,
              -30.554798547336784
            ],
            [
              -53.74040642959101,
              -30.555400188440714
            ],
            [
              -53.73977788369639,
              -30.557112551582662
            ],
            [
              -53.740720702538326,
              -30.562805002027527
            ],
            [
              -53.74040642959101,
              -30.56539668678291
            ],
            [
              -53.73752559424067,
              -30.565905767717005
            ],
            [
              -53.73820651895985,
              -30.569978415189752
            ],
            [
              -53.74197779432756,
              -30.572292419435634
            ],
            [
              -53.748996556817474,
              -30.574606423681512
            ],
            [
              -53.750515542729474,
              -30.576781587672638
            ],
            [
              -53.753815408676225,
              -30.57770718937099
            ],
            [
              -53.75187739216781,
              -30.579882353362116
            ],
            [
              -53.753605893378015,
              -30.58289055888176
            ],
            [
              -53.75538677341277,
              -30.582612878372252
            ],
            [
              -53.758424745236766,
              -30.585898764401403
            ],
            [
              -53.75831998758766,
              -30.588397888986954
            ],
            [
              -53.75921042760504,
              -30.588814409751212
            ],
            [
              -53.7628245664991,
              -30.587379727118766
            ],
            [
              -53.76308646062186,
              -30.589878851704317
            ],
            [
              -53.76518161360392,
              -30.593396138158052
            ],
            [
              -53.7676957971824,
              -30.593396138158052
            ],
            [
              -53.76900526779619,
              -30.597700186055388
            ],
            [
              -53.7740860137777,
              -30.599319989027503
            ],
            [
              -53.774609802023214,
              -30.600893511914702
            ],
            [
              -53.774190771426795,
              -30.60399427760418
            ],
            [
              -53.77277654316391,
              -30.60607688142547
            ],
            [
              -53.77298605846211,
              -30.6066785225294
            ],
            [
              -53.77560499968969,
              -30.60778924456742
            ],
            [
              -53.778590592689135,
              -30.60778924456742
            ],
            [
              -53.78047623037299,
              -30.60649340218973
            ],
            [
              -53.78560935517905,
              -30.606400842019895
            ],
            [
              -53.78702358344194,
              -30.607095043293658
            ],
            [
              -53.78670931049463,
              -30.608113205161846
            ],
            [
              -53.77979530565382,
              -30.613805655606708
            ],
            [
              -53.777700152671756,
              -30.614684977220143
            ],
            [
              -53.777490637373546,
              -30.616998981466022
            ],
            [
              -53.782519004530506,
              -30.618803904777806
            ],
            [
              -53.782519004530506,
              -30.620377427665005
            ],
            [
              -53.78152380686402,
              -30.6208865085991
            ],
            [
              -53.77492407497052,
              -30.620192307325336
            ],
            [
              -53.774819317321416,
              -30.622321191231542
            ],
            [
              -53.77848583504003,
              -30.624588915392504
            ],
            [
              -53.78209997393409,
              -30.623709593779072
            ],
            [
              -53.783304686898774,
              -30.625884757770198
            ],
            [
              -53.78309517160057,
              -30.62792108150657
            ],
            [
              -53.779481032706514,
              -30.627689681081986
            ],
            [
              -53.778590592689135,
              -30.6285227226105
            ],
            [
              -53.77911438093465,
              -30.62981856498819
            ],
            [
              -53.78021433625023,
              -30.629911125158028
            ],
            [
              -53.78340944454788,
              -30.6293094840541
            ],
            [
              -53.785190324582636,
              -30.6285227226105
            ],
            [
              -53.78649979519643,
              -30.630096245497697
            ],
            [
              -53.7889092211258,
              -30.629078083629512
            ],
            [
              -53.79220908707255,
              -30.63217884931899
            ],
            [
              -53.793623315335445,
              -30.631299527705554
            ],
            [
              -53.793413800037236,
              -30.62949460439377
            ],
            [
              -53.79189481412524,
              -30.625005436156766
            ],
            [
              -53.79268049649352,
              -30.623617033609236
            ],
            [
              -53.8021086849128,
              -30.627319440402644
            ],
            [
              -53.800275426053496,
              -30.628985523459676
            ],
            [
              -53.79781362129957,
              -30.627689681081986
            ],
            [
              -53.796085120089366,
              -30.628800403120007
            ],
            [
              -53.79838978836964,
              -30.630883006941296
            ],
            [
              -53.80368004964935,
              -30.633011890847506
            ],
            [
              -53.801794411965496,
              -30.6343077332252
            ],
            [
              -53.79912309191336,
              -30.635511015433057
            ],
            [
              -53.79838978836964,
              -30.638611781122535
            ],
            [
              -53.795613710668405,
              -30.63921342222646
            ],
            [
              -53.794094724756405,
              -30.636899417980583
            ],
            [
              -53.79257573884441,
              -30.63731593874484
            ],
            [
              -53.791475783528824,
              -30.6385192209527
            ],
            [
              -53.78828067523118,
              -30.638010140018608
            ],
            [
              -53.787494992862904,
              -30.638796901462204
            ],
            [
              -53.78828067523118,
              -30.64189766715168
            ],
            [
              -53.79158054117793,
              -30.642776988765117
            ],
            [
              -53.79598036244027,
              -30.642221627746107
            ],
            [
              -53.797604106001366,
              -30.64328606969921
            ],
            [
              -53.798285030720535,
              -30.647219876917205
            ],
            [
              -53.800275426053496,
              -30.648793399804404
            ],
            [
              -53.79802313659778,
              -30.65198672566372
            ],
            [
              -53.80100872959722,
              -30.655920532881712
            ],
            [
              -53.80058969900081,
              -30.65730893542924
            ],
            [
              -53.79880881896605,
              -30.66017830069413
            ],
            [
              -53.799804016632535,
              -30.662908825704267
            ],
            [
              -53.79870406131695,
              -30.665685630799324
            ],
            [
              -53.79529943772109,
              -30.669619438017317
            ],
            [
              -53.794723270651026,
              -30.671285521074353
            ],
            [
              -53.797394590703156,
              -30.671516921498938
            ],
            [
              -53.79838978836964,
              -30.674617687188416
            ],
            [
              -53.798075515422326,
              -30.67628377024545
            ],
            [
              -53.794094724756405,
              -30.67609864990578
            ],
            [
              -53.79440899770372,
              -30.679199415595257
            ],
            [
              -53.795404195370196,
              -30.68049525797295
            ],
            [
              -53.79639939303668,
              -30.684706745700453
            ],
            [
              -53.79791837894867,
              -30.68549350714405
            ],
            [
              -53.80132300254453,
              -30.6829943825585
            ],
            [
              -53.80258009433377,
              -30.683318343152923
            ],
            [
              -53.80299912493018,
              -30.68489186604012
            ],
            [
              -53.80268485198287,
              -30.686789349521742
            ],
            [
              -53.80121824489542,
              -30.687900071559763
            ],
            [
              -53.79749934835226,
              -30.68891823342795
            ],
            [
              -53.796975560106745,
              -30.68951987453188
            ],
            [
              -53.79749934835226,
              -30.69470324404265
            ],
            [
              -53.796294635387575,
              -30.695999086420343
            ],
            [
              -53.797394590703156,
              -30.698914731770152
            ],
            [
              -53.799804016632535,
              -30.699794053383584
            ],
            [
              -53.80100872959722,
              -30.70118245593111
            ],
            [
              -53.79728983305406,
              -30.705717904253035
            ],
            [
              -53.797604106001366,
              -30.7064121055268
            ],
            [
              -53.80299912493018,
              -30.709003790282186
            ],
            [
              -53.80561806615776,
              -30.711502914867733
            ],
            [
              -53.80708467324521,
              -30.711502914867733
            ],
            [
              -53.807975113262586,
              -30.709790551725785
            ],
            [
              -53.81080356978837,
              -30.709512871216276
            ],
            [
              -53.81247969217402,
              -30.710114512320207
            ],
            [
              -53.81258444982313,
              -30.713215278009685
            ],
            [
              -53.81378916278781,
              -30.714418560217542
            ],
            [
              -53.81300348041954,
              -30.71580696276507
            ],
            [
              -53.81342251101595,
              -30.71788956658636
            ],
            [
              -53.81127497920934,
              -30.720111010662407
            ],
            [
              -53.807398946192514,
              -30.72251757507812
            ],
            [
              -53.80509427791225,
              -30.72580346110727
            ],
            [
              -53.80388956494756,
              -30.729181907306252
            ],
            [
              -53.80619423322783,
              -30.731218231042625
            ],
            [
              -53.808394143859,
              -30.73149591155213
            ],
            [
              -53.808917932104514,
              -30.73330083486392
            ],
            [
              -53.81300348041954,
              -30.735799959449466
            ],
            [
              -53.81452246633153,
              -30.738113963695348
            ],
            [
              -53.81771757462918,
              -30.738900725138947
            ],
            [
              -53.818188984050146,
              -30.739409806073038
            ],
            [
              -53.81719378638367,
              -30.741307289554662
            ],
            [
              -53.81630334636629,
              -30.744222934904467
            ],
            [
              -53.82059840997952,
              -30.746907179829687
            ],
            [
              -53.821488849996896,
              -30.748897223481144
            ],
            [
              -53.82091268292683,
              -30.751396348066695
            ],
            [
              -53.81897466641842,
              -30.752507070104716
            ],
            [
              -53.81562242164712,
              -30.753108711208647
            ],
            [
              -53.814889118103395,
              -30.758199520549578
            ],
            [
              -53.81389392043691,
              -30.76028212437087
            ],
            [
              -53.8101226450692,
              -30.762688688786586
            ],
            [
              -53.80572282380686,
              -30.762920089211175
            ],
            [
              -53.8035229131757,
              -30.76528037354197
            ],
            [
              -53.80629899087693,
              -30.76740925744818
            ],
            [
              -53.80661326382424,
              -30.768381139231447
            ],
            [
              -53.80430859554397,
              -30.77578595281826
            ],
            [
              -53.80629899087693,
              -30.781293282923457
            ],
            [
              -53.80488476261404,
              -30.785088249886698
            ],
            [
              -53.80519903556135,
              -30.78791133506667
            ],
            [
              -53.80242295786012,
              -30.788605536340434
            ],
            [
              -53.799594501334326,
              -30.789716258378455
            ],
            [
              -53.79660890833488,
              -30.79212282279417
            ],
            [
              -53.792104329423445,
              -30.793002144407605
            ],
            [
              -53.787914023459315,
              -30.798509474512798
            ],
            [
              -53.78550459752994,
              -30.799897877060324
            ],
            [
              -53.78398561161795,
              -30.79962019655082
            ],
            [
              -53.782780898653265,
              -30.79827807408821
            ],
            [
              -53.77911438093465,
              -30.79749131264461
            ],
            [
              -53.772409891392044,
              -30.799712756720655
            ],
            [
              -53.76848147955067,
              -30.797815273239035
            ],
            [
              -53.7692147830944,
              -30.794899627889226
            ],
            [
              -53.76911002544529,
              -30.792817024067936
            ],
            [
              -53.76837672190157,
              -30.78888321684994
            ],
            [
              -53.76308646062186,
              -30.7843014884431
            ],
            [
              -53.76240553590269,
              -30.782913085895572
            ],
            [
              -53.762876945323654,
              -30.778886718507742
            ],
            [
              -53.76078179234159,
              -30.776109913412686
            ],
            [
              -53.75769144169304,
              -30.774999191374665
            ],
            [
              -53.7529773474834,
              -30.777313195620543
            ],
            [
              -53.75062030037858,
              -30.77740575579038
            ],
            [
              -53.74852514739651,
              -30.776202473582522
            ],
            [
              -53.747582328554586,
              -30.77449011044057
            ],
            [
              -53.74732043443183,
              -30.77259262695895
            ],
            [
              -53.74527766027431,
              -30.772685187128783
            ],
            [
              -53.742711097871286,
              -30.775091751544497
            ],
            [
              -53.739882641345496,
              -30.775878512988097
            ],
            [
              -53.736792290696954,
              -30.77948835961167
            ],
            [
              -53.735220925960405,
              -30.782820525725736
            ],
            [
              -53.737001805995156,
              -30.78369984733917
            ],
            [
              -53.736111365977784,
              -30.785088249886698
            ],
            [
              -53.73281150003103,
              -30.783607287169335
            ],
            [
              -53.72877833054056,
              -30.786291532094555
            ],
            [
              -53.72652604108484,
              -30.786522932519144
            ],
            [
              -53.72500705517284,
              -30.78791133506667
            ],
            [
              -53.72170718922609,
              -30.78791133506667
            ],
            [
              -53.71919300564761,
              -30.790919540586312
            ],
            [
              -53.718878732700304,
              -30.793002144407605
            ],
            [
              -53.71348371377149,
              -30.798185513918376
            ],
            [
              -53.707093497176196,
              -30.801101159268182
            ],
            [
              -53.705784026562405,
              -30.80859853302483
            ],
            [
              -53.702222266492896,
              -30.81248606015791
            ],
            [
              -53.70112231117731,
              -30.815910786441812
            ],
            [
              -53.69991759821262,
              -30.81628102712115
            ],
            [
              -53.69048940979334,
              -30.81419842329986
            ],
            [
              -53.689179939179546,
              -30.812902580922167
            ],
            [
              -53.6859848308819,
              -30.811976979223815
            ],
            [
              -53.68451822379445,
              -30.812717460582498
            ],
            [
              -53.684308708496246,
              -30.813920742790355
            ],
            [
              -53.687189543846586,
              -30.815910786441812
            ],
            [
              -53.688603772109474,
              -30.82067763518832
            ],
            [
              -53.69027989449513,
              -30.822389998330273
            ],
            [
              -53.69101319803885,
              -30.82590728478401
            ],
            [
              -53.68839425681127,
              -30.82470400257615
            ],
            [
              -53.683680162601625,
              -30.829609691577417
            ],
            [
              -53.68137549432136,
              -30.833312098370822
            ],
            [
              -53.680118402532116,
              -30.835718662786537
            ],
            [
              -53.676399505988954,
              -30.837107065334067
            ],
            [
              -53.67278536709489,
              -30.83988387042912
            ],
            [
              -53.67210444237572,
              -30.840994592467144
            ],
            [
              -53.67241871532303,
              -30.842290434844834
            ],
            [
              -53.66718083286787,
              -30.842706955609092
            ],
            [
              -53.666604665797806,
              -30.842105314505165
            ],
            [
              -53.66351431514926,
              -30.84279951577893
            ],
            [
              -53.66210008688636,
              -30.842290434844834
            ],
            [
              -53.6601096915534,
              -30.839421069579945
            ],
            [
              -53.65770026562403,
              -30.83858802805143
            ],
            [
              -53.652305246695214,
              -30.84048551153305
            ],
            [
              -53.65151956432694,
              -30.848584526393626
            ],
            [
              -53.65209573139701,
              -30.854600937432913
            ],
            [
              -53.65110053373053,
              -30.857609142952555
            ],
            [
              -53.6517814584497,
              -30.862422271783984
            ],
            [
              -53.65261951964253,
              -30.864180915010852
            ],
            [
              -53.659585903307885,
              -30.866494919256734
            ],
            [
              -53.660423964500715,
              -30.871493168427833
            ],
            [
              -53.65728123502762,
              -30.87269645063569
            ],
            [
              -53.65241000434432,
              -30.87269645063569
            ],
            [
              -53.64722450071371,
              -30.869179164181954
            ],
            [
              -53.64020573822379,
              -30.868716363332776
            ],
            [
              -53.63601543225967,
              -30.867605641294755
            ],
            [
              -53.62931094271706,
              -30.866818879851156
            ],
            [
              -53.62512063675293,
              -30.866911440020992
            ],
            [
              -53.623287377893625,
              -30.86598583832264
            ],
            [
              -53.620406542543286,
              -30.86269995229349
            ],
            [
              -53.617316191894744,
              -30.862422271783984
            ],
            [
              -53.61490676596537,
              -30.86408835484102
            ],
            [
              -53.61239258238689,
              -30.864180915010852
            ],
            [
              -53.61008791410662,
              -30.863579273906925
            ],
            [
              -53.60799276112456,
              -30.86098758915154
            ],
            [
              -53.60741659405449,
              -30.85770170312239
            ],
            [
              -53.606683290510766,
              -30.855711659470934
            ],
            [
              -53.605373819896975,
              -30.855110018367007
            ],
            [
              -53.602912015143055,
              -30.856683541254206
            ],
            [
              -53.60060734686278,
              -30.85770170312239
            ],
            [
              -53.599402633898094,
              -30.859876867113517
            ],
            [
              -53.5995073915472,
              -30.861820630680057
            ],
            [
              -53.602021575125676,
              -30.867605641294755
            ],
            [
              -53.602283469248434,
              -30.87158572859767
            ],
            [
              -53.600921619810094,
              -30.876306297259262
            ],
            [
              -53.60107875628375,
              -30.878712861674977
            ],
            [
              -53.60029307391547,
              -30.880610345156597
            ],
            [
              -53.597883647986095,
              -30.88310946974215
            ],
            [
              -53.597778890337,
              -30.88459043245951
            ],
            [
              -53.598721709178925,
              -30.886580476110964
            ],
            [
              -53.60547857754608,
              -30.894309250292203
            ],
            [
              -53.609092716440145,
              -30.8958827731794
            ],
            [
              -53.60987839880841,
              -30.897687696491186
            ],
            [
              -53.60940698938745,
              -30.898890978699043
            ],
            [
              -53.60788800347545,
              -30.899492619802974
            ],
            [
              -53.602912015143055,
              -30.896715814707918
            ],
            [
              -53.59641704089865,
              -30.896715814707918
            ],
            [
              -53.59259338670638,
              -30.89551253250006
            ],
            [
              -53.58882211133867,
              -30.895605092669896
            ],
            [
              -53.58798405014584,
              -30.896715814707918
            ],
            [
              -53.58882211133867,
              -30.898613298189538
            ],
            [
              -53.5899744454788,
              -30.899492619802974
            ],
            [
              -53.593902857320174,
              -30.89921493929347
            ],
            [
              -53.595212327933965,
              -30.89990914056723
            ],
            [
              -53.59547422205672,
              -30.901297543114758
            ],
            [
              -53.59468853968845,
              -30.90277850583212
            ],
            [
              -53.589607793706946,
              -30.906712313050114
            ],
            [
              -53.58939827840874,
              -30.908008155427808
            ],
            [
              -53.59049823372432,
              -30.909211437635665
            ],
            [
              -53.59259338670638,
              -30.90948911814517
            ],
            [
              -53.597202723266925,
              -30.9093039978055
            ],
            [
              -53.5979884056352,
              -30.909998199079265
            ],
            [
              -53.60149778688016,
              -30.91888397538344
            ],
            [
              -53.60060734686278,
              -30.920179817761134
            ],
            [
              -53.59007920312791,
              -30.92480782625289
            ],
            [
              -53.5864126854093,
              -30.923604544045034
            ],
            [
              -53.58038912058586,
              -30.9193004961477
            ],
            [
              -53.57871299820021,
              -30.91138660162679
            ],
            [
              -53.577508285235524,
              -30.90911887746583
            ],
            [
              -53.57378938869236,
              -30.908008155427808
            ],
            [
              -53.5720085086576,
              -30.9093039978055
            ],
            [
              -53.56918005213182,
              -30.913006404598907
            ],
            [
              -53.565984943834174,
              -30.915598089354294
            ],
            [
              -53.56268507788742,
              -30.92179962073325
            ],
            [
              -53.56399454850121,
              -30.925502027526658
            ],
            [
              -53.56629921678148,
              -30.929713515254157
            ],
            [
              -53.563575517904795,
              -30.931610998735778
            ],
            [
              -53.56079944020356,
              -30.932120079669872
            ],
            [
              -53.559385211940665,
              -30.931610998735778
            ],
            [
              -53.55660913423944,
              -30.928186272451878
            ],
            [
              -53.55498539067833,
              -30.926705309734515
            ],
            [
              -53.55241882827531,
              -30.92601110846075
            ],
            [
              -53.54890944703035,
              -30.92559458769649
            ],
            [
              -53.5441953528207,
              -30.926520189394843
            ],
            [
              -53.54278112455781,
              -30.92739951100828
            ],
            [
              -53.54267636690871,
              -30.930500276697757
            ],
            [
              -53.54639526345187,
              -30.9335084822174
            ],
            [
              -53.549799887047726,
              -30.93420268349116
            ],
            [
              -53.55362354123999,
              -30.933601042387235
            ],
            [
              -53.5588090448706,
              -30.934804324595092
            ],
            [
              -53.560275651958044,
              -30.936100166972786
            ],
            [
              -53.560904197852665,
              -30.937581129690148
            ],
            [
              -53.5588090448706,
              -30.941422376738306
            ],
            [
              -53.55729005895861,
              -30.94230169835174
            ],
            [
              -53.553414025941784,
              -30.940311654700285
            ],
            [
              -53.547180945820145,
              -30.940681895379626
            ],
            [
              -53.54440486811891,
              -30.939200932662263
            ],
            [
              -53.53937650096196,
              -30.937581129690148
            ],
            [
              -53.536809938558925,
              -30.938414171218664
            ],
            [
              -53.53178157140197,
              -30.94308845979534
            ],
            [
              -53.53178157140197,
              -30.94461570259762
            ],
            [
              -53.533405314963076,
              -30.946698306418913
            ],
            [
              -53.53670518090983,
              -30.947809028456934
            ],
            [
              -53.54377632222429,
              -30.946698306418913
            ],
            [
              -53.54618574815366,
              -30.948503229730697
            ],
            [
              -53.546080990504564,
              -30.94979907210839
            ],
            [
              -53.54508579283808,
              -30.951603995420175
            ],
            [
              -53.54220495748774,
              -30.95368659924147
            ],
            [
              -53.53728134797989,
              -30.953594039071632
            ],
            [
              -53.53319579966487,
              -30.952622157288364
            ],
            [
              -53.52848170545522,
              -30.953594039071632
            ],
            [
              -53.527276992490535,
              -30.953408918731963
            ],
            [
              -53.5261246583504,
              -30.95188167592968
            ],
            [
              -53.52617703717495,
              -30.950493273382154
            ],
            [
              -53.528376947806116,
              -30.945309903871383
            ],
            [
              -53.52581038540309,
              -30.94230169835174
            ],
            [
              -53.52319144417551,
              -30.941098416143884
            ],
            [
              -53.5228771712282,
              -30.940496775039954
            ],
            [
              -53.521777215912614,
              -30.93522084535935
            ],
            [
              -53.52052012412338,
              -30.934017563151492
            ],
            [
              -53.51858210761497,
              -30.93420268349116
            ],
            [
              -53.516905985229315,
              -30.93522084535935
            ],
            [
              -53.515491756966426,
              -30.937812530114734
            ],
            [
              -53.51439180165084,
              -30.942579378861247
            ],
            [
              -53.512191891019675,
              -30.944199181833362
            ],
            [
              -53.51062052628313,
              -30.944014061493693
            ],
            [
              -53.509311055669336,
              -30.942810779285836
            ],
            [
              -53.50821110035375,
              -30.94058933520979
            ],
            [
              -53.50679687209086,
              -30.93901581232259
            ],
            [
              -53.504020794389625,
              -30.939200932662263
            ],
            [
              -53.50218753553032,
              -30.939895133936027
            ],
            [
              -53.50171612610935,
              -30.94082073563438
            ],
            [
              -53.50197802023211,
              -30.945078503446794
            ],
            [
              -53.50360176379321,
              -30.950123032702813
            ],
            [
              -53.502711323775834,
              -30.953084958137538
            ],
            [
              -53.500511413144665,
              -30.95572292297784
            ],
            [
              -53.4966877589524,
              -30.96150793359254
            ],
            [
              -53.49338789300565,
              -30.960998852658445
            ],
            [
              -53.490088027058896,
              -30.95859228824273
            ],
            [
              -53.48841190467324,
              -30.95780552679913
            ],
            [
              -53.48338353751629,
              -30.95687992510078
            ],
            [
              -53.48228358220071,
              -30.9577129666293
            ],
            [
              -53.4821788245516,
              -30.95961045011092
            ],
            [
              -53.4835930528145,
              -30.96169305393221
            ],
            [
              -53.4820740669025,
              -30.967292944207237
            ],
            [
              -53.479874156271336,
              -30.968496226415095
            ],
            [
              -53.475002925588036,
              -30.966598742933474
            ],
            [
              -53.47390297027245,
              -30.961785614102045
            ],
            [
              -53.470393589027495,
              -30.956417124251605
            ],
            [
              -53.47028883137839,
              -30.95558408272309
            ],
            [
              -53.47542195618445,
              -30.95401055983589
            ],
            [
              -53.47751710916651,
              -30.95188167592968
            ],
            [
              -53.47652191150003,
              -30.949891632278224
            ],
            [
              -53.469974558431076,
              -30.948595789900534
            ],
            [
              -53.466203283063365,
              -30.945680144550725
            ],
            [
              -53.46347958418668,
              -30.944476862342867
            ],
            [
              -53.46101777943276,
              -30.94461570259762
            ],
            [
              -53.45661795817042,
              -30.945911544975313
            ],
            [
              -53.45698460994228,
              -30.94808670896644
            ],
            [
              -53.460703506485444,
              -30.94979907210839
            ],
            [
              -53.464003372432195,
              -30.95438080051523
            ],
            [
              -53.46379385713399,
              -30.956185723827016
            ],
            [
              -53.463112932414816,
              -30.957203885695204
            ],
            [
              -53.4559894122758,
              -30.957620406459462
            ],
            [
              -53.454522805188354,
              -30.95998069079026
            ],
            [
              -53.45478469931111,
              -30.96150793359254
            ],
            [
              -53.454679941662015,
              -30.966598742933474
            ],
            [
              -53.452480031030845,
              -30.96821854590559
            ],
            [
              -53.451118181592506,
              -30.96821854590559
            ],
            [
              -53.44310422143611,
              -30.96419217851776
            ],
            [
              -53.442789948488794,
              -30.964793819621686
            ],
            [
              -53.43980435548936,
              -30.964701259451854
            ],
            [
              -53.43561404952523,
              -30.960304651384682
            ],
            [
              -53.433885548315025,
              -30.959517889941083
            ],
            [
              -53.43278559299944,
              -30.96039721155452
            ],
            [
              -53.43158088003475,
              -30.96359053741383
            ],
            [
              -53.4298,
              -30.96710782386757
            ],
            [
              -53.43220942592937,
              -30.967894585311168
            ],
            [
              -53.43378079066592,
              -30.969977189132457
            ],
            [
              -53.43399030596413,
              -30.971180471340315
            ],
            [
              -53.432523698876686,
              -30.97529939889798
            ],
            [
              -53.43278559299944,
              -30.976317560766166
            ],
            [
              -53.4362949742444,
              -30.977289442549438
            ],
            [
              -53.438809157822874,
              -30.976919201870096
            ],
            [
              -53.441218583752246,
              -30.974003556520287
            ],
            [
              -53.44781831564575,
              -30.972106073038667
            ],
            [
              -53.44771355799665,
              -30.975391959067814
            ],
            [
              -53.449180165084094,
              -30.978307604417623
            ],
            [
              -53.45001822627692,
              -30.981778610786442
            ],
            [
              -53.44860399801402,
              -30.982611652314958
            ],
            [
              -53.44661360268106,
              -30.980019967559574
            ],
            [
              -53.444518449699004,
              -30.97951088662548
            ],
            [
              -53.441375720225906,
              -30.980019967559574
            ],
            [
              -53.44608981443555,
              -30.98599009851394
            ],
            [
              -53.44588029913734,
              -30.987980142165398
            ],
            [
              -53.44357563085707,
              -30.988211542589987
            ],
            [
              -53.44179475082232,
              -30.986499179448035
            ],
            [
              -53.43749968720908,
              -30.98511077690051
            ],
            [
              -53.43660924719171,
              -30.98760990148606
            ],
            [
              -53.438075854279155,
              -30.992099069723064
            ],
            [
              -53.43928056724384,
              -30.992006509553228
            ],
            [
              -53.44467558617266,
              -30.99260815065716
            ],
            [
              -53.44729452740024,
              -30.991682548958806
            ],
            [
              -53.45059439334699,
              -30.995708916346636
            ],
            [
              -53.457822671135105,
              -30.993996553204685
            ],
            [
              -53.45881786880159,
              -30.995477515922047
            ],
            [
              -53.455203729907524,
              -30.998022920592515
            ],
            [
              -53.45420853224105,
              -30.99908736254562
            ],
            [
              -53.45321333457457,
              -31.002095568065265
            ],
            [
              -53.45080390864519,
              -31.00501121341507
            ],
            [
              -53.4510134239434,
              -31.005890535028506
            ],
            [
              -53.452689546329054,
              -31.006492176132433
            ],
            [
              -53.4560941699249,
              -31.00579797485867
            ],
            [
              -53.4575083981878,
              -31.006214495622928
            ],
            [
              -53.46347958418668,
              -31.01311022827565
            ],
            [
              -53.46300817476572,
              -31.01389698971925
            ],
            [
              -53.45829408055607,
              -31.016396114304797
            ],
            [
              -53.45567513932849,
              -31.01630355413496
            ],
            [
              -53.45300381927636,
              -31.01440607065334
            ],
            [
              -53.45232289455719,
              -31.01250858717172
            ],
            [
              -53.45148483336436,
              -31.012184626577298
            ],
            [
              -53.448918270961336,
              -31.013017668105814
            ],
            [
              -53.44608981443555,
              -31.014915151587434
            ],
            [
              -53.44661360268106,
              -31.016210993965128
            ],
            [
              -53.45069915099609,
              -31.01658123464447
            ],
            [
              -53.45488945696022,
              -31.02000596092837
            ],
            [
              -53.45892262645069,
              -31.022181124919495
            ],
            [
              -53.4624843865202,
              -31.022412525344084
            ],
            [
              -53.465993767765156,
              -31.018201037616585
            ],
            [
              -53.46761751132626,
              -31.018015917276912
            ],
            [
              -53.46960790665922,
              -31.01958944016411
            ],
            [
              -53.46829843604543,
              -31.020977842711638
            ],
            [
              -53.4641081300813,
              -31.023106726617847
            ],
            [
              -53.460703506485444,
              -31.027595894854855
            ],
            [
              -53.46368909948489,
              -31.029123137657134
            ],
            [
              -53.468403193694535,
              -31.02518933043914
            ],
            [
              -53.47007931608018,
              -31.026114932137492
            ],
            [
              -53.47191257493949,
              -31.025513291033562
            ],
            [
              -53.47049834667659,
              -31.028104975788946
            ],
            [
              -53.471493544343076,
              -31.03208506309186
            ],
            [
              -53.473483939676036,
              -31.03268670419579
            ],
            [
              -53.475893365605415,
              -31.029123137657134
            ],
            [
              -53.475683850307206,
              -31.02750333468502
            ],
            [
              -53.47819803388568,
              -31.02708681392076
            ],
            [
              -53.479297989201264,
              -31.028012415619113
            ],
            [
              -53.48170741513064,
              -31.026809133411255
            ],
            [
              -53.48270261279712,
              -31.027919855449277
            ],
            [
              -53.48039794451685,
              -31.030604100374497
            ],
            [
              -53.4787218221312,
              -31.03111318130859
            ],
            [
              -53.47652191150003,
              -31.033288345299717
            ],
            [
              -53.481288384534224,
              -31.035185828781337
            ],
            [
              -53.485216796375596,
              -31.03458418767741
            ],
            [
              -53.489407102339726,
              -31.035602349545595
            ],
            [
              -53.49082133060262,
              -31.037499833027216
            ],
            [
              -53.48930234469062,
              -31.038703115235073
            ],
            [
              -53.48427397753367,
              -31.03800891396131
            ],
            [
              -53.48401208341091,
              -31.039119635999334
            ],
            [
              -53.485216796375596,
              -31.039998957612767
            ],
            [
              -53.48647388816484,
              -31.04740377119958
            ],
            [
              -53.48422159870912,
              -31.047496331369416
            ],
            [
              -53.48160265748154,
              -31.044812086444196
            ],
            [
              -53.479874156271336,
              -31.045598847887796
            ],
            [
              -53.480816975113264,
              -31.046802130095653
            ],
            [
              -53.48008367156954,
              -31.049810335615295
            ],
            [
              -53.47788376093837,
              -31.05379042291821
            ],
            [
              -53.47510768323714,
              -31.054577184361808
            ],
            [
              -53.474374379693415,
              -31.05550278606016
            ],
            [
              -53.47510768323714,
              -31.058603551749638
            ],
            [
              -53.47830279153479,
              -31.060084514467
            ],
            [
              -53.48181217277974,
              -31.06031591489159
            ],
            [
              -53.484797765779184,
              -31.057909350475875
            ],
            [
              -53.48689291876125,
              -31.057122589032275
            ],
            [
              -53.487888116427726,
              -31.057909350475875
            ],
            [
              -53.488307147024145,
              -31.059390313193237
            ],
            [
              -53.487207191708556,
              -31.060084514467
            ],
            [
              -53.48647388816484,
              -31.063416680581067
            ],
            [
              -53.48181217277974,
              -31.06522160389285
            ],
            [
              -53.479297989201264,
              -31.06790584881807
            ],
            [
              -53.47919323155216,
              -31.06887773060134
            ],
            [
              -53.48139314218333,
              -31.07059009374329
            ],
            [
              -53.48689291876125,
              -31.070312413233786
            ],
            [
              -53.487888116427726,
              -31.07392225985736
            ],
            [
              -53.489616617637935,
              -31.077208145886505
            ],
            [
              -53.48778335877863,
              -31.079522150132387
            ],
            [
              -53.48448349283188,
              -31.080910552679914
            ],
            [
              -53.4835930528145,
              -31.080679152255325
            ],
            [
              -53.47950750449947,
              -31.08308571667104
            ],
            [
              -53.47578860795631,
              -31.083918758199555
            ],
            [
              -53.474583894991625,
              -31.085399720916918
            ],
            [
              -53.47489816793893,
              -31.08961120864442
            ],
            [
              -53.47809327623658,
              -31.091601252295877
            ],
            [
              -53.47908847390306,
              -31.09039797008802
            ],
            [
              -53.47851230683299,
              -31.08868560694607
            ],
            [
              -53.4820740669025,
              -31.086417882785106
            ],
            [
              -53.48270261279712,
              -31.08521460057725
            ],
            [
              -53.48568820579656,
              -31.083779917944803
            ],
            [
              -53.486578645813935,
              -31.084103878539228
            ],
            [
              -53.487207191708556,
              -31.08789884550247
            ],
            [
              -53.48579296344566,
              -31.09072193068244
            ],
            [
              -53.48647388816484,
              -31.097016022231234
            ],
            [
              -53.48270261279712,
              -31.100810989194475
            ],
            [
              -53.48270261279712,
              -31.102615912506263
            ],
            [
              -53.48448349283188,
              -31.102291951911837
            ],
            [
              -53.485478690498354,
              -31.10280103284593
            ],
            [
              -53.487678601129524,
              -31.102014271402332
            ],
            [
              -53.48930234469062,
              -31.103402673949862
            ],
            [
              -53.492078422391856,
              -31.10418943539346
            ],
            [
              -53.49600683423323,
              -31.104096875223625
            ],
            [
              -53.4966877589524,
              -31.106086918875082
            ],
            [
              -53.49532590951406,
              -31.10650343963934
            ],
            [
              -53.493021241233784,
              -31.112010769744533
            ],
            [
              -53.491607012970896,
              -31.11210332991437
            ],
            [
              -53.48778335877863,
              -31.11048352694225
            ],
            [
              -53.48600247874387,
              -31.11108516804618
            ],
            [
              -53.48537393284925,
              -31.112704971018296
            ],
            [
              -53.48238833984981,
              -31.112704971018296
            ],
            [
              -53.48050270216595,
              -31.11358429263173
            ],
            [
              -53.48107886923602,
              -31.115620616368105
            ],
            [
              -53.48270261279712,
              -31.116314817641868
            ],
            [
              -53.4853215540247,
              -31.11821230112349
            ],
            [
              -53.485216796375596,
              -31.11969326384085
            ],
            [
              -53.48092173276237,
              -31.121220506643134
            ],
            [
              -53.48071221746416,
              -31.12200726808673
            ],
            [
              -53.48238833984981,
              -31.12432127233261
            ],
            [
              -53.48327877986719,
              -31.126681556663407
            ],
            [
              -53.485897721094766,
              -31.128486479975194
            ],
            [
              -53.48631675169118,
              -31.129921162607637
            ],
            [
              -53.48888331409421,
              -31.13167980583451
            ],
            [
              -53.49260221063737,
              -31.133392168976457
            ],
            [
              -53.49401643890027,
              -31.132096326598766
            ],
            [
              -53.49899242723267,
              -31.1321888867686
            ],
            [
              -53.49862577546081,
              -31.133392168976457
            ],
            [
              -53.49569256128592,
              -31.13908461942132
            ],
            [
              -53.49658300130329,
              -31.142694466044894
            ],
            [
              -53.495587803636816,
              -31.14329610714882
            ],
            [
              -53.49338789300565,
              -31.142879586384563
            ],
            [
              -53.4919212859182,
              -31.146119192328793
            ],
            [
              -53.492078422391856,
              -31.149497638527777
            ],
            [
              -53.488778556445105,
              -31.15158024234907
            ],
            [
              -53.48888331409421,
              -31.153801686425112
            ],
            [
              -53.49071657295352,
              -31.154681008038548
            ],
            [
              -53.49291648358468,
              -31.154079366934617
            ],
            [
              -53.496321107180535,
              -31.156208250840827
            ],
            [
              -53.4984162601626,
              -31.156485931350332
            ],
            [
              -53.50192564140756,
              -31.15579173007657
            ],
            [
              -53.50349700614411,
              -31.156995012284426
            ],
            [
              -53.50370652144231,
              -31.15861481525654
            ],
            [
              -53.5032874908459,
              -31.16120650001193
            ],
            [
              -53.501611368460246,
              -31.16439982587124
            ],
            [
              -53.502501808477625,
              -31.165417987739428
            ],
            [
              -53.50412555203873,
              -31.165695668248933
            ],
            [
              -53.506011189722585,
              -31.164584946210912
            ],
            [
              -53.507792069757336,
              -31.16439982587124
            ],
            [
              -53.508892025072925,
              -31.167778272070226
            ],
            [
              -53.51051576863402,
              -31.16921295470267
            ],
            [
              -53.51182523924781,
              -31.168611313598742
            ],
            [
              -53.51517748401911,
              -31.165695668248933
            ],
            [
              -53.51722025817663,
              -31.16800967249481
            ],
            [
              -53.51591078756284,
              -31.1698145958066
            ],
            [
              -53.51601554521194,
              -31.17208231996756
            ],
            [
              -53.517115500527524,
              -31.17328560217542
            ],
            [
              -53.52162007943896,
              -31.176617768289482
            ],
            [
              -53.521724837088065,
              -31.17819129117668
            ],
            [
              -53.519786820579654,
              -31.17897805262028
            ],
            [
              -53.51722025817663,
              -31.17920945304487
            ],
            [
              -53.51449655929994,
              -31.178283851346517
            ],
            [
              -53.51062052628313,
              -31.17782105049734
            ],
            [
              -53.50590643207348,
              -31.173007921665913
            ],
            [
              -53.50438744616149,
              -31.173193042005582
            ],
            [
              -53.504020794389625,
              -31.174997965317367
            ],
            [
              -53.5048064767579,
              -31.179487133554375
            ],
            [
              -53.50622070502079,
              -31.182587899243853
            ],
            [
              -53.50747779681003,
              -31.183883741621546
            ],
            [
              -53.509311055669336,
              -31.186614266631683
            ],
            [
              -53.513082331037054,
              -31.18939107172674
            ],
            [
              -53.51517748401911,
              -31.19151995563295
            ],
            [
              -53.51502034754546,
              -31.19878592896501
            ],
            [
              -53.51732501582573,
              -31.203506497626602
            ],
            [
              -53.520415366474275,
              -31.20582050187248
            ],
            [
              -53.5260199007013,
              -31.20679238365575
            ],
            [
              -53.52759126543785,
              -31.208412186627864
            ],
            [
              -53.5260199007013,
              -31.21100387138325
            ],
            [
              -53.5245009147893,
              -31.215400479450423
            ],
            [
              -53.52088677589524,
              -31.214798838346493
            ],
            [
              -53.51999633587786,
              -31.216094680724186
            ],
            [
              -53.520415366474275,
              -31.217621923526465
            ],
            [
              -53.52539135480668,
              -31.22368461465067
            ],
            [
              -53.52617703717495,
              -31.225304417622784
            ],
            [
              -53.5245009147893,
              -31.22919194475586
            ],
            [
              -53.5261246583504,
              -31.232015029935834
            ],
            [
              -53.52759126543785,
              -31.237198399446605
            ],
            [
              -53.529215008998946,
              -31.239281003267898
            ],
            [
              -53.53010544901632,
              -31.242011528278034
            ],
            [
              -53.528795978402535,
              -31.245991615580948
            ],
            [
              -53.52931976664805,
              -31.248305619826827
            ],
            [
              -53.533510072612174,
              -31.25168406602581
            ],
            [
              -53.53518619499783,
              -31.2519154664504
            ],
            [
              -53.537019453857134,
              -31.25011054313861
            ],
            [
              -53.53518619499783,
              -31.247611418553063
            ],
            [
              -53.53618139266431,
              -31.24117848674952
            ],
            [
              -53.53628615031341,
              -31.239281003267898
            ],
            [
              -53.53848606094458,
              -31.239882644371825
            ],
            [
              -53.54471914106622,
              -31.242381768957376
            ],
            [
              -53.55021891764414,
              -31.240114044796414
            ],
            [
              -53.5523140706262,
              -31.237522360041027
            ],
            [
              -53.548699931732145,
              -31.23321831214369
            ],
            [
              -53.54859517408304,
              -31.229515905350286
            ],
            [
              -53.55147600943338,
              -31.229701025689955
            ],
            [
              -53.55509014832744,
              -31.232801791379433
            ],
            [
              -53.55561393657295,
              -31.234190193926963
            ],
            [
              -53.55477587538013,
              -31.236781878682347
            ],
            [
              -53.55582345187116,
              -31.237800040550535
            ],
            [
              -53.56168988022094,
              -31.239697524032156
            ],
            [
              -53.56320886613294,
              -31.24150244734394
            ],
            [
              -53.55839001427419,
              -31.24381645158982
            ],
            [
              -53.559385211940665,
              -31.247611418553063
            ],
            [
              -53.562004153168246,
              -31.248583300336332
            ],
            [
              -53.56268507788742,
              -31.252100586790068
            ],
            [
              -53.56561829206231,
              -31.25589555375331
            ],
            [
              -53.56750392974617,
              -31.257793037234933
            ],
            [
              -53.568184854465336,
              -31.25950540037688
            ],
            [
              -53.567084899149755,
              -31.261819404622763
            ],
            [
              -53.56760868739527,
              -31.264781330057488
            ],
            [
              -53.56902291565817,
              -31.26607717243518
            ],
            [
              -53.571903751008506,
              -31.265984612265346
            ],
            [
              -53.57357987339415,
              -31.267696975407294
            ],
            [
              -53.57090855334202,
              -31.270196099992845
            ],
            [
              -53.56959908272823,
              -31.270196099992845
            ],
            [
              -53.56881340035996,
              -31.2721861436443
            ],
            [
              -53.5701752497983,
              -31.273620826276748
            ],
            [
              -53.57431317693788,
              -31.27260266440856
            ],
            [
              -53.57850348290201,
              -31.274407587720344
            ],
            [
              -53.581698591199654,
              -31.272880344918065
            ],
            [
              -53.584788941848196,
              -31.271908463134796
            ],
            [
              -53.586098412461986,
              -31.273296865682322
            ],
            [
              -53.58442229007633,
              -31.275703430098037
            ],
            [
              -53.581908106497856,
              -31.277878594089163
            ],
            [
              -53.58290330416434,
              -31.279590957231115
            ],
            [
              -53.58520797244461,
              -31.280377718674714
            ],
            [
              -53.58798405014584,
              -31.279590957231115
            ],
            [
              -53.59007920312791,
              -31.28121076020323
            ],
            [
              -53.5899744454788,
              -31.284080125468122
            ],
            [
              -53.59180770433811,
              -31.284311525892708
            ],
            [
              -53.59479329733755,
              -31.28278428309043
            ],
            [
              -53.59641704089865,
              -31.27908187629702
            ],
            [
              -53.597412238565134,
              -31.279405836891446
            ],
            [
              -53.598512193880715,
              -31.2821826419865
            ],
            [
              -53.60327866691491,
              -31.283200803854687
            ],
            [
              -53.605583335195185,
              -31.284820606826802
            ],
            [
              -53.604902410476015,
              -31.28681065047826
            ],
            [
              -53.60312153044126,
              -31.287504851752022
            ],
            [
              -53.60411672810774,
              -31.288985814469385
            ],
            [
              -53.60479765282691,
              -31.29578898695227
            ],
            [
              -53.60720707875628,
              -31.298982312811585
            ],
            [
              -53.60657853286166,
              -31.300416995444028
            ],
            [
              -53.601812059827466,
              -31.302221918755816
            ],
            [
              -53.60238822689754,
              -31.3063871263984
            ],
            [
              -53.60532144107243,
              -31.310506053956065
            ],
            [
              -53.60652615403711,
              -31.311616775994086
            ],
            [
              -53.60877844349283,
              -31.31189445650359
            ],
            [
              -53.61207830943958,
              -31.310320933616392
            ],
            [
              -53.6141210835971,
              -31.311709336163922
            ],
            [
              -53.61537817538633,
              -31.31397706032488
            ],
            [
              -53.61689716129833,
              -31.312820058201943
            ],
            [
              -53.618678041333084,
              -31.313005178541612
            ],
            [
              -53.61962086017501,
              -31.314902662023233
            ],
            [
              -53.621506497858874,
              -31.316198504400926
            ],
            [
              -53.62370640849004,
              -31.316522464995348
            ],
            [
              -53.62501587910383,
              -31.318882749326146
            ],
            [
              -53.623915923788246,
              -31.32050255229826
            ],
            [
              -53.62140174020977,
              -31.321983515015624
            ],
            [
              -53.620197027245084,
              -31.323880998497245
            ],
            [
              -53.620197027245084,
              -31.326195002743123
            ],
            [
              -53.61810187426302,
              -31.32739828495098
            ],
            [
              -53.617106676596535,
              -31.329110648092932
            ],
            [
              -53.61852090485943,
              -31.330499050640462
            ],
            [
              -53.620616057841495,
              -31.33110069174439
            ],
            [
              -53.62292072612176,
              -31.33068417098013
            ],
            [
              -53.624177817911004,
              -31.33299817522601
            ],
            [
              -53.62522539440204,
              -31.333507256160104
            ],
            [
              -53.627215789735,
              -31.33281305488634
            ],
            [
              -53.62978235213802,
              -31.33299817522601
            ],
            [
              -53.63051565568175,
              -31.329989969706368
            ],
            [
              -53.63182512629554,
              -31.32920320826277
            ],
            [
              -53.636120189908766,
              -31.329388328602437
            ],
            [
              -53.64109617824117,
              -31.334803098537797
            ],
            [
              -53.6468054701173,
              -31.335821260405982
            ],
            [
              -53.64958154781853,
              -31.337718743887603
            ],
            [
              -53.65078626078322,
              -31.338088984566944
            ],
            [
              -53.65319568671259,
              -31.335821260405982
            ],
            [
              -53.6599001762552,
              -31.334617978198125
            ],
            [
              -53.666604665797806,
              -31.33221141378241
            ],
            [
              -53.67278536709489,
              -31.330406490470626
            ],
            [
              -53.676818536585365,
              -31.33110069174439
            ],
            [
              -53.684308708496246,
              -31.336422901509913
            ],
            [
              -53.6861943461801,
              -31.336978262528923
            ],
            [
              -53.69080368274064,
              -31.33568242015123
            ],
            [
              -53.693422623968225,
              -31.333507256160104
            ],
            [
              -53.700493765282694,
              -31.329712289196863
            ],
            [
              -53.70588878421151,
              -31.327814805715242
            ],
            [
              -53.70829821014088,
              -31.327583405290653
            ],
            [
              -53.71238375845591,
              -31.329388328602437
            ],
            [
              -53.71898349034941,
              -31.326704083677217
            ],
            [
              -53.7220214621734,
              -31.327583405290653
            ],
            [
              -53.72589749519022,
              -31.326981764186723
            ],
            [
              -53.73249722708372,
              -31.328509006989005
            ],
            [
              -53.73422572829392,
              -31.32841644681917
            ],
            [
              -53.740511187240116,
              -31.329110648092932
            ],
            [
              -53.741401627257495,
              -31.328509006989005
            ],
            [
              -53.74360153788866,
              -31.325408241299527
            ],
            [
              -53.74637761558989,
              -31.325084280705102
            ],
            [
              -53.74789660150189,
              -31.323510757817903
            ],
            [
              -53.74878704151927,
              -31.320086031534004
            ],
            [
              -53.75187739216781,
              -31.318512508646805
            ],
            [
              -53.7546010910445,
              -31.317910867542878
            ],
            [
              -53.758424745236766,
              -31.315180342532738
            ],
            [
              -53.765286371253026,
              -31.312218417098013
            ],
            [
              -53.768010070129705,
              -31.31457870142881
            ],
            [
              -53.774819317321416,
              -31.316291064570763
            ],
            [
              -53.7758145149879,
              -31.321983515015624
            ],
            [
              -53.777700152671756,
              -31.33628406125516
            ],
            [
              -53.78309517160057,
              -31.341791391360353
            ],
            [
              -53.784614157512564,
              -31.342902113398374
            ],
            [
              -53.784614157512564,
              -31.344984717219667
            ],
            [
              -53.791213889406066,
              -31.343920275266562
            ],
            [
              -53.791004374107864,
              -31.346882200701288
            ],
            [
              -53.79189481412524,
              -31.34910364477733
            ],
            [
              -53.796294635387575,
              -31.352713491400902
            ],
            [
              -53.792994769440824,
              -31.35678613887365
            ],
            [
              -53.79330904238813,
              -31.36118274694082
            ],
            [
              -53.79818027307143,
              -31.366504956706343
            ],
            [
              -53.799175470737914,
              -31.369883402905327
            ],
            [
              -53.800484941351705,
              -31.37117924528302
            ],
            [
              -53.80090397194812,
              -31.373909770293157
            ],
            [
              -53.79681842363309,
              -31.382286465663242
            ],
            [
              -53.79639939303668,
              -31.385109550843215
            ],
            [
              -53.793413800037236,
              -31.38649795339074
            ],
            [
              -53.794094724756405,
              -31.388117756362856
            ],
            [
              -53.79241860237076,
              -31.39107968179758
            ],
            [
              -53.79158054117793,
              -31.397281213176537
            ],
            [
              -53.79069010116055,
              -31.398901016148653
            ],
            [
              -53.79257573884441,
              -31.40528766786728
            ],
            [
              -53.792104329423445,
              -31.407694232282996
            ],
            [
              -53.79058534351145,
              -31.408804954321017
            ],
            [
              -53.79199957177434,
              -31.4111189585669
            ],
            [
              -53.78969490349407,
              -31.411581759416073
            ],
            [
              -53.790113934090485,
              -31.413294122558025
            ],
            [
              -53.788123538757524,
              -31.415191606039645
            ],
            [
              -53.78707596226649,
              -31.41838493189896
            ],
            [
              -53.78770450816111,
              -31.420884056484507
            ],
            [
              -53.790323449388694,
              -31.4213931374186
            ],
            [
              -53.78990441879228,
              -31.423892262004152
            ],
            [
              -53.78817591758207,
              -31.425002984042173
            ],
            [
              -53.78529508223174,
              -31.42467902344775
            ],
            [
              -53.78539983988084,
              -31.428011189561815
            ],
            [
              -53.784614157512564,
              -31.42930703193951
            ],
            [
              -53.78508556693353,
              -31.43101939508146
            ],
            [
              -53.78220473158319,
              -31.433611079836844
            ],
            [
              -53.782519004530506,
              -31.43578624382797
            ],
            [
              -53.781209533916716,
              -31.438609329007942
            ],
            [
              -53.784614157512564,
              -31.442589416310856
            ],
            [
              -53.79037582821324,
              -31.443792698518713
            ],
            [
              -53.789223494073106,
              -31.446615783698686
            ],
            [
              -53.78927587289766,
              -31.450410750661927
            ],
            [
              -53.79179005647614,
              -31.451104951935694
            ],
            [
              -53.793413800037236,
              -31.45328011592682
            ],
            [
              -53.802475336684665,
              -31.45688996255039
            ],
            [
              -53.80572282380686,
              -31.462813813419842
            ],
            [
              -53.81389392043691,
              -31.464294776137205
            ],
            [
              -53.815779558120774,
              -31.466793900722756
            ],
            [
              -53.82489347359275,
              -31.467302981656847
            ],
            [
              -53.82871712778502,
              -31.46878394437421
            ],
            [
              -53.83007897722336,
              -31.467997182930613
            ],
            [
              -53.832593160801835,
              -31.470218627006656
            ],
            [
              -53.832802676100044,
              -31.471190508789924
            ],
            [
              -53.83117893253895,
              -31.473689633375475
            ],
            [
              -53.83248840315273,
              -31.474800355413496
            ],
            [
              -53.82897902190778,
              -31.48049280585836
            ],
            [
              -53.831493205486254,
              -31.48840670037927
            ],
            [
              -53.82787906659219,
              -31.49048930420056
            ],
            [
              -53.82709338422392,
              -31.491877706748088
            ],
            [
              -53.82751241482033,
              -31.494978472437566
            ],
            [
              -53.825102988890954,
              -31.495811513966082
            ],
            [
              -53.82478871594365,
              -31.49678339574935
            ],
            [
              -53.82489347359275,
              -31.502290725854543
            ],
            [
              -53.82552201948737,
              -31.50409564916633
            ],
            [
              -53.82410779122448,
              -31.50659477375188
            ],
            [
              -53.824422064171785,
              -31.512379784366576
            ],
            [
              -53.82190788059331,
              -31.51520286954655
            ],
            [
              -53.823007835908896,
              -31.5227002433032
            ],
            [
              -53.826621974802954,
              -31.523579564916634
            ],
            [
              -53.82651721715385,
              -31.52478284712449
            ],
            [
              -53.8281933395395,
              -31.527420811964795
            ],
            [
              -53.82609818655744,
              -31.5276984924743
            ],
            [
              -53.82379351827717,
              -31.531215778928036
            ],
            [
              -53.82578391361013,
              -31.53477934546669
            ],
            [
              -53.832593160801835,
              -31.536908229372898
            ],
            [
              -53.83358835846832,
              -31.53899083319419
            ],
            [
              -53.83159796313536,
              -31.541582517949575
            ],
            [
              -53.826621974802954,
              -31.543896522195453
            ],
            [
              -53.82698862657482,
              -31.5461179662715
            ],
            [
              -53.83358835846832,
              -31.55148645612194
            ],
            [
              -53.835212102029416,
              -31.55181041671636
            ],
            [
              -53.837412012660586,
              -31.55069969467834
            ],
            [
              -53.83908813504624,
              -31.551116215442597
            ],
            [
              -53.840083332712716,
              -31.553800460367817
            ],
            [
              -53.839402407993546,
              -31.555790504019274
            ],
            [
              -53.840292848010925,
              -31.557687987500895
            ],
            [
              -53.83851196797617,
              -31.56162179471889
            ],
            [
              -53.840292848010925,
              -31.565000240917875
            ],
            [
              -53.840083332712716,
              -31.56680516422966
            ],
            [
              -53.8411832880283,
              -31.571109212126995
            ],
            [
              -53.841602318624716,
              -31.576477701977435
            ],
            [
              -53.839611923291756,
              -31.581985032082628
            ],
            [
              -53.84149756097561,
              -31.583419714715074
            ],
            [
              -53.83762152795879,
              -31.588186563461583
            ],
            [
              -53.83919289269534,
              -31.591611289745487
            ],
            [
              -53.83971668094085,
              -31.59610045798249
            ],
            [
              -53.8412880456774,
              -31.59748886053002
            ],
            [
              -53.843697471606774,
              -31.602209429191614
            ],
            [
              -53.84018809036182,
              -31.607577919042054
            ],
            [
              -53.84411650220319,
              -31.613085249147247
            ],
            [
              -53.84841156581642,
              -31.614103411015435
            ],
            [
              -53.848306808167315,
              -31.618083498318345
            ],
            [
              -53.84731161050084,
              -31.620397502564227
            ],
            [
              -53.8493020058338,
              -31.622480106385517
            ],
            [
              -53.8493020058338,
              -31.62511807122582
            ],
            [
              -53.8509257493949,
              -31.625812272499584
            ],
            [
              -53.852706629429655,
              -31.628403957254967
            ],
            [
              -53.855587464779994,
              -31.629607239462825
            ],
            [
              -53.857315965990196,
              -31.62891303818906
            ],
            [
              -53.85852067895488,
              -31.62988491997233
            ],
            [
              -53.861611029603424,
              -31.629977480142166
            ],
            [
              -53.862920500217214,
              -31.632106364048376
            ],
            [
              -53.8625014696208,
              -31.637706254323405
            ],
            [
              -53.8639156978837,
              -31.639418617465353
            ],
            [
              -53.86648226028672,
              -31.6392797772106
            ],
            [
              -53.8689964438652,
              -31.64062189967321
            ],
            [
              -53.87098683919816,
              -31.64677715096725
            ],
            [
              -53.872191552162846,
              -31.648304393769532
            ],
            [
              -53.87622472165332,
              -31.648211833599696
            ],
            [
              -53.87910555700366,
              -31.65001675691148
            ],
            [
              -53.87941982995097,
              -31.650710958185247
            ],
            [
              -53.87847701110904,
              -31.65251588149703
            ],
            [
              -53.87690564637249,
              -31.65371916370489
            ],
            [
              -53.87910555700366,
              -31.656079448035687
            ],
            [
              -53.88088643703841,
              -31.662419819669395
            ],
            [
              -53.88591480419537,
              -31.665289184934284
            ],
            [
              -53.88958132191398,
              -31.665983386208048
            ],
            [
              -53.8900003525104,
              -31.66788086968967
            ],
            [
              -53.88869088189661,
              -31.66922299215228
            ],
            [
              -53.8885861242475,
              -31.670889075209313
            ],
            [
              -53.89220026314156,
              -31.680422772702336
            ],
            [
              -53.89130982312419,
              -31.68301445745772
            ],
            [
              -53.89178123254515,
              -31.68518962144885
            ],
            [
              -53.890314625457705,
              -31.68741106552489
            ],
            [
              -53.889005154843915,
              -31.693890277413352
            ],
            [
              -53.889424185440326,
              -31.695186119791046
            ],
            [
              -53.89371924905356,
              -31.698888526584454
            ],
            [
              -53.893876385527214,
              -31.708699904586982
            ],
            [
              -53.89492396201825,
              -31.71119902917253
            ],
            [
              -53.89811907031589,
              -31.71490143596594
            ],
            [
              -53.89811907031589,
              -31.71790964148558
            ],
            [
              -53.90000470799975,
              -31.72101040717506
            ],
            [
              -53.90241413392913,
              -31.721797168618657
            ],
            [
              -53.9015760727363,
              -31.72350953176061
            ],
            [
              -53.9033045739465,
              -31.725592135581902
            ],
            [
              -53.901418936262644,
              -31.727304498723853
            ],
            [
              -53.9015760727363,
              -31.732302747894952
            ],
            [
              -53.899795192701546,
              -31.735310953414594
            ],
            [
              -53.90110466331534,
              -31.736791916131956
            ],
            [
              -53.90079039036802,
              -31.73919848054767
            ],
            [
              -53.90199510333271,
              -31.742576926746654
            ],
            [
              -53.90388074101657,
              -31.742715767001407
            ],
            [
              -53.90849007757711,
              -31.745492572096463
            ],
            [
              -53.909118623471734,
              -31.750999902201656
            ],
            [
              -53.913518444734066,
              -31.7532213462777
            ],
            [
              -53.91189470117297,
              -31.75451718865539
            ],
            [
              -53.914199369453236,
              -31.7605798797796
            ],
            [
              -53.91718496245268,
              -31.76030219927009
            ],
            [
              -53.92022293427667,
              -31.75789563485438
            ],
            [
              -53.92341804257432,
              -31.759422877656657
            ],
            [
              -53.925513195556384,
              -31.759793118336
            ],
            [
              -53.92420372494259,
              -31.76108896071369
            ],
            [
              -53.92540843790728,
              -31.762107122581877
            ],
            [
              -53.92640363557376,
              -31.76511532810152
            ],
            [
              -53.92519892260907,
              -31.767105371752976
            ],
            [
              -53.92488464966176,
              -31.773677143811273
            ],
            [
              -53.92409896729349,
              -31.775713467547646
            ],
            [
              -53.92221332960963,
              -31.77677790950075
            ],
            [
              -53.92168954136412,
              -31.780202635784654
            ],
            [
              -53.92001341897846,
              -31.782516640030533
            ],
            [
              -53.91550884006703,
              -31.782794320540038
            ],
            [
              -53.91451364240054,
              -31.785200884955753
            ],
            [
              -53.91079474585738,
              -31.788810731579325
            ],
            [
              -53.91278514119034,
              -31.789412372683252
            ],
            [
              -53.912889898839445,
              -31.790384254466524
            ],
            [
              -53.91058523055918,
              -31.792605698542566
            ],
            [
              -53.910218578787315,
              -31.794179221429765
            ],
            [
              -53.908018668156146,
              -31.795197383297953
            ],
            [
              -53.90639492459505,
              -31.797418827373995
            ],
            [
              -53.90508545398126,
              -31.800288192638888
            ],
            [
              -53.90487593868305,
              -31.804499680366387
            ],
            [
              -53.90581875752498,
              -31.80787812656537
            ]
          ]
        ]
      }
    },
    {
      "type": "Feature",
      "properties": {
        "mesorregiao_nome": "Sudeste Rio-grandense",
        "mesorregiao_id": 4307,
        "num_municipios": 25
      },
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -52.12552264961326,
                -31.977090189821755
              ],
              [
                -52.12652253368555,
                -31.975803509995696
              ],
              [
                -52.12599627891066,
                -31.974677665147894
              ],
              [
                -52.12731191584789,
                -31.97371265527835
              ],
              [
                -52.12789079610027,
                -31.972694033749388
              ],
              [
                -52.1263120317756,
                -31.971782635539263
              ],
              [
                -52.126101529865636,
                -31.97140735392333
              ],
              [
                -52.124417514585986,
                -31.96958455750308
              ],
              [
                -52.12499639483837,
                -31.96910205256831
              ],
              [
                -52.132311336209355,
                -31.96411616824233
              ],
              [
                -52.133995351489006,
                -31.96368727496698
              ],
              [
                -52.135310988426234,
                -31.961489196930795
              ],
              [
                -52.13688975275091,
                -31.95998807046706
              ],
              [
                -52.13831064064311,
                -31.959720012169964
              ],
              [
                -52.14041565974268,
                -31.957789992430875
              ],
              [
                -52.134784733651344,
                -31.956020807670047
              ],
              [
                -52.131679830479484,
                -31.956074419329465
              ],
              [
                -52.12899593112754,
                -31.958326109025066
              ],
              [
                -52.128680178262606,
                -31.9612211386337
              ],
              [
                -52.12957481137992,
                -31.962722265097433
              ],
              [
                -52.1321008342994,
                -31.96411616824233
              ],
              [
                -52.12489114388339,
                -31.96899482924947
              ],
              [
                -52.12310187764876,
                -31.968780382611794
              ],
              [
                -52.121680989756555,
                -31.967493702785735
              ],
              [
                -52.120786356639236,
                -31.967976207720508
              ],
              [
                -52.120417978296814,
                -31.96969178082192
              ],
              [
                -52.12120736045915,
                -31.971085683966816
              ],
              [
                -52.1228913757388,
                -31.970710402350882
              ],
              [
                -52.124417514585986,
                -31.96969178082192
              ],
              [
                -52.12599627891066,
                -31.97140735392333
              ],
              [
                -52.125312147703305,
                -31.97210430549578
              ],
              [
                -52.12657515916304,
                -31.972479587111714
              ],
              [
                -52.12720666489291,
                -31.97371265527835
              ],
              [
                -52.12599627891066,
                -31.974677665147894
              ],
              [
                -52.12489114388339,
                -31.976017956633374
              ],
              [
                -52.12552264961326,
                -31.977090189821755
              ],
              [
                -52.125312147703305,
                -31.980574947683998
              ],
              [
                -52.12299662669378,
                -31.98041411270574
              ],
              [
                -52.120681105684255,
                -31.97971716113329
              ],
              [
                -52.11941809422452,
                -31.977679918075367
              ],
              [
                -52.11531330698037,
                -31.977626306415946
              ],
              [
                -52.11331353883578,
                -31.97789436471304
              ],
              [
                -52.110577014006346,
                -31.98041411270574
              ],
              [
                -52.10920875159163,
                -31.984113317205658
              ],
              [
                -52.107314234402025,
                -31.985024715415783
              ],
              [
                -52.10431458218514,
                -31.988080580002674
              ],
              [
                -52.101104428058306,
                -31.99049310467653
              ],
              [
                -52.097525895589044,
                -31.99467481411122
              ],
              [
                -52.096999640814154,
                -31.99719456210392
              ],
              [
                -52.09742064463407,
                -31.99767706703869
              ],
              [
                -52.09689438985917,
                -32.00030403835023
              ],
              [
                -52.09668388794922,
                -32.00411046616898
              ],
              [
                -52.097104891769135,
                -32.006522990842846
              ],
              [
                -52.098894158003766,
                -32.00721994241529
              ],
              [
                -52.098683656093804,
                -32.00539714599504
              ],
              [
                -52.09789427393147,
                -32.004592971103754
              ],
              [
                -52.09857840513883,
                -32.003091844640025
              ],
              [
                -52.10010454398601,
                -32.00271656302409
              ],
              [
                -52.1021043121306,
                -32.00298462132118
              ],
              [
                -52.10752473631198,
                -32.00550436931388
              ],
              [
                -52.10989288279899,
                -32.00721994241529
              ],
              [
                -52.11278728406089,
                -32.00861384556019
              ],
              [
                -52.11310303692583,
                -32.0092035738138
              ],
              [
                -52.11868133753967,
                -32.011294428531144
              ],
              [
                -52.120417978296814,
                -32.01161609848766
              ],
              [
                -52.12599627891066,
                -32.013278059929654
              ],
              [
                -52.12841705087516,
                -32.014511128096295
              ],
              [
                -52.13189033238944,
                -32.014511128096295
              ],
              [
                -52.134100602443986,
                -32.0151008563499
              ],
              [
                -52.134784733651344,
                -32.01628031285712
              ],
              [
                -52.13631087249853,
                -32.01660198281364
              ],
              [
                -52.137100254660865,
                -32.017781439320856
              ],
              [
                -52.14088928904008,
                -32.01928256578459
              ],
              [
                -52.14267855527471,
                -32.01938978910343
              ],
              [
                -52.14678334251886,
                -32.020890915567165
              ],
              [
                -52.15062500237557,
                -32.02308899360335
              ],
              [
                -52.15220376670024,
                -32.02421483845115
              ],
              [
                -52.156782183241795,
                -32.02652013980617
              ],
              [
                -52.159887086413654,
                -32.02721709137862
              ],
              [
                -52.16309724054049,
                -32.027592372994555
              ],
              [
                -52.16651789657728,
                -32.02710986805978
              ],
              [
                -52.16941229783919,
                -32.028289324567005
              ],
              [
                -52.170622683821435,
                -32.02769959631339
              ],
              [
                -52.17278032839849,
                -32.02769959631339
              ],
              [
                -52.175674729660386,
                -32.02930794609597
              ],
              [
                -52.1799900188145,
                -32.030326567624925
              ],
              [
                -52.185410442995874,
                -32.02861099452352
              ],
              [
                -52.18651557802315,
                -32.02871821784235
              ],
              [
                -52.19051511431232,
                -32.02791404295107
              ],
              [
                -52.19162024933959,
                -32.028289324567005
              ],
              [
                -52.19362001748418,
                -32.02780681963223
              ],
              [
                -52.19598816397119,
                -32.02802126626991
              ],
              [
                -52.19851418689067,
                -32.032310199023435
              ],
              [
                -52.20198746840495,
                -32.03911887976966
              ],
              [
                -52.20119808624261,
                -32.03997666632037
              ],
              [
                -52.200513955035255,
                -32.043890317457965
              ],
              [
                -52.19940882000798,
                -32.045391443921694
              ],
              [
                -52.199619321917936,
                -32.047375075320204
              ],
              [
                -52.19877731427811,
                -32.047911191914395
              ],
              [
                -52.19851418689067,
                -32.049894823312904
              ],
              [
                -52.19630391683612,
                -32.054076532747594
              ],
              [
                -52.194988279898894,
                -32.05557765921133
              ],
              [
                -52.19409364678158,
                -32.057882960566346
              ],
              [
                -52.195198781808855,
                -32.05911602873299
              ],
              [
                -52.19661966970106,
                -32.05911602873299
              ],
              [
                -52.2017243410175,
                -32.058204630522866
              ],
              [
                -52.20640800851403,
                -32.058794358776474
              ],
              [
                -52.208986656911,
                -32.05981298030544
              ],
              [
                -52.21351244797506,
                -32.0644771946749
              ],
              [
                -52.21451233204736,
                -32.066407214413985
              ],
              [
                -52.213617698930044,
                -32.0681227875154
              ],
              [
                -52.21451233204736,
                -32.070374477211004
              ],
              [
                -52.21388082631749,
                -32.07139309873996
              ],
              [
                -52.21588059446208,
                -32.071875603674734
              ],
              [
                -52.21909074858891,
                -32.069302244022616
              ],
              [
                -52.2210905167335,
                -32.06919502070378
              ],
              [
                -52.221985149850816,
                -32.06849806913133
              ],
              [
                -52.226774068302326,
                -32.06849806913133
              ],
              [
                -52.22877383644691,
                -32.06940946734146
              ],
              [
                -52.23151036127634,
                -32.06978474895739
              ],
              [
                -52.233194376556,
                -32.07117865210229
              ],
              [
                -52.231194608411414,
                -32.07348395345731
              ],
              [
                -52.23240499439366,
                -32.07519952655872
              ],
              [
                -52.23398375871833,
                -32.07471702162395
              ],
              [
                -52.23472051540318,
                -32.07568203149349
              ],
              [
                -52.23787804405253,
                -32.076700653022456
              ],
              [
                -52.239877812197115,
                -32.08002457590644
              ],
              [
                -52.23798329500751,
                -32.08120403241366
              ],
              [
                -52.235983526862924,
                -32.081096809094824
              ],
              [
                -52.234983642790624,
                -32.082705158877395
              ],
              [
                -52.23219449248371,
                -32.08350933376868
              ],
              [
                -52.23072097911401,
                -32.08168653734843
              ],
              [
                -52.228510709059464,
                -32.083402110449846
              ],
              [
                -52.227984454284574,
                -32.08458156695706
              ],
              [
                -52.225511056842585,
                -32.08447434363823
              ],
              [
                -52.220616887436094,
                -32.08511768355125
              ],
              [
                -52.217196231399306,
                -32.08458156695706
              ],
              [
                -52.21440708109238,
                -32.08297321717449
              ],
              [
                -52.21298619320017,
                -32.081096809094824
              ],
              [
                -52.21251256390277,
                -32.078898731058636
              ],
              [
                -52.212407312947796,
                -32.07632537140652
              ],
              [
                -52.210512795758184,
                -32.076003701450006
              ],
              [
                -52.21030229384823,
                -32.07359117677615
              ],
              [
                -52.20740789258633,
                -32.07080337048635
              ],
              [
                -52.206092255649104,
                -32.07010641891391
              ],
              [
                -52.20419773845949,
                -32.07117865210229
              ],
              [
                -52.20661851042399,
                -32.07332311847905
              ],
              [
                -52.206092255649104,
                -32.07530674987756
              ],
              [
                -52.20309260343222,
                -32.07557480817466
              ],
              [
                -52.19672492065604,
                -32.071125040442865
              ],
              [
                -52.19188337672704,
                -32.06817639917482
              ],
              [
                -52.19130449647466,
                -32.06731861262411
              ],
              [
                -52.18041102263441,
                -32.06179661170395
              ],
              [
                -52.1795163895171,
                -32.0610996601315
              ],
              [
                -52.1795163895171,
                -32.0597057569866
              ],
              [
                -52.17777974875995,
                -32.05922325205183
              ],
              [
                -52.17662198825519,
                -32.05809740720402
              ],
              [
                -52.1736749615158,
                -32.05702517401564
              ],
              [
                -52.17151731693875,
                -32.055792105849
              ],
              [
                -52.16841241376689,
                -32.056220999124356
              ],
              [
                -52.164676004865164,
                -32.05611377580552
              ],
              [
                -52.1606238430985,
                -32.05321874619689
              ],
              [
                -52.15830832208898,
                -32.05198567803025
              ],
              [
                -52.149782994735745,
                -32.04817925021149
              ],
              [
                -52.14688859347384,
                -32.04748229863904
              ],
              [
                -52.14152079476995,
                -32.04667812374775
              ],
              [
                -52.13857376803056,
                -32.0465172887695
              ],
              [
                -52.135310988426234,
                -32.045176997284024
              ],
              [
                -52.13252183811931,
                -32.043193365885514
              ],
              [
                -52.127417166802864,
                -32.04088806453049
              ],
              [
                -52.120523229251795,
                -32.0367063550958
              ],
              [
                -52.120417978296814,
                -32.03600940352335
              ],
              [
                -52.11610268914271,
                -32.033382432211816
              ],
              [
                -52.11620794009768,
                -32.03209575238576
              ],
              [
                -52.114313422908076,
                -32.031398800813314
              ],
              [
                -52.11399767004314,
                -32.030487402603185
              ],
              [
                -52.11041913757388,
                -32.028289324567005
              ],
              [
                -52.1113137706912,
                -32.02641291648733
              ],
              [
                -52.10810361656436,
                -32.02480456670476
              ],
              [
                -52.09768377202151,
                -32.02909349945829
              ],
              [
                -52.09499987266957,
                -32.02920072277713
              ],
              [
                -52.08968469944317,
                -32.03021934430609
              ],
              [
                -52.085579912199016,
                -32.030112120987255
              ],
              [
                -52.08047524088257,
                -32.028289324567005
              ],
              [
                -52.0788964765579,
                -32.028825441161196
              ],
              [
                -52.07710721032327,
                -32.03198852906692
              ],
              [
                -52.07542319504361,
                -32.03129157749447
              ],
              [
                -52.073686554286475,
                -32.02952239273364
              ],
              [
                -52.06979226895228,
                -32.02952239273364
              ],
              [
                -52.06931863965488,
                -32.030112120987255
              ],
              [
                -52.06947651608735,
                -32.03381132548717
              ],
              [
                -52.0692133886999,
                -32.036491908458125
              ],
              [
                -52.06810825367263,
                -32.03799303492186
              ],
              [
                -52.0667926167354,
                -32.03842192819722
              ],
              [
                -52.06610848552804,
                -32.041209734487005
              ],
              [
                -52.06547697979817,
                -32.04212113269713
              ],
              [
                -52.064108717383455,
                -32.04587394885647
              ],
              [
                -52.06510860145575,
                -32.04758952195788
              ],
              [
                -52.067213620555314,
                -32.04582033719705
              ],
              [
                -52.06779250080769,
                -32.044104764095636
              ],
              [
                -52.07131840779947,
                -32.04367587082029
              ],
              [
                -52.07089740397955,
                -32.04131695780585
              ],
              [
                -52.07158153518691,
                -32.03960138470443
              ],
              [
                -52.073423426899026,
                -32.03729608334941
              ],
              [
                -52.07331817594405,
                -32.03381132548717
              ],
              [
                -52.07479168931375,
                -32.03289992727704
              ],
              [
                -52.07531794408864,
                -32.03150602413215
              ],
              [
                -52.07700195936829,
                -32.0322029757046
              ],
              [
                -52.077422963188205,
                -32.03348965553066
              ],
              [
                -52.071213156844486,
                -32.052092901349084
              ],
              [
                -52.07410755810639,
                -32.0512887264578
              ],
              [
                -52.07568632243106,
                -32.0512887264578
              ],
              [
                -52.08021211349512,
                -32.05000204663174
              ],
              [
                -52.08310651475703,
                -32.04962676501581
              ],
              [
                -52.084422151694255,
                -32.05032371658825
              ],
              [
                -52.08531678481157,
                -32.05182484305199
              ],
              [
                -52.08510628290161,
                -32.05439820270411
              ],
              [
                -52.08731655295615,
                -32.05772212558809
              ],
              [
                -52.08831643702845,
                -32.05772212558809
              ],
              [
                -52.0875796803436,
                -32.05477348432004
              ],
              [
                -52.08642191983884,
                -32.05182484305199
              ],
              [
                -52.08768493129858,
                -32.051503173095476
              ],
              [
                -52.08957944848819,
                -32.04930509505929
              ],
              [
                -52.09247384975009,
                -32.04951954169697
              ],
              [
                -52.09468411980463,
                -32.04780396859556
              ],
              [
                -52.095420876489484,
                -32.048608143486845
              ],
              [
                -52.10057817328342,
                -32.04598117217531
              ],
              [
                -52.10168330831068,
                -32.04598117217531
              ],
              [
                -52.10268319238298,
                -32.04882259012452
              ],
              [
                -52.10510396434748,
                -32.048983425102776
              ],
              [
                -52.10810361656436,
                -32.05107427982012
              ],
              [
                -52.11220840380851,
                -32.05118150313896
              ],
              [
                -52.11299778597085,
                -32.05182484305199
              ],
              [
                -52.11631319105266,
                -32.05187845471141
              ],
              [
                -52.119102341359586,
                -32.05252179462444
              ],
              [
                -52.123891259811096,
                -32.05471987266062
              ],
              [
                -52.12510164579334,
                -32.054612649341784
              ],
              [
                -52.127417166802864,
                -32.05589932916784
              ],
              [
                -52.129311683992476,
                -32.056220999124356
              ],
              [
                -52.13289021646173,
                -32.057507678950415
              ],
              [
                -52.133995351489006,
                -32.057507678950415
              ],
              [
                -52.137521258480774,
                -32.06018826192137
              ],
              [
                -52.13910002280545,
                -32.060992436812654
              ],
              [
                -52.142310176932284,
                -32.06490608795025
              ],
              [
                -52.1460992113115,
                -32.06887335074727
              ],
              [
                -52.150203998555654,
                -32.07530674987756
              ],
              [
                -52.151993264790285,
                -32.08039985752237
              ],
              [
                -52.1528878979076,
                -32.08227626560204
              ],
              [
                -52.152519519565175,
                -32.08388461538462
              ],
              [
                -52.15409828388985,
                -32.08570741180487
              ],
              [
                -52.15441403675479,
                -32.08699409163093
              ],
              [
                -52.1538877819799,
                -32.09042523783375
              ],
              [
                -52.15467716414223,
                -32.092891374167024
              ],
              [
                -52.156519055854346,
                -32.095786403775655
              ],
              [
                -52.15567704821452,
                -32.09868143338429
              ],
              [
                -52.155098167962144,
                -32.09937838495674
              ],
              [
                -52.15520341891712,
                -32.101790909630594
              ],
              [
                -52.15351940363747,
                -32.103720929369686
              ],
              [
                -52.155098167962144,
                -32.105382890811676
              ],
              [
                -52.154992917007164,
                -32.107205687231925
              ],
              [
                -52.15609805203444,
                -32.110100716840556
              ],
              [
                -52.157518939926646,
                -32.11090489173185
              ],
              [
                -52.156887434196776,
                -32.11197712492023
              ],
              [
                -52.155098167962144,
                -32.11288852313035
              ],
              [
                -52.156676932286814,
                -32.113907144659315
              ],
              [
                -52.153677280069935,
                -32.11658772763027
              ],
              [
                -52.15151963549288,
                -32.1161052226955
              ],
              [
                -52.14920411448336,
                -32.1163732809926
              ],
              [
                -52.14820423041107,
                -32.11562271776073
              ],
              [
                -52.14688859347384,
                -32.11331741640571
              ],
              [
                -52.145415080104144,
                -32.111709066623135
              ],
              [
                -52.14088928904008,
                -32.10549011413052
              ],
              [
                -52.135679366768656,
                -32.1003970064857
              ],
              [
                -52.132416587164336,
                -32.097877258493
              ],
              [
                -52.12710141393793,
                -32.0956255687974
              ],
              [
                -52.12399651076608,
                -32.094124442333666
              ],
              [
                -52.11941809422452,
                -32.09128302438445
              ],
              [
                -52.11841821015223,
                -32.08897772302943
              ],
              [
                -52.115997438187726,
                -32.085600188486026
              ],
              [
                -52.11331353883578,
                -32.08442073197881
              ],
              [
                -52.11231365476349,
                -32.083616557087524
              ],
              [
                -52.110313886618904,
                -32.07771927455142
              ],
              [
                -52.10868249681674,
                -32.07487785660221
              ],
              [
                -52.102577941428,
                -32.067693894240044
              ],
              [
                -52.09978879112108,
                -32.065495816203864
              ],
              [
                -52.093894737642295,
                -32.062225504979295
              ],
              [
                -52.09021095421806,
                -32.06120688345033
              ],
              [
                -52.08879006632585,
                -32.05981298030544
              ],
              [
                -52.08768493129858,
                -32.060992436812654
              ],
              [
                -52.085579912199016,
                -32.0610996601315
              ],
              [
                -52.08479053003668,
                -32.062815233232904
              ],
              [
                -52.08479053003668,
                -32.06469164131258
              ],
              [
                -52.08642191983884,
                -32.06742583594295
              ],
              [
                -52.0914739656778,
                -32.073805623413826
              ],
              [
                -52.094105239552256,
                -32.076003701450006
              ],
              [
                -52.09910465991372,
                -32.08259793555856
              ],
              [
                -52.099209910868694,
                -32.085224906870096
              ],
              [
                -52.10052554780592,
                -32.08951383962362
              ],
              [
                -52.10052554780592,
                -32.09042523783375
              ],
              [
                -52.10199906117562,
                -32.0956255687974
              ],
              [
                -52.10341994906783,
                -32.09712669526114
              ],
              [
                -52.10468296052757,
                -32.10350648273201
              ],
              [
                -52.10489346243752,
                -32.10640151234064
              ],
              [
                -52.104104080275185,
                -32.107205687231925
              ],
              [
                -52.104104080275185,
                -32.112781299811516
              ],
              [
                -52.10457770957259,
                -32.11369269802164
              ],
              [
                -52.1045250840951,
                -32.11958998055774
              ],
              [
                -52.10341994906783,
                -32.12210972855044
              ],
              [
                -52.102314814040554,
                -32.12232417518812
              ],
              [
                -52.10278844333796,
                -32.1304195357604
              ],
              [
                -52.10468296052757,
                -32.13052675907924
              ],
              [
                -52.10520921530246,
                -32.13159899226762
              ],
              [
                -52.103998829320204,
                -32.13288567209368
              ],
              [
                -52.10299894524791,
                -32.13792516807908
              ],
              [
                -52.10389357836523,
                -32.13899740126746
              ],
              [
                -52.10299894524791,
                -32.14028408109352
              ],
              [
                -52.10089392614835,
                -32.1497733448107
              ],
              [
                -52.10220956308558,
                -32.15079196633966
              ],
              [
                -52.09989404207606,
                -32.15320449101352
              ],
              [
                -52.098894158003766,
                -32.15572423900622
              ],
              [
                -52.09952566373363,
                -32.158512045296014
              ],
              [
                -52.099315161823675,
                -32.15947705516556
              ],
              [
                -52.09721014272411,
                -32.16167513320174
              ],
              [
                -52.110682264961326,
                -32.16349792962199
              ],
              [
                -52.116892071305045,
                -32.165588784339334
              ],
              [
                -52.12489114388339,
                -32.16928798883925
              ],
              [
                -52.13310071837169,
                -32.173898591549296
              ],
              [
                -52.140994539995056,
                -32.179206145831785
              ],
              [
                -52.14767797563618,
                -32.184406476795445
              ],
              [
                -52.16578113989244,
                -32.199310518113954
              ],
              [
                -52.17830600353484,
                -32.21030090829487
              ],
              [
                -52.188883724510156,
                -32.21882516214251
              ],
              [
                -52.195198781808855,
                -32.22348937651197
              ],
              [
                -52.19898781618807,
                -32.22659885275828
              ],
              [
                -52.203513607252134,
                -32.23067333887413
              ],
              [
                -52.208302525703644,
                -32.23571283485953
              ],
              [
                -52.21188105817291,
                -32.23968009765654
              ],
              [
                -52.22088001482354,
                -32.247185729975214
              ],
              [
                -52.22519530397765,
                -32.25120660443165
              ],
              [
                -52.23387850776336,
                -32.260213363214056
              ],
              [
                -52.24461410517114,
                -32.27249043322104
              ],
              [
                -52.250876536992344,
                -32.279781618902035
              ],
              [
                -52.256191710218744,
                -32.28701919292361
              ],
              [
                -52.26971645793345,
                -32.304121312278305
              ],
              [
                -52.27682089739448,
                -32.31409308093026
              ],
              [
                -52.283504333035594,
                -32.32379679128512
              ],
              [
                -52.29297691898364,
                -32.3383255509877
              ],
              [
                -52.29929197628233,
                -32.348511766277326
              ],
              [
                -52.305080778806136,
                -32.35821547663218
              ],
              [
                -52.31097483228492,
                -32.368616138559496
              ],
              [
                -52.314816492141624,
                -32.37580010092165
              ],
              [
                -52.31718463862863,
                -32.37982097537809
              ],
              [
                -52.32202618255763,
                -32.38850606420398
              ],
              [
                -52.32707822839659,
                -32.399121172768965
              ],
              [
                -52.33049888443338,
                -32.40517929028332
              ],
              [
                -52.33360378760524,
                -32.4112910194571
              ],
              [
                -52.340813478021246,
                -32.42458671099304
              ],
              [
                -52.344181508580554,
                -32.43171706169578
              ],
              [
                -52.34770741557232,
                -32.43852574244201
              ],
              [
                -52.3507070677892,
                -32.445173588209975
              ],
              [
                -52.35449610216842,
                -32.453000890485164
              ],
              [
                -52.356601121267985,
                -32.45761149319521
              ],
              [
                -52.3599165263498,
                -32.463991280666086
              ],
              [
                -52.3657053288736,
                -32.47680446726725
              ],
              [
                -52.36817872631559,
                -32.481790351593226
              ],
              [
                -52.3710205021,
                -32.48822375072352
              ],
              [
                -52.37659880271385,
                -32.501894723875395
              ],
              [
                -52.381177219255406,
                -32.51277789073747
              ],
              [
                -52.386387141526825,
                -32.52580552397632
              ],
              [
                -52.391702314753225,
                -32.540012613722375
              ],
              [
                -52.39270219882552,
                -32.54312208996868
              ],
              [
                -52.39780687014196,
                -32.55652500482346
              ],
              [
                -52.40317466884586,
                -32.571000152866624
              ],
              [
                -52.40701632870256,
                -32.581883319728696
              ],
              [
                -52.409279224234595,
                -32.587673378945965
              ],
              [
                -52.41569953248827,
                -32.60520439157601
              ],
              [
                -52.418225555407744,
                -32.61308530551062
              ],
              [
                -52.42290922290427,
                -32.62879352172042
              ],
              [
                -52.427803392310764,
                -32.6478256608142
              ],
              [
                -52.42911902924799,
                -32.652597098502504
              ],
              [
                -52.42990841141033,
                -32.656403526321256
              ],
              [
                -52.433223816492145,
                -32.668198091393464
              ],
              [
                -52.436486596096465,
                -32.681922676204756
              ],
              [
                -52.4372759782588,
                -32.68658689057421
              ],
              [
                -52.44001250308824,
                -32.69768450407397
              ],
              [
                -52.4406966342956,
                -32.70111565027679
              ],
              [
                -52.445275050837154,
                -32.72068390596477
              ],
              [
                -52.44638018586442,
                -32.72572340195016
              ],
              [
                -52.44859045591897,
                -32.73467654907316
              ],
              [
                -52.45137960622589,
                -32.74502359934104
              ],
              [
                -52.45358987628043,
                -32.75349424152926
              ],
              [
                -52.45580014633497,
                -32.76169682542039
              ],
              [
                -52.45790516543454,
                -32.76861272948545
              ],
              [
                -52.460010184534106,
                -32.77531418691284
              ],
              [
                -52.46258883293107,
                -32.78271259591267
              ],
              [
                -52.46411497177826,
                -32.78759125691981
              ],
              [
                -52.46837763545487,
                -32.799493045310854
              ],
              [
                -52.47158778958171,
                -32.8086070274121
              ],
              [
                -52.4760083296908,
                -32.81949019427418
              ],
              [
                -52.47921848381763,
                -32.82801444812182
              ],
              [
                -52.48232338698949,
                -32.835520080440496
              ],
              [
                -52.48521778825139,
                -32.84431239258523
              ],
              [
                -52.48790168760334,
                -32.851121073331456
              ],
              [
                -52.49100659077519,
                -32.858197812374776
              ],
              [
                -52.495216628974326,
                -32.86720457115719
              ],
              [
                -52.502584195822806,
                -32.8821086124757
              ],
              [
                -52.50679423402193,
                -32.890311196366824
              ],
              [
                -52.51147790151846,
                -32.899210731830394
              ],
              [
                -52.514793306600275,
                -32.905000791047655
              ],
              [
                -52.51858234097949,
                -32.91180947179388
              ],
              [
                -52.526686664512816,
                -32.92521238664866
              ],
              [
                -52.53400160588381,
                -32.93770390329331
              ],
              [
                -52.53721176001064,
                -32.94258256430045
              ],
              [
                -52.54500033067903,
                -32.956682430727675
              ],
              [
                -52.54821048480587,
                -32.96188276169133
              ],
              [
                -52.55199951918509,
                -32.969173947372326
              ],
              [
                -52.55431504019461,
                -32.972980375191085
              ],
              [
                -52.557893572663865,
                -32.98000350257499
              ],
              [
                -52.559419711511055,
                -32.98338103711839
              ],
              [
                -52.56131422870066,
                -32.986919406640055
              ],
              [
                -52.56510326307988,
                -32.9949075438935
              ],
              [
                -52.56957642866645,
                -33.00268123450927
              ],
              [
                -52.57257608088333,
                -33.00868574036421
              ],
              [
                -52.57731237385735,
                -33.01699554757417
              ],
              [
                -52.580785655371635,
                -33.024501179892845
              ],
              [
                -52.58457468975085,
                -33.03200681221152
              ],
              [
                -52.58667970885042,
                -33.0367246382404
              ],
              [
                -52.593205268059066,
                -33.0501811647546
              ],
              [
                -52.595678665501055,
                -33.0546845441458
              ],
              [
                -52.59952032535776,
                -33.06208295314564
              ],
              [
                -52.60351986164694,
                -33.06932052716722
              ],
              [
                -52.61151893422528,
                -33.08331317027561
              ],
              [
                -52.623885921435225,
                -33.10422171744906
              ],
              [
                -52.63241124878846,
                -33.11682045741255
              ],
              [
                -52.636410785077636,
                -33.123307468202256
              ],
              [
                -52.640989201619185,
                -33.12968725567313
              ],
              [
                -52.65009340922481,
                -33.14169626738301
              ],
              [
                -52.65461920028887,
                -33.14700382166551
              ],
              [
                -52.6631971531196,
                -33.15810143516526
              ],
              [
                -52.66661780915639,
                -33.16217592128111
              ],
              [
                -52.67209085881526,
                -33.169199048665014
              ],
              [
                -52.685615606529964,
                -33.18560421644726
              ],
              [
                -52.687720625629524,
                -33.18849924605589
              ],
              [
                -52.692509544081034,
                -33.193699577019544
              ],
              [
                -52.695193443432984,
                -33.19718433488179
              ],
              [
                -52.69887722685722,
                -33.20131243265706
              ],
              [
                -52.70129799882172,
                -33.20442190890337
              ],
              [
                -52.70950757331002,
                -33.21380394930171
              ],
              [
                -52.7129808548243,
                -33.21809288205524
              ],
              [
                -52.71787502423079,
                -33.223185989700056
              ],
              [
                -52.72671610444896,
                -33.23321137001143
              ],
              [
                -52.73397842034246,
                -33.24109228394604
              ],
              [
                -52.741398612668426,
                -33.24870513958355
              ],
              [
                -52.75560749159049,
                -33.26280500601077
              ],
              [
                -52.76597471065585,
                -33.272883997981566
              ],
              [
                -52.76929011573766,
                -33.27610069754672
              ],
              [
                -52.77671030806363,
                -33.28312382493062
              ],
              [
                -52.78092034626276,
                -33.286715806111694
              ],
              [
                -52.79081393603071,
                -33.29540089493759
              ],
              [
                -52.80202316273589,
                -33.30489015865477
              ],
              [
                -52.80839084551208,
                -33.30960798468366
              ],
              [
                -52.81191675250385,
                -33.3128246842488
              ],
              [
                -52.82991466580513,
                -33.32660288071951
              ],
              [
                -52.8397030046181,
                -33.334215736357024
              ],
              [
                -52.85017547463844,
                -33.34209665029164
              ],
              [
                -52.8561747790722,
                -33.34692169963935
              ],
              [
                -52.86569999049773,
                -33.354695390255124
              ],
              [
                -52.876119835040576,
                -33.36380937235637
              ],
              [
                -52.895801763621506,
                -33.37962481188501
              ],
              [
                -52.900695933028,
                -33.38369929800086
              ],
              [
                -52.91169465782322,
                -33.3924916101456
              ],
              [
                -52.916799329139664,
                -33.39640526128319
              ],
              [
                -52.92448264885308,
                -33.40262421377581
              ],
              [
                -52.93637600676562,
                -33.411791807536474
              ],
              [
                -52.94048079400977,
                -33.41527656539871
              ],
              [
                -52.948479866588116,
                -33.42170996452901
              ],
              [
                -52.95747882323875,
                -33.428625868594075
              ],
              [
                -52.96068897736559,
                -33.431681733180966
              ],
              [
                -52.969319555673806,
                -33.43811513231125
              ],
              [
                -52.97747650468462,
                -33.44449491978213
              ],
              [
                -52.983423183640895,
                -33.449480804108106
              ],
              [
                -52.99142225621924,
                -33.45580697991956
              ],
              [
                -52.995474417985896,
                -33.458916456165866
              ],
              [
                -52.99747418613049,
                -33.46079286424554
              ],
              [
                -53.003105112221824,
                -33.46497457368023
              ],
              [
                -53.018892755468556,
                -33.477412478665464
              ],
              [
                -53.02378692487505,
                -33.48148696478131
              ],
              [
                -53.03889043691442,
                -33.49360319981003
              ],
              [
                -53.04678425853779,
                -33.499714928983806
              ],
              [
                -53.0496260343222,
                -33.50218106531709
              ],
              [
                -53.055414836846005,
                -33.506791668027134
              ],
              [
                -53.06299290560444,
                -33.51247450392555
              ],
              [
                -53.066413561641234,
                -33.515476756853026
              ],
              [
                -53.0772017845265,
                -33.52389378738182
              ],
              [
                -53.07909630171611,
                -33.52518046720788
              ],
              [
                -53.086200741177144,
                -33.530702468128055
              ],
              [
                -53.097883597179724,
                -33.540298955164076
              ],
              [
                -53.10688255383037,
                -33.54732208254798
              ],
              [
                -53.110408460822136,
                -33.55021711215661
              ],
              [
                -53.11240822896672,
                -33.55241519019279
              ],
              [
                -53.11619726334594,
                -33.55579272473619
              ],
              [
                -53.11988104677018,
                -33.55858053102599
              ],
              [
                -53.12251232064464,
                -33.56110027901869
              ],
              [
                -53.13261641232255,
                -33.56978536784458
              ],
              [
                -53.13530031167449,
                -33.57198344588077
              ],
              [
                -53.140825986810846,
                -33.576915718547326
              ],
              [
                -53.14461502119006,
                -33.5805076997284
              ],
              [
                -53.15619262623767,
                -33.59010418676442
              ],
              [
                -53.1604026644368,
                -33.59299921637305
              ],
              [
                -53.166296717915586,
                -33.59787787738019
              ],
              [
                -53.17282227712423,
                -33.60259570340907
              ],
              [
                -53.17708494080085,
                -33.606187684590154
              ],
              [
                -53.18671540318136,
                -33.613425258611734
              ],
              [
                -53.19160957258785,
                -33.61680279315514
              ],
              [
                -53.19581961078698,
                -33.619215317828996
              ],
              [
                -53.20418706170775,
                -33.62452287211149
              ],
              [
                -53.20908123111424,
                -33.628275688270826
              ],
              [
                -53.21308076740341,
                -33.63170683447365
              ],
              [
                -53.215080535548,
                -33.632993514299706
              ],
              [
                -53.221185090936736,
                -33.63797939862569
              ],
              [
                -53.228184279442786,
                -33.643876681161785
              ],
              [
                -53.23881462589559,
                -33.65229371169059
              ],
              [
                -53.24702420038389,
                -33.657976547589016
              ],
              [
                -53.252391999087784,
                -33.66151491711067
              ],
              [
                -53.257180917539294,
                -33.66537495658885
              ],
              [
                -53.26181195955834,
                -33.66859165615399
              ],
              [
                -53.26502211368517,
                -33.67132585078437
              ],
              [
                -53.27017941047911,
                -33.67459616200894
              ],
              [
                -53.27591558752542,
                -33.678724259784204
              ],
              [
                -53.28170439004922,
                -33.68220901764645
              ],
              [
                -53.28880882951025,
                -33.686819620356495
              ],
              [
                -53.297176280431025,
                -33.691912728001306
              ],
              [
                -53.307280372108934,
                -33.698775020406956
              ],
              [
                -53.31827909690416,
                -33.706602322682144
              ],
              [
                -53.32659392234744,
                -33.71228515858057
              ],
              [
                -53.3325932267812,
                -33.71598436308049
              ],
              [
                -53.337803149052625,
                -33.719683567580404
              ],
              [
                -53.34138168152189,
                -33.72188164561659
              ],
              [
                -53.347801989775554,
                -33.72681391828315
              ],
              [
                -53.35027538721754,
                -33.72847587972514
              ],
              [
                -53.358905965525764,
                -33.73501650217427
              ],
              [
                -53.364221138752164,
                -33.738501260036514
              ],
              [
                -53.36711554001406,
                -33.74091378471037
              ],
              [
                -53.37000994127597,
                -33.74391603763784
              ],
              [
                -53.37200970942055,
                -33.74300463942772
              ],
              [
                -53.375219863547386,
                -33.744720212529124
              ],
              [
                -53.37848264315171,
                -33.74702551388415
              ],
              [
                -53.38111391702617,
                -33.7477224654566
              ],
              [
                -53.38590283547768,
                -33.74600689235518
              ],
              [
                -53.387481599802356,
                -33.7465966206088
              ],
              [
                -53.391007506794125,
                -33.75008137847104
              ],
              [
                -53.393480904236114,
                -33.7511
              ],
              [
                -53.39690156027291,
                -33.75077833004349
              ],
              [
                -53.39969071057983,
                -33.74820497039137
              ],
              [
                -53.40211148254433,
                -33.74970609685511
              ],
              [
                -53.40332186852658,
                -33.74981332017394
              ],
              [
                -53.40811078697809,
                -33.74927720357975
              ],
              [
                -53.411320941104925,
                -33.74938442689859
              ],
              [
                -53.41668873980881,
                -33.748312193710206
              ],
              [
                -53.41810962770102,
                -33.74729357218124
              ],
              [
                -53.41989889393565,
                -33.74477382418855
              ],
              [
                -53.42200391303522,
                -33.743808814319
              ],
              [
                -53.423477426404915,
                -33.74300463942772
              ],
              [
                -53.42679283148673,
                -33.73909098829012
              ],
              [
                -53.43010823656854,
                -33.739573493224896
              ],
              [
                -53.431108120640836,
                -33.739412658246636
              ],
              [
                -53.43210800471313,
                -33.73517733715253
              ],
              [
                -53.431108120640836,
                -33.73421232728298
              ],
              [
                -53.431792251848194,
                -33.73281842413809
              ],
              [
                -53.43089761873088,
                -33.730888404398996
              ],
              [
                -53.43200275375815,
                -33.72788615147153
              ],
              [
                -53.435791788137365,
                -33.72402611199335
              ],
              [
                -53.43431827476767,
                -33.72300749046439
              ],
              [
                -53.433581518082825,
                -33.7210774707253
              ],
              [
                -53.4336867690378,
                -33.719522732602144
              ],
              [
                -53.43510765693001,
                -33.71780715950074
              ],
              [
                -53.43510765693001,
                -33.71528741150804
              ],
              [
                -53.43842306201182,
                -33.713089333471856
              ],
              [
                -53.43868618939927,
                -33.71190987696463
              ],
              [
                -53.43831781105684,
                -33.70912207067484
              ],
              [
                -53.43700217411961,
                -33.707513720892265
              ],
              [
                -53.43700217411961,
                -33.70579814779086
              ],
              [
                -53.43868618939927,
                -33.70429702132712
              ],
              [
                -53.436423293867236,
                -33.70129476839965
              ],
              [
                -53.43779155628195,
                -33.69957919529824
              ],
              [
                -53.4394755715616,
                -33.69818529215334
              ],
              [
                -53.440580706588875,
                -33.69968641861708
              ],
              [
                -53.44231734734602,
                -33.69952558363882
              ],
              [
                -53.44221209639104,
                -33.69598721411716
              ],
              [
                -53.44042283015641,
                -33.69378913608097
              ],
              [
                -53.4394755715616,
                -33.69352107778388
              ],
              [
                -53.471892865694905,
                -33.69180550468247
              ],
              [
                -53.52278170242688,
                -33.68928575668977
              ],
              [
                -53.52951776354549,
                -33.68837435847965
              ],
              [
                -53.52951776354549,
                -33.68671239703765
              ],
              [
                -53.53088602596021,
                -33.68210179432761
              ],
              [
                -53.52978089093293,
                -33.68060066786388
              ],
              [
                -53.53099127691518,
                -33.67968926965375
              ],
              [
                -53.53009664379787,
                -33.67808091987118
              ],
              [
                -53.52788637374333,
                -33.67749119161757
              ],
              [
                -53.526886489671035,
                -33.67609728847267
              ],
              [
                -53.52478147057147,
                -33.67529311358138
              ],
              [
                -53.524623594139,
                -33.67389921043649
              ],
              [
                -53.52641286037363,
                -33.67277336558869
              ],
              [
                -53.52862313042817,
                -33.672880588907525
              ],
              [
                -53.52778112278835,
                -33.67068251087134
              ],
              [
                -53.52867575590566,
                -33.668001927900384
              ],
              [
                -53.530517647617785,
                -33.6683235978569
              ],
              [
                -53.532201662897435,
                -33.667626646284454
              ],
              [
                -53.53151753169008,
                -33.66650080143665
              ],
              [
                -53.5318859100325,
                -33.66478522833524
              ],
              [
                -53.53309629601475,
                -33.66339132519034
              ],
              [
                -53.532991045059774,
                -33.66151491711067
              ],
              [
                -53.5314122807351,
                -33.661997422045445
              ],
              [
                -53.53067552405025,
                -33.659477674052745
              ],
              [
                -53.53320154696973,
                -33.659799344009265
              ],
              [
                -53.53362255078964,
                -33.6587807224803
              ],
              [
                -53.53109652787016,
                -33.65690431440063
              ],
              [
                -53.53267529219484,
                -33.65518874129922
              ],
              [
                -53.53288579410479,
                -33.65272260496594
              ],
              [
                -53.53399092913207,
                -33.65138231348046
              ],
              [
                -53.53251741576237,
                -33.649881187016724
              ],
              [
                -53.53178065907752,
                -33.64832644889357
              ],
              [
                -53.531675408122545,
                -33.64548503094436
              ],
              [
                -53.52941251259051,
                -33.64398390448063
              ],
              [
                -53.53120177882514,
                -33.64237555469805
              ],
              [
                -53.53151753169008,
                -33.640606369937224
              ],
              [
                -53.528202126608264,
                -33.63990941836477
              ],
              [
                -53.52888625781562,
                -33.6369071654373
              ],
              [
                -53.52867575590566,
                -33.63529881565473
              ],
              [
                -53.529623014500466,
                -33.63347601923448
              ],
              [
                -53.52709699158099,
                -33.63181405779249
              ],
              [
                -53.52699174062601,
                -33.63111710622004
              ],
              [
                -53.52888625781562,
                -33.629187086480954
              ],
              [
                -53.5260971075087,
                -33.62618483355348
              ],
              [
                -53.52620235846367,
                -33.62489815372742
              ],
              [
                -53.52878100686064,
                -33.623718697220205
              ],
              [
                -53.52920201068056,
                -33.620501997655055
              ],
              [
                -53.53120177882514,
                -33.61959059944493
              ],
              [
                -53.53451718390696,
                -33.6166955698363
              ],
              [
                -53.53499081320436,
                -33.615194443372566
              ],
              [
                -53.53641170109656,
                -33.61299636533638
              ],
              [
                -53.5333067979247,
                -33.61128079223497
              ],
              [
                -53.53230691385241,
                -33.60918993751763
              ],
              [
                -53.532622666717344,
                -33.60661657786551
              ],
              [
                -53.53462243486193,
                -33.60339987830036
              ],
              [
                -53.5318859100325,
                -33.6009873536265
              ],
              [
                -53.53030714570782,
                -33.60152347022069
              ],
              [
                -53.52920201068056,
                -33.60538350969887
              ],
              [
                -53.530412396662804,
                -33.61262108372045
              ],
              [
                -53.53009664379787,
                -33.615194443372566
              ],
              [
                -53.52841262851822,
                -33.61712446311165
              ],
              [
                -53.52641286037363,
                -33.61712446311165
              ],
              [
                -53.52399208840913,
                -33.61599861826385
              ],
              [
                -53.521202938102206,
                -33.615784171626174
              ],
              [
                -53.520308304984894,
                -33.61492638507547
              ],
              [
                -53.519413671867575,
                -33.61069106398136
              ],
              [
                -53.51788753302039,
                -33.608707432582854
              ],
              [
                -53.51451950246109,
                -33.60522267472061
              ],
              [
                -53.512519734316506,
                -33.60259570340907
              ],
              [
                -53.512309232406544,
                -33.59809232401787
              ],
              [
                -53.51320386552386,
                -33.59208781816293
              ],
              [
                -53.51378274577624,
                -33.58967529348907
              ],
              [
                -53.51562463748836,
                -33.58479663248193
              ],
              [
                -53.51451950246109,
                -33.58120465130085
              ],
              [
                -53.51130934833425,
                -33.5732165140474
              ],
              [
                -53.510993595469316,
                -33.567319231511306
              ],
              [
                -53.51320386552386,
                -33.55858053102599
              ],
              [
                -53.514624753416065,
                -33.554077151634786
              ],
              [
                -53.51441425150611,
                -33.55198629691744
              ],
              [
                -53.510993595469316,
                -33.54399815966399
              ],
              [
                -53.51088834451434,
                -33.54292592647561
              ],
              [
                -53.51220398145157,
                -33.540513401801746
              ],
              [
                -53.511782977631654,
                -33.536706973982994
              ],
              [
                -53.50778344134248,
                -33.531077749743986
              ],
              [
                -53.50688880822517,
                -33.531989147954114
              ],
              [
                -53.50778344134248,
                -33.534026391012034
              ],
              [
                -53.50799394325244,
                -33.536010022410544
              ],
              [
                -53.5072045610901,
                -33.53949478027278
              ],
              [
                -53.505310043900494,
                -33.54110313005536
              ],
              [
                -53.50110000570136,
                -33.543408431410384
              ],
              [
                -53.492101049050724,
                -33.54539206280889
              ],
              [
                -53.48231271023775,
                -33.54700041259146
              ],
              [
                -53.48220745928277,
                -33.54791181080159
              ],
              [
                -53.48457560576978,
                -33.55069961709138
              ],
              [
                -53.48210220832779,
                -33.552307966873954
              ],
              [
                -53.48331259431004,
                -33.5543988215913
              ],
              [
                -53.484417729337316,
                -33.554077151634786
              ],
              [
                -53.48631224652692,
                -33.55509577316375
              ],
              [
                -53.483786223607446,
                -33.558687754344824
              ],
              [
                -53.48078657139057,
                -33.5614219489752
              ],
              [
                -53.48020769113818,
                -33.562976687098356
              ],
              [
                -53.47757641726373,
                -33.56388808530848
              ],
              [
                -53.47452413956936,
                -33.56388808530848
              ],
              [
                -53.47199811664988,
                -33.56340558037371
              ],
              [
                -53.46810383131569,
                -33.56088583238101
              ],
              [
                -53.465577808396205,
                -33.55799080277238
              ],
              [
                -53.46357804025162,
                -33.55241519019279
              ],
              [
                -53.46042051160227,
                -33.54839431573636
              ],
              [
                -53.45989425682738,
                -33.5457137327654
              ],
              [
                -53.45821024154773,
                -33.541800081627805
              ],
              [
                -53.45568421862826,
                -33.539977285207556
              ],
              [
                -53.452210937113975,
                -33.53257887620772
              ],
              [
                -53.45289506832133,
                -33.53080969144689
              ],
              [
                -53.452210937113975,
                -33.527110486946974
              ],
              [
                -53.45168468233908,
                -33.52598464209917
              ],
              [
                -53.45231618806895,
                -33.52180293266448
              ],
              [
                -53.45231618806895,
                -33.51939040799062
              ],
              [
                -53.45147418042912,
                -33.51601287344722
              ],
              [
                -53.45057954731181,
                -33.51472619362116
              ],
              [
                -53.45057954731181,
                -33.51338590213568
              ],
              [
                -53.447579895094925,
                -33.508989746063314
              ],
              [
                -53.44468549383303,
                -33.50507609492572
              ],
              [
                -53.444106613580644,
                -33.50561221151991
              ],
              [
                -53.44521174860792,
                -33.507703066237255
              ],
              [
                -53.44658001102263,
                -33.511295047418336
              ],
              [
                -53.445474875995366,
                -33.51279617388207
              ],
              [
                -53.4457906288603,
                -33.515101475237095
              ],
              [
                -53.44489599574298,
                -33.51628093174431
              ],
              [
                -53.44221209639104,
                -33.51762122322979
              ],
              [
                -53.4414227142287,
                -33.51880067973701
              ],
              [
                -53.4400018263365,
                -33.51890790305585
              ],
              [
                -53.438107309146886,
                -33.516388155063154
              ],
              [
                -53.43731792698455,
                -33.513117843838586
              ],
              [
                -53.43800205819191,
                -33.510598095845886
              ],
              [
                -53.43600229004732,
                -33.50620193977352
              ],
              [
                -53.435897039092346,
                -33.50507609492572
              ],
              [
                -53.43489715502005,
                -33.5025027352736
              ],
              [
                -53.43468665311009,
                -33.50019743391858
              ],
              [
                -53.43547603527243,
                -33.49858908413601
              ],
              [
                -53.43531815883996,
                -33.497516850947626
              ],
              [
                -53.434002521902734,
                -33.496980734353436
              ],
              [
                -53.43389727094776,
                -33.495211549592604
              ],
              [
                -53.43300263783044,
                -33.493388753172354
              ],
              [
                -53.433476267127844,
                -33.49199485002746
              ],
              [
                -53.432686884965506,
                -33.4907081702014
              ],
              [
                -53.432686884965506,
                -33.487384247317415
              ],
              [
                -53.43300263783044,
                -33.48400671277401
              ],
              [
                -53.43310788878542,
                -33.47971778002048
              ],
              [
                -53.4336867690378,
                -33.47810943023791
              ],
              [
                -53.43158174993824,
                -33.475589682245214
              ],
              [
                -53.431792251848194,
                -33.47017490464388
              ],
              [
                -53.430476614910965,
                -33.46701181673815
              ],
              [
                -53.42889785058629,
                -33.46647570014396
              ],
              [
                -53.428687348676334,
                -33.46411678712952
              ],
              [
                -53.427897966513996,
                -33.46277649564404
              ],
              [
                -53.42747696269409,
                -33.46079286424554
              ],
              [
                -53.42758221364906,
                -33.45687921310794
              ],
              [
                -53.426319202189326,
                -33.4533944552457
              ],
              [
                -53.4264244531443,
                -33.449105522492175
              ],
              [
                -53.42589819836941,
                -33.44819412428205
              ],
              [
                -53.4254771945495,
                -33.442779346680716
              ],
              [
                -53.42479306334214,
                -33.44068849196337
              ],
              [
                -53.42479306334214,
                -33.43757901571706
              ],
              [
                -53.42600344932439,
                -33.42669584885498
              ],
              [
                -53.42821371937893,
                -33.41779631339141
              ],
              [
                -53.428687348676334,
                -33.41527656539871
              ],
              [
                -53.4332131397404,
                -33.40391089360187
              ],
              [
                -53.43500240597503,
                -33.39769194110925
              ],
              [
                -53.43700217411961,
                -33.392920503420946
              ],
              [
                -53.437212676029574,
                -33.39141937695722
              ],
              [
                -53.438791440354244,
                -33.386379880971816
              ],
              [
                -53.44010707729147,
                -33.38037537511688
              ],
              [
                -53.441106961363765,
                -33.37689061725464
              ],
              [
                -53.44079120849883,
                -33.37528226747206
              ],
              [
                -53.441475339706194,
                -33.37362030603007
              ],
              [
                -53.44179109257112,
                -33.37131500467505
              ],
              [
                -53.443422482373286,
                -33.36579300375488
              ],
              [
                -53.44479074478801,
                -33.363005197465085
              ],
              [
                -53.44921128489709,
                -33.3490125543567
              ],
              [
                -53.45031641992436,
                -33.34402667003072
              ],
              [
                -53.45031641992436,
                -33.34257915522641
              ],
              [
                -53.451316303996656,
                -33.34000579557429
              ],
              [
                -53.45200043520401,
                -33.336574649371464
              ],
              [
                -53.45231618806895,
                -33.33341156146574
              ],
              [
                -53.45289506832133,
                -33.329980415262916
              ],
              [
                -53.45410545430358,
                -33.32590592914706
              ],
              [
                -53.45489483646592,
                -33.32188505469063
              ],
              [
                -53.45710510652046,
                -33.31437942237196
              ],
              [
                -53.45799973963778,
                -33.309500761364816
              ],
              [
                -53.45942062752998,
                -33.30558711022722
              ],
              [
                -53.4603152606473,
                -33.304085983763486
              ],
              [
                -53.462315028791885,
                -33.297009244720165
              ],
              [
                -53.462578156179326,
                -33.29422143843037
              ],
              [
                -53.464104295026516,
                -33.2914872438
              ],
              [
                -53.46468317527889,
                -33.288806660829046
              ],
              [
                -53.4675775765408,
                -33.27969267872779
              ],
              [
                -53.4675775765408,
                -33.27647597916265
              ],
              [
                -53.46778807845075,
                -33.27261593968447
              ],
              [
                -53.469314217297935,
                -33.26591448225708
              ],
              [
                -53.46968259564036,
                -33.26012442303982
              ],
              [
                -53.469208966342954,
                -33.25540659701094
              ],
              [
                -53.46810383131569,
                -33.250795994300894
              ],
              [
                -53.46689344533343,
                -33.24672150818505
              ],
              [
                -53.46541993196374,
                -33.24420176019235
              ],
              [
                -53.46531468100876,
                -33.24318313866338
              ],
              [
                -53.46378854216158,
                -33.239698380801144
              ],
              [
                -53.4636832912066,
                -33.238626147612756
              ],
              [
                -53.46242027974686,
                -33.23648168123599
              ],
              [
                -53.45957850396245,
                -33.23347942830853
              ],
              [
                -53.45799973963778,
                -33.23112051529408
              ],
              [
                -53.4540002033486,
                -33.223775717953664
              ],
              [
                -53.45342132309622,
                -33.22222097983051
              ],
              [
                -53.45200043520401,
                -33.2207734650262
              ],
              [
                -53.45031641992436,
                -33.21568035738138
              ],
              [
                -53.44957966323952,
                -33.21299977441043
              ],
              [
                -53.448211400824796,
                -33.209407793229346
              ],
              [
                -53.446790512932594,
                -33.2047971905193
              ],
              [
                -53.4457906288603,
                -33.19970408287449
              ],
              [
                -53.44468549383303,
                -33.196004878374566
              ],
              [
                -53.44331723141831,
                -33.19418208195432
              ],
              [
                -53.441475339706194,
                -33.190214819157305
              ],
              [
                -53.44079120849883,
                -33.187105342910996
              ],
              [
                -53.43968607347156,
                -33.184585594918296
              ],
              [
                -53.43847568748931,
                -33.1831916917734
              ],
              [
                -53.435686537182384,
                -33.17161157333887
              ],
              [
                -53.43342364165036,
                -33.16651846569406
              ],
              [
                -53.4322132556681,
                -33.162122309621694
              ],
              [
                -53.4336867690378,
                -33.16169341634634
              ],
              [
                -53.43710742507459,
                -33.162122309621694
              ],
              [
                -53.435897039092346,
                -33.15740448359281
              ],
              [
                -53.433318390695376,
                -33.153222774158124
              ],
              [
                -53.42947673083867,
                -33.14448407367281
              ],
              [
                -53.42842422128889,
                -33.14132098576708
              ],
              [
                -53.42600344932439,
                -33.14067764585405
              ],
              [
                -53.4250035652521,
                -33.138694014455545
              ],
              [
                -53.42479306334214,
                -33.136174266462845
              ],
              [
                -53.422582793287596,
                -33.130384207245584
              ],
              [
                -53.42147765826032,
                -33.12850779916592
              ],
              [
                -53.421688160170284,
                -33.12668500274566
              ],
              [
                -53.419214762728295,
                -33.12400441977471
              ],
              [
                -53.41942526463825,
                -33.122020788376204
              ],
              [
                -53.41758337292613,
                -33.11687406907197
              ],
              [
                -53.41400484045687,
                -33.114407932738686
              ],
              [
                -53.41258395256467,
                -33.109904553347484
              ],
              [
                -53.411215690149945,
                -33.108081756927234
              ],
              [
                -53.40958430034778,
                -33.109314825093875
              ],
              [
                -53.41042630798761,
                -33.1116201264489
              ],
              [
                -53.410794686330036,
                -33.11649878745603
              ],
              [
                -53.4118998213573,
                -33.11741018566616
              ],
              [
                -53.41411009141185,
                -33.11730296234732
              ],
              [
                -53.41500472452916,
                -33.11832158387628
              ],
              [
                -53.41679399076379,
                -33.12287857492691
              ],
              [
                -53.41758337292613,
                -33.12357552649936
              ],
              [
                -53.41932001368327,
                -33.129097527419525
              ],
              [
                -53.422582793287596,
                -33.13542370323098
              ],
              [
                -53.42279329519755,
                -33.13912290773089
              ],
              [
                -53.421688160170284,
                -33.14078486917289
              ],
              [
                -53.42031989775556,
                -33.14657492839015
              ],
              [
                -53.42200391303522,
                -33.15627863874501
              ],
              [
                -53.4215829092153,
                -33.157779765208744
              ],
              [
                -53.42021464680059,
                -33.15928089167248
              ],
              [
                -53.41668873980881,
                -33.160996464773895
              ],
              [
                -53.411584068492374,
                -33.16131813473041
              ],
              [
                -53.40832128888805,
                -33.16131813473041
              ],
              [
                -53.40269036279671,
                -33.158315881802935
              ],
              [
                -53.400690594652126,
                -33.156493085382685
              ],
              [
                -53.40000646344476,
                -33.15450945398418
              ],
              [
                -53.3979014443452,
                -33.152901104201604
              ],
              [
                -53.39479654117334,
                -33.1509174728031
              ],
              [
                -53.393323027803646,
                -33.1495235696582
              ],
              [
                -53.39169163800148,
                -33.14732549162202
              ],
              [
                -53.390481252019235,
                -33.14448407367281
              ],
              [
                -53.389586618901916,
                -33.14309017052791
              ],
              [
                -53.38811310553222,
                -33.14330461716558
              ],
              [
                -53.38758685075733,
                -33.14040958755695
              ],
              [
                -53.38700797050495,
                -33.139283742709154
              ],
              [
                -53.38648171573006,
                -33.13681760637587
              ],
              [
                -53.38332418708071,
                -33.13590620816575
              ],
              [
                -53.38021928390886,
                -33.13209978034699
              ],
              [
                -53.371220327258214,
                -33.12539832291961
              ],
              [
                -53.368220675041336,
                -33.12282496326749
              ],
              [
                -53.36380013493225,
                -33.11671323409371
              ],
              [
                -53.36201086869762,
                -33.11542655426765
              ],
              [
                -53.357590328588536,
                -33.108993155137355
              ],
              [
                -53.35511693114655,
                -33.107492028673626
              ],
              [
                -53.35222252988464,
                -33.1051867273186
              ],
              [
                -53.35069639103746,
                -33.10352476587661
              ],
              [
                -53.34890712480283,
                -33.09998639635495
              ],
              [
                -53.345591719721014,
                -33.0945180070942
              ],
              [
                -53.34101330317946,
                -33.08840627792042
              ],
              [
                -53.33722426880024,
                -33.08261621870316
              ],
              [
                -53.33538237708812,
                -33.0743064114932
              ],
              [
                -53.333014230601115,
                -33.0689988572107
              ],
              [
                -53.32669917330242,
                -33.061278778254355
              ],
              [
                -53.32480465611281,
                -33.059884875109454
              ],
              [
                -53.322699637013244,
                -33.05618567060954
              ],
              [
                -53.319805235751346,
                -33.05479176746464
              ],
              [
                -53.318910602634034,
                -33.05629289392838
              ],
              [
                -53.31827909690416,
                -33.05977765179062
              ],
              [
                -53.317384463786844,
                -33.06149322489203
              ],
              [
                -53.317489714741825,
                -33.06460270113834
              ],
              [
                -53.318910602634034,
                -33.06567493432672
              ],
              [
                -53.32027886504875,
                -33.06551409934846
              ],
              [
                -53.322278633193335,
                -33.06379852624705
              ],
              [
                -53.32359427013056,
                -33.06379852624705
              ],
              [
                -53.325278285410214,
                -33.06519242939195
              ],
              [
                -53.326804424257396,
                -33.06808745900058
              ],
              [
                -53.328488439537054,
                -33.07328778996423
              ],
              [
                -53.32890944335696,
                -33.07902423752208
              ],
              [
                -53.32690967521238,
                -33.08299150031909
              ],
              [
                -53.322699637013244,
                -33.087602103029134
              ],
              [
                -53.31848959881412,
                -33.091891035782666
              ],
              [
                -53.31359542940763,
                -33.09559024028258
              ],
              [
                -53.29959705239553,
                -33.101005017883914
              ],
              [
                -53.2885983276003,
                -33.10470422238383
              ],
              [
                -53.277389100895114,
                -33.10942204841271
              ],
              [
                -53.27538933275053,
                -33.10781369863014
              ],
              [
                -53.27249493148863,
                -33.108993155137355
              ],
              [
                -53.26449585891028,
                -33.10947566007213
              ],
              [
                -53.26218033790076,
                -33.10872509684026
              ],
              [
                -53.26018056975617,
                -33.10738480535478
              ],
              [
                -53.257180917539294,
                -33.10239892102881
              ],
              [
                -53.25539165130466,
                -33.101219464521584
              ],
              [
                -53.25402338888995,
                -33.0992894447825
              ],
              [
                -53.25007647807826,
                -33.093177715608725
              ],
              [
                -53.24860296470857,
                -33.092480764036274
              ],
              [
                -53.24739257872632,
                -33.08792377298565
              ],
              [
                -53.245919065356624,
                -33.086315423203075
              ],
              [
                -53.2411827723826,
                -33.07607559625403
              ],
              [
                -53.23870937494061,
                -33.07521780970332
              ],
              [
                -53.236709606796026,
                -33.07189388681934
              ],
              [
                -53.235025591516376,
                -33.06958858546432
              ],
              [
                -53.232710070506855,
                -33.06771217738465
              ],
              [
                -53.22902628708261,
                -33.06331602131228
              ],
              [
                -53.2257108820008,
                -33.059884875109454
              ],
              [
                -53.223395360991276,
                -33.05908070021817
              ],
              [
                -53.2203957087744,
                -33.056400117247215
              ],
              [
                -53.219290573747124,
                -33.054416485848705
              ],
              [
                -53.216290921530245,
                -33.053290641000906
              ],
              [
                -53.21439640434064,
                -33.05119978628356
              ],
              [
                -53.21208088333112,
                -33.049323378203894
              ],
              [
                -53.20750246678956,
                -33.044980833790945
              ],
              [
                -53.201924166175715,
                -33.037904094747624
              ],
              [
                -53.201397911400825,
                -33.03768964810995
              ],
              [
                -53.198293008228966,
                -33.033400715356414
              ],
              [
                -53.19508285410213,
                -33.030505685747784
              ],
              [
                -53.19260945666014,
                -33.027181762863805
              ],
              [
                -53.19160957258785,
                -33.02428673325517
              ],
              [
                -53.18918880062335,
                -33.02149892696538
              ],
              [
                -53.18771528725365,
                -33.021016422030605
              ],
              [
                -53.18608389745149,
                -33.01951529556687
              ],
              [
                -53.183399998099546,
                -33.0153871977916
              ],
              [
                -53.181610731864914,
                -33.01190243992936
              ],
              [
                -53.17908470894544,
                -33.009597138574335
              ],
              [
                -53.178084824873146,
                -33.007077390581635
              ],
              [
                -53.17561142743116,
                -33.00498653586429
              ],
              [
                -53.17440104144891,
                -33.003485409400554
              ],
              [
                -53.173190655466655,
                -33.00032232149483
              ],
              [
                -53.17229602234934,
                -32.99898203000935
              ],
              [
                -53.17140138923203,
                -32.99549727214711
              ],
              [
                -53.16898061726753,
                -32.993996145683376
              ],
              [
                -53.16740185294285,
                -32.99018971786462
              ],
              [
                -53.16582308861818,
                -32.98777719319076
              ],
              [
                -53.16561258670822,
                -32.986597736683535
              ],
              [
                -53.163612818563635,
                -32.98391715371258
              ],
              [
                -53.16340231665368,
                -32.98091490078511
              ],
              [
                -53.162823436401304,
                -32.978609599430094
              ],
              [
                -53.16119204659914,
                -32.976411521393906
              ],
              [
                -53.159613282274464,
                -32.97340926846644
              ],
              [
                -53.15850814724719,
                -32.96778004422743
              ],
              [
                -53.15782401603983,
                -32.96649336440137
              ],
              [
                -53.156613630057585,
                -32.96188276169133
              ],
              [
                -53.156718881012566,
                -32.95930940203921
              ],
              [
                -53.15582424789525,
                -32.95518130426394
              ],
              [
                -53.154613861913,
                -32.953787401119044
              ],
              [
                -53.154403360003045,
                -32.95040986657564
              ],
              [
                -53.155192742165376,
                -32.94789011858294
              ],
              [
                -53.154824363822954,
                -32.94601371050327
              ],
              [
                -53.15587687337274,
                -32.941081437836715
              ],
              [
                -53.15571899694027,
                -32.9399019813295
              ],
              [
                -53.15640312814763,
                -32.9373822333368
              ],
              [
                -53.15819239438226,
                -32.929126037786254
              ],
              [
                -53.15898177654459,
                -32.921674017126996
              ],
              [
                -53.15871864915715,
                -32.91851092922127
              ],
              [
                -53.15887652558962,
                -32.91449005476484
              ],
              [
                -53.15850814724719,
                -32.91357865655471
              ],
              [
                -53.159192278454555,
                -32.905000791047655
              ],
              [
                -53.15850814724719,
                -32.901408809866574
              ],
              [
                -53.15887652558962,
                -32.89658376051886
              ],
              [
                -53.15808714342728,
                -32.89460012912035
              ],
              [
                -53.15850814724719,
                -32.887201720120515
              ],
              [
                -53.1575082631749,
                -32.883395292301756
              ],
              [
                -53.15708725935499,
                -32.87937441784533
              ],
              [
                -53.15871864915715,
                -32.87299463037445
              ],
              [
                -53.1579818924723,
                -32.871976008845486
              ],
              [
                -53.15782401603983,
                -32.86559622137462
              ],
              [
                -53.156508379102604,
                -32.86318369670075
              ],
              [
                -53.15682413196754,
                -32.85921643390374
              ],
              [
                -53.15561374598529,
                -32.852086083201
              ],
              [
                -53.154613861913,
                -32.84801159708515
              ],
              [
                -53.153613977840706,
                -32.8461888006649
              ],
              [
                -53.15208783899352,
                -32.83798621677377
              ],
              [
                -53.1492986886866,
                -32.83090947773045
              ],
              [
                -53.148193553659326,
                -32.82528025349144
              ],
              [
                -53.14729892054201,
                -32.81879324270173
              ],
              [
                -53.145983283604785,
                -32.81659516466555
              ],
              [
                -53.14440451928011,
                -32.81241345523086
              ],
              [
                -53.14140486706323,
                -32.80732034758604
              ],
              [
                -53.138878844143754,
                -32.804907822912185
              ],
              [
                -53.13361629639484,
                -32.800726113477495
              ],
              [
                -53.13230065945761,
                -32.79847442378189
              ],
              [
                -53.12987988749311,
                -32.796973297318154
              ],
              [
                -53.12388058305935,
                -32.79381020941243
              ],
              [
                -53.1217229384823,
                -32.79498966591965
              ],
              [
                -53.12030205059009,
                -32.796919685658736
              ],
              [
                -53.11772340219313,
                -32.79938582199202
              ],
              [
                -53.110513711777116,
                -32.80458615295567
              ],
              [
                -53.10909282388491,
                -32.8074811825643
              ],
              [
                -53.11019795891218,
                -32.80758840588314
              ],
              [
                -53.11240822896672,
                -32.805980056100566
              ],
              [
                -53.11388174233642,
                -32.80592644444115
              ],
              [
                -53.11477637545374,
                -32.8066233960136
              ],
              [
                -53.1139869932914,
                -32.8086070274121
              ],
              [
                -53.110513711777116,
                -32.810697882129446
              ],
              [
                -53.10951382770482,
                -32.81370013505692
              ],
              [
                -53.10130425321652,
                -32.82200994226688
              ],
              [
                -53.0922000456109,
                -32.82780000148414
              ],
              [
                -53.085411359014806,
                -32.8316064293029
              ],
              [
                -53.0786752978962,
                -32.83417978895502
              ],
              [
                -53.07630715140919,
                -32.83487674052746
              ],
              [
                -53.07488626351698,
                -32.834126177295595
              ],
              [
                -53.07278124441741,
                -32.83439423559269
              ],
              [
                -53.07009734506547,
                -32.83380450733908
              ],
              [
                -53.067676573100975,
                -32.831177536027546
              ],
              [
                -53.06409804063171,
                -32.82930112794788
              ],
              [
                -53.06088788650487,
                -32.82619165170157
              ],
              [
                -53.055414836846005,
                -32.8217954956292
              ],
              [
                -53.05252043558411,
                -32.81890046602057
              ],
              [
                -53.05031016552956,
                -32.81498681488298
              ],
              [
                -53.048310397384974,
                -32.813217630122146
              ],
              [
                -53.04652113115034,
                -32.81080510544829
              ],
              [
                -53.04557387255554,
                -32.808714250730944
              ],
              [
                -53.0443108610958,
                -32.80721312426721
              ],
              [
                -53.042205841996235,
                -32.803781978064386
              ],
              [
                -53.041416459833904,
                -32.80147667670936
              ],
              [
                -53.03810105475209,
                -32.79970749194853
              ],
              [
                -53.03557503183261,
                -32.797080520636996
              ],
              [
                -53.03257537961573,
                -32.794185491028365
              ],
              [
                -53.0307861133811,
                -32.793113257839984
              ],
              [
                -53.0278917121192,
                -32.79070073316612
              ],
              [
                -53.02541831467721,
                -32.789306830021225
              ],
              [
                -53.0235237974876,
                -32.78662624705027
              ],
              [
                -53.02057677074821,
                -32.783892052419894
              ],
              [
                -53.02010314145081,
                -32.78271259591267
              ],
              [
                -53.01768236948631,
                -32.781318692767776
              ],
              [
                -53.01568260134172,
                -32.77778032324612
              ],
              [
                -53.01120943575515,
                -32.77392028376794
              ],
              [
                -53.00799928162831,
                -32.770274690927444
              ],
              [
                -53.00668364469108,
                -32.769899409311506
              ],
              [
                -53.00242098101447,
                -32.765020748304366
              ],
              [
                -52.99957920523005,
                -32.763197951884116
              ],
              [
                -52.997421560652995,
                -32.761214320485614
              ],
              [
                -52.99621117467075,
                -32.762822670268186
              ],
              [
                -52.99842144472529,
                -32.76598575817391
              ],
              [
                -52.99868457211274,
                -32.767915777913004
              ],
              [
                -52.999473954275075,
                -32.76861272948545
              ],
              [
                -53.00199997719455,
                -32.77392028376794
              ],
              [
                -53.00421024724909,
                -32.781908421021384
              ],
              [
                -53.00399974533914,
                -32.78710875198504
              ],
              [
                -53.002999861266844,
                -32.79381020941243
              ],
              [
                -53.001578973374635,
                -32.797509413912344
              ],
              [
                -52.99878982306772,
                -32.80190556998471
              ],
              [
                -52.99631642562573,
                -32.80442531797741
              ],
              [
                -52.985896581082876,
                -32.81772100951335
              ],
              [
                -52.97742387920713,
                -32.82742471986821
              ],
              [
                -52.96300449837511,
                -32.842221537867886
              ],
              [
                -52.948479866588116,
                -32.85487388949079
              ],
              [
                -52.93521824626086,
                -32.86361258997611
              ],
              [
                -52.92779805393489,
                -32.86859847430208
              ],
              [
                -52.92669291890762,
                -32.869777930809306
              ],
              [
                -52.92321963739334,
                -32.87278018373677
              ],
              [
                -52.92248288070849,
                -32.87401325190341
              ],
              [
                -52.91532581576997,
                -32.881197214265576
              ],
              [
                -52.90780037248903,
                -32.88768422505529
              ],
              [
                -52.901380064235354,
                -32.892509274403004
              ],
              [
                -52.89380199547692,
                -32.897924052004335
              ],
              [
                -52.88322427450161,
                -32.903874946199856
              ],
              [
                -52.87590933313062,
                -32.906984422446165
              ],
              [
                -52.86738400577738,
                -32.909879452054795
              ],
              [
                -52.86117419943366,
                -32.91089807358376
              ],
              [
                -52.85449076379255,
                -32.91250642336633
              ],
              [
                -52.84680744407913,
                -32.91400754983007
              ],
              [
                -52.84180802371767,
                -32.913900326511225
              ],
              [
                -52.835387715463995,
                -32.91449005476484
              ],
              [
                -52.83217756133716,
                -32.91502617135903
              ],
              [
                -52.82417848875881,
                -32.91288170498227
              ],
              [
                -52.82202084418176,
                -32.912988928301104
              ],
              [
                -52.807811965259695,
                -32.910576403627246
              ],
              [
                -52.80202316273589,
                -32.90832471393164
              ],
              [
                -52.798497255744124,
                -32.90730609240268
              ],
              [
                -52.79528710161729,
                -32.90489356772882
              ],
              [
                -52.79049818316578,
                -32.903714111221596
              ],
              [
                -52.78818266215626,
                -32.90221298475786
              ],
              [
                -52.78292011440735,
                -32.89819211030143
              ],
              [
                -52.77818382143332,
                -32.89760238204782
              ],
              [
                -52.77639455519869,
                -32.89690543047537
              ],
              [
                -52.77471053991904,
                -32.8952970806928
              ],
              [
                -52.7700794979,
                -32.89309900265661
              ],
              [
                -52.768711235485284,
                -32.89202676946823
              ],
              [
                -52.76629046352078,
                -32.88918535151902
              ],
              [
                -52.763922317033774,
                -32.8880058950118
              ],
              [
                -52.76129104315932,
                -32.885807816975614
              ],
              [
                -52.75981752978962,
                -32.88382418557711
              ],
              [
                -52.75929127501473,
                -32.88221583579454
              ],
              [
                -52.75650212470781,
                -32.879803311120675
              ],
              [
                -52.75208158459872,
                -32.87347713530922
              ],
              [
                -52.75108170052643,
                -32.872726572077354
              ],
              [
                -52.74997656549915,
                -32.86870569762092
              ],
              [
                -52.74871355403942,
                -32.86607872630938
              ],
              [
                -52.74608228016496,
                -32.866025114649965
              ],
              [
                -52.74381938463293,
                -32.86377342495436
              ],
              [
                -52.743608882722974,
                -32.862915638403656
              ],
              [
                -52.74408251202038,
                -32.860020608795026
              ],
              [
                -52.742082743875784,
                -32.858787540628384
              ],
              [
                -52.740503979551114,
                -32.857286414164655
              ],
              [
                -52.74071448146107,
                -32.85541000608498
              ],
              [
                -52.73708332351432,
                -32.85262219979519
              ],
              [
                -52.735820312054585,
                -32.85197885988216
              ],
              [
                -52.73460992607233,
                -32.849191053592364
              ],
              [
                -52.73192602672039,
                -32.848601325338755
              ],
              [
                -52.730294636918224,
                -32.84742186883154
              ],
              [
                -52.730926142648094,
                -32.84538462577361
              ],
              [
                -52.73129452099052,
                -32.84238237284614
              ],
              [
                -52.728873749026015,
                -32.84200709123021
              ],
              [
                -52.7275054866113,
                -32.84061318808531
              ],
              [
                -52.72787386495372,
                -32.83739648852016
              ],
              [
                -52.72650560253901,
                -32.836806760266555
              ],
              [
                -52.72529521655676,
                -32.83450145891153
              ],
              [
                -52.72340069936715,
                -32.833911730657924
              ],
              [
                -52.72271656815979,
                -32.83278588581012
              ],
              [
                -52.721085178357626,
                -32.82919390462904
              ],
              [
                -52.72087467644767,
                -32.82699582659286
              ],
              [
                -52.71919066116802,
                -32.82608442838273
              ],
              [
                -52.7182960280507,
                -32.824583301919
              ],
              [
                -52.717085642068454,
                -32.819597417593016
              ],
              [
                -52.71582263060871,
                -32.81638071802787
              ],
              [
                -52.714612244626466,
                -32.815201261520656
              ],
              [
                -52.71308610577928,
                -32.81209178527435
              ],
              [
                -52.71198097075201,
                -32.81080510544829
              ],
              [
                -52.71208622170699,
                -32.807802852520815
              ],
              [
                -52.71161259240959,
                -32.807105900948365
              ],
              [
                -52.70887606758015,
                -32.805980056100566
              ],
              [
                -52.708402438282754,
                -32.80469337627451
              ],
              [
                -52.709612824265,
                -32.80329947312961
              ],
              [
                -52.70987595165244,
                -32.8015839000282
              ],
              [
                -52.70482390581349,
                -32.791826578013925
              ],
              [
                -52.69808784469488,
                -32.77799476988379
              ],
              [
                -52.69671958228017,
                -32.77488529363748
              ],
              [
                -52.69340417719835,
                -32.76888078778254
              ],
              [
                -52.6917201619187,
                -32.764484631710175
              ],
              [
                -52.68851000779186,
                -32.75778317428279
              ],
              [
                -52.68451047150269,
                -32.751403386811916
              ],
              [
                -52.684299969592736,
                -32.75027754196412
              ],
              [
                -52.68140556833083,
                -32.74609583252943
              ],
              [
                -52.67840591611395,
                -32.740681054928096
              ],
              [
                -52.67619564605941,
                -32.73617767553689
              ],
              [
                -52.673985376004865,
                -32.73269291767465
              ],
              [
                -52.6689859556434,
                -32.7235789355734
              ],
              [
                -52.66677568558886,
                -32.720415847667674
              ],
              [
                -52.6650916703092,
                -32.71698470146485
              ],
              [
                -52.66298665120964,
                -32.71360716692145
              ],
              [
                -52.65751360155077,
                -32.7019734368275
              ],
              [
                -52.65230367927935,
                -32.692108891494385
              ],
              [
                -52.65098804234212,
                -32.689213861885754
              ],
              [
                -52.64877777228758,
                -32.68588993900177
              ],
              [
                -52.64798839012524,
                -32.683584637646746
              ],
              [
                -52.64677800414299,
                -32.68170822956708
              ],
              [
                -52.6360950322127,
                -32.66289053711097
              ],
              [
                -52.63309537999582,
                -32.6584943810386
              ],
              [
                -52.6303062296889,
                -32.65468795321985
              ],
              [
                -52.629201094661624,
                -32.65291876845902
              ],
              [
                -52.620886269218346,
                -32.637907503821666
              ],
              [
                -52.6114136832703,
                -32.61850008311195
              ],
              [
                -52.60909816226078,
                -32.61228113061933
              ],
              [
                -52.605782757178964,
                -32.59930710903991
              ],
              [
                -52.60362511260191,
                -32.588584777156086
              ],
              [
                -52.60199372279975,
                -32.582097766366374
              ],
              [
                -52.5978889355556,
                -32.56928457976521
              ],
              [
                -52.59378414831145,
                -32.5555063832945
              ],
              [
                -52.589310982724875,
                -32.54301486664985
              ],
              [
                -52.58757434196773,
                -32.53770731236735
              ],
              [
                -52.58631133050799,
                -32.53159558319358
              ],
              [
                -52.585995577643054,
                -32.52961195179507
              ],
              [
                -52.5857850757331,
                -32.523875504237225
              ],
              [
                -52.585679824778126,
                -32.51669154187507
              ],
              [
                -52.58589032668808,
                -32.50859618130278
              ],
              [
                -52.58652183241795,
                -32.506290879947755
              ],
              [
                -52.589310982724875,
                -32.49840996601315
              ],
              [
                -52.590994998004525,
                -32.49390658662195
              ],
              [
                -52.593994650221404,
                -32.486722624259784
              ],
              [
                -52.6007833368175,
                -32.46688631027472
              ],
              [
                -52.60230947566468,
                -32.46061374612268
              ],
              [
                -52.60288835591707,
                -32.4592734546372
              ],
              [
                -52.60751939793611,
                -32.450213084195376
              ],
              [
                -52.60988754442312,
                -32.44399413170276
              ],
              [
                -52.615992099811855,
                -32.432092343311716
              ],
              [
                -52.624306925255134,
                -32.41879665177578
              ],
              [
                -52.63551615196032,
                -32.40121202748631
              ],
              [
                -52.63688441437504,
                -32.39719115302988
              ],
              [
                -52.6389894334746,
                -32.39300944359518
              ],
              [
                -52.644094104791044,
                -32.38652243280547
              ],
              [
                -52.64988290731485,
                -32.37821262559551
              ],
              [
                -52.66009224994774,
                -32.36298691432049
              ],
              [
                -52.66519692126418,
                -32.353980155538075
              ],
              [
                -52.680195182348584,
                -32.330712695350186
              ],
              [
                -52.684720973412645,
                -32.32508347111118
              ],
              [
                -52.68840475683688,
                -32.319507858531594
              ],
              [
                -52.69140440905377,
                -32.312806401104204
              ],
              [
                -52.6921937912161,
                -32.308999973285445
              ],
              [
                -52.69229904217108,
                -32.3069091185681
              ],
              [
                -52.691825412873676,
                -32.301011836031996
              ],
              [
                -52.6907202778464,
                -32.29661567995963
              ],
              [
                -52.68582610843992,
                -32.2827838718295
              ],
              [
                -52.68529985366503,
                -32.279620783923775
              ],
              [
                -52.68308958361048,
                -32.27281210317755
              ],
              [
                -52.679511051141226,
                -32.26487757758352
              ],
              [
                -52.66977533780574,
                -32.24332569049704
              ],
              [
                -52.66819657348106,
                -32.24059149586667
              ],
              [
                -52.66640730724643,
                -32.23571283485953
              ],
              [
                -52.66230252000228,
                -32.22579467786699
              ],
              [
                -52.65619796461354,
                -32.20901422846881
              ],
              [
                -52.64788313917026,
                -32.191483215838765
              ],
              [
                -52.638778931564644,
                -32.17690084447677
              ],
              [
                -52.63309537999582,
                -32.16837659062913
              ],
              [
                -52.630885109941275,
                -32.16451655115095
              ],
              [
                -52.62851696345427,
                -32.16221124979593
              ],
              [
                -52.627885457724396,
                -32.15920899686846
              ],
              [
                -52.62977997491401,
                -32.15910177354962
              ],
              [
                -52.63067460803132,
                -32.158297598658336
              ],
              [
                -52.63009572777894,
                -32.154008665904804
              ],
              [
                -52.629306345616605,
                -32.1520250345063
              ],
              [
                -52.627517079381974,
                -32.15020223808605
              ],
              [
                -52.62267553545298,
                -32.14661025690497
              ],
              [
                -52.62288603736293,
                -32.14559163537601
              ],
              [
                -52.62730657747202,
                -32.146717480223806
              ],
              [
                -52.6336742602482,
                -32.146717480223806
              ],
              [
                -52.6356214029153,
                -32.1475216551151
              ],
              [
                -52.63730541819495,
                -32.14891555825999
              ],
              [
                -52.64077869970923,
                -32.150523908042565
              ],
              [
                -52.645883371025676,
                -32.1522930928034
              ],
              [
                -52.6481988920352,
                -32.151810587868624
              ],
              [
                -52.651303795207056,
                -32.15261476275991
              ],
              [
                -52.654303447423935,
                -32.15272198607875
              ],
              [
                -52.65877661301051,
                -32.153579772629456
              ],
              [
                -52.66151313783995,
                -32.15497367577435
              ],
              [
                -52.66419703719189,
                -32.156099520622156
              ],
              [
                -52.666986187498814,
                -32.15808315202066
              ],
              [
                -52.66988058876071,
                -32.159423443506135
              ],
              [
                -52.67198560786028,
                -32.16199680315825
              ],
              [
                -52.67251186263517,
                -32.16312264800606
              ],
              [
                -52.67498526007716,
                -32.16398043455676
              ],
              [
                -52.68087931355594,
                -32.163605152940825
              ],
              [
                -52.68572085748494,
                -32.16129985158581
              ],
              [
                -52.6892993899542,
                -32.16049567669452
              ],
              [
                -52.69108865618883,
                -32.159423443506135
              ],
              [
                -52.694193559360684,
                -32.15872649193369
              ],
              [
                -52.69529869438796,
                -32.15642119057867
              ],
              [
                -52.70119274786674,
                -32.15529534573086
              ],
              [
                -52.70661317204812,
                -32.15508089909319
              ],
              [
                -52.71040220642734,
                -32.155402569049706
              ],
              [
                -52.71561212869876,
                -32.15449117083958
              ],
              [
                -52.717717147798325,
                -32.15497367577435
              ],
              [
                -52.718874908303086,
                -32.15422311254248
              ],
              [
                -52.72518996560178,
                -32.15508089909319
              ],
              [
                -52.72997888405329,
                -32.15711814215111
              ],
              [
                -52.73171552481043,
                -32.15797592870182
              ],
              [
                -52.732189154107836,
                -32.15969150180323
              ],
              [
                -52.72650560253901,
                -32.16317625966548
              ],
              [
                -52.72487421273684,
                -32.167197134121906
              ],
              [
                -52.7246110853494,
                -32.16869826058564
              ],
              [
                -52.72050629810525,
                -32.17041383368706
              ],
              [
                -52.71729614397841,
                -32.169019930542156
              ],
              [
                -52.715401626788804,
                -32.16687546416539
              ],
              [
                -52.710981086679716,
                -32.16532072604224
              ],
              [
                -52.710086453562404,
                -32.16451655115095
              ],
              [
                -52.70871819114768,
                -32.16092456996987
              ],
              [
                -52.707086801345525,
                -32.159584278484395
              ],
              [
                -52.7057185389308,
                -32.159584278484395
              ],
              [
                -52.702824137668905,
                -32.15899455023079
              ],
              [
                -52.70287676314639,
                -32.16081734665104
              ],
              [
                -52.70650792109314,
                -32.16242569643361
              ],
              [
                -52.7071920523005,
                -32.1638195995785
              ],
              [
                -52.70661317204812,
                -32.16478460944805
              ],
              [
                -52.70461340390354,
                -32.165213502723404
              ],
              [
                -52.70098224595679,
                -32.1654815610205
              ],
              [
                -52.69940348163211,
                -32.164999056085726
              ],
              [
                -52.69771946635246,
                -32.16317625966548
              ],
              [
                -52.69682483323514,
                -32.16398043455676
              ],
              [
                -52.69708796062259,
                -32.166124900933525
              ],
              [
                -52.69829834660484,
                -32.167518804078426
              ],
              [
                -52.70019286379445,
                -32.16800130901319
              ],
              [
                -52.702297882894015,
                -32.16789408569436
              ],
              [
                -52.70640267013816,
                -32.16687546416539
              ],
              [
                -52.70798143446284,
                -32.167411580759584
              ],
              [
                -52.709191820445085,
                -32.16880548390448
              ],
              [
                -52.71271772743686,
                -32.16821575565087
              ],
              [
                -52.71387548794162,
                -32.168483813947965
              ],
              [
                -52.714085989851576,
                -32.171378843556596
              ],
              [
                -52.715506877743785,
                -32.17207579512905
              ],
              [
                -52.71671726372603,
                -32.17121800857834
              ],
              [
                -52.7188222828256,
                -32.17261191172324
              ],
              [
                -52.72161143313252,
                -32.17239746508556
              ],
              [
                -52.72540046751173,
                -32.17089633862183
              ],
              [
                -52.7275054866113,
                -32.17052105700589
              ],
              [
                -52.72761073756628,
                -32.16891270722332
              ],
              [
                -52.728978999980995,
                -32.16730435744075
              ],
              [
                -52.73239965601779,
                -32.16601767761469
              ],
              [
                -52.73292591079268,
                -32.16510627940456
              ],
              [
                -52.73539930823467,
                -32.16478460944805
              ],
              [
                -52.7386094623615,
                -32.16510627940456
              ],
              [
                -52.73797795663164,
                -32.16789408569436
              ],
              [
                -52.7367149451719,
                -32.16869826058564
              ],
              [
                -52.73682019612688,
                -32.171700513513116
              ],
              [
                -52.739714597388776,
                -32.17261191172324
              ],
              [
                -52.74097760884852,
                -32.174113038186974
              ],
              [
                -52.745398148957605,
                -32.17491721307826
              ],
              [
                -52.74371413367795,
                -32.17657917452025
              ],
              [
                -52.74097760884852,
                -32.17529249469419
              ],
              [
                -52.7371885744693,
                -32.174809989759424
              ],
              [
                -52.73650444326194,
                -32.177008067795605
              ],
              [
                -52.737925331154145,
                -32.17668639783909
              ],
              [
                -52.7400829757312,
                -32.17791946600573
              ],
              [
                -52.74118811075847,
                -32.18140422386797
              ],
              [
                -52.74108285980349,
                -32.182422845396935
              ],
              [
                -52.73892521522644,
                -32.18199395212158
              ],
              [
                -52.73608343944203,
                -32.18022476736075
              ],
              [
                -52.73550455918965,
                -32.180814495614364
              ],
              [
                -52.735188806324715,
                -32.18349507858532
              ],
              [
                -52.73692544708185,
                -32.18397758352009
              ],
              [
                -52.7371885744693,
                -32.18558593330266
              ],
              [
                -52.73418892225242,
                -32.187301506404076
              ],
              [
                -52.72882112354853,
                -32.18837373959246
              ],
              [
                -52.727715988521254,
                -32.18740872972291
              ],
              [
                -52.72671610444896,
                -32.19089348758515
              ],
              [
                -52.72850537068359,
                -32.19287711898366
              ],
              [
                -52.7279791159087,
                -32.19432463378798
              ],
              [
                -52.730820891693114,
                -32.19491436204159
              ],
              [
                -52.73150502290047,
                -32.19641548850532
              ],
              [
                -52.731978652197874,
                -32.200221916324075
              ],
              [
                -52.732610157927745,
                -32.20102609121536
              ],
              [
                -52.734294173207395,
                -32.20011469300524
              ],
              [
                -52.7328206598377,
                -32.194378245447396
              ],
              [
                -52.73050513882818,
                -32.19228739073005
              ],
              [
                -52.73008413500827,
                -32.19100071090399
              ],
              [
                -52.73108401908056,
                -32.18928513780258
              ],
              [
                -52.73460992607233,
                -32.18987486605619
              ],
              [
                -52.73639919230696,
                -32.18928513780258
              ],
              [
                -52.737293825424274,
                -32.19019653601271
              ],
              [
                -52.738293709496574,
                -32.19239461404889
              ],
              [
                -52.741398612668426,
                -32.19287711898366
              ],
              [
                -52.74550339991258,
                -32.19169766247644
              ],
              [
                -52.749187183336815,
                -32.19218016741121
              ],
              [
                -52.751502704346336,
                -32.193306012259015
              ],
              [
                -52.75350247249093,
                -32.19480713872275
              ],
              [
                -52.75492336038313,
                -32.19507519701985
              ],
              [
                -52.75739675782512,
                -32.19759494501254
              ],
              [
                -52.76139629411429,
                -32.198023838287895
              ],
              [
                -52.7628171820065,
                -32.1988816248386
              ],
              [
                -52.76292243296148,
                -32.20048997462117
              ],
              [
                -52.762080425321656,
                -32.20188387776607
              ],
              [
                -52.765606332313425,
                -32.20188387776607
              ],
              [
                -52.7686059845303,
                -32.20231277104142
              ],
              [
                -52.770289999809954,
                -32.204189179121094
              ],
              [
                -52.76907961382771,
                -32.206226422179014
              ],
              [
                -52.76760610045801,
                -32.205100577331216
              ],
              [
                -52.764816950151086,
                -32.2047789073747
              ],
              [
                -52.763290811303904,
                -32.20429640243993
              ],
              [
                -52.76292243296148,
                -32.20847811187462
              ],
              [
                -52.75971227883464,
                -32.208210053577524
              ],
              [
                -52.75971227883464,
                -32.21062257825138
              ],
              [
                -52.75839664189741,
                -32.21051535493255
              ],
              [
                -52.757817761645036,
                -32.20879978183113
              ],
              [
                -52.75671262661776,
                -32.207620325323916
              ],
              [
                -52.75439710560824,
                -32.206387257157274
              ],
              [
                -52.75197633364374,
                -32.206387257157274
              ],
              [
                -52.749292434291796,
                -32.207620325323916
              ],
              [
                -52.748397801174484,
                -32.20901422846881
              ],
              [
                -52.74329312985804,
                -32.21421455943246
              ],
              [
                -52.739977724776224,
                -32.21512595764259
              ],
              [
                -52.73808320758661,
                -32.214911511004914
              ],
              [
                -52.73592556300956,
                -32.2131959379035
              ],
              [
                -52.73297853627017,
                -32.20912145178765
              ],
              [
                -52.730926142648094,
                -32.208907005149975
              ],
              [
                -52.73071564073814,
                -32.207995606939846
              ],
              [
                -52.732504906972764,
                -32.2059047522225
              ],
              [
                -52.73550455918965,
                -32.20520780065006
              ],
              [
                -52.73950409547882,
                -32.20628003383844
              ],
              [
                -52.74108285980349,
                -32.20740587868624
              ],
              [
                -52.74318787890306,
                -32.20670892711379
              ],
              [
                -52.742293245785746,
                -32.20542224728773
              ],
              [
                -52.739609346433795,
                -32.204725295715285
              ],
              [
                -52.738293709496574,
                -32.202902499295035
              ],
              [
                -52.736978072559346,
                -32.202205547722585
              ],
              [
                -52.735188806324715,
                -32.203492227548644
              ],
              [
                -52.72940000380091,
                -32.20558308226599
              ],
              [
                -52.728978999980995,
                -32.20681615043263
              ],
              [
                -52.72850537068359,
                -32.211105083186155
              ],
              [
                -52.728873749026015,
                -32.21228453969338
              ],
              [
                -52.73239965601779,
                -32.21389288947595
              ],
              [
                -52.73308378722515,
                -32.216519860787486
              ],
              [
                -52.734820427982285,
                -32.21769931729471
              ],
              [
                -52.7371885744693,
                -32.21737764733819
              ],
              [
                -52.73818845854159,
                -32.21818182222948
              ],
              [
                -52.739188342613886,
                -32.2202190652874
              ],
              [
                -52.73992509929873,
                -32.2204871235845
              ],
              [
                -52.7425037476957,
                -32.22011184196857
              ],
              [
                -52.74392463558791,
                -32.219414890396116
              ],
              [
                -52.74729266614721,
                -32.214000112794785
              ],
              [
                -52.75039756931907,
                -32.21148036480209
              ],
              [
                -52.75208158459872,
                -32.211212306505
              ],
              [
                -52.754975985860625,
                -32.21169481143977
              ],
              [
                -52.75739675782512,
                -32.21367844283827
              ],
              [
                -52.75808088903248,
                -32.21480428768608
              ],
              [
                -52.76092266481689,
                -32.21732403567877
              ],
              [
                -52.762396178186584,
                -32.21920044375844
              ],
              [
                -52.76350131321386,
                -32.221398521794626
              ],
              [
                -52.764711699196106,
                -32.22177380341056
              ],
              [
                -52.76697459472814,
                -32.22418632808442
              ],
              [
                -52.76929011573766,
                -32.224883279656865
              ],
              [
                -52.773500153936794,
                -32.2289041541133
              ],
              [
                -52.77681555901861,
                -32.23061972721471
              ],
              [
                -52.77707868640605,
                -32.23389003843928
              ],
              [
                -52.778025945000856,
                -32.23490865996824
              ],
              [
                -52.779183705505616,
                -32.23748201962036
              ],
              [
                -52.779183705505616,
                -32.24000176761305
              ],
              [
                -52.77839432334328,
                -32.2446123703231
              ],
              [
                -52.77981521123549,
                -32.246810448359284
              ],
              [
                -52.77839432334328,
                -32.250777711156296
              ],
              [
                -52.77839432334328,
                -32.252225225960615
              ],
              [
                -52.781025597217734,
                -32.25490580893157
              ],
              [
                -52.78170972842509,
                -32.25710388696775
              ],
              [
                -52.78302536536232,
                -32.25839056679381
              ],
              [
                -52.78391999847964,
                -32.26262588788792
              ],
              [
                -52.78491988255193,
                -32.26519924754003
              ],
              [
                -52.78418312586708,
                -32.26718287893854
              ],
              [
                -52.78407787491211,
                -32.269488180293564
              ],
              [
                -52.7860250175792,
                -32.270185131866015
              ],
              [
                -52.787498530948895,
                -32.27007790854717
              ],
              [
                -52.789287797183526,
                -32.26868400540228
              ],
              [
                -52.793024206085256,
                -32.26841594710518
              ],
              [
                -52.79502397422984,
                -32.26980985025008
              ],
              [
                -52.79681324046447,
                -32.2721151516051
              ],
              [
                -52.79749737167183,
                -32.27608241440211
              ],
              [
                -52.79660273855451,
                -32.27720825924992
              ],
              [
                -52.79481347231989,
                -32.277101035931075
              ],
              [
                -52.79028768125582,
                -32.27929911396726
              ],
              [
                -52.78870891693115,
                -32.27919189064842
              ],
              [
                -52.78907729527357,
                -32.280800240431
              ],
              [
                -52.79449771945495,
                -32.279084667329585
              ],
              [
                -52.79349783538266,
                -32.28358804672079
              ],
              [
                -52.79649748759954,
                -32.28589334807581
              ],
              [
                -52.79649748759954,
                -32.29018228082934
              ],
              [
                -52.79818150287919,
                -32.29388148532926
              ],
              [
                -52.80307567228568,
                -32.30631939031449
              ],
              [
                -52.80407555635797,
                -32.30991137149557
              ],
              [
                -52.80402293088048,
                -32.31109082800279
              ],
              [
                -52.807390961439786,
                -32.31237750782885
              ],
              [
                -52.80802246716966,
                -32.31468280918387
              ],
              [
                -52.80691733214238,
                -32.31827479036495
              ],
              [
                -52.80770671430472,
                -32.319507858531594
              ],
              [
                -52.81202200345883,
                -32.318596460321466
              ],
              [
                -52.81317976396359,
                -32.31961508185043
              ],
              [
                -52.81381126969346,
                -32.322402888140225
              ],
              [
                -52.81317976396359,
                -32.32470818949525
              ],
              [
                -52.80939072958437,
                -32.32578042268363
              ],
              [
                -52.80660157927745,
                -32.32631653927782
              ],
              [
                -52.8049175639978,
                -32.32760321910388
              ],
              [
                -52.80060227484369,
                -32.3346799581472
              ],
              [
                -52.80139165700602,
                -32.335323298060224
              ],
              [
                -52.803286174195634,
                -32.33387578325591
              ],
              [
                -52.805706946160136,
                -32.33012296709657
              ],
              [
                -52.80849609646705,
                -32.32771044242271
              ],
              [
                -52.81628466713545,
                -32.32578042268363
              ],
              [
                -52.817495053117696,
                -32.325994869321306
              ],
              [
                -52.81870543909994,
                -32.3273887724662
              ],
              [
                -52.820494705334575,
                -32.33108797696612
              ],
              [
                -52.821126211064445,
                -32.33409022989359
              ],
              [
                -52.820494705334575,
                -32.339826677451434
              ],
              [
                -52.8193895703073,
                -32.34261448374122
              ],
              [
                -52.81702142382029,
                -32.347278698110685
              ],
              [
                -52.81291663657614,
                -32.351085125929444
              ],
              [
                -52.80881184933199,
                -32.353604873922144
              ],
              [
                -52.80628582641251,
                -32.35392654387866
              ],
              [
                -52.80002339459131,
                -32.35242541741492
              ],
              [
                -52.79507659970733,
                -32.34770759138604
              ],
              [
                -52.79091918698569,
                -32.34352588195135
              ],
              [
                -52.78949829909348,
                -32.343096988675995
              ],
              [
                -52.78728802903894,
                -32.34529506671218
              ],
              [
                -52.78660389783158,
                -32.34969122278455
              ],
              [
                -52.782814863452366,
                -32.35060262099467
              ],
              [
                -52.7792889564606,
                -32.351085125929444
              ],
              [
                -52.77692080997358,
                -32.353015145668536
              ],
              [
                -52.78128872460518,
                -32.35247902907434
              ],
              [
                -52.785814515669244,
                -32.35569572863949
              ],
              [
                -52.78849841502119,
                -32.35558850532065
              ],
              [
                -52.79028768125582,
                -32.35478433042936
              ],
              [
                -52.79391883920257,
                -32.355374058682976
              ],
              [
                -52.79439246849997,
                -32.356875185146706
              ],
              [
                -52.7957081054372,
                -32.35751852505974
              ],
              [
                -52.79807625192421,
                -32.355213223704716
              ],
              [
                -52.80160215891598,
                -32.357625748378574
              ],
              [
                -52.80318092324065,
                -32.35982382641476
              ],
              [
                -52.801496907961,
                -32.36352303091468
              ],
              [
                -52.7996023907714,
                -32.36598916724795
              ],
              [
                -52.79928663790646,
                -32.36727584707401
              ],
              [
                -52.797813124536766,
                -32.368616138559496
              ],
              [
                -52.79418196659002,
                -32.37488870271153
              ],
              [
                -52.79202432201296,
                -32.3776228973419
              ],
              [
                -52.790077179345865,
                -32.378802353849125
              ],
              [
                -52.78791953476881,
                -32.37692594576946
              ],
              [
                -52.785814515669244,
                -32.37580010092165
              ],
              [
                -52.78370949656968,
                -32.37370924620431
              ],
              [
                -52.772605520819475,
                -32.3678119636682
              ],
              [
                -52.772710771774456,
                -32.36089605960314
              ],
              [
                -52.77471053991904,
                -32.35569572863949
              ],
              [
                -52.7739737832342,
                -32.35371209724098
              ],
              [
                -52.77171088770216,
                -32.35258625239318
              ],
              [
                -52.76881648644026,
                -32.35381932055982
              ],
              [
                -52.762501429141565,
                -32.35558850532065
              ],
              [
                -52.75692312852772,
                -32.3588052048858
              ],
              [
                -52.74971343811171,
                -32.36228996274804
              ],
              [
                -52.73018938596324,
                -32.36711501209576
              ],
              [
                -52.724190081529485,
                -32.37001004170439
              ],
              [
                -52.72308494650221,
                -32.374620644414435
              ],
              [
                -52.72361120127711,
                -32.38159016013891
              ],
              [
                -52.72597934776412,
                -32.385718257914185
              ],
              [
                -52.732189154107836,
                -32.392580550319835
              ],
              [
                -52.73782008019917,
                -32.39890672613129
              ],
              [
                -52.742924751515616,
                -32.403999833776105
              ],
              [
                -52.74718741519223,
                -32.408717659804985
              ],
              [
                -52.750713322184005,
                -32.411987971029546
              ],
              [
                -52.75481810942816,
                -32.41622329212366
              ],
              [
                -52.76229092723161,
                -32.42212057465976
              ],
              [
                -52.76639571447576,
                -32.42619506077561
              ],
              [
                -52.780394091487864,
                -32.43648849938408
              ],
              [
                -52.785919766624225,
                -32.43970519894923
              ],
              [
                -52.79160331819305,
                -32.442117723623085
              ],
              [
                -52.79891825956403,
                -32.44560248148533
              ],
              [
                -52.80239154107832,
                -32.446996384630225
              ],
              [
                -52.80660157927745,
                -32.44790778284035
              ],
              [
                -52.815074281153194,
                -32.45010586087653
              ],
              [
                -52.82070520724453,
                -32.45128531738376
              ],
              [
                -52.829020032687815,
                -32.45262560886923
              ],
              [
                -52.83449308234668,
                -32.45391228869529
              ],
              [
                -52.846491691214204,
                -32.45519896852135
              ],
              [
                -52.85612215359471,
                -32.45670009498509
              ],
              [
                -52.86312134210076,
                -32.45707537660102
              ],
              [
                -52.87412006689599,
                -32.45830844476766
              ],
              [
                -52.88511879169121,
                -32.46018485284733
              ],
              [
                -52.88911832798039,
                -32.46050652280384
              ],
              [
                -52.89238110758471,
                -32.461096251057455
              ],
              [
                -52.899696048955704,
                -32.46270460084003
              ],
              [
                -52.915115313860014,
                -32.46661825197762
              ],
              [
                -52.91958847944659,
                -32.46758326184717
              ],
              [
                -52.92769280297991,
                -32.4702102331587
              ],
              [
                -52.93158708831411,
                -32.47192580626011
              ],
              [
                -52.93990191375739,
                -32.474874447528165
              ],
              [
                -52.955110676751744,
                -32.48259452648451
              ],
              [
                -52.95932071495088,
                -32.484899827839534
              ],
              [
                -52.962215116212775,
                -32.486883459238044
              ],
              [
                -52.96800391873658,
                -32.490475440419125
              ],
              [
                -52.96979318497121,
                -32.4920837902017
              ],
              [
                -52.9703194397461,
                -32.49390658662195
              ],
              [
                -52.97247708432315,
                -32.4946035381944
              ],
              [
                -52.97810801041449,
                -32.49899969426676
              ],
              [
                -52.983317932685914,
                -32.50420002523041
              ],
              [
                -52.98768584731751,
                -32.51057981270129
              ],
              [
                -52.984212565803226,
                -32.51508319209249
              ],
              [
                -52.987212218020105,
                -32.523875504237225
              ],
              [
                -52.98858048043483,
                -32.53770731236735
              ],
              [
                -52.99189588551664,
                -32.54521294468603
              ],
              [
                -52.99421140652616,
                -32.57507463898247
              ],
              [
                -52.995474417985896,
                -32.58268749461999
              ],
              [
                -52.997421560652995,
                -32.59121174846762
              ],
              [
                -53.0007895912123,
                -32.59791320589501
              ],
              [
                -53.009314918565536,
                -32.60772413956871
              ],
              [
                -53.014893219179385,
                -32.61099445079327
              ],
              [
                -53.02010314145081,
                -32.61308530551062
              ],
              [
                -53.0293126000114,
                -32.61421115035842
              ],
              [
                -53.043100475113555,
                -32.61362142210481
              ],
              [
                -53.05409919990878,
                -32.61539060686564
              ],
              [
                -53.06299290560444,
                -32.618124801496016
              ],
              [
                -53.069992094110496,
                -32.62219928761187
              ],
              [
                -53.07699128261655,
                -32.627774900191454
              ],
              [
                -53.07967518196849,
                -32.6335113477493
              ],
              [
                -53.080780316995764,
                -32.63747861054631
              ],
              [
                -53.08041193865334,
                -32.64702148592291
              ],
              [
                -53.083095838005285,
                -32.64787927247362
              ],
              [
                -53.08367471825766,
                -32.656725196277776
              ],
              [
                -53.08462197685247,
                -32.658226322741505
              ],
              [
                -53.09041077937627,
                -32.65329405007495
              ],
              [
                -53.10851394363253,
                -32.64300061146648
              ],
              [
                -53.11940741747278,
                -32.639891135220175
              ],
              [
                -53.128406374123415,
                -32.638497232075274
              ],
              [
                -53.14672004028963,
                -32.64058808679262
              ],
              [
                -53.166717721735495,
                -32.64857622404607
              ],
              [
                -53.176400809593495,
                -32.6584943810386
              ],
              [
                -53.18061084779262,
                -32.65500962317636
              ],
              [
                -53.1821896121173,
                -32.65270432182134
              ],
              [
                -53.18308424523461,
                -32.648415389067814
              ],
              [
                -53.18439988217184,
                -32.64648536932872
              ],
              [
                -53.186504901271405,
                -32.64487701954615
              ],
              [
                -53.18982030635322,
                -32.642786164828806
              ],
              [
                -53.1932935878675,
                -32.64160670832158
              ],
              [
                -53.1971878732017,
                -32.64090975674914
              ],
              [
                -53.20271354833805,
                -32.64021280517669
              ],
              [
                -53.209291733024195,
                -32.63978391190133
              ],
              [
                -53.214712157205575,
                -32.638818902031794
              ],
              [
                -53.221185090936736,
                -32.63651360067677
              ],
              [
                -53.23049980045231,
                -32.63270717285801
              ],
              [
                -53.23707798513845,
                -32.62981214324938
              ],
              [
                -53.24049864117524,
                -32.627077948619004
              ],
              [
                -53.24349829339212,
                -32.623217909140834
              ],
              [
                -53.24418242459948,
                -32.61962592795975
              ],
              [
                -53.24418242459948,
                -32.61421115035842
              ],
              [
                -53.24560331249169,
                -32.60708079965568
              ],
              [
                -53.24949759782588,
                -32.60322076017751
              ],
              [
                -53.25491802200726,
                -32.601987692010866
              ],
              [
                -53.260285820711154,
                -32.602523808605056
              ],
              [
                -53.26402222961288,
                -32.60370326511227
              ],
              [
                -53.26860064615443,
                -32.60407854672821
              ],
              [
                -53.271810800281266,
                -32.60520439157601
              ],
              [
                -53.27470520154317,
                -32.60750969293103
              ],
              [
                -53.27781010471503,
                -32.611476955728044
              ],
              [
                -53.27849423592239,
                -32.61421115035842
              ],
              [
                -53.27781010471503,
                -32.61678451001054
              ],
              [
                -53.27859948687736,
                -32.61860730643079
              ],
              [
                -53.281388637184286,
                -32.62059093782929
              ],
              [
                -53.28438828940117,
                -32.621395112720585
              ],
              [
                -53.28880882951025,
                -32.621073442764065
              ],
              [
                -53.29217686006956,
                -32.61951870464091
              ],
              [
                -53.2968079020886,
                -32.61608755843809
              ],
              [
                -53.30317558486478,
                -32.60681274135858
              ],
              [
                -53.30717512115395,
                -32.60338159515576
              ],
              [
                -53.31317442558772,
                -32.599092662402235
              ],
              [
                -53.31959473384139,
                -32.59598318615593
              ],
              [
                -53.324488903247875,
                -32.59190870004007
              ],
              [
                -53.329804076474275,
                -32.58912089375028
              ],
              [
                -53.33101446245653,
                -32.5869228157141
              ],
              [
                -53.33322473251107,
                -32.584992795975005
              ],
              [
                -53.336013882817994,
                -32.58418862108372
              ],
              [
                -53.33880303312492,
                -32.584617514359074
              ],
              [
                -53.34059229935955,
                -32.58611864082281
              ],
              [
                -53.34380245348638,
                -32.58981784532273
              ],
              [
                -53.346223225450885,
                -32.59158703008356
              ],
              [
                -53.34901237575781,
                -32.59217675833717
              ],
              [
                -53.352696159182045,
                -32.59190870004007
              ],
              [
                -53.35548530948897,
                -32.59062202021401
              ],
              [
                -53.357379826678574,
                -32.58869200047493
              ],
              [
                -53.36001110055303,
                -32.58258027130115
              ],
              [
                -53.36127411201277,
                -32.58038219326497
              ],
              [
                -53.36358963302229,
                -32.57759438697517
              ],
              [
                -53.366010404986795,
                -32.57539630893899
              ],
              [
                -53.36969418841103,
                -32.56987430801882
              ],
              [
                -53.37279909158289,
                -32.569713473040565
              ],
              [
                -53.37658812596211,
                -32.570624871250686
              ],
              [
                -53.37869314506167,
                -32.57158988112023
              ],
              [
                -53.37990353104392,
                -32.57469935736654
              ],
              [
                -53.38021928390886,
                -32.57829133854762
              ],
              [
                -53.38500820236037,
                -32.585314465931525
              ],
              [
                -53.38811310553222,
                -32.5869228157141
              ],
              [
                -53.39000762272183,
                -32.58649392243874
              ],
              [
                -53.39390190805603,
                -32.58429584440256
              ],
              [
                -53.39921708128243,
                -32.582204989685216
              ],
              [
                -53.40337449400407,
                -32.58000691164903
              ],
              [
                -53.40569001501359,
                -32.577916056931684
              ],
              [
                -53.41232082517722,
                -32.572608502649196
              ],
              [
                -53.41658348885384,
                -32.56799789993915
              ],
              [
                -53.41721499458371,
                -32.56628232683774
              ],
              [
                -53.41647823789886,
                -32.56328007391027
              ],
              [
                -53.417425496493664,
                -32.56092116089583
              ],
              [
                -53.42179341112526,
                -32.558294189584295
              ],
              [
                -53.42468781238716,
                -32.5588839178379
              ],
              [
                -53.42600344932439,
                -32.56199339408421
              ],
              [
                -53.42658232957677,
                -32.565210093649355
              ],
              [
                -53.427897966513996,
                -32.566121491859484
              ],
              [
                -53.42979248370361,
                -32.56638955015658
              ],
              [
                -53.43142387350577,
                -32.56601426854064
              ],
              [
                -53.432423757578064,
                -32.56488842369284
              ],
              [
                -53.43310788878542,
                -32.5627975689755
              ],
              [
                -53.433581518082825,
                -32.556685839801716
              ],
              [
                -53.43558128622741,
                -32.55111022722213
              ],
              [
                -53.43689692316464,
                -32.5482151976135
              ],
              [
                -53.44331723141831,
                -32.53797537066445
              ],
              [
                -53.44621163268021,
                -32.53411533118628
              ],
              [
                -53.44947441228454,
                -32.528593330266105
              ],
              [
                -53.45342132309622,
                -32.52601997061399
              ],
              [
                -53.457526110340375,
                -32.52232076611407
              ],
              [
                -53.45810499059275,
                -32.52060519301266
              ],
              [
                -53.457789237727816,
                -32.518782396592414
              ],
              [
                -53.45657885174557,
                -32.51669154187507
              ],
              [
                -53.457526110340375,
                -32.51449346383888
              ],
              [
                -53.46131514471959,
                -32.510097307766515
              ],
              [
                -53.461525646629546,
                -32.50779200641149
              ],
              [
                -53.46352541477413,
                -32.50269889876668
              ],
              [
                -53.46199927592695,
                -32.50039359741166
              ],
              [
                -53.46210452688192,
                -32.498302742694314
              ],
              [
                -53.46541993196374,
                -32.49492520815091
              ],
              [
                -53.46652506699101,
                -32.49331685836834
              ],
              [
                -53.4661040631711,
                -32.491976566882855
              ],
              [
                -53.46357804025162,
                -32.48972487718726
              ],
              [
                -53.462578156179326,
                -32.48758041081049
              ],
              [
                -53.4632096619092,
                -32.48602567268733
              ],
              [
                -53.464420047891444,
                -32.48468538120186
              ],
              [
                -53.469208966342954,
                -32.48248730316568
              ],
              [
                -53.47089298162261,
                -32.480718118404845
              ],
              [
                -53.47810267203862,
                -32.483773982991735
              ],
              [
                -53.48099707330052,
                -32.48388120631057
              ],
              [
                -53.48552286436458,
                -32.483613148013475
              ],
              [
                -53.49141691784337,
                -32.481790351593226
              ],
              [
                -53.49341668598795,
                -32.48152229329613
              ],
              [
                -53.49567958151999,
                -32.48168312827439
              ],
              [
                -53.49957386685418,
                -32.48098617670194
              ],
              [
                -53.50241564263859,
                -32.48130784665845
              ],
              [
                -53.50788869229746,
                -32.483077031419285
              ],
              [
                -53.5096253330546,
                -32.48468538120186
              ],
              [
                -53.51120409737928,
                -32.486883459238044
              ],
              [
                -53.5135196183888,
                -32.48731235251339
              ],
              [
                -53.51451950246109,
                -32.48870625565829
              ],
              [
                -53.517098150858054,
                -32.489188760593066
              ],
              [
                -53.51778228206541,
                -32.48838458570178
              ],
              [
                -53.51620351774074,
                -32.48607928434676
              ],
              [
                -53.51530888462343,
                -32.48398842962941
              ],
              [
                -53.51599301583079,
                -32.48248730316568
              ],
              [
                -53.520308304984894,
                -32.48109340002078
              ],
              [
                -53.52278170242688,
                -32.481790351593226
              ],
              [
                -53.52362371006671,
                -32.48280897312219
              ],
              [
                -53.522518575039435,
                -32.48618650766559
              ],
              [
                -53.52441309222905,
                -32.48859903233945
              ],
              [
                -53.52641286037363,
                -32.48897431395539
              ],
              [
                -53.52862313042817,
                -32.48800930408584
              ],
              [
                -53.529623014500466,
                -32.4867762359192
              ],
              [
                -53.52830737756324,
                -32.48538233277431
              ],
              [
                -53.52841262851822,
                -32.48441732290476
              ],
              [
                -53.53109652787016,
                -32.48248730316568
              ],
              [
                -53.53288579410479,
                -32.48221924486858
              ],
              [
                -53.53630645014159,
                -32.480718118404845
              ],
              [
                -53.53851672019613,
                -32.48039644844833
              ],
              [
                -53.53988498261084,
                -32.48082534172368
              ],
              [
                -53.54162162336799,
                -32.48028922512949
              ],
              [
                -53.54351614055759,
                -32.47910976862227
              ],
              [
                -53.54362139151257,
                -32.47787670045563
              ],
              [
                -53.54067436477318,
                -32.4761075156948
              ],
              [
                -53.539990233565824,
                -32.475088894165836
              ],
              [
                -53.540884866683136,
                -32.472890816129656
              ],
              [
                -53.54277938387275,
                -32.47331970940501
              ],
              [
                -53.547199923981836,
                -32.472890816129656
              ],
              [
                -53.551883591478365,
                -32.47331970940501
              ],
              [
                -53.55262034816321,
                -32.47390943765862
              ],
              [
                -53.55519899656018,
                -32.47337332106443
              ],
              [
                -53.55640938254243,
                -32.47267636949198
              ],
              [
                -53.559777413101735,
                -32.4688163300138
              ],
              [
                -53.56219818506623,
                -32.46661825197762
              ],
              [
                -53.56351382200346,
                -32.463991280666086
              ],
              [
                -53.565618841103024,
                -32.461310697695126
              ],
              [
                -53.56709235447272,
                -32.45852289140534
              ],
              [
                -53.57088138885194,
                -32.45670009498509
              ],
              [
                -53.573775790113835,
                -32.45611036673147
              ],
              [
                -53.583985132746726,
                -32.45128531738376
              ],
              [
                -53.58640590471123,
                -32.44651387969545
              ],
              [
                -53.58640590471123,
                -32.44447663663753
              ],
              [
                -53.587616290693475,
                -32.43857935410143
              ],
              [
                -53.588774051198236,
                -32.435201819558024
              ],
              [
                -53.59308934035234,
                -32.43348624645661
              ],
              [
                -53.59640474543416,
                -32.43300374152184
              ],
              [
                -53.600299030768355,
                -32.43069844016682
              ],
              [
                -53.60182516961554,
                -32.429197313703085
              ],
              [
                -53.605087949219865,
                -32.42421142937711
              ],
              [
                -53.60982424219389,
                -32.42019055492067
              ],
              [
                -53.61498153898782,
                -32.41659857373959
              ],
              [
                -53.615823546627645,
                -32.415097447275855
              ],
              [
                -53.615192040897774,
                -32.411987971029546
              ],
              [
                -53.614402658735436,
                -32.41118379613826
              ],
              [
                -53.61371852752808,
                -32.40898571810208
              ],
              [
                -53.61282389441077,
                -32.40432150373262
              ],
              [
                -53.612087137725915,
                -32.40341010552249
              ],
              [
                -53.61282389441077,
                -32.400890357529796
              ],
              [
                -53.614402658735436,
                -32.398424221196514
              ],
              [
                -53.61971783196184,
                -32.3935991718488
              ],
              [
                -53.62387524468348,
                -32.39102581219668
              ],
              [
                -53.627874780972654,
                -32.38909579245759
              ],
              [
                -53.635084471388666,
                -32.38668326778373
              ],
              [
                -53.640399644615066,
                -32.38582548123303
              ],
              [
                -53.64397817708432,
                -32.3849140830229
              ],
              [
                -53.645188563066576,
                -32.383895461493935
              ],
              [
                -53.64550431593151,
                -32.37949930542157
              ],
              [
                -53.643925551606834,
                -32.37488870271153
              ],
              [
                -53.6436097987419,
                -32.36818724528414
              ],
              [
                -53.64239941275965,
                -32.36598916724795
              ],
              [
                -53.64071539748,
                -32.36480971074074
              ],
              [
                -53.63897875672286,
                -32.3621827394292
              ],
              [
                -53.638505127425454,
                -32.36057438964663
              ],
              [
                -53.635873853551,
                -32.35767936003799
              ],
              [
                -53.63397933636139,
                -32.356499903530775
              ],
              [
                -53.63308470324408,
                -32.353980155538075
              ],
              [
                -53.633295205154035,
                -32.35028095103816
              ],
              [
                -53.63408458731637,
                -32.34749314474836
              ],
              [
                -53.637978872650564,
                -32.3444908918209
              ],
              [
                -53.63908400767784,
                -32.34298976535716
              ],
              [
                -53.640925899389956,
                -32.33929056085724
              ],
              [
                -53.64371504969688,
                -32.33569857967616
              ],
              [
                -53.64497806115662,
                -32.332374656792176
              ],
              [
                -53.64439918090424,
                -32.32910434556761
              ],
              [
                -53.64460968281419,
                -32.32830017067632
              ],
              [
                -53.64308354396701,
                -32.32647737425607
              ],
              [
                -53.64308354396701,
                -32.32492263613292
              ],
              [
                -53.64629369809384,
                -32.32229566482138
              ],
              [
                -53.650398485337995,
                -32.321116208314166
              ],
              [
                -53.65260875539254,
                -32.321116208314166
              ],
              [
                -53.655397905699466,
                -32.319507858531594
              ],
              [
                -53.656713542636695,
                -32.318221178705535
              ],
              [
                -53.65718717193409,
                -32.316773663901216
              ],
              [
                -53.65650304072673,
                -32.31221667285059
              ],
              [
                -53.65429277067219,
                -32.311519721278145
              ],
              [
                -53.647925087896006,
                -32.31259195446653
              ],
              [
                -53.64318879492199,
                -32.30160156428561
              ],
              [
                -53.643399296831944,
                -32.29929626293059
              ],
              [
                -53.64271516562459,
                -32.297205408213244
              ],
              [
                -53.6440834280393,
                -32.295221776814735
              ],
              [
                -53.648819721013325,
                -32.293774262010416
              ],
              [
                -53.6528192573025,
                -32.292326747206104
              ],
              [
                -53.65550315665444,
                -32.290503950785855
              ],
              [
                -53.65739767384405,
                -32.28819864943083
              ],
              [
                -53.65639778977176,
                -32.285786124756974
              ],
              [
                -53.65560840760942,
                -32.28021051217738
              ],
              [
                -53.65850280887132,
                -32.275814356105016
              ],
              [
                -53.65929219103366,
                -32.27538546282967
              ],
              [
                -53.66471261521504,
                -32.27501018121373
              ],
              [
                -53.66560724833235,
                -32.274206006322444
              ],
              [
                -53.66639663049469,
                -32.27120375339498
              ],
              [
                -53.66792276934187,
                -32.26938095697473
              ],
              [
                -53.67060666869382,
                -32.26809427714867
              ],
              [
                -53.672501185883426,
                -32.26552091749655
              ],
              [
                -53.67492195784793,
                -32.26160726635896
              ],
              [
                -53.67539558714533,
                -32.26010613989522
              ],
              [
                -53.677816359109826,
                -32.258605013431485
              ],
              [
                -53.67739535528992,
                -32.25490580893157
              ],
              [
                -53.67671122408256,
                -32.25308301251132
              ],
              [
                -53.67771110815485,
                -32.25029520622152
              ],
              [
                -53.678079486497275,
                -32.24638155508393
              ],
              [
                -53.6789214941371,
                -32.244987651939034
              ],
              [
                -53.67928987247952,
                -32.24311124385936
              ],
              [
                -53.6789214941371,
                -32.24107400080144
              ],
              [
                -53.677816359109826,
                -32.24032343756957
              ],
              [
                -53.6765007221726,
                -32.238125359533385
              ],
              [
                -53.678079486497275,
                -32.23249613529438
              ],
              [
                -53.67992137820939,
                -32.229225824069815
              ],
              [
                -53.68250002660636,
                -32.22509772629454
              ],
              [
                -53.685183925958306,
                -32.219575725374376
              ],
              [
                -53.68707844314791,
                -32.21818182222948
              ],
              [
                -53.688288829130165,
                -32.21802098725122
              ],
              [
                -53.68981496797735,
                -32.21689514240342
              ],
              [
                -53.691025353959596,
                -32.214911511004914
              ],
              [
                -53.69328824949163,
                -32.213624831178855
              ],
              [
                -53.69449863547388,
                -32.21051535493255
              ],
              [
                -53.69418288260894,
                -32.20949673340358
              ],
              [
                -53.69239361637432,
                -32.20778116030217
              ],
              [
                -53.692709369239246,
                -32.206226422179014
              ],
              [
                -53.69460388642886,
                -32.20397473248342
              ],
              [
                -53.69649840361846,
                -32.20359945086748
              ],
              [
                -53.70049793990764,
                -32.20461807239644
              ],
              [
                -53.70302396282712,
                -32.207084208729725
              ],
              [
                -53.70491848001672,
                -32.20670892711379
              ],
              [
                -53.707076124593776,
                -32.204403625758765
              ],
              [
                -53.71128616279291,
                -32.19898884815744
              ],
              [
                -53.711075660882955,
                -32.196576323483576
              ],
              [
                -53.709023267260875,
                -32.19507519701985
              ],
              [
                -53.70718137554876,
                -32.19469991540391
              ],
              [
                -53.70402384689941,
                -32.19282350732424
              ],
              [
                -53.70281346091716,
                -32.191483215838765
              ],
              [
                -53.70281346091716,
                -32.18837373959246
              ],
              [
                -53.70470797810677,
                -32.1870870597664
              ],
              [
                -53.70581311313404,
                -32.1870870597664
              ],
              [
                -53.7093916456033,
                -32.18869540954897
              ],
              [
                -53.71102303540546,
                -32.18890985618665
              ],
              [
                -53.71402268762235,
                -32.18799845797652
              ],
              [
                -53.71460156787472,
                -32.18601482657802
              ],
              [
                -53.71491732073966,
                -32.18258368037519
              ],
              [
                -53.71407531309983,
                -32.179903097404235
              ],
              [
                -53.71260179973014,
                -32.178080300983986
              ],
              [
                -53.71428581500979,
                -32.17598944626664
              ],
              [
                -53.71602245576693,
                -32.17550694133187
              ],
              [
                -53.71939048632623,
                -32.175721387969546
              ],
              [
                -53.72270589140805,
                -32.17459554312175
              ],
              [
                -53.723495273570386,
                -32.17368414491162
              ],
              [
                -53.72360052452537,
                -32.17121800857834
              ],
              [
                -53.72307426975047,
                -32.169019930542156
              ],
              [
                -53.72207438567818,
                -32.16767963905668
              ],
              [
                -53.71928523537125,
                -32.164891832766884
              ],
              [
                -53.71891685702883,
                -32.16188957983942
              ],
              [
                -53.71739071818165,
                -32.15770787040473
              ],
              [
                -53.71707496531671,
                -32.15550979236854
              ],
              [
                -53.7176012200916,
                -32.15299004437585
              ],
              [
                -53.71828535129896,
                -32.152185869484555
              ],
              [
                -53.723916277390295,
                -32.150684743020825
              ],
              [
                -53.728915697751766,
                -32.15272198607875
              ],
              [
                -53.73081021494137,
                -32.152882821057005
              ],
              [
                -53.73317836142838,
                -32.15191781118746
              ],
              [
                -53.73517812957297,
                -32.15159614123095
              ],
              [
                -53.734915002185524,
                -32.14988056812954
              ],
              [
                -53.73149434614873,
                -32.14811138336871
              ],
              [
                -53.72717905699462,
                -32.146503033586136
              ],
              [
                -53.72538979075999,
                -32.14430495554995
              ],
              [
                -53.725705543624926,
                -32.14012324611526
              ],
              [
                -53.72707380603965,
                -32.13738905148489
              ],
              [
                -53.72859994488683,
                -32.135619866724056
              ],
              [
                -53.73280998308596,
                -32.13218872052123
              ],
              [
                -53.73417824550068,
                -32.12988341916621
              ],
              [
                -53.7360201372128,
                -32.1278997877677
              ],
              [
                -53.7364937665102,
                -32.12570170973152
              ],
              [
                -53.738283032744825,
                -32.12382530165185
              ],
              [
                -53.742019441646555,
                -32.11910747562297
              ],
              [
                -53.743703456926205,
                -32.11760634915923
              ],
              [
                -53.74417708622361,
                -32.11530104780421
              ],
              [
                -53.74017754993444,
                -32.11240601819558
              ],
              [
                -53.73770415249245,
                -32.10650873565948
              ],
              [
                -53.73759890153747,
                -32.10559733744935
              ],
              [
                -53.74012492445695,
                -32.10452510426097
              ],
              [
                -53.74049330279937,
                -32.10350648273201
              ],
              [
                -53.74012492445695,
                -32.100289783166865
              ],
              [
                -53.738388283699805,
                -32.100289783166865
              ],
              [
                -53.73428349645565,
                -32.10307758945665
              ],
              [
                -53.73238897926605,
                -32.10559733744935
              ],
              [
                -53.730126083734014,
                -32.105007609195745
              ],
              [
                -53.72717905699462,
                -32.101201181376986
              ],
              [
                -53.72560029266995,
                -32.09841337508719
              ],
              [
                -53.72528453980502,
                -32.095786403775655
              ],
              [
                -53.731020716851326,
                -32.094499723949596
              ],
              [
                -53.733494114293315,
                -32.09299859748587
              ],
              [
                -53.73728314867253,
                -32.09240886923225
              ],
              [
                -53.742282569034,
                -32.09219442259458
              ],
              [
                -53.745387472205856,
                -32.09139024770329
              ],
              [
                -53.74659785818811,
                -32.08897772302943
              ],
              [
                -53.746703109143084,
                -32.086886868312085
              ],
              [
                -53.746282105323175,
                -32.085600188486026
              ],
              [
                -53.746703109143084,
                -32.083991838703454
              ],
              [
                -53.7475977422604,
                -32.08318766381217
              ],
              [
                -53.74638735627815,
                -32.08152570237017
              ],
              [
                -53.74570322507079,
                -32.07938123599341
              ],
              [
                -53.74580847602577,
                -32.07809455616735
              ],
              [
                -53.74791349512534,
                -32.07788010952967
              ],
              [
                -53.75070264543226,
                -32.078898731058636
              ],
              [
                -53.754175926946544,
                -32.07938123599341
              ],
              [
                -53.75501793458637,
                -32.07922040101516
              ],
              [
                -53.756280946046104,
                -32.07621814808768
              ],
              [
                -53.75928059826299,
                -32.07702232297897
              ],
              [
                -53.76112248997511,
                -32.079113177696314
              ],
              [
                -53.76380638932705,
                -32.07959568263109
              ],
              [
                -53.767121794408865,
                -32.07820177948619
              ],
              [
                -53.76859530777856,
                -32.07648620638478
              ],
              [
                -53.76912156255345,
                -32.07369840009498
              ],
              [
                -53.771279207130505,
                -32.07278700188486
              ],
              [
                -53.77380523004998,
                -32.07267977856602
              ],
              [
                -53.77780476633916,
                -32.07160754537764
              ],
              [
                -53.77869939945647,
                -32.07171476869648
              ],
              [
                -53.78122542237595,
                -32.06978474895739
              ],
              [
                -53.782014804538285,
                -32.071875603674734
              ],
              [
                -53.78322519052053,
                -32.07230449695009
              ],
              [
                -53.78738260324218,
                -32.071125040442865
              ],
              [
                -53.7892244949543,
                -32.072197273631254
              ],
              [
                -53.7911190121439,
                -32.070588923848675
              ],
              [
                -53.789277120431784,
                -32.068390845812495
              ],
              [
                -53.791592641441305,
                -32.06801556419656
              ],
              [
                -53.793908162450826,
                -32.06919502070378
              ],
              [
                -53.79811820064996,
                -32.07010641891391
              ],
              [
                -53.80101260191186,
                -32.071125040442865
              ],
              [
                -53.804012254128736,
                -32.07069614716752
              ],
              [
                -53.80769603755298,
                -32.06801556419656
              ],
              [
                -53.80938005283263,
                -32.06581748616038
              ],
              [
                -53.81237970504951,
                -32.06490608795025
              ],
              [
                -53.814905727968984,
                -32.06201105834162
              ],
              [
                -53.81390584389669,
                -32.05959853366776
              ],
              [
                -53.81537935726639,
                -32.05911602873299
              ],
              [
                -53.817273874456,
                -32.05959853366776
              ],
              [
                -53.819799897375475,
                -32.05911602873299
              ],
              [
                -53.822010167430015,
                -32.05981298030544
              ],
              [
                -53.823694182709666,
                -32.05900880541415
              ],
              [
                -53.824483564872004,
                -32.0597057569866
              ],
              [
                -53.826904336836506,
                -32.0597057569866
              ],
              [
                -53.8283778502062,
                -32.05868713545764
              ],
              [
                -53.829114606891046,
                -32.057507678950415
              ],
              [
                -53.83090387312568,
                -32.055792105849
              ],
              [
                -53.83332464509018,
                -32.05509515427656
              ],
              [
                -53.834692907504895,
                -32.05359402781282
              ],
              [
                -53.834587656549914,
                -32.052789852921535
              ],
              [
                -53.83579804253217,
                -32.05107427982012
              ],
              [
                -53.83590329348714,
                -32.04828647353033
              ],
              [
                -53.833114143180225,
                -32.04619561881299
              ],
              [
                -53.83411402725252,
                -32.042496414313064
              ],
              [
                -53.835219162279785,
                -32.04088806453049
              ],
              [
                -53.8371136794694,
                -32.03960138470443
              ],
              [
                -53.84221835078584,
                -32.03997666632037
              ],
              [
                -53.842586729128264,
                -32.037188860030575
              ],
              [
                -53.839587076911386,
                -32.03381132548717
              ],
              [
                -53.83811356354169,
                -32.03279270395821
              ],
              [
                -53.84469174822783,
                -32.029576004393064
              ],
              [
                -53.84679676732739,
                -32.02898627613945
              ],
              [
                -53.85000692145423,
                -32.02920072277713
              ],
              [
                -53.85069105266159,
                -32.030487402603185
              ],
              [
                -53.85258556985119,
                -32.0296832277119
              ],
              [
                -53.85232244246375,
                -32.02791404295107
              ],
              [
                -53.8511120564815,
                -32.02737792635688
              ],
              [
                -53.85200668959882,
                -32.023410663559865
              ],
              [
                -53.85348020296851,
                -32.022713711987414
              ],
              [
                -53.85379595583345,
                -32.02169509045845
              ],
              [
                -53.852690820806174,
                -32.02008674067588
              ],
              [
                -53.85300657367111,
                -32.01697726442957
              ],
              [
                -53.8515856857789,
                -32.01429668145862
              ],
              [
                -53.85258556985119,
                -32.01161609848766
              ],
              [
                -53.85421695965336,
                -32.01038303032102
              ],
              [
                -53.85348020296851,
                -32.005986874248656
              ],
              [
                -53.85121730743648,
                -32.0021804464299
              ],
              [
                -53.84937541572436,
                -32.001108213241515
              ],
              [
                -53.85079630361657,
                -32.00019681503139
              ],
              [
                -53.85348020296851,
                -31.999875145074874
              ],
              [
                -53.855111592770676,
                -31.998105960314046
              ],
              [
                -53.85637460423041,
                -31.997891513676368
              ],
              [
                -53.857216611870236,
                -31.996712057169148
              ],
              [
                -53.85900587810487,
                -31.997623455379273
              ],
              [
                -53.86047939147456,
                -31.997516232060434
              ],
              [
                -53.86021626408712,
                -31.994996484067737
              ],
              [
                -53.86179502841179,
                -31.996175940574958
              ],
              [
                -53.86337379273647,
                -31.99612232891554
              ],
              [
                -53.86479468062867,
                -31.99467481411122
              ],
              [
                -53.86411054942131,
                -31.992905629350393
              ],
              [
                -53.86642607043083,
                -31.993280910966327
              ],
              [
                -53.86858371500789,
                -31.99531815402425
              ],
              [
                -53.870793985062434,
                -31.99547898900251
              ],
              [
                -53.871320239837324,
                -31.996712057169148
              ],
              [
                -53.869899351945115,
                -31.997998736995207
              ],
              [
                -53.871688618179746,
                -31.99912458184301
              ],
              [
                -53.873004255116975,
                -31.998802911886493
              ],
              [
                -53.87858255573082,
                -31.995800658959023
              ],
              [
                -53.87931931241567,
                -31.994996484067737
              ],
              [
                -53.8815822079477,
                -31.99478203743006
              ],
              [
                -53.8868973811741,
                -31.994996484067737
              ],
              [
                -53.888002516201375,
                -31.995693435640185
              ],
              [
                -53.89210730344553,
                -31.99542537734309
              ],
              [
                -53.89300193656284,
                -31.992798406031554
              ],
              [
                -53.89200205249055,
                -31.99070755131421
              ],
              [
                -53.89168629962561,
                -31.98877753157512
              ],
              [
                -53.89679097094206,
                -31.985024715415783
              ],
              [
                -53.89731722571695,
                -31.981700792531797
              ],
              [
                -53.89647521807712,
                -31.98111106427819
              ],
              [
                -53.89868548813166,
                -31.979609937814452
              ],
              [
                -53.899474870294,
                -31.97789436471304
              ],
              [
                -53.90200089321348,
                -31.9791810445391
              ],
              [
                -53.90400066135807,
                -31.97810881135072
              ],
              [
                -53.90557942568274,
                -31.976017956633374
              ],
              [
                -53.90668456071001,
                -31.976125179952213
              ],
              [
                -53.90847382694464,
                -31.974195160213124
              ],
              [
                -53.90857907789962,
                -31.97258681043055
              ],
              [
                -53.90978946388187,
                -31.972211528814615
              ],
              [
                -53.90968421292689,
                -31.97001345077843
              ],
              [
                -53.91268386514377,
                -31.967386479466896
              ],
              [
                -53.91321011991866,
                -31.965724518024906
              ],
              [
                -53.91578876831563,
                -31.966099799640837
              ],
              [
                -53.91668340143294,
                -31.964705896495943
              ],
              [
                -53.918525293145066,
                -31.963794498285818
              ],
              [
                -53.92120919249701,
                -31.96368727496698
              ],
              [
                -53.92278795682168,
                -31.962775876756854
              ],
              [
                -53.92520872878618,
                -31.96368727496698
              ],
              [
                -53.92778737718315,
                -31.962078925184404
              ],
              [
                -53.93031340010263,
                -31.963311993351045
              ],
              [
                -53.932786797544615,
                -31.962883100075693
              ],
              [
                -53.93231316824721,
                -31.9612211386337
              ],
              [
                -53.936417955491365,
                -31.958379720684487
              ],
              [
                -53.93852297459093,
                -31.957789992430875
              ],
              [
                -53.94089112107794,
                -31.95880861395984
              ],
              [
                -53.94241725992512,
                -31.958326109025066
              ],
              [
                -53.94320664208746,
                -31.956717759242494
              ],
              [
                -53.94478540641214,
                -31.955591914394695
              ],
              [
                -53.94752193124157,
                -31.95457329286573
              ],
              [
                -53.948311313403906,
                -31.953286613039673
              ],
              [
                -53.94710092742166,
                -31.952107156532453
              ],
              [
                -53.94568003952945,
                -31.952589661467222
              ],
              [
                -53.94368027138486,
                -31.95098131168465
              ],
              [
                -53.945995792394385,
                -31.94851517535137
              ],
              [
                -53.94810081149395,
                -31.94808628207602
              ],
              [
                -53.94699567646668,
                -31.94497680582971
              ],
              [
                -53.947679807674035,
                -31.94310039775004
              ],
              [
                -53.94952169938615,
                -31.941223989670373
              ],
              [
                -53.94899544461126,
                -31.939401193250124
              ],
              [
                -53.947574556719054,
                -31.938114513424065
              ],
              [
                -53.948311313403906,
                -31.936988668576262
              ],
              [
                -53.951205714665804,
                -31.93468336722124
              ],
              [
                -53.95110046371083,
                -31.932592512503895
              ],
              [
                -53.9526792280355,
                -31.93248528918506
              ],
              [
                -53.95420536688269,
                -31.931305832677836
              ],
              [
                -53.95378436306277,
                -31.929590259576425
              ],
              [
                -53.95399486497273,
                -31.92749940485908
              ],
              [
                -53.9551,
                -31.925408550141736
              ],
              [
                -53.95399486497273,
                -31.923907423678003
              ],
              [
                -53.95252135160303,
                -31.923210472105552
              ],
              [
                -53.953521235675325,
                -31.921977403938914
              ],
              [
                -53.9526792280355,
                -31.920476277475178
              ],
              [
                -53.952994980900435,
                -31.91918959764912
              ],
              [
                -53.94899544461126,
                -31.918117364460738
              ],
              [
                -53.94789030958399,
                -31.917098742931774
              ],
              [
                -53.94657467264676,
                -31.916991519612935
              ],
              [
                -53.945890541439404,
                -31.915919286424554
              ],
              [
                -53.943785522339844,
                -31.915704839786876
              ],
              [
                -53.944574904502176,
                -31.914310936641982
              ],
              [
                -53.9439960242498,
                -31.91329231511302
              ],
              [
                -53.94168050324028,
                -31.912488140221733
              ],
              [
                -53.938891352933354,
                -31.912702586859407
              ],
              [
                -53.937996719816034,
                -31.911576742011608
              ],
              [
                -53.936417955491365,
                -31.911523130352187
              ],
              [
                -53.93541807141907,
                -31.90900338235949
              ],
              [
                -53.93210266633726,
                -31.90530417785957
              ],
              [
                -53.930997531309984,
                -31.902087478294426
              ],
              [
                -53.93031340010263,
                -31.896994370649608
              ],
              [
                -53.9314185351299,
                -31.895010739251102
              ],
              [
                -53.932786797544615,
                -31.89399211772214
              ],
              [
                -53.932892048499596,
                -31.892919884533757
              ],
              [
                -53.93199741538228,
                -31.88487813562089
              ],
              [
                -53.93157641156237,
                -31.879088076403626
              ],
              [
                -53.93168166251734,
                -31.875603318541387
              ],
              [
                -53.930997531309984,
                -31.87399496875881
              ],
              [
                -53.92731374788575,
                -31.87238661897624
              ],
              [
                -53.92531397974116,
                -31.87109993915018
              ],
              [
                -53.923314211596576,
                -31.86820490954155
              ],
              [
                -53.91899892244246,
                -31.86557793823001
              ],
              [
                -53.918420042190085,
                -31.864773763338725
              ],
              [
                -53.91568351736065,
                -31.86337986019383
              ],
              [
                -53.915578266405674,
                -31.86139622879532
              ],
              [
                -53.91799903837017,
                -31.858822869143204
              ],
              [
                -53.91757803455026,
                -31.857482577657727
              ],
              [
                -53.914788884243336,
                -31.85721451936063
              ],
              [
                -53.91378900017104,
                -31.856624791107023
              ],
              [
                -53.913894251126024,
                -31.855123664643287
              ],
              [
                -53.91410475303598,
                -31.851585295121627
              ],
              [
                -53.913104868963686,
                -31.84960166372312
              ],
              [
                -53.91421000399095,
                -31.84777886730287
              ],
              [
                -53.91599927022558,
                -31.847403585686937
              ],
              [
                -53.91520988806325,
                -31.845419954288428
              ],
              [
                -53.9125259887113,
                -31.843382711230504
              ],
              [
                -53.9115787301165,
                -31.84231047804212
              ],
              [
                -53.909105332674514,
                -31.84348993454934
              ],
              [
                -53.907684444782305,
                -31.842096031404445
              ],
              [
                -53.90842120146715,
                -31.840702128259547
              ],
              [
                -53.909894714836845,
                -31.839683506730584
              ],
              [
                -53.90800019764724,
                -31.838879331839298
              ],
              [
                -53.90800019764724,
                -31.837217370397305
              ],
              [
                -53.90968421292689,
                -31.834912069042282
              ],
              [
                -53.911315602729054,
                -31.833625389216223
              ],
              [
                -53.912210235846366,
                -31.830891194585853
              ],
              [
                -53.91578876831563,
                -31.82788894165838
              ],
              [
                -53.91599927022558,
                -31.826280591875808
              ],
              [
                -53.917683285505234,
                -31.82617336855697
              ],
              [
                -53.92020930842472,
                -31.82360000890485
              ],
              [
                -53.91989355555978,
                -31.821723600825184
              ],
              [
                -53.921788072749386,
                -31.82070497929622
              ],
              [
                -53.92199857465935,
                -31.81941829947016
              ],
              [
                -53.919577802694846,
                -31.819686357767257
              ],
              [
                -53.91952517721736,
                -31.818185231303524
              ],
              [
                -53.92068293772212,
                -31.81770272636875
              ],
              [
                -53.92289320777666,
                -31.81791717300643
              ],
              [
                -53.92357733898402,
                -31.817220221433978
              ],
              [
                -53.923314211596576,
                -31.815022143397794
              ],
              [
                -53.92357733898402,
                -31.81282406536161
              ],
              [
                -53.92520872878618,
                -31.8111084922602
              ],
              [
                -53.92641911476843,
                -31.807623734397957
              ],
              [
                -53.92778737718315,
                -31.805693714658872
              ],
              [
                -53.926208612858474,
                -31.804299811513975
              ],
              [
                -53.92457722305631,
                -31.804407034832813
              ],
              [
                -53.92120919249701,
                -31.805425656361773
              ],
              [
                -53.919577802694846,
                -31.80510398640526
              ],
              [
                -53.917683285505234,
                -31.803710083260363
              ],
              [
                -53.91652552500047,
                -31.8038173065792
              ],
              [
                -53.91168398107148,
                -31.807409287760283
              ],
              [
                -53.910526220566716,
                -31.809017637542855
              ],
              [
                -53.90800019764724,
                -31.809124860861694
              ],
              [
                -53.90578992759269,
                -31.807891792695052
              ],
              [
                -53.90489529447538,
                -31.80451425815165
              ],
              [
                -53.905105796385335,
                -31.80027893705754
              ],
              [
                -53.90642143332256,
                -31.79738390744891
              ],
              [
                -53.90800019764724,
                -31.795185829412727
              ],
              [
                -53.91021046770178,
                -31.79422081954318
              ],
              [
                -53.9105788460442,
                -31.79261246976061
              ],
              [
                -53.912894367053724,
                -31.790414391724426
              ],
              [
                -53.91278911609875,
                -31.789395770195462
              ],
              [
                -53.910789347954164,
                -31.788806041941854
              ],
              [
                -53.91452575685589,
                -31.785214060760772
              ],
              [
                -53.91552564092818,
                -31.78280153608691
              ],
              [
                -53.919998806514755,
                -31.782479866130398
              ],
              [
                -53.92168282179441,
                -31.780174564775376
              ],
              [
                -53.9222090765693,
                -31.77679703023197
              ],
              [
                -53.92410359375891,
                -31.77572479704359
              ],
              [
                -53.924892975921246,
                -31.773687553985663
              ],
              [
                -53.92520872878618,
                -31.767093319877112
              ],
              [
                -53.92641911476843,
                -31.765109688478606
              ],
              [
                -53.925419230696136,
                -31.762107435551137
              ],
              [
                -53.92420884471389,
                -31.761088814022173
              ],
              [
                -53.92552448165112,
                -31.759802134196114
              ],
              [
                -53.92341946255155,
                -31.759373240920763
              ],
              [
                -53.92020930842472,
                -31.757925726116447
              ],
              [
                -53.91720965620784,
                -31.760284639130887
              ],
              [
                -53.91421000399095,
                -31.7606063090874
              ],
              [
                -53.91189448298143,
                -31.754494579913622
              ],
              [
                -53.913525872783595,
                -31.753207900087563
              ],
              [
                -53.909105332674514,
                -31.75100982205138
              ],
              [
                -53.90847382694464,
                -31.745487821131213
              ],
              [
                -53.90389541040309,
                -31.742700014841418
              ],
              [
                -53.90200089321348,
                -31.742592791522583
              ],
              [
                -53.90079050723123,
                -31.73921525697918
              ],
              [
                -53.901106260096164,
                -31.736802732305318
              ],
              [
                -53.899790623158935,
                -31.735301605841585
              ],
              [
                -53.90157988939357,
                -31.73229935291411
              ],
              [
                -53.9014220129611,
                -31.727313468588136
              ],
              [
                -53.90331653015071,
                -31.725597895486725
              ],
              [
                -53.90157988939357,
                -31.72350704076938
              ],
              [
                -53.90242189703339,
                -31.72179146766797
              ],
              [
                -53.90000112506889,
                -31.72098729277668
              ],
              [
                -53.898106607879285,
                -31.717877816530375
              ],
              [
                -53.898106607879285,
                -31.714875563602902
              ],
              [
                -53.89489645375245,
                -31.711176359102986
              ],
              [
                -53.89389656968015,
                -31.708710222769707
              ],
              [
                -53.8936860677702,
                -31.69889928909601
              ],
              [
                -53.88942340409358,
                -31.69520008459609
              ],
              [
                -53.88900240027367,
                -31.693913404770033
              ],
              [
                -53.890318037210896,
                -31.68742639398032
              ],
              [
                -53.89179155058059,
                -31.68517470428472
              ],
              [
                -53.89131792128319,
                -31.682976626248536
              ],
              [
                -53.8922125544005,
                -31.680403266596418
              ],
              [
                -53.88858139645375,
                -31.670914002879236
              ],
              [
                -53.88868664740873,
                -31.669198429777826
              ],
              [
                -53.89000228434596,
                -31.667911749951767
              ],
              [
                -53.889581280526045,
                -31.66598173021268
              ],
              [
                -53.88589749710181,
                -31.66528477864023
              ],
              [
                -53.880898076740344,
                -31.662389749031597
              ],
              [
                -53.87910881050571,
                -31.656117184879562
              ],
              [
                -53.87689854045117,
                -31.6537046602057
              ],
              [
                -53.87847730477584,
                -31.65252520369848
              ],
              [
                -53.87942456337065,
                -31.65070240727823
              ],
              [
                -53.87910881050571,
                -31.650005455705784
              ],
              [
                -53.87621440924381,
                -31.648182659285535
              ],
              [
                -53.872214872954636,
                -31.648289882604374
              ],
              [
                -53.87100448697239,
                -31.646788756140637
              ],
              [
                -53.8690047188278,
                -31.64062341530744
              ],
              [
                -53.86647869590832,
                -31.63928312382196
              ],
              [
                -53.86390004751136,
                -31.6393903471408
              ],
              [
                -53.86247915961915,
                -31.63767477403939
              ],
              [
                -53.862900163439065,
                -31.632099161459802
              ],
              [
                -53.86158452650184,
                -31.630008306742457
              ],
              [
                -53.85847962332998,
                -31.62990108342362
              ],
              [
                -53.857321862825216,
                -31.628882461894655
              ],
              [
                -53.85558522206808,
                -31.629579413467106
              ],
              [
                -53.852690820806174,
                -31.628399956959885
              ],
              [
                -53.85090155457154,
                -31.625826597307768
              ],
              [
                -53.84932279024687,
                -31.6250760340759
              ],
              [
                -53.84932279024687,
                -31.62250267442378
              ],
              [
                -53.84732302210229,
                -31.620411819706437
              ],
              [
                -53.84832290617458,
                -31.618106518351414
              ],
              [
                -53.84837553165207,
                -31.61408564389498
              ],
              [
                -53.84411286797545,
                -31.61312063402544
              ],
              [
                -53.840218582641256,
                -31.60759863310527
              ],
              [
                -53.84369186415554,
                -31.60218385550394
              ],
              [
                -53.84132371766852,
                -31.59751964113448
              ],
              [
                -53.83969232786636,
                -31.59612573798958
              ],
              [
                -53.839218698568956,
                -31.59162235859838
              ],
              [
                -53.8375873087668,
                -31.588191212395554
              ],
              [
                -53.84148159410099,
                -31.583419774707252
              ],
              [
                -53.839587076911386,
                -31.582025871562358
              ],
              [
                -53.84158684505597,
                -31.57650387064219
              ],
              [
                -53.84121846671355,
                -31.571089093040857
              ],
              [
                -53.840113331686275,
                -31.56680016028733
              ],
              [
                -53.84032383359623,
                -31.56497736386708
              ],
              [
                -53.83848194188411,
                -31.561599829323676
              ],
              [
                -53.84032383359623,
                -31.55768617818608
              ],
              [
                -53.839376575001424,
                -31.555809770106414
              ],
              [
                -53.840113331686275,
                -31.553826138707905
              ],
              [
                -53.83911344761398,
                -31.551091944077534
              ],
              [
                -53.83737680685684,
                -31.5507166624616
              ],
              [
                -53.835219162279785,
                -31.55178889564998
              ],
              [
                -53.83358777247762,
                -31.551520837352886
              ],
              [
                -53.82700958779149,
                -31.546106059751555
              ],
              [
                -53.82658858397157,
                -31.54390798171537
              ],
              [
                -53.831588004333035,
                -31.54160268036035
              ],
              [
                -53.83358777247762,
                -31.538975709048813
              ],
              [
                -53.83258788840533,
                -31.53688485433147
              ],
              [
                -53.82579920180923,
                -31.534793999614124
              ],
              [
                -53.82379943366465,
                -31.531202018433042
              ],
              [
                -53.82611495467417,
                -31.527717260570803
              ],
              [
                -53.828219973773734,
                -31.527395590614287
              ],
              [
                -53.82648333301659,
                -31.52482223096217
              ],
              [
                -53.82658858397157,
                -31.52358916279553
              ],
              [
                -53.82301005150231,
                -31.522677764585406
              ],
              [
                -53.82190491647504,
                -31.51522574392615
              ],
              [
                -53.82437831391703,
                -31.51238432597694
              ],
              [
                -53.82411518652958,
                -31.506594266759674
              ],
              [
                -53.8254834489443,
                -31.504074518766977
              ],
              [
                -53.82490456869192,
                -31.502305334006145
              ],
              [
                -53.82479931773694,
                -31.496783333085975
              ],
              [
                -53.825115070601875,
                -31.495818323216433
              ],
              [
                -53.82748321708888,
                -31.495014148325147
              ],
              [
                -53.82711483874646,
                -31.49190467207884
              ],
              [
                -53.8279042209088,
                -31.49051076893394
              ],
              [
                -53.83148275337806,
                -31.488419914216596
              ],
              [
                -53.82900935593607,
                -31.48048538862257
              ],
              [
                -53.832482637450354,
                -31.474802552724142
              ],
              [
                -53.83121962599061,
                -31.473676707876344
              ],
              [
                -53.83279839031529,
                -31.47121057154306
              ],
              [
                -53.83258788840533,
                -31.4701919500141
              ],
              [
                -53.83011449096334,
                -31.467993871977917
              ],
              [
                -53.82869360307114,
                -31.468798046869203
              ],
              [
                -53.82490456869192,
                -31.467296920405467
              ],
              [
                -53.8158003610863,
                -31.466814415470697
              ],
              [
                -53.81390584389669,
                -31.464294667477997
              ],
              [
                -53.805696269408394,
                -31.462793541014264
              ],
              [
                -53.80248611528155,
                -31.45689625847816
              ],
              [
                -53.793381907675936,
                -31.453304277297082
              ],
              [
                -53.79180314335126,
                -31.4511061992609
              ],
              [
                -53.789277120431784,
                -31.450409247688448
              ],
              [
                -53.7892244949543,
                -31.446602819869693
              ],
              [
                -53.79038225545906,
                -31.4438150135799
              ],
              [
                -53.784593452935255,
                -31.44258194541326
              ],
              [
                -53.78122542237595,
                -31.438614682616247
              ],
              [
                -53.78248843383569,
                -31.435773264667034
              ],
              [
                -53.78222530644824,
                -31.43357518663085
              ],
              [
                -53.785119707710145,
                -31.431001826978733
              ],
              [
                -53.784593452935255,
                -31.429286253877322
              ],
              [
                -53.78538283509759,
                -31.427999574051263
              ],
              [
                -53.78527758414261,
                -31.424675651167277
              ],
              [
                -53.788224610882004,
                -31.424997321123794
              ],
              [
                -53.789908626161655,
                -31.42392508793541
              ],
              [
                -53.79027700450408,
                -31.421405339942712
              ],
              [
                -53.787698356107114,
                -31.42092283500794
              ],
              [
                -53.78711947585473,
                -31.418403087015243
              ],
              [
                -53.78811935992702,
                -31.415186387450095
              ],
              [
                -53.79011912807161,
                -31.41330997937043
              ],
              [
                -53.7896981242517,
                -31.411594406269018
              ],
              [
                -53.79201364526122,
                -31.411111901334245
              ],
              [
                -53.79059275736901,
                -31.408806599979222
              ],
              [
                -53.792118896216195,
                -31.407680755131423
              ],
              [
                -53.7925925255136,
                -31.40532184211698
              ],
              [
                -53.79069800832399,
                -31.39888844298669
              ],
              [
                -53.791592641441305,
                -31.397280093204113
              ],
              [
                -53.79238202360364,
                -31.391114752370918
              ],
              [
                -53.79411866436078,
                -31.388112499443448
              ],
              [
                -53.793381907675936,
                -31.386504149660873
              ],
              [
                -53.796381559892815,
                -31.38511024651598
              ],
              [
                -53.79680256371273,
                -31.382322440226183
              ],
              [
                -53.800907350956884,
                -31.373905409697382
              ],
              [
                -53.80048634713697,
                -31.37122482672643
              ],
              [
                -53.799223335677226,
                -31.36988453524095
              ],
              [
                -53.79822345160493,
                -31.366507000697545
              ],
              [
                -53.793276656720955,
                -31.361199446415057
              ],
              [
                -53.793013529333514,
                -31.35680329034269
              ],
              [
                -53.796276308937834,
                -31.352675192567418
              ],
              [
                -53.79190839430624,
                -31.349083211386336
              ],
              [
                -53.79101376118893,
                -31.346885133350153
              ],
              [
                -53.79122426309888,
                -31.343882880422683
              ],
              [
                -53.784593452935255,
                -31.345008725270485
              ],
              [
                -53.784593452935255,
                -31.34291787055314
              ],
              [
                -53.78311993956556,
                -31.341792025705338
              ],
              [
                -53.77769951538418,
                -31.33632363644459
              ],
              [
                -53.77580499819457,
                -31.32200932337969
              ],
              [
                -53.77480511412227,
                -31.316326487481263
              ],
              [
                -53.76801642752618,
                -31.314610914379852
              ],
              [
                -53.76527990269675,
                -31.31219838970599
              ],
              [
                -53.75838596514567,
                -31.315200642633464
              ],
              [
                -53.75459693076645,
                -31.317881225604417
              ],
              [
                -53.75191303141451,
                -31.318524565517446
              ],
              [
                -53.74880812824265,
                -31.3200793036406
              ],
              [
                -53.74791349512534,
                -31.323510449843425
              ],
              [
                -53.74638735627815,
                -31.325118799625997
              ],
              [
                -53.74359820597123,
                -31.325386857923093
              ],
              [
                -53.741387935916684,
                -31.3284963341694
              ],
              [
                -53.74049330279937,
                -31.32908606242301
              ],
              [
                -53.73417824550068,
                -31.328389110850562
              ],
              [
                -53.73249423022102,
                -31.3284963341694
              ],
              [
                -53.72591604553489,
                -31.326995207705664
              ],
              [
                -53.72202176020069,
                -31.327584935959276
              ],
              [
                -53.71902210798381,
                -31.32667353774915
              ],
              [
                -53.71239129782018,
                -31.329407732379526
              ],
              [
                -53.70828651057603,
                -31.327584935959276
              ],
              [
                -53.705918364089015,
                -31.32779938259695
              ],
              [
                -53.70049793990764,
                -31.32967579067662
              ],
              [
                -53.69339350044661,
                -31.333482218495377
              ],
              [
                -53.69081485204964,
                -31.33568029653156
              ],
              [
                -53.6861838100306,
                -31.33702058801704
              ],
              [
                -53.684289292840994,
                -31.336377248104007
              ],
              [
                -53.67681647503753,
                -31.331123305480936
              ],
              [
                -53.67281693874836,
                -31.33042635390849
              ],
              [
                -53.66660713240464,
                -31.332195538669318
              ],
              [
                -53.65992369676353,
                -31.33460806334318
              ],
              [
                -53.65318763564492,
                -31.3357875198504
              ],
              [
                -53.65081948915791,
                -31.33809282120542
              ],
              [
                -53.64960910317566,
                -31.337717539589487
              ],
              [
                -53.64681995286874,
                -31.3357875198504
              ],
              [
                -53.64108377582242,
                -31.334822509980853
              ],
              [
                -53.63608435546096,
                -31.329407732379526
              ],
              [
                -53.63182169178434,
                -31.329193285741848
              ],
              [
                -53.63050605484711,
                -31.329997460633134
              ],
              [
                -53.62982192363975,
                -31.332999713560604
              ],
              [
                -53.627190649765296,
                -31.33278526692293
              ],
              [
                -53.62519088162071,
                -31.333482218495377
              ],
              [
                -53.62419099754842,
                -31.332999713560604
              ],
              [
                -53.62287536061119,
                -31.330694412205585
              ],
              [
                -53.620612465079155,
                -31.331123305480936
              ],
              [
                -53.61850744597959,
                -31.330479965567907
              ],
              [
                -53.61708655808739,
                -31.32908606242301
              ],
              [
                -53.61808644215968,
                -31.32742410098102
              ],
              [
                -53.62019146125924,
                -31.32619103281438
              ],
              [
                -53.62019146125924,
                -31.323885731459356
              ],
              [
                -53.62140184724149,
                -31.32200932337969
              ],
              [
                -53.62387524468348,
                -31.320508196915952
              ],
              [
                -53.62498037971075,
                -31.31889984713338
              ],
              [
                -53.623717368251015,
                -31.31648732245952
              ],
              [
                -53.62150709819647,
                -31.316219264162424
              ],
              [
                -53.61961258100686,
                -31.314878972676947
              ],
              [
                -53.61871794788955,
                -31.31300256459728
              ],
              [
                -53.616876056177425,
                -31.312788117959602
              ],
              [
                -53.61540254280773,
                -31.31402118612624
              ],
              [
                -53.61408690587051,
                -31.31171588477122
              ],
              [
                -53.612087137725915,
                -31.310321981626323
              ],
              [
                -53.608824358121595,
                -31.311876719749478
              ],
              [
                -53.606508837112074,
                -31.311608661452382
              ],
              [
                -53.60529845112982,
                -31.31048281660458
              ],
              [
                -53.60240404986792,
                -31.30640833048873
              ],
              [
                -53.60182516961554,
                -31.30222662105404
              ],
              [
                -53.60661408806705,
                -31.30040382463379
              ],
              [
                -53.60719296831943,
                -31.299009921488892
              ],
              [
                -53.604824821832416,
                -31.295793221923745
              ],
              [
                -53.60408806514757,
                -31.28898454117752
              ],
              [
                -53.60308818107528,
                -31.287483414713783
              ],
              [
                -53.60487744730991,
                -31.286786463141336
              ],
              [
                -53.605614203994755,
                -31.28480283174283
              ],
              [
                -53.60329868298523,
                -31.283194481960255
              ],
              [
                -53.59850976453372,
                -31.28217586043129
              ],
              [
                -53.59740462950646,
                -31.2793880541415
              ],
              [
                -53.59640474543416,
                -31.279119995844404
              ],
              [
                -53.59482598110949,
                -31.28281920034432
              ],
              [
                -53.591773703415114,
                -31.284320326808057
              ],
              [
                -53.58998443718049,
                -31.28410588017038
              ],
              [
                -53.590089688135464,
                -31.28121085056175
              ],
              [
                -53.5879846690359,
                -31.279602500779177
              ],
              [
                -53.58519551872898,
                -31.280406675670463
              ],
              [
                -53.58287999771946,
                -31.279602500779177
              ],
              [
                -53.581880113647166,
                -31.277886927677763
              ],
              [
                -53.58440613656664,
                -31.27568884964158
              ],
              [
                -53.58609015184629,
                -31.27327632496772
              ],
              [
                -53.584774514909064,
                -31.271882421822824
              ],
              [
                -53.5817222372147,
                -31.272901043351787
              ],
              [
                -53.57851208308786,
                -31.27440216981552
              ],
              [
                -53.57430204488873,
                -31.27257937339527
              ],
              [
                -53.57019725764458,
                -31.273597994924234
              ],
              [
                -53.56877636975237,
                -31.272204091779336
              ],
              [
                -53.569618377392196,
                -31.27022046038083
              ],
              [
                -53.57088138885194,
                -31.27022046038083
              ],
              [
                -53.573617913681375,
                -31.267700712388134
              ],
              [
                -53.57188127292423,
                -31.265985139286723
              ],
              [
                -53.568986871662325,
                -31.266092362605562
              ],
              [
                -53.56761860924761,
                -31.264805682779503
              ],
              [
                -53.56709235447272,
                -31.26180342985203
              ],
              [
                -53.568197489499994,
                -31.25949812849701
              ],
              [
                -53.567513358292636,
                -31.2577825553956
              ],
              [
                -53.565618841103024,
                -31.25590614731593
              ],
              [
                -53.562724439841126,
                -31.252099719497174
              ],
              [
                -53.561987683156275,
                -31.24861496163493
              ],
              [
                -53.55940903475931,
                -31.247596340105968
              ],
              [
                -53.55840915068701,
                -31.243789912287212
              ],
              [
                -53.56319806913852,
                -31.24148461093219
              ],
              [
                -53.56172455576883,
                -31.239715426171358
              ],
              [
                -53.55577787681256,
                -31.237785406432273
              ],
              [
                -53.55477799274026,
                -31.236820396562727
              ],
              [
                -53.555620000380095,
                -31.234193425251192
              ],
              [
                -53.5550937456052,
                -31.232799522106294
              ],
              [
                -53.55151521313594,
                -31.229690045859986
              ],
              [
                -53.54862081187404,
                -31.22947559922231
              ],
              [
                -53.54872606282902,
                -31.23317480372223
              ],
              [
                -53.552304595298274,
                -31.237517348135178
              ],
              [
                -53.550199576198715,
                -31.240090707787292
              ],
              [
                -53.54467390106235,
                -31.242396009142315
              ],
              [
                -53.53851672019613,
                -31.239876261149618
              ],
              [
                -53.53630645014159,
                -31.239286532896006
              ],
              [
                -53.53620119918661,
                -31.241216552635095
              ],
              [
                -53.535201315114314,
                -31.247596340105968
              ],
              [
                -53.536990581348945,
                -31.250116088098665
              ],
              [
                -53.535201315114314,
                -31.251885272859496
              ],
              [
                -53.533517299834664,
                -31.25172443788124
              ],
              [
                -53.52930726163553,
                -31.248293291678415
              ],
              [
                -53.52878100686064,
                -31.245987990323396
              ],
              [
                -53.53009664379787,
                -31.24202072752638
              ],
              [
                -53.52920201068056,
                -31.239286532896006
              ],
              [
                -53.52762324635588,
                -31.23719567817866
              ],
              [
                -53.5260971075087,
                -31.23199534721501
              ],
              [
                -53.52451834318402,
                -31.229207540925216
              ],
              [
                -53.52620235846367,
                -31.22529388978762
              ],
              [
                -53.52541297630134,
                -31.223685540005047
              ],
              [
                -53.52041355593987,
                -31.21757381083127
              ],
              [
                -53.51999255211996,
                -31.216126296026953
              ],
              [
                -53.52088718523727,
                -31.214786004541473
              ],
              [
                -53.52451834318402,
                -31.215375732795085
              ],
              [
                -53.525991856553716,
                -31.210979576722718
              ],
              [
                -53.52762324635588,
                -31.2084062170706
              ],
              [
                -53.525991856553716,
                -31.206797867288028
              ],
              [
                -53.52041355593987,
                -31.205779245759064
              ],
              [
                -53.517308652768016,
                -31.203473944404042
              ],
              [
                -53.514993131758494,
                -31.198809730034583
              ],
              [
                -53.51520363366845,
                -31.19151854435358
              ],
              [
                -53.51309861456888,
                -31.18937407797682
              ],
              [
                -53.509309580189665,
                -31.186586271687023
              ],
              [
                -53.507520313955034,
                -31.18390568871607
              ],
              [
                -53.506204677017806,
                -31.18261900889001
              ],
              [
                -53.504783789125604,
                -31.179509532643703
              ],
              [
                -53.503994406963265,
                -31.175006153252497
              ],
              [
                -53.50441541078318,
                -31.173183356832247
              ],
              [
                -53.50588892415287,
                -31.17302252185399
              ],
              [
                -53.51062521712689,
                -31.177793959542292
              ],
              [
                -53.51451950246109,
                -31.17827646447706
              ],
              [
                -53.517203401813035,
                -31.179187862687186
              ],
              [
                -53.519782050210004,
                -31.178973416049512
              ],
              [
                -53.52167656739961,
                -31.178222852817644
              ],
              [
                -53.52162394192212,
                -31.176614503035072
              ],
              [
                -53.517098150858054,
                -31.173290580151086
              ],
              [
                -53.51599301583079,
                -31.172111123643866
              ],
              [
                -53.51588776487581,
                -31.169805822288843
              ],
              [
                -53.517203401813035,
                -31.167983025868594
              ],
              [
                -53.51520363366845,
                -31.16567772451357
              ],
              [
                -53.511782977631654,
                -31.168626365781623
              ],
              [
                -53.51051996617192,
                -31.169216094035235
              ],
              [
                -53.508888576369756,
                -31.167822190890337
              ],
              [
                -53.50778344134248,
                -31.164391044687513
              ],
              [
                -53.50599417510785,
                -31.16460549132519
              ],
              [
                -53.504099657918246,
                -31.16567772451357
              ],
              [
                -53.50252089359357,
                -31.165409666216476
              ],
              [
                -53.50162626047626,
                -31.164391044687513
              ],
              [
                -53.50331027575591,
                -31.16117434512237
              ],
              [
                -53.50367865409833,
                -31.15860098547025
              ],
              [
                -53.50352077766586,
                -31.15699263568768
              ],
              [
                -53.5018893878637,
                -31.155813179180456
              ],
              [
                -53.49841610634942,
                -31.156510130752906
              ],
              [
                -53.49631108724986,
                -31.15618846079639
              ],
              [
                -53.49289043121306,
                -31.154097606079045
              ],
              [
                -53.490680161158515,
                -31.154687334332657
              ],
              [
                -53.48889089492389,
                -31.153775936122532
              ],
              [
                -53.48878564396891,
                -31.15157785808635
              ],
              [
                -53.492101049050724,
                -31.149487003369003
              ],
              [
                -53.49189054714077,
                -31.1461094688256
              ],
              [
                -53.49341668598795,
                -31.142892769260452
              ],
              [
                -53.495574330565006,
                -31.143321662535804
              ],
              [
                -53.4965742146373,
                -31.142678322622775
              ],
              [
                -53.49567958151999,
                -31.139086341441697
              ],
              [
                -53.498573982781885,
                -31.13340350554327
              ],
              [
                -53.4989949866018,
                -31.13222404903605
              ],
              [
                -53.49399556624033,
                -31.132116825717212
              ],
              [
                -53.49257467834813,
                -31.13340350554327
              ],
              [
                -53.48889089492389,
                -31.13168793244186
              ],
              [
                -53.48631224652692,
                -31.129918747681028
              ],
              [
                -53.485891242707005,
                -31.12852484453613
              ],
              [
                -53.48331259431004,
                -31.12670204811588
              ],
              [
                -53.48241796119272,
                -31.124289523442023
              ],
              [
                -53.480681320435586,
                -31.121984222087
              ],
              [
                -53.48089182234554,
                -31.121180047195715
              ],
              [
                -53.48520711149965,
                -31.119678920731978
              ],
              [
                -53.48531236245463,
                -31.118177794268245
              ],
              [
                -53.48268108858017,
                -31.116301386188574
              ],
              [
                -53.481102324255495,
                -31.115604434616127
              ],
              [
                -53.48052344400312,
                -31.11362080321762
              ],
              [
                -53.48241796119272,
                -31.112709405007497
              ],
              [
                -53.48541761340961,
                -31.112709405007497
              ],
              [
                -53.485996493661986,
                -31.11110105522492
              ],
              [
                -53.48778575989662,
                -31.110511326971313
              ],
              [
                -53.491574794275834,
                -31.112119676753885
              ],
              [
                -53.492995682168036,
                -31.112012453435046
              ],
              [
                -53.49531120317756,
                -31.10649045251488
              ],
              [
                -53.49667946559228,
                -31.106115170898946
              ],
              [
                -53.49599533438492,
                -31.10407792784102
              ],
              [
                -53.492101049050724,
                -31.104185151159857
              ],
              [
                -53.4893118987438,
                -31.10338097626857
              ],
              [
                -53.48768050894164,
                -31.101987073123674
              ],
              [
                -53.48552286436458,
                -31.10279124801496
              ],
              [
                -53.48452298029229,
                -31.10230874308019
              ],
              [
                -53.48268108858017,
                -31.102576801377285
              ],
              [
                -53.48268108858017,
                -31.100807616616454
              ],
              [
                -53.486522748436876,
                -31.097001188797698
              ],
              [
                -53.48578599175203,
                -31.090675012986242
              ],
              [
                -53.48720687964423,
                -31.08788720669645
              ],
              [
                -53.48657537391437,
                -31.08408077887769
              ],
              [
                -53.48568074079705,
                -31.083812720580596
              ],
              [
                -53.48268108858017,
                -31.085206623725494
              ],
              [
                -53.48210220832779,
                -31.086386080232714
              ],
              [
                -53.47852367585853,
                -31.088691381587736
              ],
              [
                -53.47910255611091,
                -31.090406954689147
              ],
              [
                -53.47810267203862,
                -31.091586411196367
              ],
              [
                -53.47489251791178,
                -31.08960277979786
              ],
              [
                -53.47457676504685,
                -31.085421070363168
              ],
              [
                -53.475787151029095,
                -31.083919943899435
              ],
              [
                -53.479523559930826,
                -31.08311576900815
              ],
              [
                -53.483575721697484,
                -31.080703244334288
              ],
              [
                -53.48452298029229,
                -31.080917690971965
              ],
              [
                -53.48778575989662,
                -31.079523787827068
              ],
              [
                -53.48957502613125,
                -31.077218486472045
              ],
              [
                -53.4878910108516,
                -31.073894563588063
              ],
              [
                -53.4868911267793,
                -31.07030258240698
              ],
              [
                -53.48141807712043,
                -31.070624252363498
              ],
              [
                -53.47920780706589,
                -31.068908679262087
              ],
              [
                -53.47931305802087,
                -31.067890057733123
              ],
              [
                -53.48178645546286,
                -31.065209474762167
              ],
              [
                -53.486522748436876,
                -31.063386678341917
              ],
              [
                -53.48720687964423,
                -31.060116367117352
              ],
              [
                -53.48831201467151,
                -31.0594194155449
              ],
              [
                -53.4878910108516,
                -31.05791828908117
              ],
              [
                -53.4868911267793,
                -31.057114114189883
              ],
              [
                -53.48478610767974,
                -31.05791828908117
              ],
              [
                -53.48178645546286,
                -31.06027720209561
              ],
              [
                -53.47831317394858,
                -31.060116367117352
              ],
              [
                -53.47510301982174,
                -31.058615240653616
              ],
              [
                -53.47441888861438,
                -31.055505764407307
              ],
              [
                -53.47510301982174,
                -31.054594366197183
              ],
              [
                -53.47789217012866,
                -31.053790191305897
              ],
              [
                -53.4801024401832,
                -31.04982292850888
              ],
              [
                -53.48078657139057,
                -31.04682067558141
              ],
              [
                -53.47989193827325,
                -31.045587607414774
              ],
              [
                -53.4815759535529,
                -31.044783432523488
              ],
              [
                -53.484207227427355,
                -31.047517627153862
              ],
              [
                -53.486522748436876,
                -31.047410403835023
              ],
              [
                -53.48520711149965,
                -31.040011994835186
              ],
              [
                -53.4839967255174,
                -31.03910059662506
              ],
              [
                -53.484312478382336,
                -31.03797475177726
              ],
              [
                -53.4893118987438,
                -31.038725315009128
              ],
              [
                -53.490785412113496,
                -31.03749224684249
              ],
              [
                -53.48941714969878,
                -31.03561583876282
              ],
              [
                -53.48520711149965,
                -31.034597217233856
              ],
              [
                -53.48131282616546,
                -31.035186945487467
              ],
              [
                -53.47652390771395,
                -31.033310537407797
              ],
              [
                -53.478681552291,
                -31.031112459371613
              ],
              [
                -53.48041819304814,
                -31.030576342777422
              ],
              [
                -53.48268108858017,
                -31.02789575980647
              ],
              [
                -53.48168120450788,
                -31.026823526618088
              ],
              [
                -53.47931305802087,
                -31.028002983125305
              ],
              [
                -53.4782079229936,
                -31.027091584915183
              ],
              [
                -53.47568190007412,
                -31.027520478190535
              ],
              [
                -53.475892401984076,
                -31.02907521631369
              ],
              [
                -53.47352425549707,
                -31.03272080915419
              ],
              [
                -53.471524487352475,
                -31.03207746924116
              ],
              [
                -53.47052460328018,
                -31.028110206444143
              ],
              [
                -53.471892865694905,
                -31.025483235132608
              ],
              [
                -53.47010359946027,
                -31.026126575045637
              ],
              [
                -53.46841958418062,
                -31.025215176835513
              ],
              [
                -53.4636832912066,
                -31.02907521631369
              ],
              [
                -53.46068363898972,
                -31.027574089849953
              ],
              [
                -53.464104295026516,
                -31.023124322118168
              ],
              [
                -53.46831433322564,
                -31.020979855741402
              ],
              [
                -53.46957734468538,
                -31.019585952596508
              ],
              [
                -53.4675775765408,
                -31.017977602813932
              ],
              [
                -53.46599881221612,
                -31.01819204945161
              ],
              [
                -53.46252553070184,
                -31.0223737588863
              ],
              [
                -53.45889437275509,
                -31.022212923908043
              ],
              [
                -53.45489483646592,
                -31.02001484587186
              ],
              [
                -53.450684798266785,
                -31.016583699669038
              ],
              [
                -53.44658001102263,
                -31.016208418053104
              ],
              [
                -53.44610638172524,
                -31.014921738227045
              ],
              [
                -53.448895532032154,
                -31.012991718487957
              ],
              [
                -53.45147418042912,
                -31.01218754359667
              ],
              [
                -53.45231618806895,
                -31.012509213553184
              ],
              [
                -53.453000319276306,
                -31.014385621632854
              ],
              [
                -53.45568421862826,
                -31.01631564137194
              ],
              [
                -53.458315492502706,
                -31.016422864690778
              ],
              [
                -53.46299915999924,
                -31.01390311669808
              ],
              [
                -53.46352541477413,
                -31.013098941806795
              ],
              [
                -53.457526110340375,
                -31.006183037741728
              ],
              [
                -53.456105222448166,
                -31.005807756125797
              ],
              [
                -53.45268456641137,
                -31.006504707698245
              ],
              [
                -53.45100055113172,
                -31.005914979444633
              ],
              [
                -53.450790049221766,
                -31.00500358123451
              ],
              [
                -53.45321082118627,
                -31.002108551625877
              ],
              [
                -53.45421070525856,
                -30.999106298698408
              ],
              [
                -53.455210589330854,
                -30.997980453850605
              ],
              [
                -53.45878912180011,
                -30.995514317517326
              ],
              [
                -53.457789237727816,
                -30.994013191053593
              ],
              [
                -53.45057954731181,
                -30.995675152495586
              ],
              [
                -53.447316767707484,
                -30.99170788969857
              ],
              [
                -53.44468549383303,
                -30.992619287908695
              ],
              [
                -53.439317695129134,
                -30.991975947995666
              ],
              [
                -53.438107309146886,
                -30.992083171314505
              ],
              [
                -53.436581170299704,
                -30.9875797919233
              ],
              [
                -53.437475803417016,
                -30.98511365559002
              ],
              [
                -53.44179109257112,
                -30.986507558734917
              ],
              [
                -53.443580358805754,
                -30.988223131836328
              ],
              [
                -53.445895879815275,
                -30.988008685198654
              ],
              [
                -53.44610638172524,
                -30.986025053800144
              ],
              [
                -53.4414227142287,
                -30.980020547945205
              ],
              [
                -53.44447499192307,
                -30.979484431351015
              ],
              [
                -53.44658001102263,
                -30.980020547945205
              ],
              [
                -53.448579779167225,
                -30.982593907597323
              ],
              [
                -53.45000066705943,
                -30.981789732706037
              ],
              [
                -53.44921128489709,
                -30.978304974843795
              ],
              [
                -53.447685146049906,
                -30.975409945235164
              ],
              [
                -53.44779039700489,
                -30.972086022351178
              ],
              [
                -53.441212212318746,
                -30.974016042090266
              ],
              [
                -53.438791440354244,
                -30.976911071698897
              ],
              [
                -53.436318042912255,
                -30.97728635331483
              ],
              [
                -53.43279213592049,
                -30.97632134344529
              ],
              [
                -53.43247638305555,
                -30.975302721916325
              ],
              [
                -53.434002521902734,
                -30.971174624141053
              ],
              [
                -53.43379201999278,
                -30.969995167633833
              ],
              [
                -53.4322132556681,
                -30.967904312916488
              ],
              [
                -53.42979248370361,
                -30.967100138025202
              ],
              [
                -53.43158174993824,
                -30.96361538016296
              ],
              [
                -53.43279213592049,
                -30.960398680597812
              ],
              [
                -53.43389727094776,
                -30.959487282387688
              ],
              [
                -53.43558128622741,
                -30.960291457278974
              ],
              [
                -53.43979132442654,
                -30.96468761335134
              ],
              [
                -53.44279097664342,
                -30.96479483667018
              ],
              [
                -53.44310672950835,
                -30.964205108416568
              ],
              [
                -53.4511058020867,
                -30.968225982873
              ],
              [
                -53.452474064501416,
                -30.968225982873
              ],
              [
                -53.454684334555964,
                -30.96661763309043
              ],
              [
                -53.45478958551094,
                -30.961524525445615
              ],
              [
                -53.454473832646,
                -30.96002339898188
              ],
              [
                -53.455999971493185,
                -30.95761087430802
              ],
              [
                -53.463104410954216,
                -30.957181981032665
              ],
              [
                -53.46378854216158,
                -30.956216971163123
              ],
              [
                -53.463999044071535,
                -30.954394174742873
              ],
              [
                -53.46068363898972,
                -30.94978357203283
              ],
              [
                -53.456999855565485,
                -30.94812161059084
              ],
              [
                -53.45657885174557,
                -30.945923532554655
              ],
              [
                -53.460999391854656,
                -30.944583241069175
              ],
              [
                -53.46352541477413,
                -30.94447601775034
              ],
              [
                -53.466209314126075,
                -30.945709085916977
              ],
              [
                -53.46999834850529,
                -30.948604115525608
              ],
              [
                -53.47652390771395,
                -30.949890795351667
              ],
              [
                -53.47752379178624,
                -30.951874426750173
              ],
              [
                -53.47541877268667,
                -30.95401889312694
              ],
              [
                -53.47031410137023,
                -30.955573631250093
              ],
              [
                -53.47041935232521,
                -30.95637780614138
              ],
              [
                -53.47389263383949,
                -30.96179258374271
              ],
              [
                -53.47499776886676,
                -30.96661763309043
              ],
              [
                -53.47989193827325,
                -30.968494041170096
              ],
              [
                -53.48210220832779,
                -30.967314584662876
              ],
              [
                -53.483575721697484,
                -30.96168536042387
              ],
              [
                -53.48220745928277,
                -30.959594505706526
              ],
              [
                -53.48231271023775,
                -30.95771809762686
              ],
              [
                -53.483417845265016,
                -30.95691392273557
              ],
              [
                -53.48841726562649,
                -30.957825320945695
              ],
              [
                -53.49010128090614,
                -30.958575884177563
              ],
              [
                -53.49341668598795,
                -30.960988408851424
              ],
              [
                -53.49667946559228,
                -30.961524525445615
              ],
              [
                -53.500521125448984,
                -30.955680854568932
              ],
              [
                -53.50267877002604,
                -30.953107494916814
              ],
              [
                -53.50362602862084,
                -30.950105241989345
              ],
              [
                -53.50199463881868,
                -30.945119357663366
              ],
              [
                -53.501678885953744,
                -30.94077681325042
              ],
              [
                -53.502205140728634,
                -30.939919026699712
              ],
              [
                -53.503994406963265,
                -30.939222075127265
              ],
              [
                -53.50678355727019,
                -30.939007628489588
              ],
              [
                -53.5082044451624,
                -30.940615978272163
              ],
              [
                -53.509309580189665,
                -30.942814056308347
              ],
              [
                -53.51062521712689,
                -30.943993512815567
              ],
              [
                -53.51220398145157,
                -30.944207959453244
              ],
              [
                -53.51441425150611,
                -30.94259960967067
              ],
              [
                -53.515519386533384,
                -30.93777456032295
              ],
              [
                -53.5168876489481,
                -30.935201200670832
              ],
              [
                -53.518624289705244,
                -30.93418257914187
              ],
              [
                -53.52051880689485,
                -30.934021744163612
              ],
              [
                -53.52178181835459,
                -30.935201200670832
              ],
              [
                -53.52288695338186,
                -30.940508754953324
              ],
              [
                -53.52320270624679,
                -30.941098483206936
              ],
              [
                -53.52578135464376,
                -30.942277939714156
              ],
              [
                -53.52841262851822,
                -30.945280192641626
              ],
              [
                -53.52620235846367,
                -30.95048052360528
              ],
              [
                -53.5260971075087,
                -30.951874426750173
              ],
              [
                -53.527307493490945,
                -30.95337555321391
              ],
              [
                -53.52851787947319,
                -30.953589999851587
              ],
              [
                -53.53320154696973,
                -30.95262498998204
              ],
              [
                -53.53730633421388,
                -30.953589999851587
              ],
              [
                -53.542200503620364,
                -30.953697223170423
              ],
              [
                -53.54509490488227,
                -30.951606368453078
              ],
              [
                -53.54609478895456,
                -30.94978357203283
              ],
              [
                -53.54620003990954,
                -30.94849689220677
              ],
              [
                -53.54377926794504,
                -30.94667409578652
              ],
              [
                -53.53667482848401,
                -30.947799940634322
              ],
              [
                -53.53341204887968,
                -30.94667409578652
              ],
              [
                -53.53178065907752,
                -30.944583241069175
              ],
              [
                -53.53178065907752,
                -30.943082114605442
              ],
              [
                -53.53678007943899,
                -30.93841790023598
              ],
              [
                -53.53941135331344,
                -30.937613725344693
              ],
              [
                -53.54441077367491,
                -30.939222075127265
              ],
              [
                -53.547199923981836,
                -30.940723201591002
              ],
              [
                -53.55340973032555,
                -30.940294308315647
              ],
              [
                -53.557304015659746,
                -30.942277939714156
              ],
              [
                -53.55877752902944,
                -30.94142015316345
              ],
              [
                -53.560882548129,
                -30.937613725344693
              ],
              [
                -53.560303667876624,
                -30.936112598880957
              ],
              [
                -53.55877752902944,
                -30.934825919054898
              ],
              [
                -53.5536202322355,
                -30.93359285088826
              ],
              [
                -53.5497785723788,
                -30.93418257914187
              ],
              [
                -53.5464105418195,
                -30.93348562756942
              ],
              [
                -53.54267413291777,
                -30.930483374641952
              ],
              [
                -53.54277938387275,
                -30.927373898395643
              ],
              [
                -53.54420027176495,
                -30.926516111844936
              ],
              [
                -53.548883939261486,
                -30.92560471363481
              ],
              [
                -53.552409846253255,
                -30.925979995250746
              ],
              [
                -53.554988494650225,
                -30.926676946823193
              ],
              [
                -53.55661988445239,
                -30.92817807328693
              ],
              [
                -53.55940903475931,
                -30.93160921948975
              ],
              [
                -53.56077729717403,
                -30.932091724424524
              ],
              [
                -53.56361907295844,
                -30.93160921948975
              ],
              [
                -53.56630297231038,
                -30.929679199750666
              ],
              [
                -53.56398745130086,
                -30.925497490315973
              ],
              [
                -53.562724439841126,
                -30.921798285816056
              ],
              [
                -53.56598721944545,
                -30.91557933332344
              ],
              [
                -53.56919737357229,
                -30.91300597367132
              ],
              [
                -53.57198652387921,
                -30.909306769171405
              ],
              [
                -53.573775790113835,
                -30.908020089345346
              ],
              [
                -53.577512199015565,
                -30.909092322533727
              ],
              [
                -53.57872258499781,
                -30.91139762388875
              ],
              [
                -53.58040660027747,
                -30.91927853782336
              ],
              [
                -53.58640590471123,
                -30.923621082236306
              ],
              [
                -53.590089688135464,
                -30.924800538743526
              ],
              [
                -53.60061478363329,
                -30.92018993603348
              ],
              [
                -53.6015094167506,
                -30.918903256207425
              ],
              [
                -53.59798350975883,
                -30.910003720743852
              ],
              [
                -53.597194127596495,
                -30.909306769171405
              ],
              [
                -53.59261571105495,
                -30.90952121580908
              ],
              [
                -53.59051069195538,
                -30.909199545852566
              ],
              [
                -53.58940555692811,
                -30.908020089345346
              ],
              [
                -53.58961605883806,
                -30.906679797859866
              ],
              [
                -53.594720730154506,
                -30.902819758381693
              ],
              [
                -53.595510112316845,
                -30.901318631917956
              ],
              [
                -53.59519435945191,
                -30.89992472877306
              ],
              [
                -53.59387872251468,
                -30.899174165541194
              ],
              [
                -53.58998443718049,
                -30.899495835497707
              ],
              [
                -53.588774051198236,
                -30.89858443728758
              ],
              [
                -53.5879846690359,
                -30.896708029207915
              ],
              [
                -53.588774051198236,
                -30.895582184360112
              ],
              [
                -53.59261571105495,
                -30.895474961041273
              ],
              [
                -53.59640474543416,
                -30.896708029207915
              ],
              [
                -53.602877679165324,
                -30.896708029207915
              ],
              [
                -53.60787709952679,
                -30.899495835497707
              ],
              [
                -53.60940323837397,
                -30.8989061072441
              ],
              [
                -53.609876867671375,
                -30.897726650736878
              ],
              [
                -53.609087485509036,
                -30.89590385431663
              ],
              [
                -53.60550895303978,
                -30.894295504534053
              ],
              [
                -53.59872026644368,
                -30.886575425577703
              ],
              [
                -53.597825633326366,
                -30.884591794179194
              ],
              [
                -53.59787825880385,
                -30.88309066771546
              ],
              [
                -53.600299030768355,
                -30.880624531382182
              ],
              [
                -53.60108841293069,
                -30.878694511643094
              ],
              [
                -53.60087791102074,
                -30.876281986969232
              ],
              [
                -53.60229879891294,
                -30.871617772599773
              ],
              [
                -53.601983046048005,
                -30.86759689814334
              ],
              [
                -53.599509648606016,
                -30.861806838926075
              ],
              [
                -53.59940439765104,
                -30.859876819186987
              ],
              [
                -53.60061478363329,
                -30.857678741150803
              ],
              [
                -53.602877679165324,
                -30.85671373128126
              ],
              [
                -53.6054037020848,
                -30.85510538149869
              ],
              [
                -53.60671933902203,
                -30.855695109752297
              ],
              [
                -53.607403470229386,
                -30.857678741150803
              ],
              [
                -53.60798235048177,
                -30.86100266403479
              ],
              [
                -53.61008736958133,
                -30.863576023686907
              ],
              [
                -53.61240289059085,
                -30.864219363599936
              ],
              [
                -53.61487628803284,
                -30.864112140281097
              ],
              [
                -53.61729705999734,
                -30.862396567179687
              ],
              [
                -53.6204019631692,
                -30.8627182371362
              ],
              [
                -53.6232963644311,
                -30.865988548360765
              ],
              [
                -53.62508563066573,
                -30.86689994657089
              ],
              [
                -53.62929566886486,
                -30.866792723252054
              ],
              [
                -53.63597910450598,
                -30.86759689814334
              ],
              [
                -53.64018914270511,
                -30.86872274299114
              ],
              [
                -53.64718833121116,
                -30.869205247925912
              ],
              [
                -53.65239825348258,
                -30.872690005788154
              ],
              [
                -53.65729242288907,
                -30.872690005788154
              ],
              [
                -53.66039732606093,
                -30.871510549280934
              ],
              [
                -53.65960794389859,
                -30.866524664954955
              ],
              [
                -53.65260875539254,
                -30.864219363599936
              ],
              [
                -53.651819373230204,
                -30.862396567179687
              ],
              [
                -53.65108261654535,
                -30.857625129491385
              ],
              [
                -53.65208250061765,
                -30.854622876563916
              ],
              [
                -53.65150362036527,
                -30.848618370708976
              ],
              [
                -53.65229300252761,
                -30.84052301013669
              ],
              [
                -53.65771342670899,
                -30.8385929903976
              ],
              [
                -53.660081573195995,
                -30.83939716528889
              ],
              [
                -53.66208134134058,
                -30.84229219489752
              ],
              [
                -53.66350222923279,
                -30.842774699832294
              ],
              [
                -53.66660713240464,
                -30.842077748259843
              ],
              [
                -53.66718601265703,
                -30.842721088172873
              ],
              [
                -53.67239593492845,
                -30.84229219489752
              ],
              [
                -53.67208018206352,
                -30.841005515071462
              ],
              [
                -53.67281693874836,
                -30.83987967022366
              ],
              [
                -53.676395471217624,
                -30.837091863933868
              ],
              [
                -53.68007925464186,
                -30.83569796078897
              ],
              [
                -53.68139489157909,
                -30.833285436115112
              ],
              [
                -53.68371041258861,
                -30.829586231615192
              ],
              [
                -53.68839408008514,
                -30.824707570608055
              ],
              [
                -53.691025353959596,
                -30.825887027115275
              ],
              [
                -53.69028859727475,
                -30.822402269253033
              ],
              [
                -53.6886045819951,
                -30.82068669615162
              ],
              [
                -53.68718369410289,
                -30.81591525846332
              ],
              [
                -53.684289292840994,
                -30.813878015405393
              ],
              [
                -53.68449979475095,
                -30.812698558898173
              ],
              [
                -53.68602593359813,
                -30.812001607325726
              ],
              [
                -53.68918346224748,
                -30.81291300553585
              ],
              [
                -53.690499099184706,
                -30.81419968536191
              ],
              [
                -53.69991905965526,
                -30.816290540079255
              ],
              [
                -53.70107682016002,
                -30.81591525846332
              ],
              [
                -53.70218195518729,
                -30.812484112260496
              ],
              [
                -53.70581311313404,
                -30.808624072782322
              ],
              [
                -53.707076124593776,
                -30.801118440463647
              ],
              [
                -53.71349643284745,
                -30.798223410855016
              ],
              [
                -53.71891685702883,
                -30.793023079891363
              ],
              [
                -53.71917998441628,
                -30.790878613514597
              ],
              [
                -53.721706007335754,
                -30.787876360587127
              ],
              [
                -53.72502141241757,
                -30.787876360587127
              ],
              [
                -53.726494925787264,
                -30.78648245744223
              ],
              [
                -53.728810446796786,
                -30.786321622463973
              ],
              [
                -53.73280998308596,
                -30.7835874278336
              ],
              [
                -53.73612538816777,
                -30.78508855429733
              ],
              [
                -53.73702002128509,
                -30.783694651152437
              ],
              [
                -53.73517812957297,
                -30.782783252942313
              ],
              [
                -53.73680951937513,
                -30.779512941717748
              ],
              [
                -53.73991442254699,
                -30.775920960536666
              ],
              [
                -53.74270357285391,
                -30.77511678564538
              ],
              [
                -53.74528222125088,
                -30.77270426097152
              ],
              [
                -53.74728198939547,
                -30.77259703765268
              ],
              [
                -53.7475977422604,
                -30.77447344573235
              ],
              [
                -53.748492375377715,
                -30.77618901883376
              ],
              [
                -53.75059739447728,
                -30.777422087000403
              ],
              [
                -53.753018166441784,
                -30.777314863681564
              ],
              [
                -53.75770183393831,
                -30.77500956232654
              ],
              [
                -53.76080673711017,
                -30.776081795514923
              ],
              [
                -53.76291175620973,
                -30.778923213464136
              ],
              [
                -53.76238550143484,
                -30.78289047626115
              ],
              [
                -53.763122258119694,
                -30.784284379406046
              ],
              [
                -53.76838480586861,
                -30.78889498211609
              ],
              [
                -53.76912156255345,
                -30.792808633253685
              ],
              [
                -53.76917418803094,
                -30.79489948797103
              ],
              [
                -53.76849005682358,
                -30.79779451757966
              ],
              [
                -53.77238434215778,
                -30.79972453731875
              ],
              [
                -53.77912040327639,
                -30.797526459282565
              ],
              [
                -53.78280418670062,
                -30.798277022514434
              ],
              [
                -53.78401457268287,
                -30.79961731399991
              ],
              [
                -53.78548808605257,
                -30.799885372297005
              ],
              [
                -53.78790885801707,
                -30.79849146915211
              ],
              [
                -53.792118896216195,
                -30.793023079891363
              ],
              [
                -53.79659206180277,
                -30.792111681681234
              ],
              [
                -53.799591714019655,
                -30.789699157007377
              ],
              [
                -53.80238086432657,
                -30.788573312159574
              ],
              [
                -53.80522264011099,
                -30.787876360587127
              ],
              [
                -53.804906887246055,
                -30.78508855429733
              ],
              [
                -53.80627514966077,
                -30.781282126478576
              ],
              [
                -53.804275381516184,
                -30.775813737217828
              ],
              [
                -53.806590902525706,
                -30.76841532821799
              ],
              [
                -53.80627514966077,
                -30.767396706689027
              ],
              [
                -53.803485999353846,
                -30.765305851971682
              ],
              [
                -53.805696269408394,
                -30.762893327297824
              ],
              [
                -53.810116809517474,
                -30.762678880660147
              ],
              [
                -53.81390584389669,
                -30.760319967645707
              ],
              [
                -53.814905727968984,
                -30.75817550126894
              ],
              [
                -53.81558985917634,
                -30.753082393624126
              ],
              [
                -53.81901051521314,
                -30.752492665370518
              ],
              [
                -53.82090503240275,
                -30.751420432182133
              ],
              [
                -53.821483912655125,
                -30.748900684189437
              ],
              [
                -53.82058927953781,
                -30.74691705279093
              ],
              [
                -53.816273990383706,
                -30.744182858160556
              ],
              [
                -53.817221248978505,
                -30.741287828551922
              ],
              [
                -53.8182211330508,
                -30.739411420472255
              ],
              [
                -53.81769487827591,
                -30.738875303878064
              ],
              [
                -53.814484724149075,
                -30.738124740646196
              ],
              [
                -53.81301121077938,
                -30.735819439291173
              ],
              [
                -53.80890642353523,
                -30.733299691298477
              ],
              [
                -53.80838016876034,
                -30.731476894878227
              ],
              [
                -53.80622252418328,
                -30.731208836581132
              ],
              [
                -53.80390700317376,
                -30.729225205182622
              ],
              [
                -53.80511738915601,
                -30.7257940589798
              ],
              [
                -53.807380284688044,
                -30.722523747755236
              ],
              [
                -53.811274570022235,
                -30.720111223081375
              ],
              [
                -53.8133795891218,
                -30.71791314504519
              ],
              [
                -53.81301121077938,
                -30.715822290327846
              ],
              [
                -53.81380059294172,
                -30.71437477552353
              ],
              [
                -53.81259020695946,
                -30.71319531901631
              ],
              [
                -53.81248495600449,
                -30.710085842770003
              ],
              [
                -53.81080094072483,
                -30.70949611451639
              ],
              [
                -53.808011790417915,
                -30.709817784472907
              ],
              [
                -53.807117157300596,
                -30.7114797459149
              ],
              [
                -53.80559101845341,
                -30.7114797459149
              ],
              [
                -53.80301237005644,
                -30.70901360958162
              ],
              [
                -53.79759194587506,
                -30.706386638270086
              ],
              [
                -53.797276193010134,
                -30.705689686697635
              ],
              [
                -53.80101260191186,
                -30.701186307306433
              ],
              [
                -53.79980221592961,
                -30.699792404161535
              ],
              [
                -53.79738144396511,
                -30.69888100595141
              ],
              [
                -53.796276308937834,
                -30.695985976342776
              ],
              [
                -53.79748669492009,
                -30.69469929651672
              ],
              [
                -53.797013065622686,
                -30.689498965553067
              ],
              [
                -53.79748669492009,
                -30.688909237299455
              ],
              [
                -53.80122310382181,
                -30.687890615770492
              ],
              [
                -53.80269661719151,
                -30.68681838258211
              ],
              [
                -53.80301237005644,
                -30.684888362843022
              ],
              [
                -53.802591366236534,
                -30.68328001306045
              ],
              [
                -53.801275729299306,
                -30.683011954763355
              ],
              [
                -53.79790769874,
                -30.685478091096634
              ],
              [
                -53.796381559892815,
                -30.684673916205348
              ],
              [
                -53.79538167582052,
                -30.680492206770655
              ],
              [
                -53.79438179174823,
                -30.679205526944596
              ],
              [
                -53.79411866436078,
                -30.676096050698288
              ],
              [
                -53.79811820064996,
                -30.676310497335965
              ],
              [
                -53.7983813280374,
                -30.674594924234555
              ],
              [
                -53.79738144396511,
                -30.671485447988246
              ],
              [
                -53.794697544613165,
                -30.67132461300999
              ],
              [
                -53.79527642486554,
                -30.66960903990858
              ],
              [
                -53.798697080902336,
                -30.66569538877098
              ],
              [
                -53.79980221592961,
                -30.66290758248119
              ],
              [
                -53.79880233185732,
                -30.660173387850815
              ],
              [
                -53.80059159809195,
                -30.65727835824218
              ],
              [
                -53.80101260191186,
                -30.655884455097286
              ],
              [
                -53.79801294969498,
                -30.65202441561911
              ],
              [
                -53.80027584522701,
                -30.648807716053962
              ],
              [
                -53.79827607708243,
                -30.64719936627139
              ],
              [
                -53.79759194587506,
                -30.643285715133796
              ],
              [
                -53.79601318155039,
                -30.642213481945415
              ],
              [
                -53.791592641441305,
                -30.642803210199023
              ],
              [
                -53.78827723635949,
                -30.6418918119889
              ],
              [
                -53.78748785419715,
                -30.63878233574259
              ],
              [
                -53.78827723635949,
                -30.637978160851304
              ],
              [
                -53.791487390486324,
                -30.638514277445495
              ],
              [
                -53.7925925255136,
                -30.637281209278857
              ],
              [
                -53.79411866436078,
                -30.636905927662923
              ],
              [
                -53.79559217773048,
                -30.639211229017945
              ],
              [
                -53.7983813280374,
                -30.638621500764334
              ],
              [
                -53.79911808472225,
                -30.635512024518025
              ],
              [
                -53.801801984074196,
                -30.634278956351388
              ],
              [
                -53.8036965012638,
                -30.63299227652533
              ],
              [
                -53.7983813280374,
                -30.630901421807984
              ],
              [
                -53.796118432505374,
                -30.628810567090635
              ],
              [
                -53.797802447785024,
                -30.627684722242837
              ],
              [
                -53.80027584522701,
                -30.629025013728313
              ],
              [
                -53.80211773693913,
                -30.627309440626902
              ],
              [
                -53.79269777646858,
                -30.623610236126982
              ],
              [
                -53.79190839430624,
                -30.62500413927188
              ],
              [
                -53.793381907675936,
                -30.629507518663086
              ],
              [
                -53.79359240958589,
                -30.631276703423914
              ],
              [
                -53.792224147171176,
                -30.63218810163404
              ],
              [
                -53.78890874208936,
                -30.629078625387734
              ],
              [
                -53.78648797012486,
                -30.630097246916694
              ],
              [
                -53.785224958665125,
                -30.628488897134122
              ],
              [
                -53.783383066953,
                -30.62929307202541
              ],
              [
                -53.780225538303654,
                -30.62988280027902
              ],
              [
                -53.77912040327639,
                -30.62977557696018
              ],
              [
                -53.77859414850149,
                -30.628488897134122
              ],
              [
                -53.77948878161881,
                -30.627684722242837
              ],
              [
                -53.78311993956556,
                -30.62789916888051
              ],
              [
                -53.78327781599803,
                -30.625915537482005
              ],
              [
                -53.782120055493266,
                -30.62371745944582
              ],
              [
                -53.77848889754652,
                -30.624575245996528
              ],
              [
                -53.77480511412227,
                -30.622323556300927
              ],
              [
                -53.774910365077254,
                -30.62017908992416
              ],
              [
                -53.781488549763395,
                -30.620876041496608
              ],
              [
                -53.78248843383569,
                -30.62039353656184
              ],
              [
                -53.78248843383569,
                -30.618785186779263
              ],
              [
                -53.777489013474224,
                -30.617016002018435
              ],
              [
                -53.77769951538418,
                -30.614710700663412
              ],
              [
                -53.779804534483745,
                -30.613799302453288
              ],
              [
                -53.78669847203482,
                -30.60811646655486
              ],
              [
                -53.78701422489975,
                -30.607097845025898
              ],
              [
                -53.78559333700755,
                -30.60640089345345
              ],
              [
                -53.7804886656911,
                -30.60650811677229
              ],
              [
                -53.77859414850149,
                -30.60779479659835
              ],
              [
                -53.77559449628461,
                -30.60779479659835
              ],
              [
                -53.77301584788765,
                -30.606722563409964
              ],
              [
                -53.77280534597769,
                -30.606079223496934
              ],
              [
                -53.774226233869896,
                -30.60398836877959
              ],
              [
                -53.77459461221232,
                -30.60087889253328
              ],
              [
                -53.774120982914916,
                -30.599324154410127
              ],
              [
                -53.76901631159847,
                -30.597715804627555
              ],
              [
                -53.76770067466124,
                -30.59337326021461
              ],
              [
                -53.765174651741766,
                -30.59337326021461
              ],
              [
                -53.763122258119694,
                -30.589888502352366
              ],
              [
                -53.76280650525476,
                -30.587422366019087
              ],
              [
                -53.75917534730801,
                -30.588816269163985
              ],
              [
                -53.75828071419069,
                -30.58838737588863
              ],
              [
                -53.75838596514567,
                -30.58592123955535
              ],
              [
                -53.75538631292879,
                -30.582597316671368
              ],
              [
                -53.75359704669416,
                -30.58291898662788
              ],
              [
                -53.75191303141451,
                -30.57991673370041
              ],
              [
                -53.753807548604115,
                -30.577718655664228
              ],
              [
                -53.7504921435223,
                -30.576807257454103
              ],
              [
                -53.749018630152605,
                -30.57460917941792
              ],
              [
                -53.742019441646555,
                -30.572303878062897
              ],
              [
                -53.73817778178985,
                -30.569998576707878
              ],
              [
                -53.73749365058249,
                -30.565924090592024
              ],
              [
                -53.74038805184439,
                -30.565387973997833
              ],
              [
                -53.74070380470933,
                -30.562814614345715
              ],
              [
                -53.739809171592015,
                -30.55707816678787
              ],
              [
                -53.74038805184439,
                -30.555416205345878
              ],
              [
                -53.73880928751972,
                -30.55482647709227
              ],
              [
                -53.73949341872708,
                -30.552789234034343
              ],
              [
                -53.738283032744825,
                -30.55128810757061
              ],
              [
                -53.738388283699805,
                -30.5493044761721
              ],
              [
                -53.736178013645265,
                -30.548982806215587
              ],
              [
                -53.736704268420155,
                -30.54748167975185
              ],
              [
                -53.73880928751972,
                -30.545283601715667
              ],
              [
                -53.738914538474695,
                -30.54169162053459
              ],
              [
                -53.74291407476387,
                -30.540190494070853
              ],
              [
                -53.7447033409985,
                -30.53552627970139
              ],
              [
                -53.74838712442274,
                -30.535204609744877
              ],
              [
                -53.749018630152605,
                -30.533113755027532
              ],
              [
                -53.7475977422604,
                -30.531183735288444
              ],
              [
                -53.74612422889071,
                -30.530486783715993
              ],
              [
                -53.742019441646555,
                -30.52609062764363
              ],
              [
                -53.74238781998898,
                -30.52308837471616
              ],
              [
                -53.74580847602577,
                -30.518799441962628
              ],
              [
                -53.745124344818414,
                -30.51627969396993
              ],
              [
                -53.74391395883616,
                -30.515582742397484
              ],
              [
                -53.7451769702959,
                -30.513706334317813
              ],
              [
                -53.743703456926205,
                -30.51327744104246
              ],
              [
                -53.742282569034,
                -30.511883537897564
              ],
              [
                -53.73312573595089,
                -30.4988022929993
              ],
              [
                -53.72628442387731,
                -30.492315282209592
              ],
              [
                -53.726389674832284,
                -30.48829440775316
              ],
              [
                -53.72360052452537,
                -30.486525222992327
              ],
              [
                -53.72281114236303,
                -30.486578834651745
              ],
              [
                -53.72060087230848,
                -30.48518493150685
              ],
              [
                -53.71770647104658,
                -30.485613824782202
              ],
              [
                -53.71602245576693,
                -30.484702426572078
              ],
              [
                -53.713391181892476,
                -30.484702426572078
              ],
              [
                -53.7118124175678,
                -30.482986853470667
              ],
              [
                -53.71139141374789,
                -30.48030627049971
              ],
              [
                -53.7118124175678,
                -30.476982347615724
              ],
              [
                -53.71281230164009,
                -30.47188923997091
              ],
              [
                -53.71581195385697,
                -30.465402229181198
              ],
              [
                -53.716285583154374,
                -30.463204151145014
              ],
              [
                -53.71528569908208,
                -30.45998745157987
              ],
              [
                -53.71602245576693,
                -30.456502693717628
              ],
              [
                -53.71739071818165,
                -30.45639547039879
              ],
              [
                -53.7190747334613,
                -30.457682150224848
              ],
              [
                -53.720390370398526,
                -30.457306868608914
              ],
              [
                -53.72060087230848,
                -30.45510879057273
              ],
              [
                -53.71960098823619,
                -30.452696265898872
              ],
              [
                -53.71781172200156,
                -30.451409586072813
              ],
              [
                -53.713285930937495,
                -30.451892091007583
              ],
              [
                -53.710181027765636,
                -30.451409586072813
              ],
              [
                -53.71218079591022,
                -30.448085663188827
              ],
              [
                -53.7161803321994,
                -30.44797843986999
              ],
              [
                -53.71960098823619,
                -30.44910428471779
              ],
              [
                -53.71991674110112,
                -30.448085663188827
              ],
              [
                -53.71828535129896,
                -30.44620925510916
              ],
              [
                -53.713917436667366,
                -30.436398321435462
              ],
              [
                -53.71307542902754,
                -30.43178771872542
              ],
              [
                -53.71407531309983,
                -30.42991131064575
              ],
              [
                -53.71770647104658,
                -30.43001853396459
              ],
              [
                -53.71891685702883,
                -30.42980408732691
              ],
              [
                -53.72139025447082,
                -30.424282086406745
              ],
              [
                -53.72139025447082,
                -30.422405678327074
              ],
              [
                -53.71939048632623,
                -30.421118998501015
              ],
              [
                -53.71917998441628,
                -30.420100376972055
              ],
              [
                -53.71739071818165,
                -30.419617872037282
              ],
              [
                -53.71291755259507,
                -30.4221912316894
              ],
              [
                -53.7118124175678,
                -30.42379958147197
              ],
              [
                -53.70818125962105,
                -30.42101177518218
              ],
              [
                -53.70802338318858,
                -30.419993153653216
              ],
              [
                -53.71007577681066,
                -30.418706473827157
              ],
              [
                -53.71239129782018,
                -30.414900046008402
              ],
              [
                -53.71502257169464,
                -30.41431031775479
              ],
              [
                -53.71670658697429,
                -30.41130806482732
              ],
              [
                -53.71670658697429,
                -30.40948526840707
              ],
              [
                -53.71581195385697,
                -30.408198588581012
              ],
              [
                -53.716917088884244,
                -30.406322180501345
              ],
              [
                -53.713391181892476,
                -30.40289103429852
              ],
              [
                -53.716496085064335,
                -30.397905149972544
              ],
              [
                -53.71591720481195,
                -30.39688652844358
              ],
              [
                -53.71260179973014,
                -30.394795673726236
              ],
              [
                -53.70907589273837,
                -30.397583480016028
              ],
              [
                -53.70560261122409,
                -30.401014626218853
              ],
              [
                -53.70491848001672,
                -30.402676587660842
              ],
              [
                -53.70507635644919,
                -30.40449938408109
              ],
              [
                -53.70728662650374,
                -30.407501637008565
              ],
              [
                -53.7026029590072,
                -30.409217210109976
              ],
              [
                -53.70091894372755,
                -30.41548977426201
              ],
              [
                -53.70002431061024,
                -30.416508395790974
              ],
              [
                -53.696603654573444,
                -30.416293949153296
              ],
              [
                -53.69491963929379,
                -30.416990900725747
              ],
              [
                -53.69239361637432,
                -30.419885930334377
              ],
              [
                -53.69260411828427,
                -30.42229845500824
              ],
              [
                -53.65597678595184,
                -30.43232383531961
              ],
              [
                -53.65018798342804,
                -30.427820455928405
              ],
              [
                -53.647925087896006,
                -30.425675989551642
              ],
              [
                -53.64671470191376,
                -30.42229845500824
              ],
              [
                -53.64439918090424,
                -30.418277580551806
              ],
              [
                -53.643399296831944,
                -30.41120084150848
              ],
              [
                -53.63461084209126,
                -30.403212704255036
              ],
              [
                -53.63397933636139,
                -30.39978155805221
              ],
              [
                -53.6344003401813,
                -30.394313168791463
              ],
              [
                -53.63287420133412,
                -30.393026488965404
              ],
              [
                -53.62987454911724,
                -30.391203692545155
              ],
              [
                -53.62871678861248,
                -30.388791167871297
              ],
              [
                -53.62582238735058,
                -30.3860033615815
              ],
              [
                -53.623085862521144,
                -30.38439501179893
              ],
              [
                -53.620612465079155,
                -30.384877516733702
              ],
              [
                -53.61898107527699,
                -30.384019730182995
              ],
              [
                -53.61398165491553,
                -30.37780077769038
              ],
              [
                -53.547726178756726,
                -30.363003959690705
              ],
              [
                -53.5497785723788,
                -30.364397862835602
              ],
              [
                -53.550199576198715,
                -30.3655237076834
              ],
              [
                -53.54919969212642,
                -30.36879401890797
              ],
              [
                -53.54919969212642,
                -30.370992096944153
              ],
              [
                -53.54751567684677,
                -30.376192427907807
              ],
              [
                -53.547726178756726,
                -30.38069580729901
              ],
              [
                -53.550620580018624,
                -30.382893885335193
              ],
              [
                -53.548778688306506,
                -30.38611058490034
              ],
              [
                -53.5468841711169,
                -30.3885231095742
              ],
              [
                -53.547094673026855,
                -30.39029229433503
              ],
              [
                -53.54672629468443,
                -30.39281204232773
              ],
              [
                -53.54277938387275,
                -30.394205945472624
              ],
              [
                -53.5396218552234,
                -30.39710097508126
              ],
              [
                -53.539200851403486,
                -30.39828043158848
              ],
              [
                -53.537622087078816,
                -30.398119596610222
              ],
              [
                -53.53799046542124,
                -30.396189576871134
              ],
              [
                -53.537411585168854,
                -30.39527817866101
              ],
              [
                -53.535201315114314,
                -30.395921518574035
              ],
              [
                -53.53509606415933,
                -30.397905149972544
              ],
              [
                -53.53362255078964,
                -30.39817320826964
              ],
              [
                -53.53462243486193,
                -30.400585732943497
              ],
              [
                -53.533885678177086,
                -30.401979636088395
              ],
              [
                -53.52762324635588,
                -30.403212704255036
              ],
              [
                -53.524623594139,
                -30.40181880111014
              ],
              [
                -53.522518575039435,
                -30.398923771501508
              ],
              [
                -53.51662452156065,
                -30.397208198400094
              ],
              [
                -53.51220398145157,
                -30.38900561450897
              ],
              [
                -53.511625101199186,
                -30.386485866516274
              ],
              [
                -53.50967795853209,
                -30.384984740052538
              ],
              [
                -53.50120525665634,
                -30.379623574110628
              ],
              [
                -53.49988961971911,
                -30.376782156161415
              ],
              [
                -53.50110000570136,
                -30.37061681532822
              ],
              [
                -53.49399556624033,
                -30.3657917659805
              ],
              [
                -53.49399556624033,
                -30.362414231437096
              ],
              [
                -53.49231155096068,
                -30.360108930082074
              ],
              [
                -53.49199579809574,
                -30.357696405408213
              ],
              [
                -53.490417033771074,
                -30.35549832737203
              ],
              [
                -53.48578599175203,
                -30.352013569509786
              ],
              [
                -53.48299684144511,
                -30.347510190118584
              ],
              [
                -53.48268108858017,
                -30.343274869024473
              ],
              [
                -53.47652390771395,
                -30.33871787797385
              ],
              [
                -53.473997884794464,
                -30.338020926401402
              ],
              [
                -53.471524487352475,
                -30.334697003517416
              ],
              [
                -53.466998696288414,
                -30.33030084744505
              ],
              [
                -53.4661040631711,
                -30.3284780510248
              ],
              [
                -53.4685248351356,
                -30.32140131198148
              ],
              [
                -53.466577692468505,
                -30.32022185547426
              ],
              [
                -53.46199927592695,
                -30.319792962198903
              ],
              [
                -53.46068363898972,
                -30.318881563988782
              ],
              [
                -53.460788889944695,
                -30.315718476083052
              ],
              [
                -53.462578156179326,
                -30.314002902981642
              ],
              [
                -53.46589356126114,
                -30.314002902981642
              ],
              [
                -53.46910371538798,
                -30.31341317472803
              ],
              [
                -53.46957734468538,
                -30.31228732988023
              ],
              [
                -53.469208966342954,
                -30.30998202852521
              ],
              [
                -53.465788310306166,
                -30.307891173807864
              ],
              [
                -53.464525298846425,
                -30.306390047344127
              ],
              [
                -53.462209777836904,
                -30.302476396206533
              ],
              [
                -53.46252553070184,
                -30.3009752697428
              ],
              [
                -53.464525298846425,
                -30.300385541489188
              ],
              [
                -53.47331375358711,
                -30.29850913340952
              ],
              [
                -53.4728927497672,
                -30.297115230264623
              ],
              [
                -53.47068247971265,
                -30.294005754018315
              ],
              [
                -53.47341900454209,
                -30.293684084061802
              ],
              [
                -53.47452413956936,
                -30.294488258953088
              ],
              [
                -53.478681552291,
                -30.295614103800887
              ],
              [
                -53.4815759535529,
                -30.29609660873566
              ],
              [
                -53.48410197647238,
                -30.295292433844374
              ],
              [
                -53.48410197647238,
                -30.29298713248935
              ],
              [
                -53.485101860544674,
                -30.29202212261981
              ],
              [
                -53.48541761340961,
                -30.290413772837233
              ],
              [
                -53.4839967255174,
                -30.28762596654744
              ],
              [
                -53.48489135863471,
                -30.28478454859823
              ],
              [
                -53.48278633953515,
                -30.283712315409847
              ],
              [
                -53.48020769113818,
                -30.284302043663455
              ],
              [
                -53.47957618540831,
                -30.285803170127192
              ],
              [
                -53.4782079229936,
                -30.28591039344603
              ],
              [
                -53.47652390771395,
                -30.28708984995325
              ],
              [
                -53.47452413956936,
                -30.286821791656156
              ],
              [
                -53.47310325167715,
                -30.285695946808353
              ],
              [
                -53.472419120469795,
                -30.28339064545333
              ],
              [
                -53.47257699690226,
                -30.281889518989598
              ],
              [
                -53.4714192363975,
                -30.27931615933748
              ],
              [
                -53.47320850263213,
                -30.278511984446194
              ],
              [
                -53.47299800072217,
                -30.276796411344783
              ],
              [
                -53.47199811664988,
                -30.274812779946274
              ],
              [
                -53.47299800072217,
                -30.272293031953577
              ],
              [
                -53.47199811664988,
                -30.27079190548984
              ],
              [
                -53.47278749881222,
                -30.270094953917393
              ],
              [
                -53.4714192363975,
                -30.268915497410173
              ],
              [
                -53.46952471920789,
                -30.268808274091334
              ],
              [
                -53.46652506699101,
                -30.262321263301622
              ],
              [
                -53.462209777836904,
                -30.262214039982783
              ],
              [
                -53.45821024154773,
                -30.260873748497307
              ],
              [
                -53.456999855565485,
                -30.257603437272742
              ],
              [
                -53.4540002033486,
                -30.254708407664108
              ],
              [
                -53.4511058020867,
                -30.250794756526513
              ],
              [
                -53.44658001102263,
                -30.247899726917883
              ],
              [
                -53.44210684543606,
                -30.243503570845515
              ],
              [
                -53.43600229004732,
                -30.238785744816635
              ],
              [
                -53.42510881620707,
                -30.23288846228053
              ],
              [
                -53.420793527052965,
                -30.23122650083854
              ],
              [
                -53.41979364298067,
                -30.230315102628417
              ],
              [
                -53.419109511773314,
                -30.22168362546194
              ],
              [
                -53.41658348885384,
                -30.218520537556213
              ],
              [
                -53.41668873980881,
                -30.21750191602725
              ],
              [
                -53.41421534236683,
                -30.21149741017231
              ],
              [
                -53.41100518823999,
                -30.210103507027412
              ],
              [
                -53.40558476405861,
                -30.2097818370709
              ],
              [
                -53.39979596153481,
                -30.212301585063596
              ],
              [
                -53.39490179212832,
                -30.211282963534632
              ],
              [
                -53.39148113609153,
                -30.211819080128823
              ],
              [
                -53.39011287367681,
                -30.213105759954882
              ],
              [
                -53.3853239552253,
                -30.2097818370709
              ],
              [
                -53.383903067333094,
                -30.210103507027412
              ],
              [
                -53.38300843421578,
                -30.209299332136126
              ],
              [
                -53.383113685170756,
                -30.206886807462265
              ],
              [
                -53.38458719854045,
                -30.203991777853634
              ],
              [
                -53.3829031832608,
                -30.202812321346414
              ],
              [
                -53.382482179440885,
                -30.200292573353714
              ],
              [
                -53.37890364697163,
                -30.199273951824754
              ],
              [
                -53.37890364697163,
                -30.19782643702044
              ],
              [
                -53.37700912978202,
                -30.1977192137016
              ],
              [
                -53.3736937247002,
                -30.195413912346577
              ],
              [
                -53.372904342537865,
                -30.194288067498775
              ],
              [
                -53.36911530815865,
                -30.192411659419108
              ],
              [
                -53.36632615785173,
                -30.1879082800279
              ],
              [
                -53.36480001900454,
                -30.188176338324997
              ],
              [
                -53.36269499990498,
                -30.18747938675255
              ],
              [
                -53.36269499990498,
                -30.185817425310557
              ],
              [
                -53.36169511583269,
                -30.185388532035205
              ],
              [
                -53.35937959482317,
                -30.18629993024533
              ],
              [
                -53.35659044451624,
                -30.183404900636695
              ],
              [
                -53.352590908227064,
                -30.180509871028065
              ],
              [
                -53.35159102415477,
                -30.17841901631072
              ],
              [
                -53.35248565727209,
                -30.176274549933957
              ],
              [
                -53.35159102415477,
                -30.175095093426734
              ],
              [
                -53.35211727892967,
                -30.17300423870939
              ],
              [
                -53.351012143902395,
                -30.171020607310883
              ],
              [
                -53.34890712480283,
                -30.171020607310883
              ],
              [
                -53.34638110188335,
                -30.170216432419597
              ],
              [
                -53.34201318725175,
                -30.170323655738436
              ],
              [
                -53.340802801269504,
                -30.16989476246308
              ],
              [
                -53.33980291719721,
                -30.16828641268051
              ],
              [
                -53.340276546494614,
                -30.164211926564658
              ],
              [
                -53.34280256941409,
                -30.16228190682557
              ],
              [
                -53.3418026853418,
                -30.160619945383576
              ],
              [
                -53.339487164332276,
                -30.158475479006814
              ],
              [
                -53.33848728025998,
                -30.158475479006814
              ],
              [
                -53.33438249301583,
                -30.15692074088366
              ],
              [
                -53.3325932267812,
                -30.157885750753202
              ],
              [
                -53.33048820768164,
                -30.153007089746062
              ],
              [
                -53.330803960546575,
                -30.14839648703602
              ],
              [
                -53.33001457838424,
                -30.14780675878241
              ],
              [
                -53.328488439537054,
                -30.148825380311372
              ],
              [
                -53.32638342043749,
                -30.148182040398343
              ],
              [
                -53.32490990706779,
                -30.14710980720996
              ],
              [
                -53.32380477204052,
                -30.147699535463573
              ],
              [
                -53.3185948497691,
                -30.143303379391206
              ],
              [
                -53.31827909690416,
                -30.142177534543404
              ],
              [
                -53.3122797924704,
                -30.14378588432598
              ],
              [
                -53.31117465744313,
                -30.140890854717345
              ],
              [
                -53.30328083581976,
                -30.1388
              ],
              [
                -53.303122959387295,
                -30.141480582970956
              ],
              [
                -53.304806974666946,
                -30.14378588432598
              ],
              [
                -53.30659624090158,
                -30.14968316686208
              ],
              [
                -53.30828025618123,
                -30.151184293325812
              ],
              [
                -53.30759612497387,
                -30.157081575861916
              ],
              [
                -53.30412284345959,
                -30.164426373202332
              ],
              [
                -53.30691199376651,
                -30.172682568752876
              ],
              [
                -53.3147005644349,
                -30.182225444129475
              ],
              [
                -53.315174193732304,
                -30.185924648629396
              ],
              [
                -53.319699984796365,
                -30.190320804701763
              ],
              [
                -53.320226239571255,
                -30.19402000920168
              ],
              [
                -53.32322589178814,
                -30.201096748245003
              ],
              [
                -53.328488439537054,
                -30.205921797592723
              ],
              [
                -53.32780430832969,
                -30.212408808382435
              ],
              [
                -53.329909327429256,
                -30.214821333056292
              ],
              [
                -53.329909327429256,
                -30.218895819172147
              ],
              [
                -53.33190909557384,
                -30.22302391694742
              ],
              [
                -53.3350139987457,
                -30.22591894655605
              ],
              [
                -53.339487164332276,
                -30.227312849700944
              ],
              [
                -53.34211843820673,
                -30.23288846228053
              ],
              [
                -53.34722310952318,
                -30.236480443461613
              ],
              [
                -53.34638110188335,
                -30.238196016563023
              ],
              [
                -53.34669685474829,
                -30.240179647961533
              ],
              [
                -53.34827561907296,
                -30.242377725997713
              ],
              [
                -53.3475914878656,
                -30.243181900889002
              ],
              [
                -53.34859137193789,
                -30.244683027352735
              ],
              [
                -53.350485889127505,
                -30.24559442556286
              ],
              [
                -53.35180152606473,
                -30.248489455171494
              ],
              [
                -53.35080164199244,
                -30.252885611243858
              ],
              [
                -53.34838087002794,
                -30.254386737707595
              ],
              [
                -53.34701260761322,
                -30.258407612164028
              ],
              [
                -53.344802337558676,
                -30.261677923388593
              ],
              [
                -53.34580222163097,
                -30.26602046780154
              ],
              [
                -53.3442234573063,
                -30.27341887680138
              ],
              [
                -53.34290782036907,
                -30.27561695483756
              ],
              [
                -53.34359195157643,
                -30.278726431083868
              ],
              [
                -53.343118322279025,
                -30.28360509209101
              ],
              [
                -53.34211843820673,
                -30.289180704670596
              ],
              [
                -53.34290782036907,
                -30.290896277772006
              ],
              [
                -53.342697318459116,
                -30.29491715222844
              ],
              [
                -53.34101330317946,
                -30.298723580047195
              ],
              [
                -53.33848728025998,
                -30.3009752697428
              ],
              [
                -53.335487628043104,
                -30.301189716380474
              ],
              [
                -53.33490874779072,
                -30.30580031909052
              ],
              [
                -53.333119481556096,
                -30.30751589219193
              ],
              [
                -53.333119481556096,
                -30.309606746909274
              ],
              [
                -53.33411936562839,
                -30.312501776517905
              ],
              [
                -53.33580338090804,
                -30.31469985455409
              ],
              [
                -53.3364875121154,
                -30.318774340669943
              ],
              [
                -53.329804076474275,
                -30.322419933510442
              ],
              [
                -53.32427840133792,
                -30.32729859451758
              ],
              [
                -53.32127874912104,
                -30.326226361329198
              ],
              [
                -53.31727921283187,
                -30.32670886626397
              ],
              [
                -53.28070450597693,
                -30.345526558720074
              ],
              [
                -53.276599718732776,
                -30.34289958740854
              ],
              [
                -53.27091616716395,
                -30.345526558720074
              ],
              [
                -53.26802176590205,
                -30.3453121120824
              ],
              [
                -53.2614962066934,
                -30.34177374256074
              ],
              [
                -53.255496902259644,
                -30.336680634915922
              ],
              [
                -53.24039339022026,
                -30.333303100372518
              ],
              [
                -53.23628860297611,
                -30.328906944300154
              ],
              [
                -53.234394085786505,
                -30.32971111919144
              ],
              [
                -53.229710418289976,
                -30.3284780510248
              ],
              [
                -53.22739489728045,
                -30.326816089582806
              ],
              [
                -53.22307960812634,
                -30.326601642945132
              ],
              [
                -53.218974820882195,
                -30.322687991807538
              ],
              [
                -53.219395824702104,
                -30.314485407916415
              ],
              [
                -53.21850119158479,
                -30.311804824945458
              ],
              [
                -53.21997470495449,
                -30.309821193546952
              ],
              [
                -53.22018520686444,
                -30.307891173807864
              ],
              [
                -53.218974820882195,
                -30.306121989047032
              ],
              [
                -53.21650142344021,
                -30.29770495851823
              ],
              [
                -53.21429115338566,
                -30.297597735199396
              ],
              [
                -53.21271238906099,
                -30.299206084981968
              ],
              [
                -53.210975748303845,
                -30.297490511880557
              ],
              [
                -53.20908123111424,
                -30.296900783626945
              ],
              [
                -53.207081462969654,
                -30.29738328856172
              ],
              [
                -53.206081578897354,
                -30.300010259873254
              ],
              [
                -53.20408181075277,
                -30.30027831817035
              ],
              [
                -53.20418706170775,
                -30.302208337909438
              ],
              [
                -53.2029766757255,
                -30.303709464373174
              ],
              [
                -53.2029766757255,
                -30.30740866887309
              ],
              [
                -53.201397911400825,
                -30.307891173807864
              ],
              [
                -53.19997702350862,
                -30.309499523590436
              ],
              [
                -53.20050327828351,
                -30.31169760162662
              ],
              [
                -53.19929289230126,
                -30.313198728090356
              ],
              [
                -53.192977835002566,
                -30.310625368438238
              ],
              [
                -53.18439988217184,
                -30.31411012630048
              ],
              [
                -53.18308424523461,
                -30.314378184597576
              ],
              [
                -53.18050559683765,
                -30.31282344647442
              ],
              [
                -53.1821896121173,
                -30.317594884162723
              ],
              [
                -53.18439988217184,
                -30.318077389097493
              ],
              [
                -53.18208436116232,
                -30.322312710191603
              ],
              [
                -53.179400461810374,
                -30.32440356490895
              ],
              [
                -53.178874207035484,
                -30.327781099452352
              ],
              [
                -53.181821233774876,
                -30.32912139093783
              ],
              [
                -53.184715635036774,
                -30.332981430416005
              ],
              [
                -53.18739953438872,
                -30.33271337211891
              ],
              [
                -53.187925789163614,
                -30.334589780198577
              ],
              [
                -53.18718903247876,
                -30.33630535329999
              ],
              [
                -53.18892567323591,
                -30.3394148295463
              ],
              [
                -53.1879784146411,
                -30.340915956010033
              ],
              [
                -53.18397887835193,
                -30.34177374256074
              ],
              [
                -53.18008459301773,
                -30.34477599548821
              ],
              [
                -53.17650606054847,
                -30.343006810727378
              ],
              [
                -53.17419053953895,
                -30.343114034046216
              ],
              [
                -53.1725065242593,
                -30.34938659819825
              ],
              [
                -53.16987525038484,
                -30.349708268154767
              ],
              [
                -53.16987525038484,
                -30.352013569509786
              ],
              [
                -53.17361165928657,
                -30.354586929161904
              ],
              [
                -53.17740069366579,
                -30.3585005802995
              ],
              [
                -53.17708494080085,
                -30.361824503183485
              ],
              [
                -53.17450629240388,
                -30.36380813458199
              ],
              [
                -53.17508517265627,
                -30.367185669125394
              ],
              [
                -53.17482204526882,
                -30.368901242226805
              ],
              [
                -53.17171714209696,
                -30.371206543581827
              ],
              [
                -53.17050675611471,
                -30.373779903233945
              ],
              [
                -53.17229602234934,
                -30.375495476335356
              ],
              [
                -53.17429579049393,
                -30.375709922973034
              ],
              [
                -53.17697968984587,
                -30.3789802341976
              ],
              [
                -53.17961096372033,
                -30.379998855726562
              ],
              [
                -53.17661131150345,
                -30.383483613588805
              ],
              [
                -53.17882158155799,
                -30.38900561450897
              ],
              [
                -53.176821813413405,
                -30.394313168791463
              ],
              [
                -53.18282111784717,
                -30.395921518574035
              ],
              [
                -53.18461038408179,
                -30.395224567001588
              ],
              [
                -53.187294283433744,
                -30.396189576871134
              ],
              [
                -53.192083201885254,
                -30.39570707193636
              ],
              [
                -53.1986087610939,
                -30.399406276436277
              ],
              [
                -53.198819263003855,
                -30.40299825761736
              ],
              [
                -53.199608645166194,
                -30.40449938408109
              ],
              [
                -53.18929405157833,
                -30.409109986791137
              ],
              [
                -53.188715171325946,
                -30.41130806482732
              ],
              [
                -53.19071493947053,
                -30.41500726932724
              ],
              [
                -53.19197795093027,
                -30.41548977426201
              ],
              [
                -53.19592486174196,
                -30.414900046008402
              ],
              [
                -53.19729312415667,
                -30.41559699758085
              ],
              [
                -53.19550385792204,
                -30.41790229893587
              ],
              [
                -53.19708262224672,
                -30.418223968892384
              ],
              [
                -53.19681949485927,
                -30.42090455186334
              ],
              [
                -53.198398259183946,
                -30.42878546579795
              ],
              [
                -53.206818335582206,
                -30.43178771872542
              ],
              [
                -53.20881810372679,
                -30.43178771872542
              ],
              [
                -53.2107126209164,
                -30.433985796761604
              ],
              [
                -53.209923238754065,
                -30.436773603051396
              ],
              [
                -53.21297551644843,
                -30.438810846109323
              ],
              [
                -53.212396636196054,
                -30.441276982442602
              ],
              [
                -53.21371227313328,
                -30.443421448819365
              ],
              [
                -53.21571204127787,
                -30.444011177072976
              ],
              [
                -53.21660667439518,
                -30.447120653319285
              ],
              [
                -53.21550153936791,
                -30.449908459609077
              ],
              [
                -53.21350177122332,
                -30.450873469478623
              ],
              [
                -53.209186482069214,
                -30.453714887427836
              ],
              [
                -53.20897598015926,
                -30.45628824707995
              ],
              [
                -53.20660783367225,
                -30.45982661660161
              ],
              [
                -53.20639733176229,
                -30.464383607652238
              ],
              [
                -53.20092428210342,
                -30.469315880318796
              ],
              [
                -53.195977487219444,
                -30.47741124089108
              ],
              [
                -53.1928199585701,
                -30.479823765564937
              ],
              [
                -53.1928199585701,
                -30.482504348535894
              ],
              [
                -53.19108331781296,
                -30.48641799967349
              ],
              [
                -53.18761003629868,
                -30.488026349456064
              ],
              [
                -53.18582077006405,
                -30.490492485789343
              ],
              [
                -53.186504901271405,
                -30.492100835571915
              ],
              [
                -53.19029393565062,
                -30.495692816752996
              ],
              [
                -53.186399650316424,
                -30.501000371035488
              ],
              [
                -53.191293819722915,
                -30.502984002433994
              ],
              [
                -53.19260945666014,
                -30.504914022173082
              ],
              [
                -53.191188568767934,
                -30.508291556716486
              ],
              [
                -53.19092544138049,
                -30.511776314578725
              ],
              [
                -53.19150432163287,
                -30.513223829383044
              ],
              [
                -53.189609804443265,
                -30.516226082310514
              ],
              [
                -53.191714823542824,
                -30.518584995324954
              ],
              [
                -53.18997818278569,
                -30.521319189955328
              ],
              [
                -53.18918880062335,
                -30.532309580136243
              ],
              [
                -53.18571551910907,
                -30.5335962599623
              ],
              [
                -53.18371575096448,
                -30.53188068686089
              ],
              [
                -53.18318949618959,
                -30.529200103889934
              ],
              [
                -53.18097922613505,
                -30.528503152317487
              ],
              [
                -53.17840057773808,
                -30.528503152317487
              ],
              [
                -53.17519042361124,
                -30.529682608824707
              ],
              [
                -53.173295906421636,
                -30.53188068686089
              ],
              [
                -53.176295558638515,
                -30.534078764897075
              ],
              [
                -53.17650606054847,
                -30.53552627970139
              ],
              [
                -53.175506176476176,
                -30.538206862672347
              ],
              [
                -53.17571667838614,
                -30.54158439721575
              ],
              [
                -53.17398003762899,
                -30.542281348788197
              ],
              [
                -53.16471795359091,
                -30.537509911099896
              ],
              [
                -53.162823436401304,
                -30.537509911099896
              ],
              [
                -53.161297297554114,
                -30.53981521245492
              ],
              [
                -53.16519158288831,
                -30.54351441695484
              ],
              [
                -53.16687559816796,
                -30.54769612638953
              ],
              [
                -53.15550849503031,
                -30.546623893201147
              ],
              [
                -53.1521930899485,
                -30.556595661853102
              ],
              [
                -53.148719808434215,
                -30.559973196396506
              ],
              [
                -53.14708841863205,
                -30.563511565918166
              ],
              [
                -53.141720619928165,
                -30.56688910046157
              ],
              [
                -53.141089114198294,
                -30.568122168628207
              ],
              [
                -53.14272050400046,
                -30.570695528280325
              ],
              [
                -53.140983863243314,
                -30.575520577628044
              ],
              [
                -53.1396156008286,
                -30.57621752920049
              ],
              [
                -53.135773940971895,
                -30.574984461033853
              ],
              [
                -53.1343004276022,
                -30.575520577628044
              ],
              [
                -53.131511277295274,
                -30.580399238635184
              ],
              [
                -53.13251116136757,
                -30.583079821606137
              ],
              [
                -53.13177440468272,
                -30.584795394707548
              ],
              [
                -53.12888000342082,
                -30.58838737588863
              ],
              [
                -53.12277544803208,
                -30.591014347200165
              ],
              [
                -53.12261757159961,
                -30.593480483533444
              ],
              [
                -53.12440683783424,
                -30.597394134671042
              ],
              [
                -53.120880930842475,
                -30.60152223244631
              ],
              [
                -53.1217229384823,
                -30.603023358910047
              ],
              [
                -53.125301470951555,
                -30.605703941881004
              ],
              [
                -53.12340695376195,
                -30.60929592306208
              ],
              [
                -53.12177556395979,
                -30.609617593018598
              ],
              [
                -53.11751290028317,
                -30.60758034996067
              ],
              [
                -53.113408113039014,
                -30.60758034996067
              ],
              [
                -53.10798768885764,
                -30.613102350880837
              ],
              [
                -53.10661942644292,
                -30.613906525772126
              ],
              [
                -53.104724909253314,
                -30.613799302453288
              ],
              [
                -53.1043039054334,
                -30.617712953590882
              ],
              [
                -53.102883017541195,
                -30.618892410098102
              ],
              [
                -53.10088324939661,
                -30.623395789489308
              ],
              [
                -53.099409736026914,
                -30.62307411953279
              ],
              [
                -53.0960943309451,
                -30.624682469315367
              ],
              [
                -53.09288417681826,
                -30.631115868445658
              ],
              [
                -53.08998977555636,
                -30.633474781460098
              ],
              [
                -53.08951614625896,
                -30.63519035456151
              ],
              [
                -53.0839904711226,
                -30.635512024518025
              ],
              [
                -53.08199070297801,
                -30.638996782380268
              ],
              [
                -53.079885683878445,
                -30.637924549191887
              ],
              [
                -53.078412170508756,
                -30.64001540390923
              ],
              [
                -53.0757808966343,
                -30.639908180590393
              ],
              [
                -53.073518001102265,
                -30.64167736535122
              ],
              [
                -53.072097113210056,
                -30.64167736535122
              ],
              [
                -53.070307846975425,
                -30.6444115599816
              ],
              [
                -53.06751869666851,
                -30.643982666706243
              ],
              [
                -53.06388753872176,
                -30.646502414698944
              ],
              [
                -53.055520087800986,
                -30.64741381290907
              ],
              [
                -53.05278356297155,
                -30.652078027278527
              ],
              [
                -53.05430970181874,
                -30.656313348372638
              ],
              [
                -53.053309817746445,
                -30.66151367933629
              ],
              [
                -53.05230993367415,
                -30.663122029118867
              ],
              [
                -53.04920503050229,
                -30.66521288383621
              ],
              [
                -53.03541715540014,
                -30.67132461300999
              ],
              [
                -53.03389101655296,
                -30.66950181658974
              ],
              [
                -53.03152287006595,
                -30.668590418379615
              ],
              [
                -53.02941785096638,
                -30.666606786981106
              ],
              [
                -53.02568144206465,
                -30.665373718814468
              ],
              [
                -53.02041889431574,
                -30.666017058727498
              ],
              [
                -53.01999789049583,
                -30.66778624348833
              ],
              [
                -53.01757711853133,
                -30.668590418379615
              ],
              [
                -53.016314107071594,
                -30.670305991481026
              ],
              [
                -53.01652460898155,
                -30.67250406951721
              ],
              [
                -53.01378808415211,
                -30.673093797770818
              ],
              [
                -53.011525188620084,
                -30.6693945932709
              ],
              [
                -53.010209551682856,
                -30.66998432152451
              ],
              [
                -53.00910441665558,
                -30.66821513676368
              ],
              [
                -53.00652576825861,
                -30.669019311654967
              ],
              [
                -53.00357874151923,
                -30.667410961872392
              ],
              [
                -53.00121059503221,
                -30.667410961872392
              ],
              [
                -52.997684688040444,
                -30.666606786981106
              ],
              [
                -52.9950007886885,
                -30.670305991481026
              ],
              [
                -52.99268526767898,
                -30.6705204381187
              ],
              [
                -52.991685383606686,
                -30.671485447988246
              ],
              [
                -52.99279051863395,
                -30.67379074934327
              ],
              [
                -52.99268526767898,
                -30.675613545763518
              ],
              [
                -52.991685383606686,
                -30.67679300227074
              ],
              [
                -52.98858048043483,
                -30.677704400480863
              ],
              [
                -52.98858048043483,
                -30.674702147553393
              ],
              [
                -52.98621233394781,
                -30.676096050698288
              ],
              [
                -52.98079190976644,
                -30.677704400480863
              ],
              [
                -52.98042353142401,
                -30.675774380741775
              ],
              [
                -52.978792141621845,
                -30.676096050698288
              ],
              [
                -52.97747650468462,
                -30.675184652488163
              ],
              [
                -52.97810801041449,
                -30.67357630270559
              ],
              [
                -52.97747650468462,
                -30.672879351133144
              ],
              [
                -52.9746873543777,
                -30.672182399560693
              ],
              [
                -52.97521360915259,
                -30.669716263227414
              ],
              [
                -52.97779225754955,
                -30.66891208833613
              ],
              [
                -52.97689762443224,
                -30.668000690126004
              ],
              [
                -52.97521360915259,
                -30.66162090265513
              ],
              [
                -52.971792953115795,
                -30.65920837798127
              ],
              [
                -52.97147720025086,
                -30.655509173481352
              ],
              [
                -52.973582219350426,
                -30.651702745662597
              ],
              [
                -52.97158245120584,
                -30.64902216269164
              ],
              [
                -52.975003107242635,
                -30.647574647887325
              ],
              [
                -52.97547673654003,
                -30.645698239807654
              ],
              [
                -52.97247708432315,
                -30.64419711334392
              ],
              [
                -52.97331909196298,
                -30.6430176568367
              ],
              [
                -52.97547673654003,
                -30.642106258626576
              ],
              [
                -52.97247708432315,
                -30.63342116980068
              ],
              [
                -52.974003223170335,
                -30.62607637246026
              ],
              [
                -52.971792953115795,
                -30.621626604728476
              ],
              [
                -52.97331909196298,
                -30.619803808308227
              ],
              [
                -52.975424111062544,
                -30.61910685673578
              ],
              [
                -52.97579248940497,
                -30.617498506953204
              ],
              [
                -52.97568723844999,
                -30.612995127562
              ],
              [
                -52.97300333909804,
                -30.60940314638092
              ],
              [
                -52.974792605332674,
                -30.606025611837516
              ],
              [
                -52.97458210342272,
                -30.604095592098428
              ],
              [
                -52.97258233527813,
                -30.603184193888303
              ],
              [
                -52.9674250384842,
                -30.604310038736106
              ],
              [
                -52.96447801174481,
                -30.603184193888303
              ],
              [
                -52.94921662327296,
                -30.603076970569465
              ],
              [
                -52.94490133411885,
                -30.60157584410573
              ],
              [
                -52.93600762842319,
                -30.60811646655486
              ],
              [
                -52.93132396092666,
                -30.60650811677229
              ],
              [
                -52.92937681825956,
                -30.605275048605648
              ],
              [
                -52.92537728197039,
                -30.60050361091735
              ],
              [
                -52.92358801573576,
                -30.59637551314208
              ],
              [
                -52.91790446416694,
                -30.591604075453777
              ],
              [
                -52.91611519793231,
                -30.586886249424897
              ],
              [
                -52.91022114445352,
                -30.580399238635184
              ],
              [
                -52.91022114445352,
                -30.577396985707715
              ],
              [
                -52.905905855299416,
                -30.574180286142568
              ],
              [
                -52.90748461962409,
                -30.56790772199053
              ],
              [
                -52.905905855299416,
                -30.566513818845635
              ],
              [
                -52.905379600524526,
                -30.5638868475341
              ],
              [
                -52.90811612535396,
                -30.55841845827335
              ],
              [
                -52.907589870579066,
                -30.553700632244468
              ],
              [
                -52.91111577757084,
                -30.5493044761721
              ],
              [
                -52.9117999087782,
                -30.54329997031716
              ],
              [
                -52.90880025656132,
                -30.54051216402737
              ],
              [
                -52.90690573937171,
                -30.53740268778106
              ],
              [
                -52.907905623444,
                -30.534722104810104
              ],
              [
                -52.90611635720937,
                -30.525500899390018
              ],
              [
                -52.90522172409206,
                -30.524375054542215
              ],
              [
                -52.897222651513715,
                -30.522713093100226
              ],
              [
                -52.89811728463103,
                -30.520407791745203
              ],
              [
                -52.89627539291891,
                -30.518906665281467
              ],
              [
                -52.89859091392843,
                -30.516601363926448
              ],
              [
                -52.898906666793366,
                -30.51520746078155
              ],
              [
                -52.89790678272107,
                -30.513223829383044
              ],
              [
                -52.89380199547692,
                -30.510596858071505
              ],
              [
                -52.89327574070203,
                -30.509310178245446
              ],
              [
                -52.89511763241415,
                -30.50807711007881
              ],
              [
                -52.894012497386875,
                -30.504592352216566
              ],
              [
                -52.8881184439081,
                -30.50368095400644
              ],
              [
                -52.887013308880825,
                -30.50067870107897
              ],
              [
                -52.888802575115456,
                -30.49837339972395
              ],
              [
                -52.88911832798039,
                -30.496282545006604
              ],
              [
                -52.887013308880825,
                -30.495692816752996
              ],
              [
                -52.88511879169121,
                -30.493816408673325
              ],
              [
                -52.883382150934075,
                -30.48759745618071
              ],
              [
                -52.883908405708965,
                -30.48459520325324
              ],
              [
                -52.88790794199814,
                -30.482879630151828
              ],
              [
                -52.88480303882628,
                -30.47687512429689
              ],
              [
                -52.888697324160475,
                -30.475105939536057
              ],
              [
                -52.886908057925844,
                -30.47317591979697
              ],
              [
                -52.886381803150954,
                -30.471513958354976
              ],
              [
                -52.888802575115456,
                -30.469691161934726
              ],
              [
                -52.88790794199814,
                -30.46888698704344
              ],
              [
                -52.88780269104316,
                -30.46642085071016
              ],
              [
                -52.88580292289858,
                -30.46481250092759
              ],
              [
                -52.8871185598358,
                -30.464008326036303
              ],
              [
                -52.886223926718486,
                -30.46111329642767
              ],
              [
                -52.88848682225052,
                -30.457682150224848
              ],
              [
                -52.891275972557445,
                -30.457414091927753
              ],
              [
                -52.889223578935365,
                -30.45467989729738
              ],
              [
                -52.89201272924229,
                -30.45028374122501
              ],
              [
                -52.888802575115456,
                -30.448621779783018
              ],
              [
                -52.88801319295312,
                -30.441384205761437
              ],
              [
                -52.89269686044965,
                -30.437577777942682
              ],
              [
                -52.89027608848515,
                -30.436183874797784
              ],
              [
                -52.88427678405139,
                -30.43768500126152
              ],
              [
                -52.883276899979094,
                -30.433396068507992
              ],
              [
                -52.87880373439252,
                -30.429482417370398
              ],
              [
                -52.876488213383,
                -30.42648016444293
              ],
              [
                -52.876909217202915,
                -30.425407931254547
              ],
              [
                -52.879014236302474,
                -30.424925426319774
              ],
              [
                -52.87990886941979,
                -30.422995406580686
              ],
              [
                -52.88322427450161,
                -30.421923173392305
              ],
              [
                -52.88359265284403,
                -30.420690105225663
              ],
              [
                -52.87822485414014,
                -30.41972509535612
              ],
              [
                -52.872909680913736,
                -30.419885930334377
              ],
              [
                -52.87022578156179,
                -30.418384803870644
              ],
              [
                -52.87027840703929,
                -30.41431031775479
              ],
              [
                -52.872909680913736,
                -30.41441754107363
              ],
              [
                -52.87590933313062,
                -30.41259474465338
              ],
              [
                -52.8818033866094,
                -30.410611113254873
              ],
              [
                -52.88269801972672,
                -30.409378045088232
              ],
              [
                -52.88311902354663,
                -30.407394413689726
              ],
              [
                -52.8822770159068,
                -30.403802432508645
              ],
              [
                -52.88290852163667,
                -30.397690703334867
              ],
              [
                -52.87722497006785,
                -30.391310915863993
              ],
              [
                -52.87480419810335,
                -30.386914759791626
              ],
              [
                -52.87569883122066,
                -30.3860033615815
              ],
              [
                -52.87801435223018,
                -30.386325031538018
              ],
              [
                -52.88290852163667,
                -30.382304157081585
              ],
              [
                -52.8789089853475,
                -30.37967718577005
              ],
              [
                -52.87759334841027,
                -30.377318272755605
              ],
              [
                -52.87948786559988,
                -30.37592436961071
              ],
              [
                -52.8846977878713,
                -30.375602699654195
              ],
              [
                -52.884013656663946,
                -30.373190174980337
              ],
              [
                -52.88527666812368,
                -30.36991986375577
              ],
              [
                -52.88359265284403,
                -30.370187922052864
              ],
              [
                -52.88011937132975,
                -30.3716890485166
              ],
              [
                -52.87801435223018,
                -30.371206543581827
              ],
              [
                -52.87722497006785,
                -30.36461230947328
              ],
              [
                -52.87801435223018,
                -30.361181163270455
              ],
              [
                -52.87990886941979,
                -30.3596264251473
              ],
              [
                -52.88111925540204,
                -30.361395609908133
              ],
              [
                -52.883276899979094,
                -30.36252145475593
              ],
              [
                -52.88427678405139,
                -30.36091310497336
              ],
              [
                -52.883276899979094,
                -30.360001706763235
              ],
              [
                -52.88069825158213,
                -30.351691899553273
              ],
              [
                -52.87469894714837,
                -30.349225763219994
              ],
              [
                -52.877698599365246,
                -30.34407904391576
              ],
              [
                -52.87522520192326,
                -30.341988189198414
              ],
              [
                -52.8731201828237,
                -30.34172013090132
              ],
              [
                -52.87038365799426,
                -30.342792364089703
              ],
              [
                -52.867226129344914,
                -30.340701509372355
              ],
              [
                -52.86517373572284,
                -30.34107679098829
              ],
              [
                -52.86401597521808,
                -30.344507937191114
              ],
              [
                -52.86691037647998,
                -30.346277121951942
              ],
              [
                -52.86959427583192,
                -30.3500835497707
              ],
              [
                -52.86517373572284,
                -30.349815491473606
              ],
              [
                -52.863594971398165,
                -30.351423841256178
              ],
              [
                -52.86648937266007,
                -30.354801375799582
              ],
              [
                -52.86401597521808,
                -30.35549832737203
              ],
              [
                -52.863489720443184,
                -30.357589182089374
              ],
              [
                -52.862174083505955,
                -30.358607803618337
              ],
              [
                -52.86091107204622,
                -30.358178910342986
              ],
              [
                -52.8600164389289,
                -30.35608805562564
              ],
              [
                -52.85059647845835,
                -30.347617413437423
              ],
              [
                -52.85112273323325,
                -30.345901840336012
              ],
              [
                -52.852701497557916,
                -30.344507937191114
              ],
              [
                -52.85128060966571,
                -30.341988189198414
              ],
              [
                -52.84770207719645,
                -30.341184014307128
              ],
              [
                -52.843386788042345,
                -30.34638434527078
              ],
              [
                -52.841597521807714,
                -30.345526558720074
              ],
              [
                -52.840913390600356,
                -30.34359653898099
              ],
              [
                -52.84349203899732,
                -30.33818176137966
              ],
              [
                -52.842492154925026,
                -30.33630535329999
              ],
              [
                -52.840808139645375,
                -30.336198129981153
              ],
              [
                -52.838492618635854,
                -30.334482556879742
              ],
              [
                -52.832388063247116,
                -30.33850343133617
              ],
              [
                -52.83049354605751,
                -30.338020926401402
              ],
              [
                -52.827599144795606,
                -30.334107275263808
              ],
              [
                -52.82491524544366,
                -30.333517547010196
              ],
              [
                -52.82349435755145,
                -30.334375333560903
              ],
              [
                -52.82159984036185,
                -30.333195877053683
              ],
              [
                -52.82002107603717,
                -30.334911450155094
              ],
              [
                -52.81838968623501,
                -30.334321721901482
              ],
              [
                -52.81807393337007,
                -30.335501178408702
              ],
              [
                -52.8164951690454,
                -30.334697003517416
              ],
              [
                -52.81502165567571,
                -30.335501178408702
              ],
              [
                -52.811022119386536,
                -30.33517950845219
              ],
              [
                -52.807811965259695,
                -30.331105022336338
              ],
              [
                -52.8068120811874,
                -30.326494419626293
              ],
              [
                -52.807285710484805,
                -30.325690244735007
              ],
              [
                -52.802496792033295,
                -30.324618011546626
              ],
              [
                -52.800181271023774,
                -30.320811583727867
              ],
              [
                -52.79839200478914,
                -30.319792962198903
              ],
              [
                -52.79728686976188,
                -30.31711237922795
              ],
              [
                -52.797813124536766,
                -30.316200981017825
              ],
              [
                -52.796023858302135,
                -30.313681233025125
              ],
              [
                -52.7961817347346,
                -30.311375931670106
              ],
              [
                -52.797813124536766,
                -30.310893426735333
              ],
              [
                -52.79691849141945,
                -30.30858812538031
              ],
              [
                -52.79560285448222,
                -30.307783950489025
              ],
              [
                -52.796023858302135,
                -30.305210590836907
              ],
              [
                -52.790603434120754,
                -30.302315561228276
              ],
              [
                -52.789024669796085,
                -30.30858812538031
              ],
              [
                -52.789814051958416,
                -30.312608999836744
              ],
              [
                -52.792287449400405,
                -30.31711237922795
              ],
              [
                -52.79191907105798,
                -30.32429634159011
              ],
              [
                -52.793182082517724,
                -30.33217725552472
              ],
              [
                -52.79307683156274,
                -30.335393955089863
              ],
              [
                -52.79102443794067,
                -30.341291237625967
              ],
              [
                -52.789287797183526,
                -30.342685140770865
              ],
              [
                -52.78802478572379,
                -30.342524305792608
              ],
              [
                -52.77649980615367,
                -30.33871787797385
              ],
              [
                -52.77360540489177,
                -30.33930760622746
              ],
              [
                -52.77060575267489,
                -30.341291237625967
              ],
              [
                -52.7667114673407,
                -30.34107679098829
              ],
              [
                -52.764711699196106,
                -30.34177374256074
              ],
              [
                -52.76318556034892,
                -30.343006810727378
              ],
              [
                -52.760291159087025,
                -30.350297996408376
              ],
              [
                -52.74971343811171,
                -30.362575066415353
              ],
              [
                -52.734399424162376,
                -30.3610203282922
              ],
              [
                -52.730926142648094,
                -30.361610056545807
              ],
              [
                -52.72661085349399,
                -30.36080588165452
              ],
              [
                -52.72308494650221,
                -30.36219978479942
              ],
              [
                -52.72150618217754,
                -30.366113435937013
              ],
              [
                -52.719506414032956,
                -30.36809706733552
              ],
              [
                -52.71361236055417,
                -30.365577319342822
              ],
              [
                -52.71440174271651,
                -30.361878114842902
              ],
              [
                -52.71371761150915,
                -30.360484211698008
              ],
              [
                -52.709191820445085,
                -30.35501582243726
              ],
              [
                -52.70682367395808,
                -30.35367553095178
              ],
              [
                -52.707402554210454,
                -30.35249607444456
              ],
              [
                -52.706876299435564,
                -30.350994947980826
              ],
              [
                -52.705297535110894,
                -30.350190773089537
              ],
              [
                -52.70250838480397,
                -30.350994947980826
              ],
              [
                -52.70161375168665,
                -30.349279374879416
              ],
              [
                -52.69587757464034,
                -30.343918208937502
              ],
              [
                -52.68982564472909,
                -30.341291237625967
              ],
              [
                -52.68829950588191,
                -30.33850343133617
              ],
              [
                -52.69029927402649,
                -30.335393955089863
              ],
              [
                -52.688878386134284,
                -30.33271337211891
              ],
              [
                -52.68672074155723,
                -30.330622517401565
              ],
              [
                -52.68698386894468,
                -30.328799720981316
              ],
              [
                -52.68451047150269,
                -30.323224108401728
              ],
              [
                -52.68751012371957,
                -30.318988787307617
              ],
              [
                -52.68661549060226,
                -30.317380437525046
              ],
              [
                -52.687299621809615,
                -30.31239455319907
              ],
              [
                -52.686404988692296,
                -30.310196475162886
              ],
              [
                -52.68972039377411,
                -30.306175600706453
              ],
              [
                -52.6907202778464,
                -30.303709464373174
              ],
              [
                -52.68940464090918,
                -30.3009752697428
              ],
              [
                -52.691299158098786,
                -30.29781218183707
              ],
              [
                -52.6917201619187,
                -30.294595482271923
              ],
              [
                -52.689509891864155,
                -30.292826297511095
              ],
              [
                -52.688878386134284,
                -30.291110724409684
              ],
              [
                -52.690404524981474,
                -30.284891771917067
              ],
              [
                -52.69029927402649,
                -30.282479247243206
              ],
              [
                -52.6892993899542,
                -30.28092450912005
              ],
              [
                -52.68682599251221,
                -30.279691440953414
              ],
              [
                -52.68661549060226,
                -30.278726431083868
              ],
              [
                -52.68840475683688,
                -30.27272192522893
              ],
              [
                -52.681616070240786,
                -30.264626564656645
              ],
              [
                -52.676300897014386,
                -30.2600159619466
              ],
              [
                -52.67119622569794,
                -30.256799262381456
              ],
              [
                -52.670617345445564,
                -30.25529813591772
              ],
              [
                -52.6718803569053,
                -30.25122364980187
              ],
              [
                -52.66988058876071,
                -30.247899726917883
              ],
              [
                -52.67119622569794,
                -30.243825240802032
              ],
              [
                -52.66777556966115,
                -30.241680774425266
              ],
              [
                -52.667512442273704,
                -30.24012603630211
              ],
              [
                -52.66998583971569,
                -30.23492570533846
              ],
              [
                -52.66909120659838,
                -30.228492306208167
              ],
              [
                -52.663986535281936,
                -30.224900325027086
              ],
              [
                -52.66209201809232,
                -30.222487800353225
              ],
              [
                -52.66098688306505,
                -30.217823585983766
              ],
              [
                -52.6617236397499,
                -30.21460688641862
              ],
              [
                -52.65840823466809,
                -30.21160463349115
              ],
              [
                -52.657408350595794,
                -30.209406555454965
              ],
              [
                -52.656618968433456,
                -30.212194361744757
              ],
              [
                -52.65388244360402,
                -30.213588264889655
              ],
              [
                -52.65272468309926,
                -30.213481041570816
              ],
              [
                -52.65009340922481,
                -30.210425176983925
              ],
              [
                -52.6453044907733,
                -30.21139018685347
              ],
              [
                -52.64398885383607,
                -30.214714109737457
              ],
              [
                -52.64130495448412,
                -30.216590517817124
              ],
              [
                -52.63962093920447,
                -30.220021664019946
              ],
              [
                -52.64272584237633,
                -30.22398892681696
              ],
              [
                -52.63809480035729,
                -30.23299568559937
              ],
              [
                -52.63441101693305,
                -30.23417514210659
              ],
              [
                -52.63277962713089,
                -30.2398043663456
              ],
              [
                -52.627885457724396,
                -30.242377725997713
              ],
              [
                -52.626201442444746,
                -30.2443077457368
              ],
              [
                -52.62367541952527,
                -30.249615300019293
              ],
              [
                -52.623991172390205,
                -30.25690648570029
              ],
              [
                -52.62241240806553,
                -30.260391243562534
              ],
              [
                -52.62020213801099,
                -30.260391243562534
              ],
              [
                -52.61878125011878,
                -30.262214039982783
              ],
              [
                -52.6206231418309,
                -30.26778965256237
              ],
              [
                -52.61930750489367,
                -30.268701050772496
              ],
              [
                -52.61941275584865,
                -30.27079190548984
              ],
              [
                -52.621675651380684,
                -30.274920003265112
              ],
              [
                -52.6186759991638,
                -30.277118081301296
              ],
              [
                -52.61930750489367,
                -30.280013110909927
              ],
              [
                -52.61620260172181,
                -30.288698199735823
              ],
              [
                -52.61520271764952,
                -30.292719074192256
              ],
              [
                -52.6157815979019,
                -30.295721327119725
              ],
              [
                -52.614413335487185,
                -30.29781218183707
              ],
              [
                -52.61009804633307,
                -30.300707211445705
              ],
              [
                -52.608624532963375,
                -30.3046208625833
              ],
              [
                -52.606677390296284,
                -30.30499614419923
              ],
              [
                -52.60741414698113,
                -30.306604493981805
              ],
              [
                -52.605782757178964,
                -30.312984281452678
              ],
              [
                -52.60451974571923,
                -30.312984281452678
              ],
              [
                -52.60288835591707,
                -30.315182359488862
              ],
              [
                -52.603309359736976,
                -30.317594884162723
              ],
              [
                -52.60488812406165,
                -30.32022185547426
              ],
              [
                -52.60441449476425,
                -30.321079642024962
              ],
              [
                -52.602519977574644,
                -30.32172298193799
              ],
              [
                -52.60262522852962,
                -30.3237066133365
              ],
              [
                -52.60141484254737,
                -30.323813836655336
              ],
              [
                -52.60178322088979,
                -30.326226361329198
              ],
              [
                -52.604098741899314,
                -30.326923312901645
              ],
              [
                -52.60341461069196,
                -30.328906944300154
              ],
              [
                -52.608992911305805,
                -30.339575664524556
              ],
              [
                -52.60709839411619,
                -30.341291237625967
              ],
              [
                -52.60388823998936,
                -30.34172013090132
              ],
              [
                -52.603204108782,
                -30.34338209234331
              ],
              [
                -52.60199372279975,
                -30.34407904391576
              ],
              [
                -52.59752055721317,
                -30.342685140770865
              ],
              [
                -52.59509978524868,
                -30.34359653898099
              ],
              [
                -52.594626155951275,
                -30.345526558720074
              ],
              [
                -52.59662592409586,
                -30.350190773089537
              ],
              [
                -52.596310171230925,
                -30.351799122872112
              ],
              [
                -52.59241588589673,
                -30.35549832737203
              ],
              [
                -52.59299476614911,
                -30.357589182089374
              ],
              [
                -52.58689021076037,
                -30.359787260125557
              ],
              [
                -52.58399580949847,
                -30.36198533816174
              ],
              [
                -52.582206543263844,
                -30.36520203772689
              ],
              [
                -52.583101176381156,
                -30.370777650306476
              ],
              [
                -52.581417161101506,
                -30.373082951661498
              ],
              [
                -52.578996389137004,
                -30.373779903233945
              ],
              [
                -52.57720712290237,
                -30.37292211668324
              ],
              [
                -52.57578623501017,
                -30.370884873625315
              ],
              [
                -52.5707868146487,
                -30.36868679558913
              ],
              [
                -52.57020793439632,
                -30.367989844016684
              ],
              [
                -52.57020793439632,
                -30.364880367770375
              ],
              [
                -52.56752403504438,
                -30.364880367770375
              ],
              [
                -52.56720828217944,
                -30.363111183009543
              ],
              [
                -52.56478751021494,
                -30.362896736371866
              ],
              [
                -52.56199835990802,
                -30.360323376719748
              ],
              [
                -52.56089322488074,
                -30.361717279864646
              ],
              [
                -52.55920920960109,
                -30.36219978479942
              ],
              [
                -52.556209557384214,
                -30.361610056545807
              ],
              [
                -52.55499917140197,
                -30.362896736371866
              ],
              [
                -52.54810523385089,
                -30.361610056545807
              ],
              [
                -52.54347419183185,
                -30.362414231437096
              ],
              [
                -52.536001374028395,
                -30.355283880734355
              ],
              [
                -52.539474655542676,
                -30.351477452915596
              ],
              [
                -52.54210592941713,
                -30.352978579379332
              ],
              [
                -52.54642121857124,
                -30.348689646625804
              ],
              [
                -52.556209557384214,
                -30.34638434527078
              ],
              [
                -52.55731469241149,
                -30.34488321880705
              ],
              [
                -52.55552542617686,
                -30.339200382908622
              ],
              [
                -52.55652531024915,
                -30.334697003517416
              ],
              [
                -52.555683302609324,
                -30.331587527271108
              ],
              [
                -52.55457816758205,
                -30.328585274343638
              ],
              [
                -52.55720944145651,
                -30.321508535300318
              ],
              [
                -52.55720944145651,
                -30.316790709271434
              ],
              [
                -52.55831457648378,
                -30.313198728090356
              ],
              [
                -52.555788553564305,
                -30.30697977559774
              ],
              [
                -52.55741994336647,
                -30.299903036554415
              ],
              [
                -52.55668318668162,
                -30.294702705590762
              ],
              [
                -52.559314460556074,
                -30.287411519909764
              ],
              [
                -52.559419711511055,
                -30.28521344187358
              ],
              [
                -52.55352565803227,
                -30.286875403315573
              ],
              [
                -52.54889461601323,
                -30.286714568337317
              ],
              [
                -52.5374222619206,
                -30.282800917199722
              ],
              [
                -52.53531724282104,
                -30.2804956158447
              ],
              [
                -52.53221233964918,
                -30.27942338265632
              ],
              [
                -52.53247546703662,
                -30.276689188025944
              ],
              [
                -52.53131770653186,
                -30.272400255272416
              ],
              [
                -52.523213382998534,
                -30.279101712699802
              ],
              [
                -52.52042423269162,
                -30.27931615933748
              ],
              [
                -52.51868759193447,
                -30.283122587156235
              ],
              [
                -52.51721407856478,
                -30.283819538728686
              ],
              [
                -52.51731932951976,
                -30.29191489930097
              ],
              [
                -52.51331979323058,
                -30.300599988126866
              ],
              [
                -52.5074257397518,
                -30.304781697561555
              ],
              [
                -52.50589960090462,
                -30.309606746909274
              ],
              [
                -52.50721523784185,
                -30.311322320010685
              ],
              [
                -52.505215469697255,
                -30.314002902981642
              ],
              [
                -52.50747836522929,
                -30.31587931106131
              ],
              [
                -52.50689948497691,
                -30.3211868653438
              ],
              [
                -52.5107937703111,
                -30.326226361329198
              ],
              [
                -52.50900450407647,
                -30.334911450155094
              ],
              [
                -52.50732048879682,
                -30.338288984698497
              ],
              [
                -52.50710998688687,
                -30.341291237625967
              ],
              [
                -52.508425623824095,
                -30.342685140770865
              ],
              [
                -52.50900450407647,
                -30.3453121120824
              ],
              [
                -52.50910975503145,
                -30.352174404488046
              ],
              [
                -52.504426087534924,
                -30.35919753187195
              ],
              [
                -52.50147906079553,
                -30.362307008118258
              ],
              [
                -52.4189096866151,
                -30.363003959690705
              ],
              [
                -52.416804667515535,
                -30.367185669125394
              ],
              [
                -52.416278412740645,
                -30.369008465545644
              ],
              [
                -52.41701516942549,
                -30.37158182519776
              ],
              [
                -52.41438389555104,
                -30.375602699654195
              ],
              [
                -52.40880559493719,
                -30.37769355437154
              ],
              [
                -52.40512181151295,
                -30.380374137342496
              ],
              [
                -52.402174784773564,
                -30.380803030617848
              ],
              [
                -52.40017501662898,
                -30.3801060790454
              ],
              [
                -52.39938563446664,
                -30.37828328262515
              ],
              [
                -52.393386330032875,
                -30.37662132118316
              ],
              [
                -52.391702314753225,
                -30.377211049436767
              ],
              [
                -52.38801853132899,
                -30.376299651226645
              ],
              [
                -52.38449262433722,
                -30.376674932842576
              ],
              [
                -52.37717768296623,
                -30.36991986375577
              ],
              [
                -52.37028374541516,
                -30.36761456240075
              ],
              [
                -52.36870498109048,
                -30.36450508615444
              ],
              [
                -52.36628420912598,
                -30.363218406328382
              ],
              [
                -52.36407393907144,
                -30.363593687944316
              ],
              [
                -52.357022125087894,
                -30.36198533816174
              ],
              [
                -52.351180697086605,
                -30.35801807536473
              ],
              [
                -52.34791791748228,
                -30.357589182089374
              ],
              [
                -52.34528664360782,
                -30.35919753187195
              ],
              [
                -52.34291849712081,
                -30.35898308523427
              ],
              [
                -52.34607602577016,
                -30.361878114842902
              ],
              [
                -52.346391778635095,
                -30.365416484364566
              ],
              [
                -52.34902305250955,
                -30.36750733908191
              ],
              [
                -52.351075446131624,
                -30.37179627183544
              ],
              [
                -52.354285600258464,
                -30.374316019828136
              ],
              [
                -52.354811855033354,
                -30.37828328262515
              ],
              [
                -52.35591699006063,
                -30.379087457516437
              ],
              [
                -52.35418034930348,
                -30.382893885335193
              ],
              [
                -52.35149644995154,
                -30.38552085664673
              ],
              [
                -52.35191745377145,
                -30.387504488045238
              ],
              [
                -52.35102282065414,
                -30.390077847697356
              ],
              [
                -52.353917221916035,
                -30.391203692545155
              ],
              [
                -52.35618011744807,
                -30.39072118761038
              ],
              [
                -52.35860088941257,
                -30.39211509075528
              ],
              [
                -52.35891664227751,
                -30.395599848617522
              ],
              [
                -52.36070590851214,
                -30.399084606479764
              ],
              [
                -52.36002177730477,
                -30.400800179581175
              ],
              [
                -52.357916758205214,
                -30.40278381097968
              ],
              [
                -52.35560123719569,
                -30.403105480936198
              ],
              [
                -52.35081231874418,
                -30.401926024428978
              ],
              [
                -52.34839154677968,
                -30.40278381097968
              ],
              [
                -52.3482862958247,
                -30.40460660739993
              ],
              [
                -52.35049656587925,
                -30.407019132073792
              ],
              [
                -52.352601584978814,
                -30.41248752133454
              ],
              [
                -52.35360146905111,
                -30.413077249588152
              ],
              [
                -52.351706951861495,
                -30.414685599370724
              ],
              [
                -52.351812202816475,
                -30.416186725834457
              ],
              [
                -52.3507070677892,
                -30.41800952225471
              ],
              [
                -52.353496218096126,
                -30.423209853218363
              ],
              [
                -52.350917569699156,
                -30.42878546579795
              ],
              [
                -52.348707299644616,
                -30.429107135754464
              ],
              [
                -52.34802316843726,
                -30.430876320515296
              ],
              [
                -52.349496681806954,
                -30.434521913355795
              ],
              [
                -52.35060181683422,
                -30.435218864928242
              ],
              [
                -52.351812202816475,
                -30.43468274833405
              ],
              [
                -52.35360146905111,
                -30.43232383531961
              ],
              [
                -52.35470660407837,
                -30.432591893616706
              ],
              [
                -52.355706488150666,
                -30.439186127725257
              ],
              [
                -52.356601121267985,
                -30.440204749254217
              ],
              [
                -52.361179537809534,
                -30.44068725418899
              ],
              [
                -52.36170579258443,
                -30.442081157333888
              ],
              [
                -52.36070590851214,
                -30.44610203179032
              ],
              [
                -52.36302142952166,
                -30.449425954674304
              ],
              [
                -52.36549482696365,
                -30.450873469478623
              ],
              [
                -52.36770509701819,
                -30.451302362753975
              ],
              [
                -52.368915483000436,
                -30.453714887427836
              ],
              [
                -52.37217826260476,
                -30.451302362753975
              ],
              [
                -52.375020038389174,
                -30.451624032710487
              ],
              [
                -52.375388416731596,
                -30.45521601389157
              ],
              [
                -52.37270451737965,
                -30.456717140355302
              ],
              [
                -52.37338864858701,
                -30.45939772332626
              ],
              [
                -52.37870382181342,
                -30.46309692782618
              ],
              [
                -52.37959845493073,
                -30.465723899137714
              ],
              [
                -52.38101934282294,
                -30.464973335905846
              ],
              [
                -52.3821771033277,
                -30.466313627391322
              ],
              [
                -52.38612401413938,
                -30.468726152065184
              ],
              [
                -52.38670289439176,
                -30.47012005521008
              ],
              [
                -52.38559775936449,
                -30.471192288398463
              ],
              [
                -52.386387141526825,
                -30.472103686608587
              ],
              [
                -52.38959729565366,
                -30.471621181673815
              ],
              [
                -52.39049192877098,
                -30.476017337746182
              ],
              [
                -52.39301795169045,
                -30.478000969144688
              ],
              [
                -52.390912932590886,
                -30.480520717137388
              ],
              [
                -52.391176059978335,
                -30.48159295032577
              ],
              [
                -52.394807217925084,
                -30.48271879517357
              ],
              [
                -52.39728061536707,
                -30.48282601849241
              ],
              [
                -52.40170115547616,
                -30.484273533296726
              ],
              [
                -52.403595672665766,
                -30.48400547499963
              ],
              [
                -52.40459555673806,
                -30.484702426572078
              ],
              [
                -52.404385054828104,
                -30.48690050460826
              ],
              [
                -52.404911309602994,
                -30.488508854390833
              ],
              [
                -52.404385054828104,
                -30.489688310898053
              ],
              [
                -52.404385054828104,
                -30.492100835571915
              ],
              [
                -52.40338517075581,
                -30.49279778714436
              ],
              [
                -52.40091177331382,
                -30.492690563825526
              ],
              [
                -52.39917513255668,
                -30.495317535137062
              ],
              [
                -52.39991188924153,
                -30.49971369120943
              ],
              [
                -52.40280629050343,
                -30.502287050861543
              ],
              [
                -52.402701039548454,
                -30.504914022173082
              ],
              [
                -52.40470080769304,
                -30.50679043025275
              ],
              [
                -52.402701039548454,
                -30.50920295492661
              ],
              [
                -52.401280151656245,
                -30.50920295492661
              ],
              [
                -52.400122391151484,
                -30.507112100209262
              ],
              [
                -52.39801737205192,
                -30.50738015850636
              ],
              [
                -52.3981226230069,
                -30.50850600335416
              ],
              [
                -52.39928038351166,
                -30.51022157645557
              ],
              [
                -52.39991188924153,
                -30.511883537897564
              ],
              [
                -52.4014906535662,
                -30.513706334317813
              ],
              [
                -52.40170115547616,
                -30.515421907419224
              ],
              [
                -52.40312204336836,
                -30.515421907419224
              ],
              [
                -52.40459555673806,
                -30.51397439261491
              ],
              [
                -52.406174321062736,
                -30.514296062571425
              ],
              [
                -52.409805479009485,
                -30.519174723578562
              ],
              [
                -52.41480489937095,
                -30.522498646462548
              ],
              [
                -52.41538377962333,
                -30.524589501179893
              ],
              [
                -52.41412076816359,
                -30.527484530788524
              ],
              [
                -52.415225903190866,
                -30.529789832143546
              ],
              [
                -52.41948856686748,
                -30.52839592899865
              ],
              [
                -52.42122520762462,
                -30.530325948737737
              ],
              [
                -52.421698836922026,
                -30.53322097834637
              ],
              [
                -52.42311972481423,
                -30.536116007955002
              ],
              [
                -52.42259347003934,
                -30.538474920969442
              ],
              [
                -52.42448798722895,
                -30.539600765817244
              ],
              [
                -52.42380385602159,
                -30.542013290491102
              ],
              [
                -52.42427748531899,
                -30.54329997031716
              ],
              [
                -52.42127783310211,
                -30.544908320099736
              ],
              [
                -52.41838343184021,
                -30.54801779634604
              ],
              [
                -52.42138308405709,
                -30.550323097701064
              ],
              [
                -52.42580362416618,
                -30.551877835824218
              ],
              [
                -52.42759289040081,
                -30.551073660932932
              ],
              [
                -52.43048729166271,
                -30.554880088751688
              ],
              [
                -52.43280281267223,
                -30.554880088751688
              ],
              [
                -52.434802580816815,
                -30.556595661853102
              ],
              [
                -52.43780223303369,
                -30.55471925377343
              ],
              [
                -52.439591499268325,
                -30.554504807135753
              ],
              [
                -52.44327528269256,
                -30.55311090399086
              ],
              [
                -52.44480142153975,
                -30.553915078882145
              ],
              [
                -52.44569605465706,
                -30.55557704032414
              ],
              [
                -52.44948508903628,
                -30.555523428664717
              ],
              [
                -52.45137960622589,
                -30.558311234954513
              ],
              [
                -52.45369512723541,
                -30.56072375962837
              ],
              [
                -52.451221729793424,
                -30.563618789237005
              ],
              [
                -52.449695590946234,
                -30.56442296412829
              ],
              [
                -52.44959033999126,
                -30.565977702251445
              ],
              [
                -52.45269524316312,
                -30.570802751599164
              ],
              [
                -52.452800494118094,
                -30.576003082562817
              ],
              [
                -52.45222161386572,
                -30.5770753157512
              ],
              [
                -52.45069547501853,
                -30.577289762388876
              ],
              [
                -52.44911671069386,
                -30.576592810816425
              ],
              [
                -52.44627493490945,
                -30.576807257454103
              ],
              [
                -52.44090713620555,
                -30.574126674483146
              ],
              [
                -52.434013198654476,
                -30.57460917941792
              ],
              [
                -52.43301331458218,
                -30.57637836417875
              ],
              [
                -52.433223816492145,
                -30.577718655664228
              ],
              [
                -52.43122404834756,
                -30.57830838391784
              ],
              [
                -52.43022416427526,
                -30.57991673370041
              ],
              [
                -52.43027678975275,
                -30.581417860164144
              ],
              [
                -52.429382156635434,
                -30.582007588417756
              ],
              [
                -52.42711926110341,
                -30.581525083482983
              ],
              [
                -52.426119377031114,
                -30.582704539990203
              ],
              [
                -52.42322497576921,
                -30.58302620994672
              ],
              [
                -52.42148833501207,
                -30.58227564671485
              ],
              [
                -52.419909570687395,
                -30.5840984431351
              ],
              [
                -52.42048845093977,
                -30.5866181911278
              ],
              [
                -52.41959381782246,
                -30.587422366019087
              ],
              [
                -52.41538377962333,
                -30.585706792917676
              ],
              [
                -52.41412076816359,
                -30.584420113091618
              ],
              [
                -52.412805131226364,
                -30.584580948069874
              ],
              [
                -52.41038435926186,
                -30.586403744490124
              ],
              [
                -52.41012123187442,
                -30.588226540910373
              ],
              [
                -52.40870034398221,
                -30.59010294899004
              ],
              [
                -52.406595324882645,
                -30.58967405571469
              ],
              [
                -52.4053849389004,
                -30.59021017230888
              ],
              [
                -52.40459555673806,
                -30.592301027026224
              ],
              [
                -52.40370092362075,
                -30.59321242523635
              ],
              [
                -52.401911657386115,
                -30.59337326021461
              ],
              [
                -52.40038551853893,
                -30.59262269698274
              ],
              [
                -52.39917513255668,
                -30.5939093768088
              ],
              [
                -52.399596136376594,
                -30.596000231526144
              ],
              [
                -52.39628073129478,
                -30.595410503272532
              ],
              [
                -52.39512297079002,
                -30.59621467816382
              ],
              [
                -52.3928074497805,
                -30.59669718309859
              ],
              [
                -52.39317582812292,
                -30.59809108624349
              ],
              [
                -52.39159706379825,
                -30.598305532881163
              ],
              [
                -52.390018299473574,
                -30.597018853055108
              ],
              [
                -52.38812378228397,
                -30.597126076373947
              ],
              [
                -52.38538725745453,
                -30.598305532881163
              ],
              [
                -52.38491362815713,
                -30.600610834236186
              ],
              [
                -52.38401899503982,
                -30.60152223244631
              ],
              [
                -52.381492972120334,
                -30.601683067424567
              ],
              [
                -52.380703589958,
                -30.602380018997017
              ],
              [
                -52.38128247021038,
                -30.604095592098428
              ],
              [
                -52.38101934282294,
                -30.605703941881004
              ],
              [
                -52.379808956840684,
                -30.60581116519984
              ],
              [
                -52.379387953020775,
                -30.604095592098428
              ],
              [
                -52.37601992246147,
                -30.605275048605648
              ],
              [
                -52.3743885326593,
                -30.60280891227237
              ],
              [
                -52.370599498280086,
                -30.60280891227237
              ],
              [
                -52.369178610387884,
                -30.60221918401876
              ],
              [
                -52.368389228225546,
                -30.603291417207142
              ],
              [
                -52.3691259849104,
                -30.604310038736106
              ],
              [
                -52.36802084988312,
                -30.60650811677229
              ],
              [
                -52.369704865162774,
                -30.606776175069385
              ],
              [
                -52.369810116117755,
                -30.608277301533118
              ],
              [
                -52.368389228225546,
                -30.609081476424407
              ],
              [
                -52.366178958171005,
                -30.608706194808473
              ],
              [
                -52.362179421881834,
                -30.606025611837516
              ],
              [
                -52.36249517474676,
                -30.608491748170795
              ],
              [
                -52.36060065755716,
                -30.60951036969976
              ],
              [
                -52.35781150725023,
                -30.612083729351877
              ],
              [
                -52.35618011744807,
                -30.615890157170632
              ],
              [
                -52.356495870313005,
                -30.61921408005462
              ],
              [
                -52.35591699006063,
                -30.621197711453124
              ],
              [
                -52.356390619358024,
                -30.62210910966325
              ],
              [
                -52.35470660407837,
                -30.624521634337107
              ],
              [
                -52.354811855033354,
                -30.626505265735616
              ],
              [
                -52.34981243467189,
                -30.625379420887814
              ],
              [
                -52.34602340029267,
                -30.626880547351547
              ],
              [
                -52.34591814933769,
                -30.62811361551819
              ],
              [
                -52.343392126418216,
                -30.629400295344247
              ],
              [
                -52.34228699139094,
                -30.63100864512682
              ],
              [
                -52.34270799521086,
                -30.632616994909394
              ],
              [
                -52.345602396472756,
                -30.633796451416615
              ],
              [
                -52.346391778635095,
                -30.63578008281512
              ],
              [
                -52.34549714551778,
                -30.637388432597692
              ],
              [
                -52.34207648948099,
                -30.63771010255421
              ],
              [
                -52.34070822706627,
                -30.638996782380268
              ],
              [
                -52.34218174043596,
                -30.640283462206327
              ],
              [
                -52.343813130238125,
                -30.640176238887488
              ],
              [
                -52.34439201049051,
                -30.641516530372964
              ],
              [
                -52.343286875463235,
                -30.644626006619273
              ],
              [
                -52.344181508580554,
                -30.646395191380105
              ],
              [
                -52.344076257625574,
                -30.648110764481515
              ],
              [
                -52.34191861304852,
                -30.648110764481515
              ],
              [
                -52.33891896083164,
                -30.653686377061103
              ],
              [
                -52.34091872897623,
                -30.658511426408822
              ],
              [
                -52.34002409585891,
                -30.661996184271064
              ],
              [
                -52.34049772515631,
                -30.6668748452782
              ],
              [
                -52.342023864003494,
                -30.66960903990858
              ],
              [
                -52.34439201049051,
                -30.671592671307085
              ],
              [
                -52.341602860183585,
                -30.676310497335965
              ],
              [
                -52.343023748075794,
                -30.678615798690988
              ],
              [
                -52.33639293791216,
                -30.680974711705428
              ],
              [
                -52.33660343982212,
                -30.682583061488
              ],
              [
                -52.339024211786615,
                -30.68381612965464
              ],
              [
                -52.34002409585891,
                -30.685424479437213
              ],
              [
                -52.33970834299397,
                -30.687515334154558
              ],
              [
                -52.338603207966706,
                -30.688587567342942
              ],
              [
                -52.33707706911952,
                -30.687193664198045
              ],
              [
                -52.33591930861476,
                -30.687193664198045
              ],
              [
                -52.33518255192991,
                -30.68821228572701
              ],
              [
                -52.336024559569736,
                -30.692125936864603
              ],
              [
                -52.336708690777094,
                -30.698184054378963
              ],
              [
                -52.34218174043596,
                -30.704510230190415
              ],
              [
                -52.34118185636367,
                -30.710997240980127
              ],
              [
                -52.338603207966706,
                -30.711908639190252
              ],
              [
                -52.33791907675935,
                -30.712820037400377
              ],
              [
                -52.336024559569736,
                -30.713624212291663
              ],
              [
                -52.32928849845113,
                -30.713892270588758
              ],
              [
                -52.32471008190958,
                -30.71458922216121
              ],
              [
                -52.32292081567495,
                -30.717001746835066
              ],
              [
                -52.319973788935556,
                -30.718824543255316
              ],
              [
                -52.31771089340352,
                -30.721290679588595
              ],
              [
                -52.31750039149357,
                -30.723113476008844
              ],
              [
                -52.315079619529065,
                -30.72402487421897
              ],
              [
                -52.31460599023167,
                -30.724775437450838
              ],
              [
                -52.31760564244855,
                -30.728206583653662
              ],
              [
                -52.315711125258936,
                -30.72997576841449
              ],
              [
                -52.31629000551132,
                -30.732013011472418
              ],
              [
                -52.315711125258936,
                -30.73297802134196
              ],
              [
                -52.31192209087972,
                -30.73469359444337
              ],
              [
                -52.31071170489747,
                -30.736998895798394
              ],
              [
                -52.31081695585245,
                -30.73839279894329
              ],
              [
                -52.30792255459055,
                -30.738285575624452
              ],
              [
                -52.30597541192345,
                -30.739518643791094
              ],
              [
                -52.306396415743365,
                -30.74032281868238
              ],
              [
                -52.30529128071609,
                -30.74321784829101
              ],
              [
                -52.30418614568882,
                -30.743485906588106
              ],
              [
                -52.30208112658926,
                -30.746005654580806
              ],
              [
                -52.300291860354626,
                -30.746380936196736
              ],
              [
                -52.29760796100268,
                -30.74809650929815
              ],
              [
                -52.29571344381307,
                -30.74981208239956
              ],
              [
                -52.29481881069576,
                -30.751474043841554
              ],
              [
                -52.29492406165073,
                -30.753725733537156
              ],
              [
                -52.293818926623466,
                -30.753886568515412
              ],
              [
                -52.293608424713504,
                -30.75538769497915
              ],
              [
                -52.2921875368213,
                -30.756513539826948
              ],
              [
                -52.2917139075239,
                -30.758014666290684
              ],
              [
                -52.293082169938614,
                -30.76069524926164
              ],
              [
                -52.29260854064121,
                -30.7631077739355
              ],
              [
                -52.2917139075239,
                -30.764716123718074
              ],
              [
                -52.29018776867672,
                -30.766002803544133
              ],
              [
                -52.285925105000096,
                -30.766914201754258
              ],
              [
                -52.28392533685551,
                -30.770023678000562
              ],
              [
                -52.28418846424295,
                -30.771095911188947
              ],
              [
                -52.281820317755944,
                -30.772918707609197
              ],
              [
                -52.2806099317737,
                -30.773079542587453
              ],
              [
                -52.2800836769988,
                -30.774312610754095
              ],
              [
                -52.278294410764175,
                -30.774795115688864
              ],
              [
                -52.27608414070963,
                -30.776617912109113
              ],
              [
                -52.27618939166461,
                -30.7776901452975
              ],
              [
                -52.27487375472738,
                -30.78047795158729
              ],
              [
                -52.275715762367206,
                -30.782622417964056
              ],
              [
                -52.27471587829491,
                -30.784874107659657
              ],
              [
                -52.27308448849275,
                -30.787286632333515
              ],
              [
                -52.27071634200574,
                -30.78717940901468
              ],
              [
                -52.26919020315856,
                -30.78889498211609
              ],
              [
                -52.26882182481613,
                -30.79361280814497
              ],
              [
                -52.270295338185825,
                -30.794202536398583
              ],
              [
                -52.26919020315856,
                -30.795918109499993
              ],
              [
                -52.26740093692393,
                -30.79618616779709
              ],
              [
                -52.26682205667154,
                -30.798598692470947
              ],
              [
                -52.26529591782436,
                -30.799402867362236
              ],
              [
                -52.26261201847242,
                -30.79972453731875
              ],
              [
                -52.260822752237786,
                -30.798277022514434
              ],
              [
                -52.2592966133906,
                -30.798598692470947
              ],
              [
                -52.25829672931831,
                -30.7965078377536
              ],
              [
                -52.25887560957069,
                -30.794202536398583
              ],
              [
                -52.25608645926376,
                -30.792808633253685
              ],
              [
                -52.257612598110946,
                -30.79018166194215
              ],
              [
                -52.25729684524602,
                -30.789216652072604
              ],
              [
                -52.257980976453375,
                -30.78589272918862
              ],
              [
                -52.25698109238108,
                -30.78530300093501
              ],
              [
                -52.2568758414261,
                -30.78390909779011
              ],
              [
                -52.253981440164196,
                -30.783319369536503
              ],
              [
                -52.252297424884546,
                -30.781282126478576
              ],
              [
                -52.25208692297459,
                -30.778815990145297
              ],
              [
                -52.25150804272221,
                -30.7776901452975
              ],
              [
                -52.251402791767234,
                -30.77511678564538
              ],
              [
                -52.252823679659436,
                -30.773508435862805
              ],
              [
                -52.25040290769494,
                -30.772007309399072
              ],
              [
                -52.24898201980273,
                -30.771792862761394
              ],
              [
                -52.24782425929797,
                -30.770613406254174
              ],
              [
                -52.246087618540834,
                -30.770506182935335
              ],
              [
                -52.24508773446854,
                -30.76959478472521
              ],
              [
                -52.24850839050533,
                -30.767182260051353
              ],
              [
                -52.24782425929797,
                -30.765573910268778
              ],
              [
                -52.246087618540834,
                -30.76482334703691
              ],
              [
                -52.24471935612611,
                -30.7619819290877
              ],
              [
                -52.244403603261176,
                -30.760319967645707
              ],
              [
                -52.240404066972005,
                -30.756620763145786
              ],
              [
                -52.235088893745605,
                -30.756620763145786
              ],
              [
                -52.23240499439366,
                -30.757424938037076
              ],
              [
                -52.22961584408674,
                -30.7558165882545
              ],
              [
                -52.227721326897125,
                -30.757478549696494
              ],
              [
                -52.225405805887604,
                -30.755602141616826
              ],
              [
                -52.22140626959843,
                -30.755602141616826
              ],
              [
                -52.21909074858891,
                -30.754583520087863
              ],
              [
                -52.210618046713165,
                -30.755602141616826
              ],
              [
                -52.20877615500105,
                -30.757585773015332
              ],
              [
                -52.208986656911,
                -30.76010552100803
              ],
              [
                -52.20798677283871,
                -30.7631077739355
              ],
              [
                -52.213196695110135,
                -30.770077289659984
              ],
              [
                -52.21409132822745,
                -30.77447344573235
              ],
              [
                -52.213617698930044,
                -30.778923213464136
              ],
              [
                -52.21277569129022,
                -30.777797368616334
              ],
              [
                -52.20819727474866,
                -30.777100417043886
              ],
              [
                -52.20472399323438,
                -30.774098164116417
              ],
              [
                -52.199093067143046,
                -30.771203134507786
              ],
              [
                -52.19751430281838,
                -30.765681133587616
              ],
              [
                -52.19598816397119,
                -30.763375832232594
              ],
              [
                -52.19451465060149,
                -30.764608900399235
              ],
              [
                -52.19277800984435,
                -30.76359027887027
              ],
              [
                -52.18962048119501,
                -30.764180007123883
              ],
              [
                -52.18388430414869,
                -30.769487561406372
              ],
              [
                -52.17767449780498,
                -30.7737764941599
              ],
              [
                -52.182516041733976,
                -30.776725135427952
              ],
              [
                -52.184884188220984,
                -30.778976825123554
              ],
              [
                -52.185410442995874,
                -30.780102669971356
              ],
              [
                -52.184884188220984,
                -30.782086301369862
              ],
              [
                -52.18388430414869,
                -30.78412354442779
              ],
              [
                -52.18277916912142,
                -30.78771552560887
              ],
              [
                -52.18341067485129,
                -30.792594186616007
              ],
              [
                -52.18277916912142,
                -30.79372003146381
              ],
              [
                -52.18341067485129,
                -30.79489948797103
              ],
              [
                -52.18298967103138,
                -30.797204789326052
              ],
              [
                -52.18351592580627,
                -30.798116187536177
              ],
              [
                -52.18220028886904,
                -30.79961731399991
              ],
              [
                -52.181779285049124,
                -30.801815392036094
              ],
              [
                -52.182516041733976,
                -30.80342374181867
              ],
              [
                -52.18398955510367,
                -30.80449597500705
              ],
              [
                -52.18377905319371,
                -30.80621154810846
              ],
              [
                -52.182673918166444,
                -30.807283781296842
              ],
              [
                -52.17962164047207,
                -30.808892131079418
              ],
              [
                -52.17867438187727,
                -30.811519102390953
              ],
              [
                -52.17888488378723,
                -30.81350273378946
              ],
              [
                -52.17809550162489,
                -30.81591525846332
              ],
              [
                -52.177884999714934,
                -30.818595841434274
              ],
              [
                -52.177095617552595,
                -30.819400016325563
              ],
              [
                -52.17620098443528,
                -30.822884774187806
              ],
              [
                -52.17677986468766,
                -30.824010619035604
              ],
              [
                -52.17830600353484,
                -30.824600347289216
              ],
              [
                -52.17830600353484,
                -30.8279242701732
              ],
              [
                -52.17899013474221,
                -30.828674833405067
              ],
              [
                -52.17751662137251,
                -30.830390406506478
              ],
              [
                -52.17888488378723,
                -30.837574368868637
              ],
              [
                -52.17662198825519,
                -30.838914660354117
              ],
              [
                -52.1732013322184,
                -30.83928994197005
              ],
              [
                -52.172201448146104,
                -30.840308563499015
              ],
              [
                -52.16988592713658,
                -30.841005515071462
              ],
              [
                -52.170096429046545,
                -30.842774699832294
              ],
              [
                -52.16888604306429,
                -30.843418039745323
              ],
              [
                -52.16888604306429,
                -30.84529444782499
              ],
              [
                -52.16651789657728,
                -30.847921419136526
              ],
              [
                -52.16651789657728,
                -30.848886429006072
              ],
              [
                -52.16409712461278,
                -30.851513400317607
              ],
              [
                -52.164412877477716,
                -30.8531753617596
              ],
              [
                -52.16399187365781,
                -30.8543012066074
              ],
              [
                -52.1610974723959,
                -30.85617761468707
              ],
              [
                -52.159623959026206,
                -30.85912625595512
              ],
              [
                -52.15778206731409,
                -30.860091265824664
              ],
              [
                -52.15551917178205,
                -30.862879072114456
              ],
              [
                -52.15409828388985,
                -30.862396567179687
              ],
              [
                -52.150309249510634,
                -30.86432658691877
              ],
              [
                -52.14778322659116,
                -30.86400491696226
              ],
              [
                -52.14509932723921,
                -30.86518437346948
              ],
              [
                -52.14088928904008,
                -30.864380198578193
              ],
              [
                -52.13899477185047,
                -30.865881325041926
              ],
              [
                -52.138889520895496,
                -30.867918568099853
              ],
              [
                -52.13652137440848,
                -30.8688835779694
              ],
              [
                -52.13688975275091,
                -30.87070637438965
              ],
              [
                -52.13641612345351,
                -30.871724995918612
              ],
              [
                -52.13431110435394,
                -30.871993054215707
              ],
              [
                -52.13341647123663,
                -30.8733869573606
              ],
              [
                -52.13152195404702,
                -30.873708627317118
              ],
              [
                -52.1296800623349,
                -30.873279734041763
              ],
              [
                -52.12852230183014,
                -30.874512802208404
              ],
              [
                -52.126785661072994,
                -30.87467363718666
              ],
              [
                -52.1263120317756,
                -30.875799482034463
              ],
              [
                -52.12652253368555,
                -30.87767589011413
              ],
              [
                -52.12489114388339,
                -30.880999812998116
              ],
              [
                -52.12489114388339,
                -30.882715386099527
              ],
              [
                -52.12268087382885,
                -30.884699017498033
              ],
              [
                -52.12010222543188,
                -30.884216512563263
              ],
              [
                -52.11878658849465,
                -30.884699017498033
              ],
              [
                -52.11810245728729,
                -30.88598569732409
              ],
              [
                -52.115892187232745,
                -30.888076552041436
              ],
              [
                -52.11620794009768,
                -30.889524066845752
              ],
              [
                -52.11568168532279,
                -30.894188281215214
              ],
              [
                -52.11631319105266,
                -30.896493582570237
              ],
              [
                -52.11531330698037,
                -30.89810193235281
              ],
              [
                -52.113418789790764,
                -30.897994709033973
              ],
              [
                -52.1113137706912,
                -30.90051445702667
              ],
              [
                -52.10989288279899,
                -30.903999214888913
              ],
              [
                -52.10857724586176,
                -30.90550034135265
              ],
              [
                -52.10752473631198,
                -30.90550034135265
              ],
              [
                -52.106314350329725,
                -30.903302263316462
              ],
              [
                -52.102577941428,
                -30.905607564671485
              ],
              [
                -52.09978879112108,
                -30.909092322533727
              ],
              [
                -52.09899940895874,
                -30.909092322533727
              ],
              [
                -52.09799952488645,
                -30.90710869113522
              ],
              [
                -52.09010570326308,
                -30.90587562296858
              ],
              [
                -52.089211070145765,
                -30.90287337004111
              ],
              [
                -52.08789543320854,
                -30.901908360171568
              ],
              [
                -52.08189612877478,
                -30.90287337004111
              ],
              [
                -52.07658095554838,
                -30.90651896288161
              ],
              [
                -52.070686902069596,
                -30.911880128823523
              ],
              [
                -52.07047640015964,
                -30.918903256207425
              ],
              [
                -52.0692133886999,
                -30.919600207779872
              ],
              [
                -52.068897635834965,
                -30.92099411092477
              ],
              [
                -52.06689786769038,
                -30.922977742323276
              ],
              [
                -52.06279308044623,
                -30.922977742323276
              ],
              [
                -52.055688640985196,
                -30.92699861677971
              ],
              [
                -52.05447825500295,
                -30.925979995250746
              ],
              [
                -52.05011034037135,
                -30.925979995250746
              ],
              [
                -52.04290064995534,
                -30.922977742323276
              ],
              [
                -52.03337543852981,
                -30.916597954852403
              ],
              [
                -52.03090204108782,
                -30.9179918579973
              ],
              [
                -52.02648150097873,
                -30.918688809569748
              ],
              [
                -52.020903200364884,
                -30.91622267323647
              ],
              [
                -52.01732466789563,
                -30.91611544991763
              ],
              [
                -52.01411451376879,
                -30.918796032888586
              ],
              [
                -52.013114629696496,
                -30.922602460707342
              ],
              [
                -52.00790470742508,
                -30.923674693895723
              ],
              [
                -51.993590577548034,
                -30.923192188960954
              ],
              [
                -51.986486138087,
                -30.92410358717108
              ],
              [
                -51.98222347441038,
                -30.926408888526097
              ],
              [
                -51.9802237062658,
                -30.923513858917467
              ],
              [
                -51.976803050229,
                -30.921423004200122
              ],
              [
                -51.97548741329177,
                -30.923406635598628
              ],
              [
                -51.969119730515594,
                -30.92699861677971
              ],
              [
                -51.96827772287577,
                -30.9311803262144
              ],
              [
                -51.96648845664114,
                -30.93359285088826
              ],
              [
                -51.96027865029742,
                -30.933378404250583
              ],
              [
                -51.95912088979266,
                -30.935898152243283
              ],
              [
                -51.955910735665825,
                -30.937613725344693
              ],
              [
                -51.955384480890935,
                -30.939007628489588
              ],
              [
                -51.95191119937665,
                -30.93970458006204
              ],
              [
                -51.94991143123207,
                -30.938793181851914
              ],
              [
                -51.94149135483381,
                -30.94372545451847
              ],
              [
                -51.882287692658544,
                -30.912309022098874
              ],
              [
                -51.88149831049621,
                -30.91300597367132
              ],
              [
                -51.87860390923431,
                -30.923513858917467
              ],
              [
                -51.8738149907828,
                -30.9323061710622
              ],
              [
                -51.87392024173778,
                -30.93541564730851
              ],
              [
                -51.87170997168323,
                -30.94142015316345
              ],
              [
                -51.868026188258995,
                -30.947692717315483
              ],
              [
                -51.864921285087135,
                -30.95519834963416
              ],
              [
                -51.865815918204454,
                -30.961524525445615
              ],
              [
                -51.86392140101484,
                -30.97079934252512
              ],
              [
                -51.86397402649233,
                -30.97932359637276
              ],
              [
                -51.859711362815716,
                -30.992619287908695
              ],
              [
                -51.854922444364206,
                -31.004092183024383
              ],
              [
                -51.84739700108326,
                -31.010793640451773
              ],
              [
                -51.82839920370969,
                -31.02001484587186
              ],
              [
                -51.81829511203178,
                -31.02371405037178
              ],
              [
                -51.81050654136339,
                -31.029825779545558
              ],
              [
                -51.81697947509455,
                -31.044997879161162
              ],
              [
                -51.817295227959484,
                -31.047517627153862
              ],
              [
                -51.798402681540885,
                -31.098823985217948
              ],
              [
                -51.78861434272791,
                -31.12219866872468
              ],
              [
                -51.78950897584523,
                -31.123592571869573
              ],
              [
                -51.79161399494479,
                -31.140212186289496
              ],
              [
                -51.801086580892836,
                -31.14482278899954
              ],
              [
                -51.8089804025162,
                -31.146591973760373
              ],
              [
                -51.812874687850396,
                -31.149379780050165
              ],
              [
                -51.81582171458979,
                -31.152274809658795
              ],
              [
                -51.82040013113134,
                -31.159083490405024
              ],
              [
                -51.82087376042874,
                -31.164819937962868
              ],
              [
                -51.82071588399627,
                -31.16750052093382
              ],
              [
                -51.81797935916684,
                -31.172325570281544
              ],
              [
                -51.81297993880538,
                -31.173290580151086
              ],
              [
                -51.81071704327334,
                -31.171789453687353
              ],
              [
                -51.80961190824607,
                -31.168519142462785
              ],
              [
                -51.806296503164255,
                -31.16712523931789
              ],
              [
                -51.80229696687508,
                -31.167178850977308
              ],
              [
                -51.79808692867596,
                -31.16841191914395
              ],
              [
                -51.79461364716167,
                -31.170985278796064
              ],
              [
                -51.78982472871016,
                -31.176400056397394
              ],
              [
                -51.79019310705259,
                -31.17827646447706
              ],
              [
                -51.79461364716167,
                -31.184709863607356
              ],
              [
                -51.79419264334176,
                -31.1868007183247
              ],
              [
                -51.78871959368289,
                -31.19049992282462
              ],
              [
                -51.78750920770064,
                -31.20079336143309
              ],
              [
                -51.78419380261882,
                -31.20551118746197
              ],
              [
                -51.7838254242764,
                -31.20781648881699
              ],
              [
                -51.78450955548376,
                -31.209907343534336
              ],
              [
                -51.788298589862976,
                -31.211890974932842
              ],
              [
                -51.78871959368289,
                -31.213981829650187
              ],
              [
                -51.78629882171839,
                -31.215375732795085
              ],
              [
                -51.78082577205952,
                -31.215590179432763
              ],
              [
                -51.77972063703225,
                -31.216501577642887
              ],
              [
                -51.7799837644197,
                -31.21810992742546
              ],
              [
                -51.78498318478116,
                -31.220093558823965
              ],
              [
                -51.78408855166385,
                -31.222720530135504
              ],
              [
                -51.78587781789848,
                -31.22459693821517
              ],
              [
                -51.78587781789848,
                -31.22647334629484
              ],
              [
                -51.782878165681595,
                -31.227974472758575
              ],
              [
                -51.78029951728463,
                -31.233389250359906
              ],
              [
                -51.782983416636576,
                -31.235801775033764
              ],
              [
                -51.78640407267337,
                -31.24271767909883
              ],
              [
                -51.78682507649328,
                -31.244701310497337
              ],
              [
                -51.78550943955605,
                -31.247810786743646
              ],
              [
                -51.78719345483571,
                -31.248293291678415
              ],
              [
                -51.78940372489025,
                -31.24738189346829
              ],
              [
                -51.78940372489025,
                -31.246684941895843
              ],
              [
                -51.78740395674566,
                -31.2457199320263
              ],
              [
                -51.78987735418765,
                -31.24507659211327
              ],
              [
                -51.793719014044356,
                -31.248990243250866
              ],
              [
                -51.79250862806211,
                -31.25038414639576
              ],
              [
                -51.789614226800204,
                -31.248990243250866
              ],
              [
                -51.78950897584523,
                -31.25172443788124
              ],
              [
                -51.79171924589977,
                -31.25220694281601
              ],
              [
                -51.791298242079854,
                -31.253118341026138
              ],
              [
                -51.78871959368289,
                -31.253600845960907
              ],
              [
                -51.78861434272791,
                -31.254780302468127
              ],
              [
                -51.78987735418765,
                -31.255584477359413
              ],
              [
                -51.793192759269466,
                -31.254512244171032
              ],
              [
                -51.796087160531364,
                -31.256710322207216
              ],
              [
                -51.79698179364868,
                -31.256710322207216
              ],
              [
                -51.798402681540885,
                -31.254994749105805
              ],
              [
                -51.799718318478114,
                -31.255691700678252
              ],
              [
                -51.80008669682054,
                -31.25708560382315
              ],
              [
                -51.79908681274825,
                -31.259873410112945
              ],
              [
                -51.79950781656816,
                -31.266199585924397
              ],
              [
                -51.804717738839585,
                -31.274616616453198
              ],
              [
                -51.808085769398886,
                -31.277779704358924
              ],
              [
                -51.811716927345635,
                -31.28571422995295
              ],
              [
                -51.81761098082442,
                -31.291825959126733
              ],
              [
                -51.822978779528306,
                -31.295793221923745
              ],
              [
                -51.8263994355651,
                -31.30088632956856
              ],
              [
                -51.82682043938501,
                -31.302816349307648
              ],
              [
                -51.832188238088904,
                -31.304799980706154
              ],
              [
                -51.83392487884605,
                -31.30640833048873
              ],
              [
                -51.83960843041487,
                -31.31600481752475
              ],
              [
                -51.84229232976681,
                -31.319275128749315
              ],
              [
                -51.84392371956898,
                -31.32318877988691
              ],
              [
                -51.85018615139018,
                -31.327692159278115
              ],
              [
                -51.85608020486897,
                -31.329997460633134
              ],
              [
                -51.85771159467113,
                -31.331820257053383
              ],
              [
                -51.855080320796674,
                -31.33519779159679
              ],
              [
                -51.85518557175165,
                -31.336377248104007
              ],
              [
                -51.86018499211311,
                -31.33160581041571
              ],
              [
                -51.8592903589958,
                -31.328174664212884
              ],
              [
                -51.859711362815716,
                -31.32608380949554
              ],
              [
                -51.85807997301355,
                -31.32678076106799
              ],
              [
                -51.85829047492351,
                -31.321419595126077
              ],
              [
                -51.85697483798628,
                -31.31772039062616
              ],
              [
                -51.85750109276117,
                -31.316112040843585
              ],
              [
                -51.86007974115814,
                -31.31219838970599
              ],
              [
                -51.866710551321766,
                -31.307695010314788
              ],
              [
                -51.86960495258367,
                -31.304317475771384
              ],
              [
                -51.87007858188107,
                -31.3021193977352
              ],
              [
                -51.87249935384557,
                -31.30029660131495
              ],
              [
                -51.872288851935615,
                -31.29911714480773
              ],
              [
                -51.87018383283605,
                -31.297401571706317
              ],
              [
                -51.86707892966419,
                -31.29659739681503
              ],
              [
                -51.86681580227675,
                -31.295096270351298
              ],
              [
                -51.87107846595336,
                -31.29477460039478
              ],
              [
                -51.871394218818295,
                -31.293380697249887
              ],
              [
                -51.87607788631483,
                -31.2984738048947
              ],
              [
                -51.87639363917977,
                -31.301904951097523
              ],
              [
                -51.874078118170246,
                -31.303995805814868
              ],
              [
                -51.87560425701743,
                -31.30571137891628
              ],
              [
                -51.875025376765045,
                -31.308981690140847
              ],
              [
                -51.882813947433434,
                -31.31482536101753
              ],
              [
                -51.88207719074859,
                -31.316112040843585
              ],
              [
                -51.88307707482088,
                -31.316808992416036
              ],
              [
                -51.879919546171536,
                -31.32377850814052
              ],
              [
                -51.88081417928885,
                -31.324582683031807
              ],
              [
                -51.88428746080313,
                -31.322706274952136
              ],
              [
                -51.88528734487542,
                -31.320025691981183
              ],
              [
                -51.89207603147152,
                -31.315683147568233
              ],
              [
                -51.90239062505939,
                -31.31348506953205
              ],
              [
                -51.90628491039359,
                -31.313913962807405
              ],
              [
                -51.91302097151219,
                -31.31000031166981
              ],
              [
                -51.91949390524336,
                -31.310804486561096
              ],
              [
                -51.9235986924875,
                -31.31471813769869
              ],
              [
                -51.92580896254205,
                -31.3153078659523
              ],
              [
                -51.93059788099356,
                -31.31889984713338
              ],
              [
                -51.93180826697581,
                -31.321097925169564
              ],
              [
                -51.9313872631559,
                -31.327102431024503
              ],
              [
                -51.9303873790836,
                -31.328389110850562
              ],
              [
                -51.92801923259659,
                -31.328925227444753
              ],
              [
                -51.92138842243296,
                -31.32790660591579
              ],
              [
                -51.923019812235125,
                -31.331873868712805
              ],
              [
                -51.93270290009312,
                -31.335090568277952
              ],
              [
                -51.93901795739182,
                -31.33519779159679
              ],
              [
                -51.94459625800566,
                -31.338896996096707
              ],
              [
                -51.94859579429484,
                -31.33932588937206
              ],
              [
                -51.95348996370132,
                -31.343722045444427
              ],
              [
                -51.958121005720365,
                -31.351120454444263
              ],
              [
                -51.96012077386495,
                -31.352782415886256
              ],
              [
                -51.96322567703681,
                -31.36270057287879
              ],
              [
                -51.963278302514304,
                -31.367096728951157
              ],
              [
                -51.962383669396985,
                -31.369991758559788
              ],
              [
                -51.960699654117334,
                -31.372994011487258
              ],
              [
                -51.95517397898098,
                -31.373798186378547
              ],
              [
                -51.95180594842167,
                -31.375513759479958
              ],
              [
                -51.95627911400825,
                -31.376317934371244
              ],
              [
                -51.96227841844201,
                -31.3789985173422
              ],
              [
                -51.9656990744788,
                -31.3789985173422
              ],
              [
                -51.967277838803476,
                -31.377926284153816
              ],
              [
                -51.96980386172295,
                -31.378623235726266
              ],
              [
                -51.970908996750225,
                -31.379695468914647
              ],
              [
                -51.97590841711169,
                -31.380392420487095
              ],
              [
                -51.98059208460822,
                -31.38371634337108
              ],
              [
                -51.98248660179783,
                -31.38607525638552
              ],
              [
                -51.98711764381687,
                -31.39449228691432
              ],
              [
                -51.99127505653851,
                -31.40837770670387
              ],
              [
                -51.993695828503014,
                -31.413578037667524
              ],
              [
                -51.995485094737646,
                -31.421190893305038
              ],
              [
                -51.99501146544024,
                -31.423388971341218
              ],
              [
                -51.99669548071989,
                -31.425426214399145
              ],
              [
                -51.99969513293677,
                -31.438614682616247
              ],
              [
                -52.00111602082898,
                -31.440919983971266
              ],
              [
                -52.00348416731599,
                -31.452875384021727
              ],
              [
                -52.008325711244986,
                -31.493191351904898
              ],
              [
                -52.007694205515115,
                -31.50032170260764
              ],
              [
                -52.0102202284346,
                -31.500911430861247
              ],
              [
                -52.009483471749746,
                -31.503002285578592
              ],
              [
                -52.01548277618351,
                -31.525787240831715
              ],
              [
                -52.017903548148006,
                -31.54031600053429
              ],
              [
                -52.01811405005797,
                -31.547875244512387
              ],
              [
                -52.015588027138485,
                -31.570016859852476
              ],
              [
                -52.01369350994888,
                -31.58181142492468
              ],
              [
                -52.01137798893936,
                -31.585725076062275
              ],
              [
                -52.012219996579184,
                -31.58840565903323
              ],
              [
                -52.010904359641955,
                -31.594088494931654
              ],
              [
                -52.01348300803892,
                -31.597197971177962
              ],
              [
                -52.00990447556966,
                -31.597573252793897
              ],
              [
                -52.00969397365971,
                -31.60030744742427
              ],
              [
                -52.011009610596936,
                -31.60277358375755
              ],
              [
                -52.01111486155191,
                -31.606794458213983
              ],
              [
                -52.010009726524636,
                -31.61419286721382
              ],
              [
                -52.013377757083944,
                -31.619393198177473
              ],
              [
                -52.02000856724757,
                -31.65198908710429
              ],
              [
                -52.02121895322982,
                -31.662389749031597
              ],
              [
                -52.024008103536744,
                -31.671074837857493
              ],
              [
                -52.02379760162679,
                -31.67321930423426
              ],
              [
                -52.02500798760904,
                -31.67439876074148
              ],
              [
                -52.029007523898215,
                -31.684316917734012
              ],
              [
                -52.030691539177866,
                -31.69230505498746
              ],
              [
                -52.03269130732245,
                -31.69520008459609
              ],
              [
                -52.036006712404266,
                -31.6957898128497
              ],
              [
                -52.04137451110815,
                -31.69332367651642
              ],
              [
                -52.049110456299054,
                -31.687211947342643
              ],
              [
                -52.052320610425895,
                -31.68571082087891
              ],
              [
                -52.05721477983238,
                -31.68319107288621
              ],
              [
                -52.05831991485965,
                -31.68201161637899
              ],
              [
                -52.05889879511203,
                -31.67900936345152
              ],
              [
                -52.06200369828389,
                -31.67911658677036
              ],
              [
                -52.06368771356354,
                -31.681314664806543
              ],
              [
                -52.06647686387046,
                -31.681689946422477
              ],
              [
                -52.06768724985272,
                -31.6800815966399
              ],
              [
                -52.06789775176267,
                -31.67718656703127
              ],
              [
                -52.06958176704232,
                -31.677079343712432
              ],
              [
                -52.07042377468215,
                -31.678419635197912
              ],
              [
                -52.07689670841331,
                -31.68201161637899
              ],
              [
                -52.08510628290161,
                -31.68201161637899
              ],
              [
                -52.086895549136244,
                -31.683512742842726
              ],
              [
                -52.100999177103326,
                -31.68501386930646
              ],
              [
                -52.104104080275185,
                -31.684692199349946
              ],
              [
                -52.120523229251795,
                -31.68930280205999
              ],
              [
                -52.127417166802864,
                -31.690106976951277
              ],
              [
                -52.134100602443986,
                -31.69332367651642
              ],
              [
                -52.14309955909462,
                -31.695575366212026
              ],
              [
                -52.1524142686102,
                -31.699274570711943
              ],
              [
                -52.163518244360404,
                -31.707584377921904
              ],
              [
                -52.165307510595035,
                -31.70849577613203
              ],
              [
                -52.192883260799334,
                -31.722595642559256
              ],
              [
                -52.19851418689067,
                -31.72640207037801
              ],
              [
                -52.205723877306674,
                -31.733425197761914
              ],
              [
                -52.209197158820956,
                -31.73551605247926
              ],
              [
                -52.2128809422452,
                -31.740019431870465
              ],
              [
                -52.22040638552614,
                -31.746023937725404
              ],
              [
                -52.22577418423003,
                -31.751921220261508
              ],
              [
                -52.22777395237462,
                -31.760284639130887
              ],
              [
                -52.22672144282483,
                -31.7678974947684
              ],
              [
                -52.22309028487808,
                -31.77749398180442
              ],
              [
                -52.21898549763394,
                -31.78349848765936
              ],
              [
                -52.22209040080579,
                -31.786018235652058
              ],
              [
                -52.22361653965298,
                -31.78891326526069
              ],
              [
                -52.22451117277029,
                -31.79078967334036
              ],
              [
                -52.22219565176077,
                -31.79239802312293
              ],
              [
                -52.21751198426424,
                -31.794596101159115
              ],
              [
                -52.217722486174196,
                -31.795721946006918
              ],
              [
                -52.21630159828199,
                -31.7979200240431
              ],
              [
                -52.21440708109238,
                -31.802798685050238
              ],
              [
                -52.21330194606511,
                -31.80681955950667
              ],
              [
                -52.214775459434804,
                -31.808803190905177
              ],
              [
                -52.217196231399306,
                -31.806712336187832
              ],
              [
                -52.21651210019195,
                -31.80451425815165
              ],
              [
                -52.218511868336535,
                -31.803602859941524
              ],
              [
                -52.21977487979627,
                -31.805479268021195
              ],
              [
                -52.21998538170623,
                -31.80821346265157
              ],
              [
                -52.22219565176077,
                -31.810197094050075
              ],
              [
                -52.22287978296813,
                -31.81239517208626
              ],
              [
                -52.22451117277029,
                -31.81282406536161
              ],
              [
                -52.22587943518501,
                -31.81062598732543
              ],
              [
                -52.227721326897125,
                -31.80692678282551
              ],
              [
                -52.22898433835687,
                -31.805908161296546
              ],
              [
                -52.230299975294095,
                -31.80628344291248
              ],
              [
                -52.22951059313176,
                -31.80821346265157
              ],
              [
                -52.23129985936639,
                -31.80928569583995
              ],
              [
                -52.22619518804994,
                -31.813896298549995
              ],
              [
                -52.22340603774302,
                -31.81770272636875
              ],
              [
                -52.22261665558069,
                -31.819311076151322
              ],
              [
                -52.222511404625706,
                -31.825208358687426
              ],
              [
                -52.221879898895835,
                -31.833679000875645
              ],
              [
                -52.22261665558069,
                -31.83759265201324
              ],
              [
                -52.223195535833064,
                -31.84290020629573
              ],
              [
                -52.225511056842585,
                -31.846813857433325
              ],
              [
                -52.22587943518501,
                -31.848100537259384
              ],
              [
                -52.2274055740322,
                -31.847886090621707
              ],
              [
                -52.228721210969425,
                -31.844991061013076
              ],
              [
                -52.23151036127634,
                -31.841881584766767
              ],
              [
                -52.23451001349323,
                -31.840112400005935
              ],
              [
                -52.2385095497824,
                -31.83871849686104
              ],
              [
                -52.241298700089324,
                -31.83818238026685
              ],
              [
                -52.24487723255858,
                -31.83818238026685
              ],
              [
                -52.24782425929797,
                -31.83882572017988
              ],
              [
                -52.25082391151485,
                -31.8400051766871
              ],
              [
                -52.25329730895684,
                -31.841988808085606
              ],
              [
                -52.255297077101424,
                -31.84472300271598
              ],
              [
                -52.25661271403865,
                -31.849816110360795
              ],
              [
                -52.25661271403865,
                -31.851478071802788
              ],
              [
                -52.255297077101424,
                -31.857589800976566
              ],
              [
                -52.25519182614645,
                -31.86107455883881
              ],
              [
                -52.25450769493909,
                -31.864773763338725
              ],
              [
                -52.253086807046884,
                -31.869223531070514
              ],
              [
                -52.251402791767234,
                -31.872601065613917
              ],
              [
                -52.24819263764039,
                -31.877426114961636
              ],
              [
                -52.24550873828845,
                -31.879088076403626
              ],
              [
                -52.24161445295426,
                -31.88262644592529
              ],
              [
                -52.236878159980236,
                -31.890024854925127
              ],
              [
                -52.235088893745605,
                -31.892973496193175
              ],
              [
                -52.23308912560102,
                -31.89458184597575
              ],
              [
                -52.229773720519205,
                -31.895278797548198
              ],
              [
                -52.22877383644691,
                -31.89399211772214
              ],
              [
                -52.228089705239555,
                -31.891097088113508
              ],
              [
                -52.22830020714951,
                -31.888791786758485
              ],
              [
                -52.22898433835687,
                -31.886915378678818
              ],
              [
                -52.22830020714951,
                -31.884288407367283
              ],
              [
                -52.22887908740189,
                -31.88369867911367
              ],
              [
                -52.23550989756552,
                -31.882787280903546
              ],
              [
                -52.23782541857504,
                -31.881018096142714
              ],
              [
                -52.237299163800145,
                -31.87828390151234
              ],
              [
                -52.23408900967331,
                -31.87538887190371
              ],
              [
                -52.23151036127634,
                -31.87399496875881
              ],
              [
                -52.22830020714951,
                -31.87292273557043
              ],
              [
                -52.226774068302326,
                -31.872011337360306
              ],
              [
                -52.22419541990536,
                -31.871421609106697
              ],
              [
                -52.2210905167335,
                -31.872118560679144
              ],
              [
                -52.220090632661204,
                -31.87281551225159
              ],
              [
                -52.215406965164675,
                -31.878498348150018
              ],
              [
                -52.20630275755906,
                -31.8879876118672
              ],
              [
                -52.19588291301621,
                -31.896619089033678
              ],
              [
                -52.189778357627475,
                -31.90069357514953
              ],
              [
                -52.18519994108592,
                -31.903106099823386
              ],
              [
                -52.17841125448982,
                -31.906376411047955
              ],
              [
                -52.176990366597614,
                -31.90728780925808
              ],
              [
                -52.17141206598377,
                -31.90900338235949
              ],
              [
                -52.164412877477716,
                -31.911201460395674
              ],
              [
                -52.15609805203444,
                -31.91361398506953
              ],
              [
                -52.15162488644786,
                -31.914310936641982
              ],
              [
                -52.147204346338775,
                -31.915490393149202
              ],
              [
                -52.140626161652634,
                -31.918278199438994
              ],
              [
                -52.13920527376043,
                -31.918385422757833
              ],
              [
                -52.1349952355613,
                -31.92149489900414
              ],
              [
                -52.13341647123663,
                -31.923103248786713
              ],
              [
                -52.13320596932667,
                -31.92460437525045
              ],
              [
                -52.131416703092036,
                -31.92589105507651
              ],
              [
                -52.130890448317146,
                -31.92739218154024
              ],
              [
                -52.12952218590243,
                -31.92771385149676
              ],
              [
                -52.128574927307625,
                -31.92921497796049
              ],
              [
                -52.127417166802864,
                -31.932806959141573
              ],
              [
                -52.125206896748324,
                -31.932699735822734
              ],
              [
                -52.12331237955871,
                -31.933396687395184
              ],
              [
                -52.116681569395084,
                -31.939776474866058
              ],
              [
                -52.11610268914271,
                -31.941223989670373
              ],
              [
                -52.11478705220548,
                -31.94197455290224
              ],
              [
                -52.112524156673445,
                -31.947014048887635
              ],
              [
                -52.11220840380851,
                -31.95039158343104
              ],
              [
                -52.11389241908816,
                -31.949587408539752
              ],
              [
                -52.11268203310591,
                -31.948300728713694
              ],
              [
                -52.11299778597085,
                -31.947014048887635
              ],
              [
                -52.11541855793535,
                -31.94508402914855
              ],
              [
                -52.11799720633231,
                -31.945995427358675
              ],
              [
                -52.12020747638686,
                -31.944601524213777
              ],
              [
                -52.12031272734183,
                -31.943690126003652
              ],
              [
                -52.1228913757388,
                -31.944226242597843
              ],
              [
                -52.12457539101845,
                -31.945673757402158
              ],
              [
                -52.12831179992018,
                -31.947711000460085
              ],
              [
                -52.135416239381215,
                -31.94980185517743
              ],
              [
                -52.1378896368232,
                -31.950177136793364
              ],
              [
                -52.14162604572493,
                -31.951195758322328
              ],
              [
                -52.144625697941805,
                -31.950284360112203
              ],
              [
                -52.145415080104144,
                -31.949319350242657
              ],
              [
                -52.14588870940155,
                -31.946424320634026
              ],
              [
                -52.14567820749159,
                -31.943690126003652
              ],
              [
                -52.14509932723921,
                -31.94197455290224
              ],
              [
                -52.14278380622969,
                -31.94192094124282
              ],
              [
                -52.14199442406735,
                -31.940473426438505
              ],
              [
                -52.14162604572493,
                -31.93838257172116
              ],
              [
                -52.14262592979722,
                -31.93532670713427
              ],
              [
                -52.14441519603185,
                -31.933075017438668
              ],
              [
                -52.144994076284235,
                -31.93060888110539
              ],
              [
                -52.144888825329254,
                -31.9286788613663
              ],
              [
                -52.14678334251886,
                -31.927284958221406
              ],
              [
                -52.15078287880804,
                -31.92739218154024
              ],
              [
                -52.15299314886258,
                -31.928303579750366
              ],
              [
                -52.15451928770976,
                -31.929483036257587
              ],
              [
                -52.15567704821452,
                -31.931573890974935
              ],
              [
                -52.1557822991695,
                -31.93591643538788
              ],
              [
                -52.154992917007164,
                -31.937900066786387
              ],
              [
                -52.15451928770976,
                -31.94079509639502
              ],
              [
                -52.14962511830328,
                -31.945191252467385
              ],
              [
                -52.148993612573406,
                -31.94738933050357
              ],
              [
                -52.14988824569072,
                -31.949480185220914
              ],
              [
                -52.15067762785306,
                -31.950016301815108
              ],
              [
                -52.15330890172751,
                -31.95039158343104
              ],
              [
                -52.156782183241795,
                -31.948890456967305
              ],
              [
                -52.160781719530966,
                -31.946585155612283
              ],
              [
                -52.16430762652274,
                -31.943475679365974
              ],
              [
                -52.166886274919705,
                -31.9429931744312
              ],
              [
                -52.167886158992,
                -31.944226242597843
              ],
              [
                -52.168307162811914,
                -31.94610265067751
              ],
              [
                -52.16967542522663,
                -31.947603777141246
              ],
              [
                -52.17199094623615,
                -31.948300728713694
              ],
              [
                -52.17278032839849,
                -31.950498806749877
              ],
              [
                -52.174516969155626,
                -31.95221437985129
              ],
              [
                -52.17620098443528,
                -31.952482438148387
              ],
              [
                -52.177095617552595,
                -31.95162465159768
              ],
              [
                -52.17988476785952,
                -31.950284360112203
              ],
              [
                -52.18377905319371,
                -31.949426573561496
              ],
              [
                -52.185515693950855,
                -31.94969463185859
              ],
              [
                -52.18641032706817,
                -31.953715506315024
              ],
              [
                -52.187199709230505,
                -31.955484691075856
              ],
              [
                -52.1881995933028,
                -31.956181642648303
              ],
              [
                -52.188620597122714,
                -31.9575755457932
              ],
              [
                -52.18741021114046,
                -31.961274750293118
              ],
              [
                -52.18798909139284,
                -31.96299032339453
              ],
              [
                -52.189778357627475,
                -31.963419216669884
              ],
              [
                -52.192514882456905,
                -31.963097546713367
              ],
              [
                -52.19409364678158,
                -31.96229337182208
              ],
              [
                -52.19940882000798,
                -31.96299032339453
              ],
              [
                -52.20188221744997,
                -31.96250781845976
              ],
              [
                -52.206881637811435,
                -31.96551007138723
              ],
              [
                -52.20788152188373,
                -31.965188401430712
              ],
              [
                -52.210512795758184,
                -31.963311993351045
              ],
              [
                -52.21251256390277,
                -31.96057779872067
              ],
              [
                -52.21388082631749,
                -31.959612788851125
              ],
              [
                -52.21609109637203,
                -31.960202517104737
              ],
              [
                -52.218774995723976,
                -31.959076672256934
              ],
              [
                -52.2196170033638,
                -31.96068502203951
              ],
              [
                -52.22051163648112,
                -31.964384226539426
              ],
              [
                -52.22151152055341,
                -31.96551007138723
              ],
              [
                -52.22177464794086,
                -31.967976207720508
              ],
              [
                -52.223300786788045,
                -31.971621800561007
              ],
              [
                -52.22409016895038,
                -31.972479587111714
              ],
              [
                -52.22777395237462,
                -31.974195160213124
              ],
              [
                -52.22972109504172,
                -31.975696286676857
              ],
              [
                -52.22998422242916,
                -31.978216034669558
              ],
              [
                -52.23440476253825,
                -31.981486345894123
              ],
              [
                -52.23808854596248,
                -31.983309142314372
              ],
              [
                -52.23940418289971,
                -31.98459582214043
              ],
              [
                -52.239614684809666,
                -31.98631139524184
              ],
              [
                -52.23929893194474,
                -31.98931364816931
              ],
              [
                -52.24161445295426,
                -31.991618949524334
              ],
              [
                -52.24171970390923,
                -31.993977862538774
              ],
              [
                -52.24082507079192,
                -31.99521093070541
              ],
              [
                -52.240614568881966,
                -31.997409008741595
              ],
              [
                -52.23861480073737,
                -32.00019681503139
              ],
              [
                -52.23682553450275,
                -32.0019123881328
              ],
              [
                -52.238193796917464,
                -32.004003242850146
              ],
              [
                -52.23708866189019,
                -32.006522990842846
              ],
              [
                -52.23672028354777,
                -32.00931079713264
              ],
              [
                -52.23587827590794,
                -32.01022219534276
              ],
              [
                -52.23587827590794,
                -32.01231305006011
              ],
              [
                -52.23487839183565,
                -32.01408223482094
              ],
              [
                -52.234983642790624,
                -32.01611947787887
              ],
              [
                -52.23451001349323,
                -32.01681642945131
              ],
              [
                -52.234825766358156,
                -32.01917534246575
              ],
              [
                -52.235983526862924,
                -32.02190953709613
              ],
              [
                -52.23887792812482,
                -32.02308899360335
              ],
              [
                -52.23950943385469,
                -32.02410761513231
              ],
              [
                -52.241824954864214,
                -32.02421483845115
              ],
              [
                -52.243508970143864,
                -32.02550151827721
              ],
              [
                -52.24561398924343,
                -32.028289324567005
              ],
              [
                -52.247719008343,
                -32.03289992727704
              ],
              [
                -52.24761375738802,
                -32.0341866071031
              ],
              [
                -52.24929777266767,
                -32.0369744133929
              ],
              [
                -52.24908727075771,
                -32.038100258240696
              ],
              [
                -52.249981903875025,
                -32.04019111295804
              ],
              [
                -52.249981903875025,
                -32.04378309413912
              ],
              [
                -52.25182379558714,
                -32.045176997284024
              ],
              [
                -52.252823679659436,
                -32.04710701702311
              ],
              [
                -52.25250792679451,
                -32.04887620178394
              ],
              [
                -52.25271842870446,
                -32.052789852921535
              ],
              [
                -52.25161329367719,
                -32.053325969515726
              ],
              [
                -52.24987665292005,
                -32.051395949776634
              ],
              [
                -52.24740325547806,
                -32.05048455156651
              ],
              [
                -52.24508773446854,
                -32.047911191914395
              ],
              [
                -52.2438247230088,
                -32.045391443921694
              ],
              [
                -52.24171970390923,
                -32.04549866724054
              ],
              [
                -52.238193796917464,
                -32.044426434052156
              ],
              [
                -52.234983642790624,
                -32.04367587082029
              ],
              [
                -52.232615496303616,
                -32.0414777927841
              ],
              [
                -52.22961584408674,
                -32.0369744133929
              ],
              [
                -52.22819495619453,
                -32.036116626842194
              ],
              [
                -52.22409016895038,
                -32.035580510248
              ],
              [
                -52.223511288698,
                -32.036116626842194
              ],
              [
                -52.21698572948935,
                -32.03568773356684
              ],
              [
                -52.21330194606511,
                -32.03499078199439
              ],
              [
                -52.21161793078546,
                -32.035902180204516
              ],
              [
                -52.20988129002832,
                -32.036116626842194
              ],
              [
                -52.207513143541306,
                -32.03729608334941
              ],
              [
                -52.20230322126989,
                -32.03890443313198
              ],
              [
                -52.19830368498071,
                -32.031613247450984
              ],
              [
                -52.19619866588115,
                -32.027592372994555
              ],
              [
                -52.1964091677911,
                -32.026895421422104
              ],
              [
                -52.19898781618807,
                -32.02539429495837
              ],
              [
                -52.20119808624261,
                -32.02330344024102
              ],
              [
                -52.203513607252134,
                -32.01880006084982
              ],
              [
                -52.20409248750451,
                -32.01628031285712
              ],
              [
                -52.20509237157681,
                -32.015476137965834
              ],
              [
                -52.20540812444174,
                -32.01247388503837
              ],
              [
                -52.20630275755906,
                -32.01161609848766
              ],
              [
                -52.206092255649104,
                -32.01027580700218
              ],
              [
                -52.20430298941447,
                -32.0092035738138
              ],
              [
                -52.20261897413482,
                -32.00738077739355
              ],
              [
                -52.19951407096296,
                -32.00609409756749
              ],
              [
                -52.19809318307075,
                -32.00630854420517
              ],
              [
                -52.193777893916646,
                -32.004592971103754
              ],
              [
                -52.192514882456905,
                -32.001483494857446
              ],
              [
                -52.19319901366427,
                -31.999499863458944
              ],
              [
                -52.19219912959197,
                -31.997998736995207
              ],
              [
                -52.192620133411886,
                -31.996712057169148
              ],
              [
                -52.19440939964652,
                -31.9960151055967
              ],
              [
                -52.19630391683612,
                -31.994085085857613
              ],
              [
                -52.19609341492617,
                -31.991994231140268
              ],
              [
                -52.19477777798894,
                -31.989688929785245
              ],
              [
                -52.190304612402365,
                -31.987115570133128
              ],
              [
                -52.18909422642012,
                -31.984810268778105
              ],
              [
                -52.18940997928505,
                -31.983791647249145
              ],
              [
                -52.188094342347824,
                -31.98207607414773
              ],
              [
                -52.18619982515821,
                -31.98111106427819
              ],
              [
                -52.18220028886904,
                -31.981218287597027
              ],
              [
                -52.18120040479675,
                -31.98041411270574
              ],
              [
                -52.179674265949565,
                -31.980682171002837
              ],
              [
                -52.17641148634524,
                -31.979609937814452
              ],
              [
                -52.17520110036299,
                -31.978484092966653
              ],
              [
                -52.171780444326195,
                -31.978912986242005
              ],
              [
                -52.17109631311884,
                -31.979502714495617
              ],
              [
                -52.16820191185693,
                -31.980199666068064
              ],
              [
                -52.16567588893746,
                -31.98041411270574
              ],
              [
                -52.16362349531538,
                -31.98207607414773
              ],
              [
                -52.16162372717079,
                -31.981486345894123
              ],
              [
                -52.159623959026206,
                -31.981700792531797
              ],
              [
                -52.15220376670024,
                -31.979877996111547
              ],
              [
                -52.145520331059124,
                -31.980521336024577
              ],
              [
                -52.144204694121896,
                -31.981325510915866
              ],
              [
                -52.13988940496779,
                -31.98271941406076
              ],
              [
                -52.13299546741671,
                -31.98229052078541
              ],
              [
                -52.13152195404702,
                -31.98089661764051
              ],
              [
                -52.129101182082515,
                -31.98100384095935
              ],
              [
                -52.12541739865828,
                -31.980574947683998
              ],
              [
                -52.12552264961326,
                -31.977090189821755
              ]
            ]
          ],
          [
            [
              [
                -51.23752034246185,
                -31.457378763412933
              ],
              [
                -51.231205285163156,
                -31.46349049258671
              ],
              [
                -51.21799629031339,
                -31.475499504296593
              ],
              [
                -51.193578068758434,
                -31.498123624571456
              ],
              [
                -51.186,
                -31.50439618872349
              ],
              [
                -51.19689347384025,
                -31.51570824886092
              ],
              [
                -51.2024191489766,
                -31.52160553139702
              ],
              [
                -51.20731331838309,
                -31.526484192404162
              ],
              [
                -51.214523008799105,
                -31.533507319788065
              ],
              [
                -51.220890691575285,
                -31.53940460232417
              ],
              [
                -51.226416366711646,
                -31.54401520503421
              ],
              [
                -51.23199466732549,
                -31.549108312679024
              ],
              [
                -51.24388802523803,
                -31.559294527968657
              ],
              [
                -51.24941370037439,
                -31.563905130678698
              ],
              [
                -51.25588663410555,
                -31.568998238323513
              ],
              [
                -51.26209644044927,
                -31.574305792606005
              ],
              [
                -51.26751686463064,
                -31.578594725359533
              ],
              [
                -51.28098898686786,
                -31.588620105670906
              ],
              [
                -51.28398863908474,
                -31.591086242004184
              ],
              [
                -51.28930381231114,
                -31.595107116460618
              ],
              [
                -51.293776977897714,
                -31.5986990976417
              ],
              [
                -51.303196938368266,
                -31.60529333175025
              ],
              [
                -51.31440616507345,
                -31.613281469003695
              ],
              [
                -51.31919508352496,
                -31.61730234346013
              ],
              [
                -51.32140535357951,
                -31.618696246605026
              ],
              [
                -51.33098319048253,
                -31.625397704032416
              ],
              [
                -51.33940326688079,
                -31.63177749150329
              ],
              [
                -51.34471844010719,
                -31.636173647575653
              ],
              [
                -51.35040199167601,
                -31.63992646373499
              ],
              [
                -51.35840106425436,
                -31.64609180456819
              ],
              [
                -51.363505735570804,
                -31.64952295077101
              ],
              [
                -51.37550434443832,
                -31.65799359295923
              ],
              [
                -51.3867135711435,
                -31.66630340016919
              ],
              [
                -51.39271287557726,
                -31.670592332922723
              ],
              [
                -51.400396195290675,
                -31.676489615458824
              ],
              [
                -51.40928990098634,
                -31.68270856795144
              ],
              [
                -51.41292105893309,
                -31.685389150922393
              ],
              [
                -51.41807835572702,
                -31.688981132103475
              ],
              [
                -51.427182563332636,
                -31.695575366212026
              ],
              [
                -51.44302283205686,
                -31.705815193161076
              ],
              [
                -51.4530216727798,
                -31.712516650588462
              ],
              [
                -51.45859997339364,
                -31.716001408450705
              ],
              [
                -51.47117746251354,
                -31.72409676902299
              ],
              [
                -51.47580850453258,
                -31.726777351993945
              ],
              [
                -51.48370232615595,
                -31.73192407129818
              ],
              [
                -51.4892806267698,
                -31.735301605841585
              ],
              [
                -51.49638506623083,
                -31.739322480298014
              ],
              [
                -51.502384370664586,
                -31.742914461479096
              ],
              [
                -51.53248614378837,
                -31.75931962926134
              ],
              [
                -51.55101031186454,
                -31.769184174594457
              ],
              [
                -51.571481622607806,
                -31.780389011413053
              ],
              [
                -51.585216872232465,
                -31.788216313688242
              ],
              [
                -51.59111092571125,
                -31.791379401593968
              ],
              [
                -51.60047826070431,
                -31.7967941791953
              ],
              [
                -51.61242424409434,
                -31.80328118998501
              ],
              [
                -51.624580729394324,
                -31.809500142477628
              ],
              [
                -51.638315979018984,
                -31.81598715326734
              ],
              [
                -51.64868319808434,
                -31.821026649252737
              ],
              [
                -51.655524510157925,
                -31.824189737158463
              ],
              [
                -51.66752311902545,
                -31.829497291440955
              ],
              [
                -51.6745223075315,
                -31.832982049303197
              ],
              [
                -51.67799558904578,
                -31.83437595244809
              ],
              [
                -51.69130983485053,
                -31.840916574897225
              ],
              [
                -51.707781609304625,
                -31.849226382107187
              ],
              [
                -51.71241265132367,
                -31.85142446014337
              ],
              [
                -51.72220099013664,
                -31.856303121150507
              ],
              [
                -51.73551523594139,
                -31.86332624853441
              ],
              [
                -51.7427249263574,
                -31.867293511331425
              ],
              [
                -51.74798747410631,
                -31.86997409430238
              ],
              [
                -51.76009133392881,
                -31.87662194007035
              ],
              [
                -51.76540650715521,
                -31.879785027976077
              ],
              [
                -51.775878977175545,
                -31.88552147553392
              ],
              [
                -51.79661341530626,
                -31.89769132222206
              ],
              [
                -51.80440198597465,
                -31.902516371569778
              ],
              [
                -51.81582171458979,
                -31.909700333931937
              ],
              [
                -51.821189513293675,
                -31.912917033497084
              ],
              [
                -51.83092522662916,
                -31.91918959764912
              ],
              [
                -51.847712753948194,
                -31.930823327743067
              ],
              [
                -51.86760518443908,
                -31.945298475786224
              ],
              [
                -51.886918734677586,
                -31.959773623829385
              ],
              [
                -51.89518093464338,
                -31.966421469597353
              ],
              [
                -51.92080954218058,
                -31.98770529838674
              ],
              [
                -51.927177224956765,
                -31.993280910966327
              ],
              [
                -51.94338587202341,
                -32.00802411730658
              ],
              [
                -51.95859463501777,
                -32.022016760414964
              ],
              [
                -51.96890922860564,
                -32.031774082429244
              ],
              [
                -51.977487181436366,
                -32.04040555959572
              ],
              [
                -51.986486138087,
                -32.04978759999406
              ],
              [
                -51.99401158136795,
                -32.05707878567506
              ],
              [
                -52.01811405005797,
                -32.08141847905134
              ],
              [
                -52.04000624869344,
                -32.10479316255807
              ],
              [
                -52.04532142191984,
                -32.11058322177533
              ],
              [
                -52.05358362188563,
                -32.11921469894181
              ],
              [
                -52.06568748170813,
                -32.13138454562994
              ],
              [
                -52.071213156844486,
                -32.13701376986895
              ],
              [
                -52.07579157338604,
                -32.14151714926015
              ],
              [
                -52.07721246127824,
                -32.14317911070215
              ],
              [
                -52.0778965924856,
                -32.14537718873833
              ],
              [
                -52.077422963188205,
                -32.14719998515858
              ],
              [
                -52.0784228472605,
                -32.14789693673103
              ],
              [
                -52.081580375909844,
                -32.155402569049706
              ],
              [
                -52.08189612877478,
                -32.15990594844091
              ],
              [
                -52.083001263802046,
                -32.160174006738
              ],
              [
                -52.08289601284707,
                -32.1567964721946
              ],
              [
                -52.079106978467856,
                -32.14768249009335
              ],
              [
                -52.07879122560292,
                -32.137817944760236
              ],
              [
                -52.080422615405084,
                -32.13427957523858
              ],
              [
                -52.082211881639715,
                -32.13288567209368
              ],
              [
                -52.08978995039814,
                -32.13138454562994
              ],
              [
                -52.092315973317625,
                -32.12961536086912
              ],
              [
                -52.09121083829035,
                -32.12757811781119
              ],
              [
                -52.08647454531633,
                -32.12752450615177
              ],
              [
                -52.08510628290161,
                -32.126988389557575
              ],
              [
                -52.08279076189209,
                -32.12361085501417
              ],
              [
                -52.08258025998214,
                -32.12157361195625
              ],
              [
                -52.08400114787434,
                -32.11900025230413
              ],
              [
                -52.080422615405084,
                -32.118785805666455
              ],
              [
                -52.08021211349512,
                -32.11717745588388
              ],
              [
                -52.07921222942283,
                -32.11701662090562
              ],
              [
                -52.07631782816093,
                -32.114604096231766
              ],
              [
                -52.076002075295996,
                -32.112674076492674
              ],
              [
                -52.076686206503354,
                -32.112084348239065
              ],
              [
                -52.076002075295996,
                -32.1090820953116
              ],
              [
                -52.07400230715141,
                -32.10811708544205
              ],
              [
                -52.071897288051844,
                -32.10522205583342
              ],
              [
                -52.069002886789946,
                -32.10050422980454
              ],
              [
                -52.069002886789946,
                -32.099003103340806
              ],
              [
                -52.067108369600334,
                -32.09819892844952
              ],
              [
                -52.06621373648302,
                -32.09691224862346
              ],
              [
                -52.06479284859081,
                -32.097019471942296
              ],
              [
                -52.06442447024839,
                -32.09798448181184
              ],
              [
                -52.06258257853627,
                -32.097394753558234
              ],
              [
                -52.06368771356354,
                -32.09600085041333
              ],
              [
                -52.06221420019385,
                -32.092301645913416
              ],
              [
                -52.060477559436706,
                -32.08967467460188
              ],
              [
                -52.05989867918433,
                -32.08501046023242
              ],
              [
                -52.0585830422471,
                -32.08227626560204
              ],
              [
                -52.05831991485965,
                -32.080185410884695
              ],
              [
                -52.05721477983238,
                -32.07938123599341
              ],
              [
                -52.055793891940176,
                -32.079274012674574
              ],
              [
                -52.054004625705545,
                -32.07788010952967
              ],
              [
                -52.052320610425895,
                -32.077290381276065
              ],
              [
                -52.051689104696024,
                -32.07820177948619
              ],
              [
                -52.04968933655144,
                -32.07718315795723
              ],
              [
                -52.048584201524164,
                -32.07460979830511
              ],
              [
                -52.04821582318174,
                -32.06887335074727
              ],
              [
                -52.04768956840685,
                -32.06688971934876
              ],
              [
                -52.04747906649689,
                -32.06260078659523
              ],
              [
                -52.046900186244514,
                -32.05890158209531
              ],
              [
                -52.045584549307286,
                -32.0538084744505
              ],
              [
                -52.04721593910945,
                -32.05300429955921
              ],
              [
                -52.0450056690549,
                -32.048983425102776
              ],
              [
                -52.04321640282028,
                -32.04839369684917
              ],
              [
                -52.042479646135426,
                -32.047375075320204
              ],
              [
                -52.04232176970296,
                -32.04490893898693
              ],
              [
                -52.041216634675685,
                -32.04458726903041
              ],
              [
                -52.040795630855776,
                -32.04169223942178
              ],
              [
                -52.04058512894582,
                -32.036491908458125
              ],
              [
                -52.039006364621144,
                -32.036491908458125
              ],
              [
                -52.03879586271119,
                -32.03252464566111
              ],
              [
                -52.039111615576125,
                -32.03000489766841
              ],
              [
                -52.04011149964842,
                -32.02721709137862
              ],
              [
                -52.04111138372071,
                -32.02609124653082
              ],
              [
                -52.04137451110815,
                -32.022713711987414
              ],
              [
                -52.04269014804538,
                -32.018692837530985
              ],
              [
                -52.04411103593759,
                -32.01729893438608
              ],
              [
                -52.04532142191984,
                -32.0139750115021
              ],
              [
                -52.04521617096486,
                -32.01161609848766
              ],
              [
                -52.04411103593759,
                -32.00968607874857
              ],
              [
                -52.043900534027635,
                -32.00689827245878
              ],
              [
                -52.04521617096486,
                -32.00539714599504
              ],
              [
                -52.046373931469624,
                -32.00287739800235
              ],
              [
                -52.046373931469624,
                -32.00019681503139
              ],
              [
                -52.04747906649689,
                -31.997998736995207
              ],
              [
                -52.04968933655144,
                -31.99542537734309
              ],
              [
                -52.04979458750641,
                -31.993388134285162
              ],
              [
                -52.051425977308575,
                -31.989688929785245
              ],
              [
                -52.0527942397233,
                -31.98749085174906
              ],
              [
                -52.05379412379559,
                -31.984917492096944
              ],
              [
                -52.054425629525454,
                -31.98229052078541
              ],
              [
                -52.05321524354321,
                -31.97928826785794
              ],
              [
                -52.052215359470914,
                -31.978376869647814
              ],
              [
                -52.049215707254035,
                -31.976393238249308
              ],
              [
                -52.04532142191984,
                -31.975374616720345
              ],
              [
                -52.043900534027635,
                -31.974302383531963
              ],
              [
                -52.04047987799084,
                -31.97312292702474
              ],
              [
                -52.03800648054885,
                -31.97092484898856
              ],
              [
                -52.03648034170167,
                -31.971675412220424
              ],
              [
                -52.03479632642202,
                -31.971675412220424
              ],
              [
                -52.03337543852981,
                -31.970495955713204
              ],
              [
                -52.03158617229518,
                -31.97130013060449
              ],
              [
                -52.02732350861856,
                -31.970978460647977
              ],
              [
                -52.02300821946445,
                -31.97001345077843
              ],
              [
                -52.021903084437184,
                -31.969209275887145
              ],
              [
                -52.020376945589994,
                -31.966099799640837
              ],
              [
                -52.01858767935536,
                -31.967279256148057
              ],
              [
                -52.017377293373116,
                -31.967386479466896
              ],
              [
                -52.01521964879606,
                -31.96668952789445
              ],
              [
                -52.00979922461468,
                -31.960095293785898
              ],
              [
                -52.0102202284346,
                -31.958486944003326
              ],
              [
                -52.00800995838005,
                -31.95752193413378
              ],
              [
                -52.00711532526274,
                -31.955323856097596
              ],
              [
                -52.008325711244986,
                -31.951785486575936
              ],
              [
                -52.005378684505594,
                -31.95151742827884
              ],
              [
                -52.00458930234326,
                -31.94738933050357
              ],
              [
                -52.00511555711815,
                -31.945995427358675
              ],
              [
                -52.004694553298236,
                -31.94492319417029
              ],
              [
                -52.005483935460575,
                -31.94390457264133
              ],
              [
                -52.005589186415556,
                -31.941706494605146
              ],
              [
                -52.006220692145426,
                -31.941223989670373
              ],
              [
                -52.006115441190445,
                -31.93902591163419
              ],
              [
                -52.00822046029001,
                -31.936774221938588
              ],
              [
                -52.009220344362305,
                -31.933986415648793
              ],
              [
                -52.011693741804294,
                -31.93302140577925
              ],
              [
                -52.01190424371425,
                -31.932002784250287
              ],
              [
                -52.010378104867065,
                -31.929590259576425
              ],
              [
                -52.01179899275927,
                -31.92921497796049
              ],
              [
                -52.01321988065148,
                -31.926802453286633
              ],
              [
                -52.01321988065148,
                -31.925515773460575
              ],
              [
                -52.01521964879606,
                -31.922406297214266
              ],
              [
                -52.01837717744541,
                -31.921119617388207
              ],
              [
                -52.01969281438264,
                -31.919404044286797
              ],
              [
                -52.01990331629259,
                -31.917688471185386
              ],
              [
                -52.02248196468956,
                -31.91608012140281
              ],
              [
                -52.02490273665406,
                -31.913399538431857
              ],
              [
                -52.029323276763144,
                -31.909914780569615
              ],
              [
                -52.032007176115094,
                -31.907019750960984
              ],
              [
                -52.03490157737699,
                -31.905786682794343
              ],
              [
                -52.04111138372071,
                -31.902677206548034
              ],
              [
                -52.04290064995534,
                -31.902677206548034
              ],
              [
                -52.04411103593759,
                -31.901926643316166
              ],
              [
                -52.04479516714495,
                -31.89940689532347
              ],
              [
                -52.04700543719949,
                -31.899192448685792
              ],
              [
                -52.04747906649689,
                -31.896726312352513
              ],
              [
                -52.04447941428001,
                -31.897316040606125
              ],
              [
                -52.04632130599213,
                -31.893616836106204
              ],
              [
                -52.04768956840685,
                -31.89281266121492
              ],
              [
                -52.04737381554192,
                -31.891794039685955
              ],
              [
                -52.048478950569184,
                -31.889488738330936
              ],
              [
                -52.05189960660598,
                -31.888309281823716
              ],
              [
                -52.05189960660598,
                -31.887612330251265
              ],
              [
                -52.05432037857048,
                -31.88670093204114
              ],
              [
                -52.057109528877405,
                -31.88391312575135
              ],
              [
                -52.05821466390467,
                -31.88187588269342
              ],
              [
                -52.05979342822935,
                -31.88091087282388
              ],
              [
                -52.06542435432068,
                -31.87839112483118
              ],
              [
                -52.06779250080769,
                -31.87662194007035
              ],
              [
                -52.070686902069596,
                -31.873190793867526
              ],
              [
                -52.07868597464794,
                -31.86879463779516
              ],
              [
                -52.08200137972975,
                -31.866006831505366
              ],
              [
                -52.0842116497843,
                -31.86332624853441
              ],
              [
                -52.08531678481157,
                -31.86107455883881
              ],
              [
                -52.08721130200118,
                -31.859305374077977
              ],
              [
                -52.08821118607347,
                -31.857482577657727
              ],
              [
                -52.08879006632585,
                -31.855177276302705
              ],
              [
                -52.08900056823581,
                -31.84997694533905
              ],
              [
                -52.08957944848819,
                -31.846116905860878
              ],
              [
                -52.092210722362644,
                -31.842685759658053
              ],
              [
                -52.09268435166005,
                -31.841399079831994
              ],
              [
                -52.09668388794922,
                -31.841613526469672
              ],
              [
                -52.09857840513883,
                -31.84059490494071
              ],
              [
                -52.098683656093804,
                -31.838986555158137
              ],
              [
                -52.09799952488645,
                -31.837914321969755
              ],
              [
                -52.09810477584143,
                -31.835877078911828
              ],
              [
                -52.09610500769684,
                -31.834107894150996
              ],
              [
                -52.09421049050723,
                -31.833625389216223
              ],
              [
                -52.09031620517304,
                -31.831802592795974
              ],
              [
                -52.088684815370875,
                -31.830087019694563
              ],
              [
                -52.08621141792889,
                -31.829014786506182
              ],
              [
                -52.083001263802046,
                -31.828317834933735
              ],
              [
                -52.0817908778198,
                -31.826977543448255
              ],
              [
                -52.07931748037781,
                -31.82617336855697
              ],
              [
                -52.074318060016346,
                -31.822795834013565
              ],
              [
                -52.07442331097132,
                -31.82188443580344
              ],
              [
                -52.070581651114615,
                -31.82027608602087
              ],
              [
                -52.06779250080769,
                -31.818614124578875
              ],
              [
                -52.066582114825444,
                -31.817595503049912
              ],
              [
                -52.06247732758129,
                -31.816201599905014
              ],
              [
                -52.054425629525454,
                -31.814914920078955
              ],
              [
                -52.050899722533686,
                -31.815022143397794
              ],
              [
                -52.049110456299054,
                -31.814325191825347
              ],
              [
                -52.04732119006442,
                -31.814325191825347
              ],
              [
                -52.04400578498261,
                -31.815022143397794
              ],
              [
                -52.04090088181076,
                -31.81480769676012
              ],
              [
                -52.036796094566604,
                -31.815611871651406
              ],
              [
                -52.0343753226021,
                -31.81470047344128
              ],
              [
                -52.03032316083544,
                -31.815022143397794
              ],
              [
                -52.02558686786142,
                -31.816576881520948
              ],
              [
                -52.02458698378913,
                -31.816201599905014
              ],
              [
                -52.01911393413026,
                -31.81598715326734
              ],
              [
                -52.01721941694065,
                -31.817220221433978
              ],
              [
                -52.01537752522853,
                -31.816576881520948
              ],
              [
                -52.012219996579184,
                -31.81780994968759
              ],
              [
                -52.010693857732,
                -31.817488279731073
              ],
              [
                -52.00990447556966,
                -31.81829245462236
              ],
              [
                -52.00811520933503,
                -31.818185231303524
              ],
              [
                -52.0063259431004,
                -31.819311076151322
              ],
              [
                -52.004694553298236,
                -31.81898940619481
              ],
              [
                -52.0014843991714,
                -31.820222474361447
              ],
              [
                -52.000589766054084,
                -31.821294707549832
              ],
              [
                -51.999116252684395,
                -31.821294707549832
              ],
              [
                -51.99622185142249,
                -31.822206105759957
              ],
              [
                -51.99459046162033,
                -31.82360000890485
              ],
              [
                -51.99338007563808,
                -31.82360000890485
              ],
              [
                -51.991011929151064,
                -31.825101135368588
              ],
              [
                -51.986486138087,
                -31.827191990085932
              ],
              [
                -51.98159196868051,
                -31.830623136288754
              ],
              [
                -51.97859231646363,
                -31.83201703943365
              ],
              [
                -51.97701355213896,
                -31.83330371925971
              ],
              [
                -51.97211938273247,
                -31.836091525549506
              ],
              [
                -51.9710142477052,
                -31.837217370397305
              ],
              [
                -51.9656990744788,
                -31.84048768162187
              ],
              [
                -51.96191004009958,
                -31.841988808085606
              ],
              [
                -51.960699654117334,
                -31.84172074978851
              ],
              [
                -51.959278766225125,
                -31.843221876252244
              ],
              [
                -51.95670011782816,
                -31.84407966280295
              ],
              [
                -51.952384828674056,
                -31.84697469241158
              ],
              [
                -51.950490311484444,
                -31.84697469241158
              ],
              [
                -51.94938517645717,
                -31.847993313940545
              ],
              [
                -51.94417525418575,
                -31.851102790186854
              ],
              [
                -51.93838645166195,
                -31.855284499621543
              ],
              [
                -51.93349228225546,
                -31.857482577657727
              ],
              [
                -51.92959799692127,
                -31.86032399560694
              ],
              [
                -51.9274929778217,
                -31.86107455883881
              ],
              [
                -51.92528270776716,
                -31.862522073643124
              ],
              [
                -51.9231250631901,
                -31.86337986019383
              ],
              [
                -51.92117792052301,
                -31.86332624853441
              ],
              [
                -51.91602062372907,
                -31.865899608186528
              ],
              [
                -51.91412610653946,
                -31.866114054824205
              ],
              [
                -51.90817942758319,
                -31.868901861113997
              ],
              [
                -51.90591653205116,
                -31.869116307751675
              ],
              [
                -51.902811628879306,
                -31.87051021089657
              ],
              [
                -51.900496107869785,
                -31.87051021089657
              ],
              [
                -51.89807533590528,
                -31.87131438578786
              ],
              [
                -51.8960229422832,
                -31.87131438578786
              ],
              [
                -51.89270753720139,
                -31.872225783997983
              ],
              [
                -51.89049726714685,
                -31.871796890722628
              ],
              [
                -51.88270869647846,
                -31.87281551225159
              ],
              [
                -51.87870916018929,
                -31.873083570548687
              ],
              [
                -51.87370973982782,
                -31.87281551225159
              ],
              [
                -51.86760518443908,
                -31.871904114041467
              ],
              [
                -51.86481603413216,
                -31.87131438578786
              ],
              [
                -51.863500397194926,
                -31.870617434215408
              ],
              [
                -51.860395494023074,
                -31.870188540940056
              ],
              [
                -51.857816845626104,
                -31.869116307751675
              ],
              [
                -51.85139653737243,
                -31.866114054824205
              ],
              [
                -51.84997564948023,
                -31.86509543329524
              ],
              [
                -51.84839688515555,
                -31.864988209976403
              ],
              [
                -51.84518673102872,
                -31.863111801896736
              ],
              [
                -51.84371321765902,
                -31.86279013194022
              ],
              [
                -51.83292499477375,
                -31.85689284940412
              ],
              [
                -51.82529430053783,
                -31.852389470012913
              ],
              [
                -51.811190672570746,
                -31.84472300271598
              ],
              [
                -51.80971715920105,
                -31.84348993454934
              ],
              [
                -51.8056123719569,
                -31.83930822511465
              ],
              [
                -51.80387573119976,
                -31.836091525549506
              ],
              [
                -51.80298109808244,
                -31.832713991006102
              ],
              [
                -51.80261271974002,
                -31.828210611614896
              ],
              [
                -51.80287584712747,
                -31.82558364030336
              ],
              [
                -51.803823105722266,
                -31.822795834013565
              ],
              [
                -51.804612487884604,
                -31.819203852832487
              ],
              [
                -51.80482298979456,
                -31.81480769676012
              ],
              [
                -51.80350735285733,
                -31.81411074518767
              ],
              [
                -51.799297314658205,
                -31.81352101693406
              ],
              [
                -51.7968765426937,
                -31.814325191825347
              ],
              [
                -51.792824380927044,
                -31.815022143397794
              ],
              [
                -51.789719477755185,
                -31.811912667151486
              ],
              [
                -51.78940372489025,
                -31.810304317368914
              ],
              [
                -51.78750920770064,
                -31.808374297629825
              ],
              [
                -51.7877197096106,
                -31.806497889550158
              ],
              [
                -51.78719345483571,
                -31.80499676308642
              ],
              [
                -51.791508743989816,
                -31.804085364876297
              ],
              [
                -51.793613763089375,
                -31.80451425815165
              ],
              [
                -51.79582403314392,
                -31.805800937977708
              ],
              [
                -51.79650816435128,
                -31.807302064441444
              ],
              [
                -51.79582403314392,
                -31.809875424093562
              ],
              [
                -51.794508396206695,
                -31.81169822051381
              ],
              [
                -51.7949820255041,
                -31.81298490033987
              ],
              [
                -51.796192411486345,
                -31.813092123658706
              ],
              [
                -51.79871843440582,
                -31.81239517208626
              ],
              [
                -51.80387573119976,
                -31.811322938897877
              ],
              [
                -51.806296503164255,
                -31.809982647412397
              ],
              [
                -51.80840152226382,
                -31.80928569583995
              ],
              [
                -51.813400942625286,
                -31.808320685970408
              ],
              [
                -51.81697947509455,
                -31.806497889550158
              ],
              [
                -51.824925922195405,
                -31.803120355006754
              ],
              [
                -51.829609589691934,
                -31.801887286840113
              ],
              [
                -51.83297762025124,
                -31.80151200522418
              ],
              [
                -51.83829279347764,
                -31.80210173347779
              ],
              [
                -51.84050306353218,
                -31.803013131687916
              ],
              [
                -51.840713565442144,
                -31.801994510158952
              ],
              [
                -51.83771391322526,
                -31.80097588862999
              ],
              [
                -51.83660877819799,
                -31.80140478190534
              ],
              [
                -51.8350826393508,
                -31.800600607014054
              ],
              [
                -51.83181985974648,
                -31.80038616037638
              ],
              [
                -51.8278203234573,
                -31.79920670386916
              ],
              [
                -51.82582055531272,
                -31.79920670386916
              ],
              [
                -51.824294416465534,
                -31.798188082340197
              ],
              [
                -51.82218939736597,
                -31.798188082340197
              ],
              [
                -51.82082113495125,
                -31.797276684130072
              ],
              [
                -51.81840036298675,
                -31.79722307247065
              ],
              [
                -51.81408507383264,
                -31.79561472268808
              ],
              [
                -51.81082229422832,
                -31.793416644651895
              ],
              [
                -51.80661225602919,
                -31.791808294869323
              ],
              [
                -51.80661225602919,
                -31.789824663470814
              ],
              [
                -51.80229696687508,
                -31.788484371985337
              ],
              [
                -51.79182449685475,
                -31.788698818623015
              ],
              [
                -51.78008901537468,
                -31.787519362115795
              ],
              [
                -51.77687886124784,
                -31.786822410543344
              ],
              [
                -51.773405579733556,
                -31.78650074058683
              ],
              [
                -51.767985155552175,
                -31.78660796390567
              ],
              [
                -51.759301951766474,
                -31.78709046884044
              ],
              [
                -51.75888094794656,
                -31.788109090369403
              ],
              [
                -51.75572341929721,
                -31.788806041941854
              ],
              [
                -51.75398677854007,
                -31.787412138796956
              ],
              [
                -51.75030299511583,
                -31.78891326526069
              ],
              [
                -51.74809272506129,
                -31.788806041941854
              ],
              [
                -51.74698759003402,
                -31.788216313688242
              ],
              [
                -51.74498782188943,
                -31.789020488579528
              ],
              [
                -51.74388268686216,
                -31.788109090369403
              ],
              [
                -51.74198816967255,
                -31.788591595304176
              ],
              [
                -51.73762025504095,
                -31.788001867050564
              ],
              [
                -51.73462060282407,
                -31.788698818623015
              ],
              [
                -51.733304965886845,
                -31.78719769215928
              ],
              [
                -51.731094695832304,
                -31.78719769215928
              ],
              [
                -51.725516395218456,
                -31.785589342376706
              ],
              [
                -51.72167473536175,
                -31.785106837441933
              ],
              [
                -51.71762257359509,
                -31.784892390804256
              ],
              [
                -51.71399141564834,
                -31.784999614123095
              ],
              [
                -51.71251790227865,
                -31.78462433250716
              ],
              [
                -51.70862361694445,
                -31.78478516748542
              ],
              [
                -51.70330844371805,
                -31.78301598272459
              ],
              [
                -51.69762489214922,
                -31.781675691239112
              ],
              [
                -51.69551987304966,
                -31.78231903115214
              ],
              [
                -51.69320435204014,
                -31.782211807833303
              ],
              [
                -51.68962581957088,
                -31.781300409623178
              ],
              [
                -51.68699454569642,
                -31.778405380014544
              ],
              [
                -51.681784623424996,
                -31.77572479704359
              ],
              [
                -51.67678520306353,
                -31.77438450555811
              ],
              [
                -51.673522423459204,
                -31.774116447261015
              ],
              [
                -51.67320667059427,
                -31.772990602413216
              ],
              [
                -51.67120690244968,
                -31.771703922587157
              ],
              [
                -51.66699686425056,
                -31.770524466079937
              ],
              [
                -51.66568122731333,
                -31.769076951275622
              ],
              [
                -51.66257632414147,
                -31.76837999970317
              ],
              [
                -51.66089230886182,
                -31.767522213152468
              ],
              [
                -51.65868203880728,
                -31.76687887323944
              ],
              [
                -51.65778740568996,
                -31.765216911797445
              ],
              [
                -51.65610339041031,
                -31.76489524184093
              ],
              [
                -51.65489300442806,
                -31.76387662031197
              ],
              [
                -51.65441937513066,
                -31.761785765594624
              ],
              [
                -51.65099871909386,
                -31.759105182623667
              ],
              [
                -51.64842007069689,
                -31.758622677688894
              ],
              [
                -51.647104433759665,
                -31.75578125973968
              ],
              [
                -51.64442053440772,
                -31.754977084848395
              ],
              [
                -51.642683893650585,
                -31.75299345344989
              ],
              [
                -51.640684125506,
                -31.75229650187744
              ],
              [
                -51.63847385545145,
                -31.74988397720358
              ],
              [
                -51.63721084399172,
                -31.749079802312295
              ],
              [
                -51.63447431916228,
                -31.745916714406565
              ],
              [
                -51.63189567076531,
                -31.74339696641387
              ],
              [
                -51.62642262110644,
                -31.740126655189304
              ],
              [
                -51.623791347231986,
                -31.738089412131377
              ],
              [
                -51.62410710009692,
                -31.735891334095193
              ],
              [
                -51.62142320074498,
                -31.73492632422565
              ],
              [
                -51.618476174005586,
                -31.73251379955179
              ],
              [
                -51.617581540888274,
                -31.73079822645038
              ],
              [
                -51.61521339440126,
                -31.73069100313154
              ],
              [
                -51.613318877211654,
                -31.72940432330548
              ],
              [
                -51.61142436002204,
                -31.726884575312784
              ],
              [
                -51.61042447594975,
                -31.72457927395776
              ],
              [
                -51.60579343393071,
                -31.72168424434913
              ],
              [
                -51.601899148596516,
                -31.717180864957925
              ],
              [
                -51.600109882361885,
                -31.714607505305807
              ],
              [
                -51.598688994469676,
                -31.714714728624646
              ],
              [
                -51.59600509511773,
                -31.710586630849374
              ],
              [
                -51.59600509511773,
                -31.708710222769707
              ],
              [
                -51.591584555008644,
                -31.703724338443728
              ],
              [
                -51.58758501871947,
                -31.699917910624972
              ],
              [
                -51.58579575248484,
                -31.698577619139495
              ],
              [
                -51.58479586841255,
                -31.69707649267576
              ],
              [
                -51.58332235504285,
                -31.696325929443894
              ],
              [
                -51.58058583021342,
                -31.693002006559908
              ],
              [
                -51.579901699006065,
                -31.691018375161402
              ],
              [
                -51.5777966799065,
                -31.689517248697666
              ],
              [
                -51.57311301240996,
                -31.684316917734012
              ],
              [
                -51.57258675763507,
                -31.681689946422477
              ],
              [
                -51.5681135920485,
                -31.677776295284882
              ],
              [
                -51.566587453201315,
                -31.675310158951604
              ],
              [
                -51.564114055759326,
                -31.67311208091542
              ],
              [
                -51.56148278188487,
                -31.67000260466911
              ],
              [
                -51.56100915258747,
                -31.668715924843053
              ],
              [
                -51.55822000228054,
                -31.665392001959066
              ],
              [
                -51.55379946217146,
                -31.65928027278529
              ],
              [
                -51.55258907618921,
                -31.656599689814335
              ],
              [
                -51.54979992588228,
                -31.652900485314415
              ],
              [
                -51.54711602653034,
                -31.650595183959396
              ],
              [
                -51.546274018890514,
                -31.647700154350762
              ],
              [
                -51.54422162526844,
                -31.64609180456819
              ],
              [
                -51.5424849845113,
                -31.64201731845234
              ],
              [
                -51.54237973355632,
                -31.64110592024221
              ],
              [
                -51.53922220490697,
                -31.637192269104617
              ],
              [
                -51.53880120108706,
                -31.635583919322045
              ],
              [
                -51.536696181987494,
                -31.63338584128586
              ],
              [
                -51.53559104696022,
                -31.630276365039553
              ],
              [
                -51.53459116288793,
                -31.629418578488846
              ],
              [
                -51.53301239856326,
                -31.62668438385847
              ],
              [
                -51.5303811246888,
                -31.622985179358555
              ],
              [
                -51.52980224443642,
                -31.62100154796005
              ],
              [
                -51.527118345084475,
                -31.618803469923865
              ],
              [
                -51.525802708147246,
                -31.616873450184777
              ],
              [
                -51.52480282407495,
                -31.616176498612326
              ],
              [
                -51.52322405975028,
                -31.61312063402544
              ],
              [
                -51.51901402155115,
                -31.608778089612493
              ],
              [
                -51.51822463938881,
                -31.60722335148934
              ],
              [
                -51.51448823048709,
                -31.60288080707639
              ],
              [
                -51.51138332731523,
                -31.5986990976417
              ],
              [
                -51.50880467891826,
                -31.59558962139539
              ],
              [
                -51.508594177008305,
                -31.59382043663456
              ],
              [
                -51.50738379102606,
                -31.590979018685346
              ],
              [
                -51.50591027765636,
                -31.590389290431737
              ],
              [
                -51.50259487257455,
                -31.590389290431737
              ],
              [
                -51.50027935156503,
                -31.588083989076715
              ],
              [
                -51.50001622417758,
                -31.58669008593182
              ],
              [
                -51.49827958342044,
                -31.584223949598538
              ],
              [
                -51.498384834375415,
                -31.583205328069578
              ],
              [
                -51.49691132100572,
                -31.582079483221776
              ],
              [
                -51.49470105095118,
                -31.58127530833049
              ],
              [
                -51.49228027898668,
                -31.579184453613145
              ],
              [
                -51.490596263707026,
                -31.577200822214635
              ],
              [
                -51.48917537581482,
                -31.57650387064219
              ],
              [
                -51.48601784716547,
                -31.57339439439588
              ],
              [
                -51.48059742298409,
                -31.569587966577124
              ],
              [
                -51.47749251981224,
                -31.567711558497454
              ],
              [
                -51.475176998802716,
                -31.565995985396043
              ],
              [
                -51.47412448925293,
                -31.5664248786714
              ],
              [
                -51.475703253577606,
                -31.568998238323513
              ],
              [
                -51.47438761664038,
                -31.570177694830733
              ],
              [
                -51.4742823656854,
                -31.57891639531605
              ],
              [
                -51.47301935422566,
                -31.58057835675804
              ],
              [
                -51.47128271346852,
                -31.581489754968167
              ],
              [
                -51.47112483703605,
                -31.585296182786923
              ],
              [
                -51.47059858226116,
                -31.58770870746078
              ],
              [
                -51.46980920009882,
                -31.58969233885929
              ],
              [
                -51.45460043710447,
                -31.600575505721366
              ],
              [
                -51.447495997643436,
                -31.606311953279214
              ],
              [
                -51.445811982363786,
                -31.609314206206683
              ],
              [
                -51.445706731408805,
                -31.61172673088054
              ],
              [
                -51.44460159638153,
                -31.61247729411241
              ],
              [
                -51.44418059256162,
                -31.615693993677557
              ],
              [
                -51.43902329576769,
                -31.623092402677393
              ],
              [
                -51.4380234116954,
                -31.623682130931
              ],
              [
                -51.4374971569205,
                -31.62089432464121
              ],
              [
                -51.43581314164085,
                -31.619875703112246
              ],
              [
                -51.4360762690283,
                -31.623521295952745
              ],
              [
                -51.43502375947852,
                -31.623574907612166
              ],
              [
                -51.43370812254129,
                -31.621912946170173
              ],
              [
                -51.43502375947852,
                -31.618213741670253
              ],
              [
                -51.43670777475817,
                -31.61408564389498
              ],
              [
                -51.438707542902755,
                -31.61129783760519
              ],
              [
                -51.44081256200232,
                -31.60942142952552
              ],
              [
                -51.44191769702959,
                -31.60700890485166
              ],
              [
                -51.44307545753435,
                -31.60540055506909
              ],
              [
                -51.4442858435166,
                -31.60218385550394
              ],
              [
                -51.445706731408805,
                -31.600093000786597
              ],
              [
                -51.44770649955339,
                -31.599020767598212
              ],
              [
                -51.450495649860315,
                -31.594999893141782
              ],
              [
                -51.45317954921226,
                -31.58969233885929
              ],
              [
                -51.45428468423953,
                -31.586475639294143
              ],
              [
                -51.45870522434862,
                -31.57838027872186
              ],
              [
                -51.4621785058629,
                -31.567014606925007
              ],
              [
                -51.462389007772856,
                -31.562886509149735
              ],
              [
                -51.46191537847545,
                -31.56020592617878
              ],
              [
                -51.460810243448186,
                -31.556292275041187
              ],
              [
                -51.45859997339364,
                -31.55479114857745
              ],
              [
                -51.45691595811399,
                -31.55500559521513
              ],
              [
                -51.45560032117676,
                -31.553826138707905
              ],
              [
                -51.45607395047416,
                -31.55189611896882
              ],
              [
                -51.45717908550144,
                -31.551306390715208
              ],
              [
                -51.45702120906897,
                -31.549108312679024
              ],
              [
                -51.45570557213174,
                -31.54637411804865
              ],
              [
                -51.45081140272525,
                -31.541388233722675
              ],
              [
                -51.448916885535645,
                -31.53849320411404
              ],
              [
                -51.44681186643608,
                -31.53618790275902
              ],
              [
                -51.44639086261616,
                -31.53088034847653
              ],
              [
                -51.44681186643608,
                -31.529111163715697
              ],
              [
                -51.448180128850794,
                -31.527502813933125
              ],
              [
                -51.45002202056291,
                -31.5279853188679
              ],
              [
                -51.45317954921226,
                -31.5324886982591
              ],
              [
                -51.46049449058325,
                -31.544390486650144
              ],
              [
                -51.460810243448186,
                -31.547499962896453
              ],
              [
                -51.462020629430434,
                -31.552593070541267
              ],
              [
                -51.462915262547746,
                -31.55420142032384
              ],
              [
                -51.46402039757502,
                -31.554415866961516
              ],
              [
                -51.463704644710084,
                -31.550984720758695
              ],
              [
                -51.460810243448186,
                -31.541817126998026
              ],
              [
                -51.45817896957373,
                -31.53758180590392
              ],
              [
                -51.455916074041696,
                -31.53152368838956
              ],
              [
                -51.45507406640187,
                -31.528896717078023
              ],
              [
                -51.450074646040406,
                -31.521873589694117
              ],
              [
                -51.44728549573348,
                -31.516619647071046
              ],
              [
                -51.44439109447158,
                -31.512009044361005
              ],
              [
                -51.44060206009236,
                -31.506701490078513
              ],
              [
                -51.440496809137386,
                -31.50428896540465
              ],
              [
                -51.43649727284821,
                -31.504020907107556
              ],
              [
                -51.42818244740493,
                -31.492011895397678
              ],
              [
                -51.42307777608848,
                -31.488419914216596
              ],
              [
                -51.421499011763814,
                -31.48809824426008
              ],
              [
                -51.42028862578156,
                -31.489813817361494
              ],
              [
                -51.4210780079439,
                -31.49190467207884
              ],
              [
                -51.421499011763814,
                -31.49662249810772
              ],
              [
                -51.422393644881126,
                -31.499892809332284
              ],
              [
                -51.420709629601475,
                -31.503377567194526
              ],
              [
                -51.41628908949239,
                -31.509596519687143
              ],
              [
                -51.410605537923566,
                -31.51420712239719
              ],
              [
                -51.406974379976816,
                -31.51640520043337
              ],
              [
                -51.3992910602634,
                -31.5204260748898
              ],
              [
                -51.392502373667305,
                -31.523321104498436
              ],
              [
                -51.38308241319675,
                -31.527020308998353
              ],
              [
                -51.37161005910413,
                -31.530397843541756
              ],
              [
                -51.36487399798552,
                -31.531791746686654
              ],
              [
                -51.3610849636063,
                -31.532006193324328
              ],
              [
                -51.35687492540717,
                -31.531577300048976
              ],
              [
                -51.352401759820594,
                -31.530612290179434
              ],
              [
                -51.34729708850415,
                -31.528896717078023
              ],
              [
                -51.343192301260004,
                -31.52787809554906
              ],
              [
                -51.340982031205456,
                -31.52600168746939
              ],
              [
                -51.337087745871266,
                -31.52417889104914
              ],
              [
                -51.33650886561888,
                -31.523106657860758
              ],
              [
                -51.331404194302436,
                -31.520801356505736
              ],
              [
                -51.31651118417302,
                -31.51527935558557
              ],
              [
                -51.31061713069423,
                -31.51281321925229
              ],
              [
                -51.29709238297953,
                -31.5061117618249
              ],
              [
                -51.293882228852695,
                -31.503592013832204
              ],
              [
                -51.28977744160854,
                -31.50150115911486
              ],
              [
                -51.28240987476007,
                -31.496890556404814
              ],
              [
                -51.279620724453146,
                -31.494585255049792
              ],
              [
                -51.27298991428952,
                -31.48992104068033
              ],
              [
                -51.26430671050381,
                -31.48279068997759
              ],
              [
                -51.256202386970486,
                -31.47512422268066
              ],
              [
                -51.25041358444668,
                -31.469816668398167
              ],
              [
                -51.24088837302115,
                -31.46107796791285
              ],
              [
                -51.23752034246185,
                -31.457378763412933
              ]
            ]
          ],
          [
            [
              [
                -52.102525315950516,
                -31.79121856661571
              ],
              [
                -52.10152543187822,
                -31.79250524644177
              ],
              [
                -52.099209910868694,
                -31.791593848231646
              ],
              [
                -52.09421049050723,
                -31.792880528057704
              ],
              [
                -52.094526243372165,
                -31.795775557666335
              ],
              [
                -52.09721014272411,
                -31.798885033912644
              ],
              [
                -52.099578289211124,
                -31.79979643212277
              ],
              [
                -52.101104428058306,
                -31.80097588862999
              ],
              [
                -52.103998829320204,
                -31.801887286840113
              ],
              [
                -52.10620909937475,
                -31.801780063521274
              ],
              [
                -52.105893346509816,
                -31.80038616037638
              ],
              [
                -52.10857724586176,
                -31.7954002760504
              ],
              [
                -52.108787747771714,
                -31.793523867970734
              ],
              [
                -52.111208519736216,
                -31.793523867970734
              ],
              [
                -52.11052438852886,
                -31.79207635316642
              ],
              [
                -52.108998249681676,
                -31.791593848231646
              ],
              [
                -52.10820886751934,
                -31.792773304738866
              ],
              [
                -52.10678797962713,
                -31.791808294869323
              ],
              [
                -52.1045250840951,
                -31.7908968966592
              ],
              [
                -52.102525315950516,
                -31.79121856661571
              ]
            ]
          ]
        ]
      }
    }
  ]
};
